import { jsxs as F, jsx as d, Fragment as ut } from "react/jsx-runtime";
import * as A from "react";
import O, { useEffect as ve, useLayoutEffect as x2, useState as ue, useRef as ke, Children as ar, useMemo as _e, createContext as gt, useContext as Oe, useCallback as ct, useId as bt, useImperativeHandle as Ad, Fragment as vu, forwardRef as Xe, isValidElement as sr, cloneElement as Qt, useInsertionEffect as XE, createElement as Pd, Component as Td, useReducer as gL, memo as CL, PureComponent as xo } from "react";
import * as S2 from "react-dom";
import { flushSync as Id } from "react-dom";
function QE(e) {
  const { currentTarget: t, target: n } = e;
  window.setTimeout(
    () => (t || n).blur(),
    0
  );
}
const Em = O.forwardRef(
  ({
    afterIcon: e,
    beforeIcon: t,
    children: n,
    disabled: r = !1,
    href: o = "",
    loading: i = !1,
    openInNewWindow: a = !1,
    rel: s,
    trackingName: l,
    trackingEvent: c,
    type: u = "button",
    download: f,
    target: h,
    tabIndex: p,
    onClick: C,
    onMouseUp: m,
    onEnterKeyPress: g,
    onEscapeKeyPress: v,
    onCustomKeyPress: y,
    onKeyPress: w,
    ...x
  }, b) => {
    const S = (_) => {
      r || i ? _.preventDefault() : C && C(_);
    }, M = (_) => {
      QE(_), m && m(_);
    }, E = (_) => {
      g && _.key === "Enter" && g(_), v && _.key === "Escape" && v(_), y && _.key === y.key && y.action(_), w && w(_);
    };
    ve(() => {
      if (g || v || w || y)
        return window.addEventListener("keyup", E), () => {
          window.removeEventListener("keyup", E);
        };
    }, []);
    const P = o ? "a" : "button", T = {};
    return o ? (T.href = o, T.rel = s, T.download = f, h && (T.target = h), a && (T.target = "_blank", T.rel === void 0 && (T.rel = "noopener noreferrer"))) : (T.disabled = r || i || !1, T.type = u || "button"), /* @__PURE__ */ F(
      P,
      {
        ...x,
        ...T,
        ref: b,
        "data-tracking-name": l,
        "data-tracking-event": c,
        onClick: S,
        onMouseUp: M,
        download: f,
        tabIndex: p,
        children: [
          !i && t ? t : null,
          n,
          !i && e ? e : null
        ]
      }
    );
  }
);
function JE(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (n = JE(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function We() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++) (e = arguments[n]) && (t = JE(e)) && (r && (r += " "), r += t);
  return r;
}
const Dd = "-", vL = (e) => {
  const t = bL(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (a) => {
      const s = a.split(Dd);
      return s[0] === "" && s.length !== 1 && s.shift(), e_(s, t) || yL(a);
    },
    getConflictingClassGroupIds: (a, s) => {
      const l = n[a] || [];
      return s && r[a] ? [...l, ...r[a]] : l;
    }
  };
}, e_ = (e, t) => {
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], r = t.nextPart.get(n), o = r ? e_(e.slice(1), r) : void 0;
  if (o)
    return o;
  if (t.validators.length === 0)
    return;
  const i = e.join(Dd);
  return t.validators.find(({
    validator: a
  }) => a(i))?.classGroupId;
}, _m = /^\[(.+)\]$/, yL = (e) => {
  if (_m.test(e)) {
    const t = _m.exec(e)[1], n = t?.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, bL = (e) => {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return xL(Object.entries(e.classGroups), n).forEach(([i, a]) => {
    l9(a, r, i, t);
  }), r;
}, l9 = (e, t, n, r) => {
  e.forEach((o) => {
    if (typeof o == "string") {
      const i = o === "" ? t : Om(t, o);
      i.classGroupId = n;
      return;
    }
    if (typeof o == "function") {
      if (wL(o)) {
        l9(o(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: n
      });
      return;
    }
    Object.entries(o).forEach(([i, a]) => {
      l9(a, Om(t, i), n, r);
    });
  });
}, Om = (e, t) => {
  let n = e;
  return t.split(Dd).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, wL = (e) => e.isThemeGetter, xL = (e, t) => t ? e.map(([n, r]) => {
  const o = r.map((i) => typeof i == "string" ? t + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(([a, s]) => [t + a, s])) : i);
  return [n, o];
}) : e, SL = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const o = (i, a) => {
    n.set(i, a), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(i) {
      let a = n.get(i);
      if (a !== void 0)
        return a;
      if ((a = r.get(i)) !== void 0)
        return o(i, a), a;
    },
    set(i, a) {
      n.has(i) ? n.set(i, a) : o(i, a);
    }
  };
}, t_ = "!", ML = (e) => {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, r = t.length === 1, o = t[0], i = t.length, a = (s) => {
    const l = [];
    let c = 0, u = 0, f;
    for (let g = 0; g < s.length; g++) {
      let v = s[g];
      if (c === 0) {
        if (v === o && (r || s.slice(g, g + i) === t)) {
          l.push(s.slice(u, g)), u = g + i;
          continue;
        }
        if (v === "/") {
          f = g;
          continue;
        }
      }
      v === "[" ? c++ : v === "]" && c--;
    }
    const h = l.length === 0 ? s : s.substring(u), p = h.startsWith(t_), C = p ? h.substring(1) : h, m = f && f > u ? f - u : void 0;
    return {
      modifiers: l,
      hasImportantModifier: p,
      baseClassName: C,
      maybePostfixModifierPosition: m
    };
  };
  return n ? (s) => n({
    className: s,
    parseClassName: a
  }) : a;
}, EL = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}, _L = (e) => ({
  cache: SL(e.cacheSize),
  parseClassName: ML(e),
  ...vL(e)
}), OL = /\s+/, AL = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: o
  } = t, i = [], a = e.trim().split(OL);
  let s = "";
  for (let l = a.length - 1; l >= 0; l -= 1) {
    const c = a[l], {
      modifiers: u,
      hasImportantModifier: f,
      baseClassName: h,
      maybePostfixModifierPosition: p
    } = n(c);
    let C = !!p, m = r(C ? h.substring(0, p) : h);
    if (!m) {
      if (!C) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      if (m = r(h), !m) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      C = !1;
    }
    const g = EL(u).join(":"), v = f ? g + t_ : g, y = v + m;
    if (i.includes(y))
      continue;
    i.push(y);
    const w = o(m, C);
    for (let x = 0; x < w.length; ++x) {
      const b = w[x];
      i.push(v + b);
    }
    s = c + (s.length > 0 ? " " + s : s);
  }
  return s;
};
function PL() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = n_(t)) && (r && (r += " "), r += n);
  return r;
}
const n_ = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = n_(e[r])) && (n && (n += " "), n += t);
  return n;
};
function Am(e, ...t) {
  let n, r, o, i = a;
  function a(l) {
    const c = t.reduce((u, f) => f(u), e());
    return n = _L(c), r = n.cache.get, o = n.cache.set, i = s, s(l);
  }
  function s(l) {
    const c = r(l);
    if (c)
      return c;
    const u = AL(l, n);
    return o(l, u), u;
  }
  return function() {
    return i(PL.apply(null, arguments));
  };
}
const Et = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, r_ = /^\[(?:([a-z-]+):)?(.+)\]$/i, TL = /^\d+\/\d+$/, IL = /* @__PURE__ */ new Set(["px", "full", "screen"]), DL = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, RL = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, kL = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, LL = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, NL = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, To = (e) => va(e) || IL.has(e) || TL.test(e), i1 = (e) => ps(e, "length", ZL), va = (e) => !!e && !Number.isNaN(Number(e)), z0 = (e) => ps(e, "number", va), Rs = (e) => !!e && Number.isInteger(Number(e)), FL = (e) => e.endsWith("%") && va(e.slice(0, -1)), ze = (e) => r_.test(e), a1 = (e) => DL.test(e), VL = /* @__PURE__ */ new Set(["length", "size", "percentage"]), BL = (e) => ps(e, VL, o_), $L = (e) => ps(e, "position", o_), jL = /* @__PURE__ */ new Set(["image", "url"]), HL = (e) => ps(e, jL, qL), zL = (e) => ps(e, "", WL), ks = () => !0, ps = (e, t, n) => {
  const r = r_.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}, ZL = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  RL.test(e) && !kL.test(e)
), o_ = () => !1, WL = (e) => LL.test(e), qL = (e) => NL.test(e), Pm = () => {
  const e = Et("colors"), t = Et("spacing"), n = Et("blur"), r = Et("brightness"), o = Et("borderColor"), i = Et("borderRadius"), a = Et("borderSpacing"), s = Et("borderWidth"), l = Et("contrast"), c = Et("grayscale"), u = Et("hueRotate"), f = Et("invert"), h = Et("gap"), p = Et("gradientColorStops"), C = Et("gradientColorStopPositions"), m = Et("inset"), g = Et("margin"), v = Et("opacity"), y = Et("padding"), w = Et("saturate"), x = Et("scale"), b = Et("sepia"), S = Et("skew"), M = Et("space"), E = Et("translate"), P = () => ["auto", "contain", "none"], T = () => ["auto", "hidden", "clip", "visible", "scroll"], _ = () => ["auto", ze, t], D = () => [ze, t], N = () => ["", To, i1], R = () => ["auto", va, ze], L = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], B = () => ["solid", "dashed", "dotted", "double", "none"], V = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], k = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], z = () => ["", "0", ze], $ = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], Z = () => [va, ze];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [ks],
      spacing: [To, i1],
      blur: ["none", "", a1, ze],
      brightness: Z(),
      borderColor: [e],
      borderRadius: ["none", "", "full", a1, ze],
      borderSpacing: D(),
      borderWidth: N(),
      contrast: Z(),
      grayscale: z(),
      hueRotate: Z(),
      invert: z(),
      gap: D(),
      gradientColorStops: [e],
      gradientColorStopPositions: [FL, i1],
      inset: _(),
      margin: _(),
      opacity: Z(),
      padding: D(),
      saturate: Z(),
      scale: Z(),
      sepia: z(),
      skew: Z(),
      space: D(),
      translate: D()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", ze]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [a1]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": $()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": $()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...L(), ze]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: T()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": T()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": T()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: P()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": P()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": P()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [m]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [m]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [m]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [m]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [m]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [m]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [m]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [m]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [m]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Rs, ze]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: _()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", ze]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: z()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: z()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Rs, ze]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [ks]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Rs, ze]
        }, ze]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": R()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": R()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [ks]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Rs, ze]
        }, ze]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": R()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": R()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", ze]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", ze]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [h]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [h]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [h]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...k()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...k(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...k(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [y]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [y]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [y]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [y]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [y]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [y]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [y]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [y]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [y]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [g]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [g]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [g]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [g]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [g]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [g]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [g]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [g]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [g]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [M]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [M]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", ze, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [ze, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [ze, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [a1]
        }, a1]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [ze, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [ze, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [ze, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [ze, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", a1, i1]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", z0]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [ks]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", ze]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", va, z0]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", To, ze]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", ze]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", ze]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [v]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [v]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...B(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", To, i1]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", To, ze]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: D()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", ze]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", ze]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [v]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...L(), $L]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", BL]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, HL]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [C]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [C]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [C]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [p]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [v]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...B(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [v]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: B()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [o]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...B()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [To, ze]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [To, i1]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: N()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [v]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [To, i1]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", a1, zL]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [ks]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [v]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...V(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": V()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", a1, ze]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [c]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [u]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [f]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [w]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [b]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [c]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [u]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [f]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [v]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [w]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [b]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [a]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [a]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [a]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", ze]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: Z()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", ze]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: Z()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", ze]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [x]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [x]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [x]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Rs, ze]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [E]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [E]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [S]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [S]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", ze]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", ze]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": D()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": D()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": D()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": D()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": D()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": D()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": D()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": D()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": D()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": D()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": D()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": D()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": D()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": D()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": D()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": D()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": D()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": D()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", ze]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [To, i1, z0]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, UL = (e, {
  cacheSize: t,
  prefix: n,
  separator: r,
  experimentalParseClassName: o,
  extend: i = {},
  override: a = {}
}) => {
  ol(e, "cacheSize", t), ol(e, "prefix", n), ol(e, "separator", r), ol(e, "experimentalParseClassName", o);
  for (const s in a)
    GL(e[s], a[s]);
  for (const s in i)
    KL(e[s], i[s]);
  return e;
}, ol = (e, t, n) => {
  n !== void 0 && (e[t] = n);
}, GL = (e, t) => {
  if (t)
    for (const n in t)
      ol(e, n, t[n]);
}, KL = (e, t) => {
  if (t)
    for (const n in t) {
      const r = t[n];
      r !== void 0 && (e[n] = (e[n] || []).concat(r));
    }
}, YL = (e, ...t) => typeof e == "function" ? Am(Pm, e, ...t) : Am(() => UL(Pm(), e), ...t), XL = YL({
  extend: {
    classGroups: {
      "text-color": [
        "text-text-brand",
        "text-text-primary",
        "text-text-secondary",
        "text-text-invert"
      ],
      "font-size": [
        {
          text: [
            "heading-xsmall-mobile",
            "heading-small-mobile",
            "heading-medium-mobile",
            "heading-large-mobile",
            "heading-xlarge-mobile",
            "heading-xsmall",
            "heading-small",
            "heading-medium",
            "heading-large",
            "heading-xlarge",
            "label-mobile",
            "lead-mobile",
            "paragraph-mobile",
            "small-mobile",
            "link-mobile",
            "label",
            "lead",
            "paragraph",
            "small",
            "link"
          ]
        }
      ]
    }
  }
});
function I(...e) {
  return XL(We(e));
}
function QL(...e) {
  return We(e);
}
const JL = ({
  children: e,
  variant: t = "primary",
  className: n,
  backgroundClassName: r
}) => {
  const o = {
    primary: I("bg-surface-common-icon-highlight"),
    secondary: I("bg-surface-common-subtle"),
    currentColor: I("bg-neutral-100")
  }, i = I(
    "flex items-center justify-center p-1",
    o[t],
    n,
    r
  );
  return /* @__PURE__ */ d("div", { className: i, children: e });
};
function Q(e) {
  return (t) => function(n) {
    const r = {
      className: n.className ? n.className : void 0,
      backgroundClassName: n.backgroundClassName ? n.backgroundClassName : void 0,
      accessibilityLabel: n.accessibilityLabel ? n.accessibilityLabel : void 0,
      decorative: n.decorative ? n.decorative : !0,
      flip: n.flip ? n.flip : !1,
      flipVertical: n.flipVertical ? n.flipVertical : !1,
      inline: n.inline ? n.inline : !1,
      size: n.size ? n.size : "default",
      colorVariant: n.colorVariant ? n.colorVariant : "currentColor",
      backgrounded: n.backgrounded ? n.backgrounded : !1,
      backgroundVariant: n.backgroundVariant ? n.backgroundVariant : "round"
    }, {
      accessibilityLabel: o,
      decorative: i,
      flip: a,
      className: s,
      flipVertical: l,
      inline: c,
      size: u,
      colorVariant: f,
      backgrounded: h,
      backgroundClassName: p,
      backgroundVariant: C
    } = r, m = {
      default: I("h-[20px] w-[20px] sm:h-[20px] sm:w-[20px]"),
      xsmall: I("h-[16px] w-[16px]"),
      small: I("h-[20px] w-[20px]"),
      medium: I("h-[24px] w-[24px]"),
      current: I("h-[1em]")
    }, g = I(
      f === "primary" && "text-surface-common-icon-color",
      f === "secondary" && "text-surface-common-secondary",
      f === "currentColor" && "fill-current",
      c ? "inline" : "block",
      u && m[u],
      s && s
    ), v = {
      title: e || "icon",
      focusable: "false",
      role: i ? "presentation" : "img",
      style: {
        transform: a || l ? `scale(${a ? -1 : 1}, ${l ? -1 : 1})` : "scale(1)"
        // keep scale(1) for transition flipping
      }
    };
    o ? v["aria-label"] = o : v["aria-hidden"] = !0;
    const y = {
      round: I("rounded-full"),
      square: I("rounded-md")
    }, w = {
      default: I("p-[7px]"),
      xsmall: I("p-[6px]"),
      small: I("p-[7px]"),
      medium: I("p-[8px]"),
      current: I("p-[7px]")
    }, x = I(
      C && y[C],
      u && m[u],
      u && w[u]
    );
    return h ? /* @__PURE__ */ d(
      JL,
      {
        variant: f,
        className: x,
        backgroundClassName: p,
        children: /* @__PURE__ */ d(t, { className: g, ...v })
      }
    ) : /* @__PURE__ */ d(t, { className: g, ...v });
  };
}
const eN = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M6.82502 12L9.72502 14.9C9.92502 15.1 10.0209 15.3333 10.0125 15.6C10.0042 15.8667 9.90002 16.1 9.70002 16.3C9.50002 16.4833 9.26669 16.5792 9.00002 16.5875C8.73336 16.5958 8.50002 16.5 8.30002 16.3L3.70002 11.7C3.50002 11.5 3.40002 11.2667 3.40002 11C3.40002 10.7333 3.50002 10.5 3.70002 10.3L8.30002 5.69999C8.48336 5.51665 8.71252 5.42499 8.98752 5.42499C9.26252 5.42499 9.50002 5.51665 9.70002 5.69999C9.90002 5.89999 10 6.13749 10 6.41249C10 6.68749 9.90002 6.92499 9.70002 7.12499L6.82502 9.99999H16C17.3834 9.99999 18.5625 10.4875 19.5375 11.4625C20.5125 12.4375 21 13.6167 21 15V18C21 18.2833 20.9042 18.5208 20.7125 18.7125C20.5209 18.9042 20.2834 19 20 19C19.7167 19 19.4792 18.9042 19.2875 18.7125C19.0959 18.5208 19 18.2833 19 18V15C19 14.1667 18.7084 13.4583 18.125 12.875C17.5417 12.2917 16.8334 12 16 12H6.82502Z",
    fill: "currentColor"
  }
) }), Tm = Q("IconBack")(eN), Gc = ({
  svgClassName: e,
  className: t,
  afterText: n,
  beforeText: r
}) => {
  const o = I(
    "right-md flex items-center text-surface-common-primary",
    t
  ), i = I("animate-spin fill-current text-current", e);
  return /* @__PURE__ */ F("div", { className: o, children: [
    r && /* @__PURE__ */ d("span", { className: "mr-sm text-current", children: r }),
    /* @__PURE__ */ d(
      "svg",
      {
        className: i,
        viewBox: "0 -960 960 960",
        shapeRendering: "geometricPrecision",
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        children: /* @__PURE__ */ d(
          "path",
          {
            fill: "currentColor",
            d: "M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-155.5t86-127Q252-817 325-848.5T480-880q17 0 28.5 11.5T520-840q0 17-11.5 28.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160q133 0 226.5-93.5T800-480q0-17 11.5-28.5T840-520q17 0 28.5 11.5T880-480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480-80Z"
          }
        )
      }
    ),
    n && /* @__PURE__ */ d("span", { className: "ml-sm text-current", children: n })
  ] });
}, i_ = O.createContext(null), a_ = () => {
  const e = O.useContext(i_);
  if (e == null)
    throw new Error("Tooltip components must be wrapped in <Tooltip />");
  return e;
};
function yu() {
  return typeof window < "u";
}
function I1(e) {
  return Rd(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Kn(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function So(e) {
  var t;
  return (t = (Rd(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Rd(e) {
  return yu() ? e instanceof Node || e instanceof Kn(e).Node : !1;
}
function St(e) {
  return yu() ? e instanceof Element || e instanceof Kn(e).Element : !1;
}
function Ht(e) {
  return yu() ? e instanceof HTMLElement || e instanceof Kn(e).HTMLElement : !1;
}
function c9(e) {
  return !yu() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Kn(e).ShadowRoot;
}
const tN = /* @__PURE__ */ new Set(["inline", "contents"]);
function M2(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = lr(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !tN.has(o);
}
const nN = /* @__PURE__ */ new Set(["table", "td", "th"]);
function rN(e) {
  return nN.has(I1(e));
}
const oN = [":popover-open", ":modal"];
function bu(e) {
  return oN.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const iN = ["transform", "translate", "scale", "rotate", "perspective"], aN = ["transform", "translate", "scale", "rotate", "perspective", "filter"], sN = ["paint", "layout", "strict", "content"];
function kd(e) {
  const t = wu(), n = St(e) ? lr(e) : e;
  return iN.some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || aN.some((r) => (n.willChange || "").includes(r)) || sN.some((r) => (n.contain || "").includes(r));
}
function lN(e) {
  let t = Uo(e);
  for (; Ht(t) && !zo(t); ) {
    if (kd(t))
      return t;
    if (bu(t))
      return null;
    t = Uo(t);
  }
  return null;
}
function wu() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const cN = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function zo(e) {
  return cN.has(I1(e));
}
function lr(e) {
  return Kn(e).getComputedStyle(e);
}
function xu(e) {
  return St(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Uo(e) {
  if (I1(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    c9(e) && e.host || // Fallback.
    So(e)
  );
  return c9(t) ? t.host : t;
}
function s_(e) {
  const t = Uo(e);
  return zo(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Ht(t) && M2(t) ? t : s_(t);
}
function w1(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = s_(e), i = o === ((r = e.ownerDocument) == null ? void 0 : r.body), a = Kn(o);
  if (i) {
    const s = u9(a);
    return t.concat(a, a.visualViewport || [], M2(o) ? o : [], s && n ? w1(s) : []);
  }
  return t.concat(o, w1(o, [], n));
}
function u9(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
const l_ = ["top", "right", "bottom", "left"], Im = ["start", "end"], Dm = /* @__PURE__ */ l_.reduce((e, t) => e.concat(t, t + "-" + Im[0], t + "-" + Im[1]), []), E1 = Math.min, or = Math.max, Kc = Math.round, aa = Math.floor, ho = (e) => ({
  x: e,
  y: e
}), uN = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, fN = {
  start: "end",
  end: "start"
};
function f9(e, t, n) {
  return or(e, E1(t, n));
}
function vo(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Zr(e) {
  return e.split("-")[0];
}
function Hr(e) {
  return e.split("-")[1];
}
function Ld(e) {
  return e === "x" ? "y" : "x";
}
function Nd(e) {
  return e === "y" ? "height" : "width";
}
const dN = /* @__PURE__ */ new Set(["top", "bottom"]);
function lo(e) {
  return dN.has(Zr(e)) ? "y" : "x";
}
function Fd(e) {
  return Ld(lo(e));
}
function c_(e, t, n) {
  n === void 0 && (n = !1);
  const r = Hr(e), o = Fd(e), i = Nd(o);
  let a = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (a = Xc(a)), [a, Xc(a)];
}
function hN(e) {
  const t = Xc(e);
  return [Yc(e), t, Yc(t)];
}
function Yc(e) {
  return e.replace(/start|end/g, (t) => fN[t]);
}
const Rm = ["left", "right"], km = ["right", "left"], pN = ["top", "bottom"], mN = ["bottom", "top"];
function gN(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? km : Rm : t ? Rm : km;
    case "left":
    case "right":
      return t ? pN : mN;
    default:
      return [];
  }
}
function CN(e, t, n, r) {
  const o = Hr(e);
  let i = gN(Zr(e), n === "start", r);
  return o && (i = i.map((a) => a + "-" + o), t && (i = i.concat(i.map(Yc)))), i;
}
function Xc(e) {
  return e.replace(/left|right|bottom|top/g, (t) => uN[t]);
}
function vN(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function u_(e) {
  return typeof e != "number" ? vN(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Qc(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var yN = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], Jc = /* @__PURE__ */ yN.join(","), f_ = typeof Element > "u", Ra = f_ ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, e5 = !f_ && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e?.ownerDocument;
}, t5 = function e(t, n) {
  var r;
  n === void 0 && (n = !0);
  var o = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, "inert"), i = o === "" || o === "true", a = i || n && t && e(t.parentNode);
  return a;
}, bN = function(t) {
  var n, r = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return r === "" || r === "true";
}, d_ = function(t, n, r) {
  if (t5(t))
    return [];
  var o = Array.prototype.slice.apply(t.querySelectorAll(Jc));
  return n && Ra.call(t, Jc) && o.unshift(t), o = o.filter(r), o;
}, h_ = function e(t, n, r) {
  for (var o = [], i = Array.from(t); i.length; ) {
    var a = i.shift();
    if (!t5(a, !1))
      if (a.tagName === "SLOT") {
        var s = a.assignedElements(), l = s.length ? s : a.children, c = e(l, !0, r);
        r.flatten ? o.push.apply(o, c) : o.push({
          scopeParent: a,
          candidates: c
        });
      } else {
        var u = Ra.call(a, Jc);
        u && r.filter(a) && (n || !t.includes(a)) && o.push(a);
        var f = a.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(a), h = !t5(f, !1) && (!r.shadowRootFilter || r.shadowRootFilter(a));
        if (f && h) {
          var p = e(f === !0 ? a.children : f.children, !0, r);
          r.flatten ? o.push.apply(o, p) : o.push({
            scopeParent: a,
            candidates: p
          });
        } else
          i.unshift.apply(i, a.children);
      }
  }
  return o;
}, p_ = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, m_ = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || bN(t)) && !p_(t) ? 0 : t.tabIndex;
}, wN = function(t, n) {
  var r = m_(t);
  return r < 0 && n && !p_(t) ? 0 : r;
}, xN = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, g_ = function(t) {
  return t.tagName === "INPUT";
}, SN = function(t) {
  return g_(t) && t.type === "hidden";
}, MN = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return n;
}, EN = function(t, n) {
  for (var r = 0; r < t.length; r++)
    if (t[r].checked && t[r].form === n)
      return t[r];
}, _N = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || e5(t), r = function(s) {
    return n.querySelectorAll('input[type="radio"][name="' + s + '"]');
  }, o;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    o = r(window.CSS.escape(t.name));
  else
    try {
      o = r(t.name);
    } catch (a) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", a.message), !1;
    }
  var i = EN(o, t.form);
  return !i || i === t;
}, ON = function(t) {
  return g_(t) && t.type === "radio";
}, AN = function(t) {
  return ON(t) && !_N(t);
}, PN = function(t) {
  var n, r = t && e5(t), o = (n = r) === null || n === void 0 ? void 0 : n.host, i = !1;
  if (r && r !== t) {
    var a, s, l;
    for (i = !!((a = o) !== null && a !== void 0 && (s = a.ownerDocument) !== null && s !== void 0 && s.contains(o) || t != null && (l = t.ownerDocument) !== null && l !== void 0 && l.contains(t)); !i && o; ) {
      var c, u, f;
      r = e5(o), o = (c = r) === null || c === void 0 ? void 0 : c.host, i = !!((u = o) !== null && u !== void 0 && (f = u.ownerDocument) !== null && f !== void 0 && f.contains(o));
    }
  }
  return i;
}, Lm = function(t) {
  var n = t.getBoundingClientRect(), r = n.width, o = n.height;
  return r === 0 && o === 0;
}, TN = function(t, n) {
  var r = n.displayCheck, o = n.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var i = Ra.call(t, "details>summary:first-of-type"), a = i ? t.parentElement : t;
  if (Ra.call(a, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || r === "legacy-full") {
    if (typeof o == "function") {
      for (var s = t; t; ) {
        var l = t.parentElement, c = e5(t);
        if (l && !l.shadowRoot && o(l) === !0)
          return Lm(t);
        t.assignedSlot ? t = t.assignedSlot : !l && c !== t.ownerDocument ? t = c.host : t = l;
      }
      t = s;
    }
    if (PN(t))
      return !t.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return Lm(t);
  return !1;
}, IN = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var r = 0; r < n.children.length; r++) {
          var o = n.children.item(r);
          if (o.tagName === "LEGEND")
            return Ra.call(n, "fieldset[disabled] *") ? !0 : !o.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, d9 = function(t, n) {
  return !(n.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  t5(n) || SN(n) || TN(n, t) || // For a details element with a summary, the summary element gets the focus
  MN(n) || IN(n));
}, h9 = function(t, n) {
  return !(AN(n) || m_(n) < 0 || !d9(t, n));
}, DN = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, RN = function e(t) {
  var n = [], r = [];
  return t.forEach(function(o, i) {
    var a = !!o.scopeParent, s = a ? o.scopeParent : o, l = wN(s, a), c = a ? e(o.candidates) : s;
    l === 0 ? a ? n.push.apply(n, c) : n.push(s) : r.push({
      documentOrder: i,
      tabIndex: l,
      item: o,
      isScope: a,
      content: c
    });
  }), r.sort(xN).reduce(function(o, i) {
    return i.isScope ? o.push.apply(o, i.content) : o.push(i.content), o;
  }, []).concat(n);
}, Su = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = h_([t], n.includeContainer, {
    filter: h9.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: DN
  }) : r = d_(t, n.includeContainer, h9.bind(null, n)), RN(r);
}, kN = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = h_([t], n.includeContainer, {
    filter: d9.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : r = d_(t, n.includeContainer, d9.bind(null, n)), r;
}, C_ = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return Ra.call(t, Jc) === !1 ? !1 : h9(n, t);
};
function Vd() {
  const e = navigator.userAgentData;
  return e != null && e.platform ? e.platform : navigator.platform;
}
function v_() {
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? e.brands.map((t) => {
    let {
      brand: n,
      version: r
    } = t;
    return n + "/" + r;
  }).join(" ") : navigator.userAgent;
}
function y_() {
  return /apple/i.test(navigator.vendor);
}
function p9() {
  const e = /android/i;
  return e.test(Vd()) || e.test(v_());
}
function LN() {
  return Vd().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function b_() {
  return v_().includes("jsdom/");
}
const Nm = "data-floating-ui-focusable", NN = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])", Z0 = "ArrowLeft", W0 = "ArrowRight", FN = "ArrowUp", VN = "ArrowDown";
function no(e) {
  let t = e.activeElement;
  for (; ((n = t) == null || (n = n.shadowRoot) == null ? void 0 : n.activeElement) != null; ) {
    var n;
    t = t.shadowRoot.activeElement;
  }
  return t;
}
function vn(e, t) {
  if (!e || !t)
    return !1;
  const n = t.getRootNode == null ? void 0 : t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && c9(n)) {
    let r = t;
    for (; r; ) {
      if (e === r)
        return !0;
      r = r.parentNode || r.host;
    }
  }
  return !1;
}
function Lo(e) {
  return "composedPath" in e ? e.composedPath()[0] : e.target;
}
function q0(e, t) {
  if (t == null)
    return !1;
  if ("composedPath" in e)
    return e.composedPath().includes(t);
  const n = e;
  return n.target != null && t.contains(n.target);
}
function BN(e) {
  return e.matches("html,body");
}
function bn(e) {
  return e?.ownerDocument || document;
}
function Bd(e) {
  return Ht(e) && e.matches(NN);
}
function m9(e) {
  return e ? e.getAttribute("role") === "combobox" && Bd(e) : !1;
}
function $N(e) {
  if (!e || b_()) return !0;
  try {
    return e.matches(":focus-visible");
  } catch {
    return !0;
  }
}
function n5(e) {
  return e ? e.hasAttribute(Nm) ? e : e.querySelector("[" + Nm + "]") || e : null;
}
function ui(e, t, n) {
  return n === void 0 && (n = !0), e.filter((o) => {
    var i;
    return o.parentId === t && (!n || ((i = o.context) == null ? void 0 : i.open));
  }).flatMap((o) => [o, ...ui(e, o.id, n)]);
}
function jN(e, t) {
  let n, r = -1;
  function o(i, a) {
    a > r && (n = i, r = a), ui(e, i).forEach((l) => {
      o(l.id, a + 1);
    });
  }
  return o(t, 0), e.find((i) => i.id === n);
}
function Fm(e, t) {
  var n;
  let r = [], o = (n = e.find((i) => i.id === t)) == null ? void 0 : n.parentId;
  for (; o; ) {
    const i = e.find((a) => a.id === o);
    o = i?.parentId, i && (r = r.concat(i));
  }
  return r;
}
function yn(e) {
  e.preventDefault(), e.stopPropagation();
}
function HN(e) {
  return "nativeEvent" in e;
}
function w_(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : p9() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function x_(e) {
  return b_() ? !1 : !p9() && e.width === 0 && e.height === 0 || p9() && e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  e.width < 1 && e.height < 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "touch";
}
function Ol(e, t) {
  const n = ["mouse", "pen"];
  return t || n.push("", void 0), n.includes(e);
}
var zN = typeof document < "u", ZN = function() {
}, vt = zN ? x2 : ZN;
const WN = {
  ...A
};
function Wn(e) {
  const t = A.useRef(e);
  return vt(() => {
    t.current = e;
  }), t;
}
const qN = WN.useInsertionEffect, UN = qN || ((e) => e());
function zt(e) {
  const t = A.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return UN(() => {
    t.current = e;
  }), A.useCallback(function() {
    for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
      r[o] = arguments[o];
    return t.current == null ? void 0 : t.current(...r);
  }, []);
}
function Y2(e, t, n) {
  return Math.floor(e / t) !== n;
}
function hl(e, t) {
  return t < 0 || t >= e.current.length;
}
function U0(e, t) {
  return On(e, {
    disabledIndices: t
  });
}
function Vm(e, t) {
  return On(e, {
    decrement: !0,
    startingIndex: e.current.length,
    disabledIndices: t
  });
}
function On(e, t) {
  let {
    startingIndex: n = -1,
    decrement: r = !1,
    disabledIndices: o,
    amount: i = 1
  } = t === void 0 ? {} : t, a = n;
  do
    a += r ? -i : i;
  while (a >= 0 && a <= e.current.length - 1 && Fc(e, a, o));
  return a;
}
function GN(e, t) {
  let {
    event: n,
    orientation: r,
    loop: o,
    rtl: i,
    cols: a,
    disabledIndices: s,
    minIndex: l,
    maxIndex: c,
    prevIndex: u,
    stopEvent: f = !1
  } = t, h = u;
  if (n.key === FN) {
    if (f && yn(n), u === -1)
      h = c;
    else if (h = On(e, {
      startingIndex: h,
      amount: a,
      decrement: !0,
      disabledIndices: s
    }), o && (u - a < l || h < 0)) {
      const p = u % a, C = c % a, m = c - (C - p);
      C === p ? h = c : h = C > p ? m : m - a;
    }
    hl(e, h) && (h = u);
  }
  if (n.key === VN && (f && yn(n), u === -1 ? h = l : (h = On(e, {
    startingIndex: u,
    amount: a,
    disabledIndices: s
  }), o && u + a > c && (h = On(e, {
    startingIndex: u % a - a,
    amount: a,
    disabledIndices: s
  }))), hl(e, h) && (h = u)), r === "both") {
    const p = aa(u / a);
    n.key === (i ? Z0 : W0) && (f && yn(n), u % a !== a - 1 ? (h = On(e, {
      startingIndex: u,
      disabledIndices: s
    }), o && Y2(h, a, p) && (h = On(e, {
      startingIndex: u - u % a - 1,
      disabledIndices: s
    }))) : o && (h = On(e, {
      startingIndex: u - u % a - 1,
      disabledIndices: s
    })), Y2(h, a, p) && (h = u)), n.key === (i ? W0 : Z0) && (f && yn(n), u % a !== 0 ? (h = On(e, {
      startingIndex: u,
      decrement: !0,
      disabledIndices: s
    }), o && Y2(h, a, p) && (h = On(e, {
      startingIndex: u + (a - u % a),
      decrement: !0,
      disabledIndices: s
    }))) : o && (h = On(e, {
      startingIndex: u + (a - u % a),
      decrement: !0,
      disabledIndices: s
    })), Y2(h, a, p) && (h = u));
    const C = aa(c / a) === p;
    hl(e, h) && (o && C ? h = n.key === (i ? W0 : Z0) ? c : On(e, {
      startingIndex: u - u % a - 1,
      disabledIndices: s
    }) : h = u);
  }
  return h;
}
function KN(e, t, n) {
  const r = [];
  let o = 0;
  return e.forEach((i, a) => {
    let {
      width: s,
      height: l
    } = i;
    if (s > t && process.env.NODE_ENV !== "production")
      throw new Error("[Floating UI]: Invalid grid - item width at index " + a + " is greater than grid columns");
    let c = !1;
    for (n && (o = 0); !c; ) {
      const u = [];
      for (let f = 0; f < s; f++)
        for (let h = 0; h < l; h++)
          u.push(o + f + h * t);
      o % t + s <= t && u.every((f) => r[f] == null) ? (u.forEach((f) => {
        r[f] = a;
      }), c = !0) : o++;
    }
  }), [...r];
}
function YN(e, t, n, r, o) {
  if (e === -1) return -1;
  const i = n.indexOf(e), a = t[e];
  switch (o) {
    case "tl":
      return i;
    case "tr":
      return a ? i + a.width - 1 : i;
    case "bl":
      return a ? i + (a.height - 1) * r : i;
    case "br":
      return n.lastIndexOf(e);
  }
}
function XN(e, t) {
  return t.flatMap((n, r) => e.includes(n) ? [r] : []);
}
function Fc(e, t, n) {
  if (typeof n == "function")
    return n(t);
  if (n)
    return n.includes(t);
  const r = e.current[t];
  return r == null || r.hasAttribute("disabled") || r.getAttribute("aria-disabled") === "true";
}
const E2 = () => ({
  getShadowRoot: !0,
  displayCheck: (
    // JSDOM does not support the `tabbable` library. To solve this we can
    // check if `ResizeObserver` is a real function (not polyfilled), which
    // determines if the current environment is JSDOM-like.
    typeof ResizeObserver == "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
  )
});
function S_(e, t) {
  const n = Su(e, E2()), r = n.length;
  if (r === 0) return;
  const o = no(bn(e)), i = n.indexOf(o), a = i === -1 ? t === 1 ? 0 : r - 1 : i + t;
  return n[a];
}
function M_(e) {
  return S_(bn(e).body, 1) || e;
}
function E_(e) {
  return S_(bn(e).body, -1) || e;
}
function pl(e, t) {
  const n = t || e.currentTarget, r = e.relatedTarget;
  return !r || !vn(n, r);
}
function QN(e) {
  Su(e, E2()).forEach((n) => {
    n.dataset.tabindex = n.getAttribute("tabindex") || "", n.setAttribute("tabindex", "-1");
  });
}
function Bm(e) {
  e.querySelectorAll("[data-tabindex]").forEach((n) => {
    const r = n.dataset.tabindex;
    delete n.dataset.tabindex, r ? n.setAttribute("tabindex", r) : n.removeAttribute("tabindex");
  });
}
function $m(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const i = lo(t), a = Fd(t), s = Nd(a), l = Zr(t), c = i === "y", u = r.x + r.width / 2 - o.width / 2, f = r.y + r.height / 2 - o.height / 2, h = r[s] / 2 - o[s] / 2;
  let p;
  switch (l) {
    case "top":
      p = {
        x: u,
        y: r.y - o.height
      };
      break;
    case "bottom":
      p = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      p = {
        x: r.x + r.width,
        y: f
      };
      break;
    case "left":
      p = {
        x: r.x - o.width,
        y: f
      };
      break;
    default:
      p = {
        x: r.x,
        y: r.y
      };
  }
  switch (Hr(t)) {
    case "start":
      p[a] -= h * (n && c ? -1 : 1);
      break;
    case "end":
      p[a] += h * (n && c ? -1 : 1);
      break;
  }
  return p;
}
const JN = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: a
  } = n, s = i.filter(Boolean), l = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let c = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: u,
    y: f
  } = $m(c, r, l), h = r, p = {}, C = 0;
  for (let m = 0; m < s.length; m++) {
    const {
      name: g,
      fn: v
    } = s[m], {
      x: y,
      y: w,
      data: x,
      reset: b
    } = await v({
      x: u,
      y: f,
      initialPlacement: r,
      placement: h,
      strategy: o,
      middlewareData: p,
      rects: c,
      platform: a,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = y ?? u, f = w ?? f, p = {
      ...p,
      [g]: {
        ...p[g],
        ...x
      }
    }, b && C <= 50 && (C++, typeof b == "object" && (b.placement && (h = b.placement), b.rects && (c = b.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : b.rects), {
      x: u,
      y: f
    } = $m(c, h, l)), m = -1);
  }
  return {
    x: u,
    y: f,
    placement: h,
    strategy: o,
    middlewareData: p
  };
};
async function ka(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: i,
    rects: a,
    elements: s,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: f = "floating",
    altBoundary: h = !1,
    padding: p = 0
  } = vo(t, e), C = u_(p), g = s[h ? f === "floating" ? "reference" : "floating" : f], v = Qc(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(g))) == null || n ? g : g.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(s.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), y = f === "floating" ? {
    x: r,
    y: o,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, w = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(s.floating)), x = await (i.isElement == null ? void 0 : i.isElement(w)) ? await (i.getScale == null ? void 0 : i.getScale(w)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, b = Qc(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: y,
    offsetParent: w,
    strategy: l
  }) : y);
  return {
    top: (v.top - b.top + C.top) / x.y,
    bottom: (b.bottom - v.bottom + C.bottom) / x.y,
    left: (v.left - b.left + C.left) / x.x,
    right: (b.right - v.right + C.right) / x.x
  };
}
const eF = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: i,
      platform: a,
      elements: s,
      middlewareData: l
    } = t, {
      element: c,
      padding: u = 0
    } = vo(e, t) || {};
    if (c == null)
      return {};
    const f = u_(u), h = {
      x: n,
      y: r
    }, p = Fd(o), C = Nd(p), m = await a.getDimensions(c), g = p === "y", v = g ? "top" : "left", y = g ? "bottom" : "right", w = g ? "clientHeight" : "clientWidth", x = i.reference[C] + i.reference[p] - h[p] - i.floating[C], b = h[p] - i.reference[p], S = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(c));
    let M = S ? S[w] : 0;
    (!M || !await (a.isElement == null ? void 0 : a.isElement(S))) && (M = s.floating[w] || i.floating[C]);
    const E = x / 2 - b / 2, P = M / 2 - m[C] / 2 - 1, T = E1(f[v], P), _ = E1(f[y], P), D = T, N = M - m[C] - _, R = M / 2 - m[C] / 2 + E, L = f9(D, R, N), B = !l.arrow && Hr(o) != null && R !== L && i.reference[C] / 2 - (R < D ? T : _) - m[C] / 2 < 0, V = B ? R < D ? R - D : R - N : 0;
    return {
      [p]: h[p] + V,
      data: {
        [p]: L,
        centerOffset: R - L - V,
        ...B && {
          alignmentOffset: V
        }
      },
      reset: B
    };
  }
});
function tF(e, t, n) {
  return (e ? [...n.filter((o) => Hr(o) === e), ...n.filter((o) => Hr(o) !== e)] : n.filter((o) => Zr(o) === o)).filter((o) => e ? Hr(o) === e || (t ? Yc(o) !== o : !1) : !0);
}
const nF = function(e) {
  return e === void 0 && (e = {}), {
    name: "autoPlacement",
    options: e,
    async fn(t) {
      var n, r, o;
      const {
        rects: i,
        middlewareData: a,
        placement: s,
        platform: l,
        elements: c
      } = t, {
        crossAxis: u = !1,
        alignment: f,
        allowedPlacements: h = Dm,
        autoAlignment: p = !0,
        ...C
      } = vo(e, t), m = f !== void 0 || h === Dm ? tF(f || null, p, h) : h, g = await ka(t, C), v = ((n = a.autoPlacement) == null ? void 0 : n.index) || 0, y = m[v];
      if (y == null)
        return {};
      const w = c_(y, i, await (l.isRTL == null ? void 0 : l.isRTL(c.floating)));
      if (s !== y)
        return {
          reset: {
            placement: m[0]
          }
        };
      const x = [g[Zr(y)], g[w[0]], g[w[1]]], b = [...((r = a.autoPlacement) == null ? void 0 : r.overflows) || [], {
        placement: y,
        overflows: x
      }], S = m[v + 1];
      if (S)
        return {
          data: {
            index: v + 1,
            overflows: b
          },
          reset: {
            placement: S
          }
        };
      const M = b.map((T) => {
        const _ = Hr(T.placement);
        return [T.placement, _ && u ? (
          // Check along the mainAxis and main crossAxis side.
          T.overflows.slice(0, 2).reduce((D, N) => D + N, 0)
        ) : (
          // Check only the mainAxis.
          T.overflows[0]
        ), T.overflows];
      }).sort((T, _) => T[1] - _[1]), P = ((o = M.filter((T) => T[2].slice(
        0,
        // Aligned placements should not check their opposite crossAxis
        // side.
        Hr(T[0]) ? 2 : 3
      ).every((_) => _ <= 0))[0]) == null ? void 0 : o[0]) || M[0][0];
      return P !== s ? {
        data: {
          index: v + 1,
          overflows: b
        },
        reset: {
          placement: P
        }
      } : {};
    }
  };
}, rF = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: i,
        rects: a,
        initialPlacement: s,
        platform: l,
        elements: c
      } = t, {
        mainAxis: u = !0,
        crossAxis: f = !0,
        fallbackPlacements: h,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: C = "none",
        flipAlignment: m = !0,
        ...g
      } = vo(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const v = Zr(o), y = lo(s), w = Zr(s) === s, x = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), b = h || (w || !m ? [Xc(s)] : hN(s)), S = C !== "none";
      !h && S && b.push(...CN(s, m, C, x));
      const M = [s, ...b], E = await ka(t, g), P = [];
      let T = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (u && P.push(E[v]), f) {
        const R = c_(o, a, x);
        P.push(E[R[0]], E[R[1]]);
      }
      if (T = [...T, {
        placement: o,
        overflows: P
      }], !P.every((R) => R <= 0)) {
        var _, D;
        const R = (((_ = i.flip) == null ? void 0 : _.index) || 0) + 1, L = M[R];
        if (L && (!(f === "alignment" ? y !== lo(L) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        T.every((k) => lo(k.placement) === y ? k.overflows[0] > 0 : !0)))
          return {
            data: {
              index: R,
              overflows: T
            },
            reset: {
              placement: L
            }
          };
        let B = (D = T.filter((V) => V.overflows[0] <= 0).sort((V, k) => V.overflows[1] - k.overflows[1])[0]) == null ? void 0 : D.placement;
        if (!B)
          switch (p) {
            case "bestFit": {
              var N;
              const V = (N = T.filter((k) => {
                if (S) {
                  const z = lo(k.placement);
                  return z === y || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  z === "y";
                }
                return !0;
              }).map((k) => [k.placement, k.overflows.filter((z) => z > 0).reduce((z, $) => z + $, 0)]).sort((k, z) => k[1] - z[1])[0]) == null ? void 0 : N[0];
              V && (B = V);
              break;
            }
            case "initialPlacement":
              B = s;
              break;
          }
        if (o !== B)
          return {
            reset: {
              placement: B
            }
          };
      }
      return {};
    }
  };
};
function jm(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Hm(e) {
  return l_.some((t) => e[t] >= 0);
}
const oF = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...o
      } = vo(e, t);
      switch (r) {
        case "referenceHidden": {
          const i = await ka(t, {
            ...o,
            elementContext: "reference"
          }), a = jm(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: a,
              referenceHidden: Hm(a)
            }
          };
        }
        case "escaped": {
          const i = await ka(t, {
            ...o,
            altBoundary: !0
          }), a = jm(i, n.floating);
          return {
            data: {
              escapedOffsets: a,
              escaped: Hm(a)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, __ = /* @__PURE__ */ new Set(["left", "top"]);
async function iF(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), a = Zr(n), s = Hr(n), l = lo(n) === "y", c = __.has(a) ? -1 : 1, u = i && l ? -1 : 1, f = vo(t, e);
  let {
    mainAxis: h,
    crossAxis: p,
    alignmentAxis: C
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return s && typeof C == "number" && (p = s === "end" ? C * -1 : C), l ? {
    x: p * u,
    y: h * c
  } : {
    x: h * c,
    y: p * u
  };
}
const aF = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: i,
        placement: a,
        middlewareData: s
      } = t, l = await iF(t, e);
      return a === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: o + l.x,
        y: i + l.y,
        data: {
          ...l,
          placement: a
        }
      };
    }
  };
}, sF = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: i = !0,
        crossAxis: a = !1,
        limiter: s = {
          fn: (g) => {
            let {
              x: v,
              y
            } = g;
            return {
              x: v,
              y
            };
          }
        },
        ...l
      } = vo(e, t), c = {
        x: n,
        y: r
      }, u = await ka(t, l), f = lo(Zr(o)), h = Ld(f);
      let p = c[h], C = c[f];
      if (i) {
        const g = h === "y" ? "top" : "left", v = h === "y" ? "bottom" : "right", y = p + u[g], w = p - u[v];
        p = f9(y, p, w);
      }
      if (a) {
        const g = f === "y" ? "top" : "left", v = f === "y" ? "bottom" : "right", y = C + u[g], w = C - u[v];
        C = f9(y, C, w);
      }
      const m = s.fn({
        ...t,
        [h]: p,
        [f]: C
      });
      return {
        ...m,
        data: {
          x: m.x - n,
          y: m.y - r,
          enabled: {
            [h]: i,
            [f]: a
          }
        }
      };
    }
  };
}, lF = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: i,
        middlewareData: a
      } = t, {
        offset: s = 0,
        mainAxis: l = !0,
        crossAxis: c = !0
      } = vo(e, t), u = {
        x: n,
        y: r
      }, f = lo(o), h = Ld(f);
      let p = u[h], C = u[f];
      const m = vo(s, t), g = typeof m == "number" ? {
        mainAxis: m,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...m
      };
      if (l) {
        const w = h === "y" ? "height" : "width", x = i.reference[h] - i.floating[w] + g.mainAxis, b = i.reference[h] + i.reference[w] - g.mainAxis;
        p < x ? p = x : p > b && (p = b);
      }
      if (c) {
        var v, y;
        const w = h === "y" ? "width" : "height", x = __.has(Zr(o)), b = i.reference[f] - i.floating[w] + (x && ((v = a.offset) == null ? void 0 : v[f]) || 0) + (x ? 0 : g.crossAxis), S = i.reference[f] + i.reference[w] + (x ? 0 : ((y = a.offset) == null ? void 0 : y[f]) || 0) - (x ? g.crossAxis : 0);
        C < b ? C = b : C > S && (C = S);
      }
      return {
        [h]: p,
        [f]: C
      };
    }
  };
}, cF = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        rects: i,
        platform: a,
        elements: s
      } = t, {
        apply: l = () => {
        },
        ...c
      } = vo(e, t), u = await ka(t, c), f = Zr(o), h = Hr(o), p = lo(o) === "y", {
        width: C,
        height: m
      } = i.floating;
      let g, v;
      f === "top" || f === "bottom" ? (g = f, v = h === (await (a.isRTL == null ? void 0 : a.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (v = f, g = h === "end" ? "top" : "bottom");
      const y = m - u.top - u.bottom, w = C - u.left - u.right, x = E1(m - u[g], y), b = E1(C - u[v], w), S = !t.middlewareData.shift;
      let M = x, E = b;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (E = w), (r = t.middlewareData.shift) != null && r.enabled.y && (M = y), S && !h) {
        const T = or(u.left, 0), _ = or(u.right, 0), D = or(u.top, 0), N = or(u.bottom, 0);
        p ? E = C - 2 * (T !== 0 || _ !== 0 ? T + _ : or(u.left, u.right)) : M = m - 2 * (D !== 0 || N !== 0 ? D + N : or(u.top, u.bottom));
      }
      await l({
        ...t,
        availableWidth: E,
        availableHeight: M
      });
      const P = await a.getDimensions(s.floating);
      return C !== P.width || m !== P.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function O_(e) {
  const t = lr(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = Ht(e), i = o ? e.offsetWidth : n, a = o ? e.offsetHeight : r, s = Kc(n) !== i || Kc(r) !== a;
  return s && (n = i, r = a), {
    width: n,
    height: r,
    $: s
  };
}
function $d(e) {
  return St(e) ? e : e.contextElement;
}
function ya(e) {
  const t = $d(e);
  if (!Ht(t))
    return ho(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = O_(t);
  let a = (i ? Kc(n.width) : n.width) / r, s = (i ? Kc(n.height) : n.height) / o;
  return (!a || !Number.isFinite(a)) && (a = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: a,
    y: s
  };
}
const uF = /* @__PURE__ */ ho(0);
function A_(e) {
  const t = Kn(e);
  return !wu() || !t.visualViewport ? uF : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function fF(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Kn(e) ? !1 : t;
}
function Ci(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), i = $d(e);
  let a = ho(1);
  t && (r ? St(r) && (a = ya(r)) : a = ya(e));
  const s = fF(i, n, r) ? A_(i) : ho(0);
  let l = (o.left + s.x) / a.x, c = (o.top + s.y) / a.y, u = o.width / a.x, f = o.height / a.y;
  if (i) {
    const h = Kn(i), p = r && St(r) ? Kn(r) : r;
    let C = h, m = u9(C);
    for (; m && r && p !== C; ) {
      const g = ya(m), v = m.getBoundingClientRect(), y = lr(m), w = v.left + (m.clientLeft + parseFloat(y.paddingLeft)) * g.x, x = v.top + (m.clientTop + parseFloat(y.paddingTop)) * g.y;
      l *= g.x, c *= g.y, u *= g.x, f *= g.y, l += w, c += x, C = Kn(m), m = u9(C);
    }
  }
  return Qc({
    width: u,
    height: f,
    x: l,
    y: c
  });
}
function Mu(e, t) {
  const n = xu(e).scrollLeft;
  return t ? t.left + n : Ci(So(e)).left + n;
}
function P_(e, t) {
  const n = e.getBoundingClientRect(), r = n.left + t.scrollLeft - Mu(e, n), o = n.top + t.scrollTop;
  return {
    x: r,
    y: o
  };
}
function dF(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const i = o === "fixed", a = So(r), s = t ? bu(t.floating) : !1;
  if (r === a || s && i)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = ho(1);
  const u = ho(0), f = Ht(r);
  if ((f || !f && !i) && ((I1(r) !== "body" || M2(a)) && (l = xu(r)), Ht(r))) {
    const p = Ci(r);
    c = ya(r), u.x = p.x + r.clientLeft, u.y = p.y + r.clientTop;
  }
  const h = a && !f && !i ? P_(a, l) : ho(0);
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - l.scrollLeft * c.x + u.x + h.x,
    y: n.y * c.y - l.scrollTop * c.y + u.y + h.y
  };
}
function hF(e) {
  return Array.from(e.getClientRects());
}
function pF(e) {
  const t = So(e), n = xu(e), r = e.ownerDocument.body, o = or(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = or(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let a = -n.scrollLeft + Mu(e);
  const s = -n.scrollTop;
  return lr(r).direction === "rtl" && (a += or(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: i,
    x: a,
    y: s
  };
}
const zm = 25;
function mF(e, t) {
  const n = Kn(e), r = So(e), o = n.visualViewport;
  let i = r.clientWidth, a = r.clientHeight, s = 0, l = 0;
  if (o) {
    i = o.width, a = o.height;
    const u = wu();
    (!u || u && t === "fixed") && (s = o.offsetLeft, l = o.offsetTop);
  }
  const c = Mu(r);
  if (c <= 0) {
    const u = r.ownerDocument, f = u.body, h = getComputedStyle(f), p = u.compatMode === "CSS1Compat" && parseFloat(h.marginLeft) + parseFloat(h.marginRight) || 0, C = Math.abs(r.clientWidth - f.clientWidth - p);
    C <= zm && (i -= C);
  } else c <= zm && (i += c);
  return {
    width: i,
    height: a,
    x: s,
    y: l
  };
}
const gF = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function CF(e, t) {
  const n = Ci(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, i = Ht(e) ? ya(e) : ho(1), a = e.clientWidth * i.x, s = e.clientHeight * i.y, l = o * i.x, c = r * i.y;
  return {
    width: a,
    height: s,
    x: l,
    y: c
  };
}
function Zm(e, t, n) {
  let r;
  if (t === "viewport")
    r = mF(e, n);
  else if (t === "document")
    r = pF(So(e));
  else if (St(t))
    r = CF(t, n);
  else {
    const o = A_(e);
    r = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return Qc(r);
}
function T_(e, t) {
  const n = Uo(e);
  return n === t || !St(n) || zo(n) ? !1 : lr(n).position === "fixed" || T_(n, t);
}
function vF(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = w1(e, [], !1).filter((s) => St(s) && I1(s) !== "body"), o = null;
  const i = lr(e).position === "fixed";
  let a = i ? Uo(e) : e;
  for (; St(a) && !zo(a); ) {
    const s = lr(a), l = kd(a);
    !l && s.position === "fixed" && (o = null), (i ? !l && !o : !l && s.position === "static" && !!o && gF.has(o.position) || M2(a) && !l && T_(e, a)) ? r = r.filter((u) => u !== a) : o = s, a = Uo(a);
  }
  return t.set(e, r), r;
}
function yF(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const a = [...n === "clippingAncestors" ? bu(t) ? [] : vF(t, this._c) : [].concat(n), r], s = a[0], l = a.reduce((c, u) => {
    const f = Zm(t, u, o);
    return c.top = or(f.top, c.top), c.right = E1(f.right, c.right), c.bottom = E1(f.bottom, c.bottom), c.left = or(f.left, c.left), c;
  }, Zm(t, s, o));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function bF(e) {
  const {
    width: t,
    height: n
  } = O_(e);
  return {
    width: t,
    height: n
  };
}
function wF(e, t, n) {
  const r = Ht(t), o = So(t), i = n === "fixed", a = Ci(e, !0, i, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = ho(0);
  function c() {
    l.x = Mu(o);
  }
  if (r || !r && !i)
    if ((I1(t) !== "body" || M2(o)) && (s = xu(t)), r) {
      const p = Ci(t, !0, i, t);
      l.x = p.x + t.clientLeft, l.y = p.y + t.clientTop;
    } else o && c();
  i && !r && o && c();
  const u = o && !r && !i ? P_(o, s) : ho(0), f = a.left + s.scrollLeft - l.x - u.x, h = a.top + s.scrollTop - l.y - u.y;
  return {
    x: f,
    y: h,
    width: a.width,
    height: a.height
  };
}
function G0(e) {
  return lr(e).position === "static";
}
function Wm(e, t) {
  if (!Ht(e) || lr(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return So(e) === n && (n = n.ownerDocument.body), n;
}
function I_(e, t) {
  const n = Kn(e);
  if (bu(e))
    return n;
  if (!Ht(e)) {
    let o = Uo(e);
    for (; o && !zo(o); ) {
      if (St(o) && !G0(o))
        return o;
      o = Uo(o);
    }
    return n;
  }
  let r = Wm(e, t);
  for (; r && rN(r) && G0(r); )
    r = Wm(r, t);
  return r && zo(r) && G0(r) && !kd(r) ? n : r || lN(e) || n;
}
const xF = async function(e) {
  const t = this.getOffsetParent || I_, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: wF(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function SF(e) {
  return lr(e).direction === "rtl";
}
const MF = {
  convertOffsetParentRelativeRectToViewportRelativeRect: dF,
  getDocumentElement: So,
  getClippingRect: yF,
  getOffsetParent: I_,
  getElementRects: xF,
  getClientRects: hF,
  getDimensions: bF,
  getScale: ya,
  isElement: St,
  isRTL: SF
};
function D_(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function EF(e, t) {
  let n = null, r;
  const o = So(e);
  function i() {
    var s;
    clearTimeout(r), (s = n) == null || s.disconnect(), n = null;
  }
  function a(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), i();
    const c = e.getBoundingClientRect(), {
      left: u,
      top: f,
      width: h,
      height: p
    } = c;
    if (s || t(), !h || !p)
      return;
    const C = aa(f), m = aa(o.clientWidth - (u + h)), g = aa(o.clientHeight - (f + p)), v = aa(u), w = {
      rootMargin: -C + "px " + -m + "px " + -g + "px " + -v + "px",
      threshold: or(0, E1(1, l)) || 1
    };
    let x = !0;
    function b(S) {
      const M = S[0].intersectionRatio;
      if (M !== l) {
        if (!x)
          return a();
        M ? a(!1, M) : r = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      M === 1 && !D_(c, e.getBoundingClientRect()) && a(), x = !1;
    }
    try {
      n = new IntersectionObserver(b, {
        ...w,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(b, w);
    }
    n.observe(e);
  }
  return a(!0), i;
}
function D1(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, c = $d(e), u = o || i ? [...c ? w1(c) : [], ...w1(t)] : [];
  u.forEach((v) => {
    o && v.addEventListener("scroll", n, {
      passive: !0
    }), i && v.addEventListener("resize", n);
  });
  const f = c && s ? EF(c, n) : null;
  let h = -1, p = null;
  a && (p = new ResizeObserver((v) => {
    let [y] = v;
    y && y.target === c && p && (p.unobserve(t), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var w;
      (w = p) == null || w.observe(t);
    })), n();
  }), c && !l && p.observe(c), p.observe(t));
  let C, m = l ? Ci(e) : null;
  l && g();
  function g() {
    const v = Ci(e);
    m && !D_(m, v) && n(), m = v, C = requestAnimationFrame(g);
  }
  return n(), () => {
    var v;
    u.forEach((y) => {
      o && y.removeEventListener("scroll", n), i && y.removeEventListener("resize", n);
    }), f?.(), (v = p) == null || v.disconnect(), p = null, l && cancelAnimationFrame(C);
  };
}
const R_ = aF, k_ = nF, L_ = sF, _F = rF, N_ = cF, OF = oF, qm = eF, AF = lF, PF = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: MF,
    ...n
  }, i = {
    ...o.platform,
    _c: r
  };
  return JN(e, t, {
    ...o,
    platform: i
  });
};
var TF = typeof document < "u", IF = function() {
}, Vc = TF ? x2 : IF;
function r5(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!r5(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = o[r];
      if (!(i === "_owner" && e.$$typeof) && !r5(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function F_(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Um(e, t) {
  const n = F_(e);
  return Math.round(t * n) / n;
}
function K0(e) {
  const t = A.useRef(e);
  return Vc(() => {
    t.current = e;
  }), t;
}
function V_(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: i,
      floating: a
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: c
  } = e, [u, f] = A.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [h, p] = A.useState(r);
  r5(h, r) || p(r);
  const [C, m] = A.useState(null), [g, v] = A.useState(null), y = A.useCallback((k) => {
    k !== S.current && (S.current = k, m(k));
  }, []), w = A.useCallback((k) => {
    k !== M.current && (M.current = k, v(k));
  }, []), x = i || C, b = a || g, S = A.useRef(null), M = A.useRef(null), E = A.useRef(u), P = l != null, T = K0(l), _ = K0(o), D = K0(c), N = A.useCallback(() => {
    if (!S.current || !M.current)
      return;
    const k = {
      placement: t,
      strategy: n,
      middleware: h
    };
    _.current && (k.platform = _.current), PF(S.current, M.current, k).then((z) => {
      const $ = {
        ...z,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: D.current !== !1
      };
      R.current && !r5(E.current, $) && (E.current = $, S2.flushSync(() => {
        f($);
      }));
    });
  }, [h, t, n, _, D]);
  Vc(() => {
    c === !1 && E.current.isPositioned && (E.current.isPositioned = !1, f((k) => ({
      ...k,
      isPositioned: !1
    })));
  }, [c]);
  const R = A.useRef(!1);
  Vc(() => (R.current = !0, () => {
    R.current = !1;
  }), []), Vc(() => {
    if (x && (S.current = x), b && (M.current = b), x && b) {
      if (T.current)
        return T.current(x, b, N);
      N();
    }
  }, [x, b, N, T, P]);
  const L = A.useMemo(() => ({
    reference: S,
    floating: M,
    setReference: y,
    setFloating: w
  }), [y, w]), B = A.useMemo(() => ({
    reference: x,
    floating: b
  }), [x, b]), V = A.useMemo(() => {
    const k = {
      position: n,
      left: 0,
      top: 0
    };
    if (!B.floating)
      return k;
    const z = Um(B.floating, u.x), $ = Um(B.floating, u.y);
    return s ? {
      ...k,
      transform: "translate(" + z + "px, " + $ + "px)",
      ...F_(B.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: z,
      top: $
    };
  }, [n, s, B.floating, u.x, u.y]);
  return A.useMemo(() => ({
    ...u,
    update: N,
    refs: L,
    elements: B,
    floatingStyles: V
  }), [u, N, L, B, V]);
}
const DF = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? qm({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? qm({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
}, Ti = (e, t) => ({
  ...R_(e),
  options: [e, t]
}), B_ = (e, t) => ({
  ...L_(e),
  options: [e, t]
}), RF = (e, t) => ({
  ...AF(e),
  options: [e, t]
}), Ii = (e, t) => ({
  ..._F(e),
  options: [e, t]
}), _2 = (e, t) => ({
  ...N_(e),
  options: [e, t]
}), kF = (e, t) => ({
  ...k_(e),
  options: [e, t]
}), LF = (e, t) => ({
  ...OF(e),
  options: [e, t]
}), $_ = (e, t) => ({
  ...DF(e),
  options: [e, t]
});
function Mo(e) {
  const t = A.useRef(void 0), n = A.useCallback((r) => {
    const o = e.map((i) => {
      if (i != null) {
        if (typeof i == "function") {
          const a = i, s = a(r);
          return typeof s == "function" ? s : () => {
            a(null);
          };
        }
        return i.current = r, () => {
          i.current = null;
        };
      }
    });
    return () => {
      o.forEach((i) => i?.());
    };
  }, e);
  return A.useMemo(() => e.every((r) => r == null) ? null : (r) => {
    t.current && (t.current(), t.current = void 0), r != null && (t.current = n(r));
  }, e);
}
function NF(e, t) {
  const n = e.compareDocumentPosition(t);
  return n & Node.DOCUMENT_POSITION_FOLLOWING || n & Node.DOCUMENT_POSITION_CONTAINED_BY ? -1 : n & Node.DOCUMENT_POSITION_PRECEDING || n & Node.DOCUMENT_POSITION_CONTAINS ? 1 : 0;
}
const j_ = /* @__PURE__ */ A.createContext({
  register: () => {
  },
  unregister: () => {
  },
  map: /* @__PURE__ */ new Map(),
  elementsRef: {
    current: []
  }
});
function O2(e) {
  const {
    children: t,
    elementsRef: n,
    labelsRef: r
  } = e, [o, i] = A.useState(() => /* @__PURE__ */ new Set()), a = A.useCallback((c) => {
    i((u) => new Set(u).add(c));
  }, []), s = A.useCallback((c) => {
    i((u) => {
      const f = new Set(u);
      return f.delete(c), f;
    });
  }, []), l = A.useMemo(() => {
    const c = /* @__PURE__ */ new Map();
    return Array.from(o.keys()).sort(NF).forEach((f, h) => {
      c.set(f, h);
    }), c;
  }, [o]);
  return /* @__PURE__ */ d(j_.Provider, {
    value: A.useMemo(() => ({
      register: a,
      unregister: s,
      map: l,
      elementsRef: n,
      labelsRef: r
    }), [a, s, l, n, r]),
    children: t
  });
}
function A2(e) {
  e === void 0 && (e = {});
  const {
    label: t
  } = e, {
    register: n,
    unregister: r,
    map: o,
    elementsRef: i,
    labelsRef: a
  } = A.useContext(j_), [s, l] = A.useState(null), c = A.useRef(null), u = A.useCallback((f) => {
    if (c.current = f, s !== null && (i.current[s] = f, a)) {
      var h;
      const p = t !== void 0;
      a.current[s] = p ? t : (h = f?.textContent) != null ? h : null;
    }
  }, [s, i, a, t]);
  return vt(() => {
    const f = c.current;
    if (f)
      return n(f), () => {
        r(f);
      };
  }, [n, r]), vt(() => {
    const f = c.current ? o.get(c.current) : null;
    f != null && l(f);
  }, [o]), A.useMemo(() => ({
    ref: u,
    index: s ?? -1
  }), [s, u]);
}
const FF = "data-floating-ui-focusable", Gm = "active", Km = "selected", P2 = "ArrowLeft", T2 = "ArrowRight", H_ = "ArrowUp", Eu = "ArrowDown", VF = {
  ...A
};
let Ym = !1, BF = 0;
const Xm = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + BF++
);
function $F() {
  const [e, t] = A.useState(() => Ym ? Xm() : void 0);
  return vt(() => {
    e == null && t(Xm());
  }, []), A.useEffect(() => {
    Ym = !0;
  }, []), e;
}
const jF = VF.useId, _u = jF || $F;
let Al;
process.env.NODE_ENV !== "production" && (Al = /* @__PURE__ */ new Set());
function Bc() {
  for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  const o = "Floating UI: " + n.join(" ");
  if (!((e = Al) != null && e.has(o))) {
    var i;
    (i = Al) == null || i.add(o), console.warn(o);
  }
}
function HF() {
  for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  const o = "Floating UI: " + n.join(" ");
  if (!((e = Al) != null && e.has(o))) {
    var i;
    (i = Al) == null || i.add(o), console.error(o);
  }
}
const zF = /* @__PURE__ */ A.forwardRef(function(t, n) {
  const {
    context: {
      placement: r,
      elements: {
        floating: o
      },
      middlewareData: {
        arrow: i,
        shift: a
      }
    },
    width: s = 14,
    height: l = 7,
    tipRadius: c = 0,
    strokeWidth: u = 0,
    staticOffset: f,
    stroke: h,
    d: p,
    style: {
      transform: C,
      ...m
    } = {},
    ...g
  } = t;
  process.env.NODE_ENV !== "production" && (n || Bc("The `ref` prop is required for `FloatingArrow`."));
  const v = _u(), [y, w] = A.useState(!1);
  if (vt(() => {
    if (!o) return;
    lr(o).direction === "rtl" && w(!0);
  }, [o]), !o)
    return null;
  const [x, b] = r.split("-"), S = x === "top" || x === "bottom";
  let M = f;
  (S && a != null && a.x || !S && a != null && a.y) && (M = null);
  const E = u * 2, P = E / 2, T = s / 2 * (c / -8 + 1), _ = l / 2 * c / 4, D = !!p, N = M && b === "end" ? "bottom" : "top";
  let R = M && b === "end" ? "right" : "left";
  M && y && (R = b === "end" ? "left" : "right");
  const L = i?.x != null ? M || i.x : "", B = i?.y != null ? M || i.y : "", V = p || "M0,0" + (" H" + s) + (" L" + (s - T) + "," + (l - _)) + (" Q" + s / 2 + "," + l + " " + T + "," + (l - _)) + " Z", k = {
    top: D ? "rotate(180deg)" : "",
    left: D ? "rotate(90deg)" : "rotate(-90deg)",
    bottom: D ? "" : "rotate(180deg)",
    right: D ? "rotate(-90deg)" : "rotate(90deg)"
  }[x];
  return /* @__PURE__ */ F("svg", {
    ...g,
    "aria-hidden": !0,
    ref: n,
    width: D ? s : s + E,
    height: s,
    viewBox: "0 0 " + s + " " + (l > s ? l : s),
    style: {
      position: "absolute",
      pointerEvents: "none",
      [R]: L,
      [N]: B,
      [x]: S || D ? "100%" : "calc(100% - " + E / 2 + "px)",
      transform: [k, C].filter((z) => !!z).join(" "),
      ...m
    },
    children: [E > 0 && /* @__PURE__ */ d("path", {
      clipPath: "url(#" + v + ")",
      fill: "none",
      stroke: h,
      strokeWidth: E + (p ? 0 : 1),
      d: V
    }), /* @__PURE__ */ d("path", {
      stroke: E && !p ? g.fill : "none",
      d: V
    }), /* @__PURE__ */ d("clipPath", {
      id: v,
      children: /* @__PURE__ */ d("rect", {
        x: -P,
        y: P * (D ? -1 : 1),
        width: s + E,
        height: s
      })
    })]
  });
});
function ZF() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(t, n) {
      var r;
      (r = e.get(t)) == null || r.forEach((o) => o(n));
    },
    on(t, n) {
      e.has(t) || e.set(t, /* @__PURE__ */ new Set()), e.get(t).add(n);
    },
    off(t, n) {
      var r;
      (r = e.get(t)) == null || r.delete(n);
    }
  };
}
const WF = /* @__PURE__ */ A.createContext(null), qF = /* @__PURE__ */ A.createContext(null), Ou = () => {
  var e;
  return ((e = A.useContext(WF)) == null ? void 0 : e.id) || null;
}, I2 = () => A.useContext(qF);
function vi(e) {
  return "data-floating-ui-" + e;
}
function Rn(e) {
  e.current !== -1 && (clearTimeout(e.current), e.current = -1);
}
const Qm = /* @__PURE__ */ vi("safe-polygon");
function Y0(e, t, n) {
  if (n && !Ol(n))
    return 0;
  if (typeof e == "number")
    return e;
  if (typeof e == "function") {
    const r = e();
    return typeof r == "number" ? r : r?.[t];
  }
  return e?.[t];
}
function X0(e) {
  return typeof e == "function" ? e() : e;
}
function UF(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    dataRef: o,
    events: i,
    elements: a
  } = e, {
    enabled: s = !0,
    delay: l = 0,
    handleClose: c = null,
    mouseOnly: u = !1,
    restMs: f = 0,
    move: h = !0
  } = t, p = I2(), C = Ou(), m = Wn(c), g = Wn(l), v = Wn(n), y = Wn(f), w = A.useRef(), x = A.useRef(-1), b = A.useRef(), S = A.useRef(-1), M = A.useRef(!0), E = A.useRef(!1), P = A.useRef(() => {
  }), T = A.useRef(!1), _ = zt(() => {
    var V;
    const k = (V = o.current.openEvent) == null ? void 0 : V.type;
    return k?.includes("mouse") && k !== "mousedown";
  });
  A.useEffect(() => {
    if (!s) return;
    function V(k) {
      let {
        open: z
      } = k;
      z || (Rn(x), Rn(S), M.current = !0, T.current = !1);
    }
    return i.on("openchange", V), () => {
      i.off("openchange", V);
    };
  }, [s, i]), A.useEffect(() => {
    if (!s || !m.current || !n) return;
    function V(z) {
      _() && r(!1, z, "hover");
    }
    const k = bn(a.floating).documentElement;
    return k.addEventListener("mouseleave", V), () => {
      k.removeEventListener("mouseleave", V);
    };
  }, [a.floating, n, r, s, m, _]);
  const D = A.useCallback(function(V, k, z) {
    k === void 0 && (k = !0), z === void 0 && (z = "hover");
    const $ = Y0(g.current, "close", w.current);
    $ && !b.current ? (Rn(x), x.current = window.setTimeout(() => r(!1, V, z), $)) : k && (Rn(x), r(!1, V, z));
  }, [g, r]), N = zt(() => {
    P.current(), b.current = void 0;
  }), R = zt(() => {
    if (E.current) {
      const V = bn(a.floating).body;
      V.style.pointerEvents = "", V.removeAttribute(Qm), E.current = !1;
    }
  }), L = zt(() => o.current.openEvent ? ["click", "mousedown"].includes(o.current.openEvent.type) : !1);
  A.useEffect(() => {
    if (!s) return;
    function V(W) {
      if (Rn(x), M.current = !1, u && !Ol(w.current) || X0(y.current) > 0 && !Y0(g.current, "open"))
        return;
      const H = Y0(g.current, "open", w.current);
      H ? x.current = window.setTimeout(() => {
        v.current || r(!0, W, "hover");
      }, H) : n || r(!0, W, "hover");
    }
    function k(W) {
      if (L()) {
        R();
        return;
      }
      P.current();
      const H = bn(a.floating);
      if (Rn(S), T.current = !1, m.current && o.current.floatingContext) {
        n || Rn(x), b.current = m.current({
          ...o.current.floatingContext,
          tree: p,
          x: W.clientX,
          y: W.clientY,
          onClose() {
            R(), N(), L() || D(W, !0, "safe-polygon");
          }
        });
        const Y = b.current;
        H.addEventListener("mousemove", Y), P.current = () => {
          H.removeEventListener("mousemove", Y);
        };
        return;
      }
      (w.current === "touch" ? !vn(a.floating, W.relatedTarget) : !0) && D(W);
    }
    function z(W) {
      L() || o.current.floatingContext && (m.current == null || m.current({
        ...o.current.floatingContext,
        tree: p,
        x: W.clientX,
        y: W.clientY,
        onClose() {
          R(), N(), L() || D(W);
        }
      })(W));
    }
    function $() {
      Rn(x);
    }
    function Z(W) {
      L() || D(W, !1);
    }
    if (St(a.domReference)) {
      const W = a.domReference, H = a.floating;
      return n && W.addEventListener("mouseleave", z), h && W.addEventListener("mousemove", V, {
        once: !0
      }), W.addEventListener("mouseenter", V), W.addEventListener("mouseleave", k), H && (H.addEventListener("mouseleave", z), H.addEventListener("mouseenter", $), H.addEventListener("mouseleave", Z)), () => {
        n && W.removeEventListener("mouseleave", z), h && W.removeEventListener("mousemove", V), W.removeEventListener("mouseenter", V), W.removeEventListener("mouseleave", k), H && (H.removeEventListener("mouseleave", z), H.removeEventListener("mouseenter", $), H.removeEventListener("mouseleave", Z));
      };
    }
  }, [a, s, e, u, h, D, N, R, r, n, v, p, g, m, o, L, y]), vt(() => {
    var V;
    if (s && n && (V = m.current) != null && (V = V.__options) != null && V.blockPointerEvents && _()) {
      E.current = !0;
      const z = a.floating;
      if (St(a.domReference) && z) {
        var k;
        const $ = bn(a.floating).body;
        $.setAttribute(Qm, "");
        const Z = a.domReference, W = p == null || (k = p.nodesRef.current.find((H) => H.id === C)) == null || (k = k.context) == null ? void 0 : k.elements.floating;
        return W && (W.style.pointerEvents = ""), $.style.pointerEvents = "none", Z.style.pointerEvents = "auto", z.style.pointerEvents = "auto", () => {
          $.style.pointerEvents = "", Z.style.pointerEvents = "", z.style.pointerEvents = "";
        };
      }
    }
  }, [s, n, C, a, p, m, _]), vt(() => {
    n || (w.current = void 0, T.current = !1, N(), R());
  }, [n, N, R]), A.useEffect(() => () => {
    N(), Rn(x), Rn(S), R();
  }, [s, a.domReference, N, R]);
  const B = A.useMemo(() => {
    function V(k) {
      w.current = k.pointerType;
    }
    return {
      onPointerDown: V,
      onPointerEnter: V,
      onMouseMove(k) {
        const {
          nativeEvent: z
        } = k;
        function $() {
          !M.current && !v.current && r(!0, z, "hover");
        }
        u && !Ol(w.current) || n || X0(y.current) === 0 || T.current && k.movementX ** 2 + k.movementY ** 2 < 2 || (Rn(S), w.current === "touch" ? $() : (T.current = !0, S.current = window.setTimeout($, X0(y.current))));
      }
    };
  }, [u, r, n, v, y]);
  return A.useMemo(() => s ? {
    reference: B
  } : {}, [s, B]);
}
let Jm = 0;
function G1(e, t) {
  t === void 0 && (t = {});
  const {
    preventScroll: n = !1,
    cancelPrevious: r = !0,
    sync: o = !1
  } = t;
  r && cancelAnimationFrame(Jm);
  const i = () => e?.focus({
    preventScroll: n
  });
  o ? i() : Jm = requestAnimationFrame(i);
}
function GF(e) {
  return e?.ownerDocument || document;
}
const ba = {
  inert: /* @__PURE__ */ new WeakMap(),
  "aria-hidden": /* @__PURE__ */ new WeakMap(),
  none: /* @__PURE__ */ new WeakMap()
};
function eg(e) {
  return e === "inert" ? ba.inert : e === "aria-hidden" ? ba["aria-hidden"] : ba.none;
}
let X2 = /* @__PURE__ */ new WeakSet(), Q2 = {}, Q0 = 0;
const KF = () => typeof HTMLElement < "u" && "inert" in HTMLElement.prototype, z_ = (e) => e && (e.host || z_(e.parentNode)), YF = (e, t) => t.map((n) => {
  if (e.contains(n))
    return n;
  const r = z_(n);
  return e.contains(r) ? r : null;
}).filter((n) => n != null);
function XF(e, t, n, r) {
  const o = "data-floating-ui-inert", i = r ? "inert" : n ? "aria-hidden" : null, a = YF(t, e), s = /* @__PURE__ */ new Set(), l = new Set(a), c = [];
  Q2[o] || (Q2[o] = /* @__PURE__ */ new WeakMap());
  const u = Q2[o];
  a.forEach(f), h(t), s.clear();
  function f(p) {
    !p || s.has(p) || (s.add(p), p.parentNode && f(p.parentNode));
  }
  function h(p) {
    !p || l.has(p) || [].forEach.call(p.children, (C) => {
      if (I1(C) !== "script")
        if (s.has(C))
          h(C);
        else {
          const m = i ? C.getAttribute(i) : null, g = m !== null && m !== "false", v = eg(i), y = (v.get(C) || 0) + 1, w = (u.get(C) || 0) + 1;
          v.set(C, y), u.set(C, w), c.push(C), y === 1 && g && X2.add(C), w === 1 && C.setAttribute(o, ""), !g && i && C.setAttribute(i, i === "inert" ? "" : "true");
        }
    });
  }
  return Q0++, () => {
    c.forEach((p) => {
      const C = eg(i), g = (C.get(p) || 0) - 1, v = (u.get(p) || 0) - 1;
      C.set(p, g), u.set(p, v), g || (!X2.has(p) && i && p.removeAttribute(i), X2.delete(p)), v || p.removeAttribute(o);
    }), Q0--, Q0 || (ba.inert = /* @__PURE__ */ new WeakMap(), ba["aria-hidden"] = /* @__PURE__ */ new WeakMap(), ba.none = /* @__PURE__ */ new WeakMap(), X2 = /* @__PURE__ */ new WeakSet(), Q2 = {});
  };
}
function tg(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const r = GF(e[0]).body;
  return XF(e.concat(Array.from(r.querySelectorAll('[aria-live],[role="status"],output'))), r, t, n);
}
const Au = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "fixed",
  whiteSpace: "nowrap",
  width: "1px",
  top: 0,
  left: 0
}, o5 = /* @__PURE__ */ A.forwardRef(function(t, n) {
  const [r, o] = A.useState();
  vt(() => {
    y_() && o("button");
  }, []);
  const i = {
    ref: n,
    tabIndex: 0,
    // Role is only for VoiceOver
    role: r,
    "aria-hidden": r ? void 0 : !0,
    [vi("focus-guard")]: "",
    style: Au
  };
  return /* @__PURE__ */ d("span", {
    ...t,
    ...i
  });
}), Z_ = /* @__PURE__ */ A.createContext(null), ng = /* @__PURE__ */ vi("portal");
function QF(e) {
  e === void 0 && (e = {});
  const {
    id: t,
    root: n
  } = e, r = _u(), o = W_(), [i, a] = A.useState(null), s = A.useRef(null);
  return vt(() => () => {
    i?.remove(), queueMicrotask(() => {
      s.current = null;
    });
  }, [i]), vt(() => {
    if (!r || s.current) return;
    const l = t ? document.getElementById(t) : null;
    if (!l) return;
    const c = document.createElement("div");
    c.id = r, c.setAttribute(ng, ""), l.appendChild(c), s.current = c, a(c);
  }, [t, r]), vt(() => {
    if (n === null || !r || s.current) return;
    let l = n || o?.portalNode;
    l && !Rd(l) && (l = l.current), l = l || document.body;
    let c = null;
    t && (c = document.createElement("div"), c.id = t, l.appendChild(c));
    const u = document.createElement("div");
    u.id = r, u.setAttribute(ng, ""), l = c || l, l.appendChild(u), s.current = u, a(u);
  }, [t, n, r, o]), i;
}
function JF(e) {
  const {
    children: t,
    id: n,
    root: r,
    preserveTabOrder: o = !0
  } = e, i = QF({
    id: n,
    root: r
  }), [a, s] = A.useState(null), l = A.useRef(null), c = A.useRef(null), u = A.useRef(null), f = A.useRef(null), h = a?.modal, p = a?.open, C = (
    // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!a && // Guards are only for non-modal focus management.
    !a.modal && // Don't render if unmount is transitioning.
    a.open && o && !!(r || i)
  );
  return A.useEffect(() => {
    if (!i || !o || h)
      return;
    function m(g) {
      i && pl(g) && (g.type === "focusin" ? Bm : QN)(i);
    }
    return i.addEventListener("focusin", m, !0), i.addEventListener("focusout", m, !0), () => {
      i.removeEventListener("focusin", m, !0), i.removeEventListener("focusout", m, !0);
    };
  }, [i, o, h]), A.useEffect(() => {
    i && (p || Bm(i));
  }, [p, i]), /* @__PURE__ */ F(Z_.Provider, {
    value: A.useMemo(() => ({
      preserveTabOrder: o,
      beforeOutsideRef: l,
      afterOutsideRef: c,
      beforeInsideRef: u,
      afterInsideRef: f,
      portalNode: i,
      setFocusManagerState: s
    }), [o, i]),
    children: [C && i && /* @__PURE__ */ d(o5, {
      "data-type": "outside",
      ref: l,
      onFocus: (m) => {
        if (pl(m, i)) {
          var g;
          (g = u.current) == null || g.focus();
        } else {
          const v = a ? a.domReference : null, y = E_(v);
          y?.focus();
        }
      }
    }), C && i && /* @__PURE__ */ d("span", {
      "aria-owns": i.id,
      style: Au
    }), i && /* @__PURE__ */ S2.createPortal(t, i), C && i && /* @__PURE__ */ d(o5, {
      "data-type": "outside",
      ref: c,
      onFocus: (m) => {
        if (pl(m, i)) {
          var g;
          (g = f.current) == null || g.focus();
        } else {
          const v = a ? a.domReference : null, y = M_(v);
          y?.focus(), a?.closeOnFocusOut && a?.onOpenChange(!1, m.nativeEvent, "focus-out");
        }
      }
    })]
  });
}
const W_ = () => A.useContext(Z_);
function rg(e) {
  return A.useMemo(() => (t) => {
    e.forEach((n) => {
      n && (n.current = t);
    });
  }, e);
}
const eV = 20;
let m1 = [];
function jd() {
  m1 = m1.filter((e) => e.isConnected);
}
function tV(e) {
  jd(), e && I1(e) !== "body" && (m1.push(e), m1.length > eV && (m1 = m1.slice(-20)));
}
function og() {
  return jd(), m1[m1.length - 1];
}
function nV(e) {
  const t = E2();
  return C_(e, t) ? e : Su(e, t)[0] || e;
}
function ig(e, t) {
  var n;
  if (!t.current.includes("floating") && !((n = e.getAttribute("role")) != null && n.includes("dialog")))
    return;
  const r = E2(), i = kN(e, r).filter((s) => {
    const l = s.getAttribute("data-tabindex") || "";
    return C_(s, r) || s.hasAttribute("data-tabindex") && !l.startsWith("-");
  }), a = e.getAttribute("tabindex");
  t.current.includes("floating") || i.length === 0 ? a !== "0" && e.setAttribute("tabindex", "0") : (a !== "-1" || e.hasAttribute("data-tabindex") && e.getAttribute("data-tabindex") !== "-1") && (e.setAttribute("tabindex", "-1"), e.setAttribute("data-tabindex", "-1"));
}
const rV = /* @__PURE__ */ A.forwardRef(function(t, n) {
  return /* @__PURE__ */ d("button", {
    ...t,
    type: "button",
    ref: n,
    tabIndex: -1,
    style: Au
  });
});
function ms(e) {
  const {
    context: t,
    children: n,
    disabled: r = !1,
    order: o = ["content"],
    guards: i = !0,
    initialFocus: a = 0,
    returnFocus: s = !0,
    restoreFocus: l = !1,
    modal: c = !0,
    visuallyHiddenDismiss: u = !1,
    closeOnFocusOut: f = !0,
    outsideElementsInert: h = !1,
    getInsideElements: p = () => []
  } = e, {
    open: C,
    onOpenChange: m,
    events: g,
    dataRef: v,
    elements: {
      domReference: y,
      floating: w
    }
  } = t, x = zt(() => {
    var j;
    return (j = v.current.floatingContext) == null ? void 0 : j.nodeId;
  }), b = zt(p), S = typeof a == "number" && a < 0, M = m9(y) && S, E = KF(), P = E ? i : !0, T = !P || E && h, _ = Wn(o), D = Wn(a), N = Wn(s), R = I2(), L = W_(), B = A.useRef(null), V = A.useRef(null), k = A.useRef(!1), z = A.useRef(!1), $ = A.useRef(-1), Z = A.useRef(-1), W = L != null, H = n5(w), G = zt(function(j) {
    return j === void 0 && (j = H), j ? Su(j, E2()) : [];
  }), Y = zt((j) => {
    const te = G(j);
    return _.current.map((K) => y && K === "reference" ? y : H && K === "floating" ? H : te).filter(Boolean).flat();
  });
  A.useEffect(() => {
    if (r || !c) return;
    function j(K) {
      if (K.key === "Tab") {
        vn(H, no(bn(H))) && G().length === 0 && !M && yn(K);
        const me = Y(), we = Lo(K);
        _.current[0] === "reference" && we === y && (yn(K), K.shiftKey ? G1(me[me.length - 1]) : G1(me[1])), _.current[1] === "floating" && we === H && K.shiftKey && (yn(K), G1(me[0]));
      }
    }
    const te = bn(H);
    return te.addEventListener("keydown", j), () => {
      te.removeEventListener("keydown", j);
    };
  }, [r, y, H, c, _, M, G, Y]), A.useEffect(() => {
    if (r || !w) return;
    function j(te) {
      const K = Lo(te), we = G().indexOf(K);
      we !== -1 && ($.current = we);
    }
    return w.addEventListener("focusin", j), () => {
      w.removeEventListener("focusin", j);
    };
  }, [r, w, G]), A.useEffect(() => {
    if (r || !f) return;
    function j() {
      z.current = !0, setTimeout(() => {
        z.current = !1;
      });
    }
    function te(we) {
      const ye = we.relatedTarget, Ze = we.currentTarget, Ue = Lo(we);
      queueMicrotask(() => {
        const Ke = x(), ft = !(vn(y, ye) || vn(w, ye) || vn(ye, w) || vn(L?.portalNode, ye) || ye != null && ye.hasAttribute(vi("focus-guard")) || R && (ui(R.nodesRef.current, Ke).find((fe) => {
          var ge, pe;
          return vn((ge = fe.context) == null ? void 0 : ge.elements.floating, ye) || vn((pe = fe.context) == null ? void 0 : pe.elements.domReference, ye);
        }) || Fm(R.nodesRef.current, Ke).find((fe) => {
          var ge, pe, De;
          return [(ge = fe.context) == null ? void 0 : ge.elements.floating, n5((pe = fe.context) == null ? void 0 : pe.elements.floating)].includes(ye) || ((De = fe.context) == null ? void 0 : De.elements.domReference) === ye;
        })));
        if (Ze === y && H && ig(H, _), l && Ze !== y && !(Ue != null && Ue.isConnected) && no(bn(H)) === bn(H).body) {
          Ht(H) && H.focus();
          const fe = $.current, ge = G(), pe = ge[fe] || ge[ge.length - 1] || H;
          Ht(pe) && pe.focus();
        }
        if (v.current.insideReactTree) {
          v.current.insideReactTree = !1;
          return;
        }
        (M || !c) && ye && ft && !z.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
        ye !== og() && (k.current = !0, m(!1, we, "focus-out"));
      });
    }
    const K = !!(!R && L);
    function me() {
      Rn(Z), v.current.insideReactTree = !0, Z.current = window.setTimeout(() => {
        v.current.insideReactTree = !1;
      });
    }
    if (w && Ht(y))
      return y.addEventListener("focusout", te), y.addEventListener("pointerdown", j), w.addEventListener("focusout", te), K && w.addEventListener("focusout", me, !0), () => {
        y.removeEventListener("focusout", te), y.removeEventListener("pointerdown", j), w.removeEventListener("focusout", te), K && w.removeEventListener("focusout", me, !0);
      };
  }, [r, y, w, H, c, R, L, m, f, l, G, M, x, _, v]);
  const ne = A.useRef(null), J = A.useRef(null), ee = rg([ne, L?.beforeInsideRef]), U = rg([J, L?.afterInsideRef]);
  A.useEffect(() => {
    var j, te;
    if (r || !w) return;
    const K = Array.from((L == null || (j = L.portalNode) == null ? void 0 : j.querySelectorAll("[" + vi("portal") + "]")) || []), we = (te = (R ? Fm(R.nodesRef.current, x()) : []).find((Ue) => {
      var Ke;
      return m9(((Ke = Ue.context) == null ? void 0 : Ke.elements.domReference) || null);
    })) == null || (te = te.context) == null ? void 0 : te.elements.domReference, ye = [w, we, ...K, ...b(), B.current, V.current, ne.current, J.current, L?.beforeOutsideRef.current, L?.afterOutsideRef.current, _.current.includes("reference") || M ? y : null].filter((Ue) => Ue != null), Ze = c || M ? tg(ye, !T, T) : tg(ye);
    return () => {
      Ze();
    };
  }, [r, y, w, c, _, L, M, P, T, R, x, b]), vt(() => {
    if (r || !Ht(H)) return;
    const j = bn(H), te = no(j);
    queueMicrotask(() => {
      const K = Y(H), me = D.current, we = (typeof me == "number" ? K[me] : me.current) || H, ye = vn(H, te);
      !S && !ye && C && G1(we, {
        preventScroll: we === H
      });
    });
  }, [r, C, H, S, Y, D]), vt(() => {
    if (r || !H) return;
    const j = bn(H), te = no(j);
    tV(te);
    function K(ye) {
      let {
        reason: Ze,
        event: Ue,
        nested: Ke
      } = ye;
      if (["hover", "safe-polygon"].includes(Ze) && Ue.type === "mouseleave" && (k.current = !0), Ze === "outside-press")
        if (Ke)
          k.current = !1;
        else if (w_(Ue) || x_(Ue))
          k.current = !1;
        else {
          let ft = !1;
          document.createElement("div").focus({
            get preventScroll() {
              return ft = !0, !1;
            }
          }), ft ? k.current = !1 : k.current = !0;
        }
    }
    g.on("openchange", K);
    const me = j.createElement("span");
    me.setAttribute("tabindex", "-1"), me.setAttribute("aria-hidden", "true"), Object.assign(me.style, Au), W && y && y.insertAdjacentElement("afterend", me);
    function we() {
      if (typeof N.current == "boolean") {
        const ye = y || og();
        return ye && ye.isConnected ? ye : me;
      }
      return N.current.current || me;
    }
    return () => {
      g.off("openchange", K);
      const ye = no(j), Ze = vn(w, ye) || R && ui(R.nodesRef.current, x(), !1).some((Ke) => {
        var ft;
        return vn((ft = Ke.context) == null ? void 0 : ft.elements.floating, ye);
      }), Ue = we();
      queueMicrotask(() => {
        const Ke = nV(Ue);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        N.current && !k.current && Ht(Ke) && // If the focus moved somewhere else after mount, avoid returning focus
        // since it likely entered a different element which should be
        // respected: https://github.com/floating-ui/floating-ui/issues/2607
        (!(Ke !== ye && ye !== j.body) || Ze) && Ke.focus({
          preventScroll: !0
        }), me.remove();
      });
    };
  }, [r, w, H, N, v, g, R, W, y, x]), A.useEffect(() => (queueMicrotask(() => {
    k.current = !1;
  }), () => {
    queueMicrotask(jd);
  }), [r]), vt(() => {
    if (!r && L)
      return L.setFocusManagerState({
        modal: c,
        closeOnFocusOut: f,
        open: C,
        onOpenChange: m,
        domReference: y
      }), () => {
        L.setFocusManagerState(null);
      };
  }, [r, L, c, C, m, f, y]), vt(() => {
    r || H && ig(H, _);
  }, [r, H, _]);
  function X(j) {
    return r || !u || !c ? null : /* @__PURE__ */ d(rV, {
      ref: j === "start" ? B : V,
      onClick: (te) => m(!1, te.nativeEvent),
      children: typeof u == "string" ? u : "Dismiss"
    });
  }
  const ie = !r && P && (c ? !M : !0) && (W || c);
  return /* @__PURE__ */ F(ut, {
    children: [ie && /* @__PURE__ */ d(o5, {
      "data-type": "inside",
      ref: ee,
      onFocus: (j) => {
        if (c) {
          const K = Y();
          G1(o[0] === "reference" ? K[0] : K[K.length - 1]);
        } else if (L != null && L.preserveTabOrder && L.portalNode)
          if (k.current = !1, pl(j, L.portalNode)) {
            const K = M_(y);
            K?.focus();
          } else {
            var te;
            (te = L.beforeOutsideRef.current) == null || te.focus();
          }
      }
    }), !M && X("start"), n, X("end"), ie && /* @__PURE__ */ d(o5, {
      "data-type": "inside",
      ref: U,
      onFocus: (j) => {
        if (c)
          G1(Y()[0]);
        else if (L != null && L.preserveTabOrder && L.portalNode)
          if (f && (k.current = !0), pl(j, L.portalNode)) {
            const K = E_(y);
            K?.focus();
          } else {
            var te;
            (te = L.afterOutsideRef.current) == null || te.focus();
          }
      }
    })]
  });
}
let J2 = 0;
const ag = "--floating-ui-scrollbar-width";
function oV() {
  const e = Vd(), t = /iP(hone|ad|od)|iOS/.test(e) || // iPads can claim to be MacIntel
  e === "MacIntel" && navigator.maxTouchPoints > 1, n = document.body.style, o = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft ? "paddingLeft" : "paddingRight", i = window.innerWidth - document.documentElement.clientWidth, a = n.left ? parseFloat(n.left) : window.scrollX, s = n.top ? parseFloat(n.top) : window.scrollY;
  if (n.overflow = "hidden", n.setProperty(ag, i + "px"), i && (n[o] = i + "px"), t) {
    var l, c;
    const u = ((l = window.visualViewport) == null ? void 0 : l.offsetLeft) || 0, f = ((c = window.visualViewport) == null ? void 0 : c.offsetTop) || 0;
    Object.assign(n, {
      position: "fixed",
      top: -(s - Math.floor(f)) + "px",
      left: -(a - Math.floor(u)) + "px",
      right: "0"
    });
  }
  return () => {
    Object.assign(n, {
      overflow: "",
      [o]: ""
    }), n.removeProperty(ag), t && (Object.assign(n, {
      position: "",
      top: "",
      left: "",
      right: ""
    }), window.scrollTo(a, s));
  };
}
let sg = () => {
};
const iV = /* @__PURE__ */ A.forwardRef(function(t, n) {
  const {
    lockScroll: r = !1,
    ...o
  } = t;
  return vt(() => {
    if (r)
      return J2++, J2 === 1 && (sg = oV()), () => {
        J2--, J2 === 0 && sg();
      };
  }, [r]), /* @__PURE__ */ d("div", {
    ref: n,
    ...o,
    style: {
      position: "fixed",
      overflow: "auto",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      ...o.style
    }
  });
});
function lg(e) {
  return Ht(e.target) && e.target.tagName === "BUTTON";
}
function aV(e) {
  return Ht(e.target) && e.target.tagName === "A";
}
function cg(e) {
  return Bd(e);
}
function Pu(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    dataRef: o,
    elements: {
      domReference: i
    }
  } = e, {
    enabled: a = !0,
    event: s = "click",
    toggle: l = !0,
    ignoreMouse: c = !1,
    keyboardHandlers: u = !0,
    stickIfOpen: f = !0
  } = t, h = A.useRef(), p = A.useRef(!1), C = A.useMemo(() => ({
    onPointerDown(m) {
      h.current = m.pointerType;
    },
    onMouseDown(m) {
      const g = h.current;
      m.button === 0 && s !== "click" && (Ol(g, !0) && c || (n && l && (!(o.current.openEvent && f) || o.current.openEvent.type === "mousedown") ? r(!1, m.nativeEvent, "click") : (m.preventDefault(), r(!0, m.nativeEvent, "click"))));
    },
    onClick(m) {
      const g = h.current;
      if (s === "mousedown" && h.current) {
        h.current = void 0;
        return;
      }
      Ol(g, !0) && c || (n && l && (!(o.current.openEvent && f) || o.current.openEvent.type === "click") ? r(!1, m.nativeEvent, "click") : r(!0, m.nativeEvent, "click"));
    },
    onKeyDown(m) {
      h.current = void 0, !(m.defaultPrevented || !u || lg(m)) && (m.key === " " && !cg(i) && (m.preventDefault(), p.current = !0), !aV(m) && m.key === "Enter" && r(!(n && l), m.nativeEvent, "click"));
    },
    onKeyUp(m) {
      m.defaultPrevented || !u || lg(m) || cg(i) || m.key === " " && p.current && (p.current = !1, r(!(n && l), m.nativeEvent, "click"));
    }
  }), [o, i, s, c, u, r, n, f, l]);
  return A.useMemo(() => a ? {
    reference: C
  } : {}, [a, C]);
}
const sV = {
  pointerdown: "onPointerDown",
  mousedown: "onMouseDown",
  click: "onClick"
}, lV = {
  pointerdown: "onPointerDownCapture",
  mousedown: "onMouseDownCapture",
  click: "onClickCapture"
}, ug = (e) => {
  var t, n;
  return {
    escapeKey: typeof e == "boolean" ? e : (t = e?.escapeKey) != null ? t : !1,
    outsidePress: typeof e == "boolean" ? e : (n = e?.outsidePress) != null ? n : !0
  };
};
function Di(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    elements: o,
    dataRef: i
  } = e, {
    enabled: a = !0,
    escapeKey: s = !0,
    outsidePress: l = !0,
    outsidePressEvent: c = "pointerdown",
    referencePress: u = !1,
    referencePressEvent: f = "pointerdown",
    ancestorScroll: h = !1,
    bubbles: p,
    capture: C
  } = t, m = I2(), g = zt(typeof l == "function" ? l : () => !1), v = typeof l == "function" ? g : l, y = A.useRef(!1), {
    escapeKey: w,
    outsidePress: x
  } = ug(p), {
    escapeKey: b,
    outsidePress: S
  } = ug(C), M = A.useRef(!1), E = zt((R) => {
    var L;
    if (!n || !a || !s || R.key !== "Escape" || M.current)
      return;
    const B = (L = i.current.floatingContext) == null ? void 0 : L.nodeId, V = m ? ui(m.nodesRef.current, B) : [];
    if (!w && (R.stopPropagation(), V.length > 0)) {
      let k = !0;
      if (V.forEach((z) => {
        var $;
        if (($ = z.context) != null && $.open && !z.context.dataRef.current.__escapeKeyBubbles) {
          k = !1;
          return;
        }
      }), !k)
        return;
    }
    r(!1, HN(R) ? R.nativeEvent : R, "escape-key");
  }), P = zt((R) => {
    var L;
    const B = () => {
      var V;
      E(R), (V = Lo(R)) == null || V.removeEventListener("keydown", B);
    };
    (L = Lo(R)) == null || L.addEventListener("keydown", B);
  }), T = zt((R) => {
    var L;
    const B = i.current.insideReactTree;
    i.current.insideReactTree = !1;
    const V = y.current;
    if (y.current = !1, c === "click" && V || B || typeof v == "function" && !v(R))
      return;
    const k = Lo(R), z = "[" + vi("inert") + "]", $ = bn(o.floating).querySelectorAll(z);
    let Z = St(k) ? k : null;
    for (; Z && !zo(Z); ) {
      const Y = Uo(Z);
      if (zo(Y) || !St(Y))
        break;
      Z = Y;
    }
    if ($.length && St(k) && !BN(k) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !vn(k, o.floating) && // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from($).every((Y) => !vn(Z, Y)))
      return;
    if (Ht(k) && N) {
      const Y = zo(k), ne = lr(k), J = /auto|scroll/, ee = Y || J.test(ne.overflowX), U = Y || J.test(ne.overflowY), X = ee && k.clientWidth > 0 && k.scrollWidth > k.clientWidth, ie = U && k.clientHeight > 0 && k.scrollHeight > k.clientHeight, j = ne.direction === "rtl", te = ie && (j ? R.offsetX <= k.offsetWidth - k.clientWidth : R.offsetX > k.clientWidth), K = X && R.offsetY > k.clientHeight;
      if (te || K)
        return;
    }
    const W = (L = i.current.floatingContext) == null ? void 0 : L.nodeId, H = m && ui(m.nodesRef.current, W).some((Y) => {
      var ne;
      return q0(R, (ne = Y.context) == null ? void 0 : ne.elements.floating);
    });
    if (q0(R, o.floating) || q0(R, o.domReference) || H)
      return;
    const G = m ? ui(m.nodesRef.current, W) : [];
    if (G.length > 0) {
      let Y = !0;
      if (G.forEach((ne) => {
        var J;
        if ((J = ne.context) != null && J.open && !ne.context.dataRef.current.__outsidePressBubbles) {
          Y = !1;
          return;
        }
      }), !Y)
        return;
    }
    r(!1, R, "outside-press");
  }), _ = zt((R) => {
    var L;
    const B = () => {
      var V;
      T(R), (V = Lo(R)) == null || V.removeEventListener(c, B);
    };
    (L = Lo(R)) == null || L.addEventListener(c, B);
  });
  A.useEffect(() => {
    if (!n || !a)
      return;
    i.current.__escapeKeyBubbles = w, i.current.__outsidePressBubbles = x;
    let R = -1;
    function L($) {
      r(!1, $, "ancestor-scroll");
    }
    function B() {
      window.clearTimeout(R), M.current = !0;
    }
    function V() {
      R = window.setTimeout(
        () => {
          M.current = !1;
        },
        // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
        // Only apply to WebKit for the test to remain 0ms.
        wu() ? 5 : 0
      );
    }
    const k = bn(o.floating);
    s && (k.addEventListener("keydown", b ? P : E, b), k.addEventListener("compositionstart", B), k.addEventListener("compositionend", V)), v && k.addEventListener(c, S ? _ : T, S);
    let z = [];
    return h && (St(o.domReference) && (z = w1(o.domReference)), St(o.floating) && (z = z.concat(w1(o.floating))), !St(o.reference) && o.reference && o.reference.contextElement && (z = z.concat(w1(o.reference.contextElement)))), z = z.filter(($) => {
      var Z;
      return $ !== ((Z = k.defaultView) == null ? void 0 : Z.visualViewport);
    }), z.forEach(($) => {
      $.addEventListener("scroll", L, {
        passive: !0
      });
    }), () => {
      s && (k.removeEventListener("keydown", b ? P : E, b), k.removeEventListener("compositionstart", B), k.removeEventListener("compositionend", V)), v && k.removeEventListener(c, S ? _ : T, S), z.forEach(($) => {
        $.removeEventListener("scroll", L);
      }), window.clearTimeout(R);
    };
  }, [i, o, s, v, c, n, r, h, a, w, x, E, b, P, T, S, _]), A.useEffect(() => {
    i.current.insideReactTree = !1;
  }, [i, v, c]);
  const D = A.useMemo(() => ({
    onKeyDown: E,
    ...u && {
      [sV[f]]: (R) => {
        r(!1, R.nativeEvent, "reference-press");
      },
      ...f !== "click" && {
        onClick(R) {
          r(!1, R.nativeEvent, "reference-press");
        }
      }
    }
  }), [E, r, u, f]), N = A.useMemo(() => ({
    onKeyDown: E,
    onMouseDown() {
      y.current = !0;
    },
    onMouseUp() {
      y.current = !0;
    },
    [lV[c]]: () => {
      i.current.insideReactTree = !0;
    }
  }), [E, c, i]);
  return A.useMemo(() => a ? {
    reference: D,
    floating: N
  } : {}, [a, D, N]);
}
function cV(e) {
  const {
    open: t = !1,
    onOpenChange: n,
    elements: r
  } = e, o = _u(), i = A.useRef({}), [a] = A.useState(() => ZF()), s = Ou() != null;
  if (process.env.NODE_ENV !== "production") {
    const p = r.reference;
    p && !St(p) && HF("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [l, c] = A.useState(r.reference), u = zt((p, C, m) => {
    i.current.openEvent = p ? C : void 0, a.emit("openchange", {
      open: p,
      event: C,
      reason: m,
      nested: s
    }), n?.(p, C, m);
  }), f = A.useMemo(() => ({
    setPositionReference: c
  }), []), h = A.useMemo(() => ({
    reference: l || r.reference || null,
    floating: r.floating || null,
    domReference: r.reference
  }), [l, r.reference, r.floating]);
  return A.useMemo(() => ({
    dataRef: i,
    open: t,
    onOpenChange: u,
    elements: h,
    events: a,
    floatingId: o,
    refs: f
  }), [t, u, h, a, o, f]);
}
function Ri(e) {
  e === void 0 && (e = {});
  const {
    nodeId: t
  } = e, n = cV({
    ...e,
    elements: {
      reference: null,
      floating: null,
      ...e.elements
    }
  }), r = e.rootContext || n, o = r.elements, [i, a] = A.useState(null), [s, l] = A.useState(null), u = o?.domReference || i, f = A.useRef(null), h = I2();
  vt(() => {
    u && (f.current = u);
  }, [u]);
  const p = V_({
    ...e,
    elements: {
      ...o,
      ...s && {
        reference: s
      }
    }
  }), C = A.useCallback((w) => {
    const x = St(w) ? {
      getBoundingClientRect: () => w.getBoundingClientRect(),
      getClientRects: () => w.getClientRects(),
      contextElement: w
    } : w;
    l(x), p.refs.setReference(x);
  }, [p.refs]), m = A.useCallback((w) => {
    (St(w) || w === null) && (f.current = w, a(w)), (St(p.refs.reference.current) || p.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    w !== null && !St(w)) && p.refs.setReference(w);
  }, [p.refs]), g = A.useMemo(() => ({
    ...p.refs,
    setReference: m,
    setPositionReference: C,
    domReference: f
  }), [p.refs, m, C]), v = A.useMemo(() => ({
    ...p.elements,
    domReference: u
  }), [p.elements, u]), y = A.useMemo(() => ({
    ...p,
    ...r,
    refs: g,
    elements: v,
    nodeId: t
  }), [p, g, v, t, r]);
  return vt(() => {
    r.dataRef.current.floatingContext = y;
    const w = h?.nodesRef.current.find((x) => x.id === t);
    w && (w.context = y);
  }), A.useMemo(() => ({
    ...p,
    context: y,
    refs: g,
    elements: v
  }), [p, g, v, y]);
}
function J0() {
  return LN() && y_();
}
function uV(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    events: o,
    dataRef: i,
    elements: a
  } = e, {
    enabled: s = !0,
    visibleOnly: l = !0
  } = t, c = A.useRef(!1), u = A.useRef(-1), f = A.useRef(!0);
  A.useEffect(() => {
    if (!s) return;
    const p = Kn(a.domReference);
    function C() {
      !n && Ht(a.domReference) && a.domReference === no(bn(a.domReference)) && (c.current = !0);
    }
    function m() {
      f.current = !0;
    }
    function g() {
      f.current = !1;
    }
    return p.addEventListener("blur", C), J0() && (p.addEventListener("keydown", m, !0), p.addEventListener("pointerdown", g, !0)), () => {
      p.removeEventListener("blur", C), J0() && (p.removeEventListener("keydown", m, !0), p.removeEventListener("pointerdown", g, !0));
    };
  }, [a.domReference, n, s]), A.useEffect(() => {
    if (!s) return;
    function p(C) {
      let {
        reason: m
      } = C;
      (m === "reference-press" || m === "escape-key") && (c.current = !0);
    }
    return o.on("openchange", p), () => {
      o.off("openchange", p);
    };
  }, [o, s]), A.useEffect(() => () => {
    Rn(u);
  }, []);
  const h = A.useMemo(() => ({
    onMouseLeave() {
      c.current = !1;
    },
    onFocus(p) {
      if (c.current) return;
      const C = Lo(p.nativeEvent);
      if (l && St(C)) {
        if (J0() && !p.relatedTarget) {
          if (!f.current && !Bd(C))
            return;
        } else if (!$N(C))
          return;
      }
      r(!0, p.nativeEvent, "focus");
    },
    onBlur(p) {
      c.current = !1;
      const C = p.relatedTarget, m = p.nativeEvent, g = St(C) && C.hasAttribute(vi("focus-guard")) && C.getAttribute("data-type") === "outside";
      u.current = window.setTimeout(() => {
        var v;
        const y = no(a.domReference ? a.domReference.ownerDocument : document);
        !C && y === a.domReference || vn((v = i.current.floatingContext) == null ? void 0 : v.refs.floating.current, y) || vn(a.domReference, y) || g || r(!1, m, "focus");
      });
    }
  }), [i, a.domReference, r, l]);
  return A.useMemo(() => s ? {
    reference: h
  } : {}, [s, h]);
}
function e7(e, t, n) {
  const r = /* @__PURE__ */ new Map(), o = n === "item";
  let i = e;
  if (o && e) {
    const {
      [Gm]: a,
      [Km]: s,
      ...l
    } = e;
    i = l;
  }
  return {
    ...n === "floating" && {
      tabIndex: -1,
      [FF]: ""
    },
    ...i,
    ...t.map((a) => {
      const s = a ? a[n] : null;
      return typeof s == "function" ? e ? s(e) : null : s;
    }).concat(e).reduce((a, s) => (s && Object.entries(s).forEach((l) => {
      let [c, u] = l;
      if (!(o && [Gm, Km].includes(c)))
        if (c.indexOf("on") === 0) {
          if (r.has(c) || r.set(c, []), typeof u == "function") {
            var f;
            (f = r.get(c)) == null || f.push(u), a[c] = function() {
              for (var h, p = arguments.length, C = new Array(p), m = 0; m < p; m++)
                C[m] = arguments[m];
              return (h = r.get(c)) == null ? void 0 : h.map((g) => g(...C)).find((g) => g !== void 0);
            };
          }
        } else
          a[c] = u;
    }), a), {})
  };
}
function ki(e) {
  e === void 0 && (e = []);
  const t = e.map((s) => s?.reference), n = e.map((s) => s?.floating), r = e.map((s) => s?.item), o = A.useCallback(
    (s) => e7(s, e, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), i = A.useCallback(
    (s) => e7(s, e, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    n
  ), a = A.useCallback(
    (s) => e7(s, e, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    r
  );
  return A.useMemo(() => ({
    getReferenceProps: o,
    getFloatingProps: i,
    getItemProps: a
  }), [o, i, a]);
}
const fV = "Escape";
function Tu(e, t, n) {
  switch (e) {
    case "vertical":
      return t;
    case "horizontal":
      return n;
    default:
      return t || n;
  }
}
function ec(e, t) {
  return Tu(t, e === H_ || e === Eu, e === P2 || e === T2);
}
function t7(e, t, n) {
  return Tu(t, e === Eu, n ? e === P2 : e === T2) || e === "Enter" || e === " " || e === "";
}
function fg(e, t, n) {
  return Tu(t, n ? e === P2 : e === T2, e === Eu);
}
function dg(e, t, n, r) {
  const o = n ? e === T2 : e === P2, i = e === H_;
  return t === "both" || t === "horizontal" && r && r > 1 ? e === fV : Tu(t, o, i);
}
function Iu(e, t) {
  const {
    open: n,
    onOpenChange: r,
    elements: o,
    floatingId: i
  } = e, {
    listRef: a,
    activeIndex: s,
    onNavigate: l = () => {
    },
    enabled: c = !0,
    selectedIndex: u = null,
    allowEscape: f = !1,
    loop: h = !1,
    nested: p = !1,
    rtl: C = !1,
    virtual: m = !1,
    focusItemOnOpen: g = "auto",
    focusItemOnHover: v = !0,
    openOnArrowKeyDown: y = !0,
    disabledIndices: w = void 0,
    orientation: x = "vertical",
    parentOrientation: b,
    cols: S = 1,
    scrollItemIntoView: M = !0,
    virtualItemRef: E,
    itemSizes: P,
    dense: T = !1
  } = t;
  process.env.NODE_ENV !== "production" && (f && (h || Bc("`useListNavigation` looping must be enabled to allow escaping."), m || Bc("`useListNavigation` must be virtual to allow escaping.")), x === "vertical" && S > 1 && Bc("In grid list navigation mode (`cols` > 1), the `orientation` should", 'be either "horizontal" or "both".'));
  const _ = n5(o.floating), D = Wn(_), N = Ou(), R = I2();
  vt(() => {
    e.dataRef.current.orientation = x;
  }, [e, x]);
  const L = zt(() => {
    l(k.current === -1 ? null : k.current);
  }), B = m9(o.domReference), V = A.useRef(g), k = A.useRef(u ?? -1), z = A.useRef(null), $ = A.useRef(!0), Z = A.useRef(L), W = A.useRef(!!o.floating), H = A.useRef(n), G = A.useRef(!1), Y = A.useRef(!1), ne = Wn(w), J = Wn(n), ee = Wn(M), U = Wn(u), [X, ie] = A.useState(), [j, te] = A.useState(), K = zt(() => {
    function fe(xe) {
      if (m) {
        var He;
        (He = xe.id) != null && He.endsWith("-fui-option") && (xe.id = i + "-" + Math.random().toString(16).slice(2, 10)), ie(xe.id), R?.events.emit("virtualfocus", xe), E && (E.current = xe);
      } else
        G1(xe, {
          sync: G.current,
          preventScroll: !0
        });
    }
    const ge = a.current[k.current], pe = Y.current;
    ge && fe(ge), (G.current ? (xe) => xe() : requestAnimationFrame)(() => {
      const xe = a.current[k.current] || ge;
      if (!xe) return;
      ge || fe(xe);
      const He = ee.current;
      He && we && (pe || !$.current) && (xe.scrollIntoView == null || xe.scrollIntoView(typeof He == "boolean" ? {
        block: "nearest",
        inline: "nearest"
      } : He));
    });
  });
  vt(() => {
    c && (n && o.floating ? V.current && u != null && (Y.current = !0, k.current = u, L()) : W.current && (k.current = -1, Z.current()));
  }, [c, n, o.floating, u, L]), vt(() => {
    if (c && n && o.floating)
      if (s == null) {
        if (G.current = !1, U.current != null)
          return;
        if (W.current && (k.current = -1, K()), (!H.current || !W.current) && V.current && (z.current != null || V.current === !0 && z.current == null)) {
          let fe = 0;
          const ge = () => {
            a.current[0] == null ? (fe < 2 && (fe ? requestAnimationFrame : queueMicrotask)(ge), fe++) : (k.current = z.current == null || t7(z.current, x, C) || p ? U0(a, ne.current) : Vm(a, ne.current), z.current = null, L());
          };
          ge();
        }
      } else hl(a, s) || (k.current = s, K(), Y.current = !1);
  }, [c, n, o.floating, s, U, p, a, x, C, L, K, ne]), vt(() => {
    var fe;
    if (!c || o.floating || !R || m || !W.current)
      return;
    const ge = R.nodesRef.current, pe = (fe = ge.find((He) => He.id === N)) == null || (fe = fe.context) == null ? void 0 : fe.elements.floating, De = no(bn(o.floating)), xe = ge.some((He) => He.context && vn(He.context.elements.floating, De));
    pe && !xe && $.current && pe.focus({
      preventScroll: !0
    });
  }, [c, o.floating, R, N, m]), vt(() => {
    if (!c || !R || !m || N) return;
    function fe(ge) {
      te(ge.id), E && (E.current = ge);
    }
    return R.events.on("virtualfocus", fe), () => {
      R.events.off("virtualfocus", fe);
    };
  }, [c, R, m, N, E]), vt(() => {
    Z.current = L, H.current = n, W.current = !!o.floating;
  }), vt(() => {
    n || (z.current = null, V.current = g);
  }, [n, g]);
  const me = s != null, we = A.useMemo(() => {
    function fe(pe) {
      if (!J.current) return;
      const De = a.current.indexOf(pe);
      De !== -1 && k.current !== De && (k.current = De, L());
    }
    return {
      onFocus(pe) {
        let {
          currentTarget: De
        } = pe;
        G.current = !0, fe(De);
      },
      onClick: (pe) => {
        let {
          currentTarget: De
        } = pe;
        return De.focus({
          preventScroll: !0
        });
      },
      // Safari
      onMouseMove(pe) {
        let {
          currentTarget: De
        } = pe;
        G.current = !0, Y.current = !1, v && fe(De);
      },
      onPointerLeave(pe) {
        let {
          pointerType: De
        } = pe;
        if (!(!$.current || De === "touch") && (G.current = !0, !!v && (k.current = -1, L(), !m))) {
          var xe;
          (xe = D.current) == null || xe.focus({
            preventScroll: !0
          });
        }
      }
    };
  }, [J, D, v, a, L, m]), ye = A.useCallback(() => {
    var fe;
    return b ?? (R == null || (fe = R.nodesRef.current.find((ge) => ge.id === N)) == null || (fe = fe.context) == null || (fe = fe.dataRef) == null ? void 0 : fe.current.orientation);
  }, [N, R, b]), Ze = zt((fe) => {
    if ($.current = !1, G.current = !0, fe.which === 229 || !J.current && fe.currentTarget === D.current)
      return;
    if (p && dg(fe.key, x, C, S)) {
      ec(fe.key, ye()) || yn(fe), r(!1, fe.nativeEvent, "list-navigation"), Ht(o.domReference) && (m ? R?.events.emit("virtualfocus", o.domReference) : o.domReference.focus());
      return;
    }
    const ge = k.current, pe = U0(a, w), De = Vm(a, w);
    if (B || (fe.key === "Home" && (yn(fe), k.current = pe, L()), fe.key === "End" && (yn(fe), k.current = De, L())), S > 1) {
      const xe = P || Array.from({
        length: a.current.length
      }, () => ({
        width: 1,
        height: 1
      })), He = KN(xe, S, T), pn = He.findIndex((wt) => wt != null && !Fc(a, wt, w)), Ce = He.reduce((wt, rn, Pr) => rn != null && !Fc(a, rn, w) ? Pr : wt, -1), Le = He[GN({
        current: He.map((wt) => wt != null ? a.current[wt] : null)
      }, {
        event: fe,
        orientation: x,
        loop: h,
        rtl: C,
        cols: S,
        // treat undefined (empty grid spaces) as disabled indices so we
        // don't end up in them
        disabledIndices: XN([...(typeof w != "function" ? w : null) || a.current.map((wt, rn) => Fc(a, rn, w) ? rn : void 0), void 0], He),
        minIndex: pn,
        maxIndex: Ce,
        prevIndex: YN(
          k.current > De ? pe : k.current,
          xe,
          He,
          S,
          // use a corner matching the edge closest to the direction
          // we're moving in so we don't end up in the same item. Prefer
          // top/left over bottom/right.
          fe.key === Eu ? "bl" : fe.key === (C ? P2 : T2) ? "tr" : "tl"
        ),
        stopEvent: !0
      })];
      if (Le != null && (k.current = Le, L()), x === "both")
        return;
    }
    if (ec(fe.key, x)) {
      if (yn(fe), n && !m && no(fe.currentTarget.ownerDocument) === fe.currentTarget) {
        k.current = t7(fe.key, x, C) ? pe : De, L();
        return;
      }
      t7(fe.key, x, C) ? h ? k.current = ge >= De ? f && ge !== a.current.length ? -1 : pe : On(a, {
        startingIndex: ge,
        disabledIndices: w
      }) : k.current = Math.min(De, On(a, {
        startingIndex: ge,
        disabledIndices: w
      })) : h ? k.current = ge <= pe ? f && ge !== -1 ? a.current.length : De : On(a, {
        startingIndex: ge,
        decrement: !0,
        disabledIndices: w
      }) : k.current = Math.max(pe, On(a, {
        startingIndex: ge,
        decrement: !0,
        disabledIndices: w
      })), hl(a, k.current) && (k.current = -1), L();
    }
  }), Ue = A.useMemo(() => m && n && me && {
    "aria-activedescendant": j || X
  }, [m, n, me, j, X]), Ke = A.useMemo(() => ({
    "aria-orientation": x === "both" ? void 0 : x,
    ...B ? {} : Ue,
    onKeyDown: Ze,
    onPointerMove() {
      $.current = !0;
    }
  }), [Ue, Ze, x, B]), ft = A.useMemo(() => {
    function fe(pe) {
      g === "auto" && w_(pe.nativeEvent) && (V.current = !0);
    }
    function ge(pe) {
      V.current = g, g === "auto" && x_(pe.nativeEvent) && (V.current = !0);
    }
    return {
      ...Ue,
      onKeyDown(pe) {
        $.current = !1;
        const De = pe.key.startsWith("Arrow"), xe = ["Home", "End"].includes(pe.key), He = De || xe, pn = fg(pe.key, x, C), Ce = dg(pe.key, x, C, S), Le = fg(pe.key, ye(), C), wt = ec(pe.key, x), rn = (p ? Le : wt) || pe.key === "Enter" || pe.key.trim() === "";
        if (m && n) {
          const Ir = R?.nodesRef.current.find((Fe) => Fe.parentId == null), $n = R && Ir ? jN(R.nodesRef.current, Ir.id) : null;
          if (He && $n && E) {
            const Fe = new KeyboardEvent("keydown", {
              key: pe.key,
              bubbles: !0
            });
            if (pn || Ce) {
              var Pr, Bn;
              const tt = ((Pr = $n.context) == null ? void 0 : Pr.elements.domReference) === pe.currentTarget, Te = Ce && !tt ? (Bn = $n.context) == null ? void 0 : Bn.elements.domReference : pn ? a.current.find((nt) => nt?.id === X) : null;
              Te && (yn(pe), Te.dispatchEvent(Fe), te(void 0));
            }
            if ((wt || xe) && $n.context && $n.context.open && $n.parentId && pe.currentTarget !== $n.context.elements.domReference) {
              var Tr;
              yn(pe), (Tr = $n.context.elements.domReference) == null || Tr.dispatchEvent(Fe);
              return;
            }
          }
          return Ze(pe);
        }
        if (!(!n && !y && De)) {
          if (rn) {
            const Ir = ec(pe.key, ye());
            z.current = p && Ir ? null : pe.key;
          }
          if (p) {
            Le && (yn(pe), n ? (k.current = U0(a, ne.current), L()) : r(!0, pe.nativeEvent, "list-navigation"));
            return;
          }
          wt && (u != null && (k.current = u), yn(pe), !n && y ? r(!0, pe.nativeEvent, "list-navigation") : Ze(pe), n && L());
        }
      },
      onFocus() {
        n && !m && (k.current = -1, L());
      },
      onPointerDown: ge,
      onPointerEnter: ge,
      onMouseDown: fe,
      onClick: fe
    };
  }, [X, Ue, S, Ze, ne, g, a, p, L, r, n, y, x, ye, C, u, R, m, E]);
  return A.useMemo(() => c ? {
    reference: ft,
    floating: Ke,
    item: we
  } : {}, [c, ft, Ke, we]);
}
const dV = /* @__PURE__ */ new Map([["select", "listbox"], ["combobox", "listbox"], ["label", !1]]);
function Li(e, t) {
  var n, r;
  t === void 0 && (t = {});
  const {
    open: o,
    elements: i,
    floatingId: a
  } = e, {
    enabled: s = !0,
    role: l = "dialog"
  } = t, c = _u(), u = ((n = i.domReference) == null ? void 0 : n.id) || c, f = A.useMemo(() => {
    var y;
    return ((y = n5(i.floating)) == null ? void 0 : y.id) || a;
  }, [i.floating, a]), h = (r = dV.get(l)) != null ? r : l, C = Ou() != null, m = A.useMemo(() => h === "tooltip" || l === "label" ? {
    ["aria-" + (l === "label" ? "labelledby" : "describedby")]: o ? f : void 0
  } : {
    "aria-expanded": o ? "true" : "false",
    "aria-haspopup": h === "alertdialog" ? "dialog" : h,
    "aria-controls": o ? f : void 0,
    ...h === "listbox" && {
      role: "combobox"
    },
    ...h === "menu" && {
      id: u
    },
    ...h === "menu" && C && {
      role: "menuitem"
    },
    ...l === "select" && {
      "aria-autocomplete": "none"
    },
    ...l === "combobox" && {
      "aria-autocomplete": "list"
    }
  }, [h, f, C, o, u, l]), g = A.useMemo(() => {
    const y = {
      id: f,
      ...h && {
        role: h
      }
    };
    return h === "tooltip" || l === "label" ? y : {
      ...y,
      ...h === "menu" && {
        "aria-labelledby": u
      }
    };
  }, [h, f, u, l]), v = A.useCallback((y) => {
    let {
      active: w,
      selected: x
    } = y;
    const b = {
      role: "option",
      ...w && {
        id: f + "-fui-option"
      }
    };
    switch (l) {
      case "select":
      case "combobox":
        return {
          ...b,
          "aria-selected": x
        };
    }
    return {};
  }, [f, l]);
  return A.useMemo(() => s ? {
    reference: m,
    floating: g,
    item: v
  } : {}, [s, m, g, v]);
}
function Hd(e, t) {
  var n;
  const {
    open: r,
    dataRef: o
  } = e, {
    listRef: i,
    activeIndex: a,
    onMatch: s,
    onTypingChange: l,
    enabled: c = !0,
    findMatch: u = null,
    resetMs: f = 750,
    ignoreKeys: h = [],
    selectedIndex: p = null
  } = t, C = A.useRef(-1), m = A.useRef(""), g = A.useRef((n = p ?? a) != null ? n : -1), v = A.useRef(null), y = zt(s), w = zt(l), x = Wn(u), b = Wn(h);
  vt(() => {
    r && (Rn(C), v.current = null, m.current = "");
  }, [r]), vt(() => {
    if (r && m.current === "") {
      var T;
      g.current = (T = p ?? a) != null ? T : -1;
    }
  }, [r, p, a]);
  const S = zt((T) => {
    T ? o.current.typing || (o.current.typing = T, w(T)) : o.current.typing && (o.current.typing = T, w(T));
  }), M = zt((T) => {
    function _(B, V, k) {
      const z = x.current ? x.current(V, k) : V.find(($) => $?.toLocaleLowerCase().indexOf(k.toLocaleLowerCase()) === 0);
      return z ? B.indexOf(z) : -1;
    }
    const D = i.current;
    if (m.current.length > 0 && m.current[0] !== " " && (_(D, D, m.current) === -1 ? S(!1) : T.key === " " && yn(T)), D == null || b.current.includes(T.key) || // Character key.
    T.key.length !== 1 || // Modifier key.
    T.ctrlKey || T.metaKey || T.altKey)
      return;
    r && T.key !== " " && (yn(T), S(!0)), D.every((B) => {
      var V, k;
      return B ? ((V = B[0]) == null ? void 0 : V.toLocaleLowerCase()) !== ((k = B[1]) == null ? void 0 : k.toLocaleLowerCase()) : !0;
    }) && m.current === T.key && (m.current = "", g.current = v.current), m.current += T.key, Rn(C), C.current = window.setTimeout(() => {
      m.current = "", g.current = v.current, S(!1);
    }, f);
    const R = g.current, L = _(D, [...D.slice((R || 0) + 1), ...D.slice(0, (R || 0) + 1)], m.current);
    L !== -1 ? (y(L), v.current = L) : T.key !== " " && (m.current = "", S(!1));
  }), E = A.useMemo(() => ({
    onKeyDown: M
  }), [M]), P = A.useMemo(() => ({
    onKeyDown: M,
    onKeyUp(T) {
      T.key === " " && S(!1);
    }
  }), [M, S]);
  return A.useMemo(() => c ? {
    reference: E,
    floating: P
  } : {}, [c, E, P]);
}
const R1 = (e) => {
  const t = () => ({
    width: window.innerWidth,
    height: window.innerHeight
  }), [n, r] = ue(t);
  return ve(() => {
    const o = () => {
      r(t());
    };
    return window.addEventListener("resize", o), () => window.removeEventListener("resize", o);
  }, []), n.width <= (e || 768);
};
function hV({
  initialOpen: e = !1,
  placement: t = "bottom",
  open: n,
  onOpenChange: r,
  trigger: o = "hover"
}) {
  const [i, a] = O.useState(e), s = ke(null), l = R1(), c = n ?? i, u = r ?? a, f = Ri({
    placement: t,
    open: c,
    onOpenChange: u,
    whileElementsMounted: D1,
    middleware: [
      Ti(10),
      Ii({
        crossAxis: t.includes("-"),
        fallbackAxisSideDirection: "none",
        padding: 5
      }),
      B_({ padding: 5 }),
      $_({
        element: s
      })
    ]
  }), h = () => /* @__PURE__ */ d(
    zF,
    {
      ref: s,
      context: f.context,
      tipRadius: 2,
      shapeRendering: "geometricPrecision",
      className: "fill-surface-common-tooltip-background"
    }
  ), p = f.context, C = UF(p, {
    move: !1,
    enabled: n == null && o === "hover"
  }), m = uV(p, {
    enabled: n == null && o === "hover"
  }), g = Pu(p, {
    enabled: n == null && o === "click" || l
  }), v = Di(p, {
    enabled: n == null || l
  }), y = Li(p, { role: "tooltip" }), w = ki(
    l ? [g, v, y] : [C, g, m, v, y]
  );
  return O.useMemo(
    () => ({
      open: c,
      setOpen: u,
      FloatingArrowElement: h,
      ...w,
      ...f
    }),
    [c, u, w, f]
  );
}
function q_({
  children: e,
  ...t
}) {
  const n = hV({ ...t });
  return /* @__PURE__ */ d(i_.Provider, { value: n, children: e });
}
const U_ = O.forwardRef(function({ className: t, ...n }, r) {
  const o = a_(), i = Mo([o.refs.setFloating, r]), a = () => {
    const c = o.FloatingArrowElement;
    return /* @__PURE__ */ d(c, {});
  }, s = o.getFloatingProps(n).children, l = I(
    "bg-surface-common-tooltip-background text-surface-common-tooltip-text z-10 gap-[10px] rounded-[4px] px-[12px] py-[6px]",
    "[&>p]:text-surface-common-tooltip-text",
    "[&>span]:text-surface-common-tooltip-text",
    t
  );
  return o.open ? /* @__PURE__ */ F(
    "div",
    {
      ref: i,
      className: l,
      style: {
        ...o.floatingStyles
      },
      ...o.getFloatingProps(n),
      children: [
        s,
        /* @__PURE__ */ d(a, {})
      ]
    }
  ) : null;
}), G_ = O.forwardRef(function({ children: t, asChild: n = !1, ...r }, o) {
  const i = a_(), a = t.ref, s = Mo([i.refs.setReference, o, a]);
  return n && O.isValidElement(t) ? O.cloneElement(
    t,
    i.getReferenceProps({
      ref: s,
      ...r,
      // @ts-expect-error: disable-next-line
      ...t.props,
      "data-state": i.open ? "open" : "closed"
    })
  ) : /* @__PURE__ */ d(
    "button",
    {
      ref: s,
      "data-state": i.open ? "open" : "closed",
      ...i.getReferenceProps(r),
      children: t
    }
  );
}), x1 = Object.assign(q_, {
  Trigger: G_,
  Content: U_
});
x1.Trigger.displayName = "Tooltip.Trigger";
x1.Content.displayName = "Tooltip.Content";
const Dt = O.forwardRef(
  (e, t) => {
    const {
      variant: n = "primary",
      disabled: r,
      afterIcon: o,
      beforeIcon: i,
      className: a,
      loading: s,
      back: l,
      small: c,
      tabIndex: u,
      tooltip: f,
      truncate: h = !1,
      truncateAt: p = 20,
      ...C
    } = e, m = {}, g = ar.toArray(e?.children).find(
      (z) => typeof z == "string"
    ), y = typeof g == "string" && g?.length && h ? `${g?.slice(0, p)} ${p < g?.length ? "..." : ""}` : e.children;
    s && (m["aria-busy"] = e.loading, m["aria-disabled"] = e.loading, m["aria-live"] = e["aria-live"] || "polite", m["aria-label"] = e["aria-label"] || "Laster"), r && (m["aria-disabled"] = e.disabled), l && (m["aria-label"] = e["aria-label"] || "Gå tilbake");
    const w = {
      primary: I(
        "text-button-primary-text group-hover:!text-button-primary-text-hover"
      ),
      secondary: I(
        "text-button-secondary-text group-hover:text-button-secondary-text-hover"
      ),
      ghost: I(
        "text-button-ghost-text group-hover:text-button-ghost-text-hover"
      ),
      danger: "text-ui-errorDark",
      "danger-filled": "text-text-invert group-hover:text-ui-errorDark",
      link: "text-surface-common-primary",
      "icon-backgrounded": "text-surface-common-primary",
      nostyle: "text-text-invert"
    }, x = I("border-none bg-transparent"), b = I(
      "group flex h-[42px] w-fit items-center justify-center gap-1 rounded-full bg-button-primary-default px-md text-center font-semibold !text-button-primary-text",
      "focus-visible:bg-primary-500 focus-visible::outline-none border-none focus-within:!text-button-primary-text-focus focus:border-none focus:bg-button-primary-focus focus:!text-button-primary-text-focus focus:outline-none focus:ring-0 focus-visible:underline",
      "hover:bg-button-primary-hover hover:!text-button-primary-text-hover",
      "active:bg-button-primary-active active:!text-button-primary-text-active",
      "transition-all duration-100",
      c ? "text-small" : "text-paragraph"
    ), S = I(
      "border-none bg-button-secondary-default !text-button-secondary-text",
      "active:bg-button-secondary-active active:!text-button-secondary-text-active",
      "hover:to-button-secondary-hover hover:!text-button-secondary-text-hover",
      "focus-visible:bg-button-secondary-focus focus-visible:!text-button-secondary-text-focus"
    ), M = I("h-[32px] px-md"), E = I(
      "bg-neutral-300 !text-neutral-500 hover:bg-neutral-300 hover:!text-neutral-500 focus-visible:bg-neutral-300 active:bg-neutral-300 active:!text-neutral-500"
    ), P = I(
      "border-none bg-button-ghost-default !text-button-ghost-text",
      "hover:bg-button-ghost-hover hover:!text-button-ghost-text-hover",
      "focus-visible:bg-button-ghost-focus focus-visible:!text-text-invert",
      "active:bg-button-ghost-active active:!text-button-ghost-text-focus active:underline"
    ), T = I(
      "border-none bg-transparent !text-ui-errorDark outline-none",
      "hover:bg-ui-errorLight hover:!text-ui-errorDark",
      "focus:bg-transparent focus:!text-ui-errorDark focus:!underline",
      "active:bg-ui-errorDark active:!text-text-invert active:!underline"
    ), _ = I(
      "border-none bg-ui-errorDark !text-text-invert",
      "hover:bg-ui-errorLight hover:!text-ui-errorDark",
      "focus:bg-ui-errorDark focus:!text-text-invert focus:!underline",
      "active:bg-ui-errorDark active:!text-text-invert"
    ), D = I(
      "h-auto border-none bg-transparency-full !px-0 !text-surface-common-primary underline-offset-2 outline-none",
      "hover:bg-transparency-full hover:!text-surface-common-primary hover:underline",
      "focus:bg-transparent focus:!text-surface-common-primary focus-visible:underline",
      "active:border-none active:bg-transparency-full active:!text-text-primary active:underline active:outline-none"
    ), N = I(
      "flex h-[36px] w-[36px] items-center justify-center rounded-full !bg-surface-common-light !px-0 py-0 !text-surface-common-icon-color",
      "group-hover:cursor-pointer",
      "hover:!bg-surface-common-primary-light hover:!text-surface-common-icon-color",
      "active:!bg-surface-common-primary-light active:!text-surface-common-icon-color",
      "focus:!bg-surface-common-primary-light focus:!text-surface-common-icon-color"
    ), R = I(
      "inline-flex justify-between px-4",
      "[&>svg]:!fill-current",
      "hocus:[&>svg]:fill-current"
    ), L = I("cursor-default opacity-80"), B = w[n], k = n === "nostyle" ? I(x, a) : I(
      b,
      n === "secondary" && S,
      n === "ghost" && P,
      n === "link" && D,
      n === "danger" && T,
      n === "danger-filled" && _,
      n === "icon-backgrounded" && N,
      c && M,
      r && E,
      (o || i) && R,
      l && R,
      s && L,
      a
    );
    return f ? /* @__PURE__ */ F(x1, { children: [
      /* @__PURE__ */ d(x1.Trigger, { asChild: !0, children: /* @__PURE__ */ F(
        Em,
        {
          tabIndex: u,
          disabled: r,
          loading: s,
          title: g || "",
          ref: t,
          className: k,
          afterIcon: o,
          beforeIcon: l ? /* @__PURE__ */ d(Tm, { size: "small" }) : i,
          ...m,
          ...C,
          children: [
            y || e.children,
            " ",
            s && /* @__PURE__ */ d(Gc, { svgClassName: B })
          ]
        }
      ) }),
      /* @__PURE__ */ d(x1.Content, { children: f })
    ] }) : /* @__PURE__ */ F(
      Em,
      {
        tabIndex: u,
        disabled: r,
        loading: s,
        title: g || "",
        ref: t,
        className: k,
        afterIcon: o,
        beforeIcon: l ? /* @__PURE__ */ d(Tm, { size: "small" }) : i,
        ...m,
        ...C,
        children: [
          y || e.children,
          " ",
          s && /* @__PURE__ */ d(Gc, { svgClassName: B })
        ]
      }
    );
  }
), pV = I("m-0 font-bold leading-normal"), mV = (e, t) => I(
  e === "default" && I("text-text-brand"),
  e === "primary" && I("text-text-primary"),
  e === "secondary" && I("text-text-secondary"),
  e === "dark" && I("text-text-invert"),
  e === "custom" && I(`text-${t}`),
  t && `text-${t}`
), gV = (e) => I(
  e === "xsmall" && "text-heading-xsmall-mobile sm:text-heading-xsmall",
  e === "small" && "text-heading-small-mobile sm:text-heading-small",
  e === "medium" && "text-heading-medium-mobile sm:text-heading-medium",
  e === "large" && "text-heading-large-mobile sm:text-heading-large",
  e === "xlarge" && "text-heading-xlarge-mobile sm:text-heading-xlarge"
), _1 = O.forwardRef(
  ({
    level: e = 1,
    color: t,
    size: n = "medium",
    variant: r = "default",
    children: o,
    className: i,
    id: a
  }, s) => {
    const l = `h${e}`, c = I(
      pV,
      mV(r, t),
      gV(n),
      i
    );
    return /* @__PURE__ */ d(l, { className: c, id: a, ref: s, children: o });
  }
), CV = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M9.5 16C7.68333 16 6.14583 15.3708 4.8875 14.1125C3.62917 12.8542 3 11.3167 3 9.5C3 7.68333 3.62917 6.14583 4.8875 4.8875C6.14583 3.62917 7.68333 3 9.5 3C11.3167 3 12.8542 3.62917 14.1125 4.8875C15.3708 6.14583 16 7.68333 16 9.5C16 10.2333 15.8833 10.925 15.65 11.575C15.4167 12.225 15.1 12.8 14.7 13.3L20.3 18.9C20.4833 19.0833 20.575 19.3167 20.575 19.6C20.575 19.8833 20.4833 20.1167 20.3 20.3C20.1167 20.4833 19.8833 20.575 19.6 20.575C19.3167 20.575 19.0833 20.4833 18.9 20.3L13.3 14.7C12.8 15.1 12.225 15.4167 11.575 15.65C10.925 15.8833 10.2333 16 9.5 16ZM9.5 14C10.75 14 11.8125 13.5625 12.6875 12.6875C13.5625 11.8125 14 10.75 14 9.5C14 8.25 13.5625 7.1875 12.6875 6.3125C11.8125 5.4375 10.75 5 9.5 5C8.25 5 7.1875 5.4375 6.3125 6.3125C5.4375 7.1875 5 8.25 5 9.5C5 10.75 5.4375 11.8125 6.3125 12.6875C7.1875 13.5625 8.25 14 9.5 14Z",
    fill: "currentColor"
  }
) }), wa = Q("IconSearch")(CV), ti = ({ icon: e, title: t, ariaLabel: n, variant: r = "default" }) => {
  const o = n || t, i = I(
    "hidden items-center gap-xs sm:flex [&>p]:!text-[12px] [&>p]:leading-[normal]",
    r === "outlined" && "rounded-sm border border-neutral-200 px-[3px] py-[2px] [&>p]:!text-neutral-500"
  );
  return /* @__PURE__ */ d(
    "div",
    {
      "aria-label": o,
      title: t,
      className: i,
      role: "presentation",
      children: e
    }
  );
}, npe = ({
  variant: e = "home",
  text: t = "Søk",
  animated: n = !1,
  className: r,
  loopInterval: o = 5e3
}) => {
  const i = I(
    "group flex w-full items-center gap-sm rounded-md focus-visible:outline-1 focus-visible:outline-button-primary-focus",
    e === "home" && "p-[12px] shadow-sm transition-shadow duration-200 ease-in-out hover:shadow-md sm:p-lg",
    e === "topnav" && "h-fit max-h-[40px] justify-between bg-surface-common-subtle px-[12px] py-[6px] text-start hover:bg-surface-common-light sm:px-[16px] sm:py-[8px]",
    e === "topnav-mobile" && "h-fit max-h-[40px] border border-solid border-border-light px-[12px] py-[6px] text-start sm:px-[16px] sm:py-[8px]",
    e === "topnav-mobile-dark" && I(
      "h-fit max-h-[40px] border border-solid border-surface-portalen-aside-highlight bg-surface-portalen-page-header px-[12px] py-[6px] text-start sm:px-[16px] sm:py-[8px] [&>span]:!text-globalSearchTopnavMobileDark"
    ),
    e === "topnav-elevated" && I(
      "max-h-[48px] w-full max-w-[618px] rounded-[98px] bg-surface-common-white px-[16px] py-[10px] text-start shadow-md transition-shadow duration-200 ease-in-out hover:shadow-lg"
    ),
    r
  ), a = e === "topnav" || e === "topnav-elevated", s = _e(() => navigator ? navigator.userAgent?.toLowerCase()?.includes("mac") : !1, []), l = I(
    "line-clamp-1 text-text-secondary",
    e === "home" && "text-[18px]",
    e === "topnav" && "text-[14px] text-text-brand"
  ), c = () => /* @__PURE__ */ d("div", { className: "hidden transition-all duration-200 ease-in-out group-hover:flex group-focus:flex", children: /* @__PURE__ */ d(
    ti,
    {
      icon: /* @__PURE__ */ d(Rt, { children: s ? "cmd+k" : "ctrl+k" }),
      variant: "outlined",
      title: s ? "cmd+k" : "ctrl+k"
    }
  ) });
  return /* @__PURE__ */ F(
    Dt,
    {
      variant: "nostyle",
      className: i,
      title: "Åpne søk",
      "aria-label": "åpne søk",
      onClick: () => {
        const f = new Event("gs:start-search");
        document.dispatchEvent(f);
      },
      children: [
        (e === "home" || e === "topnav-mobile") && /* @__PURE__ */ d(wa, { colorVariant: "primary" }),
        e === "topnav-mobile-dark" && /* @__PURE__ */ d(wa, { className: "text-surface-common-primary-light" }),
        n ? /* @__PURE__ */ d(
          Q9e,
          {
            words: [t],
            speed: 50,
            showCaret: !1,
            loopInterval: o
          }
        ) : /* @__PURE__ */ d("span", { className: l, children: t }),
        /* @__PURE__ */ F("div", { className: "flex flex-1 justify-end gap-md", children: [
          !e.includes("mobile") && /* @__PURE__ */ d(c, {}),
          a && /* @__PURE__ */ d(wa, { colorVariant: "primary" })
        ] })
      ]
    }
  );
}, K_ = gt(
  void 0
), La = () => {
  const e = Oe(K_);
  if (!e)
    throw new Error(
      "useNavigationContext must be used within a NavigationProvider"
    );
  return e;
}, vV = ({
  children: e
}) => {
  const [t, n] = ue(null), [r, o] = ue([]), [i, a] = ue(!1), [s, l] = ue(null);
  ve(() => {
    if (t) return;
    const m = r[0];
    n(m);
  }, [r, t]), ve(() => {
    n(null), o([]);
  }, [s]);
  const c = ct((m) => {
    l(m);
  }, []), u = ct((m) => {
    o((g) => [...g, m]);
  }, []), f = ct((m) => {
    o((g) => g.filter((v) => v !== m));
  }, []), h = () => {
    n(null), a(!0);
  }, p = () => {
    n(null);
    const m = document.querySelector("#gs-search");
    !m || !("value" in m) || (m.value = "");
  }, C = (m) => {
    const g = r.length;
    if (g === 0) return;
    const v = r.indexOf(t || "");
    if (m.key === "Escape") {
      n(null);
      return;
    }
    if (m.key === "ArrowDown") {
      if (m.preventDefault(), v === -1) {
        const x = r[0];
        n(x);
        return;
      }
      const y = v + 1, w = r[y] || r[0];
      n(w);
    }
    if (m.key === "ArrowUp") {
      if (m.preventDefault(), v === -1) {
        const x = r[g - 1];
        n(x);
        return;
      }
      const y = v - 1, w = r[y] || r[g - 1];
      n(w);
    }
  };
  return /* @__PURE__ */ d(
    K_.Provider,
    {
      value: {
        activeId: t,
        closeWasTriggered: i,
        currentListType: s,
        setActiveId: n,
        handleKeyDown: C,
        handleReset: p,
        registerItemId: u,
        unregisterItemId: f,
        handleClose: h,
        resetCloseWasTriggered: () => a(!1),
        setListType: c
      },
      children: e
    }
  );
}, Y_ = () => /* @__PURE__ */ F(
  "svg",
  {
    width: "34",
    height: "20",
    viewBox: "0 0 34 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ d("rect", { x: "0.5", y: "0.5", width: "33", height: "19", rx: "2.5", fill: "white" }),
      /* @__PURE__ */ d("rect", { x: "0.5", y: "0.5", width: "33", height: "19", rx: "2.5", stroke: "#DEE0E4" }),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M9.96 14.144C9.36 14.144 8.816 14.024 8.328 13.784C7.84 13.536 7.452 13.184 7.164 12.728C6.876 12.264 6.732 11.704 6.732 11.048C6.732 10.408 6.876 9.86 7.164 9.404C7.452 8.94 7.828 8.584 8.292 8.336C8.756 8.088 9.252 7.964 9.78 7.964C10.364 7.964 10.856 8.084 11.256 8.324C11.664 8.564 11.972 8.896 12.18 9.32C12.396 9.736 12.504 10.216 12.504 10.76C12.504 10.896 12.496 11.028 12.48 11.156C12.472 11.276 12.46 11.376 12.444 11.456H7.728V10.472H11.556L11.292 10.784C11.292 10.2 11.16 9.764 10.896 9.476C10.64 9.18 10.28 9.032 9.816 9.032C9.488 9.032 9.192 9.108 8.928 9.26C8.672 9.412 8.468 9.64 8.316 9.944C8.164 10.24 8.088 10.608 8.088 11.048C8.088 11.504 8.172 11.88 8.34 12.176C8.516 12.472 8.756 12.696 9.06 12.848C9.372 13 9.732 13.076 10.14 13.076C10.452 13.076 10.74 13.032 11.004 12.944C11.268 12.856 11.532 12.736 11.796 12.584L12.264 13.448C11.952 13.648 11.6 13.816 11.208 13.952C10.816 14.08 10.4 14.144 9.96 14.144ZM16.8313 14.144C16.2793 14.144 15.7513 14.056 15.2473 13.88C14.7433 13.696 14.3073 13.48 13.9393 13.232L14.5393 12.356C14.8913 12.588 15.2713 12.772 15.6793 12.908C16.0873 13.036 16.5313 13.1 17.0113 13.1C17.4193 13.1 17.7193 13.032 17.9113 12.896C18.1113 12.752 18.2113 12.584 18.2113 12.392C18.2113 12.296 18.1873 12.208 18.1393 12.128C18.0993 12.048 18.0233 11.976 17.9113 11.912C17.7993 11.84 17.6353 11.772 17.4193 11.708C17.2033 11.644 16.9233 11.576 16.5793 11.504C15.7953 11.336 15.2193 11.108 14.8513 10.82C14.4833 10.532 14.2993 10.168 14.2993 9.728C14.2993 9.208 14.5233 8.784 14.9713 8.456C15.4273 8.128 16.0673 7.964 16.8913 7.964C17.3793 7.964 17.8353 8.044 18.2593 8.204C18.6913 8.364 19.0553 8.544 19.3513 8.744L18.7153 9.596C18.4353 9.404 18.1273 9.26 17.7913 9.164C17.4553 9.06 17.1153 9.008 16.7713 9.008C16.5073 9.008 16.2953 9.036 16.1353 9.092C15.9833 9.148 15.8673 9.228 15.7873 9.332C15.7153 9.428 15.6793 9.536 15.6793 9.656C15.6793 9.864 15.7993 10.02 16.0393 10.124C16.2793 10.228 16.6713 10.34 17.2153 10.46C17.8473 10.596 18.3353 10.752 18.6793 10.928C19.0233 11.096 19.2593 11.292 19.3873 11.516C19.5233 11.732 19.5913 12 19.5913 12.32C19.5913 12.656 19.4833 12.964 19.2673 13.244C19.0593 13.516 18.7513 13.736 18.3433 13.904C17.9353 14.064 17.4313 14.144 16.8313 14.144ZM24.5186 14.144C23.9026 14.144 23.3466 14.024 22.8506 13.784C22.3626 13.536 21.9746 13.184 21.6866 12.728C21.4066 12.264 21.2666 11.708 21.2666 11.06C21.2666 10.404 21.4186 9.848 21.7226 9.392C22.0346 8.928 22.4466 8.576 22.9586 8.336C23.4706 8.088 24.0226 7.964 24.6146 7.964C25.0946 7.964 25.5186 8.044 25.8866 8.204C26.2546 8.356 26.5586 8.552 26.7986 8.792L26.1386 9.656C25.9066 9.472 25.6706 9.332 25.4306 9.236C25.1986 9.14 24.9506 9.092 24.6866 9.092C24.2946 9.092 23.9466 9.176 23.6426 9.344C23.3466 9.504 23.1146 9.732 22.9466 10.028C22.7786 10.324 22.6946 10.668 22.6946 11.06C22.6946 11.452 22.7746 11.796 22.9346 12.092C23.1026 12.388 23.3306 12.616 23.6186 12.776C23.9146 12.936 24.2586 13.016 24.6506 13.016C24.9866 13.016 25.2946 12.952 25.5746 12.824C25.8546 12.696 26.1066 12.544 26.3306 12.368L26.9066 13.256C26.5706 13.544 26.1946 13.764 25.7786 13.916C25.3626 14.068 24.9426 14.144 24.5186 14.144Z",
          fill: "#181B1F"
        }
      )
    ]
  }
), yV = ({
  placeholder: e,
  query: t,
  handleChange: n,
  hasResults: r = !1
}) => {
  const o = ke(null), i = I(
    "flex items-center gap-sm bg-white p-[12px] sm:p-lg",
    r && "border-b-[1px] border-b-border-light"
  );
  return ve(() => {
    o.current && o.current.focus();
  }, []), /* @__PURE__ */ F("div", { className: i, children: [
    /* @__PURE__ */ d(
      wa,
      {
        colorVariant: "primary",
        className: "h-[20px] w-[20px] sm:h-[24px] sm:w-[24px]"
      }
    ),
    /* @__PURE__ */ d(
      "input",
      {
        type: "text",
        placeholder: e,
        id: "gs-search",
        autoComplete: "off",
        className: "w-full flex-1 border-none focus:border-blue-500 focus:outline-none",
        value: t,
        onChange: n,
        autoFocus: !0
      }
    )
  ] });
}, bV = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M12 13.4L7.10005 18.3C6.91672 18.4834 6.68338 18.575 6.40005 18.575C6.11672 18.575 5.88338 18.4834 5.70005 18.3C5.51672 18.1167 5.42505 17.8834 5.42505 17.6C5.42505 17.3167 5.51672 17.0834 5.70005 16.9L10.6 12L5.70005 7.10005C5.51672 6.91672 5.42505 6.68338 5.42505 6.40005C5.42505 6.11672 5.51672 5.88338 5.70005 5.70005C5.88338 5.51672 6.11672 5.42505 6.40005 5.42505C6.68338 5.42505 6.91672 5.51672 7.10005 5.70005L12 10.6L16.9 5.70005C17.0834 5.51672 17.3167 5.42505 17.6 5.42505C17.8834 5.42505 18.1167 5.51672 18.3 5.70005C18.4834 5.88338 18.575 6.11672 18.575 6.40005C18.575 6.68338 18.4834 6.91672 18.3 7.10005L13.4 12L18.3 16.9C18.4834 17.0834 18.575 17.3167 18.575 17.6C18.575 17.8834 18.4834 18.1167 18.3 18.3C18.1167 18.4834 17.8834 18.575 17.6 18.575C17.3167 18.575 17.0834 18.4834 16.9 18.3L12 13.4Z",
    fill: "currentColor"
  }
) }), Wr = Q("IconClose")(bV), wV = () => {
  const [e, t] = ue(!1), [n, r] = ue(!1), o = ct(() => t((p) => !p), []), i = ct(() => t(!1), []), a = () => t((p) => !p);
  ve(() => {
    const p = (C) => {
      (C.ctrlKey && C.key === "k" || C.metaKey && C.key === "k") && (C.preventDefault(), o()), C.key === "Escape" && i();
    };
    return document.addEventListener("keydown", p), () => document.removeEventListener("keydown", p);
  }, [o, i]), ve(() => {
    const p = () => {
      t(!0);
    };
    return document.addEventListener("gs:start-search", p), () => document.removeEventListener("gs:start-search", p);
  }, []);
  const { context: s, floatingStyles: l, refs: c } = Ri({
    open: e,
    onOpenChange: (p, C, m) => {
      Id(() => {
        c.floating.current && !p && (c.floating.current.scrollTop = 0), setTimeout(() => {
          t(p);
        }, 1);
      }), (m === "escape-key" || m === "outside-press") && r(!0);
    },
    whileElementsMounted: (p, C, m) => (D1(p, C, m), () => {
      C.scrollTop = 0;
    }),
    middleware: [
      Ii({ padding: 10 }),
      _2({
        apply({ rects: p, elements: C }) {
          requestAnimationFrame(() => {
            Object.assign(C.floating.style, {
              width: `${p.reference.width}px`,
              maxHeight: "200px"
            });
          });
        }
      }),
      Ti(10)
    ]
  }), u = Li(s, { role: "listbox" }), f = Di(s), h = ki([u, f]);
  return O.useMemo(
    () => ({
      open: e,
      isDismissed: n,
      setIsDismissed: r,
      setOpen: t,
      toggleOpen: a,
      closeSearch: i,
      toggleSearch: o,
      context: s,
      floatingStyles: l,
      refs: c,
      ...h
    }),
    [
      e,
      n,
      r,
      t,
      a,
      i,
      o,
      s,
      l,
      c,
      h
    ]
  );
}, xV = O.forwardRef(
  ({ placeholder: e = "Søk på alt i portalen", className: t, ...n }, r) => {
    const { handleSearch: o, query: i, onClose: a, ...s } = n, [l, c] = ue(i || ""), u = O.useRef(null), {
      context: f,
      getFloatingProps: h,
      refs: p,
      open: C,
      setOpen: m,
      closeSearch: g,
      isDismissed: v,
      setIsDismissed: y
    } = wV(), {
      handleKeyDown: w,
      handleReset: x,
      closeWasTriggered: b,
      resetCloseWasTriggered: S
    } = La(), M = Mo([r, u, p.setFloating]), E = I("w-10/12 max-w-2xl sm:max-w-[600px]"), P = I(
      "relative mx-auto my-3xl min-h-0 w-full min-w-[300px] max-w-[47rem] overflow-hidden rounded-md bg-white shadow-xlarge scrollbar-none focus:outline-none sm:m-auto",
      E,
      t
    );
    ve(() => {
      n.overrideQuery && (c(n.overrideQuery), o(n.overrideQuery));
    }, [n.overrideQuery, o]);
    const T = async (N) => {
      if (N.key === "Escape") {
        D();
        return;
      }
      w(N);
    }, _ = (N) => {
      const R = N.target.value;
      c(R), o(R);
    }, D = ct(async () => {
      setTimeout(() => x(), 0), c(""), g(), m(!1), a && a(), S(), y((N) => !N);
    }, [
      x,
      g,
      m,
      a,
      S,
      y
    ]);
    return ve(() => {
      !b && !v || D();
    }, [b, v, D]), C ? /* @__PURE__ */ d(
      iV,
      {
        lockScroll: !0,
        tabIndex: -1,
        onKeyDown: T,
        className: "fixed inset-0 z-[200] flex items-center justify-center bg-gray-800 bg-opacity-50",
        children: /* @__PURE__ */ d(
          ms,
          {
            context: f,
            initialFocus: u,
            visuallyHiddenDismiss: !0,
            children: /* @__PURE__ */ d(
              "div",
              {
                role: "dialog",
                className: P,
                ref: M,
                ...h(s),
                children: /* @__PURE__ */ F("div", { className: "flex max-h-[80vh] flex-col overflow-visible scrollbar-none", children: [
                  /* @__PURE__ */ F(
                    yV,
                    {
                      placeholder: e,
                      query: l,
                      hasResults: !!n.children,
                      handleChange: _,
                      children: [
                        /* @__PURE__ */ d(ti, { icon: /* @__PURE__ */ d(Y_, {}), title: "Lukk søk" }),
                        /* @__PURE__ */ d(Dt, { title: "Lukk", variant: "nostyle", onClick: g, children: /* @__PURE__ */ d(Wr, { className: "h-[20px] w-[20px]" }) })
                      ]
                    }
                  ),
                  n.children
                ] })
              }
            )
          }
        )
      }
    ) : null;
  }
), SV = O.forwardRef(
  ({ label: e, title: t, ariaLabel: n, children: r }, o) => /* @__PURE__ */ F(
    "li",
    {
      ref: o,
      className: "flex flex-col gap-sm",
      "aria-label": n || t,
      title: t,
      children: [
        /* @__PURE__ */ d("h3", { className: "text-heading-xsmall font-semibold text-text-primary", children: e }),
        /* @__PURE__ */ d("ul", { className: "flex flex-col gap-sm", children: r })
      ]
    }
  )
), Ut = ({
  inverted: e = !1,
  weight: t = "normal",
  className: n,
  children: r,
  htmlFor: o
}) => {
  const i = {
    bold: I("font-bold"),
    semibold: I("font-semibold"),
    normal: I("font-normal")
  }, a = I(
    "text-label-mobile sm:text-label",
    i[t],
    e && "text-text-invert",
    n
  );
  return /* @__PURE__ */ d("label", { className: a, htmlFor: o, children: r });
}, MV = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M12.6 12L8.70005 8.09999C8.51672 7.91665 8.42505 7.68332 8.42505 7.39999C8.42505 7.11665 8.51672 6.88332 8.70005 6.69999C8.88338 6.51665 9.11672 6.42499 9.40005 6.42499C9.68338 6.42499 9.91672 6.51665 10.1 6.69999L14.7 11.3C14.8 11.4 14.8709 11.5083 14.9125 11.625C14.9542 11.7417 14.975 11.8667 14.975 12C14.975 12.1333 14.9542 12.2583 14.9125 12.375C14.8709 12.4917 14.8 12.6 14.7 12.7L10.1 17.3C9.91672 17.4833 9.68338 17.575 9.40005 17.575C9.11672 17.575 8.88338 17.4833 8.70005 17.3C8.51672 17.1167 8.42505 16.8833 8.42505 16.6C8.42505 16.3167 8.51672 16.0833 8.70005 15.9L12.6 12Z",
    fill: "currentColor"
  }
) }), yo = Q("IconChevronRight")(MV), X_ = () => /* @__PURE__ */ F(
  "svg",
  {
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ d(
        "rect",
        {
          x: "0.25",
          y: "0.25",
          width: "27.5",
          height: "27.5",
          rx: "5.75",
          fill: "white"
        }
      ),
      /* @__PURE__ */ d(
        "rect",
        {
          x: "0.25",
          y: "0.25",
          width: "27.5",
          height: "27.5",
          rx: "5.75",
          stroke: "#DEE0E4",
          strokeWidth: "0.5"
        }
      ),
      /* @__PURE__ */ d(
        "mask",
        {
          id: "mask0_1642_1699",
          style: { maskType: "alpha" },
          maskUnits: "userSpaceOnUse",
          x: "4",
          y: "4",
          width: "20",
          height: "20",
          children: /* @__PURE__ */ d("rect", { x: "4", y: "4", width: "20", height: "20", fill: "#D9D9D9" })
        }
      ),
      /* @__PURE__ */ d("g", { mask: "url(#mask0_1642_1699)", children: /* @__PURE__ */ d(
        "path",
        {
          d: "M9.875 14.7501L11.9167 16.7917C12.0694 16.9445 12.1458 17.1216 12.1458 17.323C12.1458 17.5244 12.0694 17.7015 11.9167 17.8542C11.7639 18.007 11.5868 18.0834 11.3854 18.0834C11.184 18.0834 11.0069 18.007 10.8542 17.8542L7.52521 14.5253C7.45285 14.4529 7.39931 14.373 7.36458 14.2855C7.32986 14.198 7.3125 14.1042 7.3125 14.0042C7.3125 13.9042 7.32986 13.8105 7.36458 13.723C7.39931 13.6355 7.45139 13.5542 7.52083 13.4792L10.8542 10.1459C11.0069 9.99314 11.184 9.91675 11.3854 9.91675C11.5868 9.91675 11.7639 9.99314 11.9167 10.1459C12.0694 10.2987 12.1458 10.4758 12.1458 10.6772C12.1458 10.8786 12.0694 11.0556 11.9167 11.2084L9.875 13.2501H19.5V11.7501C19.5 11.5376 19.5715 11.3595 19.7144 11.2157C19.8573 11.072 20.0344 11.0001 20.2456 11.0001C20.4569 11.0001 20.6354 11.072 20.7812 11.2157C20.9271 11.3595 21 11.5376 21 11.7501V13.2501C21 13.6626 20.8531 14.0157 20.5594 14.3095C20.2656 14.6032 19.9125 14.7501 19.5 14.7501H9.875Z",
          fill: "#181B1F"
        }
      ) })
    ]
  }
);
/*! @license DOMPurify 3.2.7 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.7/LICENSE */
const {
  entries: Q_,
  setPrototypeOf: hg,
  isFrozen: EV,
  getPrototypeOf: _V,
  getOwnPropertyDescriptor: OV
} = Object;
let {
  freeze: Fn,
  seal: Mr,
  create: J_
} = Object, {
  apply: g9,
  construct: C9
} = typeof Reflect < "u" && Reflect;
Fn || (Fn = function(t) {
  return t;
});
Mr || (Mr = function(t) {
  return t;
});
g9 || (g9 = function(t, n) {
  for (var r = arguments.length, o = new Array(r > 2 ? r - 2 : 0), i = 2; i < r; i++)
    o[i - 2] = arguments[i];
  return t.apply(n, o);
});
C9 || (C9 = function(t) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
    r[o - 1] = arguments[o];
  return new t(...r);
});
const tc = Vn(Array.prototype.forEach), AV = Vn(Array.prototype.lastIndexOf), pg = Vn(Array.prototype.pop), Ls = Vn(Array.prototype.push), PV = Vn(Array.prototype.splice), $c = Vn(String.prototype.toLowerCase), n7 = Vn(String.prototype.toString), r7 = Vn(String.prototype.match), Ns = Vn(String.prototype.replace), TV = Vn(String.prototype.indexOf), IV = Vn(String.prototype.trim), Rr = Vn(Object.prototype.hasOwnProperty), Dn = Vn(RegExp.prototype.test), Fs = DV(TypeError);
function Vn(e) {
  return function(t) {
    t instanceof RegExp && (t.lastIndex = 0);
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
      r[o - 1] = arguments[o];
    return g9(e, t, r);
  };
}
function DV(e) {
  return function() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return C9(e, n);
  };
}
function Ge(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $c;
  hg && hg(e, null);
  let r = t.length;
  for (; r--; ) {
    let o = t[r];
    if (typeof o == "string") {
      const i = n(o);
      i !== o && (EV(t) || (t[r] = i), o = i);
    }
    e[o] = !0;
  }
  return e;
}
function RV(e) {
  for (let t = 0; t < e.length; t++)
    Rr(e, t) || (e[t] = null);
  return e;
}
function Ro(e) {
  const t = J_(null);
  for (const [n, r] of Q_(e))
    Rr(e, n) && (Array.isArray(r) ? t[n] = RV(r) : r && typeof r == "object" && r.constructor === Object ? t[n] = Ro(r) : t[n] = r);
  return t;
}
function Vs(e, t) {
  for (; e !== null; ) {
    const r = OV(e, t);
    if (r) {
      if (r.get)
        return Vn(r.get);
      if (typeof r.value == "function")
        return Vn(r.value);
    }
    e = _V(e);
  }
  function n() {
    return null;
  }
  return n;
}
const mg = Fn(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), o7 = Fn(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "slot", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), i7 = Fn(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), kV = Fn(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), a7 = Fn(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), LV = Fn(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), gg = Fn(["#text"]), Cg = Fn(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), s7 = Fn(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), vg = Fn(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), nc = Fn(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), NV = Mr(/\{\{[\w\W]*|[\w\W]*\}\}/gm), FV = Mr(/<%[\w\W]*|[\w\W]*%>/gm), VV = Mr(/\$\{[\w\W]*/gm), BV = Mr(/^data-[\-\w.\u00B7-\uFFFF]+$/), $V = Mr(/^aria-[\-\w]+$/), eO = Mr(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), jV = Mr(/^(?:\w+script|data):/i), HV = Mr(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), tO = Mr(/^html$/i), zV = Mr(/^[a-z][.\w]*(-[.\w]+)+$/i);
var yg = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: $V,
  ATTR_WHITESPACE: HV,
  CUSTOM_ELEMENT: zV,
  DATA_ATTR: BV,
  DOCTYPE_NAME: tO,
  ERB_EXPR: FV,
  IS_ALLOWED_URI: eO,
  IS_SCRIPT_OR_DATA: jV,
  MUSTACHE_EXPR: NV,
  TMPLIT_EXPR: VV
});
const Bs = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, ZV = function() {
  return typeof window > "u" ? null : window;
}, WV = function(t, n) {
  if (typeof t != "object" || typeof t.createPolicy != "function")
    return null;
  let r = null;
  const o = "data-tt-policy-suffix";
  n && n.hasAttribute(o) && (r = n.getAttribute(o));
  const i = "dompurify" + (r ? "#" + r : "");
  try {
    return t.createPolicy(i, {
      createHTML(a) {
        return a;
      },
      createScriptURL(a) {
        return a;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + i + " could not be created."), null;
  }
}, bg = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function nO() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ZV();
  const t = (Ee) => nO(Ee);
  if (t.version = "3.2.7", t.removed = [], !e || !e.document || e.document.nodeType !== Bs.document || !e.Element)
    return t.isSupported = !1, t;
  let {
    document: n
  } = e;
  const r = n, o = r.currentScript, {
    DocumentFragment: i,
    HTMLTemplateElement: a,
    Node: s,
    Element: l,
    NodeFilter: c,
    NamedNodeMap: u = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: f,
    DOMParser: h,
    trustedTypes: p
  } = e, C = l.prototype, m = Vs(C, "cloneNode"), g = Vs(C, "remove"), v = Vs(C, "nextSibling"), y = Vs(C, "childNodes"), w = Vs(C, "parentNode");
  if (typeof a == "function") {
    const Ee = n.createElement("template");
    Ee.content && Ee.content.ownerDocument && (n = Ee.content.ownerDocument);
  }
  let x, b = "";
  const {
    implementation: S,
    createNodeIterator: M,
    createDocumentFragment: E,
    getElementsByTagName: P
  } = n, {
    importNode: T
  } = r;
  let _ = bg();
  t.isSupported = typeof Q_ == "function" && typeof w == "function" && S && S.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: D,
    ERB_EXPR: N,
    TMPLIT_EXPR: R,
    DATA_ATTR: L,
    ARIA_ATTR: B,
    IS_SCRIPT_OR_DATA: V,
    ATTR_WHITESPACE: k,
    CUSTOM_ELEMENT: z
  } = yg;
  let {
    IS_ALLOWED_URI: $
  } = yg, Z = null;
  const W = Ge({}, [...mg, ...o7, ...i7, ...a7, ...gg]);
  let H = null;
  const G = Ge({}, [...Cg, ...s7, ...vg, ...nc]);
  let Y = Object.seal(J_(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), ne = null, J = null, ee = !0, U = !0, X = !1, ie = !0, j = !1, te = !0, K = !1, me = !1, we = !1, ye = !1, Ze = !1, Ue = !1, Ke = !0, ft = !1;
  const fe = "user-content-";
  let ge = !0, pe = !1, De = {}, xe = null;
  const He = Ge({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let pn = null;
  const Ce = Ge({}, ["audio", "video", "img", "source", "image", "track"]);
  let Le = null;
  const wt = Ge({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), rn = "http://www.w3.org/1998/Math/MathML", Pr = "http://www.w3.org/2000/svg", Bn = "http://www.w3.org/1999/xhtml";
  let Tr = Bn, Ir = !1, $n = null;
  const Fe = Ge({}, [rn, Pr, Bn], n7);
  let tt = Ge({}, ["mi", "mo", "mn", "ms", "mtext"]), Te = Ge({}, ["annotation-xml"]);
  const nt = Ge({}, ["title", "style", "font", "a", "script"]);
  let on = null;
  const Qe = ["application/xhtml+xml", "text/html"], B0 = "text/html";
  let Gt = null, o1 = null;
  const Ds = n.createElement("form"), Wi = function(q) {
    return q instanceof RegExp || q instanceof Function;
  }, $0 = function() {
    let q = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(o1 && o1 === q)) {
      if ((!q || typeof q != "object") && (q = {}), q = Ro(q), on = // eslint-disable-next-line unicorn/prefer-includes
      Qe.indexOf(q.PARSER_MEDIA_TYPE) === -1 ? B0 : q.PARSER_MEDIA_TYPE, Gt = on === "application/xhtml+xml" ? n7 : $c, Z = Rr(q, "ALLOWED_TAGS") ? Ge({}, q.ALLOWED_TAGS, Gt) : W, H = Rr(q, "ALLOWED_ATTR") ? Ge({}, q.ALLOWED_ATTR, Gt) : G, $n = Rr(q, "ALLOWED_NAMESPACES") ? Ge({}, q.ALLOWED_NAMESPACES, n7) : Fe, Le = Rr(q, "ADD_URI_SAFE_ATTR") ? Ge(Ro(wt), q.ADD_URI_SAFE_ATTR, Gt) : wt, pn = Rr(q, "ADD_DATA_URI_TAGS") ? Ge(Ro(Ce), q.ADD_DATA_URI_TAGS, Gt) : Ce, xe = Rr(q, "FORBID_CONTENTS") ? Ge({}, q.FORBID_CONTENTS, Gt) : He, ne = Rr(q, "FORBID_TAGS") ? Ge({}, q.FORBID_TAGS, Gt) : Ro({}), J = Rr(q, "FORBID_ATTR") ? Ge({}, q.FORBID_ATTR, Gt) : Ro({}), De = Rr(q, "USE_PROFILES") ? q.USE_PROFILES : !1, ee = q.ALLOW_ARIA_ATTR !== !1, U = q.ALLOW_DATA_ATTR !== !1, X = q.ALLOW_UNKNOWN_PROTOCOLS || !1, ie = q.ALLOW_SELF_CLOSE_IN_ATTR !== !1, j = q.SAFE_FOR_TEMPLATES || !1, te = q.SAFE_FOR_XML !== !1, K = q.WHOLE_DOCUMENT || !1, ye = q.RETURN_DOM || !1, Ze = q.RETURN_DOM_FRAGMENT || !1, Ue = q.RETURN_TRUSTED_TYPE || !1, we = q.FORCE_BODY || !1, Ke = q.SANITIZE_DOM !== !1, ft = q.SANITIZE_NAMED_PROPS || !1, ge = q.KEEP_CONTENT !== !1, pe = q.IN_PLACE || !1, $ = q.ALLOWED_URI_REGEXP || eO, Tr = q.NAMESPACE || Bn, tt = q.MATHML_TEXT_INTEGRATION_POINTS || tt, Te = q.HTML_INTEGRATION_POINTS || Te, Y = q.CUSTOM_ELEMENT_HANDLING || {}, q.CUSTOM_ELEMENT_HANDLING && Wi(q.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (Y.tagNameCheck = q.CUSTOM_ELEMENT_HANDLING.tagNameCheck), q.CUSTOM_ELEMENT_HANDLING && Wi(q.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (Y.attributeNameCheck = q.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), q.CUSTOM_ELEMENT_HANDLING && typeof q.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (Y.allowCustomizedBuiltInElements = q.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), j && (U = !1), Ze && (ye = !0), De && (Z = Ge({}, gg), H = [], De.html === !0 && (Ge(Z, mg), Ge(H, Cg)), De.svg === !0 && (Ge(Z, o7), Ge(H, s7), Ge(H, nc)), De.svgFilters === !0 && (Ge(Z, i7), Ge(H, s7), Ge(H, nc)), De.mathMl === !0 && (Ge(Z, a7), Ge(H, vg), Ge(H, nc))), q.ADD_TAGS && (Z === W && (Z = Ro(Z)), Ge(Z, q.ADD_TAGS, Gt)), q.ADD_ATTR && (H === G && (H = Ro(H)), Ge(H, q.ADD_ATTR, Gt)), q.ADD_URI_SAFE_ATTR && Ge(Le, q.ADD_URI_SAFE_ATTR, Gt), q.FORBID_CONTENTS && (xe === He && (xe = Ro(xe)), Ge(xe, q.FORBID_CONTENTS, Gt)), ge && (Z["#text"] = !0), K && Ge(Z, ["html", "head", "body"]), Z.table && (Ge(Z, ["tbody"]), delete ne.tbody), q.TRUSTED_TYPES_POLICY) {
        if (typeof q.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw Fs('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof q.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw Fs('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        x = q.TRUSTED_TYPES_POLICY, b = x.createHTML("");
      } else
        x === void 0 && (x = WV(p, o)), x !== null && typeof b == "string" && (b = x.createHTML(""));
      Fn && Fn(q), o1 = q;
    }
  }, pm = Ge({}, [...o7, ...i7, ...kV]), mm = Ge({}, [...a7, ...LV]), pL = function(q) {
    let de = w(q);
    (!de || !de.tagName) && (de = {
      namespaceURI: Tr,
      tagName: "template"
    });
    const Se = $c(q.tagName), At = $c(de.tagName);
    return $n[q.namespaceURI] ? q.namespaceURI === Pr ? de.namespaceURI === Bn ? Se === "svg" : de.namespaceURI === rn ? Se === "svg" && (At === "annotation-xml" || tt[At]) : !!pm[Se] : q.namespaceURI === rn ? de.namespaceURI === Bn ? Se === "math" : de.namespaceURI === Pr ? Se === "math" && Te[At] : !!mm[Se] : q.namespaceURI === Bn ? de.namespaceURI === Pr && !Te[At] || de.namespaceURI === rn && !tt[At] ? !1 : !mm[Se] && (nt[Se] || !pm[Se]) : !!(on === "application/xhtml+xml" && $n[q.namespaceURI]) : !1;
  }, Yr = function(q) {
    Ls(t.removed, {
      element: q
    });
    try {
      w(q).removeChild(q);
    } catch {
      g(q);
    }
  }, Z1 = function(q, de) {
    try {
      Ls(t.removed, {
        attribute: de.getAttributeNode(q),
        from: de
      });
    } catch {
      Ls(t.removed, {
        attribute: null,
        from: de
      });
    }
    if (de.removeAttribute(q), q === "is")
      if (ye || Ze)
        try {
          Yr(de);
        } catch {
        }
      else
        try {
          de.setAttribute(q, "");
        } catch {
        }
  }, gm = function(q) {
    let de = null, Se = null;
    if (we)
      q = "<remove></remove>" + q;
    else {
      const Kt = r7(q, /^[\r\n\t ]+/);
      Se = Kt && Kt[0];
    }
    on === "application/xhtml+xml" && Tr === Bn && (q = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + q + "</body></html>");
    const At = x ? x.createHTML(q) : q;
    if (Tr === Bn)
      try {
        de = new h().parseFromString(At, on);
      } catch {
      }
    if (!de || !de.documentElement) {
      de = S.createDocument(Tr, "template", null);
      try {
        de.documentElement.innerHTML = Ir ? b : At;
      } catch {
      }
    }
    const En = de.body || de.documentElement;
    return q && Se && En.insertBefore(n.createTextNode(Se), En.childNodes[0] || null), Tr === Bn ? P.call(de, K ? "html" : "body")[0] : K ? de.documentElement : En;
  }, Cm = function(q) {
    return M.call(
      q.ownerDocument || q,
      q,
      // eslint-disable-next-line no-bitwise
      c.SHOW_ELEMENT | c.SHOW_COMMENT | c.SHOW_TEXT | c.SHOW_PROCESSING_INSTRUCTION | c.SHOW_CDATA_SECTION,
      null
    );
  }, j0 = function(q) {
    return q instanceof f && (typeof q.nodeName != "string" || typeof q.textContent != "string" || typeof q.removeChild != "function" || !(q.attributes instanceof u) || typeof q.removeAttribute != "function" || typeof q.setAttribute != "function" || typeof q.namespaceURI != "string" || typeof q.insertBefore != "function" || typeof q.hasChildNodes != "function");
  }, vm = function(q) {
    return typeof s == "function" && q instanceof s;
  };
  function Ao(Ee, q, de) {
    tc(Ee, (Se) => {
      Se.call(t, q, de, o1);
    });
  }
  const ym = function(q) {
    let de = null;
    if (Ao(_.beforeSanitizeElements, q, null), j0(q))
      return Yr(q), !0;
    const Se = Gt(q.nodeName);
    if (Ao(_.uponSanitizeElement, q, {
      tagName: Se,
      allowedTags: Z
    }), te && q.hasChildNodes() && !vm(q.firstElementChild) && Dn(/<[/\w!]/g, q.innerHTML) && Dn(/<[/\w!]/g, q.textContent) || q.nodeType === Bs.progressingInstruction || te && q.nodeType === Bs.comment && Dn(/<[/\w]/g, q.data))
      return Yr(q), !0;
    if (!Z[Se] || ne[Se]) {
      if (!ne[Se] && wm(Se) && (Y.tagNameCheck instanceof RegExp && Dn(Y.tagNameCheck, Se) || Y.tagNameCheck instanceof Function && Y.tagNameCheck(Se)))
        return !1;
      if (ge && !xe[Se]) {
        const At = w(q) || q.parentNode, En = y(q) || q.childNodes;
        if (En && At) {
          const Kt = En.length;
          for (let jn = Kt - 1; jn >= 0; --jn) {
            const Po = m(En[jn], !0);
            Po.__removalCount = (q.__removalCount || 0) + 1, At.insertBefore(Po, v(q));
          }
        }
      }
      return Yr(q), !0;
    }
    return q instanceof l && !pL(q) || (Se === "noscript" || Se === "noembed" || Se === "noframes") && Dn(/<\/no(script|embed|frames)/i, q.innerHTML) ? (Yr(q), !0) : (j && q.nodeType === Bs.text && (de = q.textContent, tc([D, N, R], (At) => {
      de = Ns(de, At, " ");
    }), q.textContent !== de && (Ls(t.removed, {
      element: q.cloneNode()
    }), q.textContent = de)), Ao(_.afterSanitizeElements, q, null), !1);
  }, bm = function(q, de, Se) {
    if (Ke && (de === "id" || de === "name") && (Se in n || Se in Ds))
      return !1;
    if (!(U && !J[de] && Dn(L, de))) {
      if (!(ee && Dn(B, de))) {
        if (!H[de] || J[de]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(wm(q) && (Y.tagNameCheck instanceof RegExp && Dn(Y.tagNameCheck, q) || Y.tagNameCheck instanceof Function && Y.tagNameCheck(q)) && (Y.attributeNameCheck instanceof RegExp && Dn(Y.attributeNameCheck, de) || Y.attributeNameCheck instanceof Function && Y.attributeNameCheck(de, q)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            de === "is" && Y.allowCustomizedBuiltInElements && (Y.tagNameCheck instanceof RegExp && Dn(Y.tagNameCheck, Se) || Y.tagNameCheck instanceof Function && Y.tagNameCheck(Se)))
          ) return !1;
        } else if (!Le[de]) {
          if (!Dn($, Ns(Se, k, ""))) {
            if (!((de === "src" || de === "xlink:href" || de === "href") && q !== "script" && TV(Se, "data:") === 0 && pn[q])) {
              if (!(X && !Dn(V, Ns(Se, k, "")))) {
                if (Se)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, wm = function(q) {
    return q !== "annotation-xml" && r7(q, z);
  }, xm = function(q) {
    Ao(_.beforeSanitizeAttributes, q, null);
    const {
      attributes: de
    } = q;
    if (!de || j0(q))
      return;
    const Se = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: H,
      forceKeepAttr: void 0
    };
    let At = de.length;
    for (; At--; ) {
      const En = de[At], {
        name: Kt,
        namespaceURI: jn,
        value: Po
      } = En, qi = Gt(Kt), H0 = Po;
      let mn = Kt === "value" ? H0 : IV(H0);
      if (Se.attrName = qi, Se.attrValue = mn, Se.keepAttr = !0, Se.forceKeepAttr = void 0, Ao(_.uponSanitizeAttribute, q, Se), mn = Se.attrValue, ft && (qi === "id" || qi === "name") && (Z1(Kt, q), mn = fe + mn), te && Dn(/((--!?|])>)|<\/(style|title|textarea)/i, mn)) {
        Z1(Kt, q);
        continue;
      }
      if (qi === "attributename" && r7(mn, "href")) {
        Z1(Kt, q);
        continue;
      }
      if (Se.forceKeepAttr)
        continue;
      if (!Se.keepAttr) {
        Z1(Kt, q);
        continue;
      }
      if (!ie && Dn(/\/>/i, mn)) {
        Z1(Kt, q);
        continue;
      }
      j && tc([D, N, R], (Mm) => {
        mn = Ns(mn, Mm, " ");
      });
      const Sm = Gt(q.nodeName);
      if (!bm(Sm, qi, mn)) {
        Z1(Kt, q);
        continue;
      }
      if (x && typeof p == "object" && typeof p.getAttributeType == "function" && !jn)
        switch (p.getAttributeType(Sm, qi)) {
          case "TrustedHTML": {
            mn = x.createHTML(mn);
            break;
          }
          case "TrustedScriptURL": {
            mn = x.createScriptURL(mn);
            break;
          }
        }
      if (mn !== H0)
        try {
          jn ? q.setAttributeNS(jn, Kt, mn) : q.setAttribute(Kt, mn), j0(q) ? Yr(q) : pg(t.removed);
        } catch {
          Z1(Kt, q);
        }
    }
    Ao(_.afterSanitizeAttributes, q, null);
  }, mL = function Ee(q) {
    let de = null;
    const Se = Cm(q);
    for (Ao(_.beforeSanitizeShadowDOM, q, null); de = Se.nextNode(); )
      Ao(_.uponSanitizeShadowNode, de, null), ym(de), xm(de), de.content instanceof i && Ee(de.content);
    Ao(_.afterSanitizeShadowDOM, q, null);
  };
  return t.sanitize = function(Ee) {
    let q = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, de = null, Se = null, At = null, En = null;
    if (Ir = !Ee, Ir && (Ee = "<!-->"), typeof Ee != "string" && !vm(Ee))
      if (typeof Ee.toString == "function") {
        if (Ee = Ee.toString(), typeof Ee != "string")
          throw Fs("dirty is not a string, aborting");
      } else
        throw Fs("toString is not a function");
    if (!t.isSupported)
      return Ee;
    if (me || $0(q), t.removed = [], typeof Ee == "string" && (pe = !1), pe) {
      if (Ee.nodeName) {
        const Po = Gt(Ee.nodeName);
        if (!Z[Po] || ne[Po])
          throw Fs("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (Ee instanceof s)
      de = gm("<!---->"), Se = de.ownerDocument.importNode(Ee, !0), Se.nodeType === Bs.element && Se.nodeName === "BODY" || Se.nodeName === "HTML" ? de = Se : de.appendChild(Se);
    else {
      if (!ye && !j && !K && // eslint-disable-next-line unicorn/prefer-includes
      Ee.indexOf("<") === -1)
        return x && Ue ? x.createHTML(Ee) : Ee;
      if (de = gm(Ee), !de)
        return ye ? null : Ue ? b : "";
    }
    de && we && Yr(de.firstChild);
    const Kt = Cm(pe ? Ee : de);
    for (; At = Kt.nextNode(); )
      ym(At), xm(At), At.content instanceof i && mL(At.content);
    if (pe)
      return Ee;
    if (ye) {
      if (Ze)
        for (En = E.call(de.ownerDocument); de.firstChild; )
          En.appendChild(de.firstChild);
      else
        En = de;
      return (H.shadowroot || H.shadowrootmode) && (En = T.call(r, En, !0)), En;
    }
    let jn = K ? de.outerHTML : de.innerHTML;
    return K && Z["!doctype"] && de.ownerDocument && de.ownerDocument.doctype && de.ownerDocument.doctype.name && Dn(tO, de.ownerDocument.doctype.name) && (jn = "<!DOCTYPE " + de.ownerDocument.doctype.name + `>
` + jn), j && tc([D, N, R], (Po) => {
      jn = Ns(jn, Po, " ");
    }), x && Ue ? x.createHTML(jn) : jn;
  }, t.setConfig = function() {
    let Ee = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    $0(Ee), me = !0;
  }, t.clearConfig = function() {
    o1 = null, me = !1;
  }, t.isValidAttribute = function(Ee, q, de) {
    o1 || $0({});
    const Se = Gt(Ee), At = Gt(q);
    return bm(Se, At, de);
  }, t.addHook = function(Ee, q) {
    typeof q == "function" && Ls(_[Ee], q);
  }, t.removeHook = function(Ee, q) {
    if (q !== void 0) {
      const de = AV(_[Ee], q);
      return de === -1 ? void 0 : PV(_[Ee], de, 1)[0];
    }
    return pg(_[Ee]);
  }, t.removeHooks = function(Ee) {
    _[Ee] = [];
  }, t.removeAllHooks = function() {
    _ = bg();
  }, t;
}
var qV = nO();
function UV(e) {
  return { __html: qV.sanitize(e) };
}
const GV = O.forwardRef(
  ({ label: e, subtitle: t, highlights: n, ariaLabel: r, chip: o, icon: i, onClick: a, options: s }, l) => {
    const { registerItemId: c, unregisterItemId: u, activeId: f } = La(), h = {
      renderHighlightsAsHtml: !1,
      lineClampHighlights: "line-clamp-3",
      lineClampSubtitle: "line-clamp-1",
      takeHighlights: 1,
      takeHighlightsValues: 1,
      ...s
    }, { handleClose: p } = La(), C = bt(), m = ke(null), g = r || e, v = f === C;
    ve(() => {
      if (!v) return;
      const _ = m.current;
      _ && _?.scrollIntoView({
        block: "nearest",
        behavior: "smooth"
      });
    }, [v]);
    const y = I(
      "flex cursor-pointer items-center justify-between gap-sm rounded-[12px] p-sm sm:p-md",
      "transition-colors ease-in-out",
      "bg-surface-common-subtle hover:bg-surface-common-light",
      "active:outline active:outline-2 active:outline-surface-common-primary",
      "focus-visibile:outline-2 focus-visible:bg-surface-common-light focus-visible:outline focus-visible:outline-surface-common-primary",
      v && "bg-surface-common-light outline outline-2 outline-surface-common-primary"
    ), w = ct(
      (_) => {
        a?.(_), p();
      },
      [a, p]
    );
    ve(() => (c(C), () => u(C)), [f, C, c, u]), ve(() => {
      const _ = m.current;
      if (!v || !_) return;
      const D = (N) => {
        N.key === "Enter" && w(N);
      };
      return window.addEventListener("keydown", D), () => {
        window.removeEventListener("keydown", D);
      };
    }, [v, m, w]), Ad(l, () => m.current);
    const x = (_) => {
      _.preventDefault(), _.key === "Enter" && (a?.(_), p());
    }, b = bt(), S = bt(), M = () => {
      if (!t) return null;
      const _ = I(
        "pointer-events-none line-clamp-1 max-w-[20ch] cursor-pointer gap-sm break-words text-left sm:max-w-[45ch] sm:!text-paragraph",
        h.lineClampSubtitle
      );
      return /* @__PURE__ */ d("div", { id: b, className: _, children: t });
    }, E = () => {
      if (!n?.length) return null;
      const _ = I(
        "pointer-events-none line-clamp-1 max-w-[25ch] cursor-pointer gap-sm break-words text-left sm:max-w-[45ch] sm:!text-paragraph",
        h.lineClampHighlights
      ), D = h.takeHighlights || n?.length, N = n?.slice(0, D);
      return h.renderHighlightsAsHtml ? /* @__PURE__ */ d("div", { id: S, className: _, tabIndex: -1, children: N.map((R, L) => {
        const B = h.takeHighlightsValues || R?.value?.length, V = R?.value?.slice(
          0,
          B
        );
        return /* @__PURE__ */ d(vu, { children: V?.map((k, z) => /* @__PURE__ */ d(
          "div",
          {
            "aria-label": `${R.key}: ${k}`,
            className: "pointer-events-none max-w-[25ch] cursor-pointer gap-sm truncate break-words text-left text-neutral-700 sm:max-w-[45ch]",
            dangerouslySetInnerHTML: UV(k)
          },
          z
        )) }, R?.key || L);
      }) }) : /* @__PURE__ */ d(
        "div",
        {
          id: S,
          className: "pointer-events-none flex cursor-pointer gap-sm",
          tabIndex: -1,
          children: n.map((R) => /* @__PURE__ */ d(
            Ut,
            {
              className: "line-clamp-1 break-words text-left text-text-primary sm:!text-paragraph",
              children: R.value
            },
            R.key
          ))
        }
      );
    }, P = () => i ? /* @__PURE__ */ d("div", { className: "flex items-center justify-center", children: i }) : null;
    return /* @__PURE__ */ d(
      "li",
      {
        ref: m,
        id: C,
        className: y,
        "aria-label": g,
        "aria-selected": v,
        "aria-describedby": (() => {
          const _ = [];
          return t && _.push(b), n?.length && _.push(S), _.join(" ");
        })(),
        role: "option",
        onKeyDown: x,
        tabIndex: 1,
        children: /* @__PURE__ */ F(
          "button",
          {
            tabIndex: -1,
            onClick: w,
            className: "flex w-full cursor-pointer items-center gap-[12px] border-none bg-transparent p-0 outline-none",
            children: [
              /* @__PURE__ */ F("div", { className: "flex w-full items-center gap-[12px]", children: [
                /* @__PURE__ */ d(P, {}),
                /* @__PURE__ */ F("div", { className: "flex w-full max-w-[20ch] flex-col items-start justify-start sm:max-w-[35ch]", children: [
                  /* @__PURE__ */ d(Ut, { className: "pointer-events-none break-words text-left font-semibold text-text-primary sm:!text-label", children: e }),
                  /* @__PURE__ */ d(M, {}),
                  /* @__PURE__ */ d(E, {})
                ] })
              ] }),
              /* @__PURE__ */ F("div", { className: "hidden flex-1 items-center gap-md md:flex", children: [
                /* @__PURE__ */ d("div", { className: "hidden items-center justify-center md:flex", children: v && /* @__PURE__ */ d(ti, { icon: /* @__PURE__ */ d(X_, {}), title: "Enter" }) }),
                o && o,
                /* @__PURE__ */ d(yo, { colorVariant: "primary" })
              ] })
            ]
          }
        )
      }
    );
  }
), Ye = ({
  variant: e = "paragraph",
  weight: t = "normal",
  align: n = "left",
  color: r = "normal",
  primary: o,
  secondary: i,
  title: a,
  onClick: s,
  children: l,
  dark: c,
  italic: u,
  wordBreak: f,
  whiteSpace: h,
  lineClamp: p,
  subtle: C,
  ...m
}) => {
  const g = e === "paragraph" ? "p" : "span", v = {
    lead: I("text-lead-mobile sm:text-lead"),
    paragraph: I("m-0 text-paragraph-mobile sm:text-paragraph"),
    small: I("text-small-mobile sm:text-small")
  }, y = {
    bold: "font-bold",
    semibold: "font-semibold",
    normal: "font-normal"
  }, w = {
    left: "text-left",
    center: "text-center",
    right: "text-right"
  }, x = I(
    "text-text-brand",
    v[e],
    y[t],
    w[n],
    u && "italic",
    o && "text-primary-900",
    i && "text-primary-500",
    c && "text-neutral-0",
    C && "text-neutral-500",
    f && f === "break-word" ? "break-words" : f,
    h && `whitespace-${h}`,
    p && `line-clamp-${p}`,
    r && r
  );
  return /* @__PURE__ */ d(g, { className: x, onClick: s, title: a, ...m, children: l });
}, KV = () => /* @__PURE__ */ F(
  "svg",
  {
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ d(
        "rect",
        {
          x: "0.25",
          y: "0.25",
          width: "27.5",
          height: "27.5",
          rx: "5.75",
          fill: "white"
        }
      ),
      /* @__PURE__ */ d(
        "rect",
        {
          x: "0.25",
          y: "0.25",
          width: "27.5",
          height: "27.5",
          rx: "5.75",
          stroke: "#DEE0E4",
          strokeWidth: "0.5"
        }
      ),
      /* @__PURE__ */ d(
        "mask",
        {
          id: "mask0_1642_1687",
          maskUnits: "userSpaceOnUse",
          x: "4",
          y: "4",
          width: "20",
          height: "20",
          children: /* @__PURE__ */ d("rect", { x: "4", y: "4", width: "20", height: "20", fill: "#D9D9D9" })
        }
      ),
      /* @__PURE__ */ d("g", { mask: "url(#mask0_1642_1687)", children: /* @__PURE__ */ d(
        "path",
        {
          d: "M13.9958 16.7501C13.8958 16.7501 13.8021 16.7327 13.7146 16.698C13.6271 16.6633 13.5486 16.6112 13.4792 16.5417L9.52791 12.5905C9.37041 12.433 9.29513 12.2536 9.30208 12.0522C9.30902 11.8508 9.38888 11.6737 9.54166 11.5209C9.69444 11.3681 9.87152 11.2917 10.0729 11.2917C10.2743 11.2917 10.4514 11.3681 10.6042 11.5209L14 14.9376L17.4167 11.5209C17.5694 11.3681 17.7465 11.2952 17.9479 11.3022C18.1493 11.3091 18.3264 11.389 18.4792 11.5417C18.6319 11.6945 18.7083 11.8716 18.7083 12.073C18.7083 12.2744 18.6296 12.4534 18.4721 12.6101L14.5208 16.5417C14.4458 16.6112 14.3646 16.6633 14.2771 16.698C14.1896 16.7327 14.0958 16.7501 13.9958 16.7501Z",
          fill: "#181B1F"
        }
      ) })
    ]
  }
), YV = () => /* @__PURE__ */ F(
  "svg",
  {
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ d(
        "rect",
        {
          x: "0.25",
          y: "0.25",
          width: "27.5",
          height: "27.5",
          rx: "5.75",
          fill: "white"
        }
      ),
      /* @__PURE__ */ d(
        "rect",
        {
          x: "0.25",
          y: "0.25",
          width: "27.5",
          height: "27.5",
          rx: "5.75",
          stroke: "#DEE0E4",
          strokeWidth: "0.5"
        }
      ),
      /* @__PURE__ */ d(
        "mask",
        {
          id: "mask0_1642_1685",
          maskUnits: "userSpaceOnUse",
          x: "4",
          y: "4",
          width: "20",
          height: "20",
          children: /* @__PURE__ */ d("rect", { x: "4", y: "4", width: "20", height: "20", fill: "#D9D9D9" })
        }
      ),
      /* @__PURE__ */ d("g", { mask: "url(#mask0_1642_1685)", children: /* @__PURE__ */ d(
        "path",
        {
          d: "M14 13.0625L10.5833 16.4792C10.4305 16.6319 10.2534 16.7083 10.052 16.7083C9.85065 16.7083 9.67357 16.6319 9.52079 16.4792C9.36801 16.3264 9.29163 16.1493 9.29163 15.9479C9.29163 15.7465 9.36801 15.5694 9.52079 15.4167L13.4791 11.4583C13.5486 11.3889 13.6284 11.3368 13.7187 11.3021C13.809 11.2674 13.9027 11.25 14 11.25C14.0972 11.25 14.1909 11.2674 14.2812 11.3021C14.3715 11.3368 14.4513 11.3889 14.5208 11.4583L18.4791 15.4167C18.6319 15.5694 18.7083 15.7431 18.7083 15.9375C18.7083 16.1319 18.6319 16.3056 18.4791 16.4583C18.3263 16.6111 18.1493 16.6875 17.9479 16.6875C17.7465 16.6875 17.5694 16.6111 17.4166 16.4583L14 13.0625Z",
          fill: "#181B1F"
        }
      ) })
    ]
  }
), l7 = ({ children: e }) => /* @__PURE__ */ d("div", { className: "flex items-center gap-sm", children: e }), XV = () => /* @__PURE__ */ F("div", { className: "hidden items-center justify-between border-t-[1px] border-neutral-200 bg-white p-lg sm:flex", children: [
  /* @__PURE__ */ F(l7, { children: [
    /* @__PURE__ */ d(ti, { icon: /* @__PURE__ */ d(YV, {}), title: "Up" }),
    /* @__PURE__ */ d(ti, { icon: /* @__PURE__ */ d(KV, {}), title: "Down" }),
    /* @__PURE__ */ d(Ye, { variant: "small", children: "Navigere" })
  ] }),
  /* @__PURE__ */ F("div", { className: "flex gap-md", children: [
    /* @__PURE__ */ F(l7, { children: [
      /* @__PURE__ */ d(ti, { icon: /* @__PURE__ */ d(X_, {}), title: "Enter" }),
      /* @__PURE__ */ d(Ye, { variant: "small", children: "Gå til" })
    ] }),
    /* @__PURE__ */ F(l7, { children: [
      /* @__PURE__ */ d(ti, { icon: /* @__PURE__ */ d(Y_, {}), title: "Escape" }),
      /* @__PURE__ */ d(Ye, { variant: "small", children: "Lukk" })
    ] })
  ] })
] }), QV = O.forwardRef(
  ({ children: e }, t) => {
    const { setListType: n } = La();
    return ve(() => {
      n("result");
    }, []), e ? /* @__PURE__ */ d(
      "ul",
      {
        ref: t,
        role: "listbox",
        className: "flex flex-col gap-half overflow-y-auto p-md scrollbar-none sm:gap-sm sm:p-lg",
        children: e
      }
    ) : null;
  }
), Rt = Xe(
  function({
    className: t,
    size: n = "default",
    color: r = "default",
    weight: o = "normal",
    lineClamp: i,
    truncate: a = !1,
    maxWidth: s,
    ...l
  }, c) {
    const f = {
      bold: "font-bold",
      semibold: "font-semibold",
      normal: "font-normal"
    }, h = {
      default: I("text-text-primary"),
      brand: I("text-text-brand"),
      subtle: I("text-neutral-600"),
      invert: I("text-text-invert")
    }, p = I(
      "text-paragraph-mobile font-normal leading-normal text-text-brand sm:text-paragraph",
      n === "small" && "text-small-mobile sm:text-small",
      r && h[r],
      o && f[o],
      a && "max-w-[50ch] truncate break-words",
      s && `max-w-[${s}]`,
      i && `line-clamp-${i} `,
      t
    );
    return /* @__PURE__ */ d("p", { ref: c, className: p, ...l });
  }
), JV = O.forwardRef(
  ({ item: e, handleClear: t, handleClick: n }, r) => {
    const { registerItemId: o, unregisterItemId: i, activeId: a } = La(), s = bt(), l = O.useRef(null), c = Mo([r, l]), u = a === s, f = I(
      "group flex cursor-pointer items-center justify-between self-stretch px-lg py-md",
      "hover:bg-surface-common-subtle hover:text-surface-common-primary",
      "focus:border-none focus:bg-surface-common-subtle focus:text-surface-common-primary focus:outline-none focus:ring-0",
      u && "bg-surface-common-subtle text-surface-common-primary"
    );
    ve(() => {
      if (!u || !l.current) return;
      const p = (C) => {
        C.key === "Enter" && n(e);
      };
      return window.addEventListener("keydown", p), () => {
        window.removeEventListener("keydown", p);
      };
    }, [u, l]), ve(() => {
      if (!u) return;
      const p = l.current;
      p && p?.scrollIntoView({
        block: "nearest",
        behavior: "smooth"
      });
    }, [u]), ve(() => (o(s), () => i(s)), [a]);
    const h = (p) => {
      p.preventDefault(), p.stopPropagation(), t(e);
    };
    return /* @__PURE__ */ F(
      "li",
      {
        ref: c,
        role: "option",
        "aria-label": `Søk på ${e.displayName}`,
        className: f,
        onClick: () => n(e),
        tabIndex: 1,
        children: [
          /* @__PURE__ */ d(
            Rt,
            {
              weight: "semibold",
              className: "line-clamp-1 group-hover:text-surface-common-primary",
              children: e.displayName
            }
          ),
          /* @__PURE__ */ d(
            Dt,
            {
              variant: "nostyle",
              "aria-label": "lukk",
              className: "group-hover:text-surface-common-primary",
              onClick: h,
              children: /* @__PURE__ */ d(Wr, { size: "small" })
            }
          )
        ]
      },
      e.id
    );
  }
), eB = O.forwardRef(
  ({ searches: e = [], className: t, handleClick: n, handleClear: r, ...o }, i) => {
    const { setListType: a } = La(), s = e.length > 0, l = I(
      "flex flex-col pt-md sm:pt-lg",
      !s && "items-center justify-center",
      t
    );
    ve(() => {
      a("previous-search");
    }, []);
    const c = ct(() => s ? /* @__PURE__ */ d("ul", { role: "listbox", className: "flex flex-col", children: e.map((u) => /* @__PURE__ */ d(
      JV,
      {
        item: u,
        handleClear: r,
        handleClick: n
      },
      u.id
    )) }) : /* @__PURE__ */ d("div", { className: "flex items-center justify-center pb-md sm:pb-lg", children: /* @__PURE__ */ d(Rt, { children: "Ingen tidligere søk" }) }), [e, s]);
    return /* @__PURE__ */ F("div", { ref: i, className: l, ...o, children: [
      s && /* @__PURE__ */ d(Ut, { weight: "semibold", className: "px-lg pb-sm pt-0", children: "Tidligere søk" }),
      /* @__PURE__ */ d(c, {})
    ] });
  }
), tB = O.forwardRef(({ render: e = !0, children: t }, n) => e ? /* @__PURE__ */ d(
  "div",
  {
    ref: n,
    role: "presentation",
    className: "flex flex-col items-center justify-center gap-sm px-[24px] py-lg",
    children: t || "Fant ingen resultater"
  }
) : null), nB = ({ error: e }) => {
  const n = e instanceof Error ? e.message : "Ukjent feil";
  return /* @__PURE__ */ F("div", { className: "flex h-full items-center justify-center p-4", children: [
    /* @__PURE__ */ d(_1, { size: "xlarge", level: 3, children: "Det skjedde en feil" }),
    /* @__PURE__ */ d(Ye, { className: "mt-2", children: n })
  ] });
}, S1 = ({
  variant: e = "default",
  height: t = void 0,
  width: n = void 0,
  borderRadius: r = void 0,
  className: o,
  afterText: i,
  beforeText: a
}) => {
  const s = {
    "aria-hidden": !0,
    role: "status",
    style: {
      borderRadius: r,
      width: n || "100%",
      height: t || "1rem"
    }
  }, l = I(
    "bg-neutral-300",
    "overflow-hidden",
    "inline-block",
    "align-middle",
    "overflow-hidden",
    "rounded-sm",
    e !== "spin-loader" && "animate-pulse",
    e === "circle" && "rounded-full",
    e === "rectangle" && "rounded-md",
    e === "spin-loader" && "flex items-center justify-center bg-surface-common-subtle p-sm",
    o
  );
  return /* @__PURE__ */ F("div", { className: l, ...s, children: [
    /* @__PURE__ */ d("span", { className: "sr-only", children: "Loading..." }),
    e === "spin-loader" && /* @__PURE__ */ d(Gc, { beforeText: a, afterText: i })
  ] });
}, rB = ({ amount: e = 1 }) => /* @__PURE__ */ d(
  "ul",
  {
    className: "scrollbar-none flex flex-col gap-sm overflow-y-auto p-lg",
    role: "listbox",
    children: [...Array(e)].map((t, n) => /* @__PURE__ */ d(oB, {}, n))
  }
), oB = () => /* @__PURE__ */ d("li", { className: "flex h-7 w-full justify-between", children: /* @__PURE__ */ F("div", { className: "flex h-[40px] w-full gap-[12px]", children: [
  /* @__PURE__ */ d(S1, { variant: "circle", height: "40px", width: "40px" }),
  /* @__PURE__ */ F("div", { className: "flex flex-1 flex-col gap-[6px]", children: [
    /* @__PURE__ */ d(S1, { width: "200px", height: "18px" }),
    /* @__PURE__ */ d(S1, { width: "148px", height: "18px" })
  ] })
] }) }), iB = O.forwardRef(
  (e, t) => {
    const { children: n } = e;
    return /* @__PURE__ */ d(vV, { children: /* @__PURE__ */ d(xV, { ref: t, ...e, children: n }) });
  }
), rpe = Object.assign(iB, {
  Group: SV,
  Item: GV,
  Footer: XV,
  Result: QV,
  PreviousSearch: eB,
  Empty: tB,
  SearchError: nB,
  Loading: rB
}), ope = () => gt(void 0), c7 = (e, t) => !t || !e ? e : typeof e == "object" ? e[t] : e, ipe = ({
  values: e,
  value: t,
  disabled: n,
  skeletons: r = 3,
  labelField: o,
  valueField: i,
  loading: a,
  onChange: s,
  ...l
}) => {
  const [c, u] = ue(void 0), f = !e?.length, h = I("flex w-full flex-wrap gap-2"), p = ct(
    (g) => c !== g ? "secondary" : "primary",
    [t, c]
  ), C = (g) => {
    u(g), s?.(g);
  }, m = _e(() => e ? e.map((g) => ({
    label: c7(g, o),
    value: c7(g, i)
  })) : [], [e, o, i]);
  return ve(() => {
    if (a || f || c !== void 0) return;
    const g = c7(t || e[0], i);
    m.some(
      ({ value: y }) => y === c
    ) || (u(g), s?.(g));
  }, [e, a, c, f, i, s]), a ? /* @__PURE__ */ d("div", { className: h, children: Array.from({ length: r }).map((g, v) => /* @__PURE__ */ d(
    S1,
    {
      width: "100px",
      height: "32px",
      borderRadius: "100px",
      variant: "rectangle"
    },
    v
  )) }) : f ? null : /* @__PURE__ */ d("div", { className: h, children: m.map(({ label: g, value: v }) => /* @__PURE__ */ d(
    Dt,
    {
      variant: p(v),
      small: !0,
      title: g,
      onClick: () => C(v),
      "aria-pressed": c === v,
      disabled: n,
      ...l,
      children: g
    },
    v
  )) });
}, zd = ({
  label: e,
  afterIcon: t,
  beforeIcon: n,
  variant: r = "default",
  borderVariant: o = "default",
  tooltip: i,
  onClose: a,
  onClick: s
}) => {
  const l = s ? "button" : "div", c = (p) => {
    p.stopPropagation(), a?.();
  }, u = (p) => {
    s?.(p);
  }, f = I(
    "flex max-h-fit w-fit items-center justify-center gap-1 rounded-[47px] px-1 py-[3px] text-small !font-normal !leading-[18px] !text-neutral-0 [&>svg]:!fill-current",
    o === "square" && "rounded-[4px]",
    r === "default" && "bg-surface-common-chip-default !text-text-brand",
    r === "neutral" && "bg-neutral-200 !text-text-brand",
    r === "primary" && "bg-surface-common-primary !text-text-invert",
    r === "draft" && "border-[1px] border-border-input bg-transparency-full !text-text-brand",
    r === "outline" && "border-[1px] border-surface-common-primary !text-text-brand",
    r === "success" && "bg-categories-greenLight !text-text-primary",
    r === "warning" && "bg-categories-orangeLight !text-text-primary",
    r === "error" && "bg-categories-redLight !text-text-primary",
    r === "badge" && "bg-surface-common-notification !text-text-primary",
    (a || s) && I(
      "hover:bg-primary-900 active:bg-primary-900 cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-border-input",
      s && "focus-visible:outline-none"
    )
  ), h = I(
    "flex h-[14px] w-[14px] cursor-pointer items-center justify-center rounded-[0.25rem] border-none bg-transparent outline-none transition-all duration-200 [&>svg]:!fill-current"
  );
  return i ? /* @__PURE__ */ F(x1, { children: [
    /* @__PURE__ */ d(x1.Trigger, { asChild: !0, children: /* @__PURE__ */ F(l, { onClick: u, className: f, children: [
      n,
      e && e,
      t,
      a && !t && /* @__PURE__ */ d(
        "button",
        {
          onClick: c,
          className: h,
          "aria-label": "Fjern",
          children: /* @__PURE__ */ d(Wr, {})
        }
      )
    ] }) }),
    /* @__PURE__ */ d(x1.Content, { children: i })
  ] }) : /* @__PURE__ */ F(
    l,
    {
      onClick: u,
      className: f,
      tabIndex: s || a ? 0 : -1,
      children: [
        n,
        e && e,
        t,
        a && !t && /* @__PURE__ */ d(
          "button",
          {
            onClick: c,
            className: h,
            "aria-label": "Fjern",
            children: /* @__PURE__ */ d(Wr, {})
          }
        )
      ]
    }
  );
};
var K1 = /* @__PURE__ */ ((e) => (e.bbld = "bbld", e.usbl = "usbl", e.gobb = "gobb", e.nbbo = "nbbo", e.aardal = "aardal", e.abbl = "abbl", e.arendal = "arendal", e.tobb = "tobb", e.bate = "bate", e.bob = "bob", e.bodo = "bodo", e.bosor = "bosor", e.bomidt = "bomidt", e.bonord = "bonord", e.bori = "bori", e.habo = "habo", e.ibbl = "ibbl", e.indresalten = "indresalten", e.kbbl = "kbbl", e.kobbl = "kobbl", e.kongsberg = "kongsberg", e.kragero = "kragero", e.labo = "labo", e.mobo = "mobo", e.moborana = "moborana", e.nbbl = "nbbl", e.nobl = "nobl", e.notodden = "notodden", e.obf = "obf", e.omt = "omt", e.pbbl = "pbbl", e.polarlys = "polarlys", e.ringbo = "ringbo", e.rjukantinn = "rjukantinn", e.rtbbl = "rtbbl", e.sbbl = "sbbl", e.skien = "skien", e.sobbl = "sobbl", e.sobo = "sobo", e.sorbbl = "sorbbl", e.sunnbo = "sunnbo", e.vansjobbl = "vansjobbl", e.vestbo = "vestbo", e.mosjoen = "mosjoen", e.gbbl = "gbbl", e))(K1 || {});
const rO = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#0D0D48",
    900: "#10105A",
    800: "#0C3181",
    700: "#0B40B3",
    600: "#0D49CB",
    500: "#1657E2",
    400: "#739AEE",
    300: "#ABC3F5",
    200: "#C9D8F9",
    100: "#E6EEFF",
    50: "#F8FAFF"
  },
  secondary: {
    1e3: "#050523",
    900: "#060623",
    800: "#090931",
    700: "#0B0B3C",
    600: "#0C0C45",
    500: "#101051",
    400: "#0F0F55",
    300: "#373767",
    200: "#70708A",
    100: "#86869A",
    50: "#DEDEEC"
  },
  spacing: {
    half: "4px",
    1: "8px",
    2: "16px",
    3: "24px",
    4: "32px",
    5: "40px",
    6: "48px",
    7: "56px",
    8: "64px",
    9: "72px",
    10: "80px",
    11: "88px",
    12: "96px",
    13: "104px"
  },
  borderRadius: {
    none: "0px",
    sm: "4px",
    md: "8px",
    lg: "16px",
    xl: "24px",
    full: "360px"
  }
}, sa = {
  neutral: {
    900: "#181B1F",
    800: "#37383D",
    700: "#43454B",
    600: "#4D4F57",
    500: "#73747A",
    400: "#A2A3A5",
    300: "#D4D5D8",
    200: "#DEE0E4",
    100: "#F9F9FC",
    0: "#FFFFFF"
  },
  ui: {
    successDark: "#007958",
    successLight: "#D6F3EB",
    warningDark: "#814F23",
    warningLight: "#FFCD80",
    errorDark: "#A31C1B",
    errorLight: "#FFDCDA"
  },
  categories: {
    pinkDark: "#B21286",
    pinkLight: "#FFE0EB",
    purpleDark: "#531C6F",
    purpleLight: "#F0DAFB",
    blueDark: "#173F97",
    blueLight: "#CCE4FF",
    greenDark: "#007958",
    middleGreen: "#A6ECB2",
    greenLight: "#D6F3EB",
    yellowDark: "#814F23",
    yellowLight: "#FFCD80",
    orangeDark: "#934500",
    orangeLight: "#FFEBCC",
    redDark: "#A31C1B",
    redMiddle: "#EB011A",
    redLight: "#FFDCDA",
    turquoiseDark: "#176997",
    turquoiseLight: "#CCFCFF",
    greyDark: "#A2A3A5",
    greyLight: "#DEE0E4",
    redBadge: "#FF7979"
  },
  transparency: {
    full: "rgba(0, 0, 0, 0)",
    modalBackground: "rgba(0, 0, 0, 0.32)"
  }
}, { primary: Je, secondary: Io, globalBackground: ape } = rO, { neutral: Ct } = sa;
Je[500], Je[300], Io[500], Je[100], Je[50], Ct[0], sa.transparency.modalBackground, Je[100], Je[50], Je[100], Je[500], Je[100], Io[500], Ct[0], Je[900], Je[1e3], Je[800], Je[400], Ct[0], Io[500], sa.transparency.full, Ct[0], Je[300], Je[1e3], Ct[0], Je[1e3], Je[200], Ct[0], Je[100], Je[500], Je[500], Io[500], sa.transparency.full, Ct[0], Je[800], Ct[0], Ct[0], Je[1e3], Io[500], Je[500], Je[500], Io[500], Ct[200], Ct[0], Ct[0], Ct[0], Ct[0], Je[100], Io[500], Je[500], Io[500], Ct[200], Je[1e3], Ct[0], Ct[0], Ct[0], sa.transparency.full, Je[100], Je[500], Je[500], Ct[200], Je[500], Je[1e3], Ct[0], Ct[0], Ct[900], Ct[600], Je[1e3], Ct[0], Ct[300], Io[500], Ct[200], Ct[100];
const aB = {
  default: {
    primitives: rO,
    base: sa
  }
}, sB = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#240207",
    900: "#35030B",
    800: "#4B0510",
    700: "#5C0614",
    600: "#6A0717",
    500: "#710718",
    400: "#865154",
    300: "#A98C8D",
    200: "#C5B4B5",
    100: "#DCD2D3",
    50: "#F5ECED"
  },
  secondary: {
    1e3: "#071118",
    900: "#10212D",
    800: "#172F3F",
    700: "#1C3A4E",
    600: "#20435A",
    500: "#22475F",
    400: "#576979",
    300: "#8F98A1",
    200: "#B6BBC0",
    100: "#D3D6D9",
    50: "#F0F3F5"
  }
}, lB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: sB
}, Symbol.toStringTag, { value: "Module" })), cB = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#001610",
    900: "#002218",
    800: "#003122",
    700: "#003C2A",
    600: "#004530",
    500: "#004933",
    400: "#49786A",
    300: "#8EB1A6",
    200: "#D7E8E0",
    100: "#E2EDE8",
    50: "#F0F7F4"
  },
  secondary: {
    1e3: "#330B0B",
    900: "#692F2F",
    800: "#944243",
    700: "#B55152",
    600: "#D15D5E",
    500: "#DE6364",
    400: "#ED9091",
    300: "#F3C4C5",
    200: "#F2D7D7",
    100: "#F7EAEA",
    50: "#FBF6F6"
  }
}, uB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: cB
}, Symbol.toStringTag, { value: "Module" })), fB = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#270116",
    900: "#700441",
    800: "#9E055C",
    700: "#C10771",
    600: "#DF0882",
    500: "#ED088A",
    400: "#EF519A",
    300: "#F38CB5",
    200: "#F6B4CD",
    100: "#F9D2E0",
    50: "#FAE8EE"
  },
  secondary: {
    1e3: "#071118",
    900: "#10212D",
    800: "#172F3F",
    700: "#1C3A4E",
    600: "#20435A",
    500: "#22475F",
    400: "#576979",
    300: "#8F98A1",
    200: "#B6BBC0",
    100: "#D3D6D9",
    50: "#F0F3F5"
  }
}, dB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: fB
}, Symbol.toStringTag, { value: "Module" })), hB = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#3C0509",
    900: "#630F15",
    800: "#8D151D",
    700: "#AC1924",
    600: "#C71D29",
    500: "#D31F2C",
    400: "#D8565B",
    300: "#E18E90",
    200: "#EAB6B7",
    100: "#F2D3D4",
    50: "#FAEEEF"
  },
  secondary: {
    1e3: "#040404",
    900: "#0E0E0D",
    800: "#131312",
    700: "#181816",
    600: "#1B1B19",
    500: "#1D1D1B",
    400: "#555555",
    300: "#8E8E8D",
    200: "#B5B5B5",
    100: "#D3D3D3",
    50: "#EBEBEB"
  }
}, pB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: hB
}, Symbol.toStringTag, { value: "Module" })), mB = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#0D0D48",
    900: "#10105A",
    800: "#0C3181",
    700: "#0B40B3",
    600: "#0D49CB",
    500: "#1657E2",
    400: "#739AEE",
    300: "#ABC3F5",
    200: "#C9D8F9",
    100: "#E6EEFF",
    50: "#F8FAFF"
  },
  secondary: {
    1e3: "#050523",
    900: "#060623",
    800: "#090931",
    700: "#0B0B3C",
    600: "#0C0C45",
    500: "#101051",
    400: "#0F0F55",
    300: "#373767",
    200: "#70708A",
    100: "#86869A",
    50: "#DEDEEC"
  },
  spacing: {
    half: "4px",
    1: "8px",
    2: "16px",
    3: "24px",
    4: "32px",
    5: "40px",
    6: "48px",
    7: "56px",
    8: "64px",
    9: "72px",
    10: "80px",
    11: "88px",
    12: "96px",
    13: "104px"
  },
  borderRadius: {
    none: "0px",
    sm: "4px",
    md: "8px",
    lg: "16px",
    xl: "24px",
    full: "360px"
  }
}, gB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: mB
}, Symbol.toStringTag, { value: "Module" })), CB = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#160624",
    900: "#29113E",
    800: "#3B1858",
    700: "#481D6C",
    600: "#53227C",
    500: "#582484",
    400: "#745895",
    300: "#9E8FB2",
    200: "#BFB6CB",
    100: "#D8D3DF",
    50: "#F1EEF6"
  },
  secondary: {
    1e3: "#111E22",
    900: "#344B52",
    800: "#6E8A92",
    700: "#95B9C2",
    600: "#AFCED6",
    500: "#C5E6EF",
    400: "#CCEEEE",
    300: "#D8EEF4",
    200: "#E4F3F7",
    100: "#EAF5F8",
    50: "#EEF7FA"
  }
}, vB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: CB
}, Symbol.toStringTag, { value: "Module" })), yB = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#330605",
    900: "#681514",
    800: "#931D1C",
    700: "#B42422",
    600: "#D02928",
    500: "#DD2C2A",
    400: "#E15B5A",
    300: "#E89090",
    200: "#EFB7B7",
    100: "#F5D4D4",
    50: "#F6E5E5"
  },
  secondary: {
    1e3: "#0D0007",
    900: "#18010F",
    800: "#18010F",
    700: "#1D0212",
    600: "#220215",
    500: "#240216",
    400: "#5D5356",
    300: "#928C8E",
    200: "#BBB2B7",
    100: "#DBD7DB",
    50: "#EAE7EA"
  }
}, bB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: yB
}, Symbol.toStringTag, { value: "Module" })), wB = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#032E38",
    900: "#0B4756",
    800: "#10657A",
    700: "#147B95",
    600: "#178EAC",
    500: "#1897B7",
    400: "#54A4BF",
    300: "#8DBCCF",
    200: "#B5D2DE",
    100: "#D3E3EA",
    50: "#E7F2F6"
  },
  secondary: {
    1e3: "#141D36",
    900: "#253151",
    800: "#354572",
    700: "#40548C",
    600: "#4A61A1",
    500: "#4F67AB",
    400: "#6E7FB5",
    300: "#9BA4C8",
    200: "#BDC2D9",
    100: "#D7DAE7",
    50: "#E7E9F3"
  }
}, xB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: wB
}, Symbol.toStringTag, { value: "Module" })), SB = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#0E231D",
    900: "#1D3E35",
    800: "#29584B",
    700: "#326C5C",
    600: "#397C6A",
    500: "#3D8471",
    400: "#639586",
    300: "#95B2A9",
    200: "#B9CBC5",
    100: "#D5DFDC",
    50: "#F1F6F4"
  },
  secondary: {
    1e3: "#302113",
    900: "#6C523A",
    800: "#997553",
    700: "#BB8F65",
    600: "#D8A575",
    500: "#E5AF7C",
    400: "#E8B98F",
    300: "#EDCAAE",
    200: "#F2DBC9",
    100: "#F7E8DE",
    50: "#F7F0EC"
  }
}, MB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: SB
}, Symbol.toStringTag, { value: "Module" })), EB = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#002311",
    900: "#003117",
    800: "#004620",
    700: "#005627",
    600: "#00632D",
    500: "#006930",
    400: "#51805D",
    300: "#8CA591",
    200: "#B4C3B7",
    100: "#D2DBD4",
    50: "#E7F0E9"
  },
  secondary: {
    1e3: "#1E2D00",
    900: "#395700",
    800: "#517B00",
    700: "#649600",
    600: "#73AD00",
    500: "#7AB800",
    400: "#8DC051",
    300: "#ADD08C",
    200: "#C8DEB4",
    100: "#DDEBD2",
    50: "#ECF5E5"
  }
}, _B = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: EB
}, Symbol.toStringTag, { value: "Module" })), OB = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#031411",
    900: "#101E1C",
    800: "#15211F",
    700: "#192F2C",
    600: "#1B3F39",
    500: "#1C5A50",
    400: "#287165",
    300: "#489F91",
    200: "#7FB6AD",
    100: "#D5E9E6",
    50: "#E7F4F2"
  },
  secondary: {
    1e3: "#C1A664",
    900: "#D9C488",
    800: "#E3D09A",
    700: "#F1DFAB",
    600: "#FAEBBE",
    500: "#FCF2D5",
    400: "#FFF8E2",
    300: "#FFF9E8",
    200: "#FFF9E9",
    100: "#FFFBEF",
    50: "#FFFCF4"
  }
}, AB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: OB
}, Symbol.toStringTag, { value: "Module" })), PB = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#0D0108",
    900: "#1C0210",
    800: "#260316",
    700: "#30051C",
    600: "#3E0825",
    500: "#501F3A",
    400: "#7B4E69",
    300: "#BAA0AF",
    200: "#E2D0DA",
    100: "#EFDFE8",
    50: "#F6EEF3"
  },
  secondary: {
    1e3: "#1B1B19",
    900: "#6C675D",
    800: "#938A7C",
    700: "#C0BAAD",
    600: "#E0DBD2",
    500: "#ECE8DF",
    400: "#F1EEE8",
    300: "#F4F1EC",
    200: "#F7F5F2",
    100: "#FAF9F6",
    50: "#FDFDFC"
  }
}, TB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: PB
}, Symbol.toStringTag, { value: "Module" })), IB = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#350E1E",
    900: "#4B142A",
    800: "#5C1632",
    700: "#5E1733",
    600: "#611A36",
    500: "#661B39",
    400: "#893A5A",
    300: "#B36E8B",
    200: "#E7ADC4",
    100: "#EFDAE2",
    50: "#FEF7FA"
  },
  secondary: {
    1e3: "#0E1619",
    900: "#142024",
    800: "#19272C",
    700: "#1D2D33",
    600: "#203238",
    500: "#23373E",
    400: "#2B3F47",
    300: "#4E5A5F",
    200: "#798083",
    100: "#898F92",
    50: "#C1C9CD"
  }
}, DB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: IB
}, Symbol.toStringTag, { value: "Module" })), RB = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#0A1420",
    900: "#19293D",
    800: "#233956",
    700: "#2A4669",
    600: "#31517A",
    500: "#345681",
    400: "#5F7393",
    300: "#929DB1",
    200: "#B8BECA",
    100: "#D4D8DF",
    50: "#E9EDF3"
  },
  secondary: {
    1e3: "#270116",
    900: "#700441",
    800: "#9E055C",
    700: "#C10771",
    600: "#DF0882",
    500: "#ED088A",
    400: "#EF519A",
    300: "#F38CB5",
    200: "#F6B4CD",
    100: "#F9D2E0",
    50: "#FAE8EE"
  }
}, kB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: RB
}, Symbol.toStringTag, { value: "Module" })), LB = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#032E38",
    900: "#0B4756",
    800: "#10657A",
    700: "#147B95",
    600: "#178EAC",
    500: "#1897B7",
    400: "#54A4BF",
    300: "#8DBCCF",
    200: "#B5D2DE",
    100: "#D3E3EA",
    50: "#E7F2F6"
  },
  secondary: {
    1e3: "#141D36",
    900: "#253151",
    800: "#354572",
    700: "#40548C",
    600: "#4A61A1",
    500: "#4F67AB",
    400: "#6E7FB5",
    300: "#9BA4C8",
    200: "#BDC2D9",
    100: "#D7DAE7",
    50: "#E7E9F3"
  }
}, NB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: LB
}, Symbol.toStringTag, { value: "Module" })), FB = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#360504",
    900: "#621211",
    800: "#8B1A19",
    700: "#AB201E",
    600: "#C52523",
    500: "#D12725",
    400: "#D65958",
    300: "#E08F8F",
    200: "#E9B6B6",
    100: "#F1D3D3",
    50: "#F7E6E6"
  },
  secondary: {
    1e3: "#070707",
    900: "#0D0D0D",
    800: "#131313",
    700: "#171717",
    600: "#1A1A1A",
    500: "#1C1C1C",
    400: "#555555",
    300: "#8E8E8E",
    200: "#B5B5B5",
    100: "#D3D3D3",
    50: "#EAEAEA"
  }
}, VB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: FB
}, Symbol.toStringTag, { value: "Module" })), BB = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#15201A",
    900: "#3C5145",
    800: "#557262",
    700: "#688C78",
    600: "#78A18B",
    500: "#7FAB93",
    400: "#91B5A1",
    300: "#AFC8BA",
    200: "#C9D9D0",
    100: "#DEE7E2",
    50: "#F1F7F4"
  },
  secondary: {
    1e3: "#221F1A",
    900: "#59544C",
    800: "#7D776C",
    700: "#999284",
    600: "#B1A999",
    500: "#BCB3A2",
    400: "#C4BCAE",
    300: "#D2CDC3",
    200: "#E0DCD6",
    100: "#ECE9E5",
    50: "#F8F5F1"
  }
}, $B = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: BB
}, Symbol.toStringTag, { value: "Module" })), jB = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#27040A",
    900: "#4E0C17",
    800: "#6F1120",
    700: "#881427",
    600: "#9D182D",
    500: "#A71930",
    400: "#B2545D",
    300: "#C68D91",
    200: "#D8B5B7",
    100: "#E7D3D4",
    50: "#F7E9EA"
  },
  secondary: {
    1e3: "#262F33",
    900: "#565F63",
    800: "#7A868D",
    700: "#95A4AC",
    600: "#ACBDC7",
    500: "#B7C9D3",
    400: "#BFCFD8",
    300: "#CFDBE1",
    200: "#DEE6EA",
    100: "#EAEFF2",
    50: "#F4FAFD"
  }
}, HB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: jB
}, Symbol.toStringTag, { value: "Module" })), zB = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#270116",
    900: "#700441",
    800: "#9E055C",
    700: "#C10771",
    600: "#DF0882",
    500: "#ED088A",
    400: "#EF519A",
    300: "#F38CB5",
    200: "#F6B4CD",
    100: "#F9D2E0",
    50: "#FAE8EE"
  },
  secondary: {
    1e3: "#071118",
    900: "#10212D",
    800: "#172F3F",
    700: "#1C3A4E",
    600: "#20435A",
    500: "#22475F",
    400: "#576979",
    300: "#8F98A1",
    200: "#B6BBC0",
    100: "#D3D6D9",
    50: "#F0F3F5"
  }
}, ZB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: zB
}, Symbol.toStringTag, { value: "Module" })), WB = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#192431",
    900: "#303F52",
    800: "#435975",
    700: "#526D8F",
    600: "#5F7DA5",
    500: "#6585AF",
    400: "#7D96B9",
    300: "#A3B3CA",
    200: "#C2CBDB",
    100: "#DADFE8",
    50: "#ECEFF5"
  },
  secondary: {
    1e3: "#2B0318",
    900: "#6C2147",
    800: "#992E64",
    700: "#BC387A",
    600: "#D9418D",
    500: "#E64596",
    400: "#E968A4",
    300: "#EE97BC",
    200: "#F3BBD1",
    100: "#F7D6E3",
    50: "#F8F0F3"
  }
}, qB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: WB
}, Symbol.toStringTag, { value: "Module" })), UB = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#270116",
    900: "#700441",
    800: "#9E055C",
    700: "#C10771",
    600: "#DF0882",
    500: "#ED088A",
    400: "#EF519A",
    300: "#F38CB5",
    200: "#F6B4CD",
    100: "#F9D2E0",
    50: "#FAE8EE"
  },
  secondary: {
    1e3: "#071118",
    900: "#10212D",
    800: "#172F3F",
    700: "#1C3A4E",
    600: "#20435A",
    500: "#22475F",
    400: "#576979",
    300: "#8F98A1",
    200: "#B6BBC0",
    100: "#D3D6D9",
    50: "#F0F3F5"
  }
}, GB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: UB
}, Symbol.toStringTag, { value: "Module" })), KB = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#270116",
    900: "#700441",
    800: "#9E055C",
    700: "#C10771",
    600: "#DF0882",
    500: "#ED088A",
    400: "#EF519A",
    300: "#F38CB5",
    200: "#F6B4CD",
    100: "#F9D2E0",
    50: "#FAE8EE"
  },
  secondary: {
    1e3: "#071118",
    900: "#10212D",
    800: "#172F3F",
    700: "#1C3A4E",
    600: "#20435A",
    500: "#22475F",
    400: "#576979",
    300: "#8F98A1",
    200: "#B6BBC0",
    100: "#D3D6D9",
    50: "#F0F3F5"
  }
}, YB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: KB
}, Symbol.toStringTag, { value: "Module" })), XB = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#270116",
    900: "#700441",
    800: "#9E055C",
    700: "#C10771",
    600: "#DF0882",
    500: "#ED088A",
    400: "#EF519A",
    300: "#F38CB5",
    200: "#F6B4CD",
    100: "#F9D2E0",
    50: "#FAE8EE"
  },
  secondary: {
    1e3: "#071118",
    900: "#10212D",
    800: "#172F3F",
    700: "#1C3A4E",
    600: "#20435A",
    500: "#22475F",
    400: "#576979",
    300: "#8F98A1",
    200: "#B6BBC0",
    100: "#D3D6D9",
    50: "#F0F3F5"
  }
}, QB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: XB
}, Symbol.toStringTag, { value: "Module" })), JB = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#270116",
    900: "#700441",
    800: "#9E055C",
    700: "#C10771",
    600: "#DF0882",
    500: "#ED088A",
    400: "#EF519A",
    300: "#F38CB5",
    200: "#F6B4CD",
    100: "#F9D2E0",
    50: "#FAE8EE"
  },
  secondary: {
    1e3: "#071118",
    900: "#10212D",
    800: "#172F3F",
    700: "#1C3A4E",
    600: "#20435A",
    500: "#22475F",
    400: "#576979",
    300: "#8F98A1",
    200: "#B6BBC0",
    100: "#D3D6D9",
    50: "#F0F3F5"
  }
}, e$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: JB
}, Symbol.toStringTag, { value: "Module" })), t$ = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#270116",
    900: "#700441",
    800: "#9E055C",
    700: "#C10771",
    600: "#DF0882",
    500: "#ED088A",
    400: "#EF519A",
    300: "#F38CB5",
    200: "#F6B4CD",
    100: "#F9D2E0",
    50: "#FAE8EE"
  },
  secondary: {
    1e3: "#071118",
    900: "#10212D",
    800: "#172F3F",
    700: "#1C3A4E",
    600: "#20435A",
    500: "#22475F",
    400: "#576979",
    300: "#8F98A1",
    200: "#B6BBC0",
    100: "#D3D6D9",
    50: "#F0F3F5"
  }
}, n$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: t$
}, Symbol.toStringTag, { value: "Module" })), r$ = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#001213",
    900: "#00373B",
    800: "#004F54",
    700: "#006269",
    600: "#00737B",
    500: "#007B83",
    400: "#88AFB3",
    300: "#B6CCCE",
    200: "#D5E0E1",
    100: "#DDE7E8",
    50: "#F0F5F5"
  },
  secondary: {
    1e3: "#160614",
    900: "#31122E",
    800: "#461840",
    700: "#551C50",
    600: "#64205D",
    500: "#6B2163",
    400: "#A78BA3",
    300: "#C7B8C5",
    200: "#DBD2DA",
    100: "#E5DEE3",
    50: "#F3F0F2"
  }
}, o$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: r$
}, Symbol.toStringTag, { value: "Module" })), i$ = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#330605",
    900: "#681514",
    800: "#931D1C",
    700: "#B42422",
    600: "#D02928",
    500: "#DD2C2A",
    400: "#E15B5A",
    300: "#E89090",
    200: "#E89090",
    100: "#F5D4D4",
    50: "#F6E5E5"
  },
  secondary: {
    1e3: "#0D0007",
    900: "#18010F",
    800: "#18010F",
    700: "#1D0212",
    600: "#220215",
    500: "#240216",
    400: "#5D5356",
    300: "#928C8E",
    200: "#BBB2B7",
    100: "#DBD7DB",
    50: "#EAE7EA"
  }
}, a$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: i$
}, Symbol.toStringTag, { value: "Module" })), s$ = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#270116",
    900: "#700441",
    800: "#9E055C",
    700: "#C10771",
    600: "#DF0882",
    500: "#ED088A",
    400: "#EF519A",
    300: "#F38CB5",
    200: "#F6B4CD",
    100: "#F9D2E0",
    50: "#FAE8EE"
  },
  secondary: {
    1e3: "#071118",
    900: "#10212D",
    800: "#172F3F",
    700: "#1C3A4E",
    600: "#20435A",
    500: "#22475F",
    400: "#576979",
    300: "#8F98A1",
    200: "#B6BBC0",
    100: "#D3D6D9",
    50: "#F0F3F5"
  }
}, l$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: s$
}, Symbol.toStringTag, { value: "Module" })), c$ = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#092118",
    900: "#133528",
    800: "#1B4B38",
    700: "#215C45",
    600: "#276A4F",
    500: "#297154",
    400: "#5A8671",
    300: "#90A99C",
    200: "#B7C5BE",
    100: "#D4DCD8",
    50: "#EBEEEC"
  },
  secondary: {
    1e3: "#312F2B",
    900: "#757269",
    800: "#A6A195",
    700: "#CBC5B6",
    600: "#EBE3D2",
    500: "#F9F1DF",
    400: "#FAF2E2",
    300: "#FBF5E9",
    200: "#FCF8F0",
    100: "#FDFBF5",
    50: "#FDFBF5"
  }
}, u$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: c$
}, Symbol.toStringTag, { value: "Module" })), f$ = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#012734",
    900: "#024C65",
    800: "#036C8F",
    700: "#0384AF",
    600: "#0499CB",
    500: "#04A2D7",
    400: "#51AEDB",
    300: "#8CC3E4",
    200: "#B4D6EC",
    100: "#D2E5F3",
    50: "#EFF8FE"
  },
  secondary: {
    1e3: "#0E101A",
    900: "#181B2A",
    800: "#21263C",
    700: "#292F49",
    600: "#2F3655",
    500: "#32395A",
    400: "#5E6175",
    300: "#92949F",
    200: "#B8B9BF",
    100: "#D4D5D8",
    50: "#EEEFF0"
  }
}, d$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: f$
}, Symbol.toStringTag, { value: "Module" })), h$ = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#002836",
    900: "#004057",
    800: "#005B7B",
    700: "#006F96",
    600: "#0080AD",
    500: "#0088B8",
    400: "#5198C0",
    300: "#8CB4D0",
    200: "#B4CCDE",
    100: "#D2E0EB",
    50: "#E7EFF5"
  },
  secondary: {
    1e3: "#270116",
    900: "#700441",
    800: "#9E055C",
    700: "#C10771",
    600: "#DF0882",
    500: "#ED088A",
    400: "#EF519A",
    300: "#F38CB5",
    200: "#F6B4CD",
    100: "#F9D2E0",
    50: "#FAE8EE"
  }
}, p$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: h$
}, Symbol.toStringTag, { value: "Module" })), m$ = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#270116",
    900: "#700441",
    800: "#9E055C",
    700: "#C10771",
    600: "#DF0882",
    500: "#ED088A",
    400: "#EF519A",
    300: "#F38CB5",
    200: "#F6B4CD",
    100: "#F9D2E0",
    50: "#FAE8EE"
  },
  secondary: {
    1e3: "#071118",
    900: "#10212D",
    800: "#172F3F",
    700: "#1C3A4E",
    600: "#20435A",
    500: "#22475F",
    400: "#576979",
    300: "#8F98A1",
    200: "#B6BBC0",
    100: "#D3D6D9",
    50: "#F0F3F5"
  }
}, g$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: m$
}, Symbol.toStringTag, { value: "Module" })), C$ = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#192431",
    900: "#303F52",
    800: "#435975",
    700: "#526D8F",
    600: "#5F7DA5",
    500: "#6585AF",
    400: "#7D96B9",
    300: "#A3B3CA",
    200: "#C2CBDB",
    100: "#DADFE8",
    50: "#ECEFF5"
  },
  secondary: {
    1e3: "#2B0318",
    900: "#6C2147",
    800: "#992E64",
    700: "#BC387A",
    600: "#D9418D",
    500: "#E64596",
    400: "#E968A4",
    300: "#EE97BC",
    200: "#F3BBD1",
    100: "#F7D6E3",
    50: "#F8F0F3"
  }
}, v$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: C$
}, Symbol.toStringTag, { value: "Module" })), y$ = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#161129",
    900: "#504770",
    800: "#71649E",
    700: "#8B7AC1",
    600: "#A08DDF",
    500: "#AA96ED",
    400: "#B4A4EF",
    300: "#C7BCF3",
    200: "#D9D1F6",
    100: "#E7E3F9",
    50: "#F5F2FF"
  },
  secondary: {
    1e3: "#071118",
    900: "#10212D",
    800: "#172F3F",
    700: "#1C3A4E",
    600: "#20435A",
    500: "#22475F",
    400: "#576979",
    300: "#8F98A1",
    200: "#8F98A1",
    100: "#D3D6D9",
    50: "#F0F3F5"
  }
}, b$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: y$
}, Symbol.toStringTag, { value: "Module" })), w$ = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#161129",
    900: "#504770",
    800: "#71649E",
    700: "#8B7AC1",
    600: "#A08DDF",
    500: "#AA96ED",
    400: "#B4A4EF",
    300: "#C7BCF3",
    200: "#D9D1F6",
    100: "#E7E3F9",
    50: "#F5F2FF"
  },
  secondary: {
    1e3: "#071118",
    900: "#10212D",
    800: "#172F3F",
    700: "#1C3A4E",
    600: "#20435A",
    500: "#22475F",
    400: "#576979",
    300: "#8F98A1",
    200: "#8F98A1",
    100: "#D3D6D9",
    50: "#F0F3F5"
  }
}, x$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: w$
}, Symbol.toStringTag, { value: "Module" })), S$ = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#00203D",
    900: "#003463",
    800: "#00498C",
    700: "#015AAB",
    600: "#0068C6",
    500: "#006ED2",
    400: "#5184D7",
    300: "#8CA7E0",
    200: "#B4C4EA",
    100: "#D2DBF2",
    50: "#EBF0FC"
  },
  secondary: {
    1e3: "#000813",
    900: "#000C1F",
    800: "#00112B",
    700: "#001535",
    600: "#00193D",
    500: "#001A41",
    400: "#515466",
    300: "#8C8D96",
    200: "#B4B5BA",
    100: "#D2D3D5",
    50: "#E9EBEE"
  }
}, M$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: S$
}, Symbol.toStringTag, { value: "Module" })), E$ = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#270116",
    900: "#700441",
    800: "#9E055C",
    700: "#C10771",
    600: "#DF0882",
    500: "#ED088A",
    400: "#EF519A",
    300: "#F38CB5",
    200: "#F6B4CD",
    100: "#F9D2E0",
    50: "#FAE8EE"
  },
  secondary: {
    1e3: "#270116",
    900: "#700441",
    800: "#9E055C",
    700: "#C10771",
    600: "#DF0882",
    500: "#ED088A",
    400: "#EF519A",
    300: "#F38CB5",
    200: "#F6B4CD",
    100: "#F9D2E0",
    50: "#FAE8EE"
  }
}, _$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: E$
}, Symbol.toStringTag, { value: "Module" })), O$ = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#072713",
    900: "#0F371E",
    800: "#154D2A",
    700: "#195F33",
    600: "#1D6D3B",
    500: "#1F743F",
    400: "#568864",
    300: "#8EAA95",
    200: "#B6C6BA",
    100: "#D3DCD5",
    50: "#F1F5F2"
  },
  secondary: {
    1e3: "#070B09",
    900: "#0E1511",
    800: "#141D18",
    700: "#18241D",
    600: "#1C2922",
    500: "#1E2C24",
    400: "#565B58",
    300: "#8E908F",
    200: "#B6B7B6",
    100: "#D3D4D3",
    50: "#F2F2F2"
  }
}, A$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: O$
}, Symbol.toStringTag, { value: "Module" })), P$ = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#00203D",
    900: "#003463",
    800: "#00498C",
    700: "#015AAB",
    600: "#0068C6",
    500: "#006ED2",
    400: "#5184D7",
    300: "#8CA7E0",
    200: "#B4C4EA",
    100: "#D2DBF2",
    50: "#EBF0FC"
  },
  secondary: {
    1e3: "#000813",
    900: "#000C1F",
    800: "#00112B",
    700: "#001535",
    600: "#00193D",
    500: "#001A41",
    400: "#515466",
    300: "#8C8D96",
    200: "#B4B5BA",
    100: "#D2D3D5",
    50: "#E9EBEE"
  }
}, T$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: P$
}, Symbol.toStringTag, { value: "Module" })), I$ = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#00203D",
    900: "#003463",
    800: "#00498C",
    700: "#015AAB",
    600: "#0068C6",
    500: "#006ED2",
    400: "#5184D7",
    300: "#8CA7E0",
    200: "#B4C4EA",
    100: "#D2DBF2",
    50: "#EBF0FC"
  },
  secondary: {
    1e3: "#000813",
    900: "#000C1F",
    800: "#00112B",
    700: "#001535",
    600: "#00193D",
    500: "#001A41",
    400: "#515466",
    300: "#8C8D96",
    200: "#B4B5BA",
    100: "#D2D3D5",
    50: "#E9EBEE"
  }
}, D$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: I$
}, Symbol.toStringTag, { value: "Module" })), R$ = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#002335",
    900: "#003754",
    800: "#004E77",
    700: "#005F91",
    600: "#006EA8",
    500: "#0075B2",
    400: "#5189BB",
    300: "#8CABCC",
    200: "#B4C6DC",
    100: "#D2DCE9",
    50: "#E9F0F9"
  },
  secondary: {
    1e3: "#001E2D",
    900: "#00273A",
    800: "#003753",
    700: "#004365",
    600: "#004D75",
    500: "#00527C",
    400: "#51708F",
    300: "#8C9CAE",
    200: "#B4BDC9",
    100: "#D2D7DE",
    50: "#EAEFF5"
  }
}, k$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: R$
}, Symbol.toStringTag, { value: "Module" })), L$ = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#112121",
    900: "#21393A",
    800: "#2F5152",
    700: "#3A6464",
    600: "#437374",
    500: "#477A7B",
    400: "#698D8E",
    300: "#98ADAD",
    200: "#BBC8C8",
    100: "#D6DDDD",
    50: "#EDF1F1"
  },
  secondary: {
    1e3: "#00101D",
    900: "#001A30",
    800: "#002543",
    700: "#002E52",
    600: "#00355F",
    500: "#003865",
    400: "#51617D",
    300: "#8C93A3",
    200: "#B4B9C2",
    100: "#D2D5DA",
    50: "#E2E7EE"
  }
}, N$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: L$
}, Symbol.toStringTag, { value: "Module" })), F$ = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#3A080A",
    900: "#5A1C1E",
    800: "#7F282B",
    700: "#9B3134",
    600: "#B3393C",
    500: "#BE3C40",
    400: "#C56365",
    300: "#D49496",
    200: "#E1B9BA",
    100: "#ECD5D5",
    50: "#FEF3F3"
  },
  secondary: {
    1e3: "#43140B",
    900: "#AA513F",
    800: "#AA513F",
    700: "#D0644D",
    600: "#F07359",
    500: "#FF7A5E",
    400: "#FF9E78",
    300: "#FFBDA0",
    200: "#FFD7C0",
    100: "#FFE8D9",
    50: "#FFF5EF"
  }
}, V$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: F$
}, Symbol.toStringTag, { value: "Module" })), B$ = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#270116",
    900: "#700441",
    800: "#9E055C",
    700: "#C10771",
    600: "#DF0882",
    500: "#ED088A",
    400: "#EF519A",
    300: "#F38CB5",
    200: "#F6B4CD",
    100: "#F9D2E0",
    50: "#FAE8EE"
  },
  secondary: {
    1e3: "#071118",
    900: "#10212D",
    800: "#172F3F",
    700: "#1C3A4E",
    600: "#20435A",
    500: "#22475F",
    400: "#576979",
    300: "#8F98A1",
    200: "#B6BBC0",
    100: "#D3D6D9",
    50: "#F0F3F5"
  }
}, $$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: B$
}, Symbol.toStringTag, { value: "Module" })), j$ = {
  globalBackground: "#F8F8FB",
  primary: {
    1e3: "#0C1F26",
    900: "#325A68",
    800: "#478093",
    700: "#579DB4",
    600: "#65B5CF",
    500: "#6BC0DC",
    400: "#82C7E0",
    300: "#A6D5E7",
    200: "#C4E2EE",
    100: "#DBEDF4",
    50: "#EFF9FD"
  },
  secondary: {
    1e3: "#121B2D",
    900: "#212D44",
    800: "#2F4061",
    700: "#394E76",
    600: "#425A89",
    500: "#466091",
    400: "#687A9F",
    300: "#97A1B9",
    200: "#BBC1CF",
    100: "#D6D9E2",
    50: "#EBECF2"
  }
}, H$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  primitives: j$
}, Symbol.toStringTag, { value: "Module" })), wg = /* @__PURE__ */ Object.assign({
  "./aardal/primitives.ts": lB,
  "./abbl/primitives.ts": uB,
  "./arendal/primitives.ts": dB,
  "./bate/primitives.ts": pB,
  "./bbld/primitives.ts": gB,
  "./bob/primitives.ts": vB,
  "./bodo/primitives.ts": bB,
  "./bomidt/primitives.ts": xB,
  "./bonord/primitives.ts": MB,
  "./bori/primitives.ts": _B,
  "./bosor/primitives.ts": AB,
  "./gbbl/primitives.ts": TB,
  "./gobb/primitives.ts": DB,
  "./habo/primitives.ts": kB,
  "./ibbl/primitives.ts": NB,
  "./indresalten/primitives.ts": VB,
  "./kbbl/primitives.ts": $B,
  "./kobbl/primitives.ts": HB,
  "./kongsberg/primitives.ts": ZB,
  "./kragero/primitives.ts": qB,
  "./labo/primitives.ts": GB,
  "./mobo/primitives.ts": YB,
  "./moborana/primitives.ts": QB,
  "./mosjoen/primitives.ts": e$,
  "./nbbl/primitives.ts": n$,
  "./nbbo/primitives.ts": o$,
  "./nobl/primitives.ts": a$,
  "./notodden/primitives.ts": l$,
  "./obf/primitives.ts": u$,
  "./omt/primitives.ts": d$,
  "./pbbl/primitives.ts": p$,
  "./polarlys/primitives.ts": g$,
  "./ringbo/primitives.ts": v$,
  "./rjukantinn/primitives.ts": b$,
  "./rtbbl/primitives.ts": x$,
  "./sbbl/primitives.ts": M$,
  "./skien/primitives.ts": _$,
  "./sobbl/primitives.ts": A$,
  "./sobo/primitives.ts": T$,
  "./sorbbl/primitives.ts": D$,
  "./sunnbo/primitives.ts": k$,
  "./tobb/primitives.ts": N$,
  "./usbl/primitives.ts": V$,
  "./vansjobbl/primitives.ts": $$,
  "./vestbo/primitives.ts": H$
}), z$ = (e) => {
  const t = e.split("/");
  return t[t.length - 2];
}, oO = {};
for (const e in wg) {
  const t = wg[e];
  if (t && Object.prototype.hasOwnProperty.call(t, "primitives")) {
    const n = z$(e);
    oO[n] = t.primitives;
  }
}
function Z$(e) {
  return oO[e];
}
const W$ = (e, t, n, r) => {
  const o = n.primitives.borderRadius;
  e.setProperty(
    "--surface-common-background",
    t.globalBackground
  ), e.setProperty("--surface-common-primary", t.primary[500]), e.setProperty("--surface-common-primary-light", t.primary[300]), e.setProperty(
    "--surface-common-primary-lighter",
    t.primary[200]
  ), e.setProperty("--surface-common-secondary", t.secondary[500]), e.setProperty("--surface-common-light", t.primary[100]), e.setProperty("--surface-common-subtle", t.primary[50]), e.setProperty(
    "--surface-common-cardItem-underline",
    t.globalBackground
  ), e.setProperty("--surface-common-chip-default", t.primary[100]), e.setProperty("--surface-common-card-hover", t.primary[50]), e.setProperty(
    "--surface-common-card-highlight",
    t.primary[100]
  ), e.setProperty("--surface-common-icon-color", t.primary[500]), e.setProperty(
    "--surface-common-icon-highlight",
    t.primary[100]
  ), e.setProperty(
    "--surface-common-tooltip-background",
    t.secondary[500]
  ), e.setProperty(
    "--surface-common-tooltip-text",
    n.base.neutral[0]
  ), e.setProperty("--surface-common-notification", "#ff7979"), e.setProperty("--surface-common-white", n.base.neutral[0]), e.setProperty("--surface-common-overlay", "rgba(0, 0, 0, 0.32)"), e.setProperty("--surface-common-card-neutral", "#EEEEF1"), e.setProperty("--surface-common-nav-tab-active", "#FFFFFF"), e.setProperty("--surface-common-nav-tab-hover", "#FFFFFF"), e.setProperty("--surface-common-nav-tab-default", "#FFFFFF"), e.setProperty("--surface-common-nav-tab-default-text", "#FFFFFF"), e.setProperty("--surface-common-nav-tab-active-text", "#FFFFFF"), e.setProperty("--surface-portalen-page-header", t.primary[900]), e.setProperty(
    "--surface-portalen-aside-background",
    t.primary[1e3]
  ), e.setProperty(
    "--surface-portalen-aside-highlight",
    t.primary[800]
  ), e.setProperty("--surface-portalen-aside-icon", t.primary[400]), e.setProperty(
    "--surface-portalen-aside-icon-active",
    n.base.neutral[0]
  ), e.setProperty("--surface-portalen-footer", t.primary[800]), e.setProperty(
    "--surface-portalen-footer-text",
    n.base.neutral[0]
  ), e.setProperty("--surface-portalen-nav-tab-default", "rgba(0, 0, 0, 0)"), e.setProperty(
    "--surface-portalen-nav-tab-default-text",
    n.base.neutral[0]
  ), e.setProperty(
    "--surface-portalen-nav-tab-hover",
    t.primary[300]
  ), e.setProperty(
    "--surface-portalen-nav-tab-hover-text",
    t.primary[1e3]
  ), e.setProperty(
    "--surface-portalen-nav-tab-active",
    n.base.neutral[0]
  ), e.setProperty(
    "--surface-portalen-nav-tab-active-text",
    t.primary[1e3]
  ), e.setProperty("--surface-portalen-icon-color", t.primary[500]), e.setProperty(
    "--surface-portalen-icon-highlight",
    t.primary[100]
  ), e.setProperty("--surface-min-side-page-header", t.primary[200]), e.setProperty(
    "--surface-min-side-aside-background",
    n.base.neutral[0]
  ), e.setProperty(
    "--surface-min-side-aside-highlight",
    t.primary[100]
  ), e.setProperty("--surface-min-side-aside-icon", t.primary[500]), e.setProperty(
    "--surface-min-side-aside-icon-active",
    t.primary[500]
  ), e.setProperty("--surface-min-side-footer", t.primary[100]), e.setProperty("--surface-min-side-footer-text", t.primary[900]), e.setProperty("--surface-min-side-nav-tab-default", "rgba(0, 0, 0, 0)"), e.setProperty(
    "--surface-min-side-nav-tab-default-text",
    n.base.neutral[0]
  ), e.setProperty(
    "--surface-min-side-nav-tab-hover",
    t.primary[800]
  ), e.setProperty(
    "--surface-min-side-nav-tab-hover-text",
    n.base.neutral[0]
  ), e.setProperty(
    "--surface-min-side-nav-tab-active",
    n.base.neutral[0]
  ), e.setProperty(
    "--surface-min-side-nav-tab-active-text",
    t.primary[1e3]
  ), e.setProperty("--button-primary-default", t.secondary[500]), e.setProperty("--button-primary-hover", t.primary[500]), e.setProperty("--button-primary-focus", t.primary[500]), e.setProperty("--button-primary-active", t.secondary[500]), e.setProperty("--button-primary-disabled", n.base.neutral[200]), e.setProperty("--button-primary-text", n.base.neutral[0]), e.setProperty("--button-primary-text-hover", n.base.neutral[0]), e.setProperty("--button-primary-text-active", n.base.neutral[0]), e.setProperty("--button-primary-text-focus", n.base.neutral[0]), e.setProperty("--button-secondary-default", t.primary[100]), e.setProperty("--button-secondary-hover", t.secondary[500]), e.setProperty("--button-secondary-focus", t.primary[500]), e.setProperty("--button-secondary-active", t.secondary[500]), e.setProperty(
    "--button-secondary-disabled",
    n.base.neutral[200]
  ), e.setProperty("--button-secondary-text", t.primary[1e3]), e.setProperty(
    "--button-secondary-text-hover",
    n.base.neutral[0]
  ), e.setProperty(
    "--button-secondary-text-active",
    n.base.neutral[0]
  ), e.setProperty(
    "--button-secondary-text-focus",
    n.base.neutral[0]
  ), e.setProperty("--button-ghost-default", "rgba(0, 0, 0, 0)"), e.setProperty("--button-ghost-hover", t.primary[100]), e.setProperty("--button-ghost-focus", t.primary[500]), e.setProperty("--button-ghost-active", t.primary[500]), e.setProperty("--button-ghost-disabled", n.base.neutral[200]), e.setProperty("--button-ghost-text", t.primary[500]), e.setProperty("--button-ghost-text-hover", t.primary[1e3]), e.setProperty("--button-ghost-text-active", n.base.neutral[0]), e.setProperty("--button-ghost-text-focus", n.base.neutral[0]), e.setProperty("--text-primary", n.base.neutral[900]), e.setProperty("--text-secondary", n.base.neutral[600]), e.setProperty("--text-brand", t.primary[1e3]), e.setProperty("--text-invert", n.base.neutral[0]), e.setProperty("--text-card-highlight", t.primary[1e3]), e.setProperty("--border-input", n.base.neutral[300]), e.setProperty("--border-button", t.secondary[500]), e.setProperty("--border-light", n.base.neutral[200]), e.setProperty("--border-subtle", n.base.neutral[100]), e.setProperty(
    "--card-radius",
    r === "portal" ? o.md : o.lg
  ), e.setProperty(
    "--modal-radius",
    o.lg
  ), e.setProperty(
    "--global-search-shortcut-topnav-mobile-dark",
    n.base.neutral[0]
  );
}, q$ = (e, t, n, r) => {
  e.setProperty(
    "--card-radius",
    r === "portal" ? n.primitives.borderRadius.md : n.primitives.borderRadius.none
  ), e.setProperty(
    "--global-search-shortcut-topnav-mobile-dark",
    n.base.neutral[600]
  ), e.setProperty(
    "--surface-common-primary-light",
    t.secondary[300]
  ), e.setProperty(
    "--surface-common-chip-default",
    t.secondary[100]
  ), e.setProperty("--surface-portalen-page-header", "#F4F0E9"), e.setProperty(
    "--surface-portalen-aside-background",
    t.primary[500]
  ), e.setProperty(
    "--surface-portalen-aside-highlight",
    t.primary[700]
  ), e.setProperty("--surface-portalen-footer", t.primary[700]), e.setProperty("--surface-portalen-aside-icon", t.primary[300]), e.setProperty(
    "--surface-portalen-nav-tab-default-text",
    n.base.neutral[900]
  ), e.setProperty(
    "--surface-portalen-nav-tab-hover",
    t.primary[100]
  ), e.setProperty(
    "--surface-portalen-nav-tab-hover-text",
    n.base.neutral[900]
  ), e.setProperty("--surface-portalen-nav-tab-active", "#7A1619"), e.setProperty(
    "--surface-portalen-nav-tab-active-text",
    n.base.neutral[0]
  ), e.setProperty("--surface-portalen-icon-color", t.primary[500]), e.setProperty(
    "--surface-portalen-icon-highlight",
    t.primary[100]
  ), e.setProperty("--surface-min-side-page-header", "#F3F0E8"), e.setProperty("--surface-min-side-aside-background", "#2E3636"), e.setProperty("--surface-min-side-aside-highlight", "#3C4848"), e.setProperty("--surface-min-side-aside-icon", "#FCEFCD"), e.setProperty("--surface-min-side-aside-icon-active", "#FFFFFF"), e.setProperty(
    "--surface-min-side-nav-tab-default-text",
    n.base.neutral[900]
  ), e.setProperty(
    "--surface-min-side-nav-tab-hover",
    t.primary[100]
  ), e.setProperty(
    "--surface-min-side-nav-tab-hover-text",
    n.base.neutral[900]
  ), e.setProperty("--surface-min-side-nav-tab-active", "#2E3636"), e.setProperty(
    "--surface-min-side-nav-tab-active-text",
    n.base.neutral[0]
  ), e.setProperty("--surface-min-side-footer", "#3C4848"), e.setProperty(
    "--surface-min-side-footer-text",
    n.base.neutral[0]
  ), e.setProperty("--button-primary-default", "#2E3636"), e.setProperty("--button-primary-hover", "#2E3636"), e.setProperty("--button-primary-focus", "#2E3636"), e.setProperty("--button-primary-active", "#2E3636"), e.setProperty("--button-secondary-default", t.secondary[200]), e.setProperty("--button-secondary-hover", t.secondary[600]), e.setProperty("--button-secondary-active", t.secondary[600]), e.setProperty("--button-ghost-hover", t.primary[200]), e.setProperty("--button-ghost-active", t.primary[200]);
}, U$ = (e, t, n, r) => {
  e.setProperty(
    "--surface-common-tooltip-text",
    n.base.neutral[900]
  ), e.setProperty("--button-primary-text", n.base.neutral[900]), e.setProperty(
    "--button-primary-text-active",
    n.base.neutral[900]
  ), e.setProperty(
    "--button-secondary-text-active",
    n.base.neutral[900]
  );
}, G$ = (e, t, n, r) => {
  e.setProperty("--surface-common-secondary", t.secondary[700]), e.setProperty("--surface-common-light", t.secondary[100]), e.setProperty(
    "--surface-common-tooltip-text",
    n.base.neutral[900]
  ), e.setProperty("--surface-portalen-page-header", t.primary[500]), e.setProperty(
    "--surface-portalen-aside-background",
    t.primary[700]
  ), e.setProperty(
    "--surface-portalen-aside-highlight",
    t.primary[500]
  ), e.setProperty("--surface-portalen-footer", t.primary[500]), e.setProperty("--surface-min-side-page-header", t.primary[50]), e.setProperty(
    "--surface-min-side-aside-highlight",
    t.primary[50]
  ), e.setProperty("--surface-min-side-footer", t.primary[50]), e.setProperty("--button-primary-default", t.primary[100]), e.setProperty("--button-primary-text", n.base.neutral[900]), e.setProperty(
    "--button-primary-text-active",
    n.base.neutral[900]
  ), e.setProperty("--button-secondary-default", t.secondary[500]), e.setProperty("--button-secondary-text", n.base.neutral[900]);
}, K$ = (e, t, n, r) => {
  const { primary: o } = t;
  e.setProperty(
    "--surface-common-tooltip-text",
    n.base.neutral[900]
  ), e.setProperty("--surface-portalen-page-header", o[500]), e.setProperty("--surface-portalen-aside-background", o[700]), e.setProperty("--surface-portalen-aside-highlight", o[500]), e.setProperty("--surface-portalen-footer", o[500]), e.setProperty("--surface-portalen-nav-tab-hover", o[800]), e.setProperty(
    "--surface-portalen-nav-tab-hover-text",
    n.base.neutral[1e3]
  ), e.setProperty("--surface-min-side-page-header", o[50]), e.setProperty("--surface-min-side-aside-highlight", o[50]), e.setProperty("--surface-min-side-footer", o[50]), e.setProperty("--surface-min-side-nav-tab-default-text", o[1e3]), e.setProperty("--surface-min-side-nav-tab-hover-text", o[1e3]), e.setProperty("--button-primary-text", n.base.neutral[900]);
}, Y$ = (e, t, n, r) => {
  const { primary: o, secondary: i } = t;
  e.setProperty("--surface-common-light", o[50]), e.setProperty(
    "--surface-common-card-highlight",
    r === "portal" ? o[100] : o[500]
  ), e.setProperty("--surface-common-icon-highlight", i[400]), e.setProperty("--surface-common-secondary", o[1e3]), e.setProperty("--surface-common-tooltip-text", o[1e3]), e.setProperty("--surface-common-notification", "#ef6461"), e.setProperty("--surface-portalen-page-header", o[700]), e.setProperty("--surface-portalen-aside-background", o[500]), e.setProperty("--surface-portalen-aside-highlight", o[400]), e.setProperty("--surface-portalen-aside-icon", o[200]), e.setProperty("--surface-portalen-footer", o[100]), e.setProperty("--surface-portalen-footer-text", o[500]), e.setProperty("--surface-min-side-page-header", i[400]), e.setProperty("--surface-min-side-footer", o[500]), e.setProperty("--surface-min-side-footer-text", o[100]), e.setProperty("--button-primary-default", o[500]), e.setProperty("--button-primary-hover", o[200]), e.setProperty("--button-primary-focus", o[200]), e.setProperty("--button-primary-active", o[300]), e.setProperty("--button-secondary-default", i[500]), e.setProperty("--button-secondary-hover", i[600]), e.setProperty("--button-secondary-focus", i[600]), e.setProperty("--button-secondary-active", i[700]), e.setProperty("--text-card-highlight", o[100]), e.setProperty("--button-secondary-text-active", o[1e3]), e.setProperty("--button-secondary-text-focus", o[1e3]);
}, X$ = (e, t, n, r) => {
  e.setProperty("--button-primary-text", n.base.neutral[800]), e.setProperty("--button-primary-text-hover", n.base.neutral[0]), e.setProperty("--button-primary-text-active", n.base.neutral[0]), e.setProperty("--button-primary-text-focus", n.base.neutral[0]), e.setProperty(
    "--surface-common-tooltip-text",
    n.base.neutral[800]
  ), e.setProperty("--surface-common-secondary", t.secondary[900]);
}, spe = ({ bbl: e, children: t, variant: n = "minside" }) => {
  const { default: r } = aB, o = Z$(e), i = document.documentElement.style;
  if (i) {
    switch (W$(i, o, r, n), e) {
      case K1.usbl:
        q$(i, o, r, n);
        break;
      case K1.bob:
        U$(i, o, r);
        break;
      case K1.gbbl:
        G$(i, o, r);
        break;
      case K1.kobbl:
        K$(i, o, r);
        break;
      case K1.bosor:
        Y$(i, o, r, n);
        break;
      case K1.obf:
        X$(i, o, r);
        break;
    }
    return /* @__PURE__ */ F("div", { "data-theme": e, children: [
      t,
      /* @__PURE__ */ d("div", { id: "floating-node" })
    ] });
  }
}, Q$ = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M12 14.975C11.8667 14.975 11.7417 14.9542 11.625 14.9125C11.5083 14.8708 11.4 14.8 11.3 14.7L6.69999 10.1C6.51665 9.91665 6.42499 9.68332 6.42499 9.39999C6.42499 9.11665 6.51665 8.88332 6.69999 8.69999C6.88332 8.51665 7.11665 8.42499 7.39999 8.42499C7.68332 8.42499 7.91665 8.51665 8.09999 8.69999L12 12.6L15.9 8.69999C16.0833 8.51665 16.3167 8.42499 16.6 8.42499C16.8833 8.42499 17.1167 8.51665 17.3 8.69999C17.4833 8.88332 17.575 9.11665 17.575 9.39999C17.575 9.68332 17.4833 9.91665 17.3 10.1L12.7 14.7C12.6 14.8 12.4917 14.8708 12.375 14.9125C12.2583 14.9542 12.1333 14.975 12 14.975Z",
    fill: "currentColor"
  }
) }), Gr = Q("IconChevronDown")(Q$), lpe = O.forwardRef(
  ({
    title: e = "Click to expand",
    icon: t,
    children: n,
    defaultOpen: r = !1,
    noShadow: o,
    className: i,
    rightContent: a,
    onToggle: s,
    ...l
  }, c) => {
    const [u, f] = ue(r), h = I(
      "relative space-y-2 rounded-card bg-neutral-50 p-3 shadow-card [&>button]:block [&>button]:w-full [&_.chevron-rotate]:open:!rotate-180",
      o && "shadow-none",
      i
    );
    return /* @__PURE__ */ F(
      "details",
      {
        open: u,
        className: h,
        ...l,
        ref: c,
        onToggle: (g) => {
          f(g.currentTarget.open), s?.(g.currentTarget.open);
        },
        children: [
          /* @__PURE__ */ F("summary", { className: "flex cursor-pointer justify-between [&::-webkit-details-marker]:hidden gap-2", children: [
            /* @__PURE__ */ F("div", { className: "flex w-full flex-wrap items-center justify-between gap-x-2 gap-y-1", children: [
              /* @__PURE__ */ F("span", { className: "flex items-center gap-x-half", children: [
                t,
                /* @__PURE__ */ d(Ye, { className: "font-semibold text-text-brand", children: e })
              ] }),
              a
            ] }),
            /* @__PURE__ */ d(Gr, { className: "self-center text-text-brand chevron-rotate" })
          ] }),
          u && /* @__PURE__ */ d("div", { children: n })
        ]
      }
    );
  }
), J$ = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M6 13C5.71667 13 5.47917 12.9042 5.2875 12.7125C5.09583 12.5208 5 12.2833 5 12C5 11.7167 5.09583 11.4792 5.2875 11.2875C5.47917 11.0958 5.71667 11 6 11H18C18.2833 11 18.5208 11.0958 18.7125 11.2875C18.9042 11.4792 19 11.7167 19 12C19 12.2833 18.9042 12.5208 18.7125 12.7125C18.5208 12.9042 18.2833 13 18 13H6Z",
    fill: "currentColor"
  }
) }), iO = Q("IconMinus")(J$), ej = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M11 13H6C5.71667 13 5.47917 12.9042 5.2875 12.7125C5.09583 12.5208 5 12.2833 5 12C5 11.7167 5.09583 11.4792 5.2875 11.2875C5.47917 11.0958 5.71667 11 6 11H11V6C11 5.71667 11.0958 5.47917 11.2875 5.2875C11.4792 5.09583 11.7167 5 12 5C12.2833 5 12.5208 5.09583 12.7125 5.2875C12.9042 5.47917 13 5.71667 13 6V11H18C18.2833 11 18.5208 11.0958 18.7125 11.2875C18.9042 11.4792 19 11.7167 19 12C19 12.2833 18.9042 12.5208 18.7125 12.7125C18.5208 12.9042 18.2833 13 18 13H13V18C13 18.2833 12.9042 18.5208 12.7125 18.7125C12.5208 18.9042 12.2833 19 12 19C11.7167 19 11.4792 18.9042 11.2875 18.7125C11.0958 18.5208 11 18.2833 11 18V13Z",
    fill: "currentColor"
  }
) }), tj = Q("IconPlus")(ej), nj = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 16 16", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    fill: "currentColor",
    d: "M3.333 14q-.55 0-.941-.392A1.28 1.28 0 0 1 2 12.667V3.333q0-.55.392-.941Q2.783 2 3.333 2h4q.285 0 .475.192A.65.65 0 0 1 8 2.667a.65.65 0 0 1-.192.475.65.65 0 0 1-.475.191h-4v9.334h9.334v-4q0-.285.191-.475A.65.65 0 0 1 13.333 8q.285 0 .475.192a.65.65 0 0 1 .192.475v4q0 .55-.392.941a1.28 1.28 0 0 1-.941.392zm9.334-9.733L6.933 10a.63.63 0 0 1-.466.183A.63.63 0 0 1 6 10a.63.63 0 0 1-.183-.467q0-.283.183-.466l5.733-5.734H10a.65.65 0 0 1-.475-.191.65.65 0 0 1-.192-.475q0-.285.192-.475A.65.65 0 0 1 10 2h3.333q.285 0 .475.192a.65.65 0 0 1 .192.475V6a.65.65 0 0 1-.192.475.65.65 0 0 1-.475.192.65.65 0 0 1-.475-.192.65.65 0 0 1-.191-.475z"
  }
) }), aO = Q("IconExternal")(nj), cpe = ({
  headerText: e,
  headerLevel: t = 3,
  hrefLabel: n = "Gå til administrasjon av tjeneste",
  href: r,
  collapsable: o,
  collapsableOpen: i,
  overrideOpenState: a,
  type: s = "default",
  noshadow: l,
  background: c,
  className: u,
  children: f,
  collapseIcon: h = s === "default" ? "plus/minus" : "chevron",
  ...p
}) => {
  const [C, m] = ue(a ?? i);
  ve(() => {
    a !== void 0 && m(a);
  }, [a]);
  const g = () => {
    m(!C);
  }, v = I(
    "relative flex flex-col gap-sm rounded-card p-md shadow-card md:p-lg [&>button]:block [&>button]:w-full",
    l && "shadow-none",
    c ? `bg-[${c}]` : "bg-neutral-50",
    u && u
  ), y = I(
    "flex justify-between text-text-brand [&>svg]:self-center"
  ), w = I("block"), x = I(
    "ml-auto flex w-fit items-center gap-1 font-semibold text-surface-common-primary"
  );
  return /* @__PURE__ */ F("div", { role: "group", className: v, ...p, children: [
    o ? /* @__PURE__ */ d(
      Dt,
      {
        className: "block w-full",
        "aria-label": `Toggle box ${C ? "closed" : "open"}`,
        "aria-expanded": C,
        onClick: g,
        variant: "nostyle",
        children: /* @__PURE__ */ F("div", { className: y, children: [
          /* @__PURE__ */ d(_1, { level: t, className: "text-text-brand", children: e }),
          h === "plus/minus" ? C ? /* @__PURE__ */ d(iO, { "aria-hidden": "true" }) : /* @__PURE__ */ d(tj, { "aria-hidden": "true" }) : /* @__PURE__ */ d(Gr, { flipVertical: C, "aria-hidden": "true" })
        ] })
      }
    ) : /* @__PURE__ */ d("div", { className: y, children: /* @__PURE__ */ d(_1, { level: t, className: "text-text-brand", children: e }) }),
    (C || !o) && /* @__PURE__ */ F(ut, { children: [
      /* @__PURE__ */ d("div", { className: w, children: f }),
      r && n && /* @__PURE__ */ F("a", { href: r, className: x, target: "_blank", children: [
        n,
        /* @__PURE__ */ d(aO, {})
      ] })
    ] })
  ] });
}, upe = O.forwardRef(
  ({
    afterIcon: e,
    beforeIcon: t,
    children: n,
    href: r = "",
    openInNewWindow: o = !1,
    rel: i,
    trackingName: a,
    trackingEvent: s,
    download: l,
    target: c,
    tabIndex: u = 0,
    isExternal: f = !1,
    themeBranding: h = !1,
    onClick: p,
    onMouseUp: C,
    className: m,
    ...g
  }, v) => {
    const y = (S) => {
      p && p(S);
    }, w = (S) => {
      QE(S), C && C(S);
    }, x = {};
    r && (x.href = r, x.rel = i, x.download = l, c && (x.target = c), o && (x.target = "_blank", x.rel === void 0 && (x.rel = "noopener noreferrer")));
    const b = I(
      "flex h-auto items-center gap-1 border-none bg-transparency-full !px-0 font-semibold !text-surface-common-primary underline-offset-2 outline-none",
      "cursor-pointer hover:bg-transparency-full hover:underline",
      "focus:bg-transparent focus-visible:underline",
      "active:border-none active:bg-transparency-full active:!text-text-primary active:underline active:outline-none",
      h ? "!text-text-brand hover:!text-text-brand focus:!text-text-brand" : "!text-surface-common-primary hover:!text-surface-common-primary focus:!text-surface-common-primary",
      m
    );
    return /* @__PURE__ */ F(
      "a",
      {
        ...x,
        ...g,
        ref: v,
        "data-tracking-name": a,
        "data-tracking-event": s,
        onClick: y,
        onMouseUp: w,
        download: l,
        tabIndex: u,
        className: b,
        children: [
          t || null,
          n,
          e || null,
          f && /* @__PURE__ */ d(aO, {})
        ]
      }
    );
  }
), fpe = ({
  label: e,
  text: t,
  className: n,
  rowInitial: r = !1,
  grid: o = !1,
  gap: i = "xs"
}) => {
  const a = bt(), l = I(
    "flex flex-col flex-wrap leading-none",
    r && "flex-row items-center",
    o && "grid grid-cols-1 items-center gap-xs sm:grid-cols-2",
    {
      xs: "gap-xs",
      sm: "gap-sm",
      md: "gap-md",
      lg: "gap-lg"
    }[i],
    n
  );
  return /* @__PURE__ */ F("div", { className: l, children: [
    /* @__PURE__ */ d(Ut, { htmlFor: a, weight: "semibold", children: e }),
    /* @__PURE__ */ d(Rt, { id: a, weight: "normal", children: t })
  ] });
}, rj = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M10.8 12L14.7 15.9C14.8833 16.0833 14.975 16.3167 14.975 16.6C14.975 16.8833 14.8833 17.1167 14.7 17.3C14.5167 17.4833 14.2833 17.575 14 17.575C13.7167 17.575 13.4833 17.4833 13.3 17.3L8.69999 12.7C8.59999 12.6 8.52915 12.4917 8.48749 12.375C8.44582 12.2583 8.42499 12.1333 8.42499 12C8.42499 11.8667 8.44582 11.7417 8.48749 11.625C8.52915 11.5083 8.59999 11.4 8.69999 11.3L13.3 6.69999C13.4833 6.51665 13.7167 6.42499 14 6.42499C14.2833 6.42499 14.5167 6.51665 14.7 6.69999C14.8833 6.88332 14.975 7.11665 14.975 7.39999C14.975 7.68332 14.8833 7.91665 14.7 8.09999L10.8 12Z",
    fill: "currentColor "
  }
) }), qr = Q("IconChevronLeft")(rj);
var oj = Object.defineProperty, ij = Object.defineProperties, aj = Object.getOwnPropertyDescriptors, xg = Object.getOwnPropertySymbols, sj = Object.prototype.hasOwnProperty, lj = Object.prototype.propertyIsEnumerable, Sg = (e, t, n) => t in e ? oj(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, u7 = (e, t) => {
  for (var n in t || (t = {}))
    sj.call(t, n) && Sg(e, n, t[n]);
  if (xg)
    for (var n of xg(t))
      lj.call(t, n) && Sg(e, n, t[n]);
  return e;
}, cj = (e, t) => ij(e, aj(t)), sO = O.createContext(
  {}
), uj = sO.Provider, Du = () => Oe(sO);
function fj(e, t, n = !0) {
  const r = ke();
  ve(() => {
    r.current = e;
  }, [e]), ve(() => {
    if (n && t !== null) {
      const o = setInterval(() => {
        r.current && r.current();
      }, t);
      return () => clearInterval(o);
    }
  }, [t, n]);
}
function dj({
  totalPages: e,
  wrapMode: t,
  initialPage: n
}) {
  const [r, o] = ue(0);
  return ve(() => {
    n && o(Math.max(0, Math.min(n, e)));
  }, [n, e]), { currentPage: r, goToPage: (l) => {
    l < 0 || l >= e || o(l);
  }, goForward: () => {
    o(t === "wrap" ? (l) => (l + 1) % e : (l) => Math.min(l + 1, e - 1));
  }, goBack: () => {
    o(t === "wrap" ? (l) => (l - 1 + e) % e : (l) => Math.max(l - 1, 0));
  } };
}
function f7(e, t) {
  return new Array(e).fill(0).map((n, r) => r * t);
}
function hj(e) {
  let t = 0;
  return e.map((n) => t += n);
}
var lO = () => typeof window < "u";
function i5(...e) {
  return e.filter(Boolean).join(" ");
}
function Mg(e) {
  return "clientY" in e;
}
function pj(e) {
  const [t, n] = ue();
  return ve(() => {
    if (!e.current) return;
    const r = e.current, o = new ResizeObserver(
      () => n(r.getBoundingClientRect())
    );
    return o.observe(r), () => {
      o.unobserve(r);
    };
  }, [e]), t;
}
function mj({ element: e, scrollDistance: t }) {
  const [n, r] = ue(0), [o, i] = ue(f7(n, 0)), a = pj(e);
  return ve(() => {
    var s;
    const l = e.current;
    if (!(l && a)) return;
    const c = l.scrollWidth, u = l.offsetWidth, f = c - u;
    if (u !== 0)
      switch (t) {
        case "screen": {
          const h = Math.round(c / u);
          r(h), i(f7(h, u));
          break;
        }
        case "slide": {
          const h = ((s = l.querySelector("#nuka-wrapper")) == null ? void 0 : s.children) || [], p = Array.from(h).map(
            (g) => g.offsetWidth
          ), C = hj([0, ...p.slice(0, -1)]), m = C.findIndex((g) => g >= f) + 1;
          r(m), i(C);
          break;
        }
        default:
          if (typeof t == "number" && t > 0) {
            const h = Math.ceil(f / t) + 1;
            r(h), i(f7(h, t));
          }
      }
  }, [e, t, a]), { totalPages: n, scrollOffset: o };
}
function Eg({
  element: e,
  enabled: t
}) {
  const [n, r] = ue(!1), o = e?.current;
  return ve(() => {
    if (o && o.addEventListener && t) {
      const i = () => r(!0), a = () => r(!1);
      return o.addEventListener("mouseover", i), o.addEventListener("mouseout", a), () => {
        o.removeEventListener("mouseover", i), o.removeEventListener("mouseout", a);
      };
    }
  }, [o, t]), n;
}
function gj({
  element: e,
  enabled: t,
  goForward: n,
  goBack: r
}) {
  const o = e?.current;
  ve(() => {
    if (o && t) {
      const i = (a) => {
        a.key === "ArrowLeft" ? r() : a.key === "ArrowRight" && n();
      };
      return o.addEventListener("keydown", i), () => o.removeEventListener("keydown", i);
    }
  }, [t, r, n, o]);
}
var cO = "(prefers-reduced-motion: no-preference)", Cj = () => lO() ? !window.matchMedia(cO).matches : !0;
function vj({ enabled: e }) {
  const [t, n] = ue(Cj);
  return ve(() => {
    if (!(lO() && e)) return;
    const r = window.matchMedia(cO), o = (i) => {
      n(!i.matches);
    };
    return r.addEventListener("change", o), () => {
      r.removeEventListener("change", o);
    };
  }, [e]), t;
}
function yj() {
  const { currentPage: e, totalPages: t, wrapMode: n, goBack: r, goForward: o } = Du(), i = n !== "nowrap", a = i || e > 0, s = i || e < t - 1, l = i5(
    "nuka-nav-button",
    "nuka-nav-button-prev",
    a && "nuka-nav-button-enabled"
  ), c = i5(
    "nuka-nav-button",
    "nuka-nav-button-next",
    s && "nuka-nav-button-enabled"
  );
  return /* @__PURE__ */ F(ut, { children: [
    /* @__PURE__ */ d("div", { className: l, onClick: r, children: /* @__PURE__ */ d(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentcolor",
        children: /* @__PURE__ */ d(
          "path",
          {
            fillRule: "evenodd",
            d: "M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z",
            clipRule: "evenodd"
          }
        )
      }
    ) }),
    /* @__PURE__ */ d("div", { className: c, onClick: o, children: /* @__PURE__ */ d(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentcolor",
        children: /* @__PURE__ */ d(
          "path",
          {
            fillRule: "evenodd",
            d: "M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z",
            clipRule: "evenodd"
          }
        )
      }
    ) })
  ] });
}
var bj = () => {
  const { totalPages: e, currentPage: t, goToPage: n } = Du(), r = (o) => i5(
    "nuka-page-indicator",
    t === o ? "nuka-page-indicator-active" : ""
  );
  return /* @__PURE__ */ d("div", { className: "nuka-page-container", "data-testid": "pageIndicatorContainer", children: [...Array(e)].map((o, i) => /* @__PURE__ */ d(
    "button",
    {
      onClick: () => n(i),
      className: r(i),
      children: /* @__PURE__ */ d("span", { className: "nuka-hidden", children: i + 1 })
    },
    i
  )) });
};
function wj(e, { insertAt: t } = {}) {
  if (typeof document > "u") return;
  const n = document.head || document.getElementsByTagName("head")[0], r = document.createElement("style");
  r.type = "text/css", t === "top" && n.firstChild ? n.insertBefore(r, n.firstChild) : n.appendChild(r), r.styleSheet ? r.styleSheet.cssText = e : r.appendChild(document.createTextNode(e));
}
wj(`.nuka-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.nuka-container {
  position: relative;
}
.nuka-slide-container {
  position: relative;
}
.nuka-overflow {
  overflow: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.nuka-overflow.scroll-smooth {
  scroll-behavior: smooth;
}
.nuka-overflow.scroll-auto {
  scroll-behavior: auto;
}
.nuka-overflow::-webkit-scrollbar {
  display: none;
}
.nuka-wrapper {
  display: flex;
}
.nuka-nav-button {
  position: absolute;
  top: calc(50% - 2rem);
  margin: 1rem;
  display: none;
  height: 2rem;
  width: 2rem;
  cursor: pointer;
  background-color: rgba(146, 148, 151, 0.5);
  color: white;
  border-radius: 9999px;
  font-size: 1rem;
  user-select: none;
}
.nuka-nav-button.nuka-nav-button-prev {
  left: 0;
  margin-right: 1rem;
}
.nuka-nav-button.nuka-nav-button-next {
  right: 0;
  margin-left: 1rem;
}
.nuka-nav-button:hover {
  background-color: rgba(146, 148, 151, 0.65);
}
.nuka-nav-button-enabled {
  display: block;
}
.nuka-container-auto-hide .nuka-nav-button {
  display: none;
}
.nuka-container-auto-hide:hover .nuka-nav-button-enabled {
  display: block;
}
.nuka-page-container {
  padding-top: 1rem;
  padding-bottom: 1rem;
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;
}
.nuka-page-indicator {
  width: 0.75rem;
  height: 0.75rem;
  cursor: pointer;
  border-radius: 9999px;
  border-style: none;
  background-color: rgba(146, 148, 151, 0.65);
}
.nuka-page-indicator.nuka-page-indicator-active,
.nuka-page-indicator.nuka-page-indicator-active:hover {
  background-color: rgb(229 231 235 / 1);
}
.nuka-page-indicator:hover {
  background-color: rgb(229 231 235 / 1);
}
`);
var xj = {
  arrows: /* @__PURE__ */ d(yj, {}),
  autoplay: !1,
  autoplayInterval: 3e3,
  dots: /* @__PURE__ */ d(bj, {}),
  id: "nuka-carousel",
  keyboard: !0,
  minSwipeDistance: 50,
  scrollDistance: "screen",
  showArrows: !1,
  showDots: !1,
  swiping: !0,
  wrapMode: "nowrap"
}, Zd = Xe(
  (e, t) => {
    const n = u7(u7({}, xj), e), {
      afterSlide: r,
      arrows: o,
      autoplay: i,
      autoplayInterval: a,
      beforeSlide: s,
      children: l,
      className: c,
      dots: u,
      id: f,
      keyboard: h,
      minSwipeDistance: p,
      scrollDistance: C,
      showArrows: m,
      showDots: g,
      swiping: v,
      title: y,
      wrapMode: w,
      initialPage: x
    } = n, b = ke(null), S = ke(null), M = ke(-1), E = ke(null), { totalPages: P, scrollOffset: T } = mj({
      element: S,
      scrollDistance: C
    }), { currentPage: _, goBack: D, goForward: N, goToPage: R } = dj({
      totalPages: P,
      wrapMode: w,
      initialPage: x
    }), [L, B] = ue(null), [V, k] = ue(null), z = (ee) => {
      v && (k(null), B(Mg(ee) ? ee.clientX : ee.targetTouches[0].clientX));
    }, $ = (ee) => {
      v && k(Mg(ee) ? ee.clientX : ee.targetTouches[0].clientX);
    }, Z = () => {
      if (!v || !S.current || !L || !V) return;
      const ee = L - V, U = ee > p, X = ee < -p;
      (U || X) && (U ? N() : D());
    };
    gj({
      element: b,
      enabled: h,
      goForward: N,
      goBack: D
    }), Ad(t, () => ({ goForward: N, goBack: D, goToPage: R }), [
      N,
      D,
      R
    ]);
    const W = Eg({ element: S, enabled: i }), H = Eg({
      element: E,
      enabled: i && m === !0
    }), G = vj({ enabled: i });
    fj(N, a, i && !(W || G || H)), ve(() => {
      if (S.current) {
        const ee = M.current, U = _;
        s && s(ee, U), S.current.scrollLeft = T[_], r && setTimeout(() => r(U), 0), M.current = _, (x === void 0 || _ === x) && (S.current.classList.remove("scroll-auto"), S.current.classList.add("scroll-smooth"));
      }
    }, [_, T, s, r, x]);
    const ne = i5(
      "nuka-container",
      m === "hover" && "nuka-container-auto-hide",
      c
    ), J = cj(u7({}, n), {
      totalPages: P,
      currentPage: _,
      scrollOffset: T,
      goBack: D,
      goForward: N,
      goToPage: R
    });
    return /* @__PURE__ */ F(uj, { value: J, children: [
      /* @__PURE__ */ F(
        "div",
        {
          className: ne,
          "aria-labelledby": "nuka-carousel-heading",
          tabIndex: h ? 0 : void 0,
          ref: b,
          id: f,
          children: [
            y && /* @__PURE__ */ d("h3", { id: "nuka-carousel-heading", className: "nuka-hidden", children: y }),
            /* @__PURE__ */ F("div", { className: "nuka-slide-container", children: [
              /* @__PURE__ */ d(
                "div",
                {
                  className: "nuka-overflow",
                  ref: S,
                  onTouchEnd: Z,
                  onTouchMove: $,
                  onTouchStart: z,
                  id: "nuka-overflow",
                  "data-testid": "nuka-overflow",
                  style: { touchAction: "pan-y" },
                  children: /* @__PURE__ */ d(
                    "div",
                    {
                      className: "nuka-wrapper",
                      id: "nuka-wrapper",
                      "data-testid": "nuka-wrapper",
                      children: l
                    }
                  )
                }
              ),
              m && /* @__PURE__ */ d("div", { ref: E, children: o })
            ] })
          ]
        }
      ),
      g && u
    ] });
  }
);
Zd.displayName = "Carousel";
const Sj = (e) => {
  let t = "";
  const n = window.URL || window.webkitURL;
  return e && (t = n.createObjectURL(e)), t;
}, Mj = ({
  src: e,
  alt: t,
  blob: n,
  height: r,
  width: o,
  responsive: i,
  objectFit: a,
  radius: s,
  withPlaceholder: l,
  fallbackUrl: c,
  interactive: u,
  ...f
}) => {
  const [h, p] = ue(!1), [C, m] = ue(
    e || n && Sj(n) || void 0
  ), g = _e(() => !h && l ? "Laster bilde..." : C ? t : "Bilde ikke tilgjengelig", [h, C, t]), v = () => {
    p(!0);
  }, y = () => {
    m(c), p(!1);
  }, w = I(i && "h-auto max-w-full");
  return /* @__PURE__ */ d(
    "img",
    {
      src: C,
      alt: g,
      onLoad: l ? () => v() : void 0,
      onError: c ? () => y() : void 0,
      style: {
        height: r,
        width: o,
        objectFit: a || "contain",
        backgroundColor: l && !h ? "red" : "transparent",
        borderRadius: s || "0"
      },
      className: w,
      tabIndex: u ? 0 : void 0,
      role: u ? "button" : void 0,
      ...f
    }
  );
}, Ej = ({ onClose: e }) => {
  const { currentPage: t, goBack: n, goForward: r, totalPages: o } = Du(), i = t + 1 > 1, a = t + 1 < o;
  return /* @__PURE__ */ F(
    "div",
    {
      className: "absolute top-0 mt-xs flex w-full items-center justify-between gap-sm",
      onClick: () => {
        e();
      },
      children: [
        /* @__PURE__ */ d(
          "button",
          {
            className: "fixed right-5 top-5 rounded-lg border-none bg-black/90 p-sm text-white outline-none",
            onClick: e,
            "aria-label": "Lukk bildevisning",
            children: /* @__PURE__ */ d(Wr, {})
          }
        ),
        i && /* @__PURE__ */ d(
          "button",
          {
            className: "fixed top-1/2 rounded-full border-none bg-black/90 p-xs text-white outline-none",
            onClick: n,
            children: /* @__PURE__ */ d(qr, { className: "text-white" })
          }
        ),
        /* @__PURE__ */ d("div", { className: "fixed bottom-0 left-1/2 mb-[0.2em] flex content-center rounded-md bg-black/80 px-[1rem] py-[0.25rem]", children: /* @__PURE__ */ F(Ye, { className: "text-white", children: [
          t + 1,
          " / ",
          o
        ] }) }),
        a && /* @__PURE__ */ d(
          "button",
          {
            className: "fixed right-5 top-1/2 rounded-full border-none bg-black/80 p-xs text-white outline-none",
            onClick: r,
            children: /* @__PURE__ */ d(yo, { className: "text-white" })
          }
        )
      ]
    }
  );
}, dpe = ({
  images: e,
  initialImage: t = 0,
  onClose: n,
  swiping: r = !0,
  ...o
}) => {
  const [i, a] = ue(!1);
  return ve(() => {
    const s = (l) => {
      l.key === "Escape" && n();
    };
    return document.addEventListener("keydown", s), () => {
      document.removeEventListener("keydown", s);
    };
  }, []), /* @__PURE__ */ d("div", { className: "fixed inset-0 left-0 top-0 z-[1001] flex h-full w-full items-center justify-center bg-black/60", children: /* @__PURE__ */ F(
    "div",
    {
      role: "dialog",
      "aria-modal": !0,
      "aria-labelledby": "carousel-heading",
      className: "h-full w-full",
      children: [
        /* @__PURE__ */ d("div", { id: "carousel-heading", className: "hidden", children: "Bildevisning" }),
        /* @__PURE__ */ d(
          Zd,
          {
            className: "ring-none border-none outline-none [&>div>div>div]:!gap-md",
            scrollDistance: "screen",
            initialPage: t,
            showArrows: !0,
            keyboard: !0,
            wrapMode: "wrap",
            arrows: /* @__PURE__ */ d(Ej, { onClose: n }),
            swiping: r,
            ...o,
            children: e.map((s, l) => /* @__PURE__ */ d(
              "div",
              {
                className: "flex h-screen w-screen items-center justify-center",
                children: /* @__PURE__ */ d(
                  Mj,
                  {
                    src: s,
                    alt: `Bilde ${l + 1} av ${e.length}`,
                    className: I(
                      "h-auto min-h-[100px] min-w-[100px] max-w-[70vw] cursor-zoom-in object-contain transition-all duration-200",
                      i && "min-w-[90vw] cursor-zoom-out"
                    ),
                    onClick: () => a(!i)
                  },
                  l
                )
              },
              l
            ))
          }
        )
      ]
    }
  ) });
}, _j = ({
  src: e,
  intersectionObserver: t = !1,
  controls: n = !0,
  poster: r,
  playing: o = !1,
  autoPlay: i = !1,
  height: a = "auto",
  width: s = "100%",
  onPause: l,
  onPlay: c,
  muted: u = !1,
  loop: f = !1,
  preload: h = "metadata",
  className: p,
  wrapperClassName: C,
  ...m
}) => {
  const g = ke(null), v = ke(null), [y, w] = ue(!1), [x, b] = ue(o), S = {
    root: null,
    rootMargin: "0px",
    threshold: 0.5
  }, M = (T) => {
    const [_] = T;
    _.isIntersecting && (i || y) ? (b(!0), g.current?.play().catch((D) => console.error("Error playing video:", D))) : (b(!1), g.current?.pause());
  };
  ve(() => {
    if (!t || !window.IntersectionObserver) return;
    const T = new IntersectionObserver(
      M,
      S
    ), _ = v.current;
    return _ && T.observe(_), () => {
      _ && T.unobserve(_);
    };
  }, [v.current, S, t]), ve(() => {
    x && g.current ? g.current.play().catch((T) => console.error("Error playing video:", T)) : !x && g.current && g.current.pause();
  }, [x]), ve(() => {
    b(o);
  }, [o]);
  const E = () => {
    w(!0), b(!0), c && c();
  }, P = () => {
    w(!1), b(!1), l && l();
  };
  return /* @__PURE__ */ d(
    "div",
    {
      className: I(
        "flex h-auto w-full items-center justify-center",
        C
      ),
      ref: v,
      children: /* @__PURE__ */ d(
        "video",
        {
          ref: g,
          className: p,
          src: e,
          poster: r,
          controls: n,
          width: s !== "auto" ? s : void 0,
          height: a !== "auto" ? a : void 0,
          style: {
            width: s === "auto" ? "auto" : s,
            height: a === "auto" ? "auto" : a
          },
          muted: u,
          loop: f,
          preload: h,
          onPlay: E,
          onPause: P,
          ...m
        }
      )
    }
  );
}, Oj = ({ media: e }) => {
  const { currentPage: t, goBack: n, goForward: r, totalPages: o } = Du(), i = t > 0, a = t + 1 < o;
  return e.length === 1 ? null : /* @__PURE__ */ F("div", { className: "mt-xs flex items-center justify-center gap-sm", children: [
    /* @__PURE__ */ d("div", { className: "flex h-2 w-2 items-center justify-center", children: i && /* @__PURE__ */ d(
      "button",
      {
        className: "rounded-full border-none bg-black/60 outline-none",
        onClick: n,
        children: /* @__PURE__ */ d(qr, { className: "text-white" })
      }
    ) }),
    /* @__PURE__ */ d("div", { className: "flex content-center rounded-md bg-black/60 px-[1rem] py-[0.25rem]", children: /* @__PURE__ */ F(Ye, { className: "text-white", children: [
      t + 1,
      " / ",
      o
    ] }) }),
    /* @__PURE__ */ d("div", { className: "flex h-2 w-2 items-center justify-center", children: a && /* @__PURE__ */ d(
      "button",
      {
        className: "rounded-full border-none bg-black/60 outline-none",
        onClick: r,
        children: /* @__PURE__ */ d(yo, { className: "text-white" })
      }
    ) })
  ] });
}, hpe = ({
  media: e,
  autoPlay: t = !1,
  className: n,
  altText: r = "Karusellbilde",
  wrapperClassName: o,
  aspectRatio: i = "aspect-[16/9]"
}) => {
  const a = e?.length > 1, s = I(n, "h-full w-full"), l = ({ mediaItem: c }) => {
    const u = !!c.mimeType?.includes("video"), f = I(
      o,
      "h-screen max-h-[300px] w-full",
      i
    );
    return /* @__PURE__ */ d("div", { className: f, children: u ? /* @__PURE__ */ d(
      _j,
      {
        src: c.src,
        autoPlay: t,
        wrapperClassName: I(s, "object-cover")
      }
    ) : /* @__PURE__ */ d(
      "img",
      {
        src: c.src,
        alt: r,
        className: I(s, "object-cover")
      }
    ) });
  };
  return /* @__PURE__ */ d("div", { className: "h-full min-h-[300px] w-full", children: /* @__PURE__ */ d(
    Zd,
    {
      className: "ring-none h-full w-full border-none outline-none [&>div>div>div]:!gap-md [&_.slider-slide]:!w-full",
      scrollDistance: "screen",
      keyboard: !0,
      swiping: a,
      showArrows: a,
      arrows: /* @__PURE__ */ d(Oj, { media: e }),
      autoplay: t,
      wrapMode: "nowrap",
      children: e.map((c, u) => /* @__PURE__ */ d(l, { mediaItem: c }, u))
    }
  ) });
}, Eo = O.forwardRef(
  ({ children: e, ...t }, n) => /* @__PURE__ */ d(
    Rt,
    {
      ref: n,
      className: "leading-[18px] text-ui-errorDark",
      size: "small",
      ...t,
      children: e
    }
  )
), Go = O.forwardRef(
  ({ children: e, ...t }, n) => /* @__PURE__ */ d(
    Rt,
    {
      ref: n,
      color: "subtle",
      className: "leading-[18px]",
      size: "small",
      ...t,
      children: e
    }
  )
);
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function g1(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function cr(e, t) {
  return (n) => {
    t.setState((r) => ({
      ...r,
      [e]: g1(n, r[e])
    }));
  };
}
function Ru(e) {
  return e instanceof Function;
}
function Aj(e) {
  return Array.isArray(e) && e.every((t) => typeof t == "number");
}
function Pj(e, t) {
  const n = [], r = (o) => {
    o.forEach((i) => {
      n.push(i);
      const a = t(i);
      a != null && a.length && r(a);
    });
  };
  return r(e), n;
}
function Ae(e, t, n) {
  let r = [], o;
  return (i) => {
    let a;
    n.key && n.debug && (a = Date.now());
    const s = e(i);
    if (!(s.length !== r.length || s.some((u, f) => r[f] !== u)))
      return o;
    r = s;
    let c;
    if (n.key && n.debug && (c = Date.now()), o = t(...s), n == null || n.onChange == null || n.onChange(o), n.key && n.debug && n != null && n.debug()) {
      const u = Math.round((Date.now() - a) * 100) / 100, f = Math.round((Date.now() - c) * 100) / 100, h = f / 16, p = (C, m) => {
        for (C = String(C); C.length < m; )
          C = " " + C;
        return C;
      };
      console.info(`%c⏱ ${p(f, 5)} /${p(u, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * h, 120))}deg 100% 31%);`, n?.key);
    }
    return o;
  };
}
function Pe(e, t, n, r) {
  return {
    debug: () => {
      var o;
      return (o = e?.debugAll) != null ? o : e[t];
    },
    key: process.env.NODE_ENV === "development" && n,
    onChange: r
  };
}
function Tj(e, t, n, r) {
  const o = () => {
    var a;
    return (a = i.getValue()) != null ? a : e.options.renderFallbackValue;
  }, i = {
    id: `${t.id}_${n.id}`,
    row: t,
    column: n,
    getValue: () => t.getValue(r),
    renderValue: o,
    getContext: Ae(() => [e, n, t, i], (a, s, l, c) => ({
      table: a,
      column: s,
      row: l,
      cell: c,
      getValue: c.getValue,
      renderValue: c.renderValue
    }), Pe(e.options, "debugCells", "cell.getContext"))
  };
  return e._features.forEach((a) => {
    a.createCell == null || a.createCell(i, n, t, e);
  }, {}), i;
}
function Ij(e, t, n, r) {
  var o, i;
  const s = {
    ...e._getDefaultColumnDef(),
    ...t
  }, l = s.accessorKey;
  let c = (o = (i = s.id) != null ? i : l ? typeof String.prototype.replaceAll == "function" ? l.replaceAll(".", "_") : l.replace(/\./g, "_") : void 0) != null ? o : typeof s.header == "string" ? s.header : void 0, u;
  if (s.accessorFn ? u = s.accessorFn : l && (l.includes(".") ? u = (h) => {
    let p = h;
    for (const m of l.split(".")) {
      var C;
      p = (C = p) == null ? void 0 : C[m], process.env.NODE_ENV !== "production" && p === void 0 && console.warn(`"${m}" in deeply nested key "${l}" returned undefined.`);
    }
    return p;
  } : u = (h) => h[s.accessorKey]), !c)
    throw process.env.NODE_ENV !== "production" ? new Error(s.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let f = {
    id: `${String(c)}`,
    accessorFn: u,
    parent: r,
    depth: n,
    columnDef: s,
    columns: [],
    getFlatColumns: Ae(() => [!0], () => {
      var h;
      return [f, ...(h = f.columns) == null ? void 0 : h.flatMap((p) => p.getFlatColumns())];
    }, Pe(e.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: Ae(() => [e._getOrderColumnsFn()], (h) => {
      var p;
      if ((p = f.columns) != null && p.length) {
        let C = f.columns.flatMap((m) => m.getLeafColumns());
        return h(C);
      }
      return [f];
    }, Pe(e.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const h of e._features)
    h.createColumn == null || h.createColumn(f, e);
  return f;
}
const _n = "debugHeaders";
function _g(e, t, n) {
  var r;
  let i = {
    id: (r = n.id) != null ? r : t.id,
    column: t,
    index: n.index,
    isPlaceholder: !!n.isPlaceholder,
    placeholderId: n.placeholderId,
    depth: n.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const a = [], s = (l) => {
        l.subHeaders && l.subHeaders.length && l.subHeaders.map(s), a.push(l);
      };
      return s(i), a;
    },
    getContext: () => ({
      table: e,
      header: i,
      column: t
    })
  };
  return e._features.forEach((a) => {
    a.createHeader == null || a.createHeader(i, e);
  }), i;
}
const Dj = {
  createTable: (e) => {
    e.getHeaderGroups = Ae(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r, o) => {
      var i, a;
      const s = (i = r?.map((f) => n.find((h) => h.id === f)).filter(Boolean)) != null ? i : [], l = (a = o?.map((f) => n.find((h) => h.id === f)).filter(Boolean)) != null ? a : [], c = n.filter((f) => !(r != null && r.includes(f.id)) && !(o != null && o.includes(f.id)));
      return rc(t, [...s, ...c, ...l], e);
    }, Pe(e.options, _n, "getHeaderGroups")), e.getCenterHeaderGroups = Ae(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r, o) => (n = n.filter((i) => !(r != null && r.includes(i.id)) && !(o != null && o.includes(i.id))), rc(t, n, e, "center")), Pe(e.options, _n, "getCenterHeaderGroups")), e.getLeftHeaderGroups = Ae(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left], (t, n, r) => {
      var o;
      const i = (o = r?.map((a) => n.find((s) => s.id === a)).filter(Boolean)) != null ? o : [];
      return rc(t, i, e, "left");
    }, Pe(e.options, _n, "getLeftHeaderGroups")), e.getRightHeaderGroups = Ae(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.right], (t, n, r) => {
      var o;
      const i = (o = r?.map((a) => n.find((s) => s.id === a)).filter(Boolean)) != null ? o : [];
      return rc(t, i, e, "right");
    }, Pe(e.options, _n, "getRightHeaderGroups")), e.getFooterGroups = Ae(() => [e.getHeaderGroups()], (t) => [...t].reverse(), Pe(e.options, _n, "getFooterGroups")), e.getLeftFooterGroups = Ae(() => [e.getLeftHeaderGroups()], (t) => [...t].reverse(), Pe(e.options, _n, "getLeftFooterGroups")), e.getCenterFooterGroups = Ae(() => [e.getCenterHeaderGroups()], (t) => [...t].reverse(), Pe(e.options, _n, "getCenterFooterGroups")), e.getRightFooterGroups = Ae(() => [e.getRightHeaderGroups()], (t) => [...t].reverse(), Pe(e.options, _n, "getRightFooterGroups")), e.getFlatHeaders = Ae(() => [e.getHeaderGroups()], (t) => t.map((n) => n.headers).flat(), Pe(e.options, _n, "getFlatHeaders")), e.getLeftFlatHeaders = Ae(() => [e.getLeftHeaderGroups()], (t) => t.map((n) => n.headers).flat(), Pe(e.options, _n, "getLeftFlatHeaders")), e.getCenterFlatHeaders = Ae(() => [e.getCenterHeaderGroups()], (t) => t.map((n) => n.headers).flat(), Pe(e.options, _n, "getCenterFlatHeaders")), e.getRightFlatHeaders = Ae(() => [e.getRightHeaderGroups()], (t) => t.map((n) => n.headers).flat(), Pe(e.options, _n, "getRightFlatHeaders")), e.getCenterLeafHeaders = Ae(() => [e.getCenterFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), Pe(e.options, _n, "getCenterLeafHeaders")), e.getLeftLeafHeaders = Ae(() => [e.getLeftFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), Pe(e.options, _n, "getLeftLeafHeaders")), e.getRightLeafHeaders = Ae(() => [e.getRightFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), Pe(e.options, _n, "getRightLeafHeaders")), e.getLeafHeaders = Ae(() => [e.getLeftHeaderGroups(), e.getCenterHeaderGroups(), e.getRightHeaderGroups()], (t, n, r) => {
      var o, i, a, s, l, c;
      return [...(o = (i = t[0]) == null ? void 0 : i.headers) != null ? o : [], ...(a = (s = n[0]) == null ? void 0 : s.headers) != null ? a : [], ...(l = (c = r[0]) == null ? void 0 : c.headers) != null ? l : []].map((u) => u.getLeafHeaders()).flat();
    }, Pe(e.options, _n, "getLeafHeaders"));
  }
};
function rc(e, t, n, r) {
  var o, i;
  let a = 0;
  const s = function(h, p) {
    p === void 0 && (p = 1), a = Math.max(a, p), h.filter((C) => C.getIsVisible()).forEach((C) => {
      var m;
      (m = C.columns) != null && m.length && s(C.columns, p + 1);
    }, 0);
  };
  s(e);
  let l = [];
  const c = (h, p) => {
    const C = {
      depth: p,
      id: [r, `${p}`].filter(Boolean).join("_"),
      headers: []
    }, m = [];
    h.forEach((g) => {
      const v = [...m].reverse()[0], y = g.column.depth === C.depth;
      let w, x = !1;
      if (y && g.column.parent ? w = g.column.parent : (w = g.column, x = !0), v && v?.column === w)
        v.subHeaders.push(g);
      else {
        const b = _g(n, w, {
          id: [r, p, w.id, g?.id].filter(Boolean).join("_"),
          isPlaceholder: x,
          placeholderId: x ? `${m.filter((S) => S.column === w).length}` : void 0,
          depth: p,
          index: m.length
        });
        b.subHeaders.push(g), m.push(b);
      }
      C.headers.push(g), g.headerGroup = C;
    }), l.push(C), p > 0 && c(m, p - 1);
  }, u = t.map((h, p) => _g(n, h, {
    depth: a,
    index: p
  }));
  c(u, a - 1), l.reverse();
  const f = (h) => h.filter((C) => C.column.getIsVisible()).map((C) => {
    let m = 0, g = 0, v = [0];
    C.subHeaders && C.subHeaders.length ? (v = [], f(C.subHeaders).forEach((w) => {
      let {
        colSpan: x,
        rowSpan: b
      } = w;
      m += x, v.push(b);
    })) : m = 1;
    const y = Math.min(...v);
    return g = g + y, C.colSpan = m, C.rowSpan = g, {
      colSpan: m,
      rowSpan: g
    };
  });
  return f((o = (i = l[0]) == null ? void 0 : i.headers) != null ? o : []), l;
}
const Wd = (e, t, n, r, o, i, a) => {
  let s = {
    id: t,
    index: r,
    original: n,
    depth: o,
    parentId: a,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (l) => {
      if (s._valuesCache.hasOwnProperty(l))
        return s._valuesCache[l];
      const c = e.getColumn(l);
      if (c != null && c.accessorFn)
        return s._valuesCache[l] = c.accessorFn(s.original, r), s._valuesCache[l];
    },
    getUniqueValues: (l) => {
      if (s._uniqueValuesCache.hasOwnProperty(l))
        return s._uniqueValuesCache[l];
      const c = e.getColumn(l);
      if (c != null && c.accessorFn)
        return c.columnDef.getUniqueValues ? (s._uniqueValuesCache[l] = c.columnDef.getUniqueValues(s.original, r), s._uniqueValuesCache[l]) : (s._uniqueValuesCache[l] = [s.getValue(l)], s._uniqueValuesCache[l]);
    },
    renderValue: (l) => {
      var c;
      return (c = s.getValue(l)) != null ? c : e.options.renderFallbackValue;
    },
    subRows: [],
    getLeafRows: () => Pj(s.subRows, (l) => l.subRows),
    getParentRow: () => s.parentId ? e.getRow(s.parentId, !0) : void 0,
    getParentRows: () => {
      let l = [], c = s;
      for (; ; ) {
        const u = c.getParentRow();
        if (!u) break;
        l.push(u), c = u;
      }
      return l.reverse();
    },
    getAllCells: Ae(() => [e.getAllLeafColumns()], (l) => l.map((c) => Tj(e, s, c, c.id)), Pe(e.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: Ae(() => [s.getAllCells()], (l) => l.reduce((c, u) => (c[u.column.id] = u, c), {}), Pe(e.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let l = 0; l < e._features.length; l++) {
    const c = e._features[l];
    c == null || c.createRow == null || c.createRow(s, e);
  }
  return s;
}, Rj = {
  createColumn: (e, t) => {
    e._getFacetedRowModel = t.options.getFacetedRowModel && t.options.getFacetedRowModel(t, e.id), e.getFacetedRowModel = () => e._getFacetedRowModel ? e._getFacetedRowModel() : t.getPreFilteredRowModel(), e._getFacetedUniqueValues = t.options.getFacetedUniqueValues && t.options.getFacetedUniqueValues(t, e.id), e.getFacetedUniqueValues = () => e._getFacetedUniqueValues ? e._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getFacetedMinMaxValues = t.options.getFacetedMinMaxValues && t.options.getFacetedMinMaxValues(t, e.id), e.getFacetedMinMaxValues = () => {
      if (e._getFacetedMinMaxValues)
        return e._getFacetedMinMaxValues();
    };
  }
}, uO = (e, t, n) => {
  var r, o;
  const i = n == null || (r = n.toString()) == null ? void 0 : r.toLowerCase();
  return !!(!((o = e.getValue(t)) == null || (o = o.toString()) == null || (o = o.toLowerCase()) == null) && o.includes(i));
};
uO.autoRemove = (e) => zr(e);
const fO = (e, t, n) => {
  var r;
  return !!(!((r = e.getValue(t)) == null || (r = r.toString()) == null) && r.includes(n));
};
fO.autoRemove = (e) => zr(e);
const dO = (e, t, n) => {
  var r;
  return ((r = e.getValue(t)) == null || (r = r.toString()) == null ? void 0 : r.toLowerCase()) === n?.toLowerCase();
};
dO.autoRemove = (e) => zr(e);
const hO = (e, t, n) => {
  var r;
  return (r = e.getValue(t)) == null ? void 0 : r.includes(n);
};
hO.autoRemove = (e) => zr(e);
const pO = (e, t, n) => !n.some((r) => {
  var o;
  return !((o = e.getValue(t)) != null && o.includes(r));
});
pO.autoRemove = (e) => zr(e) || !(e != null && e.length);
const mO = (e, t, n) => n.some((r) => {
  var o;
  return (o = e.getValue(t)) == null ? void 0 : o.includes(r);
});
mO.autoRemove = (e) => zr(e) || !(e != null && e.length);
const gO = (e, t, n) => e.getValue(t) === n;
gO.autoRemove = (e) => zr(e);
const CO = (e, t, n) => e.getValue(t) == n;
CO.autoRemove = (e) => zr(e);
const qd = (e, t, n) => {
  let [r, o] = n;
  const i = e.getValue(t);
  return i >= r && i <= o;
};
qd.resolveFilterValue = (e) => {
  let [t, n] = e, r = typeof t != "number" ? parseFloat(t) : t, o = typeof n != "number" ? parseFloat(n) : n, i = t === null || Number.isNaN(r) ? -1 / 0 : r, a = n === null || Number.isNaN(o) ? 1 / 0 : o;
  if (i > a) {
    const s = i;
    i = a, a = s;
  }
  return [i, a];
};
qd.autoRemove = (e) => zr(e) || zr(e[0]) && zr(e[1]);
const ko = {
  includesString: uO,
  includesStringSensitive: fO,
  equalsString: dO,
  arrIncludes: hO,
  arrIncludesAll: pO,
  arrIncludesSome: mO,
  equals: gO,
  weakEquals: CO,
  inNumberRange: qd
};
function zr(e) {
  return e == null || e === "";
}
const kj = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (e) => ({
    columnFilters: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnFiltersChange: cr("columnFilters", e),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (e, t) => {
    e.getAutoFilterFn = () => {
      const n = t.getCoreRowModel().flatRows[0], r = n?.getValue(e.id);
      return typeof r == "string" ? ko.includesString : typeof r == "number" ? ko.inNumberRange : typeof r == "boolean" || r !== null && typeof r == "object" ? ko.equals : Array.isArray(r) ? ko.arrIncludes : ko.weakEquals;
    }, e.getFilterFn = () => {
      var n, r;
      return Ru(e.columnDef.filterFn) ? e.columnDef.filterFn : e.columnDef.filterFn === "auto" ? e.getAutoFilterFn() : (
        // @ts-ignore
        (n = (r = t.options.filterFns) == null ? void 0 : r[e.columnDef.filterFn]) != null ? n : ko[e.columnDef.filterFn]
      );
    }, e.getCanFilter = () => {
      var n, r, o;
      return ((n = e.columnDef.enableColumnFilter) != null ? n : !0) && ((r = t.options.enableColumnFilters) != null ? r : !0) && ((o = t.options.enableFilters) != null ? o : !0) && !!e.accessorFn;
    }, e.getIsFiltered = () => e.getFilterIndex() > -1, e.getFilterValue = () => {
      var n;
      return (n = t.getState().columnFilters) == null || (n = n.find((r) => r.id === e.id)) == null ? void 0 : n.value;
    }, e.getFilterIndex = () => {
      var n, r;
      return (n = (r = t.getState().columnFilters) == null ? void 0 : r.findIndex((o) => o.id === e.id)) != null ? n : -1;
    }, e.setFilterValue = (n) => {
      t.setColumnFilters((r) => {
        const o = e.getFilterFn(), i = r?.find((u) => u.id === e.id), a = g1(n, i ? i.value : void 0);
        if (Og(o, a, e)) {
          var s;
          return (s = r?.filter((u) => u.id !== e.id)) != null ? s : [];
        }
        const l = {
          id: e.id,
          value: a
        };
        if (i) {
          var c;
          return (c = r?.map((u) => u.id === e.id ? l : u)) != null ? c : [];
        }
        return r != null && r.length ? [...r, l] : [l];
      });
    };
  },
  createRow: (e, t) => {
    e.columnFilters = {}, e.columnFiltersMeta = {};
  },
  createTable: (e) => {
    e.setColumnFilters = (t) => {
      const n = e.getAllLeafColumns(), r = (o) => {
        var i;
        return (i = g1(t, o)) == null ? void 0 : i.filter((a) => {
          const s = n.find((l) => l.id === a.id);
          if (s) {
            const l = s.getFilterFn();
            if (Og(l, a.value, s))
              return !1;
          }
          return !0;
        });
      };
      e.options.onColumnFiltersChange == null || e.options.onColumnFiltersChange(r);
    }, e.resetColumnFilters = (t) => {
      var n, r;
      e.setColumnFilters(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.columnFilters) != null ? n : []);
    }, e.getPreFilteredRowModel = () => e.getCoreRowModel(), e.getFilteredRowModel = () => (!e._getFilteredRowModel && e.options.getFilteredRowModel && (e._getFilteredRowModel = e.options.getFilteredRowModel(e)), e.options.manualFiltering || !e._getFilteredRowModel ? e.getPreFilteredRowModel() : e._getFilteredRowModel());
  }
};
function Og(e, t, n) {
  return (e && e.autoRemove ? e.autoRemove(t, n) : !1) || typeof t > "u" || typeof t == "string" && !t;
}
const Lj = (e, t, n) => n.reduce((r, o) => {
  const i = o.getValue(e);
  return r + (typeof i == "number" ? i : 0);
}, 0), Nj = (e, t, n) => {
  let r;
  return n.forEach((o) => {
    const i = o.getValue(e);
    i != null && (r > i || r === void 0 && i >= i) && (r = i);
  }), r;
}, Fj = (e, t, n) => {
  let r;
  return n.forEach((o) => {
    const i = o.getValue(e);
    i != null && (r < i || r === void 0 && i >= i) && (r = i);
  }), r;
}, Vj = (e, t, n) => {
  let r, o;
  return n.forEach((i) => {
    const a = i.getValue(e);
    a != null && (r === void 0 ? a >= a && (r = o = a) : (r > a && (r = a), o < a && (o = a)));
  }), [r, o];
}, Bj = (e, t) => {
  let n = 0, r = 0;
  if (t.forEach((o) => {
    let i = o.getValue(e);
    i != null && (i = +i) >= i && (++n, r += i);
  }), n) return r / n;
}, $j = (e, t) => {
  if (!t.length)
    return;
  const n = t.map((i) => i.getValue(e));
  if (!Aj(n))
    return;
  if (n.length === 1)
    return n[0];
  const r = Math.floor(n.length / 2), o = n.sort((i, a) => i - a);
  return n.length % 2 !== 0 ? o[r] : (o[r - 1] + o[r]) / 2;
}, jj = (e, t) => Array.from(new Set(t.map((n) => n.getValue(e))).values()), Hj = (e, t) => new Set(t.map((n) => n.getValue(e))).size, zj = (e, t) => t.length, d7 = {
  sum: Lj,
  min: Nj,
  max: Fj,
  extent: Vj,
  mean: Bj,
  median: $j,
  unique: jj,
  uniqueCount: Hj,
  count: zj
}, Zj = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (e) => {
      var t, n;
      return (t = (n = e.getValue()) == null || n.toString == null ? void 0 : n.toString()) != null ? t : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (e) => ({
    grouping: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGroupingChange: cr("grouping", e),
    groupedColumnMode: "reorder"
  }),
  createColumn: (e, t) => {
    e.toggleGrouping = () => {
      t.setGrouping((n) => n != null && n.includes(e.id) ? n.filter((r) => r !== e.id) : [...n ?? [], e.id]);
    }, e.getCanGroup = () => {
      var n, r;
      return ((n = e.columnDef.enableGrouping) != null ? n : !0) && ((r = t.options.enableGrouping) != null ? r : !0) && (!!e.accessorFn || !!e.columnDef.getGroupingValue);
    }, e.getIsGrouped = () => {
      var n;
      return (n = t.getState().grouping) == null ? void 0 : n.includes(e.id);
    }, e.getGroupedIndex = () => {
      var n;
      return (n = t.getState().grouping) == null ? void 0 : n.indexOf(e.id);
    }, e.getToggleGroupingHandler = () => {
      const n = e.getCanGroup();
      return () => {
        n && e.toggleGrouping();
      };
    }, e.getAutoAggregationFn = () => {
      const n = t.getCoreRowModel().flatRows[0], r = n?.getValue(e.id);
      if (typeof r == "number")
        return d7.sum;
      if (Object.prototype.toString.call(r) === "[object Date]")
        return d7.extent;
    }, e.getAggregationFn = () => {
      var n, r;
      if (!e)
        throw new Error();
      return Ru(e.columnDef.aggregationFn) ? e.columnDef.aggregationFn : e.columnDef.aggregationFn === "auto" ? e.getAutoAggregationFn() : (n = (r = t.options.aggregationFns) == null ? void 0 : r[e.columnDef.aggregationFn]) != null ? n : d7[e.columnDef.aggregationFn];
    };
  },
  createTable: (e) => {
    e.setGrouping = (t) => e.options.onGroupingChange == null ? void 0 : e.options.onGroupingChange(t), e.resetGrouping = (t) => {
      var n, r;
      e.setGrouping(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.grouping) != null ? n : []);
    }, e.getPreGroupedRowModel = () => e.getFilteredRowModel(), e.getGroupedRowModel = () => (!e._getGroupedRowModel && e.options.getGroupedRowModel && (e._getGroupedRowModel = e.options.getGroupedRowModel(e)), e.options.manualGrouping || !e._getGroupedRowModel ? e.getPreGroupedRowModel() : e._getGroupedRowModel());
  },
  createRow: (e, t) => {
    e.getIsGrouped = () => !!e.groupingColumnId, e.getGroupingValue = (n) => {
      if (e._groupingValuesCache.hasOwnProperty(n))
        return e._groupingValuesCache[n];
      const r = t.getColumn(n);
      return r != null && r.columnDef.getGroupingValue ? (e._groupingValuesCache[n] = r.columnDef.getGroupingValue(e.original), e._groupingValuesCache[n]) : e.getValue(n);
    }, e._groupingValuesCache = {};
  },
  createCell: (e, t, n, r) => {
    e.getIsGrouped = () => t.getIsGrouped() && t.id === n.groupingColumnId, e.getIsPlaceholder = () => !e.getIsGrouped() && t.getIsGrouped(), e.getIsAggregated = () => {
      var o;
      return !e.getIsGrouped() && !e.getIsPlaceholder() && !!((o = n.subRows) != null && o.length);
    };
  }
};
function Wj(e, t, n) {
  if (!(t != null && t.length) || !n)
    return e;
  const r = e.filter((i) => !t.includes(i.id));
  return n === "remove" ? r : [...t.map((i) => e.find((a) => a.id === i)).filter(Boolean), ...r];
}
const qj = {
  getInitialState: (e) => ({
    columnOrder: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnOrderChange: cr("columnOrder", e)
  }),
  createColumn: (e, t) => {
    e.getIndex = Ae((n) => [ml(t, n)], (n) => n.findIndex((r) => r.id === e.id), Pe(t.options, "debugColumns", "getIndex")), e.getIsFirstColumn = (n) => {
      var r;
      return ((r = ml(t, n)[0]) == null ? void 0 : r.id) === e.id;
    }, e.getIsLastColumn = (n) => {
      var r;
      const o = ml(t, n);
      return ((r = o[o.length - 1]) == null ? void 0 : r.id) === e.id;
    };
  },
  createTable: (e) => {
    e.setColumnOrder = (t) => e.options.onColumnOrderChange == null ? void 0 : e.options.onColumnOrderChange(t), e.resetColumnOrder = (t) => {
      var n;
      e.setColumnOrder(t ? [] : (n = e.initialState.columnOrder) != null ? n : []);
    }, e._getOrderColumnsFn = Ae(() => [e.getState().columnOrder, e.getState().grouping, e.options.groupedColumnMode], (t, n, r) => (o) => {
      let i = [];
      if (!(t != null && t.length))
        i = o;
      else {
        const a = [...t], s = [...o];
        for (; s.length && a.length; ) {
          const l = a.shift(), c = s.findIndex((u) => u.id === l);
          c > -1 && i.push(s.splice(c, 1)[0]);
        }
        i = [...i, ...s];
      }
      return Wj(i, n, r);
    }, Pe(e.options, "debugTable", "_getOrderColumnsFn"));
  }
}, h7 = () => ({
  left: [],
  right: []
}), Uj = {
  getInitialState: (e) => ({
    columnPinning: h7(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnPinningChange: cr("columnPinning", e)
  }),
  createColumn: (e, t) => {
    e.pin = (n) => {
      const r = e.getLeafColumns().map((o) => o.id).filter(Boolean);
      t.setColumnPinning((o) => {
        var i, a;
        if (n === "right") {
          var s, l;
          return {
            left: ((s = o?.left) != null ? s : []).filter((f) => !(r != null && r.includes(f))),
            right: [...((l = o?.right) != null ? l : []).filter((f) => !(r != null && r.includes(f))), ...r]
          };
        }
        if (n === "left") {
          var c, u;
          return {
            left: [...((c = o?.left) != null ? c : []).filter((f) => !(r != null && r.includes(f))), ...r],
            right: ((u = o?.right) != null ? u : []).filter((f) => !(r != null && r.includes(f)))
          };
        }
        return {
          left: ((i = o?.left) != null ? i : []).filter((f) => !(r != null && r.includes(f))),
          right: ((a = o?.right) != null ? a : []).filter((f) => !(r != null && r.includes(f)))
        };
      });
    }, e.getCanPin = () => e.getLeafColumns().some((r) => {
      var o, i, a;
      return ((o = r.columnDef.enablePinning) != null ? o : !0) && ((i = (a = t.options.enableColumnPinning) != null ? a : t.options.enablePinning) != null ? i : !0);
    }), e.getIsPinned = () => {
      const n = e.getLeafColumns().map((s) => s.id), {
        left: r,
        right: o
      } = t.getState().columnPinning, i = n.some((s) => r?.includes(s)), a = n.some((s) => o?.includes(s));
      return i ? "left" : a ? "right" : !1;
    }, e.getPinnedIndex = () => {
      var n, r;
      const o = e.getIsPinned();
      return o ? (n = (r = t.getState().columnPinning) == null || (r = r[o]) == null ? void 0 : r.indexOf(e.id)) != null ? n : -1 : 0;
    };
  },
  createRow: (e, t) => {
    e.getCenterVisibleCells = Ae(() => [e._getAllVisibleCells(), t.getState().columnPinning.left, t.getState().columnPinning.right], (n, r, o) => {
      const i = [...r ?? [], ...o ?? []];
      return n.filter((a) => !i.includes(a.column.id));
    }, Pe(t.options, "debugRows", "getCenterVisibleCells")), e.getLeftVisibleCells = Ae(() => [e._getAllVisibleCells(), t.getState().columnPinning.left], (n, r) => (r ?? []).map((i) => n.find((a) => a.column.id === i)).filter(Boolean).map((i) => ({
      ...i,
      position: "left"
    })), Pe(t.options, "debugRows", "getLeftVisibleCells")), e.getRightVisibleCells = Ae(() => [e._getAllVisibleCells(), t.getState().columnPinning.right], (n, r) => (r ?? []).map((i) => n.find((a) => a.column.id === i)).filter(Boolean).map((i) => ({
      ...i,
      position: "right"
    })), Pe(t.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (e) => {
    e.setColumnPinning = (t) => e.options.onColumnPinningChange == null ? void 0 : e.options.onColumnPinningChange(t), e.resetColumnPinning = (t) => {
      var n, r;
      return e.setColumnPinning(t ? h7() : (n = (r = e.initialState) == null ? void 0 : r.columnPinning) != null ? n : h7());
    }, e.getIsSomeColumnsPinned = (t) => {
      var n;
      const r = e.getState().columnPinning;
      if (!t) {
        var o, i;
        return !!((o = r.left) != null && o.length || (i = r.right) != null && i.length);
      }
      return !!((n = r[t]) != null && n.length);
    }, e.getLeftLeafColumns = Ae(() => [e.getAllLeafColumns(), e.getState().columnPinning.left], (t, n) => (n ?? []).map((r) => t.find((o) => o.id === r)).filter(Boolean), Pe(e.options, "debugColumns", "getLeftLeafColumns")), e.getRightLeafColumns = Ae(() => [e.getAllLeafColumns(), e.getState().columnPinning.right], (t, n) => (n ?? []).map((r) => t.find((o) => o.id === r)).filter(Boolean), Pe(e.options, "debugColumns", "getRightLeafColumns")), e.getCenterLeafColumns = Ae(() => [e.getAllLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r) => {
      const o = [...n ?? [], ...r ?? []];
      return t.filter((i) => !o.includes(i.id));
    }, Pe(e.options, "debugColumns", "getCenterLeafColumns"));
  }
};
function Gj(e) {
  return e || (typeof document < "u" ? document : null);
}
const oc = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, p7 = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), Kj = {
  getDefaultColumnDef: () => oc,
  getInitialState: (e) => ({
    columnSizing: {},
    columnSizingInfo: p7(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: cr("columnSizing", e),
    onColumnSizingInfoChange: cr("columnSizingInfo", e)
  }),
  createColumn: (e, t) => {
    e.getSize = () => {
      var n, r, o;
      const i = t.getState().columnSizing[e.id];
      return Math.min(Math.max((n = e.columnDef.minSize) != null ? n : oc.minSize, (r = i ?? e.columnDef.size) != null ? r : oc.size), (o = e.columnDef.maxSize) != null ? o : oc.maxSize);
    }, e.getStart = Ae((n) => [n, ml(t, n), t.getState().columnSizing], (n, r) => r.slice(0, e.getIndex(n)).reduce((o, i) => o + i.getSize(), 0), Pe(t.options, "debugColumns", "getStart")), e.getAfter = Ae((n) => [n, ml(t, n), t.getState().columnSizing], (n, r) => r.slice(e.getIndex(n) + 1).reduce((o, i) => o + i.getSize(), 0), Pe(t.options, "debugColumns", "getAfter")), e.resetSize = () => {
      t.setColumnSizing((n) => {
        let {
          [e.id]: r,
          ...o
        } = n;
        return o;
      });
    }, e.getCanResize = () => {
      var n, r;
      return ((n = e.columnDef.enableResizing) != null ? n : !0) && ((r = t.options.enableColumnResizing) != null ? r : !0);
    }, e.getIsResizing = () => t.getState().columnSizingInfo.isResizingColumn === e.id;
  },
  createHeader: (e, t) => {
    e.getSize = () => {
      let n = 0;
      const r = (o) => {
        if (o.subHeaders.length)
          o.subHeaders.forEach(r);
        else {
          var i;
          n += (i = o.column.getSize()) != null ? i : 0;
        }
      };
      return r(e), n;
    }, e.getStart = () => {
      if (e.index > 0) {
        const n = e.headerGroup.headers[e.index - 1];
        return n.getStart() + n.getSize();
      }
      return 0;
    }, e.getResizeHandler = (n) => {
      const r = t.getColumn(e.column.id), o = r?.getCanResize();
      return (i) => {
        if (!r || !o || (i.persist == null || i.persist(), m7(i) && i.touches && i.touches.length > 1))
          return;
        const a = e.getSize(), s = e ? e.getLeafHeaders().map((v) => [v.column.id, v.column.getSize()]) : [[r.id, r.getSize()]], l = m7(i) ? Math.round(i.touches[0].clientX) : i.clientX, c = {}, u = (v, y) => {
          typeof y == "number" && (t.setColumnSizingInfo((w) => {
            var x, b;
            const S = t.options.columnResizeDirection === "rtl" ? -1 : 1, M = (y - ((x = w?.startOffset) != null ? x : 0)) * S, E = Math.max(M / ((b = w?.startSize) != null ? b : 0), -0.999999);
            return w.columnSizingStart.forEach((P) => {
              let [T, _] = P;
              c[T] = Math.round(Math.max(_ + _ * E, 0) * 100) / 100;
            }), {
              ...w,
              deltaOffset: M,
              deltaPercentage: E
            };
          }), (t.options.columnResizeMode === "onChange" || v === "end") && t.setColumnSizing((w) => ({
            ...w,
            ...c
          })));
        }, f = (v) => u("move", v), h = (v) => {
          u("end", v), t.setColumnSizingInfo((y) => ({
            ...y,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, p = Gj(n), C = {
          moveHandler: (v) => f(v.clientX),
          upHandler: (v) => {
            p?.removeEventListener("mousemove", C.moveHandler), p?.removeEventListener("mouseup", C.upHandler), h(v.clientX);
          }
        }, m = {
          moveHandler: (v) => (v.cancelable && (v.preventDefault(), v.stopPropagation()), f(v.touches[0].clientX), !1),
          upHandler: (v) => {
            var y;
            p?.removeEventListener("touchmove", m.moveHandler), p?.removeEventListener("touchend", m.upHandler), v.cancelable && (v.preventDefault(), v.stopPropagation()), h((y = v.touches[0]) == null ? void 0 : y.clientX);
          }
        }, g = Yj() ? {
          passive: !1
        } : !1;
        m7(i) ? (p?.addEventListener("touchmove", m.moveHandler, g), p?.addEventListener("touchend", m.upHandler, g)) : (p?.addEventListener("mousemove", C.moveHandler, g), p?.addEventListener("mouseup", C.upHandler, g)), t.setColumnSizingInfo((v) => ({
          ...v,
          startOffset: l,
          startSize: a,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: s,
          isResizingColumn: r.id
        }));
      };
    };
  },
  createTable: (e) => {
    e.setColumnSizing = (t) => e.options.onColumnSizingChange == null ? void 0 : e.options.onColumnSizingChange(t), e.setColumnSizingInfo = (t) => e.options.onColumnSizingInfoChange == null ? void 0 : e.options.onColumnSizingInfoChange(t), e.resetColumnSizing = (t) => {
      var n;
      e.setColumnSizing(t ? {} : (n = e.initialState.columnSizing) != null ? n : {});
    }, e.resetHeaderSizeInfo = (t) => {
      var n;
      e.setColumnSizingInfo(t ? p7() : (n = e.initialState.columnSizingInfo) != null ? n : p7());
    }, e.getTotalSize = () => {
      var t, n;
      return (t = (n = e.getHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? t : 0;
    }, e.getLeftTotalSize = () => {
      var t, n;
      return (t = (n = e.getLeftHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? t : 0;
    }, e.getCenterTotalSize = () => {
      var t, n;
      return (t = (n = e.getCenterHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? t : 0;
    }, e.getRightTotalSize = () => {
      var t, n;
      return (t = (n = e.getRightHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? t : 0;
    };
  }
};
let ic = null;
function Yj() {
  if (typeof ic == "boolean") return ic;
  let e = !1;
  try {
    const t = {
      get passive() {
        return e = !0, !1;
      }
    }, n = () => {
    };
    window.addEventListener("test", n, t), window.removeEventListener("test", n);
  } catch {
    e = !1;
  }
  return ic = e, ic;
}
function m7(e) {
  return e.type === "touchstart";
}
const Xj = {
  getInitialState: (e) => ({
    columnVisibility: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnVisibilityChange: cr("columnVisibility", e)
  }),
  createColumn: (e, t) => {
    e.toggleVisibility = (n) => {
      e.getCanHide() && t.setColumnVisibility((r) => ({
        ...r,
        [e.id]: n ?? !e.getIsVisible()
      }));
    }, e.getIsVisible = () => {
      var n, r;
      const o = e.columns;
      return (n = o.length ? o.some((i) => i.getIsVisible()) : (r = t.getState().columnVisibility) == null ? void 0 : r[e.id]) != null ? n : !0;
    }, e.getCanHide = () => {
      var n, r;
      return ((n = e.columnDef.enableHiding) != null ? n : !0) && ((r = t.options.enableHiding) != null ? r : !0);
    }, e.getToggleVisibilityHandler = () => (n) => {
      e.toggleVisibility == null || e.toggleVisibility(n.target.checked);
    };
  },
  createRow: (e, t) => {
    e._getAllVisibleCells = Ae(() => [e.getAllCells(), t.getState().columnVisibility], (n) => n.filter((r) => r.column.getIsVisible()), Pe(t.options, "debugRows", "_getAllVisibleCells")), e.getVisibleCells = Ae(() => [e.getLeftVisibleCells(), e.getCenterVisibleCells(), e.getRightVisibleCells()], (n, r, o) => [...n, ...r, ...o], Pe(t.options, "debugRows", "getVisibleCells"));
  },
  createTable: (e) => {
    const t = (n, r) => Ae(() => [r(), r().filter((o) => o.getIsVisible()).map((o) => o.id).join("_")], (o) => o.filter((i) => i.getIsVisible == null ? void 0 : i.getIsVisible()), Pe(e.options, "debugColumns", n));
    e.getVisibleFlatColumns = t("getVisibleFlatColumns", () => e.getAllFlatColumns()), e.getVisibleLeafColumns = t("getVisibleLeafColumns", () => e.getAllLeafColumns()), e.getLeftVisibleLeafColumns = t("getLeftVisibleLeafColumns", () => e.getLeftLeafColumns()), e.getRightVisibleLeafColumns = t("getRightVisibleLeafColumns", () => e.getRightLeafColumns()), e.getCenterVisibleLeafColumns = t("getCenterVisibleLeafColumns", () => e.getCenterLeafColumns()), e.setColumnVisibility = (n) => e.options.onColumnVisibilityChange == null ? void 0 : e.options.onColumnVisibilityChange(n), e.resetColumnVisibility = (n) => {
      var r;
      e.setColumnVisibility(n ? {} : (r = e.initialState.columnVisibility) != null ? r : {});
    }, e.toggleAllColumnsVisible = (n) => {
      var r;
      n = (r = n) != null ? r : !e.getIsAllColumnsVisible(), e.setColumnVisibility(e.getAllLeafColumns().reduce((o, i) => ({
        ...o,
        [i.id]: n || !(i.getCanHide != null && i.getCanHide())
      }), {}));
    }, e.getIsAllColumnsVisible = () => !e.getAllLeafColumns().some((n) => !(n.getIsVisible != null && n.getIsVisible())), e.getIsSomeColumnsVisible = () => e.getAllLeafColumns().some((n) => n.getIsVisible == null ? void 0 : n.getIsVisible()), e.getToggleAllColumnsVisibilityHandler = () => (n) => {
      var r;
      e.toggleAllColumnsVisible((r = n.target) == null ? void 0 : r.checked);
    };
  }
};
function ml(e, t) {
  return t ? t === "center" ? e.getCenterVisibleLeafColumns() : t === "left" ? e.getLeftVisibleLeafColumns() : e.getRightVisibleLeafColumns() : e.getVisibleLeafColumns();
}
const Qj = {
  createTable: (e) => {
    e._getGlobalFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, "__global__"), e.getGlobalFacetedRowModel = () => e.options.manualFiltering || !e._getGlobalFacetedRowModel ? e.getPreFilteredRowModel() : e._getGlobalFacetedRowModel(), e._getGlobalFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, "__global__"), e.getGlobalFacetedUniqueValues = () => e._getGlobalFacetedUniqueValues ? e._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getGlobalFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, "__global__"), e.getGlobalFacetedMinMaxValues = () => {
      if (e._getGlobalFacetedMinMaxValues)
        return e._getGlobalFacetedMinMaxValues();
    };
  }
}, Jj = {
  getInitialState: (e) => ({
    globalFilter: void 0,
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGlobalFilterChange: cr("globalFilter", e),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (t) => {
      var n;
      const r = (n = e.getCoreRowModel().flatRows[0]) == null || (n = n._getAllCellsByColumnId()[t.id]) == null ? void 0 : n.getValue();
      return typeof r == "string" || typeof r == "number";
    }
  }),
  createColumn: (e, t) => {
    e.getCanGlobalFilter = () => {
      var n, r, o, i;
      return ((n = e.columnDef.enableGlobalFilter) != null ? n : !0) && ((r = t.options.enableGlobalFilter) != null ? r : !0) && ((o = t.options.enableFilters) != null ? o : !0) && ((i = t.options.getColumnCanGlobalFilter == null ? void 0 : t.options.getColumnCanGlobalFilter(e)) != null ? i : !0) && !!e.accessorFn;
    };
  },
  createTable: (e) => {
    e.getGlobalAutoFilterFn = () => ko.includesString, e.getGlobalFilterFn = () => {
      var t, n;
      const {
        globalFilterFn: r
      } = e.options;
      return Ru(r) ? r : r === "auto" ? e.getGlobalAutoFilterFn() : (t = (n = e.options.filterFns) == null ? void 0 : n[r]) != null ? t : ko[r];
    }, e.setGlobalFilter = (t) => {
      e.options.onGlobalFilterChange == null || e.options.onGlobalFilterChange(t);
    }, e.resetGlobalFilter = (t) => {
      e.setGlobalFilter(t ? void 0 : e.initialState.globalFilter);
    };
  }
}, eH = {
  getInitialState: (e) => ({
    expanded: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onExpandedChange: cr("expanded", e),
    paginateExpandedRows: !0
  }),
  createTable: (e) => {
    let t = !1, n = !1;
    e._autoResetExpanded = () => {
      var r, o;
      if (!t) {
        e._queue(() => {
          t = !0;
        });
        return;
      }
      if ((r = (o = e.options.autoResetAll) != null ? o : e.options.autoResetExpanded) != null ? r : !e.options.manualExpanding) {
        if (n) return;
        n = !0, e._queue(() => {
          e.resetExpanded(), n = !1;
        });
      }
    }, e.setExpanded = (r) => e.options.onExpandedChange == null ? void 0 : e.options.onExpandedChange(r), e.toggleAllRowsExpanded = (r) => {
      r ?? !e.getIsAllRowsExpanded() ? e.setExpanded(!0) : e.setExpanded({});
    }, e.resetExpanded = (r) => {
      var o, i;
      e.setExpanded(r ? {} : (o = (i = e.initialState) == null ? void 0 : i.expanded) != null ? o : {});
    }, e.getCanSomeRowsExpand = () => e.getPrePaginationRowModel().flatRows.some((r) => r.getCanExpand()), e.getToggleAllRowsExpandedHandler = () => (r) => {
      r.persist == null || r.persist(), e.toggleAllRowsExpanded();
    }, e.getIsSomeRowsExpanded = () => {
      const r = e.getState().expanded;
      return r === !0 || Object.values(r).some(Boolean);
    }, e.getIsAllRowsExpanded = () => {
      const r = e.getState().expanded;
      return typeof r == "boolean" ? r === !0 : !(!Object.keys(r).length || e.getRowModel().flatRows.some((o) => !o.getIsExpanded()));
    }, e.getExpandedDepth = () => {
      let r = 0;
      return (e.getState().expanded === !0 ? Object.keys(e.getRowModel().rowsById) : Object.keys(e.getState().expanded)).forEach((i) => {
        const a = i.split(".");
        r = Math.max(r, a.length);
      }), r;
    }, e.getPreExpandedRowModel = () => e.getSortedRowModel(), e.getExpandedRowModel = () => (!e._getExpandedRowModel && e.options.getExpandedRowModel && (e._getExpandedRowModel = e.options.getExpandedRowModel(e)), e.options.manualExpanding || !e._getExpandedRowModel ? e.getPreExpandedRowModel() : e._getExpandedRowModel());
  },
  createRow: (e, t) => {
    e.toggleExpanded = (n) => {
      t.setExpanded((r) => {
        var o;
        const i = r === !0 ? !0 : !!(r != null && r[e.id]);
        let a = {};
        if (r === !0 ? Object.keys(t.getRowModel().rowsById).forEach((s) => {
          a[s] = !0;
        }) : a = r, n = (o = n) != null ? o : !i, !i && n)
          return {
            ...a,
            [e.id]: !0
          };
        if (i && !n) {
          const {
            [e.id]: s,
            ...l
          } = a;
          return l;
        }
        return r;
      });
    }, e.getIsExpanded = () => {
      var n;
      const r = t.getState().expanded;
      return !!((n = t.options.getIsRowExpanded == null ? void 0 : t.options.getIsRowExpanded(e)) != null ? n : r === !0 || r?.[e.id]);
    }, e.getCanExpand = () => {
      var n, r, o;
      return (n = t.options.getRowCanExpand == null ? void 0 : t.options.getRowCanExpand(e)) != null ? n : ((r = t.options.enableExpanding) != null ? r : !0) && !!((o = e.subRows) != null && o.length);
    }, e.getIsAllParentsExpanded = () => {
      let n = !0, r = e;
      for (; n && r.parentId; )
        r = t.getRow(r.parentId, !0), n = r.getIsExpanded();
      return n;
    }, e.getToggleExpandedHandler = () => {
      const n = e.getCanExpand();
      return () => {
        n && e.toggleExpanded();
      };
    };
  }
}, v9 = 0, y9 = 10, g7 = () => ({
  pageIndex: v9,
  pageSize: y9
}), tH = {
  getInitialState: (e) => ({
    ...e,
    pagination: {
      ...g7(),
      ...e?.pagination
    }
  }),
  getDefaultOptions: (e) => ({
    onPaginationChange: cr("pagination", e)
  }),
  createTable: (e) => {
    let t = !1, n = !1;
    e._autoResetPageIndex = () => {
      var r, o;
      if (!t) {
        e._queue(() => {
          t = !0;
        });
        return;
      }
      if ((r = (o = e.options.autoResetAll) != null ? o : e.options.autoResetPageIndex) != null ? r : !e.options.manualPagination) {
        if (n) return;
        n = !0, e._queue(() => {
          e.resetPageIndex(), n = !1;
        });
      }
    }, e.setPagination = (r) => {
      const o = (i) => g1(r, i);
      return e.options.onPaginationChange == null ? void 0 : e.options.onPaginationChange(o);
    }, e.resetPagination = (r) => {
      var o;
      e.setPagination(r ? g7() : (o = e.initialState.pagination) != null ? o : g7());
    }, e.setPageIndex = (r) => {
      e.setPagination((o) => {
        let i = g1(r, o.pageIndex);
        const a = typeof e.options.pageCount > "u" || e.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : e.options.pageCount - 1;
        return i = Math.max(0, Math.min(i, a)), {
          ...o,
          pageIndex: i
        };
      });
    }, e.resetPageIndex = (r) => {
      var o, i;
      e.setPageIndex(r ? v9 : (o = (i = e.initialState) == null || (i = i.pagination) == null ? void 0 : i.pageIndex) != null ? o : v9);
    }, e.resetPageSize = (r) => {
      var o, i;
      e.setPageSize(r ? y9 : (o = (i = e.initialState) == null || (i = i.pagination) == null ? void 0 : i.pageSize) != null ? o : y9);
    }, e.setPageSize = (r) => {
      e.setPagination((o) => {
        const i = Math.max(1, g1(r, o.pageSize)), a = o.pageSize * o.pageIndex, s = Math.floor(a / i);
        return {
          ...o,
          pageIndex: s,
          pageSize: i
        };
      });
    }, e.setPageCount = (r) => e.setPagination((o) => {
      var i;
      let a = g1(r, (i = e.options.pageCount) != null ? i : -1);
      return typeof a == "number" && (a = Math.max(-1, a)), {
        ...o,
        pageCount: a
      };
    }), e.getPageOptions = Ae(() => [e.getPageCount()], (r) => {
      let o = [];
      return r && r > 0 && (o = [...new Array(r)].fill(null).map((i, a) => a)), o;
    }, Pe(e.options, "debugTable", "getPageOptions")), e.getCanPreviousPage = () => e.getState().pagination.pageIndex > 0, e.getCanNextPage = () => {
      const {
        pageIndex: r
      } = e.getState().pagination, o = e.getPageCount();
      return o === -1 ? !0 : o === 0 ? !1 : r < o - 1;
    }, e.previousPage = () => e.setPageIndex((r) => r - 1), e.nextPage = () => e.setPageIndex((r) => r + 1), e.firstPage = () => e.setPageIndex(0), e.lastPage = () => e.setPageIndex(e.getPageCount() - 1), e.getPrePaginationRowModel = () => e.getExpandedRowModel(), e.getPaginationRowModel = () => (!e._getPaginationRowModel && e.options.getPaginationRowModel && (e._getPaginationRowModel = e.options.getPaginationRowModel(e)), e.options.manualPagination || !e._getPaginationRowModel ? e.getPrePaginationRowModel() : e._getPaginationRowModel()), e.getPageCount = () => {
      var r;
      return (r = e.options.pageCount) != null ? r : Math.ceil(e.getRowCount() / e.getState().pagination.pageSize);
    }, e.getRowCount = () => {
      var r;
      return (r = e.options.rowCount) != null ? r : e.getPrePaginationRowModel().rows.length;
    };
  }
}, C7 = () => ({
  top: [],
  bottom: []
}), nH = {
  getInitialState: (e) => ({
    rowPinning: C7(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowPinningChange: cr("rowPinning", e)
  }),
  createRow: (e, t) => {
    e.pin = (n, r, o) => {
      const i = r ? e.getLeafRows().map((l) => {
        let {
          id: c
        } = l;
        return c;
      }) : [], a = o ? e.getParentRows().map((l) => {
        let {
          id: c
        } = l;
        return c;
      }) : [], s = /* @__PURE__ */ new Set([...a, e.id, ...i]);
      t.setRowPinning((l) => {
        var c, u;
        if (n === "bottom") {
          var f, h;
          return {
            top: ((f = l?.top) != null ? f : []).filter((m) => !(s != null && s.has(m))),
            bottom: [...((h = l?.bottom) != null ? h : []).filter((m) => !(s != null && s.has(m))), ...Array.from(s)]
          };
        }
        if (n === "top") {
          var p, C;
          return {
            top: [...((p = l?.top) != null ? p : []).filter((m) => !(s != null && s.has(m))), ...Array.from(s)],
            bottom: ((C = l?.bottom) != null ? C : []).filter((m) => !(s != null && s.has(m)))
          };
        }
        return {
          top: ((c = l?.top) != null ? c : []).filter((m) => !(s != null && s.has(m))),
          bottom: ((u = l?.bottom) != null ? u : []).filter((m) => !(s != null && s.has(m)))
        };
      });
    }, e.getCanPin = () => {
      var n;
      const {
        enableRowPinning: r,
        enablePinning: o
      } = t.options;
      return typeof r == "function" ? r(e) : (n = r ?? o) != null ? n : !0;
    }, e.getIsPinned = () => {
      const n = [e.id], {
        top: r,
        bottom: o
      } = t.getState().rowPinning, i = n.some((s) => r?.includes(s)), a = n.some((s) => o?.includes(s));
      return i ? "top" : a ? "bottom" : !1;
    }, e.getPinnedIndex = () => {
      var n, r;
      const o = e.getIsPinned();
      if (!o) return -1;
      const i = (n = o === "top" ? t.getTopRows() : t.getBottomRows()) == null ? void 0 : n.map((a) => {
        let {
          id: s
        } = a;
        return s;
      });
      return (r = i?.indexOf(e.id)) != null ? r : -1;
    };
  },
  createTable: (e) => {
    e.setRowPinning = (t) => e.options.onRowPinningChange == null ? void 0 : e.options.onRowPinningChange(t), e.resetRowPinning = (t) => {
      var n, r;
      return e.setRowPinning(t ? C7() : (n = (r = e.initialState) == null ? void 0 : r.rowPinning) != null ? n : C7());
    }, e.getIsSomeRowsPinned = (t) => {
      var n;
      const r = e.getState().rowPinning;
      if (!t) {
        var o, i;
        return !!((o = r.top) != null && o.length || (i = r.bottom) != null && i.length);
      }
      return !!((n = r[t]) != null && n.length);
    }, e._getPinnedRows = (t, n, r) => {
      var o;
      return ((o = e.options.keepPinnedRows) == null || o ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (n ?? []).map((a) => {
          const s = e.getRow(a, !0);
          return s.getIsAllParentsExpanded() ? s : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (n ?? []).map((a) => t.find((s) => s.id === a))
      )).filter(Boolean).map((a) => ({
        ...a,
        position: r
      }));
    }, e.getTopRows = Ae(() => [e.getRowModel().rows, e.getState().rowPinning.top], (t, n) => e._getPinnedRows(t, n, "top"), Pe(e.options, "debugRows", "getTopRows")), e.getBottomRows = Ae(() => [e.getRowModel().rows, e.getState().rowPinning.bottom], (t, n) => e._getPinnedRows(t, n, "bottom"), Pe(e.options, "debugRows", "getBottomRows")), e.getCenterRows = Ae(() => [e.getRowModel().rows, e.getState().rowPinning.top, e.getState().rowPinning.bottom], (t, n, r) => {
      const o = /* @__PURE__ */ new Set([...n ?? [], ...r ?? []]);
      return t.filter((i) => !o.has(i.id));
    }, Pe(e.options, "debugRows", "getCenterRows"));
  }
}, rH = {
  getInitialState: (e) => ({
    rowSelection: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowSelectionChange: cr("rowSelection", e),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (e) => {
    e.setRowSelection = (t) => e.options.onRowSelectionChange == null ? void 0 : e.options.onRowSelectionChange(t), e.resetRowSelection = (t) => {
      var n;
      return e.setRowSelection(t ? {} : (n = e.initialState.rowSelection) != null ? n : {});
    }, e.toggleAllRowsSelected = (t) => {
      e.setRowSelection((n) => {
        t = typeof t < "u" ? t : !e.getIsAllRowsSelected();
        const r = {
          ...n
        }, o = e.getPreGroupedRowModel().flatRows;
        return t ? o.forEach((i) => {
          i.getCanSelect() && (r[i.id] = !0);
        }) : o.forEach((i) => {
          delete r[i.id];
        }), r;
      });
    }, e.toggleAllPageRowsSelected = (t) => e.setRowSelection((n) => {
      const r = typeof t < "u" ? t : !e.getIsAllPageRowsSelected(), o = {
        ...n
      };
      return e.getRowModel().rows.forEach((i) => {
        b9(o, i.id, r, !0, e);
      }), o;
    }), e.getPreSelectedRowModel = () => e.getCoreRowModel(), e.getSelectedRowModel = Ae(() => [e.getState().rowSelection, e.getCoreRowModel()], (t, n) => Object.keys(t).length ? v7(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, Pe(e.options, "debugTable", "getSelectedRowModel")), e.getFilteredSelectedRowModel = Ae(() => [e.getState().rowSelection, e.getFilteredRowModel()], (t, n) => Object.keys(t).length ? v7(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, Pe(e.options, "debugTable", "getFilteredSelectedRowModel")), e.getGroupedSelectedRowModel = Ae(() => [e.getState().rowSelection, e.getSortedRowModel()], (t, n) => Object.keys(t).length ? v7(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, Pe(e.options, "debugTable", "getGroupedSelectedRowModel")), e.getIsAllRowsSelected = () => {
      const t = e.getFilteredRowModel().flatRows, {
        rowSelection: n
      } = e.getState();
      let r = !!(t.length && Object.keys(n).length);
      return r && t.some((o) => o.getCanSelect() && !n[o.id]) && (r = !1), r;
    }, e.getIsAllPageRowsSelected = () => {
      const t = e.getPaginationRowModel().flatRows.filter((o) => o.getCanSelect()), {
        rowSelection: n
      } = e.getState();
      let r = !!t.length;
      return r && t.some((o) => !n[o.id]) && (r = !1), r;
    }, e.getIsSomeRowsSelected = () => {
      var t;
      const n = Object.keys((t = e.getState().rowSelection) != null ? t : {}).length;
      return n > 0 && n < e.getFilteredRowModel().flatRows.length;
    }, e.getIsSomePageRowsSelected = () => {
      const t = e.getPaginationRowModel().flatRows;
      return e.getIsAllPageRowsSelected() ? !1 : t.filter((n) => n.getCanSelect()).some((n) => n.getIsSelected() || n.getIsSomeSelected());
    }, e.getToggleAllRowsSelectedHandler = () => (t) => {
      e.toggleAllRowsSelected(t.target.checked);
    }, e.getToggleAllPageRowsSelectedHandler = () => (t) => {
      e.toggleAllPageRowsSelected(t.target.checked);
    };
  },
  createRow: (e, t) => {
    e.toggleSelected = (n, r) => {
      const o = e.getIsSelected();
      t.setRowSelection((i) => {
        var a;
        if (n = typeof n < "u" ? n : !o, e.getCanSelect() && o === n)
          return i;
        const s = {
          ...i
        };
        return b9(s, e.id, n, (a = r?.selectChildren) != null ? a : !0, t), s;
      });
    }, e.getIsSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return Ud(e, n);
    }, e.getIsSomeSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return w9(e, n) === "some";
    }, e.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return w9(e, n) === "all";
    }, e.getCanSelect = () => {
      var n;
      return typeof t.options.enableRowSelection == "function" ? t.options.enableRowSelection(e) : (n = t.options.enableRowSelection) != null ? n : !0;
    }, e.getCanSelectSubRows = () => {
      var n;
      return typeof t.options.enableSubRowSelection == "function" ? t.options.enableSubRowSelection(e) : (n = t.options.enableSubRowSelection) != null ? n : !0;
    }, e.getCanMultiSelect = () => {
      var n;
      return typeof t.options.enableMultiRowSelection == "function" ? t.options.enableMultiRowSelection(e) : (n = t.options.enableMultiRowSelection) != null ? n : !0;
    }, e.getToggleSelectedHandler = () => {
      const n = e.getCanSelect();
      return (r) => {
        var o;
        n && e.toggleSelected((o = r.target) == null ? void 0 : o.checked);
      };
    };
  }
}, b9 = (e, t, n, r, o) => {
  var i;
  const a = o.getRow(t, !0);
  n ? (a.getCanMultiSelect() || Object.keys(e).forEach((s) => delete e[s]), a.getCanSelect() && (e[t] = !0)) : delete e[t], r && (i = a.subRows) != null && i.length && a.getCanSelectSubRows() && a.subRows.forEach((s) => b9(e, s.id, n, r, o));
};
function v7(e, t) {
  const n = e.getState().rowSelection, r = [], o = {}, i = function(a, s) {
    return a.map((l) => {
      var c;
      const u = Ud(l, n);
      if (u && (r.push(l), o[l.id] = l), (c = l.subRows) != null && c.length && (l = {
        ...l,
        subRows: i(l.subRows)
      }), u)
        return l;
    }).filter(Boolean);
  };
  return {
    rows: i(t.rows),
    flatRows: r,
    rowsById: o
  };
}
function Ud(e, t) {
  var n;
  return (n = t[e.id]) != null ? n : !1;
}
function w9(e, t, n) {
  var r;
  if (!((r = e.subRows) != null && r.length)) return !1;
  let o = !0, i = !1;
  return e.subRows.forEach((a) => {
    if (!(i && !o) && (a.getCanSelect() && (Ud(a, t) ? i = !0 : o = !1), a.subRows && a.subRows.length)) {
      const s = w9(a, t);
      s === "all" ? i = !0 : (s === "some" && (i = !0), o = !1);
    }
  }), o ? "all" : i ? "some" : !1;
}
const x9 = /([0-9]+)/gm, oH = (e, t, n) => vO(O1(e.getValue(n)).toLowerCase(), O1(t.getValue(n)).toLowerCase()), iH = (e, t, n) => vO(O1(e.getValue(n)), O1(t.getValue(n))), aH = (e, t, n) => Gd(O1(e.getValue(n)).toLowerCase(), O1(t.getValue(n)).toLowerCase()), sH = (e, t, n) => Gd(O1(e.getValue(n)), O1(t.getValue(n))), lH = (e, t, n) => {
  const r = e.getValue(n), o = t.getValue(n);
  return r > o ? 1 : r < o ? -1 : 0;
}, cH = (e, t, n) => Gd(e.getValue(n), t.getValue(n));
function Gd(e, t) {
  return e === t ? 0 : e > t ? 1 : -1;
}
function O1(e) {
  return typeof e == "number" ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : typeof e == "string" ? e : "";
}
function vO(e, t) {
  const n = e.split(x9).filter(Boolean), r = t.split(x9).filter(Boolean);
  for (; n.length && r.length; ) {
    const o = n.shift(), i = r.shift(), a = parseInt(o, 10), s = parseInt(i, 10), l = [a, s].sort();
    if (isNaN(l[0])) {
      if (o > i)
        return 1;
      if (i > o)
        return -1;
      continue;
    }
    if (isNaN(l[1]))
      return isNaN(a) ? -1 : 1;
    if (a > s)
      return 1;
    if (s > a)
      return -1;
  }
  return n.length - r.length;
}
const $s = {
  alphanumeric: oH,
  alphanumericCaseSensitive: iH,
  text: aH,
  textCaseSensitive: sH,
  datetime: lH,
  basic: cH
}, uH = {
  getInitialState: (e) => ({
    sorting: [],
    ...e
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (e) => ({
    onSortingChange: cr("sorting", e),
    isMultiSortEvent: (t) => t.shiftKey
  }),
  createColumn: (e, t) => {
    e.getAutoSortingFn = () => {
      const n = t.getFilteredRowModel().flatRows.slice(10);
      let r = !1;
      for (const o of n) {
        const i = o?.getValue(e.id);
        if (Object.prototype.toString.call(i) === "[object Date]")
          return $s.datetime;
        if (typeof i == "string" && (r = !0, i.split(x9).length > 1))
          return $s.alphanumeric;
      }
      return r ? $s.text : $s.basic;
    }, e.getAutoSortDir = () => {
      const n = t.getFilteredRowModel().flatRows[0];
      return typeof n?.getValue(e.id) == "string" ? "asc" : "desc";
    }, e.getSortingFn = () => {
      var n, r;
      if (!e)
        throw new Error();
      return Ru(e.columnDef.sortingFn) ? e.columnDef.sortingFn : e.columnDef.sortingFn === "auto" ? e.getAutoSortingFn() : (n = (r = t.options.sortingFns) == null ? void 0 : r[e.columnDef.sortingFn]) != null ? n : $s[e.columnDef.sortingFn];
    }, e.toggleSorting = (n, r) => {
      const o = e.getNextSortingOrder(), i = typeof n < "u" && n !== null;
      t.setSorting((a) => {
        const s = a?.find((p) => p.id === e.id), l = a?.findIndex((p) => p.id === e.id);
        let c = [], u, f = i ? n : o === "desc";
        if (a != null && a.length && e.getCanMultiSort() && r ? s ? u = "toggle" : u = "add" : a != null && a.length && l !== a.length - 1 ? u = "replace" : s ? u = "toggle" : u = "replace", u === "toggle" && (i || o || (u = "remove")), u === "add") {
          var h;
          c = [...a, {
            id: e.id,
            desc: f
          }], c.splice(0, c.length - ((h = t.options.maxMultiSortColCount) != null ? h : Number.MAX_SAFE_INTEGER));
        } else u === "toggle" ? c = a.map((p) => p.id === e.id ? {
          ...p,
          desc: f
        } : p) : u === "remove" ? c = a.filter((p) => p.id !== e.id) : c = [{
          id: e.id,
          desc: f
        }];
        return c;
      });
    }, e.getFirstSortDir = () => {
      var n, r;
      return ((n = (r = e.columnDef.sortDescFirst) != null ? r : t.options.sortDescFirst) != null ? n : e.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, e.getNextSortingOrder = (n) => {
      var r, o;
      const i = e.getFirstSortDir(), a = e.getIsSorted();
      return a ? a !== i && ((r = t.options.enableSortingRemoval) == null || r) && // If enableSortRemove, enable in general
      (!(n && (o = t.options.enableMultiRemove) != null) || o) ? !1 : a === "desc" ? "asc" : "desc" : i;
    }, e.getCanSort = () => {
      var n, r;
      return ((n = e.columnDef.enableSorting) != null ? n : !0) && ((r = t.options.enableSorting) != null ? r : !0) && !!e.accessorFn;
    }, e.getCanMultiSort = () => {
      var n, r;
      return (n = (r = e.columnDef.enableMultiSort) != null ? r : t.options.enableMultiSort) != null ? n : !!e.accessorFn;
    }, e.getIsSorted = () => {
      var n;
      const r = (n = t.getState().sorting) == null ? void 0 : n.find((o) => o.id === e.id);
      return r ? r.desc ? "desc" : "asc" : !1;
    }, e.getSortIndex = () => {
      var n, r;
      return (n = (r = t.getState().sorting) == null ? void 0 : r.findIndex((o) => o.id === e.id)) != null ? n : -1;
    }, e.clearSorting = () => {
      t.setSorting((n) => n != null && n.length ? n.filter((r) => r.id !== e.id) : []);
    }, e.getToggleSortingHandler = () => {
      const n = e.getCanSort();
      return (r) => {
        n && (r.persist == null || r.persist(), e.toggleSorting == null || e.toggleSorting(void 0, e.getCanMultiSort() ? t.options.isMultiSortEvent == null ? void 0 : t.options.isMultiSortEvent(r) : !1));
      };
    };
  },
  createTable: (e) => {
    e.setSorting = (t) => e.options.onSortingChange == null ? void 0 : e.options.onSortingChange(t), e.resetSorting = (t) => {
      var n, r;
      e.setSorting(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.sorting) != null ? n : []);
    }, e.getPreSortedRowModel = () => e.getGroupedRowModel(), e.getSortedRowModel = () => (!e._getSortedRowModel && e.options.getSortedRowModel && (e._getSortedRowModel = e.options.getSortedRowModel(e)), e.options.manualSorting || !e._getSortedRowModel ? e.getPreSortedRowModel() : e._getSortedRowModel());
  }
}, fH = [
  Dj,
  Xj,
  qj,
  Uj,
  Rj,
  kj,
  Qj,
  //depends on ColumnFaceting
  Jj,
  //depends on ColumnFiltering
  uH,
  Zj,
  //depends on RowSorting
  eH,
  tH,
  nH,
  rH,
  Kj
];
function dH(e) {
  var t, n;
  process.env.NODE_ENV !== "production" && (e.debugAll || e.debugTable) && console.info("Creating Table Instance...");
  const r = [...fH, ...(t = e._features) != null ? t : []];
  let o = {
    _features: r
  };
  const i = o._features.reduce((h, p) => Object.assign(h, p.getDefaultOptions == null ? void 0 : p.getDefaultOptions(o)), {}), a = (h) => o.options.mergeOptions ? o.options.mergeOptions(i, h) : {
    ...i,
    ...h
  };
  let l = {
    ...{},
    ...(n = e.initialState) != null ? n : {}
  };
  o._features.forEach((h) => {
    var p;
    l = (p = h.getInitialState == null ? void 0 : h.getInitialState(l)) != null ? p : l;
  });
  const c = [];
  let u = !1;
  const f = {
    _features: r,
    options: {
      ...i,
      ...e
    },
    initialState: l,
    _queue: (h) => {
      c.push(h), u || (u = !0, Promise.resolve().then(() => {
        for (; c.length; )
          c.shift()();
        u = !1;
      }).catch((p) => setTimeout(() => {
        throw p;
      })));
    },
    reset: () => {
      o.setState(o.initialState);
    },
    setOptions: (h) => {
      const p = g1(h, o.options);
      o.options = a(p);
    },
    getState: () => o.options.state,
    setState: (h) => {
      o.options.onStateChange == null || o.options.onStateChange(h);
    },
    _getRowId: (h, p, C) => {
      var m;
      return (m = o.options.getRowId == null ? void 0 : o.options.getRowId(h, p, C)) != null ? m : `${C ? [C.id, p].join(".") : p}`;
    },
    getCoreRowModel: () => (o._getCoreRowModel || (o._getCoreRowModel = o.options.getCoreRowModel(o)), o._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => o.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (h, p) => {
      let C = (p ? o.getPrePaginationRowModel() : o.getRowModel()).rowsById[h];
      if (!C && (C = o.getCoreRowModel().rowsById[h], !C))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${h}`) : new Error();
      return C;
    },
    _getDefaultColumnDef: Ae(() => [o.options.defaultColumn], (h) => {
      var p;
      return h = (p = h) != null ? p : {}, {
        header: (C) => {
          const m = C.header.column.columnDef;
          return m.accessorKey ? m.accessorKey : m.accessorFn ? m.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (C) => {
          var m, g;
          return (m = (g = C.renderValue()) == null || g.toString == null ? void 0 : g.toString()) != null ? m : null;
        },
        ...o._features.reduce((C, m) => Object.assign(C, m.getDefaultColumnDef == null ? void 0 : m.getDefaultColumnDef()), {}),
        ...h
      };
    }, Pe(e, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => o.options.columns,
    getAllColumns: Ae(() => [o._getColumnDefs()], (h) => {
      const p = function(C, m, g) {
        return g === void 0 && (g = 0), C.map((v) => {
          const y = Ij(o, v, g, m), w = v;
          return y.columns = w.columns ? p(w.columns, y, g + 1) : [], y;
        });
      };
      return p(h);
    }, Pe(e, "debugColumns", "getAllColumns")),
    getAllFlatColumns: Ae(() => [o.getAllColumns()], (h) => h.flatMap((p) => p.getFlatColumns()), Pe(e, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: Ae(() => [o.getAllFlatColumns()], (h) => h.reduce((p, C) => (p[C.id] = C, p), {}), Pe(e, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: Ae(() => [o.getAllColumns(), o._getOrderColumnsFn()], (h, p) => {
      let C = h.flatMap((m) => m.getLeafColumns());
      return p(C);
    }, Pe(e, "debugColumns", "getAllLeafColumns")),
    getColumn: (h) => {
      const p = o._getAllFlatColumnsById()[h];
      return process.env.NODE_ENV !== "production" && !p && console.error(`[Table] Column with id '${h}' does not exist.`), p;
    }
  };
  Object.assign(o, f);
  for (let h = 0; h < o._features.length; h++) {
    const p = o._features[h];
    p == null || p.createTable == null || p.createTable(o);
  }
  return o;
}
function hH() {
  return (e) => Ae(() => [e.options.data], (t) => {
    const n = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, r = function(o, i, a) {
      i === void 0 && (i = 0);
      const s = [];
      for (let c = 0; c < o.length; c++) {
        const u = Wd(e, e._getRowId(o[c], c, a), o[c], c, i, void 0, a?.id);
        if (n.flatRows.push(u), n.rowsById[u.id] = u, s.push(u), e.options.getSubRows) {
          var l;
          u.originalSubRows = e.options.getSubRows(o[c], c), (l = u.originalSubRows) != null && l.length && (u.subRows = r(u.originalSubRows, i + 1, u));
        }
      }
      return s;
    };
    return n.rows = r(t), n;
  }, Pe(e.options, "debugTable", "getRowModel", () => e._autoResetPageIndex()));
}
function pH() {
  return (e) => Ae(() => [e.getState().expanded, e.getPreExpandedRowModel(), e.options.paginateExpandedRows], (t, n, r) => !n.rows.length || t !== !0 && !Object.keys(t ?? {}).length || !r ? n : yO(n), Pe(e.options, "debugTable", "getExpandedRowModel"));
}
function yO(e) {
  const t = [], n = (r) => {
    var o;
    t.push(r), (o = r.subRows) != null && o.length && r.getIsExpanded() && r.subRows.forEach(n);
  };
  return e.rows.forEach(n), {
    rows: t,
    flatRows: e.flatRows,
    rowsById: e.rowsById
  };
}
function mH(e, t, n) {
  return n.options.filterFromLeafRows ? gH(e, t, n) : CH(e, t, n);
}
function gH(e, t, n) {
  var r;
  const o = [], i = {}, a = (r = n.options.maxLeafRowFilterDepth) != null ? r : 100, s = function(l, c) {
    c === void 0 && (c = 0);
    const u = [];
    for (let h = 0; h < l.length; h++) {
      var f;
      let p = l[h];
      const C = Wd(n, p.id, p.original, p.index, p.depth, void 0, p.parentId);
      if (C.columnFilters = p.columnFilters, (f = p.subRows) != null && f.length && c < a) {
        if (C.subRows = s(p.subRows, c + 1), p = C, t(p) && !C.subRows.length) {
          u.push(p), i[p.id] = p, o.push(p);
          continue;
        }
        if (t(p) || C.subRows.length) {
          u.push(p), i[p.id] = p, o.push(p);
          continue;
        }
      } else
        p = C, t(p) && (u.push(p), i[p.id] = p, o.push(p));
    }
    return u;
  };
  return {
    rows: s(e),
    flatRows: o,
    rowsById: i
  };
}
function CH(e, t, n) {
  var r;
  const o = [], i = {}, a = (r = n.options.maxLeafRowFilterDepth) != null ? r : 100, s = function(l, c) {
    c === void 0 && (c = 0);
    const u = [];
    for (let h = 0; h < l.length; h++) {
      let p = l[h];
      if (t(p)) {
        var f;
        if ((f = p.subRows) != null && f.length && c < a) {
          const m = Wd(n, p.id, p.original, p.index, p.depth, void 0, p.parentId);
          m.subRows = s(p.subRows, c + 1), p = m;
        }
        u.push(p), o.push(p), i[p.id] = p;
      }
    }
    return u;
  };
  return {
    rows: s(e),
    flatRows: o,
    rowsById: i
  };
}
function vH() {
  return (e) => Ae(() => [e.getPreFilteredRowModel(), e.getState().columnFilters, e.getState().globalFilter], (t, n, r) => {
    if (!t.rows.length || !(n != null && n.length) && !r) {
      for (let h = 0; h < t.flatRows.length; h++)
        t.flatRows[h].columnFilters = {}, t.flatRows[h].columnFiltersMeta = {};
      return t;
    }
    const o = [], i = [];
    (n ?? []).forEach((h) => {
      var p;
      const C = e.getColumn(h.id);
      if (!C)
        return;
      const m = C.getFilterFn();
      if (!m) {
        process.env.NODE_ENV !== "production" && console.warn(`Could not find a valid 'column.filterFn' for column with the ID: ${C.id}.`);
        return;
      }
      o.push({
        id: h.id,
        filterFn: m,
        resolvedValue: (p = m.resolveFilterValue == null ? void 0 : m.resolveFilterValue(h.value)) != null ? p : h.value
      });
    });
    const a = (n ?? []).map((h) => h.id), s = e.getGlobalFilterFn(), l = e.getAllLeafColumns().filter((h) => h.getCanGlobalFilter());
    r && s && l.length && (a.push("__global__"), l.forEach((h) => {
      var p;
      i.push({
        id: h.id,
        filterFn: s,
        resolvedValue: (p = s.resolveFilterValue == null ? void 0 : s.resolveFilterValue(r)) != null ? p : r
      });
    }));
    let c, u;
    for (let h = 0; h < t.flatRows.length; h++) {
      const p = t.flatRows[h];
      if (p.columnFilters = {}, o.length)
        for (let C = 0; C < o.length; C++) {
          c = o[C];
          const m = c.id;
          p.columnFilters[m] = c.filterFn(p, m, c.resolvedValue, (g) => {
            p.columnFiltersMeta[m] = g;
          });
        }
      if (i.length) {
        for (let C = 0; C < i.length; C++) {
          u = i[C];
          const m = u.id;
          if (u.filterFn(p, m, u.resolvedValue, (g) => {
            p.columnFiltersMeta[m] = g;
          })) {
            p.columnFilters.__global__ = !0;
            break;
          }
        }
        p.columnFilters.__global__ !== !0 && (p.columnFilters.__global__ = !1);
      }
    }
    const f = (h) => {
      for (let p = 0; p < a.length; p++)
        if (h.columnFilters[a[p]] === !1)
          return !1;
      return !0;
    };
    return mH(t.rows, f, e);
  }, Pe(e.options, "debugTable", "getFilteredRowModel", () => e._autoResetPageIndex()));
}
function yH(e) {
  return (t) => Ae(() => [t.getState().pagination, t.getPrePaginationRowModel(), t.options.paginateExpandedRows ? void 0 : t.getState().expanded], (n, r) => {
    if (!r.rows.length)
      return r;
    const {
      pageSize: o,
      pageIndex: i
    } = n;
    let {
      rows: a,
      flatRows: s,
      rowsById: l
    } = r;
    const c = o * i, u = c + o;
    a = a.slice(c, u);
    let f;
    t.options.paginateExpandedRows ? f = {
      rows: a,
      flatRows: s,
      rowsById: l
    } : f = yO({
      rows: a,
      flatRows: s,
      rowsById: l
    }), f.flatRows = [];
    const h = (p) => {
      f.flatRows.push(p), p.subRows.length && p.subRows.forEach(h);
    };
    return f.rows.forEach(h), f;
  }, Pe(t.options, "debugTable", "getPaginationRowModel"));
}
function bH() {
  return (e) => Ae(() => [e.getState().sorting, e.getPreSortedRowModel()], (t, n) => {
    if (!n.rows.length || !(t != null && t.length))
      return n;
    const r = e.getState().sorting, o = [], i = r.filter((l) => {
      var c;
      return (c = e.getColumn(l.id)) == null ? void 0 : c.getCanSort();
    }), a = {};
    i.forEach((l) => {
      const c = e.getColumn(l.id);
      c && (a[l.id] = {
        sortUndefined: c.columnDef.sortUndefined,
        invertSorting: c.columnDef.invertSorting,
        sortingFn: c.getSortingFn()
      });
    });
    const s = (l) => {
      const c = l.map((u) => ({
        ...u
      }));
      return c.sort((u, f) => {
        for (let p = 0; p < i.length; p += 1) {
          var h;
          const C = i[p], m = a[C.id], g = m.sortUndefined, v = (h = C?.desc) != null ? h : !1;
          let y = 0;
          if (g) {
            const w = u.getValue(C.id), x = f.getValue(C.id), b = w === void 0, S = x === void 0;
            if (b || S) {
              if (g === "first") return b ? -1 : 1;
              if (g === "last") return b ? 1 : -1;
              y = b && S ? 0 : b ? g : -g;
            }
          }
          if (y === 0 && (y = m.sortingFn(u, f, C.id)), y !== 0)
            return v && (y *= -1), m.invertSorting && (y *= -1), y;
        }
        return u.index - f.index;
      }), c.forEach((u) => {
        var f;
        o.push(u), (f = u.subRows) != null && f.length && (u.subRows = s(u.subRows));
      }), c;
    };
    return {
      rows: s(n.rows),
      flatRows: o,
      rowsById: n.rowsById
    };
  }, Pe(e.options, "debugTable", "getSortedRowModel", () => e._autoResetPageIndex()));
}
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function Ag(e, t) {
  return e ? wH(e) ? /* @__PURE__ */ A.createElement(e, t) : e : null;
}
function wH(e) {
  return xH(e) || typeof e == "function" || SH(e);
}
function xH(e) {
  return typeof e == "function" && (() => {
    const t = Object.getPrototypeOf(e);
    return t.prototype && t.prototype.isReactComponent;
  })();
}
function SH(e) {
  return typeof e == "object" && typeof e.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(e.$$typeof.description);
}
function MH(e) {
  const t = {
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    ...e
  }, [n] = A.useState(() => ({
    current: dH(t)
  })), [r, o] = A.useState(() => n.current.initialState);
  return n.current.setOptions((i) => ({
    ...i,
    ...e,
    state: {
      ...r,
      ...e.state
    },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: (a) => {
      o(a), e.onStateChange == null || e.onStateChange(a);
    }
  })), n.current;
}
const Kd = O.createContext(null), Yd = () => {
  const e = O.useContext(Kd);
  if (e == null)
    throw new Error("Table components must be wrapped in <Table />");
  return e;
}, EH = O.forwardRef(
  ({ children: e, className: t, width: n, height: r, ...o }, i) => {
    const a = I(
      "w-full border-collapse rounded-md text-left align-top",
      t
    ), {
      bordered: s = !1,
      striped: l = !0,
      loading: c = !1,
      loadingOptions: u = {
        rows: 5,
        columns: 5
      },
      collapseToList: f = !1,
      ...h
    } = o;
    return /* @__PURE__ */ d(
      Kd.Provider,
      {
        value: {
          bordered: s,
          striped: l,
          loading: c,
          loadingOptions: u,
          collapseToList: f,
          ...h
        },
        children: /* @__PURE__ */ d("div", { className: "overflow-x-auto overflow-y-auto scrollbar-thin", children: /* @__PURE__ */ d("div", { className: "table min-w-full", style: { width: n, height: r }, children: /* @__PURE__ */ d("table", { ref: i, className: a, children: e }) }) })
      }
    );
  }
), bO = O.forwardRef(
  ({ children: e, className: t, ...n }, r) => {
    const o = Oe(Kd), i = I("align-[inherit]", t), a = () => {
      if (!o?.loading) return null;
      const s = Array.from({ length: o?.loadingOptions?.rows || 5 }), l = Array.from({
        length: o?.loadingOptions?.columns || 5
      });
      return s.map((c, u) => /* @__PURE__ */ d(Lt.Row, { children: l.map((f, h) => /* @__PURE__ */ d(Lt.Cell, { role: "alert", "aria-busy": "true", children: /* @__PURE__ */ d(S1, {}) }, h)) }, u));
    };
    return /* @__PURE__ */ d("tbody", { ref: r, className: i, ...n, children: o?.loading ? /* @__PURE__ */ d(a, {}) : e });
  }
);
bO.displayName = "TableBody";
const wO = 6048e5, _H = 864e5, OH = 6e4, AH = 36e5, PH = 1e3, Pg = Symbol.for("constructDateFrom");
function ht(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && Pg in e ? e[Pg](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function qe(e, t) {
  return ht(t || e, e);
}
function ku(e, t, n) {
  const r = qe(e, n?.in);
  return isNaN(t) ? ht(n?.in || e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
function xO(e, t, n) {
  const r = qe(e, n?.in);
  if (isNaN(t)) return ht(e, NaN);
  if (!t)
    return r;
  const o = r.getDate(), i = ht(e, r.getTime());
  i.setMonth(r.getMonth() + t + 1, 0);
  const a = i.getDate();
  return o >= a ? i : (r.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    o
  ), r);
}
let TH = {};
function Ni() {
  return TH;
}
function Ko(e, t) {
  const n = Ni(), r = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, o = qe(e, t?.in), i = o.getDay(), a = (i < r ? 7 : 0) + i - r;
  return o.setDate(o.getDate() - a), o.setHours(0, 0, 0, 0), o;
}
function yi(e, t) {
  return Ko(e, { ...t, weekStartsOn: 1 });
}
function SO(e, t) {
  const n = qe(e, t?.in), r = n.getFullYear(), o = ht(n, 0);
  o.setFullYear(r + 1, 0, 4), o.setHours(0, 0, 0, 0);
  const i = yi(o), a = ht(n, 0);
  a.setFullYear(r, 0, 4), a.setHours(0, 0, 0, 0);
  const s = yi(a);
  return n.getTime() >= i.getTime() ? r + 1 : n.getTime() >= s.getTime() ? r : r - 1;
}
function a5(e) {
  const t = qe(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function gs(e, ...t) {
  const n = ht.bind(
    null,
    t.find((r) => typeof r == "object")
  );
  return t.map(n);
}
function Pl(e, t) {
  const n = qe(e, t?.in);
  return n.setHours(0, 0, 0, 0), n;
}
function MO(e, t, n) {
  const [r, o] = gs(
    n?.in,
    e,
    t
  ), i = Pl(r), a = Pl(o), s = +i - a5(i), l = +a - a5(a);
  return Math.round((s - l) / _H);
}
function IH(e, t) {
  const n = SO(e, t), r = ht(e, 0);
  return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), yi(r);
}
function DH(e, t, n) {
  return ku(e, t * 7, n);
}
function RH(e, t, n) {
  return xO(e, t * 12, n);
}
function kH(e, t) {
  let n, r = t?.in;
  return e.forEach((o) => {
    !r && typeof o == "object" && (r = ht.bind(null, o));
    const i = qe(o, r);
    (!n || n < i || isNaN(+i)) && (n = i);
  }), ht(r, n || NaN);
}
function LH(e, t) {
  let n, r = t?.in;
  return e.forEach((o) => {
    !r && typeof o == "object" && (r = ht.bind(null, o));
    const i = qe(o, r);
    (!n || n > i || isNaN(+i)) && (n = i);
  }), ht(r, n || NaN);
}
function NH(e, t, n) {
  const [r, o] = gs(
    n?.in,
    e,
    t
  );
  return +Pl(r) == +Pl(o);
}
function EO(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Xd(e) {
  return !(!EO(e) && typeof e != "number" || isNaN(+qe(e)));
}
function FH(e, t, n) {
  const [r, o] = gs(
    n?.in,
    e,
    t
  ), i = r.getFullYear() - o.getFullYear(), a = r.getMonth() - o.getMonth();
  return i * 12 + a;
}
function VH(e, t) {
  const n = qe(e, t?.in), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function _O(e, t) {
  const [n, r] = gs(e, t.start, t.end);
  return { start: n, end: r };
}
function BH(e, t) {
  const { start: n, end: r } = _O(t?.in, e);
  let o = +n > +r;
  const i = o ? +n : +r, a = o ? r : n;
  a.setHours(0, 0, 0, 0), a.setDate(1);
  let s = 1;
  const l = [];
  for (; +a <= i; )
    l.push(ht(n, a)), a.setMonth(a.getMonth() + s);
  return o ? l.reverse() : l;
}
function $H(e, t) {
  const n = qe(e, t?.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function jH(e, t) {
  const n = qe(e, t?.in), r = n.getFullYear();
  return n.setFullYear(r + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function OO(e, t) {
  const n = qe(e, t?.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function HH(e, t) {
  const { start: n, end: r } = _O(t?.in, e);
  let o = +n > +r;
  const i = o ? +n : +r, a = o ? r : n;
  a.setHours(0, 0, 0, 0), a.setMonth(0, 1);
  let s = 1;
  const l = [];
  for (; +a <= i; )
    l.push(ht(n, a)), a.setFullYear(a.getFullYear() + s);
  return o ? l.reverse() : l;
}
function AO(e, t) {
  const n = Ni(), r = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, o = qe(e, t?.in), i = o.getDay(), a = (i < r ? -7 : 0) + 6 - (i - r);
  return o.setDate(o.getDate() + a), o.setHours(23, 59, 59, 999), o;
}
function zH(e, t) {
  return AO(e, { ...t, weekStartsOn: 1 });
}
const ZH = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, WH = (e, t, n) => {
  let r;
  const o = ZH[e];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", t.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function xa(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const qH = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, UH = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, GH = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, KH = {
  date: xa({
    formats: qH,
    defaultWidth: "full"
  }),
  time: xa({
    formats: UH,
    defaultWidth: "full"
  }),
  dateTime: xa({
    formats: GH,
    defaultWidth: "full"
  })
}, YH = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, XH = (e, t, n, r) => YH[e];
function ro(e) {
  return (t, n) => {
    const r = n?.context ? String(n.context) : "standalone";
    let o;
    if (r === "formatting" && e.formattingValues) {
      const a = e.defaultFormattingWidth || e.defaultWidth, s = n?.width ? String(n.width) : a;
      o = e.formattingValues[s] || e.formattingValues[a];
    } else {
      const a = e.defaultWidth, s = n?.width ? String(n.width) : e.defaultWidth;
      o = e.values[s] || e.values[a];
    }
    const i = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[i];
  };
}
const QH = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, JH = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, ez = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, tz = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, nz = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, rz = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, oz = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, iz = {
  ordinalNumber: oz,
  era: ro({
    values: QH,
    defaultWidth: "wide"
  }),
  quarter: ro({
    values: JH,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: ro({
    values: ez,
    defaultWidth: "wide"
  }),
  day: ro({
    values: tz,
    defaultWidth: "wide"
  }),
  dayPeriod: ro({
    values: nz,
    defaultWidth: "wide",
    formattingValues: rz,
    defaultFormattingWidth: "wide"
  })
};
function oo(e) {
  return (t, n = {}) => {
    const r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], i = t.match(o);
    if (!i)
      return null;
    const a = i[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? sz(s, (f) => f.test(a)) : (
      // [TODO] -- I challenge you to fix the type
      az(s, (f) => f.test(a))
    );
    let c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(c)
    ) : c;
    const u = t.slice(a.length);
    return { value: c, rest: u };
  };
}
function az(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function sz(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function PO(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const o = r[0], i = t.match(e.parsePattern);
    if (!i) return null;
    let a = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    a = n.valueCallback ? n.valueCallback(a) : a;
    const s = t.slice(o.length);
    return { value: a, rest: s };
  };
}
const lz = /^(\d+)(th|st|nd|rd)?/i, cz = /\d+/i, uz = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, fz = {
  any: [/^b/i, /^(a|c)/i]
}, dz = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, hz = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, pz = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, mz = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, gz = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Cz = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, vz = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, yz = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, bz = {
  ordinalNumber: PO({
    matchPattern: lz,
    parsePattern: cz,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: oo({
    matchPatterns: uz,
    defaultMatchWidth: "wide",
    parsePatterns: fz,
    defaultParseWidth: "any"
  }),
  quarter: oo({
    matchPatterns: dz,
    defaultMatchWidth: "wide",
    parsePatterns: hz,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: oo({
    matchPatterns: pz,
    defaultMatchWidth: "wide",
    parsePatterns: mz,
    defaultParseWidth: "any"
  }),
  day: oo({
    matchPatterns: gz,
    defaultMatchWidth: "wide",
    parsePatterns: Cz,
    defaultParseWidth: "any"
  }),
  dayPeriod: oo({
    matchPatterns: vz,
    defaultMatchWidth: "any",
    parsePatterns: yz,
    defaultParseWidth: "any"
  })
}, Lu = {
  code: "en-US",
  formatDistance: WH,
  formatLong: KH,
  formatRelative: XH,
  localize: iz,
  match: bz,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function wz(e, t) {
  const n = qe(e, t?.in);
  return MO(n, OO(n)) + 1;
}
function Qd(e, t) {
  const n = qe(e, t?.in), r = +yi(n) - +IH(n);
  return Math.round(r / wO) + 1;
}
function Jd(e, t) {
  const n = qe(e, t?.in), r = n.getFullYear(), o = Ni(), i = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? o.firstWeekContainsDate ?? o.locale?.options?.firstWeekContainsDate ?? 1, a = ht(t?.in || e, 0);
  a.setFullYear(r + 1, 0, i), a.setHours(0, 0, 0, 0);
  const s = Ko(a, t), l = ht(t?.in || e, 0);
  l.setFullYear(r, 0, i), l.setHours(0, 0, 0, 0);
  const c = Ko(l, t);
  return +n >= +s ? r + 1 : +n >= +c ? r : r - 1;
}
function xz(e, t) {
  const n = Ni(), r = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, o = Jd(e, t), i = ht(t?.in || e, 0);
  return i.setFullYear(o, 0, r), i.setHours(0, 0, 0, 0), Ko(i, t);
}
function eh(e, t) {
  const n = qe(e, t?.in), r = +Ko(n, t) - +xz(n, t);
  return Math.round(r / wO) + 1;
}
function dt(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const s1 = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return dt(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : dt(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return dt(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return dt(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return dt(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return dt(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return dt(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), o = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return dt(o, t.length);
  }
}, Ui = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Tg = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), o = r > 0 ? r : 1 - r;
      return n.ordinalNumber(o, { unit: "year" });
    }
    return s1.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const o = Jd(e, r), i = o > 0 ? o : 1 - o;
    if (t === "YY") {
      const a = i % 100;
      return dt(a, 2);
    }
    return t === "Yo" ? n.ordinalNumber(i, { unit: "year" }) : dt(i, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = SO(e);
    return dt(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return dt(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return dt(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return dt(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return s1.M(e, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return dt(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const o = eh(e, r);
    return t === "wo" ? n.ordinalNumber(o, { unit: "week" }) : dt(o, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = Qd(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : dt(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : s1.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = wz(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : dt(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const o = e.getDay(), i = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(i);
      // Padded numerical value
      case "ee":
        return dt(i, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(i, { unit: "day" });
      case "eee":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const o = e.getDay(), i = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(i);
      // Padded numerical value
      case "cc":
        return dt(i, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return n.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(o, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(o, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return n.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), o = r === 0 ? 7 : r;
    switch (t) {
      // 2
      case "i":
        return String(o);
      // 02
      case "ii":
        return dt(o, t.length);
      // 2nd
      case "io":
        return n.ordinalNumber(o, { unit: "day" });
      // Tue
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r === 12 ? o = Ui.noon : r === 0 ? o = Ui.midnight : o = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r >= 17 ? o = Ui.evening : r >= 12 ? o = Ui.afternoon : r >= 4 ? o = Ui.morning : o = Ui.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return s1.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : s1.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : dt(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : dt(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : s1.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : s1.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return s1.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return Dg(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return Y1(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return Y1(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return Dg(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return Y1(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return Y1(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Ig(r, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + Y1(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Ig(r, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + Y1(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(+e / 1e3);
    return dt(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    return dt(+e, t.length);
  }
};
function Ig(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.trunc(r / 60), i = r % 60;
  return i === 0 ? n + String(o) : n + String(o) + t + dt(i, 2);
}
function Dg(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + dt(Math.abs(e) / 60, 2) : Y1(e, t);
}
function Y1(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = dt(Math.trunc(r / 60), 2), i = dt(r % 60, 2);
  return n + o + t + i;
}
const Rg = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, TO = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, Sz = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], o = n[2];
  if (!o)
    return Rg(e, t);
  let i;
  switch (r) {
    case "P":
      i = t.dateTime({ width: "short" });
      break;
    case "PP":
      i = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = t.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", Rg(r, t)).replace("{{time}}", TO(o, t));
}, S9 = {
  p: TO,
  P: Sz
}, Mz = /^D+$/, Ez = /^Y+$/, _z = ["D", "DD", "YY", "YYYY"];
function IO(e) {
  return Mz.test(e);
}
function DO(e) {
  return Ez.test(e);
}
function M9(e, t, n) {
  const r = Oz(e, t, n);
  if (console.warn(r), _z.includes(e)) throw new RangeError(r);
}
function Oz(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const Az = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Pz = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Tz = /^'([^]*?)'?$/, Iz = /''/g, Dz = /[a-zA-Z]/;
function Sa(e, t, n) {
  const r = Ni(), o = n?.locale ?? r.locale ?? Lu, i = n?.firstWeekContainsDate ?? n?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, a = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? r.weekStartsOn ?? r.locale?.options?.weekStartsOn ?? 0, s = qe(e, n?.in);
  if (!Xd(s))
    throw new RangeError("Invalid time value");
  let l = t.match(Pz).map((u) => {
    const f = u[0];
    if (f === "p" || f === "P") {
      const h = S9[f];
      return h(u, o.formatLong);
    }
    return u;
  }).join("").match(Az).map((u) => {
    if (u === "''")
      return { isToken: !1, value: "'" };
    const f = u[0];
    if (f === "'")
      return { isToken: !1, value: Rz(u) };
    if (Tg[f])
      return { isToken: !0, value: u };
    if (f.match(Dz))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + f + "`"
      );
    return { isToken: !1, value: u };
  });
  o.localize.preprocessor && (l = o.localize.preprocessor(s, l));
  const c = {
    firstWeekContainsDate: i,
    weekStartsOn: a,
    locale: o
  };
  return l.map((u) => {
    if (!u.isToken) return u.value;
    const f = u.value;
    (!n?.useAdditionalWeekYearTokens && DO(f) || !n?.useAdditionalDayOfYearTokens && IO(f)) && M9(f, t, String(e));
    const h = Tg[f[0]];
    return h(s, f, o.localize, c);
  }).join("");
}
function Rz(e) {
  const t = e.match(Tz);
  return t ? t[1].replace(Iz, "'") : e;
}
function kz(e, t) {
  return qe(e, t?.in).getDate();
}
function Lz(e, t) {
  const n = qe(e, t?.in), r = n.getFullYear(), o = n.getMonth(), i = ht(n, 0);
  return i.setFullYear(r, o + 1, 0), i.setHours(0, 0, 0, 0), i.getDate();
}
function Nz() {
  return Object.assign({}, Ni());
}
function Fz(e, t) {
  const n = qe(e, t?.in).getDay();
  return n === 0 ? 7 : n;
}
function RO(e, t) {
  return qe(e, t?.in).getMonth();
}
function kO(e, t) {
  return qe(e, t?.in).getFullYear();
}
function Vz(e, t) {
  return +qe(e) > +qe(t);
}
function Bz(e, t) {
  return +qe(e) < +qe(t);
}
function $z(e, t) {
  const n = jz(t) ? new t(0) : ht(t, 0);
  return n.setFullYear(e.getFullYear(), e.getMonth(), e.getDate()), n.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), n;
}
function jz(e) {
  return typeof e == "function" && e.prototype?.constructor === e;
}
const Hz = 10;
class LO {
  subPriority = 0;
  validate(t, n) {
    return !0;
  }
}
class zz extends LO {
  constructor(t, n, r, o, i) {
    super(), this.value = t, this.validateValue = n, this.setValue = r, this.priority = o, i && (this.subPriority = i);
  }
  validate(t, n) {
    return this.validateValue(t, this.value, n);
  }
  set(t, n, r) {
    return this.setValue(t, n, this.value, r);
  }
}
class Zz extends LO {
  priority = Hz;
  subPriority = -1;
  constructor(t, n) {
    super(), this.context = t || ((r) => ht(n, r));
  }
  set(t, n) {
    return n.timestampIsSet ? t : ht(t, $z(t, this.context));
  }
}
class ot {
  run(t, n, r, o) {
    const i = this.parse(t, n, r, o);
    return i ? {
      setter: new zz(
        i.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: i.rest
    } : null;
  }
  validate(t, n, r) {
    return !0;
  }
}
class Wz extends ot {
  priority = 140;
  parse(t, n, r) {
    switch (n) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return r.era(t, { width: "abbreviated" }) || r.era(t, { width: "narrow" });
      // A, B
      case "GGGGG":
        return r.era(t, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return r.era(t, { width: "wide" }) || r.era(t, { width: "abbreviated" }) || r.era(t, { width: "narrow" });
    }
  }
  set(t, n, r) {
    return n.era = r, t.setFullYear(r, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = ["R", "u", "t", "T"];
}
const Wt = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, io = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function qt(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function Ft(e, t) {
  const n = t.match(e);
  return n ? {
    value: parseInt(n[0], 10),
    rest: t.slice(n[0].length)
  } : null;
}
function ao(e, t) {
  const n = t.match(e);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  const r = n[1] === "+" ? 1 : -1, o = n[2] ? parseInt(n[2], 10) : 0, i = n[3] ? parseInt(n[3], 10) : 0, a = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: r * (o * AH + i * OH + a * PH),
    rest: t.slice(n[0].length)
  };
}
function NO(e) {
  return Ft(Wt.anyDigitsSigned, e);
}
function $t(e, t) {
  switch (e) {
    case 1:
      return Ft(Wt.singleDigit, t);
    case 2:
      return Ft(Wt.twoDigits, t);
    case 3:
      return Ft(Wt.threeDigits, t);
    case 4:
      return Ft(Wt.fourDigits, t);
    default:
      return Ft(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function s5(e, t) {
  switch (e) {
    case 1:
      return Ft(Wt.singleDigitSigned, t);
    case 2:
      return Ft(Wt.twoDigitsSigned, t);
    case 3:
      return Ft(Wt.threeDigitsSigned, t);
    case 4:
      return Ft(Wt.fourDigitsSigned, t);
    default:
      return Ft(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function th(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function FO(e, t) {
  const n = t > 0, r = n ? t : 1 - t;
  let o;
  if (r <= 50)
    o = e || 100;
  else {
    const i = r + 50, a = Math.trunc(i / 100) * 100, s = e >= i % 100;
    o = e + a - (s ? 100 : 0);
  }
  return n ? o : 1 - o;
}
function VO(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
class qz extends ot {
  priority = 130;
  incompatibleTokens = ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"];
  parse(t, n, r) {
    const o = (i) => ({
      year: i,
      isTwoDigitYear: n === "yy"
    });
    switch (n) {
      case "y":
        return qt($t(4, t), o);
      case "yo":
        return qt(
          r.ordinalNumber(t, {
            unit: "year"
          }),
          o
        );
      default:
        return qt($t(n.length, t), o);
    }
  }
  validate(t, n) {
    return n.isTwoDigitYear || n.year > 0;
  }
  set(t, n, r) {
    const o = t.getFullYear();
    if (r.isTwoDigitYear) {
      const a = FO(
        r.year,
        o
      );
      return t.setFullYear(a, 0, 1), t.setHours(0, 0, 0, 0), t;
    }
    const i = !("era" in n) || n.era === 1 ? r.year : 1 - r.year;
    return t.setFullYear(i, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Uz extends ot {
  priority = 130;
  parse(t, n, r) {
    const o = (i) => ({
      year: i,
      isTwoDigitYear: n === "YY"
    });
    switch (n) {
      case "Y":
        return qt($t(4, t), o);
      case "Yo":
        return qt(
          r.ordinalNumber(t, {
            unit: "year"
          }),
          o
        );
      default:
        return qt($t(n.length, t), o);
    }
  }
  validate(t, n) {
    return n.isTwoDigitYear || n.year > 0;
  }
  set(t, n, r, o) {
    const i = Jd(t, o);
    if (r.isTwoDigitYear) {
      const s = FO(
        r.year,
        i
      );
      return t.setFullYear(
        s,
        0,
        o.firstWeekContainsDate
      ), t.setHours(0, 0, 0, 0), Ko(t, o);
    }
    const a = !("era" in n) || n.era === 1 ? r.year : 1 - r.year;
    return t.setFullYear(a, 0, o.firstWeekContainsDate), t.setHours(0, 0, 0, 0), Ko(t, o);
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T"
  ];
}
class Gz extends ot {
  priority = 130;
  parse(t, n) {
    return s5(n === "R" ? 4 : n.length, t);
  }
  set(t, n, r) {
    const o = ht(t, 0);
    return o.setFullYear(r, 0, 4), o.setHours(0, 0, 0, 0), yi(o);
  }
  incompatibleTokens = [
    "G",
    "y",
    "Y",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T"
  ];
}
class Kz extends ot {
  priority = 130;
  parse(t, n) {
    return s5(n === "u" ? 4 : n.length, t);
  }
  set(t, n, r) {
    return t.setFullYear(r, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"];
}
class Yz extends ot {
  priority = 120;
  parse(t, n, r) {
    switch (n) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ":
        return $t(n.length, t);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return r.ordinalNumber(t, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return r.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return r.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return r.quarter(t, {
          width: "wide",
          context: "formatting"
        }) || r.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 4;
  }
  set(t, n, r) {
    return t.setMonth((r - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
class Xz extends ot {
  priority = 120;
  parse(t, n, r) {
    switch (n) {
      // 1, 2, 3, 4
      case "q":
      case "qq":
        return $t(n.length, t);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return r.ordinalNumber(t, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return r.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return r.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return r.quarter(t, {
          width: "wide",
          context: "standalone"
        }) || r.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 4;
  }
  set(t, n, r) {
    return t.setMonth((r - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
class Qz extends ot {
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "L",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
  priority = 110;
  parse(t, n, r) {
    const o = (i) => i - 1;
    switch (n) {
      // 1, 2, ..., 12
      case "M":
        return qt(
          Ft(Wt.month, t),
          o
        );
      // 01, 02, ..., 12
      case "MM":
        return qt($t(2, t), o);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return qt(
          r.ordinalNumber(t, {
            unit: "month"
          }),
          o
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return r.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.month(t, { width: "narrow", context: "formatting" });
      // J, F, ..., D
      case "MMMMM":
        return r.month(t, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return r.month(t, { width: "wide", context: "formatting" }) || r.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.month(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 11;
  }
  set(t, n, r) {
    return t.setMonth(r, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Jz extends ot {
  priority = 110;
  parse(t, n, r) {
    const o = (i) => i - 1;
    switch (n) {
      // 1, 2, ..., 12
      case "L":
        return qt(
          Ft(Wt.month, t),
          o
        );
      // 01, 02, ..., 12
      case "LL":
        return qt($t(2, t), o);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return qt(
          r.ordinalNumber(t, {
            unit: "month"
          }),
          o
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return r.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.month(t, { width: "narrow", context: "standalone" });
      // J, F, ..., D
      case "LLLLL":
        return r.month(t, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return r.month(t, { width: "wide", context: "standalone" }) || r.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.month(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 11;
  }
  set(t, n, r) {
    return t.setMonth(r, 1), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
function eZ(e, t, n) {
  const r = qe(e, n?.in), o = eh(r, n) - t;
  return r.setDate(r.getDate() - o * 7), qe(r, n?.in);
}
class tZ extends ot {
  priority = 100;
  parse(t, n, r) {
    switch (n) {
      case "w":
        return Ft(Wt.week, t);
      case "wo":
        return r.ordinalNumber(t, { unit: "week" });
      default:
        return $t(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 53;
  }
  set(t, n, r, o) {
    return Ko(eZ(t, r, o), o);
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T"
  ];
}
function nZ(e, t, n) {
  const r = qe(e, n?.in), o = Qd(r, n) - t;
  return r.setDate(r.getDate() - o * 7), r;
}
class rZ extends ot {
  priority = 100;
  parse(t, n, r) {
    switch (n) {
      case "I":
        return Ft(Wt.week, t);
      case "Io":
        return r.ordinalNumber(t, { unit: "week" });
      default:
        return $t(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 53;
  }
  set(t, n, r) {
    return yi(nZ(t, r));
  }
  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T"
  ];
}
const oZ = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], iZ = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class aZ extends ot {
  priority = 90;
  subPriority = 1;
  parse(t, n, r) {
    switch (n) {
      case "d":
        return Ft(Wt.date, t);
      case "do":
        return r.ordinalNumber(t, { unit: "date" });
      default:
        return $t(n.length, t);
    }
  }
  validate(t, n) {
    const r = t.getFullYear(), o = VO(r), i = t.getMonth();
    return o ? n >= 1 && n <= iZ[i] : n >= 1 && n <= oZ[i];
  }
  set(t, n, r) {
    return t.setDate(r), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
class sZ extends ot {
  priority = 90;
  subpriority = 1;
  parse(t, n, r) {
    switch (n) {
      case "D":
      case "DD":
        return Ft(Wt.dayOfYear, t);
      case "Do":
        return r.ordinalNumber(t, { unit: "date" });
      default:
        return $t(n.length, t);
    }
  }
  validate(t, n) {
    const r = t.getFullYear();
    return VO(r) ? n >= 1 && n <= 366 : n >= 1 && n <= 365;
  }
  set(t, n, r) {
    return t.setMonth(0, r), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "E",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
function nh(e, t, n) {
  const r = Ni(), o = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? r.weekStartsOn ?? r.locale?.options?.weekStartsOn ?? 0, i = qe(e, n?.in), a = i.getDay(), l = (t % 7 + 7) % 7, c = 7 - o, u = t < 0 || t > 6 ? t - (a + c) % 7 : (l + c) % 7 - (a + c) % 7;
  return ku(i, u, n);
}
class lZ extends ot {
  priority = 90;
  parse(t, n, r) {
    switch (n) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
      // T
      case "EEEEE":
        return r.day(t, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
      // Tuesday
      case "EEEE":
      default:
        return r.day(t, { width: "wide", context: "formatting" }) || r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 6;
  }
  set(t, n, r, o) {
    return t = nh(t, r, o), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = ["D", "i", "e", "c", "t", "T"];
}
class cZ extends ot {
  priority = 90;
  parse(t, n, r, o) {
    const i = (a) => {
      const s = Math.floor((a - 1) / 7) * 7;
      return (a + o.weekStartsOn + 6) % 7 + s;
    };
    switch (n) {
      // 3
      case "e":
      case "ee":
        return qt($t(n.length, t), i);
      // 3rd
      case "eo":
        return qt(
          r.ordinalNumber(t, {
            unit: "day"
          }),
          i
        );
      // Tue
      case "eee":
        return r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
      // T
      case "eeeee":
        return r.day(t, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
      // Tuesday
      case "eeee":
      default:
        return r.day(t, { width: "wide", context: "formatting" }) || r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 6;
  }
  set(t, n, r, o) {
    return t = nh(t, r, o), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "c",
    "t",
    "T"
  ];
}
class uZ extends ot {
  priority = 90;
  parse(t, n, r, o) {
    const i = (a) => {
      const s = Math.floor((a - 1) / 7) * 7;
      return (a + o.weekStartsOn + 6) % 7 + s;
    };
    switch (n) {
      // 3
      case "c":
      case "cc":
        return qt($t(n.length, t), i);
      // 3rd
      case "co":
        return qt(
          r.ordinalNumber(t, {
            unit: "day"
          }),
          i
        );
      // Tue
      case "ccc":
        return r.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.day(t, { width: "short", context: "standalone" }) || r.day(t, { width: "narrow", context: "standalone" });
      // T
      case "ccccc":
        return r.day(t, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return r.day(t, { width: "short", context: "standalone" }) || r.day(t, { width: "narrow", context: "standalone" });
      // Tuesday
      case "cccc":
      default:
        return r.day(t, { width: "wide", context: "standalone" }) || r.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.day(t, { width: "short", context: "standalone" }) || r.day(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 6;
  }
  set(t, n, r, o) {
    return t = nh(t, r, o), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "e",
    "t",
    "T"
  ];
}
function fZ(e, t, n) {
  const r = qe(e, n?.in), o = Fz(r, n), i = t - o;
  return ku(r, i, n);
}
class dZ extends ot {
  priority = 90;
  parse(t, n, r) {
    const o = (i) => i === 0 ? 7 : i;
    switch (n) {
      // 2
      case "i":
      case "ii":
        return $t(n.length, t);
      // 2nd
      case "io":
        return r.ordinalNumber(t, { unit: "day" });
      // Tue
      case "iii":
        return qt(
          r.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(t, {
            width: "short",
            context: "formatting"
          }) || r.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      // T
      case "iiiii":
        return qt(
          r.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      // Tu
      case "iiiiii":
        return qt(
          r.day(t, {
            width: "short",
            context: "formatting"
          }) || r.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      // Tuesday
      case "iiii":
      default:
        return qt(
          r.day(t, {
            width: "wide",
            context: "formatting"
          }) || r.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(t, {
            width: "short",
            context: "formatting"
          }) || r.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 7;
  }
  set(t, n, r) {
    return t = fZ(t, r), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "E",
    "e",
    "c",
    "t",
    "T"
  ];
}
class hZ extends ot {
  priority = 80;
  parse(t, n, r) {
    switch (n) {
      case "a":
      case "aa":
      case "aaa":
        return r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, n, r) {
    return t.setHours(th(r), 0, 0, 0), t;
  }
  incompatibleTokens = ["b", "B", "H", "k", "t", "T"];
}
class pZ extends ot {
  priority = 80;
  parse(t, n, r) {
    switch (n) {
      case "b":
      case "bb":
      case "bbb":
        return r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, n, r) {
    return t.setHours(th(r), 0, 0, 0), t;
  }
  incompatibleTokens = ["a", "B", "H", "k", "t", "T"];
}
class mZ extends ot {
  priority = 80;
  parse(t, n, r) {
    switch (n) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, n, r) {
    return t.setHours(th(r), 0, 0, 0), t;
  }
  incompatibleTokens = ["a", "b", "t", "T"];
}
class gZ extends ot {
  priority = 70;
  parse(t, n, r) {
    switch (n) {
      case "h":
        return Ft(Wt.hour12h, t);
      case "ho":
        return r.ordinalNumber(t, { unit: "hour" });
      default:
        return $t(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 12;
  }
  set(t, n, r) {
    const o = t.getHours() >= 12;
    return o && r < 12 ? t.setHours(r + 12, 0, 0, 0) : !o && r === 12 ? t.setHours(0, 0, 0, 0) : t.setHours(r, 0, 0, 0), t;
  }
  incompatibleTokens = ["H", "K", "k", "t", "T"];
}
class CZ extends ot {
  priority = 70;
  parse(t, n, r) {
    switch (n) {
      case "H":
        return Ft(Wt.hour23h, t);
      case "Ho":
        return r.ordinalNumber(t, { unit: "hour" });
      default:
        return $t(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 23;
  }
  set(t, n, r) {
    return t.setHours(r, 0, 0, 0), t;
  }
  incompatibleTokens = ["a", "b", "h", "K", "k", "t", "T"];
}
class vZ extends ot {
  priority = 70;
  parse(t, n, r) {
    switch (n) {
      case "K":
        return Ft(Wt.hour11h, t);
      case "Ko":
        return r.ordinalNumber(t, { unit: "hour" });
      default:
        return $t(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 11;
  }
  set(t, n, r) {
    return t.getHours() >= 12 && r < 12 ? t.setHours(r + 12, 0, 0, 0) : t.setHours(r, 0, 0, 0), t;
  }
  incompatibleTokens = ["h", "H", "k", "t", "T"];
}
class yZ extends ot {
  priority = 70;
  parse(t, n, r) {
    switch (n) {
      case "k":
        return Ft(Wt.hour24h, t);
      case "ko":
        return r.ordinalNumber(t, { unit: "hour" });
      default:
        return $t(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 24;
  }
  set(t, n, r) {
    const o = r <= 24 ? r % 24 : r;
    return t.setHours(o, 0, 0, 0), t;
  }
  incompatibleTokens = ["a", "b", "h", "H", "K", "t", "T"];
}
class bZ extends ot {
  priority = 60;
  parse(t, n, r) {
    switch (n) {
      case "m":
        return Ft(Wt.minute, t);
      case "mo":
        return r.ordinalNumber(t, { unit: "minute" });
      default:
        return $t(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 59;
  }
  set(t, n, r) {
    return t.setMinutes(r, 0, 0), t;
  }
  incompatibleTokens = ["t", "T"];
}
class wZ extends ot {
  priority = 50;
  parse(t, n, r) {
    switch (n) {
      case "s":
        return Ft(Wt.second, t);
      case "so":
        return r.ordinalNumber(t, { unit: "second" });
      default:
        return $t(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 59;
  }
  set(t, n, r) {
    return t.setSeconds(r, 0), t;
  }
  incompatibleTokens = ["t", "T"];
}
class xZ extends ot {
  priority = 30;
  parse(t, n) {
    const r = (o) => Math.trunc(o * Math.pow(10, -n.length + 3));
    return qt($t(n.length, t), r);
  }
  set(t, n, r) {
    return t.setMilliseconds(r), t;
  }
  incompatibleTokens = ["t", "T"];
}
class SZ extends ot {
  priority = 10;
  parse(t, n) {
    switch (n) {
      case "X":
        return ao(
          io.basicOptionalMinutes,
          t
        );
      case "XX":
        return ao(io.basic, t);
      case "XXXX":
        return ao(
          io.basicOptionalSeconds,
          t
        );
      case "XXXXX":
        return ao(
          io.extendedOptionalSeconds,
          t
        );
      case "XXX":
      default:
        return ao(io.extended, t);
    }
  }
  set(t, n, r) {
    return n.timestampIsSet ? t : ht(
      t,
      t.getTime() - a5(t) - r
    );
  }
  incompatibleTokens = ["t", "T", "x"];
}
class MZ extends ot {
  priority = 10;
  parse(t, n) {
    switch (n) {
      case "x":
        return ao(
          io.basicOptionalMinutes,
          t
        );
      case "xx":
        return ao(io.basic, t);
      case "xxxx":
        return ao(
          io.basicOptionalSeconds,
          t
        );
      case "xxxxx":
        return ao(
          io.extendedOptionalSeconds,
          t
        );
      case "xxx":
      default:
        return ao(io.extended, t);
    }
  }
  set(t, n, r) {
    return n.timestampIsSet ? t : ht(
      t,
      t.getTime() - a5(t) - r
    );
  }
  incompatibleTokens = ["t", "T", "X"];
}
class EZ extends ot {
  priority = 40;
  parse(t) {
    return NO(t);
  }
  set(t, n, r) {
    return [ht(t, r * 1e3), { timestampIsSet: !0 }];
  }
  incompatibleTokens = "*";
}
class _Z extends ot {
  priority = 20;
  parse(t) {
    return NO(t);
  }
  set(t, n, r) {
    return [ht(t, r), { timestampIsSet: !0 }];
  }
  incompatibleTokens = "*";
}
const OZ = {
  G: new Wz(),
  y: new qz(),
  Y: new Uz(),
  R: new Gz(),
  u: new Kz(),
  Q: new Yz(),
  q: new Xz(),
  M: new Qz(),
  L: new Jz(),
  w: new tZ(),
  I: new rZ(),
  d: new aZ(),
  D: new sZ(),
  E: new lZ(),
  e: new cZ(),
  c: new uZ(),
  i: new dZ(),
  a: new hZ(),
  b: new pZ(),
  B: new mZ(),
  h: new gZ(),
  H: new CZ(),
  K: new vZ(),
  k: new yZ(),
  m: new bZ(),
  s: new wZ(),
  S: new xZ(),
  X: new SZ(),
  x: new MZ(),
  t: new EZ(),
  T: new _Z()
}, AZ = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, PZ = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, TZ = /^'([^]*?)'?$/, IZ = /''/g, DZ = /\S/, RZ = /[a-zA-Z]/;
function kZ(e, t, n, r) {
  const o = () => ht(n, NaN), i = Nz(), a = i.locale ?? Lu, s = i.firstWeekContainsDate ?? i.locale?.options?.firstWeekContainsDate ?? 1, l = i.weekStartsOn ?? i.locale?.options?.weekStartsOn ?? 0;
  if (!t)
    return e ? o() : qe(n, r?.in);
  const c = {
    firstWeekContainsDate: s,
    weekStartsOn: l,
    locale: a
  }, u = [new Zz(r?.in, n)], f = t.match(PZ).map((g) => {
    const v = g[0];
    if (v in S9) {
      const y = S9[v];
      return y(g, a.formatLong);
    }
    return g;
  }).join("").match(AZ), h = [];
  for (let g of f) {
    DO(g) && M9(g, t, e), IO(g) && M9(g, t, e);
    const v = g[0], y = OZ[v];
    if (y) {
      const { incompatibleTokens: w } = y;
      if (Array.isArray(w)) {
        const b = h.find(
          (S) => w.includes(S.token) || S.token === v
        );
        if (b)
          throw new RangeError(
            `The format string mustn't contain \`${b.fullToken}\` and \`${g}\` at the same time`
          );
      } else if (y.incompatibleTokens === "*" && h.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${g}\` and any other token at the same time`
        );
      h.push({ token: v, fullToken: g });
      const x = y.run(
        e,
        g,
        a.match,
        c
      );
      if (!x)
        return o();
      u.push(x.setter), e = x.rest;
    } else {
      if (v.match(RZ))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + v + "`"
        );
      if (g === "''" ? g = "'" : v === "'" && (g = LZ(g)), e.indexOf(g) === 0)
        e = e.slice(g.length);
      else
        return o();
    }
  }
  if (e.length > 0 && DZ.test(e))
    return o();
  const p = u.map((g) => g.priority).sort((g, v) => v - g).filter((g, v, y) => y.indexOf(g) === v).map(
    (g) => u.filter((v) => v.priority === g).sort((v, y) => y.subPriority - v.subPriority)
  ).map((g) => g[0]);
  let C = qe(n, r?.in);
  if (isNaN(+C)) return o();
  const m = {};
  for (const g of p) {
    if (!g.validate(C, c))
      return o();
    const v = g.set(C, m, c);
    Array.isArray(v) ? (C = v[0], Object.assign(m, v[1])) : C = v;
  }
  return C;
}
function LZ(e) {
  return e.match(TZ)[1].replace(IZ, "'");
}
function kg(e, t) {
  const n = qe(e, t?.in);
  return n.setSeconds(0, 0), n;
}
function Lg(e, t) {
  return +kg(e) == +kg(t);
}
function NZ(e, t, n) {
  const [r, o] = gs(
    n?.in,
    e,
    t
  );
  return r.getFullYear() === o.getFullYear() && r.getMonth() === o.getMonth();
}
function FZ(e, t, n) {
  const [r, o] = gs(
    n?.in,
    e,
    t
  );
  return r.getFullYear() === o.getFullYear();
}
function VZ(e, t, n) {
  const r = qe(e, n?.in), o = r.getFullYear(), i = r.getDate(), a = ht(e, 0);
  a.setFullYear(o, t, 15), a.setHours(0, 0, 0, 0);
  const s = Lz(a);
  return r.setMonth(t, Math.min(i, s)), r;
}
function BZ(e, t, n) {
  const r = qe(e, n?.in);
  return isNaN(+r) ? ht(e, NaN) : (r.setFullYear(t), r);
}
const ppe = [
  "Januar",
  "Februar",
  "Mars",
  "April",
  "Mai",
  "Juni",
  "Juli",
  "August",
  "September",
  "Oktober",
  "November",
  "Desember"
], mpe = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "Mai",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Okt",
  "Nov",
  "Des"
], gpe = [
  "Mandag",
  "Tirsdag",
  "Onsdag",
  "Torsdag",
  "Fredag",
  "Lørdag",
  "Søndag"
], Cpe = ["S", "M", "T", "O", "T", "F", "L"], $Z = (e) => {
  switch (e.length) {
    case 10:
      return e.includes(".") ? "dd.MM.yyyy" : e.includes("/") ? "dd/MM/yyyy" : void 0;
    case 8:
      return e.includes(".") ? "dd.MM.yy" : e.includes("/") ? "dd/MM/yy" : "ddMMyyyy";
    case 6:
      return "ddMMyy";
    default:
      return;
  }
}, Tl = (e) => {
  const t = /* @__PURE__ */ new Date(), n = $Z(e);
  if (!n) return /* @__PURE__ */ new Date(NaN);
  const r = kZ(e, n, t);
  return Xd(r) ? jZ(r) : /* @__PURE__ */ new Date(NaN);
}, jZ = (e) => {
  const t = kO(e), n = RO(e), r = kz(e), o = Date.UTC(t, n, r);
  return new Date(o);
}, vpe = (e) => {
  const t = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric"
  };
  return new Intl.DateTimeFormat(
    ["no-NO", "nb-NO", "nn-NO", "de-DE"],
    t
  ).format(new Date(e));
}, HZ = (e, t, n) => {
  if (!e) return !1;
  const r = t ? new Date(t) : null, o = n ? new Date(n) : null;
  return e = new Date(e), e.setHours(12), r && r.setHours(0), o && o.setHours(24), r || o ? (!r || r && e >= r) && (!o || o && e <= o) : !0;
}, rh = (e, t) => e.getFullYear() === t.getFullYear() && e.getMonth() === t.getMonth() && e.getDate() === t.getDate(), oh = {
  day: "2-digit",
  month: "2-digit",
  year: "numeric"
}, zZ = {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit"
}, ype = {
  day: "numeric",
  month: "long"
}, bpe = {
  month: "short"
}, wpe = {
  month: "long",
  year: "numeric"
}, xpe = {
  month: "2-digit",
  year: "numeric"
}, BO = {
  hour: "2-digit",
  minute: "2-digit"
}, Spe = {
  day: "2-digit",
  month: "long",
  year: "numeric"
}, Ma = (e, t, n) => {
  if (isNaN(e))
    return e;
  if (e == null)
    return "";
  n && (e = Math.floor(e));
  const r = new Intl.NumberFormat(["no-NO", "nb-NO"], {
    style: "decimal",
    useGrouping: !0,
    currency: "NOK",
    maximumFractionDigits: t || 0,
    minimumFractionDigits: t || 0
  }).format(e);
  return t ? r : r.replace(/,/g, ".");
}, Mpe = (e, t) => e == null ? "Ikke angitt" : Ma(e, t) + " kr", Ea = (e, t) => {
  const n = t || {
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    day: "2-digit",
    month: "2-digit",
    year: "2-digit"
  };
  return new Intl.DateTimeFormat(
    ["no-NO", "nb-NO", "nn-NO", "de-DE"],
    n
  ).format(new Date(e));
}, $O = (e) => {
  const t = new Date(e);
  return (t.getHours() < 10 ? "0" : "") + t.getHours() + ":" + (t.getMinutes() < 10 ? "0" : "") + t.getMinutes();
}, y7 = (e, t = oh) => e ? `${Ea(e, t)} kl ${$O(e)}` : "", Epe = (e) => e ? (e = e.toLowerCase(), e.charAt(0).toUpperCase() + e.slice(1)) : "", _pe = (e) => {
  if (!e) return "";
  e = e.replace(/\s/g, "");
  let t = "";
  for (let n = 0; n < e.length; n++)
    n % 4 === 0 && n > 0 && (t = t.concat(" ")), t = t.concat(e[n]);
  return t;
}, Ope = (e) => {
  let t = String(e);
  return t ? (t = t.replace(/\s/g, ""), t.replace(/\B(?=(\d{3})+(?!\d))/g, " ")) : "";
}, Ape = (e, t) => {
  const n = e ? new Date(e) : null, r = t ? new Date(t) : null;
  return !n && !r ? "" : n && r && rh(n, r) ? `${y7(n)}-${$O(r)}` : `${n ? y7(n) + " " : ""}-${r ? " " + y7(r) : ""}`;
}, b7 = (e) => new Date(e).toISOString(), ZZ = (e, t) => {
  switch (t) {
    case "currency":
      return Ma(e);
    case "date":
      return Ea(b7(e), oh);
    case "datetime":
      return Ea(b7(e), zZ);
    case "number":
      return parseFloat(e).toLocaleString();
    case "time":
      return Ea(b7(e), BO);
    default:
      return e;
  }
}, WZ = O.forwardRef(
  ({
    children: e,
    type: t = "text",
    align: n = "left",
    placeholder: r = "-",
    tooltip: o,
    className: i,
    width: a,
    collapsedCellDirection: s = "column",
    collapsedCellClasses: l,
    ...c
  }, u) => {
    const f = Yd(), p = ZZ(e, t), C = typeof p == "string", m = f?.collapseToList, g = {
      left: "text-left",
      right: "text-right",
      center: "text-center"
    }, y = I("px-md py-[14px]", {
      left: "justify-start",
      right: "justify-end",
      center: "justify-center"
    }[n]), w = I(
      "h-full px-md py-[14px] align-middle text-[14px] font-medium leading-[20px] text-text-primary",
      g[n],
      C && "whitespace-nowrap",
      !C && y,
      m && `pb-1 pt-1 before:block before:font-semibold before:content-[attr(data-th)] first:pb-0 last:pt-0 ${l}`,
      m && s === "row" && "flex items-center gap-md",
      i
    ), x = {
      minWidth: a
    };
    return o ? /* @__PURE__ */ d(
      "td",
      {
        ref: u,
        title: o,
        className: w,
        style: x,
        ...c,
        children: /* @__PURE__ */ F(q_, { trigger: "hover", children: [
          /* @__PURE__ */ d(G_, { asChild: !0, children: /* @__PURE__ */ d("span", { children: p }) }),
          /* @__PURE__ */ d(U_, { children: o || r })
        ] })
      }
    ) : /* @__PURE__ */ d("td", { ref: u, className: w, ...c, style: x, children: p || r });
  }
), bi = (e, t) => {
  const n = {}, r = {};
  let o = 0;
  const i = e.length;
  for (; o < i; )
    r[e[o]] = 1, o += 1;
  for (const a in t)
    Object.prototype.hasOwnProperty.call(r, a) || (n[a] = t[a]);
  return n;
}, qZ = O.forwardRef(
  ({ text: e, children: t, colSpan: n, ...r }, o) => {
    const a = t || e || "Ingen data å vise", s = typeof a == "string", l = n ?? 1;
    return /* @__PURE__ */ d(Lt.Row, { ...bi(["onClick"], r), ref: o, children: /* @__PURE__ */ d(Lt.Cell, { align: "center", colSpan: l, children: s ? /* @__PURE__ */ d(Rt, { size: "small", children: a }) : t }) });
  }
), UZ = O.forwardRef(
  ({ children: e, ...t }, n) => /* @__PURE__ */ d("tfoot", { ref: n, className: "align-[inherit]", ...t, children: e })
), GZ = O.forwardRef(
  ({ children: e, ...t }, n) => /* @__PURE__ */ d(
    "thead",
    {
      ref: n,
      className: "align-[inherit]",
      style: {
        width: t.width
      },
      ...t,
      children: e
    }
  )
), KZ = (e) => /* @__PURE__ */ F("svg", { viewBox: "0 0 24 24", ...e, children: [
  /* @__PURE__ */ d(
    "path",
    {
      d: "M12 8.6L15.9 12.5C16.0833 12.6833 16.3167 12.775 16.6 12.775C16.8833 12.775 17.1167 12.6833 17.3 12.5C17.4833 12.3167 17.575 12.0833 17.575 11.8C17.575 11.5167 17.4833 11.2833 17.3 11.1L12.7 6.5C12.6 6.4 12.4917 6.32917 12.375 6.2875C12.2583 6.24583 12.1333 6.225 12 6.225C11.8667 6.225 11.7417 6.24583 11.625 6.2875C11.5083 6.32917 11.4 6.4 11.3 6.5L6.69999 11.1C6.51665 11.2833 6.42499 11.5167 6.42499 11.8C6.42499 12.0833 6.51665 12.3167 6.69999 12.5C6.88332 12.6833 7.11665 12.775 7.39999 12.775C7.68332 12.775 7.91665 12.6833 8.09999 12.5L12 8.6Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M12 17.8L8.10005 13.925C7.91672 13.7417 7.68755 13.6458 7.41255 13.6375C7.13755 13.6292 6.90005 13.725 6.70005 13.925C6.51672 14.1083 6.42505 14.3417 6.42505 14.625C6.42505 14.9083 6.51672 15.1417 6.70005 15.325L11.3 19.925C11.4 20.025 11.5084 20.0958 11.625 20.1375C11.7417 20.1792 11.8667 20.2 12 20.2C12.1334 20.2 12.2584 20.1792 12.375 20.1375C12.4917 20.0958 12.6 20.025 12.7 19.925L17.3 15.325C17.4834 15.1417 17.5792 14.9125 17.5875 14.6375C17.5959 14.3625 17.5 14.125 17.3 13.925C17.1167 13.7417 16.8834 13.65 16.6 13.65C16.3167 13.65 16.0834 13.7417 15.9 13.925L12 17.8Z",
      fill: "currentColor"
    }
  )
] }), YZ = Q("IconChevronUpDown")(KZ), XZ = O.forwardRef(
  ({ children: e, sortable: t = !0, width: n, handleSortClick: r, isSorted: o, ...i }, a) => {
    const s = Yd(), { className: l, ...c } = i, u = I(
      "w-fit border-b-[2px] border-b-border-subtle px-md py-[12px] text-left text-[14px] font-semibold text-neutral-500",
      t && "cursor-pointer",
      s?.collapseToList && "hidden",
      l
    );
    return /* @__PURE__ */ d(
      "th",
      {
        ref: a,
        className: u,
        onClick: () => {
          r?.();
        },
        style: { minWidth: n, maxWidth: n },
        ...c,
        children: /* @__PURE__ */ F("div", { className: "flex items-center gap-sm", children: [
          e,
          t && /* @__PURE__ */ d(() => {
            if (o === !1) return /* @__PURE__ */ d(YZ, { className: "h-4 w-4" });
            if (o === "asc") return /* @__PURE__ */ d(V0, { className: "h-4 w-4" });
            if (o === "desc") return /* @__PURE__ */ d(Gr, { className: "h-4 w-4" });
          }, {})
        ] })
      }
    );
  }
), QZ = ({
  rows: e = 3,
  cells: t = 5
}) => Array.from({ length: e }, (n, r) => /* @__PURE__ */ d(Lt.Row, { children: Array.from({ length: t }, (o, i) => /* @__PURE__ */ d(Lt.Cell, { role: "alert", "aria-busy": "true", children: /* @__PURE__ */ d(S1, {}) }, i)) }, r)), JZ = O.forwardRef(
  ({
    children: e,
    className: t,
    onClick: n,
    expandable: r,
    expanded: o = !1,
    onExpandChange: i,
    ...a
  }, s) => {
    const [l, c] = O.useState(o), u = Yd(), { striped: f, collapseToList: h } = u, p = !!n, C = I(
      "even:bg-neutral-50",
      p && "hover:bg-neutral-100"
    ), m = I(
      "bg-neutral-0 align-middle",
      p && "cursor-pointer hover:bg-neutral-50",
      f && C,
      h && "flex flex-col even:border-y",
      t
    );
    return O.useEffect(() => {
      o !== void 0 && c(o);
    }, [o]), /* @__PURE__ */ F(
      "tr",
      {
        ref: s,
        tabIndex: p ? 0 : -1,
        "aria-expanded": r ? l : void 0,
        role: p ? "button" : void 0,
        "aria-disabled": p ? !1 : void 0,
        "aria-label": p ? "Clickable table row" : void 0,
        className: m,
        onKeyUp: (g) => {
          g.key !== "Enter" && g.key !== " " || p && n?.(g);
        },
        onClick: (g) => n?.(g),
        ...a,
        children: [
          r && /* @__PURE__ */ d(
            "td",
            {
              className: "w-4 cursor-pointer",
              onClick: () => {
                i && i(!l), c((g) => !g);
              },
              children: l ? /* @__PURE__ */ d(V0, { colorVariant: "primary" }) : /* @__PURE__ */ d(Gr, { colorVariant: "primary" })
            }
          ),
          e
        ]
      }
    );
  }
), Lt = Object.assign(EH, {
  Head: GZ,
  TableHeaderCell: XZ,
  Body: bO,
  Foot: UZ,
  Row: JZ,
  Cell: WZ,
  Loading: QZ,
  Empty: qZ
});
Lt.displayName = "Table";
Lt.Head.displayName = "Table.Head";
Lt.TableHeaderCell.displayName = "Table.TableHeaderCell";
Lt.Body.displayName = "Table.Body";
Lt.Foot.displayName = "Table.Foot";
Lt.Row.displayName = "Table.Row";
Lt.Empty.displayName = "Table.Empty";
const jO = gt(
  null
);
function eW() {
  const e = Oe(jO);
  if (!e)
    throw new Error("DataTableContext not found");
  return e;
}
const tW = ({
  fill: e = "none",
  viewBox: t = "0 0 12 10",
  ...n
}) => /* @__PURE__ */ d(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: e,
    viewBox: t,
    ...n,
    children: /* @__PURE__ */ d(
      "path",
      {
        d: "M3.97778 7.38889L10.6222 0.744444C10.7839 0.581481 10.9724 0.5 11.1878 0.5C11.4033 0.5 11.5926 0.581481 11.7556 0.744444C11.9185 0.907407 12 1.09689 12 1.31289C12 1.52889 11.9214 1.71548 11.7642 1.87267L4.55556 9.1C4.39393 9.26296 4.20541 9.34445 3.99 9.34445C3.77444 9.34445 3.58519 9.26296 3.42222 9.1L0.244444 5.92222C0.0814815 5.75926 0 5.57037 0 5.35556C0 5.14074 0.0814815 4.95185 0.244444 4.78889C0.407407 4.62593 0.597556 4.54444 0.814889 4.54444C1.03207 4.54444 1.2197 4.62593 1.37778 4.78889L3.97778 7.38889Z",
        fill: "white"
      }
    )
  }
), nW = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M12 17C12.2833 17 12.5208 16.9042 12.7125 16.7125C12.9042 16.5208 13 16.2833 13 16V12C13 11.7167 12.9042 11.4792 12.7125 11.2875C12.5208 11.0958 12.2833 11 12 11C11.7167 11 11.4792 11.0958 11.2875 11.2875C11.0958 11.4792 11 11.7167 11 12V16C11 16.2833 11.0958 16.5208 11.2875 16.7125C11.4792 16.9042 11.7167 17 12 17ZM12 9C12.2833 9 12.5208 8.90417 12.7125 8.7125C12.9042 8.52083 13 8.28333 13 8C13 7.71667 12.9042 7.47917 12.7125 7.2875C12.5208 7.09583 12.2833 7 12 7C11.7167 7 11.4792 7.09583 11.2875 7.2875C11.0958 7.47917 11 7.71667 11 8C11 8.28333 11.0958 8.52083 11.2875 8.7125C11.4792 8.90417 11.7167 9 12 9ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z",
    fill: "currentColor"
  }
) }), ih = Q("IconInfo")(nW), E9 = (e, t = 2) => {
  const n = e.replace(/\s/g, "").replace(",", "."), r = Number(n);
  return isNaN(r) ? n.replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace(".", ",") : r.toFixed(t).replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace(".", ",");
}, ac = (e) => e.replace(/\s/g, ""), rW = (e, t = !0) => t ? e.replace(/[^0-9\-,.]/g, "") : e.replace(/[^0-9,.]/g, ""), oW = (e) => {
  const t = e.replace(/-/g, "");
  return e.startsWith("-") ? "-" + t : t;
}, iW = (e) => {
  const t = e.indexOf("."), n = e.indexOf(",");
  let r = -1, o = "";
  if (t !== -1 && (n === -1 || t < n) ? (r = t, o = ".") : n !== -1 && (r = n, o = ","), r !== -1) {
    const i = e.replace(/[.,]/g, "");
    return i.slice(0, r) + o + i.slice(r);
  }
  return e;
}, aW = (e, t, n = 2) => _e(() => t && typeof e == "string" ? E9(e, n) : e, [t, e, n]), sW = (e, t, n, r, o = 2, i = !0) => {
  const [a, s] = ue(e), [l, c] = ue(!1);
  return ve(() => {
    s(t && typeof e == "string" ? l ? ac(e) : E9(e, o) : e);
  }, [e, t, l]), {
    displayValue: a,
    isFocused: l,
    handleFocus: (p) => {
      if (c(!0), t && typeof p.target.value == "string") {
        const C = ac(p.target.value);
        s(C);
        const m = {
          ...p,
          target: {
            ...p.target,
            value: C
          }
        };
        n && !r && n(m);
      }
      return p;
    },
    handleBlur: (p) => {
      if (c(!1), t && typeof p.target.value == "string") {
        const C = ac(p.target.value), m = E9(C, o);
        s(m);
        const g = {
          ...p,
          target: {
            ...p.target,
            value: C
            // Use unformatted value for onChange
          }
        };
        n && !r && n(g);
      }
      return p;
    },
    handleChange: (p) => {
      if (t) {
        const C = ac(p.target.value), m = rW(C, i), g = oW(m);
        let v = g;
        o === 0 ? v = g.replace(".", "").replace(",", "") : v = iW(g), s(v);
        const y = {
          ...p,
          target: {
            ...p.target,
            value: v
          }
        };
        if (!r && n)
          return n(y), p;
      }
      return !r && n && n(p), p;
    }
  };
}, A1 = Xe(
  ({
    type: e = "text",
    label: t,
    labelWeight: n = "semibold",
    border: r = !0,
    required: o = !1,
    htmlFor: i,
    hint: a,
    invalid: s,
    errorMessage: l,
    className: c,
    iconLeft: u,
    iconRight: f,
    loading: h,
    disabled: p,
    onChange: C,
    onClick: m,
    onBlur: g,
    onFocus: v,
    wrapperClassName: y,
    inputWrapperClassName: w,
    formatAmount: x = !1,
    value: b,
    defaultValue: S,
    decimals: M = 0,
    allowNegative: E = !1,
    ghostMode: P = !1,
    ...T
  }, _) => {
    const D = bt(), N = i || D, R = e === "checkbox" || e === "radio", L = e === "checkbox", B = e === "radio", V = e === "number", k = aW(
      S,
      x,
      M
    ), { displayValue: z, handleFocus: $, handleBlur: Z, handleChange: W } = sW(
      b,
      x,
      C,
      T.readOnly,
      M,
      E
    ), H = _e(() => s || u, [s, u]), G = _e(
      () => s || f,
      [s, f]
    ), Y = h || p, ne = {
      asterix: I("text-ui-errorDark"),
      border: I("border-ui-errorDark"),
      message: I("text-ui-errorDark")
    }, J = I(
      "flex h-[10px] w-full min-w-13 items-center gap-sm rounded-md p-md ring-offset-0 transition-all",
      "hover:border-neutral-400",
      "outline-none focus-visible:border-surface-common-primary focus-visible:ring-[3px] focus-visible:ring-surface-common-primary-light",
      "active:border-surface-common-primary active:ring-surface-common-primary-light",
      !r && "hover:outline hover:outline-border-input",
      r && I(`border border-border-input ${s && ne.border}`),
      p && "bg-neutral-100 text-neutral-500 hover:border-border-input active:border-border-input",
      H && I("pl-6"),
      G && I("pr-6")
    ), ee = I(
      "flex flex-col gap-xs",
      R && "flex-row-reverse items-start justify-end !gap-1",
      y
    ), U = I(
      "inline-block",
      R && I("!mb-none cursor-pointer leading-5", p && "!text-neutral-500")
    ), X = I(
      "peer h-[20px] w-[20px] cursor-pointer appearance-none !rounded-full border border-border-input !p-0 transition-all",
      "checked:bg-surface-common-primary",
      "focus:outline-surface-common-light focus:ring-surface-common-light focus-visible:outline-surface-common-light",
      "disbled:pointer-events-none disabled:border-border-input disabled:bg-neutral-200"
    ), ie = I(
      "peer h-[20px] w-[20px] cursor-pointer appearance-none rounded-[4px] !p-0 transition-all",
      "checked:border-transparent checked:bg-surface-common-primary",
      "focus:outline-surface-common-light focus:ring-surface-common-light",
      "active:border-surface-common-light",
      "disabled:pointer-events-none disabled:border-border-input disabled:bg-neutral-200",
      T.indetermined === "true" && "border-surface-common-primary bg-surface-common-primary"
    ), j = I(
      "text-primary !mb-0 min-w-0 rounded-sm border border-border-light focus:ring-[2px]"
    ), te = I(
      "appearance-textfield [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
    ), K = I(
      "bg-transparent p-sm hover:bg-surface-common-background focus:bg-surface-common-background"
    ), me = I(
      J,
      L && ie,
      B && X,
      R && j,
      V && te,
      P && K,
      c
    ), we = I(
      "relative flex items-center",
      w
    ), ye = () => !H || s || R ? null : /* @__PURE__ */ d("div", { className: "absolute left-md flex items-center text-surface-common-primary", children: u }), Ze = () => h && /* @__PURE__ */ d(
      Gc,
      {
        className: "absolute right-lg",
        svgClassName: I("text-surface-common-primary")
      }
    ), Ue = () => !G || s || R ? null : /* @__PURE__ */ d("div", { className: "absolute right-md flex items-center text-surface-common-primary", children: f }), Ke = () => /* @__PURE__ */ d("span", { className: "pointer-events-none absolute left-1/2 top-1/2 h-1 w-1 -translate-x-1/2 -translate-y-1/2 transform rounded-full bg-neutral-0 opacity-0 transition-opacity duration-200 peer-checked:opacity-100" }), ft = () => T.indetermined === "true" ? /* @__PURE__ */ d(
      iO,
      {
        className: "pointer-events-none absolute !h-[20px] !w-[20px] -translate-x-1/2 -translate-y-1/2 transform text-white"
      }
    ) : /* @__PURE__ */ d(
      tW,
      {
        className: "pointer-events-none absolute left-1/2 top-1/2 h-[10px] w-[12px] -translate-x-1/2 -translate-y-1/2 transform text-white opacity-0 peer-checked:opacity-100"
      }
    ), fe = () => a && !l && /* @__PURE__ */ d(Go, { className: I(p && "text-neutral-400"), children: a }), ge = () => l && s && /* @__PURE__ */ d(Eo, { className: ne.message, children: l }), pe = () => /* @__PURE__ */ F(ut, { children: [
      /* @__PURE__ */ d(fe, {}),
      /* @__PURE__ */ d(ge, {})
    ] }), De = ke(!1);
    return ve(() => {
      const xe = (pn) => {
        pn.key === "Tab" && (De.current = !0);
      }, He = () => {
        De.current = !1;
      };
      return window.addEventListener("keydown", xe), window.addEventListener("mousedown", He), () => {
        window.removeEventListener("keydown", xe), window.removeEventListener("mousedown", He);
      };
    }, []), /* @__PURE__ */ F("div", { className: ee, children: [
      !!t && /* @__PURE__ */ F("div", { className: "flex flex-col", children: [
        /* @__PURE__ */ F(
          Ut,
          {
            weight: n,
            className: U,
            htmlFor: N,
            children: [
              t,
              (o || s) && /* @__PURE__ */ d(
                "span",
                {
                  "aria-label": "required field",
                  className: I("ml-[2px] text-ui-errorDark"),
                  children: "*"
                }
              )
            ]
          }
        ),
        R && /* @__PURE__ */ d(pe, {})
      ] }),
      /* @__PURE__ */ F("div", { className: we, children: [
        s && !R && /* @__PURE__ */ d(ih, { className: "absolute left-md flex items-center !text-ui-errorDark" }),
        /* @__PURE__ */ d(ye, {}),
        /* @__PURE__ */ d(
          "input",
          {
            id: N,
            className: me,
            ref: _,
            type: e,
            "aria-invalid": s || void 0,
            "aria-describedby": a || l ? `${D}-description` : void 0,
            "aria-readonly": T.readOnly || void 0,
            "aria-required": o || void 0,
            onChange: W,
            onFocus: async (xe) => {
              await $(xe), await v?.(xe), De.current && xe.target.select();
            },
            onBlur: (xe) => {
              Z(xe), g?.(xe);
            },
            onClick: (xe) => {
              T.readOnly && xe.preventDefault(), m?.(xe);
            },
            disabled: Y,
            value: z,
            defaultValue: b ? void 0 : k,
            ...T
          }
        ),
        h ? /* @__PURE__ */ d(Ze, {}) : /* @__PURE__ */ d(Ue, {}),
        L && /* @__PURE__ */ d(ft, {}),
        B && /* @__PURE__ */ d(Ke, {})
      ] }),
      !R && /* @__PURE__ */ d(pe, {})
    ] });
  }
), D2 = (e) => /* @__PURE__ */ d(A1, { type: "checkbox", role: "switch", ...e }), Ng = ({ row: e }) => /* @__PURE__ */ d(
  D2,
  {
    checked: e.getIsSelected(),
    disabled: !e.getCanSelect(),
    onChange: e.getToggleSelectedHandler()
  }
), lW = ({ table: e }) => /* @__PURE__ */ d(
  D2,
  {
    checked: !!e.getIsAllPageRowsSelected(),
    indetermined: e.getIsSomePageRowsSelected() ? "true" : "false",
    onChange: (t) => e.toggleAllPageRowsSelected(!!t.target.checked)
  }
);
function cW(e) {
  return e.map((t) => {
    const n = {
      enableSorting: t.sortable ?? !0
    };
    return t.checkbox ? {
      ...t,
      ...n,
      cell: ({ row: r }) => /* @__PURE__ */ d(Ng, { row: r })
    } : t.checkboxAll ? {
      ...t,
      ...n,
      header: ({ table: r }) => /* @__PURE__ */ d(lW, { table: r }),
      cell: ({ row: r }) => /* @__PURE__ */ d(Ng, { row: r })
    } : {
      ...t,
      ...n
    };
  });
}
function Fg(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function en(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e?.(o), n === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
function ah(e, t = []) {
  let n = [];
  function r(i, a) {
    const s = A.createContext(a), l = n.length;
    n = [...n, a];
    const c = (f) => {
      const { scope: h, children: p, ...C } = f, m = h?.[e]?.[l] || s, g = A.useMemo(() => C, Object.values(C));
      return /* @__PURE__ */ d(m.Provider, { value: g, children: p });
    };
    c.displayName = i + "Provider";
    function u(f, h) {
      const p = h?.[e]?.[l] || s, C = A.useContext(p);
      if (C) return C;
      if (a !== void 0) return a;
      throw new Error(`\`${f}\` must be used within \`${i}\``);
    }
    return [c, u];
  }
  const o = () => {
    const i = n.map((a) => A.createContext(a));
    return function(s) {
      const l = s?.[e] || i;
      return A.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    };
  };
  return o.scopeName = e, [r, uW(o, ...t)];
}
function uW(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const a = r.reduce((s, { useScope: l, scopeName: c }) => {
        const f = l(i)[`__scope${c}`];
        return { ...s, ...f };
      }, {});
      return A.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Vg(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function HO(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = Vg(o, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const i = r[o];
          typeof i == "function" ? i() : Vg(e[o], null);
        }
      };
  };
}
function Sn(...e) {
  return A.useCallback(HO(...e), e);
}
// @__NO_SIDE_EFFECTS__
function Il(e) {
  const t = /* @__PURE__ */ dW(e), n = A.forwardRef((r, o) => {
    const { children: i, ...a } = r, s = A.Children.toArray(i), l = s.find(pW);
    if (l) {
      const c = l.props.children, u = s.map((f) => f === l ? A.Children.count(c) > 1 ? A.Children.only(null) : A.isValidElement(c) ? c.props.children : null : f);
      return /* @__PURE__ */ d(t, { ...a, ref: o, children: A.isValidElement(c) ? A.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ d(t, { ...a, ref: o, children: i });
  });
  return n.displayName = `${e}.Slot`, n;
}
var fW = /* @__PURE__ */ Il("Slot");
// @__NO_SIDE_EFFECTS__
function dW(e) {
  const t = A.forwardRef((n, r) => {
    const { children: o, ...i } = n;
    if (A.isValidElement(o)) {
      const a = gW(o), s = mW(i, o.props);
      return o.type !== A.Fragment && (s.ref = r ? HO(r, a) : a), A.cloneElement(o, s);
    }
    return A.Children.count(o) > 1 ? A.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var hW = Symbol("radix.slottable");
function pW(e) {
  return A.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === hW;
}
function mW(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...s) => {
      const l = i(...s);
      return o(...s), l;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function gW(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function CW(e) {
  const t = e + "CollectionProvider", [n, r] = ah(t), [o, i] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), a = (m) => {
    const { scope: g, children: v } = m, y = O.useRef(null), w = O.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ d(o, { scope: g, itemMap: w, collectionRef: y, children: v });
  };
  a.displayName = t;
  const s = e + "CollectionSlot", l = /* @__PURE__ */ Il(s), c = O.forwardRef(
    (m, g) => {
      const { scope: v, children: y } = m, w = i(s, v), x = Sn(g, w.collectionRef);
      return /* @__PURE__ */ d(l, { ref: x, children: y });
    }
  );
  c.displayName = s;
  const u = e + "CollectionItemSlot", f = "data-radix-collection-item", h = /* @__PURE__ */ Il(u), p = O.forwardRef(
    (m, g) => {
      const { scope: v, children: y, ...w } = m, x = O.useRef(null), b = Sn(g, x), S = i(u, v);
      return O.useEffect(() => (S.itemMap.set(x, { ref: x, ...w }), () => void S.itemMap.delete(x))), /* @__PURE__ */ d(h, { [f]: "", ref: b, children: y });
    }
  );
  p.displayName = u;
  function C(m) {
    const g = i(e + "CollectionConsumer", m);
    return O.useCallback(() => {
      const y = g.collectionRef.current;
      if (!y) return [];
      const w = Array.from(y.querySelectorAll(`[${f}]`));
      return Array.from(g.itemMap.values()).sort(
        (S, M) => w.indexOf(S.ref.current) - w.indexOf(M.ref.current)
      );
    }, [g.collectionRef, g.itemMap]);
  }
  return [
    { Provider: a, Slot: c, ItemSlot: p },
    C,
    r
  ];
}
var vW = A.createContext(void 0);
function yW(e) {
  const t = A.useContext(vW);
  return e || t || "ltr";
}
var bW = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], nn = bW.reduce((e, t) => {
  const n = /* @__PURE__ */ Il(`Primitive.${t}`), r = A.forwardRef((o, i) => {
    const { asChild: a, ...s } = o, l = a ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ d(l, { ...s, ref: i });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function wW(e, t) {
  e && S2.flushSync(() => e.dispatchEvent(t));
}
function wi(e) {
  const t = A.useRef(e);
  return A.useEffect(() => {
    t.current = e;
  }), A.useMemo(() => (...n) => t.current?.(...n), []);
}
function xW(e, t = globalThis?.document) {
  const n = wi(e);
  A.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var SW = "DismissableLayer", _9 = "dismissableLayer.update", MW = "dismissableLayer.pointerDownOutside", EW = "dismissableLayer.focusOutside", Bg, zO = A.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), ZO = A.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: i,
      onInteractOutside: a,
      onDismiss: s,
      ...l
    } = e, c = A.useContext(zO), [u, f] = A.useState(null), h = u?.ownerDocument ?? globalThis?.document, [, p] = A.useState({}), C = Sn(t, (M) => f(M)), m = Array.from(c.layers), [g] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), v = m.indexOf(g), y = u ? m.indexOf(u) : -1, w = c.layersWithOutsidePointerEventsDisabled.size > 0, x = y >= v, b = AW((M) => {
      const E = M.target, P = [...c.branches].some((T) => T.contains(E));
      !x || P || (o?.(M), a?.(M), M.defaultPrevented || s?.());
    }, h), S = PW((M) => {
      const E = M.target;
      [...c.branches].some((T) => T.contains(E)) || (i?.(M), a?.(M), M.defaultPrevented || s?.());
    }, h);
    return xW((M) => {
      y === c.layers.size - 1 && (r?.(M), !M.defaultPrevented && s && (M.preventDefault(), s()));
    }, h), A.useEffect(() => {
      if (u)
        return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (Bg = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(u)), c.layers.add(u), $g(), () => {
          n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = Bg);
        };
    }, [u, h, n, c]), A.useEffect(() => () => {
      u && (c.layers.delete(u), c.layersWithOutsidePointerEventsDisabled.delete(u), $g());
    }, [u, c]), A.useEffect(() => {
      const M = () => p({});
      return document.addEventListener(_9, M), () => document.removeEventListener(_9, M);
    }, []), /* @__PURE__ */ d(
      nn.div,
      {
        ...l,
        ref: C,
        style: {
          pointerEvents: w ? x ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: en(e.onFocusCapture, S.onFocusCapture),
        onBlurCapture: en(e.onBlurCapture, S.onBlurCapture),
        onPointerDownCapture: en(
          e.onPointerDownCapture,
          b.onPointerDownCapture
        )
      }
    );
  }
);
ZO.displayName = SW;
var _W = "DismissableLayerBranch", OW = A.forwardRef((e, t) => {
  const n = A.useContext(zO), r = A.useRef(null), o = Sn(t, r);
  return A.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ d(nn.div, { ...e, ref: o });
});
OW.displayName = _W;
function AW(e, t = globalThis?.document) {
  const n = wi(e), r = A.useRef(!1), o = A.useRef(() => {
  });
  return A.useEffect(() => {
    const i = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          WO(
            MW,
            n,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = l, t.addEventListener("click", o.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function PW(e, t = globalThis?.document) {
  const n = wi(e), r = A.useRef(!1);
  return A.useEffect(() => {
    const o = (i) => {
      i.target && !r.current && WO(EW, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function $g() {
  const e = new CustomEvent(_9);
  document.dispatchEvent(e);
}
function WO(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? wW(o, i) : o.dispatchEvent(i);
}
var w7 = 0;
function TW() {
  A.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? jg()), document.body.insertAdjacentElement("beforeend", e[1] ?? jg()), w7++, () => {
      w7 === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), w7--;
    };
  }, []);
}
function jg() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var x7 = "focusScope.autoFocusOnMount", S7 = "focusScope.autoFocusOnUnmount", Hg = { bubbles: !1, cancelable: !0 }, IW = "FocusScope", qO = A.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i,
    ...a
  } = e, [s, l] = A.useState(null), c = wi(o), u = wi(i), f = A.useRef(null), h = Sn(t, (m) => l(m)), p = A.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  A.useEffect(() => {
    if (r) {
      let m = function(w) {
        if (p.paused || !s) return;
        const x = w.target;
        s.contains(x) ? f.current = x : c1(f.current, { select: !0 });
      }, g = function(w) {
        if (p.paused || !s) return;
        const x = w.relatedTarget;
        x !== null && (s.contains(x) || c1(f.current, { select: !0 }));
      }, v = function(w) {
        if (document.activeElement === document.body)
          for (const b of w)
            b.removedNodes.length > 0 && c1(s);
      };
      document.addEventListener("focusin", m), document.addEventListener("focusout", g);
      const y = new MutationObserver(v);
      return s && y.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", m), document.removeEventListener("focusout", g), y.disconnect();
      };
    }
  }, [r, s, p.paused]), A.useEffect(() => {
    if (s) {
      Zg.add(p);
      const m = document.activeElement;
      if (!s.contains(m)) {
        const v = new CustomEvent(x7, Hg);
        s.addEventListener(x7, c), s.dispatchEvent(v), v.defaultPrevented || (DW(FW(UO(s)), { select: !0 }), document.activeElement === m && c1(s));
      }
      return () => {
        s.removeEventListener(x7, c), setTimeout(() => {
          const v = new CustomEvent(S7, Hg);
          s.addEventListener(S7, u), s.dispatchEvent(v), v.defaultPrevented || c1(m ?? document.body, { select: !0 }), s.removeEventListener(S7, u), Zg.remove(p);
        }, 0);
      };
    }
  }, [s, c, u, p]);
  const C = A.useCallback(
    (m) => {
      if (!n && !r || p.paused) return;
      const g = m.key === "Tab" && !m.altKey && !m.ctrlKey && !m.metaKey, v = document.activeElement;
      if (g && v) {
        const y = m.currentTarget, [w, x] = RW(y);
        w && x ? !m.shiftKey && v === x ? (m.preventDefault(), n && c1(w, { select: !0 })) : m.shiftKey && v === w && (m.preventDefault(), n && c1(x, { select: !0 })) : v === y && m.preventDefault();
      }
    },
    [n, r, p.paused]
  );
  return /* @__PURE__ */ d(nn.div, { tabIndex: -1, ...a, ref: h, onKeyDown: C });
});
qO.displayName = IW;
function DW(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (c1(r, { select: t }), document.activeElement !== n) return;
}
function RW(e) {
  const t = UO(e), n = zg(t, e), r = zg(t.reverse(), e);
  return [n, r];
}
function UO(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function zg(e, t) {
  for (const n of e)
    if (!kW(n, { upTo: t })) return n;
}
function kW(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function LW(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function c1(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && LW(e) && t && e.select();
  }
}
var Zg = NW();
function NW() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && n?.pause(), e = Wg(e, t), e.unshift(t);
    },
    remove(t) {
      e = Wg(e, t), e[0]?.resume();
    }
  };
}
function Wg(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function FW(e) {
  return e.filter((t) => t.tagName !== "A");
}
var ur = globalThis?.document ? A.useLayoutEffect : () => {
}, VW = A[" useId ".trim().toString()] || (() => {
}), BW = 0;
function sh(e) {
  const [t, n] = A.useState(VW());
  return ur(() => {
    n((r) => r ?? String(BW++));
  }, [e]), t ? `radix-${t}` : "";
}
var $W = "Arrow", GO = A.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...i } = e;
  return /* @__PURE__ */ d(
    nn.svg,
    {
      ...i,
      ref: t,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ d("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
GO.displayName = $W;
var jW = GO;
function HW(e) {
  const [t, n] = A.useState(void 0);
  return ur(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const i = o[0];
        let a, s;
        if ("borderBoxSize" in i) {
          const l = i.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          a = c.inlineSize, s = c.blockSize;
        } else
          a = e.offsetWidth, s = e.offsetHeight;
        n({ width: a, height: s });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var lh = "Popper", [KO, YO] = ah(lh), [zW, XO] = KO(lh), QO = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = A.useState(null);
  return /* @__PURE__ */ d(zW, { scope: t, anchor: r, onAnchorChange: o, children: n });
};
QO.displayName = lh;
var JO = "PopperAnchor", eA = A.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...o } = e, i = XO(JO, n), a = A.useRef(null), s = Sn(t, a), l = A.useRef(null);
    return A.useEffect(() => {
      const c = l.current;
      l.current = r?.current || a.current, c !== l.current && i.onAnchorChange(l.current);
    }), r ? null : /* @__PURE__ */ d(nn.div, { ...o, ref: s });
  }
);
eA.displayName = JO;
var ch = "PopperContent", [ZW, WW] = KO(ch), tA = A.forwardRef(
  (e, t) => {
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: o = 0,
      align: i = "center",
      alignOffset: a = 0,
      arrowPadding: s = 0,
      avoidCollisions: l = !0,
      collisionBoundary: c = [],
      collisionPadding: u = 0,
      sticky: f = "partial",
      hideWhenDetached: h = !1,
      updatePositionStrategy: p = "optimized",
      onPlaced: C,
      ...m
    } = e, g = XO(ch, n), [v, y] = A.useState(null), w = Sn(t, (J) => y(J)), [x, b] = A.useState(null), S = HW(x), M = S?.width ?? 0, E = S?.height ?? 0, P = r + (i !== "center" ? "-" + i : ""), T = typeof u == "number" ? u : { top: 0, right: 0, bottom: 0, left: 0, ...u }, _ = Array.isArray(c) ? c : [c], D = _.length > 0, N = {
      padding: T,
      boundary: _.filter(UW),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: D
    }, { refs: R, floatingStyles: L, placement: B, isPositioned: V, middlewareData: k } = V_({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: P,
      whileElementsMounted: (...J) => D1(...J, {
        animationFrame: p === "always"
      }),
      elements: {
        reference: g.anchor
      },
      middleware: [
        Ti({ mainAxis: o + E, alignmentAxis: a }),
        l && B_({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? RF() : void 0,
          ...N
        }),
        l && Ii({ ...N }),
        _2({
          ...N,
          apply: ({ elements: J, rects: ee, availableWidth: U, availableHeight: X }) => {
            const { width: ie, height: j } = ee.reference, te = J.floating.style;
            te.setProperty("--radix-popper-available-width", `${U}px`), te.setProperty("--radix-popper-available-height", `${X}px`), te.setProperty("--radix-popper-anchor-width", `${ie}px`), te.setProperty("--radix-popper-anchor-height", `${j}px`);
          }
        }),
        x && $_({ element: x, padding: s }),
        GW({ arrowWidth: M, arrowHeight: E }),
        h && LF({ strategy: "referenceHidden", ...N })
      ]
    }), [z, $] = oA(B), Z = wi(C);
    ur(() => {
      V && Z?.();
    }, [V, Z]);
    const W = k.arrow?.x, H = k.arrow?.y, G = k.arrow?.centerOffset !== 0, [Y, ne] = A.useState();
    return ur(() => {
      v && ne(window.getComputedStyle(v).zIndex);
    }, [v]), /* @__PURE__ */ d(
      "div",
      {
        ref: R.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...L,
          transform: V ? L.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: Y,
          "--radix-popper-transform-origin": [
            k.transformOrigin?.x,
            k.transformOrigin?.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...k.hide?.referenceHidden && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ d(
          ZW,
          {
            scope: n,
            placedSide: z,
            onArrowChange: b,
            arrowX: W,
            arrowY: H,
            shouldHideArrow: G,
            children: /* @__PURE__ */ d(
              nn.div,
              {
                "data-side": z,
                "data-align": $,
                ...m,
                ref: w,
                style: {
                  ...m.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: V ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
tA.displayName = ch;
var nA = "PopperArrow", qW = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, rA = A.forwardRef(function(t, n) {
  const { __scopePopper: r, ...o } = t, i = WW(nA, r), a = qW[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ d(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [a]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ d(
          jW,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
rA.displayName = nA;
function UW(e) {
  return e !== null;
}
var GW = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    const { placement: n, rects: r, middlewareData: o } = t, a = o.arrow?.centerOffset !== 0, s = a ? 0 : e.arrowWidth, l = a ? 0 : e.arrowHeight, [c, u] = oA(n), f = { start: "0%", center: "50%", end: "100%" }[u], h = (o.arrow?.x ?? 0) + s / 2, p = (o.arrow?.y ?? 0) + l / 2;
    let C = "", m = "";
    return c === "bottom" ? (C = a ? f : `${h}px`, m = `${-l}px`) : c === "top" ? (C = a ? f : `${h}px`, m = `${r.floating.height + l}px`) : c === "right" ? (C = `${-l}px`, m = a ? f : `${p}px`) : c === "left" && (C = `${r.floating.width + l}px`, m = a ? f : `${p}px`), { data: { x: C, y: m } };
  }
});
function oA(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var KW = QO, YW = eA, XW = tA, QW = rA, JW = A[" useInsertionEffect ".trim().toString()] || ur;
function qg({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: r
}) {
  const [o, i, a] = eq({
    defaultProp: t,
    onChange: n
  }), s = e !== void 0, l = s ? e : o;
  {
    const u = A.useRef(e !== void 0);
    A.useEffect(() => {
      const f = u.current;
      f !== s && console.warn(
        `${r} is changing from ${f ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), u.current = s;
    }, [s, r]);
  }
  const c = A.useCallback(
    (u) => {
      if (s) {
        const f = tq(u) ? u(e) : u;
        f !== e && a.current?.(f);
      } else
        i(u);
    },
    [s, e, i, a]
  );
  return [l, c];
}
function eq({
  defaultProp: e,
  onChange: t
}) {
  const [n, r] = A.useState(e), o = A.useRef(n), i = A.useRef(t);
  return JW(() => {
    i.current = t;
  }, [t]), A.useEffect(() => {
    o.current !== n && (i.current?.(n), o.current = n);
  }, [n, o]), [n, r, i];
}
function tq(e) {
  return typeof e == "function";
}
function nq(e) {
  const t = A.useRef({ value: e, previous: e });
  return A.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var iA = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), rq = "VisuallyHidden", oq = A.forwardRef(
  (e, t) => /* @__PURE__ */ d(
    nn.span,
    {
      ...e,
      ref: t,
      style: { ...iA, ...e.style }
    }
  )
);
oq.displayName = rq;
var iq = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Gi = /* @__PURE__ */ new WeakMap(), sc = /* @__PURE__ */ new WeakMap(), lc = {}, M7 = 0, aA = function(e) {
  return e && (e.host || aA(e.parentNode));
}, aq = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = aA(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, sq = function(e, t, n, r) {
  var o = aq(t, Array.isArray(e) ? e : [e]);
  lc[n] || (lc[n] = /* @__PURE__ */ new WeakMap());
  var i = lc[n], a = [], s = /* @__PURE__ */ new Set(), l = new Set(o), c = function(f) {
    !f || s.has(f) || (s.add(f), c(f.parentNode));
  };
  o.forEach(c);
  var u = function(f) {
    !f || l.has(f) || Array.prototype.forEach.call(f.children, function(h) {
      if (s.has(h))
        u(h);
      else
        try {
          var p = h.getAttribute(r), C = p !== null && p !== "false", m = (Gi.get(h) || 0) + 1, g = (i.get(h) || 0) + 1;
          Gi.set(h, m), i.set(h, g), a.push(h), m === 1 && C && sc.set(h, !0), g === 1 && h.setAttribute(n, "true"), C || h.setAttribute(r, "true");
        } catch (v) {
          console.error("aria-hidden: cannot operate on ", h, v);
        }
    });
  };
  return u(t), s.clear(), M7++, function() {
    a.forEach(function(f) {
      var h = Gi.get(f) - 1, p = i.get(f) - 1;
      Gi.set(f, h), i.set(f, p), h || (sc.has(f) || f.removeAttribute(r), sc.delete(f)), p || f.removeAttribute(n);
    }), M7--, M7 || (Gi = /* @__PURE__ */ new WeakMap(), Gi = /* @__PURE__ */ new WeakMap(), sc = /* @__PURE__ */ new WeakMap(), lc = {});
  };
}, lq = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = iq(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live], script"))), sq(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, so = function() {
  return so = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, so.apply(this, arguments);
};
function sA(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function cq(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, o = t.length, i; r < o; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var jc = "right-scroll-bar-position", Hc = "width-before-scroll-bar", uq = "with-scroll-bars-hidden", fq = "--removed-body-scroll-bar-size";
function E7(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function dq(e, t) {
  var n = ue(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var hq = typeof window < "u" ? A.useLayoutEffect : A.useEffect, Ug = /* @__PURE__ */ new WeakMap();
function pq(e, t) {
  var n = dq(null, function(r) {
    return e.forEach(function(o) {
      return E7(o, r);
    });
  });
  return hq(function() {
    var r = Ug.get(n);
    if (r) {
      var o = new Set(r), i = new Set(e), a = n.current;
      o.forEach(function(s) {
        i.has(s) || E7(s, null);
      }), i.forEach(function(s) {
        o.has(s) || E7(s, a);
      });
    }
    Ug.set(n, e);
  }, [e]), n;
}
function mq(e) {
  return e;
}
function gq(e, t) {
  t === void 0 && (t = mq);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var a = t(i, r);
      return n.push(a), function() {
        n = n.filter(function(s) {
          return s !== a;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var a = n;
        n = [], a.forEach(i);
      }
      n = {
        push: function(s) {
          return i(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var a = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(i), a = n;
      }
      var l = function() {
        var u = a;
        a = [], u.forEach(i);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), n = {
        push: function(u) {
          a.push(u), c();
        },
        filter: function(u) {
          return a = a.filter(u), n;
        }
      };
    }
  };
  return o;
}
function Cq(e) {
  e === void 0 && (e = {});
  var t = gq(null);
  return t.options = so({ async: !0, ssr: !1 }, e), t;
}
var lA = function(e) {
  var t = e.sideCar, n = sA(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return A.createElement(r, so({}, n));
};
lA.isSideCarExport = !0;
function vq(e, t) {
  return e.useMedium(t), lA;
}
var cA = Cq(), _7 = function() {
}, Nu = A.forwardRef(function(e, t) {
  var n = A.useRef(null), r = A.useState({
    onScrollCapture: _7,
    onWheelCapture: _7,
    onTouchMoveCapture: _7
  }), o = r[0], i = r[1], a = e.forwardProps, s = e.children, l = e.className, c = e.removeScrollBar, u = e.enabled, f = e.shards, h = e.sideCar, p = e.noRelative, C = e.noIsolation, m = e.inert, g = e.allowPinchZoom, v = e.as, y = v === void 0 ? "div" : v, w = e.gapMode, x = sA(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), b = h, S = pq([n, t]), M = so(so({}, x), o);
  return A.createElement(
    A.Fragment,
    null,
    u && A.createElement(b, { sideCar: cA, removeScrollBar: c, shards: f, noRelative: p, noIsolation: C, inert: m, setCallbacks: i, allowPinchZoom: !!g, lockRef: n, gapMode: w }),
    a ? A.cloneElement(A.Children.only(s), so(so({}, M), { ref: S })) : A.createElement(y, so({}, M, { className: l, ref: S }), s)
  );
});
Nu.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Nu.classNames = {
  fullWidth: Hc,
  zeroRight: jc
};
var yq = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function bq() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = yq();
  return t && e.setAttribute("nonce", t), e;
}
function wq(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function xq(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var Sq = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = bq()) && (wq(t, n), xq(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Mq = function() {
  var e = Sq();
  return function(t, n) {
    A.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, uA = function() {
  var e = Mq(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, Eq = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, O7 = function(e) {
  return parseInt(e || "", 10) || 0;
}, _q = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [O7(n), O7(r), O7(o)];
}, Oq = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return Eq;
  var t = _q(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, Aq = uA(), _a = "data-scroll-locked", Pq = function(e, t, n, r) {
  var o = e.left, i = e.top, a = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(uq, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body[`).concat(_a, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(jc, ` {
    right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(Hc, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(jc, " .").concat(jc, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(Hc, " .").concat(Hc, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(_a, `] {
    `).concat(fq, ": ").concat(s, `px;
  }
`);
}, Gg = function() {
  var e = parseInt(document.body.getAttribute(_a) || "0", 10);
  return isFinite(e) ? e : 0;
}, Tq = function() {
  A.useEffect(function() {
    return document.body.setAttribute(_a, (Gg() + 1).toString()), function() {
      var e = Gg() - 1;
      e <= 0 ? document.body.removeAttribute(_a) : document.body.setAttribute(_a, e.toString());
    };
  }, []);
}, Iq = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  Tq();
  var i = A.useMemo(function() {
    return Oq(o);
  }, [o]);
  return A.createElement(Aq, { styles: Pq(i, !t, o, n ? "" : "!important") });
}, O9 = !1;
if (typeof window < "u")
  try {
    var cc = Object.defineProperty({}, "passive", {
      get: function() {
        return O9 = !0, !0;
      }
    });
    window.addEventListener("test", cc, cc), window.removeEventListener("test", cc, cc);
  } catch {
    O9 = !1;
  }
var Ki = O9 ? { passive: !1 } : !1, Dq = function(e) {
  return e.tagName === "TEXTAREA";
}, fA = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Dq(e) && n[t] === "visible")
  );
}, Rq = function(e) {
  return fA(e, "overflowY");
}, kq = function(e) {
  return fA(e, "overflowX");
}, Kg = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = dA(e, r);
    if (o) {
      var i = hA(e, r), a = i[1], s = i[2];
      if (a > s)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, Lq = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, Nq = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, dA = function(e, t) {
  return e === "v" ? Rq(t) : kq(t);
}, hA = function(e, t) {
  return e === "v" ? Lq(t) : Nq(t);
}, Fq = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Vq = function(e, t, n, r, o) {
  var i = Fq(e, window.getComputedStyle(t).direction), a = i * r, s = n.target, l = t.contains(s), c = !1, u = a > 0, f = 0, h = 0;
  do {
    if (!s)
      break;
    var p = hA(e, s), C = p[0], m = p[1], g = p[2], v = m - g - i * C;
    (C || v) && dA(e, s) && (f += v, h += C);
    var y = s.parentNode;
    s = y && y.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? y.host : y;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (u && Math.abs(f) < 1 || !u && Math.abs(h) < 1) && (c = !0), c;
}, uc = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Yg = function(e) {
  return [e.deltaX, e.deltaY];
}, Xg = function(e) {
  return e && "current" in e ? e.current : e;
}, Bq = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, $q = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, jq = 0, Yi = [];
function Hq(e) {
  var t = A.useRef([]), n = A.useRef([0, 0]), r = A.useRef(), o = A.useState(jq++)[0], i = A.useState(uA)[0], a = A.useRef(e);
  A.useEffect(function() {
    a.current = e;
  }, [e]), A.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var m = cq([e.lockRef.current], (e.shards || []).map(Xg), !0).filter(Boolean);
      return m.forEach(function(g) {
        return g.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), m.forEach(function(g) {
          return g.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = A.useCallback(function(m, g) {
    if ("touches" in m && m.touches.length === 2 || m.type === "wheel" && m.ctrlKey)
      return !a.current.allowPinchZoom;
    var v = uc(m), y = n.current, w = "deltaX" in m ? m.deltaX : y[0] - v[0], x = "deltaY" in m ? m.deltaY : y[1] - v[1], b, S = m.target, M = Math.abs(w) > Math.abs(x) ? "h" : "v";
    if ("touches" in m && M === "h" && S.type === "range")
      return !1;
    var E = Kg(M, S);
    if (!E)
      return !0;
    if (E ? b = M : (b = M === "v" ? "h" : "v", E = Kg(M, S)), !E)
      return !1;
    if (!r.current && "changedTouches" in m && (w || x) && (r.current = b), !b)
      return !0;
    var P = r.current || b;
    return Vq(P, g, m, P === "h" ? w : x);
  }, []), l = A.useCallback(function(m) {
    var g = m;
    if (!(!Yi.length || Yi[Yi.length - 1] !== i)) {
      var v = "deltaY" in g ? Yg(g) : uc(g), y = t.current.filter(function(b) {
        return b.name === g.type && (b.target === g.target || g.target === b.shadowParent) && Bq(b.delta, v);
      })[0];
      if (y && y.should) {
        g.cancelable && g.preventDefault();
        return;
      }
      if (!y) {
        var w = (a.current.shards || []).map(Xg).filter(Boolean).filter(function(b) {
          return b.contains(g.target);
        }), x = w.length > 0 ? s(g, w[0]) : !a.current.noIsolation;
        x && g.cancelable && g.preventDefault();
      }
    }
  }, []), c = A.useCallback(function(m, g, v, y) {
    var w = { name: m, delta: g, target: v, should: y, shadowParent: zq(v) };
    t.current.push(w), setTimeout(function() {
      t.current = t.current.filter(function(x) {
        return x !== w;
      });
    }, 1);
  }, []), u = A.useCallback(function(m) {
    n.current = uc(m), r.current = void 0;
  }, []), f = A.useCallback(function(m) {
    c(m.type, Yg(m), m.target, s(m, e.lockRef.current));
  }, []), h = A.useCallback(function(m) {
    c(m.type, uc(m), m.target, s(m, e.lockRef.current));
  }, []);
  A.useEffect(function() {
    return Yi.push(i), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", l, Ki), document.addEventListener("touchmove", l, Ki), document.addEventListener("touchstart", u, Ki), function() {
      Yi = Yi.filter(function(m) {
        return m !== i;
      }), document.removeEventListener("wheel", l, Ki), document.removeEventListener("touchmove", l, Ki), document.removeEventListener("touchstart", u, Ki);
    };
  }, []);
  var p = e.removeScrollBar, C = e.inert;
  return A.createElement(
    A.Fragment,
    null,
    C ? A.createElement(i, { styles: $q(o) }) : null,
    p ? A.createElement(Iq, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function zq(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const Zq = vq(cA, Hq);
var pA = A.forwardRef(function(e, t) {
  return A.createElement(Nu, so({}, e, { ref: t, sideCar: Zq }));
});
pA.classNames = Nu.classNames;
var Wq = [" ", "Enter", "ArrowUp", "ArrowDown"], qq = [" ", "Enter"], xi = "Select", [Fu, Vu, Uq] = CW(xi), [Cs] = ah(xi, [
  Uq,
  YO
]), Bu = YO(), [Gq, k1] = Cs(xi), [Kq, Yq] = Cs(xi), mA = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    value: a,
    defaultValue: s,
    onValueChange: l,
    dir: c,
    name: u,
    autoComplete: f,
    disabled: h,
    required: p,
    form: C
  } = e, m = Bu(t), [g, v] = A.useState(null), [y, w] = A.useState(null), [x, b] = A.useState(!1), S = yW(c), [M, E] = qg({
    prop: r,
    defaultProp: o ?? !1,
    onChange: i,
    caller: xi
  }), [P, T] = qg({
    prop: a,
    defaultProp: s,
    onChange: l,
    caller: xi
  }), _ = A.useRef(null), D = g ? C || !!g.closest("form") : !0, [N, R] = A.useState(/* @__PURE__ */ new Set()), L = Array.from(N).map((B) => B.props.value).join(";");
  return /* @__PURE__ */ d(KW, { ...m, children: /* @__PURE__ */ F(
    Gq,
    {
      required: p,
      scope: t,
      trigger: g,
      onTriggerChange: v,
      valueNode: y,
      onValueNodeChange: w,
      valueNodeHasChildren: x,
      onValueNodeHasChildrenChange: b,
      contentId: sh(),
      value: P,
      onValueChange: T,
      open: M,
      onOpenChange: E,
      dir: S,
      triggerPointerDownPosRef: _,
      disabled: h,
      children: [
        /* @__PURE__ */ d(Fu.Provider, { scope: t, children: /* @__PURE__ */ d(
          Kq,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: A.useCallback((B) => {
              R((V) => new Set(V).add(B));
            }, []),
            onNativeOptionRemove: A.useCallback((B) => {
              R((V) => {
                const k = new Set(V);
                return k.delete(B), k;
              });
            }, []),
            children: n
          }
        ) }),
        D ? /* @__PURE__ */ F(
          BA,
          {
            "aria-hidden": !0,
            required: p,
            tabIndex: -1,
            name: u,
            autoComplete: f,
            value: P,
            onChange: (B) => T(B.target.value),
            disabled: h,
            form: C,
            children: [
              P === void 0 ? /* @__PURE__ */ d("option", { value: "" }) : null,
              Array.from(N)
            ]
          },
          L
        ) : null
      ]
    }
  ) });
};
mA.displayName = xi;
var gA = "SelectTrigger", CA = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: r = !1, ...o } = e, i = Bu(n), a = k1(gA, n), s = a.disabled || r, l = Sn(t, a.onTriggerChange), c = Vu(n), u = A.useRef("touch"), [f, h, p] = jA((m) => {
      const g = c().filter((w) => !w.disabled), v = g.find((w) => w.value === a.value), y = HA(g, m, v);
      y !== void 0 && a.onValueChange(y.value);
    }), C = (m) => {
      s || (a.onOpenChange(!0), p()), m && (a.triggerPointerDownPosRef.current = {
        x: Math.round(m.pageX),
        y: Math.round(m.pageY)
      });
    };
    return /* @__PURE__ */ d(YW, { asChild: !0, ...i, children: /* @__PURE__ */ d(
      nn.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": a.contentId,
        "aria-expanded": a.open,
        "aria-required": a.required,
        "aria-autocomplete": "none",
        dir: a.dir,
        "data-state": a.open ? "open" : "closed",
        disabled: s,
        "data-disabled": s ? "" : void 0,
        "data-placeholder": $A(a.value) ? "" : void 0,
        ...o,
        ref: l,
        onClick: en(o.onClick, (m) => {
          m.currentTarget.focus(), u.current !== "mouse" && C(m);
        }),
        onPointerDown: en(o.onPointerDown, (m) => {
          u.current = m.pointerType;
          const g = m.target;
          g.hasPointerCapture(m.pointerId) && g.releasePointerCapture(m.pointerId), m.button === 0 && m.ctrlKey === !1 && m.pointerType === "mouse" && (C(m), m.preventDefault());
        }),
        onKeyDown: en(o.onKeyDown, (m) => {
          const g = f.current !== "";
          !(m.ctrlKey || m.altKey || m.metaKey) && m.key.length === 1 && h(m.key), !(g && m.key === " ") && Wq.includes(m.key) && (C(), m.preventDefault());
        })
      }
    ) });
  }
);
CA.displayName = gA;
var vA = "SelectValue", yA = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: o, children: i, placeholder: a = "", ...s } = e, l = k1(vA, n), { onValueNodeHasChildrenChange: c } = l, u = i !== void 0, f = Sn(t, l.onValueNodeChange);
    return ur(() => {
      c(u);
    }, [c, u]), /* @__PURE__ */ d(
      nn.span,
      {
        ...s,
        ref: f,
        style: { pointerEvents: "none" },
        children: $A(l.value) ? /* @__PURE__ */ d(ut, { children: a }) : i
      }
    );
  }
);
yA.displayName = vA;
var Xq = "SelectIcon", bA = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: r, ...o } = e;
    return /* @__PURE__ */ d(nn.span, { "aria-hidden": !0, ...o, ref: t, children: r || "▼" });
  }
);
bA.displayName = Xq;
var Si = "SelectContent", wA = A.forwardRef(
  (e, t) => {
    const n = k1(Si, e.__scopeSelect), [r, o] = A.useState();
    if (ur(() => {
      o(new DocumentFragment());
    }, []), !n.open) {
      const i = r;
      return i ? S2.createPortal(
        /* @__PURE__ */ d(xA, { scope: e.__scopeSelect, children: /* @__PURE__ */ d(Fu.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ d("div", { children: e.children }) }) }),
        i
      ) : null;
    }
    return /* @__PURE__ */ d(SA, { ...e, ref: t });
  }
);
wA.displayName = Si;
var kr = 10, [xA, L1] = Cs(Si), Qq = "SelectContentImpl", Jq = /* @__PURE__ */ Il("SelectContent.RemoveScroll"), SA = A.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: r = "item-aligned",
      onCloseAutoFocus: o,
      onEscapeKeyDown: i,
      onPointerDownOutside: a,
      //
      // PopperContent props
      side: s,
      sideOffset: l,
      align: c,
      alignOffset: u,
      arrowPadding: f,
      collisionBoundary: h,
      collisionPadding: p,
      sticky: C,
      hideWhenDetached: m,
      avoidCollisions: g,
      //
      ...v
    } = e, y = k1(Si, n), [w, x] = A.useState(null), [b, S] = A.useState(null), M = Sn(t, (J) => x(J)), [E, P] = A.useState(null), [T, _] = A.useState(
      null
    ), D = Vu(n), [N, R] = A.useState(!1), L = A.useRef(!1);
    A.useEffect(() => {
      if (w) return lq(w);
    }, [w]), TW();
    const B = A.useCallback(
      (J) => {
        const [ee, ...U] = D().map((j) => j.ref.current), [X] = U.slice(-1), ie = document.activeElement;
        for (const j of J)
          if (j === ie || (j?.scrollIntoView({ block: "nearest" }), j === ee && b && (b.scrollTop = 0), j === X && b && (b.scrollTop = b.scrollHeight), j?.focus(), document.activeElement !== ie)) return;
      },
      [D, b]
    ), V = A.useCallback(
      () => B([E, w]),
      [B, E, w]
    );
    A.useEffect(() => {
      N && V();
    }, [N, V]);
    const { onOpenChange: k, triggerPointerDownPosRef: z } = y;
    A.useEffect(() => {
      if (w) {
        let J = { x: 0, y: 0 };
        const ee = (X) => {
          J = {
            x: Math.abs(Math.round(X.pageX) - (z.current?.x ?? 0)),
            y: Math.abs(Math.round(X.pageY) - (z.current?.y ?? 0))
          };
        }, U = (X) => {
          J.x <= 10 && J.y <= 10 ? X.preventDefault() : w.contains(X.target) || k(!1), document.removeEventListener("pointermove", ee), z.current = null;
        };
        return z.current !== null && (document.addEventListener("pointermove", ee), document.addEventListener("pointerup", U, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", ee), document.removeEventListener("pointerup", U, { capture: !0 });
        };
      }
    }, [w, k, z]), A.useEffect(() => {
      const J = () => k(!1);
      return window.addEventListener("blur", J), window.addEventListener("resize", J), () => {
        window.removeEventListener("blur", J), window.removeEventListener("resize", J);
      };
    }, [k]);
    const [$, Z] = jA((J) => {
      const ee = D().filter((ie) => !ie.disabled), U = ee.find((ie) => ie.ref.current === document.activeElement), X = HA(ee, J, U);
      X && setTimeout(() => X.ref.current.focus());
    }), W = A.useCallback(
      (J, ee, U) => {
        const X = !L.current && !U;
        (y.value !== void 0 && y.value === ee || X) && (P(J), X && (L.current = !0));
      },
      [y.value]
    ), H = A.useCallback(() => w?.focus(), [w]), G = A.useCallback(
      (J, ee, U) => {
        const X = !L.current && !U;
        (y.value !== void 0 && y.value === ee || X) && _(J);
      },
      [y.value]
    ), Y = r === "popper" ? A9 : MA, ne = Y === A9 ? {
      side: s,
      sideOffset: l,
      align: c,
      alignOffset: u,
      arrowPadding: f,
      collisionBoundary: h,
      collisionPadding: p,
      sticky: C,
      hideWhenDetached: m,
      avoidCollisions: g
    } : {};
    return /* @__PURE__ */ d(
      xA,
      {
        scope: n,
        content: w,
        viewport: b,
        onViewportChange: S,
        itemRefCallback: W,
        selectedItem: E,
        onItemLeave: H,
        itemTextRefCallback: G,
        focusSelectedItem: V,
        selectedItemText: T,
        position: r,
        isPositioned: N,
        searchRef: $,
        children: /* @__PURE__ */ d(pA, { as: Jq, allowPinchZoom: !0, children: /* @__PURE__ */ d(
          qO,
          {
            asChild: !0,
            trapped: y.open,
            onMountAutoFocus: (J) => {
              J.preventDefault();
            },
            onUnmountAutoFocus: en(o, (J) => {
              y.trigger?.focus({ preventScroll: !0 }), J.preventDefault();
            }),
            children: /* @__PURE__ */ d(
              ZO,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: i,
                onPointerDownOutside: a,
                onFocusOutside: (J) => J.preventDefault(),
                onDismiss: () => y.onOpenChange(!1),
                children: /* @__PURE__ */ d(
                  Y,
                  {
                    role: "listbox",
                    id: y.contentId,
                    "data-state": y.open ? "open" : "closed",
                    dir: y.dir,
                    onContextMenu: (J) => J.preventDefault(),
                    ...v,
                    ...ne,
                    onPlaced: () => R(!0),
                    ref: M,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...v.style
                    },
                    onKeyDown: en(v.onKeyDown, (J) => {
                      const ee = J.ctrlKey || J.altKey || J.metaKey;
                      if (J.key === "Tab" && J.preventDefault(), !ee && J.key.length === 1 && Z(J.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(J.key)) {
                        let X = D().filter((ie) => !ie.disabled).map((ie) => ie.ref.current);
                        if (["ArrowUp", "End"].includes(J.key) && (X = X.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(J.key)) {
                          const ie = J.target, j = X.indexOf(ie);
                          X = X.slice(j + 1);
                        }
                        setTimeout(() => B(X)), J.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
SA.displayName = Qq;
var eU = "SelectItemAlignedPosition", MA = A.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: r, ...o } = e, i = k1(Si, n), a = L1(Si, n), [s, l] = A.useState(null), [c, u] = A.useState(null), f = Sn(t, (M) => u(M)), h = Vu(n), p = A.useRef(!1), C = A.useRef(!0), { viewport: m, selectedItem: g, selectedItemText: v, focusSelectedItem: y } = a, w = A.useCallback(() => {
    if (i.trigger && i.valueNode && s && c && m && g && v) {
      const M = i.trigger.getBoundingClientRect(), E = c.getBoundingClientRect(), P = i.valueNode.getBoundingClientRect(), T = v.getBoundingClientRect();
      if (i.dir !== "rtl") {
        const ie = T.left - E.left, j = P.left - ie, te = M.left - j, K = M.width + te, me = Math.max(K, E.width), we = window.innerWidth - kr, ye = Fg(j, [
          kr,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(kr, we - me)
        ]);
        s.style.minWidth = K + "px", s.style.left = ye + "px";
      } else {
        const ie = E.right - T.right, j = window.innerWidth - P.right - ie, te = window.innerWidth - M.right - j, K = M.width + te, me = Math.max(K, E.width), we = window.innerWidth - kr, ye = Fg(j, [
          kr,
          Math.max(kr, we - me)
        ]);
        s.style.minWidth = K + "px", s.style.right = ye + "px";
      }
      const _ = h(), D = window.innerHeight - kr * 2, N = m.scrollHeight, R = window.getComputedStyle(c), L = parseInt(R.borderTopWidth, 10), B = parseInt(R.paddingTop, 10), V = parseInt(R.borderBottomWidth, 10), k = parseInt(R.paddingBottom, 10), z = L + B + N + k + V, $ = Math.min(g.offsetHeight * 5, z), Z = window.getComputedStyle(m), W = parseInt(Z.paddingTop, 10), H = parseInt(Z.paddingBottom, 10), G = M.top + M.height / 2 - kr, Y = D - G, ne = g.offsetHeight / 2, J = g.offsetTop + ne, ee = L + B + J, U = z - ee;
      if (ee <= G) {
        const ie = _.length > 0 && g === _[_.length - 1].ref.current;
        s.style.bottom = "0px";
        const j = c.clientHeight - m.offsetTop - m.offsetHeight, te = Math.max(
          Y,
          ne + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (ie ? H : 0) + j + V
        ), K = ee + te;
        s.style.height = K + "px";
      } else {
        const ie = _.length > 0 && g === _[0].ref.current;
        s.style.top = "0px";
        const te = Math.max(
          G,
          L + m.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (ie ? W : 0) + ne
        ) + U;
        s.style.height = te + "px", m.scrollTop = ee - G + m.offsetTop;
      }
      s.style.margin = `${kr}px 0`, s.style.minHeight = $ + "px", s.style.maxHeight = D + "px", r?.(), requestAnimationFrame(() => p.current = !0);
    }
  }, [
    h,
    i.trigger,
    i.valueNode,
    s,
    c,
    m,
    g,
    v,
    i.dir,
    r
  ]);
  ur(() => w(), [w]);
  const [x, b] = A.useState();
  ur(() => {
    c && b(window.getComputedStyle(c).zIndex);
  }, [c]);
  const S = A.useCallback(
    (M) => {
      M && C.current === !0 && (w(), y?.(), C.current = !1);
    },
    [w, y]
  );
  return /* @__PURE__ */ d(
    nU,
    {
      scope: n,
      contentWrapper: s,
      shouldExpandOnScrollRef: p,
      onScrollButtonChange: S,
      children: /* @__PURE__ */ d(
        "div",
        {
          ref: l,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: x
          },
          children: /* @__PURE__ */ d(
            nn.div,
            {
              ...o,
              ref: f,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...o.style
              }
            }
          )
        }
      )
    }
  );
});
MA.displayName = eU;
var tU = "SelectPopperPosition", A9 = A.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: r = "start",
    collisionPadding: o = kr,
    ...i
  } = e, a = Bu(n);
  return /* @__PURE__ */ d(
    XW,
    {
      ...a,
      ...i,
      ref: t,
      align: r,
      collisionPadding: o,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...i.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
A9.displayName = tU;
var [nU, uh] = Cs(Si, {}), P9 = "SelectViewport", EA = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: r, ...o } = e, i = L1(P9, n), a = uh(P9, n), s = Sn(t, i.onViewportChange), l = A.useRef(0);
    return /* @__PURE__ */ F(ut, { children: [
      /* @__PURE__ */ d(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ d(Fu.Slot, { scope: n, children: /* @__PURE__ */ d(
        nn.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...o,
          ref: s,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...o.style
          },
          onScroll: en(o.onScroll, (c) => {
            const u = c.currentTarget, { contentWrapper: f, shouldExpandOnScrollRef: h } = a;
            if (h?.current && f) {
              const p = Math.abs(l.current - u.scrollTop);
              if (p > 0) {
                const C = window.innerHeight - kr * 2, m = parseFloat(f.style.minHeight), g = parseFloat(f.style.height), v = Math.max(m, g);
                if (v < C) {
                  const y = v + p, w = Math.min(C, y), x = y - w;
                  f.style.height = w + "px", f.style.bottom === "0px" && (u.scrollTop = x > 0 ? x : 0, f.style.justifyContent = "flex-end");
                }
              }
            }
            l.current = u.scrollTop;
          })
        }
      ) })
    ] });
  }
);
EA.displayName = P9;
var _A = "SelectGroup", [rU, oU] = Cs(_A), OA = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = sh();
    return /* @__PURE__ */ d(rU, { scope: n, id: o, children: /* @__PURE__ */ d(nn.div, { role: "group", "aria-labelledby": o, ...r, ref: t }) });
  }
);
OA.displayName = _A;
var AA = "SelectLabel", PA = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = oU(AA, n);
    return /* @__PURE__ */ d(nn.div, { id: o.id, ...r, ref: t });
  }
);
PA.displayName = AA;
var l5 = "SelectItem", [iU, TA] = Cs(l5), IA = A.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: r,
      disabled: o = !1,
      textValue: i,
      ...a
    } = e, s = k1(l5, n), l = L1(l5, n), c = s.value === r, [u, f] = A.useState(i ?? ""), [h, p] = A.useState(!1), C = Sn(
      t,
      (y) => l.itemRefCallback?.(y, r, o)
    ), m = sh(), g = A.useRef("touch"), v = () => {
      o || (s.onValueChange(r), s.onOpenChange(!1));
    };
    if (r === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ d(
      iU,
      {
        scope: n,
        value: r,
        disabled: o,
        textId: m,
        isSelected: c,
        onItemTextChange: A.useCallback((y) => {
          f((w) => w || (y?.textContent ?? "").trim());
        }, []),
        children: /* @__PURE__ */ d(
          Fu.ItemSlot,
          {
            scope: n,
            value: r,
            disabled: o,
            textValue: u,
            children: /* @__PURE__ */ d(
              nn.div,
              {
                role: "option",
                "aria-labelledby": m,
                "data-highlighted": h ? "" : void 0,
                "aria-selected": c && h,
                "data-state": c ? "checked" : "unchecked",
                "aria-disabled": o || void 0,
                "data-disabled": o ? "" : void 0,
                tabIndex: o ? void 0 : -1,
                ...a,
                ref: C,
                onFocus: en(a.onFocus, () => p(!0)),
                onBlur: en(a.onBlur, () => p(!1)),
                onClick: en(a.onClick, () => {
                  g.current !== "mouse" && v();
                }),
                onPointerUp: en(a.onPointerUp, () => {
                  g.current === "mouse" && v();
                }),
                onPointerDown: en(a.onPointerDown, (y) => {
                  g.current = y.pointerType;
                }),
                onPointerMove: en(a.onPointerMove, (y) => {
                  g.current = y.pointerType, o ? l.onItemLeave?.() : g.current === "mouse" && y.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: en(a.onPointerLeave, (y) => {
                  y.currentTarget === document.activeElement && l.onItemLeave?.();
                }),
                onKeyDown: en(a.onKeyDown, (y) => {
                  l.searchRef?.current !== "" && y.key === " " || (qq.includes(y.key) && v(), y.key === " " && y.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
IA.displayName = l5;
var il = "SelectItemText", DA = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: o, ...i } = e, a = k1(il, n), s = L1(il, n), l = TA(il, n), c = Yq(il, n), [u, f] = A.useState(null), h = Sn(
      t,
      (v) => f(v),
      l.onItemTextChange,
      (v) => s.itemTextRefCallback?.(v, l.value, l.disabled)
    ), p = u?.textContent, C = A.useMemo(
      () => /* @__PURE__ */ d("option", { value: l.value, disabled: l.disabled, children: p }, l.value),
      [l.disabled, l.value, p]
    ), { onNativeOptionAdd: m, onNativeOptionRemove: g } = c;
    return ur(() => (m(C), () => g(C)), [m, g, C]), /* @__PURE__ */ F(ut, { children: [
      /* @__PURE__ */ d(nn.span, { id: l.textId, ...i, ref: h }),
      l.isSelected && a.valueNode && !a.valueNodeHasChildren ? S2.createPortal(i.children, a.valueNode) : null
    ] });
  }
);
DA.displayName = il;
var RA = "SelectItemIndicator", kA = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return TA(RA, n).isSelected ? /* @__PURE__ */ d(nn.span, { "aria-hidden": !0, ...r, ref: t }) : null;
  }
);
kA.displayName = RA;
var T9 = "SelectScrollUpButton", LA = A.forwardRef((e, t) => {
  const n = L1(T9, e.__scopeSelect), r = uh(T9, e.__scopeSelect), [o, i] = A.useState(!1), a = Sn(t, r.onScrollButtonChange);
  return ur(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const c = l.scrollTop > 0;
        i(c);
      };
      const l = n.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ d(
    FA,
    {
      ...e,
      ref: a,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: l } = n;
        s && l && (s.scrollTop = s.scrollTop - l.offsetHeight);
      }
    }
  ) : null;
});
LA.displayName = T9;
var I9 = "SelectScrollDownButton", NA = A.forwardRef((e, t) => {
  const n = L1(I9, e.__scopeSelect), r = uh(I9, e.__scopeSelect), [o, i] = A.useState(!1), a = Sn(t, r.onScrollButtonChange);
  return ur(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const c = l.scrollHeight - l.clientHeight, u = Math.ceil(l.scrollTop) < c;
        i(u);
      };
      const l = n.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ d(
    FA,
    {
      ...e,
      ref: a,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: l } = n;
        s && l && (s.scrollTop = s.scrollTop + l.offsetHeight);
      }
    }
  ) : null;
});
NA.displayName = I9;
var FA = A.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: r, ...o } = e, i = L1("SelectScrollButton", n), a = A.useRef(null), s = Vu(n), l = A.useCallback(() => {
    a.current !== null && (window.clearInterval(a.current), a.current = null);
  }, []);
  return A.useEffect(() => () => l(), [l]), ur(() => {
    s().find((u) => u.ref.current === document.activeElement)?.ref.current?.scrollIntoView({ block: "nearest" });
  }, [s]), /* @__PURE__ */ d(
    nn.div,
    {
      "aria-hidden": !0,
      ...o,
      ref: t,
      style: { flexShrink: 0, ...o.style },
      onPointerDown: en(o.onPointerDown, () => {
        a.current === null && (a.current = window.setInterval(r, 50));
      }),
      onPointerMove: en(o.onPointerMove, () => {
        i.onItemLeave?.(), a.current === null && (a.current = window.setInterval(r, 50));
      }),
      onPointerLeave: en(o.onPointerLeave, () => {
        l();
      })
    }
  );
}), aU = "SelectSeparator", VA = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return /* @__PURE__ */ d(nn.div, { "aria-hidden": !0, ...r, ref: t });
  }
);
VA.displayName = aU;
var D9 = "SelectArrow", sU = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = Bu(n), i = k1(D9, n), a = L1(D9, n);
    return i.open && a.position === "popper" ? /* @__PURE__ */ d(QW, { ...o, ...r, ref: t }) : null;
  }
);
sU.displayName = D9;
var lU = "SelectBubbleInput", BA = A.forwardRef(
  ({ __scopeSelect: e, value: t, ...n }, r) => {
    const o = A.useRef(null), i = Sn(r, o), a = nq(t);
    return A.useEffect(() => {
      const s = o.current;
      if (!s) return;
      const l = window.HTMLSelectElement.prototype, u = Object.getOwnPropertyDescriptor(
        l,
        "value"
      ).set;
      if (a !== t && u) {
        const f = new Event("change", { bubbles: !0 });
        u.call(s, t), s.dispatchEvent(f);
      }
    }, [a, t]), /* @__PURE__ */ d(
      nn.select,
      {
        ...n,
        style: { ...iA, ...n.style },
        ref: i,
        defaultValue: t
      }
    );
  }
);
BA.displayName = lU;
function $A(e) {
  return e === "" || e === void 0;
}
function jA(e) {
  const t = wi(e), n = A.useRef(""), r = A.useRef(0), o = A.useCallback(
    (a) => {
      const s = n.current + a;
      t(s), (function l(c) {
        n.current = c, window.clearTimeout(r.current), c !== "" && (r.current = window.setTimeout(() => l(""), 1e3));
      })(s);
    },
    [t]
  ), i = A.useCallback(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return A.useEffect(() => () => window.clearTimeout(r.current), []), [n, o, i];
}
function HA(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((c) => c === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let a = cU(e, Math.max(i, 0));
  o.length === 1 && (a = a.filter((c) => c !== n));
  const l = a.find(
    (c) => c.textValue.toLowerCase().startsWith(o.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function cU(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var uU = mA, fU = CA, dU = yA, hU = bA, pU = wA, mU = EA, gU = OA, CU = PA, vU = IA, yU = DA, bU = kA, wU = LA, xU = NA, SU = VA;
const $u = gt({}), MU = ({
  children: e,
  handleClear: t,
  ...n
}) => {
  const r = Oe($u), o = r?.clearable && !!n.value, i = r?.disabled, a = r.topLabel ? r.placeholder : r.label || r.placeholder, s = r.required || r.error ? /* @__PURE__ */ F("span", { children: [
    a,
    " ",
    !r.topLabel && /* @__PURE__ */ d("span", { className: "text-ui-errorDark", children: "*" })
  ] }) : a, l = r.size === "small", c = I(
    "ml-[9px] flex items-center justify-center text-surface-common-primary",
    i && "text-neutral-500"
  ), u = I(
    "h-[18px] w-[18px]",
    l && "!h-[16px] !w-[16px]"
  ), f = (h) => {
    h.preventDefault(), h.stopPropagation(), t();
  };
  return /* @__PURE__ */ F(ut, { children: [
    /* @__PURE__ */ d(dU, { placeholder: s, ...n, children: e }),
    /* @__PURE__ */ F(hU, { className: c, children: [
      o && /* @__PURE__ */ d(
        "span",
        {
          onPointerDown: f,
          className: "rounded-sm bg-transparent text-neutral-500 transition-all hover:bg-neutral-200 hover:text-neutral-600",
          children: /* @__PURE__ */ d(Wr, { className: u })
        }
      ),
      /* @__PURE__ */ d(Gr, {})
    ] })
  ] });
}, zA = ({
  children: e,
  handleClear: t,
  ...n
}) => {
  const r = Oe($u), o = r.borderless, i = !!r.error, a = !!r.disabled, s = I(
    "flex min-w-[100px] items-center justify-between rounded-md px-[10px] py-[4px] transition-all duration-200 ease-in-out",
    "focus:outline-1 focus:outline-surface-common-primary",
    o ? "border border-transparent hover:!border hover:!border-border-input" : "border border-border-input hover:border-neutral-400",
    i && "border-ui-errorDark",
    a && "border-border-input bg-neutral-200 text-neutral-500 hover:border-border-input",
    r.size === "medium" && "py-[9px]"
  );
  return /* @__PURE__ */ d(fU, { className: s, ...n, children: /* @__PURE__ */ d(MU, { value: n.value, handleClear: t, children: e }) });
}, EU = ({
  children: e,
  placeholder: t = "-",
  label: n = "-",
  size: r = "small",
  topLabel: o = !1,
  borderless: i = !1,
  required: a = !1,
  clearable: s = !0,
  error: l,
  hint: c,
  value: u,
  onValueChange: f,
  onBlur: h,
  ...p
}) => {
  const [C, m] = ue(
    p.defaultValue || ""
  ), g = u !== void 0 ? u : C, v = ke(null), y = {
    topLabel: o,
    placeholder: t,
    label: n,
    borderless: i,
    required: a,
    clearable: s,
    size: r,
    error: l,
    searchRef: v,
    ...p
  }, w = (M) => {
    m(M), f?.(M);
  }, x = () => !o || !n ? null : /* @__PURE__ */ F(Ut, { weight: "semibold", children: [
    n,
    (a || l) && /* @__PURE__ */ d(
      "span",
      {
        "aria-label": "required field",
        className: "ml-[2px] text-ui-errorDark",
        children: "*"
      }
    )
  ] }), b = () => !c || l ? null : /* @__PURE__ */ d(Go, { children: c }), S = () => l ? /* @__PURE__ */ d(Eo, { children: l }) : null;
  return /* @__PURE__ */ d($u.Provider, { value: y, children: /* @__PURE__ */ F("div", { className: "flex w-fit flex-col gap-xs", children: [
    /* @__PURE__ */ d(x, {}),
    /* @__PURE__ */ F(
      uU,
      {
        value: g,
        onValueChange: w,
        open: p.open,
        onOpenChange: p.onOpenChange,
        ...p,
        children: [
          /* @__PURE__ */ d(
            zA,
            {
              value: g,
              handleClear: () => w(""),
              onBlur: h
            }
          ),
          e
        ]
      }
    ),
    /* @__PURE__ */ d(b, {}),
    /* @__PURE__ */ d(S, {})
  ] }) });
}, _U = ({
  children: e,
  className: t,
  position: n = "item-aligned",
  ...r
}) => {
  const i = Oe($u).size === "small";
  return /* @__PURE__ */ F(
    pU,
    {
      position: n,
      className: I(
        "border-1 z-[999] max-h-[var(--radix-select-content-available-height)] w-full overflow-hidden rounded-md border bg-neutral-0",
        t
      ),
      ...r,
      children: [
        /* @__PURE__ */ d(wU, { className: "flex h-[25px] cursor-default items-center justify-center bg-white !text-surface-common-primary", children: /* @__PURE__ */ d(V0, {}) }),
        /* @__PURE__ */ d(
          mU,
          {
            className: I(i ? "p-[5px]" : "p-[10px]"),
            children: e
          }
        ),
        /* @__PURE__ */ d(xU, { className: "flex h-[25px] cursor-default items-center justify-center bg-white !text-surface-common-primary", children: /* @__PURE__ */ d(Gr, {}) })
      ]
    }
  );
}, OU = ({
  children: e,
  ...t
}) => /* @__PURE__ */ d(
  CU,
  {
    className: "my-[4px] pl-[5px] pr-[5px] text-[14px] text-sm leading-none text-neutral-500 underline",
    ...t,
    children: e
  }
), AU = ({
  children: e,
  label: t,
  ...n
}) => /* @__PURE__ */ F(gU, { ...n, children: [
  /* @__PURE__ */ d(OU, { children: t }),
  e
] }), PU = O.forwardRef(
  ({ children: e, ...t }, n) => {
    const r = I(
      "relative flex h-[25px] cursor-pointer select-none items-center rounded-[3px] pl-[5px] pr-[5px] text-[16px] leading-none data-[disabled]:pointer-events-none data-[highlighted]:bg-surface-common-light data-[disabled]:text-neutral-500 data-[highlighted]:text-text-primary data-[highlighted]:outline-none"
    );
    return /* @__PURE__ */ F(vU, { ref: n, className: r, ...t, children: [
      /* @__PURE__ */ d(yU, { children: e }),
      /* @__PURE__ */ d(bU, { className: "absolute right-0 inline-flex w-[25px] items-center justify-center !text-surface-common-primary", children: /* @__PURE__ */ d(k2, {}) })
    ] });
  }
), TU = ({ ...e }) => /* @__PURE__ */ d(
  SU,
  {
    className: "m-[5px] h-px bg-neutral-200",
    ...e
  }
), xn = Object.assign(EU, {
  Trigger: zA,
  Content: _U,
  Item: PU,
  Group: AU,
  Separator: TU
});
xn.displayName = "Select";
xn.Content.displayName = "Select.Content";
xn.Item.displayName = "Select.Item";
xn.Group.displayName = "Select.Group";
xn.Separator.displayName = "Select.Separator";
function Qg({
  table: e,
  filterFields: t,
  globalFilter: n,
  globalFilterOptions: r
}) {
  const o = _e(() => t, [t]), i = I(
    "flex w-full flex-col flex-wrap items-start justify-center gap-md sm:w-fit sm:flex-row sm:items-end"
  ), a = (u, f) => {
    const h = e.getColumn(f), p = h?.getFilterValue()?.toString() ?? "";
    return /* @__PURE__ */ d(
      xn,
      {
        size: "medium",
        topLabel: !0,
        label: u.label,
        value: p,
        onValueChange: (C) => h?.setFilterValue(C),
        children: /* @__PURE__ */ d(xn.Content, { children: u.filterValues?.map((C) => /* @__PURE__ */ d(xn.Item, { value: String(C.id), children: C.label }, String(C.id))) })
      }
    );
  }, s = (u, f) => /* @__PURE__ */ d(
    A1,
    {
      label: u.label,
      value: e.getColumn(f)?.getFilterValue()?.toString() ?? "",
      placeholder: u.placeholder,
      onChange: (h) => e.getColumn(f)?.setFilterValue(h.target.value)
    }
  ), l = (u, f) => {
    const h = e.getColumn(f), p = h?.getFilterValue();
    return /* @__PURE__ */ d(
      D2,
      {
        label: u.label,
        wrapperClassName: "mb-[12px]",
        checked: p ?? !1,
        onChange: (C) => {
          h?.setFilterValue(C.target.checked);
        }
      }
    );
  }, c = (u, f) => {
    switch (u.type) {
      case "text":
        return s(u, f);
      case "checkbox":
        return l(u, f);
      case "select":
        return a(u, f);
    }
  };
  return /* @__PURE__ */ F("div", { className: i, children: [
    n && /* @__PURE__ */ F("div", { className: "flex w-full items-center gap-sm sm:w-fit", children: [
      /* @__PURE__ */ d(
        A1,
        {
          className: "w-full min-w-[300px] flex-1 sm:min-w-fit",
          label: r?.label,
          placeholder: r?.placeholder,
          onChange: (u) => e.setGlobalFilter(u.target.value)
        }
      ),
      r?.tooltip && /* @__PURE__ */ d(
        zd,
        {
          label: r.tooltipChipLabel ?? "Hjelp",
          tooltip: r.tooltip
        }
      )
    ] }),
    o?.map((u) => /* @__PURE__ */ d("div", { className: "w-full sm:w-fit", children: c(u, u.id) }, u.id))
  ] });
}
const IU = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 20 20", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M5.83333 15C5.59722 15 5.39931 14.9201 5.23958 14.7604C5.07986 14.6007 5 14.4028 5 14.1667V5.83333C5 5.59722 5.07986 5.39931 5.23958 5.23958C5.39931 5.07986 5.59722 5 5.83333 5C6.06944 5 6.26736 5.07986 6.42708 5.23958C6.58681 5.39931 6.66667 5.59722 6.66667 5.83333V14.1667C6.66667 14.4028 6.58681 14.6007 6.42708 14.7604C6.26736 14.9201 6.06944 15 5.83333 15ZM11.5 10L14.75 13.25C14.9028 13.4028 14.9792 13.5972 14.9792 13.8333C14.9792 14.0694 14.9028 14.2639 14.75 14.4167C14.5972 14.5694 14.4028 14.6458 14.1667 14.6458C13.9306 14.6458 13.7361 14.5694 13.5833 14.4167L9.75 10.5833C9.66667 10.5 9.60764 10.4097 9.57292 10.3125C9.53819 10.2153 9.52083 10.1111 9.52083 10C9.52083 9.88889 9.53819 9.78472 9.57292 9.6875C9.60764 9.59028 9.66667 9.5 9.75 9.41667L13.5833 5.58333C13.7361 5.43056 13.9306 5.35417 14.1667 5.35417C14.4028 5.35417 14.5972 5.43056 14.75 5.58333C14.9028 5.73611 14.9792 5.93056 14.9792 6.16667C14.9792 6.40278 14.9028 6.59722 14.75 6.75L11.5 10Z",
    fill: "currentColor"
  }
) }), ZA = Q("IconChevronLeftFirst")(IU), DU = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 20 20", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M8.49992 10L5.24992 6.75C5.09714 6.59722 5.02075 6.40278 5.02075 6.16667C5.02075 5.93056 5.09714 5.73611 5.24992 5.58333C5.4027 5.43056 5.59714 5.35417 5.83325 5.35417C6.06936 5.35417 6.26381 5.43056 6.41659 5.58333L10.2499 9.41667C10.3333 9.5 10.3923 9.59028 10.427 9.6875C10.4617 9.78472 10.4791 9.88889 10.4791 10C10.4791 10.1111 10.4617 10.2153 10.427 10.3125C10.3923 10.4097 10.3333 10.5 10.2499 10.5833L6.41659 14.4167C6.26381 14.5694 6.06936 14.6458 5.83325 14.6458C5.59714 14.6458 5.4027 14.5694 5.24992 14.4167C5.09714 14.2639 5.02075 14.0694 5.02075 13.8333C5.02075 13.5972 5.09714 13.4028 5.24992 13.25L8.49992 10ZM14.1666 5C14.4027 5 14.6006 5.07986 14.7603 5.23958C14.9201 5.39931 14.9999 5.59722 14.9999 5.83333V14.1667C14.9999 14.4028 14.9201 14.6007 14.7603 14.7604C14.6006 14.9201 14.4027 15 14.1666 15C13.9305 15 13.7326 14.9201 13.5728 14.7604C13.4131 14.6007 13.3333 14.4028 13.3333 14.1667V5.83333C13.3333 5.59722 13.4131 5.39931 13.5728 5.23958C13.7326 5.07986 13.9305 5 14.1666 5Z",
    fill: "currentColor"
  }
) }), WA = Q("IconChevronRightLast")(DU);
function RU({
  table: e,
  pageIndex: t,
  pageCount: n,
  handlePageChange: r
}) {
  const o = I(
    "flex w-full items-center justify-between rounded-md sm:border"
  ), i = I(
    "p-[8px] outline-none transition-colors duration-75 ease-in hover:bg-surface-common-subtle",
    "disabled:cursor-not-allowed disabled:opacity-50"
  );
  return /* @__PURE__ */ F("div", { className: o, children: [
    /* @__PURE__ */ d("div", { className: "hidden sm:flex", children: /* @__PURE__ */ d(() => /* @__PURE__ */ F(ut, { children: [
      /* @__PURE__ */ d(
        "button",
        {
          className: I(i),
          "aria-label": "Første side",
          onClick: () => r(0),
          disabled: !e.getCanPreviousPage(),
          children: /* @__PURE__ */ d(ZA, { colorVariant: "primary" })
        }
      ),
      /* @__PURE__ */ d(
        "button",
        {
          className: I(
            i,
            "border-l border-r border-border-light"
          ),
          "aria-label": "Forrige side",
          onClick: () => r(t - 1),
          disabled: !e.getCanPreviousPage(),
          children: /* @__PURE__ */ d(qr, { colorVariant: "primary" })
        }
      ),
      /* @__PURE__ */ d(
        "button",
        {
          className: I(i, "border-r border-border-light"),
          "aria-label": "Neste side",
          onClick: () => r(t + 1),
          disabled: !e.getCanNextPage(),
          children: /* @__PURE__ */ d(yo, { colorVariant: "primary" })
        }
      ),
      /* @__PURE__ */ d(
        "button",
        {
          className: I(i),
          "aria-label": "Siste side",
          onClick: () => r(n - 1),
          disabled: !e.getCanNextPage(),
          children: /* @__PURE__ */ d(WA, { colorVariant: "primary" })
        }
      )
    ] }), {}) }),
    /* @__PURE__ */ d("div", { className: "flex w-full items-center justify-between sm:hidden", children: /* @__PURE__ */ d(() => /* @__PURE__ */ F(ut, { children: [
      /* @__PURE__ */ d(
        "button",
        {
          className: I(i, "outline-none"),
          "aria-label": "Forrige side",
          onClick: () => r(t - 1),
          disabled: e.getState().pagination.pageIndex === 0,
          children: /* @__PURE__ */ d(qr, { colorVariant: "primary" })
        }
      ),
      /* @__PURE__ */ d("div", { className: "flex", children: /* @__PURE__ */ F(Rt, { children: [
        "Side ",
        t + 1,
        " av ",
        n
      ] }) }),
      /* @__PURE__ */ d(
        "button",
        {
          className: I(i),
          "aria-label": "Neste side",
          onClick: () => r(t + 1),
          disabled: e.getState().pagination.pageIndex === n - 1,
          children: /* @__PURE__ */ d(yo, { colorVariant: "primary" })
        }
      )
    ] }), {}) })
  ] });
}
function kU({
  table: e,
  pageOptions: t = [10, 20, 30],
  onPageSizeChange: n
}) {
  const r = e.getState().pagination.pageSize, o = e.getState().pagination.pageIndex, i = (l) => {
    e.setPageIndex(l);
  }, a = (l) => {
    e.setPageSize(Number(l)), n?.(Number(l));
  }, s = e.getPageCount();
  return /* @__PURE__ */ F("div", { className: "mt-md flex w-full items-center justify-between", children: [
    /* @__PURE__ */ F("div", { className: "hidden items-center gap-sm sm:flex", children: [
      /* @__PURE__ */ d(Ye, { children: "Rader per side" }),
      /* @__PURE__ */ d(
        xn,
        {
          clearable: !1,
          value: `${r}`,
          onValueChange: (l) => a(l),
          children: /* @__PURE__ */ d(xn.Content, { children: t.map((l) => /* @__PURE__ */ d(xn.Item, { value: l.toString(), children: l }, l)) })
        }
      )
    ] }),
    /* @__PURE__ */ d("div", { className: "hidden sm:flex", children: /* @__PURE__ */ F(Ye, { children: [
      "Side ",
      o + 1,
      " av ",
      s
    ] }) }),
    /* @__PURE__ */ d("div", { className: "flex w-full gap-md sm:w-fit", children: /* @__PURE__ */ d(
      RU,
      {
        handlePageChange: i,
        table: e,
        pageIndex: o,
        pageCount: s
      }
    ) })
  ] });
}
function qA({
  data: e,
  columns: t,
  mobileColumns: n,
  collapseToList: r = !1,
  pagination: o = !0,
  hasGlobalFilter: i = !1,
  globalFilterOptions: a = {
    globalFilterFn: "includesString",
    placeholder: "Søk i alle felter",
    tooltip: "Søk i alle felter",
    tooltipChipLabel: "Hjelp"
  },
  paginationSettings: s = {
    paginationState: {
      pageSize: 10,
      pageIndex: 0
    },
    pageOptions: [10, 25, 50, 100]
  },
  manualControls: l = !1,
  totalRowCount: c,
  filterPosition: u = "top",
  filterFields: f,
  onSortingChange: h,
  onFiltersChange: p,
  onPaginationChange: C,
  onRowClick: m,
  collapseToListWhenMobile: g = !1,
  tableClassName: v,
  tableHeaderClassName: y,
  tableBodyClassName: w,
  tableRowClassName: x,
  tableCellClassName: b,
  disableTableWidthCalculation: S,
  children: M,
  ...E
}, P) {
  const T = R1(), [_, D] = ue([]), [N, R] = ue([]), [L, B] = ue({}), [V, k] = ue(""), [z, $] = ue(
    s.paginationState
  ), [Z, W] = ue({}), H = T && g, G = _e(
    () => cW(
      H && n ? n : t
    ),
    [t, n, H]
  ), Y = _e(
    () => ({
      data: e,
      columns: G,
      pageCount: l ? Math.ceil((c ?? 0) / z.pageSize) : void 0,
      manualSorting: l,
      manualFiltering: l,
      manualPagination: l,
      // Important that you use the key 'subRows' for nested rows
      getSubRows: (te) => te?.subRows,
      onExpandedChange: W,
      onSortingChange: (te) => {
        if (!l) {
          D(te);
          return;
        }
        const K = typeof te == "function" ? te(_) : te;
        D(K), h?.(K);
      },
      onColumnFiltersChange: (te) => {
        if (!l) {
          R(te);
          return;
        }
        const K = typeof te == "function" ? te(N) : te;
        R(K), p?.(K);
      },
      onPaginationChange: (te) => {
        if (!o) return;
        if (!l) {
          $(te);
          return;
        }
        const K = typeof te == "function" ? te(z) : te;
        $(K), C?.(K);
      },
      getCoreRowModel: hH(),
      getSortedRowModel: bH(),
      getFilteredRowModel: vH(),
      getExpandedRowModel: pH(),
      onRowSelectionChange: B,
      ...o && { getPaginationRowModel: yH() },
      state: {
        expanded: Z,
        columnFilters: N,
        rowSelection: L,
        sorting: _,
        globalFilter: V,
        ...o && { pagination: z }
      },
      initialState: {
        expanded: Z,
        ...o && {
          pagination: {
            pageSize: s.paginationState.pageSize,
            pageIndex: s.paginationState.pageIndex
          }
        },
        ...E.initialTableState
      },
      globalFilterFn: a.globalFilterFn,
      onGlobalFilterChange: k
    }),
    [
      e,
      G,
      l,
      c,
      z,
      N,
      L,
      _,
      V,
      s.paginationState.pageSize,
      s.paginationState.pageIndex,
      E.initialTableState,
      a.globalFilterFn,
      h,
      p,
      C,
      o,
      Z
    ]
  ), ne = MH(Y), J = ne.getHeaderGroups()[0].headers, ee = _e(() => ne.getRowModel().rows.some((te) => te.getCanExpand()), [ne]), U = _e(
    () => !!ne.getGlobalFilterFn() && i,
    [ne, i]
  ), X = _e(
    () => f && f.length > 0 || !!U,
    [f, U]
  ), ie = _e(
    () => a,
    [a]
  ), j = _e(() => f, [f]);
  return /* @__PURE__ */ d(jO.Provider, { value: { table: ne }, children: /* @__PURE__ */ F("div", { className: "flex gap-md", children: [
    /* @__PURE__ */ F("div", { className: "flex flex-1 flex-col gap-2 overflow-x-auto", children: [
      X && u === "top" && /* @__PURE__ */ d("div", { children: /* @__PURE__ */ d(
        Qg,
        {
          table: ne,
          filterFields: j,
          globalFilter: i,
          globalFilterOptions: a
        }
      ) }),
      M,
      /* @__PURE__ */ F(
        Lt,
        {
          className: v,
          collapseToList: H || r,
          width: S ? void 0 : ne.getTotalSize(),
          ...E,
          ref: P,
          children: [
            /* @__PURE__ */ d(Lt.Head, { className: y, children: ne.getHeaderGroups().map((te) => /* @__PURE__ */ F(Lt.Row, { className: x, children: [
              ee && /* @__PURE__ */ d(
                Lt.TableHeaderCell,
                {
                  className: I("w-4", b)
                }
              ),
              te.headers.map((K) => /* @__PURE__ */ d(
                Lt.TableHeaderCell,
                {
                  className: b,
                  width: S ? void 0 : K.getSize(),
                  sortable: K.column.getCanSort(),
                  isSorted: K.column.getIsSorted(),
                  handleSortClick: () => {
                    K.column.getCanSort() && K.column.toggleSorting();
                  },
                  children: Ag(
                    K.column.columnDef.header,
                    K.getContext()
                  )
                },
                K.id
              ))
            ] }, te.id)) }),
            /* @__PURE__ */ d(Lt.Body, { className: w, children: ne.getRowModel()?.rows?.length ? ne.getRowModel().rows.map((te, K) => /* @__PURE__ */ d(
              Lt.Row,
              {
                expandable: te.getCanExpand(),
                expanded: te.getIsExpanded(),
                onExpandChange: (me) => {
                  te.toggleExpanded(me);
                },
                onClick: m ? () => m(te.original, te) : void 0,
                className: x,
                children: te.getVisibleCells()?.map((me) => {
                  const we = me.column.columnDef;
                  return /* @__PURE__ */ d(
                    Lt.Cell,
                    {
                      "data-th": me.column.columnDef.header,
                      width: S ? void 0 : me.column.getSize(),
                      placeholder: me.column.columnDef.header ? "" : "-",
                      collapsedCellDirection: we?.collapsedCellDirection || "column",
                      className: b,
                      children: Ag(
                        me.column.columnDef.cell,
                        me.getContext()
                      )
                    },
                    me.id
                  );
                })
              },
              K
            )) : /* @__PURE__ */ d(Lt.Row, { children: /* @__PURE__ */ d(
              Lt.Cell,
              {
                colSpan: J.length,
                className: "w-full text-center",
                children: E.emptyState || "Ingen data"
              }
            ) }) })
          ]
        }
      ),
      o && /* @__PURE__ */ d(
        kU,
        {
          table: ne,
          pageOptions: s.pageOptions
        }
      )
    ] }),
    X && u === "right" && /* @__PURE__ */ d(
      Qg,
      {
        table: ne,
        filterFields: j,
        globalFilter: i,
        globalFilterOptions: ie
      }
    )
  ] }) });
}
const LU = O.forwardRef(qA);
qA.displayName = "DataTable";
const NU = ({
  hideLabel: e,
  hideRemoveAll: t,
  children: n
}) => {
  const r = eW();
  if (!r)
    return console.error("TableCheckedSummary: table is required"), null;
  const o = r.table, { getSelectedRowModel: i } = o, a = i().rows;
  if (!a?.length) return null;
  const s = () => {
    o.setRowSelection({});
  };
  return /* @__PURE__ */ F("div", { className: "flex items-center gap-md self-stretch bg-surface-common-subtle px-md py-sm", children: [
    !e && /* @__PURE__ */ d(Ye, { className: "text-[14px]", children: `Med markerte (${a.length} stk)` }),
    n,
    !t && /* @__PURE__ */ d(Dt, { variant: "ghost", small: !0, onClick: s, children: "Fjern markering" })
  ] });
}, UA = Object.assign(LU, {
  CheckedSummary: NU
});
UA.displayName = "DataTable";
UA.CheckedSummary.displayName = "DataTable.CheckedSummary";
const FU = Xe(
  function(t, n) {
    const {
      children: r,
      className: o,
      closeButton: i = "Lukk dialogvindu",
      bannerVariant: a,
      variant: s = "default",
      type: l = "info",
      withBorder: c = !1,
      ...u
    } = t, [f, h] = ue(!1), p = a || s, C = {
      info: I(
        "bg-categories-blueLight",
        c && "border-categories-blueDark"
      ),
      success: I("bg-ui-successLight", c && "border-ui-successDark"),
      warning: I(
        "bg-categories-orangeLight",
        c && "border-ui-warningDark"
      ),
      error: I("bg-ui-errorLight", c && "border-ui-errorDark"),
      default: I(
        "bg-surface-common-subtle",
        c && "border-surface-common-primary"
      )
    }, m = I(
      "relative box-border flex w-full flex-col justify-between rounded-md p-md text-text-primary",
      C[p],
      c && "border",
      f && "hidden",
      o
    );
    return /* @__PURE__ */ F(
      "section",
      {
        className: m,
        ref: n,
        "aria-live": l === "alert" ? "assertive" : "polite",
        role: l === "alert" ? "alert" : "status",
        ...u,
        children: [
          i !== !1 && /* @__PURE__ */ d("span", { className: "absolute right-2 top-2", children: /* @__PURE__ */ d(
            Dt,
            {
              "aria-label": i,
              title: "Lukk",
              variant: "nostyle",
              type: "button",
              autoFocus: !0,
              onClick: (w) => {
                t.onClick && t.onClick(w), h(!0);
              },
              children: /* @__PURE__ */ d(Wr, { className: "h-[20px] w-[20px]" })
            }
          ) }),
          r
        ]
      }
    );
  }
), VU = Xe(
  function({ className: t, level: n = 2, size: r = "small", ...o }, i) {
    const a = _1, s = I("pb-xs leading-normal", t);
    return /* @__PURE__ */ d(
      a,
      {
        className: s,
        variant: "custom",
        level: n,
        size: r,
        ref: i,
        ...o
      }
    );
  }
), BU = Xe(
  function({ className: t, ...n }, r) {
    const o = "footer", i = I("flex justify-between pt-sm", t);
    return /* @__PURE__ */ d(o, { className: i, ref: r, ...n });
  }
), $U = Xe(
  function({ className: t, ...n }, r) {
    const i = I(t);
    return /* @__PURE__ */ d("div", { className: i, ref: r, ...n });
  }
), Na = Object.assign(FU, {
  Header: VU,
  Footer: BU,
  Block: $U
});
Na.displayName = "Banner";
Na.Header.displayName = "Banner.Header";
Na.Footer.displayName = "Banner.Footer";
Na.Block.displayName = "Banner.Block";
const jU = Xe(
  function(t, n) {
    const {
      children: r,
      className: o,
      noShadow: i = !1,
      as: a = "section",
      surfaceBackground: s = !1,
      isLoading: l = !1,
      loadingOptions: c = {
        variant: "default",
        height: "100px",
        afterText: "Laster innhold...",
        beforeText: ""
      },
      empty: u = !1,
      error: f = !1,
      ...h
    } = t, p = a || "div", C = {
      variant: c.variant || "default",
      height: c.height || "100px",
      afterText: c.afterText || "Laster innhold...",
      beforeText: c.beforeText || ""
    }, m = I(
      "box-border flex w-full flex-col justify-between gap-md rounded-card bg-white p-md md:p-lg",
      s ? "bg-surface-common-background" : "bg-neutral-0",
      i ? "shadow-none" : "shadow-card",
      o
    );
    return l ? /* @__PURE__ */ d(
      S1,
      {
        width: "100%",
        variant: C.variant,
        height: C.height,
        afterText: C.afterText,
        beforeText: C.beforeText
      }
    ) : /* @__PURE__ */ d(p, { className: m, ref: n, ...h, children: O.Children.map(r, (v) => O.isValidElement(v) ? O.cloneElement(v, {
      empty: u,
      error: f
    }) : v) });
  }
), HU = Xe(
  function({ className: t, level: n = 2, variant: r = "default", size: o = "medium", ...i }, a) {
    const s = _1, l = I("leading-normal", t);
    return /* @__PURE__ */ d(
      s,
      {
        className: l,
        level: n,
        variant: r,
        size: o,
        ref: a,
        ...i
      }
    );
  }
), zU = Xe(
  function({ className: t, error: n, empty: r, ...o }, i) {
    const a = "footer", s = I("flex justify-between", t);
    return n ? null : /* @__PURE__ */ d(a, { className: s, ref: i, ...o });
  }
), ZU = Xe(
  function({ className: t, empty: n, error: r, ...o }, i) {
    const s = I(t);
    return n || r ? null : /* @__PURE__ */ d("div", { className: s, ref: i, ...o });
  }
), WU = Xe(
  function({ className: t, empty: n, error: r, ...o }, i) {
    const s = I(t);
    return r || !n ? null : /* @__PURE__ */ d("div", { className: s, ref: i, ...o });
  }
), qU = Xe(
  function({ className: t, error: n, ...r }, o) {
    const a = I("text-ui-errorDark", t);
    return n ? /* @__PURE__ */ d("div", { className: a, ref: o, ...r }) : null;
  }
), vs = Object.assign(jU, {
  Header: HU,
  Footer: zU,
  Block: ZU,
  Empty: WU,
  Error: qU
});
vs.displayName = "Box";
vs.Header.displayName = "Box.Header";
vs.Footer.displayName = "Box.Footer";
vs.Block.displayName = "Box.Block";
vs.Empty.displayName = "Box.Empty";
vs.Error.displayName = "Box.Error";
const fh = gt({
  current: null
}), GA = ({ children: e }) => {
  const t = ke(null);
  return /* @__PURE__ */ d(fh.Provider, { value: t, children: e });
};
GA.displayName = "ModalContext";
const KA = gt({}), dh = () => {
  const e = Oe(KA);
  if (e == null)
    throw new Error("ModalPropsProvider is not found");
  return e;
}, UU = Xe(
  function(t, n) {
    const {
      className: r,
      closeButton: o = "Lukk dialogvindu",
      onClose: i,
      open: a,
      overflowScroll: s = !0,
      backdropClose: l = !0,
      fullSize: c = !1,
      asChild: u,
      children: f,
      ...h
    } = t, p = Oe(fh), C = ke(null), m = u ? fW : "dialog", g = "div", v = Mo([p, n, C]);
    ve(() => C.current?.[a ? "showModal" : "close"](), [a]), ve(() => {
      const x = C.current, b = ({
        clientY: M,
        clientX: E,
        target: P
      }) => {
        if (!window.getSelection()?.toString() && x && P === x && l) {
          const { top: T, left: _, right: D, bottom: N } = x.getBoundingClientRect();
          T <= M && M <= N && _ <= E && E <= D || x?.close();
        }
      }, S = () => {
        const M = x?.querySelector("[autofocus]");
        document.activeElement !== M && M?.focus();
      };
      return x?.addEventListener("animationend", S), x?.addEventListener("click", b), () => {
        x?.removeEventListener("animationend", S), x?.removeEventListener("click", b);
      };
    }, [l]), ve(() => {
      const x = (b) => i?.(b);
      return C.current?.addEventListener("close", x), () => C.current?.removeEventListener("close", x);
    }, [i]), ve(() => {
      const x = new MutationObserver((b) => {
        const S = b.some(
          (M) => M.target.open
        );
        document.body.style.overflow = S ? "hidden" : "";
      });
      if (C.current)
        return x.observe(C.current, {
          attributes: !0,
          attributeFilter: ["open"]
        }), () => {
          x.disconnect(), document.body.style.overflow = "";
        };
    }, []);
    const y = c ? "w-full" : I("w-10/12 md:max-w-[600px]"), w = I(
      "min-w-[300px] rounded-modal bg-white shadow-xlarge md:min-w-[480px] [&>div>form]:absolute [&>div>form]:right-[24px] [&>div>form]:top-[29px]",
      !c && "mx-auto my-xl max-h-[80vh] p-lg md:m-auto md:my-2xl",
      s && "overflow-y-auto",
      c ? "h-full w-full rounded-none p-[18px]" : y,
      "right-[var(--removed-body-scroll-bar-size,0px)]",
      r
    );
    return /* @__PURE__ */ d(
      KA.Provider,
      {
        value: {
          closeButton: o,
          backdropClose: l,
          overflowScroll: s,
          fullSize: c,
          asChild: u
        },
        children: /* @__PURE__ */ d(m, { className: w, ref: v, ...h, children: /* @__PURE__ */ F(
          g,
          {
            className: I(
              "flex max-h-[80vh] w-full flex-col overflow-visible",
              c && "h-full max-h-full"
            ),
            children: [
              o !== !1 && /* @__PURE__ */ d("form", { method: "dialog", children: /* @__PURE__ */ d(
                Dt,
                {
                  "aria-label": o,
                  title: "Lukk",
                  variant: "nostyle",
                  type: "submit",
                  autoFocus: !0,
                  children: /* @__PURE__ */ d(
                    Wr,
                    {
                      className: "h-[20px] w-[20px]",
                      colorVariant: "primary"
                    }
                  )
                }
              ) }),
              f
            ]
          }
        ) })
      }
    );
  }
), GU = Xe(
  function({ className: t, ...n }, r) {
    const o = dh(), i = "div", a = o.fullSize, s = I(
      "mb-sm overflow-y-auto p-xs",
      a && "flex-1",
      t
    );
    return /* @__PURE__ */ d(i, { className: s, ref: r, ...n });
  }
), KU = Xe(
  function({ className: t, ...n }, r) {
    const o = "footer", a = dh().fullSize, s = I(
      "flex justify-between pt-md",
      a && "border-t-2 border-t-border-light !pb-2 !pt-lg",
      t
    );
    return /* @__PURE__ */ d(o, { className: s, ref: r, ...n });
  }
), YU = Xe(
  function({ className: t, level: n = 2, variant: r = "primary", size: o = "medium", ...i }, a) {
    const s = _1, c = dh().fullSize, u = I(
      "pb-md leading-normal",
      c && "pb-md pt-4",
      t
    );
    return /* @__PURE__ */ d(
      s,
      {
        className: u,
        level: n,
        variant: r,
        size: o,
        ref: a,
        ...i
      }
    );
  }
), XU = Xe(
  function({ ...t }, n) {
    const r = Oe(fh);
    return /* @__PURE__ */ d(
      Dt,
      {
        "aria-haspopup": "dialog",
        onClick: () => r?.current?.showModal(),
        ref: n,
        ...t
      }
    );
  }
), vr = Object.assign(UU, {
  Header: YU,
  Footer: KU,
  Block: GU,
  Context: GA,
  Trigger: XU
});
vr.displayName = "Modal";
vr.Header.displayName = "Modal.Header";
vr.Footer.displayName = "Modal.Footer";
vr.Block.displayName = "Modal.Block";
vr.Context.displayName = "Modal.Context";
vr.Trigger.displayName = "Modal.Trigger";
const QU = Xe(
  function(t, n) {
    const { children: r, className: o, ...i } = t, a = I("space-y-2", o), s = ar.count(r);
    return /* @__PURE__ */ d("div", { className: a, ref: n, ...i, children: ar.map(r, (l, c) => sr(l) ? Qt(l, {
      isFirst: c === 0,
      isLast: c === s - 1
    }) : l) });
  }
), YA = Xe(
  function({
    variant: t = "default",
    date: n,
    isFirst: r,
    isLast: o,
    children: i,
    className: a,
    ...s
  }, l) {
    const [c, u] = ue(/* @__PURE__ */ new Date()), f = I(
      "box-border rounded-md border border-border-light bg-surface-common-white px-[12px] py-1 shadow-sm",
      {
        "border-transparent bg-neutral-100": t === "neutral"
      },
      a
    );
    return ve(() => {
      const h = setInterval(() => {
        u(/* @__PURE__ */ new Date());
      }, 6e4);
      return Lg(n, c) || clearInterval(h), () => clearInterval(h);
    }, []), /* @__PURE__ */ F(
      "div",
      {
        className: "max-sm:grid max-sm:grid-cols-[14px_1fr] max-sm:gap-half",
        ...s,
        ref: l,
        children: [
          /* @__PURE__ */ F("div", { className: "flex h-full flex-col items-center pt-[2px] sm:!hidden", children: [
            /* @__PURE__ */ d(
              "span",
              {
                className: I(
                  "my-[2px] h-1 w-1 rounded-full border-2 border-border-light bg-transparent",
                  {
                    "border-surface-common-primary": r
                  }
                )
              }
            ),
            /* @__PURE__ */ d(
              "span",
              {
                className: I("-mb-2 w-[1px] flex-grow bg-border-light", {
                  "opacity-0": o
                })
              }
            )
          ] }),
          /* @__PURE__ */ F("div", { className: "grid items-center sm:grid-cols-[105px_14px_1fr] sm:gap-[12px]", children: [
            /* @__PURE__ */ F("div", { className: "flex max-sm:flex-row max-sm:gap-1 sm:flex-col sm:text-right", children: [
              /* @__PURE__ */ d(Rt, { size: "small", weight: "semibold", children: Ea(n, oh) }),
              /* @__PURE__ */ d(Rt, { size: "small", color: "subtle", children: Lg(n, c) ? "Nå" : Ea(n, BO) })
            ] }),
            /* @__PURE__ */ F("div", { className: "flex h-full flex-col items-center max-sm:!hidden", children: [
              /* @__PURE__ */ d(
                "span",
                {
                  className: I("-mt-1 w-[1px] flex-grow bg-border-light", {
                    "opacity-0": r
                  })
                }
              ),
              /* @__PURE__ */ d(
                "span",
                {
                  className: I(
                    "my-[2px] h-1 w-1 rounded-full border-2 border-border-light bg-transparent",
                    {
                      "border-surface-common-primary": r
                    }
                  )
                }
              ),
              /* @__PURE__ */ d(
                "span",
                {
                  className: I("-mb-1 w-[1px] flex-grow bg-border-light", {
                    "opacity-0": o
                  })
                }
              )
            ] }),
            /* @__PURE__ */ d("div", { className: f, children: typeof i == "string" && t === "neutral" ? /* @__PURE__ */ d(Rt, { color: "subtle", className: "italic", children: i }) : i })
          ] })
        ]
      }
    );
  }
), JU = Object.assign(QU, {
  Item: YA
});
JU.displayName = "Timeline";
YA.displayName = "TimelineItem";
const XA = gt(null), QA = () => Oe(XA), eG = ({ context: e, children: t }) => /* @__PURE__ */ d(XA.Provider, { value: e, children: t }), tG = ({
  defaultValue: e,
  overrideValue: t,
  onChange: n,
  className: r,
  tabs: o,
  content: i
}) => {
  const [a, s] = ue(
    e || ""
  );
  return ve(() => {
    t && s(t);
  }, [t]), /* @__PURE__ */ d(
    eG,
    {
      context: {
        currentActive: a,
        onChange: (c) => {
          s(c), n?.(c);
        },
        setActiveTab: s
      },
      children: /* @__PURE__ */ F(ut, { children: [
        /* @__PURE__ */ d("div", { className: I("flex flex-col mx-[0px]", r), children: /* @__PURE__ */ d("div", { className: "flex", children: o }) }),
        i
      ] })
    }
  );
}, nG = ({
  tabContent: e,
  value: t,
  headerProps: n,
  tabContainerClassName: r,
  disabled: o = !1,
  isLoading: i = !1
}) => {
  const a = QA();
  if (!a)
    throw new Error("Tab must be used within a TabGroup");
  const s = a.currentActive === t, l = () => {
    o || a.onChange(t);
  }, c = I(
    "relative box-border w-fit min-w-[120px] cursor-pointer rounded-tl-md rounded-tr-md px-lg py-md shadow transition-colors",
    s ? "z-[9] bg-surface-common-white" : "bg-[#FBFBFB] hover:bg-[#F7F7F7]",
    o && "cursor-not-allowed opacity-50",
    r
  ), u = I(
    "relative box-border w-fit min-w-[120px] rounded-tl-md rounded-tr-md shadow transition-colors"
  ), f = typeof e == "string" ? /* @__PURE__ */ d(
    _1,
    {
      level: n?.level || 3,
      ...n,
      className: I(n?.className),
      children: e
    }
  ) : e;
  return i ? /* @__PURE__ */ d(
    "div",
    {
      className: u,
      "aria-busy": "true",
      "aria-live": "polite",
      "aria-label": "Tab laster",
      children: /* @__PURE__ */ d(
        S1,
        {
          height: "100%",
          className: "min-h-8 min-w-[160px] rounded-b-[0px]"
        }
      )
    }
  ) : /* @__PURE__ */ F("div", { className: c, onClick: l, children: [
    f,
    /* @__PURE__ */ d("div", { className: "absolute bottom-[-4px] left-[0px] right-[0px] z-[9] h-[5px] w-full bg-surface-common-white" })
  ] });
}, rG = ({ value: e, children: t }) => {
  if (QA()?.currentActive === e) return /* @__PURE__ */ d("div", { children: t });
}, hh = Object.assign(tG, {
  Tab: nG,
  Content: rG
});
hh.displayName = "Tabs";
hh.Tab.displayName = "Tabs.Tab";
hh.Content.displayName = "Tabs.Content";
const JA = gt({
  total: 0,
  totalPages: 0,
  pageSize: 10,
  pageIndex: 0,
  pageOptions: [10, 25, 50],
  canGetNextPage: !1,
  canGetPreviousPage: !1,
  onPageSizeChange: void 0,
  setPageSize: () => {
  },
  setPageIndex: () => {
  }
}), Ppe = ({
  initialState: e,
  children: t
}) => {
  const [n, r] = O.useState(e?.pageSize || 10), [o, i] = O.useState(e?.pageIndex || 0), a = e?.pageOptions, s = e?.total ? Math.ceil(e?.total / n) : 0, l = o < s - 1, c = o > 0, u = {
    total: e.total || 0,
    totalPages: e.totalPages || s,
    pageSize: n,
    pageIndex: o,
    pageOptions: a || [10, 25, 50],
    canGetNextPage: l,
    canGetPreviousPage: c,
    setPageSize: r,
    setPageIndex: i
  };
  return /* @__PURE__ */ d(JA.Provider, { value: u, children: t });
}, eP = () => {
  const e = O.useContext(JA);
  if (!e)
    throw new Error(
      "usePaginationContext must be used within a PaginationProvider"
    );
  return e;
};
function oG({
  pageIndex: e,
  pageCount: t,
  handlePageChange: n
}) {
  const o = eP(), i = I(
    "flex w-full items-center justify-between rounded-md sm:border"
  ), a = I(
    "p-[8px] outline-none transition-colors duration-75 ease-in hover:bg-surface-common-subtle",
    "disabled:cursor-not-allowed disabled:opacity-50"
  ), s = (u) => {
    n(u), o.setPageIndex(u);
  };
  return /* @__PURE__ */ F("div", { className: i, children: [
    /* @__PURE__ */ d("div", { className: "hidden sm:flex", children: /* @__PURE__ */ d(() => /* @__PURE__ */ F(ut, { children: [
      /* @__PURE__ */ d(
        "button",
        {
          className: I(a),
          "aria-label": "Første side",
          onClick: () => s(0),
          disabled: !o.canGetPreviousPage,
          children: /* @__PURE__ */ d(ZA, { colorVariant: "primary" })
        }
      ),
      /* @__PURE__ */ d(
        "button",
        {
          className: I(
            a,
            "border-l border-r border-border-light"
          ),
          "aria-label": "Forrige side",
          onClick: () => s(e - 1),
          disabled: !o.canGetPreviousPage,
          children: /* @__PURE__ */ d(qr, { colorVariant: "primary" })
        }
      ),
      /* @__PURE__ */ d(
        "button",
        {
          className: I(a, "border-r border-border-light"),
          "aria-label": "Neste side",
          onClick: () => s(e + 1),
          disabled: !o.canGetNextPage,
          children: /* @__PURE__ */ d(yo, { colorVariant: "primary" })
        }
      ),
      /* @__PURE__ */ d(
        "button",
        {
          className: I(a),
          "aria-label": "Siste side",
          onClick: () => s(t - 1),
          disabled: !o.canGetNextPage,
          children: /* @__PURE__ */ d(WA, { colorVariant: "primary" })
        }
      )
    ] }), {}) }),
    /* @__PURE__ */ d("div", { className: "flex w-full items-center justify-between sm:hidden", children: /* @__PURE__ */ d(() => /* @__PURE__ */ F(ut, { children: [
      /* @__PURE__ */ d(
        "button",
        {
          className: I(a, "outline-none"),
          "aria-label": "Forrige side",
          onClick: () => s(e - 1),
          disabled: o.pageIndex === 0,
          children: /* @__PURE__ */ d(qr, { colorVariant: "primary" })
        }
      ),
      /* @__PURE__ */ d("div", { className: "flex", children: /* @__PURE__ */ F(Rt, { children: [
        "Side ",
        e + 1,
        " av ",
        t
      ] }) }),
      /* @__PURE__ */ d(
        "button",
        {
          className: I(a),
          "aria-label": "Neste side",
          onClick: () => s(e + 1),
          disabled: o.pageIndex === t - 1,
          children: /* @__PURE__ */ d(yo, { colorVariant: "primary" })
        }
      )
    ] }), {}) })
  ] });
}
function Tpe({
  onPageChange: e,
  onPageSizeChange: t
}) {
  const n = eP();
  if (!n)
    throw new Error("Pagination must be used within a PaginationProvider");
  const r = n.pageSize, o = n.pageIndex, i = n.pageOptions, a = n.totalPages, s = (c) => {
    n.setPageIndex(c), e?.(c);
  }, l = (c) => {
    n.setPageIndex(0), n.setPageSize(Number(c)), t?.(Number(c));
  };
  return /* @__PURE__ */ F("div", { className: "mt-md flex w-full items-center justify-between", children: [
    /* @__PURE__ */ F("div", { className: "hidden items-center gap-sm sm:flex", children: [
      /* @__PURE__ */ d(Ye, { children: "Rader per side" }),
      /* @__PURE__ */ d(
        xn,
        {
          clearable: !1,
          value: `${r}`,
          onValueChange: (c) => l(c),
          children: /* @__PURE__ */ d(xn.Content, { children: i.map((c) => /* @__PURE__ */ d(xn.Item, { value: c.toString(), children: c }, c)) })
        }
      )
    ] }),
    /* @__PURE__ */ d("div", { className: "hidden sm:flex", children: /* @__PURE__ */ F(Ye, { children: [
      "Side ",
      o + 1,
      " av ",
      a
    ] }) }),
    /* @__PURE__ */ d("div", { className: "flex w-full gap-md sm:w-fit", children: /* @__PURE__ */ d(
      oG,
      {
        handlePageChange: s,
        pageIndex: o,
        pageCount: a
      }
    ) })
  ] });
}
const Ipe = ({
  icon: e,
  onClick: t,
  label: n,
  ...r
}) => {
  const { small: o } = r, i = QL("!px-[11px]", o && "!px-[6px]", r.className);
  return /* @__PURE__ */ d(
    Dt,
    {
      onClick: t,
      title: n,
      "aria-label": n,
      className: i,
      ...r,
      children: !r.loading && e
    }
  );
}, iG = ({ dark: e, className: t, children: n }) => /* @__PURE__ */ d(
  "div",
  {
    role: "banner",
    className: I(
      "relative box-border grid w-full grid-cols-1 items-center justify-between gap-[10px] p-[24px] md:grid-cols-[repeat(auto-fit,minmax(0,1fr))] md:px-[32px]",
      e ? "bg-surface-portalen-aside-background" : "bg-surface-common-white",
      t
    ),
    children: n
  }
), aG = ({ children: e, className: t }) => /* @__PURE__ */ d("div", { className: I(t), children: e }), tP = Object.assign(iG, {
  Slot: aG
});
tP.displayName = "TopBar";
tP.Slot.displayName = "TopBar.Slot";
const R2 = (e) => {
  ve(() => {
    const t = document.getElementsByTagName("dialog");
    if (!t?.length) return;
    const n = t[0];
    return n.style.overflow = e ? "visible" : "hidden", () => {
      n.style.overflow = "hidden";
    };
  }, [e]);
}, nP = O.createContext(null);
function sG({
  initialOpen: e = !1,
  placement: t = "bottom",
  listRef: n = null,
  labelsRef: r = null,
  modal: o,
  autoSize: i,
  open: a,
  onOpenChange: s,
  typeaheadEnabled: l = !0,
  disabled: c
} = {}) {
  const [u, f] = ue(e), [h, p] = ue(), [C, m] = ue(!1), [g, v] = ue(null), y = O.useRef([]), w = O.useRef([]), x = a ?? u, b = s ?? f, S = Ri({
    placement: t,
    open: x,
    onOpenChange: b,
    whileElementsMounted: D1,
    middleware: [
      Ti(7),
      Ii({
        crossAxis: t.includes("-"),
        fallbackAxisSideDirection: "end",
        padding: 5
      }),
      L_({ padding: 5 }),
      i && N_({
        apply({ rects: R, elements: L }) {
          requestAnimationFrame(() => {
            Object.assign(L.floating.style, {
              // reference width - padding of the floating element
              width: `calc(${R.reference.width}px - 16px)`,
              maxHeight: "250px"
            });
          });
        }
      })
    ]
  }), M = S.context, E = Pu(M, {
    enabled: a == null
  }), P = Di(M), T = Li(M, {
    role: "menu"
  }), _ = Hd(M, {
    listRef: r ?? w,
    activeIndex: g,
    onMatch: v,
    enabled: l
  }), D = Iu(M, {
    listRef: n ?? y,
    activeIndex: g,
    onNavigate: v
  }), N = ki([
    E,
    P,
    T,
    D,
    _
  ]);
  return O.useMemo(
    () => ({
      open: x,
      setOpen: b,
      disabled: c,
      ...N,
      ...S,
      modal: o,
      labelId: h,
      listRef: n,
      hasCloseButton: C,
      activeIndex: g,
      setActiveIndex: v,
      setLabelId: p,
      setHasCloseButton: m
    }),
    [
      x,
      b,
      c,
      N,
      n,
      S,
      o,
      g,
      h,
      C
    ]
  );
}
function lG({
  children: e,
  labelsRef: t,
  modal: n = !1,
  autoSize: r = !1,
  ...o
}) {
  const i = O.useRef([]), a = sG({
    modal: n,
    listRef: i,
    labelsRef: t ?? null,
    autoSize: r,
    ...o
  });
  return R2(a.open), /* @__PURE__ */ d(nP.Provider, { value: a, children: e });
}
const Xn = () => O.useContext(nP), cG = O.forwardRef(function(t, n) {
  const r = Xn();
  if (!r)
    throw new Error("PopoverClose must be used within a Popover component");
  const { setOpen: o, setHasCloseButton: i } = r;
  return O.useEffect(() => (i(!0), () => i(!1)), [i]), /* @__PURE__ */ d("div", { className: "absolute right-[10px] flex justify-end text-surface-common-primary-light", children: /* @__PURE__ */ d(
    Dt,
    {
      type: "button",
      variant: "nostyle",
      className: "text-surface-common-primary-light",
      ref: n,
      onClick: (a) => {
        t.onClick?.(a), o(!1);
      },
      children: /* @__PURE__ */ d(Wr, {})
    }
  ) });
}), rP = O.forwardRef(function({ style: t, className: n, ...r }, o) {
  const i = Xn();
  if (!i)
    throw new Error("PopoverContent must be used within a Popover component");
  const { context: a } = i, s = Mo([i.refs.setFloating, o]), l = I(
    "rounded-card border-none bg-white p-md shadow-card outline-none",
    "border border-gray-200",
    "z-[9999]",
    "overflow-y-auto overflow-x-hidden",
    n
  );
  return a.open ? /* @__PURE__ */ d(ms, { context: a, modal: i.modal, children: /* @__PURE__ */ F(ut, { children: [
    r.withPortal && /* @__PURE__ */ d(JF, { id: "floating-node", children: /* @__PURE__ */ d(
      "div",
      {
        className: l,
        ref: s,
        style: { ...i.floatingStyles, ...t },
        "aria-labelledby": i.labelId,
        ...i.getFloatingProps(r),
        children: r.children
      }
    ) }),
    !r.withPortal && /* @__PURE__ */ d(
      "div",
      {
        className: l,
        ref: s,
        style: { ...i.floatingStyles, ...t },
        "aria-labelledby": i.labelId,
        ...i.getFloatingProps(r),
        children: r.children
      }
    )
  ] }) }) : null;
}), uG = O.forwardRef(function({ size: t = "small", level: n = 2, ...r }, o) {
  const i = Xn();
  if (!i)
    throw new Error("PopoverHeading must be used within a Popover component");
  const { setLabelId: a, hasCloseButton: s } = i, l = bt();
  return O.useLayoutEffect(() => (a(l), () => a(void 0)), [l, a]), /* @__PURE__ */ d(
    _1,
    {
      level: n,
      size: t,
      className: I(s && "mr-lg"),
      ...bi(["size", "level"], r),
      ref: o,
      id: l,
      children: r.children
    }
  );
}), oP = O.forwardRef(function({ children: t, asChild: n = !1, disabled: r, ...o }, i) {
  const a = Xn(), s = t.ref;
  if (!a)
    throw new Error("PopoverTrigger must be used within a Popover component");
  const l = Mo([a.refs.setReference, i, s]);
  return n && O.isValidElement(t) ? O.cloneElement(
    t,
    a.getReferenceProps({
      ref: l,
      ...o,
      // @ts-expect-error: disable-next-line
      ...t.props,
      "data-state": a.open ? "open" : "closed"
    })
  ) : /* @__PURE__ */ d(
    "button",
    {
      ref: l,
      type: "button",
      disabled: r,
      className: "cursor-pointer",
      "data-state": a.open ? "open" : "closed",
      ...a.getReferenceProps(o),
      children: t
    }
  );
}), Mn = Object.assign(lG, {
  Close: cG,
  Heading: uG,
  Content: rP,
  Trigger: oP
});
Mn.Close.displayName = "Popover.Close";
Mn.Heading.displayName = "Popover.Heading";
Mn.Content.displayName = "Popover.Content";
Mn.Trigger.displayName = "Popover.Trigger";
const iP = O.createContext({}), fG = iP.Provider, ju = () => {
  const e = O.useContext(iP);
  if (!e)
    throw new Error(
      "useRelationPickerContext must be used within a RelationPickerProvider"
    );
  return e;
}, dG = () => {
  const e = ju(), t = Xn(), n = bt();
  if (!t)
    throw new Error(
      "RelationPickerTrigger must be used within a Popover component"
    );
  if (!e)
    throw new Error(
      "RelationPickerTrigger must be used within a RelationPicker component"
    );
  const { dark: r, withClientNo: o, icon: i } = e, { open: a, disabled: s } = t, l = I(
    "flex items-center justify-between gap-[8px] rounded-lg bg-surface-common-white px-[11px] py-[6px] transition-all duration-75 ease-in-out",
    "group-hover:cursor-pointer",
    "hover:bg-surface-common-light",
    e.dark && "bg-surface-portalen-aside-highlight hover:bg-surface-portalen-aside-background"
  ), c = e?.currentClient, u = o ? `${c?.no} - ${c?.name}` : c?.name;
  return /* @__PURE__ */ d(
    Mn.Trigger,
    {
      className: "w-full min-w-[100px] max-w-full rounded-lg md:max-w-[250px] lg:max-w-[300px]",
      id: n,
      "aria-label": "pick company",
      disabled: e?.disabled,
      children: /* @__PURE__ */ F("div", { className: l, children: [
        /* @__PURE__ */ F("div", { className: "flex items-center gap-sm", children: [
          i && O.cloneElement(i, {
            // @ts-expect-error: disable-next-line
            colorVariant: "primary",
            className: I(r && "text-surface-common-primary-light")
          }),
          /* @__PURE__ */ d(
            Ut,
            {
              weight: "semibold",
              className: I(
                "cursor-pointer truncate !text-[14px] text-text-brand md:max-w-[20ch] lg:max-w-[30ch]",
                e.dark && "text-text-invert"
              ),
              children: u
            }
          )
        ] }),
        /* @__PURE__ */ d(
          Gr,
          {
            flipVertical: a,
            accessibilityLabel: a ? "arrow up" : "arrow down",
            className: I(
              "text-text-brand",
              s && "text-neutral-500",
              e.dark && "text-text-invert"
            ),
            "aria-hidden": "true"
          }
        )
      ] })
    }
  );
}, hG = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M9.55002 15.15L18.025 6.675C18.225 6.475 18.4584 6.375 18.725 6.375C18.9917 6.375 19.225 6.475 19.425 6.675C19.625 6.875 19.725 7.1125 19.725 7.3875C19.725 7.6625 19.625 7.9 19.425 8.1L10.25 17.3C10.05 17.5 9.81669 17.6 9.55002 17.6C9.28336 17.6 9.05002 17.5 8.85002 17.3L4.55002 13C4.35002 12.8 4.25419 12.5625 4.26252 12.2875C4.27086 12.0125 4.37502 11.775 4.57502 11.575C4.77502 11.375 5.01252 11.275 5.28752 11.275C5.56252 11.275 5.80002 11.375 6.00002 11.575L9.55002 15.15Z",
    fill: "currentColor"
  }
) }), k2 = Q("IconCheckmark")(hG), pG = ({
  client: e
}) => {
  const t = ju(), n = Xn();
  if (!n)
    throw new Error(
      "RelationPickerOption must be used within a RelationPicker component"
    );
  if (!t)
    throw new Error(
      "RelationPickerOption must be used within a RelationPicker component"
    );
  const { currentClient: r, onSelect: o, withClientNo: i } = t, a = r?.id === e.id, s = () => {
    o?.(e), n.setOpen(!1);
  }, { ref: l, index: c } = A2({ label: e.name }), { activeIndex: u } = n, f = u === c, h = i ? `${e.no} - ${e.name}` : e.name || e.no;
  return /* @__PURE__ */ d("li", { role: "menuitem", children: /* @__PURE__ */ d(
    "button",
    {
      ref: l,
      title: e.name,
      "aria-current": a,
      "aria-label": "pick company",
      tabIndex: f ? 0 : -1,
      className: I(
        "ring-none my-[1px] h-[39px] w-full cursor-pointer items-center justify-between gap-sm rounded-md border-none p-sm outline-none hover:bg-surface-common-light",
        "line-clamp-1 text-start focus:bg-surface-common-light focus:ring-surface-common-primary-light",
        a && "bg-surface-common-light font-semibold",
        f && "bg-surface-common-light"
      ),
      onClick: s,
      children: /* @__PURE__ */ F("span", { className: "flex w-full items-center justify-between", children: [
        /* @__PURE__ */ d("p", { className: "max-w-[35ch] truncate", children: h }),
        a && /* @__PURE__ */ d(k2, { className: "text-surface-common-primary" })
      ] })
    },
    e.id
  ) });
}, mG = () => {
  const e = Xn(), t = ju();
  if (!e)
    throw new Error(
      "RelationPickerList must be used within a RelationPicker component"
    );
  const n = e.listRef, r = _e(
    () => t.filteredClients?.findIndex(
      (o) => o.id === t.currentClient?.id
    ) ?? -1,
    [t.currentClient?.id, t.filteredClients]
  );
  return ve(() => {
    e.setActiveIndex(r);
  }, [r]), /* @__PURE__ */ d(O2, { elementsRef: n, children: /* @__PURE__ */ d("ul", { role: "menu", children: t.filteredClients?.map((o) => /* @__PURE__ */ d(pG, { client: o }, o.id)) }) });
}, Dpe = (e) => {
  if (!e) return "Ikke angitt";
  if (e.length === 13)
    return e;
  const t = e.substring(0, 4), n = e.substring(4, 6), r = e.substring(6, 11);
  return [t, n, r].join(".");
}, Rpe = (e, t = !0) => {
  if (!e) return !t;
  const n = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2], r = e.replace(/[\s.]+/g, "");
  if (r.length !== 11)
    return !1;
  {
    const o = parseInt(
      r.charAt(10),
      10
    ), i = r.substring(0, 10);
    let a = 0;
    for (let l = 0; l < 10; l++)
      a += parseInt(i.charAt(l), 10) * n[l];
    const s = a % 11;
    return o === (s === 0 ? 0 : 11 - s);
  }
}, kpe = (e, t) => {
  if (e.length <= t) return e;
  const n = [];
  for (let r = 0; r < t; r++)
    n.push(e[r]);
  return n;
};
function Lpe(e, ...t) {
  return (n) => {
    if (!e) return !0;
    const r = e.toLowerCase().trim();
    return t.some((o) => {
      const i = n[o];
      return typeof i == "string" ? i.toLowerCase().includes(r) : !1;
    });
  };
}
const Npe = (e, t, n = 9) => Array.from(
  { length: Math.ceil(Math.min(e.length, n) / t) },
  (r, o) => e.slice(o * t, o * t + t)
), Dl = [
  {
    name: "Afghanistan",
    flag: "🇦🇫",
    code: "AF",
    dial_code: "+93",
    alpha3: "AFG"
  },
  { name: "Åland", flag: "🇦🇽", code: "AX", dial_code: "+358", alpha3: "ALA" },
  { name: "Albania", flag: "🇦🇱", code: "AL", dial_code: "+355", alpha3: "ALB" },
  { name: "Algerie", flag: "🇩🇿", code: "DZ", dial_code: "+213", alpha3: "DZA" },
  {
    name: "Amerikansk Samoa",
    flag: "🇦🇸",
    code: "AS",
    dial_code: "+1684",
    alpha3: "ASM"
  },
  { name: "Andorra", flag: "🇦🇩", code: "AD", dial_code: "+376", alpha3: "AND" },
  { name: "Angola", flag: "🇦🇴", code: "AO", dial_code: "+244", alpha3: "AGO" },
  {
    name: "Anguilla",
    flag: "🇦🇮",
    code: "AI",
    dial_code: "+1264",
    alpha3: "AIA"
  },
  {
    name: "Antarktis",
    flag: "🇦🇶",
    code: "AQ",
    dial_code: "+672",
    alpha3: "ATA"
  },
  {
    name: "Antigua og Barbuda",
    flag: "🇦🇬",
    code: "AG",
    dial_code: "+1268",
    alpha3: "ATG"
  },
  {
    name: "Argentina",
    flag: "🇦🇷",
    code: "AR",
    dial_code: "+54",
    alpha3: "ARG"
  },
  { name: "Armenia", flag: "🇦🇲", code: "AM", dial_code: "+374", alpha3: "ARM" },
  { name: "Aruba", flag: "🇦🇼", code: "AW", dial_code: "+297", alpha3: "ABW" },
  {
    name: "Australia",
    flag: "🇦🇺",
    code: "AU",
    dial_code: "+61",
    alpha3: "AUS"
  },
  {
    name: "Østerrike",
    flag: "🇦🇹",
    code: "AT",
    dial_code: "+43",
    alpha3: "AUT"
  },
  {
    name: "Aserbajdsjan",
    flag: "🇦🇿",
    code: "AZ",
    dial_code: "+994",
    alpha3: "AZE"
  },
  {
    name: "Bahamas",
    flag: "🇧🇸",
    code: "BS",
    dial_code: "+1242",
    alpha3: "BHS"
  },
  { name: "Bahrain", flag: "🇧🇭", code: "BH", dial_code: "+973", alpha3: "BHR" },
  {
    name: "Bangladesh",
    flag: "🇧🇩",
    code: "BD",
    dial_code: "+880",
    alpha3: "BGD"
  },
  {
    name: "Barbados",
    flag: "🇧🇧",
    code: "BB",
    dial_code: "+1246",
    alpha3: "BRB"
  },
  {
    name: "Hviterussland",
    flag: "🇧🇾",
    code: "BY",
    dial_code: "+375",
    alpha3: "BLR"
  },
  { name: "Belgia", flag: "🇧🇪", code: "BE", dial_code: "+32", alpha3: "BEL" },
  { name: "Belize", flag: "🇧🇿", code: "BZ", dial_code: "+501", alpha3: "BLZ" },
  { name: "Benin", flag: "🇧🇯", code: "BJ", dial_code: "+229", alpha3: "BEN" },
  {
    name: "Bermuda",
    flag: "🇧🇲",
    code: "BM",
    dial_code: "+1441",
    alpha3: "BMU"
  },
  { name: "Bhutan", flag: "🇧🇹", code: "BT", dial_code: "+975", alpha3: "BTN" },
  { name: "Bolivia", flag: "🇧🇴", code: "BO", dial_code: "+591", alpha3: "BOL" },
  {
    name: "Bosnia og Hercegovina",
    flag: "🇧🇦",
    code: "BA",
    dial_code: "+387",
    alpha3: "BIH"
  },
  {
    name: "Botswana",
    flag: "🇧🇼",
    code: "BW",
    dial_code: "+267",
    alpha3: "BWA"
  },
  { name: "Brasil", flag: "🇧🇷", code: "BR", dial_code: "+55", alpha3: "BRA" },
  {
    name: "Britisk territorium i Indiahavet",
    flag: "🇮🇴",
    code: "IO",
    dial_code: "+246",
    alpha3: "IOT"
  },
  { name: "Brunei", flag: "🇧🇳", code: "BN", dial_code: "+673", alpha3: "BRN" },
  {
    name: "Bulgaria",
    flag: "🇧🇬",
    code: "BG",
    dial_code: "+359",
    alpha3: "BGR"
  },
  {
    name: "Burkina Faso",
    flag: "🇧🇫",
    code: "BF",
    dial_code: "+226",
    alpha3: "BFA"
  },
  { name: "Burundi", flag: "🇧🇮", code: "BI", dial_code: "+257", alpha3: "BDI" },
  {
    name: "Kambodsja",
    flag: "🇰🇭",
    code: "KH",
    dial_code: "+855",
    alpha3: "KHM"
  },
  { name: "Kamerun", flag: "🇨🇲", code: "CM", dial_code: "+237", alpha3: "CMR" },
  { name: "Canada", flag: "🇨🇦", code: "CA", dial_code: "+1", alpha3: "CAN" },
  {
    name: "Kapp Verde",
    flag: "🇨🇻",
    code: "CV",
    dial_code: "+238",
    alpha3: "CPV"
  },
  {
    name: "Caymanøyene",
    flag: "🇰🇾",
    code: "KY",
    dial_code: "+345",
    alpha3: "CYM"
  },
  {
    name: "Den sentralafrikanske republikk",
    flag: "🇨🇫",
    code: "CF",
    dial_code: "+236",
    alpha3: "CAF"
  },
  { name: "Tsjad", flag: "🇹🇩", code: "TD", dial_code: "+235", alpha3: "TCD" },
  { name: "Chile", flag: "🇨🇱", code: "CL", dial_code: "+56", alpha3: "CHL" },
  { name: "Kina", flag: "🇨🇳", code: "CN", dial_code: "+86", alpha3: "CHN" },
  {
    name: "Christmasøya",
    flag: "🇨🇽",
    code: "CX",
    dial_code: "+61",
    alpha3: "CXR"
  },
  {
    name: "Cocosøyene",
    flag: "🇨🇨",
    code: "CC",
    dial_code: "+61",
    alpha3: "CCK"
  },
  { name: "Colombia", flag: "🇨🇴", code: "CO", dial_code: "+57", alpha3: "COL" },
  {
    name: "Komorene",
    flag: "🇰🇲",
    code: "KM",
    dial_code: "+269",
    alpha3: "COM"
  },
  { name: "Kongo", flag: "🇨🇬", code: "CG", dial_code: "+242", alpha3: "COG" },
  {
    name: "Den demokratiske republikken Kongo",
    flag: "🇨🇩",
    code: "CD",
    dial_code: "+243",
    alpha3: "COD"
  },
  {
    name: "Cookøyene",
    flag: "🇨🇰",
    code: "CK",
    dial_code: "+682",
    alpha3: "COK"
  },
  {
    name: "Costa Rica",
    flag: "🇨🇷",
    code: "CR",
    dial_code: "+506",
    alpha3: "CRI"
  },
  {
    name: "Elfenbenskysten",
    flag: "🇨🇮",
    code: "CI",
    dial_code: "+225",
    alpha3: "CIV"
  },
  { name: "Kroatia", flag: "🇭🇷", code: "HR", dial_code: "+385", alpha3: "HRV" },
  { name: "Cuba", flag: "🇨🇺", code: "CU", dial_code: "+53", alpha3: "CUB" },
  { name: "Kypros", flag: "🇨🇾", code: "CY", dial_code: "+357", alpha3: "CYP" },
  {
    name: "Tsjekkia",
    flag: "🇨🇿",
    code: "CZ",
    dial_code: "+420",
    alpha3: "CZE"
  },
  { name: "Danmark", flag: "🇩🇰", code: "DK", dial_code: "+45", alpha3: "DNK" },
  {
    name: "Djibouti",
    flag: "🇩🇯",
    code: "DJ",
    dial_code: "+253",
    alpha3: "DJI"
  },
  {
    name: "Dominica",
    flag: "🇩🇲",
    code: "DM",
    dial_code: "+1767",
    alpha3: "DMA"
  },
  {
    name: "Den dominikanske republikk",
    flag: "🇩🇴",
    code: "DO",
    dial_code: "+1849",
    alpha3: "DOM"
  },
  { name: "Ecuador", flag: "🇪🇨", code: "EC", dial_code: "+593", alpha3: "ECU" },
  { name: "Egypt", flag: "🇪🇬", code: "EG", dial_code: "+20", alpha3: "EGY" },
  {
    name: "El Salvador",
    flag: "🇸🇻",
    code: "SV",
    dial_code: "+503",
    alpha3: "SLV"
  },
  {
    name: "Ekvatorial-Guinea",
    flag: "🇬🇶",
    code: "GQ",
    dial_code: "+240",
    alpha3: "GNQ"
  },
  { name: "Eritrea", flag: "🇪🇷", code: "ER", dial_code: "+291", alpha3: "ERI" },
  { name: "Estland", flag: "🇪🇪", code: "EE", dial_code: "+372", alpha3: "EST" },
  { name: "Etiopia", flag: "🇪🇹", code: "ET", dial_code: "+251", alpha3: "ETH" },
  {
    name: "Falklandsøyene (Malvinas)",
    flag: "🇫🇰",
    code: "FK",
    dial_code: "+500",
    alpha3: "FLK"
  },
  { name: "Fiji", flag: "🇫🇯", code: "FJ", dial_code: "+679", alpha3: "FJI" },
  { name: "Finland", flag: "🇫🇮", code: "FI", dial_code: "+358", alpha3: "FIN" },
  {
    name: "Frankrike",
    flag: "🇫🇷",
    code: "FR",
    dial_code: "+33",
    alpha3: "FRA"
  },
  {
    name: "Fransk Guyana",
    flag: "🇬🇫",
    code: "GF",
    dial_code: "+594",
    alpha3: "GUF"
  },
  {
    name: "Fransk Polynesia",
    flag: "🇵🇫",
    code: "PF",
    dial_code: "+689",
    alpha3: "PYF"
  },
  {
    name: "Franske Sørlige Og Antarktiske Områder",
    flag: "🇹🇫",
    code: "TF",
    dial_code: "+262",
    alpha3: "ATF"
  },
  { name: "Gabon", flag: "🇬🇦", code: "GA", dial_code: "+241", alpha3: "GAB" },
  { name: "Gambia", flag: "🇬🇲", code: "GM", dial_code: "+220", alpha3: "GMB" },
  { name: "Georgia", flag: "🇬🇪", code: "GE", dial_code: "+995", alpha3: "GEO" },
  { name: "Tyskland", flag: "🇩🇪", code: "DE", dial_code: "+49", alpha3: "DEU" },
  { name: "Ghana", flag: "🇬🇭", code: "GH", dial_code: "+233", alpha3: "GHA" },
  {
    name: "Gibraltar",
    flag: "🇬🇮",
    code: "GI",
    dial_code: "+350",
    alpha3: "GIB"
  },
  { name: "Hellas", flag: "🇬🇷", code: "GR", dial_code: "+30", alpha3: "GRC" },
  {
    name: "Grønland",
    flag: "🇬🇱",
    code: "GL",
    dial_code: "+299",
    alpha3: "GRL"
  },
  {
    name: "Grenada",
    flag: "🇬🇩",
    code: "GD",
    dial_code: "+1473",
    alpha3: "GRD"
  },
  {
    name: "Guadeloupe",
    flag: "🇬🇵",
    code: "GP",
    dial_code: "+590",
    alpha3: "GLP"
  },
  { name: "Guam", flag: "🇬🇺", code: "GU", dial_code: "+1671", alpha3: "GUM" },
  {
    name: "Guatemala",
    flag: "🇬🇹",
    code: "GT",
    dial_code: "+502",
    alpha3: "GTM"
  },
  { name: "Guernsey", flag: "🇬🇬", code: "GG", dial_code: "+44", alpha3: "GGY" },
  { name: "Guinea", flag: "🇬🇳", code: "GN", dial_code: "+224", alpha3: "GIN" },
  {
    name: "Guinea-Bissau",
    flag: "🇬🇼",
    code: "GW",
    dial_code: "+245",
    alpha3: "GNB"
  },
  { name: "Guyana", flag: "🇬🇾", code: "GY", dial_code: "+592", alpha3: "GUY" },
  { name: "Haiti", flag: "🇭🇹", code: "HT", dial_code: "+509", alpha3: "HTI" },
  {
    name: "Heardøya Og Mcdonaldøyene",
    flag: "🇭🇲",
    code: "HM",
    dial_code: "+672",
    alpha3: "HMD"
  },
  {
    name: "Honduras",
    flag: "🇭🇳",
    code: "HN",
    dial_code: "+504",
    alpha3: "HND"
  },
  {
    name: "Hongkong",
    flag: "🇭🇰",
    code: "HK",
    dial_code: "+852",
    alpha3: "HKG"
  },
  { name: "Ungarn", flag: "🇭🇺", code: "HU", dial_code: "+36", alpha3: "HUN" },
  { name: "Island", flag: "🇮🇸", code: "IS", dial_code: "+354", alpha3: "ISL" },
  { name: "India", flag: "🇮🇳", code: "IN", dial_code: "+91", alpha3: "IND" },
  {
    name: "Indonesia",
    flag: "🇮🇩",
    code: "ID",
    dial_code: "+62",
    alpha3: "IDN"
  },
  { name: "Iran", flag: "🇮🇷", code: "IR", dial_code: "+98", alpha3: "IRN" },
  { name: "Irak", flag: "🇮🇶", code: "IQ", dial_code: "+964", alpha3: "IRQ" },
  { name: "Irland", flag: "🇮🇪", code: "IE", dial_code: "+353", alpha3: "IRL" },
  { name: "Man", flag: "🇮🇲", code: "IM", dial_code: "+44", alpha3: "IMN" },
  { name: "Israel", flag: "🇮🇱", code: "IL", dial_code: "+972", alpha3: "ISR" },
  { name: "Italia", flag: "🇮🇹", code: "IT", dial_code: "+39", alpha3: "ITA" },
  {
    name: "Jamaica",
    flag: "🇯🇲",
    code: "JM",
    dial_code: "+1876",
    alpha3: "JAM"
  },
  { name: "Japan", flag: "🇯🇵", code: "JP", dial_code: "+81", alpha3: "JPN" },
  { name: "Jersey", flag: "🇯🇪", code: "JE", dial_code: "+44", alpha3: "JEY" },
  { name: "Jordan", flag: "🇯🇴", code: "JO", dial_code: "+962", alpha3: "JOR" },
  {
    name: "Kasakhstan",
    flag: "🇰🇿",
    code: "KZ",
    dial_code: "+7",
    alpha3: "KAZ"
  },
  { name: "Kenya", flag: "🇰🇪", code: "KE", dial_code: "+254", alpha3: "KEN" },
  {
    name: "Kiribati",
    flag: "🇰🇮",
    code: "KI",
    dial_code: "+686",
    alpha3: "KIR"
  },
  {
    name: "Nord-Korea",
    flag: "🇰🇵",
    code: "KP",
    dial_code: "+850",
    alpha3: "PRK"
  },
  {
    name: "Sør-Korea",
    flag: "🇰🇷",
    code: "KR",
    dial_code: "+82",
    alpha3: "KOR"
  },
  { name: "Kuwait", flag: "🇰🇼", code: "KW", dial_code: "+965", alpha3: "KWT" },
  {
    name: "Kirgisistan",
    flag: "🇰🇬",
    code: "KG",
    dial_code: "+996",
    alpha3: "KGZ"
  },
  { name: "Laos", flag: "🇱🇦", code: "LA", dial_code: "+856", alpha3: "LAO" },
  { name: "Latvia", flag: "🇱🇻", code: "LV", dial_code: "+371", alpha3: "LVA" },
  { name: "Libanon", flag: "🇱🇧", code: "LB", dial_code: "+961", alpha3: "LBN" },
  { name: "Lesotho", flag: "🇱🇸", code: "LS", dial_code: "+266", alpha3: "LSO" },
  { name: "Liberia", flag: "🇱🇷", code: "LR", dial_code: "+231", alpha3: "LBR" },
  { name: "Libya", flag: "🇱🇾", code: "LY", dial_code: "+218", alpha3: "LBY" },
  {
    name: "Liechtenstein",
    flag: "🇱🇮",
    code: "LI",
    dial_code: "+423",
    alpha3: "LIE"
  },
  { name: "Litauen", flag: "🇱🇹", code: "LT", dial_code: "+370", alpha3: "LTU" },
  {
    name: "Luxembourg",
    flag: "🇱🇺",
    code: "LU",
    dial_code: "+352",
    alpha3: "LUX"
  },
  { name: "Macao", flag: "🇲🇴", code: "MO", dial_code: "+853", alpha3: "MAC" },
  {
    name: "Makedonia",
    flag: "🇲🇰",
    code: "MK",
    dial_code: "+389",
    alpha3: "MKD"
  },
  {
    name: "Madagaskar",
    flag: "🇲🇬",
    code: "MG",
    dial_code: "+261",
    alpha3: "MDG"
  },
  { name: "Malawi", flag: "🇲🇼", code: "MW", dial_code: "+265", alpha3: "MWI" },
  { name: "Malaysia", flag: "🇲🇾", code: "MY", dial_code: "+60", alpha3: "MYS" },
  {
    name: "Maldivene",
    flag: "🇲🇻",
    code: "MV",
    dial_code: "+960",
    alpha3: "MDV"
  },
  { name: "Mali", flag: "🇲🇱", code: "ML", dial_code: "+223", alpha3: "MLI" },
  { name: "Malta", flag: "🇲🇹", code: "MT", dial_code: "+356", alpha3: "MLT" },
  {
    name: "Marshalløyene",
    flag: "🇲🇭",
    code: "MH",
    dial_code: "+692",
    alpha3: "MHL"
  },
  {
    name: "Martinique",
    flag: "🇲🇶",
    code: "MQ",
    dial_code: "+596",
    alpha3: "MTQ"
  },
  {
    name: "Mauritania",
    flag: "🇲🇷",
    code: "MR",
    dial_code: "+222",
    alpha3: "MRT"
  },
  {
    name: "Mauritius",
    flag: "🇲🇺",
    code: "MU",
    dial_code: "+230",
    alpha3: "MUS"
  },
  { name: "Mayotte", flag: "🇾🇹", code: "YT", dial_code: "+262", alpha3: "MYT" },
  { name: "Mexico", flag: "🇲🇽", code: "MX", dial_code: "+52", alpha3: "MEX" },
  {
    name: "Mikronesia",
    flag: "🇫🇲",
    code: "FM",
    dial_code: "+691",
    alpha3: "FSM"
  },
  { name: "Moldova", flag: "🇲🇩", code: "MD", dial_code: "+373", alpha3: "MDA" },
  { name: "Monaco", flag: "🇲🇨", code: "MC", dial_code: "+377", alpha3: "MCO" },
  {
    name: "Mongolia",
    flag: "🇲🇳",
    code: "MN",
    dial_code: "+976",
    alpha3: "MNG"
  },
  {
    name: "Montenegro",
    flag: "🇲🇪",
    code: "ME",
    dial_code: "+382",
    alpha3: "MNE"
  },
  {
    name: "Montserrat",
    flag: "🇲🇸",
    code: "MS",
    dial_code: "+1664",
    alpha3: "MSR"
  },
  { name: "Marokko", flag: "🇲🇦", code: "MA", dial_code: "+212", alpha3: "MAR" },
  {
    name: "Mosambik",
    flag: "🇲🇿",
    code: "MZ",
    dial_code: "+258",
    alpha3: "MOZ"
  },
  { name: "Myanmar", flag: "🇲🇲", code: "MM", dial_code: "+95", alpha3: "MMR" },
  { name: "Namibia", flag: "🇳🇦", code: "NA", dial_code: "+264", alpha3: "NAM" },
  { name: "Nauru", flag: "🇳🇷", code: "NR", dial_code: "+674", alpha3: "NRU" },
  { name: "Nepal", flag: "🇳🇵", code: "NP", dial_code: "+977", alpha3: "NPL" },
  {
    name: "Nederland",
    flag: "🇳🇱",
    code: "NL",
    dial_code: "+31",
    alpha3: "NLD"
  },
  {
    name: "Ny-Caledonia",
    flag: "🇳🇨",
    code: "NC",
    dial_code: "+687",
    alpha3: "NCL"
  },
  {
    name: "New Zealand",
    flag: "🇳🇿",
    code: "NZ",
    dial_code: "+64",
    alpha3: "NZL"
  },
  {
    name: "Nicaragua",
    flag: "🇳🇮",
    code: "NI",
    dial_code: "+505",
    alpha3: "NIC"
  },
  { name: "Niger", flag: "🇳🇪", code: "NE", dial_code: "+227", alpha3: "NER" },
  { name: "Nigeria", flag: "🇳🇬", code: "NG", dial_code: "+234", alpha3: "NGA" },
  { name: "Niue", flag: "🇳🇺", code: "NU", dial_code: "+683", alpha3: "NIU" },
  {
    name: "Norfolkøyene",
    flag: "🇳🇫",
    code: "NF",
    dial_code: "+672",
    alpha3: "NFK"
  },
  {
    name: "Nord-Marianene",
    flag: "🇲🇵",
    code: "MP",
    dial_code: "+1670",
    alpha3: "MNP"
  },
  { name: "Norge", flag: "🇳🇴", code: "NO", dial_code: "+47", alpha3: "NOR" },
  { name: "Oman", flag: "🇴🇲", code: "OM", dial_code: "+968", alpha3: "OMN" },
  { name: "Pakistan", flag: "🇵🇰", code: "PK", dial_code: "+92", alpha3: "PAK" },
  { name: "Palau", flag: "🇵🇼", code: "PW", dial_code: "+680", alpha3: "PLW" },
  {
    name: "Palestinsk territorium",
    flag: "🇵🇸",
    code: "PS",
    dial_code: "+970",
    alpha3: "PSE"
  },
  { name: "Panama", flag: "🇵🇦", code: "PA", dial_code: "+507", alpha3: "PAN" },
  {
    name: "Papua Ny-Guinea",
    flag: "🇵🇬",
    code: "PG",
    dial_code: "+675",
    alpha3: "PNG"
  },
  {
    name: "Paraguay",
    flag: "🇵🇾",
    code: "PY",
    dial_code: "+595",
    alpha3: "PRY"
  },
  { name: "Peru", flag: "🇵🇪", code: "PE", dial_code: "+51", alpha3: "PER" },
  {
    name: "Filippinene",
    flag: "🇵🇭",
    code: "PH",
    dial_code: "+63",
    alpha3: "PHL"
  },
  {
    name: "Pitcairnøyene",
    flag: "🇵🇳",
    code: "PN",
    dial_code: "+64",
    alpha3: "PCN"
  },
  { name: "Polen", flag: "🇵🇱", code: "PL", dial_code: "+48", alpha3: "POL" },
  {
    name: "Portugal",
    flag: "🇵🇹",
    code: "PT",
    dial_code: "+351",
    alpha3: "PRT"
  },
  {
    name: "Puerto Rico",
    flag: "🇵🇷",
    code: "PR",
    dial_code: "+1",
    alpha3: "PRI"
  },
  { name: "Qatar", flag: "🇶🇦", code: "QA", dial_code: "+974", alpha3: "QAT" },
  { name: "Réunion", flag: "🇷🇪", code: "RE", dial_code: "+262", alpha3: "REU" },
  { name: "Romania", flag: "🇷🇴", code: "RO", dial_code: "+40", alpha3: "ROU" },
  { name: "Russland", flag: "🇷🇺", code: "RU", dial_code: "+7", alpha3: "RUS" },
  { name: "Rwanda", flag: "🇷🇼", code: "RW", dial_code: "+250", alpha3: "RWA" },
  {
    name: "Saint Barthélemy",
    flag: "🇧🇱",
    code: "BL",
    dial_code: "+590",
    alpha3: "BLM"
  },
  {
    name: "Saudi-Arabia",
    flag: "🇸🇦",
    code: "SA",
    dial_code: "+966",
    alpha3: "SAU"
  },
  {
    name: "Singapore",
    flag: "🇸🇬",
    code: "SG",
    dial_code: "+65",
    alpha3: "SGP"
  },
  {
    name: "Sør-Afrika",
    flag: "🇿🇦",
    code: "ZA",
    dial_code: "+27",
    alpha3: "ZAF"
  },
  {
    name: "Spania",
    flag: "🇪🇸",
    code: "ES",
    dial_code: "+34",
    alpha3: "ESP"
  },
  {
    name: "Sverige",
    flag: "🇸🇪",
    code: "SE",
    dial_code: "+46",
    alpha3: "SWE"
  },
  {
    name: "Sveits",
    flag: "🇨🇭",
    code: "CH",
    dial_code: "+41",
    alpha3: "CHE"
  },
  {
    name: "Taiwan",
    flag: "🇹🇼",
    code: "TW",
    dial_code: "+886",
    alpha3: "TWN"
  },
  {
    name: "Thailand",
    flag: "🇹🇭",
    code: "TH",
    dial_code: "+66",
    alpha3: "THA"
  },
  {
    name: "Tyrkia",
    flag: "🇹🇷",
    code: "TR",
    dial_code: "+90",
    alpha3: "TUR"
  },
  {
    name: "De forente arabiske emirater",
    flag: "🇦🇪",
    code: "AE",
    dial_code: "+971",
    alpha3: "ARE"
  },
  {
    name: "Storbritannia",
    flag: "🇬🇧",
    code: "GB",
    dial_code: "+44",
    alpha3: "GBR"
  },
  {
    name: "USA",
    flag: "🇺🇸",
    code: "US",
    dial_code: "+1",
    alpha3: "USA"
  },
  {
    name: "Venezuela",
    flag: "🇻🇪",
    code: "VE",
    dial_code: "+58",
    alpha3: "VEN"
  },
  {
    name: "Vietnam",
    flag: "🇻🇳",
    code: "VN",
    dial_code: "+84",
    alpha3: "VNM"
  }
], gG = {}, ph = {};
Dl.forEach((e) => {
  gG[e.dial_code] = e;
});
Dl.forEach((e) => {
  ph[e.code] = e;
});
const fc = ph.NO, CG = (e, t = "asc") => {
  const n = t === "asc";
  return function(r, o) {
    const i = typeof r[e] == "string" ? r[e]?.toLowerCase() : r[e], a = typeof o[e] == "string" ? o[e]?.toLowerCase() : o[e];
    return i < a ? n ? -1 : 1 : i > a ? n ? 1 : -1 : 0;
  };
}, vG = typeof window < "u" ? A.useLayoutEffect : A.useEffect;
function c5(e, t, n, r) {
  const o = ke(t);
  vG(() => {
    o.current = t;
  }, [t]), ve(() => {
    const i = n?.current ?? window;
    if (!(i && i.addEventListener)) return;
    const a = (s) => {
      o.current(s);
    };
    return i.addEventListener(e, a, r), () => {
      i.removeEventListener(e, a, r);
    };
  }, [e, n, r]);
}
function yG(e) {
  const [t, n] = ue(!1), r = () => {
    n(!0);
  }, o = () => {
    n(!1);
  };
  return c5("focusin", r, e), c5("focusout", o, e), x2(() => {
    typeof document < "u" && e.current && n(document.activeElement === e.current);
  }, [e.current]), t;
}
function bG(e) {
  const [t, n] = ue(!1), r = () => {
    n(!0);
  }, o = () => {
    n(!1);
  };
  return c5("mouseenter", r, e), c5("mouseleave", o, e), t;
}
const wG = (e, t) => {
  const [n, r] = ue(e);
  return ve(() => {
    const o = setTimeout(() => {
      r(e);
    }, t);
    return () => {
      clearTimeout(o);
    };
  }, [e, t]), n;
};
function mh(e, t = 50) {
  const n = ke(null);
  return ve(() => () => {
    n.current !== null && clearTimeout(n.current);
  }, []), (...o) => {
    n.current !== null && clearTimeout(n.current), n.current = window.setTimeout(() => {
      e(...o);
    }, t);
  };
}
var xG = "2.0.6", SG = 500, Jg = "user-agent", Fa = "", eC = "?", Zt = {
  FUNCTION: "function",
  OBJECT: "object",
  STRING: "string",
  UNDEFINED: "undefined"
}, zn = "browser", No = "cpu", to = "device", Vr = "engine", rr = "os", Oa = "result", se = "name", oe = "type", le = "vendor", ce = "version", kn = "architecture", Rl = "major", ae = "model", al = "console", Ve = "mobile", pt = "tablet", Yt = "smarttv", Xr = "wearable", dc = "xr", sl = "embedded", Xi = "inapp", gh = "brands", ei = "formFactors", Ch = "fullVersionList", Aa = "platform", vh = "platformVersion", Hu = "bitness", N1 = "sec-ch-ua", MG = N1 + "-full-version-list", EG = N1 + "-arch", _G = N1 + "-" + Hu, OG = N1 + "-form-factors", AG = N1 + "-" + Ve, PG = N1 + "-" + ae, aP = N1 + "-" + Aa, TG = aP + "-version", sP = [gh, Ch, Ve, ae, Aa, vh, kn, ei, Hu], hc = "Amazon", Qi = "Apple", tC = "ASUS", nC = "BlackBerry", W1 = "Google", rC = "Huawei", A7 = "Lenovo", oC = "Honor", pc = "LG", P7 = "Microsoft", T7 = "Motorola", I7 = "Nvidia", iC = "OnePlus", D7 = "OPPO", js = "Samsung", aC = "Sharp", Hs = "Sony", R7 = "Xiaomi", k7 = "Zebra", sC = "Chrome", lC = "Chromium", l1 = "Chromecast", zc = "Edge", zs = "Firefox", Zs = "Opera", L7 = "Facebook", cC = "Sogou", Ji = "Mobile ", Ws = " Browser", R9 = "Windows", IG = typeof window !== Zt.UNDEFINED, Zn = IG && window.navigator ? window.navigator : void 0, h1 = Zn && Zn.userAgentData ? Zn.userAgentData : void 0, DG = function(e, t) {
  var n = {}, r = t;
  if (!u5(t)) {
    r = {};
    for (var o in t)
      for (var i in t[o])
        r[i] = t[o][i].concat(r[i] ? r[i] : []);
  }
  for (var a in e)
    n[a] = r[a] && r[a].length % 2 === 0 ? r[a].concat(e[a]) : e[a];
  return n;
}, zu = function(e) {
  for (var t = {}, n = 0; n < e.length; n++)
    t[e[n].toUpperCase()] = e[n];
  return t;
}, k9 = function(e, t) {
  if (typeof e === Zt.OBJECT && e.length > 0) {
    for (var n in e)
      if (C1(t) == C1(e[n])) return !0;
    return !1;
  }
  return L2(e) ? C1(t) == C1(e) : !1;
}, u5 = function(e, t) {
  for (var n in e)
    return /^(browser|cpu|device|engine|os)$/.test(n) || (t ? u5(e[n]) : !1);
}, L2 = function(e) {
  return typeof e === Zt.STRING;
}, N7 = function(e) {
  if (e) {
    for (var t = [], n = Va(/\\?\"/g, e).split(","), r = 0; r < n.length; r++)
      if (n[r].indexOf(";") > -1) {
        var o = f5(n[r]).split(";v=");
        t[r] = { brand: o[0], version: o[1] };
      } else
        t[r] = f5(n[r]);
    return t;
  }
}, C1 = function(e) {
  return L2(e) ? e.toLowerCase() : e;
}, F7 = function(e) {
  return L2(e) ? Va(/[^\d\.]/g, e).split(".")[0] : void 0;
}, Fo = function(e) {
  for (var t in e)
    if (e.hasOwnProperty(t)) {
      var n = e[t];
      typeof n == Zt.OBJECT && n.length == 2 ? this[n[0]] = n[1] : this[n] = void 0;
    }
  return this;
}, Va = function(e, t) {
  return L2(t) ? t.replace(e, Fa) : t;
}, qs = function(e) {
  return Va(/\\?\"/g, e);
}, f5 = function(e, t) {
  return e = Va(/^\s\s*/, String(e)), typeof t === Zt.UNDEFINED ? e : e.substring(0, t);
}, V7 = function(e, t) {
  if (!(!e || !t))
    for (var n = 0, r, o, i, a, s, l; n < t.length && !s; ) {
      var c = t[n], u = t[n + 1];
      for (r = o = 0; r < c.length && !s && c[r]; )
        if (s = c[r++].exec(e), s)
          for (i = 0; i < u.length; i++)
            l = s[++o], a = u[i], typeof a === Zt.OBJECT && a.length > 0 ? a.length === 2 ? typeof a[1] == Zt.FUNCTION ? this[a[0]] = a[1].call(this, l) : this[a[0]] = a[1] : a.length >= 3 && (typeof a[1] === Zt.FUNCTION && !(a[1].exec && a[1].test) ? a.length > 3 ? this[a[0]] = l ? a[1].apply(this, a.slice(2)) : void 0 : this[a[0]] = l ? a[1].call(this, l, a[2]) : void 0 : a.length == 3 ? this[a[0]] = l ? l.replace(a[1], a[2]) : void 0 : a.length == 4 ? this[a[0]] = l ? a[3].call(this, l.replace(a[1], a[2])) : void 0 : a.length > 4 && (this[a[0]] = l ? a[3].apply(this, [l.replace(a[1], a[2])].concat(a.slice(4))) : void 0)) : this[a] = l || void 0;
      n += 2;
    }
}, Jr = function(e, t) {
  for (var n in t)
    if (typeof t[n] === Zt.OBJECT && t[n].length > 0) {
      for (var r = 0; r < t[n].length; r++)
        if (k9(t[n][r], e))
          return n === eC ? void 0 : n;
    } else if (k9(t[n], e))
      return n === eC ? void 0 : n;
  return t.hasOwnProperty("*") ? t["*"] : e;
}, uC = {
  ME: "4.90",
  "NT 3.51": "3.51",
  "NT 4.0": "4.0",
  2e3: ["5.0", "5.01"],
  XP: ["5.1", "5.2"],
  Vista: "6.0",
  7: "6.1",
  8: "6.2",
  "8.1": "6.3",
  10: ["6.4", "10.0"],
  NT: ""
}, fC = {
  embedded: "Automotive",
  mobile: "Mobile",
  tablet: ["Tablet", "EInk"],
  smarttv: "TV",
  wearable: "Watch",
  xr: ["VR", "XR"],
  "?": ["Desktop", "Unknown"],
  "*": void 0
}, RG = {
  Chrome: "Google Chrome",
  Edge: "Microsoft Edge",
  "Edge WebView2": "Microsoft Edge WebView2",
  "Chrome WebView": "Android WebView",
  "Chrome Headless": "HeadlessChrome",
  "Huawei Browser": "HuaweiBrowser",
  "MIUI Browser": "Miui Browser",
  "Opera Mobi": "OperaMobile",
  Yandex: "YaBrowser"
}, dC = {
  browser: [
    [
      // Most common regardless engine
      /\b(?:crmo|crios)\/([\w\.]+)/i
      // Chrome for Android/iOS
    ],
    [ce, [se, Ji + "Chrome"]],
    [
      /webview.+edge\/([\w\.]+)/i
      // Microsoft Edge
    ],
    [ce, [se, zc + " WebView"]],
    [
      /edg(?:e|ios|a)?\/([\w\.]+)/i
    ],
    [ce, [se, "Edge"]],
    [
      // Presto based
      /(opera mini)\/([-\w\.]+)/i,
      // Opera Mini
      /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
      // Opera Mobi/Tablet
      /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
      // Opera
    ],
    [se, ce],
    [
      /opios[\/ ]+([\w\.]+)/i
      // Opera mini on iphone >= 8.0
    ],
    [ce, [se, Zs + " Mini"]],
    [
      /\bop(?:rg)?x\/([\w\.]+)/i
      // Opera GX
    ],
    [ce, [se, Zs + " GX"]],
    [
      /\bopr\/([\w\.]+)/i
      // Opera Webkit
    ],
    [ce, [se, Zs]],
    [
      // Mixed
      /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
      // Baidu
    ],
    [ce, [se, "Baidu"]],
    [
      /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i
      // Maxthon
    ],
    [ce, [se, "Maxthon"]],
    [
      /(kindle)\/([\w\.]+)/i,
      // Kindle
      /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
      // Lunascape/Maxthon/Netfront/Jasmine/Blazer/Sleipnir
      // Trident based
      /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
      // Avant/IEMobile/SlimBrowser/SlimBoat/Slimjet
      /(?:ms|\()(ie) ([\w\.]+)/i,
      // Internet Explorer
      // Blink/Webkit/KHTML based                                         // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon/LG Browser/Otter/qutebrowser/Dooble/Palemoon
      /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon|otter|dooble|(?:lg |qute)browser|palemoon)\/([-\w\.]+)/i,
      // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo/Klar/Helio/Dragon
      /(heytap|ovi|115|surf|qwant)browser\/([\d\.]+)/i,
      // HeyTap/Ovi/115/Surf
      /(qwant)(?:ios|mobile)\/([\d\.]+)/i,
      // Qwant
      /(ecosia|weibo)(?:__| \w+@)([\d\.]+)/i
      // Ecosia/Weibo
    ],
    [se, ce],
    [
      /quark(?:pc)?\/([-\w\.]+)/i
      // Quark
    ],
    [ce, [se, "Quark"]],
    [
      /\bddg\/([\w\.]+)/i
      // DuckDuckGo
    ],
    [ce, [se, "DuckDuckGo"]],
    [
      /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
      // UCBrowser
    ],
    [ce, [se, "UCBrowser"]],
    [
      /microm.+\bqbcore\/([\w\.]+)/i,
      // WeChat Desktop for Windows Built-in Browser
      /\bqbcore\/([\w\.]+).+microm/i,
      /micromessenger\/([\w\.]+)/i
      // WeChat
    ],
    [ce, [se, "WeChat"]],
    [
      /konqueror\/([\w\.]+)/i
      // Konqueror
    ],
    [ce, [se, "Konqueror"]],
    [
      /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
      // IE11
    ],
    [ce, [se, "IE"]],
    [
      /ya(?:search)?browser\/([\w\.]+)/i
      // Yandex
    ],
    [ce, [se, "Yandex"]],
    [
      /slbrowser\/([\w\.]+)/i
      // Smart Lenovo Browser
    ],
    [ce, [se, "Smart " + A7 + Ws]],
    [
      /(avast|avg)\/([\w\.]+)/i
      // Avast/AVG Secure Browser
    ],
    [[se, /(.+)/, "$1 Secure" + Ws], ce],
    [
      /\bfocus\/([\w\.]+)/i
      // Firefox Focus
    ],
    [ce, [se, zs + " Focus"]],
    [
      /\bopt\/([\w\.]+)/i
      // Opera Touch
    ],
    [ce, [se, Zs + " Touch"]],
    [
      /coc_coc\w+\/([\w\.]+)/i
      // Coc Coc Browser
    ],
    [ce, [se, "Coc Coc"]],
    [
      /dolfin\/([\w\.]+)/i
      // Dolphin
    ],
    [ce, [se, "Dolphin"]],
    [
      /coast\/([\w\.]+)/i
      // Opera Coast
    ],
    [ce, [se, Zs + " Coast"]],
    [
      /miuibrowser\/([\w\.]+)/i
      // MIUI Browser
    ],
    [ce, [se, "MIUI" + Ws]],
    [
      /fxios\/([\w\.-]+)/i
      // Firefox for iOS
    ],
    [ce, [se, Ji + zs]],
    [
      /\bqihoobrowser\/?([\w\.]*)/i
      // 360
    ],
    [ce, [se, "360"]],
    [
      /\b(qq)\/([\w\.]+)/i
      // QQ
    ],
    [[se, /(.+)/, "$1Browser"], ce],
    [
      /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
    ],
    [[se, /(.+)/, "$1" + Ws], ce],
    [
      // Oculus/Sailfish/HuaweiBrowser/VivoBrowser/PicoBrowser
      /samsungbrowser\/([\w\.]+)/i
      // Samsung Internet
    ],
    [ce, [se, js + " Internet"]],
    [
      /metasr[\/ ]?([\d\.]+)/i
      // Sogou Explorer
    ],
    [ce, [se, cC + " Explorer"]],
    [
      /(sogou)mo\w+\/([\d\.]+)/i
      // Sogou Mobile
    ],
    [[se, cC + " Mobile"], ce],
    [
      /(electron)\/([\w\.]+) safari/i,
      // Electron-based App
      /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
      // Tesla
      /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i
      // QQ/2345
    ],
    [se, ce],
    [
      /(lbbrowser|rekonq)/i
      // LieBao Browser/Rekonq
    ],
    [se],
    [
      /ome\/([\w\.]+) \w* ?(iron) saf/i,
      // Iron
      /ome\/([\w\.]+).+qihu (360)[es]e/i
      // 360
    ],
    [ce, se],
    [
      // WebView
      /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
      // Facebook App for iOS & Android
    ],
    [[se, L7], ce, [oe, Xi]],
    [
      /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
      // Kakao App
      /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
      // Naver InApp
      /(daum)apps[\/ ]([\w\.]+)/i,
      // Daum App
      /safari (line)\/([\w\.]+)/i,
      // Line App for iOS
      /\b(line)\/([\w\.]+)\/iab/i,
      // Line App for Android
      /(alipay)client\/([\w\.]+)/i,
      // Alipay
      /(twitter)(?:and| f.+e\/([\w\.]+))/i,
      // Twitter
      /(bing)(?:web|sapphire)\/([\w\.]+)/i,
      // Bing
      /(instagram|snapchat|klarna)[\/ ]([-\w\.]+)/i
      // Instagram/Snapchat/Klarna
    ],
    [se, ce, [oe, Xi]],
    [
      /\bgsa\/([\w\.]+) .*safari\//i
      // Google Search Appliance on iOS
    ],
    [ce, [se, "GSA"], [oe, Xi]],
    [
      /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
      // TikTok
    ],
    [ce, [se, "TikTok"], [oe, Xi]],
    [
      /\[(linkedin)app\]/i
      // LinkedIn App for iOS & Android
    ],
    [se, [oe, Xi]],
    [
      /(zalo(?:app)?)[\/\sa-z]*([\w\.-]+)/i
      // Zalo 
    ],
    [[se, /(.+)/, "Zalo"], ce, [oe, Xi]],
    [
      /(chromium)[\/ ]([-\w\.]+)/i
      // Chromium
    ],
    [se, ce],
    [
      /headlesschrome(?:\/([\w\.]+)| )/i
      // Chrome Headless
    ],
    [ce, [se, sC + " Headless"]],
    [
      /wv\).+chrome\/([\w\.]+).+edgw\//i
      // Edge WebView2
    ],
    [ce, [se, zc + " WebView2"]],
    [
      / wv\).+(chrome)\/([\w\.]+)/i
      // Chrome WebView
    ],
    [[se, sC + " WebView"], ce],
    [
      /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
      // Android Browser
    ],
    [ce, [se, "Android" + Ws]],
    [
      /chrome\/([\w\.]+) mobile/i
      // Chrome Mobile
    ],
    [ce, [se, Ji + "Chrome"]],
    [
      /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
      // Chrome/OmniWeb/Arora/Tizen/Nokia
    ],
    [se, ce],
    [
      /version\/([\w\.\,]+) .*mobile(?:\/\w+ | ?)safari/i
      // Safari Mobile
    ],
    [ce, [se, Ji + "Safari"]],
    [
      /iphone .*mobile(?:\/\w+ | ?)safari/i
    ],
    [[se, Ji + "Safari"]],
    [
      /version\/([\w\.\,]+) .*(safari)/i
      // Safari
    ],
    [ce, se],
    [
      /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
      // Safari < 3.0
    ],
    [se, [ce, "1"]],
    [
      /(webkit|khtml)\/([\w\.]+)/i
    ],
    [se, ce],
    [
      // Gecko based
      /(?:mobile|tablet);.*(firefox)\/([\w\.-]+)/i
      // Firefox Mobile
    ],
    [[se, Ji + zs], ce],
    [
      /(navigator|netscape\d?)\/([-\w\.]+)/i
      // Netscape
    ],
    [[se, "Netscape"], ce],
    [
      /(wolvic|librewolf)\/([\w\.]+)/i
      // Wolvic/LibreWolf
    ],
    [se, ce],
    [
      /mobile vr; rv:([\w\.]+)\).+firefox/i
      // Firefox Reality
    ],
    [ce, [se, zs + " Reality"]],
    [
      /ekiohf.+(flow)\/([\w\.]+)/i,
      // Flow
      /(swiftfox)/i,
      // Swiftfox
      /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
      // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
      /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|basilisk|waterfox)\/([-\w\.]+)$/i,
      // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
      /(firefox)\/([\w\.]+)/i,
      // Other Firefox-based
      /(mozilla)\/([\w\.]+(?= .+rv\:.+gecko\/\d+)|[0-4][\w\.]+(?!.+compatible))/i,
      // Mozilla
      // Other
      /(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
      // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Obigo/Mosaic/Go/ICE/UP.Browser/Ladybird
      /\b(links) \(([\w\.]+)/i
      // Links
    ],
    [se, [ce, /_/g, "."]],
    [
      /(cobalt)\/([\w\.]+)/i
      // Cobalt
    ],
    [se, [ce, /[^\d\.]+./, Fa]]
  ],
  cpu: [
    [
      /\b((amd|x|x86[-_]?|wow|win)64)\b/i
      // AMD64 (x64)
    ],
    [[kn, "amd64"]],
    [
      /(ia32(?=;))/i,
      // IA32 (quicktime)
      /\b((i[346]|x)86)(pc)?\b/i
      // IA32 (x86)
    ],
    [[kn, "ia32"]],
    [
      /\b(aarch64|arm(v?[89]e?l?|_?64))\b/i
      // ARM64
    ],
    [[kn, "arm64"]],
    [
      /\b(arm(v[67])?ht?n?[fl]p?)\b/i
      // ARMHF
    ],
    [[kn, "armhf"]],
    [
      // PocketPC mistakenly identified as PowerPC
      /( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i
    ],
    [[kn, "arm"]],
    [
      / sun4\w[;\)]/i
      // SPARC
    ],
    [[kn, "sparc"]],
    [
      // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
      /\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i,
      /((ppc|powerpc)(64)?)( mac|;|\))/i,
      // PowerPC
      /(?:osf1|[freopnt]{3,4}bsd) (alpha)/i
      // Alpha
    ],
    [[kn, /ower/, Fa, C1]],
    [
      /mc680.0/i
    ],
    [[kn, "68k"]],
    [
      /winnt.+\[axp/i
    ],
    [[kn, "alpha"]]
  ],
  device: [
    [
      //////////////////////////
      // MOBILES & TABLETS
      /////////////////////////
      // Samsung
      /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
    ],
    [ae, [le, js], [oe, pt]],
    [
      /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
      /samsung[- ]((?!sm-[lr]|browser)[-\w]+)/i,
      /sec-(sgh\w+)/i
    ],
    [ae, [le, js], [oe, Ve]],
    [
      // Apple
      /(?:\/|\()(ip(?:hone|od)[\w, ]*)[\/\);]/i
      // iPod/iPhone
    ],
    [ae, [le, Qi], [oe, Ve]],
    [
      /\b(?:ios|apple\w+)\/.+[\(\/](ipad)/i,
      // iPad
      /\b(ipad)[\d,]*[;\] ].+(mac |i(pad)?)os/i
    ],
    [ae, [le, Qi], [oe, pt]],
    [
      /(macintosh);/i
    ],
    [ae, [le, Qi]],
    [
      // Sharp
      /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
    ],
    [ae, [le, aC], [oe, Ve]],
    [
      // Honor
      /\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i
    ],
    [ae, [le, oC], [oe, pt]],
    [
      /honor([-\w ]+)[;\)]/i
    ],
    [ae, [le, oC], [oe, Ve]],
    [
      // Huawei
      /\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i
    ],
    [ae, [le, rC], [oe, pt]],
    [
      /(?:huawei) ?([-\w ]+)[;\)]/i,
      /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][\dc][adnt]?)\b(?!.+d\/s)/i
    ],
    [ae, [le, rC], [oe, Ve]],
    [
      // Xiaomi
      /oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,
      /\b(?:xiao)?((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i
      // Mi Pad tablets
    ],
    [[ae, /_/g, " "], [le, R7], [oe, pt]],
    [
      /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
      // Xiaomi POCO
      /\b; (\w+) build\/hm\1/i,
      // Xiaomi Hongmi 'numeric' models
      /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
      // Xiaomi Hongmi
      /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
      // Xiaomi Redmi
      /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
      // Xiaomi Redmi 'numeric' models
      /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note|max|cc)?[_ ]?(?:\d{0,2}\w?)[_ ]?(?:plus|se|lite|pro)?( 5g|lte)?)(?: bui|\))/i,
      // Xiaomi Mi
      / ([\w ]+) miui\/v?\d/i
    ],
    [[ae, /_/g, " "], [le, R7], [oe, Ve]],
    [
      // OnePlus
      /droid.+; (cph2[3-6]\d[13579]|((gm|hd)19|(ac|be|in|kb)20|(d[en]|eb|le|mt)21|ne22)[0-2]\d|p[g-k]\w[1m]10)\b/i,
      /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
    ],
    [ae, [le, iC], [oe, Ve]],
    [
      // OPPO
      /; (\w+) bui.+ oppo/i,
      /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
    ],
    [ae, [le, D7], [oe, Ve]],
    [
      /\b(opd2(\d{3}a?))(?: bui|\))/i
    ],
    [ae, [le, Jr, { OnePlus: ["203", "304", "403", "404", "413", "415"], "*": D7 }], [oe, pt]],
    [
      // BLU
      /(vivo (5r?|6|8l?|go|one|s|x[il]?[2-4]?)[\w\+ ]*)(?: bui|\))/i
      // Vivo series
    ],
    [ae, [le, "BLU"], [oe, Ve]],
    [
      // Vivo
      /; vivo (\w+)(?: bui|\))/i,
      /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
    ],
    [ae, [le, "Vivo"], [oe, Ve]],
    [
      // Realme
      /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
    ],
    [ae, [le, "Realme"], [oe, Ve]],
    [
      // Lenovo
      /(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,
      /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i
    ],
    [ae, [le, A7], [oe, pt]],
    [
      /lenovo[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i
    ],
    [ae, [le, A7], [oe, Ve]],
    [
      // Motorola
      /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
      /\bmot(?:orola)?[- ]([\w\s]+)(\)| bui)/i,
      /((?:moto(?! 360)[-\w\(\) ]+|xt\d{3,4}[cgkosw\+]?[-\d]*|nexus 6)(?= bui|\)))/i
    ],
    [ae, [le, T7], [oe, Ve]],
    [
      /\b(mz60\d|xoom[2 ]{0,2}) build\//i
    ],
    [ae, [le, T7], [oe, pt]],
    [
      // LG
      /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
    ],
    [ae, [le, pc], [oe, pt]],
    [
      /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
      /\blg[-e;\/ ]+(?!.*(?:browser|netcast|android tv|watch|webos))(\w+)/i,
      /\blg-?([\d\w]+) bui/i
    ],
    [ae, [le, pc], [oe, Ve]],
    [
      // Nokia
      /(nokia) (t[12][01])/i
    ],
    [le, ae, [oe, pt]],
    [
      /(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i,
      /nokia[-_ ]?(([-\w\. ]*?))( bui|\)|;|\/)/i
    ],
    [[ae, /_/g, " "], [oe, Ve], [le, "Nokia"]],
    [
      // Google
      /(pixel (c|tablet))\b/i
      // Google Pixel C/Tablet
    ],
    [ae, [le, W1], [oe, pt]],
    [
      // Google Pixel
      /droid.+;(?: google)? (g(01[13]a|020[aem]|025[jn]|1b60|1f8f|2ybb|4s1m|576d|5nz6|8hhn|8vou|a02099|c15s|d1yq|e2ae|ec77|gh2x|kv4x|p4bc|pj41|r83y|tt9q|ur25|wvk6)|pixel[\d ]*a?( pro)?( xl)?( fold)?( \(5g\))?)( bui|\))/i
    ],
    [ae, [le, W1], [oe, Ve]],
    [
      /(google) (pixelbook( go)?)/i
    ],
    [le, ae],
    [
      // Sony
      /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-\w\w\d\d)(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
    ],
    [ae, [le, Hs], [oe, Ve]],
    [
      /sony tablet [ps]/i,
      /\b(?:sony)?sgp\w+(?: bui|\))/i
    ],
    [[ae, "Xperia Tablet"], [le, Hs], [oe, pt]],
    [
      // Amazon
      /(alexa)webm/i,
      /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
      // Kindle Fire without Silk / Echo Show
      /(kf[a-z]+)( bui|\)).+silk\//i
      // Kindle Fire HD
    ],
    [ae, [le, hc], [oe, pt]],
    [
      /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
      // Fire Phone
    ],
    [[ae, /(.+)/g, "Fire Phone $1"], [le, hc], [oe, Ve]],
    [
      // BlackBerry
      /(playbook);[-\w\),; ]+(rim)/i
      // BlackBerry PlayBook
    ],
    [ae, le, [oe, pt]],
    [
      /\b((?:bb[a-f]|st[hv])100-\d)/i,
      /(?:blackberry|\(bb10;) (\w+)/i
    ],
    [ae, [le, nC], [oe, Ve]],
    [
      // Asus
      /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
    ],
    [ae, [le, tC], [oe, pt]],
    [
      / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
    ],
    [ae, [le, tC], [oe, Ve]],
    [
      // HTC
      /(nexus 9)/i
      // HTC Nexus 9
    ],
    [ae, [le, "HTC"], [oe, pt]],
    [
      /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
      // HTC
      // ZTE
      /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
      /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
      // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
    ],
    [le, [ae, /_/g, " "], [oe, Ve]],
    [
      // TCL
      /tcl (xess p17aa)/i,
      /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])(_\w(\w|\w\w))?(\)| bui)/i
    ],
    [ae, [le, "TCL"], [oe, pt]],
    [
      /droid [\w\.]+; (418(?:7d|8v)|5087z|5102l|61(?:02[dh]|25[adfh]|27[ai]|56[dh]|59k|65[ah])|a509dl|t(?:43(?:0w|1[adepqu])|50(?:6d|7[adju])|6(?:09dl|10k|12b|71[efho]|76[hjk])|7(?:66[ahju]|67[hw]|7[045][bh]|71[hk]|73o|76[ho]|79w|81[hks]?|82h|90[bhsy]|99b)|810[hs]))(_\w(\w|\w\w))?(\)| bui)/i
    ],
    [ae, [le, "TCL"], [oe, Ve]],
    [
      // itel
      /(itel) ((\w+))/i
    ],
    [[le, C1], ae, [oe, Jr, { tablet: ["p10001l", "w7001"], "*": "mobile" }]],
    [
      // Acer
      /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
    ],
    [ae, [le, "Acer"], [oe, pt]],
    [
      // Meizu
      /droid.+; (m[1-5] note) bui/i,
      /\bmz-([-\w]{2,})/i
    ],
    [ae, [le, "Meizu"], [oe, Ve]],
    [
      // Ulefone
      /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
    ],
    [ae, [le, "Ulefone"], [oe, Ve]],
    [
      // Energizer
      /; (energy ?\w+)(?: bui|\))/i,
      /; energizer ([\w ]+)(?: bui|\))/i
    ],
    [ae, [le, "Energizer"], [oe, Ve]],
    [
      // Cat
      /; cat (b35);/i,
      /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
    ],
    [ae, [le, "Cat"], [oe, Ve]],
    [
      // Smartfren
      /((?:new )?andromax[\w- ]+)(?: bui|\))/i
    ],
    [ae, [le, "Smartfren"], [oe, Ve]],
    [
      // Nothing
      /droid.+; (a(in)?(0(15|59|6[35])|142)p?)/i
    ],
    [ae, [le, "Nothing"], [oe, Ve]],
    [
      // Archos
      /; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i,
      /archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i
    ],
    [ae, [le, "Archos"], [oe, pt]],
    [
      /archos ([\w ]+)( b|\))/i,
      /; (ac[3-6]\d\w{2,8})( b|\))/i
    ],
    [ae, [le, "Archos"], [oe, Ve]],
    [
      // HMD
      /; (n159v)/i
    ],
    [ae, [le, "HMD"], [oe, Ve]],
    [
      // MIXED
      /(imo) (tab \w+)/i,
      // IMO
      /(infinix|tecno) (x1101b?|p904|dp(7c|8d|10a)( pro)?|p70[1-3]a?|p904|t1101)/i
      // Infinix XPad / Tecno
    ],
    [le, ae, [oe, pt]],
    [
      /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
      // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron/Tecno/Micromax/Advan
      // BLU/HMD/IMO/Infinix/Lava/OnePlus/TCL/Wiko
      /; (blu|hmd|imo|infinix|lava|oneplus|tcl|wiko)[_ ]([\w\+ ]+?)(?: bui|\)|; r)/i,
      /(hp) ([\w ]+\w)/i,
      // HP iPAQ
      /(microsoft); (lumia[\w ]+)/i,
      // Microsoft Lumia
      /(oppo) ?([\w ]+) bui/i,
      // OPPO
      /(hisense) ([ehv][\w ]+)\)/i,
      // Hisense
      /droid[^;]+; (philips)[_ ]([sv-x][\d]{3,4}[xz]?)/i
      // Philips
    ],
    [le, ae, [oe, Ve]],
    [
      /(kobo)\s(ereader|touch)/i,
      // Kobo
      /(hp).+(touchpad(?!.+tablet)|tablet)/i,
      // HP TouchPad
      /(kindle)\/([\w\.]+)/i
      // Kindle
    ],
    [le, ae, [oe, pt]],
    [
      /(surface duo)/i
      // Surface Duo
    ],
    [ae, [le, P7], [oe, pt]],
    [
      /droid [\d\.]+; (fp\du?)(?: b|\))/i
      // Fairphone
    ],
    [ae, [le, "Fairphone"], [oe, Ve]],
    [
      /((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i
      // Nvidia Tablets
    ],
    [ae, [le, I7], [oe, pt]],
    [
      /(sprint) (\w+)/i
      // Sprint Phones
    ],
    [le, ae, [oe, Ve]],
    [
      /(kin\.[onetw]{3})/i
      // Microsoft Kin
    ],
    [[ae, /\./g, " "], [le, P7], [oe, Ve]],
    [
      /droid.+; ([c6]+|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
      // Zebra
    ],
    [ae, [le, k7], [oe, pt]],
    [
      /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
    ],
    [ae, [le, k7], [oe, Ve]],
    [
      ///////////////////
      // SMARTTVS
      ///////////////////
      /(philips)[\w ]+tv/i,
      // Philips
      /smart-tv.+(samsung)/i
      // Samsung
    ],
    [le, [oe, Yt]],
    [
      /hbbtv.+maple;(\d+)/i
    ],
    [[ae, /^/, "SmartTV"], [le, js], [oe, Yt]],
    [
      /(vizio)(?: |.+model\/)(\w+-\w+)/i,
      // Vizio
      /tcast.+(lg)e?. ([-\w]+)/i
      // LG SmartTV
    ],
    [le, ae, [oe, Yt]],
    [
      /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
    ],
    [[le, pc], [oe, Yt]],
    [
      /(apple) ?tv/i
      // Apple TV
    ],
    [le, [ae, Qi + " TV"], [oe, Yt]],
    [
      /crkey.*devicetype\/chromecast/i
      // Google Chromecast Third Generation
    ],
    [[ae, l1 + " Third Generation"], [le, W1], [oe, Yt]],
    [
      /crkey.*devicetype\/([^/]*)/i
      // Google Chromecast with specific device type
    ],
    [[ae, /^/, "Chromecast "], [le, W1], [oe, Yt]],
    [
      /fuchsia.*crkey/i
      // Google Chromecast Nest Hub
    ],
    [[ae, l1 + " Nest Hub"], [le, W1], [oe, Yt]],
    [
      /crkey/i
      // Google Chromecast, Linux-based or unknown
    ],
    [[ae, l1], [le, W1], [oe, Yt]],
    [
      /(portaltv)/i
      // Facebook Portal TV
    ],
    [ae, [le, L7], [oe, Yt]],
    [
      /droid.+aft(\w+)( bui|\))/i
      // Fire TV
    ],
    [ae, [le, hc], [oe, Yt]],
    [
      /(shield \w+ tv)/i
      // Nvidia Shield TV
    ],
    [ae, [le, I7], [oe, Yt]],
    [
      /\(dtv[\);].+(aquos)/i,
      /(aquos-tv[\w ]+)\)/i
      // Sharp
    ],
    [ae, [le, aC], [oe, Yt]],
    [
      /(bravia[\w ]+)( bui|\))/i
      // Sony
    ],
    [ae, [le, Hs], [oe, Yt]],
    [
      /(mi(tv|box)-?\w+) bui/i
      // Xiaomi
    ],
    [ae, [le, R7], [oe, Yt]],
    [
      /Hbbtv.*(technisat) (.*);/i
      // TechniSAT
    ],
    [le, ae, [oe, Yt]],
    [
      /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
      // Roku
      /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
      // HbbTV devices
    ],
    [[le, /.+\/(\w+)/, "$1", Jr, { LG: "lge" }], [ae, f5], [oe, Yt]],
    [
      ///////////////////
      // CONSOLES
      ///////////////////
      /(playstation \w+)/i
      // Playstation
    ],
    [ae, [le, Hs], [oe, al]],
    [
      /\b(xbox(?: one)?(?!; xbox))[\); ]/i
      // Microsoft Xbox
    ],
    [ae, [le, P7], [oe, al]],
    [
      /(ouya)/i,
      // Ouya
      /(nintendo) (\w+)/i,
      // Nintendo
      /(retroid) (pocket ([^\)]+))/i
      // Retroid Pocket
    ],
    [le, ae, [oe, al]],
    [
      /droid.+; (shield)( bui|\))/i
      // Nvidia Portable
    ],
    [ae, [le, I7], [oe, al]],
    [
      ///////////////////
      // WEARABLES
      ///////////////////
      /\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i
      // Samsung Galaxy Watch
    ],
    [ae, [le, js], [oe, Xr]],
    [
      /((pebble))app/i,
      // Pebble
      /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i
      // Asus ZenWatch / LG Watch / Pixel Watch
    ],
    [le, ae, [oe, Xr]],
    [
      /(ow(?:19|20)?we?[1-3]{1,3})/i
      // Oppo Watch
    ],
    [ae, [le, D7], [oe, Xr]],
    [
      /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
      // Apple Watch
    ],
    [ae, [le, Qi], [oe, Xr]],
    [
      /(opwwe\d{3})/i
      // OnePlus Watch
    ],
    [ae, [le, iC], [oe, Xr]],
    [
      /(moto 360)/i
      // Motorola 360
    ],
    [ae, [le, T7], [oe, Xr]],
    [
      /(smartwatch 3)/i
      // Sony SmartWatch
    ],
    [ae, [le, Hs], [oe, Xr]],
    [
      /(g watch r)/i
      // LG G Watch R
    ],
    [ae, [le, pc], [oe, Xr]],
    [
      /droid.+; (wt63?0{2,3})\)/i
    ],
    [ae, [le, k7], [oe, Xr]],
    [
      ///////////////////
      // XR
      ///////////////////
      /droid.+; (glass) \d/i
      // Google Glass
    ],
    [ae, [le, W1], [oe, dc]],
    [
      /(pico) ([\w ]+) os\d/i
      // Pico
    ],
    [le, ae, [oe, dc]],
    [
      /(quest( \d| pro)?s?).+vr/i
      // Meta Quest
    ],
    [ae, [le, L7], [oe, dc]],
    [
      /mobile vr; rv.+firefox/i
      // Unidentifiable VR device using Firefox Reality / Wolvic
    ],
    [[oe, dc]],
    [
      ///////////////////
      // EMBEDDED
      ///////////////////
      /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
      // Tesla
    ],
    [le, [oe, sl]],
    [
      /(aeobc)\b/i
      // Echo Dot
    ],
    [ae, [le, hc], [oe, sl]],
    [
      /(homepod).+mac os/i
      // Apple HomePod
    ],
    [ae, [le, Qi], [oe, sl]],
    [
      /windows iot/i
      // Unidentifiable embedded device using Windows IoT
    ],
    [[oe, sl]],
    [
      ////////////////////
      // MIXED (GENERIC)
      ///////////////////
      /droid.+; ([\w- ]+) (4k|android|smart|google)[- ]?tv/i
      // Unidentifiable SmartTV
    ],
    [ae, [oe, Yt]],
    [
      /\b((4k|android|smart|opera)[- ]?tv|tv; rv:|large screen[\w ]+safari)\b/i
    ],
    [[oe, Yt]],
    [
      /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew|; hmsc).+?(mobile|vr|\d) safari/i
    ],
    [ae, [oe, Jr, { mobile: "Mobile", xr: "VR", "*": pt }]],
    [
      /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
      // Unidentifiable Tablet
    ],
    [[oe, pt]],
    [
      /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
      // Unidentifiable Mobile
    ],
    [[oe, Ve]],
    [
      /droid .+?; ([\w\. -]+)( bui|\))/i
      // Generic Android Device
    ],
    [ae, [le, "Generic"]]
  ],
  engine: [
    [
      /windows.+ edge\/([\w\.]+)/i
      // EdgeHTML
    ],
    [ce, [se, zc + "HTML"]],
    [
      /(arkweb)\/([\w\.]+)/i
      // ArkWeb
    ],
    [se, ce],
    [
      /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
      // Blink
    ],
    [ce, [se, "Blink"]],
    [
      /(presto)\/([\w\.]+)/i,
      // Presto
      /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
      // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna/Servo
      /ekioh(flow)\/([\w\.]+)/i,
      // Flow
      /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
      // KHTML/Tasman/Links
      /(icab)[\/ ]([23]\.[\d\.]+)/i,
      // iCab
      /\b(libweb)/i
      // LibWeb
    ],
    [se, ce],
    [
      /ladybird\//i
    ],
    [[se, "LibWeb"]],
    [
      /rv\:([\w\.]{1,9})\b.+(gecko)/i
      // Gecko
    ],
    [ce, se]
  ],
  os: [
    [
      // Windows
      /(windows nt) (6\.[23]); arm/i
      // Windows RT
    ],
    [[se, /N/, "R"], [ce, Jr, uC]],
    [
      /(windows (?:phone|mobile|iot))(?: os)?[\/ ]?([\d\.]*( se)?)/i,
      // Windows IoT/Mobile/Phone
      // Windows NT/3.1/95/98/ME/2000/XP/Vista/7/8/8.1/10/11
      /(windows)[\/ ](1[01]|2000|3\.1|7|8(\.1)?|9[58]|me|server 20\d\d( r2)?|vista|xp)/i
    ],
    [se, ce],
    [
      /windows nt ?([\d\.\)]*)(?!.+xbox)/i,
      /\bwin(?=3| ?9|n)(?:nt| 9x )?([\d\.;]*)/i
    ],
    [[ce, /(;|\))/g, "", Jr, uC], [se, R9]],
    [
      /(windows ce)\/?([\d\.]*)/i
      // Windows CE
    ],
    [se, ce],
    [
      // iOS/macOS
      /[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,
      // iOS
      /(?:ios;fbsv|ios(?=.+ip(?:ad|hone))|ip(?:ad|hone)(?: |.+i(?:pad)?)os)[\/ ]([\w\.]+)/i,
      /cfnetwork\/.+darwin/i
    ],
    [[ce, /_/g, "."], [se, "iOS"]],
    [
      /(mac os x) ?([\w\. ]*)/i,
      /(macintosh|mac_powerpc\b)(?!.+(haiku|morphos))/i
      // Mac OS
    ],
    [[se, "macOS"], [ce, /_/g, "."]],
    [
      // Google Chromecast
      /android ([\d\.]+).*crkey/i
      // Google Chromecast, Android-based
    ],
    [ce, [se, l1 + " Android"]],
    [
      /fuchsia.*crkey\/([\d\.]+)/i
      // Google Chromecast, Fuchsia-based
    ],
    [ce, [se, l1 + " Fuchsia"]],
    [
      /crkey\/([\d\.]+).*devicetype\/smartspeaker/i
      // Google Chromecast, Linux-based Smart Speaker
    ],
    [ce, [se, l1 + " SmartSpeaker"]],
    [
      /linux.*crkey\/([\d\.]+)/i
      // Google Chromecast, Legacy Linux-based
    ],
    [ce, [se, l1 + " Linux"]],
    [
      /crkey\/([\d\.]+)/i
      // Google Chromecast, unknown
    ],
    [ce, [se, l1]],
    [
      // Mobile OSes
      /droid ([\w\.]+)\b.+(android[- ]x86)/i
      // Android-x86
    ],
    [ce, se],
    [
      /(ubuntu) ([\w\.]+) like android/i
      // Ubuntu Touch
    ],
    [[se, /(.+)/, "$1 Touch"], ce],
    [
      /(harmonyos)[\/ ]?([\d\.]*)/i,
      // HarmonyOS
      // Android/Blackberry/WebOS/QNX/Bada/RIM/KaiOS/Maemo/MeeGo/S40/Sailfish OS/OpenHarmony/Tizen
      /(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen)\w*[-\/\.; ]?([\d\.]*)/i
    ],
    [se, ce],
    [
      /\(bb(10);/i
      // BlackBerry 10
    ],
    [ce, [se, nC]],
    [
      /(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i
      // Symbian
    ],
    [ce, [se, "Symbian"]],
    [
      /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
      // Firefox OS
    ],
    [ce, [se, zs + " OS"]],
    [
      /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i,
      // WebOS
      /webos(?:[ \/]?|\.tv-20(?=2[2-9]))(\d[\d\.]*)/i
    ],
    [ce, [se, "webOS"]],
    [
      /web0s;.+?(?:chr[o0]me|safari)\/(\d+)/i
      // https://webostv.developer.lge.com/develop/specifications/web-api-and-web-engine
    ],
    [[ce, Jr, { 25: "120", 24: "108", 23: "94", 22: "87", 6: "79", 5: "68", 4: "53", 3: "38", 2: "538", 1: "537", "*": "TV" }], [se, "webOS"]],
    [
      /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
      // watchOS
    ],
    [ce, [se, "watchOS"]],
    [
      // Google ChromeOS
      /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
      // Chromium OS
    ],
    [[se, "Chrome OS"], ce],
    [
      // Smart TVs
      /panasonic;(viera)/i,
      // Panasonic Viera
      /(netrange)mmh/i,
      // Netrange
      /(nettv)\/(\d+\.[\w\.]+)/i,
      // NetTV
      // Console
      /(nintendo|playstation) (\w+)/i,
      // Nintendo/Playstation
      /(xbox); +xbox ([^\);]+)/i,
      // Microsoft Xbox (360, One, X, S, Series X, Series S)
      /(pico) .+os([\w\.]+)/i,
      // Pico
      // Other
      /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
      // Joli/Palm
      /linux.+(mint)[\/\(\) ]?([\w\.]*)/i,
      // Mint
      /(mageia|vectorlinux|fuchsia|arcaos|arch(?= ?linux))[;l ]([\d\.]*)/i,
      // Mageia/VectorLinux/Fuchsia/ArcaOS/Arch
      /([kxln]?ubuntu|debian|suse|opensuse|gentoo|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire|knoppix)(?: gnu[\/ ]linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
      // Ubuntu/Debian/SUSE/Gentoo/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire/Knoppix
      /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
      // Solaris
      /\b(aix)[; ]([1-9\.]{0,4})/i,
      // AIX
      /(hurd|linux|morphos)(?: (?:arm|x86|ppc)\w*| ?)([\w\.]*)/i,
      // Hurd/Linux/MorphOS
      /(gnu) ?([\w\.]*)/i,
      // GNU
      /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
      // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
      /(haiku) ?(r\d)?/i
      // Haiku
    ],
    [se, ce],
    [
      /(sunos) ?([\d\.]*)/i
      // Solaris
    ],
    [[se, "Solaris"], ce],
    [
      /\b(beos|os\/2|amigaos|openvms|hp-ux|serenityos)/i,
      // BeOS/OS2/AmigaOS/OpenVMS/HP-UX/SerenityOS
      /(unix) ?([\w\.]*)/i
      // UNIX
    ],
    [se, ce]
  ]
}, mc = (function() {
  var e = { init: {}, isIgnore: {}, isIgnoreRgx: {}, toString: {} };
  return Fo.call(e.init, [
    [zn, [se, ce, Rl, oe]],
    [No, [kn]],
    [to, [oe, ae, le]],
    [Vr, [se, ce]],
    [rr, [se, ce]]
  ]), Fo.call(e.isIgnore, [
    [zn, [ce, Rl]],
    [Vr, [ce]],
    [rr, [ce]]
  ]), Fo.call(e.isIgnoreRgx, [
    [zn, / ?browser$/i],
    [rr, / ?os$/i]
  ]), Fo.call(e.toString, [
    [zn, [se, ce]],
    [No, [kn]],
    [to, [le, ae]],
    [Vr, [se, ce]],
    [rr, [se, ce]]
  ]), e;
})(), kG = function(e, t) {
  var n = mc.init[t], r = mc.isIgnore[t] || 0, o = mc.isIgnoreRgx[t] || 0, i = mc.toString[t] || 0;
  function a() {
    Fo.call(this, n);
  }
  return a.prototype.getItem = function() {
    return e;
  }, a.prototype.withClientHints = function() {
    return h1 ? h1.getHighEntropyValues(sP).then(function(s) {
      return e.setCH(new lP(s, !1)).parseCH().get();
    }) : e.parseCH().get();
  }, a.prototype.withFeatureCheck = function() {
    return e.detectFeature().get();
  }, t != Oa && (a.prototype.is = function(s) {
    var l = !1;
    for (var c in this)
      if (this.hasOwnProperty(c) && !k9(r, c) && C1(o ? Va(o, this[c]) : this[c]) == C1(o ? Va(o, s) : s)) {
        if (l = !0, s != Zt.UNDEFINED) break;
      } else if (s == Zt.UNDEFINED && l) {
        l = !l;
        break;
      }
    return l;
  }, a.prototype.toString = function() {
    var s = Fa;
    for (var l in i)
      typeof this[i[l]] !== Zt.UNDEFINED && (s += (s ? " " : Fa) + this[i[l]]);
    return s || Zt.UNDEFINED;
  }), h1 || (a.prototype.then = function(s) {
    var l = this, c = function() {
      for (var f in l)
        l.hasOwnProperty(f) && (this[f] = l[f]);
    };
    c.prototype = {
      is: a.prototype.is,
      toString: a.prototype.toString
    };
    var u = new c();
    return s(u), u;
  }), new a();
};
function lP(e, t) {
  if (e = e || {}, Fo.call(this, sP), t)
    Fo.call(this, [
      [gh, N7(e[N1])],
      [Ch, N7(e[MG])],
      [Ve, /\?1/.test(e[AG])],
      [ae, qs(e[PG])],
      [Aa, qs(e[aP])],
      [vh, qs(e[TG])],
      [kn, qs(e[EG])],
      [ei, N7(e[OG])],
      [Hu, qs(e[_G])]
    ]);
  else
    for (var n in e)
      this.hasOwnProperty(n) && typeof e[n] !== Zt.UNDEFINED && (this[n] = e[n]);
}
function hC(e, t, n, r) {
  return this.get = function(o) {
    return o ? this.data.hasOwnProperty(o) ? this.data[o] : void 0 : this.data;
  }, this.set = function(o, i) {
    return this.data[o] = i, this;
  }, this.setCH = function(o) {
    return this.uaCH = o, this;
  }, this.detectFeature = function() {
    if (Zn && Zn.userAgent == this.ua)
      switch (this.itemType) {
        case zn:
          Zn.brave && typeof Zn.brave.isBrave == Zt.FUNCTION && this.set(se, "Brave");
          break;
        case to:
          !this.get(oe) && h1 && h1[Ve] && this.set(oe, Ve), this.get(ae) == "Macintosh" && Zn && typeof Zn.standalone !== Zt.UNDEFINED && Zn.maxTouchPoints && Zn.maxTouchPoints > 2 && this.set(ae, "iPad").set(oe, pt);
          break;
        case rr:
          !this.get(se) && h1 && h1[Aa] && this.set(se, h1[Aa]);
          break;
        case Oa:
          var o = this.data, i = function(a) {
            return o[a].getItem().detectFeature().get();
          };
          this.set(zn, i(zn)).set(No, i(No)).set(to, i(to)).set(Vr, i(Vr)).set(rr, i(rr));
      }
    return this;
  }, this.parseUA = function() {
    switch (this.itemType != Oa && V7.call(this.data, this.ua, this.rgxMap), this.itemType) {
      case zn:
        this.set(Rl, F7(this.get(ce)));
        break;
      case rr:
        if (this.get(se) == "iOS" && this.get(ce) == "18.6") {
          var o = /\) Version\/([\d\.]+)/.exec(this.ua);
          o && parseInt(o[1].substring(0, 2), 10) >= 26 && this.set(ce, o[1]);
        }
        break;
    }
    return this;
  }, this.parseCH = function() {
    var o = this.uaCH, i = this.rgxMap;
    switch (this.itemType) {
      case zn:
      case Vr:
        var a = o[Ch] || o[gh], s;
        if (a)
          for (var l = 0; l < a.length; l++) {
            var c = a[l].brand || a[l], u = a[l].version;
            this.itemType == zn && !/not.a.brand/i.test(c) && (!s || /Chrom/.test(s) && c != lC || s == zc && /WebView2/.test(c)) && (c = Jr(c, RG), s = this.get(se), s && !/Chrom/.test(s) && /Chrom/.test(c) || this.set(se, c).set(ce, u).set(Rl, F7(u)), s = c), this.itemType == Vr && c == lC && this.set(ce, u);
          }
        break;
      case No:
        var f = o[kn];
        f && (f && o[Hu] == "64" && (f += "64"), V7.call(this.data, f + ";", i));
        break;
      case to:
        if (o[Ve] && this.set(oe, Ve), o[ae] && (this.set(ae, o[ae]), !this.get(oe) || !this.get(le))) {
          var h = {};
          V7.call(h, "droid 9; " + o[ae] + ")", i), !this.get(oe) && h.type && this.set(oe, h.type), !this.get(le) && h.vendor && this.set(le, h.vendor);
        }
        if (o[ei]) {
          var p;
          if (typeof o[ei] != "string")
            for (var C = 0; !p && C < o[ei].length; )
              p = Jr(o[ei][C++], fC);
          else
            p = Jr(o[ei], fC);
          this.set(oe, p);
        }
        break;
      case rr:
        var m = o[Aa];
        if (m) {
          var g = o[vh];
          m == R9 && (g = parseInt(F7(g), 10) >= 13 ? "11" : "10"), this.set(se, m).set(ce, g);
        }
        this.get(se) == R9 && o[ae] == "Xbox" && this.set(se, "Xbox").set(ce, void 0);
        break;
      case Oa:
        var v = this.data, y = function(w) {
          return v[w].getItem().setCH(o).parseCH().get();
        };
        this.set(zn, y(zn)).set(No, y(No)).set(to, y(to)).set(Vr, y(Vr)).set(rr, y(rr));
    }
    return this;
  }, Fo.call(this, [
    ["itemType", e],
    ["ua", t],
    ["uaCH", r],
    ["rgxMap", n],
    ["data", kG(this, e)]
  ]), this;
}
function bo(e, t, n) {
  if (typeof e === Zt.OBJECT ? (u5(e, !0) ? (typeof t === Zt.OBJECT && (n = t), t = e) : (n = e, t = void 0), e = void 0) : typeof e === Zt.STRING && !u5(t, !0) && (n = t, t = void 0), n)
    if (typeof n.append === Zt.FUNCTION) {
      var r = {};
      n.forEach(function(u, f) {
        r[String(f).toLowerCase()] = u;
      }), n = r;
    } else {
      var o = {};
      for (var i in n)
        n.hasOwnProperty(i) && (o[String(i).toLowerCase()] = n[i]);
      n = o;
    }
  if (!(this instanceof bo))
    return new bo(e, t, n).getResult();
  var a = typeof e === Zt.STRING ? e : (
    // Passed user-agent string
    n && n[Jg] ? n[Jg] : (
      // User-Agent from passed headers
      Zn && Zn.userAgent ? Zn.userAgent : (
        // navigator.userAgent
        Fa
      )
    )
  ), s = new lP(n, !0), l = t ? DG(dC, t) : dC, c = function(u) {
    return u == Oa ? function() {
      return new hC(u, a, l, s).set("ua", a).set(zn, this.getBrowser()).set(No, this.getCPU()).set(to, this.getDevice()).set(Vr, this.getEngine()).set(rr, this.getOS()).get();
    } : function() {
      return new hC(u, a, l[u], s).parseUA().get();
    };
  };
  return Fo.call(this, [
    ["getBrowser", c(zn)],
    ["getCPU", c(No)],
    ["getDevice", c(to)],
    ["getEngine", c(Vr)],
    ["getOS", c(rr)],
    ["getResult", c(Oa)],
    ["getUA", function() {
      return a;
    }],
    ["setUA", function(u) {
      return L2(u) && (a = f5(u, SG)), this;
    }]
  ]).setUA(a), this;
}
bo.VERSION = xG;
bo.BROWSER = zu([se, ce, Rl, oe]);
bo.CPU = zu([kn]);
bo.DEVICE = zu([ae, le, oe, al, Ve, Yt, pt, Xr, sl]);
bo.ENGINE = bo.OS = zu([se, ce]);
const cP = typeof window < "u" && typeof navigator < "u" ? navigator.userAgent : "", Fpe = (e = cP) => _e(() => {
  try {
    return new bo(e).getResult();
  } catch (n) {
    return console.error("Error parsing User Agent string:", n), null;
  }
}, [e]), uP = (e = cP) => _e(() => {
  try {
    return new bo(e).getOS().name === "Windows";
  } catch (n) {
    return console.error("Error parsing User Agent string:", n), null;
  }
}, [e]), LG = (e, t) => {
  if (e === t) return !0;
  if (e == null || t == null || typeof e != "object" || typeof t != "object")
    return !1;
  if (e instanceof Date && t instanceof Date)
    return e.getTime() === t.getTime();
  const n = Object.keys(e), r = Object.keys(t);
  return n.length !== r.length ? !1 : n.every((o) => Object.prototype.hasOwnProperty.call(t, o) ? LG(
    e[o],
    t[o]
  ) : !1);
};
function pC(e) {
  const t = Number(e);
  if (isNaN(t))
    return String(e);
  const n = Math.abs(t);
  let r;
  return n >= 1e6 ? r = (t / 1e6).toFixed(1).replace(/\.0$/, "") + "m" : n >= 1e3 ? r = (t / 1e3).toFixed(1).replace(/\.0$/, "") + "k" : r = t.toString(), r;
}
const Vpe = (e) => {
  let t = "";
  const n = window.URL || window.webkitURL;
  return e && (t = n.createObjectURL(e)), t;
}, B7 = (e) => {
  const t = e.match(/^(4|9)(\d{7})$/);
  if (t) {
    const [, n, r] = t;
    return `${n}${r.slice(0, 2)} ${r.slice(2, 4)} ${r.slice(
      4,
      7
    )}`;
  }
  return `${e.slice(0, 2)} ${e.slice(2, 4)} ${e.slice(
    4,
    6
  )} ${e.slice(6, 8)}`;
}, Bpe = (e) => {
  const t = String(e).replace(/ /g, ""), n = t.match(/^(0047|\+47)(\d{8})$/);
  if (n) {
    const [, o, i] = n;
    return `${o} ${B7(i)}`;
  }
  const r = t.match(/^(\+47)(\d{3})(\d{2})(\d{3})$/);
  if (r) {
    const [, o, i] = r;
    return `${o} ${B7(i)}`;
  }
  return t.length === 8 ? B7(t) : e ? t : "Ikke angitt";
}, $pe = (e) => e.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "").split("/")[0], jpe = (e) => e.startsWith("http") || e.startsWith("//") ? e : "https://" + e, Hpe = (e) => {
  const t = e / 1024;
  if (t < 1)
    return `${Math.max(0, Math.round(e))}B`;
  const n = t / 1024, r = n / 1024;
  let o, i;
  return t < 1024 ? (o = t, i = "KB") : n < 1024 ? (o = n, i = "MB") : (o = r, i = "GB"), `${o >= 100 ? o.toFixed(0) : o >= 10 ? o.toFixed(1) : o.toFixed(2)}${i}`;
}, NG = ({ placeholder: e }) => {
  const [t, n] = ue(""), r = wG(t, 500), o = ju(), i = ke(null), a = R1(768);
  if (!o)
    throw new Error(
      "RelationPickerSearch must be within a RelationPickerContext"
    );
  const {
    clients: s,
    setFilteredClients: l,
    filteredClients: c,
    currentClient: u,
    withClientNo: f
  } = o, h = ct(
    (C) => {
      const m = C.name?.toLowerCase() || "", g = C.no || "", v = r?.toLowerCase() || "";
      return m.includes(v) || g.toString().includes(v) || f && `${g} - ${m}`.includes(v);
    },
    [r, f]
  ), p = _e(() => r !== void 0 ? s?.filter(h) : o.clients, [s, r]);
  return ve(() => {
    r !== void 0 && p && o.setFilteredClients && l?.(p);
  }, [p, l, r]), ve(() => {
    setTimeout(() => {
      i.current && !a && i.current.focus();
    }, 50);
  }, [u, c]), /* @__PURE__ */ d(
    A1,
    {
      ref: i,
      autoFocus: !a,
      className: "mb-1",
      iconRight: /* @__PURE__ */ d(wa, { className: "mb-1" }),
      placeholder: e || "Søk etter selskap",
      value: t,
      onChange: (C) => n(C.target.value)
    }
  );
}, zpe = ({
  dark: e = !1,
  clients: t,
  currentClient: n,
  disabled: r,
  onSelect: o,
  searchPlaceholder: i,
  withClientNo: a = !1,
  icon: s = /* @__PURE__ */ d(Xfe, {})
}) => {
  const [l, c] = ue(
    n ?? t?.length ? t[0] : null
  ), [u, f] = ue(t), h = ke(
    t.map(
      (C) => a ? `${C.no} - ${C.name}` : C.name
    )
  ), p = (C) => {
    c(C), o?.(C);
  };
  return ve(() => {
    n && c(n);
  }, [n]), !t || t.length === 0 ? null : /* @__PURE__ */ d(
    fG,
    {
      value: {
        clients: t,
        dark: e,
        currentClient: l,
        disabled: r,
        withClientNo: a,
        labelsRef: h,
        onSelect: p,
        filteredClients: u,
        setFilteredClients: f,
        icon: s
      },
      children: /* @__PURE__ */ F(Mn, { autoSize: !0, labelsRef: h, typeaheadEnabled: !1, children: [
        /* @__PURE__ */ d(dG, {}),
        /* @__PURE__ */ F(Mn.Content, { className: "box-border max-h-80 w-full gap-9 overflow-hidden !p-sm", children: [
          /* @__PURE__ */ d(NG, { placeholder: i }),
          /* @__PURE__ */ d("div", { className: "max-h-44 overflow-y-auto", children: /* @__PURE__ */ d(mG, {}) })
        ] })
      ] })
    }
  );
}, fP = O.createContext({}), FG = fP.Provider, N2 = () => {
  const e = O.useContext(fP);
  if (!e)
    throw new Error(
      "useNotificationMenuContext must be used within a NotificationMenuProvider"
    );
  return e;
}, VG = ({
  notification: e,
  icon: t,
  chip: n,
  closeOnSelect: r = !0,
  isLast: o,
  children: i,
  onClick: a
}) => {
  const s = N2(), l = Xn(), c = (C) => {
    s.onSelect && s.onSelect(C), r && (l?.open && l.setOpen?.(!1), s.isMobileViewOpen && s.setMobileViewOpen?.(!1), a?.(C));
  }, { ref: u, index: f } = A2({ label: e.Title }), p = l?.activeIndex === f;
  return /* @__PURE__ */ d(
    "li",
    {
      className: I(
        "w-full border-b-[1px] border-border-light py-[10px]",
        o && "border-b-0"
      ),
      ref: u,
      children: /* @__PURE__ */ d(
        "button",
        {
          className: I(
            "flex w-full items-center gap-3 rounded-md p-sm hover:bg-surface-common-subtle",
            p && "bg-surface-common-subtle"
          ),
          onClick: () => c(e),
          children: /* @__PURE__ */ d(ut, { children: i || /* @__PURE__ */ F("div", { className: "flex w-full items-center justify-between", children: [
            /* @__PURE__ */ F("div", { className: "flex items-center gap-md text-text-brand", children: [
              t,
              /* @__PURE__ */ F("div", { className: "flex flex-col items-start text-left", children: [
                e.Title && /* @__PURE__ */ d(Rt, { weight: "semibold", children: e.Title }),
                e.Description && /* @__PURE__ */ d(Rt, { size: "small", children: e.Description })
              ] })
            ] }),
            n && n
          ] }) })
        }
      )
    }
  );
}, BG = () => {
  const e = Xn(), t = N2(), n = bt(), r = t?.shake || !1, o = t?.unread || 0, i = t?.dark || !1, a = I(
    "flex h-[36px] w-[36px] items-center justify-center rounded-full bg-surface-common-light",
    "group-hover:cursor-pointer",
    "hover:bg-surface-common-primary-light focus:bg-surface-common-primary-light",
    t.dark && "bg-surface-portalen-aside-highlight hover:bg-surface-portalen-aside-background"
  );
  return /* @__PURE__ */ F(
    Mn.Trigger,
    {
      className: "relative h-[36px] w-[36px] rounded-lg",
      id: n,
      "aria-label": "Open notifications",
      disabled: e?.disabled,
      children: [
        /* @__PURE__ */ d("div", { className: a, children: /* @__PURE__ */ d(
          dP,
          {
            colorVariant: "primary",
            className: I(
              "!h-[20px] !w-[20px]",
              r && "animate-wiggle",
              i && "text-surface-common-white"
            )
          }
        ) }),
        !!o && /* @__PURE__ */ d(
          "data",
          {
            "aria-live": "polite",
            role: "alert",
            "aria-label": `Du har ${o} uleste varsler`,
            value: o,
            className: I(
              "absolute right-[-5px] top-0 z-10 h-[16px] w-auto min-w-[14px] items-center justify-center rounded-full bg-surface-common-notification text-xs font-semibold text-text-primary",
              o > 99 ? "px-[4px]" : "px-[2px]"
            ),
            children: o
          }
        )
      ]
    }
  );
}, $G = ({ children: e }) => {
  const t = R1(768), n = Xn(), r = N2(), o = ke([]), i = n?.listRef;
  return t && r.isMobileViewOpen ? /* @__PURE__ */ F("div", { className: "absolute left-0 top-0 z-50 flex h-full flex-col gap-md overflow-y-auto bg-white px-[24px] pb-[24px] pt-[32px]", children: [
    /* @__PURE__ */ F("div", { className: "flex h-[40px] items-center gap-md", children: [
      /* @__PURE__ */ d(
        "button",
        {
          "aria-label": "Lukk varsler",
          onClick: () => n?.setOpen?.(!1),
          children: /* @__PURE__ */ d(qr, { className: "h-[24px] w-[24px]" })
        }
      ),
      /* @__PURE__ */ d(
        Rt,
        {
          className: "text-lead-mobile md:text-lead",
          weight: "semibold",
          children: "Varsler"
        }
      )
    ] }),
    e
  ] }) : /* @__PURE__ */ d(
    Mn.Content,
    {
      className: I(
        "max-h-[400px] max-w-[300px] overflow-auto rounded-lg md:h-fit"
      ),
      children: /* @__PURE__ */ d(O2, { elementsRef: i || o, children: e })
    }
  );
}, jG = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M5 19C4.71667 19 4.47917 18.9042 4.2875 18.7125C4.09583 18.5208 4 18.2833 4 18C4 17.7167 4.09583 17.4792 4.2875 17.2875C4.47917 17.0958 4.71667 17 5 17H6V10C6 8.61667 6.41667 7.3875 7.25 6.3125C8.08333 5.2375 9.16667 4.53333 10.5 4.2V3.5C10.5 3.08333 10.6458 2.72917 10.9375 2.4375C11.2292 2.14583 11.5833 2 12 2C12.4167 2 12.7708 2.14583 13.0625 2.4375C13.3542 2.72917 13.5 3.08333 13.5 3.5V4.2C14.8333 4.53333 15.9167 5.2375 16.75 6.3125C17.5833 7.3875 18 8.61667 18 10V17H19C19.2833 17 19.5208 17.0958 19.7125 17.2875C19.9042 17.4792 20 17.7167 20 18C20 18.2833 19.9042 18.5208 19.7125 18.7125C19.5208 18.9042 19.2833 19 19 19H5ZM12 22C11.45 22 10.9792 21.8042 10.5875 21.4125C10.1958 21.0208 10 20.55 10 20H14C14 20.55 13.8042 21.0208 13.4125 21.4125C13.0208 21.8042 12.55 22 12 22ZM8 17H16V10C16 8.9 15.6083 7.95833 14.825 7.175C14.0417 6.39167 13.1 6 12 6C10.9 6 9.95833 6.39167 9.175 7.175C8.39167 7.95833 8 8.9 8 10V17Z",
    fill: "currentColor"
  }
) }), dP = Q("IconNotifications")(jG), HG = () => {
  const e = N2(), t = bt(), n = e?.shake || !1, r = e?.unread || 0, o = e?.dark || !1, i = I(
    "flex h-[36px] w-[36px] items-center justify-center rounded-full bg-surface-common-light",
    "group-hover:cursor-pointer",
    "transition-all duration-75 ease-in-out",
    "hover:bg-surface-common-primary-light focus:bg-surface-common-primary-light",
    o && "bg-surface-portalen-aside-highlight hover:bg-surface-portalen-aside-background"
  );
  return /* @__PURE__ */ F(
    "button",
    {
      className: I("relative h-[36px] w-[36px] cursor-pointer rounded-lg"),
      disabled: e.disabled,
      "aria-label": "Open notifications",
      id: t,
      onClick: () => e.setMobileViewOpen?.(!0),
      children: [
        /* @__PURE__ */ d("div", { className: i, children: /* @__PURE__ */ d(
          dP,
          {
            colorVariant: "primary",
            className: I(
              n && "animate-wiggle",
              o && "text-surface-common-white"
            )
          }
        ) }),
        !!r && /* @__PURE__ */ d(
          "data",
          {
            "aria-live": "polite",
            role: "alert",
            "aria-label": `Du har ${r} uleste varsler`,
            value: r,
            className: I(
              "bg-primary absolute right-[-5px] top-0 z-10 h-[16px] w-auto min-w-[14px] items-center justify-center rounded-full bg-surface-common-notification text-xs font-semibold text-text-primary",
              r > 99 ? "px-[4px]" : "px-[2px]"
            ),
            children: r
          }
        )
      ]
    }
  );
}, zG = ({
  children: e
}) => {
  const t = N2();
  return t.isMobileViewOpen ? /* @__PURE__ */ d(
    vr,
    {
      fullSize: !0,
      closeButton: !1,
      open: !0,
      className: "flex h-full min-h-screen flex-col gap-md",
      children: /* @__PURE__ */ F(vr.Block, { className: "mt-md flex flex-col gap-md", children: [
        /* @__PURE__ */ F("div", { className: "flex h-[40px] items-center gap-md", children: [
          /* @__PURE__ */ d(
            "button",
            {
              "aria-label": "Lukk varsler",
              onClick: () => t?.setMobileViewOpen?.(!1),
              children: /* @__PURE__ */ d(qr, { className: "h-[24px] w-[24px]" })
            }
          ),
          /* @__PURE__ */ d(
            Rt,
            {
              className: "text-lead-mobile md:text-lead",
              weight: "semibold",
              children: "Varsler"
            }
          )
        ] }),
        e
      ] })
    }
  ) : null;
}, ZG = ({
  dark: e = !1,
  disabled: t,
  onSelect: n,
  children: r,
  unread: o,
  shake: i
}) => {
  const [a, s] = O.useState(!1), l = R1(768);
  return /* @__PURE__ */ d(
    FG,
    {
      value: {
        dark: e,
        disabled: t,
        onSelect: (u) => {
          n?.(u);
        },
        isMobileViewOpen: a,
        setMobileViewOpen: s,
        unread: o,
        shake: i
      },
      children: l ? /* @__PURE__ */ F(ut, { children: [
        /* @__PURE__ */ d(HG, {}),
        /* @__PURE__ */ d(zG, { children: r })
      ] }) : /* @__PURE__ */ F(Mn, { children: [
        /* @__PURE__ */ d(BG, {}),
        /* @__PURE__ */ d($G, { children: r })
      ] })
    }
  );
}, WG = ({
  children: e
}) => /* @__PURE__ */ d("div", { className: "mb-sm flex justify-between", children: e }), qG = ({
  children: e
}) => {
  const t = R1(768);
  return /* @__PURE__ */ d("ul", { className: I("flex flex-col", t && "gap-[4px]"), children: e });
}, Zu = Object.assign(ZG, {
  List: qG,
  Item: VG,
  Header: WG
});
Zu.displayName = "NotificationMenu";
Zu.List.displayName = "NotificationMenu.List";
Zu.Item.displayName = "NotificationMenu.Item";
Zu.Header.displayName = "NotificationMenu.Header";
const yh = O.createContext(
  {}
), UG = ({
  label: e,
  value: t,
  children: n,
  icon: r,
  variant: o = "nostyle",
  className: i,
  onClick: a,
  ...s
}) => {
  const { activeIndex: l, setIsOpen: c, getItemProps: u } = O.useContext(yh), { ref: f, index: h } = A2({ label: e }), p = l === h, m = I(
    "group flex w-full items-center justify-between rounded-md p-sm outline-none ring-0 group-hover:cursor-pointer",
    p && o === "nostyle" && "bg-neutral-100 hover:bg-surface-common-subtle focus:bg-surface-common-subtle",
    i
  ), g = () => {
    a?.(t || e || ""), c(!1);
  };
  return !(t || e) && !n ? (console.warn("ContextMenuOption: value or label is required"), null) : /* @__PURE__ */ d("li", { role: "menuitem", children: n ? /* @__PURE__ */ d(
    "div",
    {
      ref: f,
      className: I(m, "px-0"),
      role: "menuitem",
      "aria-current": p,
      tabIndex: p ? 0 : -1,
      onClick: g,
      onKeyDown: (y) => {
        (y.key === "Enter" || y.key === " ") && g();
      },
      ...bi(["align"], s),
      children: n
    }
  ) : /* @__PURE__ */ d(
    Dt,
    {
      ref: f,
      variant: o,
      className: m,
      role: "menuitem",
      "aria-current": p,
      ...s,
      ...u(),
      tabIndex: p ? 0 : -1,
      onClick: g,
      children: /* @__PURE__ */ F("div", { className: "flex min-h-fit items-center gap-sm", children: [
        r && /* @__PURE__ */ d(
          "div",
          {
            className: I(
              "flex h-[24px] w-[24px] items-center justify-center"
            ),
            children: r
          }
        ),
        /* @__PURE__ */ d(Ut, { className: "text-[14px] hover:cursor-pointer md:text-[15px]", children: e || n })
      ] })
    }
  ) });
}, GG = Xe(
  ({
    referenceProps: e,
    variant: t = "nostyle",
    title: n = "Åpne menyen",
    icon: r,
    children: o
  }, i) => {
    const a = Oe(yh), { disabled: s } = a, l = !o && r, c = t === "profile" ? "nostyle" : t, u = a.dark, f = I(
      "flex w-full items-center justify-between gap-sm",
      u && "[&>div>]!text-text-invert"
    ), h = I(
      "transition-all duration-75 ease-in-out",
      l && "justify-center px-sm",
      t === "profile" && I(
        "group w-fit rounded-[8px] group-hover:cursor-pointer hover:bg-surface-common-light md:px-[4px] md:py-[4px] md:pl-[16px]"
      ),
      u && I("hover:bg-surface-portalen-aside-highlight")
    ), p = I(
      "group flex items-center justify-center rounded-full bg-surface-common-light group-hover:bg-surface-common-light",
      "h-[36px] w-[36px] cursor-pointer",
      u && "bg-surface-portalen-aside-highlight group-hover:bg-surface-portalen-aside-highlight"
    ), C = _e(() => r, [r]), m = ct(() => t === "profile" ? /* @__PURE__ */ d("div", { className: p, children: C || /* @__PURE__ */ d(
      Dfe,
      {
        colorVariant: "primary",
        className: I(
          "!h-[20px] !w-[20px]",
          u && "text-surface-common-white"
        )
      }
    ) }) : C || null, [C, t, u]);
    return /* @__PURE__ */ d(
      Dt,
      {
        ref: i,
        title: n,
        variant: c,
        className: h,
        ...e,
        tabIndex: 0,
        disabled: s,
        "aria-expanded": a.isOpen,
        "aria-labelledby": a.labelId,
        "aria-describedby": a.descriptionId,
        children: /* @__PURE__ */ d("div", { className: f, children: /* @__PURE__ */ F(
          "div",
          {
            className: I(
              "flex flex-1 items-center justify-center gap-sm",
              u && "[&>div>label]:!text-text-invert [&>div>p]:!text-text-invert [&>div>span]:!text-text-invert"
            ),
            children: [
              o,
              " ",
              /* @__PURE__ */ d(m, {})
            ]
          }
        ) })
      }
    );
  }
), KG = ({
  listRef: e,
  labelsRef: t,
  defaultOpen: n
}) => {
  const [r, o] = ue(n), [i, a] = ue(null), [s, l] = ue(null), [c, u] = ue(null), [f, h] = ue(null), { refs: p, floatingStyles: C, context: m } = Ri({
    placement: "bottom-start",
    open: r,
    onOpenChange: o,
    whileElementsMounted: D1,
    middleware: [
      Ii(),
      Ti(7),
      _2({
        apply({ elements: T }) {
          requestAnimationFrame(() => {
            Object.assign(T.floating.style, {
              // reference width - padding of the floating element
              width: "auto",
              minWidth: "200px",
              maxHeight: "200px"
            });
          });
        }
      })
    ]
  }), g = O.useCallback(
    ({ value: T, index: _ }) => {
      l(_), o(!1), _ !== null && (u(t.current[_]), h(T ?? null));
    },
    []
  );
  function v(T) {
    r ? a(T) : T !== null && g({
      index: T,
      value: t.current[T] ?? ""
    });
  }
  const y = Iu(m, {
    listRef: e,
    scrollItemIntoView: !0,
    enabled: r,
    activeIndex: i,
    selectedIndex: s,
    onNavigate: a
  }), w = Hd(m, {
    listRef: t,
    activeIndex: i,
    selectedIndex: s,
    onMatch: v
  }), x = Pu(m), b = Di(m), S = Li(m, { role: "listbox" }), { getReferenceProps: M, getFloatingProps: E, getItemProps: P } = ki(
    [y, w, x, b, S]
  );
  return {
    isOpen: r,
    activeIndex: i,
    selectedIndex: s,
    selectedLabel: c,
    selectedValue: f,
    refs: p,
    floatingStyles: C,
    context: m,
    getReferenceProps: M,
    getFloatingProps: E,
    getItemProps: P,
    setIsOpen: o
  };
}, YG = ({
  children: e,
  triggerLabel: t,
  triggerIcon: n,
  triggerVariant: r,
  defaultOpen: o,
  size: i = "default",
  dark: a = !1,
  disabled: s = !1,
  className: l
}) => {
  const c = O.useRef([]), u = O.useRef([]), f = bt(), h = f + "-label", p = f + "-list", C = f + "-description", {
    isOpen: m,
    activeIndex: g,
    selectedIndex: v,
    refs: y,
    floatingStyles: w,
    context: x,
    getReferenceProps: b,
    getFloatingProps: S,
    getItemProps: M,
    setIsOpen: E
  } = KG({
    listRef: c,
    labelsRef: u,
    defaultOpen: o ?? !1
  }), P = O.useMemo(
    () => ({
      id: f,
      triggerLabel: t,
      labelId: h,
      listId: p,
      descriptionId: C,
      activeIndex: g,
      selectedIndex: v,
      getItemProps: M,
      dark: a,
      isOpen: m ?? !1,
      setIsOpen: E,
      size: i,
      disabled: s
    }),
    [
      f,
      h,
      p,
      C,
      g,
      v,
      M,
      m,
      E,
      a,
      i,
      s
    ]
  );
  return R2(m), /* @__PURE__ */ F(yh.Provider, { value: P, children: [
    /* @__PURE__ */ d("div", { className: I("flex w-full flex-col gap-xs", l), children: /* @__PURE__ */ d(
      GG,
      {
        icon: n,
        variant: r,
        ref: y.setReference,
        referenceProps: b(),
        children: t
      }
    ) }),
    m && /* @__PURE__ */ d(
      ms,
      {
        context: x,
        modal: !1,
        visuallyHiddenDismiss: !0,
        initialFocus: 0,
        children: /* @__PURE__ */ d(
          "div",
          {
            ref: y.setFloating,
            id: p,
            "aria-label": "ContextMenu options",
            style: {
              ...w,
              outline: "none",
              zIndex: 999
            },
            ...S(),
            tabIndex: -1,
            children: /* @__PURE__ */ d(O2, { elementsRef: c, labelsRef: u, children: /* @__PURE__ */ d(
              "ul",
              {
                role: "menu",
                tabIndex: -1,
                className: "border-input z-[999] flex max-h-[350px] w-full flex-col overflow-auto overflow-y-auto rounded-md border bg-white px-md pb-sm pt-md shadow-modal focus:border-none focus:outline-none focus:ring-0 focus:ring-offset-0",
                children: e
              }
            ) })
          }
        )
      }
    )
  ] });
}, XG = ({
  className: e,
  children: t
}) => /* @__PURE__ */ d("li", { role: "menuitem", className: I(e), children: t }), QG = () => /* @__PURE__ */ d("li", { className: "flex py-[8px]", role: "presentation", children: /* @__PURE__ */ d("span", { className: "h-[1px] w-full bg-border-light" }) }), bh = Object.assign(YG, {
  Option: UG,
  Node: XG,
  Spacer: QG
});
bh.Option.displayName = "ContextMenu.Option";
bh.Node.displayName = "ContextMenu.Node";
bh.Spacer.displayName = "ContextMenu.Spacer";
const Zpe = ({ open: e, children: t, className: n }) => {
  const r = I(
    "mt-[10vh] flex flex-col overflow-hidden overflow-y-auto",
    !e && "ml-[20%] w-[80%] pl-0",
    e && "w-calc(100%-26px) ml-0 pl-[26px]",
    n
  );
  return /* @__PURE__ */ d("nav", { children: /* @__PURE__ */ d("ul", { className: r, children: t }) });
}, Wpe = ({ open: e, mysite: t, children: n, className: r }) => {
  const o = R1(768), i = I(
    "z-[98] flex h-[calc(100vh-20px)] flex-col items-center justify-start overflow-hidden pt-[20px] transition-all duration-[0.2s] ease-in-out",
    t ? "bg-surface-min-side-aside-background" : "bg-surface-portalen-aside-background",
    e ? "w-full md:w-[300px]" : "w-[72px]",
    o && I("box-border h-full"),
    r
  );
  return /* @__PURE__ */ d("div", { className: i, children: n });
}, JG = ({
  children: e,
  ...t
}) => /* @__PURE__ */ d("a", { ...t, children: e }), qpe = ({
  small: e,
  logo: t,
  logoHref: n,
  onLogoClick: r,
  className: o,
  children: i
}) => /* @__PURE__ */ F(ut, { children: [
  t && /* @__PURE__ */ d(
    JG,
    {
      href: n || "/",
      onClick: r,
      trackingName: "Sidemenu",
      trackingEvent: "Menu click: logo",
      children: /* @__PURE__ */ d(
        "img",
        {
          className: I(
            "max-h-[40px] cursor-pointer",
            e ? "max-w-full" : "max-w-[auto]"
          ),
          src: t,
          alt: "logo"
        }
      )
    }
  ),
  /* @__PURE__ */ d(
    "div",
    {
      className: I(
        "my-[32px] box-border flex min-h-[72px] w-full items-start justify-start overflow-visible !px-[12px] [&>a:nth-of-type(2)]:ml-[0.5rem]",
        o
      ),
      children: i
    }
  )
] });
var la = /* @__PURE__ */ ((e) => (e.MinSide = "Min side", e.Portalen = "Portalen", e))(la || {});
const hP = O.createContext({}), eK = hP.Provider, pP = () => {
  const e = O.useContext(hP);
  if (!e)
    throw new Error(
      "useAppPickerContext must be used within a AppPickerProvider"
    );
  return e;
}, tK = ({ children: e }) => {
  const t = Xn();
  if (!t)
    throw new Error("AppPickerList must be used within a AppPicker component");
  ve(() => {
    t.setActiveIndex(0);
  }, []);
  const n = t.listRef;
  return /* @__PURE__ */ d(O2, { elementsRef: n, children: e });
}, nK = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 16 16", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M8 0C12.416 0 16 3.584 16 8C16 12.416 12.416 16 8 16C3.584 16 0 12.416 0 8C0 3.584 3.584 0 8 0ZM6 10.4958C5.06459 10.4958 3.42569 10.8648 2.73342 11.63C4.59881 14.2741 7.26495 14.3943 7.92035 14.3997L8 14.4C8.566 14.4 9.09933 14.3335 9.6 14.2005V12.4045C9.582 11.1713 7.194 10.4958 6 10.4958ZM11.7442 2.8H6.69091V4.8C8.02318 5.33333 8.68931 6.21972 8.68931 7.45916C8.68931 8.69859 8.12468 9.49615 6.99543 9.85183C7.62982 9.89789 8.23156 10.0451 8.80064 10.2935L8.8 9.6H10.16V10.96L9.94174 10.9594C10.0974 11.0751 10.2501 11.1998 10.4 11.3333V13.9297C11.3862 13.6086 14.4 11.6883 14.4 8.36484C14.5145 5.21523 12.6421 3.45068 11.7442 2.8ZM12.56 9.6V10.96H11.2V9.6H12.56ZM6 5.6C5.004 5.6 4.2 6.43042 4.2 7.45916C4.2 8.48789 5.004 9.31831 6 9.31831C6.996 9.31831 7.8 8.48789 7.8 7.45916C7.8 6.43042 6.996 5.6 6 5.6ZM12.56 7.2V8.56H11.2V7.2H12.56ZM10.16 7.2V8.56H8.8V7.2H10.16ZM12.56 4.8V6.16H11.2V4.8H12.56ZM10.16 4.8V6.16H8.8V4.8H10.16Z",
    fill: "currentColor"
  }
) }), rK = Q("IconUserBuilding")(nK), oK = () => {
  const e = pP(), t = Xn(), n = bt();
  if (!t)
    throw new Error("AppPickerTrigger must be used within a Popover component");
  const { open: r, disabled: o } = t, { small: i, variant: a } = e, s = a === "dark", l = a === "light", c = e.selected, u = c?.value === la.MinSide, f = I(
    "flex items-center justify-between gap-[8px] rounded-lg px-[11px] py-[6px] transition-all duration-75 ease-in-out",
    "group-hover:cursor-pointer",
    "hover:bg-surface-common-light",
    l && "bg-surface-common-subtle hover:bg-surface-common-primary-light",
    s && "border border-surface-portalen-aside-highlight bg-surface-portalen-aside-background hover:bg-surface-portalen-aside-highlight",
    i && "box-border min-w-6 justify-center rounded-[10px] px-[4px]"
  );
  return /* @__PURE__ */ d(
    Mn.Trigger,
    {
      className: I(
        "w-full min-w-[100px] max-w-full rounded-lg",
        i && "h-auto min-w-[36px]"
      ),
      id: n,
      "aria-label": "pick company",
      disabled: e?.disabled,
      children: /* @__PURE__ */ F("div", { className: f, children: [
        /* @__PURE__ */ F(
          "div",
          {
            className: I("group flex items-center gap-sm", i && "flex-col"),
            children: [
              u ? /* @__PURE__ */ d(
                nde,
                {
                  colorVariant: "primary",
                  className: I(
                    "!h-[20px] !w-[20px] md:!h-[20px] md:!w-[20px]",
                    s && "text-surface-common-primary-light"
                  )
                }
              ) : /* @__PURE__ */ d(
                rK,
                {
                  colorVariant: "primary",
                  className: I(
                    "!h-[20px] !w-[20px] md:!h-[20px] md:!w-[20px]",
                    s && "text-surface-common-primary-light"
                  )
                }
              ),
              /* @__PURE__ */ d(
                Ut,
                {
                  weight: "semibold",
                  className: I(
                    "cursor-pointer !text-[12px] text-text-brand md:!text-[14px]",
                    i && "!text-[12px] md:!text-[12px]",
                    s && "text-text-invert"
                  ),
                  children: c?.label || c?.value
                }
              )
            ]
          }
        ),
        !i && /* @__PURE__ */ d(
          Gr,
          {
            flipVertical: r,
            accessibilityLabel: r ? "arrow up" : "arrow down",
            className: I(
              "text-text-brand",
              o && "text-neutral-500",
              s && "text-text-invert",
              l && "text-surface-common-icon-color"
            ),
            "aria-hidden": "true"
          }
        )
      ] })
    }
  );
}, iK = ({
  variant: e = "light",
  selected: t = {
    value: la.MinSide
  },
  small: n,
  disabled: r,
  withPortal: o = !1,
  children: i
}) => {
  const [a, s] = ue({
    value: t.value
  }), l = ke([
    la.MinSide,
    la.Portalen
  ]), u = _e(() => O.Children.map(i, (h) => O.isValidElement(h) ? h.props : null), []) || [];
  return /* @__PURE__ */ d(
    eK,
    {
      value: {
        variant: e,
        disabled: r,
        small: n,
        withPortal: o,
        selected: {
          // @ts-expect-error: disable-next-line
          label: u?.find((f) => f.value === a.value)?.label,
          value: a.value || la.MinSide
        },
        onSelect: (f) => {
          s(f);
        }
      },
      children: /* @__PURE__ */ F(Mn, { autoSize: !0, labelsRef: l, children: [
        /* @__PURE__ */ d(oK, {}),
        /* @__PURE__ */ d(
          Mn.Content,
          {
            withPortal: o,
            className: "z-[9999] min-w-[100px] gap-9 !rounded-md !px-0 !py-sm !shadow-lg",
            children: /* @__PURE__ */ d(tK, { children: i })
          }
        )
      ] })
    }
  );
}, aK = ({
  label: e,
  value: t,
  href: n,
  className: r
}) => {
  const o = bt(), i = pP(), a = Xn();
  if (!a)
    throw new Error("AppPickerOption must be used within a AppPicker component");
  const { activeIndex: s } = a, { ref: l, index: c } = A2({ label: e }), u = s === c, f = i.selected?.value === t, h = () => {
    t && (i.onSelect?.({
      value: t,
      label: e
    }), a.setOpen(!1));
  };
  return /* @__PURE__ */ d(
    "a",
    {
      ref: l,
      id: o,
      "aria-current": f,
      "aria-label": "Pick application",
      tabIndex: u ? 0 : -1,
      className: I(
        "ring-none my-[1px] flex h-[39px] w-full cursor-pointer items-center justify-between gap-sm border-none no-underline outline-none hover:bg-surface-common-subtle",
        "focus:bg-surface-common-subtle focus:font-semibold focus:ring-surface-common-primary-light",
        f && u && "bg-surface-common-subtle font-semibold hover:bg-surface-common-light",
        u && "bg-surface-common-light",
        r
      ),
      href: n,
      onClick: h,
      children: /* @__PURE__ */ d("span", { className: "flex w-full justify-between gap-xs px-sm", children: e || t })
    },
    o
  );
}, Upe = Object.assign(iK, {
  App: aK
}), Gpe = O.memo(
  ({
    sideBar: e,
    topBar: t,
    isOpen: n,
    children: r,
    footer: o,
    onSkipToMainContent: i,
    onSkipToNav: a
  }) => {
    const s = /* @__PURE__ */ d(
      "button",
      {
        className: "focus fixed left-[-999px] top-[1px] -z-[9999] h-[1px] w-[1px] overflow-hidden border-none focus-visible:left-[1px] focus-visible:z-[9999] focus-visible:h-auto focus-visible:w-auto focus-visible:overflow-auto focus-visible:bg-white focus-visible:p-[5px]",
        onClick: i,
        role: "link",
        "data-tracking-name": "Felles",
        "data-tracking-event": "Klikk: Gå til hovedinnhold",
        children: "Gå til hovedinnhold"
      }
    ), l = /* @__PURE__ */ d(
      "button",
      {
        className: "focus fixed left-[-999px] top-[1px] -z-[9999] h-[1px] w-[1px] overflow-hidden border-none focus-visible:left-[1px] focus-visible:z-[9999] focus-visible:h-auto focus-visible:w-auto focus-visible:overflow-auto focus-visible:bg-white focus-visible:p-[5px]",
        role: "link",
        onClick: a,
        "data-tracking-name": "Felles",
        "data-tracking-event": "Klikk: Gå til undermeny",
        children: "Gå til undermeny"
      }
    ), c = !!e;
    return /* @__PURE__ */ d("div", { className: I(c ? "flex flex-col" : "pb-[80px]"), children: /* @__PURE__ */ F("div", { className: "box-border flex", children: [
      a && l,
      i && s,
      c ? /* @__PURE__ */ d(
        "aside",
        {
          className: I(
            "relative transition-all duration-[0.2s] ease-in-out",
            n ? "w-[300px]" : "w-[72px]"
          ),
          children: e
        }
      ) : /* @__PURE__ */ d(vu, {}),
      /* @__PURE__ */ F(
        "div",
        {
          className: I(
            "flex min-h-[100vh] w-full min-w-0 max-w-full flex-1 flex-col transition-all duration-[0.2s] ease-in-out"
          ),
          children: [
            t,
            /* @__PURE__ */ d("main", { className: "row-start-2 flex w-full flex-1 flex-col bg-surface-common-background", children: r }),
            c ? /* @__PURE__ */ d("div", { className: "col-span-full mt-auto", children: o }) : o
          ]
        }
      )
    ] }) });
  }
), Kpe = ({
  as: e = "section",
  grid: t = !1,
  centered: n = !1,
  className: r,
  children: o
}) => {
  const i = e, a = I(
    "flex h-screen flex-col px-[1rem] py-[1.5rem] md:px-[2.5rem] md:py-[2rem]",
    t && "grid grid-cols-4 gap-[30px] md:grid-cols-12",
    n && "items-center",
    r
  );
  return /* @__PURE__ */ d(i, { className: a, children: o });
}, wh = gt({});
function Wu(e) {
  const t = ke(null);
  return t.current === null && (t.current = e()), t.current;
}
const xh = typeof window < "u", mP = xh ? x2 : ve, qu = /* @__PURE__ */ gt(null);
function Sh(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function Uu(e, t) {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
const Yo = (e, t, n) => n > t ? t : n < e ? e : n;
function L9(e, t) {
  return t ? `${e}. For more information and steps for solving, visit https://motion.dev/troubleshooting/${t}` : e;
}
let ys = () => {
}, Er = () => {
};
process.env.NODE_ENV !== "production" && (ys = (e, t, n) => {
  !e && typeof console < "u" && console.warn(L9(t, n));
}, Er = (e, t, n) => {
  if (!e)
    throw new Error(L9(t, n));
});
const Xo = {}, gP = (e) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(e);
function CP(e) {
  return typeof e == "object" && e !== null;
}
const vP = (e) => /^0[^.\s]+$/u.test(e);
// @__NO_SIDE_EFFECTS__
function Mh(e) {
  let t;
  return () => (t === void 0 && (t = e()), t);
}
const wr = /* @__NO_SIDE_EFFECTS__ */ (e) => e, sK = (e, t) => (n) => t(e(n)), F2 = (...e) => e.reduce(sK), Ba = /* @__NO_SIDE_EFFECTS__ */ (e, t, n) => {
  const r = t - e;
  return r === 0 ? 1 : (n - e) / r;
};
class Eh {
  constructor() {
    this.subscriptions = [];
  }
  add(t) {
    return Sh(this.subscriptions, t), () => Uu(this.subscriptions, t);
  }
  notify(t, n, r) {
    const o = this.subscriptions.length;
    if (o)
      if (o === 1)
        this.subscriptions[0](t, n, r);
      else
        for (let i = 0; i < o; i++) {
          const a = this.subscriptions[i];
          a && a(t, n, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const xr = /* @__NO_SIDE_EFFECTS__ */ (e) => e * 1e3, yr = /* @__NO_SIDE_EFFECTS__ */ (e) => e / 1e3;
function yP(e, t) {
  return t ? e * (1e3 / t) : 0;
}
const mC = /* @__PURE__ */ new Set();
function _h(e, t, n) {
  e || mC.has(t) || (console.warn(L9(t, n)), mC.add(t));
}
const lK = (e, t, n) => {
  const r = t - e;
  return ((n - e) % r + r) % r + e;
}, bP = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e, cK = 1e-7, uK = 12;
function fK(e, t, n, r, o) {
  let i, a, s = 0;
  do
    a = t + (n - t) / 2, i = bP(a, r, o) - e, i > 0 ? n = a : t = a;
  while (Math.abs(i) > cK && ++s < uK);
  return a;
}
function V2(e, t, n, r) {
  if (e === t && n === r)
    return wr;
  const o = (i) => fK(i, 0, 1, e, n);
  return (i) => i === 0 || i === 1 ? i : bP(o(i), t, r);
}
const wP = (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, xP = (e) => (t) => 1 - e(1 - t), SP = /* @__PURE__ */ V2(0.33, 1.53, 0.69, 0.99), Oh = /* @__PURE__ */ xP(SP), MP = /* @__PURE__ */ wP(Oh), EP = (e) => (e *= 2) < 1 ? 0.5 * Oh(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), Ah = (e) => 1 - Math.sin(Math.acos(e)), _P = xP(Ah), OP = wP(Ah), dK = /* @__PURE__ */ V2(0.42, 0, 1, 1), hK = /* @__PURE__ */ V2(0, 0, 0.58, 1), AP = /* @__PURE__ */ V2(0.42, 0, 0.58, 1), PP = (e) => Array.isArray(e) && typeof e[0] != "number";
function TP(e, t) {
  return PP(e) ? e[lK(0, e.length, t)] : e;
}
const IP = (e) => Array.isArray(e) && typeof e[0] == "number", gC = {
  linear: wr,
  easeIn: dK,
  easeInOut: AP,
  easeOut: hK,
  circIn: Ah,
  circInOut: OP,
  circOut: _P,
  backIn: Oh,
  backInOut: MP,
  backOut: SP,
  anticipate: EP
}, pK = (e) => typeof e == "string", CC = (e) => {
  if (IP(e)) {
    Er(e.length === 4, "Cubic bezier arrays must contain four numerical values.", "cubic-bezier-length");
    const [t, n, r, o] = e;
    return V2(t, n, r, o);
  } else if (pK(e))
    return Er(gC[e] !== void 0, `Invalid easing type '${e}'`, "invalid-easing-type"), gC[e];
  return e;
}, gc = [
  "setup",
  // Compute
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "preUpdate",
  // Compute
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
];
function mK(e, t) {
  let n = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), o = !1, i = !1;
  const a = /* @__PURE__ */ new WeakSet();
  let s = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function l(u) {
    a.has(u) && (c.schedule(u), e()), u(s);
  }
  const c = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (u, f = !1, h = !1) => {
      const C = h && o ? n : r;
      return f && a.add(u), C.has(u) || C.add(u), u;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (u) => {
      r.delete(u), a.delete(u);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (u) => {
      if (s = u, o) {
        i = !0;
        return;
      }
      o = !0, [n, r] = [r, n], n.forEach(l), n.clear(), o = !1, i && (i = !1, c.process(u));
    }
  };
  return c;
}
const gK = 40;
function DP(e, t) {
  let n = !1, r = !0;
  const o = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, i = () => n = !0, a = gc.reduce((w, x) => (w[x] = mK(i), w), {}), { setup: s, read: l, resolveKeyframes: c, preUpdate: u, update: f, preRender: h, render: p, postRender: C } = a, m = () => {
    const w = Xo.useManualTiming ? o.timestamp : performance.now();
    n = !1, Xo.useManualTiming || (o.delta = r ? 1e3 / 60 : Math.max(Math.min(w - o.timestamp, gK), 1)), o.timestamp = w, o.isProcessing = !0, s.process(o), l.process(o), c.process(o), u.process(o), f.process(o), h.process(o), p.process(o), C.process(o), o.isProcessing = !1, n && t && (r = !1, e(m));
  }, g = () => {
    n = !0, r = !0, o.isProcessing || e(m);
  };
  return { schedule: gc.reduce((w, x) => {
    const b = a[x];
    return w[x] = (S, M = !1, E = !1) => (n || g(), b.schedule(S, M, E)), w;
  }, {}), cancel: (w) => {
    for (let x = 0; x < gc.length; x++)
      a[gc[x]].cancel(w);
  }, state: o, steps: a };
}
const { schedule: Tt, cancel: P1, state: Cn, steps: $7 } = /* @__PURE__ */ DP(typeof requestAnimationFrame < "u" ? requestAnimationFrame : wr, !0);
let Zc;
function CK() {
  Zc = void 0;
}
const qn = {
  now: () => (Zc === void 0 && qn.set(Cn.isProcessing || Xo.useManualTiming ? Cn.timestamp : performance.now()), Zc),
  set: (e) => {
    Zc = e, queueMicrotask(CK);
  }
}, RP = (e) => (t) => typeof t == "string" && t.startsWith(e), Ph = /* @__PURE__ */ RP("--"), vK = /* @__PURE__ */ RP("var(--"), Th = (e) => vK(e) ? yK.test(e.split("/*")[0].trim()) : !1, yK = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, bs = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, kl = {
  ...bs,
  transform: (e) => Yo(0, 1, e)
}, Cc = {
  ...bs,
  default: 1
}, gl = (e) => Math.round(e * 1e5) / 1e5, Ih = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function bK(e) {
  return e == null;
}
const wK = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, Dh = (e, t) => (n) => !!(typeof n == "string" && wK.test(n) && n.startsWith(e) || t && !bK(n) && Object.prototype.hasOwnProperty.call(n, t)), kP = (e, t, n) => (r) => {
  if (typeof r != "string")
    return r;
  const [o, i, a, s] = r.match(Ih);
  return {
    [e]: parseFloat(o),
    [t]: parseFloat(i),
    [n]: parseFloat(a),
    alpha: s !== void 0 ? parseFloat(s) : 1
  };
}, xK = (e) => Yo(0, 255, e), j7 = {
  ...bs,
  transform: (e) => Math.round(xK(e))
}, ni = {
  test: /* @__PURE__ */ Dh("rgb", "red"),
  parse: /* @__PURE__ */ kP("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: n, alpha: r = 1 }) => "rgba(" + j7.transform(e) + ", " + j7.transform(t) + ", " + j7.transform(n) + ", " + gl(kl.transform(r)) + ")"
};
function SK(e) {
  let t = "", n = "", r = "", o = "";
  return e.length > 5 ? (t = e.substring(1, 3), n = e.substring(3, 5), r = e.substring(5, 7), o = e.substring(7, 9)) : (t = e.substring(1, 2), n = e.substring(2, 3), r = e.substring(3, 4), o = e.substring(4, 5), t += t, n += n, r += r, o += o), {
    red: parseInt(t, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: o ? parseInt(o, 16) / 255 : 1
  };
}
const N9 = {
  test: /* @__PURE__ */ Dh("#"),
  parse: SK,
  transform: ni.transform
}, B2 = /* @__NO_SIDE_EFFECTS__ */ (e) => ({
  test: (t) => typeof t == "string" && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), u1 = /* @__PURE__ */ B2("deg"), po = /* @__PURE__ */ B2("%"), Re = /* @__PURE__ */ B2("px"), MK = /* @__PURE__ */ B2("vh"), EK = /* @__PURE__ */ B2("vw"), vC = {
  ...po,
  parse: (e) => po.parse(e) / 100,
  transform: (e) => po.transform(e * 100)
}, ca = {
  test: /* @__PURE__ */ Dh("hsl", "hue"),
  parse: /* @__PURE__ */ kP("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(e) + ", " + po.transform(gl(t)) + ", " + po.transform(gl(n)) + ", " + gl(kl.transform(r)) + ")"
}, Jt = {
  test: (e) => ni.test(e) || N9.test(e) || ca.test(e),
  parse: (e) => ni.test(e) ? ni.parse(e) : ca.test(e) ? ca.parse(e) : N9.parse(e),
  transform: (e) => typeof e == "string" ? e : e.hasOwnProperty("red") ? ni.transform(e) : ca.transform(e),
  getAnimatableNone: (e) => {
    const t = Jt.parse(e);
    return t.alpha = 0, Jt.transform(t);
  }
}, _K = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function OK(e) {
  return isNaN(e) && typeof e == "string" && (e.match(Ih)?.length || 0) + (e.match(_K)?.length || 0) > 0;
}
const LP = "number", NP = "color", AK = "var", PK = "var(", yC = "${}", TK = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function Ll(e) {
  const t = e.toString(), n = [], r = {
    color: [],
    number: [],
    var: []
  }, o = [];
  let i = 0;
  const s = t.replace(TK, (l) => (Jt.test(l) ? (r.color.push(i), o.push(NP), n.push(Jt.parse(l))) : l.startsWith(PK) ? (r.var.push(i), o.push(AK), n.push(l)) : (r.number.push(i), o.push(LP), n.push(parseFloat(l))), ++i, yC)).split(yC);
  return { values: n, split: s, indexes: r, types: o };
}
function FP(e) {
  return Ll(e).values;
}
function VP(e) {
  const { split: t, types: n } = Ll(e), r = t.length;
  return (o) => {
    let i = "";
    for (let a = 0; a < r; a++)
      if (i += t[a], o[a] !== void 0) {
        const s = n[a];
        s === LP ? i += gl(o[a]) : s === NP ? i += Jt.transform(o[a]) : i += o[a];
      }
    return i;
  };
}
const IK = (e) => typeof e == "number" ? 0 : Jt.test(e) ? Jt.getAnimatableNone(e) : e;
function DK(e) {
  const t = FP(e);
  return VP(e)(t.map(IK));
}
const T1 = {
  test: OK,
  parse: FP,
  createTransformer: VP,
  getAnimatableNone: DK
};
function H7(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function RK({ hue: e, saturation: t, lightness: n, alpha: r }) {
  e /= 360, t /= 100, n /= 100;
  let o = 0, i = 0, a = 0;
  if (!t)
    o = i = a = n;
  else {
    const s = n < 0.5 ? n * (1 + t) : n + t - n * t, l = 2 * n - s;
    o = H7(l, s, e + 1 / 3), i = H7(l, s, e), a = H7(l, s, e - 1 / 3);
  }
  return {
    red: Math.round(o * 255),
    green: Math.round(i * 255),
    blue: Math.round(a * 255),
    alpha: r
  };
}
function d5(e, t) {
  return (n) => n > 0 ? t : e;
}
const Pt = (e, t, n) => e + (t - e) * n, z7 = (e, t, n) => {
  const r = e * e, o = n * (t * t - r) + r;
  return o < 0 ? 0 : Math.sqrt(o);
}, kK = [N9, ni, ca], LK = (e) => kK.find((t) => t.test(e));
function bC(e) {
  const t = LK(e);
  if (ys(!!t, `'${e}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable"), !t)
    return !1;
  let n = t.parse(e);
  return t === ca && (n = RK(n)), n;
}
const wC = (e, t) => {
  const n = bC(e), r = bC(t);
  if (!n || !r)
    return d5(e, t);
  const o = { ...n };
  return (i) => (o.red = z7(n.red, r.red, i), o.green = z7(n.green, r.green, i), o.blue = z7(n.blue, r.blue, i), o.alpha = Pt(n.alpha, r.alpha, i), ni.transform(o));
}, F9 = /* @__PURE__ */ new Set(["none", "hidden"]);
function NK(e, t) {
  return F9.has(e) ? (n) => n <= 0 ? e : t : (n) => n >= 1 ? t : e;
}
function FK(e, t) {
  return (n) => Pt(e, t, n);
}
function Rh(e) {
  return typeof e == "number" ? FK : typeof e == "string" ? Th(e) ? d5 : Jt.test(e) ? wC : $K : Array.isArray(e) ? BP : typeof e == "object" ? Jt.test(e) ? wC : VK : d5;
}
function BP(e, t) {
  const n = [...e], r = n.length, o = e.map((i, a) => Rh(i)(i, t[a]));
  return (i) => {
    for (let a = 0; a < r; a++)
      n[a] = o[a](i);
    return n;
  };
}
function VK(e, t) {
  const n = { ...e, ...t }, r = {};
  for (const o in n)
    e[o] !== void 0 && t[o] !== void 0 && (r[o] = Rh(e[o])(e[o], t[o]));
  return (o) => {
    for (const i in r)
      n[i] = r[i](o);
    return n;
  };
}
function BK(e, t) {
  const n = [], r = { color: 0, var: 0, number: 0 };
  for (let o = 0; o < t.values.length; o++) {
    const i = t.types[o], a = e.indexes[i][r[i]], s = e.values[a] ?? 0;
    n[o] = s, r[i]++;
  }
  return n;
}
const $K = (e, t) => {
  const n = T1.createTransformer(t), r = Ll(e), o = Ll(t);
  return r.indexes.var.length === o.indexes.var.length && r.indexes.color.length === o.indexes.color.length && r.indexes.number.length >= o.indexes.number.length ? F9.has(e) && !o.values.length || F9.has(t) && !r.values.length ? NK(e, t) : F2(BP(BK(r, o), o.values), n) : (ys(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different"), d5(e, t));
};
function $P(e, t, n) {
  return typeof e == "number" && typeof t == "number" && typeof n == "number" ? Pt(e, t, n) : Rh(e)(e, t);
}
const jK = (e) => {
  const t = ({ timestamp: n }) => e(n);
  return {
    start: (n = !0) => Tt.update(t, n),
    stop: () => P1(t),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => Cn.isProcessing ? Cn.timestamp : qn.now()
  };
}, jP = (e, t, n = 10) => {
  let r = "";
  const o = Math.max(Math.round(t / n), 2);
  for (let i = 0; i < o; i++)
    r += Math.round(e(i / (o - 1)) * 1e4) / 1e4 + ", ";
  return `linear(${r.substring(0, r.length - 2)})`;
}, h5 = 2e4;
function kh(e) {
  let t = 0;
  const n = 50;
  let r = e.next(t);
  for (; !r.done && t < h5; )
    t += n, r = e.next(t);
  return t >= h5 ? 1 / 0 : t;
}
function HP(e, t = 100, n) {
  const r = n({ ...e, keyframes: [0, t] }), o = Math.min(kh(r), h5);
  return {
    type: "keyframes",
    ease: (i) => r.next(o * i).value / t,
    duration: /* @__PURE__ */ yr(o)
  };
}
const HK = 5;
function zP(e, t, n) {
  const r = Math.max(t - HK, 0);
  return yP(n - e(r), t - r);
}
const kt = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
}, Z7 = 1e-3;
function zK({ duration: e = kt.duration, bounce: t = kt.bounce, velocity: n = kt.velocity, mass: r = kt.mass }) {
  let o, i;
  ys(e <= /* @__PURE__ */ xr(kt.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
  let a = 1 - t;
  a = Yo(kt.minDamping, kt.maxDamping, a), e = Yo(kt.minDuration, kt.maxDuration, /* @__PURE__ */ yr(e)), a < 1 ? (o = (c) => {
    const u = c * a, f = u * e, h = u - n, p = V9(c, a), C = Math.exp(-f);
    return Z7 - h / p * C;
  }, i = (c) => {
    const f = c * a * e, h = f * n + n, p = Math.pow(a, 2) * Math.pow(c, 2) * e, C = Math.exp(-f), m = V9(Math.pow(c, 2), a);
    return (-o(c) + Z7 > 0 ? -1 : 1) * ((h - p) * C) / m;
  }) : (o = (c) => {
    const u = Math.exp(-c * e), f = (c - n) * e + 1;
    return -Z7 + u * f;
  }, i = (c) => {
    const u = Math.exp(-c * e), f = (n - c) * (e * e);
    return u * f;
  });
  const s = 5 / e, l = WK(o, i, s);
  if (e = /* @__PURE__ */ xr(e), isNaN(l))
    return {
      stiffness: kt.stiffness,
      damping: kt.damping,
      duration: e
    };
  {
    const c = Math.pow(l, 2) * r;
    return {
      stiffness: c,
      damping: a * 2 * Math.sqrt(r * c),
      duration: e
    };
  }
}
const ZK = 12;
function WK(e, t, n) {
  let r = n;
  for (let o = 1; o < ZK; o++)
    r = r - e(r) / t(r);
  return r;
}
function V9(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const qK = ["duration", "bounce"], UK = ["stiffness", "damping", "mass"];
function xC(e, t) {
  return t.some((n) => e[n] !== void 0);
}
function GK(e) {
  let t = {
    velocity: kt.velocity,
    stiffness: kt.stiffness,
    damping: kt.damping,
    mass: kt.mass,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!xC(e, UK) && xC(e, qK))
    if (e.visualDuration) {
      const n = e.visualDuration, r = 2 * Math.PI / (n * 1.2), o = r * r, i = 2 * Yo(0.05, 1, 1 - (e.bounce || 0)) * Math.sqrt(o);
      t = {
        ...t,
        mass: kt.mass,
        stiffness: o,
        damping: i
      };
    } else {
      const n = zK(e);
      t = {
        ...t,
        ...n,
        mass: kt.mass
      }, t.isResolvedFromDuration = !0;
    }
  return t;
}
function Nl(e = kt.visualDuration, t = kt.bounce) {
  const n = typeof e != "object" ? {
    visualDuration: e,
    keyframes: [0, 1],
    bounce: t
  } : e;
  let { restSpeed: r, restDelta: o } = n;
  const i = n.keyframes[0], a = n.keyframes[n.keyframes.length - 1], s = { done: !1, value: i }, { stiffness: l, damping: c, mass: u, duration: f, velocity: h, isResolvedFromDuration: p } = GK({
    ...n,
    velocity: -/* @__PURE__ */ yr(n.velocity || 0)
  }), C = h || 0, m = c / (2 * Math.sqrt(l * u)), g = a - i, v = /* @__PURE__ */ yr(Math.sqrt(l / u)), y = Math.abs(g) < 5;
  r || (r = y ? kt.restSpeed.granular : kt.restSpeed.default), o || (o = y ? kt.restDelta.granular : kt.restDelta.default);
  let w;
  if (m < 1) {
    const b = V9(v, m);
    w = (S) => {
      const M = Math.exp(-m * v * S);
      return a - M * ((C + m * v * g) / b * Math.sin(b * S) + g * Math.cos(b * S));
    };
  } else if (m === 1)
    w = (b) => a - Math.exp(-v * b) * (g + (C + v * g) * b);
  else {
    const b = v * Math.sqrt(m * m - 1);
    w = (S) => {
      const M = Math.exp(-m * v * S), E = Math.min(b * S, 300);
      return a - M * ((C + m * v * g) * Math.sinh(E) + b * g * Math.cosh(E)) / b;
    };
  }
  const x = {
    calculatedDuration: p && f || null,
    next: (b) => {
      const S = w(b);
      if (p)
        s.done = b >= f;
      else {
        let M = b === 0 ? C : 0;
        m < 1 && (M = b === 0 ? /* @__PURE__ */ xr(C) : zP(w, b, S));
        const E = Math.abs(M) <= r, P = Math.abs(a - S) <= o;
        s.done = E && P;
      }
      return s.value = s.done ? a : S, s;
    },
    toString: () => {
      const b = Math.min(kh(x), h5), S = jP((M) => x.next(b * M).value, b, 30);
      return b + "ms " + S;
    },
    toTransition: () => {
    }
  };
  return x;
}
Nl.applyToOptions = (e) => {
  const t = HP(e, 100, Nl);
  return e.ease = t.ease, e.duration = /* @__PURE__ */ xr(t.duration), e.type = "keyframes", e;
};
function B9({ keyframes: e, velocity: t = 0, power: n = 0.8, timeConstant: r = 325, bounceDamping: o = 10, bounceStiffness: i = 500, modifyTarget: a, min: s, max: l, restDelta: c = 0.5, restSpeed: u }) {
  const f = e[0], h = {
    done: !1,
    value: f
  }, p = (E) => s !== void 0 && E < s || l !== void 0 && E > l, C = (E) => s === void 0 ? l : l === void 0 || Math.abs(s - E) < Math.abs(l - E) ? s : l;
  let m = n * t;
  const g = f + m, v = a === void 0 ? g : a(g);
  v !== g && (m = v - f);
  const y = (E) => -m * Math.exp(-E / r), w = (E) => v + y(E), x = (E) => {
    const P = y(E), T = w(E);
    h.done = Math.abs(P) <= c, h.value = h.done ? v : T;
  };
  let b, S;
  const M = (E) => {
    p(h.value) && (b = E, S = Nl({
      keyframes: [h.value, C(h.value)],
      velocity: zP(w, E, h.value),
      // TODO: This should be passing * 1000
      damping: o,
      stiffness: i,
      restDelta: c,
      restSpeed: u
    }));
  };
  return M(0), {
    calculatedDuration: null,
    next: (E) => {
      let P = !1;
      return !S && b === void 0 && (P = !0, x(E), M(E)), b !== void 0 && E >= b ? S.next(E - b) : (!P && x(E), h);
    }
  };
}
function KK(e, t, n) {
  const r = [], o = n || Xo.mix || $P, i = e.length - 1;
  for (let a = 0; a < i; a++) {
    let s = o(e[a], e[a + 1]);
    if (t) {
      const l = Array.isArray(t) ? t[a] || wr : t;
      s = F2(l, s);
    }
    r.push(s);
  }
  return r;
}
function YK(e, t, { clamp: n = !0, ease: r, mixer: o } = {}) {
  const i = e.length;
  if (Er(i === t.length, "Both input and output ranges must be the same length", "range-length"), i === 1)
    return () => t[0];
  if (i === 2 && t[0] === t[1])
    return () => t[1];
  const a = e[0] === e[1];
  e[0] > e[i - 1] && (e = [...e].reverse(), t = [...t].reverse());
  const s = KK(t, r, o), l = s.length, c = (u) => {
    if (a && u < e[0])
      return t[0];
    let f = 0;
    if (l > 1)
      for (; f < e.length - 2 && !(u < e[f + 1]); f++)
        ;
    const h = /* @__PURE__ */ Ba(e[f], e[f + 1], u);
    return s[f](h);
  };
  return n ? (u) => c(Yo(e[0], e[i - 1], u)) : c;
}
function ZP(e, t) {
  const n = e[e.length - 1];
  for (let r = 1; r <= t; r++) {
    const o = /* @__PURE__ */ Ba(0, t, r);
    e.push(Pt(n, 1, o));
  }
}
function WP(e) {
  const t = [0];
  return ZP(t, e.length - 1), t;
}
function XK(e, t) {
  return e.map((n) => n * t);
}
function QK(e, t) {
  return e.map(() => t || AP).splice(0, e.length - 1);
}
function ua({ duration: e = 300, keyframes: t, times: n, ease: r = "easeInOut" }) {
  const o = PP(r) ? r.map(CC) : CC(r), i = {
    done: !1,
    value: t[0]
  }, a = XK(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === t.length ? n : WP(t),
    e
  ), s = YK(a, t, {
    ease: Array.isArray(o) ? o : QK(t, o)
  });
  return {
    calculatedDuration: e,
    next: (l) => (i.value = s(l), i.done = l >= e, i)
  };
}
const JK = (e) => e !== null;
function Lh(e, { repeat: t, repeatType: n = "loop" }, r, o = 1) {
  const i = e.filter(JK), s = o < 0 || t && n !== "loop" && t % 2 === 1 ? 0 : i.length - 1;
  return !s || r === void 0 ? i[s] : r;
}
const eY = {
  decay: B9,
  inertia: B9,
  tween: ua,
  keyframes: ua,
  spring: Nl
};
function qP(e) {
  typeof e.type == "string" && (e.type = eY[e.type]);
}
class Nh {
  constructor() {
    this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this._finished = new Promise((t) => {
      this.resolve = t;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  /**
   * Allows the animation to be awaited.
   *
   * @deprecated Use `finished` instead.
   */
  then(t, n) {
    return this.finished.then(t, n);
  }
}
const tY = (e) => e / 100;
class Fh extends Nh {
  constructor(t) {
    super(), this.state = "idle", this.startTime = null, this.isStopped = !1, this.currentTime = 0, this.holdTime = null, this.playbackSpeed = 1, this.stop = () => {
      const { motionValue: n } = this.options;
      n && n.updatedAt !== qn.now() && this.tick(qn.now()), this.isStopped = !0, this.state !== "idle" && (this.teardown(), this.options.onStop?.());
    }, this.options = t, this.initAnimation(), this.play(), t.autoplay === !1 && this.pause();
  }
  initAnimation() {
    const { options: t } = this;
    qP(t);
    const { type: n = ua, repeat: r = 0, repeatDelay: o = 0, repeatType: i, velocity: a = 0 } = t;
    let { keyframes: s } = t;
    const l = n || ua;
    process.env.NODE_ENV !== "production" && l !== ua && Er(s.length <= 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${s}`, "spring-two-frames"), l !== ua && typeof s[0] != "number" && (this.mixKeyframes = F2(tY, $P(s[0], s[1])), s = [0, 100]);
    const c = l({ ...t, keyframes: s });
    i === "mirror" && (this.mirroredGenerator = l({
      ...t,
      keyframes: [...s].reverse(),
      velocity: -a
    })), c.calculatedDuration === null && (c.calculatedDuration = kh(c));
    const { calculatedDuration: u } = c;
    this.calculatedDuration = u, this.resolvedDuration = u + o, this.totalDuration = this.resolvedDuration * (r + 1) - o, this.generator = c;
  }
  updateTime(t) {
    const n = Math.round(t - this.startTime) * this.playbackSpeed;
    this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = n;
  }
  tick(t, n = !1) {
    const { generator: r, totalDuration: o, mixKeyframes: i, mirroredGenerator: a, resolvedDuration: s, calculatedDuration: l } = this;
    if (this.startTime === null)
      return r.next(0);
    const { delay: c = 0, keyframes: u, repeat: f, repeatType: h, repeatDelay: p, type: C, onUpdate: m, finalKeyframe: g } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, t) : this.speed < 0 && (this.startTime = Math.min(t - o / this.speed, this.startTime)), n ? this.currentTime = t : this.updateTime(t);
    const v = this.currentTime - c * (this.playbackSpeed >= 0 ? 1 : -1), y = this.playbackSpeed >= 0 ? v < 0 : v > o;
    this.currentTime = Math.max(v, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = o);
    let w = this.currentTime, x = r;
    if (f) {
      const E = Math.min(this.currentTime, o) / s;
      let P = Math.floor(E), T = E % 1;
      !T && E >= 1 && (T = 1), T === 1 && P--, P = Math.min(P, f + 1), !!(P % 2) && (h === "reverse" ? (T = 1 - T, p && (T -= p / s)) : h === "mirror" && (x = a)), w = Yo(0, 1, T) * s;
    }
    const b = y ? { done: !1, value: u[0] } : x.next(w);
    i && (b.value = i(b.value));
    let { done: S } = b;
    !y && l !== null && (S = this.playbackSpeed >= 0 ? this.currentTime >= o : this.currentTime <= 0);
    const M = this.holdTime === null && (this.state === "finished" || this.state === "running" && S);
    return M && C !== B9 && (b.value = Lh(u, this.options, g, this.speed)), m && m(b.value), M && this.finish(), b;
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(t, n) {
    return this.finished.then(t, n);
  }
  get duration() {
    return /* @__PURE__ */ yr(this.calculatedDuration);
  }
  get iterationDuration() {
    const { delay: t = 0 } = this.options || {};
    return this.duration + /* @__PURE__ */ yr(t);
  }
  get time() {
    return /* @__PURE__ */ yr(this.currentTime);
  }
  set time(t) {
    t = /* @__PURE__ */ xr(t), this.currentTime = t, this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0 ? this.holdTime = t : this.driver && (this.startTime = this.driver.now() - t / this.playbackSpeed), this.driver?.start(!1);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(t) {
    this.updateTime(qn.now());
    const n = this.playbackSpeed !== t;
    this.playbackSpeed = t, n && (this.time = /* @__PURE__ */ yr(this.currentTime));
  }
  play() {
    if (this.isStopped)
      return;
    const { driver: t = jK, startTime: n } = this.options;
    this.driver || (this.driver = t((o) => this.tick(o))), this.options.onPlay?.();
    const r = this.driver.now();
    this.state === "finished" ? (this.updateFinished(), this.startTime = r) : this.holdTime !== null ? this.startTime = r - this.holdTime : this.startTime || (this.startTime = n ?? r), this.state === "finished" && this.speed < 0 && (this.startTime += this.calculatedDuration), this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    this.state = "paused", this.updateTime(qn.now()), this.holdTime = this.currentTime;
  }
  complete() {
    this.state !== "running" && this.play(), this.state = "finished", this.holdTime = null;
  }
  finish() {
    this.notifyFinished(), this.teardown(), this.state = "finished", this.options.onComplete?.();
  }
  cancel() {
    this.holdTime = null, this.startTime = 0, this.tick(0), this.teardown(), this.options.onCancel?.();
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.startTime = this.holdTime = null;
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(t) {
    return this.startTime = 0, this.tick(t, !0);
  }
  attachTimeline(t) {
    return this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear", this.initAnimation()), this.driver?.stop(), t.observe(this);
  }
}
function nY(e) {
  for (let t = 1; t < e.length; t++)
    e[t] ?? (e[t] = e[t - 1]);
}
const ri = (e) => e * 180 / Math.PI, $9 = (e) => {
  const t = ri(Math.atan2(e[1], e[0]));
  return j9(t);
}, rY = {
  x: 4,
  y: 5,
  translateX: 4,
  translateY: 5,
  scaleX: 0,
  scaleY: 3,
  scale: (e) => (Math.abs(e[0]) + Math.abs(e[3])) / 2,
  rotate: $9,
  rotateZ: $9,
  skewX: (e) => ri(Math.atan(e[1])),
  skewY: (e) => ri(Math.atan(e[2])),
  skew: (e) => (Math.abs(e[1]) + Math.abs(e[2])) / 2
}, j9 = (e) => (e = e % 360, e < 0 && (e += 360), e), SC = $9, MC = (e) => Math.sqrt(e[0] * e[0] + e[1] * e[1]), EC = (e) => Math.sqrt(e[4] * e[4] + e[5] * e[5]), oY = {
  x: 12,
  y: 13,
  z: 14,
  translateX: 12,
  translateY: 13,
  translateZ: 14,
  scaleX: MC,
  scaleY: EC,
  scale: (e) => (MC(e) + EC(e)) / 2,
  rotateX: (e) => j9(ri(Math.atan2(e[6], e[5]))),
  rotateY: (e) => j9(ri(Math.atan2(-e[2], e[0]))),
  rotateZ: SC,
  rotate: SC,
  skewX: (e) => ri(Math.atan(e[4])),
  skewY: (e) => ri(Math.atan(e[1])),
  skew: (e) => (Math.abs(e[1]) + Math.abs(e[4])) / 2
};
function H9(e) {
  return e.includes("scale") ? 1 : 0;
}
function z9(e, t) {
  if (!e || e === "none")
    return H9(t);
  const n = e.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
  let r, o;
  if (n)
    r = oY, o = n;
  else {
    const s = e.match(/^matrix\(([-\d.e\s,]+)\)$/u);
    r = rY, o = s;
  }
  if (!o)
    return H9(t);
  const i = r[t], a = o[1].split(",").map(aY);
  return typeof i == "function" ? i(a) : a[i];
}
const iY = (e, t) => {
  const { transform: n = "none" } = getComputedStyle(e);
  return z9(n, t);
};
function aY(e) {
  return parseFloat(e.trim());
}
const ws = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], xs = new Set(ws), _C = (e) => e === bs || e === Re, sY = /* @__PURE__ */ new Set(["x", "y", "z"]), lY = ws.filter((e) => !sY.has(e));
function cY(e) {
  const t = [];
  return lY.forEach((n) => {
    const r = e.getValue(n);
    r !== void 0 && (t.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), t;
}
const fi = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: t = "0", paddingRight: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  height: ({ y: e }, { paddingTop: t = "0", paddingBottom: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  top: (e, { top: t }) => parseFloat(t),
  left: (e, { left: t }) => parseFloat(t),
  bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
  right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
  // Transform
  x: (e, { transform: t }) => z9(t, "x"),
  y: (e, { transform: t }) => z9(t, "y")
};
fi.translateX = fi.x;
fi.translateY = fi.y;
const di = /* @__PURE__ */ new Set();
let Z9 = !1, W9 = !1, q9 = !1;
function UP() {
  if (W9) {
    const e = Array.from(di).filter((r) => r.needsMeasurement), t = new Set(e.map((r) => r.element)), n = /* @__PURE__ */ new Map();
    t.forEach((r) => {
      const o = cY(r);
      o.length && (n.set(r, o), r.render());
    }), e.forEach((r) => r.measureInitialState()), t.forEach((r) => {
      r.render();
      const o = n.get(r);
      o && o.forEach(([i, a]) => {
        r.getValue(i)?.set(a);
      });
    }), e.forEach((r) => r.measureEndState()), e.forEach((r) => {
      r.suspendedScrollY !== void 0 && window.scrollTo(0, r.suspendedScrollY);
    });
  }
  W9 = !1, Z9 = !1, di.forEach((e) => e.complete(q9)), di.clear();
}
function GP() {
  di.forEach((e) => {
    e.readKeyframes(), e.needsMeasurement && (W9 = !0);
  });
}
function uY() {
  q9 = !0, GP(), UP(), q9 = !1;
}
class Vh {
  constructor(t, n, r, o, i, a = !1) {
    this.state = "pending", this.isAsync = !1, this.needsMeasurement = !1, this.unresolvedKeyframes = [...t], this.onComplete = n, this.name = r, this.motionValue = o, this.element = i, this.isAsync = a;
  }
  scheduleResolve() {
    this.state = "scheduled", this.isAsync ? (di.add(this), Z9 || (Z9 = !0, Tt.read(GP), Tt.resolveKeyframes(UP))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, name: n, element: r, motionValue: o } = this;
    if (t[0] === null) {
      const i = o?.get(), a = t[t.length - 1];
      if (i !== void 0)
        t[0] = i;
      else if (r && n) {
        const s = r.readValue(n, a);
        s != null && (t[0] = s);
      }
      t[0] === void 0 && (t[0] = a), o && i === void 0 && o.set(t[0]);
    }
    nY(t);
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete(t = !1) {
    this.state = "complete", this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, t), di.delete(this);
  }
  cancel() {
    this.state === "scheduled" && (di.delete(this), this.state = "pending");
  }
  resume() {
    this.state === "pending" && this.scheduleResolve();
  }
}
const fY = (e) => e.startsWith("--");
function dY(e, t, n) {
  fY(t) ? e.style.setProperty(t, n) : e.style[t] = n;
}
const hY = /* @__PURE__ */ Mh(() => window.ScrollTimeline !== void 0), pY = {};
function mY(e, t) {
  const n = /* @__PURE__ */ Mh(e);
  return () => pY[t] ?? n();
}
const KP = /* @__PURE__ */ mY(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), ll = ([e, t, n, r]) => `cubic-bezier(${e}, ${t}, ${n}, ${r})`, OC = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ ll([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ ll([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ ll([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ ll([0.33, 1.53, 0.69, 0.99])
};
function YP(e, t) {
  if (e)
    return typeof e == "function" ? KP() ? jP(e, t) : "ease-out" : IP(e) ? ll(e) : Array.isArray(e) ? e.map((n) => YP(n, t) || OC.easeOut) : OC[e];
}
function gY(e, t, n, { delay: r = 0, duration: o = 300, repeat: i = 0, repeatType: a = "loop", ease: s = "easeOut", times: l } = {}, c = void 0) {
  const u = {
    [t]: n
  };
  l && (u.offset = l);
  const f = YP(s, o);
  Array.isArray(f) && (u.easing = f);
  const h = {
    delay: r,
    duration: o,
    easing: Array.isArray(f) ? "linear" : f,
    fill: "both",
    iterations: i + 1,
    direction: a === "reverse" ? "alternate" : "normal"
  };
  return c && (h.pseudoElement = c), e.animate(u, h);
}
function Bh(e) {
  return typeof e == "function" && "applyToOptions" in e;
}
function CY({ type: e, ...t }) {
  return Bh(e) && KP() ? e.applyToOptions(t) : (t.duration ?? (t.duration = 300), t.ease ?? (t.ease = "easeOut"), t);
}
class vY extends Nh {
  constructor(t) {
    if (super(), this.finishedTime = null, this.isStopped = !1, !t)
      return;
    const { element: n, name: r, keyframes: o, pseudoElement: i, allowFlatten: a = !1, finalKeyframe: s, onComplete: l } = t;
    this.isPseudoElement = !!i, this.allowFlatten = a, this.options = t, Er(typeof t.type != "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
    const c = CY(t);
    this.animation = gY(n, r, o, c, i), c.autoplay === !1 && this.animation.pause(), this.animation.onfinish = () => {
      if (this.finishedTime = this.time, !i) {
        const u = Lh(o, this.options, s, this.speed);
        this.updateMotionValue ? this.updateMotionValue(u) : dY(n, r, u), this.animation.cancel();
      }
      l?.(), this.notifyFinished();
    };
  }
  play() {
    this.isStopped || (this.animation.play(), this.state === "finished" && this.updateFinished());
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.finish?.();
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch {
    }
  }
  stop() {
    if (this.isStopped)
      return;
    this.isStopped = !0;
    const { state: t } = this;
    t === "idle" || t === "finished" || (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(), this.isPseudoElement || this.cancel());
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * In this method, we commit styles back to the DOM before cancelling
   * the animation.
   *
   * This is designed to be overridden by NativeAnimationExtended, which
   * will create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to also correctly calculate velocity for any subsequent animation
   * while deferring the commit until the next animation frame.
   */
  commitStyles() {
    this.isPseudoElement || this.animation.commitStyles?.();
  }
  get duration() {
    const t = this.animation.effect?.getComputedTiming?.().duration || 0;
    return /* @__PURE__ */ yr(Number(t));
  }
  get iterationDuration() {
    const { delay: t = 0 } = this.options || {};
    return this.duration + /* @__PURE__ */ yr(t);
  }
  get time() {
    return /* @__PURE__ */ yr(Number(this.animation.currentTime) || 0);
  }
  set time(t) {
    this.finishedTime = null, this.animation.currentTime = /* @__PURE__ */ xr(t);
  }
  /**
   * The playback speed of the animation.
   * 1 = normal speed, 2 = double speed, 0.5 = half speed.
   */
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(t) {
    t < 0 && (this.finishedTime = null), this.animation.playbackRate = t;
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState;
  }
  get startTime() {
    return Number(this.animation.startTime);
  }
  set startTime(t) {
    this.animation.startTime = t;
  }
  /**
   * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
   */
  attachTimeline({ timeline: t, observe: n }) {
    return this.allowFlatten && this.animation.effect?.updateTiming({ easing: "linear" }), this.animation.onfinish = null, t && hY() ? (this.animation.timeline = t, wr) : n(this);
  }
}
const XP = {
  anticipate: EP,
  backInOut: MP,
  circInOut: OP
};
function yY(e) {
  return e in XP;
}
function bY(e) {
  typeof e.ease == "string" && yY(e.ease) && (e.ease = XP[e.ease]);
}
const AC = 10;
class wY extends vY {
  constructor(t) {
    bY(t), qP(t), super(t), t.startTime && (this.startTime = t.startTime), this.options = t;
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * Rather than read commited styles back out of the DOM, we can
   * create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to calculate velocity for any subsequent animation.
   */
  updateMotionValue(t) {
    const { motionValue: n, onUpdate: r, onComplete: o, element: i, ...a } = this.options;
    if (!n)
      return;
    if (t !== void 0) {
      n.set(t);
      return;
    }
    const s = new Fh({
      ...a,
      autoplay: !1
    }), l = /* @__PURE__ */ xr(this.finishedTime ?? this.time);
    n.setWithVelocity(s.sample(l - AC).value, s.sample(l).value, AC), s.stop();
  }
}
const PC = (e, t) => t === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && // It's animatable if we have a string
(T1.test(e) || e === "0") && // And it contains numbers and/or colors
!e.startsWith("url("));
function xY(e) {
  const t = e[0];
  if (e.length === 1)
    return !0;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t)
      return !0;
}
function SY(e, t, n, r) {
  const o = e[0];
  if (o === null)
    return !1;
  if (t === "display" || t === "visibility")
    return !0;
  const i = e[e.length - 1], a = PC(o, t), s = PC(i, t);
  return ys(a === s, `You are trying to animate ${t} from "${o}" to "${i}". "${a ? i : o}" is not an animatable value.`, "value-not-animatable"), !a || !s ? !1 : xY(e) || (n === "spring" || Bh(n)) && r;
}
function U9(e) {
  e.duration = 0, e.type = "keyframes";
}
const MY = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Could be re-enabled now we have support for linear() easing
  // "background-color"
]), EY = /* @__PURE__ */ Mh(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function _Y(e) {
  const { motionValue: t, name: n, repeatDelay: r, repeatType: o, damping: i, type: a } = e;
  if (!(t?.owner?.current instanceof HTMLElement))
    return !1;
  const { onUpdate: l, transformTemplate: c } = t.owner.getProps();
  return EY() && n && MY.has(n) && (n !== "transform" || !c) && /**
   * If we're outputting values to onUpdate then we can't use WAAPI as there's
   * no way to read the value from WAAPI every frame.
   */
  !l && !r && o !== "mirror" && i !== 0 && a !== "inertia";
}
const OY = 40;
class AY extends Nh {
  constructor({ autoplay: t = !0, delay: n = 0, type: r = "keyframes", repeat: o = 0, repeatDelay: i = 0, repeatType: a = "loop", keyframes: s, name: l, motionValue: c, element: u, ...f }) {
    super(), this.stop = () => {
      this._animation && (this._animation.stop(), this.stopTimeline?.()), this.keyframeResolver?.cancel();
    }, this.createdAt = qn.now();
    const h = {
      autoplay: t,
      delay: n,
      type: r,
      repeat: o,
      repeatDelay: i,
      repeatType: a,
      name: l,
      motionValue: c,
      element: u,
      ...f
    }, p = u?.KeyframeResolver || Vh;
    this.keyframeResolver = new p(s, (C, m, g) => this.onKeyframesResolved(C, m, h, !g), l, c, u), this.keyframeResolver?.scheduleResolve();
  }
  onKeyframesResolved(t, n, r, o) {
    this.keyframeResolver = void 0;
    const { name: i, type: a, velocity: s, delay: l, isHandoff: c, onUpdate: u } = r;
    this.resolvedAt = qn.now(), SY(t, i, a, s) || ((Xo.instantAnimations || !l) && u?.(Lh(t, r, n)), t[0] = t[t.length - 1], U9(r), r.repeat = 0);
    const h = {
      startTime: o ? this.resolvedAt ? this.resolvedAt - this.createdAt > OY ? this.resolvedAt : this.createdAt : this.createdAt : void 0,
      finalKeyframe: n,
      ...r,
      keyframes: t
    }, p = !c && _Y(h) ? new wY({
      ...h,
      element: h.motionValue.owner.current
    }) : new Fh(h);
    p.finished.then(() => this.notifyFinished()).catch(wr), this.pendingTimeline && (this.stopTimeline = p.attachTimeline(this.pendingTimeline), this.pendingTimeline = void 0), this._animation = p;
  }
  get finished() {
    return this._animation ? this.animation.finished : this._finished;
  }
  then(t, n) {
    return this.finished.finally(t).then(() => {
    });
  }
  get animation() {
    return this._animation || (this.keyframeResolver?.resume(), uY()), this._animation;
  }
  get duration() {
    return this.animation.duration;
  }
  get iterationDuration() {
    return this.animation.iterationDuration;
  }
  get time() {
    return this.animation.time;
  }
  set time(t) {
    this.animation.time = t;
  }
  get speed() {
    return this.animation.speed;
  }
  get state() {
    return this.animation.state;
  }
  set speed(t) {
    this.animation.speed = t;
  }
  get startTime() {
    return this.animation.startTime;
  }
  attachTimeline(t) {
    return this._animation ? this.stopTimeline = this.animation.attachTimeline(t) : this.pendingTimeline = t, () => this.stop();
  }
  play() {
    this.animation.play();
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.complete();
  }
  cancel() {
    this._animation && this.animation.cancel(), this.keyframeResolver?.cancel();
  }
}
class PY {
  constructor(t) {
    this.stop = () => this.runAll("stop"), this.animations = t.filter(Boolean);
  }
  get finished() {
    return Promise.all(this.animations.map((t) => t.finished));
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(t) {
    return this.animations[0][t];
  }
  setAll(t, n) {
    for (let r = 0; r < this.animations.length; r++)
      this.animations[r][t] = n;
  }
  attachTimeline(t) {
    const n = this.animations.map((r) => r.attachTimeline(t));
    return () => {
      n.forEach((r, o) => {
        r && r(), this.animations[o].stop();
      });
    };
  }
  get time() {
    return this.getAll("time");
  }
  set time(t) {
    this.setAll("time", t);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(t) {
    this.setAll("speed", t);
  }
  get state() {
    return this.getAll("state");
  }
  get startTime() {
    return this.getAll("startTime");
  }
  get duration() {
    return TC(this.animations, "duration");
  }
  get iterationDuration() {
    return TC(this.animations, "iterationDuration");
  }
  runAll(t) {
    this.animations.forEach((n) => n[t]());
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
}
function TC(e, t) {
  let n = 0;
  for (let r = 0; r < e.length; r++) {
    const o = e[r][t];
    o !== null && o > n && (n = o);
  }
  return n;
}
class TY extends PY {
  then(t, n) {
    return this.finished.finally(t).then(() => {
    });
  }
}
const IY = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function DY(e) {
  const t = IY.exec(e);
  if (!t)
    return [,];
  const [, n, r, o] = t;
  return [`--${n ?? r}`, o];
}
const RY = 4;
function QP(e, t, n = 1) {
  Er(n <= RY, `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
  const [r, o] = DY(e);
  if (!r)
    return;
  const i = window.getComputedStyle(t).getPropertyValue(r);
  if (i) {
    const a = i.trim();
    return gP(a) ? parseFloat(a) : a;
  }
  return Th(o) ? QP(o, t, n + 1) : o;
}
function $h(e, t) {
  return e?.[t] ?? e?.default ?? e;
}
const JP = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...ws
]), kY = {
  test: (e) => e === "auto",
  parse: (e) => e
}, eT = (e) => (t) => t.test(e), tT = [bs, Re, po, u1, EK, MK, kY], IC = (e) => tT.find(eT(e));
function LY(e) {
  return typeof e == "number" ? e === 0 : e !== null ? e === "none" || e === "0" || vP(e) : !0;
}
const NY = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function FY(e) {
  const [t, n] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [r] = n.match(Ih) || [];
  if (!r)
    return e;
  const o = n.replace(r, "");
  let i = NY.has(t) ? 1 : 0;
  return r !== n && (i *= 100), t + "(" + i + o + ")";
}
const VY = /\b([a-z-]*)\(.*?\)/gu, G9 = {
  ...T1,
  getAnimatableNone: (e) => {
    const t = e.match(VY);
    return t ? t.map(FY).join(" ") : e;
  }
}, DC = {
  ...bs,
  transform: Math.round
}, BY = {
  rotate: u1,
  rotateX: u1,
  rotateY: u1,
  rotateZ: u1,
  scale: Cc,
  scaleX: Cc,
  scaleY: Cc,
  scaleZ: Cc,
  skew: u1,
  skewX: u1,
  skewY: u1,
  distance: Re,
  translateX: Re,
  translateY: Re,
  translateZ: Re,
  x: Re,
  y: Re,
  z: Re,
  perspective: Re,
  transformPerspective: Re,
  opacity: kl,
  originX: vC,
  originY: vC,
  originZ: Re
}, jh = {
  // Border props
  borderWidth: Re,
  borderTopWidth: Re,
  borderRightWidth: Re,
  borderBottomWidth: Re,
  borderLeftWidth: Re,
  borderRadius: Re,
  radius: Re,
  borderTopLeftRadius: Re,
  borderTopRightRadius: Re,
  borderBottomRightRadius: Re,
  borderBottomLeftRadius: Re,
  // Positioning props
  width: Re,
  maxWidth: Re,
  height: Re,
  maxHeight: Re,
  top: Re,
  right: Re,
  bottom: Re,
  left: Re,
  // Spacing props
  padding: Re,
  paddingTop: Re,
  paddingRight: Re,
  paddingBottom: Re,
  paddingLeft: Re,
  margin: Re,
  marginTop: Re,
  marginRight: Re,
  marginBottom: Re,
  marginLeft: Re,
  // Misc
  backgroundPositionX: Re,
  backgroundPositionY: Re,
  ...BY,
  zIndex: DC,
  // SVG
  fillOpacity: kl,
  strokeOpacity: kl,
  numOctaves: DC
}, $Y = {
  ...jh,
  // Color props
  color: Jt,
  backgroundColor: Jt,
  outlineColor: Jt,
  fill: Jt,
  stroke: Jt,
  // Border props
  borderColor: Jt,
  borderTopColor: Jt,
  borderRightColor: Jt,
  borderBottomColor: Jt,
  borderLeftColor: Jt,
  filter: G9,
  WebkitFilter: G9
}, nT = (e) => $Y[e];
function rT(e, t) {
  let n = nT(e);
  return n !== G9 && (n = T1), n.getAnimatableNone ? n.getAnimatableNone(t) : void 0;
}
const jY = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function HY(e, t, n) {
  let r = 0, o;
  for (; r < e.length && !o; ) {
    const i = e[r];
    typeof i == "string" && !jY.has(i) && Ll(i).values.length && (o = e[r]), r++;
  }
  if (o && n)
    for (const i of t)
      e[i] = rT(n, o);
}
class zY extends Vh {
  constructor(t, n, r, o, i) {
    super(t, n, r, o, i, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, element: n, name: r } = this;
    if (!n || !n.current)
      return;
    super.readKeyframes();
    for (let l = 0; l < t.length; l++) {
      let c = t[l];
      if (typeof c == "string" && (c = c.trim(), Th(c))) {
        const u = QP(c, n.current);
        u !== void 0 && (t[l] = u), l === t.length - 1 && (this.finalKeyframe = c);
      }
    }
    if (this.resolveNoneKeyframes(), !JP.has(r) || t.length !== 2)
      return;
    const [o, i] = t, a = IC(o), s = IC(i);
    if (a !== s)
      if (_C(a) && _C(s))
        for (let l = 0; l < t.length; l++) {
          const c = t[l];
          typeof c == "string" && (t[l] = parseFloat(c));
        }
      else fi[r] && (this.needsMeasurement = !0);
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: t, name: n } = this, r = [];
    for (let o = 0; o < t.length; o++)
      (t[o] === null || LY(t[o])) && r.push(o);
    r.length && HY(t, r, n);
  }
  measureInitialState() {
    const { element: t, unresolvedKeyframes: n, name: r } = this;
    if (!t || !t.current)
      return;
    r === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = fi[r](t.measureViewportBox(), window.getComputedStyle(t.current)), n[0] = this.measuredOrigin;
    const o = n[n.length - 1];
    o !== void 0 && t.getValue(r, o).jump(o, !1);
  }
  measureEndState() {
    const { element: t, name: n, unresolvedKeyframes: r } = this;
    if (!t || !t.current)
      return;
    const o = t.getValue(n);
    o && o.jump(this.measuredOrigin, !1);
    const i = r.length - 1, a = r[i];
    r[i] = fi[n](t.measureViewportBox(), window.getComputedStyle(t.current)), a !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = a), this.removedTransforms?.length && this.removedTransforms.forEach(([s, l]) => {
      t.getValue(s).set(l);
    }), this.resolveNoneKeyframes();
  }
}
function oT(e, t, n) {
  if (e instanceof EventTarget)
    return [e];
  if (typeof e == "string") {
    let r = document;
    const o = n?.[e] ?? r.querySelectorAll(e);
    return o ? Array.from(o) : [];
  }
  return Array.from(e);
}
const iT = (e, t) => t && typeof e == "number" ? t.transform(e) : e;
function aT(e) {
  return CP(e) && "offsetHeight" in e;
}
const RC = 30, ZY = (e) => !isNaN(parseFloat(e));
class WY {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   */
  constructor(t, n = {}) {
    this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (r) => {
      const o = qn.now();
      if (this.updatedAt !== o && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(r), this.current !== this.prev && (this.events.change?.notify(this.current), this.dependents))
        for (const i of this.dependents)
          i.dirty();
    }, this.hasAnimated = !1, this.setCurrent(t), this.owner = n.owner;
  }
  setCurrent(t) {
    this.current = t, this.updatedAt = qn.now(), this.canTrackVelocity === null && t !== void 0 && (this.canTrackVelocity = ZY(this.current));
  }
  setPrevFrameValue(t = this.current) {
    this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(t) {
    return process.env.NODE_ENV !== "production" && _h(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", t);
  }
  on(t, n) {
    this.events[t] || (this.events[t] = new Eh());
    const r = this.events[t].add(n);
    return t === "change" ? () => {
      r(), Tt.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const t in this.events)
      this.events[t].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   */
  attach(t, n) {
    this.passiveEffect = t, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(t) {
    this.passiveEffect ? this.passiveEffect(t, this.updateAndNotify) : this.updateAndNotify(t);
  }
  setWithVelocity(t, n, r) {
    this.set(n), this.prev = void 0, this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt - r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(t, n = !0) {
    this.updateAndNotify(t), this.prev = t, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  dirty() {
    this.events.change?.notify(this.current);
  }
  addDependent(t) {
    this.dependents || (this.dependents = /* @__PURE__ */ new Set()), this.dependents.add(t);
  }
  removeDependent(t) {
    this.dependents && this.dependents.delete(t);
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const t = qn.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || t - this.updatedAt > RC)
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, RC);
    return yP(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   */
  start(t) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = t(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.dependents?.clear(), this.events.destroy?.notify(), this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function Mi(e, t) {
  return new WY(e, t);
}
const { schedule: Hh } = /* @__PURE__ */ DP(queueMicrotask, !1), Lr = {
  x: !1,
  y: !1
};
function sT() {
  return Lr.x || Lr.y;
}
function qY(e) {
  return e === "x" || e === "y" ? Lr[e] ? null : (Lr[e] = !0, () => {
    Lr[e] = !1;
  }) : Lr.x || Lr.y ? null : (Lr.x = Lr.y = !0, () => {
    Lr.x = Lr.y = !1;
  });
}
function lT(e, t) {
  const n = oT(e), r = new AbortController(), o = {
    passive: !0,
    ...t,
    signal: r.signal
  };
  return [n, o, () => r.abort()];
}
function kC(e) {
  return !(e.pointerType === "touch" || sT());
}
function UY(e, t, n = {}) {
  const [r, o, i] = lT(e, n), a = (s) => {
    if (!kC(s))
      return;
    const { target: l } = s, c = t(l, s);
    if (typeof c != "function" || !l)
      return;
    const u = (f) => {
      kC(f) && (c(f), l.removeEventListener("pointerleave", u));
    };
    l.addEventListener("pointerleave", u, o);
  };
  return r.forEach((s) => {
    s.addEventListener("pointerenter", a, o);
  }), i;
}
const cT = (e, t) => t ? e === t ? !0 : cT(e, t.parentElement) : !1, zh = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1, GY = /* @__PURE__ */ new Set([
  "BUTTON",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "A"
]);
function KY(e) {
  return GY.has(e.tagName) || e.tabIndex !== -1;
}
const Wc = /* @__PURE__ */ new WeakSet();
function LC(e) {
  return (t) => {
    t.key === "Enter" && e(t);
  };
}
function W7(e, t) {
  e.dispatchEvent(new PointerEvent("pointer" + t, { isPrimary: !0, bubbles: !0 }));
}
const YY = (e, t) => {
  const n = e.currentTarget;
  if (!n)
    return;
  const r = LC(() => {
    if (Wc.has(n))
      return;
    W7(n, "down");
    const o = LC(() => {
      W7(n, "up");
    }), i = () => W7(n, "cancel");
    n.addEventListener("keyup", o, t), n.addEventListener("blur", i, t);
  });
  n.addEventListener("keydown", r, t), n.addEventListener("blur", () => n.removeEventListener("keydown", r), t);
};
function NC(e) {
  return zh(e) && !sT();
}
function XY(e, t, n = {}) {
  const [r, o, i] = lT(e, n), a = (s) => {
    const l = s.currentTarget;
    if (!NC(s))
      return;
    Wc.add(l);
    const c = t(l, s), u = (p, C) => {
      window.removeEventListener("pointerup", f), window.removeEventListener("pointercancel", h), Wc.has(l) && Wc.delete(l), NC(p) && typeof c == "function" && c(p, { success: C });
    }, f = (p) => {
      u(p, l === window || l === document || n.useGlobalTarget || cT(l, p.target));
    }, h = (p) => {
      u(p, !1);
    };
    window.addEventListener("pointerup", f, o), window.addEventListener("pointercancel", h, o);
  };
  return r.forEach((s) => {
    (n.useGlobalTarget ? window : s).addEventListener("pointerdown", a, o), aT(s) && (s.addEventListener("focus", (c) => YY(c, o)), !KY(s) && !s.hasAttribute("tabindex") && (s.tabIndex = 0));
  }), i;
}
function Zh(e) {
  return CP(e) && "ownerSVGElement" in e;
}
function uT(e) {
  return Zh(e) && e.tagName === "svg";
}
const dn = (e) => !!(e && e.getVelocity), QY = [...tT, Jt, T1], JY = (e) => QY.find(eT(e)), Gu = gt({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
});
function FC(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function eX(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = FC(o, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const i = r[o];
          typeof i == "function" ? i() : FC(e[o], null);
        }
      };
  };
}
function tX(...e) {
  return A.useCallback(eX(...e), e);
}
class nX extends A.Component {
  getSnapshotBeforeUpdate(t) {
    const n = this.props.childRef.current;
    if (n && t.isPresent && !this.props.isPresent) {
      const r = n.offsetParent, o = aT(r) && r.offsetWidth || 0, i = this.props.sizeRef.current;
      i.height = n.offsetHeight || 0, i.width = n.offsetWidth || 0, i.top = n.offsetTop, i.left = n.offsetLeft, i.right = o - i.width - i.left;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function rX({ children: e, isPresent: t, anchorX: n, root: r }) {
  const o = bt(), i = ke(null), a = ke({
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    right: 0
  }), { nonce: s } = Oe(Gu), l = tX(i, e?.ref);
  return XE(() => {
    const { width: c, height: u, top: f, left: h, right: p } = a.current;
    if (t || !i.current || !c || !u)
      return;
    const C = n === "left" ? `left: ${h}` : `right: ${p}`;
    i.current.dataset.motionPopId = o;
    const m = document.createElement("style");
    s && (m.nonce = s);
    const g = r ?? document.head;
    return g.appendChild(m), m.sheet && m.sheet.insertRule(`
          [data-motion-pop-id="${o}"] {
            position: absolute !important;
            width: ${c}px !important;
            height: ${u}px !important;
            ${C}px !important;
            top: ${f}px !important;
          }
        `), () => {
      g.contains(m) && g.removeChild(m);
    };
  }, [t]), d(nX, { isPresent: t, childRef: i, sizeRef: a, children: A.cloneElement(e, { ref: l }) });
}
const oX = ({ children: e, initial: t, isPresent: n, onExitComplete: r, custom: o, presenceAffectsLayout: i, mode: a, anchorX: s, root: l }) => {
  const c = Wu(iX), u = bt();
  let f = !0, h = _e(() => (f = !1, {
    id: u,
    initial: t,
    isPresent: n,
    custom: o,
    onExitComplete: (p) => {
      c.set(p, !0);
      for (const C of c.values())
        if (!C)
          return;
      r && r();
    },
    register: (p) => (c.set(p, !1), () => c.delete(p))
  }), [n, c, r]);
  return i && f && (h = { ...h }), _e(() => {
    c.forEach((p, C) => c.set(C, !1));
  }, [n]), A.useEffect(() => {
    !n && !c.size && r && r();
  }, [n]), a === "popLayout" && (e = d(rX, { isPresent: n, anchorX: s, root: l, children: e })), d(qu.Provider, { value: h, children: e });
};
function iX() {
  return /* @__PURE__ */ new Map();
}
function fT(e = !0) {
  const t = Oe(qu);
  if (t === null)
    return [!0, null];
  const { isPresent: n, onExitComplete: r, register: o } = t, i = bt();
  ve(() => {
    if (e)
      return o(i);
  }, [e]);
  const a = ct(() => e && r && r(i), [i, r, e]);
  return !n && r ? [!1, a] : [!0];
}
const vc = (e) => e.key || "";
function VC(e) {
  const t = [];
  return ar.forEach(e, (n) => {
    sr(n) && t.push(n);
  }), t;
}
const aX = ({ children: e, custom: t, initial: n = !0, onExitComplete: r, presenceAffectsLayout: o = !0, mode: i = "sync", propagate: a = !1, anchorX: s = "left", root: l }) => {
  const [c, u] = fT(a), f = _e(() => VC(e), [e]), h = a && !c ? [] : f.map(vc), p = ke(!0), C = ke(f), m = Wu(() => /* @__PURE__ */ new Map()), [g, v] = ue(f), [y, w] = ue(f);
  mP(() => {
    p.current = !1, C.current = f;
    for (let S = 0; S < y.length; S++) {
      const M = vc(y[S]);
      h.includes(M) ? m.delete(M) : m.get(M) !== !0 && m.set(M, !1);
    }
  }, [y, h.length, h.join("-")]);
  const x = [];
  if (f !== g) {
    let S = [...f];
    for (let M = 0; M < y.length; M++) {
      const E = y[M], P = vc(E);
      h.includes(P) || (S.splice(M, 0, E), x.push(E));
    }
    return i === "wait" && x.length && (S = x), w(VC(S)), v(f), null;
  }
  process.env.NODE_ENV !== "production" && i === "wait" && y.length > 1 && console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`);
  const { forceRender: b } = Oe(wh);
  return d(ut, { children: y.map((S) => {
    const M = vc(S), E = a && !c ? !1 : f === y || h.includes(M), P = () => {
      if (m.has(M))
        m.set(M, !0);
      else
        return;
      let T = !0;
      m.forEach((_) => {
        _ || (T = !1);
      }), T && (b?.(), w(C.current), a && u?.(), r && r());
    };
    return d(oX, { isPresent: E, initial: !p.current || n ? void 0 : !1, custom: t, presenceAffectsLayout: o, mode: i, root: l, onExitComplete: E ? void 0 : P, anchorX: s, children: S }, M);
  }) });
}, Wh = gt({ strict: !1 }), BC = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, $a = {};
for (const e in BC)
  $a[e] = {
    isEnabled: (t) => BC[e].some((n) => !!t[n])
  };
function K9(e) {
  for (const t in e)
    $a[t] = {
      ...$a[t],
      ...e[t]
    };
}
function sX({ children: e, features: t, strict: n = !1 }) {
  const [, r] = ue(!q7(t)), o = ke(void 0);
  if (!q7(t)) {
    const { renderer: i, ...a } = t;
    o.current = i, K9(a);
  }
  return ve(() => {
    q7(t) && t().then(({ renderer: i, ...a }) => {
      K9(a), o.current = i, r(!0);
    });
  }, []), d(Wh.Provider, { value: { renderer: o.current, strict: n }, children: e });
}
function q7(e) {
  return typeof e == "function";
}
const lX = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function p5(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || e.startsWith("onLayout") || lX.has(e);
}
let dT = (e) => !p5(e);
function cX(e) {
  typeof e == "function" && (dT = (t) => t.startsWith("on") ? !p5(t) : e(t));
}
try {
  cX(require("@emotion/is-prop-valid").default);
} catch {
}
function uX(e, t, n) {
  const r = {};
  for (const o in e)
    o === "values" && typeof e.values == "object" || (dT(o) || n === !0 && p5(o) || !t && !p5(o) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && o.startsWith("onDrag")) && (r[o] = e[o]);
  return r;
}
const Ku = /* @__PURE__ */ gt({});
function Yu(e) {
  return e !== null && typeof e == "object" && typeof e.start == "function";
}
function Fl(e) {
  return typeof e == "string" || Array.isArray(e);
}
const qh = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], Uh = ["initial", ...qh];
function Xu(e) {
  return Yu(e.animate) || Uh.some((t) => Fl(e[t]));
}
function hT(e) {
  return !!(Xu(e) || e.variants);
}
function fX(e, t) {
  if (Xu(e)) {
    const { initial: n, animate: r } = e;
    return {
      initial: n === !1 || Fl(n) ? n : void 0,
      animate: Fl(r) ? r : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function dX(e) {
  const { initial: t, animate: n } = fX(e, Oe(Ku));
  return _e(() => ({ initial: t, animate: n }), [$C(t), $C(n)]);
}
function $C(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const Vl = {};
function hX(e) {
  for (const t in e)
    Vl[t] = e[t], Ph(t) && (Vl[t].isCSSVariable = !0);
}
function pT(e, { layout: t, layoutId: n }) {
  return xs.has(e) || e.startsWith("origin") || (t || n !== void 0) && (!!Vl[e] || e === "opacity");
}
const pX = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, mX = ws.length;
function gX(e, t, n) {
  let r = "", o = !0;
  for (let i = 0; i < mX; i++) {
    const a = ws[i], s = e[a];
    if (s === void 0)
      continue;
    let l = !0;
    if (typeof s == "number" ? l = s === (a.startsWith("scale") ? 1 : 0) : l = parseFloat(s) === 0, !l || n) {
      const c = iT(s, jh[a]);
      if (!l) {
        o = !1;
        const u = pX[a] || a;
        r += `${u}(${c}) `;
      }
      n && (t[a] = c);
    }
  }
  return r = r.trim(), n ? r = n(t, o ? "" : r) : o && (r = "none"), r;
}
function Gh(e, t, n) {
  const { style: r, vars: o, transformOrigin: i } = e;
  let a = !1, s = !1;
  for (const l in t) {
    const c = t[l];
    if (xs.has(l)) {
      a = !0;
      continue;
    } else if (Ph(l)) {
      o[l] = c;
      continue;
    } else {
      const u = iT(c, jh[l]);
      l.startsWith("origin") ? (s = !0, i[l] = u) : r[l] = u;
    }
  }
  if (t.transform || (a || n ? r.transform = gX(t, e.transform, n) : r.transform && (r.transform = "none")), s) {
    const { originX: l = "50%", originY: c = "50%", originZ: u = 0 } = i;
    r.transformOrigin = `${l} ${c} ${u}`;
  }
}
const Kh = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function mT(e, t, n) {
  for (const r in t)
    !dn(t[r]) && !pT(r, n) && (e[r] = t[r]);
}
function CX({ transformTemplate: e }, t) {
  return _e(() => {
    const n = Kh();
    return Gh(n, t, e), Object.assign({}, n.vars, n.style);
  }, [t]);
}
function vX(e, t) {
  const n = e.style || {}, r = {};
  return mT(r, n, e), Object.assign(r, CX(e, t)), r;
}
function yX(e, t) {
  const n = {}, r = vX(e, t);
  return e.drag && e.dragListener !== !1 && (n.draggable = !1, r.userSelect = r.WebkitUserSelect = r.WebkitTouchCallout = "none", r.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (n.tabIndex = 0), n.style = r, n;
}
const bX = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, wX = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function xX(e, t, n = 1, r = 0, o = !0) {
  e.pathLength = 1;
  const i = o ? bX : wX;
  e[i.offset] = Re.transform(-r);
  const a = Re.transform(t), s = Re.transform(n);
  e[i.array] = `${a} ${s}`;
}
function gT(e, {
  attrX: t,
  attrY: n,
  attrScale: r,
  pathLength: o,
  pathSpacing: i = 1,
  pathOffset: a = 0,
  // This is object creation, which we try to avoid per-frame.
  ...s
}, l, c, u) {
  if (Gh(e, s, c), l) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: f, style: h } = e;
  f.transform && (h.transform = f.transform, delete f.transform), (h.transform || f.transformOrigin) && (h.transformOrigin = f.transformOrigin ?? "50% 50%", delete f.transformOrigin), h.transform && (h.transformBox = u?.transformBox ?? "fill-box", delete f.transformBox), t !== void 0 && (f.x = t), n !== void 0 && (f.y = n), r !== void 0 && (f.scale = r), o !== void 0 && xX(f, o, i, a, !1);
}
const CT = () => ({
  ...Kh(),
  attrs: {}
}), vT = (e) => typeof e == "string" && e.toLowerCase() === "svg";
function SX(e, t, n, r) {
  const o = _e(() => {
    const i = CT();
    return gT(i, t, vT(r), e.transformTemplate, e.style), {
      ...i.attrs,
      style: { ...i.style }
    };
  }, [t]);
  if (e.style) {
    const i = {};
    mT(i, e.style, e), o.style = { ...i, ...o.style };
  }
  return o;
}
const MX = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function Yh(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(MX.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(e))
    )
  );
}
function EX(e, t, n, { latestValues: r }, o, i = !1) {
  const s = (Yh(e) ? SX : yX)(t, r, o, e), l = uX(t, typeof e == "string", i), c = e !== vu ? { ...l, ...s, ref: n } : {}, { children: u } = t, f = _e(() => dn(u) ? u.get() : u, [u]);
  return Pd(e, {
    ...c,
    children: f
  });
}
function jC(e) {
  const t = [{}, {}];
  return e?.values.forEach((n, r) => {
    t[0][r] = n.get(), t[1][r] = n.getVelocity();
  }), t;
}
function Xh(e, t, n, r) {
  if (typeof t == "function") {
    const [o, i] = jC(r);
    t = t(n !== void 0 ? n : e.custom, o, i);
  }
  if (typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function") {
    const [o, i] = jC(r);
    t = t(n !== void 0 ? n : e.custom, o, i);
  }
  return t;
}
function qc(e) {
  return dn(e) ? e.get() : e;
}
function _X({ scrapeMotionValuesFromProps: e, createRenderState: t }, n, r, o) {
  return {
    latestValues: OX(n, r, o, e),
    renderState: t()
  };
}
function OX(e, t, n, r) {
  const o = {}, i = r(e, {});
  for (const h in i)
    o[h] = qc(i[h]);
  let { initial: a, animate: s } = e;
  const l = Xu(e), c = hT(e);
  t && c && !l && e.inherit !== !1 && (a === void 0 && (a = t.initial), s === void 0 && (s = t.animate));
  let u = n ? n.initial === !1 : !1;
  u = u || a === !1;
  const f = u ? s : a;
  if (f && typeof f != "boolean" && !Yu(f)) {
    const h = Array.isArray(f) ? f : [f];
    for (let p = 0; p < h.length; p++) {
      const C = Xh(e, h[p]);
      if (C) {
        const { transitionEnd: m, transition: g, ...v } = C;
        for (const y in v) {
          let w = v[y];
          if (Array.isArray(w)) {
            const x = u ? w.length - 1 : 0;
            w = w[x];
          }
          w !== null && (o[y] = w);
        }
        for (const y in m)
          o[y] = m[y];
      }
    }
  }
  return o;
}
const yT = (e) => (t, n) => {
  const r = Oe(Ku), o = Oe(qu), i = () => _X(e, t, r, o);
  return n ? i() : Wu(i);
};
function Qh(e, t, n) {
  const { style: r } = e, o = {};
  for (const i in r)
    (dn(r[i]) || t.style && dn(t.style[i]) || pT(i, e) || n?.getValue(i)?.liveStyle !== void 0) && (o[i] = r[i]);
  return o;
}
const AX = /* @__PURE__ */ yT({
  scrapeMotionValuesFromProps: Qh,
  createRenderState: Kh
});
function bT(e, t, n) {
  const r = Qh(e, t, n);
  for (const o in e)
    if (dn(e[o]) || dn(t[o])) {
      const i = ws.indexOf(o) !== -1 ? "attr" + o.charAt(0).toUpperCase() + o.substring(1) : o;
      r[i] = e[o];
    }
  return r;
}
const PX = /* @__PURE__ */ yT({
  scrapeMotionValuesFromProps: bT,
  createRenderState: CT
}), TX = Symbol.for("motionComponentSymbol");
function fa(e) {
  return e && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function IX(e, t, n) {
  return ct(
    (r) => {
      r && e.onMount && e.onMount(r), t && (r ? t.mount(r) : t.unmount()), n && (typeof n == "function" ? n(r) : fa(n) && (n.current = r));
    },
    /**
     * Include externalRef in dependencies to ensure the callback updates
     * when the ref changes, allowing proper ref forwarding.
     */
    [t]
  );
}
const Jh = (e) => e.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), DX = "framerAppearId", wT = "data-" + Jh(DX), xT = gt({});
function RX(e, t, n, r, o) {
  const { visualElement: i } = Oe(Ku), a = Oe(Wh), s = Oe(qu), l = Oe(Gu).reducedMotion, c = ke(null);
  r = r || a.renderer, !c.current && r && (c.current = r(e, {
    visualState: t,
    parent: i,
    props: n,
    presenceContext: s,
    blockInitialAnimation: s ? s.initial === !1 : !1,
    reducedMotionConfig: l
  }));
  const u = c.current, f = Oe(xT);
  u && !u.projection && o && (u.type === "html" || u.type === "svg") && kX(c.current, n, o, f);
  const h = ke(!1);
  XE(() => {
    u && h.current && u.update(n, s);
  });
  const p = n[wT], C = ke(!!p && !window.MotionHandoffIsComplete?.(p) && window.MotionHasOptimisedAnimation?.(p));
  return mP(() => {
    u && (h.current = !0, window.MotionIsMounted = !0, u.updateFeatures(), u.scheduleRenderMicrotask(), C.current && u.animationState && u.animationState.animateChanges());
  }), ve(() => {
    u && (!C.current && u.animationState && u.animationState.animateChanges(), C.current && (queueMicrotask(() => {
      window.MotionHandoffMarkAsComplete?.(p);
    }), C.current = !1), u.enteringChildren = void 0);
  }), u;
}
function kX(e, t, n, r) {
  const { layoutId: o, layout: i, drag: a, dragConstraints: s, layoutScroll: l, layoutRoot: c, layoutCrossfade: u } = t;
  e.projection = new n(e.latestValues, t["data-framer-portal-id"] ? void 0 : ST(e.parent)), e.projection.setOptions({
    layoutId: o,
    layout: i,
    alwaysMeasureLayout: !!a || s && fa(s),
    visualElement: e,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof i == "string" ? i : "both",
    initialPromotionConfig: r,
    crossfade: u,
    layoutScroll: l,
    layoutRoot: c
  });
}
function ST(e) {
  if (e)
    return e.options.allowProjection !== !1 ? e.projection : ST(e.parent);
}
function U7(e, { forwardMotionProps: t = !1 } = {}, n, r) {
  n && K9(n);
  const o = Yh(e) ? PX : AX;
  function i(s, l) {
    let c;
    const u = {
      ...Oe(Gu),
      ...s,
      layoutId: LX(s)
    }, { isStatic: f } = u, h = dX(s), p = o(s, f);
    if (!f && xh) {
      NX(u, n);
      const C = FX(u);
      c = C.MeasureLayout, h.visualElement = RX(e, p, u, r, C.ProjectionNode);
    }
    return F(Ku.Provider, { value: h, children: [c && h.visualElement ? d(c, { visualElement: h.visualElement, ...u }) : null, EX(e, s, IX(p, h.visualElement, l), p, f, t)] });
  }
  i.displayName = `motion.${typeof e == "string" ? e : `create(${e.displayName ?? e.name ?? ""})`}`;
  const a = Xe(i);
  return a[TX] = e, a;
}
function LX({ layoutId: e }) {
  const t = Oe(wh).id;
  return t && e !== void 0 ? t + "-" + e : e;
}
function NX(e, t) {
  const n = Oe(Wh).strict;
  if (process.env.NODE_ENV !== "production" && t && n) {
    const r = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    e.ignoreStrict ? ys(!1, r, "lazy-strict-mode") : Er(!1, r, "lazy-strict-mode");
  }
}
function FX(e) {
  const { drag: t, layout: n } = $a;
  if (!t && !n)
    return {};
  const r = { ...t, ...n };
  return {
    MeasureLayout: t?.isEnabled(e) || n?.isEnabled(e) ? r.MeasureLayout : void 0,
    ProjectionNode: r.ProjectionNode
  };
}
function MT(e, t) {
  if (typeof Proxy > "u")
    return U7;
  const n = /* @__PURE__ */ new Map(), r = (i, a) => U7(i, a, e, t), o = (i, a) => (process.env.NODE_ENV !== "production" && _h(!1, "motion() is deprecated. Use motion.create() instead."), r(i, a));
  return new Proxy(o, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (i, a) => a === "create" ? r : (n.has(a) || n.set(a, U7(a, void 0, e, t)), n.get(a))
  });
}
const VX = /* @__PURE__ */ MT();
function ET({ top: e, left: t, right: n, bottom: r }) {
  return {
    x: { min: t, max: n },
    y: { min: e, max: r }
  };
}
function BX({ x: e, y: t }) {
  return { top: t.min, right: e.max, bottom: t.max, left: e.min };
}
function $X(e, t) {
  if (!t)
    return e;
  const n = t({ x: e.left, y: e.top }), r = t({ x: e.right, y: e.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
function G7(e) {
  return e === void 0 || e === 1;
}
function Y9({ scale: e, scaleX: t, scaleY: n }) {
  return !G7(e) || !G7(t) || !G7(n);
}
function X1(e) {
  return Y9(e) || _T(e) || e.z || e.rotate || e.rotateX || e.rotateY || e.skewX || e.skewY;
}
function _T(e) {
  return HC(e.x) || HC(e.y);
}
function HC(e) {
  return e && e !== "0%";
}
function m5(e, t, n) {
  const r = e - n, o = t * r;
  return n + o;
}
function zC(e, t, n, r, o) {
  return o !== void 0 && (e = m5(e, o, r)), m5(e, n, r) + t;
}
function X9(e, t = 0, n = 1, r, o) {
  e.min = zC(e.min, t, n, r, o), e.max = zC(e.max, t, n, r, o);
}
function OT(e, { x: t, y: n }) {
  X9(e.x, t.translate, t.scale, t.originPoint), X9(e.y, n.translate, n.scale, n.originPoint);
}
const ZC = 0.999999999999, WC = 1.0000000000001;
function jX(e, t, n, r = !1) {
  const o = n.length;
  if (!o)
    return;
  t.x = t.y = 1;
  let i, a;
  for (let s = 0; s < o; s++) {
    i = n[s], a = i.projectionDelta;
    const { visualElement: l } = i.options;
    l && l.props.style && l.props.style.display === "contents" || (r && i.options.layoutScroll && i.scroll && i !== i.root && ha(e, {
      x: -i.scroll.offset.x,
      y: -i.scroll.offset.y
    }), a && (t.x *= a.x.scale, t.y *= a.y.scale, OT(e, a)), r && X1(i.latestValues) && ha(e, i.latestValues));
  }
  t.x < WC && t.x > ZC && (t.x = 1), t.y < WC && t.y > ZC && (t.y = 1);
}
function da(e, t) {
  e.min = e.min + t, e.max = e.max + t;
}
function qC(e, t, n, r, o = 0.5) {
  const i = Pt(e.min, e.max, o);
  X9(e, t, n, i, r);
}
function ha(e, t) {
  qC(e.x, t.x, t.scaleX, t.scale, t.originX), qC(e.y, t.y, t.scaleY, t.scale, t.originY);
}
function AT(e, t) {
  return ET($X(e.getBoundingClientRect(), t));
}
function HX(e, t, n) {
  const r = AT(e, n), { scroll: o } = t;
  return o && (da(r.x, o.offset.x), da(r.y, o.offset.y)), r;
}
const UC = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), pa = () => ({
  x: UC(),
  y: UC()
}), GC = () => ({ min: 0, max: 0 }), Vt = () => ({
  x: GC(),
  y: GC()
}), Q9 = { current: null }, PT = { current: !1 };
function zX() {
  if (PT.current = !0, !!xh)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), t = () => Q9.current = e.matches;
      e.addEventListener("change", t), t();
    } else
      Q9.current = !1;
}
const Bl = /* @__PURE__ */ new WeakMap();
function ZX(e, t, n) {
  for (const r in t) {
    const o = t[r], i = n[r];
    if (dn(o))
      e.addValue(r, o);
    else if (dn(i))
      e.addValue(r, Mi(o, { owner: e }));
    else if (i !== o)
      if (e.hasValue(r)) {
        const a = e.getValue(r);
        a.liveStyle === !0 ? a.jump(o) : a.hasAnimated || a.set(o);
      } else {
        const a = e.getStaticValue(r);
        e.addValue(r, Mi(a !== void 0 ? a : o, { owner: e }));
      }
  }
  for (const r in n)
    t[r] === void 0 && e.removeValue(r);
  return t;
}
const KC = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
class TT {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(t, n, r) {
    return {};
  }
  constructor({ parent: t, props: n, presenceContext: r, reducedMotionConfig: o, blockInitialAnimation: i, visualState: a }, s = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = Vh, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const h = qn.now();
      this.renderScheduledAt < h && (this.renderScheduledAt = h, Tt.render(this.render, !1, !0));
    };
    const { latestValues: l, renderState: c } = a;
    this.latestValues = l, this.baseTarget = { ...l }, this.initialValues = n.initial ? { ...l } : {}, this.renderState = c, this.parent = t, this.props = n, this.presenceContext = r, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = o, this.options = s, this.blockInitialAnimation = !!i, this.isControllingVariants = Xu(n), this.isVariantNode = hT(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(t && t.current);
    const { willChange: u, ...f } = this.scrapeMotionValuesFromProps(n, {}, this);
    for (const h in f) {
      const p = f[h];
      l[h] !== void 0 && dn(p) && p.set(l[h]);
    }
  }
  mount(t) {
    this.current = t, Bl.set(t, this), this.projection && !this.projection.instance && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((n, r) => this.bindToMotionValue(r, n)), PT.current || zX(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : Q9.current, process.env.NODE_ENV !== "production" && _h(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected.", "reduced-motion-disabled"), this.parent?.addChild(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    this.projection && this.projection.unmount(), P1(this.notifyUpdate), P1(this.render), this.valueSubscriptions.forEach((t) => t()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent?.removeChild(this);
    for (const t in this.events)
      this.events[t].clear();
    for (const t in this.features) {
      const n = this.features[t];
      n && (n.unmount(), n.isMounted = !1);
    }
    this.current = null;
  }
  addChild(t) {
    this.children.add(t), this.enteringChildren ?? (this.enteringChildren = /* @__PURE__ */ new Set()), this.enteringChildren.add(t);
  }
  removeChild(t) {
    this.children.delete(t), this.enteringChildren && this.enteringChildren.delete(t);
  }
  bindToMotionValue(t, n) {
    this.valueSubscriptions.has(t) && this.valueSubscriptions.get(t)();
    const r = xs.has(t);
    r && this.onBindTransform && this.onBindTransform();
    const o = n.on("change", (a) => {
      this.latestValues[t] = a, this.props.onUpdate && Tt.preRender(this.notifyUpdate), r && this.projection && (this.projection.isTransformDirty = !0), this.scheduleRender();
    });
    let i;
    window.MotionCheckAppearSync && (i = window.MotionCheckAppearSync(this, t, n)), this.valueSubscriptions.set(t, () => {
      o(), i && i(), n.owner && n.stop();
    });
  }
  sortNodePosition(t) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== t.type ? 0 : this.sortInstanceNodePosition(this.current, t.current);
  }
  updateFeatures() {
    let t = "animation";
    for (t in $a) {
      const n = $a[t];
      if (!n)
        continue;
      const { isEnabled: r, Feature: o } = n;
      if (!this.features[t] && o && r(this.props) && (this.features[t] = new o(this)), this.features[t]) {
        const i = this.features[t];
        i.isMounted ? i.update() : (i.mount(), i.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : Vt();
  }
  getStaticValue(t) {
    return this.latestValues[t];
  }
  setStaticValue(t, n) {
    this.latestValues[t] = n;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(t, n) {
    (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let r = 0; r < KC.length; r++) {
      const o = KC[r];
      this.propEventSubscriptions[o] && (this.propEventSubscriptions[o](), delete this.propEventSubscriptions[o]);
      const i = "on" + o, a = t[i];
      a && (this.propEventSubscriptions[o] = this.on(o, a));
    }
    this.prevMotionValues = ZX(this, this.scrapeMotionValuesFromProps(t, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(t) {
    return this.props.variants ? this.props.variants[t] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(t) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(t), () => n.variantChildren.delete(t);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(t, n) {
    const r = this.values.get(t);
    n !== r && (r && this.removeValue(t), this.bindToMotionValue(t, n), this.values.set(t, n), this.latestValues[t] = n.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(t) {
    this.values.delete(t);
    const n = this.valueSubscriptions.get(t);
    n && (n(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(t) {
    return this.values.has(t);
  }
  getValue(t, n) {
    if (this.props.values && this.props.values[t])
      return this.props.values[t];
    let r = this.values.get(t);
    return r === void 0 && n !== void 0 && (r = Mi(n === null ? void 0 : n, { owner: this }), this.addValue(t, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(t, n) {
    let r = this.latestValues[t] !== void 0 || !this.current ? this.latestValues[t] : this.getBaseTargetFromProps(this.props, t) ?? this.readValueFromInstance(this.current, t, this.options);
    return r != null && (typeof r == "string" && (gP(r) || vP(r)) ? r = parseFloat(r) : !JY(r) && T1.test(n) && (r = rT(t, n)), this.setBaseTarget(t, dn(r) ? r.get() : r)), dn(r) ? r.get() : r;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(t, n) {
    this.baseTarget[t] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(t) {
    const { initial: n } = this.props;
    let r;
    if (typeof n == "string" || typeof n == "object") {
      const i = Xh(this.props, n, this.presenceContext?.custom);
      i && (r = i[t]);
    }
    if (n && r !== void 0)
      return r;
    const o = this.getBaseTargetFromProps(this.props, t);
    return o !== void 0 && !dn(o) ? o : this.initialValues[t] !== void 0 && r === void 0 ? void 0 : this.baseTarget[t];
  }
  on(t, n) {
    return this.events[t] || (this.events[t] = new Eh()), this.events[t].add(n);
  }
  notify(t, ...n) {
    this.events[t] && this.events[t].notify(...n);
  }
  scheduleRenderMicrotask() {
    Hh.render(this.render);
  }
}
class IT extends TT {
  constructor() {
    super(...arguments), this.KeyframeResolver = zY;
  }
  sortInstanceNodePosition(t, n) {
    return t.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(t, n) {
    return t.style ? t.style[n] : void 0;
  }
  removeValueFromRenderState(t, { vars: n, style: r }) {
    delete n[t], delete r[t];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: t } = this.props;
    dn(t) && (this.childSubscription = t.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
}
function DT(e, { style: t, vars: n }, r, o) {
  const i = e.style;
  let a;
  for (a in t)
    i[a] = t[a];
  o?.applyProjectionStyles(i, r);
  for (a in n)
    i.setProperty(a, n[a]);
}
function WX(e) {
  return window.getComputedStyle(e);
}
class RT extends IT {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = DT;
  }
  readValueFromInstance(t, n) {
    if (xs.has(n))
      return this.projection?.isProjecting ? H9(n) : iY(t, n);
    {
      const r = WX(t), o = (Ph(n) ? r.getPropertyValue(n) : r[n]) || 0;
      return typeof o == "string" ? o.trim() : o;
    }
  }
  measureInstanceViewportBox(t, { transformPagePoint: n }) {
    return AT(t, n);
  }
  build(t, n, r) {
    Gh(t, n, r.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return Qh(t, n, r);
  }
}
const kT = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function qX(e, t, n, r) {
  DT(e, t, void 0, r);
  for (const o in t.attrs)
    e.setAttribute(kT.has(o) ? o : Jh(o), t.attrs[o]);
}
class LT extends IT {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = Vt;
  }
  getBaseTargetFromProps(t, n) {
    return t[n];
  }
  readValueFromInstance(t, n) {
    if (xs.has(n)) {
      const r = nT(n);
      return r && r.default || 0;
    }
    return n = kT.has(n) ? n : Jh(n), t.getAttribute(n);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return bT(t, n, r);
  }
  build(t, n, r) {
    gT(t, n, this.isSVGTag, r.transformTemplate, r.style);
  }
  renderInstance(t, n, r, o) {
    qX(t, n, r, o);
  }
  mount(t) {
    this.isSVGTag = vT(t.tagName), super.mount(t);
  }
}
const NT = (e, t) => Yh(e) ? new LT(t) : new RT(t, {
  allowProjection: e !== vu
});
function Pa(e, t, n) {
  const r = e.getProps();
  return Xh(r, t, n !== void 0 ? n : r.custom, e);
}
const J9 = (e) => Array.isArray(e);
function UX(e, t, n) {
  e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, Mi(n));
}
function GX(e) {
  return J9(e) ? e[e.length - 1] || 0 : e;
}
function KX(e, t) {
  const n = Pa(e, t);
  let { transitionEnd: r = {}, transition: o = {}, ...i } = n || {};
  i = { ...i, ...r };
  for (const a in i) {
    const s = GX(i[a]);
    UX(e, a, s);
  }
}
function YX(e) {
  return !!(dn(e) && e.add);
}
function ef(e, t) {
  const n = e.getValue("willChange");
  if (YX(n))
    return n.add(t);
  if (!n && Xo.WillChange) {
    const r = new Xo.WillChange("auto");
    e.addValue("willChange", r), r.add(t);
  }
}
function FT(e) {
  return e.props[wT];
}
const XX = (e) => e !== null;
function QX(e, { repeat: t, repeatType: n = "loop" }, r) {
  const o = e.filter(XX), i = t && n !== "loop" && t % 2 === 1 ? 0 : o.length - 1;
  return o[i];
}
const JX = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, eQ = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), tQ = {
  type: "keyframes",
  duration: 0.8
}, nQ = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, rQ = (e, { keyframes: t }) => t.length > 2 ? tQ : xs.has(e) ? e.startsWith("scale") ? eQ(t[1]) : JX : nQ;
function oQ({ when: e, delay: t, delayChildren: n, staggerChildren: r, staggerDirection: o, repeat: i, repeatType: a, repeatDelay: s, from: l, elapsed: c, ...u }) {
  return !!Object.keys(u).length;
}
const ep = (e, t, n, r = {}, o, i) => (a) => {
  const s = $h(r, e) || {}, l = s.delay || r.delay || 0;
  let { elapsed: c = 0 } = r;
  c = c - /* @__PURE__ */ xr(l);
  const u = {
    keyframes: Array.isArray(n) ? n : [null, n],
    ease: "easeOut",
    velocity: t.getVelocity(),
    ...s,
    delay: -c,
    onUpdate: (h) => {
      t.set(h), s.onUpdate && s.onUpdate(h);
    },
    onComplete: () => {
      a(), s.onComplete && s.onComplete();
    },
    name: e,
    motionValue: t,
    element: i ? void 0 : o
  };
  oQ(s) || Object.assign(u, rQ(e, u)), u.duration && (u.duration = /* @__PURE__ */ xr(u.duration)), u.repeatDelay && (u.repeatDelay = /* @__PURE__ */ xr(u.repeatDelay)), u.from !== void 0 && (u.keyframes[0] = u.from);
  let f = !1;
  if ((u.type === !1 || u.duration === 0 && !u.repeatDelay) && (U9(u), u.delay === 0 && (f = !0)), (Xo.instantAnimations || Xo.skipAnimations) && (f = !0, U9(u), u.delay = 0), u.allowFlatten = !s.type && !s.ease, f && !i && t.get() !== void 0) {
    const h = QX(u.keyframes, s);
    if (h !== void 0) {
      Tt.update(() => {
        u.onUpdate(h), u.onComplete();
      });
      return;
    }
  }
  return s.isSync ? new Fh(u) : new AY(u);
};
function iQ({ protectedKeys: e, needsAnimating: t }, n) {
  const r = e.hasOwnProperty(n) && t[n] !== !0;
  return t[n] = !1, r;
}
function tp(e, t, { delay: n = 0, transitionOverride: r, type: o } = {}) {
  let { transition: i = e.getDefaultTransition(), transitionEnd: a, ...s } = t;
  r && (i = r);
  const l = [], c = o && e.animationState && e.animationState.getState()[o];
  for (const u in s) {
    const f = e.getValue(u, e.latestValues[u] ?? null), h = s[u];
    if (h === void 0 || c && iQ(c, u))
      continue;
    const p = {
      delay: n,
      ...$h(i || {}, u)
    }, C = f.get();
    if (C !== void 0 && !f.isAnimating && !Array.isArray(h) && h === C && !p.velocity)
      continue;
    let m = !1;
    if (window.MotionHandoffAnimation) {
      const v = FT(e);
      if (v) {
        const y = window.MotionHandoffAnimation(v, u, Tt);
        y !== null && (p.startTime = y, m = !0);
      }
    }
    ef(e, u), f.start(ep(u, f, h, e.shouldReduceMotion && JP.has(u) ? { type: !1 } : p, e, m));
    const g = f.animation;
    g && l.push(g);
  }
  return a && Promise.all(l).then(() => {
    Tt.update(() => {
      a && KX(e, a);
    });
  }), l;
}
function VT(e, t, n, r = 0, o = 1) {
  const i = Array.from(e).sort((c, u) => c.sortNodePosition(u)).indexOf(t), a = e.size, s = (a - 1) * r;
  return typeof n == "function" ? n(i, a) : o === 1 ? i * r : s - i * r;
}
function tf(e, t, n = {}) {
  const r = Pa(e, t, n.type === "exit" ? e.presenceContext?.custom : void 0);
  let { transition: o = e.getDefaultTransition() || {} } = r || {};
  n.transitionOverride && (o = n.transitionOverride);
  const i = r ? () => Promise.all(tp(e, r, n)) : () => Promise.resolve(), a = e.variantChildren && e.variantChildren.size ? (l = 0) => {
    const { delayChildren: c = 0, staggerChildren: u, staggerDirection: f } = o;
    return aQ(e, t, l, c, u, f, n);
  } : () => Promise.resolve(), { when: s } = o;
  if (s) {
    const [l, c] = s === "beforeChildren" ? [i, a] : [a, i];
    return l().then(() => c());
  } else
    return Promise.all([i(), a(n.delay)]);
}
function aQ(e, t, n = 0, r = 0, o = 0, i = 1, a) {
  const s = [];
  for (const l of e.variantChildren)
    l.notify("AnimationStart", t), s.push(tf(l, t, {
      ...a,
      delay: n + (typeof r == "function" ? 0 : r) + VT(e.variantChildren, l, r, o, i)
    }).then(() => l.notify("AnimationComplete", t)));
  return Promise.all(s);
}
function sQ(e, t, n = {}) {
  e.notify("AnimationStart", t);
  let r;
  if (Array.isArray(t)) {
    const o = t.map((i) => tf(e, i, n));
    r = Promise.all(o);
  } else if (typeof t == "string")
    r = tf(e, t, n);
  else {
    const o = typeof t == "function" ? Pa(e, t, n.custom) : t;
    r = Promise.all(tp(e, o, n));
  }
  return r.then(() => {
    e.notify("AnimationComplete", t);
  });
}
function BT(e, t) {
  if (!Array.isArray(t))
    return !1;
  const n = t.length;
  if (n !== e.length)
    return !1;
  for (let r = 0; r < n; r++)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
const lQ = Uh.length;
function $T(e) {
  if (!e)
    return;
  if (!e.isControllingVariants) {
    const n = e.parent ? $T(e.parent) || {} : {};
    return e.props.initial !== void 0 && (n.initial = e.props.initial), n;
  }
  const t = {};
  for (let n = 0; n < lQ; n++) {
    const r = Uh[n], o = e.props[r];
    (Fl(o) || o === !1) && (t[r] = o);
  }
  return t;
}
const cQ = [...qh].reverse(), uQ = qh.length;
function fQ(e) {
  return (t) => Promise.all(t.map(({ animation: n, options: r }) => sQ(e, n, r)));
}
function dQ(e) {
  let t = fQ(e), n = YC(), r = !0;
  const o = (l) => (c, u) => {
    const f = Pa(e, u, l === "exit" ? e.presenceContext?.custom : void 0);
    if (f) {
      const { transition: h, transitionEnd: p, ...C } = f;
      c = { ...c, ...C, ...p };
    }
    return c;
  };
  function i(l) {
    t = l(e);
  }
  function a(l) {
    const { props: c } = e, u = $T(e.parent) || {}, f = [], h = /* @__PURE__ */ new Set();
    let p = {}, C = 1 / 0;
    for (let g = 0; g < uQ; g++) {
      const v = cQ[g], y = n[v], w = c[v] !== void 0 ? c[v] : u[v], x = Fl(w), b = v === l ? y.isActive : null;
      b === !1 && (C = g);
      let S = w === u[v] && w !== c[v] && x;
      if (S && r && e.manuallyAnimateOnMount && (S = !1), y.protectedKeys = { ...p }, // If it isn't active and hasn't *just* been set as inactive
      !y.isActive && b === null || // If we didn't and don't have any defined prop for this animation type
      !w && !y.prevProp || // Or if the prop doesn't define an animation
      Yu(w) || typeof w == "boolean")
        continue;
      const M = hQ(y.prevProp, w);
      let E = M || // If we're making this variant active, we want to always make it active
      v === l && y.isActive && !S && x || // If we removed a higher-priority variant (i is in reverse order)
      g > C && x, P = !1;
      const T = Array.isArray(w) ? w : [w];
      let _ = T.reduce(o(v), {});
      b === !1 && (_ = {});
      const { prevResolvedValues: D = {} } = y, N = {
        ...D,
        ..._
      }, R = (V) => {
        E = !0, h.has(V) && (P = !0, h.delete(V)), y.needsAnimating[V] = !0;
        const k = e.getValue(V);
        k && (k.liveStyle = !1);
      };
      for (const V in N) {
        const k = _[V], z = D[V];
        if (p.hasOwnProperty(V))
          continue;
        let $ = !1;
        J9(k) && J9(z) ? $ = !BT(k, z) : $ = k !== z, $ ? k != null ? R(V) : h.add(V) : k !== void 0 && h.has(V) ? R(V) : y.protectedKeys[V] = !0;
      }
      y.prevProp = w, y.prevResolvedValues = _, y.isActive && (p = { ...p, ..._ }), r && e.blockInitialAnimation && (E = !1);
      const L = S && M;
      E && (!L || P) && f.push(...T.map((V) => {
        const k = { type: v };
        if (typeof V == "string" && r && !L && e.manuallyAnimateOnMount && e.parent) {
          const { parent: z } = e, $ = Pa(z, V);
          if (z.enteringChildren && $) {
            const { delayChildren: Z } = $.transition || {};
            k.delay = VT(z.enteringChildren, e, Z);
          }
        }
        return {
          animation: V,
          options: k
        };
      }));
    }
    if (h.size) {
      const g = {};
      if (typeof c.initial != "boolean") {
        const v = Pa(e, Array.isArray(c.initial) ? c.initial[0] : c.initial);
        v && v.transition && (g.transition = v.transition);
      }
      h.forEach((v) => {
        const y = e.getBaseTarget(v), w = e.getValue(v);
        w && (w.liveStyle = !0), g[v] = y ?? null;
      }), f.push({ animation: g });
    }
    let m = !!f.length;
    return r && (c.initial === !1 || c.initial === c.animate) && !e.manuallyAnimateOnMount && (m = !1), r = !1, m ? t(f) : Promise.resolve();
  }
  function s(l, c) {
    if (n[l].isActive === c)
      return Promise.resolve();
    e.variantChildren?.forEach((f) => f.animationState?.setActive(l, c)), n[l].isActive = c;
    const u = a(l);
    for (const f in n)
      n[f].protectedKeys = {};
    return u;
  }
  return {
    animateChanges: a,
    setActive: s,
    setAnimateFunction: i,
    getState: () => n,
    reset: () => {
      n = YC(), r = !0;
    }
  };
}
function hQ(e, t) {
  return typeof t == "string" ? t !== e : Array.isArray(t) ? !BT(t, e) : !1;
}
function q1(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function YC() {
  return {
    animate: q1(!0),
    whileInView: q1(),
    whileHover: q1(),
    whileTap: q1(),
    whileDrag: q1(),
    whileFocus: q1(),
    exit: q1()
  };
}
class F1 {
  constructor(t) {
    this.isMounted = !1, this.node = t;
  }
  update() {
  }
}
class pQ extends F1 {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(t) {
    super(t), t.animationState || (t.animationState = dQ(t));
  }
  updateAnimationControlsSubscription() {
    const { animate: t } = this.node.getProps();
    Yu(t) && (this.unmountControls = t.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: t } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    t !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
    this.node.animationState.reset(), this.unmountControls?.();
  }
}
let mQ = 0;
class gQ extends F1 {
  constructor() {
    super(...arguments), this.id = mQ++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: t, onExitComplete: n } = this.node.presenceContext, { isPresent: r } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || t === r)
      return;
    const o = this.node.animationState.setActive("exit", !t);
    n && !t && o.then(() => {
      n(this.id);
    });
  }
  mount() {
    const { register: t, onExitComplete: n } = this.node.presenceContext || {};
    n && n(this.id), t && (this.unmount = t(this.id));
  }
  unmount() {
  }
}
const jT = {
  animation: {
    Feature: pQ
  },
  exit: {
    Feature: gQ
  }
};
function $l(e, t, n, r = { passive: !0 }) {
  return e.addEventListener(t, n, r), () => e.removeEventListener(t, n);
}
function $2(e) {
  return {
    point: {
      x: e.pageX,
      y: e.pageY
    }
  };
}
const CQ = (e) => (t) => zh(t) && e(t, $2(t));
function Cl(e, t, n, r) {
  return $l(e, t, CQ(n), r);
}
const HT = 1e-4, vQ = 1 - HT, yQ = 1 + HT, zT = 0.01, bQ = 0 - zT, wQ = 0 + zT;
function Ln(e) {
  return e.max - e.min;
}
function xQ(e, t, n) {
  return Math.abs(e - t) <= n;
}
function XC(e, t, n, r = 0.5) {
  e.origin = r, e.originPoint = Pt(t.min, t.max, e.origin), e.scale = Ln(n) / Ln(t), e.translate = Pt(n.min, n.max, e.origin) - e.originPoint, (e.scale >= vQ && e.scale <= yQ || isNaN(e.scale)) && (e.scale = 1), (e.translate >= bQ && e.translate <= wQ || isNaN(e.translate)) && (e.translate = 0);
}
function vl(e, t, n, r) {
  XC(e.x, t.x, n.x, r ? r.originX : void 0), XC(e.y, t.y, n.y, r ? r.originY : void 0);
}
function QC(e, t, n) {
  e.min = n.min + t.min, e.max = e.min + Ln(t);
}
function SQ(e, t, n) {
  QC(e.x, t.x, n.x), QC(e.y, t.y, n.y);
}
function JC(e, t, n) {
  e.min = t.min - n.min, e.max = e.min + Ln(t);
}
function yl(e, t, n) {
  JC(e.x, t.x, n.x), JC(e.y, t.y, n.y);
}
function gr(e) {
  return [e("x"), e("y")];
}
const ZT = ({ current: e }) => e ? e.ownerDocument.defaultView : null, ev = (e, t) => Math.abs(e - t);
function MQ(e, t) {
  const n = ev(e.x, t.x), r = ev(e.y, t.y);
  return Math.sqrt(n ** 2 + r ** 2);
}
class WT {
  constructor(t, n, { transformPagePoint: r, contextWindow: o = window, dragSnapToOrigin: i = !1, distanceThreshold: a = 3 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const h = Y7(this.lastMoveEventInfo, this.history), p = this.startEvent !== null, C = MQ(h.offset, { x: 0, y: 0 }) >= this.distanceThreshold;
      if (!p && !C)
        return;
      const { point: m } = h, { timestamp: g } = Cn;
      this.history.push({ ...m, timestamp: g });
      const { onStart: v, onMove: y } = this.handlers;
      p || (v && v(this.lastMoveEvent, h), this.startEvent = this.lastMoveEvent), y && y(this.lastMoveEvent, h);
    }, this.handlePointerMove = (h, p) => {
      this.lastMoveEvent = h, this.lastMoveEventInfo = K7(p, this.transformPagePoint), Tt.update(this.updatePoint, !0);
    }, this.handlePointerUp = (h, p) => {
      this.end();
      const { onEnd: C, onSessionEnd: m, resumeAnimation: g } = this.handlers;
      if (this.dragSnapToOrigin && g && g(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const v = Y7(h.type === "pointercancel" ? this.lastMoveEventInfo : K7(p, this.transformPagePoint), this.history);
      this.startEvent && C && C(h, v), m && m(h, v);
    }, !zh(t))
      return;
    this.dragSnapToOrigin = i, this.handlers = n, this.transformPagePoint = r, this.distanceThreshold = a, this.contextWindow = o || window;
    const s = $2(t), l = K7(s, this.transformPagePoint), { point: c } = l, { timestamp: u } = Cn;
    this.history = [{ ...c, timestamp: u }];
    const { onSessionStart: f } = n;
    f && f(t, Y7(l, this.history)), this.removeListeners = F2(Cl(this.contextWindow, "pointermove", this.handlePointerMove), Cl(this.contextWindow, "pointerup", this.handlePointerUp), Cl(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(t) {
    this.handlers = t;
  }
  end() {
    this.removeListeners && this.removeListeners(), P1(this.updatePoint);
  }
}
function K7(e, t) {
  return t ? { point: t(e.point) } : e;
}
function tv(e, t) {
  return { x: e.x - t.x, y: e.y - t.y };
}
function Y7({ point: e }, t) {
  return {
    point: e,
    delta: tv(e, qT(t)),
    offset: tv(e, EQ(t)),
    velocity: _Q(t, 0.1)
  };
}
function EQ(e) {
  return e[0];
}
function qT(e) {
  return e[e.length - 1];
}
function _Q(e, t) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  let n = e.length - 1, r = null;
  const o = qT(e);
  for (; n >= 0 && (r = e[n], !(o.timestamp - r.timestamp > /* @__PURE__ */ xr(t))); )
    n--;
  if (!r)
    return { x: 0, y: 0 };
  const i = /* @__PURE__ */ yr(o.timestamp - r.timestamp);
  if (i === 0)
    return { x: 0, y: 0 };
  const a = {
    x: (o.x - r.x) / i,
    y: (o.y - r.y) / i
  };
  return a.x === 1 / 0 && (a.x = 0), a.y === 1 / 0 && (a.y = 0), a;
}
function OQ(e, { min: t, max: n }, r) {
  return t !== void 0 && e < t ? e = r ? Pt(t, e, r.min) : Math.max(e, t) : n !== void 0 && e > n && (e = r ? Pt(n, e, r.max) : Math.min(e, n)), e;
}
function nv(e, t, n) {
  return {
    min: t !== void 0 ? e.min + t : void 0,
    max: n !== void 0 ? e.max + n - (e.max - e.min) : void 0
  };
}
function AQ(e, { top: t, left: n, bottom: r, right: o }) {
  return {
    x: nv(e.x, n, o),
    y: nv(e.y, t, r)
  };
}
function rv(e, t) {
  let n = t.min - e.min, r = t.max - e.max;
  return t.max - t.min < e.max - e.min && ([n, r] = [r, n]), { min: n, max: r };
}
function PQ(e, t) {
  return {
    x: rv(e.x, t.x),
    y: rv(e.y, t.y)
  };
}
function TQ(e, t) {
  let n = 0.5;
  const r = Ln(e), o = Ln(t);
  return o > r ? n = /* @__PURE__ */ Ba(t.min, t.max - r, e.min) : r > o && (n = /* @__PURE__ */ Ba(e.min, e.max - o, t.min)), Yo(0, 1, n);
}
function IQ(e, t) {
  const n = {};
  return t.min !== void 0 && (n.min = t.min - e.min), t.max !== void 0 && (n.max = t.max - e.min), n;
}
const nf = 0.35;
function DQ(e = nf) {
  return e === !1 ? e = 0 : e === !0 && (e = nf), {
    x: ov(e, "left", "right"),
    y: ov(e, "top", "bottom")
  };
}
function ov(e, t, n) {
  return {
    min: iv(e, t),
    max: iv(e, n)
  };
}
function iv(e, t) {
  return typeof e == "number" ? e : e[t] || 0;
}
const RQ = /* @__PURE__ */ new WeakMap();
class kQ {
  constructor(t) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = Vt(), this.latestPointerEvent = null, this.latestPanInfo = null, this.visualElement = t;
  }
  start(t, { snapToCursor: n = !1, distanceThreshold: r } = {}) {
    const { presenceContext: o } = this.visualElement;
    if (o && o.isPresent === !1)
      return;
    const i = (f) => {
      const { dragSnapToOrigin: h } = this.getProps();
      h ? this.pauseAnimation() : this.stopAnimation(), n && this.snapToCursor($2(f).point);
    }, a = (f, h) => {
      const { drag: p, dragPropagation: C, onDragStart: m } = this.getProps();
      if (p && !C && (this.openDragLock && this.openDragLock(), this.openDragLock = qY(p), !this.openDragLock))
        return;
      this.latestPointerEvent = f, this.latestPanInfo = h, this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), gr((v) => {
        let y = this.getAxisMotionValue(v).get() || 0;
        if (po.test(y)) {
          const { projection: w } = this.visualElement;
          if (w && w.layout) {
            const x = w.layout.layoutBox[v];
            x && (y = Ln(x) * (parseFloat(y) / 100));
          }
        }
        this.originPoint[v] = y;
      }), m && Tt.postRender(() => m(f, h)), ef(this.visualElement, "transform");
      const { animationState: g } = this.visualElement;
      g && g.setActive("whileDrag", !0);
    }, s = (f, h) => {
      this.latestPointerEvent = f, this.latestPanInfo = h;
      const { dragPropagation: p, dragDirectionLock: C, onDirectionLock: m, onDrag: g } = this.getProps();
      if (!p && !this.openDragLock)
        return;
      const { offset: v } = h;
      if (C && this.currentDirection === null) {
        this.currentDirection = LQ(v), this.currentDirection !== null && m && m(this.currentDirection);
        return;
      }
      this.updateAxis("x", h.point, v), this.updateAxis("y", h.point, v), this.visualElement.render(), g && g(f, h);
    }, l = (f, h) => {
      this.latestPointerEvent = f, this.latestPanInfo = h, this.stop(f, h), this.latestPointerEvent = null, this.latestPanInfo = null;
    }, c = () => gr((f) => this.getAnimationState(f) === "paused" && this.getAxisMotionValue(f).animation?.play()), { dragSnapToOrigin: u } = this.getProps();
    this.panSession = new WT(t, {
      onSessionStart: i,
      onStart: a,
      onMove: s,
      onSessionEnd: l,
      resumeAnimation: c
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: u,
      distanceThreshold: r,
      contextWindow: ZT(this.visualElement)
    });
  }
  /**
   * @internal
   */
  stop(t, n) {
    const r = t || this.latestPointerEvent, o = n || this.latestPanInfo, i = this.isDragging;
    if (this.cancel(), !i || !o || !r)
      return;
    const { velocity: a } = o;
    this.startAnimation(a);
    const { onDragEnd: s } = this.getProps();
    s && Tt.postRender(() => s(r, o));
  }
  /**
   * @internal
   */
  cancel() {
    this.isDragging = !1;
    const { projection: t, animationState: n } = this.visualElement;
    t && (t.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: r } = this.getProps();
    !r && this.openDragLock && (this.openDragLock(), this.openDragLock = null), n && n.setActive("whileDrag", !1);
  }
  updateAxis(t, n, r) {
    const { drag: o } = this.getProps();
    if (!r || !yc(t, o, this.currentDirection))
      return;
    const i = this.getAxisMotionValue(t);
    let a = this.originPoint[t] + r[t];
    this.constraints && this.constraints[t] && (a = OQ(a, this.constraints[t], this.elastic[t])), i.set(a);
  }
  resolveConstraints() {
    const { dragConstraints: t, dragElastic: n } = this.getProps(), r = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : this.visualElement.projection?.layout, o = this.constraints;
    t && fa(t) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : t && r ? this.constraints = AQ(r.layoutBox, t) : this.constraints = !1, this.elastic = DQ(n), o !== this.constraints && r && this.constraints && !this.hasMutatedConstraints && gr((i) => {
      this.constraints !== !1 && this.getAxisMotionValue(i) && (this.constraints[i] = IQ(r.layoutBox[i], this.constraints[i]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: t, onMeasureDragConstraints: n } = this.getProps();
    if (!t || !fa(t))
      return !1;
    const r = t.current;
    Er(r !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
    const { projection: o } = this.visualElement;
    if (!o || !o.layout)
      return !1;
    const i = HX(r, o.root, this.visualElement.getTransformPagePoint());
    let a = PQ(o.layout.layoutBox, i);
    if (n) {
      const s = n(BX(a));
      this.hasMutatedConstraints = !!s, s && (a = ET(s));
    }
    return a;
  }
  startAnimation(t) {
    const { drag: n, dragMomentum: r, dragElastic: o, dragTransition: i, dragSnapToOrigin: a, onDragTransitionEnd: s } = this.getProps(), l = this.constraints || {}, c = gr((u) => {
      if (!yc(u, n, this.currentDirection))
        return;
      let f = l && l[u] || {};
      a && (f = { min: 0, max: 0 });
      const h = o ? 200 : 1e6, p = o ? 40 : 1e7, C = {
        type: "inertia",
        velocity: r ? t[u] : 0,
        bounceStiffness: h,
        bounceDamping: p,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...i,
        ...f
      };
      return this.startAxisValueAnimation(u, C);
    });
    return Promise.all(c).then(s);
  }
  startAxisValueAnimation(t, n) {
    const r = this.getAxisMotionValue(t);
    return ef(this.visualElement, t), r.start(ep(t, r, 0, n, this.visualElement, !1));
  }
  stopAnimation() {
    gr((t) => this.getAxisMotionValue(t).stop());
  }
  pauseAnimation() {
    gr((t) => this.getAxisMotionValue(t).animation?.pause());
  }
  getAnimationState(t) {
    return this.getAxisMotionValue(t).animation?.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(t) {
    const n = `_drag${t.toUpperCase()}`, r = this.visualElement.getProps(), o = r[n];
    return o || this.visualElement.getValue(t, (r.initial ? r.initial[t] : void 0) || 0);
  }
  snapToCursor(t) {
    gr((n) => {
      const { drag: r } = this.getProps();
      if (!yc(n, r, this.currentDirection))
        return;
      const { projection: o } = this.visualElement, i = this.getAxisMotionValue(n);
      if (o && o.layout) {
        const { min: a, max: s } = o.layout.layoutBox[n];
        i.set(t[n] - Pt(a, s, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: t, dragConstraints: n } = this.getProps(), { projection: r } = this.visualElement;
    if (!fa(n) || !r || !this.constraints)
      return;
    this.stopAnimation();
    const o = { x: 0, y: 0 };
    gr((a) => {
      const s = this.getAxisMotionValue(a);
      if (s && this.constraints !== !1) {
        const l = s.get();
        o[a] = TQ({ min: l, max: l }, this.constraints[a]);
      }
    });
    const { transformTemplate: i } = this.visualElement.getProps();
    this.visualElement.current.style.transform = i ? i({}, "") : "none", r.root && r.root.updateScroll(), r.updateLayout(), this.resolveConstraints(), gr((a) => {
      if (!yc(a, t, null))
        return;
      const s = this.getAxisMotionValue(a), { min: l, max: c } = this.constraints[a];
      s.set(Pt(l, c, o[a]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    RQ.set(this.visualElement, this);
    const t = this.visualElement.current, n = Cl(t, "pointerdown", (l) => {
      const { drag: c, dragListener: u = !0 } = this.getProps();
      c && u && this.start(l);
    }), r = () => {
      const { dragConstraints: l } = this.getProps();
      fa(l) && l.current && (this.constraints = this.resolveRefConstraints());
    }, { projection: o } = this.visualElement, i = o.addEventListener("measure", r);
    o && !o.layout && (o.root && o.root.updateScroll(), o.updateLayout()), Tt.read(r);
    const a = $l(window, "resize", () => this.scalePositionWithinConstraints()), s = o.addEventListener("didUpdate", (({ delta: l, hasLayoutChanged: c }) => {
      this.isDragging && c && (gr((u) => {
        const f = this.getAxisMotionValue(u);
        f && (this.originPoint[u] += l[u].translate, f.set(f.get() + l[u].translate));
      }), this.visualElement.render());
    }));
    return () => {
      a(), n(), i(), s && s();
    };
  }
  getProps() {
    const t = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: r = !1, dragPropagation: o = !1, dragConstraints: i = !1, dragElastic: a = nf, dragMomentum: s = !0 } = t;
    return {
      ...t,
      drag: n,
      dragDirectionLock: r,
      dragPropagation: o,
      dragConstraints: i,
      dragElastic: a,
      dragMomentum: s
    };
  }
}
function yc(e, t, n) {
  return (t === !0 || t === e) && (n === null || n === e);
}
function LQ(e, t = 10) {
  let n = null;
  return Math.abs(e.y) > t ? n = "y" : Math.abs(e.x) > t && (n = "x"), n;
}
class NQ extends F1 {
  constructor(t) {
    super(t), this.removeGroupControls = wr, this.removeListeners = wr, this.controls = new kQ(t);
  }
  mount() {
    const { dragControls: t } = this.node.getProps();
    t && (this.removeGroupControls = t.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || wr;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const av = (e) => (t, n) => {
  e && Tt.postRender(() => e(t, n));
};
class FQ extends F1 {
  constructor() {
    super(...arguments), this.removePointerDownListener = wr;
  }
  onPointerDown(t) {
    this.session = new WT(t, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: ZT(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: t, onPanStart: n, onPan: r, onPanEnd: o } = this.node.getProps();
    return {
      onSessionStart: av(t),
      onStart: av(n),
      onMove: r,
      onEnd: (i, a) => {
        delete this.session, o && Tt.postRender(() => o(i, a));
      }
    };
  }
  mount() {
    this.removePointerDownListener = Cl(this.node.current, "pointerdown", (t) => this.onPointerDown(t));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
const Uc = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function sv(e, t) {
  return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
const Us = {
  correct: (e, t) => {
    if (!t.target)
      return e;
    if (typeof e == "string")
      if (Re.test(e))
        e = parseFloat(e);
      else
        return e;
    const n = sv(e, t.target.x), r = sv(e, t.target.y);
    return `${n}% ${r}%`;
  }
}, VQ = {
  correct: (e, { treeScale: t, projectionDelta: n }) => {
    const r = e, o = T1.parse(e);
    if (o.length > 5)
      return r;
    const i = T1.createTransformer(e), a = typeof o[0] != "number" ? 1 : 0, s = n.x.scale * t.x, l = n.y.scale * t.y;
    o[0 + a] /= s, o[1 + a] /= l;
    const c = Pt(s, l, 0.5);
    return typeof o[2 + a] == "number" && (o[2 + a] /= c), typeof o[3 + a] == "number" && (o[3 + a] /= c), i(o);
  }
};
let X7 = !1;
class BQ extends Td {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r, layoutId: o } = this.props, { projection: i } = t;
    hX($Q), i && (n.group && n.group.add(i), r && r.register && o && r.register(i), X7 && i.root.didUpdate(), i.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), i.setOptions({
      ...i.options,
      onExitComplete: () => this.safeToRemove()
    })), Uc.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(t) {
    const { layoutDependency: n, visualElement: r, drag: o, isPresent: i } = this.props, { projection: a } = r;
    return a && (a.isPresent = i, X7 = !0, o || t.layoutDependency !== n || n === void 0 || t.isPresent !== i ? a.willUpdate() : this.safeToRemove(), t.isPresent !== i && (i ? a.promote() : a.relegate() || Tt.postRender(() => {
      const s = a.getStack();
      (!s || !s.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: t } = this.props.visualElement;
    t && (t.root.didUpdate(), Hh.postRender(() => {
      !t.currentAnimation && t.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r } = this.props, { projection: o } = t;
    X7 = !0, o && (o.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(o), r && r.deregister && r.deregister(o));
  }
  safeToRemove() {
    const { safeToRemove: t } = this.props;
    t && t();
  }
  render() {
    return null;
  }
}
function UT(e) {
  const [t, n] = fT(), r = Oe(wh);
  return d(BQ, { ...e, layoutGroup: r, switchLayoutGroup: Oe(xT), isPresent: t, safeToRemove: n });
}
const $Q = {
  borderRadius: {
    ...Us,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: Us,
  borderTopRightRadius: Us,
  borderBottomLeftRadius: Us,
  borderBottomRightRadius: Us,
  boxShadow: VQ
};
function GT(e, t, n) {
  const r = dn(e) ? e : Mi(e);
  return r.start(ep("", r, t, n)), r.animation;
}
const jQ = (e, t) => e.depth - t.depth;
class HQ {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(t) {
    Sh(this.children, t), this.isDirty = !0;
  }
  remove(t) {
    Uu(this.children, t), this.isDirty = !0;
  }
  forEach(t) {
    this.isDirty && this.children.sort(jQ), this.isDirty = !1, this.children.forEach(t);
  }
}
function zQ(e, t) {
  const n = qn.now(), r = ({ timestamp: o }) => {
    const i = o - n;
    i >= t && (P1(r), e(i - t));
  };
  return Tt.setup(r, !0), () => P1(r);
}
const KT = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], ZQ = KT.length, lv = (e) => typeof e == "string" ? parseFloat(e) : e, cv = (e) => typeof e == "number" || Re.test(e);
function WQ(e, t, n, r, o, i) {
  o ? (e.opacity = Pt(0, n.opacity ?? 1, qQ(r)), e.opacityExit = Pt(t.opacity ?? 1, 0, UQ(r))) : i && (e.opacity = Pt(t.opacity ?? 1, n.opacity ?? 1, r));
  for (let a = 0; a < ZQ; a++) {
    const s = `border${KT[a]}Radius`;
    let l = uv(t, s), c = uv(n, s);
    if (l === void 0 && c === void 0)
      continue;
    l || (l = 0), c || (c = 0), l === 0 || c === 0 || cv(l) === cv(c) ? (e[s] = Math.max(Pt(lv(l), lv(c), r), 0), (po.test(c) || po.test(l)) && (e[s] += "%")) : e[s] = c;
  }
  (t.rotate || n.rotate) && (e.rotate = Pt(t.rotate || 0, n.rotate || 0, r));
}
function uv(e, t) {
  return e[t] !== void 0 ? e[t] : e.borderRadius;
}
const qQ = /* @__PURE__ */ YT(0, 0.5, _P), UQ = /* @__PURE__ */ YT(0.5, 0.95, wr);
function YT(e, t, n) {
  return (r) => r < e ? 0 : r > t ? 1 : n(/* @__PURE__ */ Ba(e, t, r));
}
function fv(e, t) {
  e.min = t.min, e.max = t.max;
}
function dr(e, t) {
  fv(e.x, t.x), fv(e.y, t.y);
}
function dv(e, t) {
  e.translate = t.translate, e.scale = t.scale, e.originPoint = t.originPoint, e.origin = t.origin;
}
function hv(e, t, n, r, o) {
  return e -= t, e = m5(e, 1 / n, r), o !== void 0 && (e = m5(e, 1 / o, r)), e;
}
function GQ(e, t = 0, n = 1, r = 0.5, o, i = e, a = e) {
  if (po.test(t) && (t = parseFloat(t), t = Pt(a.min, a.max, t / 100) - a.min), typeof t != "number")
    return;
  let s = Pt(i.min, i.max, r);
  e === i && (s -= t), e.min = hv(e.min, t, n, s, o), e.max = hv(e.max, t, n, s, o);
}
function pv(e, t, [n, r, o], i, a) {
  GQ(e, t[n], t[r], t[o], t.scale, i, a);
}
const KQ = ["x", "scaleX", "originX"], YQ = ["y", "scaleY", "originY"];
function mv(e, t, n, r) {
  pv(e.x, t, KQ, n ? n.x : void 0, r ? r.x : void 0), pv(e.y, t, YQ, n ? n.y : void 0, r ? r.y : void 0);
}
function gv(e) {
  return e.translate === 0 && e.scale === 1;
}
function XT(e) {
  return gv(e.x) && gv(e.y);
}
function Cv(e, t) {
  return e.min === t.min && e.max === t.max;
}
function XQ(e, t) {
  return Cv(e.x, t.x) && Cv(e.y, t.y);
}
function vv(e, t) {
  return Math.round(e.min) === Math.round(t.min) && Math.round(e.max) === Math.round(t.max);
}
function QT(e, t) {
  return vv(e.x, t.x) && vv(e.y, t.y);
}
function yv(e) {
  return Ln(e.x) / Ln(e.y);
}
function bv(e, t) {
  return e.translate === t.translate && e.scale === t.scale && e.originPoint === t.originPoint;
}
class QQ {
  constructor() {
    this.members = [];
  }
  add(t) {
    Sh(this.members, t), t.scheduleRender();
  }
  remove(t) {
    if (Uu(this.members, t), t === this.prevLead && (this.prevLead = void 0), t === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(t) {
    const n = this.members.findIndex((o) => t === o);
    if (n === 0)
      return !1;
    let r;
    for (let o = n; o >= 0; o--) {
      const i = this.members[o];
      if (i.isPresent !== !1) {
        r = i;
        break;
      }
    }
    return r ? (this.promote(r), !0) : !1;
  }
  promote(t, n) {
    const r = this.lead;
    if (t !== r && (this.prevLead = r, this.lead = t, t.show(), r)) {
      r.instance && r.scheduleRender(), t.scheduleRender(), t.resumeFrom = r, n && (t.resumeFrom.preserveOpacity = !0), r.snapshot && (t.snapshot = r.snapshot, t.snapshot.latestValues = r.animationValues || r.latestValues), t.root && t.root.isUpdating && (t.isLayoutDirty = !0);
      const { crossfade: o } = t.options;
      o === !1 && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((t) => {
      const { options: n, resumingFrom: r } = t;
      n.onExitComplete && n.onExitComplete(), r && r.options.onExitComplete && r.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((t) => {
      t.instance && t.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function JQ(e, t, n) {
  let r = "";
  const o = e.x.translate / t.x, i = e.y.translate / t.y, a = n?.z || 0;
  if ((o || i || a) && (r = `translate3d(${o}px, ${i}px, ${a}px) `), (t.x !== 1 || t.y !== 1) && (r += `scale(${1 / t.x}, ${1 / t.y}) `), n) {
    const { transformPerspective: c, rotate: u, rotateX: f, rotateY: h, skewX: p, skewY: C } = n;
    c && (r = `perspective(${c}px) ${r}`), u && (r += `rotate(${u}deg) `), f && (r += `rotateX(${f}deg) `), h && (r += `rotateY(${h}deg) `), p && (r += `skewX(${p}deg) `), C && (r += `skewY(${C}deg) `);
  }
  const s = e.x.scale * t.x, l = e.y.scale * t.y;
  return (s !== 1 || l !== 1) && (r += `scale(${s}, ${l})`), r || "none";
}
const Q7 = ["", "X", "Y", "Z"], eJ = 1e3;
let tJ = 0;
function J7(e, t, n, r) {
  const { latestValues: o } = t;
  o[e] && (n[e] = o[e], t.setStaticValue(e, 0), r && (r[e] = 0));
}
function JT(e) {
  if (e.hasCheckedOptimisedAppear = !0, e.root === e)
    return;
  const { visualElement: t } = e.options;
  if (!t)
    return;
  const n = FT(t);
  if (window.MotionHasOptimisedAnimation(n, "transform")) {
    const { layout: o, layoutId: i } = e.options;
    window.MotionCancelOptimisedAnimation(n, "transform", Tt, !(o || i));
  }
  const { parent: r } = e;
  r && !r.hasCheckedOptimisedAppear && JT(r);
}
function eI({ attachResizeListener: e, defaultParent: t, measureScroll: n, checkIsScrollRoot: r, resetTransform: o }) {
  return class {
    constructor(a = {}, s = t?.()) {
      this.id = tJ++, this.animationId = 0, this.animationCommitId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, this.nodes.forEach(oJ), this.nodes.forEach(lJ), this.nodes.forEach(cJ), this.nodes.forEach(iJ);
      }, this.resolvedRelativeTargetAt = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = a, this.root = s ? s.root || s : this, this.path = s ? [...s.path, s] : [], this.parent = s, this.depth = s ? s.depth + 1 : 0;
      for (let l = 0; l < this.path.length; l++)
        this.path[l].shouldResetTransform = !0;
      this.root === this && (this.nodes = new HQ());
    }
    addEventListener(a, s) {
      return this.eventHandlers.has(a) || this.eventHandlers.set(a, new Eh()), this.eventHandlers.get(a).add(s);
    }
    notifyListeners(a, ...s) {
      const l = this.eventHandlers.get(a);
      l && l.notify(...s);
    }
    hasListeners(a) {
      return this.eventHandlers.has(a);
    }
    /**
     * Lifecycles
     */
    mount(a) {
      if (this.instance)
        return;
      this.isSVG = Zh(a) && !uT(a), this.instance = a;
      const { layoutId: s, layout: l, visualElement: c } = this.options;
      if (c && !c.current && c.mount(a), this.root.nodes.add(this), this.parent && this.parent.children.add(this), this.root.hasTreeAnimated && (l || s) && (this.isLayoutDirty = !0), e) {
        let u, f = 0;
        const h = () => this.root.updateBlockedByResize = !1;
        Tt.read(() => {
          f = window.innerWidth;
        }), e(a, () => {
          const p = window.innerWidth;
          p !== f && (f = p, this.root.updateBlockedByResize = !0, u && u(), u = zQ(h, 250), Uc.hasAnimatedSinceResize && (Uc.hasAnimatedSinceResize = !1, this.nodes.forEach(Sv)));
        });
      }
      s && this.root.registerSharedNode(s, this), this.options.animate !== !1 && c && (s || l) && this.addEventListener("didUpdate", ({ delta: u, hasLayoutChanged: f, hasRelativeLayoutChanged: h, layout: p }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const C = this.options.transition || c.getDefaultTransition() || pJ, { onLayoutAnimationStart: m, onLayoutAnimationComplete: g } = c.getProps(), v = !this.targetLayout || !QT(this.targetLayout, p), y = !f && h;
        if (this.options.layoutRoot || this.resumeFrom || y || f && (v || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0);
          const w = {
            ...$h(C, "layout"),
            onPlay: m,
            onComplete: g
          };
          (c.shouldReduceMotion || this.options.layoutRoot) && (w.delay = 0, w.type = !1), this.startAnimation(w), this.setAnimationOrigin(u, y);
        } else
          f || Sv(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = p;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const a = this.getStack();
      a && a.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, this.eventHandlers.clear(), P1(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(uJ), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: a } = this.options;
      return a && a.getProps().transformTemplate;
    }
    willUpdate(a = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && JT(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let u = 0; u < this.path.length; u++) {
        const f = this.path[u];
        f.shouldResetTransform = !0, f.updateScroll("snapshot"), f.options.layoutRoot && f.willUpdate(!1);
      }
      const { layoutId: s, layout: l } = this.options;
      if (s === void 0 && !l)
        return;
      const c = this.getTransformTemplate();
      this.prevTransformTemplateValue = c ? c(this.latestValues, "") : void 0, this.updateSnapshot(), a && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(wv);
        return;
      }
      if (this.animationId <= this.animationCommitId) {
        this.nodes.forEach(xv);
        return;
      }
      this.animationCommitId = this.animationId, this.isUpdating ? (this.isUpdating = !1, this.nodes.forEach(sJ), this.nodes.forEach(nJ), this.nodes.forEach(rJ)) : this.nodes.forEach(xv), this.clearAllSnapshots();
      const s = qn.now();
      Cn.delta = Yo(0, 1e3 / 60, s - Cn.timestamp), Cn.timestamp = s, Cn.isProcessing = !0, $7.update.process(Cn), $7.preRender.process(Cn), $7.render.process(Cn), Cn.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, Hh.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(aJ), this.sharedNodes.forEach(fJ);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, Tt.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      Tt.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure(), this.snapshot && !Ln(this.snapshot.measuredBox.x) && !Ln(this.snapshot.measuredBox.y) && (this.snapshot = void 0));
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let l = 0; l < this.path.length; l++)
          this.path[l].updateScroll();
      const a = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = Vt(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: s } = this.options;
      s && s.notify("LayoutMeasure", this.layout.layoutBox, a ? a.layoutBox : void 0);
    }
    updateScroll(a = "measure") {
      let s = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === a && (s = !1), s && this.instance) {
        const l = r(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: a,
          isRoot: l,
          offset: n(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : l
        };
      }
    }
    resetTransform() {
      if (!o)
        return;
      const a = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, s = this.projectionDelta && !XT(this.projectionDelta), l = this.getTransformTemplate(), c = l ? l(this.latestValues, "") : void 0, u = c !== this.prevTransformTemplateValue;
      a && this.instance && (s || X1(this.latestValues) || u) && (o(this.instance, c), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(a = !0) {
      const s = this.measurePageBox();
      let l = this.removeElementScroll(s);
      return a && (l = this.removeTransform(l)), mJ(l), {
        animationId: this.root.animationId,
        measuredBox: s,
        layoutBox: l,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      const { visualElement: a } = this.options;
      if (!a)
        return Vt();
      const s = a.measureViewportBox();
      if (!(this.scroll?.wasRoot || this.path.some(gJ))) {
        const { scroll: c } = this.root;
        c && (da(s.x, c.offset.x), da(s.y, c.offset.y));
      }
      return s;
    }
    removeElementScroll(a) {
      const s = Vt();
      if (dr(s, a), this.scroll?.wasRoot)
        return s;
      for (let l = 0; l < this.path.length; l++) {
        const c = this.path[l], { scroll: u, options: f } = c;
        c !== this.root && u && f.layoutScroll && (u.wasRoot && dr(s, a), da(s.x, u.offset.x), da(s.y, u.offset.y));
      }
      return s;
    }
    applyTransform(a, s = !1) {
      const l = Vt();
      dr(l, a);
      for (let c = 0; c < this.path.length; c++) {
        const u = this.path[c];
        !s && u.options.layoutScroll && u.scroll && u !== u.root && ha(l, {
          x: -u.scroll.offset.x,
          y: -u.scroll.offset.y
        }), X1(u.latestValues) && ha(l, u.latestValues);
      }
      return X1(this.latestValues) && ha(l, this.latestValues), l;
    }
    removeTransform(a) {
      const s = Vt();
      dr(s, a);
      for (let l = 0; l < this.path.length; l++) {
        const c = this.path[l];
        if (!c.instance || !X1(c.latestValues))
          continue;
        Y9(c.latestValues) && c.updateSnapshot();
        const u = Vt(), f = c.measurePageBox();
        dr(u, f), mv(s, c.latestValues, c.snapshot ? c.snapshot.layoutBox : void 0, u);
      }
      return X1(this.latestValues) && mv(s, this.latestValues), s;
    }
    setTargetDelta(a) {
      this.targetDelta = a, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(a) {
      this.options = {
        ...this.options,
        ...a,
        crossfade: a.crossfade !== void 0 ? a.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== Cn.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(a = !1) {
      const s = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = s.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = s.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = s.isSharedProjectionDirty);
      const l = !!this.resumingFrom || this !== s;
      if (!(a || l && this.isSharedProjectionDirty || this.isProjectionDirty || this.parent?.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: u, layoutId: f } = this.options;
      if (!(!this.layout || !(u || f))) {
        if (this.resolvedRelativeTargetAt = Cn.timestamp, !this.targetDelta && !this.relativeTarget) {
          const h = this.getClosestProjectingParent();
          h && h.layout && this.animationProgress !== 1 ? (this.relativeParent = h, this.forceRelativeParentToResolveTarget(), this.relativeTarget = Vt(), this.relativeTargetOrigin = Vt(), yl(this.relativeTargetOrigin, this.layout.layoutBox, h.layout.layoutBox), dr(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = Vt(), this.targetWithTransforms = Vt()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), SQ(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : dr(this.target, this.layout.layoutBox), OT(this.target, this.targetDelta)) : dr(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget)) {
          this.attemptToResolveRelativeTarget = !1;
          const h = this.getClosestProjectingParent();
          h && !!h.resumingFrom == !!this.resumingFrom && !h.options.layoutScroll && h.target && this.animationProgress !== 1 ? (this.relativeParent = h, this.forceRelativeParentToResolveTarget(), this.relativeTarget = Vt(), this.relativeTargetOrigin = Vt(), yl(this.relativeTargetOrigin, this.target, h.target), dr(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || Y9(this.parent.latestValues) || _T(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      const a = this.getLead(), s = !!this.resumingFrom || this !== a;
      let l = !0;
      if ((this.isProjectionDirty || this.parent?.isProjectionDirty) && (l = !1), s && (this.isSharedProjectionDirty || this.isTransformDirty) && (l = !1), this.resolvedRelativeTargetAt === Cn.timestamp && (l = !1), l)
        return;
      const { layout: c, layoutId: u } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(c || u))
        return;
      dr(this.layoutCorrected, this.layout.layoutBox);
      const f = this.treeScale.x, h = this.treeScale.y;
      jX(this.layoutCorrected, this.treeScale, this.path, s), a.layout && !a.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (a.target = a.layout.layoutBox, a.targetWithTransforms = Vt());
      const { target: p } = a;
      if (!p) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (dv(this.prevProjectionDelta.x, this.projectionDelta.x), dv(this.prevProjectionDelta.y, this.projectionDelta.y)), vl(this.projectionDelta, this.layoutCorrected, p, this.latestValues), (this.treeScale.x !== f || this.treeScale.y !== h || !bv(this.projectionDelta.x, this.prevProjectionDelta.x) || !bv(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", p));
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(a = !0) {
      if (this.options.visualElement?.scheduleRender(), a) {
        const s = this.getStack();
        s && s.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = pa(), this.projectionDelta = pa(), this.projectionDeltaWithTransform = pa();
    }
    setAnimationOrigin(a, s = !1) {
      const l = this.snapshot, c = l ? l.latestValues : {}, u = { ...this.latestValues }, f = pa();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !s;
      const h = Vt(), p = l ? l.source : void 0, C = this.layout ? this.layout.source : void 0, m = p !== C, g = this.getStack(), v = !g || g.members.length <= 1, y = !!(m && !v && this.options.crossfade === !0 && !this.path.some(hJ));
      this.animationProgress = 0;
      let w;
      this.mixTargetDelta = (x) => {
        const b = x / 1e3;
        Mv(f.x, a.x, b), Mv(f.y, a.y, b), this.setTargetDelta(f), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (yl(h, this.layout.layoutBox, this.relativeParent.layout.layoutBox), dJ(this.relativeTarget, this.relativeTargetOrigin, h, b), w && XQ(this.relativeTarget, w) && (this.isProjectionDirty = !1), w || (w = Vt()), dr(w, this.relativeTarget)), m && (this.animationValues = u, WQ(u, c, this.latestValues, b, y, v)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = b;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(a) {
      this.notifyListeners("animationStart"), this.currentAnimation?.stop(), this.resumingFrom?.currentAnimation?.stop(), this.pendingAnimation && (P1(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = Tt.update(() => {
        Uc.hasAnimatedSinceResize = !0, this.motionValue || (this.motionValue = Mi(0)), this.currentAnimation = GT(this.motionValue, [0, 1e3], {
          ...a,
          velocity: 0,
          isSync: !0,
          onUpdate: (s) => {
            this.mixTargetDelta(s), a.onUpdate && a.onUpdate(s);
          },
          onStop: () => {
          },
          onComplete: () => {
            a.onComplete && a.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const a = this.getStack();
      a && a.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(eJ), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const a = this.getLead();
      let { targetWithTransforms: s, target: l, layout: c, latestValues: u } = a;
      if (!(!s || !l || !c)) {
        if (this !== a && this.layout && c && tI(this.options.animationType, this.layout.layoutBox, c.layoutBox)) {
          l = this.target || Vt();
          const f = Ln(this.layout.layoutBox.x);
          l.x.min = a.target.x.min, l.x.max = l.x.min + f;
          const h = Ln(this.layout.layoutBox.y);
          l.y.min = a.target.y.min, l.y.max = l.y.min + h;
        }
        dr(s, l), ha(s, u), vl(this.projectionDeltaWithTransform, this.layoutCorrected, s, u);
      }
    }
    registerSharedNode(a, s) {
      this.sharedNodes.has(a) || this.sharedNodes.set(a, new QQ()), this.sharedNodes.get(a).add(s);
      const c = s.options.initialPromotionConfig;
      s.promote({
        transition: c ? c.transition : void 0,
        preserveFollowOpacity: c && c.shouldPreserveFollowOpacity ? c.shouldPreserveFollowOpacity(s) : void 0
      });
    }
    isLead() {
      const a = this.getStack();
      return a ? a.lead === this : !0;
    }
    getLead() {
      const { layoutId: a } = this.options;
      return a ? this.getStack()?.lead || this : this;
    }
    getPrevLead() {
      const { layoutId: a } = this.options;
      return a ? this.getStack()?.prevLead : void 0;
    }
    getStack() {
      const { layoutId: a } = this.options;
      if (a)
        return this.root.sharedNodes.get(a);
    }
    promote({ needsReset: a, transition: s, preserveFollowOpacity: l } = {}) {
      const c = this.getStack();
      c && c.promote(this, l), a && (this.projectionDelta = void 0, this.needsReset = !0), s && this.setOptions({ transition: s });
    }
    relegate() {
      const a = this.getStack();
      return a ? a.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: a } = this.options;
      if (!a)
        return;
      let s = !1;
      const { latestValues: l } = a;
      if ((l.z || l.rotate || l.rotateX || l.rotateY || l.rotateZ || l.skewX || l.skewY) && (s = !0), !s)
        return;
      const c = {};
      l.z && J7("z", a, c, this.animationValues);
      for (let u = 0; u < Q7.length; u++)
        J7(`rotate${Q7[u]}`, a, c, this.animationValues), J7(`skew${Q7[u]}`, a, c, this.animationValues);
      a.render();
      for (const u in c)
        a.setStaticValue(u, c[u]), this.animationValues && (this.animationValues[u] = c[u]);
      a.scheduleRender();
    }
    applyProjectionStyles(a, s) {
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible) {
        a.visibility = "hidden";
        return;
      }
      const l = this.getTransformTemplate();
      if (this.needsReset) {
        this.needsReset = !1, a.visibility = "", a.opacity = "", a.pointerEvents = qc(s?.pointerEvents) || "", a.transform = l ? l(this.latestValues, "") : "none";
        return;
      }
      const c = this.getLead();
      if (!this.projectionDelta || !this.layout || !c.target) {
        this.options.layoutId && (a.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, a.pointerEvents = qc(s?.pointerEvents) || ""), this.hasProjected && !X1(this.latestValues) && (a.transform = l ? l({}, "") : "none", this.hasProjected = !1);
        return;
      }
      a.visibility = "";
      const u = c.animationValues || c.latestValues;
      this.applyTransformsToTarget();
      let f = JQ(this.projectionDeltaWithTransform, this.treeScale, u);
      l && (f = l(u, f)), a.transform = f;
      const { x: h, y: p } = this.projectionDelta;
      a.transformOrigin = `${h.origin * 100}% ${p.origin * 100}% 0`, c.animationValues ? a.opacity = c === this ? u.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : u.opacityExit : a.opacity = c === this ? u.opacity !== void 0 ? u.opacity : "" : u.opacityExit !== void 0 ? u.opacityExit : 0;
      for (const C in Vl) {
        if (u[C] === void 0)
          continue;
        const { correct: m, applyTo: g, isCSSVariable: v } = Vl[C], y = f === "none" ? u[C] : m(u[C], c);
        if (g) {
          const w = g.length;
          for (let x = 0; x < w; x++)
            a[g[x]] = y;
        } else
          v ? this.options.visualElement.renderState.vars[C] = y : a[C] = y;
      }
      this.options.layoutId && (a.pointerEvents = c === this ? qc(s?.pointerEvents) || "" : "none");
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((a) => a.currentAnimation?.stop()), this.root.nodes.forEach(wv), this.root.sharedNodes.clear();
    }
  };
}
function nJ(e) {
  e.updateLayout();
}
function rJ(e) {
  const t = e.resumeFrom?.snapshot || e.snapshot;
  if (e.isLead() && e.layout && t && e.hasListeners("didUpdate")) {
    const { layoutBox: n, measuredBox: r } = e.layout, { animationType: o } = e.options, i = t.source !== e.layout.source;
    o === "size" ? gr((u) => {
      const f = i ? t.measuredBox[u] : t.layoutBox[u], h = Ln(f);
      f.min = n[u].min, f.max = f.min + h;
    }) : tI(o, t.layoutBox, n) && gr((u) => {
      const f = i ? t.measuredBox[u] : t.layoutBox[u], h = Ln(n[u]);
      f.max = f.min + h, e.relativeTarget && !e.currentAnimation && (e.isProjectionDirty = !0, e.relativeTarget[u].max = e.relativeTarget[u].min + h);
    });
    const a = pa();
    vl(a, n, t.layoutBox);
    const s = pa();
    i ? vl(s, e.applyTransform(r, !0), t.measuredBox) : vl(s, n, t.layoutBox);
    const l = !XT(a);
    let c = !1;
    if (!e.resumeFrom) {
      const u = e.getClosestProjectingParent();
      if (u && !u.resumeFrom) {
        const { snapshot: f, layout: h } = u;
        if (f && h) {
          const p = Vt();
          yl(p, t.layoutBox, f.layoutBox);
          const C = Vt();
          yl(C, n, h.layoutBox), QT(p, C) || (c = !0), u.options.layoutRoot && (e.relativeTarget = C, e.relativeTargetOrigin = p, e.relativeParent = u);
        }
      }
    }
    e.notifyListeners("didUpdate", {
      layout: n,
      snapshot: t,
      delta: s,
      layoutDelta: a,
      hasLayoutChanged: l,
      hasRelativeLayoutChanged: c
    });
  } else if (e.isLead()) {
    const { onExitComplete: n } = e.options;
    n && n();
  }
  e.options.transition = void 0;
}
function oJ(e) {
  e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty || (e.isSharedProjectionDirty = !!(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty)), e.isTransformDirty || (e.isTransformDirty = e.parent.isTransformDirty));
}
function iJ(e) {
  e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
}
function aJ(e) {
  e.clearSnapshot();
}
function wv(e) {
  e.clearMeasurements();
}
function xv(e) {
  e.isLayoutDirty = !1;
}
function sJ(e) {
  const { visualElement: t } = e.options;
  t && t.getProps().onBeforeLayoutMeasure && t.notify("BeforeLayoutMeasure"), e.resetTransform();
}
function Sv(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0, e.isProjectionDirty = !0;
}
function lJ(e) {
  e.resolveTargetDelta();
}
function cJ(e) {
  e.calcProjection();
}
function uJ(e) {
  e.resetSkewAndRotation();
}
function fJ(e) {
  e.removeLeadSnapshot();
}
function Mv(e, t, n) {
  e.translate = Pt(t.translate, 0, n), e.scale = Pt(t.scale, 1, n), e.origin = t.origin, e.originPoint = t.originPoint;
}
function Ev(e, t, n, r) {
  e.min = Pt(t.min, n.min, r), e.max = Pt(t.max, n.max, r);
}
function dJ(e, t, n, r) {
  Ev(e.x, t.x, n.x, r), Ev(e.y, t.y, n.y, r);
}
function hJ(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
const pJ = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, _v = (e) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(e), Ov = _v("applewebkit/") && !_v("chrome/") ? Math.round : wr;
function Av(e) {
  e.min = Ov(e.min), e.max = Ov(e.max);
}
function mJ(e) {
  Av(e.x), Av(e.y);
}
function tI(e, t, n) {
  return e === "position" || e === "preserve-aspect" && !xQ(yv(t), yv(n), 0.2);
}
function gJ(e) {
  return e !== e.root && e.scroll?.wasRoot;
}
const CJ = eI({
  attachResizeListener: (e, t) => $l(e, "resize", t),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), e3 = {
  current: void 0
}, nI = eI({
  measureScroll: (e) => ({
    x: e.scrollLeft,
    y: e.scrollTop
  }),
  defaultParent: () => {
    if (!e3.current) {
      const e = new CJ({});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), e3.current = e;
    }
    return e3.current;
  },
  resetTransform: (e, t) => {
    e.style.transform = t !== void 0 ? t : "none";
  },
  checkIsScrollRoot: (e) => window.getComputedStyle(e).position === "fixed"
}), vJ = {
  pan: {
    Feature: FQ
  },
  drag: {
    Feature: NQ,
    ProjectionNode: nI,
    MeasureLayout: UT
  }
};
function Pv(e, t, n) {
  const { props: r } = e;
  e.animationState && r.whileHover && e.animationState.setActive("whileHover", n === "Start");
  const o = "onHover" + n, i = r[o];
  i && Tt.postRender(() => i(t, $2(t)));
}
class yJ extends F1 {
  mount() {
    const { current: t } = this.node;
    t && (this.unmount = UY(t, (n, r) => (Pv(this.node, r, "Start"), (o) => Pv(this.node, o, "End"))));
  }
  unmount() {
  }
}
class bJ extends F1 {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let t = !1;
    try {
      t = this.node.current.matches(":focus-visible");
    } catch {
      t = !0;
    }
    !t || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = F2($l(this.node.current, "focus", () => this.onFocus()), $l(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
function Tv(e, t, n) {
  const { props: r } = e;
  if (e.current instanceof HTMLButtonElement && e.current.disabled)
    return;
  e.animationState && r.whileTap && e.animationState.setActive("whileTap", n === "Start");
  const o = "onTap" + (n === "End" ? "" : n), i = r[o];
  i && Tt.postRender(() => i(t, $2(t)));
}
class wJ extends F1 {
  mount() {
    const { current: t } = this.node;
    t && (this.unmount = XY(t, (n, r) => (Tv(this.node, r, "Start"), (o, { success: i }) => Tv(this.node, o, i ? "End" : "Cancel")), { useGlobalTarget: this.node.props.globalTapTarget }));
  }
  unmount() {
  }
}
const rf = /* @__PURE__ */ new WeakMap(), t3 = /* @__PURE__ */ new WeakMap(), xJ = (e) => {
  const t = rf.get(e.target);
  t && t(e);
}, SJ = (e) => {
  e.forEach(xJ);
};
function MJ({ root: e, ...t }) {
  const n = e || document;
  t3.has(n) || t3.set(n, {});
  const r = t3.get(n), o = JSON.stringify(t);
  return r[o] || (r[o] = new IntersectionObserver(SJ, { root: e, ...t })), r[o];
}
function EJ(e, t, n) {
  const r = MJ(t);
  return rf.set(e, n), r.observe(e), () => {
    rf.delete(e), r.unobserve(e);
  };
}
const _J = {
  some: 0,
  all: 1
};
class OJ extends F1 {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: t = {} } = this.node.getProps(), { root: n, margin: r, amount: o = "some", once: i } = t, a = {
      root: n ? n.current : void 0,
      rootMargin: r,
      threshold: typeof o == "number" ? o : _J[o]
    }, s = (l) => {
      const { isIntersecting: c } = l;
      if (this.isInView === c || (this.isInView = c, i && !c && this.hasEnteredView))
        return;
      c && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", c);
      const { onViewportEnter: u, onViewportLeave: f } = this.node.getProps(), h = c ? u : f;
      h && h(l);
    };
    return EJ(this.node.current, a, s);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: t, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(AJ(t, n)) && this.startObserver();
  }
  unmount() {
  }
}
function AJ({ viewport: e = {} }, { viewport: t = {} } = {}) {
  return (n) => e[n] !== t[n];
}
const rI = {
  inView: {
    Feature: OJ
  },
  tap: {
    Feature: wJ
  },
  focus: {
    Feature: bJ
  },
  hover: {
    Feature: yJ
  }
}, PJ = {
  layout: {
    ProjectionNode: nI,
    MeasureLayout: UT
  }
}, TJ = {
  ...jT,
  ...rI,
  ...vJ,
  ...PJ
}, oI = /* @__PURE__ */ MT(TJ, NT), IJ = {
  renderer: NT,
  ...jT,
  ...rI
};
function DJ(e) {
  const t = Wu(() => Mi(e)), { isStatic: n } = Oe(Gu);
  if (n) {
    const [, r] = ue(e);
    ve(() => t.on("change", r), []);
  }
  return t;
}
function np(e) {
  return typeof e == "object" && !Array.isArray(e);
}
function iI(e, t, n, r) {
  return typeof e == "string" && np(t) ? oT(e, n, r) : e instanceof NodeList ? Array.from(e) : Array.isArray(e) ? e : [e];
}
function RJ(e, t, n) {
  return e * (t + 1);
}
function Iv(e, t, n, r) {
  return typeof t == "number" ? t : t.startsWith("-") || t.startsWith("+") ? Math.max(0, e + parseFloat(t)) : t === "<" ? n : t.startsWith("<") ? Math.max(0, n + parseFloat(t.slice(1))) : r.get(t) ?? e;
}
function kJ(e, t, n) {
  for (let r = 0; r < e.length; r++) {
    const o = e[r];
    o.at > t && o.at < n && (Uu(e, o), r--);
  }
}
function LJ(e, t, n, r, o, i) {
  kJ(e, o, i);
  for (let a = 0; a < t.length; a++)
    e.push({
      value: t[a],
      at: Pt(o, i, r[a]),
      easing: TP(n, a)
    });
}
function NJ(e, t) {
  for (let n = 0; n < e.length; n++)
    e[n] = e[n] / (t + 1);
}
function FJ(e, t) {
  return e.at === t.at ? e.value === null ? 1 : t.value === null ? -1 : 0 : e.at - t.at;
}
const VJ = "easeInOut", BJ = 20;
function $J(e, { defaultTransition: t = {}, ...n } = {}, r, o) {
  const i = t.duration || 0.3, a = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map(), l = {}, c = /* @__PURE__ */ new Map();
  let u = 0, f = 0, h = 0;
  for (let p = 0; p < e.length; p++) {
    const C = e[p];
    if (typeof C == "string") {
      c.set(C, f);
      continue;
    } else if (!Array.isArray(C)) {
      c.set(C.name, Iv(f, C.at, u, c));
      continue;
    }
    let [m, g, v = {}] = C;
    v.at !== void 0 && (f = Iv(f, v.at, u, c));
    let y = 0;
    const w = (x, b, S, M = 0, E = 0) => {
      const P = jJ(x), { delay: T = 0, times: _ = WP(P), type: D = "keyframes", repeat: N, repeatType: R, repeatDelay: L = 0, ...B } = b;
      let { ease: V = t.ease || "easeOut", duration: k } = b;
      const z = typeof T == "function" ? T(M, E) : T, $ = P.length, Z = Bh(D) ? D : o?.[D || "keyframes"];
      if ($ <= 2 && Z) {
        let Y = 100;
        if ($ === 2 && ZJ(P)) {
          const ee = P[1] - P[0];
          Y = Math.abs(ee);
        }
        const ne = { ...B };
        k !== void 0 && (ne.duration = /* @__PURE__ */ xr(k));
        const J = HP(ne, Y, Z);
        V = J.ease, k = J.duration;
      }
      k ?? (k = i);
      const W = f + z;
      _.length === 1 && _[0] === 0 && (_[1] = 1);
      const H = _.length - P.length;
      if (H > 0 && ZP(_, H), P.length === 1 && P.unshift(null), N) {
        Er(N < BJ, "Repeat count too high, must be less than 20", "repeat-count-high"), k = RJ(k, N);
        const Y = [...P], ne = [..._];
        V = Array.isArray(V) ? [...V] : [V];
        const J = [...V];
        for (let ee = 0; ee < N; ee++) {
          P.push(...Y);
          for (let U = 0; U < Y.length; U++)
            _.push(ne[U] + (ee + 1)), V.push(U === 0 ? "linear" : TP(J, U - 1));
        }
        NJ(_, N);
      }
      const G = W + k;
      LJ(S, P, V, _, W, G), y = Math.max(z + k, y), h = Math.max(G, h);
    };
    if (dn(m)) {
      const x = Dv(m, s);
      w(g, v, Rv("default", x));
    } else {
      const x = iI(m, g, r, l), b = x.length;
      for (let S = 0; S < b; S++) {
        g = g, v = v;
        const M = x[S], E = Dv(M, s);
        for (const P in g)
          w(g[P], HJ(v, P), Rv(P, E), S, b);
      }
    }
    u = f, f += y;
  }
  return s.forEach((p, C) => {
    for (const m in p) {
      const g = p[m];
      g.sort(FJ);
      const v = [], y = [], w = [];
      for (let b = 0; b < g.length; b++) {
        const { at: S, value: M, easing: E } = g[b];
        v.push(M), y.push(/* @__PURE__ */ Ba(0, h, S)), w.push(E || "easeOut");
      }
      y[0] !== 0 && (y.unshift(0), v.unshift(v[0]), w.unshift(VJ)), y[y.length - 1] !== 1 && (y.push(1), v.push(null)), a.has(C) || a.set(C, {
        keyframes: {},
        transition: {}
      });
      const x = a.get(C);
      x.keyframes[m] = v, x.transition[m] = {
        ...t,
        duration: h,
        ease: w,
        times: y,
        ...n
      };
    }
  }), a;
}
function Dv(e, t) {
  return !t.has(e) && t.set(e, {}), t.get(e);
}
function Rv(e, t) {
  return t[e] || (t[e] = []), t[e];
}
function jJ(e) {
  return Array.isArray(e) ? e : [e];
}
function HJ(e, t) {
  return e && e[t] ? {
    ...e,
    ...e[t]
  } : { ...e };
}
const zJ = (e) => typeof e == "number", ZJ = (e) => e.every(zJ);
function WJ(e, t) {
  return e in t;
}
class qJ extends TT {
  constructor() {
    super(...arguments), this.type = "object";
  }
  readValueFromInstance(t, n) {
    if (WJ(n, t)) {
      const r = t[n];
      if (typeof r == "string" || typeof r == "number")
        return r;
    }
  }
  getBaseTargetFromProps() {
  }
  removeValueFromRenderState(t, n) {
    delete n.output[t];
  }
  measureInstanceViewportBox() {
    return Vt();
  }
  build(t, n) {
    Object.assign(t.output, n);
  }
  renderInstance(t, { output: n }) {
    Object.assign(t, n);
  }
  sortInstanceNodePosition() {
    return 0;
  }
}
function UJ(e) {
  const t = {
    presenceContext: null,
    props: {},
    visualState: {
      renderState: {
        transform: {},
        transformOrigin: {},
        style: {},
        vars: {},
        attrs: {}
      },
      latestValues: {}
    }
  }, n = Zh(e) && !uT(e) ? new LT(t) : new RT(t);
  n.mount(e), Bl.set(e, n);
}
function GJ(e) {
  const t = {
    presenceContext: null,
    props: {},
    visualState: {
      renderState: {
        output: {}
      },
      latestValues: {}
    }
  }, n = new qJ(t);
  n.mount(e), Bl.set(e, n);
}
function KJ(e, t) {
  return dn(e) || typeof e == "number" || typeof e == "string" && !np(t);
}
function aI(e, t, n, r) {
  const o = [];
  if (KJ(e, t))
    o.push(GT(e, np(t) && t.default || t, n && (n.default || n)));
  else {
    const i = iI(e, t, r), a = i.length;
    Er(!!a, "No valid elements provided.", "no-valid-elements");
    for (let s = 0; s < a; s++) {
      const l = i[s];
      Er(l !== null, "You're trying to perform an animation on null. Ensure that selectors are correctly finding elements and refs are correctly hydrated.", "animate-null");
      const c = l instanceof Element ? UJ : GJ;
      Bl.has(l) || c(l);
      const u = Bl.get(l), f = { ...n };
      "delay" in f && typeof f.delay == "function" && (f.delay = f.delay(s, a)), o.push(...tp(u, { ...t, transition: f }, {}));
    }
  }
  return o;
}
function YJ(e, t, n) {
  const r = [];
  return $J(e, t, n, { spring: Nl }).forEach(({ keyframes: i, transition: a }, s) => {
    r.push(...aI(s, i, a));
  }), r;
}
function XJ(e) {
  return Array.isArray(e) && e.some(Array.isArray);
}
function QJ(e) {
  function t(n, r, o) {
    let i = [], a;
    if (XJ(n))
      i = YJ(n, r, e);
    else {
      const { onComplete: l, ...c } = o || {};
      typeof l == "function" && (a = l), i = aI(n, r, c, e);
    }
    const s = new TY(i);
    return a && s.finished.then(a), s;
  }
  return t;
}
const kv = QJ();
var bc = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Mt(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var wc = { exports: {} }, xc = { exports: {} }, it = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Lv;
function JJ() {
  if (Lv) return it;
  Lv = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, C = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, v = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
  function w(b) {
    if (typeof b == "object" && b !== null) {
      var S = b.$$typeof;
      switch (S) {
        case t:
          switch (b = b.type, b) {
            case l:
            case c:
            case r:
            case i:
            case o:
            case f:
              return b;
            default:
              switch (b = b && b.$$typeof, b) {
                case s:
                case u:
                case C:
                case p:
                case a:
                  return b;
                default:
                  return S;
              }
          }
        case n:
          return S;
      }
    }
  }
  function x(b) {
    return w(b) === c;
  }
  return it.AsyncMode = l, it.ConcurrentMode = c, it.ContextConsumer = s, it.ContextProvider = a, it.Element = t, it.ForwardRef = u, it.Fragment = r, it.Lazy = C, it.Memo = p, it.Portal = n, it.Profiler = i, it.StrictMode = o, it.Suspense = f, it.isAsyncMode = function(b) {
    return x(b) || w(b) === l;
  }, it.isConcurrentMode = x, it.isContextConsumer = function(b) {
    return w(b) === s;
  }, it.isContextProvider = function(b) {
    return w(b) === a;
  }, it.isElement = function(b) {
    return typeof b == "object" && b !== null && b.$$typeof === t;
  }, it.isForwardRef = function(b) {
    return w(b) === u;
  }, it.isFragment = function(b) {
    return w(b) === r;
  }, it.isLazy = function(b) {
    return w(b) === C;
  }, it.isMemo = function(b) {
    return w(b) === p;
  }, it.isPortal = function(b) {
    return w(b) === n;
  }, it.isProfiler = function(b) {
    return w(b) === i;
  }, it.isStrictMode = function(b) {
    return w(b) === o;
  }, it.isSuspense = function(b) {
    return w(b) === f;
  }, it.isValidElementType = function(b) {
    return typeof b == "string" || typeof b == "function" || b === r || b === c || b === i || b === o || b === f || b === h || typeof b == "object" && b !== null && (b.$$typeof === C || b.$$typeof === p || b.$$typeof === a || b.$$typeof === s || b.$$typeof === u || b.$$typeof === g || b.$$typeof === v || b.$$typeof === y || b.$$typeof === m);
  }, it.typeOf = w, it;
}
var at = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Nv;
function eee() {
  return Nv || (Nv = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, C = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, v = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
    function w(j) {
      return typeof j == "string" || typeof j == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      j === r || j === c || j === i || j === o || j === f || j === h || typeof j == "object" && j !== null && (j.$$typeof === C || j.$$typeof === p || j.$$typeof === a || j.$$typeof === s || j.$$typeof === u || j.$$typeof === g || j.$$typeof === v || j.$$typeof === y || j.$$typeof === m);
    }
    function x(j) {
      if (typeof j == "object" && j !== null) {
        var te = j.$$typeof;
        switch (te) {
          case t:
            var K = j.type;
            switch (K) {
              case l:
              case c:
              case r:
              case i:
              case o:
              case f:
                return K;
              default:
                var me = K && K.$$typeof;
                switch (me) {
                  case s:
                  case u:
                  case C:
                  case p:
                  case a:
                    return me;
                  default:
                    return te;
                }
            }
          case n:
            return te;
        }
      }
    }
    var b = l, S = c, M = s, E = a, P = t, T = u, _ = r, D = C, N = p, R = n, L = i, B = o, V = f, k = !1;
    function z(j) {
      return k || (k = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), $(j) || x(j) === l;
    }
    function $(j) {
      return x(j) === c;
    }
    function Z(j) {
      return x(j) === s;
    }
    function W(j) {
      return x(j) === a;
    }
    function H(j) {
      return typeof j == "object" && j !== null && j.$$typeof === t;
    }
    function G(j) {
      return x(j) === u;
    }
    function Y(j) {
      return x(j) === r;
    }
    function ne(j) {
      return x(j) === C;
    }
    function J(j) {
      return x(j) === p;
    }
    function ee(j) {
      return x(j) === n;
    }
    function U(j) {
      return x(j) === i;
    }
    function X(j) {
      return x(j) === o;
    }
    function ie(j) {
      return x(j) === f;
    }
    at.AsyncMode = b, at.ConcurrentMode = S, at.ContextConsumer = M, at.ContextProvider = E, at.Element = P, at.ForwardRef = T, at.Fragment = _, at.Lazy = D, at.Memo = N, at.Portal = R, at.Profiler = L, at.StrictMode = B, at.Suspense = V, at.isAsyncMode = z, at.isConcurrentMode = $, at.isContextConsumer = Z, at.isContextProvider = W, at.isElement = H, at.isForwardRef = G, at.isFragment = Y, at.isLazy = ne, at.isMemo = J, at.isPortal = ee, at.isProfiler = U, at.isStrictMode = X, at.isSuspense = ie, at.isValidElementType = w, at.typeOf = x;
  })()), at;
}
var Fv;
function sI() {
  return Fv || (Fv = 1, process.env.NODE_ENV === "production" ? xc.exports = JJ() : xc.exports = eee()), xc.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var n3, Vv;
function tee() {
  if (Vv) return n3;
  Vv = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var a = {}, s = 0; s < 10; s++)
        a["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(a).map(function(u) {
        return a[u];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        c[u] = u;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return n3 = o() ? Object.assign : function(i, a) {
    for (var s, l = r(i), c, u = 1; u < arguments.length; u++) {
      s = Object(arguments[u]);
      for (var f in s)
        t.call(s, f) && (l[f] = s[f]);
      if (e) {
        c = e(s);
        for (var h = 0; h < c.length; h++)
          n.call(s, c[h]) && (l[c[h]] = s[c[h]]);
      }
    }
    return l;
  }, n3;
}
var r3, Bv;
function rp() {
  if (Bv) return r3;
  Bv = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return r3 = e, r3;
}
var o3, $v;
function lI() {
  return $v || ($v = 1, o3 = Function.call.bind(Object.prototype.hasOwnProperty)), o3;
}
var i3, jv;
function nee() {
  if (jv) return i3;
  jv = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ rp(), n = {}, r = /* @__PURE__ */ lI();
    e = function(i) {
      var a = "Warning: " + i;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function o(i, a, s, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in i)
        if (r(i, u)) {
          var f;
          try {
            if (typeof i[u] != "function") {
              var h = Error(
                (l || "React class") + ": " + s + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw h.name = "Invariant Violation", h;
            }
            f = i[u](a, u, l, s, null, t);
          } catch (C) {
            f = C;
          }
          if (f && !(f instanceof Error) && e(
            (l || "React class") + ": type specification of " + s + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in n)) {
            n[f.message] = !0;
            var p = c ? c() : "";
            e(
              "Failed " + s + " type: " + f.message + (p ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, i3 = o, i3;
}
var a3, Hv;
function ree() {
  if (Hv) return a3;
  Hv = 1;
  var e = sI(), t = tee(), n = /* @__PURE__ */ rp(), r = /* @__PURE__ */ lI(), o = /* @__PURE__ */ nee(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return a3 = function(s, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function f($) {
      var Z = $ && (c && $[c] || $[u]);
      if (typeof Z == "function")
        return Z;
    }
    var h = "<<anonymous>>", p = {
      array: v("array"),
      bigint: v("bigint"),
      bool: v("boolean"),
      func: v("function"),
      number: v("number"),
      object: v("object"),
      string: v("string"),
      symbol: v("symbol"),
      any: y(),
      arrayOf: w,
      element: x(),
      elementType: b(),
      instanceOf: S,
      node: T(),
      objectOf: E,
      oneOf: M,
      oneOfType: P,
      shape: D,
      exact: N
    };
    function C($, Z) {
      return $ === Z ? $ !== 0 || 1 / $ === 1 / Z : $ !== $ && Z !== Z;
    }
    function m($, Z) {
      this.message = $, this.data = Z && typeof Z == "object" ? Z : {}, this.stack = "";
    }
    m.prototype = Error.prototype;
    function g($) {
      if (process.env.NODE_ENV !== "production")
        var Z = {}, W = 0;
      function H(Y, ne, J, ee, U, X, ie) {
        if (ee = ee || h, X = X || J, ie !== n) {
          if (l) {
            var j = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw j.name = "Invariant Violation", j;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var te = ee + ":" + J;
            !Z[te] && // Avoid spamming the console because they are often not actionable except for lib authors
            W < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + X + "` prop on `" + ee + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), Z[te] = !0, W++);
          }
        }
        return ne[J] == null ? Y ? ne[J] === null ? new m("The " + U + " `" + X + "` is marked as required " + ("in `" + ee + "`, but its value is `null`.")) : new m("The " + U + " `" + X + "` is marked as required in " + ("`" + ee + "`, but its value is `undefined`.")) : null : $(ne, J, ee, U, X);
      }
      var G = H.bind(null, !1);
      return G.isRequired = H.bind(null, !0), G;
    }
    function v($) {
      function Z(W, H, G, Y, ne, J) {
        var ee = W[H], U = B(ee);
        if (U !== $) {
          var X = V(ee);
          return new m(
            "Invalid " + Y + " `" + ne + "` of type " + ("`" + X + "` supplied to `" + G + "`, expected ") + ("`" + $ + "`."),
            { expectedType: $ }
          );
        }
        return null;
      }
      return g(Z);
    }
    function y() {
      return g(a);
    }
    function w($) {
      function Z(W, H, G, Y, ne) {
        if (typeof $ != "function")
          return new m("Property `" + ne + "` of component `" + G + "` has invalid PropType notation inside arrayOf.");
        var J = W[H];
        if (!Array.isArray(J)) {
          var ee = B(J);
          return new m("Invalid " + Y + " `" + ne + "` of type " + ("`" + ee + "` supplied to `" + G + "`, expected an array."));
        }
        for (var U = 0; U < J.length; U++) {
          var X = $(J, U, G, Y, ne + "[" + U + "]", n);
          if (X instanceof Error)
            return X;
        }
        return null;
      }
      return g(Z);
    }
    function x() {
      function $(Z, W, H, G, Y) {
        var ne = Z[W];
        if (!s(ne)) {
          var J = B(ne);
          return new m("Invalid " + G + " `" + Y + "` of type " + ("`" + J + "` supplied to `" + H + "`, expected a single ReactElement."));
        }
        return null;
      }
      return g($);
    }
    function b() {
      function $(Z, W, H, G, Y) {
        var ne = Z[W];
        if (!e.isValidElementType(ne)) {
          var J = B(ne);
          return new m("Invalid " + G + " `" + Y + "` of type " + ("`" + J + "` supplied to `" + H + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return g($);
    }
    function S($) {
      function Z(W, H, G, Y, ne) {
        if (!(W[H] instanceof $)) {
          var J = $.name || h, ee = z(W[H]);
          return new m("Invalid " + Y + " `" + ne + "` of type " + ("`" + ee + "` supplied to `" + G + "`, expected ") + ("instance of `" + J + "`."));
        }
        return null;
      }
      return g(Z);
    }
    function M($) {
      if (!Array.isArray($))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), a;
      function Z(W, H, G, Y, ne) {
        for (var J = W[H], ee = 0; ee < $.length; ee++)
          if (C(J, $[ee]))
            return null;
        var U = JSON.stringify($, function(ie, j) {
          var te = V(j);
          return te === "symbol" ? String(j) : j;
        });
        return new m("Invalid " + Y + " `" + ne + "` of value `" + String(J) + "` " + ("supplied to `" + G + "`, expected one of " + U + "."));
      }
      return g(Z);
    }
    function E($) {
      function Z(W, H, G, Y, ne) {
        if (typeof $ != "function")
          return new m("Property `" + ne + "` of component `" + G + "` has invalid PropType notation inside objectOf.");
        var J = W[H], ee = B(J);
        if (ee !== "object")
          return new m("Invalid " + Y + " `" + ne + "` of type " + ("`" + ee + "` supplied to `" + G + "`, expected an object."));
        for (var U in J)
          if (r(J, U)) {
            var X = $(J, U, G, Y, ne + "." + U, n);
            if (X instanceof Error)
              return X;
          }
        return null;
      }
      return g(Z);
    }
    function P($) {
      if (!Array.isArray($))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var Z = 0; Z < $.length; Z++) {
        var W = $[Z];
        if (typeof W != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + k(W) + " at index " + Z + "."
          ), a;
      }
      function H(G, Y, ne, J, ee) {
        for (var U = [], X = 0; X < $.length; X++) {
          var ie = $[X], j = ie(G, Y, ne, J, ee, n);
          if (j == null)
            return null;
          j.data && r(j.data, "expectedType") && U.push(j.data.expectedType);
        }
        var te = U.length > 0 ? ", expected one of type [" + U.join(", ") + "]" : "";
        return new m("Invalid " + J + " `" + ee + "` supplied to " + ("`" + ne + "`" + te + "."));
      }
      return g(H);
    }
    function T() {
      function $(Z, W, H, G, Y) {
        return R(Z[W]) ? null : new m("Invalid " + G + " `" + Y + "` supplied to " + ("`" + H + "`, expected a ReactNode."));
      }
      return g($);
    }
    function _($, Z, W, H, G) {
      return new m(
        ($ || "React class") + ": " + Z + " type `" + W + "." + H + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + G + "`."
      );
    }
    function D($) {
      function Z(W, H, G, Y, ne) {
        var J = W[H], ee = B(J);
        if (ee !== "object")
          return new m("Invalid " + Y + " `" + ne + "` of type `" + ee + "` " + ("supplied to `" + G + "`, expected `object`."));
        for (var U in $) {
          var X = $[U];
          if (typeof X != "function")
            return _(G, Y, ne, U, V(X));
          var ie = X(J, U, G, Y, ne + "." + U, n);
          if (ie)
            return ie;
        }
        return null;
      }
      return g(Z);
    }
    function N($) {
      function Z(W, H, G, Y, ne) {
        var J = W[H], ee = B(J);
        if (ee !== "object")
          return new m("Invalid " + Y + " `" + ne + "` of type `" + ee + "` " + ("supplied to `" + G + "`, expected `object`."));
        var U = t({}, W[H], $);
        for (var X in U) {
          var ie = $[X];
          if (r($, X) && typeof ie != "function")
            return _(G, Y, ne, X, V(ie));
          if (!ie)
            return new m(
              "Invalid " + Y + " `" + ne + "` key `" + X + "` supplied to `" + G + "`.\nBad object: " + JSON.stringify(W[H], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys($), null, "  ")
            );
          var j = ie(J, X, G, Y, ne + "." + X, n);
          if (j)
            return j;
        }
        return null;
      }
      return g(Z);
    }
    function R($) {
      switch (typeof $) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !$;
        case "object":
          if (Array.isArray($))
            return $.every(R);
          if ($ === null || s($))
            return !0;
          var Z = f($);
          if (Z) {
            var W = Z.call($), H;
            if (Z !== $.entries) {
              for (; !(H = W.next()).done; )
                if (!R(H.value))
                  return !1;
            } else
              for (; !(H = W.next()).done; ) {
                var G = H.value;
                if (G && !R(G[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function L($, Z) {
      return $ === "symbol" ? !0 : Z ? Z["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && Z instanceof Symbol : !1;
    }
    function B($) {
      var Z = typeof $;
      return Array.isArray($) ? "array" : $ instanceof RegExp ? "object" : L(Z, $) ? "symbol" : Z;
    }
    function V($) {
      if (typeof $ > "u" || $ === null)
        return "" + $;
      var Z = B($);
      if (Z === "object") {
        if ($ instanceof Date)
          return "date";
        if ($ instanceof RegExp)
          return "regexp";
      }
      return Z;
    }
    function k($) {
      var Z = V($);
      switch (Z) {
        case "array":
        case "object":
          return "an " + Z;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + Z;
        default:
          return Z;
      }
    }
    function z($) {
      return !$.constructor || !$.constructor.name ? h : $.constructor.name;
    }
    return p.checkPropTypes = o, p.resetWarningCache = o.resetWarningCache, p.PropTypes = p, p;
  }, a3;
}
var s3, zv;
function oee() {
  if (zv) return s3;
  zv = 1;
  var e = /* @__PURE__ */ rp();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, s3 = function() {
    function r(a, s, l, c, u, f) {
      if (f !== e) {
        var h = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw h.name = "Invariant Violation", h;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, s3;
}
var Zv;
function iee() {
  if (Zv) return wc.exports;
  if (Zv = 1, process.env.NODE_ENV !== "production") {
    var e = sI(), t = !0;
    wc.exports = /* @__PURE__ */ ree()(e.isElement, t);
  } else
    wc.exports = /* @__PURE__ */ oee()();
  return wc.exports;
}
var aee = /* @__PURE__ */ iee();
const $e = /* @__PURE__ */ Mt(aee), see = $e.string, lee = $e.func, cee = $e.func, uee = $e.func, fee = $e.bool, dee = $e.number, hee = $e.object, pee = $e.bool, mee = $e.node.isRequired, gee = $e.oneOfType([
  $e.func,
  $e.shape({ current: $e.any })
]), cI = O.forwardRef(
  ({
    children: e,
    prevArrow: t,
    nextArrow: n,
    navigation: r,
    navigationPosition: o = "default",
    reserveOutsideNavSpace: i = !1,
    navReserveHeight: a = 36,
    autoplay: s,
    autoplayDelay: l,
    transition: c,
    loop: u = !0,
    className: f,
    slideRef: h,
    arrowClassName: p,
    slideClassName: C,
    tabIndex: m = null,
    ...g
  }, v) => {
    const y = DJ(0), w = O.useRef(null), x = bG(w), b = yG(w);
    c || (c = { duration: 0.5 }), s && !l && (l = 3e3);
    const [S, M] = O.useState(0), E = O.Children.toArray(e), P = _e(
      () => E.length > 1,
      [E.length]
    ), T = _e(
      () => S < E.length - 1,
      [S, E.length]
    ), _ = _e(() => S > 0, [S]), D = o === "outside", N = D && i && !P, R = I("flex flex-col", f), L = I(
      "inline-block h-auto w-full flex-none rounded-md [&>img]:rounded-md",
      C
    ), B = I(
      "rounded-full bg-white bg-opacity-50 p-xs text-text-brand transition-all ease-in hover:bg-white hover:text-text-brand",
      D && "border-text-neutral border hover:bg-slate-100",
      p
    ), V = O.useCallback(
      () => -S * (w.current?.clientWidth || 0),
      [S]
    ), k = O.useCallback(() => {
      const G = u ? 0 : S;
      M(S + 1 === E.length ? G : S + 1);
    }, [S, u, E.length]), z = () => {
      const G = u ? E.length - 1 : 0;
      M(S - 1 < 0 ? G : S - 1);
    };
    O.useEffect(() => kv(y, V(), c).stop, [V, S, y, c]), O.useEffect(() => {
      const G = () => {
        kv(y, V(), c);
      };
      return window.addEventListener("resize", G), () => {
        window.removeEventListener("resize", G);
      };
    }, [V, c, y]), O.useEffect(() => {
      if (!s || x || b)
        return;
      const G = setInterval(() => k(), l);
      return () => clearInterval(G);
    }, [s, k, l, x, b]);
    const $ = Mo([w, v]), Z = ({
      loop: G,
      handlePrev: Y,
      activeIndex: ne,
      firstIndex: J
    }) => !_ && !G || !P ? null : /* @__PURE__ */ d(
      "button",
      {
        onClick: Y,
        onKeyDown: (U) => {
          U.key === "ArrowLeft" && (U.preventDefault(), Y()), U.key === "ArrowRight" && (U.preventDefault(), k());
        },
        disabled: !G && J,
        "aria-label": "Previous slide",
        className: I(
          D ? "" : "absolute left-0 top-1/2 ml-sm -translate-y-1/2",
          B,
          !G && J ? "opacity-25" : ""
        ),
        children: /* @__PURE__ */ d(qr, {})
      }
    ), W = ({
      loop: G,
      handleNext: Y,
      activeIndex: ne,
      lastIndex: J
    }) => !T && !G || !P ? null : /* @__PURE__ */ d(
      "button",
      {
        onClick: Y,
        onKeyDown: (U) => {
          U.key === "ArrowLeft" && (U.preventDefault(), z()), U.key === "ArrowRight" && (U.preventDefault(), Y());
        },
        disabled: !G && J,
        "aria-label": "Next slide",
        className: I(
          D ? "" : "absolute right-0 top-1/2 mr-sm -translate-y-1/2",
          B,
          !G && J ? "opacity-25" : ""
        ),
        children: /* @__PURE__ */ d(yo, {})
      }
    ), H = ({
      setActiveIndex: G,
      activeIndex: Y,
      length: ne
    }) => {
      if (!P) return null;
      const J = (U) => {
        U.key === "ArrowLeft" && (U.preventDefault(), z()), U.key === "ArrowRight" && (U.preventDefault(), k());
      }, ee = /* @__PURE__ */ d("div", { className: "flex items-center justify-center gap-[6px] rounded-lg bg-white px-[12px] py-[8px] shadow-lg", children: Array.from({ length: ne }).map((U, X) => /* @__PURE__ */ d(
        oI.button,
        {
          onKeyDown: J,
          onClick: () => G(X),
          variants: {
            active: { width: "24px" },
            inactive: { width: "6px" }
          },
          exit: "inactive",
          animate: Y === X ? "active" : "inactive",
          transition: { duration: 0.2 },
          className: `h-[6px] w-[6px] rounded-full ${X === Y ? "bg-surface-common-secondary" : "bg-neutral-300"}`
        },
        X
      )) });
      return D ? ee : /* @__PURE__ */ d(aX, { children: /* @__PURE__ */ d("div", { className: "absolute bottom-2 left-1/2 flex -translate-x-1/2 space-x-2", children: ee }) });
    };
    return t = t ?? Z, n = n ?? W, r = r ?? H, /* @__PURE__ */ F("div", { ...g, ref: $, className: R, children: [
      /* @__PURE__ */ F("div", { className: "relative overflow-hidden rounded-md", children: [
        /* @__PURE__ */ d(sX, { features: IJ, children: /* @__PURE__ */ d(
          VX.div,
          {
            style: { x: y },
            className: "flex will-change-transform",
            role: "list",
            "aria-roledescription": "carousel",
            "aria-label": "Bildekarusell",
            children: E.map((G, Y) => /* @__PURE__ */ d(
              "div",
              {
                ref: Y === S ? h : void 0,
                className: I(
                  L,
                  S !== Y && "pointer-events-none invisible"
                ),
                role: "group",
                "aria-roledescription": "slide",
                "aria-label": `${Y + 1} av ${E.length}`,
                "aria-hidden": S !== Y,
                tabIndex: S === Y ? m || 0 : -1,
                children: G
              },
              Y
            ))
          }
        ) }),
        !D && /* @__PURE__ */ F(ut, { children: [
          t && t({
            loop: u,
            handlePrev: z,
            activeIndex: S,
            firstIndex: S === 0
          }),
          n && n({
            loop: u,
            handleNext: k,
            activeIndex: S,
            lastIndex: S === E.length - 1
          }),
          r && r({
            setActiveIndex: M,
            activeIndex: S,
            length: E.length
          })
        ] })
      ] }),
      D && /* @__PURE__ */ d(ut, { children: P ? /* @__PURE__ */ d("div", { className: "mt-2 flex items-center justify-center gap-2", children: /* @__PURE__ */ F(ut, { children: [
        t && t({
          loop: u,
          handlePrev: z,
          activeIndex: S,
          firstIndex: S === 0
        }),
        r && r({
          setActiveIndex: M,
          activeIndex: S,
          length: E.length
        }),
        n && n({
          loop: u,
          handleNext: k,
          activeIndex: S,
          lastIndex: S === E.length - 1
        })
      ] }) }) : N && /* @__PURE__ */ d(
        "div",
        {
          className: "mt-2",
          style: { height: a },
          "aria-hidden": !0
        }
      ) })
    ] });
  }
);
cI.propTypes = {
  className: see,
  children: mee,
  nextArrow: cee,
  prevArrow: lee,
  navigation: uee,
  autoplay: fee,
  autoplayDelay: dee,
  transition: hee,
  loop: pee,
  slideRef: gee
};
cI.displayName = "MaterialTailwind.Carousel";
const Cee = (e) => /* @__PURE__ */ d(A1, { type: "radio", role: "switch", ...e }), Xpe = ({
  type: e = "date",
  ...t
}) => /* @__PURE__ */ d(A1, { type: e, ...t }), Wv = (e) => {
  let t = e.split(" - ");
  if (t.length !== 2 && (t = e.split("-")), t.length !== 2) return;
  const [n, r] = t;
  if (!n || !r) return;
  const o = Tl(n), i = Tl(r);
  if (!(isNaN(o.getTime()) || isNaN(i.getTime()))) {
    if (rh(o, i)) {
      const a = new Date(i);
      return a.setHours(23, 59, 59, 999), { from: o, to: a };
    }
    return { from: o, to: i };
  }
}, vee = (e) => e.split(",").map((o) => Tl(o)).filter((o) => o !== void 0), qv = (e) => Tl(e), l3 = (e, t) => {
  const n = "dd.MM.yyyy";
  return e && t ? [Sa(e, n), Sa(t, n)].join(" - ") : e && !t ? Sa(e, n) : "";
}, yee = (e) => {
  if (e?.from && e?.to && rh(e.from, e.to)) {
    const t = new Date(e.to);
    return t.setHours(23, 59, 59, 999), { from: e.from, to: t };
  }
  return e;
}, op = gt(
  null
);
op.displayName = "DatepickerContext";
const of = ({ value: e, children: t }) => /* @__PURE__ */ d(op.Provider, { value: e, children: t });
of.displayName = "DatepickerProvider";
function bee(e, t, n = "long") {
  return new Intl.DateTimeFormat("en-US", {
    // Enforces engine to render the time. Without the option JavaScriptCore omits it.
    hour: "numeric",
    timeZone: e,
    timeZoneName: n
  }).format(t).split(/\s/g).slice(2).join(" ");
}
const wee = {}, cl = {};
function oi(e, t) {
  try {
    const r = (wee[e] ||= new Intl.DateTimeFormat("en-US", {
      timeZone: e,
      timeZoneName: "longOffset"
    }).format)(t).split("GMT")[1];
    return r in cl ? cl[r] : Uv(r, r.split(":"));
  } catch {
    if (e in cl) return cl[e];
    const n = e?.match(xee);
    return n ? Uv(e, n.slice(1)) : NaN;
  }
}
const xee = /([+-]\d\d):?(\d\d)?/;
function Uv(e, t) {
  const n = +(t[0] || 0), r = +(t[1] || 0), o = +(t[2] || 0) / 60;
  return cl[e] = n * 60 + r > 0 ? n * 60 + r + o : n * 60 - r - o;
}
class co extends Date {
  //#region static
  constructor(...t) {
    super(), t.length > 1 && typeof t[t.length - 1] == "string" && (this.timeZone = t.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(oi(this.timeZone, this)) ? this.setTime(NaN) : t.length ? typeof t[0] == "number" && (t.length === 1 || t.length === 2 && typeof t[1] != "number") ? this.setTime(t[0]) : typeof t[0] == "string" ? this.setTime(+new Date(t[0])) : t[0] instanceof Date ? this.setTime(+t[0]) : (this.setTime(+new Date(...t)), uI(this), af(this)) : this.setTime(Date.now());
  }
  static tz(t, ...n) {
    return n.length ? new co(...n, t) : new co(Date.now(), t);
  }
  //#endregion
  //#region time zone
  withTimeZone(t) {
    return new co(+this, t);
  }
  getTimezoneOffset() {
    const t = -oi(this.timeZone, this);
    return t > 0 ? Math.floor(t) : Math.ceil(t);
  }
  //#endregion
  //#region time
  setTime(t) {
    return Date.prototype.setTime.apply(this, arguments), af(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new co(+new Date(t), this.timeZone);
  }
  //#endregion
}
const Gv = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((e) => {
  if (!Gv.test(e)) return;
  const t = e.replace(Gv, "$1UTC");
  co.prototype[t] && (e.startsWith("get") ? co.prototype[e] = function() {
    return this.internal[t]();
  } : (co.prototype[e] = function() {
    return Date.prototype[t].apply(this.internal, arguments), See(this), +this;
  }, co.prototype[t] = function() {
    return Date.prototype[t].apply(this, arguments), af(this), +this;
  }));
});
function af(e) {
  e.internal.setTime(+e), e.internal.setUTCSeconds(e.internal.getUTCSeconds() - Math.round(-oi(e.timeZone, e) * 60));
}
function See(e) {
  Date.prototype.setFullYear.call(e, e.internal.getUTCFullYear(), e.internal.getUTCMonth(), e.internal.getUTCDate()), Date.prototype.setHours.call(e, e.internal.getUTCHours(), e.internal.getUTCMinutes(), e.internal.getUTCSeconds(), e.internal.getUTCMilliseconds()), uI(e);
}
function uI(e) {
  const t = oi(e.timeZone, e), n = t > 0 ? Math.floor(t) : Math.ceil(t), r = /* @__PURE__ */ new Date(+e);
  r.setUTCHours(r.getUTCHours() - 1);
  const o = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset(), i = -(/* @__PURE__ */ new Date(+r)).getTimezoneOffset(), a = o - i, s = Date.prototype.getHours.apply(e) !== e.internal.getUTCHours();
  a && s && e.internal.setUTCMinutes(e.internal.getUTCMinutes() + a);
  const l = o - n;
  l && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + l);
  const c = /* @__PURE__ */ new Date(+e);
  c.setUTCSeconds(0);
  const u = o > 0 ? c.getSeconds() : (c.getSeconds() - 60) % 60, f = Math.round(-(oi(e.timeZone, e) * 60)) % 60;
  (f || u) && (e.internal.setUTCSeconds(e.internal.getUTCSeconds() + f), Date.prototype.setUTCSeconds.call(e, Date.prototype.getUTCSeconds.call(e) + f + u));
  const h = oi(e.timeZone, e), p = h > 0 ? Math.floor(h) : Math.ceil(h), m = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset() - p, g = p !== n, v = m - l;
  if (g && v) {
    Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + v);
    const y = oi(e.timeZone, e), w = y > 0 ? Math.floor(y) : Math.ceil(y), x = p - w;
    x && (e.internal.setUTCMinutes(e.internal.getUTCMinutes() + x), Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + x));
  }
}
class Pn extends co {
  //#region static
  static tz(t, ...n) {
    return n.length ? new Pn(...n, t) : new Pn(Date.now(), t);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [t, n, r] = this.tzComponents(), o = `${t}${n}:${r}`;
    return this.internal.toISOString().slice(0, -1) + o;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [t, n, r, o] = this.internal.toUTCString().split(" ");
    return `${t?.slice(0, -1)} ${r} ${n} ${o}`;
  }
  toTimeString() {
    const t = this.internal.toUTCString().split(" ")[4], [n, r, o] = this.tzComponents();
    return `${t} GMT${n}${r}${o} (${bee(this.timeZone, this)})`;
  }
  toLocaleString(t, n) {
    return Date.prototype.toLocaleString.call(this, t, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  toLocaleDateString(t, n) {
    return Date.prototype.toLocaleDateString.call(this, t, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  toLocaleTimeString(t, n) {
    return Date.prototype.toLocaleTimeString.call(this, t, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const t = this.getTimezoneOffset(), n = t > 0 ? "-" : "+", r = String(Math.floor(Math.abs(t) / 60)).padStart(2, "0"), o = String(Math.abs(t) % 60).padStart(2, "0");
    return [n, r, o];
  }
  //#endregion
  withTimeZone(t) {
    return new Pn(+this, t);
  }
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new Pn(+new Date(t), this.timeZone);
  }
  //#endregion
}
const Kv = 5, Mee = 4;
function Eee(e, t) {
  const n = t.startOfMonth(e), r = n.getDay() > 0 ? n.getDay() : 7, o = t.addDays(e, -r + 1), i = t.addDays(o, Kv * 7 - 1);
  return t.getMonth(e) === t.getMonth(i) ? Kv : Mee;
}
function fI(e, t) {
  const n = t.startOfMonth(e), r = n.getDay();
  return r === 1 ? n : r === 0 ? t.addDays(n, -6) : t.addDays(n, -1 * (r - 1));
}
function _ee(e, t) {
  const n = fI(e, t), r = Eee(e, t);
  return t.addDays(n, r * 7 - 1);
}
class fr {
  /**
   * Creates an instance of `DateLib`.
   *
   * @param options Configuration options for the date library.
   * @param overrides Custom overrides for the date library functions.
   */
  constructor(t, n) {
    this.Date = Date, this.today = () => this.overrides?.today ? this.overrides.today() : this.options.timeZone ? Pn.tz(this.options.timeZone) : new this.Date(), this.newDate = (r, o, i) => this.overrides?.newDate ? this.overrides.newDate(r, o, i) : this.options.timeZone ? new Pn(r, o, i, this.options.timeZone) : new Date(r, o, i), this.addDays = (r, o) => this.overrides?.addDays ? this.overrides.addDays(r, o) : ku(r, o), this.addMonths = (r, o) => this.overrides?.addMonths ? this.overrides.addMonths(r, o) : xO(r, o), this.addWeeks = (r, o) => this.overrides?.addWeeks ? this.overrides.addWeeks(r, o) : DH(r, o), this.addYears = (r, o) => this.overrides?.addYears ? this.overrides.addYears(r, o) : RH(r, o), this.differenceInCalendarDays = (r, o) => this.overrides?.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(r, o) : MO(r, o), this.differenceInCalendarMonths = (r, o) => this.overrides?.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(r, o) : FH(r, o), this.eachMonthOfInterval = (r) => this.overrides?.eachMonthOfInterval ? this.overrides.eachMonthOfInterval(r) : BH(r), this.eachYearOfInterval = (r) => {
      const o = this.overrides?.eachYearOfInterval ? this.overrides.eachYearOfInterval(r) : HH(r), i = new Set(o.map((s) => this.getYear(s)));
      if (i.size === o.length)
        return o;
      const a = [];
      return i.forEach((s) => {
        a.push(new Date(s, 0, 1));
      }), a;
    }, this.endOfBroadcastWeek = (r) => this.overrides?.endOfBroadcastWeek ? this.overrides.endOfBroadcastWeek(r) : _ee(r, this), this.endOfISOWeek = (r) => this.overrides?.endOfISOWeek ? this.overrides.endOfISOWeek(r) : zH(r), this.endOfMonth = (r) => this.overrides?.endOfMonth ? this.overrides.endOfMonth(r) : VH(r), this.endOfWeek = (r, o) => this.overrides?.endOfWeek ? this.overrides.endOfWeek(r, o) : AO(r, this.options), this.endOfYear = (r) => this.overrides?.endOfYear ? this.overrides.endOfYear(r) : jH(r), this.format = (r, o, i) => {
      const a = this.overrides?.format ? this.overrides.format(r, o, this.options) : Sa(r, o, this.options);
      return this.options.numerals && this.options.numerals !== "latn" ? this.replaceDigits(a) : a;
    }, this.getISOWeek = (r) => this.overrides?.getISOWeek ? this.overrides.getISOWeek(r) : Qd(r), this.getMonth = (r, o) => this.overrides?.getMonth ? this.overrides.getMonth(r, this.options) : RO(r, this.options), this.getYear = (r, o) => this.overrides?.getYear ? this.overrides.getYear(r, this.options) : kO(r, this.options), this.getWeek = (r, o) => this.overrides?.getWeek ? this.overrides.getWeek(r, this.options) : eh(r, this.options), this.isAfter = (r, o) => this.overrides?.isAfter ? this.overrides.isAfter(r, o) : Vz(r, o), this.isBefore = (r, o) => this.overrides?.isBefore ? this.overrides.isBefore(r, o) : Bz(r, o), this.isDate = (r) => this.overrides?.isDate ? this.overrides.isDate(r) : EO(r), this.isSameDay = (r, o) => this.overrides?.isSameDay ? this.overrides.isSameDay(r, o) : NH(r, o), this.isSameMonth = (r, o) => this.overrides?.isSameMonth ? this.overrides.isSameMonth(r, o) : NZ(r, o), this.isSameYear = (r, o) => this.overrides?.isSameYear ? this.overrides.isSameYear(r, o) : FZ(r, o), this.max = (r) => this.overrides?.max ? this.overrides.max(r) : kH(r), this.min = (r) => this.overrides?.min ? this.overrides.min(r) : LH(r), this.setMonth = (r, o) => this.overrides?.setMonth ? this.overrides.setMonth(r, o) : VZ(r, o), this.setYear = (r, o) => this.overrides?.setYear ? this.overrides.setYear(r, o) : BZ(r, o), this.startOfBroadcastWeek = (r, o) => this.overrides?.startOfBroadcastWeek ? this.overrides.startOfBroadcastWeek(r, this) : fI(r, this), this.startOfDay = (r) => this.overrides?.startOfDay ? this.overrides.startOfDay(r) : Pl(r), this.startOfISOWeek = (r) => this.overrides?.startOfISOWeek ? this.overrides.startOfISOWeek(r) : yi(r), this.startOfMonth = (r) => this.overrides?.startOfMonth ? this.overrides.startOfMonth(r) : $H(r), this.startOfWeek = (r, o) => this.overrides?.startOfWeek ? this.overrides.startOfWeek(r, this.options) : Ko(r, this.options), this.startOfYear = (r) => this.overrides?.startOfYear ? this.overrides.startOfYear(r) : OO(r), this.options = { locale: Lu, ...t }, this.overrides = n;
  }
  /**
   * Generates a mapping of Arabic digits (0-9) to the target numbering system
   * digits.
   *
   * @since 9.5.0
   * @returns A record mapping Arabic digits to the target numerals.
   */
  getDigitMap() {
    const { numerals: t = "latn" } = this.options, n = new Intl.NumberFormat("en-US", {
      numberingSystem: t
    }), r = {};
    for (let o = 0; o < 10; o++)
      r[o.toString()] = n.format(o);
    return r;
  }
  /**
   * Replaces Arabic digits in a string with the target numbering system digits.
   *
   * @since 9.5.0
   * @param input The string containing Arabic digits.
   * @returns The string with digits replaced.
   */
  replaceDigits(t) {
    const n = this.getDigitMap();
    return t.replace(/\d/g, (r) => n[r] || r);
  }
  /**
   * Formats a number using the configured numbering system.
   *
   * @since 9.5.0
   * @param value The number to format.
   * @returns The formatted number as a string.
   */
  formatNumber(t) {
    return this.replaceDigits(t.toString());
  }
  /**
   * Returns the preferred ordering for month and year labels for the current
   * locale.
   */
  getMonthYearOrder() {
    const t = this.options.locale?.code;
    return t && fr.yearFirstLocales.has(t) ? "year-first" : "month-first";
  }
  /**
   * Formats the month/year pair respecting locale conventions.
   *
   * @since 9.11.0
   */
  formatMonthYear(t) {
    const { locale: n, timeZone: r, numerals: o } = this.options, i = n?.code;
    if (i && fr.yearFirstLocales.has(i))
      try {
        return new Intl.DateTimeFormat(i, {
          month: "long",
          year: "numeric",
          timeZone: r,
          numberingSystem: o
        }).format(t);
      } catch {
      }
    const a = this.getMonthYearOrder() === "year-first" ? "y LLLL" : "LLLL y";
    return this.format(t, a);
  }
}
fr.yearFirstLocales = /* @__PURE__ */ new Set([
  "eu",
  "hu",
  "ja",
  "ja-Hira",
  "ja-JP",
  "ko",
  "ko-KR",
  "lt",
  "lt-LT",
  "lv",
  "lv-LV",
  "mn",
  "mn-MN",
  "zh",
  "zh-CN",
  "zh-HK",
  "zh-TW"
]);
const _o = new fr();
class dI {
  constructor(t, n, r = _o) {
    this.date = t, this.displayMonth = n, this.outside = !!(n && !r.isSameMonth(t, n)), this.dateLib = r;
  }
  /**
   * Checks if this day is equal to another `CalendarDay`, considering both the
   * date and the displayed month.
   *
   * @param day The `CalendarDay` to compare with.
   * @returns `true` if the days are equal, otherwise `false`.
   */
  isEqualTo(t) {
    return this.dateLib.isSameDay(t.date, this.date) && this.dateLib.isSameMonth(t.displayMonth, this.displayMonth);
  }
}
class Oee {
  constructor(t, n) {
    this.date = t, this.weeks = n;
  }
}
class Aee {
  constructor(t, n) {
    this.days = n, this.weekNumber = t;
  }
}
function Pee(e) {
  return O.createElement("button", { ...e });
}
function Tee(e) {
  return O.createElement("span", { ...e });
}
function Iee(e) {
  const { size: t = 24, orientation: n = "left", className: r } = e;
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: handled by the parent component
    O.createElement(
      "svg",
      { className: r, width: t, height: t, viewBox: "0 0 24 24" },
      n === "up" && O.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }),
      n === "down" && O.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }),
      n === "left" && O.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }),
      n === "right" && O.createElement("polygon", { points: "8 18.112 14.18888889 12 8 5.87733333 9.91111111 4 18 12 9.91111111 20" })
    )
  );
}
function Dee(e) {
  const { day: t, modifiers: n, ...r } = e;
  return O.createElement("td", { ...r });
}
function Ree(e) {
  const { day: t, modifiers: n, ...r } = e, o = O.useRef(null);
  return O.useEffect(() => {
    n.focused && o.current?.focus();
  }, [n.focused]), O.createElement("button", { ref: o, ...r });
}
var Me;
(function(e) {
  e.Root = "root", e.Chevron = "chevron", e.Day = "day", e.DayButton = "day_button", e.CaptionLabel = "caption_label", e.Dropdowns = "dropdowns", e.Dropdown = "dropdown", e.DropdownRoot = "dropdown_root", e.Footer = "footer", e.MonthGrid = "month_grid", e.MonthCaption = "month_caption", e.MonthsDropdown = "months_dropdown", e.Month = "month", e.Months = "months", e.Nav = "nav", e.NextMonthButton = "button_next", e.PreviousMonthButton = "button_previous", e.Week = "week", e.Weeks = "weeks", e.Weekday = "weekday", e.Weekdays = "weekdays", e.WeekNumber = "week_number", e.WeekNumberHeader = "week_number_header", e.YearsDropdown = "years_dropdown";
})(Me || (Me = {}));
var Nt;
(function(e) {
  e.disabled = "disabled", e.hidden = "hidden", e.outside = "outside", e.focused = "focused", e.today = "today";
})(Nt || (Nt = {}));
var $r;
(function(e) {
  e.range_end = "range_end", e.range_middle = "range_middle", e.range_start = "range_start", e.selected = "selected";
})($r || ($r = {}));
var tr;
(function(e) {
  e.weeks_before_enter = "weeks_before_enter", e.weeks_before_exit = "weeks_before_exit", e.weeks_after_enter = "weeks_after_enter", e.weeks_after_exit = "weeks_after_exit", e.caption_after_enter = "caption_after_enter", e.caption_after_exit = "caption_after_exit", e.caption_before_enter = "caption_before_enter", e.caption_before_exit = "caption_before_exit";
})(tr || (tr = {}));
function kee(e) {
  const { options: t, className: n, components: r, classNames: o, ...i } = e, a = [o[Me.Dropdown], n].join(" "), s = t?.find(({ value: l }) => l === i.value);
  return O.createElement(
    "span",
    { "data-disabled": i.disabled, className: o[Me.DropdownRoot] },
    O.createElement(r.Select, { className: a, ...i }, t?.map(({ value: l, label: c, disabled: u }) => O.createElement(r.Option, { key: l, value: l, disabled: u }, c))),
    O.createElement(
      "span",
      { className: o[Me.CaptionLabel], "aria-hidden": !0 },
      s?.label,
      O.createElement(r.Chevron, { orientation: "down", size: 18, className: o[Me.Chevron] })
    )
  );
}
function Lee(e) {
  return O.createElement("div", { ...e });
}
function Nee(e) {
  return O.createElement("div", { ...e });
}
function Fee(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return O.createElement("div", { ...r }, e.children);
}
function Vee(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return O.createElement("div", { ...r });
}
function Bee(e) {
  return O.createElement("table", { ...e });
}
function $ee(e) {
  return O.createElement("div", { ...e });
}
const hI = gt(void 0);
function j2() {
  const e = Oe(hI);
  if (e === void 0)
    throw new Error("useDayPicker() must be used within a custom component.");
  return e;
}
function jee(e) {
  const { components: t } = j2();
  return O.createElement(t.Dropdown, { ...e });
}
function Hee(e) {
  const { onPreviousClick: t, onNextClick: n, previousMonth: r, nextMonth: o, ...i } = e, { components: a, classNames: s, labels: { labelPrevious: l, labelNext: c } } = j2(), u = ct((h) => {
    o && n?.(h);
  }, [o, n]), f = ct((h) => {
    r && t?.(h);
  }, [r, t]);
  return O.createElement(
    "nav",
    { ...i },
    O.createElement(
      a.PreviousMonthButton,
      { type: "button", className: s[Me.PreviousMonthButton], tabIndex: r ? void 0 : -1, "aria-disabled": r ? void 0 : !0, "aria-label": l(r), onClick: f },
      O.createElement(a.Chevron, { disabled: r ? void 0 : !0, className: s[Me.Chevron], orientation: "left" })
    ),
    O.createElement(
      a.NextMonthButton,
      { type: "button", className: s[Me.NextMonthButton], tabIndex: o ? void 0 : -1, "aria-disabled": o ? void 0 : !0, "aria-label": c(o), onClick: u },
      O.createElement(a.Chevron, { disabled: o ? void 0 : !0, orientation: "right", className: s[Me.Chevron] })
    )
  );
}
function zee(e) {
  const { components: t } = j2();
  return O.createElement(t.Button, { ...e });
}
function Zee(e) {
  return O.createElement("option", { ...e });
}
function Wee(e) {
  const { components: t } = j2();
  return O.createElement(t.Button, { ...e });
}
function qee(e) {
  const { rootRef: t, ...n } = e;
  return O.createElement("div", { ...n, ref: t });
}
function Uee(e) {
  return O.createElement("select", { ...e });
}
function Gee(e) {
  const { week: t, ...n } = e;
  return O.createElement("tr", { ...n });
}
function Kee(e) {
  return O.createElement("th", { ...e });
}
function Yee(e) {
  return O.createElement(
    "thead",
    { "aria-hidden": !0 },
    O.createElement("tr", { ...e })
  );
}
function Xee(e) {
  const { week: t, ...n } = e;
  return O.createElement("th", { ...n });
}
function Qee(e) {
  return O.createElement("th", { ...e });
}
function Jee(e) {
  return O.createElement("tbody", { ...e });
}
function ete(e) {
  const { components: t } = j2();
  return O.createElement(t.Dropdown, { ...e });
}
const tte = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: Pee,
  CaptionLabel: Tee,
  Chevron: Iee,
  Day: Dee,
  DayButton: Ree,
  Dropdown: kee,
  DropdownNav: Lee,
  Footer: Nee,
  Month: Fee,
  MonthCaption: Vee,
  MonthGrid: Bee,
  Months: $ee,
  MonthsDropdown: jee,
  Nav: Hee,
  NextMonthButton: zee,
  Option: Zee,
  PreviousMonthButton: Wee,
  Root: qee,
  Select: Uee,
  Week: Gee,
  WeekNumber: Xee,
  WeekNumberHeader: Qee,
  Weekday: Kee,
  Weekdays: Yee,
  Weeks: Jee,
  YearsDropdown: ete
}, Symbol.toStringTag, { value: "Module" }));
function Vo(e, t, n = !1, r = _o) {
  let { from: o, to: i } = e;
  const { differenceInCalendarDays: a, isSameDay: s } = r;
  return o && i ? (a(i, o) < 0 && ([o, i] = [i, o]), a(t, o) >= (n ? 1 : 0) && a(i, t) >= (n ? 1 : 0)) : !n && i ? s(i, t) : !n && o ? s(o, t) : !1;
}
function pI(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function ip(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function mI(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function gI(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function CI(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function vI(e, t) {
  return Array.isArray(e) && e.every(t.isDate);
}
function Bo(e, t, n = _o) {
  const r = Array.isArray(t) ? t : [t], { isSameDay: o, differenceInCalendarDays: i, isAfter: a } = n;
  return r.some((s) => {
    if (typeof s == "boolean")
      return s;
    if (n.isDate(s))
      return o(e, s);
    if (vI(s, n))
      return s.includes(e);
    if (ip(s))
      return Vo(s, e, !1, n);
    if (CI(s))
      return Array.isArray(s.dayOfWeek) ? s.dayOfWeek.includes(e.getDay()) : s.dayOfWeek === e.getDay();
    if (pI(s)) {
      const l = i(s.before, e), c = i(s.after, e), u = l > 0, f = c < 0;
      return a(s.before, s.after) ? f && u : u || f;
    }
    return mI(s) ? i(e, s.after) > 0 : gI(s) ? i(s.before, e) > 0 : typeof s == "function" ? s(e) : !1;
  });
}
function nte(e, t, n, r, o) {
  const { disabled: i, hidden: a, modifiers: s, showOutsideDays: l, broadcastCalendar: c, today: u } = t, { isSameDay: f, isSameMonth: h, startOfMonth: p, isBefore: C, endOfMonth: m, isAfter: g } = o, v = n && p(n), y = r && m(r), w = {
    [Nt.focused]: [],
    [Nt.outside]: [],
    [Nt.disabled]: [],
    [Nt.hidden]: [],
    [Nt.today]: []
  }, x = {};
  for (const b of e) {
    const { date: S, displayMonth: M } = b, E = !!(M && !h(S, M)), P = !!(v && C(S, v)), T = !!(y && g(S, y)), _ = !!(i && Bo(S, i, o)), D = !!(a && Bo(S, a, o)) || P || T || // Broadcast calendar will show outside days as default
    !c && !l && E || c && l === !1 && E, N = f(S, u ?? o.today());
    E && w.outside.push(b), _ && w.disabled.push(b), D && w.hidden.push(b), N && w.today.push(b), s && Object.keys(s).forEach((R) => {
      const L = s?.[R];
      L && Bo(S, L, o) && (x[R] ? x[R].push(b) : x[R] = [b]);
    });
  }
  return (b) => {
    const S = {
      [Nt.focused]: !1,
      [Nt.disabled]: !1,
      [Nt.hidden]: !1,
      [Nt.outside]: !1,
      [Nt.today]: !1
    }, M = {};
    for (const E in w) {
      const P = w[E];
      S[E] = P.some((T) => T === b);
    }
    for (const E in x)
      M[E] = x[E].some((P) => P === b);
    return {
      ...S,
      // custom modifiers should override all the previous ones
      ...M
    };
  };
}
function rte(e, t, n = {}) {
  return Object.entries(e).filter(([, o]) => o === !0).reduce((o, [i]) => (n[i] ? o.push(n[i]) : t[Nt[i]] ? o.push(t[Nt[i]]) : t[$r[i]] && o.push(t[$r[i]]), o), [t[Me.Day]]);
}
function ote(e) {
  return {
    ...tte,
    ...e
  };
}
function ite(e) {
  const t = {
    "data-mode": e.mode ?? void 0,
    "data-required": "required" in e ? e.required : void 0,
    "data-multiple-months": e.numberOfMonths && e.numberOfMonths > 1 || void 0,
    "data-week-numbers": e.showWeekNumber || void 0,
    "data-broadcast-calendar": e.broadcastCalendar || void 0,
    "data-nav-layout": e.navLayout || void 0
  };
  return Object.entries(e).forEach(([n, r]) => {
    n.startsWith("data-") && (t[n] = r);
  }), t;
}
function yI() {
  const e = {};
  for (const t in Me)
    e[Me[t]] = `rdp-${Me[t]}`;
  for (const t in Nt)
    e[Nt[t]] = `rdp-${Nt[t]}`;
  for (const t in $r)
    e[$r[t]] = `rdp-${$r[t]}`;
  for (const t in tr)
    e[tr[t]] = `rdp-${tr[t]}`;
  return e;
}
function bI(e, t, n) {
  return (n ?? new fr(t)).formatMonthYear(e);
}
const ate = bI;
function ste(e, t, n) {
  return (n ?? new fr(t)).format(e, "d");
}
function lte(e, t = _o) {
  return t.format(e, "LLLL");
}
function cte(e, t, n) {
  return (n ?? new fr(t)).format(e, "cccccc");
}
function ute(e, t = _o) {
  return e < 10 ? t.formatNumber(`0${e.toLocaleString()}`) : t.formatNumber(`${e.toLocaleString()}`);
}
function fte() {
  return "";
}
function wI(e, t = _o) {
  return t.format(e, "yyyy");
}
const dte = wI, hte = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCaption: bI,
  formatDay: ste,
  formatMonthCaption: ate,
  formatMonthDropdown: lte,
  formatWeekNumber: ute,
  formatWeekNumberHeader: fte,
  formatWeekdayName: cte,
  formatYearCaption: dte,
  formatYearDropdown: wI
}, Symbol.toStringTag, { value: "Module" }));
function pte(e) {
  return e?.formatMonthCaption && !e.formatCaption && (e.formatCaption = e.formatMonthCaption), e?.formatYearCaption && !e.formatYearDropdown && (e.formatYearDropdown = e.formatYearCaption), {
    ...hte,
    ...e
  };
}
function mte(e, t, n, r, o) {
  const { startOfMonth: i, startOfYear: a, endOfYear: s, eachMonthOfInterval: l, getMonth: c } = o;
  return l({
    start: a(e),
    end: s(e)
  }).map((h) => {
    const p = r.formatMonthDropdown(h, o), C = c(h), m = t && h < i(t) || n && h > i(n) || !1;
    return { value: C, label: p, disabled: m };
  });
}
function gte(e, t = {}, n = {}) {
  let r = { ...t?.[Me.Day] };
  return Object.entries(e).filter(([, o]) => o === !0).forEach(([o]) => {
    r = {
      ...r,
      ...n?.[o]
    };
  }), r;
}
function Cte(e, t, n) {
  const r = e.today(), o = t ? e.startOfISOWeek(r) : e.startOfWeek(r), i = [];
  for (let a = 0; a < 7; a++) {
    const s = e.addDays(o, a);
    i.push(s);
  }
  return i;
}
function vte(e, t, n, r, o = !1) {
  if (!e || !t)
    return;
  const { startOfYear: i, endOfYear: a, eachYearOfInterval: s, getYear: l } = r, c = i(e), u = a(t), f = s({ start: c, end: u });
  return o && f.reverse(), f.map((h) => {
    const p = n.formatYearDropdown(h, r);
    return {
      value: l(h),
      label: p,
      disabled: !1
    };
  });
}
function xI(e, t, n, r) {
  let o = (r ?? new fr(n)).format(e, "PPPP");
  return t.today && (o = `Today, ${o}`), t.selected && (o = `${o}, selected`), o;
}
const yte = xI;
function SI(e, t, n) {
  return (n ?? new fr(t)).formatMonthYear(e);
}
const bte = SI;
function wte(e, t, n, r) {
  let o = (r ?? new fr(n)).format(e, "PPPP");
  return t?.today && (o = `Today, ${o}`), o;
}
function xte(e) {
  return "Choose the Month";
}
function Ste() {
  return "";
}
function Mte(e) {
  return "Go to the Next Month";
}
function Ete(e) {
  return "Go to the Previous Month";
}
function _te(e, t, n) {
  return (n ?? new fr(t)).format(e, "cccc");
}
function Ote(e, t) {
  return `Week ${e}`;
}
function Ate(e) {
  return "Week Number";
}
function Pte(e) {
  return "Choose the Year";
}
const Tte = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  labelCaption: bte,
  labelDay: yte,
  labelDayButton: xI,
  labelGrid: SI,
  labelGridcell: wte,
  labelMonthDropdown: xte,
  labelNav: Ste,
  labelNext: Mte,
  labelPrevious: Ete,
  labelWeekNumber: Ote,
  labelWeekNumberHeader: Ate,
  labelWeekday: _te,
  labelYearDropdown: Pte
}, Symbol.toStringTag, { value: "Module" })), H2 = (e) => e instanceof HTMLElement ? e : null, c3 = (e) => [
  ...e.querySelectorAll("[data-animated-month]") ?? []
], Ite = (e) => H2(e.querySelector("[data-animated-month]")), u3 = (e) => H2(e.querySelector("[data-animated-caption]")), f3 = (e) => H2(e.querySelector("[data-animated-weeks]")), Dte = (e) => H2(e.querySelector("[data-animated-nav]")), Rte = (e) => H2(e.querySelector("[data-animated-weekdays]"));
function kte(e, t, { classNames: n, months: r, focused: o, dateLib: i }) {
  const a = ke(null), s = ke(r), l = ke(!1);
  x2(() => {
    const c = s.current;
    if (s.current = r, !t || !e.current || // safety check because the ref can be set to anything by consumers
    !(e.current instanceof HTMLElement) || // validation required for the animation to work as expected
    r.length === 0 || c.length === 0 || r.length !== c.length)
      return;
    const u = i.isSameMonth(r[0].date, c[0].date), f = i.isAfter(r[0].date, c[0].date), h = f ? n[tr.caption_after_enter] : n[tr.caption_before_enter], p = f ? n[tr.weeks_after_enter] : n[tr.weeks_before_enter], C = a.current, m = e.current.cloneNode(!0);
    if (m instanceof HTMLElement ? (c3(m).forEach((w) => {
      if (!(w instanceof HTMLElement))
        return;
      const x = Ite(w);
      x && w.contains(x) && w.removeChild(x);
      const b = u3(w);
      b && b.classList.remove(h);
      const S = f3(w);
      S && S.classList.remove(p);
    }), a.current = m) : a.current = null, l.current || u || // skip animation if a day is focused because it can cause issues to the animation and is better for a11y
    o)
      return;
    const g = C instanceof HTMLElement ? c3(C) : [], v = c3(e.current);
    if (v?.every((y) => y instanceof HTMLElement) && g && g.every((y) => y instanceof HTMLElement)) {
      l.current = !0, e.current.style.isolation = "isolate";
      const y = Dte(e.current);
      y && (y.style.zIndex = "1"), v.forEach((w, x) => {
        const b = g[x];
        if (!b)
          return;
        w.style.position = "relative", w.style.overflow = "hidden";
        const S = u3(w);
        S && S.classList.add(h);
        const M = f3(w);
        M && M.classList.add(p);
        const E = () => {
          l.current = !1, e.current && (e.current.style.isolation = ""), y && (y.style.zIndex = ""), S && S.classList.remove(h), M && M.classList.remove(p), w.style.position = "", w.style.overflow = "", w.contains(b) && w.removeChild(b);
        };
        b.style.pointerEvents = "none", b.style.position = "absolute", b.style.overflow = "hidden", b.setAttribute("aria-hidden", "true");
        const P = Rte(b);
        P && (P.style.opacity = "0");
        const T = u3(b);
        T && (T.classList.add(f ? n[tr.caption_before_exit] : n[tr.caption_after_exit]), T.addEventListener("animationend", E));
        const _ = f3(b);
        _ && _.classList.add(f ? n[tr.weeks_before_exit] : n[tr.weeks_after_exit]), w.insertBefore(b, w.firstChild);
      });
    }
  });
}
function Lte(e, t, n, r) {
  const o = e[0], i = e[e.length - 1], { ISOWeek: a, fixedWeeks: s, broadcastCalendar: l } = n ?? {}, { addDays: c, differenceInCalendarDays: u, differenceInCalendarMonths: f, endOfBroadcastWeek: h, endOfISOWeek: p, endOfMonth: C, endOfWeek: m, isAfter: g, startOfBroadcastWeek: v, startOfISOWeek: y, startOfWeek: w } = r, x = l ? v(o, r) : a ? y(o) : w(o), b = l ? h(i) : a ? p(C(i)) : m(C(i)), S = u(b, x), M = f(i, o) + 1, E = [];
  for (let _ = 0; _ <= S; _++) {
    const D = c(x, _);
    if (t && g(D, t))
      break;
    E.push(D);
  }
  const T = (l ? 35 : 42) * M;
  if (s && E.length < T) {
    const _ = T - E.length;
    for (let D = 0; D < _; D++) {
      const N = c(E[E.length - 1], 1);
      E.push(N);
    }
  }
  return E;
}
function Nte(e) {
  const t = [];
  return e.reduce((n, r) => {
    const o = r.weeks.reduce((i, a) => i.concat(a.days.slice()), t.slice());
    return n.concat(o.slice());
  }, t.slice());
}
function Fte(e, t, n, r) {
  const { numberOfMonths: o = 1 } = n, i = [];
  for (let a = 0; a < o; a++) {
    const s = r.addMonths(e, a);
    if (t && s > t)
      break;
    i.push(s);
  }
  return i;
}
function Yv(e, t, n, r) {
  const { month: o, defaultMonth: i, today: a = r.today(), numberOfMonths: s = 1 } = e;
  let l = o || i || a;
  const { differenceInCalendarMonths: c, addMonths: u, startOfMonth: f } = r;
  if (n && c(n, l) < s - 1) {
    const h = -1 * (s - 1);
    l = u(n, h);
  }
  return t && c(l, t) < 0 && (l = t), f(l);
}
function Vte(e, t, n, r) {
  const { addDays: o, endOfBroadcastWeek: i, endOfISOWeek: a, endOfMonth: s, endOfWeek: l, getISOWeek: c, getWeek: u, startOfBroadcastWeek: f, startOfISOWeek: h, startOfWeek: p } = r, C = e.reduce((m, g) => {
    const v = n.broadcastCalendar ? f(g, r) : n.ISOWeek ? h(g) : p(g), y = n.broadcastCalendar ? i(g) : n.ISOWeek ? a(s(g)) : l(s(g)), w = t.filter((M) => M >= v && M <= y), x = n.broadcastCalendar ? 35 : 42;
    if (n.fixedWeeks && w.length < x) {
      const M = t.filter((E) => {
        const P = x - w.length;
        return E > y && E <= o(y, P);
      });
      w.push(...M);
    }
    const b = w.reduce((M, E) => {
      const P = n.ISOWeek ? c(E) : u(E), T = M.find((D) => D.weekNumber === P), _ = new dI(E, g, r);
      return T ? T.days.push(_) : M.push(new Aee(P, [_])), M;
    }, []), S = new Oee(g, b);
    return m.push(S), m;
  }, []);
  return n.reverseMonths ? C.reverse() : C;
}
function Bte(e, t) {
  let { startMonth: n, endMonth: r } = e;
  const { startOfYear: o, startOfDay: i, startOfMonth: a, endOfMonth: s, addYears: l, endOfYear: c, newDate: u, today: f } = t, { fromYear: h, toYear: p, fromMonth: C, toMonth: m } = e;
  !n && C && (n = C), !n && h && (n = t.newDate(h, 0, 1)), !r && m && (r = m), !r && p && (r = u(p, 11, 31));
  const g = e.captionLayout === "dropdown" || e.captionLayout === "dropdown-years";
  return n ? n = a(n) : h ? n = u(h, 0, 1) : !n && g && (n = o(l(e.today ?? f(), -100))), r ? r = s(r) : p ? r = u(p, 11, 31) : !r && g && (r = c(e.today ?? f())), [
    n && i(n),
    r && i(r)
  ];
}
function $te(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: o, numberOfMonths: i = 1 } = n, { startOfMonth: a, addMonths: s, differenceInCalendarMonths: l } = r, c = o ? i : 1, u = a(e);
  if (!t)
    return s(u, c);
  if (!(l(t, e) < i))
    return s(u, c);
}
function jte(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: o, numberOfMonths: i } = n, { startOfMonth: a, addMonths: s, differenceInCalendarMonths: l } = r, c = o ? i ?? 1 : 1, u = a(e);
  if (!t)
    return s(u, -c);
  if (!(l(u, t) <= 0))
    return s(u, -c);
}
function Hte(e) {
  const t = [];
  return e.reduce((n, r) => n.concat(r.weeks.slice()), t.slice());
}
function Qu(e, t) {
  const [n, r] = ue(e);
  return [t === void 0 ? n : t, r];
}
function zte(e, t) {
  const [n, r] = Bte(e, t), { startOfMonth: o, endOfMonth: i } = t, a = Yv(e, n, r, t), [s, l] = Qu(
    a,
    // initialMonth is always computed from props.month if provided
    e.month ? a : void 0
  );
  ve(() => {
    const S = Yv(e, n, r, t);
    l(S);
  }, [e.timeZone]);
  const c = Fte(s, r, e, t), u = Lte(c, e.endMonth ? i(e.endMonth) : void 0, e, t), f = Vte(c, u, e, t), h = Hte(f), p = Nte(f), C = jte(s, n, e, t), m = $te(s, r, e, t), { disableNavigation: g, onMonthChange: v } = e, y = (S) => h.some((M) => M.days.some((E) => E.isEqualTo(S))), w = (S) => {
    if (g)
      return;
    let M = o(S);
    n && M < o(n) && (M = o(n)), r && M > o(r) && (M = o(r)), l(M), v?.(M);
  };
  return {
    months: f,
    weeks: h,
    days: p,
    navStart: n,
    navEnd: r,
    previousMonth: C,
    nextMonth: m,
    goToMonth: w,
    goToDay: (S) => {
      y(S) || w(S.date);
    }
  };
}
var Qr;
(function(e) {
  e[e.Today = 0] = "Today", e[e.Selected = 1] = "Selected", e[e.LastFocused = 2] = "LastFocused", e[e.FocusedModifier = 3] = "FocusedModifier";
})(Qr || (Qr = {}));
function Xv(e) {
  return !e[Nt.disabled] && !e[Nt.hidden] && !e[Nt.outside];
}
function Zte(e, t, n, r) {
  let o, i = -1;
  for (const a of e) {
    const s = t(a);
    Xv(s) && (s[Nt.focused] && i < Qr.FocusedModifier ? (o = a, i = Qr.FocusedModifier) : r?.isEqualTo(a) && i < Qr.LastFocused ? (o = a, i = Qr.LastFocused) : n(a.date) && i < Qr.Selected ? (o = a, i = Qr.Selected) : s[Nt.today] && i < Qr.Today && (o = a, i = Qr.Today));
  }
  return o || (o = e.find((a) => Xv(t(a)))), o;
}
function Wte(e, t, n, r, o, i, a) {
  const { ISOWeek: s, broadcastCalendar: l } = i, { addDays: c, addMonths: u, addWeeks: f, addYears: h, endOfBroadcastWeek: p, endOfISOWeek: C, endOfWeek: m, max: g, min: v, startOfBroadcastWeek: y, startOfISOWeek: w, startOfWeek: x } = a;
  let S = {
    day: c,
    week: f,
    month: u,
    year: h,
    startOfWeek: (M) => l ? y(M, a) : s ? w(M) : x(M),
    endOfWeek: (M) => l ? p(M) : s ? C(M) : m(M)
  }[e](n, t === "after" ? 1 : -1);
  return t === "before" && r ? S = g([r, S]) : t === "after" && o && (S = v([o, S])), S;
}
function MI(e, t, n, r, o, i, a, s = 0) {
  if (s > 365)
    return;
  const l = Wte(e, t, n.date, r, o, i, a), c = !!(i.disabled && Bo(l, i.disabled, a)), u = !!(i.hidden && Bo(l, i.hidden, a)), f = l, h = new dI(l, f, a);
  return !c && !u ? h : MI(e, t, h, r, o, i, a, s + 1);
}
function qte(e, t, n, r, o) {
  const { autoFocus: i } = e, [a, s] = ue(), l = Zte(t.days, n, r || (() => !1), a), [c, u] = ue(i ? l : void 0);
  return {
    isFocusTarget: (m) => !!l?.isEqualTo(m),
    setFocused: u,
    focused: c,
    blur: () => {
      s(c), u(void 0);
    },
    moveFocus: (m, g) => {
      if (!c)
        return;
      const v = MI(m, g, c, t.navStart, t.navEnd, e, o);
      v && (e.disableNavigation && !t.days.some((w) => w.isEqualTo(v)) || (t.goToDay(v), u(v)));
    }
  };
}
function Ute(e, t) {
  const { selected: n, required: r, onSelect: o } = e, [i, a] = Qu(n, o ? n : void 0), s = o ? n : i, { isSameDay: l } = t, c = (p) => s?.some((C) => l(C, p)) ?? !1, { min: u, max: f } = e;
  return {
    selected: s,
    select: (p, C, m) => {
      let g = [...s ?? []];
      if (c(p)) {
        if (s?.length === u || r && s?.length === 1)
          return;
        g = s?.filter((v) => !l(v, p));
      } else
        s?.length === f ? g = [p] : g = [...g, p];
      return o || a(g), o?.(g, p, C, m), g;
    },
    isSelected: c
  };
}
function Gte(e, t, n = 0, r = 0, o = !1, i = _o) {
  const { from: a, to: s } = t || {}, { isSameDay: l, isAfter: c, isBefore: u } = i;
  let f;
  if (!a && !s)
    f = { from: e, to: n > 0 ? void 0 : e };
  else if (a && !s)
    l(a, e) ? n === 0 ? f = { from: a, to: e } : o ? f = { from: a, to: void 0 } : f = void 0 : u(e, a) ? f = { from: e, to: a } : f = { from: a, to: e };
  else if (a && s)
    if (l(a, e) && l(s, e))
      o ? f = { from: a, to: s } : f = void 0;
    else if (l(a, e))
      f = { from: a, to: n > 0 ? void 0 : e };
    else if (l(s, e))
      f = { from: e, to: n > 0 ? void 0 : e };
    else if (u(e, a))
      f = { from: e, to: s };
    else if (c(e, a))
      f = { from: a, to: e };
    else if (c(e, s))
      f = { from: a, to: e };
    else
      throw new Error("Invalid range");
  if (f?.from && f?.to) {
    const h = i.differenceInCalendarDays(f.to, f.from);
    r > 0 && h > r ? f = { from: e, to: void 0 } : n > 1 && h < n && (f = { from: e, to: void 0 });
  }
  return f;
}
function Kte(e, t, n = _o) {
  const r = Array.isArray(t) ? t : [t];
  let o = e.from;
  const i = n.differenceInCalendarDays(e.to, e.from), a = Math.min(i, 6);
  for (let s = 0; s <= a; s++) {
    if (r.includes(o.getDay()))
      return !0;
    o = n.addDays(o, 1);
  }
  return !1;
}
function Qv(e, t, n = _o) {
  return Vo(e, t.from, !1, n) || Vo(e, t.to, !1, n) || Vo(t, e.from, !1, n) || Vo(t, e.to, !1, n);
}
function Yte(e, t, n = _o) {
  const r = Array.isArray(t) ? t : [t];
  if (r.filter((s) => typeof s != "function").some((s) => typeof s == "boolean" ? s : n.isDate(s) ? Vo(e, s, !1, n) : vI(s, n) ? s.some((l) => Vo(e, l, !1, n)) : ip(s) ? s.from && s.to ? Qv(e, { from: s.from, to: s.to }, n) : !1 : CI(s) ? Kte(e, s.dayOfWeek, n) : pI(s) ? n.isAfter(s.before, s.after) ? Qv(e, {
    from: n.addDays(s.after, 1),
    to: n.addDays(s.before, -1)
  }, n) : Bo(e.from, s, n) || Bo(e.to, s, n) : mI(s) || gI(s) ? Bo(e.from, s, n) || Bo(e.to, s, n) : !1))
    return !0;
  const a = r.filter((s) => typeof s == "function");
  if (a.length) {
    let s = e.from;
    const l = n.differenceInCalendarDays(e.to, e.from);
    for (let c = 0; c <= l; c++) {
      if (a.some((u) => u(s)))
        return !0;
      s = n.addDays(s, 1);
    }
  }
  return !1;
}
function Xte(e, t) {
  const { disabled: n, excludeDisabled: r, selected: o, required: i, onSelect: a } = e, [s, l] = Qu(o, a ? o : void 0), c = a ? o : s;
  return {
    selected: c,
    select: (h, p, C) => {
      const { min: m, max: g } = e, v = h ? Gte(h, c, m, g, i, t) : void 0;
      return r && n && v?.from && v.to && Yte({ from: v.from, to: v.to }, n, t) && (v.from = h, v.to = void 0), a || l(v), a?.(v, h, p, C), v;
    },
    isSelected: (h) => c && Vo(c, h, !1, t)
  };
}
function Qte(e, t) {
  const { selected: n, required: r, onSelect: o } = e, [i, a] = Qu(n, o ? n : void 0), s = o ? n : i, { isSameDay: l } = t;
  return {
    selected: s,
    select: (f, h, p) => {
      let C = f;
      return !r && s && s && l(f, s) && (C = void 0), o || a(C), o?.(C, f, h, p), C;
    },
    isSelected: (f) => s ? l(s, f) : !1
  };
}
function Jte(e, t) {
  const n = Qte(e, t), r = Ute(e, t), o = Xte(e, t);
  switch (e.mode) {
    case "single":
      return n;
    case "multiple":
      return r;
    case "range":
      return o;
    default:
      return;
  }
}
function ene(e) {
  let t = e;
  t.timeZone && (t = {
    ...e
  }, t.today && (t.today = new Pn(t.today, t.timeZone)), t.month && (t.month = new Pn(t.month, t.timeZone)), t.defaultMonth && (t.defaultMonth = new Pn(t.defaultMonth, t.timeZone)), t.startMonth && (t.startMonth = new Pn(t.startMonth, t.timeZone)), t.endMonth && (t.endMonth = new Pn(t.endMonth, t.timeZone)), t.mode === "single" && t.selected ? t.selected = new Pn(t.selected, t.timeZone) : t.mode === "multiple" && t.selected ? t.selected = t.selected?.map((Fe) => new Pn(Fe, t.timeZone)) : t.mode === "range" && t.selected && (t.selected = {
    from: t.selected.from ? new Pn(t.selected.from, t.timeZone) : void 0,
    to: t.selected.to ? new Pn(t.selected.to, t.timeZone) : void 0
  }));
  const { components: n, formatters: r, labels: o, dateLib: i, locale: a, classNames: s } = _e(() => {
    const Fe = { ...Lu, ...t.locale };
    return {
      dateLib: new fr({
        locale: Fe,
        weekStartsOn: t.broadcastCalendar ? 1 : t.weekStartsOn,
        firstWeekContainsDate: t.firstWeekContainsDate,
        useAdditionalWeekYearTokens: t.useAdditionalWeekYearTokens,
        useAdditionalDayOfYearTokens: t.useAdditionalDayOfYearTokens,
        timeZone: t.timeZone,
        numerals: t.numerals
      }, t.dateLib),
      components: ote(t.components),
      formatters: pte(t.formatters),
      labels: { ...Tte, ...t.labels },
      locale: Fe,
      classNames: { ...yI(), ...t.classNames }
    };
  }, [
    t.locale,
    t.broadcastCalendar,
    t.weekStartsOn,
    t.firstWeekContainsDate,
    t.useAdditionalWeekYearTokens,
    t.useAdditionalDayOfYearTokens,
    t.timeZone,
    t.numerals,
    t.dateLib,
    t.components,
    t.formatters,
    t.labels,
    t.classNames
  ]), { captionLayout: l, mode: c, navLayout: u, numberOfMonths: f = 1, onDayBlur: h, onDayClick: p, onDayFocus: C, onDayKeyDown: m, onDayMouseEnter: g, onDayMouseLeave: v, onNextClick: y, onPrevClick: w, showWeekNumber: x, styles: b } = t, { formatCaption: S, formatDay: M, formatMonthDropdown: E, formatWeekNumber: P, formatWeekNumberHeader: T, formatWeekdayName: _, formatYearDropdown: D } = r, N = zte(t, i), { days: R, months: L, navStart: B, navEnd: V, previousMonth: k, nextMonth: z, goToMonth: $ } = N, Z = nte(R, t, B, V, i), { isSelected: W, select: H, selected: G } = Jte(t, i) ?? {}, { blur: Y, focused: ne, isFocusTarget: J, moveFocus: ee, setFocused: U } = qte(t, N, Z, W ?? (() => !1), i), { labelDayButton: X, labelGridcell: ie, labelGrid: j, labelMonthDropdown: te, labelNav: K, labelPrevious: me, labelNext: we, labelWeekday: ye, labelWeekNumber: Ze, labelWeekNumberHeader: Ue, labelYearDropdown: Ke } = o, ft = _e(() => Cte(i, t.ISOWeek), [i, t.ISOWeek]), fe = c !== void 0 || p !== void 0, ge = ct(() => {
    k && ($(k), w?.(k));
  }, [k, $, w]), pe = ct(() => {
    z && ($(z), y?.(z));
  }, [$, z, y]), De = ct((Fe, tt) => (Te) => {
    Te.preventDefault(), Te.stopPropagation(), U(Fe), H?.(Fe.date, tt, Te), p?.(Fe.date, tt, Te);
  }, [H, p, U]), xe = ct((Fe, tt) => (Te) => {
    U(Fe), C?.(Fe.date, tt, Te);
  }, [C, U]), He = ct((Fe, tt) => (Te) => {
    Y(), h?.(Fe.date, tt, Te);
  }, [Y, h]), pn = ct((Fe, tt) => (Te) => {
    const nt = {
      ArrowLeft: [
        Te.shiftKey ? "month" : "day",
        t.dir === "rtl" ? "after" : "before"
      ],
      ArrowRight: [
        Te.shiftKey ? "month" : "day",
        t.dir === "rtl" ? "before" : "after"
      ],
      ArrowDown: [Te.shiftKey ? "year" : "week", "after"],
      ArrowUp: [Te.shiftKey ? "year" : "week", "before"],
      PageUp: [Te.shiftKey ? "year" : "month", "before"],
      PageDown: [Te.shiftKey ? "year" : "month", "after"],
      Home: ["startOfWeek", "before"],
      End: ["endOfWeek", "after"]
    };
    if (nt[Te.key]) {
      Te.preventDefault(), Te.stopPropagation();
      const [on, Qe] = nt[Te.key];
      ee(on, Qe);
    }
    m?.(Fe.date, tt, Te);
  }, [ee, m, t.dir]), Ce = ct((Fe, tt) => (Te) => {
    g?.(Fe.date, tt, Te);
  }, [g]), Le = ct((Fe, tt) => (Te) => {
    v?.(Fe.date, tt, Te);
  }, [v]), wt = ct((Fe) => (tt) => {
    const Te = Number(tt.target.value), nt = i.setMonth(i.startOfMonth(Fe), Te);
    $(nt);
  }, [i, $]), rn = ct((Fe) => (tt) => {
    const Te = Number(tt.target.value), nt = i.setYear(i.startOfMonth(Fe), Te);
    $(nt);
  }, [i, $]), { className: Pr, style: Bn } = _e(() => ({
    className: [s[Me.Root], t.className].filter(Boolean).join(" "),
    style: { ...b?.[Me.Root], ...t.style }
  }), [s, t.className, t.style, b]), Tr = ite(t), Ir = ke(null);
  kte(Ir, !!t.animate, {
    classNames: s,
    months: L,
    focused: ne,
    dateLib: i
  });
  const $n = {
    dayPickerProps: t,
    selected: G,
    select: H,
    isSelected: W,
    months: L,
    nextMonth: z,
    previousMonth: k,
    goToMonth: $,
    getModifiers: Z,
    components: n,
    classNames: s,
    styles: b,
    labels: o,
    formatters: r
  };
  return O.createElement(
    hI.Provider,
    { value: $n },
    O.createElement(
      n.Root,
      { rootRef: t.animate ? Ir : void 0, className: Pr, style: Bn, dir: t.dir, id: t.id, lang: t.lang, nonce: t.nonce, title: t.title, role: t.role, "aria-label": t["aria-label"], "aria-labelledby": t["aria-labelledby"], ...Tr },
      O.createElement(
        n.Months,
        { className: s[Me.Months], style: b?.[Me.Months] },
        !t.hideNavigation && !u && O.createElement(n.Nav, { "data-animated-nav": t.animate ? "true" : void 0, className: s[Me.Nav], style: b?.[Me.Nav], "aria-label": K(), onPreviousClick: ge, onNextClick: pe, previousMonth: k, nextMonth: z }),
        L.map((Fe, tt) => O.createElement(
          n.Month,
          {
            "data-animated-month": t.animate ? "true" : void 0,
            className: s[Me.Month],
            style: b?.[Me.Month],
            // biome-ignore lint/suspicious/noArrayIndexKey: breaks animation
            key: tt,
            displayIndex: tt,
            calendarMonth: Fe
          },
          u === "around" && !t.hideNavigation && tt === 0 && O.createElement(
            n.PreviousMonthButton,
            { type: "button", className: s[Me.PreviousMonthButton], tabIndex: k ? void 0 : -1, "aria-disabled": k ? void 0 : !0, "aria-label": me(k), onClick: ge, "data-animated-button": t.animate ? "true" : void 0 },
            O.createElement(n.Chevron, { disabled: k ? void 0 : !0, className: s[Me.Chevron], orientation: t.dir === "rtl" ? "right" : "left" })
          ),
          O.createElement(n.MonthCaption, { "data-animated-caption": t.animate ? "true" : void 0, className: s[Me.MonthCaption], style: b?.[Me.MonthCaption], calendarMonth: Fe, displayIndex: tt }, l?.startsWith("dropdown") ? O.createElement(
            n.DropdownNav,
            { className: s[Me.Dropdowns], style: b?.[Me.Dropdowns] },
            (() => {
              const Te = l === "dropdown" || l === "dropdown-months" ? O.createElement(n.MonthsDropdown, { key: "month", className: s[Me.MonthsDropdown], "aria-label": te(), classNames: s, components: n, disabled: !!t.disableNavigation, onChange: wt(Fe.date), options: mte(Fe.date, B, V, r, i), style: b?.[Me.Dropdown], value: i.getMonth(Fe.date) }) : O.createElement("span", { key: "month" }, E(Fe.date, i)), nt = l === "dropdown" || l === "dropdown-years" ? O.createElement(n.YearsDropdown, { key: "year", className: s[Me.YearsDropdown], "aria-label": Ke(i.options), classNames: s, components: n, disabled: !!t.disableNavigation, onChange: rn(Fe.date), options: vte(B, V, r, i, !!t.reverseYears), style: b?.[Me.Dropdown], value: i.getYear(Fe.date) }) : O.createElement("span", { key: "year" }, D(Fe.date, i));
              return i.getMonthYearOrder() === "year-first" ? [nt, Te] : [Te, nt];
            })(),
            O.createElement("span", { role: "status", "aria-live": "polite", style: {
              border: 0,
              clip: "rect(0 0 0 0)",
              height: "1px",
              margin: "-1px",
              overflow: "hidden",
              padding: 0,
              position: "absolute",
              width: "1px",
              whiteSpace: "nowrap",
              wordWrap: "normal"
            } }, S(Fe.date, i.options, i))
          ) : (
            // biome-ignore lint/a11y/useSemanticElements: breaking change
            O.createElement(n.CaptionLabel, { className: s[Me.CaptionLabel], role: "status", "aria-live": "polite" }, S(Fe.date, i.options, i))
          )),
          u === "around" && !t.hideNavigation && tt === f - 1 && O.createElement(
            n.NextMonthButton,
            { type: "button", className: s[Me.NextMonthButton], tabIndex: z ? void 0 : -1, "aria-disabled": z ? void 0 : !0, "aria-label": we(z), onClick: pe, "data-animated-button": t.animate ? "true" : void 0 },
            O.createElement(n.Chevron, { disabled: z ? void 0 : !0, className: s[Me.Chevron], orientation: t.dir === "rtl" ? "left" : "right" })
          ),
          tt === f - 1 && u === "after" && !t.hideNavigation && O.createElement(n.Nav, { "data-animated-nav": t.animate ? "true" : void 0, className: s[Me.Nav], style: b?.[Me.Nav], "aria-label": K(), onPreviousClick: ge, onNextClick: pe, previousMonth: k, nextMonth: z }),
          O.createElement(
            n.MonthGrid,
            { role: "grid", "aria-multiselectable": c === "multiple" || c === "range", "aria-label": j(Fe.date, i.options, i) || void 0, className: s[Me.MonthGrid], style: b?.[Me.MonthGrid] },
            !t.hideWeekdays && O.createElement(
              n.Weekdays,
              { "data-animated-weekdays": t.animate ? "true" : void 0, className: s[Me.Weekdays], style: b?.[Me.Weekdays] },
              x && O.createElement(n.WeekNumberHeader, { "aria-label": Ue(i.options), className: s[Me.WeekNumberHeader], style: b?.[Me.WeekNumberHeader], scope: "col" }, T()),
              ft.map((Te) => O.createElement(n.Weekday, { "aria-label": ye(Te, i.options, i), className: s[Me.Weekday], key: String(Te), style: b?.[Me.Weekday], scope: "col" }, _(Te, i.options, i)))
            ),
            O.createElement(n.Weeks, { "data-animated-weeks": t.animate ? "true" : void 0, className: s[Me.Weeks], style: b?.[Me.Weeks] }, Fe.weeks.map((Te) => O.createElement(
              n.Week,
              { className: s[Me.Week], key: Te.weekNumber, style: b?.[Me.Week], week: Te },
              x && // biome-ignore lint/a11y/useSemanticElements: react component
              O.createElement(n.WeekNumber, { week: Te, style: b?.[Me.WeekNumber], "aria-label": Ze(Te.weekNumber, {
                locale: a
              }), className: s[Me.WeekNumber], scope: "row", role: "rowheader" }, P(Te.weekNumber, i)),
              Te.days.map((nt) => {
                const { date: on } = nt, Qe = Z(nt);
                if (Qe[Nt.focused] = !Qe.hidden && !!ne?.isEqualTo(nt), Qe[$r.selected] = W?.(on) || Qe.selected, ip(G)) {
                  const { from: Ds, to: Wi } = G;
                  Qe[$r.range_start] = !!(Ds && Wi && i.isSameDay(on, Ds)), Qe[$r.range_end] = !!(Ds && Wi && i.isSameDay(on, Wi)), Qe[$r.range_middle] = Vo(G, on, !0, i);
                }
                const B0 = gte(Qe, b, t.modifiersStyles), Gt = rte(Qe, s, t.modifiersClassNames), o1 = !fe && !Qe.hidden ? ie(on, Qe, i.options, i) : void 0;
                return (
                  // biome-ignore lint/a11y/useSemanticElements: react component
                  O.createElement(n.Day, { key: `${i.format(on, "yyyy-MM-dd")}_${i.format(nt.displayMonth, "yyyy-MM")}`, day: nt, modifiers: Qe, className: Gt.join(" "), style: B0, role: "gridcell", "aria-selected": Qe.selected || void 0, "aria-label": o1, "data-day": i.format(on, "yyyy-MM-dd"), "data-month": nt.outside ? i.format(on, "yyyy-MM") : void 0, "data-selected": Qe.selected || void 0, "data-disabled": Qe.disabled || void 0, "data-hidden": Qe.hidden || void 0, "data-outside": nt.outside || void 0, "data-focused": Qe.focused || void 0, "data-today": Qe.today || void 0 }, !Qe.hidden && fe ? O.createElement(n.DayButton, { className: s[Me.DayButton], style: b?.[Me.DayButton], type: "button", day: nt, modifiers: Qe, disabled: Qe.disabled || void 0, tabIndex: J(nt) ? 0 : -1, "aria-label": X(on, Qe, i.options, i), onClick: De(nt, Qe), onBlur: He(nt, Qe), onFocus: xe(nt, Qe), onKeyDown: pn(nt, Qe), onMouseEnter: Ce(nt, Qe), onMouseLeave: Le(nt, Qe) }, M(on, i.options, i)) : !Qe.hidden && M(nt.date, i.options, i))
                );
              })
            )))
          )
        ))
      ),
      t.footer && // biome-ignore lint/a11y/useSemanticElements: react component
      O.createElement(n.Footer, { className: s[Me.Footer], style: b?.[Me.Footer], role: "status", "aria-live": "polite" }, t.footer)
    )
  );
}
const tne = {
  lessThanXSeconds: {
    one: "mindre enn ett sekund",
    other: "mindre enn {{count}} sekunder"
  },
  xSeconds: {
    one: "ett sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "et halvt minutt",
  lessThanXMinutes: {
    one: "mindre enn ett minutt",
    other: "mindre enn {{count}} minutter"
  },
  xMinutes: {
    one: "ett minutt",
    other: "{{count}} minutter"
  },
  aboutXHours: {
    one: "omtrent en time",
    other: "omtrent {{count}} timer"
  },
  xHours: {
    one: "en time",
    other: "{{count}} timer"
  },
  xDays: {
    one: "en dag",
    other: "{{count}} dager"
  },
  aboutXWeeks: {
    one: "omtrent en uke",
    other: "omtrent {{count}} uker"
  },
  xWeeks: {
    one: "en uke",
    other: "{{count}} uker"
  },
  aboutXMonths: {
    one: "omtrent en måned",
    other: "omtrent {{count}} måneder"
  },
  xMonths: {
    one: "en måned",
    other: "{{count}} måneder"
  },
  aboutXYears: {
    one: "omtrent ett år",
    other: "omtrent {{count}} år"
  },
  xYears: {
    one: "ett år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "over ett år",
    other: "over {{count}} år"
  },
  almostXYears: {
    one: "nesten ett år",
    other: "nesten {{count}} år"
  }
}, nne = (e, t, n) => {
  let r;
  const o = tne[e];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", String(t)), n?.addSuffix ? n.comparison && n.comparison > 0 ? "om " + r : r + " siden" : r;
}, rne = {
  full: "EEEE d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd.MM.y"
}, one = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, ine = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, ane = {
  date: xa({
    formats: rne,
    defaultWidth: "full"
  }),
  time: xa({
    formats: one,
    defaultWidth: "full"
  }),
  dateTime: xa({
    formats: ine,
    defaultWidth: "full"
  })
}, sne = {
  lastWeek: "'forrige' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgen kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P"
}, lne = (e, t, n, r) => sne[e], cne = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["før Kristus", "etter Kristus"]
}, une = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, fne = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mars",
    "apr.",
    "mai",
    "juni",
    "juli",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "des."
  ],
  wide: [
    "januar",
    "februar",
    "mars",
    "april",
    "mai",
    "juni",
    "juli",
    "august",
    "september",
    "oktober",
    "november",
    "desember"
  ]
}, dne = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sø", "ma", "ti", "on", "to", "fr", "lø"],
  abbreviated: ["søn", "man", "tir", "ons", "tor", "fre", "lør"],
  wide: [
    "søndag",
    "mandag",
    "tirsdag",
    "onsdag",
    "torsdag",
    "fredag",
    "lørdag"
  ]
}, hne = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på etterm.",
    evening: "på kvelden",
    night: "på natten"
  },
  abbreviated: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på etterm.",
    evening: "på kvelden",
    night: "på natten"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morgenen",
    afternoon: "på ettermiddagen",
    evening: "på kvelden",
    night: "på natten"
  }
}, pne = (e, t) => Number(e) + ".", mne = {
  ordinalNumber: pne,
  era: ro({
    values: cne,
    defaultWidth: "wide"
  }),
  quarter: ro({
    values: une,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: ro({
    values: fne,
    defaultWidth: "wide"
  }),
  day: ro({
    values: dne,
    defaultWidth: "wide"
  }),
  dayPeriod: ro({
    values: hne,
    defaultWidth: "wide"
  })
}, gne = /^(\d+)\.?/i, Cne = /\d+/i, vne = {
  narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
}, yne = {
  any: [/^f/i, /^e/i]
}, bne = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? kvartal/i
}, wne = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, xne = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
  wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
}, Sne = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^aug/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Mne = {
  narrow: /^[smtofl]/i,
  short: /^(sø|ma|ti|on|to|fr|lø)/i,
  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
}, Ene = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, _ne = {
  narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
  any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
}, One = {
  any: {
    am: /^a(\.?\s?m\.?)?$/i,
    pm: /^p(\.?\s?m\.?)?$/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgen/i,
    afternoon: /ettermiddag/i,
    evening: /kveld/i,
    night: /natt/i
  }
}, Ane = {
  ordinalNumber: PO({
    matchPattern: gne,
    parsePattern: Cne,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: oo({
    matchPatterns: vne,
    defaultMatchWidth: "wide",
    parsePatterns: yne,
    defaultParseWidth: "any"
  }),
  quarter: oo({
    matchPatterns: bne,
    defaultMatchWidth: "wide",
    parsePatterns: wne,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: oo({
    matchPatterns: xne,
    defaultMatchWidth: "wide",
    parsePatterns: Sne,
    defaultParseWidth: "any"
  }),
  day: oo({
    matchPatterns: Mne,
    defaultMatchWidth: "wide",
    parsePatterns: Ene,
    defaultParseWidth: "any"
  }),
  dayPeriod: oo({
    matchPatterns: _ne,
    defaultMatchWidth: "any",
    parsePatterns: One,
    defaultParseWidth: "any"
  })
}, Pne = {
  code: "nb",
  formatDistance: nne,
  formatLong: ane,
  formatRelative: lne,
  localize: mne,
  match: Ane,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Tne = () => {
  const e = Oe(op);
  if (!e)
    throw new Error(
      "useDatepickerContext must be used within a DatepickerProvider"
    );
  return e;
}, Jv = () => {
  const {
    mode: e,
    captionLayout: t,
    required: n,
    alwaysOpen: r,
    displayMonth: o,
    defaultMonth: i,
    selection: a,
    fromDate: s,
    toDate: l,
    handleSelect: c,
    setDisplayMonth: u
  } = Tne(), f = yI(), h = _e(
    () => ({
      today: I(
        f.today,
        "rounded-full !bg-surface-common-light !text-text-primary outline-none ring-0"
      ),
      selected: I(
        f.selected,
        "!bg-surface-common-primary p-0 text-white"
      ),
      day: I(
        f.day,
        "!h-[16px] !w-[16px] rounded-full text-center outline-none ring-0"
      ),
      root: I(
        f.root,
        "gap-2 rounded-md bg-white p-sm shadow-card",
        r && "rounded-sm border border-neutral-200 shadow-none"
      ),
      chevron: I(f.chevron, "!fill-surface-common-primary"),
      focused: I(
        f.focused,
        "!bg-surface-common-primary-light"
      ),
      month_grid: I(f.month_grid, "gap-md"),
      month_caption: I(
        f.month_caption,
        "!text-heading-small font-semibold capitalize text-text-primary"
      ),
      disabled: I(f.disabled, "text-neutral-400"),
      dropdown: I(
        f.dropdown,
        "absolute flex !fill-surface-common-primary"
      ),
      day_button: I(
        f.day_button,
        "rounded-full !border-none outline-none ring-0 focus-visible:!rounded-full focus-visible:!bg-surface-common-primary-light"
      ),
      caption_label: I(
        f.caption_label,
        "gap-xs !text-heading-small"
      ),
      range_start: I(
        f.selected,
        "!bg-surface-common-primary p-0 text-white focus-visible:!bg-surface-common-primary"
      ),
      range_middle: I(
        f.range_middle,
        "!rounded-full !border-none !bg-surface-common-primary-lighter p-0 !text-text-primary !text-white ring-0",
        "focus-visible:!rounded-full focus-visible:!bg-surface-common-primary-lighter focus-visible:!shadow-none focus-visible:!outline-none"
      ),
      range_end: I(
        f.selected,
        "!bg-surface-common-primary p-0 text-white focus-visible:!bg-surface-common-primary"
      )
    }),
    [f, r]
  );
  return /* @__PURE__ */ d(
    ene,
    {
      "aria-label": "Datovelger",
      className: "snorrev2-rdp",
      defaultMonth: i,
      selected: a,
      classNames: h,
      mode: e,
      required: n,
      startMonth: s,
      endMonth: l,
      month: o,
      locale: Pne,
      captionLayout: t,
      disabled: [{ before: s }, { after: l }],
      onSelect: c,
      onMonthChange: u,
      onDayClick: (C, m, g) => {
        g.detail > 0 && g.target.blur();
      }
    }
  );
}, ey = "dd.MM.yyyy", Qpe = ({
  name: e,
  value: t,
  toValue: n,
  label: r,
  max: o,
  min: i,
  disabled: a,
  disabledTitle: s,
  mode: l = "single",
  captionLayout: c = "label",
  required: u,
  error: f,
  alwaysOpen: h = !1,
  onChange: p,
  onDayChange: C,
  onRangeChange: m,
  className: g,
  placeholder: v = l === "range" ? "dd.mm.åååå - dd.mm.åååå" : "dd.mm.åååå",
  onBlur: y,
  ...w
}) => {
  const x = (/* @__PURE__ */ new Date()).getFullYear(), b = ke(null), S = ke(null), M = ke(null), E = o ? new Date(o) : new Date(x, 11, 31), P = i ? new Date(i) : new Date(x - 150, 0), T = R1(), [_, D] = ue(t || void 0), [N, R] = ue(t || void 0), [L, B] = ue(t || void 0), [V, k] = ue(t && n ? { from: t, to: n } : void 0), [z, $] = ue([]), [Z, W] = ue(
    l3(t, n)
  ), [H, G] = ue(!1), Y = Ri({
    open: H,
    onOpenChange: G,
    middleware: [
      R_({ mainAxis: 5, crossAxis: 5 }),
      k_({
        allowedPlacements: ["bottom-start", "bottom-end", "top-start"]
      })
    ],
    whileElementsMounted: D1
  }), ne = Di(Y.context, {
    escapeKey: !1
  }), J = Li(Y.context), { getReferenceProps: ee, getFloatingProps: U } = ki([
    ne,
    J
  ]);
  R2(H), ve(() => {
    const Ce = (Le) => {
      const wt = Y?.refs.floating.current;
      if (!wt) return;
      const rn = S.current;
      wt.contains(Le.target) || rn && rn.contains(Le.target) || te();
    };
    return H ? document.addEventListener("mousedown", Ce) : document.removeEventListener("mousedown", Ce), () => {
      document.removeEventListener("mousedown", Ce);
    };
  }, [H, Y?.refs.floating]), ve(() => {
    const Ce = (Le) => {
      H && (Le.key === "Escape" || Le.key === "Esc") && (Le.preventDefault(), Le.stopPropagation(), te());
    };
    return document.addEventListener("keydown", Ce, { capture: !0 }), () => document.removeEventListener("keydown", Ce, {
      capture: !0
    });
  }, [H]);
  const X = _e(() => l === "range" ? V : l === "multiple" ? z : L, [l, V, z, L]);
  ve(() => {
    const Ce = l3(t, n);
    Z !== Ce && Ke(Ce);
  }, [t, n]);
  const ie = (Ce) => {
    if (!Ce && Z || (!Ce?.from || !Ce?.to) && Z) return p?.(void 0);
    R(Ce?.from), p?.(Ce), m?.(Ce);
  }, j = (Ce) => {
    if (!Ce && Z) return p?.(void 0);
    Ce?.setHours(11, 0), R(Ce), p?.(Ce), C?.(Ce);
  }, te = () => {
    D(void 0), G(!1);
  }, K = (Ce) => {
    a || ie(Ce);
  }, me = (Ce) => {
    if (!a) {
      if (!Ce) {
        j();
        return;
      }
      if (!we(Ce)) {
        j();
        return;
      }
      j(Ce);
    }
  }, we = (Ce) => {
    const Le = typeof Ce == "string" ? Tl(Ce) : Ce;
    return Xd(Le) && HZ(Le, P, E);
  }, ye = (Ce) => {
    const Le = qv(Ce);
    Le && we(Le) ? (B(Le), D(Le)) : B(void 0), me(Le);
  }, Ze = (Ce) => {
    const Le = Wv(Ce);
    Le ? (k(Le), D(Le?.from)) : k(void 0), K(Le);
  }, Ue = (Ce) => {
    const Le = vee(Ce);
    throw $(Le), new Error("Multiple is not completed");
  }, Ke = (Ce) => {
    switch (W(Ce), l) {
      case "range":
        Ze(Ce);
        break;
      case "multiple":
        Ue(Ce);
        break;
      default:
        ye(Ce);
    }
  }, ft = (Ce) => {
    W(Sa(Ce, ey)), B(Ce), me(Ce), te();
  }, fe = (Ce) => {
    const Le = yee(Ce), wt = l3(Le.from, Le.to);
    W(wt), k(Le), K(Le);
  }, ge = () => {
    if (!(!Z && !N)) {
      if (l === "single") {
        const Ce = qv(Z);
        me(Ce);
      }
      if (l === "range") {
        const Ce = Wv(Z);
        K(Ce);
      }
      if (l === "multiple")
        throw new Error("Multiple is not completed");
      y?.();
    }
  }, pe = (Ce) => {
    const Le = Ce.map((rn) => Sa(rn, ey)), wt = 3;
    throw W(Le.join(", ")), Le?.length > wt && W(
      `${Le.slice(0, wt)} + ${Le.length - wt}`
    ), $(Ce), new Error("Multiple is not completed");
  }, De = (Ce) => {
    switch (l) {
      case "range":
        fe(Ce);
        break;
      case "multiple":
        pe(Ce);
        break;
      default:
        ft(Ce);
    }
  }, xe = (Ce) => {
    Ce.key === "ArrowDown" && G(!0);
  }, He = I(
    "flex h-[10px] w-full min-w-13 items-center gap-sm rounded-md p-md ring-offset-0 transition-all",
    "hover:border-neutral-400",
    "focus-:border-surface-common-primary outline-none focus-visible:ring-[3px] focus-visible:ring-surface-common-primary-light",
    H && "border-surface-common-primary outline-none ring-[3px] ring-surface-common-primary-light",
    "active:border-surface-common-primary active:ring-surface-common-primary-light",
    `border border-border-input ${f && "border-ui-errorDark"}`,
    a && "bg-neutral-100 text-neutral-500 hover:border-border-input active:border-border-input",
    f && I("pl-6"),
    "placeholder:text-sm"
  ), pn = _e(
    () => ({
      mode: l,
      captionLayout: c,
      required: u,
      alwaysOpen: h,
      displayMonth: _,
      defaultMonth: N,
      selection: X,
      fromDate: P,
      toDate: E,
      handleSelect: De,
      setDisplayMonth: D
    }),
    [
      l,
      c,
      u,
      h,
      _,
      N,
      X,
      P,
      E,
      De
    ]
  );
  return /* @__PURE__ */ F(
    "div",
    {
      title: a ? s : void 0,
      "aria-disabled": a,
      className: I("flex flex-col gap-xs", g),
      children: [
        r && /* @__PURE__ */ F(Ut, { weight: "semibold", children: [
          r,
          (u || f) && /* @__PURE__ */ d(
            "span",
            {
              "aria-label": "required field",
              className: "ml-[2px] text-ui-errorDark",
              children: "*"
            }
          )
        ] }),
        /* @__PURE__ */ F("div", { className: "flex flex-col items-start", ref: b, children: [
          h ? /* @__PURE__ */ d(of, { value: pn, children: /* @__PURE__ */ d(Jv, {}) }) : /* @__PURE__ */ F(
            "div",
            {
              className: "relative flex w-full",
              ref: Y.refs.setReference,
              ...ee(),
              children: [
                f && /* @__PURE__ */ d(ih, { className: "absolute left-md flex justify-center self-center text-ui-errorDark" }),
                /* @__PURE__ */ d(
                  "input",
                  {
                    ref: M,
                    placeholder: v,
                    value: Z,
                    className: He,
                    name: e,
                    onChange: (Ce) => Ke(Ce.target.value),
                    disabled: a,
                    readOnly: T,
                    onBlur: ge,
                    onKeyDown: xe,
                    "aria-invalid": !!f,
                    "aria-describedby": f ? "error-desc" : void 0,
                    "aria-label": r || "Felt for å velge dato",
                    "aria-busy": H,
                    ...w
                  }
                ),
                /* @__PURE__ */ d(
                  "button",
                  {
                    ref: S,
                    type: "button",
                    "aria-label": "Åpne datovelger",
                    className: "absolute right-md flex justify-center self-center border-0 bg-transparent p-0 text-surface-common-primary",
                    disabled: a,
                    onClick: () => {
                      G(!H);
                    },
                    children: /* @__PURE__ */ d(hL, {})
                  }
                )
              ]
            }
          ),
          f && /* @__PURE__ */ d("div", { className: "mt-xs flex items-center justify-center gap-xs", children: /* @__PURE__ */ d(Eo, { id: "error-desc", className: "text-ui-errorDark", children: f }) })
        ] }),
        H && /* @__PURE__ */ d(ms, { context: Y.context, modal: !0, children: /* @__PURE__ */ d(
          "div",
          {
            tabIndex: -1,
            className: "z-[1000] mb-sm mt-sm",
            style: Y.floatingStyles,
            ref: Y.refs.setFloating,
            role: "dialog",
            "aria-modal": "true",
            "aria-label": "Datovelger dialog",
            ...U(),
            children: /* @__PURE__ */ d(of, { value: pn, children: /* @__PURE__ */ d(Jv, {}) })
          }
        ) })
      ]
    }
  );
}, Ine = Xe(
  ({
    label: e,
    border: t = !0,
    required: n = !1,
    htmlFor: r,
    hint: o,
    invalid: i,
    errorMessage: a,
    className: s,
    loading: l,
    disabled: c,
    onChange: u,
    onClick: f,
    wordCount: h = !0,
    defaultValue: p,
    value: C,
    ...m
  }, g) => {
    const v = bt(), y = r || v, [w, x] = ue(
      p?.length || C?.length || 0
    ), b = m?.maxLength, S = h && b, M = l || c, E = {
      asterix: I("text-ui-errorDark"),
      border: I("border-ui-errorDark"),
      message: I("text-ui-errorDark")
    }, P = I(
      "flex h-[99px] min-h-[50px] w-full min-w-13 items-center gap-sm rounded-md px-md py-[12px] ring-offset-0 transition-all",
      "hover:border-neutral-400",
      "outline-none focus-visible:border-surface-common-primary focus-visible:ring-[3px] focus-visible:ring-surface-common-primary-light",
      "active:border-surface-common-primary active:ring-surface-common-primary-light",
      !t && "hover:outline hover:outline-border-input",
      t && I(`border border-border-input ${i && E.border}`)
    ), T = I("flex flex-col gap-xs"), _ = I("inline-block"), D = I(P, s), N = (z) => {
      const W = z.target.value.length;
      x(W), u?.(z);
    }, R = () => l ? /* @__PURE__ */ d("div", { className: "absolute right-md flex items-center text-surface-common-primary", children: /* @__PURE__ */ F(
      "svg",
      {
        className: "animate-spin text-neutral-200",
        viewBox: "0 0 64 64",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        children: [
          /* @__PURE__ */ d(
            "path",
            {
              d: "M32 3C35.8083 3 39.5794 3.75011 43.0978 5.20749C46.6163 6.66488 49.8132 8.80101 52.5061 11.4939C55.199 14.1868 57.3351 17.3837 58.7925 20.9022C60.2499 24.4206 61 28.1917 61 32C61 35.8083 60.2499 39.5794 58.7925 43.0978C57.3351 46.6163 55.199 49.8132 52.5061 52.5061C49.8132 55.199 46.6163 57.3351 43.0978 58.7925C39.5794 60.2499 35.8083 61 32 61C28.1917 61 24.4206 60.2499 20.9022 58.7925C17.3837 57.3351 14.1868 55.199 11.4939 52.5061C8.801 49.8132 6.66487 46.6163 5.20749 43.0978C3.7501 39.5794 3 35.8083 3 32C3 28.1917 3.75011 24.4206 5.2075 20.9022C6.66489 17.3837 8.80101 14.1868 11.4939 11.4939C14.1868 8.80099 17.3838 6.66487 20.9022 5.20749C24.4206 3.7501 28.1917 3 32 3L32 3Z",
              stroke: "currentColor",
              "stroke-width": "5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }
          ),
          /* @__PURE__ */ d(
            "path",
            {
              d: "M32 3C36.5778 3 41.0906 4.08374 45.1692 6.16256C49.2477 8.24138 52.7762 11.2562 55.466 14.9605C58.1558 18.6647 59.9304 22.9531 60.6448 27.4748C61.3591 31.9965 60.9928 36.6232 59.5759 40.9762",
              stroke: "currentColor",
              "stroke-width": "5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              className: "text-surface-common-primary"
            }
          )
        ]
      }
    ) }) : null, L = () => o && !a && /* @__PURE__ */ d(Go, { className: I("mt-xs", c && "text-neutral-400"), children: o }), B = () => a && /* @__PURE__ */ d(Eo, { className: E.message, children: a }), V = () => /* @__PURE__ */ F(ut, { children: [
      /* @__PURE__ */ d(L, {}),
      /* @__PURE__ */ d(B, {})
    ] }), k = () => /* @__PURE__ */ F(Go, { className: I("mt-xs", c && "text-neutral-400"), children: [
      w,
      " / ",
      b
    ] });
    return /* @__PURE__ */ F("div", { className: T, children: [
      !!e && /* @__PURE__ */ d("div", { className: "flex flex-col", children: /* @__PURE__ */ F(
        Ut,
        {
          weight: "semibold",
          className: _,
          htmlFor: y,
          children: [
            e,
            (n || i) && /* @__PURE__ */ d(
              "span",
              {
                "aria-label": "required field",
                className: I("ml-[2px] text-ui-errorDark"),
                children: "*"
              }
            )
          ]
        }
      ) }),
      /* @__PURE__ */ F("div", { className: "relative z-0 flex items-center", children: [
        /* @__PURE__ */ d(
          "textarea",
          {
            id: y,
            className: D,
            ref: g,
            "aria-invalid": i || void 0,
            "aria-describedby": o || a ? `${v}-description` : void 0,
            "aria-readonly": m.readOnly || void 0,
            "aria-required": n || void 0,
            onChange: (z) => m.readOnly || N(z),
            onClick: (z) => {
              m.readOnly && z.preventDefault(), f?.(z);
            },
            disabled: M,
            defaultValue: p,
            value: C,
            ...m
          }
        ),
        /* @__PURE__ */ d(R, {})
      ] }),
      /* @__PURE__ */ F("div", { className: "flex justify-between", children: [
        /* @__PURE__ */ d(V, {}),
        S && /* @__PURE__ */ d(k, {})
      ] })
    ] });
  }
), EI = ({ flag: e }) => /* @__PURE__ */ d("div", { className: "noto-color-emoji-regular", role: "img", children: e }), _I = ({ flag: e }) => /* @__PURE__ */ d("div", { role: "img", children: e }), Jpe = ({
  label: e = "Land",
  countryCode: t,
  showCountryName: n = !0,
  showLabel: r = !1,
  className: o = ""
}) => {
  const i = bt(), a = uP(), s = I("", e && "flex flex-col", o);
  if (t === "")
    return null;
  const l = ph[t];
  return l ? /* @__PURE__ */ F("div", { className: s, children: [
    r && /* @__PURE__ */ d(Ut, { htmlFor: i, weight: "semibold", children: e }),
    /* @__PURE__ */ F("div", { className: "flex items-baseline gap-xs", children: [
      a ? /* @__PURE__ */ d(EI, { flag: l.flag }) : /* @__PURE__ */ d(_I, { flag: l.flag }),
      n && l.name
    ] })
  ] }) : (console.error(
    `Country code "${t}" not found in supported contryCodesMap`
  ), null);
}, Dne = ({
  /**
   * Label for the select component
   */
  label: e = "Land",
  /**
   * Size of the select component
   */
  size: t = "small",
  /**
   * Placeholder for the select component
   */
  placeholder: n = "Land",
  /**
   * Whether the select component is clearable
   */
  clearable: r = !0,
  /**
   * Whether the select component has a border
   */
  borderless: o = !1,
  /**
   * Whether to show the dial code in the select component
   */
  showDialCode: i = !0,
  error: a = "",
  /**
   * Callback function to handle the change of the select component.
   * If not provided, the select component will emit the selected country code.
   */
  onChange: s,
  ...l
}) => {
  const c = _e(
    () => Dl.sort((p, C) => p.name.localeCompare(C.name)),
    []
  ), u = uP(), f = (p) => {
    if (p === "" && s?.({
      name: "",
      flag: "",
      alpha3: "",
      code: "",
      dial_code: ""
    }), !p) return;
    const C = c.find((m) => m.code === p);
    if (!C) throw new Error("Country code not found");
    s?.(C);
  }, h = () => /* @__PURE__ */ d(ut, { children: c.map((p) => /* @__PURE__ */ d(
    xn.Item,
    {
      value: p.code,
      textValue: p.name.toLowerCase(),
      children: /* @__PURE__ */ F("div", { className: "flex items-center gap-xs", children: [
        /* @__PURE__ */ F("span", { className: "flex items-baseline gap-xs", children: [
          u ? /* @__PURE__ */ d(EI, { flag: p.flag }) : /* @__PURE__ */ d(_I, { flag: p.flag }),
          p.name
        ] }),
        i && ` (${p.dial_code})`
      ] })
    },
    p.alpha3
  )) });
  return /* @__PURE__ */ d("div", { className: "group flex items-center", children: /* @__PURE__ */ d(
    xn,
    {
      label: e,
      size: t,
      placeholder: n,
      clearable: r,
      borderless: o,
      onValueChange: f,
      error: r && a ? a : void 0,
      ...l,
      children: /* @__PURE__ */ d(xn.Content, { className: "mt-xs max-h-[24rem]", position: "popper", children: /* @__PURE__ */ d(h, {}) })
    }
  ) });
}, Rne = O.forwardRef(
  ({
    onChange: e,
    onBlur: t,
    readOnly: n,
    disabled: r,
    disabledPostalCode: o,
    disabledPostalCity: i = !0,
    required: a,
    label: s = "Postnummer og poststed",
    invalid: l,
    errorMessage: c,
    hint: u,
    postalCode: f,
    postalCity: h,
    defaultPostalCode: p = "",
    defaultPostalCity: C = "",
    clearableCountryPicker: m = !1,
    defaultCountryCode: g = m ? "" : fc.code,
    countryCode: v,
    countryPicker: y = !1,
    size: w = "small",
    postalCodeOptions: x = { placeholder: "Postnummer" },
    postalCityOptions: b = { placeholder: "Poststed" }
  }, S) => {
    const M = bt(), [E, P] = ue(p), [T, _] = ue(C), [D, N] = ue(g), R = f ?? E, L = h ?? T, B = v ?? D, V = y ? B == fc.code ? 4 : 10 : 4, k = g ? Dl.find((X) => X.code === g.toUpperCase())?.code : "", z = Dl.find(
      (X) => X.code === B?.toUpperCase()
    )?.code, $ = y && B !== fc.code, Z = (X) => {
      const ie = {
        postalCode: X.postalCode ?? R,
        postalCity: X.postalCity ?? L,
        countryCode: X.countryCode ?? B
      };
      e?.(ie);
    }, W = (X) => {
      let ie = X.target.value;
      (!y || B === fc.code) && (ie = X.target.value.replace(/[^0-9]/g, ""), ie = ie.slice(0, 4)), f || P(ie), Z({ postalCode: ie });
    }, H = (X) => {
      const ie = X.target.value;
      h || _(ie), Z({ postalCity: ie });
    }, G = (X) => {
      X && (v || (N(X.code), P(""), _("")), Z({ countryCode: X.code }));
    }, Y = () => u && !c && /* @__PURE__ */ d(Go, { className: I(r && "text-neutral-400"), children: u }), ne = () => c && l && /* @__PURE__ */ d(Eo, { className: "text-ui-errorDark", children: c }), J = () => /* @__PURE__ */ F(ut, { children: [
      /* @__PURE__ */ d(Y, {}),
      /* @__PURE__ */ d(ne, {})
    ] }), ee = I(
      "col-span-2 inline-block w-full sm:flex-none sm:basis-1/4",
      x?.wrapperClassName
    ), U = I(
      "col-span-4 inline-block w-full sm:min-w-[200px] sm:flex-1 sm:basis-1/2",
      b?.wrapperClassName
    );
    return /* @__PURE__ */ F(ut, { children: [
      y && /* @__PURE__ */ d("div", { className: "mb-1", children: /* @__PURE__ */ d(
        Dne,
        {
          size: w,
          clearable: m,
          defaultValue: k,
          value: z,
          placeholder: "-",
          showDialCode: !1,
          topLabel: !0,
          error: l ? " " : void 0,
          onChange: G
        }
      ) }),
      /* @__PURE__ */ F("div", { className: "flex flex-col gap-xs", ref: S, children: [
        s && /* @__PURE__ */ F(Ut, { weight: "semibold", htmlFor: `${M}-postal-code`, children: [
          s,
          (a || l) && /* @__PURE__ */ d(
            "span",
            {
              "aria-label": "required field",
              className: I("ml-[2px] text-ui-errorDark"),
              children: "*"
            }
          )
        ] }),
        /* @__PURE__ */ F(
          "div",
          {
            className: "grid grid-cols-4 gap-xs sm:flex sm:flex-wrap",
            role: "group",
            "aria-labelledby": s ? `${M}-postal-code` : void 0,
            children: [
              /* @__PURE__ */ d(
                A1,
                {
                  id: `${M}-postal-code`,
                  label: x?.label,
                  onChange: W,
                  required: a,
                  disabled: r || o,
                  readOnly: n,
                  invalid: l,
                  placeholder: x?.placeholder,
                  "aria-label": "Postnummer",
                  wrapperClassName: ee,
                  value: R,
                  inputMode: $ ? "text" : "numeric",
                  pattern: $ ? void 0 : "[0-9]*",
                  maxLength: V,
                  onBlur: t
                }
              ),
              /* @__PURE__ */ d(
                A1,
                {
                  id: `${M}-postal-city`,
                  label: b?.label,
                  onChange: H,
                  required: a,
                  disabled: r || i,
                  readOnly: n,
                  invalid: l,
                  placeholder: b?.placeholder,
                  "aria-label": "Poststed",
                  wrapperClassName: U,
                  value: L,
                  onBlur: t
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ d(J, {})
      ] })
    ] });
  }
);
Rne.displayName = "PostalInput";
const Fi = gt(
  void 0
), OI = gt({
  activeIndex: 0
}), kne = (e, t) => {
  switch (t.type) {
    case "SET_ACTIVE_INDEX":
      return {
        ...e,
        activeIndex: t.payload
      };
    default:
      return e;
  }
}, AI = gt(() => {
  throw new Error("ComboboxIdDispatch must be used within a provider");
}), Lne = ({ children: e }) => {
  const [t, n] = gL(kne, {
    activeIndex: 0
  });
  return /* @__PURE__ */ d(OI.Provider, { value: t, children: /* @__PURE__ */ d(AI.Provider, { value: n, children: e }) });
};
function ap() {
  return Oe(AI);
}
function sp() {
  return Oe(OI);
}
function ea(e, t, n) {
  let r = n.initialDeps ?? [], o;
  function i() {
    var a, s, l, c;
    let u;
    n.key && ((a = n.debug) != null && a.call(n)) && (u = Date.now());
    const f = e();
    if (!(f.length !== r.length || f.some((C, m) => r[m] !== C)))
      return o;
    r = f;
    let p;
    if (n.key && ((s = n.debug) != null && s.call(n)) && (p = Date.now()), o = t(...f), n.key && ((l = n.debug) != null && l.call(n))) {
      const C = Math.round((Date.now() - u) * 100) / 100, m = Math.round((Date.now() - p) * 100) / 100, g = m / 16, v = (y, w) => {
        for (y = String(y); y.length < w; )
          y = " " + y;
        return y;
      };
      console.info(
        `%c⏱ ${v(m, 5)} /${v(C, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * g, 120)
        )}deg 100% 31%);`,
        n?.key
      );
    }
    return (c = n?.onChange) == null || c.call(n, o), o;
  }
  return i.updateDeps = (a) => {
    r = a;
  }, i;
}
function ty(e, t) {
  if (e === void 0)
    throw new Error("Unexpected undefined");
  return e;
}
const Nne = (e, t) => Math.abs(e - t) < 1.01, Fne = (e, t, n) => {
  let r;
  return function(...o) {
    e.clearTimeout(r), r = e.setTimeout(() => t.apply(this, o), n);
  };
}, ny = (e) => {
  const { offsetWidth: t, offsetHeight: n } = e;
  return { width: t, height: n };
}, Vne = (e) => e, Bne = (e) => {
  const t = Math.max(e.startIndex - e.overscan, 0), n = Math.min(e.endIndex + e.overscan, e.count - 1), r = [];
  for (let o = t; o <= n; o++)
    r.push(o);
  return r;
}, $ne = (e, t) => {
  const n = e.scrollElement;
  if (!n)
    return;
  const r = e.targetWindow;
  if (!r)
    return;
  const o = (a) => {
    const { width: s, height: l } = a;
    t({ width: Math.round(s), height: Math.round(l) });
  };
  if (o(ny(n)), !r.ResizeObserver)
    return () => {
    };
  const i = new r.ResizeObserver((a) => {
    const s = () => {
      const l = a[0];
      if (l?.borderBoxSize) {
        const c = l.borderBoxSize[0];
        if (c) {
          o({ width: c.inlineSize, height: c.blockSize });
          return;
        }
      }
      o(ny(n));
    };
    e.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(s) : s();
  });
  return i.observe(n, { box: "border-box" }), () => {
    i.unobserve(n);
  };
}, ry = {
  passive: !0
}, oy = typeof window > "u" ? !0 : "onscrollend" in window, jne = (e, t) => {
  const n = e.scrollElement;
  if (!n)
    return;
  const r = e.targetWindow;
  if (!r)
    return;
  let o = 0;
  const i = e.options.useScrollendEvent && oy ? () => {
  } : Fne(
    r,
    () => {
      t(o, !1);
    },
    e.options.isScrollingResetDelay
  ), a = (u) => () => {
    const { horizontal: f, isRtl: h } = e.options;
    o = f ? n.scrollLeft * (h && -1 || 1) : n.scrollTop, i(), t(o, u);
  }, s = a(!0), l = a(!1);
  l(), n.addEventListener("scroll", s, ry);
  const c = e.options.useScrollendEvent && oy;
  return c && n.addEventListener("scrollend", l, ry), () => {
    n.removeEventListener("scroll", s), c && n.removeEventListener("scrollend", l);
  };
}, Hne = (e, t, n) => {
  if (t?.borderBoxSize) {
    const r = t.borderBoxSize[0];
    if (r)
      return Math.round(
        r[n.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return e[n.options.horizontal ? "offsetWidth" : "offsetHeight"];
}, zne = (e, {
  adjustments: t = 0,
  behavior: n
}, r) => {
  var o, i;
  const a = e + t;
  (i = (o = r.scrollElement) == null ? void 0 : o.scrollTo) == null || i.call(o, {
    [r.options.horizontal ? "left" : "top"]: a,
    behavior: n
  });
};
class Zne {
  constructor(t) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let n = null;
      const r = () => n || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : n = new this.targetWindow.ResizeObserver((o) => {
        o.forEach((i) => {
          const a = () => {
            this._measureElement(i.target, i);
          };
          this.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(a) : a();
        });
      }));
      return {
        disconnect: () => {
          var o;
          (o = r()) == null || o.disconnect(), n = null;
        },
        observe: (o) => {
          var i;
          return (i = r()) == null ? void 0 : i.observe(o, { box: "border-box" });
        },
        unobserve: (o) => {
          var i;
          return (i = r()) == null ? void 0 : i.unobserve(o);
        }
      };
    })(), this.range = null, this.setOptions = (n) => {
      Object.entries(n).forEach(([r, o]) => {
        typeof o > "u" && delete n[r];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: Vne,
        rangeExtractor: Bne,
        onChange: () => {
        },
        measureElement: Hne,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        isRtl: !1,
        useScrollendEvent: !1,
        useAnimationFrameWithResizeObserver: !1,
        ...n
      };
    }, this.notify = (n) => {
      var r, o;
      (o = (r = this.options).onChange) == null || o.call(r, this, n);
    }, this.maybeNotify = ea(
      () => (this.calculateRange(), [
        this.isScrolling,
        this.range ? this.range.startIndex : null,
        this.range ? this.range.endIndex : null
      ]),
      (n) => {
        this.notify(n);
      },
      {
        key: process.env.NODE_ENV !== "production" && "maybeNotify",
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    ), this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((n) => n()), this.unsubs = [], this.observer.disconnect(), this.scrollElement = null, this.targetWindow = null;
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var n;
      const r = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== r) {
        if (this.cleanup(), !r) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = r, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((n = this.scrollElement) == null ? void 0 : n.window) ?? null, this.elementsCache.forEach((o) => {
          this.observer.observe(o);
        }), this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        }), this.unsubs.push(
          this.options.observeElementRect(this, (o) => {
            this.scrollRect = o, this.maybeNotify();
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (o, i) => {
            this.scrollAdjustments = 0, this.scrollDirection = i ? this.getScrollOffset() < o ? "forward" : "backward" : null, this.scrollOffset = o, this.isScrolling = i, this.maybeNotify();
          })
        );
      }
    }, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (n, r) => {
      const o = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
      for (let a = r - 1; a >= 0; a--) {
        const s = n[a];
        if (o.has(s.lane))
          continue;
        const l = i.get(
          s.lane
        );
        if (l == null || s.end > l.end ? i.set(s.lane, s) : s.end < l.end && o.set(s.lane, !0), o.size === this.options.lanes)
          break;
      }
      return i.size === this.options.lanes ? Array.from(i.values()).sort((a, s) => a.end === s.end ? a.index - s.index : a.end - s.end)[0] : void 0;
    }, this.getMeasurementOptions = ea(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled
      ],
      (n, r, o, i, a) => (this.pendingMeasuredCacheIndexes = [], {
        count: n,
        paddingStart: r,
        scrollMargin: o,
        getItemKey: i,
        enabled: a
      }),
      {
        key: !1
      }
    ), this.getMeasurements = ea(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: n, paddingStart: r, scrollMargin: o, getItemKey: i, enabled: a }, s) => {
        if (!a)
          return this.measurementsCache = [], this.itemSizeCache.clear(), [];
        this.measurementsCache.length === 0 && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((u) => {
          this.itemSizeCache.set(u.key, u.size);
        }));
        const l = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [];
        const c = this.measurementsCache.slice(0, l);
        for (let u = l; u < n; u++) {
          const f = i(u), h = this.options.lanes === 1 ? c[u - 1] : this.getFurthestMeasurement(c, u), p = h ? h.end + this.options.gap : r + o, C = s.get(f), m = typeof C == "number" ? C : this.options.estimateSize(u), g = p + m, v = h ? h.lane : u % this.options.lanes;
          c[u] = {
            index: u,
            start: p,
            size: m,
            end: g,
            key: f,
            lane: v
          };
        }
        return this.measurementsCache = c, c;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = ea(
      () => [
        this.getMeasurements(),
        this.getSize(),
        this.getScrollOffset(),
        this.options.lanes
      ],
      (n, r, o, i) => this.range = n.length > 0 && r > 0 ? Wne({
        measurements: n,
        outerSize: r,
        scrollOffset: o,
        lanes: i
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getVirtualIndexes = ea(
      () => {
        let n = null, r = null;
        const o = this.calculateRange();
        return o && (n = o.startIndex, r = o.endIndex), this.maybeNotify.updateDeps([this.isScrolling, n, r]), [
          this.options.rangeExtractor,
          this.options.overscan,
          this.options.count,
          n,
          r
        ];
      },
      (n, r, o, i, a) => i === null || a === null ? [] : n({
        startIndex: i,
        endIndex: a,
        overscan: r,
        count: o
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (n) => {
      const r = this.options.indexAttribute, o = n.getAttribute(r);
      return o ? parseInt(o, 10) : (console.warn(
        `Missing attribute name '${r}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (n, r) => {
      const o = this.indexFromElement(n), i = this.measurementsCache[o];
      if (!i)
        return;
      const a = i.key, s = this.elementsCache.get(a);
      s !== n && (s && this.observer.unobserve(s), this.observer.observe(n), this.elementsCache.set(a, n)), n.isConnected && this.resizeItem(o, this.options.measureElement(n, r, this));
    }, this.resizeItem = (n, r) => {
      const o = this.measurementsCache[n];
      if (!o)
        return;
      const i = this.itemSizeCache.get(o.key) ?? o.size, a = r - i;
      a !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(o, a, this) : o.start < this.getScrollOffset() + this.scrollAdjustments) && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", a), this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += a,
        behavior: void 0
      })), this.pendingMeasuredCacheIndexes.push(o.index), this.itemSizeCache = new Map(this.itemSizeCache.set(o.key, r)), this.notify(!1));
    }, this.measureElement = (n) => {
      if (!n) {
        this.elementsCache.forEach((r, o) => {
          r.isConnected || (this.observer.unobserve(r), this.elementsCache.delete(o));
        });
        return;
      }
      this._measureElement(n, void 0);
    }, this.getVirtualItems = ea(
      () => [this.getVirtualIndexes(), this.getMeasurements()],
      (n, r) => {
        const o = [];
        for (let i = 0, a = n.length; i < a; i++) {
          const s = n[i], l = r[s];
          o.push(l);
        }
        return o;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualItems",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (n) => {
      const r = this.getMeasurements();
      if (r.length !== 0)
        return ty(
          r[PI(
            0,
            r.length - 1,
            (o) => ty(r[o]).start,
            n
          )]
        );
    }, this.getOffsetForAlignment = (n, r, o = 0) => {
      const i = this.getSize(), a = this.getScrollOffset();
      r === "auto" && (r = n >= a + i ? "end" : "start"), r === "center" ? n += (o - i) / 2 : r === "end" && (n -= i);
      const s = this.getTotalSize() + this.options.scrollMargin - i;
      return Math.max(Math.min(s, n), 0);
    }, this.getOffsetForIndex = (n, r = "auto") => {
      n = Math.max(0, Math.min(n, this.options.count - 1));
      const o = this.measurementsCache[n];
      if (!o)
        return;
      const i = this.getSize(), a = this.getScrollOffset();
      if (r === "auto")
        if (o.end >= a + i - this.options.scrollPaddingEnd)
          r = "end";
        else if (o.start <= a + this.options.scrollPaddingStart)
          r = "start";
        else
          return [a, r];
      const s = r === "end" ? o.end + this.options.scrollPaddingEnd : o.start - this.options.scrollPaddingStart;
      return [
        this.getOffsetForAlignment(s, r, o.size),
        r
      ];
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.scrollToOffset = (n, { align: r = "start", behavior: o } = {}) => {
      o === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(n, r), {
        adjustments: void 0,
        behavior: o
      });
    }, this.scrollToIndex = (n, { align: r = "auto", behavior: o } = {}) => {
      o === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), n = Math.max(0, Math.min(n, this.options.count - 1));
      let i = 0;
      const a = 10, s = (c) => {
        if (!this.targetWindow) return;
        const u = this.getOffsetForIndex(n, c);
        if (!u) {
          console.warn("Failed to get offset for index:", n);
          return;
        }
        const [f, h] = u;
        this._scrollToOffset(f, { adjustments: void 0, behavior: o }), this.targetWindow.requestAnimationFrame(() => {
          const p = this.getScrollOffset(), C = this.getOffsetForIndex(n, h);
          if (!C) {
            console.warn("Failed to get offset for index:", n);
            return;
          }
          Nne(C[0], p) || l(h);
        });
      }, l = (c) => {
        this.targetWindow && (i++, i < a ? (process.env.NODE_ENV !== "production" && this.options.debug && console.info("Schedule retry", i, a), this.targetWindow.requestAnimationFrame(() => s(c))) : console.warn(
          `Failed to scroll to index ${n} after ${a} attempts.`
        ));
      };
      s(r);
    }, this.scrollBy = (n, { behavior: r } = {}) => {
      r === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + n, {
        adjustments: void 0,
        behavior: r
      });
    }, this.getTotalSize = () => {
      var n;
      const r = this.getMeasurements();
      let o;
      if (r.length === 0)
        o = this.options.paddingStart;
      else if (this.options.lanes === 1)
        o = ((n = r[r.length - 1]) == null ? void 0 : n.end) ?? 0;
      else {
        const i = Array(this.options.lanes).fill(null);
        let a = r.length - 1;
        for (; a >= 0 && i.some((s) => s === null); ) {
          const s = r[a];
          i[s.lane] === null && (i[s.lane] = s.end), a--;
        }
        o = Math.max(...i.filter((s) => s !== null));
      }
      return Math.max(
        o - this.options.scrollMargin + this.options.paddingEnd,
        0
      );
    }, this._scrollToOffset = (n, {
      adjustments: r,
      behavior: o
    }) => {
      this.options.scrollToFn(n, { behavior: o, adjustments: r }, this);
    }, this.measure = () => {
      this.itemSizeCache = /* @__PURE__ */ new Map(), this.notify(!1);
    }, this.setOptions(t);
  }
}
const PI = (e, t, n, r) => {
  for (; e <= t; ) {
    const o = (e + t) / 2 | 0, i = n(o);
    if (i < r)
      e = o + 1;
    else if (i > r)
      t = o - 1;
    else
      return o;
  }
  return e > 0 ? e - 1 : 0;
};
function Wne({
  measurements: e,
  outerSize: t,
  scrollOffset: n,
  lanes: r
}) {
  const o = e.length - 1, i = (l) => e[l].start;
  if (e.length <= r)
    return {
      startIndex: 0,
      endIndex: o
    };
  let a = PI(
    0,
    o,
    i,
    n
  ), s = a;
  if (r === 1)
    for (; s < o && e[s].end < n + t; )
      s++;
  else if (r > 1) {
    const l = Array(r).fill(0);
    for (; s < o && l.some((u) => u < n + t); ) {
      const u = e[s];
      l[u.lane] = u.end, s++;
    }
    const c = Array(r).fill(n + t);
    for (; a >= 0 && c.some((u) => u >= n); ) {
      const u = e[a];
      c[u.lane] = u.start, a--;
    }
    a = Math.max(0, a - a % r), s = Math.min(o, s + (r - 1 - s % r));
  }
  return { startIndex: a, endIndex: s };
}
const iy = typeof document < "u" ? A.useLayoutEffect : A.useEffect;
function qne(e) {
  const t = A.useReducer(() => ({}), {})[1], n = {
    ...e,
    onChange: (o, i) => {
      var a;
      i ? Id(t) : t(), (a = e.onChange) == null || a.call(e, o, i);
    }
  }, [r] = A.useState(
    () => new Zne(n)
  );
  return r.setOptions(n), iy(() => r._didMount(), []), iy(() => r._willUpdate()), r;
}
function Une(e) {
  return qne({
    observeElementRect: $ne,
    observeElementOffset: jne,
    scrollToFn: zne,
    ...e
  });
}
const TI = ({ selected: e }) => /* @__PURE__ */ d("div", { className: I("text-surface-common-primary"), children: e && /* @__PURE__ */ d(k2, {}) });
TI.displayName = "SelectedIcon";
const II = "internal-option-", Hn = (e) => II + e, ay = (e) => e.slice(II.length), Gs = (e, t) => {
  const n = e.value;
  e.value = t;
  const r = e._valueTracker;
  typeof r < "u" && r.setValue(n), e.dispatchEvent(new Event("change", { bubbles: !0 }));
}, Gne = ({
  id: e,
  ref: t,
  value: n
}) => {
  const r = bt(), o = e || r, i = Oe(Fi), { activeIndex: a } = sp(), s = ap();
  if (!i)
    throw new Error("ComboboxOption must be used within a Combobox");
  const {
    selectedOptions: l,
    onOptionClick: c,
    debounceSelectOption: u,
    setListRef: f,
    customIds: h,
    filteredOptions: p
  } = i, C = _e(
    () => p.indexOf(Hn(String(n))) + h.length,
    [h.length, p, n]
  ), m = Mo([
    (w) => {
      f(C, w);
    },
    t
  ]);
  if (C === -1)
    throw new Error("Internal error: ComboboxOption did not find index");
  const g = l[Hn(n)], v = a === C;
  ve(() => {
    v && s?.({ type: "SET_ACTIVE_INDEX", payload: C });
  }, [r, e, s, v, C]);
  const y = mh(
    () => c(n),
    u
  );
  return {
    id: o,
    ref: m,
    selected: g,
    active: v,
    onOptionClick: y
  };
}, lp = CL(
  Xe(
    ({ value: e, description: t, children: n, className: r, ...o }, i) => {
      const a = bt(), { id: s, ref: l, selected: c, active: u, onOptionClick: f } = Gne({
        id: o.id,
        ref: i,
        value: e
      }), h = Oe(Fi);
      if (!h)
        throw new Error("ComboboxOption must be used within a Combobox");
      const { multiple: p, multipleMode: C, getItemProps: m } = h, g = p && C === "checkbox", v = m();
      return /* @__PURE__ */ d(
        "button",
        {
          ref: l,
          id: s,
          role: "option",
          type: "button",
          tabIndex: -1,
          "aria-selected": !!c,
          "aria-labelledby": a,
          onClick: (y) => {
            f(), o.onClick?.(y);
          },
          className: I(
            "flex w-full rounded-sm p-sm hover:bg-surface-common-subtle focus:bg-surface-common-subtle",
            u && "bg-surface-common-subtle",
            r
          ),
          ...bi(["displayValue"], o),
          ...bi(["onClick", "onPointerLeave"], v),
          children: /* @__PURE__ */ F(
            Ut,
            {
              className: I(
                "pointer-events-none flex w-full items-center justify-between",
                g && "justify-start gap-sm"
              ),
              weight: c ? "semibold" : "normal",
              id: a,
              children: [
                g && /* @__PURE__ */ d(D2, { checked: !!c }),
                n,
                !g && /* @__PURE__ */ d(TI, { selected: !!c })
              ]
            }
          )
        }
      );
    }
  )
);
lp.displayName = "ComboboxOption";
function Kne(e) {
  return sr(e) && e.type === lp;
}
const Yne = (e) => !!e;
function Xne({
  children: e,
  inputValue: t,
  multiple: n,
  filterMode: r = "includes",
  filter: o = (a, s) => r === "startsWith" ? s.label.toLowerCase().startsWith(a.toLowerCase()) : s.label.toLowerCase().includes(a.toLowerCase()),
  initialValue: i
}) {
  const a = ct(o, [o]), { optionsChildren: s, customIds: l, restChildren: c } = _e(() => ar.toArray(e).reduce(
    (y, w) => (Kne(w) ? y.optionsChildren.push(w) : y.restChildren.push(w), y),
    {
      optionsChildren: [],
      customIds: [],
      restChildren: []
    }
  ), [e]), u = _e(() => {
    const g = [], v = {};
    return s.map((y) => {
      const w = y.props;
      let x = w.displayValue || "";
      if (!w.displayValue) {
        let b = "";
        ar.forEach(w.children, (S) => {
          if (typeof S == "string")
            b += S;
          else
            throw new Error(
              "If ComboboxOption is not a string, it must have a displayValue prop"
            );
        }), x = b;
      }
      g.includes(w.value) && console.warn(
        `Combobox has multiple options with the same value: ${w.value}`
      ), g.push(w.value), v[Hn(String(w.value))] = {
        value: String(w.value),
        label: x,
        displayValue: w.displayValue,
        description: w.description
      };
    }), v;
  }, [s]), f = _e(
    () => (i?.map((g) => Hn(g)) || []).reduce((g, v) => {
      const y = u[v];
      return Yne(y) && (g[v] = y), g;
    }, {}),
    [i, u]
  ), [h, p] = ue(f), { filteredOptions: C, filteredOptionsChildren: m } = _e(() => {
    const g = [], v = Object.keys(u).map((y, w) => {
      if (!n && Object.keys(h).length === 1 || n && h[y] || a(t, u[y]))
        return g.push(y), s[w];
    }).filter((y) => y);
    return { filteredOptions: g, filteredOptionsChildren: v };
  }, [
    a,
    t,
    n,
    u,
    s,
    h
  ]);
  return {
    filteredOptionsChildren: m,
    filteredOptions: C,
    restChildren: c,
    options: u,
    customIds: l,
    selectedOptions: h,
    setSelectedOptions: p
  };
}
const Qne = ({
  readOnly: e,
  disabled: t,
  filteredOptions: n,
  inputValue: r,
  selectedOptions: o,
  multiple: i,
  open: a,
  options: s,
  setOpen: l,
  handleSelectOption: c
}) => {
  const { activeIndex: u } = sp();
  return mh((p) => {
    if (!t && p)
      switch (p.key) {
        case "ArrowDown":
          if (p.preventDefault(), a) break;
          l(!0);
          break;
        case "ArrowUp":
          if (p.preventDefault(), u !== 0) break;
          l(!1);
          break;
        case "Enter": {
          if (p.preventDefault(), !a) break;
          const m = n[u];
          c({ option: s[m] });
          break;
        }
        case "Backspace":
          if (!i) {
            const C = Object.keys(o).pop();
            C && c({
              option: o[C],
              remove: !0
            });
            break;
          }
          if (r === "" && i) {
            const C = Object.keys(o).pop();
            C && c({
              option: o[C],
              remove: !0
            });
          }
          break;
      }
  }, 20);
}, Jne = ({
  listRef: e,
  useAutoPlacement: t = !1
}) => {
  const [n, r] = ue(!1), { activeIndex: o } = sp(), i = ap(), { refs: a, floatingStyles: s, context: l } = Ri({
    open: n,
    onOpenChange: (m) => {
      m || i?.({ type: "SET_ACTIVE_INDEX", payload: 0 }), Id(() => {
        a.floating.current && !m && (a.floating.current.scrollTop = 0), setTimeout(() => {
          r(m);
        }, 1);
      });
    },
    whileElementsMounted: (m, g, v) => (D1(m, g, v), () => {
      g.scrollTop = 0;
    }),
    middleware: [
      t ? kF({}) : Ii({ padding: 10 }),
      _2({
        apply({ rects: m, elements: g }) {
          requestAnimationFrame(() => {
            Object.assign(g.floating.style, {
              // reference width - padding of the floating element
              width: `calc(${m.reference.width}px - 16px)`,
              maxHeight: "200px"
            });
          });
        }
      }),
      Ti(7)
    ]
  }), c = Li(l, { role: "listbox" }), u = Di(l), f = Iu(l, {
    listRef: e,
    activeIndex: o,
    virtual: !0,
    scrollItemIntoView: !0,
    enabled: n,
    focusItemOnHover: !0,
    onNavigate: (m) => {
      i?.({ type: "SET_ACTIVE_INDEX", payload: m || 0 });
    }
  }), { getReferenceProps: h, getFloatingProps: p, getItemProps: C } = ki(
    [c, u, f]
  );
  return {
    open: n,
    setOpen: r,
    activeIndex: o,
    refs: a,
    floatingStyles: s,
    context: l,
    getReferenceProps: h,
    getFloatingProps: p,
    getItemProps: C
  };
}, DI = ({ htmlForId: e }) => {
  const t = Oe(Fi);
  if (!t)
    throw new Error("ComboboxLabel must be used within a Combobox");
  const { label: n, topLabel: r, required: o, error: i } = t;
  if (!(!n || !r))
    return /* @__PURE__ */ F(Ut, { htmlFor: e, className: "inline-block font-semibold", children: [
      n,
      (i || o) && /* @__PURE__ */ d(
        "span",
        {
          "aria-label": "required field",
          className: "ml-[2px] text-ui-errorDark",
          children: "*"
        }
      )
    ] });
};
DI.displayName = "ComboboxLabel";
const RI = Xe((e, t) => {
  const n = Oe(Fi);
  if (!n)
    throw new Error("ComboboxContext is missing");
  const { readOnly: r, disabled: o, clearButtonLabel: i, handleSelectOption: a } = n;
  return /* @__PURE__ */ d(
    "button",
    {
      ...e,
      ref: t,
      disabled: o,
      className: I(
        "right-md flex items-center rounded-sm bg-transparent text-neutral-500 transition-all hover:bg-neutral-200 hover:text-neutral-600"
      ),
      onClick: () => {
        r || o || a({ option: null, clear: !0 });
      },
      onKeyDown: (s) => {
        r || o || s.key === "Enter" && (s.stopPropagation(), a({ option: null, clear: !0 }));
      },
      type: "button",
      "aria-label": i,
      children: /* @__PURE__ */ d(
        Wr,
        {
          accessibilityLabel: "Clear selection",
          size: "small",
          colorVariant: "currentColor"
        }
      )
    }
  );
});
RI.displayName = "ComboboxClearButton";
const kI = ({
  hideClearButton: e,
  listId: t,
  error: n,
  border: r,
  iconLeft: o,
  size: i,
  htmlFor: a,
  handleKeyDown: s,
  ...l
}) => {
  const c = Oe(Fi), u = ap(), f = ke(null);
  if (!c)
    throw new Error("ComboboxContext is missing");
  const h = (ee) => {
    u?.({ type: "SET_ACTIVE_INDEX", payload: ee });
  }, {
    label: p,
    topLabel: C,
    forwareddRef: m,
    readOnly: g,
    disabled: v,
    open: y,
    multiple: w,
    inputRef: x,
    refs: b,
    inputValue: S,
    selectedOptions: M,
    options: E,
    setOpen: P,
    getReferenceProps: T,
    setInputValue: _,
    handleSelectOption: D,
    selectionSummaryThreshold: N,
    summaryType: R,
    summaryFormatter: L
  } = c, B = Mo([m, x]), V = _e(() => n || o, [n, o]), k = (ee) => {
    const U = ee.target.value;
    _(U), h(0);
    for (const X of Object.values(E))
      if (X.label.toLowerCase() === U.toLowerCase()) {
        if (M[Hn(X.value)]) continue;
        D({ option: X });
      }
  }, z = Object.keys(M).length > 0, $ = !e && (z || S.length > 0), Z = T({
    ref: b?.setReference,
    role: null,
    "aria-controls": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    /* If we click the wrapper, toggle open, set index to first option, and focus the input */
    onClick(ee) {
      v || g || f.current?.contains(ee.target) || (P(!y), h(0), x.current?.focus());
    },
    /* Handles list navigation */
    onKeyDown: s,
    // preventDefault on keydown to avoid sending in form
    onKeyPress(ee) {
      ee.key === "Enter" && ee.preventDefault();
    }
  }), W = {
    asterix: I("text-ui-errorDark"),
    border: I("border-ui-errorDark"),
    message: I("text-ui-errorDark")
  }, H = I(
    "flex min-w-13 items-center justify-between rounded-md bg-white transition-all",
    "hover:border-neutral-400",
    "outline-none focus-visible:ring-surface-common-primary-light",
    "active:border-surface-common-primary active:ring-surface-common-primary-light",
    i === "small" ? "h-[22px] px-[10px] py-[4px]" : "h-[18px] px-md py-[12px]",
    !r && "hover:outline hover:outline-[1px] hover:outline-border-input",
    !r && !!y && "outline-[1px] outline-border-input",
    r && I(`border border-border-input ${n && W.border}`),
    v && "bg-neutral-100 text-neutral-500 hover:border-border-input active:border-border-input",
    v && !r && "hover:outline-none"
  ), G = I(
    "min-w-[100px] max-w-full border-none bg-transparent outline-none",
    !w && "mr-2 w-full",
    !C && z && "font-semibold"
  ), Y = () => V ? /* @__PURE__ */ F("div", { className: "flex items-center gap-1 text-surface-common-primary", children: [
    n && /* @__PURE__ */ d("div", { className: "text-ui-errorDark", children: /* @__PURE__ */ d(
      ih,
      {
        accessibilityLabel: "error",
        colorVariant: "currentColor",
        size: "small"
      }
    ) }),
    o
  ] }) : null, ne = () => !C && /* @__PURE__ */ F(Rt, { children: [
    p,
    ":"
  ] }), J = () => {
    if (!w || !z) return null;
    const ee = N, U = Object.values(M).length, X = Object.values(M).sort(CG("index")).slice(0, ee).map(({ label: te }) => te), ie = U - ee;
    ie > 0 && R === "count" && X.push(`+ ${ie} flere`);
    const j = L ? L(M) : R === "count" ? `${U} valgt` : X.join(", ");
    return /* @__PURE__ */ F("div", { className: I("min-w-[24px] max-w-full", !C && "gap-[5px]"), children: [
      /* @__PURE__ */ d(ne, {}),
      /* @__PURE__ */ d(
        Rt,
        {
          className: I("text-text-primary", !C && "font-semibold"),
          lineClamp: 1,
          children: j
        }
      )
    ] });
  };
  return /* @__PURE__ */ d(
    "div",
    {
      ...Z,
      className: "relatize z-0 w-full",
      "aria-disabled": v ? "true" : void 0,
      children: /* @__PURE__ */ F("div", { className: H, children: [
        /* @__PURE__ */ F("div", { className: I("flex gap-1", !w && "w-full"), children: [
          w && /* @__PURE__ */ d(J, {}),
          !w && /* @__PURE__ */ d(ne, {}),
          /* @__PURE__ */ d(Y, {}),
          /* @__PURE__ */ d(
            "input",
            {
              ref: B,
              id: a,
              "aria-activedescendant": Z["aria-activedescendant"],
              readOnly: g,
              "aria-autocomplete": "list",
              role: "combobox",
              "aria-expanded": y,
              "aria-controls": y ? t : void 0,
              autoComplete: "off",
              className: G,
              value: S,
              ...bi(["style", "className"], l),
              onChange: (ee) => {
                k(ee), y || P(!0), l.onChange?.(ee);
              }
            }
          )
        ] }),
        /* @__PURE__ */ F("div", { className: "inline-flex", children: [
          $ && /* @__PURE__ */ d(RI, { ref: f }),
          /* @__PURE__ */ d("div", { className: "text-surface-common-primary", children: y ? /* @__PURE__ */ d(
            V0,
            {
              accessibilityLabel: "arrow up",
              colorVariant: "currentColor"
            }
          ) : /* @__PURE__ */ d(
            Gr,
            {
              accessibilityLabel: "arrow down",
              colorVariant: "currentColor"
            }
          ) })
        ] })
      ] })
    }
  );
};
kI.displayName = "ComboboxInput";
const LI = ({ error: e }) => {
  if (e)
    return /* @__PURE__ */ d("div", { "aria-live": "polite", "aria-relevant": "additions removals", children: /* @__PURE__ */ d(Eo, { children: e }) });
};
LI.displayName = "ComboboxError";
const NI = ({ hint: e }) => {
  if (e)
    return /* @__PURE__ */ d(Go, { children: e });
};
NI.displayName = "ComboboxLabel";
const ere = Xe(
  ({
    value: e,
    initialValue: t = [],
    onValueChange: n,
    label: r,
    topLabel: o = !0,
    multiple: i = !1,
    disabled: a = !1,
    readOnly: s = !1,
    autoPlacement: l = !1,
    multipleMode: c = "checkmark",
    clearButtonLabel: u = "Fjern alt",
    hideClearButton: f = !1,
    selectionSummaryThreshold: h = 3,
    debounceSelectOption: p = 0,
    summaryType: C = "count",
    summaryFormatter: m,
    hint: g,
    error: v,
    border: y = !0,
    iconLeft: w,
    size: x = "default",
    children: b,
    style: S,
    loading: M,
    filter: E,
    filterMode: P = "includes",
    className: T,
    placeholder: _ = "-",
    required: D,
    virtual: N = !1,
    ...R
  }, L) => {
    const B = ke(null), V = ke(null), k = ke([]), z = bt(), [$, Z] = ue(R.inputValue || "");
    ve(() => {
      typeof R.inputValue == "string" && Z(R.inputValue);
    }, [R.inputValue]);
    const {
      selectedOptions: W,
      options: H,
      restChildren: G,
      customIds: Y,
      filteredOptionsChildren: ne,
      filteredOptions: J,
      setSelectedOptions: ee
    } = Xne({
      children: b,
      inputValue: $,
      filter: E,
      filterMode: P,
      multiple: i,
      initialValue: t
    }), {
      open: U,
      setOpen: X,
      refs: ie,
      floatingStyles: j,
      context: te,
      getReferenceProps: K,
      getFloatingProps: me,
      getItemProps: we
    } = Jne({ listRef: k, useAutoPlacement: l });
    R2(U), ve(() => {
      if (e && e.length > 0 && !i) {
        const fe = H[Hn(e[0])];
        B.current && Gs(B.current, fe?.label || "");
      } else !i && e && e.length === 0 && (B.current && Gs(B.current, ""), ee({}), X(!1));
    }, [i, e, H, X, ee]), ve(() => {
      if (e && Object.keys(H).length >= 0) {
        const fe = e.map((ge) => H[Hn(ge)]);
        ee(
          fe.reduce(
            (ge, pe) => (pe && (ge[Hn(pe.value)] = pe), ge),
            {}
          )
        );
      }
    }, [i, e, H, ee]);
    const Ze = mh(
      (fe) => {
        const { option: ge, clear: pe, remove: De } = fe;
        if (pe) {
          ee({}), B.current && Gs(B.current, ""), n?.([]);
          return;
        }
        if (!ge) return;
        if (De) {
          const He = { ...W };
          delete He[Hn(ge.value)], ee(He), n?.(
            Object.keys(He).map((pn) => ay(pn))
          );
          return;
        }
        const xe = { ...W };
        if (i)
          xe[Hn(ge.value)] ? delete xe[Hn(ge.value)] : xe[Hn(ge.value)] = ge, B.current && Gs(B.current, ""), B.current?.focus();
        else {
          for (const He of Object.keys(xe))
            delete xe[He];
          xe[Hn(ge.value)] = ge, B.current && Gs(B.current, ge?.label || ""), setTimeout(() => {
            B.current?.setSelectionRange(
              ge?.label?.length || 0,
              ge?.label?.length || 0
            );
          }, 0);
        }
        ee(xe), n?.(
          Object.keys(xe).map((He) => ay(He))
        ), i || X(!1), ie.domReference.current && ie.domReference.current.focus();
      },
      p
    ), Ue = Qne({
      filteredOptions: J,
      selectedOptions: W,
      readOnly: !1,
      disabled: a,
      multiple: i,
      inputValue: $,
      options: H,
      open: U,
      setOpen: X,
      handleSelectOption: Ze
    }), Ke = Une({
      count: Object.keys(ne).length,
      getScrollElement: () => N ? ie.floating.current : null,
      estimateSize: () => 70,
      measureElement: (fe) => fe.getBoundingClientRect().height,
      overscan: 7
    }), ft = i && W && Object.keys(W).length > 0 ? "" : _;
    return /* @__PURE__ */ F(
      Fi.Provider,
      {
        value: {
          label: r,
          topLabel: o,
          required: D,
          error: v,
          options: H,
          selectedOptions: W,
          debounceSelectOption: p,
          multiple: i,
          multipleMode: c,
          disabled: a,
          readOnly: s,
          selectionSummaryThreshold: h,
          open: U,
          inputRef: B,
          refs: ie,
          inputValue: $,
          clearButtonLabel: u,
          customIds: Y,
          filteredOptions: J,
          setInputValue: Z,
          setOpen: X,
          getReferenceProps: K,
          getItemProps: we,
          summaryType: C,
          summaryFormatter: m,
          /* Recieves the value of the option, and searches for it in our values lookup */
          onOptionClick: (fe) => {
            if (s || a) return;
            const ge = H[Hn(fe)];
            Ze({ option: ge });
          },
          handleSelectOption: Ze,
          listRef: k,
          forwareddRef: L,
          setListRef: (fe, ge) => {
            k.current[fe] = ge;
          }
        },
        children: [
          /* @__PURE__ */ F(
            "div",
            {
              className: I(
                "flex w-full min-w-[256px] flex-col gap-xs transition-all",
                T
              ),
              style: S,
              ref: V,
              children: [
                /* @__PURE__ */ d(DI, { htmlForId: z }),
                /* @__PURE__ */ d(
                  kI,
                  {
                    ...bi(["inputValue"], R),
                    hideClearButton: f,
                    listId: te.floatingId || "",
                    border: y,
                    iconLeft: w,
                    placeholder: ft,
                    htmlFor: z,
                    error: v,
                    size: x,
                    handleKeyDown: Ue,
                    "aria-busy": M
                  }
                ),
                /* @__PURE__ */ d(NI, { hint: g }),
                /* @__PURE__ */ d(LI, { error: v })
              ]
            }
          ),
          U && /* @__PURE__ */ d(
            ms,
            {
              context: te,
              initialFocus: -1,
              visuallyHiddenDismiss: !0,
              children: /* @__PURE__ */ F(
                "div",
                {
                  "aria-autocomplete": "list",
                  tabIndex: -1,
                  ...me({
                    ref: ie.setFloating,
                    style: { ...j }
                  }),
                  className: I(
                    "z-[999] flex flex-col overflow-y-auto rounded-md border border-border-input bg-white p-sm shadow-modal"
                  ),
                  children: [
                    N && /* @__PURE__ */ d(
                      "div",
                      {
                        style: {
                          height: `${Ke.getTotalSize()}px`,
                          width: "100%",
                          position: "relative"
                        },
                        children: Ke.getVirtualItems().map((fe) => /* @__PURE__ */ d(
                          "div",
                          {
                            ref: Ke.measureElement,
                            "data-index": fe.index,
                            style: {
                              position: "absolute",
                              top: 0,
                              left: 0,
                              width: "100%",
                              transform: `translateY(${fe.start}px)`
                            },
                            children: ne[fe.index]
                          },
                          fe.index
                        ))
                      }
                    ),
                    /* @__PURE__ */ F(ut, { children: [
                      G,
                      !N && ne
                    ] })
                  ]
                }
              )
            }
          )
        ]
      }
    );
  }
), FI = Xe(
  (e, t) => /* @__PURE__ */ d(Lne, { children: /* @__PURE__ */ d(ere, { ...e, ref: t }) })
);
FI.displayName = "Combobox";
const VI = Xe(
  ({ children: e, ...t }, n) => {
    const r = Oe(Fi);
    if (!r)
      throw new Error("ComboboxEmpty must be used within a Combobox");
    const { filteredOptions: o } = r;
    return o.length === 0 && /* @__PURE__ */ d(Rt, { ref: n, ...t, size: "small", children: e });
  }
);
VI.displayName = "ComboboxEmpty";
const Ju = FI;
Ju.Option = lp;
Ju.Empty = VI;
Ju.Option.displayName = "Combobox.Option";
Ju.Empty.displayName = "Combobox.Empty";
const e0 = O.createContext(
  {}
), tre = ({
  label: e,
  value: t,
  children: n,
  icon: r,
  isBackgroundedIcon: o = !0,
  onClick: i
}) => {
  const {
    activeIndex: a,
    selectedIndex: s,
    getItemProps: l,
    handleSelect: c,
    withOptionAs: u
  } = O.useContext(e0), { ref: f, index: h } = A2({ label: e }), p = a === h, C = s === h, g = I(
    "flex w-full items-center justify-between rounded-md p-sm outline-none ring-0 hover:bg-surface-common-subtle focus:bg-surface-common-subtle",
    p && "bg-neutral-100",
    u === "label" && "min-h-[40px]"
  ), v = t || e;
  return v ? /* @__PURE__ */ F(
    "button",
    {
      ref: f,
      className: g,
      role: "option",
      "aria-selected": p && C,
      "aria-current": p,
      tabIndex: p ? 0 : -1,
      ...l({
        onClick: () => {
          c?.({ value: v, index: h }), i?.();
        }
      }),
      children: [
        /* @__PURE__ */ F("div", { className: "flex min-h-fit items-center", children: [
          r && /* @__PURE__ */ d(
            "div",
            {
              className: I(
                "flex h-[24px] w-[24px] items-center justify-center",
                o && I(
                  "rounded-card bg-surface-common-card-hover p-sm text-surface-common-primary"
                )
              ),
              children: r
            }
          ),
          n ?? e
        ] }),
        /* @__PURE__ */ d(
          "div",
          {
            className: "block h-[24px] w-[24px]",
            "aria-hidden": !C,
            "aria-label": C ? "Selected" : "Not selected",
            children: C && /* @__PURE__ */ d(k2, { colorVariant: "primary" })
          }
        )
      ]
    }
  ) : (console.warn("DropdownOption: value or label is required"), null);
}, nre = () => {
  const e = Oe(e0);
  if (!e)
    throw new Error("DropdownContext is missing");
  const { handleSelect: t, disabled: n } = e;
  return /* @__PURE__ */ d(
    "span",
    {
      role: "button",
      tabIndex: 0,
      "aria-disabled": n,
      className: "right-md flex items-center rounded-sm bg-transparent text-neutral-500 transition-all hover:bg-neutral-200 hover:text-neutral-600",
      onClick: () => {
        t?.({
          index: null,
          value: null
        });
      },
      children: /* @__PURE__ */ d(Wr, {})
    }
  );
}, rre = Xe(({ referenceProps: e, children: t }, n) => {
  const r = Oe(e0), {
    size: o,
    disabled: i,
    error: a,
    placeholder: s,
    padding: l,
    clearable: c,
    selectedIndex: u,
    withOptionAs: f,
    hideInputOnSelect: h
  } = r, p = c && u !== null, C = u !== null, m = {
    asterix: I("text-ui-errorDark"),
    border: I("border-ui-errorDark"),
    message: I("text-ui-errorDark")
  }, g = {
    small: "h-[44px]",
    default: "h-[48px]",
    fit: "h-fit max-h-[56px]"
  }, v = {
    none: "p-0",
    small: "px-[10px] py-[4px]",
    medium: "px-md py-[14px]",
    default: "px-md py-[12px]",
    node: "px-md py-[12px]",
    nodeSelected: "px-md py-[8px]"
  }, y = I(
    "flex w-full min-w-13 items-center rounded-md border border-border-input bg-white text-left transition-all",
    "hover:border-neutral-400",
    "outline-none focus-visible:ring-surface-common-primary-light",
    "active:border-surface-common-primary active:ring-surface-common-primary-light",
    "focus:border-1 focus:border-surface-common-primary-light focus:ring-1 focus:ring-surface-common-primary-light",
    h && !r.isOpen && "ring-none border-none bg-surface-common-subtle outline-none",
    f === "node" || f === "icon" ? "h-fit" : g[o],
    f === "node" || f === "icon" ? v[C ? "nodeSelected" : "node"] : v[l],
    a && m.border,
    i && "bg-neutral-100 text-neutral-500 hover:border-border-input active:border-border-input"
  );
  return /* @__PURE__ */ d(
    "button",
    {
      ref: n,
      tabIndex: 0,
      ...e,
      className: y,
      disabled: i,
      "aria-haspopup": "listbox",
      "aria-expanded": r.isOpen,
      "aria-labelledby": r.labelId,
      "aria-describedby": r.descriptionId,
      "aria-invalid": !!a,
      role: "combobox",
      children: /* @__PURE__ */ F("div", { className: "flex w-full items-center justify-between gap-sm", children: [
        /* @__PURE__ */ d("div", { className: "flex-1", children: t ?? /* @__PURE__ */ d("span", { className: "text-neutral-500", children: s }) }),
        p && /* @__PURE__ */ d(nre, {}),
        !h || r.isOpen ? /* @__PURE__ */ d(
          Gr,
          {
            flipVertical: r.isOpen,
            accessibilityLabel: r.isOpen ? "arrow up" : "arrow down",
            className: I(
              "text-surface-common-primary",
              i && "text-neutral-500"
            ),
            "aria-hidden": "true"
          }
        ) : /* @__PURE__ */ d(Ut, { className: "cursor-pointer font-semibold text-surface-common-primary", children: "Endre" })
      ] })
    }
  );
}), ore = ({
  listRef: e,
  labelsRef: t,
  defaultOpen: n
}) => {
  const [r, o] = ue(n), [i, a] = ue(null), [s, l] = ue(null), [c, u] = ue(null), [f, h] = ue(null), { refs: p, floatingStyles: C, context: m } = Ri({
    placement: "bottom-start",
    open: r,
    onOpenChange: o,
    whileElementsMounted: D1,
    middleware: [
      Ii(),
      Ti(7),
      _2({
        apply({ rects: T, elements: _ }) {
          requestAnimationFrame(() => {
            Object.assign(_.floating.style, {
              // reference width - padding of the floating element
              width: `calc(${T.reference.width}px - 16px)`,
              maxHeight: "200px"
            });
          });
        }
      })
    ]
  }), g = O.useCallback(
    ({ value: T, index: _ }) => {
      l(_), o(!1), _ !== null && (u(t.current[_]), h(T ?? null));
    },
    []
  );
  function v(T) {
    r ? a(T) : T !== null && g({
      index: T,
      value: t.current[T] ?? ""
    });
  }
  const y = Iu(m, {
    listRef: e,
    scrollItemIntoView: !0,
    enabled: r,
    activeIndex: i,
    selectedIndex: s,
    onNavigate: a
  }), w = Hd(m, {
    listRef: t,
    activeIndex: i,
    selectedIndex: s,
    onMatch: v
  }), x = Pu(m), b = Di(m), S = Li(m, { role: "listbox" }), { getReferenceProps: M, getFloatingProps: E, getItemProps: P } = ki(
    [y, w, x, b, S]
  );
  return {
    isOpen: r,
    activeIndex: i,
    selectedIndex: s,
    selectedLabel: c,
    selectedValue: f,
    refs: p,
    floatingStyles: C,
    context: m,
    getReferenceProps: M,
    getFloatingProps: E,
    getItemProps: P,
    handleSelect: g
  };
}, ire = ({
  children: e,
  label: t,
  hint: n,
  placeholder: r,
  error: o,
  defaultOpen: i,
  required: a = !1,
  size: s = "default",
  disabled: l = !1,
  padding: c = "default",
  withOptionAs: u = "label",
  onSelectChange: f,
  clearable: h = !0,
  defaultSelectedIndex: p = null,
  hideInputOnSelect: C = !1,
  className: m
}) => {
  const g = O.useRef([]), v = O.useRef([]), y = bt(), w = y + "-label", x = y + "-list", b = y + "-description", {
    isOpen: S,
    activeIndex: M,
    selectedIndex: E,
    selectedLabel: P,
    refs: T,
    floatingStyles: _,
    context: D,
    getReferenceProps: N,
    getFloatingProps: R,
    getItemProps: L,
    handleSelect: B
  } = ore({
    listRef: g,
    labelsRef: v,
    defaultOpen: i ?? !1
  }), V = O.useMemo(
    () => ({
      id: y,
      labelId: w,
      listId: x,
      descriptionId: b,
      activeIndex: M,
      selectedIndex: E,
      getItemProps: L,
      handleSelect: B,
      isOpen: S ?? !1,
      placeholder: r ?? "-",
      required: a,
      size: s,
      disabled: l,
      error: o ?? null,
      padding: c,
      withOptionAs: u,
      clearable: h,
      hideInputOnSelect: C
    }),
    [
      y,
      w,
      x,
      b,
      M,
      E,
      L,
      B,
      S,
      s,
      l,
      r,
      o,
      a,
      c,
      u,
      h,
      C
    ]
  );
  R2(S), ve(() => {
    f?.(E, P);
  }, [f, E, P]), ve(() => {
    if (p !== null) {
      const Z = O.Children.toArray(e);
      if (p < Z.length) {
        const W = Z[p];
        if (O.isValidElement(W)) {
          const H = W.props.label;
          if (v.current.length <= p)
            for (let G = v.current.length; G <= p; G++)
              v.current[G] = null;
          v.current[p] = H, B?.({ value: H ?? null, index: p });
        }
      }
    }
  }, [p, e, B, v]);
  const k = () => {
    if (E === null) return null;
    const Z = O.Children.toArray(e);
    if (E >= Z.length) return null;
    const W = Z[E];
    return O.isValidElement(W) ? W.props.children : null;
  }, z = () => {
    if (E === null) return null;
    const Z = O.Children.toArray(e);
    if (E >= Z.length) return null;
    const W = Z[E];
    if (!O.isValidElement(W)) return null;
    const H = W.props.icon, G = W.props.label;
    return /* @__PURE__ */ F("div", { className: I("flex items-center gap-md", m), children: [
      H && /* @__PURE__ */ d(
        "div",
        {
          className: I(
            "flex h-[24px] w-[24px] items-center justify-center rounded-card bg-surface-common-primary p-sm text-text-invert"
          ),
          children: H
        }
      ),
      G
    ] });
  }, $ = () => {
    if (u === "label")
      return P;
    const Z = u === "icon" ? z() : k();
    return Z ? O.cloneElement(Z, {
      // @ts-expect-error: disable-next-line
      ...Z.props
    }) : null;
  };
  return /* @__PURE__ */ F(e0.Provider, { value: V, children: [
    /* @__PURE__ */ F("div", { className: I("flex w-full flex-col gap-xs", m), children: [
      t && /* @__PURE__ */ F(Ut, { weight: "semibold", id: w, children: [
        t,
        " ",
        (a || o?.length) && /* @__PURE__ */ d(
          "span",
          {
            "aria-label": "required field",
            className: I("ml-[2px] text-ui-errorDark"),
            children: "*"
          }
        )
      ] }),
      /* @__PURE__ */ d(
        rre,
        {
          ref: T.setReference,
          referenceProps: N(),
          children: E !== null ? /* @__PURE__ */ d($, {}) : r
        }
      ),
      n && !o && /* @__PURE__ */ d(Go, { id: b, children: n }),
      o && /* @__PURE__ */ d(Eo, { id: b, children: o })
    ] }),
    S && /* @__PURE__ */ d(
      ms,
      {
        context: D,
        modal: !1,
        visuallyHiddenDismiss: !0,
        initialFocus: -1,
        children: /* @__PURE__ */ d(
          "div",
          {
            ref: T.setFloating,
            id: x,
            role: "listbox",
            "aria-label": t || "Dropdown options",
            style: {
              ..._,
              outline: "none",
              zIndex: 999
            },
            ...R(),
            tabIndex: -1,
            children: /* @__PURE__ */ d(O2, { elementsRef: g, labelsRef: v, children: /* @__PURE__ */ d(
              "div",
              {
                tabIndex: -1,
                className: "border-input z-[999] flex max-h-[200px] w-full flex-col overflow-y-auto rounded-md border bg-white p-sm shadow-modal focus:border-none focus:outline-none focus:ring-0 focus:ring-offset-0",
                children: e
              }
            ) })
          }
        )
      }
    )
  ] });
}, are = Object.assign(ire, {
  Option: tre
});
are.Option.displayName = "Dropdown.Option";
async function eme(e, t, n, r) {
  const o = new XMLHttpRequest();
  return new Promise(
    (a, s) => {
      o.upload.addEventListener("progress", (l) => {
        l.lengthComputable && n && n(l.loaded / l.total * 100);
      }), o.addEventListener("load", (l) => {
        o.status >= 400 && s(l), a(l);
      }), o.addEventListener("error", (l) => {
        s(l);
      }), o.addEventListener("abort", (l) => {
        s(l);
      }), o.open("POST", e), Object.entries(r || {}).forEach(([l, c]) => {
        o.setRequestHeader(l, c);
      }), o.send(t);
    }
  ).then(
    () => JSON.parse(o.responseText),
    () => {
      throw new Error(o.statusText);
    }
  );
}
function g5(e) {
  return e >= 1e5 ? `${sy(Number(e / 1e3 / 1e3))} MB` : `${sy(e / 1e3)} KB`;
}
function sy(e) {
  const t = sre(e);
  return t ? new Intl.NumberFormat("nb-NO", {
    maximumFractionDigits: 2
  }).format(t) : e.toString();
}
function sre(e) {
  if (typeof e == "number")
    return e;
  const t = /\s/g, n = e.replace(t, "").split(""), r = n.reduce(
    (o, i) => i === "," || i === "." ? i : o,
    null
  );
  return Number(r === "." ? ly(n, ".").replace(",", "") : r === "," ? ly(n, ",").replace(".", "").replace(",", ".") : n.join(""));
}
const ly = (e, t) => {
  const n = Array.isArray(e) ? e : e.split(""), r = n.lastIndexOf(t);
  return n.filter((o, i) => o !== t ? !0 : i === r).join("");
};
function BI(e, t = "", n) {
  const r = t.split(",").map((i) => i.toLowerCase()).map((i) => i.replace(/\*/g, "")).map((i) => i.trim());
  let o = r.length === 0;
  if (o = r.some(
    (i) => e.type.toLowerCase().includes(i) || e.name.toLowerCase().endsWith(i)
  ), !o)
    return {
      type: "WRONG_TYPE",
      message: `Filtypen ${e.name?.split(".")[1] || ""} støttes ikke`
    };
  if (typeof n < "u" && e.size > n)
    return {
      type: "TOO_LARGE",
      message: `Filen er ${g5(
        e.size
      )}, men kan maksimalt være ${g5(n)}`
    };
}
const $I = gt(null), cp = () => Oe($I), lre = ({ context: e, children: t }) => /* @__PURE__ */ d($I.Provider, { value: e, children: t }), jI = Xe(
  (e, t) => {
    const { children: n, ...r } = e, [o, i] = ue(""), [a, s] = ue([]), l = cp();
    if (!l)
      return /* @__PURE__ */ d("p", { children: "Dropzone must be placed inside a FileUploadContextProvider." });
    const { maxSizeBytes: c, accept: u, onChange: f } = l, h = (p) => {
      const C = [], m = [];
      Array.from(p).forEach((g) => {
        const v = BI(g, u, c);
        v ? m.push(v.message) : C.push({
          file: g,
          state: "SELECTED",
          validation: void 0,
          uploadProgress: 0
        });
      }), s(m), C.length > 0 && f(
        { preventDefault: () => {
        } },
        C
      );
    };
    return /* @__PURE__ */ F(
      "div",
      {
        ...r,
        ref: t,
        className: I(
          "flex flex-col items-center justify-center p-2",
          o
        ),
        onDragEnter: (p) => {
          i("bg-surface-common-primary-light"), p.preventDefault();
        },
        onDragOver: (p) => {
          i("bg-surface-common-primary-light"), p.preventDefault();
        },
        onDrop: (p) => {
          p.preventDefault(), i(""), p.dataTransfer.files && h(p.dataTransfer.files);
        },
        onDragLeave: (p) => {
          i(""), p.preventDefault();
        },
        children: [
          n,
          a.length > 0 && /* @__PURE__ */ d("div", { className: "text-status-error mt-2 text-sm", children: a.map((p, C) => /* @__PURE__ */ d(Eo, { className: "text-ui-errorDark", children: p }, C)) })
        ]
      }
    );
  }
);
jI.displayName = "FileUploadDropzone";
const cre = Xe(
  (e, t) => {
    const { multiple: n, id: r, label: o, ...i } = e, a = bt(), s = r + "-description", l = cp();
    if (!l)
      return /* @__PURE__ */ d("p", { children: "Input must be placed inside a FileUploadContextProvider." });
    const { accept: c, maxSizeBytes: u, onChange: f } = l, h = r || a;
    return /* @__PURE__ */ F(ut, { children: [
      /* @__PURE__ */ F(
        "label",
        {
          className: "flex min-w-7 cursor-pointer flex-col items-center justify-center gap-[12px] font-semibold text-text-brand",
          htmlFor: r || a,
          id: `${h}__add-btn`,
          tabIndex: 0,
          role: "button",
          onKeyDown: (p) => {
            (p.key === "Enter" || p.key === " ") && (p.preventDefault(), document.getElementById(h)?.click());
          },
          children: [
            /* @__PURE__ */ d(rhe, { className: "rounded-md border border-border-light p-[12px] text-surface-common-icon-color" }),
            o
          ]
        }
      ),
      /* @__PURE__ */ d(
        "input",
        {
          ...i,
          ref: t,
          id: h,
          accept: c,
          "aria-describedby": u ? s : void 0,
          className: "hidden",
          type: "file",
          multiple: n,
          value: "",
          onChange: (p) => {
            p.target.files && f(
              p,
              [...p.target.files].map((C) => ({
                file: C,
                state: "SELECTED",
                validation: BI(C, c, u),
                uploadProgress: 0
              }))
            );
          }
        }
      ),
      /* @__PURE__ */ d(Ye, { subtle: !0, children: "eller dra og slipp filer her for å legge til" })
    ] });
  }
), ure = ({ id: e }) => {
  const t = cp();
  if (!t)
    return /* @__PURE__ */ d("p", { children: "MaxSize must be placed inside a FileUploadContextProvider." });
  const { maxSizeBytes: n } = t;
  return typeof n > "u" ? !1 : /* @__PURE__ */ F("div", { id: e, className: "jkl-file-input__max-size-text", children: [
    "Maks ",
    g5(n),
    " per fil"
  ] });
}, fre = Xe(
  (e, t) => {
    const {
      accept: n,
      label: r,
      id: o,
      value: i,
      multiple: a = !0,
      maxSizeBytes: s,
      showMaxSize: l = !1,
      onChange: c
    } = e, u = bt();
    return /* @__PURE__ */ d(
      lre,
      {
        context: { accept: n, onChange: c, maxSizeBytes: s, files: i },
        children: /* @__PURE__ */ F("div", { children: [
          /* @__PURE__ */ d(jI, { children: /* @__PURE__ */ d(
            cre,
            {
              id: o,
              label: r || "Legg til fil",
              multiple: a,
              ref: t,
              "aria-describedby": u
            }
          ) }),
          l && /* @__PURE__ */ d(ure, { id: u })
        ] })
      }
    );
  }
);
fre.displayName = "FileUpload";
const tme = ({
  file: e,
  onDelete: t,
  hasSearchIcon: n = !0,
  onSearch: r
}) => {
  const { file: o, validation: i } = e, { name: a, type: s, size: l, webkitRelativePath: c } = o;
  return /* @__PURE__ */ F(
    c ? "a" : "div",
    {
      href: c,
      target: c ? "_blank" : void 0,
      className: "box-border flex w-full flex-row items-center justify-between gap-2 rounded-card p-[12px] outline outline-1 outline-border-light",
      children: [
        /* @__PURE__ */ F("div", { className: "flex flex-row items-center gap-2", children: [
          /* @__PURE__ */ d(() => s.startsWith("image/") ? /* @__PURE__ */ d(
            "img",
            {
              className: "h-5 w-5 rounded object-cover",
              src: o ? URL.createObjectURL(o) : c,
              alt: ""
            }
          ) : /* @__PURE__ */ d(lfe, { className: "rounded-md bg-surface-common-subtle p-1" }), {}),
          /* @__PURE__ */ F("div", { className: "flex flex-col", children: [
            /* @__PURE__ */ d(Rt, { className: "text-sm font-semibold text-text-brand", children: i ? i.message : a }),
            /* @__PURE__ */ d(Rt, { className: "text-sm font-normal text-text-secondary", children: g5(l) })
          ] })
        ] }),
        /* @__PURE__ */ F("div", { className: "flex gap-2", children: [
          n && /* @__PURE__ */ d(Dt, { variant: "nostyle", onClick: r, children: /* @__PURE__ */ d(wa, { colorVariant: "primary" }) }),
          /* @__PURE__ */ d(Dt, { variant: "nostyle", onClick: t, children: /* @__PURE__ */ d(Yde, { colorVariant: "primary" }) })
        ] })
      ]
    }
  );
}, HI = O.createContext(
  {}
), dre = HI.Provider, t0 = () => {
  const e = O.useContext(HI);
  if (!e)
    throw new Error(
      "useNestedDropdownContext must be used within a NestedDropdownProvider"
    );
  return e;
}, hre = () => {
  const e = bt(), t = Xn(), n = t0(), r = t?.open, o = t?.disabled, {
    selected: i,
    placeholder: a,
    label: s,
    disabled: l,
    hint: c,
    error: u,
    required: f,
    inputLabelClassName: h,
    formatSelection: p
  } = n, C = I(
    "flex min-w-13 items-center justify-between rounded-md border border-border-input bg-white px-md py-[12px] text-left transition-all",
    "hover:border-neutral-400",
    "outline-none focus-visible:ring-surface-common-primary-light",
    "active:border-surface-common-primary active:ring-surface-common-primary-light",
    "focus:border-1 focus:border-surface-common-primary-light focus:ring-1 focus:ring-surface-common-primary-light",
    l && "bg-neutral-100 text-neutral-500 hover:border-border-input active:border-border-input"
  ), m = _e(
    () => i?.length ? p?.(i) ?? i.map((w) => w.label).join(", ") : a ?? "-",
    [p, a, i]
  ), g = () => c && !u && /* @__PURE__ */ d(Go, { className: I(l && "text-neutral-400"), children: c }), v = () => !!u && /* @__PURE__ */ d(Eo, { children: u }), y = () => /* @__PURE__ */ F("div", { id: `${e}-description`, children: [
    /* @__PURE__ */ d(g, {}),
    /* @__PURE__ */ d(v, {})
  ] });
  return /* @__PURE__ */ F("div", { className: "flex flex-col gap-xs", "aria-disabled": l, children: [
    s && /* @__PURE__ */ F(Ut, { htmlFor: e, id: `${e}-label`, weight: "semibold", children: [
      s,
      (u || f) && /* @__PURE__ */ d(
        "span",
        {
          "aria-label": "required field",
          className: "ml-[2px] text-ui-errorDark",
          children: "*"
        }
      )
    ] }),
    /* @__PURE__ */ d(
      Mn.Trigger,
      {
        disabled: l,
        className: "w-full",
        id: e,
        "aria-labelledby": `${e}-label`,
        "aria-describedby": `${e}-description`,
        children: /* @__PURE__ */ F("div", { className: C, children: [
          /* @__PURE__ */ d(Ut, { className: h, children: m }),
          /* @__PURE__ */ d(
            Gr,
            {
              flipVertical: r,
              accessibilityLabel: r ? "arrow up" : "arrow down",
              className: I(
                "text-surface-common-primary",
                o && "text-neutral-500"
              ),
              "aria-hidden": "true"
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ d(y, {})
  ] });
}, C5 = (e) => [
  e,
  ...(e.children ?? []).flatMap(C5)
], zI = (e, t) => {
  for (const n of e) {
    if (n.children?.some((r) => r.value === t.value)) return n;
    if (n.children) {
      const r = zI(n.children, t);
      if (r) return r;
    }
  }
  return null;
}, ZI = (e, t, n) => {
  const r = zI(n, e);
  if (!r) return;
  const o = r.children.every(
    (a) => t.some((s) => s.value === a.value)
  ), i = t.findIndex((a) => a.value === r.value);
  o && i === -1 && t.push(r), !o && i !== -1 && t.splice(i, 1), ZI(r, t, n);
}, pre = (e, t, n) => {
  const r = e.some((i) => i.value === t.value);
  let o;
  if (r) {
    const i = new Set(C5(t).map((a) => a.value));
    o = e.filter((a) => !i.has(a.value));
  } else {
    const i = /* @__PURE__ */ new Map();
    e.forEach((a) => i.set(a.value, a)), C5(t).forEach((a) => i.set(a.value, a)), o = Array.from(i.values());
  }
  return ZI(t, o, n), o;
}, mre = ({ option: e }) => {
  const t = t0(), n = bt(), {
    setSelected: r,
    selected: o,
    options: i,
    selectDescendants: a
  } = t, s = (C) => {
    if (a) {
      const m = pre(o, e, i);
      r(m);
    } else {
      const m = o.some((g) => g.value === e.value);
      r(m ? o.filter((g) => g.value !== e.value) : [...o, e]);
    }
  }, l = o.some((C) => C.value === e.value), c = C5(e).filter(
    (C) => C.value !== e.value
  ), u = c.some(
    (C) => o.some((m) => m.value === C.value)
  ), f = c.length > 0 && c.every((C) => o.some((m) => m.value === C.value)), h = !l && u && !f, p = e.label;
  return /* @__PURE__ */ F(
    "label",
    {
      htmlFor: n,
      className: I(
        "flex h-[23px] w-[calc(100%-16px)] cursor-pointer items-center gap-sm rounded-md p-sm hover:bg-surface-common-subtle"
      ),
      children: [
        /* @__PURE__ */ d(
          D2,
          {
            id: n,
            checked: l,
            indetermined: a && h ? "true" : "false",
            onChange: s
          }
        ),
        /* @__PURE__ */ d("span", { className: I(l && "font-semibold"), children: p })
      ]
    }
  );
}, gre = ({ option: e }) => {
  const t = t0(), { selected: n, setSelected: r } = t, o = _e(
    () => n[0]?.value === e?.value,
    [n, e]
  ), i = e.label;
  return /* @__PURE__ */ F(
    "button",
    {
      onClick: () => r([e]),
      className: I(
        "ring-none my-[1px] flex h-[39px] w-full cursor-pointer items-center justify-between gap-sm rounded-md border-none p-sm outline-none hover:bg-surface-common-subtle",
        "focus:bg-surface-common-subtle focus:ring-surface-common-primary-light",
        o && "bg-surface-common-subtle"
      ),
      children: [
        /* @__PURE__ */ d("span", { className: I("py-sm", o && "font-semibold"), children: i }),
        o && /* @__PURE__ */ d(k2, { className: "text-surface-common-primary" })
      ]
    }
  );
}, WI = ({ options: e, isChild: t = !1 }) => {
  const r = t0().type;
  return /* @__PURE__ */ d("ul", { className: I("ml-md flex flex-col", !t && "!ml-0"), children: e.map((o) => /* @__PURE__ */ F("li", { role: "button", children: [
    r === "multiple" ? /* @__PURE__ */ d(mre, { option: o }) : /* @__PURE__ */ d(gre, { option: o }),
    o.children && o.children.length > 0 && /* @__PURE__ */ d(WI, { options: o.children, isChild: !0 })
  ] }, o.value)) });
}, Cre = ({
  placeholder: e = "- ",
  options: t,
  type: n = "single",
  label: r,
  hint: o,
  error: i,
  disabled: a,
  required: s,
  selectDescendants: l = !1,
  inputLabelClassName: c,
  onChange: u,
  formatSelection: f,
  children: h,
  selected: p
}) => {
  const [C, m] = ue([]), g = (v) => {
    m(v), u?.(v);
  };
  return ve(() => {
    p && p !== C && m(p);
  }, [p]), /* @__PURE__ */ d(
    dre,
    {
      value: {
        type: n,
        options: t,
        placeholder: e,
        disabled: a,
        label: r,
        hint: o,
        error: i,
        required: s,
        selectDescendants: l,
        inputLabelClassName: c,
        formatSelection: f,
        selected: C,
        setSelected: g,
        onChange: u
      },
      children: /* @__PURE__ */ F(Mn, { autoSize: !0, children: [
        /* @__PURE__ */ d(hre, {}),
        /* @__PURE__ */ F(Mn.Content, { className: "w-full gap-0 !p-sm", children: [
          /* @__PURE__ */ d(WI, { options: t }),
          h
        ] })
      ] })
    }
  );
};
function qI({
  children: e,
  className: t = "",
  onClick: n
}) {
  return /* @__PURE__ */ F(ut, { children: [
    /* @__PURE__ */ d("hr", { className: "my-xs" }),
    /* @__PURE__ */ d(
      "div",
      {
        className: `flex w-full items-center justify-center ${t}`,
        onClick: n,
        children: e
      }
    ),
    " "
  ] });
}
qI.displayName = "NestedDropdownBlock";
const UI = Object.assign(Cre, {
  Block: qI
});
UI.displayName = "NestedDropdown";
UI.Block.displayName = "NestedDropdown.Block";
const vre = ({
  label: e,
  labelWeight: t = "normal",
  children: n,
  className: r,
  wrapperClassName: o,
  orientation: i = "horizontal",
  ...a
}) => {
  const { hint: s, errorMessage: l, disabled: c, loading: u, ...f } = a, h = I(r), p = I(
    "mt-2 flex gap-2",
    i === "horizontal" ? "flex-row" : "flex-col",
    o
  ), C = _e(() => c || u, [c, u]), m = () => s && !l && /* @__PURE__ */ d(Go, { className: I("mt-sm", c && "text-neutral-400"), children: s }), g = () => l && /* @__PURE__ */ d(Eo, { className: I("mt-sm text-ui-errorDark"), children: l }), v = () => /* @__PURE__ */ F(ut, { children: [
    /* @__PURE__ */ d(m, {}),
    /* @__PURE__ */ d(g, {})
  ] }), y = {
    "aria-disabled": c || u,
    "aria-busy": u,
    "aria-labelledby": "descriptor"
  }, w = _e(
    () => O.Children.map(
      n,
      (x) => O.isValidElement(
        x
      ) ? O.cloneElement(x, {
        disabled: C || !1
      }) : x
    ),
    [C, n]
  );
  return /* @__PURE__ */ F(
    "div",
    {
      className: h,
      role: "radiogroup",
      ...y,
      ...f,
      children: [
        /* @__PURE__ */ d(Ut, { id: "descriptor", weight: t, children: e }),
        /* @__PURE__ */ d("div", { className: p, id: "radioGroup", children: w }),
        /* @__PURE__ */ d(v, {})
      ]
    }
  );
}, nme = Object.assign(vre, {
  Radio: Cee
});
var d3, cy;
function Qn() {
  if (cy) return d3;
  cy = 1;
  var e = Array.isArray;
  return d3 = e, d3;
}
var h3, uy;
function GI() {
  if (uy) return h3;
  uy = 1;
  var e = typeof bc == "object" && bc && bc.Object === Object && bc;
  return h3 = e, h3;
}
var p3, fy;
function Oo() {
  if (fy) return p3;
  fy = 1;
  var e = GI(), t = typeof self == "object" && self && self.Object === Object && self, n = e || t || Function("return this")();
  return p3 = n, p3;
}
var m3, dy;
function z2() {
  if (dy) return m3;
  dy = 1;
  var e = Oo(), t = e.Symbol;
  return m3 = t, m3;
}
var g3, hy;
function yre() {
  if (hy) return g3;
  hy = 1;
  var e = z2(), t = Object.prototype, n = t.hasOwnProperty, r = t.toString, o = e ? e.toStringTag : void 0;
  function i(a) {
    var s = n.call(a, o), l = a[o];
    try {
      a[o] = void 0;
      var c = !0;
    } catch {
    }
    var u = r.call(a);
    return c && (s ? a[o] = l : delete a[o]), u;
  }
  return g3 = i, g3;
}
var C3, py;
function bre() {
  if (py) return C3;
  py = 1;
  var e = Object.prototype, t = e.toString;
  function n(r) {
    return t.call(r);
  }
  return C3 = n, C3;
}
var v3, my;
function t1() {
  if (my) return v3;
  my = 1;
  var e = z2(), t = yre(), n = bre(), r = "[object Null]", o = "[object Undefined]", i = e ? e.toStringTag : void 0;
  function a(s) {
    return s == null ? s === void 0 ? o : r : i && i in Object(s) ? t(s) : n(s);
  }
  return v3 = a, v3;
}
var y3, gy;
function n1() {
  if (gy) return y3;
  gy = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return y3 = e, y3;
}
var b3, Cy;
function Ss() {
  if (Cy) return b3;
  Cy = 1;
  var e = t1(), t = n1(), n = "[object Symbol]";
  function r(o) {
    return typeof o == "symbol" || t(o) && e(o) == n;
  }
  return b3 = r, b3;
}
var w3, vy;
function up() {
  if (vy) return w3;
  vy = 1;
  var e = Qn(), t = Ss(), n = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, r = /^\w*$/;
  function o(i, a) {
    if (e(i))
      return !1;
    var s = typeof i;
    return s == "number" || s == "symbol" || s == "boolean" || i == null || t(i) ? !0 : r.test(i) || !n.test(i) || a != null && i in Object(a);
  }
  return w3 = o, w3;
}
var x3, yy;
function V1() {
  if (yy) return x3;
  yy = 1;
  function e(t) {
    var n = typeof t;
    return t != null && (n == "object" || n == "function");
  }
  return x3 = e, x3;
}
var S3, by;
function fp() {
  if (by) return S3;
  by = 1;
  var e = t1(), t = V1(), n = "[object AsyncFunction]", r = "[object Function]", o = "[object GeneratorFunction]", i = "[object Proxy]";
  function a(s) {
    if (!t(s))
      return !1;
    var l = e(s);
    return l == r || l == o || l == n || l == i;
  }
  return S3 = a, S3;
}
var M3, wy;
function wre() {
  if (wy) return M3;
  wy = 1;
  var e = Oo(), t = e["__core-js_shared__"];
  return M3 = t, M3;
}
var E3, xy;
function xre() {
  if (xy) return E3;
  xy = 1;
  var e = wre(), t = (function() {
    var r = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return r ? "Symbol(src)_1." + r : "";
  })();
  function n(r) {
    return !!t && t in r;
  }
  return E3 = n, E3;
}
var _3, Sy;
function KI() {
  if (Sy) return _3;
  Sy = 1;
  var e = Function.prototype, t = e.toString;
  function n(r) {
    if (r != null) {
      try {
        return t.call(r);
      } catch {
      }
      try {
        return r + "";
      } catch {
      }
    }
    return "";
  }
  return _3 = n, _3;
}
var O3, My;
function Sre() {
  if (My) return O3;
  My = 1;
  var e = fp(), t = xre(), n = V1(), r = KI(), o = /[\\^$.*+?()[\]{}|]/g, i = /^\[object .+?Constructor\]$/, a = Function.prototype, s = Object.prototype, l = a.toString, c = s.hasOwnProperty, u = RegExp(
    "^" + l.call(c).replace(o, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!n(h) || t(h))
      return !1;
    var p = e(h) ? u : i;
    return p.test(r(h));
  }
  return O3 = f, O3;
}
var A3, Ey;
function Mre() {
  if (Ey) return A3;
  Ey = 1;
  function e(t, n) {
    return t?.[n];
  }
  return A3 = e, A3;
}
var P3, _y;
function Vi() {
  if (_y) return P3;
  _y = 1;
  var e = Sre(), t = Mre();
  function n(r, o) {
    var i = t(r, o);
    return e(i) ? i : void 0;
  }
  return P3 = n, P3;
}
var T3, Oy;
function n0() {
  if (Oy) return T3;
  Oy = 1;
  var e = Vi(), t = e(Object, "create");
  return T3 = t, T3;
}
var I3, Ay;
function Ere() {
  if (Ay) return I3;
  Ay = 1;
  var e = n0();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return I3 = t, I3;
}
var D3, Py;
function _re() {
  if (Py) return D3;
  Py = 1;
  function e(t) {
    var n = this.has(t) && delete this.__data__[t];
    return this.size -= n ? 1 : 0, n;
  }
  return D3 = e, D3;
}
var R3, Ty;
function Ore() {
  if (Ty) return R3;
  Ty = 1;
  var e = n0(), t = "__lodash_hash_undefined__", n = Object.prototype, r = n.hasOwnProperty;
  function o(i) {
    var a = this.__data__;
    if (e) {
      var s = a[i];
      return s === t ? void 0 : s;
    }
    return r.call(a, i) ? a[i] : void 0;
  }
  return R3 = o, R3;
}
var k3, Iy;
function Are() {
  if (Iy) return k3;
  Iy = 1;
  var e = n0(), t = Object.prototype, n = t.hasOwnProperty;
  function r(o) {
    var i = this.__data__;
    return e ? i[o] !== void 0 : n.call(i, o);
  }
  return k3 = r, k3;
}
var L3, Dy;
function Pre() {
  if (Dy) return L3;
  Dy = 1;
  var e = n0(), t = "__lodash_hash_undefined__";
  function n(r, o) {
    var i = this.__data__;
    return this.size += this.has(r) ? 0 : 1, i[r] = e && o === void 0 ? t : o, this;
  }
  return L3 = n, L3;
}
var N3, Ry;
function Tre() {
  if (Ry) return N3;
  Ry = 1;
  var e = Ere(), t = _re(), n = Ore(), r = Are(), o = Pre();
  function i(a) {
    var s = -1, l = a == null ? 0 : a.length;
    for (this.clear(); ++s < l; ) {
      var c = a[s];
      this.set(c[0], c[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = n, i.prototype.has = r, i.prototype.set = o, N3 = i, N3;
}
var F3, ky;
function Ire() {
  if (ky) return F3;
  ky = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return F3 = e, F3;
}
var V3, Ly;
function dp() {
  if (Ly) return V3;
  Ly = 1;
  function e(t, n) {
    return t === n || t !== t && n !== n;
  }
  return V3 = e, V3;
}
var B3, Ny;
function r0() {
  if (Ny) return B3;
  Ny = 1;
  var e = dp();
  function t(n, r) {
    for (var o = n.length; o--; )
      if (e(n[o][0], r))
        return o;
    return -1;
  }
  return B3 = t, B3;
}
var $3, Fy;
function Dre() {
  if (Fy) return $3;
  Fy = 1;
  var e = r0(), t = Array.prototype, n = t.splice;
  function r(o) {
    var i = this.__data__, a = e(i, o);
    if (a < 0)
      return !1;
    var s = i.length - 1;
    return a == s ? i.pop() : n.call(i, a, 1), --this.size, !0;
  }
  return $3 = r, $3;
}
var j3, Vy;
function Rre() {
  if (Vy) return j3;
  Vy = 1;
  var e = r0();
  function t(n) {
    var r = this.__data__, o = e(r, n);
    return o < 0 ? void 0 : r[o][1];
  }
  return j3 = t, j3;
}
var H3, By;
function kre() {
  if (By) return H3;
  By = 1;
  var e = r0();
  function t(n) {
    return e(this.__data__, n) > -1;
  }
  return H3 = t, H3;
}
var z3, $y;
function Lre() {
  if ($y) return z3;
  $y = 1;
  var e = r0();
  function t(n, r) {
    var o = this.__data__, i = e(o, n);
    return i < 0 ? (++this.size, o.push([n, r])) : o[i][1] = r, this;
  }
  return z3 = t, z3;
}
var Z3, jy;
function o0() {
  if (jy) return Z3;
  jy = 1;
  var e = Ire(), t = Dre(), n = Rre(), r = kre(), o = Lre();
  function i(a) {
    var s = -1, l = a == null ? 0 : a.length;
    for (this.clear(); ++s < l; ) {
      var c = a[s];
      this.set(c[0], c[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = n, i.prototype.has = r, i.prototype.set = o, Z3 = i, Z3;
}
var W3, Hy;
function hp() {
  if (Hy) return W3;
  Hy = 1;
  var e = Vi(), t = Oo(), n = e(t, "Map");
  return W3 = n, W3;
}
var q3, zy;
function Nre() {
  if (zy) return q3;
  zy = 1;
  var e = Tre(), t = o0(), n = hp();
  function r() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (n || t)(),
      string: new e()
    };
  }
  return q3 = r, q3;
}
var U3, Zy;
function Fre() {
  if (Zy) return U3;
  Zy = 1;
  function e(t) {
    var n = typeof t;
    return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? t !== "__proto__" : t === null;
  }
  return U3 = e, U3;
}
var G3, Wy;
function i0() {
  if (Wy) return G3;
  Wy = 1;
  var e = Fre();
  function t(n, r) {
    var o = n.__data__;
    return e(r) ? o[typeof r == "string" ? "string" : "hash"] : o.map;
  }
  return G3 = t, G3;
}
var K3, qy;
function Vre() {
  if (qy) return K3;
  qy = 1;
  var e = i0();
  function t(n) {
    var r = e(this, n).delete(n);
    return this.size -= r ? 1 : 0, r;
  }
  return K3 = t, K3;
}
var Y3, Uy;
function Bre() {
  if (Uy) return Y3;
  Uy = 1;
  var e = i0();
  function t(n) {
    return e(this, n).get(n);
  }
  return Y3 = t, Y3;
}
var X3, Gy;
function $re() {
  if (Gy) return X3;
  Gy = 1;
  var e = i0();
  function t(n) {
    return e(this, n).has(n);
  }
  return X3 = t, X3;
}
var Q3, Ky;
function jre() {
  if (Ky) return Q3;
  Ky = 1;
  var e = i0();
  function t(n, r) {
    var o = e(this, n), i = o.size;
    return o.set(n, r), this.size += o.size == i ? 0 : 1, this;
  }
  return Q3 = t, Q3;
}
var J3, Yy;
function pp() {
  if (Yy) return J3;
  Yy = 1;
  var e = Nre(), t = Vre(), n = Bre(), r = $re(), o = jre();
  function i(a) {
    var s = -1, l = a == null ? 0 : a.length;
    for (this.clear(); ++s < l; ) {
      var c = a[s];
      this.set(c[0], c[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = n, i.prototype.has = r, i.prototype.set = o, J3 = i, J3;
}
var e8, Xy;
function YI() {
  if (Xy) return e8;
  Xy = 1;
  var e = pp(), t = "Expected a function";
  function n(r, o) {
    if (typeof r != "function" || o != null && typeof o != "function")
      throw new TypeError(t);
    var i = function() {
      var a = arguments, s = o ? o.apply(this, a) : a[0], l = i.cache;
      if (l.has(s))
        return l.get(s);
      var c = r.apply(this, a);
      return i.cache = l.set(s, c) || l, c;
    };
    return i.cache = new (n.Cache || e)(), i;
  }
  return n.Cache = e, e8 = n, e8;
}
var t8, Qy;
function Hre() {
  if (Qy) return t8;
  Qy = 1;
  var e = YI(), t = 500;
  function n(r) {
    var o = e(r, function(a) {
      return i.size === t && i.clear(), a;
    }), i = o.cache;
    return o;
  }
  return t8 = n, t8;
}
var n8, Jy;
function zre() {
  if (Jy) return n8;
  Jy = 1;
  var e = Hre(), t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, n = /\\(\\)?/g, r = e(function(o) {
    var i = [];
    return o.charCodeAt(0) === 46 && i.push(""), o.replace(t, function(a, s, l, c) {
      i.push(l ? c.replace(n, "$1") : s || a);
    }), i;
  });
  return n8 = r, n8;
}
var r8, eb;
function mp() {
  if (eb) return r8;
  eb = 1;
  function e(t, n) {
    for (var r = -1, o = t == null ? 0 : t.length, i = Array(o); ++r < o; )
      i[r] = n(t[r], r, t);
    return i;
  }
  return r8 = e, r8;
}
var o8, tb;
function Zre() {
  if (tb) return o8;
  tb = 1;
  var e = z2(), t = mp(), n = Qn(), r = Ss(), o = e ? e.prototype : void 0, i = o ? o.toString : void 0;
  function a(s) {
    if (typeof s == "string")
      return s;
    if (n(s))
      return t(s, a) + "";
    if (r(s))
      return i ? i.call(s) : "";
    var l = s + "";
    return l == "0" && 1 / s == -1 / 0 ? "-0" : l;
  }
  return o8 = a, o8;
}
var i8, nb;
function XI() {
  if (nb) return i8;
  nb = 1;
  var e = Zre();
  function t(n) {
    return n == null ? "" : e(n);
  }
  return i8 = t, i8;
}
var a8, rb;
function QI() {
  if (rb) return a8;
  rb = 1;
  var e = Qn(), t = up(), n = zre(), r = XI();
  function o(i, a) {
    return e(i) ? i : t(i, a) ? [i] : n(r(i));
  }
  return a8 = o, a8;
}
var s8, ob;
function a0() {
  if (ob) return s8;
  ob = 1;
  var e = Ss();
  function t(n) {
    if (typeof n == "string" || e(n))
      return n;
    var r = n + "";
    return r == "0" && 1 / n == -1 / 0 ? "-0" : r;
  }
  return s8 = t, s8;
}
var l8, ib;
function gp() {
  if (ib) return l8;
  ib = 1;
  var e = QI(), t = a0();
  function n(r, o) {
    o = e(o, r);
    for (var i = 0, a = o.length; r != null && i < a; )
      r = r[t(o[i++])];
    return i && i == a ? r : void 0;
  }
  return l8 = n, l8;
}
var c8, ab;
function JI() {
  if (ab) return c8;
  ab = 1;
  var e = gp();
  function t(n, r, o) {
    var i = n == null ? void 0 : e(n, r);
    return i === void 0 ? o : i;
  }
  return c8 = t, c8;
}
var Wre = JI();
const Sr = /* @__PURE__ */ Mt(Wre);
var u8, sb;
function qre() {
  if (sb) return u8;
  sb = 1;
  function e(t) {
    return t == null;
  }
  return u8 = e, u8;
}
var Ure = qre();
const Ne = /* @__PURE__ */ Mt(Ure);
var f8, lb;
function Gre() {
  if (lb) return f8;
  lb = 1;
  var e = t1(), t = Qn(), n = n1(), r = "[object String]";
  function o(i) {
    return typeof i == "string" || !t(i) && n(i) && e(i) == r;
  }
  return f8 = o, f8;
}
var Kre = Gre();
const Ei = /* @__PURE__ */ Mt(Kre);
var Yre = fp();
const je = /* @__PURE__ */ Mt(Yre);
var Xre = V1();
const Ms = /* @__PURE__ */ Mt(Xre);
var Sc = { exports: {} }, st = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var cb;
function Qre() {
  if (cb) return st;
  cb = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), C;
  C = Symbol.for("react.module.reference");
  function m(g) {
    if (typeof g == "object" && g !== null) {
      var v = g.$$typeof;
      switch (v) {
        case e:
          switch (g = g.type, g) {
            case n:
            case o:
            case r:
            case c:
            case u:
              return g;
            default:
              switch (g = g && g.$$typeof, g) {
                case s:
                case a:
                case l:
                case h:
                case f:
                case i:
                  return g;
                default:
                  return v;
              }
          }
        case t:
          return v;
      }
    }
  }
  return st.ContextConsumer = a, st.ContextProvider = i, st.Element = e, st.ForwardRef = l, st.Fragment = n, st.Lazy = h, st.Memo = f, st.Portal = t, st.Profiler = o, st.StrictMode = r, st.Suspense = c, st.SuspenseList = u, st.isAsyncMode = function() {
    return !1;
  }, st.isConcurrentMode = function() {
    return !1;
  }, st.isContextConsumer = function(g) {
    return m(g) === a;
  }, st.isContextProvider = function(g) {
    return m(g) === i;
  }, st.isElement = function(g) {
    return typeof g == "object" && g !== null && g.$$typeof === e;
  }, st.isForwardRef = function(g) {
    return m(g) === l;
  }, st.isFragment = function(g) {
    return m(g) === n;
  }, st.isLazy = function(g) {
    return m(g) === h;
  }, st.isMemo = function(g) {
    return m(g) === f;
  }, st.isPortal = function(g) {
    return m(g) === t;
  }, st.isProfiler = function(g) {
    return m(g) === o;
  }, st.isStrictMode = function(g) {
    return m(g) === r;
  }, st.isSuspense = function(g) {
    return m(g) === c;
  }, st.isSuspenseList = function(g) {
    return m(g) === u;
  }, st.isValidElementType = function(g) {
    return typeof g == "string" || typeof g == "function" || g === n || g === o || g === r || g === c || g === u || g === p || typeof g == "object" && g !== null && (g.$$typeof === h || g.$$typeof === f || g.$$typeof === i || g.$$typeof === a || g.$$typeof === l || g.$$typeof === C || g.getModuleId !== void 0);
  }, st.typeOf = m, st;
}
var lt = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ub;
function Jre() {
  return ub || (ub = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), C = !1, m = !1, g = !1, v = !1, y = !1, w;
    w = Symbol.for("react.module.reference");
    function x(K) {
      return !!(typeof K == "string" || typeof K == "function" || K === n || K === o || y || K === r || K === c || K === u || v || K === p || C || m || g || typeof K == "object" && K !== null && (K.$$typeof === h || K.$$typeof === f || K.$$typeof === i || K.$$typeof === a || K.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      K.$$typeof === w || K.getModuleId !== void 0));
    }
    function b(K) {
      if (typeof K == "object" && K !== null) {
        var me = K.$$typeof;
        switch (me) {
          case e:
            var we = K.type;
            switch (we) {
              case n:
              case o:
              case r:
              case c:
              case u:
                return we;
              default:
                var ye = we && we.$$typeof;
                switch (ye) {
                  case s:
                  case a:
                  case l:
                  case h:
                  case f:
                  case i:
                    return ye;
                  default:
                    return me;
                }
            }
          case t:
            return me;
        }
      }
    }
    var S = a, M = i, E = e, P = l, T = n, _ = h, D = f, N = t, R = o, L = r, B = c, V = u, k = !1, z = !1;
    function $(K) {
      return k || (k = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function Z(K) {
      return z || (z = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function W(K) {
      return b(K) === a;
    }
    function H(K) {
      return b(K) === i;
    }
    function G(K) {
      return typeof K == "object" && K !== null && K.$$typeof === e;
    }
    function Y(K) {
      return b(K) === l;
    }
    function ne(K) {
      return b(K) === n;
    }
    function J(K) {
      return b(K) === h;
    }
    function ee(K) {
      return b(K) === f;
    }
    function U(K) {
      return b(K) === t;
    }
    function X(K) {
      return b(K) === o;
    }
    function ie(K) {
      return b(K) === r;
    }
    function j(K) {
      return b(K) === c;
    }
    function te(K) {
      return b(K) === u;
    }
    lt.ContextConsumer = S, lt.ContextProvider = M, lt.Element = E, lt.ForwardRef = P, lt.Fragment = T, lt.Lazy = _, lt.Memo = D, lt.Portal = N, lt.Profiler = R, lt.StrictMode = L, lt.Suspense = B, lt.SuspenseList = V, lt.isAsyncMode = $, lt.isConcurrentMode = Z, lt.isContextConsumer = W, lt.isContextProvider = H, lt.isElement = G, lt.isForwardRef = Y, lt.isFragment = ne, lt.isLazy = J, lt.isMemo = ee, lt.isPortal = U, lt.isProfiler = X, lt.isStrictMode = ie, lt.isSuspense = j, lt.isSuspenseList = te, lt.isValidElementType = x, lt.typeOf = b;
  })()), lt;
}
var fb;
function eoe() {
  return fb || (fb = 1, process.env.NODE_ENV === "production" ? Sc.exports = Qre() : Sc.exports = Jre()), Sc.exports;
}
var toe = eoe(), d8, db;
function eD() {
  if (db) return d8;
  db = 1;
  var e = t1(), t = n1(), n = "[object Number]";
  function r(o) {
    return typeof o == "number" || t(o) && e(o) == n;
  }
  return d8 = r, d8;
}
var h8, hb;
function noe() {
  if (hb) return h8;
  hb = 1;
  var e = eD();
  function t(n) {
    return e(n) && n != +n;
  }
  return h8 = t, h8;
}
var roe = noe();
const Es = /* @__PURE__ */ Mt(roe);
var ooe = eD();
const ioe = /* @__PURE__ */ Mt(ooe);
var jr = function(t) {
  return t === 0 ? 0 : t > 0 ? 1 : -1;
}, ii = function(t) {
  return Ei(t) && t.indexOf("%") === t.length - 1;
}, he = function(t) {
  return ioe(t) && !Es(t);
}, aoe = function(t) {
  return Ne(t);
}, ln = function(t) {
  return he(t) || Ei(t);
}, soe = 0, Bi = function(t) {
  var n = ++soe;
  return "".concat(t || "").concat(n);
}, _i = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if (!he(t) && !Ei(t))
    return r;
  var i;
  if (ii(t)) {
    var a = t.indexOf("%");
    i = n * parseFloat(t.slice(0, a)) / 100;
  } else
    i = +t;
  return Es(i) && (i = r), o && i > n && (i = n), i;
}, p1 = function(t) {
  if (!t)
    return null;
  var n = Object.keys(t);
  return n && n.length ? t[n[0]] : null;
}, loe = function(t) {
  if (!Array.isArray(t))
    return !1;
  for (var n = t.length, r = {}, o = 0; o < n; o++)
    if (!r[t[o]])
      r[t[o]] = !0;
    else
      return !0;
  return !1;
}, jt = function(t, n) {
  return he(t) && he(n) ? function(r) {
    return t + r * (n - t);
  } : function() {
    return n;
  };
};
function v5(e, t, n) {
  return !e || !e.length ? null : e.find(function(r) {
    return r && (typeof t == "function" ? t(r) : Sr(r, t)) === n;
  });
}
var coe = function(t) {
  if (!t || !t.length)
    return null;
  for (var n = t.length, r = 0, o = 0, i = 0, a = 0, s = 1 / 0, l = -1 / 0, c = 0, u = 0, f = 0; f < n; f++)
    c = t[f].cx || 0, u = t[f].cy || 0, r += c, o += u, i += c * u, a += c * c, s = Math.min(s, c), l = Math.max(l, c);
  var h = n * a !== r * r ? (n * i - r * o) / (n * a - r * r) : 0;
  return {
    xmin: s,
    xmax: l,
    a: h,
    b: (o - h * r) / n
  };
}, uoe = function(t, n) {
  return he(t) && he(n) ? t - n : Ei(t) && Ei(n) ? t.localeCompare(n) : t instanceof Date && n instanceof Date ? t.getTime() - n.getTime() : String(t).localeCompare(String(n));
};
function Ta(e, t) {
  for (var n in e)
    if ({}.hasOwnProperty.call(e, n) && (!{}.hasOwnProperty.call(t, n) || e[n] !== t[n]))
      return !1;
  for (var r in t)
    if ({}.hasOwnProperty.call(t, r) && !{}.hasOwnProperty.call(e, r))
      return !1;
  return !0;
}
function sf(e) {
  "@babel/helpers - typeof";
  return sf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, sf(e);
}
var foe = ["viewBox", "children"], doe = [
  "aria-activedescendant",
  "aria-atomic",
  "aria-autocomplete",
  "aria-busy",
  "aria-checked",
  "aria-colcount",
  "aria-colindex",
  "aria-colspan",
  "aria-controls",
  "aria-current",
  "aria-describedby",
  "aria-details",
  "aria-disabled",
  "aria-errormessage",
  "aria-expanded",
  "aria-flowto",
  "aria-haspopup",
  "aria-hidden",
  "aria-invalid",
  "aria-keyshortcuts",
  "aria-label",
  "aria-labelledby",
  "aria-level",
  "aria-live",
  "aria-modal",
  "aria-multiline",
  "aria-multiselectable",
  "aria-orientation",
  "aria-owns",
  "aria-placeholder",
  "aria-posinset",
  "aria-pressed",
  "aria-readonly",
  "aria-relevant",
  "aria-required",
  "aria-roledescription",
  "aria-rowcount",
  "aria-rowindex",
  "aria-rowspan",
  "aria-selected",
  "aria-setsize",
  "aria-sort",
  "aria-valuemax",
  "aria-valuemin",
  "aria-valuenow",
  "aria-valuetext",
  "className",
  "color",
  "height",
  "id",
  "lang",
  "max",
  "media",
  "method",
  "min",
  "name",
  "style",
  /*
   * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
   * that can use it and it conflicts with the recharts prop 'type'
   * https://github.com/recharts/recharts/pull/3327
   * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
   */
  // 'type',
  "target",
  "width",
  "role",
  "tabIndex",
  "accentHeight",
  "accumulate",
  "additive",
  "alignmentBaseline",
  "allowReorder",
  "alphabetic",
  "amplitude",
  "arabicForm",
  "ascent",
  "attributeName",
  "attributeType",
  "autoReverse",
  "azimuth",
  "baseFrequency",
  "baselineShift",
  "baseProfile",
  "bbox",
  "begin",
  "bias",
  "by",
  "calcMode",
  "capHeight",
  "clip",
  "clipPath",
  "clipPathUnits",
  "clipRule",
  "colorInterpolation",
  "colorInterpolationFilters",
  "colorProfile",
  "colorRendering",
  "contentScriptType",
  "contentStyleType",
  "cursor",
  "cx",
  "cy",
  "d",
  "decelerate",
  "descent",
  "diffuseConstant",
  "direction",
  "display",
  "divisor",
  "dominantBaseline",
  "dur",
  "dx",
  "dy",
  "edgeMode",
  "elevation",
  "enableBackground",
  "end",
  "exponent",
  "externalResourcesRequired",
  "fill",
  "fillOpacity",
  "fillRule",
  "filter",
  "filterRes",
  "filterUnits",
  "floodColor",
  "floodOpacity",
  "focusable",
  "fontFamily",
  "fontSize",
  "fontSizeAdjust",
  "fontStretch",
  "fontStyle",
  "fontVariant",
  "fontWeight",
  "format",
  "from",
  "fx",
  "fy",
  "g1",
  "g2",
  "glyphName",
  "glyphOrientationHorizontal",
  "glyphOrientationVertical",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "hanging",
  "horizAdvX",
  "horizOriginX",
  "href",
  "ideographic",
  "imageRendering",
  "in2",
  "in",
  "intercept",
  "k1",
  "k2",
  "k3",
  "k4",
  "k",
  "kernelMatrix",
  "kernelUnitLength",
  "kerning",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "letterSpacing",
  "lightingColor",
  "limitingConeAngle",
  "local",
  "markerEnd",
  "markerHeight",
  "markerMid",
  "markerStart",
  "markerUnits",
  "markerWidth",
  "mask",
  "maskContentUnits",
  "maskUnits",
  "mathematical",
  "mode",
  "numOctaves",
  "offset",
  "opacity",
  "operator",
  "order",
  "orient",
  "orientation",
  "origin",
  "overflow",
  "overlinePosition",
  "overlineThickness",
  "paintOrder",
  "panose1",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointerEvents",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "r",
  "radius",
  "refX",
  "refY",
  "renderingIntent",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "restart",
  "result",
  "rotate",
  "rx",
  "ry",
  "seed",
  "shapeRendering",
  "slope",
  "spacing",
  "specularConstant",
  "specularExponent",
  "speed",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stemh",
  "stemv",
  "stitchTiles",
  "stopColor",
  "stopOpacity",
  "strikethroughPosition",
  "strikethroughThickness",
  "string",
  "stroke",
  "strokeDasharray",
  "strokeDashoffset",
  "strokeLinecap",
  "strokeLinejoin",
  "strokeMiterlimit",
  "strokeOpacity",
  "strokeWidth",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textAnchor",
  "textDecoration",
  "textLength",
  "textRendering",
  "to",
  "transform",
  "u1",
  "u2",
  "underlinePosition",
  "underlineThickness",
  "unicode",
  "unicodeBidi",
  "unicodeRange",
  "unitsPerEm",
  "vAlphabetic",
  "values",
  "vectorEffect",
  "version",
  "vertAdvY",
  "vertOriginX",
  "vertOriginY",
  "vHanging",
  "vIdeographic",
  "viewTarget",
  "visibility",
  "vMathematical",
  "widths",
  "wordSpacing",
  "writingMode",
  "x1",
  "x2",
  "x",
  "xChannelSelector",
  "xHeight",
  "xlinkActuate",
  "xlinkArcrole",
  "xlinkHref",
  "xlinkRole",
  "xlinkShow",
  "xlinkTitle",
  "xlinkType",
  "xmlBase",
  "xmlLang",
  "xmlns",
  "xmlnsXlink",
  "xmlSpace",
  "y1",
  "y2",
  "y",
  "yChannelSelector",
  "z",
  "zoomAndPan",
  "ref",
  "key",
  "angle"
], pb = ["points", "pathLength"], p8 = {
  svg: foe,
  polygon: pb,
  polyline: pb
}, Cp = ["dangerouslySetInnerHTML", "onCopy", "onCopyCapture", "onCut", "onCutCapture", "onPaste", "onPasteCapture", "onCompositionEnd", "onCompositionEndCapture", "onCompositionStart", "onCompositionStartCapture", "onCompositionUpdate", "onCompositionUpdateCapture", "onFocus", "onFocusCapture", "onBlur", "onBlurCapture", "onChange", "onChangeCapture", "onBeforeInput", "onBeforeInputCapture", "onInput", "onInputCapture", "onReset", "onResetCapture", "onSubmit", "onSubmitCapture", "onInvalid", "onInvalidCapture", "onLoad", "onLoadCapture", "onError", "onErrorCapture", "onKeyDown", "onKeyDownCapture", "onKeyPress", "onKeyPressCapture", "onKeyUp", "onKeyUpCapture", "onAbort", "onAbortCapture", "onCanPlay", "onCanPlayCapture", "onCanPlayThrough", "onCanPlayThroughCapture", "onDurationChange", "onDurationChangeCapture", "onEmptied", "onEmptiedCapture", "onEncrypted", "onEncryptedCapture", "onEnded", "onEndedCapture", "onLoadedData", "onLoadedDataCapture", "onLoadedMetadata", "onLoadedMetadataCapture", "onLoadStart", "onLoadStartCapture", "onPause", "onPauseCapture", "onPlay", "onPlayCapture", "onPlaying", "onPlayingCapture", "onProgress", "onProgressCapture", "onRateChange", "onRateChangeCapture", "onSeeked", "onSeekedCapture", "onSeeking", "onSeekingCapture", "onStalled", "onStalledCapture", "onSuspend", "onSuspendCapture", "onTimeUpdate", "onTimeUpdateCapture", "onVolumeChange", "onVolumeChangeCapture", "onWaiting", "onWaitingCapture", "onAuxClick", "onAuxClickCapture", "onClick", "onClickCapture", "onContextMenu", "onContextMenuCapture", "onDoubleClick", "onDoubleClickCapture", "onDrag", "onDragCapture", "onDragEnd", "onDragEndCapture", "onDragEnter", "onDragEnterCapture", "onDragExit", "onDragExitCapture", "onDragLeave", "onDragLeaveCapture", "onDragOver", "onDragOverCapture", "onDragStart", "onDragStartCapture", "onDrop", "onDropCapture", "onMouseDown", "onMouseDownCapture", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseMoveCapture", "onMouseOut", "onMouseOutCapture", "onMouseOver", "onMouseOverCapture", "onMouseUp", "onMouseUpCapture", "onSelect", "onSelectCapture", "onTouchCancel", "onTouchCancelCapture", "onTouchEnd", "onTouchEndCapture", "onTouchMove", "onTouchMoveCapture", "onTouchStart", "onTouchStartCapture", "onPointerDown", "onPointerDownCapture", "onPointerMove", "onPointerMoveCapture", "onPointerUp", "onPointerUpCapture", "onPointerCancel", "onPointerCancelCapture", "onPointerEnter", "onPointerEnterCapture", "onPointerLeave", "onPointerLeaveCapture", "onPointerOver", "onPointerOverCapture", "onPointerOut", "onPointerOutCapture", "onGotPointerCapture", "onGotPointerCaptureCapture", "onLostPointerCapture", "onLostPointerCaptureCapture", "onScroll", "onScrollCapture", "onWheel", "onWheelCapture", "onAnimationStart", "onAnimationStartCapture", "onAnimationEnd", "onAnimationEndCapture", "onAnimationIteration", "onAnimationIterationCapture", "onTransitionEnd", "onTransitionEndCapture"], y5 = function(t, n) {
  if (!t || typeof t == "function" || typeof t == "boolean")
    return null;
  var r = t;
  if (/* @__PURE__ */ sr(t) && (r = t.props), !Ms(r))
    return null;
  var o = {};
  return Object.keys(r).forEach(function(i) {
    Cp.includes(i) && (o[i] = n || function(a) {
      return r[i](r, a);
    });
  }), o;
}, hoe = function(t, n, r) {
  return function(o) {
    return t(n, r, o), null;
  };
}, jl = function(t, n, r) {
  if (!Ms(t) || sf(t) !== "object")
    return null;
  var o = null;
  return Object.keys(t).forEach(function(i) {
    var a = t[i];
    Cp.includes(i) && typeof a == "function" && (o || (o = {}), o[i] = hoe(a, n, r));
  }), o;
}, poe = ["children"], moe = ["children"];
function mb(e, t) {
  if (e == null) return {};
  var n = goe(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function goe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function lf(e) {
  "@babel/helpers - typeof";
  return lf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, lf(e);
}
var gb = {
  click: "onClick",
  mousedown: "onMouseDown",
  mouseup: "onMouseUp",
  mouseover: "onMouseOver",
  mousemove: "onMouseMove",
  mouseout: "onMouseOut",
  mouseenter: "onMouseEnter",
  mouseleave: "onMouseLeave",
  touchcancel: "onTouchCancel",
  touchend: "onTouchEnd",
  touchmove: "onTouchMove",
  touchstart: "onTouchStart",
  contextmenu: "onContextMenu",
  dblclick: "onDoubleClick"
}, Zo = function(t) {
  return typeof t == "string" ? t : t ? t.displayName || t.name || "Component" : "";
}, Cb = null, m8 = null, vp = function e(t) {
  if (t === Cb && Array.isArray(m8))
    return m8;
  var n = [];
  return ar.forEach(t, function(r) {
    Ne(r) || (toe.isFragment(r) ? n = n.concat(e(r.props.children)) : n.push(r));
  }), m8 = n, Cb = t, n;
};
function Yn(e, t) {
  var n = [], r = [];
  return Array.isArray(t) ? r = t.map(function(o) {
    return Zo(o);
  }) : r = [Zo(t)], vp(e).forEach(function(o) {
    var i = Sr(o, "type.displayName") || Sr(o, "type.name");
    r.indexOf(i) !== -1 && n.push(o);
  }), n;
}
function nr(e, t) {
  var n = Yn(e, t);
  return n && n[0];
}
var vb = function(t) {
  if (!t || !t.props)
    return !1;
  var n = t.props, r = n.width, o = n.height;
  return !(!he(r) || r <= 0 || !he(o) || o <= 0);
}, Coe = ["a", "altGlyph", "altGlyphDef", "altGlyphItem", "animate", "animateColor", "animateMotion", "animateTransform", "circle", "clipPath", "color-profile", "cursor", "defs", "desc", "ellipse", "feBlend", "feColormatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "font", "font-face", "font-face-format", "font-face-name", "font-face-url", "foreignObject", "g", "glyph", "glyphRef", "hkern", "image", "line", "lineGradient", "marker", "mask", "metadata", "missing-glyph", "mpath", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "script", "set", "stop", "style", "svg", "switch", "symbol", "text", "textPath", "title", "tref", "tspan", "use", "view", "vkern"], voe = function(t) {
  return t && t.type && Ei(t.type) && Coe.indexOf(t.type) >= 0;
}, tD = function(t) {
  return t && lf(t) === "object" && "clipDot" in t;
}, yoe = function(t, n, r, o) {
  var i, a = (i = p8?.[o]) !== null && i !== void 0 ? i : [];
  return n.startsWith("data-") || !je(t) && (o && a.includes(n) || doe.includes(n)) || r && Cp.includes(n);
}, Be = function(t, n, r) {
  if (!t || typeof t == "function" || typeof t == "boolean")
    return null;
  var o = t;
  if (/* @__PURE__ */ sr(t) && (o = t.props), !Ms(o))
    return null;
  var i = {};
  return Object.keys(o).forEach(function(a) {
    var s;
    yoe((s = o) === null || s === void 0 ? void 0 : s[a], a, n, r) && (i[a] = o[a]);
  }), i;
}, cf = function e(t, n) {
  if (t === n)
    return !0;
  var r = ar.count(t);
  if (r !== ar.count(n))
    return !1;
  if (r === 0)
    return !0;
  if (r === 1)
    return yb(Array.isArray(t) ? t[0] : t, Array.isArray(n) ? n[0] : n);
  for (var o = 0; o < r; o++) {
    var i = t[o], a = n[o];
    if (Array.isArray(i) || Array.isArray(a)) {
      if (!e(i, a))
        return !1;
    } else if (!yb(i, a))
      return !1;
  }
  return !0;
}, yb = function(t, n) {
  if (Ne(t) && Ne(n))
    return !0;
  if (!Ne(t) && !Ne(n)) {
    var r = t.props || {}, o = r.children, i = mb(r, poe), a = n.props || {}, s = a.children, l = mb(a, moe);
    return o && s ? Ta(i, l) && cf(o, s) : !o && !s ? Ta(i, l) : !1;
  }
  return !1;
}, bb = function(t, n) {
  var r = [], o = {};
  return vp(t).forEach(function(i, a) {
    if (voe(i))
      r.push(i);
    else if (i) {
      var s = Zo(i.type), l = n[s] || {}, c = l.handler, u = l.once;
      if (c && (!u || !o[s])) {
        var f = c(i, s, a);
        r.push(f), o[s] = !0;
      }
    }
  }), r;
}, boe = function(t) {
  var n = t && t.type;
  return n && gb[n] ? gb[n] : null;
}, woe = function(t, n) {
  return vp(n).indexOf(t);
}, xoe = ["children", "width", "height", "viewBox", "className", "style", "title", "desc"];
function uf() {
  return uf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, uf.apply(this, arguments);
}
function Soe(e, t) {
  if (e == null) return {};
  var n = Moe(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Moe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function ff(e) {
  var t = e.children, n = e.width, r = e.height, o = e.viewBox, i = e.className, a = e.style, s = e.title, l = e.desc, c = Soe(e, xoe), u = o || {
    width: n,
    height: r,
    x: 0,
    y: 0
  }, f = We("recharts-surface", i);
  return /* @__PURE__ */ O.createElement("svg", uf({}, Be(c, !0, "svg"), {
    className: f,
    width: n,
    height: r,
    style: a,
    viewBox: "".concat(u.x, " ").concat(u.y, " ").concat(u.width, " ").concat(u.height)
  }), /* @__PURE__ */ O.createElement("title", null, s), /* @__PURE__ */ O.createElement("desc", null, l), t);
}
var Eoe = ["children", "className"];
function df() {
  return df = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, df.apply(this, arguments);
}
function _oe(e, t) {
  if (e == null) return {};
  var n = Ooe(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Ooe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
var rt = /* @__PURE__ */ O.forwardRef(function(e, t) {
  var n = e.children, r = e.className, o = _oe(e, Eoe), i = We("recharts-layer", r);
  return /* @__PURE__ */ O.createElement("g", df({
    className: i
  }, Be(o, !0), {
    ref: t
  }), n);
}), Aoe = process.env.NODE_ENV !== "production", Wo = function(t, n) {
  for (var r = arguments.length, o = new Array(r > 2 ? r - 2 : 0), i = 2; i < r; i++)
    o[i - 2] = arguments[i];
  if (Aoe && typeof console < "u" && console.warn && (n === void 0 && console.warn("LogUtils requires an error message argument"), !t))
    if (n === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var a = 0;
      console.warn(n.replace(/%s/g, function() {
        return o[a++];
      }));
    }
}, g8, wb;
function Poe() {
  if (wb) return g8;
  wb = 1;
  function e(t, n, r) {
    var o = -1, i = t.length;
    n < 0 && (n = -n > i ? 0 : i + n), r = r > i ? i : r, r < 0 && (r += i), i = n > r ? 0 : r - n >>> 0, n >>>= 0;
    for (var a = Array(i); ++o < i; )
      a[o] = t[o + n];
    return a;
  }
  return g8 = e, g8;
}
var C8, xb;
function Toe() {
  if (xb) return C8;
  xb = 1;
  var e = Poe();
  function t(n, r, o) {
    var i = n.length;
    return o = o === void 0 ? i : o, !r && o >= i ? n : e(n, r, o);
  }
  return C8 = t, C8;
}
var v8, Sb;
function nD() {
  if (Sb) return v8;
  Sb = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", n = "\\ufe20-\\ufe2f", r = "\\u20d0-\\u20ff", o = t + n + r, i = "\\ufe0e\\ufe0f", a = "\\u200d", s = RegExp("[" + a + e + o + i + "]");
  function l(c) {
    return s.test(c);
  }
  return v8 = l, v8;
}
var y8, Mb;
function Ioe() {
  if (Mb) return y8;
  Mb = 1;
  function e(t) {
    return t.split("");
  }
  return y8 = e, y8;
}
var b8, Eb;
function Doe() {
  if (Eb) return b8;
  Eb = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", n = "\\ufe20-\\ufe2f", r = "\\u20d0-\\u20ff", o = t + n + r, i = "\\ufe0e\\ufe0f", a = "[" + e + "]", s = "[" + o + "]", l = "\\ud83c[\\udffb-\\udfff]", c = "(?:" + s + "|" + l + ")", u = "[^" + e + "]", f = "(?:\\ud83c[\\udde6-\\uddff]){2}", h = "[\\ud800-\\udbff][\\udc00-\\udfff]", p = "\\u200d", C = c + "?", m = "[" + i + "]?", g = "(?:" + p + "(?:" + [u, f, h].join("|") + ")" + m + C + ")*", v = m + C + g, y = "(?:" + [u + s + "?", s, f, h, a].join("|") + ")", w = RegExp(l + "(?=" + l + ")|" + y + v, "g");
  function x(b) {
    return b.match(w) || [];
  }
  return b8 = x, b8;
}
var w8, _b;
function Roe() {
  if (_b) return w8;
  _b = 1;
  var e = Ioe(), t = nD(), n = Doe();
  function r(o) {
    return t(o) ? n(o) : e(o);
  }
  return w8 = r, w8;
}
var x8, Ob;
function koe() {
  if (Ob) return x8;
  Ob = 1;
  var e = Toe(), t = nD(), n = Roe(), r = XI();
  function o(i) {
    return function(a) {
      a = r(a);
      var s = t(a) ? n(a) : void 0, l = s ? s[0] : a.charAt(0), c = s ? e(s, 1).join("") : a.slice(1);
      return l[i]() + c;
    };
  }
  return x8 = o, x8;
}
var S8, Ab;
function Loe() {
  if (Ab) return S8;
  Ab = 1;
  var e = koe(), t = e("toUpperCase");
  return S8 = t, S8;
}
var Noe = Loe();
const s0 = /* @__PURE__ */ Mt(Noe);
function xt(e) {
  return function() {
    return e;
  };
}
const rD = Math.cos, b5 = Math.sin, Kr = Math.sqrt, w5 = Math.PI, l0 = 2 * w5, hf = Math.PI, pf = 2 * hf, Q1 = 1e-6, Foe = pf - Q1;
function oD(e) {
  this._ += e[0];
  for (let t = 1, n = e.length; t < n; ++t)
    this._ += arguments[t] + e[t];
}
function Voe(e) {
  let t = Math.floor(e);
  if (!(t >= 0)) throw new Error(`invalid digits: ${e}`);
  if (t > 15) return oD;
  const n = 10 ** t;
  return function(r) {
    this._ += r[0];
    for (let o = 1, i = r.length; o < i; ++o)
      this._ += Math.round(arguments[o] * n) / n + r[o];
  };
}
class Boe {
  constructor(t) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = t == null ? oD : Voe(t);
  }
  moveTo(t, n) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +n}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(t, n) {
    this._append`L${this._x1 = +t},${this._y1 = +n}`;
  }
  quadraticCurveTo(t, n, r, o) {
    this._append`Q${+t},${+n},${this._x1 = +r},${this._y1 = +o}`;
  }
  bezierCurveTo(t, n, r, o, i, a) {
    this._append`C${+t},${+n},${+r},${+o},${this._x1 = +i},${this._y1 = +a}`;
  }
  arcTo(t, n, r, o, i) {
    if (t = +t, n = +n, r = +r, o = +o, i = +i, i < 0) throw new Error(`negative radius: ${i}`);
    let a = this._x1, s = this._y1, l = r - t, c = o - n, u = a - t, f = s - n, h = u * u + f * f;
    if (this._x1 === null)
      this._append`M${this._x1 = t},${this._y1 = n}`;
    else if (h > Q1) if (!(Math.abs(f * l - c * u) > Q1) || !i)
      this._append`L${this._x1 = t},${this._y1 = n}`;
    else {
      let p = r - a, C = o - s, m = l * l + c * c, g = p * p + C * C, v = Math.sqrt(m), y = Math.sqrt(h), w = i * Math.tan((hf - Math.acos((m + h - g) / (2 * v * y))) / 2), x = w / y, b = w / v;
      Math.abs(x - 1) > Q1 && this._append`L${t + x * u},${n + x * f}`, this._append`A${i},${i},0,0,${+(f * p > u * C)},${this._x1 = t + b * l},${this._y1 = n + b * c}`;
    }
  }
  arc(t, n, r, o, i, a) {
    if (t = +t, n = +n, r = +r, a = !!a, r < 0) throw new Error(`negative radius: ${r}`);
    let s = r * Math.cos(o), l = r * Math.sin(o), c = t + s, u = n + l, f = 1 ^ a, h = a ? o - i : i - o;
    this._x1 === null ? this._append`M${c},${u}` : (Math.abs(this._x1 - c) > Q1 || Math.abs(this._y1 - u) > Q1) && this._append`L${c},${u}`, r && (h < 0 && (h = h % pf + pf), h > Foe ? this._append`A${r},${r},0,1,${f},${t - s},${n - l}A${r},${r},0,1,${f},${this._x1 = c},${this._y1 = u}` : h > Q1 && this._append`A${r},${r},0,${+(h >= hf)},${f},${this._x1 = t + r * Math.cos(i)},${this._y1 = n + r * Math.sin(i)}`);
  }
  rect(t, n, r, o) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +n}h${r = +r}v${+o}h${-r}Z`;
  }
  toString() {
    return this._;
  }
}
function yp(e) {
  let t = 3;
  return e.digits = function(n) {
    if (!arguments.length) return t;
    if (n == null)
      t = null;
    else {
      const r = Math.floor(n);
      if (!(r >= 0)) throw new RangeError(`invalid digits: ${n}`);
      t = r;
    }
    return e;
  }, () => new Boe(t);
}
function bp(e) {
  return typeof e == "object" && "length" in e ? e : Array.from(e);
}
function iD(e) {
  this._context = e;
}
iD.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      // falls through
      default:
        this._context.lineTo(e, t);
        break;
    }
  }
};
function c0(e) {
  return new iD(e);
}
function aD(e) {
  return e[0];
}
function sD(e) {
  return e[1];
}
function lD(e, t) {
  var n = xt(!0), r = null, o = c0, i = null, a = yp(s);
  e = typeof e == "function" ? e : e === void 0 ? aD : xt(e), t = typeof t == "function" ? t : t === void 0 ? sD : xt(t);
  function s(l) {
    var c, u = (l = bp(l)).length, f, h = !1, p;
    for (r == null && (i = o(p = a())), c = 0; c <= u; ++c)
      !(c < u && n(f = l[c], c, l)) === h && ((h = !h) ? i.lineStart() : i.lineEnd()), h && i.point(+e(f, c, l), +t(f, c, l));
    if (p) return i = null, p + "" || null;
  }
  return s.x = function(l) {
    return arguments.length ? (e = typeof l == "function" ? l : xt(+l), s) : e;
  }, s.y = function(l) {
    return arguments.length ? (t = typeof l == "function" ? l : xt(+l), s) : t;
  }, s.defined = function(l) {
    return arguments.length ? (n = typeof l == "function" ? l : xt(!!l), s) : n;
  }, s.curve = function(l) {
    return arguments.length ? (o = l, r != null && (i = o(r)), s) : o;
  }, s.context = function(l) {
    return arguments.length ? (l == null ? r = i = null : i = o(r = l), s) : r;
  }, s;
}
function Mc(e, t, n) {
  var r = null, o = xt(!0), i = null, a = c0, s = null, l = yp(c);
  e = typeof e == "function" ? e : e === void 0 ? aD : xt(+e), t = typeof t == "function" ? t : xt(t === void 0 ? 0 : +t), n = typeof n == "function" ? n : n === void 0 ? sD : xt(+n);
  function c(f) {
    var h, p, C, m = (f = bp(f)).length, g, v = !1, y, w = new Array(m), x = new Array(m);
    for (i == null && (s = a(y = l())), h = 0; h <= m; ++h) {
      if (!(h < m && o(g = f[h], h, f)) === v)
        if (v = !v)
          p = h, s.areaStart(), s.lineStart();
        else {
          for (s.lineEnd(), s.lineStart(), C = h - 1; C >= p; --C)
            s.point(w[C], x[C]);
          s.lineEnd(), s.areaEnd();
        }
      v && (w[h] = +e(g, h, f), x[h] = +t(g, h, f), s.point(r ? +r(g, h, f) : w[h], n ? +n(g, h, f) : x[h]));
    }
    if (y) return s = null, y + "" || null;
  }
  function u() {
    return lD().defined(o).curve(a).context(i);
  }
  return c.x = function(f) {
    return arguments.length ? (e = typeof f == "function" ? f : xt(+f), r = null, c) : e;
  }, c.x0 = function(f) {
    return arguments.length ? (e = typeof f == "function" ? f : xt(+f), c) : e;
  }, c.x1 = function(f) {
    return arguments.length ? (r = f == null ? null : typeof f == "function" ? f : xt(+f), c) : r;
  }, c.y = function(f) {
    return arguments.length ? (t = typeof f == "function" ? f : xt(+f), n = null, c) : t;
  }, c.y0 = function(f) {
    return arguments.length ? (t = typeof f == "function" ? f : xt(+f), c) : t;
  }, c.y1 = function(f) {
    return arguments.length ? (n = f == null ? null : typeof f == "function" ? f : xt(+f), c) : n;
  }, c.lineX0 = c.lineY0 = function() {
    return u().x(e).y(t);
  }, c.lineY1 = function() {
    return u().x(e).y(n);
  }, c.lineX1 = function() {
    return u().x(r).y(t);
  }, c.defined = function(f) {
    return arguments.length ? (o = typeof f == "function" ? f : xt(!!f), c) : o;
  }, c.curve = function(f) {
    return arguments.length ? (a = f, i != null && (s = a(i)), c) : a;
  }, c.context = function(f) {
    return arguments.length ? (f == null ? i = s = null : s = a(i = f), c) : i;
  }, c;
}
class cD {
  constructor(t, n) {
    this._context = t, this._x = n;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  }
  point(t, n) {
    switch (t = +t, n = +n, this._point) {
      case 0: {
        this._point = 1, this._line ? this._context.lineTo(t, n) : this._context.moveTo(t, n);
        break;
      }
      case 1:
        this._point = 2;
      // falls through
      default: {
        this._x ? this._context.bezierCurveTo(this._x0 = (this._x0 + t) / 2, this._y0, this._x0, n, t, n) : this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + n) / 2, t, this._y0, t, n);
        break;
      }
    }
    this._x0 = t, this._y0 = n;
  }
}
function $oe(e) {
  return new cD(e, !0);
}
function joe(e) {
  return new cD(e, !1);
}
const wp = {
  draw(e, t) {
    const n = Kr(t / w5);
    e.moveTo(n, 0), e.arc(0, 0, n, 0, l0);
  }
}, Hoe = {
  draw(e, t) {
    const n = Kr(t / 5) / 2;
    e.moveTo(-3 * n, -n), e.lineTo(-n, -n), e.lineTo(-n, -3 * n), e.lineTo(n, -3 * n), e.lineTo(n, -n), e.lineTo(3 * n, -n), e.lineTo(3 * n, n), e.lineTo(n, n), e.lineTo(n, 3 * n), e.lineTo(-n, 3 * n), e.lineTo(-n, n), e.lineTo(-3 * n, n), e.closePath();
  }
}, uD = Kr(1 / 3), zoe = uD * 2, Zoe = {
  draw(e, t) {
    const n = Kr(t / zoe), r = n * uD;
    e.moveTo(0, -n), e.lineTo(r, 0), e.lineTo(0, n), e.lineTo(-r, 0), e.closePath();
  }
}, Woe = {
  draw(e, t) {
    const n = Kr(t), r = -n / 2;
    e.rect(r, r, n, n);
  }
}, qoe = 0.8908130915292852, fD = b5(w5 / 10) / b5(7 * w5 / 10), Uoe = b5(l0 / 10) * fD, Goe = -rD(l0 / 10) * fD, Koe = {
  draw(e, t) {
    const n = Kr(t * qoe), r = Uoe * n, o = Goe * n;
    e.moveTo(0, -n), e.lineTo(r, o);
    for (let i = 1; i < 5; ++i) {
      const a = l0 * i / 5, s = rD(a), l = b5(a);
      e.lineTo(l * n, -s * n), e.lineTo(s * r - l * o, l * r + s * o);
    }
    e.closePath();
  }
}, M8 = Kr(3), Yoe = {
  draw(e, t) {
    const n = -Kr(t / (M8 * 3));
    e.moveTo(0, n * 2), e.lineTo(-M8 * n, -n), e.lineTo(M8 * n, -n), e.closePath();
  }
}, hr = -0.5, pr = Kr(3) / 2, mf = 1 / Kr(12), Xoe = (mf / 2 + 1) * 3, Qoe = {
  draw(e, t) {
    const n = Kr(t / Xoe), r = n / 2, o = n * mf, i = r, a = n * mf + n, s = -i, l = a;
    e.moveTo(r, o), e.lineTo(i, a), e.lineTo(s, l), e.lineTo(hr * r - pr * o, pr * r + hr * o), e.lineTo(hr * i - pr * a, pr * i + hr * a), e.lineTo(hr * s - pr * l, pr * s + hr * l), e.lineTo(hr * r + pr * o, hr * o - pr * r), e.lineTo(hr * i + pr * a, hr * a - pr * i), e.lineTo(hr * s + pr * l, hr * l - pr * s), e.closePath();
  }
};
function Joe(e, t) {
  let n = null, r = yp(o);
  e = typeof e == "function" ? e : xt(e || wp), t = typeof t == "function" ? t : xt(t === void 0 ? 64 : +t);
  function o() {
    let i;
    if (n || (n = i = r()), e.apply(this, arguments).draw(n, +t.apply(this, arguments)), i) return n = null, i + "" || null;
  }
  return o.type = function(i) {
    return arguments.length ? (e = typeof i == "function" ? i : xt(i), o) : e;
  }, o.size = function(i) {
    return arguments.length ? (t = typeof i == "function" ? i : xt(+i), o) : t;
  }, o.context = function(i) {
    return arguments.length ? (n = i ?? null, o) : n;
  }, o;
}
function x5() {
}
function S5(e, t, n) {
  e._context.bezierCurveTo(
    (2 * e._x0 + e._x1) / 3,
    (2 * e._y0 + e._y1) / 3,
    (e._x0 + 2 * e._x1) / 3,
    (e._y0 + 2 * e._y1) / 3,
    (e._x0 + 4 * e._x1 + t) / 6,
    (e._y0 + 4 * e._y1 + n) / 6
  );
}
function dD(e) {
  this._context = e;
}
dD.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        S5(this, this._x1, this._y1);
      // falls through
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      // falls through
      default:
        S5(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function e1e(e) {
  return new dD(e);
}
function hD(e) {
  this._context = e;
}
hD.prototype = {
  areaStart: x5,
  areaEnd: x5,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._x2 = e, this._y2 = t;
        break;
      case 1:
        this._point = 2, this._x3 = e, this._y3 = t;
        break;
      case 2:
        this._point = 3, this._x4 = e, this._y4 = t, this._context.moveTo((this._x0 + 4 * this._x1 + e) / 6, (this._y0 + 4 * this._y1 + t) / 6);
        break;
      default:
        S5(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function t1e(e) {
  return new hD(e);
}
function pD(e) {
  this._context = e;
}
pD.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var n = (this._x0 + 4 * this._x1 + e) / 6, r = (this._y0 + 4 * this._y1 + t) / 6;
        this._line ? this._context.lineTo(n, r) : this._context.moveTo(n, r);
        break;
      case 3:
        this._point = 4;
      // falls through
      default:
        S5(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function n1e(e) {
  return new pD(e);
}
function mD(e) {
  this._context = e;
}
mD.prototype = {
  areaStart: x5,
  areaEnd: x5,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(e, t) {
    e = +e, t = +t, this._point ? this._context.lineTo(e, t) : (this._point = 1, this._context.moveTo(e, t));
  }
};
function r1e(e) {
  return new mD(e);
}
function Pb(e) {
  return e < 0 ? -1 : 1;
}
function Tb(e, t, n) {
  var r = e._x1 - e._x0, o = t - e._x1, i = (e._y1 - e._y0) / (r || o < 0 && -0), a = (n - e._y1) / (o || r < 0 && -0), s = (i * o + a * r) / (r + o);
  return (Pb(i) + Pb(a)) * Math.min(Math.abs(i), Math.abs(a), 0.5 * Math.abs(s)) || 0;
}
function Ib(e, t) {
  var n = e._x1 - e._x0;
  return n ? (3 * (e._y1 - e._y0) / n - t) / 2 : t;
}
function E8(e, t, n) {
  var r = e._x0, o = e._y0, i = e._x1, a = e._y1, s = (i - r) / 3;
  e._context.bezierCurveTo(r + s, o + s * t, i - s, a - s * n, i, a);
}
function M5(e) {
  this._context = e;
}
M5.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        E8(this, this._t0, Ib(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    var n = NaN;
    if (e = +e, t = +t, !(e === this._x1 && t === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, E8(this, Ib(this, n = Tb(this, e, t)), n);
          break;
        default:
          E8(this, this._t0, n = Tb(this, e, t));
          break;
      }
      this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t, this._t0 = n;
    }
  }
};
function gD(e) {
  this._context = new CD(e);
}
(gD.prototype = Object.create(M5.prototype)).point = function(e, t) {
  M5.prototype.point.call(this, t, e);
};
function CD(e) {
  this._context = e;
}
CD.prototype = {
  moveTo: function(e, t) {
    this._context.moveTo(t, e);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(e, t) {
    this._context.lineTo(t, e);
  },
  bezierCurveTo: function(e, t, n, r, o, i) {
    this._context.bezierCurveTo(t, e, r, n, i, o);
  }
};
function o1e(e) {
  return new M5(e);
}
function i1e(e) {
  return new gD(e);
}
function vD(e) {
  this._context = e;
}
vD.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var e = this._x, t = this._y, n = e.length;
    if (n)
      if (this._line ? this._context.lineTo(e[0], t[0]) : this._context.moveTo(e[0], t[0]), n === 2)
        this._context.lineTo(e[1], t[1]);
      else
        for (var r = Db(e), o = Db(t), i = 0, a = 1; a < n; ++i, ++a)
          this._context.bezierCurveTo(r[0][i], o[0][i], r[1][i], o[1][i], e[a], t[a]);
    (this._line || this._line !== 0 && n === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(e, t) {
    this._x.push(+e), this._y.push(+t);
  }
};
function Db(e) {
  var t, n = e.length - 1, r, o = new Array(n), i = new Array(n), a = new Array(n);
  for (o[0] = 0, i[0] = 2, a[0] = e[0] + 2 * e[1], t = 1; t < n - 1; ++t) o[t] = 1, i[t] = 4, a[t] = 4 * e[t] + 2 * e[t + 1];
  for (o[n - 1] = 2, i[n - 1] = 7, a[n - 1] = 8 * e[n - 1] + e[n], t = 1; t < n; ++t) r = o[t] / i[t - 1], i[t] -= r, a[t] -= r * a[t - 1];
  for (o[n - 1] = a[n - 1] / i[n - 1], t = n - 2; t >= 0; --t) o[t] = (a[t] - o[t + 1]) / i[t];
  for (i[n - 1] = (e[n] + o[n - 1]) / 2, t = 0; t < n - 1; ++t) i[t] = 2 * e[t + 1] - o[t + 1];
  return [o, i];
}
function a1e(e) {
  return new vD(e);
}
function u0(e, t) {
  this._context = e, this._t = t;
}
u0.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      // falls through
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, t), this._context.lineTo(e, t);
        else {
          var n = this._x * (1 - this._t) + e * this._t;
          this._context.lineTo(n, this._y), this._context.lineTo(n, t);
        }
        break;
      }
    }
    this._x = e, this._y = t;
  }
};
function s1e(e) {
  return new u0(e, 0.5);
}
function l1e(e) {
  return new u0(e, 0);
}
function c1e(e) {
  return new u0(e, 1);
}
function ja(e, t) {
  if ((a = e.length) > 1)
    for (var n = 1, r, o, i = e[t[0]], a, s = i.length; n < a; ++n)
      for (o = i, i = e[t[n]], r = 0; r < s; ++r)
        i[r][1] += i[r][0] = isNaN(o[r][1]) ? o[r][0] : o[r][1];
}
function gf(e) {
  for (var t = e.length, n = new Array(t); --t >= 0; ) n[t] = t;
  return n;
}
function u1e(e, t) {
  return e[t];
}
function f1e(e) {
  const t = [];
  return t.key = e, t;
}
function d1e() {
  var e = xt([]), t = gf, n = ja, r = u1e;
  function o(i) {
    var a = Array.from(e.apply(this, arguments), f1e), s, l = a.length, c = -1, u;
    for (const f of i)
      for (s = 0, ++c; s < l; ++s)
        (a[s][c] = [0, +r(f, a[s].key, c, i)]).data = f;
    for (s = 0, u = bp(t(a)); s < l; ++s)
      a[u[s]].index = s;
    return n(a, u), a;
  }
  return o.keys = function(i) {
    return arguments.length ? (e = typeof i == "function" ? i : xt(Array.from(i)), o) : e;
  }, o.value = function(i) {
    return arguments.length ? (r = typeof i == "function" ? i : xt(+i), o) : r;
  }, o.order = function(i) {
    return arguments.length ? (t = i == null ? gf : typeof i == "function" ? i : xt(Array.from(i)), o) : t;
  }, o.offset = function(i) {
    return arguments.length ? (n = i ?? ja, o) : n;
  }, o;
}
function h1e(e, t) {
  if ((r = e.length) > 0) {
    for (var n, r, o = 0, i = e[0].length, a; o < i; ++o) {
      for (a = n = 0; n < r; ++n) a += e[n][o][1] || 0;
      if (a) for (n = 0; n < r; ++n) e[n][o][1] /= a;
    }
    ja(e, t);
  }
}
function p1e(e, t) {
  if ((o = e.length) > 0) {
    for (var n = 0, r = e[t[0]], o, i = r.length; n < i; ++n) {
      for (var a = 0, s = 0; a < o; ++a) s += e[a][n][1] || 0;
      r[n][1] += r[n][0] = -s / 2;
    }
    ja(e, t);
  }
}
function m1e(e, t) {
  if (!(!((a = e.length) > 0) || !((i = (o = e[t[0]]).length) > 0))) {
    for (var n = 0, r = 1, o, i, a; r < i; ++r) {
      for (var s = 0, l = 0, c = 0; s < a; ++s) {
        for (var u = e[t[s]], f = u[r][1] || 0, h = u[r - 1][1] || 0, p = (f - h) / 2, C = 0; C < s; ++C) {
          var m = e[t[C]], g = m[r][1] || 0, v = m[r - 1][1] || 0;
          p += g - v;
        }
        l += f, c += p * f;
      }
      o[r - 1][1] += o[r - 1][0] = n, l && (n -= c / l);
    }
    o[r - 1][1] += o[r - 1][0] = n, ja(e, t);
  }
}
function Hl(e) {
  "@babel/helpers - typeof";
  return Hl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Hl(e);
}
var g1e = ["type", "size", "sizeType"];
function Cf() {
  return Cf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Cf.apply(this, arguments);
}
function Rb(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function kb(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Rb(Object(n), !0).forEach(function(r) {
      C1e(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Rb(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function C1e(e, t, n) {
  return t = v1e(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function v1e(e) {
  var t = y1e(e, "string");
  return Hl(t) == "symbol" ? t : t + "";
}
function y1e(e, t) {
  if (Hl(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Hl(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function b1e(e, t) {
  if (e == null) return {};
  var n = w1e(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function w1e(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
var yD = {
  symbolCircle: wp,
  symbolCross: Hoe,
  symbolDiamond: Zoe,
  symbolSquare: Woe,
  symbolStar: Koe,
  symbolTriangle: Yoe,
  symbolWye: Qoe
}, x1e = Math.PI / 180, S1e = function(t) {
  var n = "symbol".concat(s0(t));
  return yD[n] || wp;
}, M1e = function(t, n, r) {
  if (n === "area")
    return t;
  switch (r) {
    case "cross":
      return 5 * t * t / 9;
    case "diamond":
      return 0.5 * t * t / Math.sqrt(3);
    case "square":
      return t * t;
    case "star": {
      var o = 18 * x1e;
      return 1.25 * t * t * (Math.tan(o) - Math.tan(o * 2) * Math.pow(Math.tan(o), 2));
    }
    case "triangle":
      return Math.sqrt(3) * t * t / 4;
    case "wye":
      return (21 - 10 * Math.sqrt(3)) * t * t / 8;
    default:
      return Math.PI * t * t / 4;
  }
}, E1e = function(t, n) {
  yD["symbol".concat(s0(t))] = n;
}, f0 = function(t) {
  var n = t.type, r = n === void 0 ? "circle" : n, o = t.size, i = o === void 0 ? 64 : o, a = t.sizeType, s = a === void 0 ? "area" : a, l = b1e(t, g1e), c = kb(kb({}, l), {}, {
    type: r,
    size: i,
    sizeType: s
  }), u = function() {
    var g = S1e(r), v = Joe().type(g).size(M1e(i, s, r));
    return v();
  }, f = c.className, h = c.cx, p = c.cy, C = Be(c, !0);
  return h === +h && p === +p && i === +i ? /* @__PURE__ */ O.createElement("path", Cf({}, C, {
    className: We("recharts-symbols", f),
    transform: "translate(".concat(h, ", ").concat(p, ")"),
    d: u()
  })) : null;
};
f0.registerSymbol = E1e;
function Ha(e) {
  "@babel/helpers - typeof";
  return Ha = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ha(e);
}
function vf() {
  return vf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, vf.apply(this, arguments);
}
function Lb(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function _1e(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Lb(Object(n), !0).forEach(function(r) {
      zl(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Lb(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function O1e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function A1e(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, wD(r.key), r);
  }
}
function P1e(e, t, n) {
  return t && A1e(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function T1e(e, t, n) {
  return t = E5(t), I1e(e, bD() ? Reflect.construct(t, n || [], E5(e).constructor) : t.apply(e, n));
}
function I1e(e, t) {
  if (t && (Ha(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return D1e(e);
}
function D1e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function bD() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (bD = function() {
    return !!e;
  })();
}
function E5(e) {
  return E5 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, E5(e);
}
function R1e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && yf(e, t);
}
function yf(e, t) {
  return yf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, yf(e, t);
}
function zl(e, t, n) {
  return t = wD(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function wD(e) {
  var t = k1e(e, "string");
  return Ha(t) == "symbol" ? t : t + "";
}
function k1e(e, t) {
  if (Ha(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Ha(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var mr = 32, xp = /* @__PURE__ */ (function(e) {
  function t() {
    return O1e(this, t), T1e(this, t, arguments);
  }
  return R1e(t, e), P1e(t, [{
    key: "renderIcon",
    value: (
      /**
       * Render the path of icon
       * @param {Object} data Data of each legend item
       * @return {String} Path element
       */
      function(r) {
        var o = this.props.inactiveColor, i = mr / 2, a = mr / 6, s = mr / 3, l = r.inactive ? o : r.color;
        if (r.type === "plainline")
          return /* @__PURE__ */ O.createElement("line", {
            strokeWidth: 4,
            fill: "none",
            stroke: l,
            strokeDasharray: r.payload.strokeDasharray,
            x1: 0,
            y1: i,
            x2: mr,
            y2: i,
            className: "recharts-legend-icon"
          });
        if (r.type === "line")
          return /* @__PURE__ */ O.createElement("path", {
            strokeWidth: 4,
            fill: "none",
            stroke: l,
            d: "M0,".concat(i, "h").concat(s, `
            A`).concat(a, ",").concat(a, ",0,1,1,").concat(2 * s, ",").concat(i, `
            H`).concat(mr, "M").concat(2 * s, ",").concat(i, `
            A`).concat(a, ",").concat(a, ",0,1,1,").concat(s, ",").concat(i),
            className: "recharts-legend-icon"
          });
        if (r.type === "rect")
          return /* @__PURE__ */ O.createElement("path", {
            stroke: "none",
            fill: l,
            d: "M0,".concat(mr / 8, "h").concat(mr, "v").concat(mr * 3 / 4, "h").concat(-mr, "z"),
            className: "recharts-legend-icon"
          });
        if (/* @__PURE__ */ O.isValidElement(r.legendIcon)) {
          var c = _1e({}, r);
          return delete c.legendIcon, /* @__PURE__ */ O.cloneElement(r.legendIcon, c);
        }
        return /* @__PURE__ */ O.createElement(f0, {
          fill: l,
          cx: i,
          cy: i,
          size: mr,
          sizeType: "diameter",
          type: r.type
        });
      }
    )
    /**
     * Draw items of legend
     * @return {ReactElement} Items
     */
  }, {
    key: "renderItems",
    value: function() {
      var r = this, o = this.props, i = o.payload, a = o.iconSize, s = o.layout, l = o.formatter, c = o.inactiveColor, u = {
        x: 0,
        y: 0,
        width: mr,
        height: mr
      }, f = {
        display: s === "horizontal" ? "inline-block" : "block",
        marginRight: 10
      }, h = {
        display: "inline-block",
        verticalAlign: "middle",
        marginRight: 4
      };
      return i.map(function(p, C) {
        var m = p.formatter || l, g = We(zl(zl({
          "recharts-legend-item": !0
        }, "legend-item-".concat(C), !0), "inactive", p.inactive));
        if (p.type === "none")
          return null;
        var v = je(p.value) ? null : p.value;
        Wo(
          !je(p.value),
          `The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name="Name of my Data"/>`
          // eslint-disable-line max-len
        );
        var y = p.inactive ? c : p.color;
        return /* @__PURE__ */ O.createElement("li", vf({
          className: g,
          style: f,
          key: "legend-item-".concat(C)
        }, jl(r.props, p, C)), /* @__PURE__ */ O.createElement(ff, {
          width: a,
          height: a,
          viewBox: u,
          style: h
        }, r.renderIcon(p)), /* @__PURE__ */ O.createElement("span", {
          className: "recharts-legend-item-text",
          style: {
            color: y
          }
        }, m ? m(v, p, C) : v));
      });
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, o = r.payload, i = r.layout, a = r.align;
      if (!o || !o.length)
        return null;
      var s = {
        padding: 0,
        margin: 0,
        textAlign: i === "horizontal" ? a : "left"
      };
      return /* @__PURE__ */ O.createElement("ul", {
        className: "recharts-default-legend",
        style: s
      }, this.renderItems());
    }
  }]);
})(xo);
zl(xp, "displayName", "Legend");
zl(xp, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "middle",
  inactiveColor: "#ccc"
});
var _8, Nb;
function L1e() {
  if (Nb) return _8;
  Nb = 1;
  var e = o0();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return _8 = t, _8;
}
var O8, Fb;
function N1e() {
  if (Fb) return O8;
  Fb = 1;
  function e(t) {
    var n = this.__data__, r = n.delete(t);
    return this.size = n.size, r;
  }
  return O8 = e, O8;
}
var A8, Vb;
function F1e() {
  if (Vb) return A8;
  Vb = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return A8 = e, A8;
}
var P8, Bb;
function V1e() {
  if (Bb) return P8;
  Bb = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return P8 = e, P8;
}
var T8, $b;
function B1e() {
  if ($b) return T8;
  $b = 1;
  var e = o0(), t = hp(), n = pp(), r = 200;
  function o(i, a) {
    var s = this.__data__;
    if (s instanceof e) {
      var l = s.__data__;
      if (!t || l.length < r - 1)
        return l.push([i, a]), this.size = ++s.size, this;
      s = this.__data__ = new n(l);
    }
    return s.set(i, a), this.size = s.size, this;
  }
  return T8 = o, T8;
}
var I8, jb;
function xD() {
  if (jb) return I8;
  jb = 1;
  var e = o0(), t = L1e(), n = N1e(), r = F1e(), o = V1e(), i = B1e();
  function a(s) {
    var l = this.__data__ = new e(s);
    this.size = l.size;
  }
  return a.prototype.clear = t, a.prototype.delete = n, a.prototype.get = r, a.prototype.has = o, a.prototype.set = i, I8 = a, I8;
}
var D8, Hb;
function $1e() {
  if (Hb) return D8;
  Hb = 1;
  var e = "__lodash_hash_undefined__";
  function t(n) {
    return this.__data__.set(n, e), this;
  }
  return D8 = t, D8;
}
var R8, zb;
function j1e() {
  if (zb) return R8;
  zb = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return R8 = e, R8;
}
var k8, Zb;
function SD() {
  if (Zb) return k8;
  Zb = 1;
  var e = pp(), t = $1e(), n = j1e();
  function r(o) {
    var i = -1, a = o == null ? 0 : o.length;
    for (this.__data__ = new e(); ++i < a; )
      this.add(o[i]);
  }
  return r.prototype.add = r.prototype.push = t, r.prototype.has = n, k8 = r, k8;
}
var L8, Wb;
function MD() {
  if (Wb) return L8;
  Wb = 1;
  function e(t, n) {
    for (var r = -1, o = t == null ? 0 : t.length; ++r < o; )
      if (n(t[r], r, t))
        return !0;
    return !1;
  }
  return L8 = e, L8;
}
var N8, qb;
function ED() {
  if (qb) return N8;
  qb = 1;
  function e(t, n) {
    return t.has(n);
  }
  return N8 = e, N8;
}
var F8, Ub;
function _D() {
  if (Ub) return F8;
  Ub = 1;
  var e = SD(), t = MD(), n = ED(), r = 1, o = 2;
  function i(a, s, l, c, u, f) {
    var h = l & r, p = a.length, C = s.length;
    if (p != C && !(h && C > p))
      return !1;
    var m = f.get(a), g = f.get(s);
    if (m && g)
      return m == s && g == a;
    var v = -1, y = !0, w = l & o ? new e() : void 0;
    for (f.set(a, s), f.set(s, a); ++v < p; ) {
      var x = a[v], b = s[v];
      if (c)
        var S = h ? c(b, x, v, s, a, f) : c(x, b, v, a, s, f);
      if (S !== void 0) {
        if (S)
          continue;
        y = !1;
        break;
      }
      if (w) {
        if (!t(s, function(M, E) {
          if (!n(w, E) && (x === M || u(x, M, l, c, f)))
            return w.push(E);
        })) {
          y = !1;
          break;
        }
      } else if (!(x === b || u(x, b, l, c, f))) {
        y = !1;
        break;
      }
    }
    return f.delete(a), f.delete(s), y;
  }
  return F8 = i, F8;
}
var V8, Gb;
function H1e() {
  if (Gb) return V8;
  Gb = 1;
  var e = Oo(), t = e.Uint8Array;
  return V8 = t, V8;
}
var B8, Kb;
function z1e() {
  if (Kb) return B8;
  Kb = 1;
  function e(t) {
    var n = -1, r = Array(t.size);
    return t.forEach(function(o, i) {
      r[++n] = [i, o];
    }), r;
  }
  return B8 = e, B8;
}
var $8, Yb;
function Sp() {
  if (Yb) return $8;
  Yb = 1;
  function e(t) {
    var n = -1, r = Array(t.size);
    return t.forEach(function(o) {
      r[++n] = o;
    }), r;
  }
  return $8 = e, $8;
}
var j8, Xb;
function Z1e() {
  if (Xb) return j8;
  Xb = 1;
  var e = z2(), t = H1e(), n = dp(), r = _D(), o = z1e(), i = Sp(), a = 1, s = 2, l = "[object Boolean]", c = "[object Date]", u = "[object Error]", f = "[object Map]", h = "[object Number]", p = "[object RegExp]", C = "[object Set]", m = "[object String]", g = "[object Symbol]", v = "[object ArrayBuffer]", y = "[object DataView]", w = e ? e.prototype : void 0, x = w ? w.valueOf : void 0;
  function b(S, M, E, P, T, _, D) {
    switch (E) {
      case y:
        if (S.byteLength != M.byteLength || S.byteOffset != M.byteOffset)
          return !1;
        S = S.buffer, M = M.buffer;
      case v:
        return !(S.byteLength != M.byteLength || !_(new t(S), new t(M)));
      case l:
      case c:
      case h:
        return n(+S, +M);
      case u:
        return S.name == M.name && S.message == M.message;
      case p:
      case m:
        return S == M + "";
      case f:
        var N = o;
      case C:
        var R = P & a;
        if (N || (N = i), S.size != M.size && !R)
          return !1;
        var L = D.get(S);
        if (L)
          return L == M;
        P |= s, D.set(S, M);
        var B = r(N(S), N(M), P, T, _, D);
        return D.delete(S), B;
      case g:
        if (x)
          return x.call(S) == x.call(M);
    }
    return !1;
  }
  return j8 = b, j8;
}
var H8, Qb;
function OD() {
  if (Qb) return H8;
  Qb = 1;
  function e(t, n) {
    for (var r = -1, o = n.length, i = t.length; ++r < o; )
      t[i + r] = n[r];
    return t;
  }
  return H8 = e, H8;
}
var z8, Jb;
function W1e() {
  if (Jb) return z8;
  Jb = 1;
  var e = OD(), t = Qn();
  function n(r, o, i) {
    var a = o(r);
    return t(r) ? a : e(a, i(r));
  }
  return z8 = n, z8;
}
var Z8, ew;
function q1e() {
  if (ew) return Z8;
  ew = 1;
  function e(t, n) {
    for (var r = -1, o = t == null ? 0 : t.length, i = 0, a = []; ++r < o; ) {
      var s = t[r];
      n(s, r, t) && (a[i++] = s);
    }
    return a;
  }
  return Z8 = e, Z8;
}
var W8, tw;
function U1e() {
  if (tw) return W8;
  tw = 1;
  function e() {
    return [];
  }
  return W8 = e, W8;
}
var q8, nw;
function G1e() {
  if (nw) return q8;
  nw = 1;
  var e = q1e(), t = U1e(), n = Object.prototype, r = n.propertyIsEnumerable, o = Object.getOwnPropertySymbols, i = o ? function(a) {
    return a == null ? [] : (a = Object(a), e(o(a), function(s) {
      return r.call(a, s);
    }));
  } : t;
  return q8 = i, q8;
}
var U8, rw;
function K1e() {
  if (rw) return U8;
  rw = 1;
  function e(t, n) {
    for (var r = -1, o = Array(t); ++r < t; )
      o[r] = n(r);
    return o;
  }
  return U8 = e, U8;
}
var G8, ow;
function Y1e() {
  if (ow) return G8;
  ow = 1;
  var e = t1(), t = n1(), n = "[object Arguments]";
  function r(o) {
    return t(o) && e(o) == n;
  }
  return G8 = r, G8;
}
var K8, iw;
function Mp() {
  if (iw) return K8;
  iw = 1;
  var e = Y1e(), t = n1(), n = Object.prototype, r = n.hasOwnProperty, o = n.propertyIsEnumerable, i = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(a) {
    return t(a) && r.call(a, "callee") && !o.call(a, "callee");
  };
  return K8 = i, K8;
}
var ul = { exports: {} }, Y8, aw;
function X1e() {
  if (aw) return Y8;
  aw = 1;
  function e() {
    return !1;
  }
  return Y8 = e, Y8;
}
ul.exports;
var sw;
function AD() {
  return sw || (sw = 1, (function(e, t) {
    var n = Oo(), r = X1e(), o = t && !t.nodeType && t, i = o && !0 && e && !e.nodeType && e, a = i && i.exports === o, s = a ? n.Buffer : void 0, l = s ? s.isBuffer : void 0, c = l || r;
    e.exports = c;
  })(ul, ul.exports)), ul.exports;
}
var X8, lw;
function Ep() {
  if (lw) return X8;
  lw = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function n(r, o) {
    var i = typeof r;
    return o = o ?? e, !!o && (i == "number" || i != "symbol" && t.test(r)) && r > -1 && r % 1 == 0 && r < o;
  }
  return X8 = n, X8;
}
var Q8, cw;
function _p() {
  if (cw) return Q8;
  cw = 1;
  var e = 9007199254740991;
  function t(n) {
    return typeof n == "number" && n > -1 && n % 1 == 0 && n <= e;
  }
  return Q8 = t, Q8;
}
var J8, uw;
function Q1e() {
  if (uw) return J8;
  uw = 1;
  var e = t1(), t = _p(), n = n1(), r = "[object Arguments]", o = "[object Array]", i = "[object Boolean]", a = "[object Date]", s = "[object Error]", l = "[object Function]", c = "[object Map]", u = "[object Number]", f = "[object Object]", h = "[object RegExp]", p = "[object Set]", C = "[object String]", m = "[object WeakMap]", g = "[object ArrayBuffer]", v = "[object DataView]", y = "[object Float32Array]", w = "[object Float64Array]", x = "[object Int8Array]", b = "[object Int16Array]", S = "[object Int32Array]", M = "[object Uint8Array]", E = "[object Uint8ClampedArray]", P = "[object Uint16Array]", T = "[object Uint32Array]", _ = {};
  _[y] = _[w] = _[x] = _[b] = _[S] = _[M] = _[E] = _[P] = _[T] = !0, _[r] = _[o] = _[g] = _[i] = _[v] = _[a] = _[s] = _[l] = _[c] = _[u] = _[f] = _[h] = _[p] = _[C] = _[m] = !1;
  function D(N) {
    return n(N) && t(N.length) && !!_[e(N)];
  }
  return J8 = D, J8;
}
var e6, fw;
function PD() {
  if (fw) return e6;
  fw = 1;
  function e(t) {
    return function(n) {
      return t(n);
    };
  }
  return e6 = e, e6;
}
var fl = { exports: {} };
fl.exports;
var dw;
function J1e() {
  return dw || (dw = 1, (function(e, t) {
    var n = GI(), r = t && !t.nodeType && t, o = r && !0 && e && !e.nodeType && e, i = o && o.exports === r, a = i && n.process, s = (function() {
      try {
        var l = o && o.require && o.require("util").types;
        return l || a && a.binding && a.binding("util");
      } catch {
      }
    })();
    e.exports = s;
  })(fl, fl.exports)), fl.exports;
}
var t6, hw;
function TD() {
  if (hw) return t6;
  hw = 1;
  var e = Q1e(), t = PD(), n = J1e(), r = n && n.isTypedArray, o = r ? t(r) : e;
  return t6 = o, t6;
}
var n6, pw;
function eie() {
  if (pw) return n6;
  pw = 1;
  var e = K1e(), t = Mp(), n = Qn(), r = AD(), o = Ep(), i = TD(), a = Object.prototype, s = a.hasOwnProperty;
  function l(c, u) {
    var f = n(c), h = !f && t(c), p = !f && !h && r(c), C = !f && !h && !p && i(c), m = f || h || p || C, g = m ? e(c.length, String) : [], v = g.length;
    for (var y in c)
      (u || s.call(c, y)) && !(m && // Safari 9 has enumerable `arguments.length` in strict mode.
      (y == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      p && (y == "offset" || y == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      C && (y == "buffer" || y == "byteLength" || y == "byteOffset") || // Skip index properties.
      o(y, v))) && g.push(y);
    return g;
  }
  return n6 = l, n6;
}
var r6, mw;
function tie() {
  if (mw) return r6;
  mw = 1;
  var e = Object.prototype;
  function t(n) {
    var r = n && n.constructor, o = typeof r == "function" && r.prototype || e;
    return n === o;
  }
  return r6 = t, r6;
}
var o6, gw;
function ID() {
  if (gw) return o6;
  gw = 1;
  function e(t, n) {
    return function(r) {
      return t(n(r));
    };
  }
  return o6 = e, o6;
}
var i6, Cw;
function nie() {
  if (Cw) return i6;
  Cw = 1;
  var e = ID(), t = e(Object.keys, Object);
  return i6 = t, i6;
}
var a6, vw;
function rie() {
  if (vw) return a6;
  vw = 1;
  var e = tie(), t = nie(), n = Object.prototype, r = n.hasOwnProperty;
  function o(i) {
    if (!e(i))
      return t(i);
    var a = [];
    for (var s in Object(i))
      r.call(i, s) && s != "constructor" && a.push(s);
    return a;
  }
  return a6 = o, a6;
}
var s6, yw;
function Z2() {
  if (yw) return s6;
  yw = 1;
  var e = fp(), t = _p();
  function n(r) {
    return r != null && t(r.length) && !e(r);
  }
  return s6 = n, s6;
}
var l6, bw;
function d0() {
  if (bw) return l6;
  bw = 1;
  var e = eie(), t = rie(), n = Z2();
  function r(o) {
    return n(o) ? e(o) : t(o);
  }
  return l6 = r, l6;
}
var c6, ww;
function oie() {
  if (ww) return c6;
  ww = 1;
  var e = W1e(), t = G1e(), n = d0();
  function r(o) {
    return e(o, n, t);
  }
  return c6 = r, c6;
}
var u6, xw;
function iie() {
  if (xw) return u6;
  xw = 1;
  var e = oie(), t = 1, n = Object.prototype, r = n.hasOwnProperty;
  function o(i, a, s, l, c, u) {
    var f = s & t, h = e(i), p = h.length, C = e(a), m = C.length;
    if (p != m && !f)
      return !1;
    for (var g = p; g--; ) {
      var v = h[g];
      if (!(f ? v in a : r.call(a, v)))
        return !1;
    }
    var y = u.get(i), w = u.get(a);
    if (y && w)
      return y == a && w == i;
    var x = !0;
    u.set(i, a), u.set(a, i);
    for (var b = f; ++g < p; ) {
      v = h[g];
      var S = i[v], M = a[v];
      if (l)
        var E = f ? l(M, S, v, a, i, u) : l(S, M, v, i, a, u);
      if (!(E === void 0 ? S === M || c(S, M, s, l, u) : E)) {
        x = !1;
        break;
      }
      b || (b = v == "constructor");
    }
    if (x && !b) {
      var P = i.constructor, T = a.constructor;
      P != T && "constructor" in i && "constructor" in a && !(typeof P == "function" && P instanceof P && typeof T == "function" && T instanceof T) && (x = !1);
    }
    return u.delete(i), u.delete(a), x;
  }
  return u6 = o, u6;
}
var f6, Sw;
function aie() {
  if (Sw) return f6;
  Sw = 1;
  var e = Vi(), t = Oo(), n = e(t, "DataView");
  return f6 = n, f6;
}
var d6, Mw;
function sie() {
  if (Mw) return d6;
  Mw = 1;
  var e = Vi(), t = Oo(), n = e(t, "Promise");
  return d6 = n, d6;
}
var h6, Ew;
function DD() {
  if (Ew) return h6;
  Ew = 1;
  var e = Vi(), t = Oo(), n = e(t, "Set");
  return h6 = n, h6;
}
var p6, _w;
function lie() {
  if (_w) return p6;
  _w = 1;
  var e = Vi(), t = Oo(), n = e(t, "WeakMap");
  return p6 = n, p6;
}
var m6, Ow;
function cie() {
  if (Ow) return m6;
  Ow = 1;
  var e = aie(), t = hp(), n = sie(), r = DD(), o = lie(), i = t1(), a = KI(), s = "[object Map]", l = "[object Object]", c = "[object Promise]", u = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", p = a(e), C = a(t), m = a(n), g = a(r), v = a(o), y = i;
  return (e && y(new e(new ArrayBuffer(1))) != h || t && y(new t()) != s || n && y(n.resolve()) != c || r && y(new r()) != u || o && y(new o()) != f) && (y = function(w) {
    var x = i(w), b = x == l ? w.constructor : void 0, S = b ? a(b) : "";
    if (S)
      switch (S) {
        case p:
          return h;
        case C:
          return s;
        case m:
          return c;
        case g:
          return u;
        case v:
          return f;
      }
    return x;
  }), m6 = y, m6;
}
var g6, Aw;
function uie() {
  if (Aw) return g6;
  Aw = 1;
  var e = xD(), t = _D(), n = Z1e(), r = iie(), o = cie(), i = Qn(), a = AD(), s = TD(), l = 1, c = "[object Arguments]", u = "[object Array]", f = "[object Object]", h = Object.prototype, p = h.hasOwnProperty;
  function C(m, g, v, y, w, x) {
    var b = i(m), S = i(g), M = b ? u : o(m), E = S ? u : o(g);
    M = M == c ? f : M, E = E == c ? f : E;
    var P = M == f, T = E == f, _ = M == E;
    if (_ && a(m)) {
      if (!a(g))
        return !1;
      b = !0, P = !1;
    }
    if (_ && !P)
      return x || (x = new e()), b || s(m) ? t(m, g, v, y, w, x) : n(m, g, M, v, y, w, x);
    if (!(v & l)) {
      var D = P && p.call(m, "__wrapped__"), N = T && p.call(g, "__wrapped__");
      if (D || N) {
        var R = D ? m.value() : m, L = N ? g.value() : g;
        return x || (x = new e()), w(R, L, v, y, x);
      }
    }
    return _ ? (x || (x = new e()), r(m, g, v, y, w, x)) : !1;
  }
  return g6 = C, g6;
}
var C6, Pw;
function Op() {
  if (Pw) return C6;
  Pw = 1;
  var e = uie(), t = n1();
  function n(r, o, i, a, s) {
    return r === o ? !0 : r == null || o == null || !t(r) && !t(o) ? r !== r && o !== o : e(r, o, i, a, n, s);
  }
  return C6 = n, C6;
}
var v6, Tw;
function fie() {
  if (Tw) return v6;
  Tw = 1;
  var e = xD(), t = Op(), n = 1, r = 2;
  function o(i, a, s, l) {
    var c = s.length, u = c, f = !l;
    if (i == null)
      return !u;
    for (i = Object(i); c--; ) {
      var h = s[c];
      if (f && h[2] ? h[1] !== i[h[0]] : !(h[0] in i))
        return !1;
    }
    for (; ++c < u; ) {
      h = s[c];
      var p = h[0], C = i[p], m = h[1];
      if (f && h[2]) {
        if (C === void 0 && !(p in i))
          return !1;
      } else {
        var g = new e();
        if (l)
          var v = l(C, m, p, i, a, g);
        if (!(v === void 0 ? t(m, C, n | r, l, g) : v))
          return !1;
      }
    }
    return !0;
  }
  return v6 = o, v6;
}
var y6, Iw;
function RD() {
  if (Iw) return y6;
  Iw = 1;
  var e = V1();
  function t(n) {
    return n === n && !e(n);
  }
  return y6 = t, y6;
}
var b6, Dw;
function die() {
  if (Dw) return b6;
  Dw = 1;
  var e = RD(), t = d0();
  function n(r) {
    for (var o = t(r), i = o.length; i--; ) {
      var a = o[i], s = r[a];
      o[i] = [a, s, e(s)];
    }
    return o;
  }
  return b6 = n, b6;
}
var w6, Rw;
function kD() {
  if (Rw) return w6;
  Rw = 1;
  function e(t, n) {
    return function(r) {
      return r == null ? !1 : r[t] === n && (n !== void 0 || t in Object(r));
    };
  }
  return w6 = e, w6;
}
var x6, kw;
function hie() {
  if (kw) return x6;
  kw = 1;
  var e = fie(), t = die(), n = kD();
  function r(o) {
    var i = t(o);
    return i.length == 1 && i[0][2] ? n(i[0][0], i[0][1]) : function(a) {
      return a === o || e(a, o, i);
    };
  }
  return x6 = r, x6;
}
var S6, Lw;
function pie() {
  if (Lw) return S6;
  Lw = 1;
  function e(t, n) {
    return t != null && n in Object(t);
  }
  return S6 = e, S6;
}
var M6, Nw;
function mie() {
  if (Nw) return M6;
  Nw = 1;
  var e = QI(), t = Mp(), n = Qn(), r = Ep(), o = _p(), i = a0();
  function a(s, l, c) {
    l = e(l, s);
    for (var u = -1, f = l.length, h = !1; ++u < f; ) {
      var p = i(l[u]);
      if (!(h = s != null && c(s, p)))
        break;
      s = s[p];
    }
    return h || ++u != f ? h : (f = s == null ? 0 : s.length, !!f && o(f) && r(p, f) && (n(s) || t(s)));
  }
  return M6 = a, M6;
}
var E6, Fw;
function gie() {
  if (Fw) return E6;
  Fw = 1;
  var e = pie(), t = mie();
  function n(r, o) {
    return r != null && t(r, o, e);
  }
  return E6 = n, E6;
}
var _6, Vw;
function Cie() {
  if (Vw) return _6;
  Vw = 1;
  var e = Op(), t = JI(), n = gie(), r = up(), o = RD(), i = kD(), a = a0(), s = 1, l = 2;
  function c(u, f) {
    return r(u) && o(f) ? i(a(u), f) : function(h) {
      var p = t(h, u);
      return p === void 0 && p === f ? n(h, u) : e(f, p, s | l);
    };
  }
  return _6 = c, _6;
}
var O6, Bw;
function _s() {
  if (Bw) return O6;
  Bw = 1;
  function e(t) {
    return t;
  }
  return O6 = e, O6;
}
var A6, $w;
function vie() {
  if ($w) return A6;
  $w = 1;
  function e(t) {
    return function(n) {
      return n?.[t];
    };
  }
  return A6 = e, A6;
}
var P6, jw;
function yie() {
  if (jw) return P6;
  jw = 1;
  var e = gp();
  function t(n) {
    return function(r) {
      return e(r, n);
    };
  }
  return P6 = t, P6;
}
var T6, Hw;
function bie() {
  if (Hw) return T6;
  Hw = 1;
  var e = vie(), t = yie(), n = up(), r = a0();
  function o(i) {
    return n(i) ? e(r(i)) : t(i);
  }
  return T6 = o, T6;
}
var I6, zw;
function B1() {
  if (zw) return I6;
  zw = 1;
  var e = hie(), t = Cie(), n = _s(), r = Qn(), o = bie();
  function i(a) {
    return typeof a == "function" ? a : a == null ? n : typeof a == "object" ? r(a) ? t(a[0], a[1]) : e(a) : o(a);
  }
  return I6 = i, I6;
}
var D6, Zw;
function LD() {
  if (Zw) return D6;
  Zw = 1;
  function e(t, n, r, o) {
    for (var i = t.length, a = r + (o ? 1 : -1); o ? a-- : ++a < i; )
      if (n(t[a], a, t))
        return a;
    return -1;
  }
  return D6 = e, D6;
}
var R6, Ww;
function wie() {
  if (Ww) return R6;
  Ww = 1;
  function e(t) {
    return t !== t;
  }
  return R6 = e, R6;
}
var k6, qw;
function xie() {
  if (qw) return k6;
  qw = 1;
  function e(t, n, r) {
    for (var o = r - 1, i = t.length; ++o < i; )
      if (t[o] === n)
        return o;
    return -1;
  }
  return k6 = e, k6;
}
var L6, Uw;
function Sie() {
  if (Uw) return L6;
  Uw = 1;
  var e = LD(), t = wie(), n = xie();
  function r(o, i, a) {
    return i === i ? n(o, i, a) : e(o, t, a);
  }
  return L6 = r, L6;
}
var N6, Gw;
function Mie() {
  if (Gw) return N6;
  Gw = 1;
  var e = Sie();
  function t(n, r) {
    var o = n == null ? 0 : n.length;
    return !!o && e(n, r, 0) > -1;
  }
  return N6 = t, N6;
}
var F6, Kw;
function Eie() {
  if (Kw) return F6;
  Kw = 1;
  function e(t, n, r) {
    for (var o = -1, i = t == null ? 0 : t.length; ++o < i; )
      if (r(n, t[o]))
        return !0;
    return !1;
  }
  return F6 = e, F6;
}
var V6, Yw;
function _ie() {
  if (Yw) return V6;
  Yw = 1;
  function e() {
  }
  return V6 = e, V6;
}
var B6, Xw;
function Oie() {
  if (Xw) return B6;
  Xw = 1;
  var e = DD(), t = _ie(), n = Sp(), r = 1 / 0, o = e && 1 / n(new e([, -0]))[1] == r ? function(i) {
    return new e(i);
  } : t;
  return B6 = o, B6;
}
var $6, Qw;
function Aie() {
  if (Qw) return $6;
  Qw = 1;
  var e = SD(), t = Mie(), n = Eie(), r = ED(), o = Oie(), i = Sp(), a = 200;
  function s(l, c, u) {
    var f = -1, h = t, p = l.length, C = !0, m = [], g = m;
    if (u)
      C = !1, h = n;
    else if (p >= a) {
      var v = c ? null : o(l);
      if (v)
        return i(v);
      C = !1, h = r, g = new e();
    } else
      g = c ? [] : m;
    e:
      for (; ++f < p; ) {
        var y = l[f], w = c ? c(y) : y;
        if (y = u || y !== 0 ? y : 0, C && w === w) {
          for (var x = g.length; x--; )
            if (g[x] === w)
              continue e;
          c && g.push(w), m.push(y);
        } else h(g, w, u) || (g !== m && g.push(w), m.push(y));
      }
    return m;
  }
  return $6 = s, $6;
}
var j6, Jw;
function Pie() {
  if (Jw) return j6;
  Jw = 1;
  var e = B1(), t = Aie();
  function n(r, o) {
    return r && r.length ? t(r, e(o, 2)) : [];
  }
  return j6 = n, j6;
}
var Tie = Pie();
const ex = /* @__PURE__ */ Mt(Tie);
function ND(e, t, n) {
  return t === !0 ? ex(e, n) : je(t) ? ex(e, t) : e;
}
function za(e) {
  "@babel/helpers - typeof";
  return za = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, za(e);
}
var Iie = ["ref"];
function tx(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Do(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? tx(Object(n), !0).forEach(function(r) {
      h0(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : tx(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Die(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function nx(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, VD(r.key), r);
  }
}
function Rie(e, t, n) {
  return t && nx(e.prototype, t), n && nx(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function kie(e, t, n) {
  return t = _5(t), Lie(e, FD() ? Reflect.construct(t, n || [], _5(e).constructor) : t.apply(e, n));
}
function Lie(e, t) {
  if (t && (za(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Nie(e);
}
function Nie(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function FD() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (FD = function() {
    return !!e;
  })();
}
function _5(e) {
  return _5 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, _5(e);
}
function Fie(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && bf(e, t);
}
function bf(e, t) {
  return bf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, bf(e, t);
}
function h0(e, t, n) {
  return t = VD(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function VD(e) {
  var t = Vie(e, "string");
  return za(t) == "symbol" ? t : t + "";
}
function Vie(e, t) {
  if (za(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (za(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function Bie(e, t) {
  if (e == null) return {};
  var n = $ie(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function $ie(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function jie(e) {
  return e.value;
}
function Hie(e, t) {
  if (/* @__PURE__ */ O.isValidElement(e))
    return /* @__PURE__ */ O.cloneElement(e, t);
  if (typeof e == "function")
    return /* @__PURE__ */ O.createElement(e, t);
  t.ref;
  var n = Bie(t, Iie);
  return /* @__PURE__ */ O.createElement(xp, n);
}
var rx = 1, hi = /* @__PURE__ */ (function(e) {
  function t() {
    var n;
    Die(this, t);
    for (var r = arguments.length, o = new Array(r), i = 0; i < r; i++)
      o[i] = arguments[i];
    return n = kie(this, t, [].concat(o)), h0(n, "lastBoundingBox", {
      width: -1,
      height: -1
    }), n;
  }
  return Fie(t, e), Rie(t, [{
    key: "componentDidMount",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "getBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var r = this.wrapperNode.getBoundingClientRect();
        return r.height = this.wrapperNode.offsetHeight, r.width = this.wrapperNode.offsetWidth, r;
      }
      return null;
    }
  }, {
    key: "updateBBox",
    value: function() {
      var r = this.props.onBBoxUpdate, o = this.getBBox();
      o ? (Math.abs(o.width - this.lastBoundingBox.width) > rx || Math.abs(o.height - this.lastBoundingBox.height) > rx) && (this.lastBoundingBox.width = o.width, this.lastBoundingBox.height = o.height, r && r(o)) : (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) && (this.lastBoundingBox.width = -1, this.lastBoundingBox.height = -1, r && r(null));
    }
  }, {
    key: "getBBoxSnapshot",
    value: function() {
      return this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0 ? Do({}, this.lastBoundingBox) : {
        width: 0,
        height: 0
      };
    }
  }, {
    key: "getDefaultPosition",
    value: function(r) {
      var o = this.props, i = o.layout, a = o.align, s = o.verticalAlign, l = o.margin, c = o.chartWidth, u = o.chartHeight, f, h;
      if (!r || (r.left === void 0 || r.left === null) && (r.right === void 0 || r.right === null))
        if (a === "center" && i === "vertical") {
          var p = this.getBBoxSnapshot();
          f = {
            left: ((c || 0) - p.width) / 2
          };
        } else
          f = a === "right" ? {
            right: l && l.right || 0
          } : {
            left: l && l.left || 0
          };
      if (!r || (r.top === void 0 || r.top === null) && (r.bottom === void 0 || r.bottom === null))
        if (s === "middle") {
          var C = this.getBBoxSnapshot();
          h = {
            top: ((u || 0) - C.height) / 2
          };
        } else
          h = s === "bottom" ? {
            bottom: l && l.bottom || 0
          } : {
            top: l && l.top || 0
          };
      return Do(Do({}, f), h);
    }
  }, {
    key: "render",
    value: function() {
      var r = this, o = this.props, i = o.content, a = o.width, s = o.height, l = o.wrapperStyle, c = o.payloadUniqBy, u = o.payload, f = Do(Do({
        position: "absolute",
        width: a || "auto",
        height: s || "auto"
      }, this.getDefaultPosition(l)), l);
      return /* @__PURE__ */ O.createElement("div", {
        className: "recharts-legend-wrapper",
        style: f,
        ref: function(p) {
          r.wrapperNode = p;
        }
      }, Hie(i, Do(Do({}, this.props), {}, {
        payload: ND(u, c, jie)
      })));
    }
  }], [{
    key: "getWithHeight",
    value: function(r, o) {
      var i = Do(Do({}, this.defaultProps), r.props), a = i.layout;
      return a === "vertical" && he(r.props.height) ? {
        height: r.props.height
      } : a === "horizontal" ? {
        width: r.props.width || o
      } : null;
    }
  }]);
})(xo);
h0(hi, "displayName", "Legend");
h0(hi, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "bottom"
});
var H6, ox;
function zie() {
  if (ox) return H6;
  ox = 1;
  var e = z2(), t = Mp(), n = Qn(), r = e ? e.isConcatSpreadable : void 0;
  function o(i) {
    return n(i) || t(i) || !!(r && i && i[r]);
  }
  return H6 = o, H6;
}
var z6, ix;
function BD() {
  if (ix) return z6;
  ix = 1;
  var e = OD(), t = zie();
  function n(r, o, i, a, s) {
    var l = -1, c = r.length;
    for (i || (i = t), s || (s = []); ++l < c; ) {
      var u = r[l];
      o > 0 && i(u) ? o > 1 ? n(u, o - 1, i, a, s) : e(s, u) : a || (s[s.length] = u);
    }
    return s;
  }
  return z6 = n, z6;
}
var Z6, ax;
function Zie() {
  if (ax) return Z6;
  ax = 1;
  function e(t) {
    return function(n, r, o) {
      for (var i = -1, a = Object(n), s = o(n), l = s.length; l--; ) {
        var c = s[t ? l : ++i];
        if (r(a[c], c, a) === !1)
          break;
      }
      return n;
    };
  }
  return Z6 = e, Z6;
}
var W6, sx;
function Wie() {
  if (sx) return W6;
  sx = 1;
  var e = Zie(), t = e();
  return W6 = t, W6;
}
var q6, lx;
function $D() {
  if (lx) return q6;
  lx = 1;
  var e = Wie(), t = d0();
  function n(r, o) {
    return r && e(r, o, t);
  }
  return q6 = n, q6;
}
var U6, cx;
function qie() {
  if (cx) return U6;
  cx = 1;
  var e = Z2();
  function t(n, r) {
    return function(o, i) {
      if (o == null)
        return o;
      if (!e(o))
        return n(o, i);
      for (var a = o.length, s = r ? a : -1, l = Object(o); (r ? s-- : ++s < a) && i(l[s], s, l) !== !1; )
        ;
      return o;
    };
  }
  return U6 = t, U6;
}
var G6, ux;
function Ap() {
  if (ux) return G6;
  ux = 1;
  var e = $D(), t = qie(), n = t(e);
  return G6 = n, G6;
}
var K6, fx;
function jD() {
  if (fx) return K6;
  fx = 1;
  var e = Ap(), t = Z2();
  function n(r, o) {
    var i = -1, a = t(r) ? Array(r.length) : [];
    return e(r, function(s, l, c) {
      a[++i] = o(s, l, c);
    }), a;
  }
  return K6 = n, K6;
}
var Y6, dx;
function Uie() {
  if (dx) return Y6;
  dx = 1;
  function e(t, n) {
    var r = t.length;
    for (t.sort(n); r--; )
      t[r] = t[r].value;
    return t;
  }
  return Y6 = e, Y6;
}
var X6, hx;
function Gie() {
  if (hx) return X6;
  hx = 1;
  var e = Ss();
  function t(n, r) {
    if (n !== r) {
      var o = n !== void 0, i = n === null, a = n === n, s = e(n), l = r !== void 0, c = r === null, u = r === r, f = e(r);
      if (!c && !f && !s && n > r || s && l && u && !c && !f || i && l && u || !o && u || !a)
        return 1;
      if (!i && !s && !f && n < r || f && o && a && !i && !s || c && o && a || !l && a || !u)
        return -1;
    }
    return 0;
  }
  return X6 = t, X6;
}
var Q6, px;
function Kie() {
  if (px) return Q6;
  px = 1;
  var e = Gie();
  function t(n, r, o) {
    for (var i = -1, a = n.criteria, s = r.criteria, l = a.length, c = o.length; ++i < l; ) {
      var u = e(a[i], s[i]);
      if (u) {
        if (i >= c)
          return u;
        var f = o[i];
        return u * (f == "desc" ? -1 : 1);
      }
    }
    return n.index - r.index;
  }
  return Q6 = t, Q6;
}
var J6, mx;
function Yie() {
  if (mx) return J6;
  mx = 1;
  var e = mp(), t = gp(), n = B1(), r = jD(), o = Uie(), i = PD(), a = Kie(), s = _s(), l = Qn();
  function c(u, f, h) {
    f.length ? f = e(f, function(m) {
      return l(m) ? function(g) {
        return t(g, m.length === 1 ? m[0] : m);
      } : m;
    }) : f = [s];
    var p = -1;
    f = e(f, i(n));
    var C = r(u, function(m, g, v) {
      var y = e(f, function(w) {
        return w(m);
      });
      return { criteria: y, index: ++p, value: m };
    });
    return o(C, function(m, g) {
      return a(m, g, h);
    });
  }
  return J6 = c, J6;
}
var e4, gx;
function Xie() {
  if (gx) return e4;
  gx = 1;
  function e(t, n, r) {
    switch (r.length) {
      case 0:
        return t.call(n);
      case 1:
        return t.call(n, r[0]);
      case 2:
        return t.call(n, r[0], r[1]);
      case 3:
        return t.call(n, r[0], r[1], r[2]);
    }
    return t.apply(n, r);
  }
  return e4 = e, e4;
}
var t4, Cx;
function Qie() {
  if (Cx) return t4;
  Cx = 1;
  var e = Xie(), t = Math.max;
  function n(r, o, i) {
    return o = t(o === void 0 ? r.length - 1 : o, 0), function() {
      for (var a = arguments, s = -1, l = t(a.length - o, 0), c = Array(l); ++s < l; )
        c[s] = a[o + s];
      s = -1;
      for (var u = Array(o + 1); ++s < o; )
        u[s] = a[s];
      return u[o] = i(c), e(r, this, u);
    };
  }
  return t4 = n, t4;
}
var n4, vx;
function Jie() {
  if (vx) return n4;
  vx = 1;
  function e(t) {
    return function() {
      return t;
    };
  }
  return n4 = e, n4;
}
var r4, yx;
function HD() {
  if (yx) return r4;
  yx = 1;
  var e = Vi(), t = (function() {
    try {
      var n = e(Object, "defineProperty");
      return n({}, "", {}), n;
    } catch {
    }
  })();
  return r4 = t, r4;
}
var o4, bx;
function eae() {
  if (bx) return o4;
  bx = 1;
  var e = Jie(), t = HD(), n = _s(), r = t ? function(o, i) {
    return t(o, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(i),
      writable: !0
    });
  } : n;
  return o4 = r, o4;
}
var i4, wx;
function tae() {
  if (wx) return i4;
  wx = 1;
  var e = 800, t = 16, n = Date.now;
  function r(o) {
    var i = 0, a = 0;
    return function() {
      var s = n(), l = t - (s - a);
      if (a = s, l > 0) {
        if (++i >= e)
          return arguments[0];
      } else
        i = 0;
      return o.apply(void 0, arguments);
    };
  }
  return i4 = r, i4;
}
var a4, xx;
function nae() {
  if (xx) return a4;
  xx = 1;
  var e = eae(), t = tae(), n = t(e);
  return a4 = n, a4;
}
var s4, Sx;
function rae() {
  if (Sx) return s4;
  Sx = 1;
  var e = _s(), t = Qie(), n = nae();
  function r(o, i) {
    return n(t(o, i, e), o + "");
  }
  return s4 = r, s4;
}
var l4, Mx;
function p0() {
  if (Mx) return l4;
  Mx = 1;
  var e = dp(), t = Z2(), n = Ep(), r = V1();
  function o(i, a, s) {
    if (!r(s))
      return !1;
    var l = typeof a;
    return (l == "number" ? t(s) && n(a, s.length) : l == "string" && a in s) ? e(s[a], i) : !1;
  }
  return l4 = o, l4;
}
var c4, Ex;
function oae() {
  if (Ex) return c4;
  Ex = 1;
  var e = BD(), t = Yie(), n = rae(), r = p0(), o = n(function(i, a) {
    if (i == null)
      return [];
    var s = a.length;
    return s > 1 && r(i, a[0], a[1]) ? a = [] : s > 2 && r(a[0], a[1], a[2]) && (a = [a[0]]), t(i, e(a, 1), []);
  });
  return c4 = o, c4;
}
var iae = oae();
const Pp = /* @__PURE__ */ Mt(iae);
function Zl(e) {
  "@babel/helpers - typeof";
  return Zl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Zl(e);
}
function wf() {
  return wf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, wf.apply(this, arguments);
}
function aae(e, t) {
  return uae(e) || cae(e, t) || lae(e, t) || sae();
}
function sae() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function lae(e, t) {
  if (e) {
    if (typeof e == "string") return _x(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _x(e, t);
  }
}
function _x(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function cae(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, o, i, a, s = [], l = !0, c = !1;
    try {
      if (i = (n = n.call(e)).next, t !== 0) for (; !(l = (r = i.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (u) {
      c = !0, o = u;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw o;
      }
    }
    return s;
  }
}
function uae(e) {
  if (Array.isArray(e)) return e;
}
function Ox(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function u4(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ox(Object(n), !0).forEach(function(r) {
      fae(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ox(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function fae(e, t, n) {
  return t = dae(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function dae(e) {
  var t = hae(e, "string");
  return Zl(t) == "symbol" ? t : t + "";
}
function hae(e, t) {
  if (Zl(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Zl(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function pae(e) {
  return Array.isArray(e) && ln(e[0]) && ln(e[1]) ? e.join(" ~ ") : e;
}
var mae = function(t) {
  var n = t.separator, r = n === void 0 ? " : " : n, o = t.contentStyle, i = o === void 0 ? {} : o, a = t.itemStyle, s = a === void 0 ? {} : a, l = t.labelStyle, c = l === void 0 ? {} : l, u = t.payload, f = t.formatter, h = t.itemSorter, p = t.wrapperClassName, C = t.labelClassName, m = t.label, g = t.labelFormatter, v = t.accessibilityLayer, y = v === void 0 ? !1 : v, w = function() {
    if (u && u.length) {
      var D = {
        padding: 0,
        margin: 0
      }, N = (h ? Pp(u, h) : u).map(function(R, L) {
        if (R.type === "none")
          return null;
        var B = u4({
          display: "block",
          paddingTop: 4,
          paddingBottom: 4,
          color: R.color || "#000"
        }, s), V = R.formatter || f || pae, k = R.value, z = R.name, $ = k, Z = z;
        if (V && $ != null && Z != null) {
          var W = V(k, z, R, L, u);
          if (Array.isArray(W)) {
            var H = aae(W, 2);
            $ = H[0], Z = H[1];
          } else
            $ = W;
        }
        return (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ O.createElement("li", {
            className: "recharts-tooltip-item",
            key: "tooltip-item-".concat(L),
            style: B
          }, ln(Z) ? /* @__PURE__ */ O.createElement("span", {
            className: "recharts-tooltip-item-name"
          }, Z) : null, ln(Z) ? /* @__PURE__ */ O.createElement("span", {
            className: "recharts-tooltip-item-separator"
          }, r) : null, /* @__PURE__ */ O.createElement("span", {
            className: "recharts-tooltip-item-value"
          }, $), /* @__PURE__ */ O.createElement("span", {
            className: "recharts-tooltip-item-unit"
          }, R.unit || ""))
        );
      });
      return /* @__PURE__ */ O.createElement("ul", {
        className: "recharts-tooltip-item-list",
        style: D
      }, N);
    }
    return null;
  }, x = u4({
    margin: 0,
    padding: 10,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    whiteSpace: "nowrap"
  }, i), b = u4({
    margin: 0
  }, c), S = !Ne(m), M = S ? m : "", E = We("recharts-default-tooltip", p), P = We("recharts-tooltip-label", C);
  S && g && u !== void 0 && u !== null && (M = g(m, u));
  var T = y ? {
    role: "status",
    "aria-live": "assertive"
  } : {};
  return /* @__PURE__ */ O.createElement("div", wf({
    className: E,
    style: x
  }, T), /* @__PURE__ */ O.createElement("p", {
    className: P,
    style: b
  }, /* @__PURE__ */ O.isValidElement(M) ? M : "".concat(M)), w());
};
function Wl(e) {
  "@babel/helpers - typeof";
  return Wl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Wl(e);
}
function Ec(e, t, n) {
  return t = gae(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function gae(e) {
  var t = Cae(e, "string");
  return Wl(t) == "symbol" ? t : t + "";
}
function Cae(e, t) {
  if (Wl(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Wl(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Ks = "recharts-tooltip-wrapper", vae = {
  visibility: "hidden"
};
function yae(e) {
  var t = e.coordinate, n = e.translateX, r = e.translateY;
  return We(Ks, Ec(Ec(Ec(Ec({}, "".concat(Ks, "-right"), he(n) && t && he(t.x) && n >= t.x), "".concat(Ks, "-left"), he(n) && t && he(t.x) && n < t.x), "".concat(Ks, "-bottom"), he(r) && t && he(t.y) && r >= t.y), "".concat(Ks, "-top"), he(r) && t && he(t.y) && r < t.y));
}
function Ax(e) {
  var t = e.allowEscapeViewBox, n = e.coordinate, r = e.key, o = e.offsetTopLeft, i = e.position, a = e.reverseDirection, s = e.tooltipDimension, l = e.viewBox, c = e.viewBoxDimension;
  if (i && he(i[r]))
    return i[r];
  var u = n[r] - s - o, f = n[r] + o;
  if (t[r])
    return a[r] ? u : f;
  if (a[r]) {
    var h = u, p = l[r];
    return h < p ? Math.max(f, l[r]) : Math.max(u, l[r]);
  }
  var C = f + s, m = l[r] + c;
  return C > m ? Math.max(u, l[r]) : Math.max(f, l[r]);
}
function bae(e) {
  var t = e.translateX, n = e.translateY, r = e.useTranslate3d;
  return {
    transform: r ? "translate3d(".concat(t, "px, ").concat(n, "px, 0)") : "translate(".concat(t, "px, ").concat(n, "px)")
  };
}
function wae(e) {
  var t = e.allowEscapeViewBox, n = e.coordinate, r = e.offsetTopLeft, o = e.position, i = e.reverseDirection, a = e.tooltipBox, s = e.useTranslate3d, l = e.viewBox, c, u, f;
  return a.height > 0 && a.width > 0 && n ? (u = Ax({
    allowEscapeViewBox: t,
    coordinate: n,
    key: "x",
    offsetTopLeft: r,
    position: o,
    reverseDirection: i,
    tooltipDimension: a.width,
    viewBox: l,
    viewBoxDimension: l.width
  }), f = Ax({
    allowEscapeViewBox: t,
    coordinate: n,
    key: "y",
    offsetTopLeft: r,
    position: o,
    reverseDirection: i,
    tooltipDimension: a.height,
    viewBox: l,
    viewBoxDimension: l.height
  }), c = bae({
    translateX: u,
    translateY: f,
    useTranslate3d: s
  })) : c = vae, {
    cssProperties: c,
    cssClasses: yae({
      translateX: u,
      translateY: f,
      coordinate: n
    })
  };
}
function Za(e) {
  "@babel/helpers - typeof";
  return Za = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Za(e);
}
function Px(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Tx(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Px(Object(n), !0).forEach(function(r) {
      Sf(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Px(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function xae(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Sae(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, ZD(r.key), r);
  }
}
function Mae(e, t, n) {
  return t && Sae(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Eae(e, t, n) {
  return t = O5(t), _ae(e, zD() ? Reflect.construct(t, n || [], O5(e).constructor) : t.apply(e, n));
}
function _ae(e, t) {
  if (t && (Za(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Oae(e);
}
function Oae(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function zD() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (zD = function() {
    return !!e;
  })();
}
function O5(e) {
  return O5 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, O5(e);
}
function Aae(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && xf(e, t);
}
function xf(e, t) {
  return xf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, xf(e, t);
}
function Sf(e, t, n) {
  return t = ZD(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function ZD(e) {
  var t = Pae(e, "string");
  return Za(t) == "symbol" ? t : t + "";
}
function Pae(e, t) {
  if (Za(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Za(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Ix = 1, Tae = /* @__PURE__ */ (function(e) {
  function t() {
    var n;
    xae(this, t);
    for (var r = arguments.length, o = new Array(r), i = 0; i < r; i++)
      o[i] = arguments[i];
    return n = Eae(this, t, [].concat(o)), Sf(n, "state", {
      dismissed: !1,
      dismissedAtCoordinate: {
        x: 0,
        y: 0
      },
      lastBoundingBox: {
        width: -1,
        height: -1
      }
    }), Sf(n, "handleKeyDown", function(a) {
      if (a.key === "Escape") {
        var s, l, c, u;
        n.setState({
          dismissed: !0,
          dismissedAtCoordinate: {
            x: (s = (l = n.props.coordinate) === null || l === void 0 ? void 0 : l.x) !== null && s !== void 0 ? s : 0,
            y: (c = (u = n.props.coordinate) === null || u === void 0 ? void 0 : u.y) !== null && c !== void 0 ? c : 0
          }
        });
      }
    }), n;
  }
  return Aae(t, e), Mae(t, [{
    key: "updateBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var r = this.wrapperNode.getBoundingClientRect();
        (Math.abs(r.width - this.state.lastBoundingBox.width) > Ix || Math.abs(r.height - this.state.lastBoundingBox.height) > Ix) && this.setState({
          lastBoundingBox: {
            width: r.width,
            height: r.height
          }
        });
      } else (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) && this.setState({
        lastBoundingBox: {
          width: -1,
          height: -1
        }
      });
    }
  }, {
    key: "componentDidMount",
    value: function() {
      document.addEventListener("keydown", this.handleKeyDown), this.updateBBox();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      document.removeEventListener("keydown", this.handleKeyDown);
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      var r, o;
      this.props.active && this.updateBBox(), this.state.dismissed && (((r = this.props.coordinate) === null || r === void 0 ? void 0 : r.x) !== this.state.dismissedAtCoordinate.x || ((o = this.props.coordinate) === null || o === void 0 ? void 0 : o.y) !== this.state.dismissedAtCoordinate.y) && (this.state.dismissed = !1);
    }
  }, {
    key: "render",
    value: function() {
      var r = this, o = this.props, i = o.active, a = o.allowEscapeViewBox, s = o.animationDuration, l = o.animationEasing, c = o.children, u = o.coordinate, f = o.hasPayload, h = o.isAnimationActive, p = o.offset, C = o.position, m = o.reverseDirection, g = o.useTranslate3d, v = o.viewBox, y = o.wrapperStyle, w = wae({
        allowEscapeViewBox: a,
        coordinate: u,
        offsetTopLeft: p,
        position: C,
        reverseDirection: m,
        tooltipBox: this.state.lastBoundingBox,
        useTranslate3d: g,
        viewBox: v
      }), x = w.cssClasses, b = w.cssProperties, S = Tx(Tx({
        transition: h && i ? "transform ".concat(s, "ms ").concat(l) : void 0
      }, b), {}, {
        pointerEvents: "none",
        visibility: !this.state.dismissed && i && f ? "visible" : "hidden",
        position: "absolute",
        top: 0,
        left: 0
      }, y);
      return (
        // This element allow listening to the `Escape` key.
        // See https://github.com/recharts/recharts/pull/2925
        /* @__PURE__ */ O.createElement("div", {
          tabIndex: -1,
          className: x,
          style: S,
          ref: function(E) {
            r.wrapperNode = E;
          }
        }, c)
      );
    }
  }]);
})(xo), Iae = function() {
  return !(typeof window < "u" && window.document && window.document.createElement && window.setTimeout);
}, $1 = {
  isSsr: Iae()
};
function Wa(e) {
  "@babel/helpers - typeof";
  return Wa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Wa(e);
}
function Dx(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Rx(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Dx(Object(n), !0).forEach(function(r) {
      Tp(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Dx(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Dae(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Rae(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, qD(r.key), r);
  }
}
function kae(e, t, n) {
  return t && Rae(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Lae(e, t, n) {
  return t = A5(t), Nae(e, WD() ? Reflect.construct(t, n || [], A5(e).constructor) : t.apply(e, n));
}
function Nae(e, t) {
  if (t && (Wa(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Fae(e);
}
function Fae(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function WD() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (WD = function() {
    return !!e;
  })();
}
function A5(e) {
  return A5 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, A5(e);
}
function Vae(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Mf(e, t);
}
function Mf(e, t) {
  return Mf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, Mf(e, t);
}
function Tp(e, t, n) {
  return t = qD(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function qD(e) {
  var t = Bae(e, "string");
  return Wa(t) == "symbol" ? t : t + "";
}
function Bae(e, t) {
  if (Wa(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Wa(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function $ae(e) {
  return e.dataKey;
}
function jae(e, t) {
  return /* @__PURE__ */ O.isValidElement(e) ? /* @__PURE__ */ O.cloneElement(e, t) : typeof e == "function" ? /* @__PURE__ */ O.createElement(e, t) : /* @__PURE__ */ O.createElement(mae, t);
}
var eo = /* @__PURE__ */ (function(e) {
  function t() {
    return Dae(this, t), Lae(this, t, arguments);
  }
  return Vae(t, e), kae(t, [{
    key: "render",
    value: function() {
      var r = this, o = this.props, i = o.active, a = o.allowEscapeViewBox, s = o.animationDuration, l = o.animationEasing, c = o.content, u = o.coordinate, f = o.filterNull, h = o.isAnimationActive, p = o.offset, C = o.payload, m = o.payloadUniqBy, g = o.position, v = o.reverseDirection, y = o.useTranslate3d, w = o.viewBox, x = o.wrapperStyle, b = C ?? [];
      f && b.length && (b = ND(C.filter(function(M) {
        return M.value != null && (M.hide !== !0 || r.props.includeHidden);
      }), m, $ae));
      var S = b.length > 0;
      return /* @__PURE__ */ O.createElement(Tae, {
        allowEscapeViewBox: a,
        animationDuration: s,
        animationEasing: l,
        isAnimationActive: h,
        active: i,
        coordinate: u,
        hasPayload: S,
        offset: p,
        position: g,
        reverseDirection: v,
        useTranslate3d: y,
        viewBox: w,
        wrapperStyle: x
      }, jae(c, Rx(Rx({}, this.props), {}, {
        payload: b
      })));
    }
  }]);
})(xo);
Tp(eo, "displayName", "Tooltip");
Tp(eo, "defaultProps", {
  accessibilityLayer: !1,
  allowEscapeViewBox: {
    x: !1,
    y: !1
  },
  animationDuration: 400,
  animationEasing: "ease",
  contentStyle: {},
  coordinate: {
    x: 0,
    y: 0
  },
  cursor: !0,
  cursorStyle: {},
  filterNull: !0,
  isAnimationActive: !$1.isSsr,
  itemStyle: {},
  labelStyle: {},
  offset: 10,
  reverseDirection: {
    x: !1,
    y: !1
  },
  separator: " : ",
  trigger: "hover",
  useTranslate3d: !1,
  viewBox: {
    x: 0,
    y: 0,
    height: 0,
    width: 0
  },
  wrapperStyle: {}
});
var f4, kx;
function Hae() {
  if (kx) return f4;
  kx = 1;
  var e = Oo(), t = function() {
    return e.Date.now();
  };
  return f4 = t, f4;
}
var d4, Lx;
function zae() {
  if (Lx) return d4;
  Lx = 1;
  var e = /\s/;
  function t(n) {
    for (var r = n.length; r-- && e.test(n.charAt(r)); )
      ;
    return r;
  }
  return d4 = t, d4;
}
var h4, Nx;
function Zae() {
  if (Nx) return h4;
  Nx = 1;
  var e = zae(), t = /^\s+/;
  function n(r) {
    return r && r.slice(0, e(r) + 1).replace(t, "");
  }
  return h4 = n, h4;
}
var p4, Fx;
function UD() {
  if (Fx) return p4;
  Fx = 1;
  var e = Zae(), t = V1(), n = Ss(), r = NaN, o = /^[-+]0x[0-9a-f]+$/i, i = /^0b[01]+$/i, a = /^0o[0-7]+$/i, s = parseInt;
  function l(c) {
    if (typeof c == "number")
      return c;
    if (n(c))
      return r;
    if (t(c)) {
      var u = typeof c.valueOf == "function" ? c.valueOf() : c;
      c = t(u) ? u + "" : u;
    }
    if (typeof c != "string")
      return c === 0 ? c : +c;
    c = e(c);
    var f = i.test(c);
    return f || a.test(c) ? s(c.slice(2), f ? 2 : 8) : o.test(c) ? r : +c;
  }
  return p4 = l, p4;
}
var m4, Vx;
function Wae() {
  if (Vx) return m4;
  Vx = 1;
  var e = V1(), t = Hae(), n = UD(), r = "Expected a function", o = Math.max, i = Math.min;
  function a(s, l, c) {
    var u, f, h, p, C, m, g = 0, v = !1, y = !1, w = !0;
    if (typeof s != "function")
      throw new TypeError(r);
    l = n(l) || 0, e(c) && (v = !!c.leading, y = "maxWait" in c, h = y ? o(n(c.maxWait) || 0, l) : h, w = "trailing" in c ? !!c.trailing : w);
    function x(N) {
      var R = u, L = f;
      return u = f = void 0, g = N, p = s.apply(L, R), p;
    }
    function b(N) {
      return g = N, C = setTimeout(E, l), v ? x(N) : p;
    }
    function S(N) {
      var R = N - m, L = N - g, B = l - R;
      return y ? i(B, h - L) : B;
    }
    function M(N) {
      var R = N - m, L = N - g;
      return m === void 0 || R >= l || R < 0 || y && L >= h;
    }
    function E() {
      var N = t();
      if (M(N))
        return P(N);
      C = setTimeout(E, S(N));
    }
    function P(N) {
      return C = void 0, w && u ? x(N) : (u = f = void 0, p);
    }
    function T() {
      C !== void 0 && clearTimeout(C), g = 0, u = m = f = C = void 0;
    }
    function _() {
      return C === void 0 ? p : P(t());
    }
    function D() {
      var N = t(), R = M(N);
      if (u = arguments, f = this, m = N, R) {
        if (C === void 0)
          return b(m);
        if (y)
          return clearTimeout(C), C = setTimeout(E, l), x(m);
      }
      return C === void 0 && (C = setTimeout(E, l)), p;
    }
    return D.cancel = T, D.flush = _, D;
  }
  return m4 = a, m4;
}
var g4, Bx;
function qae() {
  if (Bx) return g4;
  Bx = 1;
  var e = Wae(), t = V1(), n = "Expected a function";
  function r(o, i, a) {
    var s = !0, l = !0;
    if (typeof o != "function")
      throw new TypeError(n);
    return t(a) && (s = "leading" in a ? !!a.leading : s, l = "trailing" in a ? !!a.trailing : l), e(o, i, {
      leading: s,
      maxWait: i,
      trailing: l
    });
  }
  return g4 = r, g4;
}
var Uae = qae();
const GD = /* @__PURE__ */ Mt(Uae);
function ql(e) {
  "@babel/helpers - typeof";
  return ql = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ql(e);
}
function $x(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function _c(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? $x(Object(n), !0).forEach(function(r) {
      Gae(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $x(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Gae(e, t, n) {
  return t = Kae(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Kae(e) {
  var t = Yae(e, "string");
  return ql(t) == "symbol" ? t : t + "";
}
function Yae(e, t) {
  if (ql(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (ql(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Xae(e, t) {
  return tse(e) || ese(e, t) || Jae(e, t) || Qae();
}
function Qae() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Jae(e, t) {
  if (e) {
    if (typeof e == "string") return jx(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return jx(e, t);
  }
}
function jx(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function ese(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, o, i, a, s = [], l = !0, c = !1;
    try {
      if (i = (n = n.call(e)).next, t !== 0) for (; !(l = (r = i.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (u) {
      c = !0, o = u;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw o;
      }
    }
    return s;
  }
}
function tse(e) {
  if (Array.isArray(e)) return e;
}
var nse = /* @__PURE__ */ Xe(function(e, t) {
  var n = e.aspect, r = e.initialDimension, o = r === void 0 ? {
    width: -1,
    height: -1
  } : r, i = e.width, a = i === void 0 ? "100%" : i, s = e.height, l = s === void 0 ? "100%" : s, c = e.minWidth, u = c === void 0 ? 0 : c, f = e.minHeight, h = e.maxHeight, p = e.children, C = e.debounce, m = C === void 0 ? 0 : C, g = e.id, v = e.className, y = e.onResize, w = e.style, x = w === void 0 ? {} : w, b = ke(null), S = ke();
  S.current = y, Ad(t, function() {
    return Object.defineProperty(b.current, "current", {
      get: function() {
        return console.warn("The usage of ref.current.current is deprecated and will no longer be supported."), b.current;
      },
      configurable: !0
    });
  });
  var M = ue({
    containerWidth: o.width,
    containerHeight: o.height
  }), E = Xae(M, 2), P = E[0], T = E[1], _ = ct(function(N, R) {
    T(function(L) {
      var B = Math.round(N), V = Math.round(R);
      return L.containerWidth === B && L.containerHeight === V ? L : {
        containerWidth: B,
        containerHeight: V
      };
    });
  }, []);
  ve(function() {
    var N = function(z) {
      var $, Z = z[0].contentRect, W = Z.width, H = Z.height;
      _(W, H), ($ = S.current) === null || $ === void 0 || $.call(S, W, H);
    };
    m > 0 && (N = GD(N, m, {
      trailing: !0,
      leading: !1
    }));
    var R = new ResizeObserver(N), L = b.current.getBoundingClientRect(), B = L.width, V = L.height;
    return _(B, V), R.observe(b.current), function() {
      R.disconnect();
    };
  }, [_, m]);
  var D = _e(function() {
    var N = P.containerWidth, R = P.containerHeight;
    if (N < 0 || R < 0)
      return null;
    Wo(ii(a) || ii(l), `The width(%s) and height(%s) are both fixed numbers,
       maybe you don't need to use a ResponsiveContainer.`, a, l), Wo(!n || n > 0, "The aspect(%s) must be greater than zero.", n);
    var L = ii(a) ? N : a, B = ii(l) ? R : l;
    n && n > 0 && (L ? B = L / n : B && (L = B * n), h && B > h && (B = h)), Wo(L > 0 || B > 0, `The width(%s) and height(%s) of chart should be greater than 0,
       please check the style of container, or the props width(%s) and height(%s),
       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the
       height and width.`, L, B, a, l, u, f, n);
    var V = !Array.isArray(p) && Zo(p.type).endsWith("Chart");
    return O.Children.map(p, function(k) {
      return /* @__PURE__ */ O.isValidElement(k) ? /* @__PURE__ */ Qt(k, _c({
        width: L,
        height: B
      }, V ? {
        style: _c({
          height: "100%",
          width: "100%",
          maxHeight: B,
          maxWidth: L
        }, k.props.style)
      } : {})) : k;
    });
  }, [n, p, l, h, f, u, P, a]);
  return /* @__PURE__ */ O.createElement("div", {
    id: g ? "".concat(g) : void 0,
    className: We("recharts-responsive-container", v),
    style: _c(_c({}, x), {}, {
      width: a,
      height: l,
      minWidth: u,
      minHeight: f,
      maxHeight: h
    }),
    ref: b
  }, D);
}), Ip = function(t) {
  return null;
};
Ip.displayName = "Cell";
function Ul(e) {
  "@babel/helpers - typeof";
  return Ul = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ul(e);
}
function Hx(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ef(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Hx(Object(n), !0).forEach(function(r) {
      rse(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Hx(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function rse(e, t, n) {
  return t = ose(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function ose(e) {
  var t = ise(e, "string");
  return Ul(t) == "symbol" ? t : t + "";
}
function ise(e, t) {
  if (Ul(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Ul(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var ta = {
  widthCache: {},
  cacheCount: 0
}, ase = 2e3, sse = {
  position: "absolute",
  top: "-20000px",
  left: 0,
  padding: 0,
  margin: 0,
  border: "none",
  whiteSpace: "pre"
}, zx = "recharts_measurement_span";
function lse(e) {
  var t = Ef({}, e);
  return Object.keys(t).forEach(function(n) {
    t[n] || delete t[n];
  }), t;
}
var bl = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (t == null || $1.isSsr)
    return {
      width: 0,
      height: 0
    };
  var r = lse(n), o = JSON.stringify({
    text: t,
    copyStyle: r
  });
  if (ta.widthCache[o])
    return ta.widthCache[o];
  try {
    var i = document.getElementById(zx);
    i || (i = document.createElement("span"), i.setAttribute("id", zx), i.setAttribute("aria-hidden", "true"), document.body.appendChild(i));
    var a = Ef(Ef({}, sse), r);
    Object.assign(i.style, a), i.textContent = "".concat(t);
    var s = i.getBoundingClientRect(), l = {
      width: s.width,
      height: s.height
    };
    return ta.widthCache[o] = l, ++ta.cacheCount > ase && (ta.cacheCount = 0, ta.widthCache = {}), l;
  } catch {
    return {
      width: 0,
      height: 0
    };
  }
}, cse = function(t) {
  return {
    top: t.top + window.scrollY - document.documentElement.clientTop,
    left: t.left + window.scrollX - document.documentElement.clientLeft
  };
};
function Gl(e) {
  "@babel/helpers - typeof";
  return Gl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Gl(e);
}
function P5(e, t) {
  return hse(e) || dse(e, t) || fse(e, t) || use();
}
function use() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function fse(e, t) {
  if (e) {
    if (typeof e == "string") return Zx(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Zx(e, t);
  }
}
function Zx(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function dse(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, o, i, a, s = [], l = !0, c = !1;
    try {
      if (i = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n) return;
        l = !1;
      } else for (; !(l = (r = i.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (u) {
      c = !0, o = u;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw o;
      }
    }
    return s;
  }
}
function hse(e) {
  if (Array.isArray(e)) return e;
}
function pse(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Wx(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, gse(r.key), r);
  }
}
function mse(e, t, n) {
  return t && Wx(e.prototype, t), n && Wx(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function gse(e) {
  var t = Cse(e, "string");
  return Gl(t) == "symbol" ? t : t + "";
}
function Cse(e, t) {
  if (Gl(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Gl(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var qx = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, Ux = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, vse = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/, yse = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/, KD = {
  cm: 96 / 2.54,
  mm: 96 / 25.4,
  pt: 96 / 72,
  pc: 96 / 6,
  in: 96,
  Q: 96 / (2.54 * 40),
  px: 1
}, bse = Object.keys(KD), ma = "NaN";
function wse(e, t) {
  return e * KD[t];
}
var Oc = /* @__PURE__ */ (function() {
  function e(t, n) {
    pse(this, e), this.num = t, this.unit = n, this.num = t, this.unit = n, Number.isNaN(t) && (this.unit = ""), n !== "" && !vse.test(n) && (this.num = NaN, this.unit = ""), bse.includes(n) && (this.num = wse(t, n), this.unit = "px");
  }
  return mse(e, [{
    key: "add",
    value: function(n) {
      return this.unit !== n.unit ? new e(NaN, "") : new e(this.num + n.num, this.unit);
    }
  }, {
    key: "subtract",
    value: function(n) {
      return this.unit !== n.unit ? new e(NaN, "") : new e(this.num - n.num, this.unit);
    }
  }, {
    key: "multiply",
    value: function(n) {
      return this.unit !== "" && n.unit !== "" && this.unit !== n.unit ? new e(NaN, "") : new e(this.num * n.num, this.unit || n.unit);
    }
  }, {
    key: "divide",
    value: function(n) {
      return this.unit !== "" && n.unit !== "" && this.unit !== n.unit ? new e(NaN, "") : new e(this.num / n.num, this.unit || n.unit);
    }
  }, {
    key: "toString",
    value: function() {
      return "".concat(this.num).concat(this.unit);
    }
  }, {
    key: "isNaN",
    value: function() {
      return Number.isNaN(this.num);
    }
  }], [{
    key: "parse",
    value: function(n) {
      var r, o = (r = yse.exec(n)) !== null && r !== void 0 ? r : [], i = P5(o, 3), a = i[1], s = i[2];
      return new e(parseFloat(a), s ?? "");
    }
  }]);
})();
function YD(e) {
  if (e.includes(ma))
    return ma;
  for (var t = e; t.includes("*") || t.includes("/"); ) {
    var n, r = (n = qx.exec(t)) !== null && n !== void 0 ? n : [], o = P5(r, 4), i = o[1], a = o[2], s = o[3], l = Oc.parse(i ?? ""), c = Oc.parse(s ?? ""), u = a === "*" ? l.multiply(c) : l.divide(c);
    if (u.isNaN())
      return ma;
    t = t.replace(qx, u.toString());
  }
  for (; t.includes("+") || /.-\d+(?:\.\d+)?/.test(t); ) {
    var f, h = (f = Ux.exec(t)) !== null && f !== void 0 ? f : [], p = P5(h, 4), C = p[1], m = p[2], g = p[3], v = Oc.parse(C ?? ""), y = Oc.parse(g ?? ""), w = m === "+" ? v.add(y) : v.subtract(y);
    if (w.isNaN())
      return ma;
    t = t.replace(Ux, w.toString());
  }
  return t;
}
var Gx = /\(([^()]*)\)/;
function xse(e) {
  for (var t = e; t.includes("("); ) {
    var n = Gx.exec(t), r = P5(n, 2), o = r[1];
    t = t.replace(Gx, YD(o));
  }
  return t;
}
function Sse(e) {
  var t = e.replace(/\s+/g, "");
  return t = xse(t), t = YD(t), t;
}
function Mse(e) {
  try {
    return Sse(e);
  } catch {
    return ma;
  }
}
function C4(e) {
  var t = Mse(e.slice(5, -1));
  return t === ma ? "" : t;
}
var Ese = ["x", "y", "lineHeight", "capHeight", "scaleToFit", "textAnchor", "verticalAnchor", "fill"], _se = ["dx", "dy", "angle", "className", "breakAll"];
function _f() {
  return _f = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, _f.apply(this, arguments);
}
function Kx(e, t) {
  if (e == null) return {};
  var n = Ose(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Ose(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function Yx(e, t) {
  return Ise(e) || Tse(e, t) || Pse(e, t) || Ase();
}
function Ase() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Pse(e, t) {
  if (e) {
    if (typeof e == "string") return Xx(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Xx(e, t);
  }
}
function Xx(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Tse(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, o, i, a, s = [], l = !0, c = !1;
    try {
      if (i = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n) return;
        l = !1;
      } else for (; !(l = (r = i.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (u) {
      c = !0, o = u;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw o;
      }
    }
    return s;
  }
}
function Ise(e) {
  if (Array.isArray(e)) return e;
}
var XD = /[ \f\n\r\t\v\u2028\u2029]+/, QD = function(t) {
  var n = t.children, r = t.breakAll, o = t.style;
  try {
    var i = [];
    Ne(n) || (r ? i = n.toString().split("") : i = n.toString().split(XD));
    var a = i.map(function(l) {
      return {
        word: l,
        width: bl(l, o).width
      };
    }), s = r ? 0 : bl(" ", o).width;
    return {
      wordsWithComputedWidth: a,
      spaceWidth: s
    };
  } catch {
    return null;
  }
}, Dse = function(t, n, r, o, i) {
  var a = t.maxLines, s = t.children, l = t.style, c = t.breakAll, u = he(a), f = s, h = function() {
    var L = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return L.reduce(function(B, V) {
      var k = V.word, z = V.width, $ = B[B.length - 1];
      if ($ && (o == null || i || $.width + z + r < Number(o)))
        $.words.push(k), $.width += z + r;
      else {
        var Z = {
          words: [k],
          width: z
        };
        B.push(Z);
      }
      return B;
    }, []);
  }, p = h(n), C = function(L) {
    return L.reduce(function(B, V) {
      return B.width > V.width ? B : V;
    });
  };
  if (!u)
    return p;
  for (var m = "…", g = function(L) {
    var B = f.slice(0, L), V = QD({
      breakAll: c,
      style: l,
      children: B + m
    }).wordsWithComputedWidth, k = h(V), z = k.length > a || C(k).width > Number(o);
    return [z, k];
  }, v = 0, y = f.length - 1, w = 0, x; v <= y && w <= f.length - 1; ) {
    var b = Math.floor((v + y) / 2), S = b - 1, M = g(S), E = Yx(M, 2), P = E[0], T = E[1], _ = g(b), D = Yx(_, 1), N = D[0];
    if (!P && !N && (v = b + 1), P && N && (y = b - 1), !P && N) {
      x = T;
      break;
    }
    w++;
  }
  return x || p;
}, Qx = function(t) {
  var n = Ne(t) ? [] : t.toString().split(XD);
  return [{
    words: n
  }];
}, Rse = function(t) {
  var n = t.width, r = t.scaleToFit, o = t.children, i = t.style, a = t.breakAll, s = t.maxLines;
  if ((n || r) && !$1.isSsr) {
    var l, c, u = QD({
      breakAll: a,
      children: o,
      style: i
    });
    if (u) {
      var f = u.wordsWithComputedWidth, h = u.spaceWidth;
      l = f, c = h;
    } else
      return Qx(o);
    return Dse({
      breakAll: a,
      children: o,
      maxLines: s,
      style: i
    }, l, c, n, r);
  }
  return Qx(o);
}, Jx = "#808080", T5 = function(t) {
  var n = t.x, r = n === void 0 ? 0 : n, o = t.y, i = o === void 0 ? 0 : o, a = t.lineHeight, s = a === void 0 ? "1em" : a, l = t.capHeight, c = l === void 0 ? "0.71em" : l, u = t.scaleToFit, f = u === void 0 ? !1 : u, h = t.textAnchor, p = h === void 0 ? "start" : h, C = t.verticalAnchor, m = C === void 0 ? "end" : C, g = t.fill, v = g === void 0 ? Jx : g, y = Kx(t, Ese), w = _e(function() {
    return Rse({
      breakAll: y.breakAll,
      children: y.children,
      maxLines: y.maxLines,
      scaleToFit: f,
      style: y.style,
      width: y.width
    });
  }, [y.breakAll, y.children, y.maxLines, f, y.style, y.width]), x = y.dx, b = y.dy, S = y.angle, M = y.className, E = y.breakAll, P = Kx(y, _se);
  if (!ln(r) || !ln(i))
    return null;
  var T = r + (he(x) ? x : 0), _ = i + (he(b) ? b : 0), D;
  switch (m) {
    case "start":
      D = C4("calc(".concat(c, ")"));
      break;
    case "middle":
      D = C4("calc(".concat((w.length - 1) / 2, " * -").concat(s, " + (").concat(c, " / 2))"));
      break;
    default:
      D = C4("calc(".concat(w.length - 1, " * -").concat(s, ")"));
      break;
  }
  var N = [];
  if (f) {
    var R = w[0].width, L = y.width;
    N.push("scale(".concat((he(L) ? L / R : 1) / R, ")"));
  }
  return S && N.push("rotate(".concat(S, ", ").concat(T, ", ").concat(_, ")")), N.length && (P.transform = N.join(" ")), /* @__PURE__ */ O.createElement("text", _f({}, Be(P, !0), {
    x: T,
    y: _,
    className: We("recharts-text", M),
    textAnchor: p,
    fill: v.includes("url") ? Jx : v
  }), w.map(function(B, V) {
    var k = B.words.join(E ? "" : " ");
    return (
      // duplicate words will cause duplicate keys
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ O.createElement("tspan", {
        x: T,
        dy: V === 0 ? D : s,
        key: "".concat(k, "-").concat(V)
      }, k)
    );
  }));
};
function M1(e, t) {
  return e == null || t == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function kse(e, t) {
  return e == null || t == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function Dp(e) {
  let t, n, r;
  e.length !== 2 ? (t = M1, n = (s, l) => M1(e(s), l), r = (s, l) => e(s) - l) : (t = e === M1 || e === kse ? e : Lse, n = e, r = e);
  function o(s, l, c = 0, u = s.length) {
    if (c < u) {
      if (t(l, l) !== 0) return u;
      do {
        const f = c + u >>> 1;
        n(s[f], l) < 0 ? c = f + 1 : u = f;
      } while (c < u);
    }
    return c;
  }
  function i(s, l, c = 0, u = s.length) {
    if (c < u) {
      if (t(l, l) !== 0) return u;
      do {
        const f = c + u >>> 1;
        n(s[f], l) <= 0 ? c = f + 1 : u = f;
      } while (c < u);
    }
    return c;
  }
  function a(s, l, c = 0, u = s.length) {
    const f = o(s, l, c, u - 1);
    return f > c && r(s[f - 1], l) > -r(s[f], l) ? f - 1 : f;
  }
  return { left: o, center: a, right: i };
}
function Lse() {
  return 0;
}
function JD(e) {
  return e === null ? NaN : +e;
}
function* Nse(e, t) {
  for (let n of e)
    n != null && (n = +n) >= n && (yield n);
}
const Fse = Dp(M1), W2 = Fse.right;
Dp(JD).center;
class eS extends Map {
  constructor(t, n = $se) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: n } }), t != null) for (const [r, o] of t) this.set(r, o);
  }
  get(t) {
    return super.get(tS(this, t));
  }
  has(t) {
    return super.has(tS(this, t));
  }
  set(t, n) {
    return super.set(Vse(this, t), n);
  }
  delete(t) {
    return super.delete(Bse(this, t));
  }
}
function tS({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) ? e.get(r) : n;
}
function Vse({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) ? e.get(r) : (e.set(r, n), n);
}
function Bse({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) && (n = e.get(r), e.delete(r)), n;
}
function $se(e) {
  return e !== null && typeof e == "object" ? e.valueOf() : e;
}
function jse(e = M1) {
  if (e === M1) return eR;
  if (typeof e != "function") throw new TypeError("compare is not a function");
  return (t, n) => {
    const r = e(t, n);
    return r || r === 0 ? r : (e(n, n) === 0) - (e(t, t) === 0);
  };
}
function eR(e, t) {
  return (e == null || !(e >= e)) - (t == null || !(t >= t)) || (e < t ? -1 : e > t ? 1 : 0);
}
const Hse = Math.sqrt(50), zse = Math.sqrt(10), Zse = Math.sqrt(2);
function I5(e, t, n) {
  const r = (t - e) / Math.max(0, n), o = Math.floor(Math.log10(r)), i = r / Math.pow(10, o), a = i >= Hse ? 10 : i >= zse ? 5 : i >= Zse ? 2 : 1;
  let s, l, c;
  return o < 0 ? (c = Math.pow(10, -o) / a, s = Math.round(e * c), l = Math.round(t * c), s / c < e && ++s, l / c > t && --l, c = -c) : (c = Math.pow(10, o) * a, s = Math.round(e / c), l = Math.round(t / c), s * c < e && ++s, l * c > t && --l), l < s && 0.5 <= n && n < 2 ? I5(e, t, n * 2) : [s, l, c];
}
function Of(e, t, n) {
  if (t = +t, e = +e, n = +n, !(n > 0)) return [];
  if (e === t) return [e];
  const r = t < e, [o, i, a] = r ? I5(t, e, n) : I5(e, t, n);
  if (!(i >= o)) return [];
  const s = i - o + 1, l = new Array(s);
  if (r)
    if (a < 0) for (let c = 0; c < s; ++c) l[c] = (i - c) / -a;
    else for (let c = 0; c < s; ++c) l[c] = (i - c) * a;
  else if (a < 0) for (let c = 0; c < s; ++c) l[c] = (o + c) / -a;
  else for (let c = 0; c < s; ++c) l[c] = (o + c) * a;
  return l;
}
function Af(e, t, n) {
  return t = +t, e = +e, n = +n, I5(e, t, n)[2];
}
function Pf(e, t, n) {
  t = +t, e = +e, n = +n;
  const r = t < e, o = r ? Af(t, e, n) : Af(e, t, n);
  return (r ? -1 : 1) * (o < 0 ? 1 / -o : o);
}
function nS(e, t) {
  let n;
  for (const r of e)
    r != null && (n < r || n === void 0 && r >= r) && (n = r);
  return n;
}
function rS(e, t) {
  let n;
  for (const r of e)
    r != null && (n > r || n === void 0 && r >= r) && (n = r);
  return n;
}
function tR(e, t, n = 0, r = 1 / 0, o) {
  if (t = Math.floor(t), n = Math.floor(Math.max(0, n)), r = Math.floor(Math.min(e.length - 1, r)), !(n <= t && t <= r)) return e;
  for (o = o === void 0 ? eR : jse(o); r > n; ) {
    if (r - n > 600) {
      const l = r - n + 1, c = t - n + 1, u = Math.log(l), f = 0.5 * Math.exp(2 * u / 3), h = 0.5 * Math.sqrt(u * f * (l - f) / l) * (c - l / 2 < 0 ? -1 : 1), p = Math.max(n, Math.floor(t - c * f / l + h)), C = Math.min(r, Math.floor(t + (l - c) * f / l + h));
      tR(e, t, p, C, o);
    }
    const i = e[t];
    let a = n, s = r;
    for (Ys(e, n, t), o(e[r], i) > 0 && Ys(e, n, r); a < s; ) {
      for (Ys(e, a, s), ++a, --s; o(e[a], i) < 0; ) ++a;
      for (; o(e[s], i) > 0; ) --s;
    }
    o(e[n], i) === 0 ? Ys(e, n, s) : (++s, Ys(e, s, r)), s <= t && (n = s + 1), t <= s && (r = s - 1);
  }
  return e;
}
function Ys(e, t, n) {
  const r = e[t];
  e[t] = e[n], e[n] = r;
}
function Wse(e, t, n) {
  if (e = Float64Array.from(Nse(e)), !(!(r = e.length) || isNaN(t = +t))) {
    if (t <= 0 || r < 2) return rS(e);
    if (t >= 1) return nS(e);
    var r, o = (r - 1) * t, i = Math.floor(o), a = nS(tR(e, i).subarray(0, i + 1)), s = rS(e.subarray(i + 1));
    return a + (s - a) * (o - i);
  }
}
function qse(e, t, n = JD) {
  if (!(!(r = e.length) || isNaN(t = +t))) {
    if (t <= 0 || r < 2) return +n(e[0], 0, e);
    if (t >= 1) return +n(e[r - 1], r - 1, e);
    var r, o = (r - 1) * t, i = Math.floor(o), a = +n(e[i], i, e), s = +n(e[i + 1], i + 1, e);
    return a + (s - a) * (o - i);
  }
}
function Use(e, t, n) {
  e = +e, t = +t, n = (o = arguments.length) < 2 ? (t = e, e = 0, 1) : o < 3 ? 1 : +n;
  for (var r = -1, o = Math.max(0, Math.ceil((t - e) / n)) | 0, i = new Array(o); ++r < o; )
    i[r] = e + r * n;
  return i;
}
function Or(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(e);
      break;
    default:
      this.range(t).domain(e);
      break;
  }
  return this;
}
function r1(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof e == "function" ? this.interpolator(e) : this.range(e);
      break;
    }
    default: {
      this.domain(e), typeof t == "function" ? this.interpolator(t) : this.range(t);
      break;
    }
  }
  return this;
}
const Tf = Symbol("implicit");
function Rp() {
  var e = new eS(), t = [], n = [], r = Tf;
  function o(i) {
    let a = e.get(i);
    if (a === void 0) {
      if (r !== Tf) return r;
      e.set(i, a = t.push(i) - 1);
    }
    return n[a % n.length];
  }
  return o.domain = function(i) {
    if (!arguments.length) return t.slice();
    t = [], e = new eS();
    for (const a of i)
      e.has(a) || e.set(a, t.push(a) - 1);
    return o;
  }, o.range = function(i) {
    return arguments.length ? (n = Array.from(i), o) : n.slice();
  }, o.unknown = function(i) {
    return arguments.length ? (r = i, o) : r;
  }, o.copy = function() {
    return Rp(t, n).unknown(r);
  }, Or.apply(o, arguments), o;
}
function Kl() {
  var e = Rp().unknown(void 0), t = e.domain, n = e.range, r = 0, o = 1, i, a, s = !1, l = 0, c = 0, u = 0.5;
  delete e.unknown;
  function f() {
    var h = t().length, p = o < r, C = p ? o : r, m = p ? r : o;
    i = (m - C) / Math.max(1, h - l + c * 2), s && (i = Math.floor(i)), C += (m - C - i * (h - l)) * u, a = i * (1 - l), s && (C = Math.round(C), a = Math.round(a));
    var g = Use(h).map(function(v) {
      return C + i * v;
    });
    return n(p ? g.reverse() : g);
  }
  return e.domain = function(h) {
    return arguments.length ? (t(h), f()) : t();
  }, e.range = function(h) {
    return arguments.length ? ([r, o] = h, r = +r, o = +o, f()) : [r, o];
  }, e.rangeRound = function(h) {
    return [r, o] = h, r = +r, o = +o, s = !0, f();
  }, e.bandwidth = function() {
    return a;
  }, e.step = function() {
    return i;
  }, e.round = function(h) {
    return arguments.length ? (s = !!h, f()) : s;
  }, e.padding = function(h) {
    return arguments.length ? (l = Math.min(1, c = +h), f()) : l;
  }, e.paddingInner = function(h) {
    return arguments.length ? (l = Math.min(1, h), f()) : l;
  }, e.paddingOuter = function(h) {
    return arguments.length ? (c = +h, f()) : c;
  }, e.align = function(h) {
    return arguments.length ? (u = Math.max(0, Math.min(1, h)), f()) : u;
  }, e.copy = function() {
    return Kl(t(), [r, o]).round(s).paddingInner(l).paddingOuter(c).align(u);
  }, Or.apply(f(), arguments);
}
function nR(e) {
  var t = e.copy;
  return e.padding = e.paddingOuter, delete e.paddingInner, delete e.paddingOuter, e.copy = function() {
    return nR(t());
  }, e;
}
function wl() {
  return nR(Kl.apply(null, arguments).paddingInner(1));
}
function kp(e, t, n) {
  e.prototype = t.prototype = n, n.constructor = e;
}
function rR(e, t) {
  var n = Object.create(e.prototype);
  for (var r in t) n[r] = t[r];
  return n;
}
function q2() {
}
var Yl = 0.7, D5 = 1 / Yl, Ia = "\\s*([+-]?\\d+)\\s*", Xl = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", mo = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", Gse = /^#([0-9a-f]{3,8})$/, Kse = new RegExp(`^rgb\\(${Ia},${Ia},${Ia}\\)$`), Yse = new RegExp(`^rgb\\(${mo},${mo},${mo}\\)$`), Xse = new RegExp(`^rgba\\(${Ia},${Ia},${Ia},${Xl}\\)$`), Qse = new RegExp(`^rgba\\(${mo},${mo},${mo},${Xl}\\)$`), Jse = new RegExp(`^hsl\\(${Xl},${mo},${mo}\\)$`), ele = new RegExp(`^hsla\\(${Xl},${mo},${mo},${Xl}\\)$`), oS = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
kp(q2, Ql, {
  copy(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: iS,
  // Deprecated! Use color.formatHex.
  formatHex: iS,
  formatHex8: tle,
  formatHsl: nle,
  formatRgb: aS,
  toString: aS
});
function iS() {
  return this.rgb().formatHex();
}
function tle() {
  return this.rgb().formatHex8();
}
function nle() {
  return oR(this).formatHsl();
}
function aS() {
  return this.rgb().formatRgb();
}
function Ql(e) {
  var t, n;
  return e = (e + "").trim().toLowerCase(), (t = Gse.exec(e)) ? (n = t[1].length, t = parseInt(t[1], 16), n === 6 ? sS(t) : n === 3 ? new Un(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : n === 8 ? Ac(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : n === 4 ? Ac(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = Kse.exec(e)) ? new Un(t[1], t[2], t[3], 1) : (t = Yse.exec(e)) ? new Un(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = Xse.exec(e)) ? Ac(t[1], t[2], t[3], t[4]) : (t = Qse.exec(e)) ? Ac(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = Jse.exec(e)) ? uS(t[1], t[2] / 100, t[3] / 100, 1) : (t = ele.exec(e)) ? uS(t[1], t[2] / 100, t[3] / 100, t[4]) : oS.hasOwnProperty(e) ? sS(oS[e]) : e === "transparent" ? new Un(NaN, NaN, NaN, 0) : null;
}
function sS(e) {
  return new Un(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function Ac(e, t, n, r) {
  return r <= 0 && (e = t = n = NaN), new Un(e, t, n, r);
}
function rle(e) {
  return e instanceof q2 || (e = Ql(e)), e ? (e = e.rgb(), new Un(e.r, e.g, e.b, e.opacity)) : new Un();
}
function If(e, t, n, r) {
  return arguments.length === 1 ? rle(e) : new Un(e, t, n, r ?? 1);
}
function Un(e, t, n, r) {
  this.r = +e, this.g = +t, this.b = +n, this.opacity = +r;
}
kp(Un, If, rR(q2, {
  brighter(e) {
    return e = e == null ? D5 : Math.pow(D5, e), new Un(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? Yl : Math.pow(Yl, e), new Un(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new Un(pi(this.r), pi(this.g), pi(this.b), R5(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: lS,
  // Deprecated! Use color.formatHex.
  formatHex: lS,
  formatHex8: ole,
  formatRgb: cS,
  toString: cS
}));
function lS() {
  return `#${ai(this.r)}${ai(this.g)}${ai(this.b)}`;
}
function ole() {
  return `#${ai(this.r)}${ai(this.g)}${ai(this.b)}${ai((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function cS() {
  const e = R5(this.opacity);
  return `${e === 1 ? "rgb(" : "rgba("}${pi(this.r)}, ${pi(this.g)}, ${pi(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function R5(e) {
  return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function pi(e) {
  return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function ai(e) {
  return e = pi(e), (e < 16 ? "0" : "") + e.toString(16);
}
function uS(e, t, n, r) {
  return r <= 0 ? e = t = n = NaN : n <= 0 || n >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new Br(e, t, n, r);
}
function oR(e) {
  if (e instanceof Br) return new Br(e.h, e.s, e.l, e.opacity);
  if (e instanceof q2 || (e = Ql(e)), !e) return new Br();
  if (e instanceof Br) return e;
  e = e.rgb();
  var t = e.r / 255, n = e.g / 255, r = e.b / 255, o = Math.min(t, n, r), i = Math.max(t, n, r), a = NaN, s = i - o, l = (i + o) / 2;
  return s ? (t === i ? a = (n - r) / s + (n < r) * 6 : n === i ? a = (r - t) / s + 2 : a = (t - n) / s + 4, s /= l < 0.5 ? i + o : 2 - i - o, a *= 60) : s = l > 0 && l < 1 ? 0 : a, new Br(a, s, l, e.opacity);
}
function ile(e, t, n, r) {
  return arguments.length === 1 ? oR(e) : new Br(e, t, n, r ?? 1);
}
function Br(e, t, n, r) {
  this.h = +e, this.s = +t, this.l = +n, this.opacity = +r;
}
kp(Br, ile, rR(q2, {
  brighter(e) {
    return e = e == null ? D5 : Math.pow(D5, e), new Br(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? Yl : Math.pow(Yl, e), new Br(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, n = this.l, r = n + (n < 0.5 ? n : 1 - n) * t, o = 2 * n - r;
    return new Un(
      v4(e >= 240 ? e - 240 : e + 120, o, r),
      v4(e, o, r),
      v4(e < 120 ? e + 240 : e - 120, o, r),
      this.opacity
    );
  },
  clamp() {
    return new Br(fS(this.h), Pc(this.s), Pc(this.l), R5(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const e = R5(this.opacity);
    return `${e === 1 ? "hsl(" : "hsla("}${fS(this.h)}, ${Pc(this.s) * 100}%, ${Pc(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
  }
}));
function fS(e) {
  return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function Pc(e) {
  return Math.max(0, Math.min(1, e || 0));
}
function v4(e, t, n) {
  return (e < 60 ? t + (n - t) * e / 60 : e < 180 ? n : e < 240 ? t + (n - t) * (240 - e) / 60 : t) * 255;
}
const Lp = (e) => () => e;
function ale(e, t) {
  return function(n) {
    return e + n * t;
  };
}
function sle(e, t, n) {
  return e = Math.pow(e, n), t = Math.pow(t, n) - e, n = 1 / n, function(r) {
    return Math.pow(e + r * t, n);
  };
}
function lle(e) {
  return (e = +e) == 1 ? iR : function(t, n) {
    return n - t ? sle(t, n, e) : Lp(isNaN(t) ? n : t);
  };
}
function iR(e, t) {
  var n = t - e;
  return n ? ale(e, n) : Lp(isNaN(e) ? t : e);
}
const dS = (function e(t) {
  var n = lle(t);
  function r(o, i) {
    var a = n((o = If(o)).r, (i = If(i)).r), s = n(o.g, i.g), l = n(o.b, i.b), c = iR(o.opacity, i.opacity);
    return function(u) {
      return o.r = a(u), o.g = s(u), o.b = l(u), o.opacity = c(u), o + "";
    };
  }
  return r.gamma = e, r;
})(1);
function cle(e, t) {
  t || (t = []);
  var n = e ? Math.min(t.length, e.length) : 0, r = t.slice(), o;
  return function(i) {
    for (o = 0; o < n; ++o) r[o] = e[o] * (1 - i) + t[o] * i;
    return r;
  };
}
function ule(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function fle(e, t) {
  var n = t ? t.length : 0, r = e ? Math.min(n, e.length) : 0, o = new Array(r), i = new Array(n), a;
  for (a = 0; a < r; ++a) o[a] = Os(e[a], t[a]);
  for (; a < n; ++a) i[a] = t[a];
  return function(s) {
    for (a = 0; a < r; ++a) i[a] = o[a](s);
    return i;
  };
}
function dle(e, t) {
  var n = /* @__PURE__ */ new Date();
  return e = +e, t = +t, function(r) {
    return n.setTime(e * (1 - r) + t * r), n;
  };
}
function k5(e, t) {
  return e = +e, t = +t, function(n) {
    return e * (1 - n) + t * n;
  };
}
function hle(e, t) {
  var n = {}, r = {}, o;
  (e === null || typeof e != "object") && (e = {}), (t === null || typeof t != "object") && (t = {});
  for (o in t)
    o in e ? n[o] = Os(e[o], t[o]) : r[o] = t[o];
  return function(i) {
    for (o in n) r[o] = n[o](i);
    return r;
  };
}
var Df = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, y4 = new RegExp(Df.source, "g");
function ple(e) {
  return function() {
    return e;
  };
}
function mle(e) {
  return function(t) {
    return e(t) + "";
  };
}
function gle(e, t) {
  var n = Df.lastIndex = y4.lastIndex = 0, r, o, i, a = -1, s = [], l = [];
  for (e = e + "", t = t + ""; (r = Df.exec(e)) && (o = y4.exec(t)); )
    (i = o.index) > n && (i = t.slice(n, i), s[a] ? s[a] += i : s[++a] = i), (r = r[0]) === (o = o[0]) ? s[a] ? s[a] += o : s[++a] = o : (s[++a] = null, l.push({ i: a, x: k5(r, o) })), n = y4.lastIndex;
  return n < t.length && (i = t.slice(n), s[a] ? s[a] += i : s[++a] = i), s.length < 2 ? l[0] ? mle(l[0].x) : ple(t) : (t = l.length, function(c) {
    for (var u = 0, f; u < t; ++u) s[(f = l[u]).i] = f.x(c);
    return s.join("");
  });
}
function Os(e, t) {
  var n = typeof t, r;
  return t == null || n === "boolean" ? Lp(t) : (n === "number" ? k5 : n === "string" ? (r = Ql(t)) ? (t = r, dS) : gle : t instanceof Ql ? dS : t instanceof Date ? dle : ule(t) ? cle : Array.isArray(t) ? fle : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? hle : k5)(e, t);
}
function Np(e, t) {
  return e = +e, t = +t, function(n) {
    return Math.round(e * (1 - n) + t * n);
  };
}
function Cle(e, t) {
  t === void 0 && (t = e, e = Os);
  for (var n = 0, r = t.length - 1, o = t[0], i = new Array(r < 0 ? 0 : r); n < r; ) i[n] = e(o, o = t[++n]);
  return function(a) {
    var s = Math.max(0, Math.min(r - 1, Math.floor(a *= r)));
    return i[s](a - s);
  };
}
function vle(e) {
  return function() {
    return e;
  };
}
function L5(e) {
  return +e;
}
var hS = [0, 1];
function Nn(e) {
  return e;
}
function Rf(e, t) {
  return (t -= e = +e) ? function(n) {
    return (n - e) / t;
  } : vle(isNaN(t) ? NaN : 0.5);
}
function yle(e, t) {
  var n;
  return e > t && (n = e, e = t, t = n), function(r) {
    return Math.max(e, Math.min(t, r));
  };
}
function ble(e, t, n) {
  var r = e[0], o = e[1], i = t[0], a = t[1];
  return o < r ? (r = Rf(o, r), i = n(a, i)) : (r = Rf(r, o), i = n(i, a)), function(s) {
    return i(r(s));
  };
}
function wle(e, t, n) {
  var r = Math.min(e.length, t.length) - 1, o = new Array(r), i = new Array(r), a = -1;
  for (e[r] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++a < r; )
    o[a] = Rf(e[a], e[a + 1]), i[a] = n(t[a], t[a + 1]);
  return function(s) {
    var l = W2(e, s, 1, r) - 1;
    return i[l](o[l](s));
  };
}
function U2(e, t) {
  return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
}
function m0() {
  var e = hS, t = hS, n = Os, r, o, i, a = Nn, s, l, c;
  function u() {
    var h = Math.min(e.length, t.length);
    return a !== Nn && (a = yle(e[0], e[h - 1])), s = h > 2 ? wle : ble, l = c = null, f;
  }
  function f(h) {
    return h == null || isNaN(h = +h) ? i : (l || (l = s(e.map(r), t, n)))(r(a(h)));
  }
  return f.invert = function(h) {
    return a(o((c || (c = s(t, e.map(r), k5)))(h)));
  }, f.domain = function(h) {
    return arguments.length ? (e = Array.from(h, L5), u()) : e.slice();
  }, f.range = function(h) {
    return arguments.length ? (t = Array.from(h), u()) : t.slice();
  }, f.rangeRound = function(h) {
    return t = Array.from(h), n = Np, u();
  }, f.clamp = function(h) {
    return arguments.length ? (a = h ? !0 : Nn, u()) : a !== Nn;
  }, f.interpolate = function(h) {
    return arguments.length ? (n = h, u()) : n;
  }, f.unknown = function(h) {
    return arguments.length ? (i = h, f) : i;
  }, function(h, p) {
    return r = h, o = p, u();
  };
}
function Fp() {
  return m0()(Nn, Nn);
}
function xle(e) {
  return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
}
function N5(e, t) {
  if ((n = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0) return null;
  var n, r = e.slice(0, n);
  return [
    r.length > 1 ? r[0] + r.slice(2) : r,
    +e.slice(n + 1)
  ];
}
function qa(e) {
  return e = N5(Math.abs(e)), e ? e[1] : NaN;
}
function Sle(e, t) {
  return function(n, r) {
    for (var o = n.length, i = [], a = 0, s = e[0], l = 0; o > 0 && s > 0 && (l + s + 1 > r && (s = Math.max(1, r - l)), i.push(n.substring(o -= s, o + s)), !((l += s + 1) > r)); )
      s = e[a = (a + 1) % e.length];
    return i.reverse().join(t);
  };
}
function Mle(e) {
  return function(t) {
    return t.replace(/[0-9]/g, function(n) {
      return e[+n];
    });
  };
}
var Ele = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function Jl(e) {
  if (!(t = Ele.exec(e))) throw new Error("invalid format: " + e);
  var t;
  return new Vp({
    fill: t[1],
    align: t[2],
    sign: t[3],
    symbol: t[4],
    zero: t[5],
    width: t[6],
    comma: t[7],
    precision: t[8] && t[8].slice(1),
    trim: t[9],
    type: t[10]
  });
}
Jl.prototype = Vp.prototype;
function Vp(e) {
  this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
}
Vp.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function _le(e) {
  e: for (var t = e.length, n = 1, r = -1, o; n < t; ++n)
    switch (e[n]) {
      case ".":
        r = o = n;
        break;
      case "0":
        r === 0 && (r = n), o = n;
        break;
      default:
        if (!+e[n]) break e;
        r > 0 && (r = 0);
        break;
    }
  return r > 0 ? e.slice(0, r) + e.slice(o + 1) : e;
}
var aR;
function Ole(e, t) {
  var n = N5(e, t);
  if (!n) return e + "";
  var r = n[0], o = n[1], i = o - (aR = Math.max(-8, Math.min(8, Math.floor(o / 3))) * 3) + 1, a = r.length;
  return i === a ? r : i > a ? r + new Array(i - a + 1).join("0") : i > 0 ? r.slice(0, i) + "." + r.slice(i) : "0." + new Array(1 - i).join("0") + N5(e, Math.max(0, t + i - 1))[0];
}
function pS(e, t) {
  var n = N5(e, t);
  if (!n) return e + "";
  var r = n[0], o = n[1];
  return o < 0 ? "0." + new Array(-o).join("0") + r : r.length > o + 1 ? r.slice(0, o + 1) + "." + r.slice(o + 1) : r + new Array(o - r.length + 2).join("0");
}
const mS = {
  "%": (e, t) => (e * 100).toFixed(t),
  b: (e) => Math.round(e).toString(2),
  c: (e) => e + "",
  d: xle,
  e: (e, t) => e.toExponential(t),
  f: (e, t) => e.toFixed(t),
  g: (e, t) => e.toPrecision(t),
  o: (e) => Math.round(e).toString(8),
  p: (e, t) => pS(e * 100, t),
  r: pS,
  s: Ole,
  X: (e) => Math.round(e).toString(16).toUpperCase(),
  x: (e) => Math.round(e).toString(16)
};
function gS(e) {
  return e;
}
var CS = Array.prototype.map, vS = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function Ale(e) {
  var t = e.grouping === void 0 || e.thousands === void 0 ? gS : Sle(CS.call(e.grouping, Number), e.thousands + ""), n = e.currency === void 0 ? "" : e.currency[0] + "", r = e.currency === void 0 ? "" : e.currency[1] + "", o = e.decimal === void 0 ? "." : e.decimal + "", i = e.numerals === void 0 ? gS : Mle(CS.call(e.numerals, String)), a = e.percent === void 0 ? "%" : e.percent + "", s = e.minus === void 0 ? "−" : e.minus + "", l = e.nan === void 0 ? "NaN" : e.nan + "";
  function c(f) {
    f = Jl(f);
    var h = f.fill, p = f.align, C = f.sign, m = f.symbol, g = f.zero, v = f.width, y = f.comma, w = f.precision, x = f.trim, b = f.type;
    b === "n" ? (y = !0, b = "g") : mS[b] || (w === void 0 && (w = 12), x = !0, b = "g"), (g || h === "0" && p === "=") && (g = !0, h = "0", p = "=");
    var S = m === "$" ? n : m === "#" && /[boxX]/.test(b) ? "0" + b.toLowerCase() : "", M = m === "$" ? r : /[%p]/.test(b) ? a : "", E = mS[b], P = /[defgprs%]/.test(b);
    w = w === void 0 ? 6 : /[gprs]/.test(b) ? Math.max(1, Math.min(21, w)) : Math.max(0, Math.min(20, w));
    function T(_) {
      var D = S, N = M, R, L, B;
      if (b === "c")
        N = E(_) + N, _ = "";
      else {
        _ = +_;
        var V = _ < 0 || 1 / _ < 0;
        if (_ = isNaN(_) ? l : E(Math.abs(_), w), x && (_ = _le(_)), V && +_ == 0 && C !== "+" && (V = !1), D = (V ? C === "(" ? C : s : C === "-" || C === "(" ? "" : C) + D, N = (b === "s" ? vS[8 + aR / 3] : "") + N + (V && C === "(" ? ")" : ""), P) {
          for (R = -1, L = _.length; ++R < L; )
            if (B = _.charCodeAt(R), 48 > B || B > 57) {
              N = (B === 46 ? o + _.slice(R + 1) : _.slice(R)) + N, _ = _.slice(0, R);
              break;
            }
        }
      }
      y && !g && (_ = t(_, 1 / 0));
      var k = D.length + _.length + N.length, z = k < v ? new Array(v - k + 1).join(h) : "";
      switch (y && g && (_ = t(z + _, z.length ? v - N.length : 1 / 0), z = ""), p) {
        case "<":
          _ = D + _ + N + z;
          break;
        case "=":
          _ = D + z + _ + N;
          break;
        case "^":
          _ = z.slice(0, k = z.length >> 1) + D + _ + N + z.slice(k);
          break;
        default:
          _ = z + D + _ + N;
          break;
      }
      return i(_);
    }
    return T.toString = function() {
      return f + "";
    }, T;
  }
  function u(f, h) {
    var p = c((f = Jl(f), f.type = "f", f)), C = Math.max(-8, Math.min(8, Math.floor(qa(h) / 3))) * 3, m = Math.pow(10, -C), g = vS[8 + C / 3];
    return function(v) {
      return p(m * v) + g;
    };
  }
  return {
    format: c,
    formatPrefix: u
  };
}
var Tc, Bp, sR;
Ple({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function Ple(e) {
  return Tc = Ale(e), Bp = Tc.format, sR = Tc.formatPrefix, Tc;
}
function Tle(e) {
  return Math.max(0, -qa(Math.abs(e)));
}
function Ile(e, t) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(qa(t) / 3))) * 3 - qa(Math.abs(e)));
}
function Dle(e, t) {
  return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, qa(t) - qa(e)) + 1;
}
function lR(e, t, n, r) {
  var o = Pf(e, t, n), i;
  switch (r = Jl(r ?? ",f"), r.type) {
    case "s": {
      var a = Math.max(Math.abs(e), Math.abs(t));
      return r.precision == null && !isNaN(i = Ile(o, a)) && (r.precision = i), sR(r, a);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      r.precision == null && !isNaN(i = Dle(o, Math.max(Math.abs(e), Math.abs(t)))) && (r.precision = i - (r.type === "e"));
      break;
    }
    case "f":
    case "%": {
      r.precision == null && !isNaN(i = Tle(o)) && (r.precision = i - (r.type === "%") * 2);
      break;
    }
  }
  return Bp(r);
}
function j1(e) {
  var t = e.domain;
  return e.ticks = function(n) {
    var r = t();
    return Of(r[0], r[r.length - 1], n ?? 10);
  }, e.tickFormat = function(n, r) {
    var o = t();
    return lR(o[0], o[o.length - 1], n ?? 10, r);
  }, e.nice = function(n) {
    n == null && (n = 10);
    var r = t(), o = 0, i = r.length - 1, a = r[o], s = r[i], l, c, u = 10;
    for (s < a && (c = a, a = s, s = c, c = o, o = i, i = c); u-- > 0; ) {
      if (c = Af(a, s, n), c === l)
        return r[o] = a, r[i] = s, t(r);
      if (c > 0)
        a = Math.floor(a / c) * c, s = Math.ceil(s / c) * c;
      else if (c < 0)
        a = Math.ceil(a * c) / c, s = Math.floor(s * c) / c;
      else
        break;
      l = c;
    }
    return e;
  }, e;
}
function F5() {
  var e = Fp();
  return e.copy = function() {
    return U2(e, F5());
  }, Or.apply(e, arguments), j1(e);
}
function cR(e) {
  var t;
  function n(r) {
    return r == null || isNaN(r = +r) ? t : r;
  }
  return n.invert = n, n.domain = n.range = function(r) {
    return arguments.length ? (e = Array.from(r, L5), n) : e.slice();
  }, n.unknown = function(r) {
    return arguments.length ? (t = r, n) : t;
  }, n.copy = function() {
    return cR(e).unknown(t);
  }, e = arguments.length ? Array.from(e, L5) : [0, 1], j1(n);
}
function uR(e, t) {
  e = e.slice();
  var n = 0, r = e.length - 1, o = e[n], i = e[r], a;
  return i < o && (a = n, n = r, r = a, a = o, o = i, i = a), e[n] = t.floor(o), e[r] = t.ceil(i), e;
}
function yS(e) {
  return Math.log(e);
}
function bS(e) {
  return Math.exp(e);
}
function Rle(e) {
  return -Math.log(-e);
}
function kle(e) {
  return -Math.exp(-e);
}
function Lle(e) {
  return isFinite(e) ? +("1e" + e) : e < 0 ? 0 : e;
}
function Nle(e) {
  return e === 10 ? Lle : e === Math.E ? Math.exp : (t) => Math.pow(e, t);
}
function Fle(e) {
  return e === Math.E ? Math.log : e === 10 && Math.log10 || e === 2 && Math.log2 || (e = Math.log(e), (t) => Math.log(t) / e);
}
function wS(e) {
  return (t, n) => -e(-t, n);
}
function $p(e) {
  const t = e(yS, bS), n = t.domain;
  let r = 10, o, i;
  function a() {
    return o = Fle(r), i = Nle(r), n()[0] < 0 ? (o = wS(o), i = wS(i), e(Rle, kle)) : e(yS, bS), t;
  }
  return t.base = function(s) {
    return arguments.length ? (r = +s, a()) : r;
  }, t.domain = function(s) {
    return arguments.length ? (n(s), a()) : n();
  }, t.ticks = (s) => {
    const l = n();
    let c = l[0], u = l[l.length - 1];
    const f = u < c;
    f && ([c, u] = [u, c]);
    let h = o(c), p = o(u), C, m;
    const g = s == null ? 10 : +s;
    let v = [];
    if (!(r % 1) && p - h < g) {
      if (h = Math.floor(h), p = Math.ceil(p), c > 0) {
        for (; h <= p; ++h)
          for (C = 1; C < r; ++C)
            if (m = h < 0 ? C / i(-h) : C * i(h), !(m < c)) {
              if (m > u) break;
              v.push(m);
            }
      } else for (; h <= p; ++h)
        for (C = r - 1; C >= 1; --C)
          if (m = h > 0 ? C / i(-h) : C * i(h), !(m < c)) {
            if (m > u) break;
            v.push(m);
          }
      v.length * 2 < g && (v = Of(c, u, g));
    } else
      v = Of(h, p, Math.min(p - h, g)).map(i);
    return f ? v.reverse() : v;
  }, t.tickFormat = (s, l) => {
    if (s == null && (s = 10), l == null && (l = r === 10 ? "s" : ","), typeof l != "function" && (!(r % 1) && (l = Jl(l)).precision == null && (l.trim = !0), l = Bp(l)), s === 1 / 0) return l;
    const c = Math.max(1, r * s / t.ticks().length);
    return (u) => {
      let f = u / i(Math.round(o(u)));
      return f * r < r - 0.5 && (f *= r), f <= c ? l(u) : "";
    };
  }, t.nice = () => n(uR(n(), {
    floor: (s) => i(Math.floor(o(s))),
    ceil: (s) => i(Math.ceil(o(s)))
  })), t;
}
function fR() {
  const e = $p(m0()).domain([1, 10]);
  return e.copy = () => U2(e, fR()).base(e.base()), Or.apply(e, arguments), e;
}
function xS(e) {
  return function(t) {
    return Math.sign(t) * Math.log1p(Math.abs(t / e));
  };
}
function SS(e) {
  return function(t) {
    return Math.sign(t) * Math.expm1(Math.abs(t)) * e;
  };
}
function jp(e) {
  var t = 1, n = e(xS(t), SS(t));
  return n.constant = function(r) {
    return arguments.length ? e(xS(t = +r), SS(t)) : t;
  }, j1(n);
}
function dR() {
  var e = jp(m0());
  return e.copy = function() {
    return U2(e, dR()).constant(e.constant());
  }, Or.apply(e, arguments);
}
function MS(e) {
  return function(t) {
    return t < 0 ? -Math.pow(-t, e) : Math.pow(t, e);
  };
}
function Vle(e) {
  return e < 0 ? -Math.sqrt(-e) : Math.sqrt(e);
}
function Ble(e) {
  return e < 0 ? -e * e : e * e;
}
function Hp(e) {
  var t = e(Nn, Nn), n = 1;
  function r() {
    return n === 1 ? e(Nn, Nn) : n === 0.5 ? e(Vle, Ble) : e(MS(n), MS(1 / n));
  }
  return t.exponent = function(o) {
    return arguments.length ? (n = +o, r()) : n;
  }, j1(t);
}
function zp() {
  var e = Hp(m0());
  return e.copy = function() {
    return U2(e, zp()).exponent(e.exponent());
  }, Or.apply(e, arguments), e;
}
function $le() {
  return zp.apply(null, arguments).exponent(0.5);
}
function ES(e) {
  return Math.sign(e) * e * e;
}
function jle(e) {
  return Math.sign(e) * Math.sqrt(Math.abs(e));
}
function hR() {
  var e = Fp(), t = [0, 1], n = !1, r;
  function o(i) {
    var a = jle(e(i));
    return isNaN(a) ? r : n ? Math.round(a) : a;
  }
  return o.invert = function(i) {
    return e.invert(ES(i));
  }, o.domain = function(i) {
    return arguments.length ? (e.domain(i), o) : e.domain();
  }, o.range = function(i) {
    return arguments.length ? (e.range((t = Array.from(i, L5)).map(ES)), o) : t.slice();
  }, o.rangeRound = function(i) {
    return o.range(i).round(!0);
  }, o.round = function(i) {
    return arguments.length ? (n = !!i, o) : n;
  }, o.clamp = function(i) {
    return arguments.length ? (e.clamp(i), o) : e.clamp();
  }, o.unknown = function(i) {
    return arguments.length ? (r = i, o) : r;
  }, o.copy = function() {
    return hR(e.domain(), t).round(n).clamp(e.clamp()).unknown(r);
  }, Or.apply(o, arguments), j1(o);
}
function pR() {
  var e = [], t = [], n = [], r;
  function o() {
    var a = 0, s = Math.max(1, t.length);
    for (n = new Array(s - 1); ++a < s; ) n[a - 1] = qse(e, a / s);
    return i;
  }
  function i(a) {
    return a == null || isNaN(a = +a) ? r : t[W2(n, a)];
  }
  return i.invertExtent = function(a) {
    var s = t.indexOf(a);
    return s < 0 ? [NaN, NaN] : [
      s > 0 ? n[s - 1] : e[0],
      s < n.length ? n[s] : e[e.length - 1]
    ];
  }, i.domain = function(a) {
    if (!arguments.length) return e.slice();
    e = [];
    for (let s of a) s != null && !isNaN(s = +s) && e.push(s);
    return e.sort(M1), o();
  }, i.range = function(a) {
    return arguments.length ? (t = Array.from(a), o()) : t.slice();
  }, i.unknown = function(a) {
    return arguments.length ? (r = a, i) : r;
  }, i.quantiles = function() {
    return n.slice();
  }, i.copy = function() {
    return pR().domain(e).range(t).unknown(r);
  }, Or.apply(i, arguments);
}
function mR() {
  var e = 0, t = 1, n = 1, r = [0.5], o = [0, 1], i;
  function a(l) {
    return l != null && l <= l ? o[W2(r, l, 0, n)] : i;
  }
  function s() {
    var l = -1;
    for (r = new Array(n); ++l < n; ) r[l] = ((l + 1) * t - (l - n) * e) / (n + 1);
    return a;
  }
  return a.domain = function(l) {
    return arguments.length ? ([e, t] = l, e = +e, t = +t, s()) : [e, t];
  }, a.range = function(l) {
    return arguments.length ? (n = (o = Array.from(l)).length - 1, s()) : o.slice();
  }, a.invertExtent = function(l) {
    var c = o.indexOf(l);
    return c < 0 ? [NaN, NaN] : c < 1 ? [e, r[0]] : c >= n ? [r[n - 1], t] : [r[c - 1], r[c]];
  }, a.unknown = function(l) {
    return arguments.length && (i = l), a;
  }, a.thresholds = function() {
    return r.slice();
  }, a.copy = function() {
    return mR().domain([e, t]).range(o).unknown(i);
  }, Or.apply(j1(a), arguments);
}
function gR() {
  var e = [0.5], t = [0, 1], n, r = 1;
  function o(i) {
    return i != null && i <= i ? t[W2(e, i, 0, r)] : n;
  }
  return o.domain = function(i) {
    return arguments.length ? (e = Array.from(i), r = Math.min(e.length, t.length - 1), o) : e.slice();
  }, o.range = function(i) {
    return arguments.length ? (t = Array.from(i), r = Math.min(e.length, t.length - 1), o) : t.slice();
  }, o.invertExtent = function(i) {
    var a = t.indexOf(i);
    return [e[a - 1], e[a]];
  }, o.unknown = function(i) {
    return arguments.length ? (n = i, o) : n;
  }, o.copy = function() {
    return gR().domain(e).range(t).unknown(n);
  }, Or.apply(o, arguments);
}
const b4 = /* @__PURE__ */ new Date(), w4 = /* @__PURE__ */ new Date();
function un(e, t, n, r) {
  function o(i) {
    return e(i = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+i)), i;
  }
  return o.floor = (i) => (e(i = /* @__PURE__ */ new Date(+i)), i), o.ceil = (i) => (e(i = new Date(i - 1)), t(i, 1), e(i), i), o.round = (i) => {
    const a = o(i), s = o.ceil(i);
    return i - a < s - i ? a : s;
  }, o.offset = (i, a) => (t(i = /* @__PURE__ */ new Date(+i), a == null ? 1 : Math.floor(a)), i), o.range = (i, a, s) => {
    const l = [];
    if (i = o.ceil(i), s = s == null ? 1 : Math.floor(s), !(i < a) || !(s > 0)) return l;
    let c;
    do
      l.push(c = /* @__PURE__ */ new Date(+i)), t(i, s), e(i);
    while (c < i && i < a);
    return l;
  }, o.filter = (i) => un((a) => {
    if (a >= a) for (; e(a), !i(a); ) a.setTime(a - 1);
  }, (a, s) => {
    if (a >= a)
      if (s < 0) for (; ++s <= 0; )
        for (; t(a, -1), !i(a); )
          ;
      else for (; --s >= 0; )
        for (; t(a, 1), !i(a); )
          ;
  }), n && (o.count = (i, a) => (b4.setTime(+i), w4.setTime(+a), e(b4), e(w4), Math.floor(n(b4, w4))), o.every = (i) => (i = Math.floor(i), !isFinite(i) || !(i > 0) ? null : i > 1 ? o.filter(r ? (a) => r(a) % i === 0 : (a) => o.count(0, a) % i === 0) : o)), o;
}
const V5 = un(() => {
}, (e, t) => {
  e.setTime(+e + t);
}, (e, t) => t - e);
V5.every = (e) => (e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? un((t) => {
  t.setTime(Math.floor(t / e) * e);
}, (t, n) => {
  t.setTime(+t + n * e);
}, (t, n) => (n - t) / e) : V5);
V5.range;
const $o = 1e3, br = $o * 60, jo = br * 60, Qo = jo * 24, Zp = Qo * 7, _S = Qo * 30, x4 = Qo * 365, si = un((e) => {
  e.setTime(e - e.getMilliseconds());
}, (e, t) => {
  e.setTime(+e + t * $o);
}, (e, t) => (t - e) / $o, (e) => e.getUTCSeconds());
si.range;
const Wp = un((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * $o);
}, (e, t) => {
  e.setTime(+e + t * br);
}, (e, t) => (t - e) / br, (e) => e.getMinutes());
Wp.range;
const qp = un((e) => {
  e.setUTCSeconds(0, 0);
}, (e, t) => {
  e.setTime(+e + t * br);
}, (e, t) => (t - e) / br, (e) => e.getUTCMinutes());
qp.range;
const Up = un((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * $o - e.getMinutes() * br);
}, (e, t) => {
  e.setTime(+e + t * jo);
}, (e, t) => (t - e) / jo, (e) => e.getHours());
Up.range;
const Gp = un((e) => {
  e.setUTCMinutes(0, 0, 0);
}, (e, t) => {
  e.setTime(+e + t * jo);
}, (e, t) => (t - e) / jo, (e) => e.getUTCHours());
Gp.range;
const G2 = un(
  (e) => e.setHours(0, 0, 0, 0),
  (e, t) => e.setDate(e.getDate() + t),
  (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * br) / Qo,
  (e) => e.getDate() - 1
);
G2.range;
const g0 = un((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / Qo, (e) => e.getUTCDate() - 1);
g0.range;
const CR = un((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / Qo, (e) => Math.floor(e / Qo));
CR.range;
function $i(e) {
  return un((t) => {
    t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
  }, (t, n) => {
    t.setDate(t.getDate() + n * 7);
  }, (t, n) => (n - t - (n.getTimezoneOffset() - t.getTimezoneOffset()) * br) / Zp);
}
const C0 = $i(0), B5 = $i(1), Hle = $i(2), zle = $i(3), Ua = $i(4), Zle = $i(5), Wle = $i(6);
C0.range;
B5.range;
Hle.range;
zle.range;
Ua.range;
Zle.range;
Wle.range;
function ji(e) {
  return un((t) => {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
  }, (t, n) => {
    t.setUTCDate(t.getUTCDate() + n * 7);
  }, (t, n) => (n - t) / Zp);
}
const v0 = ji(0), $5 = ji(1), qle = ji(2), Ule = ji(3), Ga = ji(4), Gle = ji(5), Kle = ji(6);
v0.range;
$5.range;
qle.range;
Ule.range;
Ga.range;
Gle.range;
Kle.range;
const Kp = un((e) => {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setMonth(e.getMonth() + t);
}, (e, t) => t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12, (e) => e.getMonth());
Kp.range;
const Yp = un((e) => {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCMonth(e.getUTCMonth() + t);
}, (e, t) => t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12, (e) => e.getUTCMonth());
Yp.range;
const Jo = un((e) => {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setFullYear(e.getFullYear() + t);
}, (e, t) => t.getFullYear() - e.getFullYear(), (e) => e.getFullYear());
Jo.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : un((t) => {
  t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, (t, n) => {
  t.setFullYear(t.getFullYear() + n * e);
});
Jo.range;
const e1 = un((e) => {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, (e, t) => t.getUTCFullYear() - e.getUTCFullYear(), (e) => e.getUTCFullYear());
e1.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : un((t) => {
  t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, (t, n) => {
  t.setUTCFullYear(t.getUTCFullYear() + n * e);
});
e1.range;
function vR(e, t, n, r, o, i) {
  const a = [
    [si, 1, $o],
    [si, 5, 5 * $o],
    [si, 15, 15 * $o],
    [si, 30, 30 * $o],
    [i, 1, br],
    [i, 5, 5 * br],
    [i, 15, 15 * br],
    [i, 30, 30 * br],
    [o, 1, jo],
    [o, 3, 3 * jo],
    [o, 6, 6 * jo],
    [o, 12, 12 * jo],
    [r, 1, Qo],
    [r, 2, 2 * Qo],
    [n, 1, Zp],
    [t, 1, _S],
    [t, 3, 3 * _S],
    [e, 1, x4]
  ];
  function s(c, u, f) {
    const h = u < c;
    h && ([c, u] = [u, c]);
    const p = f && typeof f.range == "function" ? f : l(c, u, f), C = p ? p.range(c, +u + 1) : [];
    return h ? C.reverse() : C;
  }
  function l(c, u, f) {
    const h = Math.abs(u - c) / f, p = Dp(([, , g]) => g).right(a, h);
    if (p === a.length) return e.every(Pf(c / x4, u / x4, f));
    if (p === 0) return V5.every(Math.max(Pf(c, u, f), 1));
    const [C, m] = a[h / a[p - 1][2] < a[p][2] / h ? p - 1 : p];
    return C.every(m);
  }
  return [s, l];
}
const [Yle, Xle] = vR(e1, Yp, v0, CR, Gp, qp), [Qle, Jle] = vR(Jo, Kp, C0, G2, Up, Wp);
function S4(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
    return t.setFullYear(e.y), t;
  }
  return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
}
function M4(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
    return t.setUTCFullYear(e.y), t;
  }
  return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
}
function Xs(e, t, n) {
  return { y: e, m: t, d: n, H: 0, M: 0, S: 0, L: 0 };
}
function e2e(e) {
  var t = e.dateTime, n = e.date, r = e.time, o = e.periods, i = e.days, a = e.shortDays, s = e.months, l = e.shortMonths, c = Qs(o), u = Js(o), f = Qs(i), h = Js(i), p = Qs(a), C = Js(a), m = Qs(s), g = Js(s), v = Qs(l), y = Js(l), w = {
    a: V,
    A: k,
    b: z,
    B: $,
    c: null,
    d: DS,
    e: DS,
    f: S2e,
    g: R2e,
    G: L2e,
    H: b2e,
    I: w2e,
    j: x2e,
    L: yR,
    m: M2e,
    M: E2e,
    p: Z,
    q: W,
    Q: LS,
    s: NS,
    S: _2e,
    u: O2e,
    U: A2e,
    V: P2e,
    w: T2e,
    W: I2e,
    x: null,
    X: null,
    y: D2e,
    Y: k2e,
    Z: N2e,
    "%": kS
  }, x = {
    a: H,
    A: G,
    b: Y,
    B: ne,
    c: null,
    d: RS,
    e: RS,
    f: $2e,
    g: Y2e,
    G: Q2e,
    H: F2e,
    I: V2e,
    j: B2e,
    L: wR,
    m: j2e,
    M: H2e,
    p: J,
    q: ee,
    Q: LS,
    s: NS,
    S: z2e,
    u: Z2e,
    U: W2e,
    V: q2e,
    w: U2e,
    W: G2e,
    x: null,
    X: null,
    y: K2e,
    Y: X2e,
    Z: J2e,
    "%": kS
  }, b = {
    a: T,
    A: _,
    b: D,
    B: N,
    c: R,
    d: TS,
    e: TS,
    f: g2e,
    g: PS,
    G: AS,
    H: IS,
    I: IS,
    j: d2e,
    L: m2e,
    m: f2e,
    M: h2e,
    p: P,
    q: u2e,
    Q: v2e,
    s: y2e,
    S: p2e,
    u: i2e,
    U: a2e,
    V: s2e,
    w: o2e,
    W: l2e,
    x: L,
    X: B,
    y: PS,
    Y: AS,
    Z: c2e,
    "%": C2e
  };
  w.x = S(n, w), w.X = S(r, w), w.c = S(t, w), x.x = S(n, x), x.X = S(r, x), x.c = S(t, x);
  function S(U, X) {
    return function(ie) {
      var j = [], te = -1, K = 0, me = U.length, we, ye, Ze;
      for (ie instanceof Date || (ie = /* @__PURE__ */ new Date(+ie)); ++te < me; )
        U.charCodeAt(te) === 37 && (j.push(U.slice(K, te)), (ye = OS[we = U.charAt(++te)]) != null ? we = U.charAt(++te) : ye = we === "e" ? " " : "0", (Ze = X[we]) && (we = Ze(ie, ye)), j.push(we), K = te + 1);
      return j.push(U.slice(K, te)), j.join("");
    };
  }
  function M(U, X) {
    return function(ie) {
      var j = Xs(1900, void 0, 1), te = E(j, U, ie += "", 0), K, me;
      if (te != ie.length) return null;
      if ("Q" in j) return new Date(j.Q);
      if ("s" in j) return new Date(j.s * 1e3 + ("L" in j ? j.L : 0));
      if (X && !("Z" in j) && (j.Z = 0), "p" in j && (j.H = j.H % 12 + j.p * 12), j.m === void 0 && (j.m = "q" in j ? j.q : 0), "V" in j) {
        if (j.V < 1 || j.V > 53) return null;
        "w" in j || (j.w = 1), "Z" in j ? (K = M4(Xs(j.y, 0, 1)), me = K.getUTCDay(), K = me > 4 || me === 0 ? $5.ceil(K) : $5(K), K = g0.offset(K, (j.V - 1) * 7), j.y = K.getUTCFullYear(), j.m = K.getUTCMonth(), j.d = K.getUTCDate() + (j.w + 6) % 7) : (K = S4(Xs(j.y, 0, 1)), me = K.getDay(), K = me > 4 || me === 0 ? B5.ceil(K) : B5(K), K = G2.offset(K, (j.V - 1) * 7), j.y = K.getFullYear(), j.m = K.getMonth(), j.d = K.getDate() + (j.w + 6) % 7);
      } else ("W" in j || "U" in j) && ("w" in j || (j.w = "u" in j ? j.u % 7 : "W" in j ? 1 : 0), me = "Z" in j ? M4(Xs(j.y, 0, 1)).getUTCDay() : S4(Xs(j.y, 0, 1)).getDay(), j.m = 0, j.d = "W" in j ? (j.w + 6) % 7 + j.W * 7 - (me + 5) % 7 : j.w + j.U * 7 - (me + 6) % 7);
      return "Z" in j ? (j.H += j.Z / 100 | 0, j.M += j.Z % 100, M4(j)) : S4(j);
    };
  }
  function E(U, X, ie, j) {
    for (var te = 0, K = X.length, me = ie.length, we, ye; te < K; ) {
      if (j >= me) return -1;
      if (we = X.charCodeAt(te++), we === 37) {
        if (we = X.charAt(te++), ye = b[we in OS ? X.charAt(te++) : we], !ye || (j = ye(U, ie, j)) < 0) return -1;
      } else if (we != ie.charCodeAt(j++))
        return -1;
    }
    return j;
  }
  function P(U, X, ie) {
    var j = c.exec(X.slice(ie));
    return j ? (U.p = u.get(j[0].toLowerCase()), ie + j[0].length) : -1;
  }
  function T(U, X, ie) {
    var j = p.exec(X.slice(ie));
    return j ? (U.w = C.get(j[0].toLowerCase()), ie + j[0].length) : -1;
  }
  function _(U, X, ie) {
    var j = f.exec(X.slice(ie));
    return j ? (U.w = h.get(j[0].toLowerCase()), ie + j[0].length) : -1;
  }
  function D(U, X, ie) {
    var j = v.exec(X.slice(ie));
    return j ? (U.m = y.get(j[0].toLowerCase()), ie + j[0].length) : -1;
  }
  function N(U, X, ie) {
    var j = m.exec(X.slice(ie));
    return j ? (U.m = g.get(j[0].toLowerCase()), ie + j[0].length) : -1;
  }
  function R(U, X, ie) {
    return E(U, t, X, ie);
  }
  function L(U, X, ie) {
    return E(U, n, X, ie);
  }
  function B(U, X, ie) {
    return E(U, r, X, ie);
  }
  function V(U) {
    return a[U.getDay()];
  }
  function k(U) {
    return i[U.getDay()];
  }
  function z(U) {
    return l[U.getMonth()];
  }
  function $(U) {
    return s[U.getMonth()];
  }
  function Z(U) {
    return o[+(U.getHours() >= 12)];
  }
  function W(U) {
    return 1 + ~~(U.getMonth() / 3);
  }
  function H(U) {
    return a[U.getUTCDay()];
  }
  function G(U) {
    return i[U.getUTCDay()];
  }
  function Y(U) {
    return l[U.getUTCMonth()];
  }
  function ne(U) {
    return s[U.getUTCMonth()];
  }
  function J(U) {
    return o[+(U.getUTCHours() >= 12)];
  }
  function ee(U) {
    return 1 + ~~(U.getUTCMonth() / 3);
  }
  return {
    format: function(U) {
      var X = S(U += "", w);
      return X.toString = function() {
        return U;
      }, X;
    },
    parse: function(U) {
      var X = M(U += "", !1);
      return X.toString = function() {
        return U;
      }, X;
    },
    utcFormat: function(U) {
      var X = S(U += "", x);
      return X.toString = function() {
        return U;
      }, X;
    },
    utcParse: function(U) {
      var X = M(U += "", !0);
      return X.toString = function() {
        return U;
      }, X;
    }
  };
}
var OS = { "-": "", _: " ", 0: "0" }, hn = /^\s*\d+/, t2e = /^%/, n2e = /[\\^$*+?|[\]().{}]/g;
function et(e, t, n) {
  var r = e < 0 ? "-" : "", o = (r ? -e : e) + "", i = o.length;
  return r + (i < n ? new Array(n - i + 1).join(t) + o : o);
}
function r2e(e) {
  return e.replace(n2e, "\\$&");
}
function Qs(e) {
  return new RegExp("^(?:" + e.map(r2e).join("|") + ")", "i");
}
function Js(e) {
  return new Map(e.map((t, n) => [t.toLowerCase(), n]));
}
function o2e(e, t, n) {
  var r = hn.exec(t.slice(n, n + 1));
  return r ? (e.w = +r[0], n + r[0].length) : -1;
}
function i2e(e, t, n) {
  var r = hn.exec(t.slice(n, n + 1));
  return r ? (e.u = +r[0], n + r[0].length) : -1;
}
function a2e(e, t, n) {
  var r = hn.exec(t.slice(n, n + 2));
  return r ? (e.U = +r[0], n + r[0].length) : -1;
}
function s2e(e, t, n) {
  var r = hn.exec(t.slice(n, n + 2));
  return r ? (e.V = +r[0], n + r[0].length) : -1;
}
function l2e(e, t, n) {
  var r = hn.exec(t.slice(n, n + 2));
  return r ? (e.W = +r[0], n + r[0].length) : -1;
}
function AS(e, t, n) {
  var r = hn.exec(t.slice(n, n + 4));
  return r ? (e.y = +r[0], n + r[0].length) : -1;
}
function PS(e, t, n) {
  var r = hn.exec(t.slice(n, n + 2));
  return r ? (e.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
}
function c2e(e, t, n) {
  var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(n, n + 6));
  return r ? (e.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
}
function u2e(e, t, n) {
  var r = hn.exec(t.slice(n, n + 1));
  return r ? (e.q = r[0] * 3 - 3, n + r[0].length) : -1;
}
function f2e(e, t, n) {
  var r = hn.exec(t.slice(n, n + 2));
  return r ? (e.m = r[0] - 1, n + r[0].length) : -1;
}
function TS(e, t, n) {
  var r = hn.exec(t.slice(n, n + 2));
  return r ? (e.d = +r[0], n + r[0].length) : -1;
}
function d2e(e, t, n) {
  var r = hn.exec(t.slice(n, n + 3));
  return r ? (e.m = 0, e.d = +r[0], n + r[0].length) : -1;
}
function IS(e, t, n) {
  var r = hn.exec(t.slice(n, n + 2));
  return r ? (e.H = +r[0], n + r[0].length) : -1;
}
function h2e(e, t, n) {
  var r = hn.exec(t.slice(n, n + 2));
  return r ? (e.M = +r[0], n + r[0].length) : -1;
}
function p2e(e, t, n) {
  var r = hn.exec(t.slice(n, n + 2));
  return r ? (e.S = +r[0], n + r[0].length) : -1;
}
function m2e(e, t, n) {
  var r = hn.exec(t.slice(n, n + 3));
  return r ? (e.L = +r[0], n + r[0].length) : -1;
}
function g2e(e, t, n) {
  var r = hn.exec(t.slice(n, n + 6));
  return r ? (e.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
}
function C2e(e, t, n) {
  var r = t2e.exec(t.slice(n, n + 1));
  return r ? n + r[0].length : -1;
}
function v2e(e, t, n) {
  var r = hn.exec(t.slice(n));
  return r ? (e.Q = +r[0], n + r[0].length) : -1;
}
function y2e(e, t, n) {
  var r = hn.exec(t.slice(n));
  return r ? (e.s = +r[0], n + r[0].length) : -1;
}
function DS(e, t) {
  return et(e.getDate(), t, 2);
}
function b2e(e, t) {
  return et(e.getHours(), t, 2);
}
function w2e(e, t) {
  return et(e.getHours() % 12 || 12, t, 2);
}
function x2e(e, t) {
  return et(1 + G2.count(Jo(e), e), t, 3);
}
function yR(e, t) {
  return et(e.getMilliseconds(), t, 3);
}
function S2e(e, t) {
  return yR(e, t) + "000";
}
function M2e(e, t) {
  return et(e.getMonth() + 1, t, 2);
}
function E2e(e, t) {
  return et(e.getMinutes(), t, 2);
}
function _2e(e, t) {
  return et(e.getSeconds(), t, 2);
}
function O2e(e) {
  var t = e.getDay();
  return t === 0 ? 7 : t;
}
function A2e(e, t) {
  return et(C0.count(Jo(e) - 1, e), t, 2);
}
function bR(e) {
  var t = e.getDay();
  return t >= 4 || t === 0 ? Ua(e) : Ua.ceil(e);
}
function P2e(e, t) {
  return e = bR(e), et(Ua.count(Jo(e), e) + (Jo(e).getDay() === 4), t, 2);
}
function T2e(e) {
  return e.getDay();
}
function I2e(e, t) {
  return et(B5.count(Jo(e) - 1, e), t, 2);
}
function D2e(e, t) {
  return et(e.getFullYear() % 100, t, 2);
}
function R2e(e, t) {
  return e = bR(e), et(e.getFullYear() % 100, t, 2);
}
function k2e(e, t) {
  return et(e.getFullYear() % 1e4, t, 4);
}
function L2e(e, t) {
  var n = e.getDay();
  return e = n >= 4 || n === 0 ? Ua(e) : Ua.ceil(e), et(e.getFullYear() % 1e4, t, 4);
}
function N2e(e) {
  var t = e.getTimezoneOffset();
  return (t > 0 ? "-" : (t *= -1, "+")) + et(t / 60 | 0, "0", 2) + et(t % 60, "0", 2);
}
function RS(e, t) {
  return et(e.getUTCDate(), t, 2);
}
function F2e(e, t) {
  return et(e.getUTCHours(), t, 2);
}
function V2e(e, t) {
  return et(e.getUTCHours() % 12 || 12, t, 2);
}
function B2e(e, t) {
  return et(1 + g0.count(e1(e), e), t, 3);
}
function wR(e, t) {
  return et(e.getUTCMilliseconds(), t, 3);
}
function $2e(e, t) {
  return wR(e, t) + "000";
}
function j2e(e, t) {
  return et(e.getUTCMonth() + 1, t, 2);
}
function H2e(e, t) {
  return et(e.getUTCMinutes(), t, 2);
}
function z2e(e, t) {
  return et(e.getUTCSeconds(), t, 2);
}
function Z2e(e) {
  var t = e.getUTCDay();
  return t === 0 ? 7 : t;
}
function W2e(e, t) {
  return et(v0.count(e1(e) - 1, e), t, 2);
}
function xR(e) {
  var t = e.getUTCDay();
  return t >= 4 || t === 0 ? Ga(e) : Ga.ceil(e);
}
function q2e(e, t) {
  return e = xR(e), et(Ga.count(e1(e), e) + (e1(e).getUTCDay() === 4), t, 2);
}
function U2e(e) {
  return e.getUTCDay();
}
function G2e(e, t) {
  return et($5.count(e1(e) - 1, e), t, 2);
}
function K2e(e, t) {
  return et(e.getUTCFullYear() % 100, t, 2);
}
function Y2e(e, t) {
  return e = xR(e), et(e.getUTCFullYear() % 100, t, 2);
}
function X2e(e, t) {
  return et(e.getUTCFullYear() % 1e4, t, 4);
}
function Q2e(e, t) {
  var n = e.getUTCDay();
  return e = n >= 4 || n === 0 ? Ga(e) : Ga.ceil(e), et(e.getUTCFullYear() % 1e4, t, 4);
}
function J2e() {
  return "+0000";
}
function kS() {
  return "%";
}
function LS(e) {
  return +e;
}
function NS(e) {
  return Math.floor(+e / 1e3);
}
var na, SR, MR;
ece({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function ece(e) {
  return na = e2e(e), SR = na.format, na.parse, MR = na.utcFormat, na.utcParse, na;
}
function tce(e) {
  return new Date(e);
}
function nce(e) {
  return e instanceof Date ? +e : +/* @__PURE__ */ new Date(+e);
}
function Xp(e, t, n, r, o, i, a, s, l, c) {
  var u = Fp(), f = u.invert, h = u.domain, p = c(".%L"), C = c(":%S"), m = c("%I:%M"), g = c("%I %p"), v = c("%a %d"), y = c("%b %d"), w = c("%B"), x = c("%Y");
  function b(S) {
    return (l(S) < S ? p : s(S) < S ? C : a(S) < S ? m : i(S) < S ? g : r(S) < S ? o(S) < S ? v : y : n(S) < S ? w : x)(S);
  }
  return u.invert = function(S) {
    return new Date(f(S));
  }, u.domain = function(S) {
    return arguments.length ? h(Array.from(S, nce)) : h().map(tce);
  }, u.ticks = function(S) {
    var M = h();
    return e(M[0], M[M.length - 1], S ?? 10);
  }, u.tickFormat = function(S, M) {
    return M == null ? b : c(M);
  }, u.nice = function(S) {
    var M = h();
    return (!S || typeof S.range != "function") && (S = t(M[0], M[M.length - 1], S ?? 10)), S ? h(uR(M, S)) : u;
  }, u.copy = function() {
    return U2(u, Xp(e, t, n, r, o, i, a, s, l, c));
  }, u;
}
function rce() {
  return Or.apply(Xp(Qle, Jle, Jo, Kp, C0, G2, Up, Wp, si, SR).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function oce() {
  return Or.apply(Xp(Yle, Xle, e1, Yp, v0, g0, Gp, qp, si, MR).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function y0() {
  var e = 0, t = 1, n, r, o, i, a = Nn, s = !1, l;
  function c(f) {
    return f == null || isNaN(f = +f) ? l : a(o === 0 ? 0.5 : (f = (i(f) - n) * o, s ? Math.max(0, Math.min(1, f)) : f));
  }
  c.domain = function(f) {
    return arguments.length ? ([e, t] = f, n = i(e = +e), r = i(t = +t), o = n === r ? 0 : 1 / (r - n), c) : [e, t];
  }, c.clamp = function(f) {
    return arguments.length ? (s = !!f, c) : s;
  }, c.interpolator = function(f) {
    return arguments.length ? (a = f, c) : a;
  };
  function u(f) {
    return function(h) {
      var p, C;
      return arguments.length ? ([p, C] = h, a = f(p, C), c) : [a(0), a(1)];
    };
  }
  return c.range = u(Os), c.rangeRound = u(Np), c.unknown = function(f) {
    return arguments.length ? (l = f, c) : l;
  }, function(f) {
    return i = f, n = f(e), r = f(t), o = n === r ? 0 : 1 / (r - n), c;
  };
}
function H1(e, t) {
  return t.domain(e.domain()).interpolator(e.interpolator()).clamp(e.clamp()).unknown(e.unknown());
}
function ER() {
  var e = j1(y0()(Nn));
  return e.copy = function() {
    return H1(e, ER());
  }, r1.apply(e, arguments);
}
function _R() {
  var e = $p(y0()).domain([1, 10]);
  return e.copy = function() {
    return H1(e, _R()).base(e.base());
  }, r1.apply(e, arguments);
}
function OR() {
  var e = jp(y0());
  return e.copy = function() {
    return H1(e, OR()).constant(e.constant());
  }, r1.apply(e, arguments);
}
function Qp() {
  var e = Hp(y0());
  return e.copy = function() {
    return H1(e, Qp()).exponent(e.exponent());
  }, r1.apply(e, arguments);
}
function ice() {
  return Qp.apply(null, arguments).exponent(0.5);
}
function AR() {
  var e = [], t = Nn;
  function n(r) {
    if (r != null && !isNaN(r = +r)) return t((W2(e, r, 1) - 1) / (e.length - 1));
  }
  return n.domain = function(r) {
    if (!arguments.length) return e.slice();
    e = [];
    for (let o of r) o != null && !isNaN(o = +o) && e.push(o);
    return e.sort(M1), n;
  }, n.interpolator = function(r) {
    return arguments.length ? (t = r, n) : t;
  }, n.range = function() {
    return e.map((r, o) => t(o / (e.length - 1)));
  }, n.quantiles = function(r) {
    return Array.from({ length: r + 1 }, (o, i) => Wse(e, i / r));
  }, n.copy = function() {
    return AR(t).domain(e);
  }, r1.apply(n, arguments);
}
function b0() {
  var e = 0, t = 0.5, n = 1, r = 1, o, i, a, s, l, c = Nn, u, f = !1, h;
  function p(m) {
    return isNaN(m = +m) ? h : (m = 0.5 + ((m = +u(m)) - i) * (r * m < r * i ? s : l), c(f ? Math.max(0, Math.min(1, m)) : m));
  }
  p.domain = function(m) {
    return arguments.length ? ([e, t, n] = m, o = u(e = +e), i = u(t = +t), a = u(n = +n), s = o === i ? 0 : 0.5 / (i - o), l = i === a ? 0 : 0.5 / (a - i), r = i < o ? -1 : 1, p) : [e, t, n];
  }, p.clamp = function(m) {
    return arguments.length ? (f = !!m, p) : f;
  }, p.interpolator = function(m) {
    return arguments.length ? (c = m, p) : c;
  };
  function C(m) {
    return function(g) {
      var v, y, w;
      return arguments.length ? ([v, y, w] = g, c = Cle(m, [v, y, w]), p) : [c(0), c(0.5), c(1)];
    };
  }
  return p.range = C(Os), p.rangeRound = C(Np), p.unknown = function(m) {
    return arguments.length ? (h = m, p) : h;
  }, function(m) {
    return u = m, o = m(e), i = m(t), a = m(n), s = o === i ? 0 : 0.5 / (i - o), l = i === a ? 0 : 0.5 / (a - i), r = i < o ? -1 : 1, p;
  };
}
function PR() {
  var e = j1(b0()(Nn));
  return e.copy = function() {
    return H1(e, PR());
  }, r1.apply(e, arguments);
}
function TR() {
  var e = $p(b0()).domain([0.1, 1, 10]);
  return e.copy = function() {
    return H1(e, TR()).base(e.base());
  }, r1.apply(e, arguments);
}
function IR() {
  var e = jp(b0());
  return e.copy = function() {
    return H1(e, IR()).constant(e.constant());
  }, r1.apply(e, arguments);
}
function Jp() {
  var e = Hp(b0());
  return e.copy = function() {
    return H1(e, Jp()).exponent(e.exponent());
  }, r1.apply(e, arguments);
}
function ace() {
  return Jp.apply(null, arguments).exponent(0.5);
}
const FS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: Kl,
  scaleDiverging: PR,
  scaleDivergingLog: TR,
  scaleDivergingPow: Jp,
  scaleDivergingSqrt: ace,
  scaleDivergingSymlog: IR,
  scaleIdentity: cR,
  scaleImplicit: Tf,
  scaleLinear: F5,
  scaleLog: fR,
  scaleOrdinal: Rp,
  scalePoint: wl,
  scalePow: zp,
  scaleQuantile: pR,
  scaleQuantize: mR,
  scaleRadial: hR,
  scaleSequential: ER,
  scaleSequentialLog: _R,
  scaleSequentialPow: Qp,
  scaleSequentialQuantile: AR,
  scaleSequentialSqrt: ice,
  scaleSequentialSymlog: OR,
  scaleSqrt: $le,
  scaleSymlog: dR,
  scaleThreshold: gR,
  scaleTime: rce,
  scaleUtc: oce,
  tickFormat: lR
}, Symbol.toStringTag, { value: "Module" }));
var E4, VS;
function DR() {
  if (VS) return E4;
  VS = 1;
  var e = Ss();
  function t(n, r, o) {
    for (var i = -1, a = n.length; ++i < a; ) {
      var s = n[i], l = r(s);
      if (l != null && (c === void 0 ? l === l && !e(l) : o(l, c)))
        var c = l, u = s;
    }
    return u;
  }
  return E4 = t, E4;
}
var _4, BS;
function sce() {
  if (BS) return _4;
  BS = 1;
  function e(t, n) {
    return t > n;
  }
  return _4 = e, _4;
}
var O4, $S;
function lce() {
  if ($S) return O4;
  $S = 1;
  var e = DR(), t = sce(), n = _s();
  function r(o) {
    return o && o.length ? e(o, n, t) : void 0;
  }
  return O4 = r, O4;
}
var cce = lce();
const v1 = /* @__PURE__ */ Mt(cce);
var A4, jS;
function uce() {
  if (jS) return A4;
  jS = 1;
  function e(t, n) {
    return t < n;
  }
  return A4 = e, A4;
}
var P4, HS;
function fce() {
  if (HS) return P4;
  HS = 1;
  var e = DR(), t = uce(), n = _s();
  function r(o) {
    return o && o.length ? e(o, n, t) : void 0;
  }
  return P4 = r, P4;
}
var dce = fce();
const w0 = /* @__PURE__ */ Mt(dce);
var T4, zS;
function hce() {
  if (zS) return T4;
  zS = 1;
  var e = mp(), t = B1(), n = jD(), r = Qn();
  function o(i, a) {
    var s = r(i) ? e : n;
    return s(i, t(a, 3));
  }
  return T4 = o, T4;
}
var I4, ZS;
function pce() {
  if (ZS) return I4;
  ZS = 1;
  var e = BD(), t = hce();
  function n(r, o) {
    return e(t(r, o), 1);
  }
  return I4 = n, I4;
}
var mce = pce();
const gce = /* @__PURE__ */ Mt(mce);
var D4, WS;
function Cce() {
  if (WS) return D4;
  WS = 1;
  var e = Op();
  function t(n, r) {
    return e(n, r);
  }
  return D4 = t, D4;
}
var vce = Cce();
const Oi = /* @__PURE__ */ Mt(vce);
var As = 1e9, yce = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed during run-time using `Decimal.config`.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
  // `toFixed`, `toPrecision` and `toSignificantDigits`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -MAX_E
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to MAX_E
  // The natural logarithm of 10.
  // 115 digits
  LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
}, tm, It = !0, _r = "[DecimalError] ", mi = _r + "Invalid argument: ", em = _r + "Exponent out of range: ", Ps = Math.floor, J1 = Math.pow, bce = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ir, fn = 1e7, _t = 7, RR = 9007199254740991, j5 = Ps(RR / _t), be = {};
be.absoluteValue = be.abs = function() {
  var e = new this.constructor(this);
  return e.s && (e.s = 1), e;
};
be.comparedTo = be.cmp = function(e) {
  var t, n, r, o, i = this;
  if (e = new i.constructor(e), i.s !== e.s) return i.s || -e.s;
  if (i.e !== e.e) return i.e > e.e ^ i.s < 0 ? 1 : -1;
  for (r = i.d.length, o = e.d.length, t = 0, n = r < o ? r : o; t < n; ++t)
    if (i.d[t] !== e.d[t]) return i.d[t] > e.d[t] ^ i.s < 0 ? 1 : -1;
  return r === o ? 0 : r > o ^ i.s < 0 ? 1 : -1;
};
be.decimalPlaces = be.dp = function() {
  var e = this, t = e.d.length - 1, n = (t - e.e) * _t;
  if (t = e.d[t], t) for (; t % 10 == 0; t /= 10) n--;
  return n < 0 ? 0 : n;
};
be.dividedBy = be.div = function(e) {
  return qo(this, new this.constructor(e));
};
be.dividedToIntegerBy = be.idiv = function(e) {
  var t = this, n = t.constructor;
  return yt(qo(t, new n(e), 0, 1), n.precision);
};
be.equals = be.eq = function(e) {
  return !this.cmp(e);
};
be.exponent = function() {
  return tn(this);
};
be.greaterThan = be.gt = function(e) {
  return this.cmp(e) > 0;
};
be.greaterThanOrEqualTo = be.gte = function(e) {
  return this.cmp(e) >= 0;
};
be.isInteger = be.isint = function() {
  return this.e > this.d.length - 2;
};
be.isNegative = be.isneg = function() {
  return this.s < 0;
};
be.isPositive = be.ispos = function() {
  return this.s > 0;
};
be.isZero = function() {
  return this.s === 0;
};
be.lessThan = be.lt = function(e) {
  return this.cmp(e) < 0;
};
be.lessThanOrEqualTo = be.lte = function(e) {
  return this.cmp(e) < 1;
};
be.logarithm = be.log = function(e) {
  var t, n = this, r = n.constructor, o = r.precision, i = o + 5;
  if (e === void 0)
    e = new r(10);
  else if (e = new r(e), e.s < 1 || e.eq(ir)) throw Error(_r + "NaN");
  if (n.s < 1) throw Error(_r + (n.s ? "NaN" : "-Infinity"));
  return n.eq(ir) ? new r(0) : (It = !1, t = qo(e2(n, i), e2(e, i), i), It = !0, yt(t, o));
};
be.minus = be.sub = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? NR(t, e) : kR(t, (e.s = -e.s, e));
};
be.modulo = be.mod = function(e) {
  var t, n = this, r = n.constructor, o = r.precision;
  if (e = new r(e), !e.s) throw Error(_r + "NaN");
  return n.s ? (It = !1, t = qo(n, e, 0, 1).times(e), It = !0, n.minus(t)) : yt(new r(n), o);
};
be.naturalExponential = be.exp = function() {
  return LR(this);
};
be.naturalLogarithm = be.ln = function() {
  return e2(this);
};
be.negated = be.neg = function() {
  var e = new this.constructor(this);
  return e.s = -e.s || 0, e;
};
be.plus = be.add = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? kR(t, e) : NR(t, (e.s = -e.s, e));
};
be.precision = be.sd = function(e) {
  var t, n, r, o = this;
  if (e !== void 0 && e !== !!e && e !== 1 && e !== 0) throw Error(mi + e);
  if (t = tn(o) + 1, r = o.d.length - 1, n = r * _t + 1, r = o.d[r], r) {
    for (; r % 10 == 0; r /= 10) n--;
    for (r = o.d[0]; r >= 10; r /= 10) n++;
  }
  return e && t > n ? t : n;
};
be.squareRoot = be.sqrt = function() {
  var e, t, n, r, o, i, a, s = this, l = s.constructor;
  if (s.s < 1) {
    if (!s.s) return new l(0);
    throw Error(_r + "NaN");
  }
  for (e = tn(s), It = !1, o = Math.sqrt(+s), o == 0 || o == 1 / 0 ? (t = uo(s.d), (t.length + e) % 2 == 0 && (t += "0"), o = Math.sqrt(t), e = Ps((e + 1) / 2) - (e < 0 || e % 2), o == 1 / 0 ? t = "5e" + e : (t = o.toExponential(), t = t.slice(0, t.indexOf("e") + 1) + e), r = new l(t)) : r = new l(o.toString()), n = l.precision, o = a = n + 3; ; )
    if (i = r, r = i.plus(qo(s, i, a + 2)).times(0.5), uo(i.d).slice(0, a) === (t = uo(r.d)).slice(0, a)) {
      if (t = t.slice(a - 3, a + 1), o == a && t == "4999") {
        if (yt(i, n + 1, 0), i.times(i).eq(s)) {
          r = i;
          break;
        }
      } else if (t != "9999")
        break;
      a += 4;
    }
  return It = !0, yt(r, n);
};
be.times = be.mul = function(e) {
  var t, n, r, o, i, a, s, l, c, u = this, f = u.constructor, h = u.d, p = (e = new f(e)).d;
  if (!u.s || !e.s) return new f(0);
  for (e.s *= u.s, n = u.e + e.e, l = h.length, c = p.length, l < c && (i = h, h = p, p = i, a = l, l = c, c = a), i = [], a = l + c, r = a; r--; ) i.push(0);
  for (r = c; --r >= 0; ) {
    for (t = 0, o = l + r; o > r; )
      s = i[o] + p[r] * h[o - r - 1] + t, i[o--] = s % fn | 0, t = s / fn | 0;
    i[o] = (i[o] + t) % fn | 0;
  }
  for (; !i[--a]; ) i.pop();
  return t ? ++n : i.shift(), e.d = i, e.e = n, It ? yt(e, f.precision) : e;
};
be.toDecimalPlaces = be.todp = function(e, t) {
  var n = this, r = n.constructor;
  return n = new r(n), e === void 0 ? n : (wo(e, 0, As), t === void 0 ? t = r.rounding : wo(t, 0, 8), yt(n, e + tn(n) + 1, t));
};
be.toExponential = function(e, t) {
  var n, r = this, o = r.constructor;
  return e === void 0 ? n = Ai(r, !0) : (wo(e, 0, As), t === void 0 ? t = o.rounding : wo(t, 0, 8), r = yt(new o(r), e + 1, t), n = Ai(r, !0, e + 1)), n;
};
be.toFixed = function(e, t) {
  var n, r, o = this, i = o.constructor;
  return e === void 0 ? Ai(o) : (wo(e, 0, As), t === void 0 ? t = i.rounding : wo(t, 0, 8), r = yt(new i(o), e + tn(o) + 1, t), n = Ai(r.abs(), !1, e + tn(r) + 1), o.isneg() && !o.isZero() ? "-" + n : n);
};
be.toInteger = be.toint = function() {
  var e = this, t = e.constructor;
  return yt(new t(e), tn(e) + 1, t.rounding);
};
be.toNumber = function() {
  return +this;
};
be.toPower = be.pow = function(e) {
  var t, n, r, o, i, a, s = this, l = s.constructor, c = 12, u = +(e = new l(e));
  if (!e.s) return new l(ir);
  if (s = new l(s), !s.s) {
    if (e.s < 1) throw Error(_r + "Infinity");
    return s;
  }
  if (s.eq(ir)) return s;
  if (r = l.precision, e.eq(ir)) return yt(s, r);
  if (t = e.e, n = e.d.length - 1, a = t >= n, i = s.s, a) {
    if ((n = u < 0 ? -u : u) <= RR) {
      for (o = new l(ir), t = Math.ceil(r / _t + 4), It = !1; n % 2 && (o = o.times(s), US(o.d, t)), n = Ps(n / 2), n !== 0; )
        s = s.times(s), US(s.d, t);
      return It = !0, e.s < 0 ? new l(ir).div(o) : yt(o, r);
    }
  } else if (i < 0) throw Error(_r + "NaN");
  return i = i < 0 && e.d[Math.max(t, n)] & 1 ? -1 : 1, s.s = 1, It = !1, o = e.times(e2(s, r + c)), It = !0, o = LR(o), o.s = i, o;
};
be.toPrecision = function(e, t) {
  var n, r, o = this, i = o.constructor;
  return e === void 0 ? (n = tn(o), r = Ai(o, n <= i.toExpNeg || n >= i.toExpPos)) : (wo(e, 1, As), t === void 0 ? t = i.rounding : wo(t, 0, 8), o = yt(new i(o), e, t), n = tn(o), r = Ai(o, e <= n || n <= i.toExpNeg, e)), r;
};
be.toSignificantDigits = be.tosd = function(e, t) {
  var n = this, r = n.constructor;
  return e === void 0 ? (e = r.precision, t = r.rounding) : (wo(e, 1, As), t === void 0 ? t = r.rounding : wo(t, 0, 8)), yt(new r(n), e, t);
};
be.toString = be.valueOf = be.val = be.toJSON = be[Symbol.for("nodejs.util.inspect.custom")] = function() {
  var e = this, t = tn(e), n = e.constructor;
  return Ai(e, t <= n.toExpNeg || t >= n.toExpPos);
};
function kR(e, t) {
  var n, r, o, i, a, s, l, c, u = e.constructor, f = u.precision;
  if (!e.s || !t.s)
    return t.s || (t = new u(e)), It ? yt(t, f) : t;
  if (l = e.d, c = t.d, a = e.e, o = t.e, l = l.slice(), i = a - o, i) {
    for (i < 0 ? (r = l, i = -i, s = c.length) : (r = c, o = a, s = l.length), a = Math.ceil(f / _t), s = a > s ? a + 1 : s + 1, i > s && (i = s, r.length = 1), r.reverse(); i--; ) r.push(0);
    r.reverse();
  }
  for (s = l.length, i = c.length, s - i < 0 && (i = s, r = c, c = l, l = r), n = 0; i; )
    n = (l[--i] = l[i] + c[i] + n) / fn | 0, l[i] %= fn;
  for (n && (l.unshift(n), ++o), s = l.length; l[--s] == 0; ) l.pop();
  return t.d = l, t.e = o, It ? yt(t, f) : t;
}
function wo(e, t, n) {
  if (e !== ~~e || e < t || e > n)
    throw Error(mi + e);
}
function uo(e) {
  var t, n, r, o = e.length - 1, i = "", a = e[0];
  if (o > 0) {
    for (i += a, t = 1; t < o; t++)
      r = e[t] + "", n = _t - r.length, n && (i += d1(n)), i += r;
    a = e[t], r = a + "", n = _t - r.length, n && (i += d1(n));
  } else if (a === 0)
    return "0";
  for (; a % 10 === 0; ) a /= 10;
  return i + a;
}
var qo = /* @__PURE__ */ (function() {
  function e(r, o) {
    var i, a = 0, s = r.length;
    for (r = r.slice(); s--; )
      i = r[s] * o + a, r[s] = i % fn | 0, a = i / fn | 0;
    return a && r.unshift(a), r;
  }
  function t(r, o, i, a) {
    var s, l;
    if (i != a)
      l = i > a ? 1 : -1;
    else
      for (s = l = 0; s < i; s++)
        if (r[s] != o[s]) {
          l = r[s] > o[s] ? 1 : -1;
          break;
        }
    return l;
  }
  function n(r, o, i) {
    for (var a = 0; i--; )
      r[i] -= a, a = r[i] < o[i] ? 1 : 0, r[i] = a * fn + r[i] - o[i];
    for (; !r[0] && r.length > 1; ) r.shift();
  }
  return function(r, o, i, a) {
    var s, l, c, u, f, h, p, C, m, g, v, y, w, x, b, S, M, E, P = r.constructor, T = r.s == o.s ? 1 : -1, _ = r.d, D = o.d;
    if (!r.s) return new P(r);
    if (!o.s) throw Error(_r + "Division by zero");
    for (l = r.e - o.e, M = D.length, b = _.length, p = new P(T), C = p.d = [], c = 0; D[c] == (_[c] || 0); ) ++c;
    if (D[c] > (_[c] || 0) && --l, i == null ? y = i = P.precision : a ? y = i + (tn(r) - tn(o)) + 1 : y = i, y < 0) return new P(0);
    if (y = y / _t + 2 | 0, c = 0, M == 1)
      for (u = 0, D = D[0], y++; (c < b || u) && y--; c++)
        w = u * fn + (_[c] || 0), C[c] = w / D | 0, u = w % D | 0;
    else {
      for (u = fn / (D[0] + 1) | 0, u > 1 && (D = e(D, u), _ = e(_, u), M = D.length, b = _.length), x = M, m = _.slice(0, M), g = m.length; g < M; ) m[g++] = 0;
      E = D.slice(), E.unshift(0), S = D[0], D[1] >= fn / 2 && ++S;
      do
        u = 0, s = t(D, m, M, g), s < 0 ? (v = m[0], M != g && (v = v * fn + (m[1] || 0)), u = v / S | 0, u > 1 ? (u >= fn && (u = fn - 1), f = e(D, u), h = f.length, g = m.length, s = t(f, m, h, g), s == 1 && (u--, n(f, M < h ? E : D, h))) : (u == 0 && (s = u = 1), f = D.slice()), h = f.length, h < g && f.unshift(0), n(m, f, g), s == -1 && (g = m.length, s = t(D, m, M, g), s < 1 && (u++, n(m, M < g ? E : D, g))), g = m.length) : s === 0 && (u++, m = [0]), C[c++] = u, s && m[0] ? m[g++] = _[x] || 0 : (m = [_[x]], g = 1);
      while ((x++ < b || m[0] !== void 0) && y--);
    }
    return C[0] || C.shift(), p.e = l, yt(p, a ? i + tn(p) + 1 : i);
  };
})();
function LR(e, t) {
  var n, r, o, i, a, s, l = 0, c = 0, u = e.constructor, f = u.precision;
  if (tn(e) > 16) throw Error(em + tn(e));
  if (!e.s) return new u(ir);
  for (It = !1, s = f, a = new u(0.03125); e.abs().gte(0.1); )
    e = e.times(a), c += 5;
  for (r = Math.log(J1(2, c)) / Math.LN10 * 2 + 5 | 0, s += r, n = o = i = new u(ir), u.precision = s; ; ) {
    if (o = yt(o.times(e), s), n = n.times(++l), a = i.plus(qo(o, n, s)), uo(a.d).slice(0, s) === uo(i.d).slice(0, s)) {
      for (; c--; ) i = yt(i.times(i), s);
      return u.precision = f, t == null ? (It = !0, yt(i, f)) : i;
    }
    i = a;
  }
}
function tn(e) {
  for (var t = e.e * _t, n = e.d[0]; n >= 10; n /= 10) t++;
  return t;
}
function R4(e, t, n) {
  if (t > e.LN10.sd())
    throw It = !0, n && (e.precision = n), Error(_r + "LN10 precision limit exceeded");
  return yt(new e(e.LN10), t);
}
function d1(e) {
  for (var t = ""; e--; ) t += "0";
  return t;
}
function e2(e, t) {
  var n, r, o, i, a, s, l, c, u, f = 1, h = 10, p = e, C = p.d, m = p.constructor, g = m.precision;
  if (p.s < 1) throw Error(_r + (p.s ? "NaN" : "-Infinity"));
  if (p.eq(ir)) return new m(0);
  if (t == null ? (It = !1, c = g) : c = t, p.eq(10))
    return t == null && (It = !0), R4(m, c);
  if (c += h, m.precision = c, n = uo(C), r = n.charAt(0), i = tn(p), Math.abs(i) < 15e14) {
    for (; r < 7 && r != 1 || r == 1 && n.charAt(1) > 3; )
      p = p.times(e), n = uo(p.d), r = n.charAt(0), f++;
    i = tn(p), r > 1 ? (p = new m("0." + n), i++) : p = new m(r + "." + n.slice(1));
  } else
    return l = R4(m, c + 2, g).times(i + ""), p = e2(new m(r + "." + n.slice(1)), c - h).plus(l), m.precision = g, t == null ? (It = !0, yt(p, g)) : p;
  for (s = a = p = qo(p.minus(ir), p.plus(ir), c), u = yt(p.times(p), c), o = 3; ; ) {
    if (a = yt(a.times(u), c), l = s.plus(qo(a, new m(o), c)), uo(l.d).slice(0, c) === uo(s.d).slice(0, c))
      return s = s.times(2), i !== 0 && (s = s.plus(R4(m, c + 2, g).times(i + ""))), s = qo(s, new m(f), c), m.precision = g, t == null ? (It = !0, yt(s, g)) : s;
    s = l, o += 2;
  }
}
function qS(e, t) {
  var n, r, o;
  for ((n = t.indexOf(".")) > -1 && (t = t.replace(".", "")), (r = t.search(/e/i)) > 0 ? (n < 0 && (n = r), n += +t.slice(r + 1), t = t.substring(0, r)) : n < 0 && (n = t.length), r = 0; t.charCodeAt(r) === 48; ) ++r;
  for (o = t.length; t.charCodeAt(o - 1) === 48; ) --o;
  if (t = t.slice(r, o), t) {
    if (o -= r, n = n - r - 1, e.e = Ps(n / _t), e.d = [], r = (n + 1) % _t, n < 0 && (r += _t), r < o) {
      for (r && e.d.push(+t.slice(0, r)), o -= _t; r < o; ) e.d.push(+t.slice(r, r += _t));
      t = t.slice(r), r = _t - t.length;
    } else
      r -= o;
    for (; r--; ) t += "0";
    if (e.d.push(+t), It && (e.e > j5 || e.e < -j5)) throw Error(em + n);
  } else
    e.s = 0, e.e = 0, e.d = [0];
  return e;
}
function yt(e, t, n) {
  var r, o, i, a, s, l, c, u, f = e.d;
  for (a = 1, i = f[0]; i >= 10; i /= 10) a++;
  if (r = t - a, r < 0)
    r += _t, o = t, c = f[u = 0];
  else {
    if (u = Math.ceil((r + 1) / _t), i = f.length, u >= i) return e;
    for (c = i = f[u], a = 1; i >= 10; i /= 10) a++;
    r %= _t, o = r - _t + a;
  }
  if (n !== void 0 && (i = J1(10, a - o - 1), s = c / i % 10 | 0, l = t < 0 || f[u + 1] !== void 0 || c % i, l = n < 4 ? (s || l) && (n == 0 || n == (e.s < 0 ? 3 : 2)) : s > 5 || s == 5 && (n == 4 || l || n == 6 && // Check whether the digit to the left of the rounding digit is odd.
  (r > 0 ? o > 0 ? c / J1(10, a - o) : 0 : f[u - 1]) % 10 & 1 || n == (e.s < 0 ? 8 : 7))), t < 1 || !f[0])
    return l ? (i = tn(e), f.length = 1, t = t - i - 1, f[0] = J1(10, (_t - t % _t) % _t), e.e = Ps(-t / _t) || 0) : (f.length = 1, f[0] = e.e = e.s = 0), e;
  if (r == 0 ? (f.length = u, i = 1, u--) : (f.length = u + 1, i = J1(10, _t - r), f[u] = o > 0 ? (c / J1(10, a - o) % J1(10, o) | 0) * i : 0), l)
    for (; ; )
      if (u == 0) {
        (f[0] += i) == fn && (f[0] = 1, ++e.e);
        break;
      } else {
        if (f[u] += i, f[u] != fn) break;
        f[u--] = 0, i = 1;
      }
  for (r = f.length; f[--r] === 0; ) f.pop();
  if (It && (e.e > j5 || e.e < -j5))
    throw Error(em + tn(e));
  return e;
}
function NR(e, t) {
  var n, r, o, i, a, s, l, c, u, f, h = e.constructor, p = h.precision;
  if (!e.s || !t.s)
    return t.s ? t.s = -t.s : t = new h(e), It ? yt(t, p) : t;
  if (l = e.d, f = t.d, r = t.e, c = e.e, l = l.slice(), a = c - r, a) {
    for (u = a < 0, u ? (n = l, a = -a, s = f.length) : (n = f, r = c, s = l.length), o = Math.max(Math.ceil(p / _t), s) + 2, a > o && (a = o, n.length = 1), n.reverse(), o = a; o--; ) n.push(0);
    n.reverse();
  } else {
    for (o = l.length, s = f.length, u = o < s, u && (s = o), o = 0; o < s; o++)
      if (l[o] != f[o]) {
        u = l[o] < f[o];
        break;
      }
    a = 0;
  }
  for (u && (n = l, l = f, f = n, t.s = -t.s), s = l.length, o = f.length - s; o > 0; --o) l[s++] = 0;
  for (o = f.length; o > a; ) {
    if (l[--o] < f[o]) {
      for (i = o; i && l[--i] === 0; ) l[i] = fn - 1;
      --l[i], l[o] += fn;
    }
    l[o] -= f[o];
  }
  for (; l[--s] === 0; ) l.pop();
  for (; l[0] === 0; l.shift()) --r;
  return l[0] ? (t.d = l, t.e = r, It ? yt(t, p) : t) : new h(0);
}
function Ai(e, t, n) {
  var r, o = tn(e), i = uo(e.d), a = i.length;
  return t ? (n && (r = n - a) > 0 ? i = i.charAt(0) + "." + i.slice(1) + d1(r) : a > 1 && (i = i.charAt(0) + "." + i.slice(1)), i = i + (o < 0 ? "e" : "e+") + o) : o < 0 ? (i = "0." + d1(-o - 1) + i, n && (r = n - a) > 0 && (i += d1(r))) : o >= a ? (i += d1(o + 1 - a), n && (r = n - o - 1) > 0 && (i = i + "." + d1(r))) : ((r = o + 1) < a && (i = i.slice(0, r) + "." + i.slice(r)), n && (r = n - a) > 0 && (o + 1 === a && (i += "."), i += d1(r))), e.s < 0 ? "-" + i : i;
}
function US(e, t) {
  if (e.length > t)
    return e.length = t, !0;
}
function FR(e) {
  var t, n, r;
  function o(i) {
    var a = this;
    if (!(a instanceof o)) return new o(i);
    if (a.constructor = o, i instanceof o) {
      a.s = i.s, a.e = i.e, a.d = (i = i.d) ? i.slice() : i;
      return;
    }
    if (typeof i == "number") {
      if (i * 0 !== 0)
        throw Error(mi + i);
      if (i > 0)
        a.s = 1;
      else if (i < 0)
        i = -i, a.s = -1;
      else {
        a.s = 0, a.e = 0, a.d = [0];
        return;
      }
      if (i === ~~i && i < 1e7) {
        a.e = 0, a.d = [i];
        return;
      }
      return qS(a, i.toString());
    } else if (typeof i != "string")
      throw Error(mi + i);
    if (i.charCodeAt(0) === 45 ? (i = i.slice(1), a.s = -1) : a.s = 1, bce.test(i)) qS(a, i);
    else throw Error(mi + i);
  }
  if (o.prototype = be, o.ROUND_UP = 0, o.ROUND_DOWN = 1, o.ROUND_CEIL = 2, o.ROUND_FLOOR = 3, o.ROUND_HALF_UP = 4, o.ROUND_HALF_DOWN = 5, o.ROUND_HALF_EVEN = 6, o.ROUND_HALF_CEIL = 7, o.ROUND_HALF_FLOOR = 8, o.clone = FR, o.config = o.set = wce, e === void 0 && (e = {}), e)
    for (r = ["precision", "rounding", "toExpNeg", "toExpPos", "LN10"], t = 0; t < r.length; ) e.hasOwnProperty(n = r[t++]) || (e[n] = this[n]);
  return o.config(e), o;
}
function wce(e) {
  if (!e || typeof e != "object")
    throw Error(_r + "Object expected");
  var t, n, r, o = [
    "precision",
    1,
    As,
    "rounding",
    0,
    8,
    "toExpNeg",
    -1 / 0,
    0,
    "toExpPos",
    0,
    1 / 0
  ];
  for (t = 0; t < o.length; t += 3)
    if ((r = e[n = o[t]]) !== void 0)
      if (Ps(r) === r && r >= o[t + 1] && r <= o[t + 2]) this[n] = r;
      else throw Error(mi + n + ": " + r);
  if ((r = e[n = "LN10"]) !== void 0)
    if (r == Math.LN10) this[n] = new this(r);
    else throw Error(mi + n + ": " + r);
  return this;
}
var tm = FR(yce);
ir = new tm(1);
const mt = tm;
function xce(e) {
  return _ce(e) || Ece(e) || Mce(e) || Sce();
}
function Sce() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Mce(e, t) {
  if (e) {
    if (typeof e == "string") return kf(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return kf(e, t);
  }
}
function Ece(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e)) return Array.from(e);
}
function _ce(e) {
  if (Array.isArray(e)) return kf(e);
}
function kf(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var Oce = function(t) {
  return t;
}, VR = {}, BR = function(t) {
  return t === VR;
}, GS = function(t) {
  return function n() {
    return arguments.length === 0 || arguments.length === 1 && BR(arguments.length <= 0 ? void 0 : arguments[0]) ? n : t.apply(void 0, arguments);
  };
}, Ace = function e(t, n) {
  return t === 1 ? n : GS(function() {
    for (var r = arguments.length, o = new Array(r), i = 0; i < r; i++)
      o[i] = arguments[i];
    var a = o.filter(function(s) {
      return s !== VR;
    }).length;
    return a >= t ? n.apply(void 0, o) : e(t - a, GS(function() {
      for (var s = arguments.length, l = new Array(s), c = 0; c < s; c++)
        l[c] = arguments[c];
      var u = o.map(function(f) {
        return BR(f) ? l.shift() : f;
      });
      return n.apply(void 0, xce(u).concat(l));
    }));
  });
}, x0 = function(t) {
  return Ace(t.length, t);
}, Lf = function(t, n) {
  for (var r = [], o = t; o < n; ++o)
    r[o - t] = o;
  return r;
}, Pce = x0(function(e, t) {
  return Array.isArray(t) ? t.map(e) : Object.keys(t).map(function(n) {
    return t[n];
  }).map(e);
}), Tce = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  if (!n.length)
    return Oce;
  var o = n.reverse(), i = o[0], a = o.slice(1);
  return function() {
    return a.reduce(function(s, l) {
      return l(s);
    }, i.apply(void 0, arguments));
  };
}, Nf = function(t) {
  return Array.isArray(t) ? t.reverse() : t.split("").reverse.join("");
}, $R = function(t) {
  var n = null, r = null;
  return function() {
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return n && i.every(function(s, l) {
      return s === n[l];
    }) || (n = i, r = t.apply(void 0, i)), r;
  };
};
function Ice(e) {
  var t;
  return e === 0 ? t = 1 : t = Math.floor(new mt(e).abs().log(10).toNumber()) + 1, t;
}
function Dce(e, t, n) {
  for (var r = new mt(e), o = 0, i = []; r.lt(t) && o < 1e5; )
    i.push(r.toNumber()), r = r.add(n), o++;
  return i;
}
var Rce = x0(function(e, t, n) {
  var r = +e, o = +t;
  return r + n * (o - r);
}), kce = x0(function(e, t, n) {
  var r = t - +e;
  return r = r || 1 / 0, (n - e) / r;
}), Lce = x0(function(e, t, n) {
  var r = t - +e;
  return r = r || 1 / 0, Math.max(0, Math.min(1, (n - e) / r));
});
const S0 = {
  rangeStep: Dce,
  getDigitCount: Ice,
  interpolateNumber: Rce,
  uninterpolateNumber: kce,
  uninterpolateTruncation: Lce
};
function Ff(e) {
  return Vce(e) || Fce(e) || jR(e) || Nce();
}
function Nce() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Fce(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e)) return Array.from(e);
}
function Vce(e) {
  if (Array.isArray(e)) return Vf(e);
}
function t2(e, t) {
  return jce(e) || $ce(e, t) || jR(e, t) || Bce();
}
function Bce() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function jR(e, t) {
  if (e) {
    if (typeof e == "string") return Vf(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Vf(e, t);
  }
}
function Vf(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function $ce(e, t) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(e)))) {
    var n = [], r = !0, o = !1, i = void 0;
    try {
      for (var a = e[Symbol.iterator](), s; !(r = (s = a.next()).done) && (n.push(s.value), !(t && n.length === t)); r = !0)
        ;
    } catch (l) {
      o = !0, i = l;
    } finally {
      try {
        !r && a.return != null && a.return();
      } finally {
        if (o) throw i;
      }
    }
    return n;
  }
}
function jce(e) {
  if (Array.isArray(e)) return e;
}
function HR(e) {
  var t = t2(e, 2), n = t[0], r = t[1], o = n, i = r;
  return n > r && (o = r, i = n), [o, i];
}
function zR(e, t, n) {
  if (e.lte(0))
    return new mt(0);
  var r = S0.getDigitCount(e.toNumber()), o = new mt(10).pow(r), i = e.div(o), a = r !== 1 ? 0.05 : 0.1, s = new mt(Math.ceil(i.div(a).toNumber())).add(n).mul(a), l = s.mul(o);
  return t ? l : new mt(Math.ceil(l));
}
function Hce(e, t, n) {
  var r = 1, o = new mt(e);
  if (!o.isint() && n) {
    var i = Math.abs(e);
    i < 1 ? (r = new mt(10).pow(S0.getDigitCount(e) - 1), o = new mt(Math.floor(o.div(r).toNumber())).mul(r)) : i > 1 && (o = new mt(Math.floor(e)));
  } else e === 0 ? o = new mt(Math.floor((t - 1) / 2)) : n || (o = new mt(Math.floor(e)));
  var a = Math.floor((t - 1) / 2), s = Tce(Pce(function(l) {
    return o.add(new mt(l - a).mul(r)).toNumber();
  }), Lf);
  return s(0, t);
}
function ZR(e, t, n, r) {
  var o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
  if (!Number.isFinite((t - e) / (n - 1)))
    return {
      step: new mt(0),
      tickMin: new mt(0),
      tickMax: new mt(0)
    };
  var i = zR(new mt(t).sub(e).div(n - 1), r, o), a;
  e <= 0 && t >= 0 ? a = new mt(0) : (a = new mt(e).add(t).div(2), a = a.sub(new mt(a).mod(i)));
  var s = Math.ceil(a.sub(e).div(i).toNumber()), l = Math.ceil(new mt(t).sub(a).div(i).toNumber()), c = s + l + 1;
  return c > n ? ZR(e, t, n, r, o + 1) : (c < n && (l = t > 0 ? l + (n - c) : l, s = t > 0 ? s : s + (n - c)), {
    step: i,
    tickMin: a.sub(new mt(s).mul(i)),
    tickMax: a.add(new mt(l).mul(i))
  });
}
function zce(e) {
  var t = t2(e, 2), n = t[0], r = t[1], o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, a = Math.max(o, 2), s = HR([n, r]), l = t2(s, 2), c = l[0], u = l[1];
  if (c === -1 / 0 || u === 1 / 0) {
    var f = u === 1 / 0 ? [c].concat(Ff(Lf(0, o - 1).map(function() {
      return 1 / 0;
    }))) : [].concat(Ff(Lf(0, o - 1).map(function() {
      return -1 / 0;
    })), [u]);
    return n > r ? Nf(f) : f;
  }
  if (c === u)
    return Hce(c, o, i);
  var h = ZR(c, u, a, i), p = h.step, C = h.tickMin, m = h.tickMax, g = S0.rangeStep(C, m.add(new mt(0.1).mul(p)), p);
  return n > r ? Nf(g) : g;
}
function Zce(e, t) {
  var n = t2(e, 2), r = n[0], o = n[1], i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, a = HR([r, o]), s = t2(a, 2), l = s[0], c = s[1];
  if (l === -1 / 0 || c === 1 / 0)
    return [r, o];
  if (l === c)
    return [l];
  var u = Math.max(t, 2), f = zR(new mt(c).sub(l).div(u - 1), i, 0), h = [].concat(Ff(S0.rangeStep(new mt(l), new mt(c).sub(new mt(0.99).mul(f)), f)), [c]);
  return r > o ? Nf(h) : h;
}
var Wce = $R(zce), qce = $R(Zce), Uce = process.env.NODE_ENV === "production", k4 = "Invariant failed";
function Gn(e, t) {
  if (Uce)
    throw new Error(k4);
  var n = typeof t == "function" ? t() : t, r = n ? "".concat(k4, ": ").concat(n) : k4;
  throw new Error(r);
}
var Gce = ["offset", "layout", "width", "dataKey", "data", "dataPointFormatter", "xAxis", "yAxis"];
function Ka(e) {
  "@babel/helpers - typeof";
  return Ka = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ka(e);
}
function H5() {
  return H5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, H5.apply(this, arguments);
}
function Kce(e, t) {
  return Jce(e) || Qce(e, t) || Xce(e, t) || Yce();
}
function Yce() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Xce(e, t) {
  if (e) {
    if (typeof e == "string") return KS(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return KS(e, t);
  }
}
function KS(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Qce(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, o, i, a, s = [], l = !0, c = !1;
    try {
      if (i = (n = n.call(e)).next, t !== 0) for (; !(l = (r = i.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (u) {
      c = !0, o = u;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw o;
      }
    }
    return s;
  }
}
function Jce(e) {
  if (Array.isArray(e)) return e;
}
function e5e(e, t) {
  if (e == null) return {};
  var n = t5e(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function t5e(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function n5e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function r5e(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, UR(r.key), r);
  }
}
function o5e(e, t, n) {
  return t && r5e(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function i5e(e, t, n) {
  return t = z5(t), a5e(e, WR() ? Reflect.construct(t, n || [], z5(e).constructor) : t.apply(e, n));
}
function a5e(e, t) {
  if (t && (Ka(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return s5e(e);
}
function s5e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function WR() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (WR = function() {
    return !!e;
  })();
}
function z5(e) {
  return z5 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, z5(e);
}
function l5e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Bf(e, t);
}
function Bf(e, t) {
  return Bf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, Bf(e, t);
}
function qR(e, t, n) {
  return t = UR(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function UR(e) {
  var t = c5e(e, "string");
  return Ka(t) == "symbol" ? t : t + "";
}
function c5e(e, t) {
  if (Ka(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Ka(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Ts = /* @__PURE__ */ (function(e) {
  function t() {
    return n5e(this, t), i5e(this, t, arguments);
  }
  return l5e(t, e), o5e(t, [{
    key: "render",
    value: function() {
      var r = this.props, o = r.offset, i = r.layout, a = r.width, s = r.dataKey, l = r.data, c = r.dataPointFormatter, u = r.xAxis, f = r.yAxis, h = e5e(r, Gce), p = Be(h, !1);
      this.props.direction === "x" && u.type !== "number" && (process.env.NODE_ENV !== "production" ? Gn(!1, 'ErrorBar requires Axis type property to be "number".') : Gn());
      var C = l.map(function(m) {
        var g = c(m, s), v = g.x, y = g.y, w = g.value, x = g.errorVal;
        if (!x)
          return null;
        var b = [], S, M;
        if (Array.isArray(x)) {
          var E = Kce(x, 2);
          S = E[0], M = E[1];
        } else
          S = M = x;
        if (i === "vertical") {
          var P = u.scale, T = y + o, _ = T + a, D = T - a, N = P(w - S), R = P(w + M);
          b.push({
            x1: R,
            y1: _,
            x2: R,
            y2: D
          }), b.push({
            x1: N,
            y1: T,
            x2: R,
            y2: T
          }), b.push({
            x1: N,
            y1: _,
            x2: N,
            y2: D
          });
        } else if (i === "horizontal") {
          var L = f.scale, B = v + o, V = B - a, k = B + a, z = L(w - S), $ = L(w + M);
          b.push({
            x1: V,
            y1: $,
            x2: k,
            y2: $
          }), b.push({
            x1: B,
            y1: z,
            x2: B,
            y2: $
          }), b.push({
            x1: V,
            y1: z,
            x2: k,
            y2: z
          });
        }
        return /* @__PURE__ */ O.createElement(rt, H5({
          className: "recharts-errorBar",
          key: "bar-".concat(b.map(function(Z) {
            return "".concat(Z.x1, "-").concat(Z.x2, "-").concat(Z.y1, "-").concat(Z.y2);
          }))
        }, p), b.map(function(Z) {
          return /* @__PURE__ */ O.createElement("line", H5({}, Z, {
            key: "line-".concat(Z.x1, "-").concat(Z.x2, "-").concat(Z.y1, "-").concat(Z.y2)
          }));
        }));
      });
      return /* @__PURE__ */ O.createElement(rt, {
        className: "recharts-errorBars"
      }, C);
    }
  }]);
})(O.Component);
qR(Ts, "defaultProps", {
  stroke: "black",
  strokeWidth: 1.5,
  width: 5,
  offset: 0,
  layout: "horizontal"
});
qR(Ts, "displayName", "ErrorBar");
function n2(e) {
  "@babel/helpers - typeof";
  return n2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, n2(e);
}
function YS(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function U1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? YS(Object(n), !0).forEach(function(r) {
      u5e(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : YS(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function u5e(e, t, n) {
  return t = f5e(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function f5e(e) {
  var t = d5e(e, "string");
  return n2(t) == "symbol" ? t : t + "";
}
function d5e(e, t) {
  if (n2(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (n2(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var GR = function(t) {
  var n = t.children, r = t.formattedGraphicalItems, o = t.legendWidth, i = t.legendContent, a = nr(n, hi);
  if (!a)
    return null;
  var s = hi.defaultProps, l = s !== void 0 ? U1(U1({}, s), a.props) : {}, c;
  return a.props && a.props.payload ? c = a.props && a.props.payload : i === "children" ? c = (r || []).reduce(function(u, f) {
    var h = f.item, p = f.props, C = p.sectors || p.data || [];
    return u.concat(C.map(function(m) {
      return {
        type: a.props.iconType || h.props.legendType,
        value: m.name,
        color: m.fill,
        payload: m
      };
    }));
  }, []) : c = (r || []).map(function(u) {
    var f = u.item, h = f.type.defaultProps, p = h !== void 0 ? U1(U1({}, h), f.props) : {}, C = p.dataKey, m = p.name, g = p.legendType, v = p.hide;
    return {
      inactive: v,
      dataKey: C,
      type: l.iconType || g || "square",
      color: nm(f),
      value: m || C,
      // @ts-expect-error property strokeDasharray is required in Payload but optional in props
      payload: p
    };
  }), U1(U1(U1({}, l), hi.getWithHeight(a, o)), {}, {
    payload: c,
    item: a
  });
};
function r2(e) {
  "@babel/helpers - typeof";
  return r2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, r2(e);
}
function XS(e) {
  return g5e(e) || m5e(e) || p5e(e) || h5e();
}
function h5e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function p5e(e, t) {
  if (e) {
    if (typeof e == "string") return $f(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f(e, t);
  }
}
function m5e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function g5e(e) {
  if (Array.isArray(e)) return $f(e);
}
function $f(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function QS(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Bt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? QS(Object(n), !0).forEach(function(r) {
      Da(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : QS(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Da(e, t, n) {
  return t = C5e(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function C5e(e) {
  var t = v5e(e, "string");
  return r2(t) == "symbol" ? t : t + "";
}
function v5e(e, t) {
  if (r2(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (r2(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function cn(e, t, n) {
  return Ne(e) || Ne(t) ? n : ln(t) ? Sr(e, t, n) : je(t) ? t(e) : n;
}
function xl(e, t, n, r) {
  var o = gce(e, function(s) {
    return cn(s, t);
  });
  if (n === "number") {
    var i = o.filter(function(s) {
      return he(s) || parseFloat(s);
    });
    return i.length ? [w0(i), v1(i)] : [1 / 0, -1 / 0];
  }
  var a = r ? o.filter(function(s) {
    return !Ne(s);
  }) : o;
  return a.map(function(s) {
    return ln(s) || s instanceof Date ? s : "";
  });
}
var y5e = function(t) {
  var n, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], o = arguments.length > 2 ? arguments[2] : void 0, i = arguments.length > 3 ? arguments[3] : void 0, a = -1, s = (n = r?.length) !== null && n !== void 0 ? n : 0;
  if (s <= 1)
    return 0;
  if (i && i.axisType === "angleAxis" && Math.abs(Math.abs(i.range[1] - i.range[0]) - 360) <= 1e-6)
    for (var l = i.range, c = 0; c < s; c++) {
      var u = c > 0 ? o[c - 1].coordinate : o[s - 1].coordinate, f = o[c].coordinate, h = c >= s - 1 ? o[0].coordinate : o[c + 1].coordinate, p = void 0;
      if (jr(f - u) !== jr(h - f)) {
        var C = [];
        if (jr(h - f) === jr(l[1] - l[0])) {
          p = h;
          var m = f + l[1] - l[0];
          C[0] = Math.min(m, (m + u) / 2), C[1] = Math.max(m, (m + u) / 2);
        } else {
          p = u;
          var g = h + l[1] - l[0];
          C[0] = Math.min(f, (g + f) / 2), C[1] = Math.max(f, (g + f) / 2);
        }
        var v = [Math.min(f, (p + f) / 2), Math.max(f, (p + f) / 2)];
        if (t > v[0] && t <= v[1] || t >= C[0] && t <= C[1]) {
          a = o[c].index;
          break;
        }
      } else {
        var y = Math.min(u, h), w = Math.max(u, h);
        if (t > (y + f) / 2 && t <= (w + f) / 2) {
          a = o[c].index;
          break;
        }
      }
    }
  else
    for (var x = 0; x < s; x++)
      if (x === 0 && t <= (r[x].coordinate + r[x + 1].coordinate) / 2 || x > 0 && x < s - 1 && t > (r[x].coordinate + r[x - 1].coordinate) / 2 && t <= (r[x].coordinate + r[x + 1].coordinate) / 2 || x === s - 1 && t > (r[x].coordinate + r[x - 1].coordinate) / 2) {
        a = r[x].index;
        break;
      }
  return a;
}, nm = function(t) {
  var n, r = t, o = r.type.displayName, i = (n = t.type) !== null && n !== void 0 && n.defaultProps ? Bt(Bt({}, t.type.defaultProps), t.props) : t.props, a = i.stroke, s = i.fill, l;
  switch (o) {
    case "Line":
      l = a;
      break;
    case "Area":
    case "Radar":
      l = a && a !== "none" ? a : s;
      break;
    default:
      l = s;
      break;
  }
  return l;
}, b5e = function(t) {
  var n = t.barSize, r = t.totalSize, o = t.stackGroups, i = o === void 0 ? {} : o;
  if (!i)
    return {};
  for (var a = {}, s = Object.keys(i), l = 0, c = s.length; l < c; l++)
    for (var u = i[s[l]].stackGroups, f = Object.keys(u), h = 0, p = f.length; h < p; h++) {
      var C = u[f[h]], m = C.items, g = C.cateAxisId, v = m.filter(function(M) {
        return Zo(M.type).indexOf("Bar") >= 0;
      });
      if (v && v.length) {
        var y = v[0].type.defaultProps, w = y !== void 0 ? Bt(Bt({}, y), v[0].props) : v[0].props, x = w.barSize, b = w[g];
        a[b] || (a[b] = []);
        var S = Ne(x) ? n : x;
        a[b].push({
          item: v[0],
          stackList: v.slice(1),
          barSize: Ne(S) ? void 0 : _i(S, r, 0)
        });
      }
    }
  return a;
}, w5e = function(t) {
  var n = t.barGap, r = t.barCategoryGap, o = t.bandSize, i = t.sizeList, a = i === void 0 ? [] : i, s = t.maxBarSize, l = a.length;
  if (l < 1) return null;
  var c = _i(n, o, 0, !0), u, f = [];
  if (a[0].barSize === +a[0].barSize) {
    var h = !1, p = o / l, C = a.reduce(function(x, b) {
      return x + b.barSize || 0;
    }, 0);
    C += (l - 1) * c, C >= o && (C -= (l - 1) * c, c = 0), C >= o && p > 0 && (h = !0, p *= 0.9, C = l * p);
    var m = (o - C) / 2 >> 0, g = {
      offset: m - c,
      size: 0
    };
    u = a.reduce(function(x, b) {
      var S = {
        item: b.item,
        position: {
          offset: g.offset + g.size + c,
          // @ts-expect-error the type check above does not check for type number explicitly
          size: h ? p : b.barSize
        }
      }, M = [].concat(XS(x), [S]);
      return g = M[M.length - 1].position, b.stackList && b.stackList.length && b.stackList.forEach(function(E) {
        M.push({
          item: E,
          position: g
        });
      }), M;
    }, f);
  } else {
    var v = _i(r, o, 0, !0);
    o - 2 * v - (l - 1) * c <= 0 && (c = 0);
    var y = (o - 2 * v - (l - 1) * c) / l;
    y > 1 && (y >>= 0);
    var w = s === +s ? Math.min(y, s) : y;
    u = a.reduce(function(x, b, S) {
      var M = [].concat(XS(x), [{
        item: b.item,
        position: {
          offset: v + (y + c) * S + (y - w) / 2,
          size: w
        }
      }]);
      return b.stackList && b.stackList.length && b.stackList.forEach(function(E) {
        M.push({
          item: E,
          position: M[M.length - 1].position
        });
      }), M;
    }, f);
  }
  return u;
}, x5e = function(t, n, r, o) {
  var i = r.children, a = r.width, s = r.margin, l = a - (s.left || 0) - (s.right || 0), c = GR({
    children: i,
    legendWidth: l
  });
  if (c) {
    var u = o || {}, f = u.width, h = u.height, p = c.align, C = c.verticalAlign, m = c.layout;
    if ((m === "vertical" || m === "horizontal" && C === "middle") && p !== "center" && he(t[p]))
      return Bt(Bt({}, t), {}, Da({}, p, t[p] + (f || 0)));
    if ((m === "horizontal" || m === "vertical" && p === "center") && C !== "middle" && he(t[C]))
      return Bt(Bt({}, t), {}, Da({}, C, t[C] + (h || 0)));
  }
  return t;
}, S5e = function(t, n, r) {
  return Ne(n) ? !0 : t === "horizontal" ? n === "yAxis" : t === "vertical" || r === "x" ? n === "xAxis" : r === "y" ? n === "yAxis" : !0;
}, KR = function(t, n, r, o, i) {
  var a = n.props.children, s = Yn(a, Ts).filter(function(c) {
    return S5e(o, i, c.props.direction);
  });
  if (s && s.length) {
    var l = s.map(function(c) {
      return c.props.dataKey;
    });
    return t.reduce(function(c, u) {
      var f = cn(u, r);
      if (Ne(f)) return c;
      var h = Array.isArray(f) ? [w0(f), v1(f)] : [f, f], p = l.reduce(function(C, m) {
        var g = cn(u, m, 0), v = h[0] - Math.abs(Array.isArray(g) ? g[0] : g), y = h[1] + Math.abs(Array.isArray(g) ? g[1] : g);
        return [Math.min(v, C[0]), Math.max(y, C[1])];
      }, [1 / 0, -1 / 0]);
      return [Math.min(p[0], c[0]), Math.max(p[1], c[1])];
    }, [1 / 0, -1 / 0]);
  }
  return null;
}, M5e = function(t, n, r, o, i) {
  var a = n.map(function(s) {
    return KR(t, s, r, i, o);
  }).filter(function(s) {
    return !Ne(s);
  });
  return a && a.length ? a.reduce(function(s, l) {
    return [Math.min(s[0], l[0]), Math.max(s[1], l[1])];
  }, [1 / 0, -1 / 0]) : null;
}, YR = function(t, n, r, o, i) {
  var a = n.map(function(l) {
    var c = l.props.dataKey;
    return r === "number" && c && KR(t, l, c, o) || xl(t, c, r, i);
  });
  if (r === "number")
    return a.reduce(
      // @ts-expect-error if (type === number) means that the domain is numerical type
      // - but this link is missing in the type definition
      function(l, c) {
        return [Math.min(l[0], c[0]), Math.max(l[1], c[1])];
      },
      [1 / 0, -1 / 0]
    );
  var s = {};
  return a.reduce(function(l, c) {
    for (var u = 0, f = c.length; u < f; u++)
      s[c[u]] || (s[c[u]] = !0, l.push(c[u]));
    return l;
  }, []);
}, XR = function(t, n) {
  return t === "horizontal" && n === "xAxis" || t === "vertical" && n === "yAxis" || t === "centric" && n === "angleAxis" || t === "radial" && n === "radiusAxis";
}, QR = function(t, n, r, o) {
  if (o)
    return t.map(function(l) {
      return l.coordinate;
    });
  var i, a, s = t.map(function(l) {
    return l.coordinate === n && (i = !0), l.coordinate === r && (a = !0), l.coordinate;
  });
  return i || s.push(n), a || s.push(r), s;
}, Ho = function(t, n, r) {
  if (!t) return null;
  var o = t.scale, i = t.duplicateDomain, a = t.type, s = t.range, l = t.realScaleType === "scaleBand" ? o.bandwidth() / 2 : 2, c = (n || r) && a === "category" && o.bandwidth ? o.bandwidth() / l : 0;
  if (c = t.axisType === "angleAxis" && s?.length >= 2 ? jr(s[0] - s[1]) * 2 * c : c, n && (t.ticks || t.niceTicks)) {
    var u = (t.ticks || t.niceTicks).map(function(f) {
      var h = i ? i.indexOf(f) : f;
      return {
        // If the scaleContent is not a number, the coordinate will be NaN.
        // That could be the case for example with a PointScale and a string as domain.
        coordinate: o(h) + c,
        value: f,
        offset: c
      };
    });
    return u.filter(function(f) {
      return !Es(f.coordinate);
    });
  }
  return t.isCategorical && t.categoricalDomain ? t.categoricalDomain.map(function(f, h) {
    return {
      coordinate: o(f) + c,
      value: f,
      index: h,
      offset: c
    };
  }) : o.ticks && !r ? o.ticks(t.tickCount).map(function(f) {
    return {
      coordinate: o(f) + c,
      value: f,
      offset: c
    };
  }) : o.domain().map(function(f, h) {
    return {
      coordinate: o(f) + c,
      value: i ? i[f] : f,
      index: h,
      offset: c
    };
  });
}, L4 = /* @__PURE__ */ new WeakMap(), Ic = function(t, n) {
  if (typeof n != "function")
    return t;
  L4.has(t) || L4.set(t, /* @__PURE__ */ new WeakMap());
  var r = L4.get(t);
  if (r.has(n))
    return r.get(n);
  var o = function() {
    t.apply(void 0, arguments), n.apply(void 0, arguments);
  };
  return r.set(n, o), o;
}, E5e = function(t, n, r) {
  var o = t.scale, i = t.type, a = t.layout, s = t.axisType;
  if (o === "auto")
    return a === "radial" && s === "radiusAxis" ? {
      scale: Kl(),
      realScaleType: "band"
    } : a === "radial" && s === "angleAxis" ? {
      scale: F5(),
      realScaleType: "linear"
    } : i === "category" && n && (n.indexOf("LineChart") >= 0 || n.indexOf("AreaChart") >= 0 || n.indexOf("ComposedChart") >= 0 && !r) ? {
      scale: wl(),
      realScaleType: "point"
    } : i === "category" ? {
      scale: Kl(),
      realScaleType: "band"
    } : {
      scale: F5(),
      realScaleType: "linear"
    };
  if (Ei(o)) {
    var l = "scale".concat(s0(o));
    return {
      scale: (FS[l] || wl)(),
      realScaleType: FS[l] ? l : "point"
    };
  }
  return je(o) ? {
    scale: o
  } : {
    scale: wl(),
    realScaleType: "point"
  };
}, JS = 1e-4, _5e = function(t) {
  var n = t.domain();
  if (!(!n || n.length <= 2)) {
    var r = n.length, o = t.range(), i = Math.min(o[0], o[1]) - JS, a = Math.max(o[0], o[1]) + JS, s = t(n[0]), l = t(n[r - 1]);
    (s < i || s > a || l < i || l > a) && t.domain([n[0], n[r - 1]]);
  }
}, O5e = function(t, n) {
  if (!t)
    return null;
  for (var r = 0, o = t.length; r < o; r++)
    if (t[r].item === n)
      return t[r].position;
  return null;
}, A5e = function(t, n) {
  if (!n || n.length !== 2 || !he(n[0]) || !he(n[1]))
    return t;
  var r = Math.min(n[0], n[1]), o = Math.max(n[0], n[1]), i = [t[0], t[1]];
  return (!he(t[0]) || t[0] < r) && (i[0] = r), (!he(t[1]) || t[1] > o) && (i[1] = o), i[0] > o && (i[0] = o), i[1] < r && (i[1] = r), i;
}, P5e = function(t) {
  var n = t.length;
  if (!(n <= 0))
    for (var r = 0, o = t[0].length; r < o; ++r)
      for (var i = 0, a = 0, s = 0; s < n; ++s) {
        var l = Es(t[s][r][1]) ? t[s][r][0] : t[s][r][1];
        l >= 0 ? (t[s][r][0] = i, t[s][r][1] = i + l, i = t[s][r][1]) : (t[s][r][0] = a, t[s][r][1] = a + l, a = t[s][r][1]);
      }
}, T5e = function(t) {
  var n = t.length;
  if (!(n <= 0))
    for (var r = 0, o = t[0].length; r < o; ++r)
      for (var i = 0, a = 0; a < n; ++a) {
        var s = Es(t[a][r][1]) ? t[a][r][0] : t[a][r][1];
        s >= 0 ? (t[a][r][0] = i, t[a][r][1] = i + s, i = t[a][r][1]) : (t[a][r][0] = 0, t[a][r][1] = 0);
      }
}, I5e = {
  sign: P5e,
  // @ts-expect-error definitelytyped types are incorrect
  expand: h1e,
  // @ts-expect-error definitelytyped types are incorrect
  none: ja,
  // @ts-expect-error definitelytyped types are incorrect
  silhouette: p1e,
  // @ts-expect-error definitelytyped types are incorrect
  wiggle: m1e,
  positive: T5e
}, D5e = function(t, n, r) {
  var o = n.map(function(s) {
    return s.props.dataKey;
  }), i = I5e[r], a = d1e().keys(o).value(function(s, l) {
    return +cn(s, l, 0);
  }).order(gf).offset(i);
  return a(t);
}, R5e = function(t, n, r, o, i, a) {
  if (!t)
    return null;
  var s = a ? n.reverse() : n, l = {}, c = s.reduce(function(f, h) {
    var p, C = (p = h.type) !== null && p !== void 0 && p.defaultProps ? Bt(Bt({}, h.type.defaultProps), h.props) : h.props, m = C.stackId, g = C.hide;
    if (g)
      return f;
    var v = C[r], y = f[v] || {
      hasStack: !1,
      stackGroups: {}
    };
    if (ln(m)) {
      var w = y.stackGroups[m] || {
        numericAxisId: r,
        cateAxisId: o,
        items: []
      };
      w.items.push(h), y.hasStack = !0, y.stackGroups[m] = w;
    } else
      y.stackGroups[Bi("_stackId_")] = {
        numericAxisId: r,
        cateAxisId: o,
        items: [h]
      };
    return Bt(Bt({}, f), {}, Da({}, v, y));
  }, l), u = {};
  return Object.keys(c).reduce(function(f, h) {
    var p = c[h];
    if (p.hasStack) {
      var C = {};
      p.stackGroups = Object.keys(p.stackGroups).reduce(function(m, g) {
        var v = p.stackGroups[g];
        return Bt(Bt({}, m), {}, Da({}, g, {
          numericAxisId: r,
          cateAxisId: o,
          items: v.items,
          stackedData: D5e(t, v.items, i)
        }));
      }, C);
    }
    return Bt(Bt({}, f), {}, Da({}, h, p));
  }, u);
}, k5e = function(t, n) {
  var r = n.realScaleType, o = n.type, i = n.tickCount, a = n.originalDomain, s = n.allowDecimals, l = r || n.scale;
  if (l !== "auto" && l !== "linear")
    return null;
  if (i && o === "number" && a && (a[0] === "auto" || a[1] === "auto")) {
    var c = t.domain();
    if (!c.length)
      return null;
    var u = Wce(c, i, s);
    return t.domain([w0(u), v1(u)]), {
      niceTicks: u
    };
  }
  if (i && o === "number") {
    var f = t.domain(), h = qce(f, i, s);
    return {
      niceTicks: h
    };
  }
  return null;
};
function Ya(e) {
  var t = e.axis, n = e.ticks, r = e.bandSize, o = e.entry, i = e.index, a = e.dataKey;
  if (t.type === "category") {
    if (!t.allowDuplicatedCategory && t.dataKey && !Ne(o[t.dataKey])) {
      var s = v5(n, "value", o[t.dataKey]);
      if (s)
        return s.coordinate + r / 2;
    }
    return n[i] ? n[i].coordinate + r / 2 : null;
  }
  var l = cn(o, Ne(a) ? t.dataKey : a);
  return Ne(l) ? null : t.scale(l);
}
var eM = function(t) {
  var n = t.axis, r = t.ticks, o = t.offset, i = t.bandSize, a = t.entry, s = t.index;
  if (n.type === "category")
    return r[s] ? r[s].coordinate + o : null;
  var l = cn(a, n.dataKey, n.domain[s]);
  return Ne(l) ? null : n.scale(l) - i / 2 + o;
}, L5e = function(t) {
  var n = t.numericAxis, r = n.scale.domain();
  if (n.type === "number") {
    var o = Math.min(r[0], r[1]), i = Math.max(r[0], r[1]);
    return o <= 0 && i >= 0 ? 0 : i < 0 ? i : o;
  }
  return r[0];
}, N5e = function(t, n) {
  var r, o = (r = t.type) !== null && r !== void 0 && r.defaultProps ? Bt(Bt({}, t.type.defaultProps), t.props) : t.props, i = o.stackId;
  if (ln(i)) {
    var a = n[i];
    if (a) {
      var s = a.items.indexOf(t);
      return s >= 0 ? a.stackedData[s] : null;
    }
  }
  return null;
}, F5e = function(t) {
  return t.reduce(function(n, r) {
    return [w0(r.concat([n[0]]).filter(he)), v1(r.concat([n[1]]).filter(he))];
  }, [1 / 0, -1 / 0]);
}, JR = function(t, n, r) {
  return Object.keys(t).reduce(function(o, i) {
    var a = t[i], s = a.stackedData, l = s.reduce(function(c, u) {
      var f = F5e(u.slice(n, r + 1));
      return [Math.min(c[0], f[0]), Math.max(c[1], f[1])];
    }, [1 / 0, -1 / 0]);
    return [Math.min(l[0], o[0]), Math.max(l[1], o[1])];
  }, [1 / 0, -1 / 0]).map(function(o) {
    return o === 1 / 0 || o === -1 / 0 ? 0 : o;
  });
}, tM = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, nM = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, jf = function(t, n, r) {
  if (je(t))
    return t(n, r);
  if (!Array.isArray(t))
    return n;
  var o = [];
  if (he(t[0]))
    o[0] = r ? t[0] : Math.min(t[0], n[0]);
  else if (tM.test(t[0])) {
    var i = +tM.exec(t[0])[1];
    o[0] = n[0] - i;
  } else je(t[0]) ? o[0] = t[0](n[0]) : o[0] = n[0];
  if (he(t[1]))
    o[1] = r ? t[1] : Math.max(t[1], n[1]);
  else if (nM.test(t[1])) {
    var a = +nM.exec(t[1])[1];
    o[1] = n[1] + a;
  } else je(t[1]) ? o[1] = t[1](n[1]) : o[1] = n[1];
  return o;
}, Z5 = function(t, n, r) {
  if (t && t.scale && t.scale.bandwidth) {
    var o = t.scale.bandwidth();
    if (!r || o > 0)
      return o;
  }
  if (t && n && n.length >= 2) {
    for (var i = Pp(n, function(f) {
      return f.coordinate;
    }), a = 1 / 0, s = 1, l = i.length; s < l; s++) {
      var c = i[s], u = i[s - 1];
      a = Math.min((c.coordinate || 0) - (u.coordinate || 0), a);
    }
    return a === 1 / 0 ? 0 : a;
  }
  return r ? void 0 : 0;
}, rM = function(t, n, r) {
  return !t || !t.length || Oi(t, Sr(r, "type.defaultProps.domain")) ? n : t;
}, ek = function(t, n) {
  var r = t.type.defaultProps ? Bt(Bt({}, t.type.defaultProps), t.props) : t.props, o = r.dataKey, i = r.name, a = r.unit, s = r.formatter, l = r.tooltipType, c = r.chartType, u = r.hide;
  return Bt(Bt({}, Be(t, !1)), {}, {
    dataKey: o,
    unit: a,
    formatter: s,
    name: i || o,
    color: nm(t),
    value: cn(n, o),
    type: l,
    payload: n,
    chartType: c,
    hide: u
  });
};
function o2(e) {
  "@babel/helpers - typeof";
  return o2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, o2(e);
}
function oM(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function iM(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? oM(Object(n), !0).forEach(function(r) {
      V5e(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : oM(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function V5e(e, t, n) {
  return t = B5e(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function B5e(e) {
  var t = $5e(e, "string");
  return o2(t) == "symbol" ? t : t + "";
}
function $5e(e, t) {
  if (o2(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (o2(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var W5 = Math.PI / 180, j5e = function(t) {
  return t * 180 / Math.PI;
}, wn = function(t, n, r, o) {
  return {
    x: t + Math.cos(-W5 * o) * r,
    y: n + Math.sin(-W5 * o) * r
  };
}, H5e = function(t, n) {
  var r = t.x, o = t.y, i = n.x, a = n.y;
  return Math.sqrt(Math.pow(r - i, 2) + Math.pow(o - a, 2));
}, z5e = function(t, n) {
  var r = t.x, o = t.y, i = n.cx, a = n.cy, s = H5e({
    x: r,
    y: o
  }, {
    x: i,
    y: a
  });
  if (s <= 0)
    return {
      radius: s
    };
  var l = (r - i) / s, c = Math.acos(l);
  return o > a && (c = 2 * Math.PI - c), {
    radius: s,
    angle: j5e(c),
    angleInRadian: c
  };
}, Z5e = function(t) {
  var n = t.startAngle, r = t.endAngle, o = Math.floor(n / 360), i = Math.floor(r / 360), a = Math.min(o, i);
  return {
    startAngle: n - a * 360,
    endAngle: r - a * 360
  };
}, W5e = function(t, n) {
  var r = n.startAngle, o = n.endAngle, i = Math.floor(r / 360), a = Math.floor(o / 360), s = Math.min(i, a);
  return t + s * 360;
}, aM = function(t, n) {
  var r = t.x, o = t.y, i = z5e({
    x: r,
    y: o
  }, n), a = i.radius, s = i.angle, l = n.innerRadius, c = n.outerRadius;
  if (a < l || a > c)
    return !1;
  if (a === 0)
    return !0;
  var u = Z5e(n), f = u.startAngle, h = u.endAngle, p = s, C;
  if (f <= h) {
    for (; p > h; )
      p -= 360;
    for (; p < f; )
      p += 360;
    C = p >= f && p <= h;
  } else {
    for (; p > f; )
      p -= 360;
    for (; p < h; )
      p += 360;
    C = p >= h && p <= f;
  }
  return C ? iM(iM({}, n), {}, {
    radius: a,
    angle: W5e(p, n)
  }) : null;
};
function i2(e) {
  "@babel/helpers - typeof";
  return i2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, i2(e);
}
var q5e = ["offset"];
function U5e(e) {
  return X5e(e) || Y5e(e) || K5e(e) || G5e();
}
function G5e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function K5e(e, t) {
  if (e) {
    if (typeof e == "string") return Hf(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Hf(e, t);
  }
}
function Y5e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function X5e(e) {
  if (Array.isArray(e)) return Hf(e);
}
function Hf(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Q5e(e, t) {
  if (e == null) return {};
  var n = J5e(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function J5e(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function sM(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function sn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? sM(Object(n), !0).forEach(function(r) {
      eue(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : sM(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function eue(e, t, n) {
  return t = tue(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function tue(e) {
  var t = nue(e, "string");
  return i2(t) == "symbol" ? t : t + "";
}
function nue(e, t) {
  if (i2(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (i2(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function a2() {
  return a2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, a2.apply(this, arguments);
}
var rue = function(t) {
  var n = t.value, r = t.formatter, o = Ne(t.children) ? n : t.children;
  return je(r) ? r(o) : o;
}, oue = function(t, n) {
  var r = jr(n - t), o = Math.min(Math.abs(n - t), 360);
  return r * o;
}, iue = function(t, n, r) {
  var o = t.position, i = t.viewBox, a = t.offset, s = t.className, l = i, c = l.cx, u = l.cy, f = l.innerRadius, h = l.outerRadius, p = l.startAngle, C = l.endAngle, m = l.clockWise, g = (f + h) / 2, v = oue(p, C), y = v >= 0 ? 1 : -1, w, x;
  o === "insideStart" ? (w = p + y * a, x = m) : o === "insideEnd" ? (w = C - y * a, x = !m) : o === "end" && (w = C + y * a, x = m), x = v <= 0 ? x : !x;
  var b = wn(c, u, g, w), S = wn(c, u, g, w + (x ? 1 : -1) * 359), M = "M".concat(b.x, ",").concat(b.y, `
    A`).concat(g, ",").concat(g, ",0,1,").concat(x ? 0 : 1, `,
    `).concat(S.x, ",").concat(S.y), E = Ne(t.id) ? Bi("recharts-radial-line-") : t.id;
  return /* @__PURE__ */ O.createElement("text", a2({}, r, {
    dominantBaseline: "central",
    className: We("recharts-radial-bar-label", s)
  }), /* @__PURE__ */ O.createElement("defs", null, /* @__PURE__ */ O.createElement("path", {
    id: E,
    d: M
  })), /* @__PURE__ */ O.createElement("textPath", {
    xlinkHref: "#".concat(E)
  }, n));
}, aue = function(t) {
  var n = t.viewBox, r = t.offset, o = t.position, i = n, a = i.cx, s = i.cy, l = i.innerRadius, c = i.outerRadius, u = i.startAngle, f = i.endAngle, h = (u + f) / 2;
  if (o === "outside") {
    var p = wn(a, s, c + r, h), C = p.x, m = p.y;
    return {
      x: C,
      y: m,
      textAnchor: C >= a ? "start" : "end",
      verticalAnchor: "middle"
    };
  }
  if (o === "center")
    return {
      x: a,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "middle"
    };
  if (o === "centerTop")
    return {
      x: a,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "start"
    };
  if (o === "centerBottom")
    return {
      x: a,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "end"
    };
  var g = (l + c) / 2, v = wn(a, s, g, h), y = v.x, w = v.y;
  return {
    x: y,
    y: w,
    textAnchor: "middle",
    verticalAnchor: "middle"
  };
}, sue = function(t) {
  var n = t.viewBox, r = t.parentViewBox, o = t.offset, i = t.position, a = n, s = a.x, l = a.y, c = a.width, u = a.height, f = u >= 0 ? 1 : -1, h = f * o, p = f > 0 ? "end" : "start", C = f > 0 ? "start" : "end", m = c >= 0 ? 1 : -1, g = m * o, v = m > 0 ? "end" : "start", y = m > 0 ? "start" : "end";
  if (i === "top") {
    var w = {
      x: s + c / 2,
      y: l - f * o,
      textAnchor: "middle",
      verticalAnchor: p
    };
    return sn(sn({}, w), r ? {
      height: Math.max(l - r.y, 0),
      width: c
    } : {});
  }
  if (i === "bottom") {
    var x = {
      x: s + c / 2,
      y: l + u + h,
      textAnchor: "middle",
      verticalAnchor: C
    };
    return sn(sn({}, x), r ? {
      height: Math.max(r.y + r.height - (l + u), 0),
      width: c
    } : {});
  }
  if (i === "left") {
    var b = {
      x: s - g,
      y: l + u / 2,
      textAnchor: v,
      verticalAnchor: "middle"
    };
    return sn(sn({}, b), r ? {
      width: Math.max(b.x - r.x, 0),
      height: u
    } : {});
  }
  if (i === "right") {
    var S = {
      x: s + c + g,
      y: l + u / 2,
      textAnchor: y,
      verticalAnchor: "middle"
    };
    return sn(sn({}, S), r ? {
      width: Math.max(r.x + r.width - S.x, 0),
      height: u
    } : {});
  }
  var M = r ? {
    width: c,
    height: u
  } : {};
  return i === "insideLeft" ? sn({
    x: s + g,
    y: l + u / 2,
    textAnchor: y,
    verticalAnchor: "middle"
  }, M) : i === "insideRight" ? sn({
    x: s + c - g,
    y: l + u / 2,
    textAnchor: v,
    verticalAnchor: "middle"
  }, M) : i === "insideTop" ? sn({
    x: s + c / 2,
    y: l + h,
    textAnchor: "middle",
    verticalAnchor: C
  }, M) : i === "insideBottom" ? sn({
    x: s + c / 2,
    y: l + u - h,
    textAnchor: "middle",
    verticalAnchor: p
  }, M) : i === "insideTopLeft" ? sn({
    x: s + g,
    y: l + h,
    textAnchor: y,
    verticalAnchor: C
  }, M) : i === "insideTopRight" ? sn({
    x: s + c - g,
    y: l + h,
    textAnchor: v,
    verticalAnchor: C
  }, M) : i === "insideBottomLeft" ? sn({
    x: s + g,
    y: l + u - h,
    textAnchor: y,
    verticalAnchor: p
  }, M) : i === "insideBottomRight" ? sn({
    x: s + c - g,
    y: l + u - h,
    textAnchor: v,
    verticalAnchor: p
  }, M) : Ms(i) && (he(i.x) || ii(i.x)) && (he(i.y) || ii(i.y)) ? sn({
    x: s + _i(i.x, c),
    y: l + _i(i.y, u),
    textAnchor: "end",
    verticalAnchor: "end"
  }, M) : sn({
    x: s + c / 2,
    y: l + u / 2,
    textAnchor: "middle",
    verticalAnchor: "middle"
  }, M);
}, lue = function(t) {
  return "cx" in t && he(t.cx);
};
function Tn(e) {
  var t = e.offset, n = t === void 0 ? 5 : t, r = Q5e(e, q5e), o = sn({
    offset: n
  }, r), i = o.viewBox, a = o.position, s = o.value, l = o.children, c = o.content, u = o.className, f = u === void 0 ? "" : u, h = o.textBreakAll;
  if (!i || Ne(s) && Ne(l) && !/* @__PURE__ */ sr(c) && !je(c))
    return null;
  if (/* @__PURE__ */ sr(c))
    return /* @__PURE__ */ Qt(c, o);
  var p;
  if (je(c)) {
    if (p = /* @__PURE__ */ Pd(c, o), /* @__PURE__ */ sr(p))
      return p;
  } else
    p = rue(o);
  var C = lue(i), m = Be(o, !0);
  if (C && (a === "insideStart" || a === "insideEnd" || a === "end"))
    return iue(o, p, m);
  var g = C ? aue(o) : sue(o);
  return /* @__PURE__ */ O.createElement(T5, a2({
    className: We("recharts-label", f)
  }, m, g, {
    breakAll: h
  }), p);
}
Tn.displayName = "Label";
var tk = function(t) {
  var n = t.cx, r = t.cy, o = t.angle, i = t.startAngle, a = t.endAngle, s = t.r, l = t.radius, c = t.innerRadius, u = t.outerRadius, f = t.x, h = t.y, p = t.top, C = t.left, m = t.width, g = t.height, v = t.clockWise, y = t.labelViewBox;
  if (y)
    return y;
  if (he(m) && he(g)) {
    if (he(f) && he(h))
      return {
        x: f,
        y: h,
        width: m,
        height: g
      };
    if (he(p) && he(C))
      return {
        x: p,
        y: C,
        width: m,
        height: g
      };
  }
  return he(f) && he(h) ? {
    x: f,
    y: h,
    width: 0,
    height: 0
  } : he(n) && he(r) ? {
    cx: n,
    cy: r,
    startAngle: i || o || 0,
    endAngle: a || o || 0,
    innerRadius: c || 0,
    outerRadius: u || l || s || 0,
    clockWise: v
  } : t.viewBox ? t.viewBox : {};
}, cue = function(t, n) {
  return t ? t === !0 ? /* @__PURE__ */ O.createElement(Tn, {
    key: "label-implicit",
    viewBox: n
  }) : ln(t) ? /* @__PURE__ */ O.createElement(Tn, {
    key: "label-implicit",
    viewBox: n,
    value: t
  }) : /* @__PURE__ */ sr(t) ? t.type === Tn ? /* @__PURE__ */ Qt(t, {
    key: "label-implicit",
    viewBox: n
  }) : /* @__PURE__ */ O.createElement(Tn, {
    key: "label-implicit",
    content: t,
    viewBox: n
  }) : je(t) ? /* @__PURE__ */ O.createElement(Tn, {
    key: "label-implicit",
    content: t,
    viewBox: n
  }) : Ms(t) ? /* @__PURE__ */ O.createElement(Tn, a2({
    viewBox: n
  }, t, {
    key: "label-implicit"
  })) : null : null;
}, uue = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!t || !t.children && r && !t.label)
    return null;
  var o = t.children, i = tk(t), a = Yn(o, Tn).map(function(l, c) {
    return /* @__PURE__ */ Qt(l, {
      viewBox: n || i,
      // eslint-disable-next-line react/no-array-index-key
      key: "label-".concat(c)
    });
  });
  if (!r)
    return a;
  var s = cue(t.label, n || i);
  return [s].concat(U5e(a));
};
Tn.parseViewBox = tk;
Tn.renderCallByParent = uue;
var N4, lM;
function fue() {
  if (lM) return N4;
  lM = 1;
  function e(t) {
    var n = t == null ? 0 : t.length;
    return n ? t[n - 1] : void 0;
  }
  return N4 = e, N4;
}
var due = fue();
const hue = /* @__PURE__ */ Mt(due);
function s2(e) {
  "@babel/helpers - typeof";
  return s2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, s2(e);
}
var pue = ["valueAccessor"], mue = ["data", "dataKey", "clockWise", "id", "textBreakAll"];
function gue(e) {
  return bue(e) || yue(e) || vue(e) || Cue();
}
function Cue() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function vue(e, t) {
  if (e) {
    if (typeof e == "string") return zf(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return zf(e, t);
  }
}
function yue(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function bue(e) {
  if (Array.isArray(e)) return zf(e);
}
function zf(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function q5() {
  return q5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, q5.apply(this, arguments);
}
function cM(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function uM(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? cM(Object(n), !0).forEach(function(r) {
      wue(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : cM(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function wue(e, t, n) {
  return t = xue(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function xue(e) {
  var t = Sue(e, "string");
  return s2(t) == "symbol" ? t : t + "";
}
function Sue(e, t) {
  if (s2(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (s2(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function fM(e, t) {
  if (e == null) return {};
  var n = Mue(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Mue(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
var Eue = function(t) {
  return Array.isArray(t.value) ? hue(t.value) : t.value;
};
function go(e) {
  var t = e.valueAccessor, n = t === void 0 ? Eue : t, r = fM(e, pue), o = r.data, i = r.dataKey, a = r.clockWise, s = r.id, l = r.textBreakAll, c = fM(r, mue);
  return !o || !o.length ? null : /* @__PURE__ */ O.createElement(rt, {
    className: "recharts-label-list"
  }, o.map(function(u, f) {
    var h = Ne(i) ? n(u, f) : cn(u && u.payload, i), p = Ne(s) ? {} : {
      id: "".concat(s, "-").concat(f)
    };
    return /* @__PURE__ */ O.createElement(Tn, q5({}, Be(u, !0), c, p, {
      parentViewBox: u.parentViewBox,
      value: h,
      textBreakAll: l,
      viewBox: Tn.parseViewBox(Ne(a) ? u : uM(uM({}, u), {}, {
        clockWise: a
      })),
      key: "label-".concat(f),
      index: f
    }));
  }));
}
go.displayName = "LabelList";
function _ue(e, t) {
  return e ? e === !0 ? /* @__PURE__ */ O.createElement(go, {
    key: "labelList-implicit",
    data: t
  }) : /* @__PURE__ */ O.isValidElement(e) || je(e) ? /* @__PURE__ */ O.createElement(go, {
    key: "labelList-implicit",
    data: t,
    content: e
  }) : Ms(e) ? /* @__PURE__ */ O.createElement(go, q5({
    data: t
  }, e, {
    key: "labelList-implicit"
  })) : null : null;
}
function Oue(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!e || !e.children && n && !e.label)
    return null;
  var r = e.children, o = Yn(r, go).map(function(a, s) {
    return /* @__PURE__ */ Qt(a, {
      data: t,
      // eslint-disable-next-line react/no-array-index-key
      key: "labelList-".concat(s)
    });
  });
  if (!n)
    return o;
  var i = _ue(e.label, t);
  return [i].concat(gue(o));
}
go.renderCallByParent = Oue;
function l2(e) {
  "@babel/helpers - typeof";
  return l2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, l2(e);
}
function Zf() {
  return Zf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Zf.apply(this, arguments);
}
function dM(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function hM(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? dM(Object(n), !0).forEach(function(r) {
      Aue(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : dM(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Aue(e, t, n) {
  return t = Pue(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Pue(e) {
  var t = Tue(e, "string");
  return l2(t) == "symbol" ? t : t + "";
}
function Tue(e, t) {
  if (l2(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (l2(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Iue = function(t, n) {
  var r = jr(n - t), o = Math.min(Math.abs(n - t), 359.999);
  return r * o;
}, Dc = function(t) {
  var n = t.cx, r = t.cy, o = t.radius, i = t.angle, a = t.sign, s = t.isExternal, l = t.cornerRadius, c = t.cornerIsExternal, u = l * (s ? 1 : -1) + o, f = Math.asin(l / u) / W5, h = c ? i : i + a * f, p = wn(n, r, u, h), C = wn(n, r, o, h), m = c ? i - a * f : i, g = wn(n, r, u * Math.cos(f * W5), m);
  return {
    center: p,
    circleTangency: C,
    lineTangency: g,
    theta: f
  };
}, nk = function(t) {
  var n = t.cx, r = t.cy, o = t.innerRadius, i = t.outerRadius, a = t.startAngle, s = t.endAngle, l = Iue(a, s), c = a + l, u = wn(n, r, i, a), f = wn(n, r, i, c), h = "M ".concat(u.x, ",").concat(u.y, `
    A `).concat(i, ",").concat(i, `,0,
    `).concat(+(Math.abs(l) > 180), ",").concat(+(a > c), `,
    `).concat(f.x, ",").concat(f.y, `
  `);
  if (o > 0) {
    var p = wn(n, r, o, a), C = wn(n, r, o, c);
    h += "L ".concat(C.x, ",").concat(C.y, `
            A `).concat(o, ",").concat(o, `,0,
            `).concat(+(Math.abs(l) > 180), ",").concat(+(a <= c), `,
            `).concat(p.x, ",").concat(p.y, " Z");
  } else
    h += "L ".concat(n, ",").concat(r, " Z");
  return h;
}, Due = function(t) {
  var n = t.cx, r = t.cy, o = t.innerRadius, i = t.outerRadius, a = t.cornerRadius, s = t.forceCornerRadius, l = t.cornerIsExternal, c = t.startAngle, u = t.endAngle, f = jr(u - c), h = Dc({
    cx: n,
    cy: r,
    radius: i,
    angle: c,
    sign: f,
    cornerRadius: a,
    cornerIsExternal: l
  }), p = h.circleTangency, C = h.lineTangency, m = h.theta, g = Dc({
    cx: n,
    cy: r,
    radius: i,
    angle: u,
    sign: -f,
    cornerRadius: a,
    cornerIsExternal: l
  }), v = g.circleTangency, y = g.lineTangency, w = g.theta, x = l ? Math.abs(c - u) : Math.abs(c - u) - m - w;
  if (x < 0)
    return s ? "M ".concat(C.x, ",").concat(C.y, `
        a`).concat(a, ",").concat(a, ",0,0,1,").concat(a * 2, `,0
        a`).concat(a, ",").concat(a, ",0,0,1,").concat(-a * 2, `,0
      `) : nk({
      cx: n,
      cy: r,
      innerRadius: o,
      outerRadius: i,
      startAngle: c,
      endAngle: u
    });
  var b = "M ".concat(C.x, ",").concat(C.y, `
    A`).concat(a, ",").concat(a, ",0,0,").concat(+(f < 0), ",").concat(p.x, ",").concat(p.y, `
    A`).concat(i, ",").concat(i, ",0,").concat(+(x > 180), ",").concat(+(f < 0), ",").concat(v.x, ",").concat(v.y, `
    A`).concat(a, ",").concat(a, ",0,0,").concat(+(f < 0), ",").concat(y.x, ",").concat(y.y, `
  `);
  if (o > 0) {
    var S = Dc({
      cx: n,
      cy: r,
      radius: o,
      angle: c,
      sign: f,
      isExternal: !0,
      cornerRadius: a,
      cornerIsExternal: l
    }), M = S.circleTangency, E = S.lineTangency, P = S.theta, T = Dc({
      cx: n,
      cy: r,
      radius: o,
      angle: u,
      sign: -f,
      isExternal: !0,
      cornerRadius: a,
      cornerIsExternal: l
    }), _ = T.circleTangency, D = T.lineTangency, N = T.theta, R = l ? Math.abs(c - u) : Math.abs(c - u) - P - N;
    if (R < 0 && a === 0)
      return "".concat(b, "L").concat(n, ",").concat(r, "Z");
    b += "L".concat(D.x, ",").concat(D.y, `
      A`).concat(a, ",").concat(a, ",0,0,").concat(+(f < 0), ",").concat(_.x, ",").concat(_.y, `
      A`).concat(o, ",").concat(o, ",0,").concat(+(R > 180), ",").concat(+(f > 0), ",").concat(M.x, ",").concat(M.y, `
      A`).concat(a, ",").concat(a, ",0,0,").concat(+(f < 0), ",").concat(E.x, ",").concat(E.y, "Z");
  } else
    b += "L".concat(n, ",").concat(r, "Z");
  return b;
}, Rue = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0,
  forceCornerRadius: !1,
  cornerIsExternal: !1
}, rk = function(t) {
  var n = hM(hM({}, Rue), t), r = n.cx, o = n.cy, i = n.innerRadius, a = n.outerRadius, s = n.cornerRadius, l = n.forceCornerRadius, c = n.cornerIsExternal, u = n.startAngle, f = n.endAngle, h = n.className;
  if (a < i || u === f)
    return null;
  var p = We("recharts-sector", h), C = a - i, m = _i(s, C, 0, !0), g;
  return m > 0 && Math.abs(u - f) < 360 ? g = Due({
    cx: r,
    cy: o,
    innerRadius: i,
    outerRadius: a,
    cornerRadius: Math.min(m, C / 2),
    forceCornerRadius: l,
    cornerIsExternal: c,
    startAngle: u,
    endAngle: f
  }) : g = nk({
    cx: r,
    cy: o,
    innerRadius: i,
    outerRadius: a,
    startAngle: u,
    endAngle: f
  }), /* @__PURE__ */ O.createElement("path", Zf({}, Be(n, !0), {
    className: p,
    d: g,
    role: "img"
  }));
};
function c2(e) {
  "@babel/helpers - typeof";
  return c2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, c2(e);
}
function Wf() {
  return Wf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Wf.apply(this, arguments);
}
function pM(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function mM(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? pM(Object(n), !0).forEach(function(r) {
      kue(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : pM(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function kue(e, t, n) {
  return t = Lue(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Lue(e) {
  var t = Nue(e, "string");
  return c2(t) == "symbol" ? t : t + "";
}
function Nue(e, t) {
  if (c2(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (c2(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var gM = {
  curveBasisClosed: t1e,
  curveBasisOpen: n1e,
  curveBasis: e1e,
  curveBumpX: $oe,
  curveBumpY: joe,
  curveLinearClosed: r1e,
  curveLinear: c0,
  curveMonotoneX: o1e,
  curveMonotoneY: i1e,
  curveNatural: a1e,
  curveStep: s1e,
  curveStepAfter: c1e,
  curveStepBefore: l1e
}, Rc = function(t) {
  return t.x === +t.x && t.y === +t.y;
}, el = function(t) {
  return t.x;
}, tl = function(t) {
  return t.y;
}, Fue = function(t, n) {
  if (je(t))
    return t;
  var r = "curve".concat(s0(t));
  return (r === "curveMonotone" || r === "curveBump") && n ? gM["".concat(r).concat(n === "vertical" ? "Y" : "X")] : gM[r] || c0;
}, Vue = function(t) {
  var n = t.type, r = n === void 0 ? "linear" : n, o = t.points, i = o === void 0 ? [] : o, a = t.baseLine, s = t.layout, l = t.connectNulls, c = l === void 0 ? !1 : l, u = Fue(r, s), f = c ? i.filter(function(m) {
    return Rc(m);
  }) : i, h;
  if (Array.isArray(a)) {
    var p = c ? a.filter(function(m) {
      return Rc(m);
    }) : a, C = f.map(function(m, g) {
      return mM(mM({}, m), {}, {
        base: p[g]
      });
    });
    return s === "vertical" ? h = Mc().y(tl).x1(el).x0(function(m) {
      return m.base.x;
    }) : h = Mc().x(el).y1(tl).y0(function(m) {
      return m.base.y;
    }), h.defined(Rc).curve(u), h(C);
  }
  return s === "vertical" && he(a) ? h = Mc().y(tl).x1(el).x0(a) : he(a) ? h = Mc().x(el).y1(tl).y0(a) : h = lD().x(el).y(tl), h.defined(Rc).curve(u), h(f);
}, gi = function(t) {
  var n = t.className, r = t.points, o = t.path, i = t.pathRef;
  if ((!r || !r.length) && !o)
    return null;
  var a = r && r.length ? Vue(t) : o;
  return /* @__PURE__ */ A.createElement("path", Wf({}, Be(t, !1), y5(t), {
    className: We("recharts-curve", n),
    d: a,
    ref: i
  }));
}, Bue = Object.getOwnPropertyNames, $ue = Object.getOwnPropertySymbols, jue = Object.prototype.hasOwnProperty;
function CM(e, t) {
  return function(r, o, i) {
    return e(r, o, i) && t(r, o, i);
  };
}
function kc(e) {
  return function(n, r, o) {
    if (!n || !r || typeof n != "object" || typeof r != "object")
      return e(n, r, o);
    var i = o.cache, a = i.get(n), s = i.get(r);
    if (a && s)
      return a === r && s === n;
    i.set(n, r), i.set(r, n);
    var l = e(n, r, o);
    return i.delete(n), i.delete(r), l;
  };
}
function Hue(e) {
  return e?.[Symbol.toStringTag];
}
function vM(e) {
  return Bue(e).concat($ue(e));
}
var zue = Object.hasOwn || (function(e, t) {
  return jue.call(e, t);
});
function Hi(e, t) {
  return e === t || !e && !t && e !== e && t !== t;
}
var Zue = "__v", Wue = "__o", que = "_owner", yM = Object.getOwnPropertyDescriptor, bM = Object.keys;
function Uue(e, t, n) {
  var r = e.length;
  if (t.length !== r)
    return !1;
  for (; r-- > 0; )
    if (!n.equals(e[r], t[r], r, r, e, t, n))
      return !1;
  return !0;
}
function Gue(e, t) {
  return Hi(e.getTime(), t.getTime());
}
function Kue(e, t) {
  return e.name === t.name && e.message === t.message && e.cause === t.cause && e.stack === t.stack;
}
function Yue(e, t) {
  return e === t;
}
function wM(e, t, n) {
  var r = e.size;
  if (r !== t.size)
    return !1;
  if (!r)
    return !0;
  for (var o = new Array(r), i = e.entries(), a, s, l = 0; (a = i.next()) && !a.done; ) {
    for (var c = t.entries(), u = !1, f = 0; (s = c.next()) && !s.done; ) {
      if (o[f]) {
        f++;
        continue;
      }
      var h = a.value, p = s.value;
      if (n.equals(h[0], p[0], l, f, e, t, n) && n.equals(h[1], p[1], h[0], p[0], e, t, n)) {
        u = o[f] = !0;
        break;
      }
      f++;
    }
    if (!u)
      return !1;
    l++;
  }
  return !0;
}
var Xue = Hi;
function Que(e, t, n) {
  var r = bM(e), o = r.length;
  if (bM(t).length !== o)
    return !1;
  for (; o-- > 0; )
    if (!ok(e, t, n, r[o]))
      return !1;
  return !0;
}
function nl(e, t, n) {
  var r = vM(e), o = r.length;
  if (vM(t).length !== o)
    return !1;
  for (var i, a, s; o-- > 0; )
    if (i = r[o], !ok(e, t, n, i) || (a = yM(e, i), s = yM(t, i), (a || s) && (!a || !s || a.configurable !== s.configurable || a.enumerable !== s.enumerable || a.writable !== s.writable)))
      return !1;
  return !0;
}
function Jue(e, t) {
  return Hi(e.valueOf(), t.valueOf());
}
function e0e(e, t) {
  return e.source === t.source && e.flags === t.flags;
}
function xM(e, t, n) {
  var r = e.size;
  if (r !== t.size)
    return !1;
  if (!r)
    return !0;
  for (var o = new Array(r), i = e.values(), a, s; (a = i.next()) && !a.done; ) {
    for (var l = t.values(), c = !1, u = 0; (s = l.next()) && !s.done; ) {
      if (!o[u] && n.equals(a.value, s.value, a.value, s.value, e, t, n)) {
        c = o[u] = !0;
        break;
      }
      u++;
    }
    if (!c)
      return !1;
  }
  return !0;
}
function t0e(e, t) {
  var n = e.length;
  if (t.length !== n)
    return !1;
  for (; n-- > 0; )
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function n0e(e, t) {
  return e.hostname === t.hostname && e.pathname === t.pathname && e.protocol === t.protocol && e.port === t.port && e.hash === t.hash && e.username === t.username && e.password === t.password;
}
function ok(e, t, n, r) {
  return (r === que || r === Wue || r === Zue) && (e.$$typeof || t.$$typeof) ? !0 : zue(t, r) && n.equals(e[r], t[r], r, r, e, t, n);
}
var r0e = "[object Arguments]", o0e = "[object Boolean]", i0e = "[object Date]", a0e = "[object Error]", s0e = "[object Map]", l0e = "[object Number]", c0e = "[object Object]", u0e = "[object RegExp]", f0e = "[object Set]", d0e = "[object String]", h0e = "[object URL]", p0e = Array.isArray, SM = typeof ArrayBuffer == "function" && ArrayBuffer.isView ? ArrayBuffer.isView : null, MM = Object.assign, m0e = Object.prototype.toString.call.bind(Object.prototype.toString);
function g0e(e) {
  var t = e.areArraysEqual, n = e.areDatesEqual, r = e.areErrorsEqual, o = e.areFunctionsEqual, i = e.areMapsEqual, a = e.areNumbersEqual, s = e.areObjectsEqual, l = e.arePrimitiveWrappersEqual, c = e.areRegExpsEqual, u = e.areSetsEqual, f = e.areTypedArraysEqual, h = e.areUrlsEqual, p = e.unknownTagComparators;
  return function(m, g, v) {
    if (m === g)
      return !0;
    if (m == null || g == null)
      return !1;
    var y = typeof m;
    if (y !== typeof g)
      return !1;
    if (y !== "object")
      return y === "number" ? a(m, g, v) : y === "function" ? o(m, g, v) : !1;
    var w = m.constructor;
    if (w !== g.constructor)
      return !1;
    if (w === Object)
      return s(m, g, v);
    if (p0e(m))
      return t(m, g, v);
    if (SM != null && SM(m))
      return f(m, g, v);
    if (w === Date)
      return n(m, g, v);
    if (w === RegExp)
      return c(m, g, v);
    if (w === Map)
      return i(m, g, v);
    if (w === Set)
      return u(m, g, v);
    var x = m0e(m);
    if (x === i0e)
      return n(m, g, v);
    if (x === u0e)
      return c(m, g, v);
    if (x === s0e)
      return i(m, g, v);
    if (x === f0e)
      return u(m, g, v);
    if (x === c0e)
      return typeof m.then != "function" && typeof g.then != "function" && s(m, g, v);
    if (x === h0e)
      return h(m, g, v);
    if (x === a0e)
      return r(m, g, v);
    if (x === r0e)
      return s(m, g, v);
    if (x === o0e || x === l0e || x === d0e)
      return l(m, g, v);
    if (p) {
      var b = p[x];
      if (!b) {
        var S = Hue(m);
        S && (b = p[S]);
      }
      if (b)
        return b(m, g, v);
    }
    return !1;
  };
}
function C0e(e) {
  var t = e.circular, n = e.createCustomConfig, r = e.strict, o = {
    areArraysEqual: r ? nl : Uue,
    areDatesEqual: Gue,
    areErrorsEqual: Kue,
    areFunctionsEqual: Yue,
    areMapsEqual: r ? CM(wM, nl) : wM,
    areNumbersEqual: Xue,
    areObjectsEqual: r ? nl : Que,
    arePrimitiveWrappersEqual: Jue,
    areRegExpsEqual: e0e,
    areSetsEqual: r ? CM(xM, nl) : xM,
    areTypedArraysEqual: r ? nl : t0e,
    areUrlsEqual: n0e,
    unknownTagComparators: void 0
  };
  if (n && (o = MM({}, o, n(o))), t) {
    var i = kc(o.areArraysEqual), a = kc(o.areMapsEqual), s = kc(o.areObjectsEqual), l = kc(o.areSetsEqual);
    o = MM({}, o, {
      areArraysEqual: i,
      areMapsEqual: a,
      areObjectsEqual: s,
      areSetsEqual: l
    });
  }
  return o;
}
function v0e(e) {
  return function(t, n, r, o, i, a, s) {
    return e(t, n, s);
  };
}
function y0e(e) {
  var t = e.circular, n = e.comparator, r = e.createState, o = e.equals, i = e.strict;
  if (r)
    return function(l, c) {
      var u = r(), f = u.cache, h = f === void 0 ? t ? /* @__PURE__ */ new WeakMap() : void 0 : f, p = u.meta;
      return n(l, c, {
        cache: h,
        equals: o,
        meta: p,
        strict: i
      });
    };
  if (t)
    return function(l, c) {
      return n(l, c, {
        cache: /* @__PURE__ */ new WeakMap(),
        equals: o,
        meta: void 0,
        strict: i
      });
    };
  var a = {
    cache: void 0,
    equals: o,
    meta: void 0,
    strict: i
  };
  return function(l, c) {
    return n(l, c, a);
  };
}
var b0e = z1();
z1({ strict: !0 });
z1({ circular: !0 });
z1({
  circular: !0,
  strict: !0
});
z1({
  createInternalComparator: function() {
    return Hi;
  }
});
z1({
  strict: !0,
  createInternalComparator: function() {
    return Hi;
  }
});
z1({
  circular: !0,
  createInternalComparator: function() {
    return Hi;
  }
});
z1({
  circular: !0,
  createInternalComparator: function() {
    return Hi;
  },
  strict: !0
});
function z1(e) {
  e === void 0 && (e = {});
  var t = e.circular, n = t === void 0 ? !1 : t, r = e.createInternalComparator, o = e.createState, i = e.strict, a = i === void 0 ? !1 : i, s = C0e(e), l = g0e(s), c = r ? r(l) : v0e(l);
  return y0e({ circular: n, comparator: l, createState: o, equals: c, strict: a });
}
function w0e(e) {
  typeof requestAnimationFrame < "u" && requestAnimationFrame(e);
}
function EM(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = -1, r = function o(i) {
    n < 0 && (n = i), i - n > t ? (e(i), n = -1) : w0e(o);
  };
  requestAnimationFrame(r);
}
function qf(e) {
  "@babel/helpers - typeof";
  return qf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, qf(e);
}
function x0e(e) {
  return _0e(e) || E0e(e) || M0e(e) || S0e();
}
function S0e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function M0e(e, t) {
  if (e) {
    if (typeof e == "string") return _M(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _M(e, t);
  }
}
function _M(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function E0e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function _0e(e) {
  if (Array.isArray(e)) return e;
}
function O0e() {
  var e = {}, t = function() {
    return null;
  }, n = !1, r = function o(i) {
    if (!n) {
      if (Array.isArray(i)) {
        if (!i.length)
          return;
        var a = i, s = x0e(a), l = s[0], c = s.slice(1);
        if (typeof l == "number") {
          EM(o.bind(null, c), l);
          return;
        }
        o(l), EM(o.bind(null, c));
        return;
      }
      qf(i) === "object" && (e = i, t(e)), typeof i == "function" && i();
    }
  };
  return {
    stop: function() {
      n = !0;
    },
    start: function(i) {
      n = !1, r(i);
    },
    subscribe: function(i) {
      return t = i, function() {
        t = function() {
          return null;
        };
      };
    }
  };
}
function u2(e) {
  "@babel/helpers - typeof";
  return u2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, u2(e);
}
function OM(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function AM(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? OM(Object(n), !0).forEach(function(r) {
      ik(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : OM(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function ik(e, t, n) {
  return t = A0e(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function A0e(e) {
  var t = P0e(e, "string");
  return u2(t) === "symbol" ? t : String(t);
}
function P0e(e, t) {
  if (u2(e) !== "object" || e === null) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (u2(r) !== "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var T0e = function(t, n) {
  return [Object.keys(t), Object.keys(n)].reduce(function(r, o) {
    return r.filter(function(i) {
      return o.includes(i);
    });
  });
}, I0e = function(t) {
  return t;
}, D0e = function(t) {
  return t.replace(/([A-Z])/g, function(n) {
    return "-".concat(n.toLowerCase());
  });
}, Sl = function(t, n) {
  return Object.keys(n).reduce(function(r, o) {
    return AM(AM({}, r), {}, ik({}, o, t(o, n[o])));
  }, {});
}, PM = function(t, n, r) {
  return t.map(function(o) {
    return "".concat(D0e(o), " ").concat(n, "ms ").concat(r);
  }).join(",");
}, R0e = process.env.NODE_ENV !== "production", U5 = function(t, n, r, o, i, a, s, l) {
  if (R0e && typeof console < "u" && console.warn && (n === void 0 && console.warn("LogUtils requires an error message argument"), !t))
    if (n === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var c = [r, o, i, a, s, l], u = 0;
      console.warn(n.replace(/%s/g, function() {
        return c[u++];
      }));
    }
};
function k0e(e, t) {
  return F0e(e) || N0e(e, t) || ak(e, t) || L0e();
}
function L0e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function N0e(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, o, i, a, s = [], l = !0, c = !1;
    try {
      if (i = (n = n.call(e)).next, t !== 0) for (; !(l = (r = i.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (u) {
      c = !0, o = u;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw o;
      }
    }
    return s;
  }
}
function F0e(e) {
  if (Array.isArray(e)) return e;
}
function V0e(e) {
  return j0e(e) || $0e(e) || ak(e) || B0e();
}
function B0e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ak(e, t) {
  if (e) {
    if (typeof e == "string") return Uf(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Uf(e, t);
  }
}
function $0e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function j0e(e) {
  if (Array.isArray(e)) return Uf(e);
}
function Uf(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
var G5 = 1e-4, sk = function(t, n) {
  return [0, 3 * t, 3 * n - 6 * t, 3 * t - 3 * n + 1];
}, lk = function(t, n) {
  return t.map(function(r, o) {
    return r * Math.pow(n, o);
  }).reduce(function(r, o) {
    return r + o;
  });
}, TM = function(t, n) {
  return function(r) {
    var o = sk(t, n);
    return lk(o, r);
  };
}, H0e = function(t, n) {
  return function(r) {
    var o = sk(t, n), i = [].concat(V0e(o.map(function(a, s) {
      return a * s;
    }).slice(1)), [0]);
    return lk(i, r);
  };
}, IM = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  var o = n[0], i = n[1], a = n[2], s = n[3];
  if (n.length === 1)
    switch (n[0]) {
      case "linear":
        o = 0, i = 0, a = 1, s = 1;
        break;
      case "ease":
        o = 0.25, i = 0.1, a = 0.25, s = 1;
        break;
      case "ease-in":
        o = 0.42, i = 0, a = 1, s = 1;
        break;
      case "ease-out":
        o = 0.42, i = 0, a = 0.58, s = 1;
        break;
      case "ease-in-out":
        o = 0, i = 0, a = 0.58, s = 1;
        break;
      default: {
        var l = n[0].split("(");
        if (l[0] === "cubic-bezier" && l[1].split(")")[0].split(",").length === 4) {
          var c = l[1].split(")")[0].split(",").map(function(g) {
            return parseFloat(g);
          }), u = k0e(c, 4);
          o = u[0], i = u[1], a = u[2], s = u[3];
        } else
          U5(!1, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", n);
      }
    }
  U5([o, a, i, s].every(function(g) {
    return typeof g == "number" && g >= 0 && g <= 1;
  }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", n);
  var f = TM(o, a), h = TM(i, s), p = H0e(o, a), C = function(v) {
    return v > 1 ? 1 : v < 0 ? 0 : v;
  }, m = function(v) {
    for (var y = v > 1 ? 1 : v, w = y, x = 0; x < 8; ++x) {
      var b = f(w) - y, S = p(w);
      if (Math.abs(b - y) < G5 || S < G5)
        return h(w);
      w = C(w - b / S);
    }
    return h(w);
  };
  return m.isStepper = !1, m;
}, z0e = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.stiff, r = n === void 0 ? 100 : n, o = t.damping, i = o === void 0 ? 8 : o, a = t.dt, s = a === void 0 ? 17 : a, l = function(u, f, h) {
    var p = -(u - f) * r, C = h * i, m = h + (p - C) * s / 1e3, g = h * s / 1e3 + u;
    return Math.abs(g - f) < G5 && Math.abs(m) < G5 ? [f, 0] : [g, m];
  };
  return l.isStepper = !0, l.dt = s, l;
}, Z0e = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  var o = n[0];
  if (typeof o == "string")
    switch (o) {
      case "ease":
      case "ease-in-out":
      case "ease-out":
      case "ease-in":
      case "linear":
        return IM(o);
      case "spring":
        return z0e();
      default:
        if (o.split("(")[0] === "cubic-bezier")
          return IM(o);
        U5(!1, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", n);
    }
  return typeof o == "function" ? o : (U5(!1, "[configEasing]: first argument type should be function or string, instead received %s", n), null);
};
function f2(e) {
  "@babel/helpers - typeof";
  return f2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, f2(e);
}
function DM(e) {
  return U0e(e) || q0e(e) || ck(e) || W0e();
}
function W0e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function q0e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function U0e(e) {
  if (Array.isArray(e)) return Kf(e);
}
function RM(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function gn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? RM(Object(n), !0).forEach(function(r) {
      Gf(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : RM(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Gf(e, t, n) {
  return t = G0e(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function G0e(e) {
  var t = K0e(e, "string");
  return f2(t) === "symbol" ? t : String(t);
}
function K0e(e, t) {
  if (f2(e) !== "object" || e === null) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (f2(r) !== "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Y0e(e, t) {
  return J0e(e) || Q0e(e, t) || ck(e, t) || X0e();
}
function X0e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ck(e, t) {
  if (e) {
    if (typeof e == "string") return Kf(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Kf(e, t);
  }
}
function Kf(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Q0e(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, o, i, a, s = [], l = !0, c = !1;
    try {
      if (i = (n = n.call(e)).next, t !== 0) for (; !(l = (r = i.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (u) {
      c = !0, o = u;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw o;
      }
    }
    return s;
  }
}
function J0e(e) {
  if (Array.isArray(e)) return e;
}
var K5 = function(t, n, r) {
  return t + (n - t) * r;
}, Yf = function(t) {
  var n = t.from, r = t.to;
  return n !== r;
}, e7e = function e(t, n, r) {
  var o = Sl(function(i, a) {
    if (Yf(a)) {
      var s = t(a.from, a.to, a.velocity), l = Y0e(s, 2), c = l[0], u = l[1];
      return gn(gn({}, a), {}, {
        from: c,
        velocity: u
      });
    }
    return a;
  }, n);
  return r < 1 ? Sl(function(i, a) {
    return Yf(a) ? gn(gn({}, a), {}, {
      velocity: K5(a.velocity, o[i].velocity, r),
      from: K5(a.from, o[i].from, r)
    }) : a;
  }, n) : e(t, o, r - 1);
};
const t7e = (function(e, t, n, r, o) {
  var i = T0e(e, t), a = i.reduce(function(g, v) {
    return gn(gn({}, g), {}, Gf({}, v, [e[v], t[v]]));
  }, {}), s = i.reduce(function(g, v) {
    return gn(gn({}, g), {}, Gf({}, v, {
      from: e[v],
      velocity: 0,
      to: t[v]
    }));
  }, {}), l = -1, c, u, f = function() {
    return null;
  }, h = function() {
    return Sl(function(v, y) {
      return y.from;
    }, s);
  }, p = function() {
    return !Object.values(s).filter(Yf).length;
  }, C = function(v) {
    c || (c = v);
    var y = v - c, w = y / n.dt;
    s = e7e(n, s, w), o(gn(gn(gn({}, e), t), h())), c = v, p() || (l = requestAnimationFrame(f));
  }, m = function(v) {
    u || (u = v);
    var y = (v - u) / r, w = Sl(function(b, S) {
      return K5.apply(void 0, DM(S).concat([n(y)]));
    }, a);
    if (o(gn(gn(gn({}, e), t), w)), y < 1)
      l = requestAnimationFrame(f);
    else {
      var x = Sl(function(b, S) {
        return K5.apply(void 0, DM(S).concat([n(1)]));
      }, a);
      o(gn(gn(gn({}, e), t), x));
    }
  };
  return f = n.isStepper ? C : m, function() {
    return requestAnimationFrame(f), function() {
      cancelAnimationFrame(l);
    };
  };
});
function Xa(e) {
  "@babel/helpers - typeof";
  return Xa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Xa(e);
}
var n7e = ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"];
function r7e(e, t) {
  if (e == null) return {};
  var n = o7e(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function o7e(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), o, i;
  for (i = 0; i < r.length; i++)
    o = r[i], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function F4(e) {
  return l7e(e) || s7e(e) || a7e(e) || i7e();
}
function i7e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function a7e(e, t) {
  if (e) {
    if (typeof e == "string") return Xf(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Xf(e, t);
  }
}
function s7e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function l7e(e) {
  if (Array.isArray(e)) return Xf(e);
}
function Xf(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function kM(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Dr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? kM(Object(n), !0).forEach(function(r) {
      dl(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : kM(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function dl(e, t, n) {
  return t = uk(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function c7e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function u7e(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, uk(r.key), r);
  }
}
function f7e(e, t, n) {
  return t && u7e(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function uk(e) {
  var t = d7e(e, "string");
  return Xa(t) === "symbol" ? t : String(t);
}
function d7e(e, t) {
  if (Xa(e) !== "object" || e === null) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Xa(r) !== "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function h7e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Qf(e, t);
}
function Qf(e, t) {
  return Qf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, Qf(e, t);
}
function p7e(e) {
  var t = m7e();
  return function() {
    var r = Y5(e), o;
    if (t) {
      var i = Y5(this).constructor;
      o = Reflect.construct(r, arguments, i);
    } else
      o = r.apply(this, arguments);
    return Jf(this, o);
  };
}
function Jf(e, t) {
  if (t && (Xa(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return ed(e);
}
function ed(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function m7e() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Y5(e) {
  return Y5 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Y5(e);
}
var Ur = /* @__PURE__ */ (function(e) {
  h7e(n, e);
  var t = p7e(n);
  function n(r, o) {
    var i;
    c7e(this, n), i = t.call(this, r, o);
    var a = i.props, s = a.isActive, l = a.attributeName, c = a.from, u = a.to, f = a.steps, h = a.children, p = a.duration;
    if (i.handleStyleChange = i.handleStyleChange.bind(ed(i)), i.changeStyle = i.changeStyle.bind(ed(i)), !s || p <= 0)
      return i.state = {
        style: {}
      }, typeof h == "function" && (i.state = {
        style: u
      }), Jf(i);
    if (f && f.length)
      i.state = {
        style: f[0].style
      };
    else if (c) {
      if (typeof h == "function")
        return i.state = {
          style: c
        }, Jf(i);
      i.state = {
        style: l ? dl({}, l, c) : c
      };
    } else
      i.state = {
        style: {}
      };
    return i;
  }
  return f7e(n, [{
    key: "componentDidMount",
    value: function() {
      var o = this.props, i = o.isActive, a = o.canBegin;
      this.mounted = !0, !(!i || !a) && this.runAnimation(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function(o) {
      var i = this.props, a = i.isActive, s = i.canBegin, l = i.attributeName, c = i.shouldReAnimate, u = i.to, f = i.from, h = this.state.style;
      if (s) {
        if (!a) {
          var p = {
            style: l ? dl({}, l, u) : u
          };
          this.state && h && (l && h[l] !== u || !l && h !== u) && this.setState(p);
          return;
        }
        if (!(b0e(o.to, u) && o.canBegin && o.isActive)) {
          var C = !o.canBegin || !o.isActive;
          this.manager && this.manager.stop(), this.stopJSAnimation && this.stopJSAnimation();
          var m = C || c ? f : o.to;
          if (this.state && h) {
            var g = {
              style: l ? dl({}, l, m) : m
            };
            (l && h[l] !== m || !l && h !== m) && this.setState(g);
          }
          this.runAnimation(Dr(Dr({}, this.props), {}, {
            from: m,
            begin: 0
          }));
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.mounted = !1;
      var o = this.props.onAnimationEnd;
      this.unSubscribe && this.unSubscribe(), this.manager && (this.manager.stop(), this.manager = null), this.stopJSAnimation && this.stopJSAnimation(), o && o();
    }
  }, {
    key: "handleStyleChange",
    value: function(o) {
      this.changeStyle(o);
    }
  }, {
    key: "changeStyle",
    value: function(o) {
      this.mounted && this.setState({
        style: o
      });
    }
  }, {
    key: "runJSAnimation",
    value: function(o) {
      var i = this, a = o.from, s = o.to, l = o.duration, c = o.easing, u = o.begin, f = o.onAnimationEnd, h = o.onAnimationStart, p = t7e(a, s, Z0e(c), l, this.changeStyle), C = function() {
        i.stopJSAnimation = p();
      };
      this.manager.start([h, u, C, l, f]);
    }
  }, {
    key: "runStepAnimation",
    value: function(o) {
      var i = this, a = o.steps, s = o.begin, l = o.onAnimationStart, c = a[0], u = c.style, f = c.duration, h = f === void 0 ? 0 : f, p = function(m, g, v) {
        if (v === 0)
          return m;
        var y = g.duration, w = g.easing, x = w === void 0 ? "ease" : w, b = g.style, S = g.properties, M = g.onAnimationEnd, E = v > 0 ? a[v - 1] : g, P = S || Object.keys(b);
        if (typeof x == "function" || x === "spring")
          return [].concat(F4(m), [i.runJSAnimation.bind(i, {
            from: E.style,
            to: b,
            duration: y,
            easing: x
          }), y]);
        var T = PM(P, y, x), _ = Dr(Dr(Dr({}, E.style), b), {}, {
          transition: T
        });
        return [].concat(F4(m), [_, y, M]).filter(I0e);
      };
      return this.manager.start([l].concat(F4(a.reduce(p, [u, Math.max(h, s)])), [o.onAnimationEnd]));
    }
  }, {
    key: "runAnimation",
    value: function(o) {
      this.manager || (this.manager = O0e());
      var i = o.begin, a = o.duration, s = o.attributeName, l = o.to, c = o.easing, u = o.onAnimationStart, f = o.onAnimationEnd, h = o.steps, p = o.children, C = this.manager;
      if (this.unSubscribe = C.subscribe(this.handleStyleChange), typeof c == "function" || typeof p == "function" || c === "spring") {
        this.runJSAnimation(o);
        return;
      }
      if (h.length > 1) {
        this.runStepAnimation(o);
        return;
      }
      var m = s ? dl({}, s, l) : l, g = PM(Object.keys(m), a, c);
      C.start([u, i, Dr(Dr({}, m), {}, {
        transition: g
      }), a, f]);
    }
  }, {
    key: "render",
    value: function() {
      var o = this.props, i = o.children;
      o.begin;
      var a = o.duration;
      o.attributeName, o.easing;
      var s = o.isActive;
      o.steps, o.from, o.to, o.canBegin, o.onAnimationEnd, o.shouldReAnimate, o.onAnimationReStart;
      var l = r7e(o, n7e), c = ar.count(i), u = this.state.style;
      if (typeof i == "function")
        return i(u);
      if (!s || c === 0 || a <= 0)
        return i;
      var f = function(p) {
        var C = p.props, m = C.style, g = m === void 0 ? {} : m, v = C.className, y = /* @__PURE__ */ Qt(p, Dr(Dr({}, l), {}, {
          style: Dr(Dr({}, g), u),
          className: v
        }));
        return y;
      };
      return c === 1 ? f(ar.only(i)) : /* @__PURE__ */ O.createElement("div", null, ar.map(i, function(h) {
        return f(h);
      }));
    }
  }]), n;
})(xo);
Ur.displayName = "Animate";
Ur.defaultProps = {
  begin: 0,
  duration: 1e3,
  from: "",
  to: "",
  attributeName: "",
  easing: "ease",
  isActive: !0,
  canBegin: !0,
  steps: [],
  onAnimationEnd: function() {
  },
  onAnimationStart: function() {
  }
};
Ur.propTypes = {
  from: $e.oneOfType([$e.object, $e.string]),
  to: $e.oneOfType([$e.object, $e.string]),
  attributeName: $e.string,
  // animation duration
  duration: $e.number,
  begin: $e.number,
  easing: $e.oneOfType([$e.string, $e.func]),
  steps: $e.arrayOf($e.shape({
    duration: $e.number.isRequired,
    style: $e.object.isRequired,
    easing: $e.oneOfType([$e.oneOf(["ease", "ease-in", "ease-out", "ease-in-out", "linear"]), $e.func]),
    // transition css properties(dash case), optional
    properties: $e.arrayOf("string"),
    onAnimationEnd: $e.func
  })),
  children: $e.oneOfType([$e.node, $e.func]),
  isActive: $e.bool,
  canBegin: $e.bool,
  onAnimationEnd: $e.func,
  // decide if it should reanimate with initial from style when props change
  shouldReAnimate: $e.bool,
  onAnimationStart: $e.func,
  onAnimationReStart: $e.func
};
function d2(e) {
  "@babel/helpers - typeof";
  return d2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, d2(e);
}
function X5() {
  return X5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, X5.apply(this, arguments);
}
function g7e(e, t) {
  return b7e(e) || y7e(e, t) || v7e(e, t) || C7e();
}
function C7e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function v7e(e, t) {
  if (e) {
    if (typeof e == "string") return LM(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return LM(e, t);
  }
}
function LM(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function y7e(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, o, i, a, s = [], l = !0, c = !1;
    try {
      if (i = (n = n.call(e)).next, t !== 0) for (; !(l = (r = i.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (u) {
      c = !0, o = u;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw o;
      }
    }
    return s;
  }
}
function b7e(e) {
  if (Array.isArray(e)) return e;
}
function NM(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function FM(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? NM(Object(n), !0).forEach(function(r) {
      w7e(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : NM(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function w7e(e, t, n) {
  return t = x7e(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function x7e(e) {
  var t = S7e(e, "string");
  return d2(t) == "symbol" ? t : t + "";
}
function S7e(e, t) {
  if (d2(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (d2(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var VM = function(t, n, r, o, i) {
  var a = Math.min(Math.abs(r) / 2, Math.abs(o) / 2), s = o >= 0 ? 1 : -1, l = r >= 0 ? 1 : -1, c = o >= 0 && r >= 0 || o < 0 && r < 0 ? 1 : 0, u;
  if (a > 0 && i instanceof Array) {
    for (var f = [0, 0, 0, 0], h = 0, p = 4; h < p; h++)
      f[h] = i[h] > a ? a : i[h];
    u = "M".concat(t, ",").concat(n + s * f[0]), f[0] > 0 && (u += "A ".concat(f[0], ",").concat(f[0], ",0,0,").concat(c, ",").concat(t + l * f[0], ",").concat(n)), u += "L ".concat(t + r - l * f[1], ",").concat(n), f[1] > 0 && (u += "A ".concat(f[1], ",").concat(f[1], ",0,0,").concat(c, `,
        `).concat(t + r, ",").concat(n + s * f[1])), u += "L ".concat(t + r, ",").concat(n + o - s * f[2]), f[2] > 0 && (u += "A ".concat(f[2], ",").concat(f[2], ",0,0,").concat(c, `,
        `).concat(t + r - l * f[2], ",").concat(n + o)), u += "L ".concat(t + l * f[3], ",").concat(n + o), f[3] > 0 && (u += "A ".concat(f[3], ",").concat(f[3], ",0,0,").concat(c, `,
        `).concat(t, ",").concat(n + o - s * f[3])), u += "Z";
  } else if (a > 0 && i === +i && i > 0) {
    var C = Math.min(a, i);
    u = "M ".concat(t, ",").concat(n + s * C, `
            A `).concat(C, ",").concat(C, ",0,0,").concat(c, ",").concat(t + l * C, ",").concat(n, `
            L `).concat(t + r - l * C, ",").concat(n, `
            A `).concat(C, ",").concat(C, ",0,0,").concat(c, ",").concat(t + r, ",").concat(n + s * C, `
            L `).concat(t + r, ",").concat(n + o - s * C, `
            A `).concat(C, ",").concat(C, ",0,0,").concat(c, ",").concat(t + r - l * C, ",").concat(n + o, `
            L `).concat(t + l * C, ",").concat(n + o, `
            A `).concat(C, ",").concat(C, ",0,0,").concat(c, ",").concat(t, ",").concat(n + o - s * C, " Z");
  } else
    u = "M ".concat(t, ",").concat(n, " h ").concat(r, " v ").concat(o, " h ").concat(-r, " Z");
  return u;
}, M7e = function(t, n) {
  if (!t || !n)
    return !1;
  var r = t.x, o = t.y, i = n.x, a = n.y, s = n.width, l = n.height;
  if (Math.abs(s) > 0 && Math.abs(l) > 0) {
    var c = Math.min(i, i + s), u = Math.max(i, i + s), f = Math.min(a, a + l), h = Math.max(a, a + l);
    return r >= c && r <= u && o >= f && o <= h;
  }
  return !1;
}, E7e = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  // The radius of border
  // The radius of four corners when radius is a number
  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
  radius: 0,
  isAnimationActive: !1,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, rm = function(t) {
  var n = FM(FM({}, E7e), t), r = ke(), o = ue(-1), i = g7e(o, 2), a = i[0], s = i[1];
  ve(function() {
    if (r.current && r.current.getTotalLength)
      try {
        var x = r.current.getTotalLength();
        x && s(x);
      } catch {
      }
  }, []);
  var l = n.x, c = n.y, u = n.width, f = n.height, h = n.radius, p = n.className, C = n.animationEasing, m = n.animationDuration, g = n.animationBegin, v = n.isAnimationActive, y = n.isUpdateAnimationActive;
  if (l !== +l || c !== +c || u !== +u || f !== +f || u === 0 || f === 0)
    return null;
  var w = We("recharts-rectangle", p);
  return y ? /* @__PURE__ */ O.createElement(Ur, {
    canBegin: a > 0,
    from: {
      width: u,
      height: f,
      x: l,
      y: c
    },
    to: {
      width: u,
      height: f,
      x: l,
      y: c
    },
    duration: m,
    animationEasing: C,
    isActive: y
  }, function(x) {
    var b = x.width, S = x.height, M = x.x, E = x.y;
    return /* @__PURE__ */ O.createElement(Ur, {
      canBegin: a > 0,
      from: "0px ".concat(a === -1 ? 1 : a, "px"),
      to: "".concat(a, "px 0px"),
      attributeName: "strokeDasharray",
      begin: g,
      duration: m,
      isActive: v,
      easing: C
    }, /* @__PURE__ */ O.createElement("path", X5({}, Be(n, !0), {
      className: w,
      d: VM(M, E, b, S, h),
      ref: r
    })));
  }) : /* @__PURE__ */ O.createElement("path", X5({}, Be(n, !0), {
    className: w,
    d: VM(l, c, u, f, h)
  }));
};
function td() {
  return td = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, td.apply(this, arguments);
}
var M0 = function(t) {
  var n = t.cx, r = t.cy, o = t.r, i = t.className, a = We("recharts-dot", i);
  return n === +n && r === +r && o === +o ? /* @__PURE__ */ A.createElement("circle", td({}, Be(t, !1), y5(t), {
    className: a,
    cx: n,
    cy: r,
    r: o
  })) : null;
};
function h2(e) {
  "@babel/helpers - typeof";
  return h2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, h2(e);
}
var _7e = ["x", "y", "top", "left", "width", "height", "className"];
function nd() {
  return nd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, nd.apply(this, arguments);
}
function BM(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function O7e(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? BM(Object(n), !0).forEach(function(r) {
      A7e(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : BM(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function A7e(e, t, n) {
  return t = P7e(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function P7e(e) {
  var t = T7e(e, "string");
  return h2(t) == "symbol" ? t : t + "";
}
function T7e(e, t) {
  if (h2(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (h2(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function I7e(e, t) {
  if (e == null) return {};
  var n = D7e(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function D7e(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
var R7e = function(t, n, r, o, i, a) {
  return "M".concat(t, ",").concat(i, "v").concat(o, "M").concat(a, ",").concat(n, "h").concat(r);
}, k7e = function(t) {
  var n = t.x, r = n === void 0 ? 0 : n, o = t.y, i = o === void 0 ? 0 : o, a = t.top, s = a === void 0 ? 0 : a, l = t.left, c = l === void 0 ? 0 : l, u = t.width, f = u === void 0 ? 0 : u, h = t.height, p = h === void 0 ? 0 : h, C = t.className, m = I7e(t, _7e), g = O7e({
    x: r,
    y: i,
    top: s,
    left: c,
    width: f,
    height: p
  }, m);
  return !he(r) || !he(i) || !he(f) || !he(p) || !he(s) || !he(c) ? null : /* @__PURE__ */ O.createElement("path", nd({}, Be(g, !0), {
    className: We("recharts-cross", C),
    d: R7e(r, i, f, p, s, c)
  }));
}, V4, $M;
function L7e() {
  if ($M) return V4;
  $M = 1;
  var e = ID(), t = e(Object.getPrototypeOf, Object);
  return V4 = t, V4;
}
var B4, jM;
function N7e() {
  if (jM) return B4;
  jM = 1;
  var e = t1(), t = L7e(), n = n1(), r = "[object Object]", o = Function.prototype, i = Object.prototype, a = o.toString, s = i.hasOwnProperty, l = a.call(Object);
  function c(u) {
    if (!n(u) || e(u) != r)
      return !1;
    var f = t(u);
    if (f === null)
      return !0;
    var h = s.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && a.call(h) == l;
  }
  return B4 = c, B4;
}
var F7e = N7e();
const V7e = /* @__PURE__ */ Mt(F7e);
var $4, HM;
function B7e() {
  if (HM) return $4;
  HM = 1;
  var e = t1(), t = n1(), n = "[object Boolean]";
  function r(o) {
    return o === !0 || o === !1 || t(o) && e(o) == n;
  }
  return $4 = r, $4;
}
var $7e = B7e();
const j7e = /* @__PURE__ */ Mt($7e);
function p2(e) {
  "@babel/helpers - typeof";
  return p2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, p2(e);
}
function Q5() {
  return Q5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Q5.apply(this, arguments);
}
function H7e(e, t) {
  return q7e(e) || W7e(e, t) || Z7e(e, t) || z7e();
}
function z7e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Z7e(e, t) {
  if (e) {
    if (typeof e == "string") return zM(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return zM(e, t);
  }
}
function zM(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function W7e(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, o, i, a, s = [], l = !0, c = !1;
    try {
      if (i = (n = n.call(e)).next, t !== 0) for (; !(l = (r = i.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (u) {
      c = !0, o = u;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw o;
      }
    }
    return s;
  }
}
function q7e(e) {
  if (Array.isArray(e)) return e;
}
function ZM(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function WM(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ZM(Object(n), !0).forEach(function(r) {
      U7e(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ZM(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function U7e(e, t, n) {
  return t = G7e(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function G7e(e) {
  var t = K7e(e, "string");
  return p2(t) == "symbol" ? t : t + "";
}
function K7e(e, t) {
  if (p2(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (p2(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var qM = function(t, n, r, o, i) {
  var a = r - o, s;
  return s = "M ".concat(t, ",").concat(n), s += "L ".concat(t + r, ",").concat(n), s += "L ".concat(t + r - a / 2, ",").concat(n + i), s += "L ".concat(t + r - a / 2 - o, ",").concat(n + i), s += "L ".concat(t, ",").concat(n, " Z"), s;
}, Y7e = {
  x: 0,
  y: 0,
  upperWidth: 0,
  lowerWidth: 0,
  height: 0,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, X7e = function(t) {
  var n = WM(WM({}, Y7e), t), r = ke(), o = ue(-1), i = H7e(o, 2), a = i[0], s = i[1];
  ve(function() {
    if (r.current && r.current.getTotalLength)
      try {
        var w = r.current.getTotalLength();
        w && s(w);
      } catch {
      }
  }, []);
  var l = n.x, c = n.y, u = n.upperWidth, f = n.lowerWidth, h = n.height, p = n.className, C = n.animationEasing, m = n.animationDuration, g = n.animationBegin, v = n.isUpdateAnimationActive;
  if (l !== +l || c !== +c || u !== +u || f !== +f || h !== +h || u === 0 && f === 0 || h === 0)
    return null;
  var y = We("recharts-trapezoid", p);
  return v ? /* @__PURE__ */ O.createElement(Ur, {
    canBegin: a > 0,
    from: {
      upperWidth: 0,
      lowerWidth: 0,
      height: h,
      x: l,
      y: c
    },
    to: {
      upperWidth: u,
      lowerWidth: f,
      height: h,
      x: l,
      y: c
    },
    duration: m,
    animationEasing: C,
    isActive: v
  }, function(w) {
    var x = w.upperWidth, b = w.lowerWidth, S = w.height, M = w.x, E = w.y;
    return /* @__PURE__ */ O.createElement(Ur, {
      canBegin: a > 0,
      from: "0px ".concat(a === -1 ? 1 : a, "px"),
      to: "".concat(a, "px 0px"),
      attributeName: "strokeDasharray",
      begin: g,
      duration: m,
      easing: C
    }, /* @__PURE__ */ O.createElement("path", Q5({}, Be(n, !0), {
      className: y,
      d: qM(M, E, x, b, S),
      ref: r
    })));
  }) : /* @__PURE__ */ O.createElement("g", null, /* @__PURE__ */ O.createElement("path", Q5({}, Be(n, !0), {
    className: y,
    d: qM(l, c, u, f, h)
  })));
}, Q7e = ["option", "shapeType", "propTransformer", "activeClassName", "isActive"];
function m2(e) {
  "@babel/helpers - typeof";
  return m2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, m2(e);
}
function J7e(e, t) {
  if (e == null) return {};
  var n = e3e(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function e3e(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function UM(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function J5(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? UM(Object(n), !0).forEach(function(r) {
      t3e(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : UM(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function t3e(e, t, n) {
  return t = n3e(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function n3e(e) {
  var t = r3e(e, "string");
  return m2(t) == "symbol" ? t : t + "";
}
function r3e(e, t) {
  if (m2(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (m2(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function o3e(e, t) {
  return J5(J5({}, t), e);
}
function i3e(e, t) {
  return e === "symbols";
}
function GM(e) {
  var t = e.shapeType, n = e.elementProps;
  switch (t) {
    case "rectangle":
      return /* @__PURE__ */ O.createElement(rm, n);
    case "trapezoid":
      return /* @__PURE__ */ O.createElement(X7e, n);
    case "sector":
      return /* @__PURE__ */ O.createElement(rk, n);
    case "symbols":
      if (i3e(t))
        return /* @__PURE__ */ O.createElement(f0, n);
      break;
    default:
      return null;
  }
}
function a3e(e) {
  return /* @__PURE__ */ sr(e) ? e.props : e;
}
function rd(e) {
  var t = e.option, n = e.shapeType, r = e.propTransformer, o = r === void 0 ? o3e : r, i = e.activeClassName, a = i === void 0 ? "recharts-active-shape" : i, s = e.isActive, l = J7e(e, Q7e), c;
  if (/* @__PURE__ */ sr(t))
    c = /* @__PURE__ */ Qt(t, J5(J5({}, l), a3e(t)));
  else if (je(t))
    c = t(l);
  else if (V7e(t) && !j7e(t)) {
    var u = o(t, l);
    c = /* @__PURE__ */ O.createElement(GM, {
      shapeType: n,
      elementProps: u
    });
  } else {
    var f = l;
    c = /* @__PURE__ */ O.createElement(GM, {
      shapeType: n,
      elementProps: f
    });
  }
  return s ? /* @__PURE__ */ O.createElement(rt, {
    className: a
  }, c) : c;
}
function E0(e, t) {
  return t != null && "trapezoids" in e.props;
}
function _0(e, t) {
  return t != null && "sectors" in e.props;
}
function g2(e, t) {
  return t != null && "points" in e.props;
}
function s3e(e, t) {
  var n, r, o = e.x === (t == null || (n = t.labelViewBox) === null || n === void 0 ? void 0 : n.x) || e.x === t.x, i = e.y === (t == null || (r = t.labelViewBox) === null || r === void 0 ? void 0 : r.y) || e.y === t.y;
  return o && i;
}
function l3e(e, t) {
  var n = e.endAngle === t.endAngle, r = e.startAngle === t.startAngle;
  return n && r;
}
function c3e(e, t) {
  var n = e.x === t.x, r = e.y === t.y, o = e.z === t.z;
  return n && r && o;
}
function u3e(e, t) {
  var n;
  return E0(e, t) ? n = s3e : _0(e, t) ? n = l3e : g2(e, t) && (n = c3e), n;
}
function f3e(e, t) {
  var n;
  return E0(e, t) ? n = "trapezoids" : _0(e, t) ? n = "sectors" : g2(e, t) && (n = "points"), n;
}
function d3e(e, t) {
  if (E0(e, t)) {
    var n;
    return (n = t.tooltipPayload) === null || n === void 0 || (n = n[0]) === null || n === void 0 || (n = n.payload) === null || n === void 0 ? void 0 : n.payload;
  }
  if (_0(e, t)) {
    var r;
    return (r = t.tooltipPayload) === null || r === void 0 || (r = r[0]) === null || r === void 0 || (r = r.payload) === null || r === void 0 ? void 0 : r.payload;
  }
  return g2(e, t) ? t.payload : {};
}
function h3e(e) {
  var t = e.activeTooltipItem, n = e.graphicalItem, r = e.itemData, o = f3e(n, t), i = d3e(n, t), a = r.filter(function(l, c) {
    var u = Oi(i, l), f = n.props[o].filter(function(C) {
      var m = u3e(n, t);
      return m(C, t);
    }), h = n.props[o].indexOf(f[f.length - 1]), p = c === h;
    return u && p;
  }), s = r.indexOf(a[a.length - 1]);
  return s;
}
var j4, KM;
function p3e() {
  if (KM) return j4;
  KM = 1;
  var e = Math.ceil, t = Math.max;
  function n(r, o, i, a) {
    for (var s = -1, l = t(e((o - r) / (i || 1)), 0), c = Array(l); l--; )
      c[a ? l : ++s] = r, r += i;
    return c;
  }
  return j4 = n, j4;
}
var H4, YM;
function fk() {
  if (YM) return H4;
  YM = 1;
  var e = UD(), t = 1 / 0, n = 17976931348623157e292;
  function r(o) {
    if (!o)
      return o === 0 ? o : 0;
    if (o = e(o), o === t || o === -t) {
      var i = o < 0 ? -1 : 1;
      return i * n;
    }
    return o === o ? o : 0;
  }
  return H4 = r, H4;
}
var z4, XM;
function m3e() {
  if (XM) return z4;
  XM = 1;
  var e = p3e(), t = p0(), n = fk();
  function r(o) {
    return function(i, a, s) {
      return s && typeof s != "number" && t(i, a, s) && (a = s = void 0), i = n(i), a === void 0 ? (a = i, i = 0) : a = n(a), s = s === void 0 ? i < a ? 1 : -1 : n(s), e(i, a, s, o);
    };
  }
  return z4 = r, z4;
}
var Z4, QM;
function g3e() {
  if (QM) return Z4;
  QM = 1;
  var e = m3e(), t = e();
  return Z4 = t, Z4;
}
var C3e = g3e();
const eu = /* @__PURE__ */ Mt(C3e);
function C2(e) {
  "@babel/helpers - typeof";
  return C2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, C2(e);
}
function JM(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function eE(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? JM(Object(n), !0).forEach(function(r) {
      dk(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : JM(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function dk(e, t, n) {
  return t = v3e(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function v3e(e) {
  var t = y3e(e, "string");
  return C2(t) == "symbol" ? t : t + "";
}
function y3e(e, t) {
  if (C2(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (C2(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var b3e = ["Webkit", "Moz", "O", "ms"], w3e = function(t, n) {
  var r = t.replace(/(\w)/, function(i) {
    return i.toUpperCase();
  }), o = b3e.reduce(function(i, a) {
    return eE(eE({}, i), {}, dk({}, a + r, n));
  }, {});
  return o[t] = n, o;
};
function Qa(e) {
  "@babel/helpers - typeof";
  return Qa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Qa(e);
}
function tu() {
  return tu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, tu.apply(this, arguments);
}
function tE(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function W4(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? tE(Object(n), !0).forEach(function(r) {
      er(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : tE(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function x3e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function nE(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, pk(r.key), r);
  }
}
function S3e(e, t, n) {
  return t && nE(e.prototype, t), n && nE(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function M3e(e, t, n) {
  return t = nu(t), E3e(e, hk() ? Reflect.construct(t, n || [], nu(e).constructor) : t.apply(e, n));
}
function E3e(e, t) {
  if (t && (Qa(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _3e(e);
}
function _3e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function hk() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (hk = function() {
    return !!e;
  })();
}
function nu(e) {
  return nu = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, nu(e);
}
function O3e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && od(e, t);
}
function od(e, t) {
  return od = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, od(e, t);
}
function er(e, t, n) {
  return t = pk(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function pk(e) {
  var t = A3e(e, "string");
  return Qa(t) == "symbol" ? t : t + "";
}
function A3e(e, t) {
  if (Qa(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Qa(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var P3e = function(t) {
  var n = t.data, r = t.startIndex, o = t.endIndex, i = t.x, a = t.width, s = t.travellerWidth;
  if (!n || !n.length)
    return {};
  var l = n.length, c = wl().domain(eu(0, l)).range([i, i + a - s]), u = c.domain().map(function(f) {
    return c(f);
  });
  return {
    isTextActive: !1,
    isSlideMoving: !1,
    isTravellerMoving: !1,
    isTravellerFocused: !1,
    startX: c(r),
    endX: c(o),
    scale: c,
    scaleValues: u
  };
}, rE = function(t) {
  return t.changedTouches && !!t.changedTouches.length;
}, Ja = /* @__PURE__ */ (function(e) {
  function t(n) {
    var r;
    return x3e(this, t), r = M3e(this, t, [n]), er(r, "handleDrag", function(o) {
      r.leaveTimer && (clearTimeout(r.leaveTimer), r.leaveTimer = null), r.state.isTravellerMoving ? r.handleTravellerMove(o) : r.state.isSlideMoving && r.handleSlideDrag(o);
    }), er(r, "handleTouchMove", function(o) {
      o.changedTouches != null && o.changedTouches.length > 0 && r.handleDrag(o.changedTouches[0]);
    }), er(r, "handleDragEnd", function() {
      r.setState({
        isTravellerMoving: !1,
        isSlideMoving: !1
      }, function() {
        var o = r.props, i = o.endIndex, a = o.onDragEnd, s = o.startIndex;
        a?.({
          endIndex: i,
          startIndex: s
        });
      }), r.detachDragEndListener();
    }), er(r, "handleLeaveWrapper", function() {
      (r.state.isTravellerMoving || r.state.isSlideMoving) && (r.leaveTimer = window.setTimeout(r.handleDragEnd, r.props.leaveTimeOut));
    }), er(r, "handleEnterSlideOrTraveller", function() {
      r.setState({
        isTextActive: !0
      });
    }), er(r, "handleLeaveSlideOrTraveller", function() {
      r.setState({
        isTextActive: !1
      });
    }), er(r, "handleSlideDragStart", function(o) {
      var i = rE(o) ? o.changedTouches[0] : o;
      r.setState({
        isTravellerMoving: !1,
        isSlideMoving: !0,
        slideMoveStartX: i.pageX
      }), r.attachDragEndListener();
    }), r.travellerDragStartHandlers = {
      startX: r.handleTravellerDragStart.bind(r, "startX"),
      endX: r.handleTravellerDragStart.bind(r, "endX")
    }, r.state = {}, r;
  }
  return O3e(t, e), S3e(t, [{
    key: "componentWillUnmount",
    value: function() {
      this.leaveTimer && (clearTimeout(this.leaveTimer), this.leaveTimer = null), this.detachDragEndListener();
    }
  }, {
    key: "getIndex",
    value: function(r) {
      var o = r.startX, i = r.endX, a = this.state.scaleValues, s = this.props, l = s.gap, c = s.data, u = c.length - 1, f = Math.min(o, i), h = Math.max(o, i), p = t.getIndexInRange(a, f), C = t.getIndexInRange(a, h);
      return {
        startIndex: p - p % l,
        endIndex: C === u ? u : C - C % l
      };
    }
  }, {
    key: "getTextOfTick",
    value: function(r) {
      var o = this.props, i = o.data, a = o.tickFormatter, s = o.dataKey, l = cn(i[r], s, r);
      return je(a) ? a(l, r) : l;
    }
  }, {
    key: "attachDragEndListener",
    value: function() {
      window.addEventListener("mouseup", this.handleDragEnd, !0), window.addEventListener("touchend", this.handleDragEnd, !0), window.addEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "detachDragEndListener",
    value: function() {
      window.removeEventListener("mouseup", this.handleDragEnd, !0), window.removeEventListener("touchend", this.handleDragEnd, !0), window.removeEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "handleSlideDrag",
    value: function(r) {
      var o = this.state, i = o.slideMoveStartX, a = o.startX, s = o.endX, l = this.props, c = l.x, u = l.width, f = l.travellerWidth, h = l.startIndex, p = l.endIndex, C = l.onChange, m = r.pageX - i;
      m > 0 ? m = Math.min(m, c + u - f - s, c + u - f - a) : m < 0 && (m = Math.max(m, c - a, c - s));
      var g = this.getIndex({
        startX: a + m,
        endX: s + m
      });
      (g.startIndex !== h || g.endIndex !== p) && C && C(g), this.setState({
        startX: a + m,
        endX: s + m,
        slideMoveStartX: r.pageX
      });
    }
  }, {
    key: "handleTravellerDragStart",
    value: function(r, o) {
      var i = rE(o) ? o.changedTouches[0] : o;
      this.setState({
        isSlideMoving: !1,
        isTravellerMoving: !0,
        movingTravellerId: r,
        brushMoveStartX: i.pageX
      }), this.attachDragEndListener();
    }
  }, {
    key: "handleTravellerMove",
    value: function(r) {
      var o = this.state, i = o.brushMoveStartX, a = o.movingTravellerId, s = o.endX, l = o.startX, c = this.state[a], u = this.props, f = u.x, h = u.width, p = u.travellerWidth, C = u.onChange, m = u.gap, g = u.data, v = {
        startX: this.state.startX,
        endX: this.state.endX
      }, y = r.pageX - i;
      y > 0 ? y = Math.min(y, f + h - p - c) : y < 0 && (y = Math.max(y, f - c)), v[a] = c + y;
      var w = this.getIndex(v), x = w.startIndex, b = w.endIndex, S = function() {
        var E = g.length - 1;
        return a === "startX" && (s > l ? x % m === 0 : b % m === 0) || s < l && b === E || a === "endX" && (s > l ? b % m === 0 : x % m === 0) || s > l && b === E;
      };
      this.setState(er(er({}, a, c + y), "brushMoveStartX", r.pageX), function() {
        C && S() && C(w);
      });
    }
  }, {
    key: "handleTravellerMoveKeyboard",
    value: function(r, o) {
      var i = this, a = this.state, s = a.scaleValues, l = a.startX, c = a.endX, u = this.state[o], f = s.indexOf(u);
      if (f !== -1) {
        var h = f + r;
        if (!(h === -1 || h >= s.length)) {
          var p = s[h];
          o === "startX" && p >= c || o === "endX" && p <= l || this.setState(er({}, o, p), function() {
            i.props.onChange(i.getIndex({
              startX: i.state.startX,
              endX: i.state.endX
            }));
          });
        }
      }
    }
  }, {
    key: "renderBackground",
    value: function() {
      var r = this.props, o = r.x, i = r.y, a = r.width, s = r.height, l = r.fill, c = r.stroke;
      return /* @__PURE__ */ O.createElement("rect", {
        stroke: c,
        fill: l,
        x: o,
        y: i,
        width: a,
        height: s
      });
    }
  }, {
    key: "renderPanorama",
    value: function() {
      var r = this.props, o = r.x, i = r.y, a = r.width, s = r.height, l = r.data, c = r.children, u = r.padding, f = ar.only(c);
      return f ? /* @__PURE__ */ O.cloneElement(f, {
        x: o,
        y: i,
        width: a,
        height: s,
        margin: u,
        compact: !0,
        data: l
      }) : null;
    }
  }, {
    key: "renderTravellerLayer",
    value: function(r, o) {
      var i, a, s = this, l = this.props, c = l.y, u = l.travellerWidth, f = l.height, h = l.traveller, p = l.ariaLabel, C = l.data, m = l.startIndex, g = l.endIndex, v = Math.max(r, this.props.x), y = W4(W4({}, Be(this.props, !1)), {}, {
        x: v,
        y: c,
        width: u,
        height: f
      }), w = p || "Min value: ".concat((i = C[m]) === null || i === void 0 ? void 0 : i.name, ", Max value: ").concat((a = C[g]) === null || a === void 0 ? void 0 : a.name);
      return /* @__PURE__ */ O.createElement(rt, {
        tabIndex: 0,
        role: "slider",
        "aria-label": w,
        "aria-valuenow": r,
        className: "recharts-brush-traveller",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.travellerDragStartHandlers[o],
        onTouchStart: this.travellerDragStartHandlers[o],
        onKeyDown: function(b) {
          ["ArrowLeft", "ArrowRight"].includes(b.key) && (b.preventDefault(), b.stopPropagation(), s.handleTravellerMoveKeyboard(b.key === "ArrowRight" ? 1 : -1, o));
        },
        onFocus: function() {
          s.setState({
            isTravellerFocused: !0
          });
        },
        onBlur: function() {
          s.setState({
            isTravellerFocused: !1
          });
        },
        style: {
          cursor: "col-resize"
        }
      }, t.renderTraveller(h, y));
    }
  }, {
    key: "renderSlide",
    value: function(r, o) {
      var i = this.props, a = i.y, s = i.height, l = i.stroke, c = i.travellerWidth, u = Math.min(r, o) + c, f = Math.max(Math.abs(o - r) - c, 0);
      return /* @__PURE__ */ O.createElement("rect", {
        className: "recharts-brush-slide",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.handleSlideDragStart,
        onTouchStart: this.handleSlideDragStart,
        style: {
          cursor: "move"
        },
        stroke: "none",
        fill: l,
        fillOpacity: 0.2,
        x: u,
        y: a,
        width: f,
        height: s
      });
    }
  }, {
    key: "renderText",
    value: function() {
      var r = this.props, o = r.startIndex, i = r.endIndex, a = r.y, s = r.height, l = r.travellerWidth, c = r.stroke, u = this.state, f = u.startX, h = u.endX, p = 5, C = {
        pointerEvents: "none",
        fill: c
      };
      return /* @__PURE__ */ O.createElement(rt, {
        className: "recharts-brush-texts"
      }, /* @__PURE__ */ O.createElement(T5, tu({
        textAnchor: "end",
        verticalAnchor: "middle",
        x: Math.min(f, h) - p,
        y: a + s / 2
      }, C), this.getTextOfTick(o)), /* @__PURE__ */ O.createElement(T5, tu({
        textAnchor: "start",
        verticalAnchor: "middle",
        x: Math.max(f, h) + l + p,
        y: a + s / 2
      }, C), this.getTextOfTick(i)));
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, o = r.data, i = r.className, a = r.children, s = r.x, l = r.y, c = r.width, u = r.height, f = r.alwaysShowText, h = this.state, p = h.startX, C = h.endX, m = h.isTextActive, g = h.isSlideMoving, v = h.isTravellerMoving, y = h.isTravellerFocused;
      if (!o || !o.length || !he(s) || !he(l) || !he(c) || !he(u) || c <= 0 || u <= 0)
        return null;
      var w = We("recharts-brush", i), x = O.Children.count(a) === 1, b = w3e("userSelect", "none");
      return /* @__PURE__ */ O.createElement(rt, {
        className: w,
        onMouseLeave: this.handleLeaveWrapper,
        onTouchMove: this.handleTouchMove,
        style: b
      }, this.renderBackground(), x && this.renderPanorama(), this.renderSlide(p, C), this.renderTravellerLayer(p, "startX"), this.renderTravellerLayer(C, "endX"), (m || g || v || y || f) && this.renderText());
    }
  }], [{
    key: "renderDefaultTraveller",
    value: function(r) {
      var o = r.x, i = r.y, a = r.width, s = r.height, l = r.stroke, c = Math.floor(i + s / 2) - 1;
      return /* @__PURE__ */ O.createElement(O.Fragment, null, /* @__PURE__ */ O.createElement("rect", {
        x: o,
        y: i,
        width: a,
        height: s,
        fill: l,
        stroke: "none"
      }), /* @__PURE__ */ O.createElement("line", {
        x1: o + 1,
        y1: c,
        x2: o + a - 1,
        y2: c,
        fill: "none",
        stroke: "#fff"
      }), /* @__PURE__ */ O.createElement("line", {
        x1: o + 1,
        y1: c + 2,
        x2: o + a - 1,
        y2: c + 2,
        fill: "none",
        stroke: "#fff"
      }));
    }
  }, {
    key: "renderTraveller",
    value: function(r, o) {
      var i;
      return /* @__PURE__ */ O.isValidElement(r) ? i = /* @__PURE__ */ O.cloneElement(r, o) : je(r) ? i = r(o) : i = t.renderDefaultTraveller(o), i;
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function(r, o) {
      var i = r.data, a = r.width, s = r.x, l = r.travellerWidth, c = r.updateId, u = r.startIndex, f = r.endIndex;
      if (i !== o.prevData || c !== o.prevUpdateId)
        return W4({
          prevData: i,
          prevTravellerWidth: l,
          prevUpdateId: c,
          prevX: s,
          prevWidth: a
        }, i && i.length ? P3e({
          data: i,
          width: a,
          x: s,
          travellerWidth: l,
          startIndex: u,
          endIndex: f
        }) : {
          scale: null,
          scaleValues: null
        });
      if (o.scale && (a !== o.prevWidth || s !== o.prevX || l !== o.prevTravellerWidth)) {
        o.scale.range([s, s + a - l]);
        var h = o.scale.domain().map(function(p) {
          return o.scale(p);
        });
        return {
          prevData: i,
          prevTravellerWidth: l,
          prevUpdateId: c,
          prevX: s,
          prevWidth: a,
          startX: o.scale(r.startIndex),
          endX: o.scale(r.endIndex),
          scaleValues: h
        };
      }
      return null;
    }
  }, {
    key: "getIndexInRange",
    value: function(r, o) {
      for (var i = r.length, a = 0, s = i - 1; s - a > 1; ) {
        var l = Math.floor((a + s) / 2);
        r[l] > o ? s = l : a = l;
      }
      return o >= r[s] ? s : a;
    }
  }]);
})(xo);
er(Ja, "displayName", "Brush");
er(Ja, "defaultProps", {
  height: 40,
  travellerWidth: 5,
  gap: 1,
  fill: "#fff",
  stroke: "#666",
  padding: {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  },
  leaveTimeOut: 1e3,
  alwaysShowText: !1
});
var q4, oE;
function T3e() {
  if (oE) return q4;
  oE = 1;
  var e = Ap();
  function t(n, r) {
    var o;
    return e(n, function(i, a, s) {
      return o = r(i, a, s), !o;
    }), !!o;
  }
  return q4 = t, q4;
}
var U4, iE;
function I3e() {
  if (iE) return U4;
  iE = 1;
  var e = MD(), t = B1(), n = T3e(), r = Qn(), o = p0();
  function i(a, s, l) {
    var c = r(a) ? e : n;
    return l && o(a, s, l) && (s = void 0), c(a, t(s, 3));
  }
  return U4 = i, U4;
}
var D3e = I3e();
const R3e = /* @__PURE__ */ Mt(D3e);
var Co = function(t, n) {
  var r = t.alwaysShow, o = t.ifOverflow;
  return r && (o = "extendDomain"), o === n;
}, G4, aE;
function k3e() {
  if (aE) return G4;
  aE = 1;
  var e = HD();
  function t(n, r, o) {
    r == "__proto__" && e ? e(n, r, {
      configurable: !0,
      enumerable: !0,
      value: o,
      writable: !0
    }) : n[r] = o;
  }
  return G4 = t, G4;
}
var K4, sE;
function L3e() {
  if (sE) return K4;
  sE = 1;
  var e = k3e(), t = $D(), n = B1();
  function r(o, i) {
    var a = {};
    return i = n(i, 3), t(o, function(s, l, c) {
      e(a, l, i(s, l, c));
    }), a;
  }
  return K4 = r, K4;
}
var N3e = L3e();
const F3e = /* @__PURE__ */ Mt(N3e);
var Y4, lE;
function V3e() {
  if (lE) return Y4;
  lE = 1;
  function e(t, n) {
    for (var r = -1, o = t == null ? 0 : t.length; ++r < o; )
      if (!n(t[r], r, t))
        return !1;
    return !0;
  }
  return Y4 = e, Y4;
}
var X4, cE;
function B3e() {
  if (cE) return X4;
  cE = 1;
  var e = Ap();
  function t(n, r) {
    var o = !0;
    return e(n, function(i, a, s) {
      return o = !!r(i, a, s), o;
    }), o;
  }
  return X4 = t, X4;
}
var Q4, uE;
function $3e() {
  if (uE) return Q4;
  uE = 1;
  var e = V3e(), t = B3e(), n = B1(), r = Qn(), o = p0();
  function i(a, s, l) {
    var c = r(a) ? e : t;
    return l && o(a, s, l) && (s = void 0), c(a, n(s, 3));
  }
  return Q4 = i, Q4;
}
var j3e = $3e();
const mk = /* @__PURE__ */ Mt(j3e);
var H3e = ["x", "y"];
function es(e) {
  "@babel/helpers - typeof";
  return es = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, es(e);
}
function id() {
  return id = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, id.apply(this, arguments);
}
function fE(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function rl(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? fE(Object(n), !0).forEach(function(r) {
      z3e(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : fE(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function z3e(e, t, n) {
  return t = Z3e(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Z3e(e) {
  var t = W3e(e, "string");
  return es(t) == "symbol" ? t : t + "";
}
function W3e(e, t) {
  if (es(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (es(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function q3e(e, t) {
  if (e == null) return {};
  var n = U3e(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function U3e(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function G3e(e, t) {
  var n = e.x, r = e.y, o = q3e(e, H3e), i = "".concat(n), a = parseInt(i, 10), s = "".concat(r), l = parseInt(s, 10), c = "".concat(t.height || o.height), u = parseInt(c, 10), f = "".concat(t.width || o.width), h = parseInt(f, 10);
  return rl(rl(rl(rl(rl({}, t), o), a ? {
    x: a
  } : {}), l ? {
    y: l
  } : {}), {}, {
    height: u,
    width: h,
    name: t.name,
    radius: t.radius
  });
}
function dE(e) {
  return /* @__PURE__ */ O.createElement(rd, id({
    shapeType: "rectangle",
    propTransformer: G3e,
    activeClassName: "recharts-active-bar"
  }, e));
}
var K3e = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return function(r, o) {
    if (typeof t == "number") return t;
    var i = he(r) || aoe(r);
    return i ? t(r, o) : (i || (process.env.NODE_ENV !== "production" ? Gn(!1, "minPointSize callback function received a value with type of ".concat(es(r), ". Currently only numbers or null/undefined are supported.")) : Gn()), n);
  };
}, Y3e = ["value", "background"], gk;
function ts(e) {
  "@babel/helpers - typeof";
  return ts = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ts(e);
}
function X3e(e, t) {
  if (e == null) return {};
  var n = Q3e(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Q3e(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function ru() {
  return ru = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ru.apply(this, arguments);
}
function hE(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Xt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? hE(Object(n), !0).forEach(function(r) {
      y1(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : hE(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function J3e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function pE(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, vk(r.key), r);
  }
}
function e8e(e, t, n) {
  return t && pE(e.prototype, t), n && pE(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function t8e(e, t, n) {
  return t = ou(t), n8e(e, Ck() ? Reflect.construct(t, n || [], ou(e).constructor) : t.apply(e, n));
}
function n8e(e, t) {
  if (t && (ts(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return r8e(e);
}
function r8e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Ck() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Ck = function() {
    return !!e;
  })();
}
function ou(e) {
  return ou = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, ou(e);
}
function o8e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && ad(e, t);
}
function ad(e, t) {
  return ad = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, ad(e, t);
}
function y1(e, t, n) {
  return t = vk(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function vk(e) {
  var t = i8e(e, "string");
  return ts(t) == "symbol" ? t : t + "";
}
function i8e(e, t) {
  if (ts(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (ts(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var zi = /* @__PURE__ */ (function(e) {
  function t() {
    var n;
    J3e(this, t);
    for (var r = arguments.length, o = new Array(r), i = 0; i < r; i++)
      o[i] = arguments[i];
    return n = t8e(this, t, [].concat(o)), y1(n, "state", {
      isAnimationFinished: !1
    }), y1(n, "id", Bi("recharts-bar-")), y1(n, "handleAnimationEnd", function() {
      var a = n.props.onAnimationEnd;
      n.setState({
        isAnimationFinished: !0
      }), a && a();
    }), y1(n, "handleAnimationStart", function() {
      var a = n.props.onAnimationStart;
      n.setState({
        isAnimationFinished: !1
      }), a && a();
    }), n;
  }
  return o8e(t, e), e8e(t, [{
    key: "renderRectanglesStatically",
    value: function(r) {
      var o = this, i = this.props, a = i.shape, s = i.dataKey, l = i.activeIndex, c = i.activeBar, u = Be(this.props, !1);
      return r && r.map(function(f, h) {
        var p = h === l, C = p ? c : a, m = Xt(Xt(Xt({}, u), f), {}, {
          isActive: p,
          option: C,
          index: h,
          dataKey: s,
          onAnimationStart: o.handleAnimationStart,
          onAnimationEnd: o.handleAnimationEnd
        });
        return /* @__PURE__ */ O.createElement(rt, ru({
          className: "recharts-bar-rectangle"
        }, jl(o.props, f, h), {
          // https://github.com/recharts/recharts/issues/5415
          // eslint-disable-next-line react/no-array-index-key
          key: "rectangle-".concat(f?.x, "-").concat(f?.y, "-").concat(f?.value, "-").concat(h)
        }), /* @__PURE__ */ O.createElement(dE, m));
      });
    }
  }, {
    key: "renderRectanglesWithAnimation",
    value: function() {
      var r = this, o = this.props, i = o.data, a = o.layout, s = o.isAnimationActive, l = o.animationBegin, c = o.animationDuration, u = o.animationEasing, f = o.animationId, h = this.state.prevData;
      return /* @__PURE__ */ O.createElement(Ur, {
        begin: l,
        duration: c,
        isActive: s,
        easing: u,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "bar-".concat(f),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(p) {
        var C = p.t, m = i.map(function(g, v) {
          var y = h && h[v];
          if (y) {
            var w = jt(y.x, g.x), x = jt(y.y, g.y), b = jt(y.width, g.width), S = jt(y.height, g.height);
            return Xt(Xt({}, g), {}, {
              x: w(C),
              y: x(C),
              width: b(C),
              height: S(C)
            });
          }
          if (a === "horizontal") {
            var M = jt(0, g.height), E = M(C);
            return Xt(Xt({}, g), {}, {
              y: g.y + g.height - E,
              height: E
            });
          }
          var P = jt(0, g.width), T = P(C);
          return Xt(Xt({}, g), {}, {
            width: T
          });
        });
        return /* @__PURE__ */ O.createElement(rt, null, r.renderRectanglesStatically(m));
      });
    }
  }, {
    key: "renderRectangles",
    value: function() {
      var r = this.props, o = r.data, i = r.isAnimationActive, a = this.state.prevData;
      return i && o && o.length && (!a || !Oi(a, o)) ? this.renderRectanglesWithAnimation() : this.renderRectanglesStatically(o);
    }
  }, {
    key: "renderBackground",
    value: function() {
      var r = this, o = this.props, i = o.data, a = o.dataKey, s = o.activeIndex, l = Be(this.props.background, !1);
      return i.map(function(c, u) {
        c.value;
        var f = c.background, h = X3e(c, Y3e);
        if (!f)
          return null;
        var p = Xt(Xt(Xt(Xt(Xt({}, h), {}, {
          fill: "#eee"
        }, f), l), jl(r.props, c, u)), {}, {
          onAnimationStart: r.handleAnimationStart,
          onAnimationEnd: r.handleAnimationEnd,
          dataKey: a,
          index: u,
          className: "recharts-bar-background-rectangle"
        });
        return /* @__PURE__ */ O.createElement(dE, ru({
          key: "background-bar-".concat(u),
          option: r.props.background,
          isActive: u === s
        }, p));
      });
    }
  }, {
    key: "renderErrorBar",
    value: function(r, o) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var i = this.props, a = i.data, s = i.xAxis, l = i.yAxis, c = i.layout, u = i.children, f = Yn(u, Ts);
      if (!f)
        return null;
      var h = c === "vertical" ? a[0].height / 2 : a[0].width / 2, p = function(g, v) {
        var y = Array.isArray(g.value) ? g.value[1] : g.value;
        return {
          x: g.x,
          y: g.y,
          value: y,
          errorVal: cn(g, v)
        };
      }, C = {
        clipPath: r ? "url(#clipPath-".concat(o, ")") : null
      };
      return /* @__PURE__ */ O.createElement(rt, C, f.map(function(m) {
        return /* @__PURE__ */ O.cloneElement(m, {
          key: "error-bar-".concat(o, "-").concat(m.props.dataKey),
          data: a,
          xAxis: s,
          yAxis: l,
          layout: c,
          offset: h,
          dataPointFormatter: p
        });
      }));
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, o = r.hide, i = r.data, a = r.className, s = r.xAxis, l = r.yAxis, c = r.left, u = r.top, f = r.width, h = r.height, p = r.isAnimationActive, C = r.background, m = r.id;
      if (o || !i || !i.length)
        return null;
      var g = this.state.isAnimationFinished, v = We("recharts-bar", a), y = s && s.allowDataOverflow, w = l && l.allowDataOverflow, x = y || w, b = Ne(m) ? this.id : m;
      return /* @__PURE__ */ O.createElement(rt, {
        className: v
      }, y || w ? /* @__PURE__ */ O.createElement("defs", null, /* @__PURE__ */ O.createElement("clipPath", {
        id: "clipPath-".concat(b)
      }, /* @__PURE__ */ O.createElement("rect", {
        x: y ? c : c - f / 2,
        y: w ? u : u - h / 2,
        width: y ? f : f * 2,
        height: w ? h : h * 2
      }))) : null, /* @__PURE__ */ O.createElement(rt, {
        className: "recharts-bar-rectangles",
        clipPath: x ? "url(#clipPath-".concat(b, ")") : null
      }, C ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(x, b), (!p || g) && go.renderCallByParent(this.props, i));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(r, o) {
      return r.animationId !== o.prevAnimationId ? {
        prevAnimationId: r.animationId,
        curData: r.data,
        prevData: o.curData
      } : r.data !== o.curData ? {
        curData: r.data
      } : null;
    }
  }]);
})(xo);
gk = zi;
y1(zi, "displayName", "Bar");
y1(zi, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  legendType: "rect",
  minPointSize: 0,
  hide: !1,
  data: [],
  layout: "vertical",
  activeBar: !1,
  isAnimationActive: !$1.isSsr,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: "ease"
});
y1(zi, "getComposedData", function(e) {
  var t = e.props, n = e.item, r = e.barPosition, o = e.bandSize, i = e.xAxis, a = e.yAxis, s = e.xAxisTicks, l = e.yAxisTicks, c = e.stackedData, u = e.dataStartIndex, f = e.displayedData, h = e.offset, p = O5e(r, n);
  if (!p)
    return null;
  var C = t.layout, m = n.type.defaultProps, g = m !== void 0 ? Xt(Xt({}, m), n.props) : n.props, v = g.dataKey, y = g.children, w = g.minPointSize, x = C === "horizontal" ? a : i, b = c ? x.scale.domain() : null, S = L5e({
    numericAxis: x
  }), M = Yn(y, Ip), E = f.map(function(P, T) {
    var _, D, N, R, L, B;
    c ? _ = A5e(c[u + T], b) : (_ = cn(P, v), Array.isArray(_) || (_ = [S, _]));
    var V = K3e(w, gk.defaultProps.minPointSize)(_[1], T);
    if (C === "horizontal") {
      var k, z = [a.scale(_[0]), a.scale(_[1])], $ = z[0], Z = z[1];
      D = eM({
        axis: i,
        ticks: s,
        bandSize: o,
        offset: p.offset,
        entry: P,
        index: T
      }), N = (k = Z ?? $) !== null && k !== void 0 ? k : void 0, R = p.size;
      var W = $ - Z;
      if (L = Number.isNaN(W) ? 0 : W, B = {
        x: D,
        y: a.y,
        width: R,
        height: a.height
      }, Math.abs(V) > 0 && Math.abs(L) < Math.abs(V)) {
        var H = jr(L || V) * (Math.abs(V) - Math.abs(L));
        N -= H, L += H;
      }
    } else {
      var G = [i.scale(_[0]), i.scale(_[1])], Y = G[0], ne = G[1];
      if (D = Y, N = eM({
        axis: a,
        ticks: l,
        bandSize: o,
        offset: p.offset,
        entry: P,
        index: T
      }), R = ne - Y, L = p.size, B = {
        x: i.x,
        y: N,
        width: i.width,
        height: L
      }, Math.abs(V) > 0 && Math.abs(R) < Math.abs(V)) {
        var J = jr(R || V) * (Math.abs(V) - Math.abs(R));
        R += J;
      }
    }
    return Xt(Xt(Xt({}, P), {}, {
      x: D,
      y: N,
      width: R,
      height: L,
      value: c ? _ : _[1],
      payload: P,
      background: B
    }, M && M[T] && M[T].props), {}, {
      tooltipPayload: [ek(n, P)],
      tooltipPosition: {
        x: D + R / 2,
        y: N + L / 2
      }
    });
  });
  return Xt({
    data: E,
    layout: C
  }, h);
});
function v2(e) {
  "@babel/helpers - typeof";
  return v2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, v2(e);
}
function a8e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function mE(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, yk(r.key), r);
  }
}
function s8e(e, t, n) {
  return t && mE(e.prototype, t), n && mE(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function gE(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Nr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? gE(Object(n), !0).forEach(function(r) {
      O0(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : gE(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function O0(e, t, n) {
  return t = yk(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function yk(e) {
  var t = l8e(e, "string");
  return v2(t) == "symbol" ? t : t + "";
}
function l8e(e, t) {
  if (v2(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (v2(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var c8e = function(t, n, r, o, i) {
  var a = t.width, s = t.height, l = t.layout, c = t.children, u = Object.keys(n), f = {
    left: r.left,
    leftMirror: r.left,
    right: a - r.right,
    rightMirror: a - r.right,
    top: r.top,
    topMirror: r.top,
    bottom: s - r.bottom,
    bottomMirror: s - r.bottom
  }, h = !!nr(c, zi);
  return u.reduce(function(p, C) {
    var m = n[C], g = m.orientation, v = m.domain, y = m.padding, w = y === void 0 ? {} : y, x = m.mirror, b = m.reversed, S = "".concat(g).concat(x ? "Mirror" : ""), M, E, P, T, _;
    if (m.type === "number" && (m.padding === "gap" || m.padding === "no-gap")) {
      var D = v[1] - v[0], N = 1 / 0, R = m.categoricalDomain.sort(uoe);
      if (R.forEach(function(G, Y) {
        Y > 0 && (N = Math.min((G || 0) - (R[Y - 1] || 0), N));
      }), Number.isFinite(N)) {
        var L = N / D, B = m.layout === "vertical" ? r.height : r.width;
        if (m.padding === "gap" && (M = L * B / 2), m.padding === "no-gap") {
          var V = _i(t.barCategoryGap, L * B), k = L * B / 2;
          M = k - V - (k - V) / B * V;
        }
      }
    }
    o === "xAxis" ? E = [r.left + (w.left || 0) + (M || 0), r.left + r.width - (w.right || 0) - (M || 0)] : o === "yAxis" ? E = l === "horizontal" ? [r.top + r.height - (w.bottom || 0), r.top + (w.top || 0)] : [r.top + (w.top || 0) + (M || 0), r.top + r.height - (w.bottom || 0) - (M || 0)] : E = m.range, b && (E = [E[1], E[0]]);
    var z = E5e(m, i, h), $ = z.scale, Z = z.realScaleType;
    $.domain(v).range(E), _5e($);
    var W = k5e($, Nr(Nr({}, m), {}, {
      realScaleType: Z
    }));
    o === "xAxis" ? (_ = g === "top" && !x || g === "bottom" && x, P = r.left, T = f[S] - _ * m.height) : o === "yAxis" && (_ = g === "left" && !x || g === "right" && x, P = f[S] - _ * m.width, T = r.top);
    var H = Nr(Nr(Nr({}, m), W), {}, {
      realScaleType: Z,
      x: P,
      y: T,
      scale: $,
      width: o === "xAxis" ? r.width : m.width,
      height: o === "yAxis" ? r.height : m.height
    });
    return H.bandSize = Z5(H, W), !m.hide && o === "xAxis" ? f[S] += (_ ? -1 : 1) * H.height : m.hide || (f[S] += (_ ? -1 : 1) * H.width), Nr(Nr({}, p), {}, O0({}, C, H));
  }, {});
}, bk = function(t, n) {
  var r = t.x, o = t.y, i = n.x, a = n.y;
  return {
    x: Math.min(r, i),
    y: Math.min(o, a),
    width: Math.abs(i - r),
    height: Math.abs(a - o)
  };
}, u8e = function(t) {
  var n = t.x1, r = t.y1, o = t.x2, i = t.y2;
  return bk({
    x: n,
    y: r
  }, {
    x: o,
    y: i
  });
}, wk = /* @__PURE__ */ (function() {
  function e(t) {
    a8e(this, e), this.scale = t;
  }
  return s8e(e, [{
    key: "domain",
    get: function() {
      return this.scale.domain;
    }
  }, {
    key: "range",
    get: function() {
      return this.scale.range;
    }
  }, {
    key: "rangeMin",
    get: function() {
      return this.range()[0];
    }
  }, {
    key: "rangeMax",
    get: function() {
      return this.range()[1];
    }
  }, {
    key: "bandwidth",
    get: function() {
      return this.scale.bandwidth;
    }
  }, {
    key: "apply",
    value: function(n) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = r.bandAware, i = r.position;
      if (n !== void 0) {
        if (i)
          switch (i) {
            case "start":
              return this.scale(n);
            case "middle": {
              var a = this.bandwidth ? this.bandwidth() / 2 : 0;
              return this.scale(n) + a;
            }
            case "end": {
              var s = this.bandwidth ? this.bandwidth() : 0;
              return this.scale(n) + s;
            }
            default:
              return this.scale(n);
          }
        if (o) {
          var l = this.bandwidth ? this.bandwidth() / 2 : 0;
          return this.scale(n) + l;
        }
        return this.scale(n);
      }
    }
  }, {
    key: "isInRange",
    value: function(n) {
      var r = this.range(), o = r[0], i = r[r.length - 1];
      return o <= i ? n >= o && n <= i : n >= i && n <= o;
    }
  }], [{
    key: "create",
    value: function(n) {
      return new e(n);
    }
  }]);
})();
O0(wk, "EPS", 1e-4);
var om = function(t) {
  var n = Object.keys(t).reduce(function(r, o) {
    return Nr(Nr({}, r), {}, O0({}, o, wk.create(t[o])));
  }, {});
  return Nr(Nr({}, n), {}, {
    apply: function(o) {
      var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = i.bandAware, s = i.position;
      return F3e(o, function(l, c) {
        return n[c].apply(l, {
          bandAware: a,
          position: s
        });
      });
    },
    isInRange: function(o) {
      return mk(o, function(i, a) {
        return n[a].isInRange(i);
      });
    }
  });
};
function f8e(e) {
  return (e % 180 + 180) % 180;
}
var d8e = function(t) {
  var n = t.width, r = t.height, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, i = f8e(o), a = i * Math.PI / 180, s = Math.atan(r / n), l = a > s && a < Math.PI - s ? r / Math.sin(a) : n / Math.cos(a);
  return Math.abs(l);
}, J4, CE;
function h8e() {
  if (CE) return J4;
  CE = 1;
  var e = B1(), t = Z2(), n = d0();
  function r(o) {
    return function(i, a, s) {
      var l = Object(i);
      if (!t(i)) {
        var c = e(a, 3);
        i = n(i), a = function(f) {
          return c(l[f], f, l);
        };
      }
      var u = o(i, a, s);
      return u > -1 ? l[c ? i[u] : u] : void 0;
    };
  }
  return J4 = r, J4;
}
var e9, vE;
function p8e() {
  if (vE) return e9;
  vE = 1;
  var e = fk();
  function t(n) {
    var r = e(n), o = r % 1;
    return r === r ? o ? r - o : r : 0;
  }
  return e9 = t, e9;
}
var t9, yE;
function m8e() {
  if (yE) return t9;
  yE = 1;
  var e = LD(), t = B1(), n = p8e(), r = Math.max;
  function o(i, a, s) {
    var l = i == null ? 0 : i.length;
    if (!l)
      return -1;
    var c = s == null ? 0 : n(s);
    return c < 0 && (c = r(l + c, 0)), e(i, t(a, 3), c);
  }
  return t9 = o, t9;
}
var n9, bE;
function g8e() {
  if (bE) return n9;
  bE = 1;
  var e = h8e(), t = m8e(), n = e(t);
  return n9 = n, n9;
}
var C8e = g8e();
const v8e = /* @__PURE__ */ Mt(C8e);
var y8e = YI();
const b8e = /* @__PURE__ */ Mt(y8e);
var w8e = b8e(function(e) {
  return {
    x: e.left,
    y: e.top,
    width: e.width,
    height: e.height
  };
}, function(e) {
  return ["l", e.left, "t", e.top, "w", e.width, "h", e.height].join("");
});
function iu(e) {
  "@babel/helpers - typeof";
  return iu = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, iu(e);
}
var im = /* @__PURE__ */ gt(void 0), am = /* @__PURE__ */ gt(void 0), xk = /* @__PURE__ */ gt(void 0), Sk = /* @__PURE__ */ gt({}), Mk = /* @__PURE__ */ gt(void 0), Ek = /* @__PURE__ */ gt(0), _k = /* @__PURE__ */ gt(0), wE = function(t) {
  var n = t.state, r = n.xAxisMap, o = n.yAxisMap, i = n.offset, a = t.clipPathId, s = t.children, l = t.width, c = t.height, u = w8e(i);
  return /* @__PURE__ */ O.createElement(im.Provider, {
    value: r
  }, /* @__PURE__ */ O.createElement(am.Provider, {
    value: o
  }, /* @__PURE__ */ O.createElement(Sk.Provider, {
    value: i
  }, /* @__PURE__ */ O.createElement(xk.Provider, {
    value: u
  }, /* @__PURE__ */ O.createElement(Mk.Provider, {
    value: a
  }, /* @__PURE__ */ O.createElement(Ek.Provider, {
    value: c
  }, /* @__PURE__ */ O.createElement(_k.Provider, {
    value: l
  }, s)))))));
}, x8e = function() {
  return Oe(Mk);
};
function Ok(e) {
  var t = Object.keys(e);
  return t.length === 0 ? "There are no available ids." : "Available ids are: ".concat(t, ".");
}
var Ak = function(t) {
  var n = Oe(im);
  n == null && (process.env.NODE_ENV !== "production" ? Gn(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : Gn());
  var r = n[t];
  return r == null && (process.env.NODE_ENV !== "production" ? Gn(!1, 'Could not find xAxis by id "'.concat(t, '" [').concat(iu(t), "]. ").concat(Ok(n))) : Gn()), r;
}, S8e = function() {
  var t = Oe(im);
  return p1(t);
}, M8e = function() {
  var t = Oe(am), n = v8e(t, function(r) {
    return mk(r.domain, Number.isFinite);
  });
  return n || p1(t);
}, Pk = function(t) {
  var n = Oe(am);
  n == null && (process.env.NODE_ENV !== "production" ? Gn(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : Gn());
  var r = n[t];
  return r == null && (process.env.NODE_ENV !== "production" ? Gn(!1, 'Could not find yAxis by id "'.concat(t, '" [').concat(iu(t), "]. ").concat(Ok(n))) : Gn()), r;
}, E8e = function() {
  var t = Oe(xk);
  return t;
}, _8e = function() {
  return Oe(Sk);
}, sm = function() {
  return Oe(_k);
}, lm = function() {
  return Oe(Ek);
};
function ns(e) {
  "@babel/helpers - typeof";
  return ns = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ns(e);
}
function O8e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function A8e(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, Ik(r.key), r);
  }
}
function P8e(e, t, n) {
  return t && A8e(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function T8e(e, t, n) {
  return t = au(t), I8e(e, Tk() ? Reflect.construct(t, n || [], au(e).constructor) : t.apply(e, n));
}
function I8e(e, t) {
  if (t && (ns(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return D8e(e);
}
function D8e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Tk() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Tk = function() {
    return !!e;
  })();
}
function au(e) {
  return au = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, au(e);
}
function R8e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && sd(e, t);
}
function sd(e, t) {
  return sd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, sd(e, t);
}
function xE(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function SE(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? xE(Object(n), !0).forEach(function(r) {
      cm(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : xE(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function cm(e, t, n) {
  return t = Ik(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Ik(e) {
  var t = k8e(e, "string");
  return ns(t) == "symbol" ? t : t + "";
}
function k8e(e, t) {
  if (ns(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (ns(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function L8e(e, t) {
  return B8e(e) || V8e(e, t) || F8e(e, t) || N8e();
}
function N8e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function F8e(e, t) {
  if (e) {
    if (typeof e == "string") return ME(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ME(e, t);
  }
}
function ME(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function V8e(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, o, i, a, s = [], l = !0, c = !1;
    try {
      if (i = (n = n.call(e)).next, t !== 0) for (; !(l = (r = i.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (u) {
      c = !0, o = u;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw o;
      }
    }
    return s;
  }
}
function B8e(e) {
  if (Array.isArray(e)) return e;
}
function ld() {
  return ld = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ld.apply(this, arguments);
}
var $8e = function(t, n) {
  var r;
  return /* @__PURE__ */ O.isValidElement(t) ? r = /* @__PURE__ */ O.cloneElement(t, n) : je(t) ? r = t(n) : r = /* @__PURE__ */ O.createElement("line", ld({}, n, {
    className: "recharts-reference-line-line"
  })), r;
}, j8e = function(t, n, r, o, i, a, s, l, c) {
  var u = i.x, f = i.y, h = i.width, p = i.height;
  if (r) {
    var C = c.y, m = t.y.apply(C, {
      position: a
    });
    if (Co(c, "discard") && !t.y.isInRange(m))
      return null;
    var g = [{
      x: u + h,
      y: m
    }, {
      x: u,
      y: m
    }];
    return l === "left" ? g.reverse() : g;
  }
  if (n) {
    var v = c.x, y = t.x.apply(v, {
      position: a
    });
    if (Co(c, "discard") && !t.x.isInRange(y))
      return null;
    var w = [{
      x: y,
      y: f + p
    }, {
      x: y,
      y: f
    }];
    return s === "top" ? w.reverse() : w;
  }
  if (o) {
    var x = c.segment, b = x.map(function(S) {
      return t.apply(S, {
        position: a
      });
    });
    return Co(c, "discard") && R3e(b, function(S) {
      return !t.isInRange(S);
    }) ? null : b;
  }
  return null;
};
function H8e(e) {
  var t = e.x, n = e.y, r = e.segment, o = e.xAxisId, i = e.yAxisId, a = e.shape, s = e.className, l = e.alwaysShow, c = x8e(), u = Ak(o), f = Pk(i), h = E8e();
  if (!c || !h)
    return null;
  Wo(l === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
  var p = om({
    x: u.scale,
    y: f.scale
  }), C = ln(t), m = ln(n), g = r && r.length === 2, v = j8e(p, C, m, g, h, e.position, u.orientation, f.orientation, e);
  if (!v)
    return null;
  var y = L8e(v, 2), w = y[0], x = w.x, b = w.y, S = y[1], M = S.x, E = S.y, P = Co(e, "hidden") ? "url(#".concat(c, ")") : void 0, T = SE(SE({
    clipPath: P
  }, Be(e, !0)), {}, {
    x1: x,
    y1: b,
    x2: M,
    y2: E
  });
  return /* @__PURE__ */ O.createElement(rt, {
    className: We("recharts-reference-line", s)
  }, $8e(a, T), Tn.renderCallByParent(e, u8e({
    x1: x,
    y1: b,
    x2: M,
    y2: E
  })));
}
var A0 = /* @__PURE__ */ (function(e) {
  function t() {
    return O8e(this, t), T8e(this, t, arguments);
  }
  return R8e(t, e), P8e(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ O.createElement(H8e, this.props);
    }
  }]);
})(O.Component);
cm(A0, "displayName", "ReferenceLine");
cm(A0, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  fill: "none",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1,
  position: "middle"
});
function cd() {
  return cd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, cd.apply(this, arguments);
}
function rs(e) {
  "@babel/helpers - typeof";
  return rs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, rs(e);
}
function EE(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function _E(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? EE(Object(n), !0).forEach(function(r) {
      P0(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : EE(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function z8e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Z8e(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, Rk(r.key), r);
  }
}
function W8e(e, t, n) {
  return t && Z8e(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function q8e(e, t, n) {
  return t = su(t), U8e(e, Dk() ? Reflect.construct(t, n || [], su(e).constructor) : t.apply(e, n));
}
function U8e(e, t) {
  if (t && (rs(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return G8e(e);
}
function G8e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Dk() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Dk = function() {
    return !!e;
  })();
}
function su(e) {
  return su = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, su(e);
}
function K8e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && ud(e, t);
}
function ud(e, t) {
  return ud = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, ud(e, t);
}
function P0(e, t, n) {
  return t = Rk(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Rk(e) {
  var t = Y8e(e, "string");
  return rs(t) == "symbol" ? t : t + "";
}
function Y8e(e, t) {
  if (rs(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (rs(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var X8e = function(t) {
  var n = t.x, r = t.y, o = t.xAxis, i = t.yAxis, a = om({
    x: o.scale,
    y: i.scale
  }), s = a.apply({
    x: n,
    y: r
  }, {
    bandAware: !0
  });
  return Co(t, "discard") && !a.isInRange(s) ? null : s;
}, T0 = /* @__PURE__ */ (function(e) {
  function t() {
    return z8e(this, t), q8e(this, t, arguments);
  }
  return K8e(t, e), W8e(t, [{
    key: "render",
    value: function() {
      var r = this.props, o = r.x, i = r.y, a = r.r, s = r.alwaysShow, l = r.clipPathId, c = ln(o), u = ln(i);
      if (Wo(s === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.'), !c || !u)
        return null;
      var f = X8e(this.props);
      if (!f)
        return null;
      var h = f.x, p = f.y, C = this.props, m = C.shape, g = C.className, v = Co(this.props, "hidden") ? "url(#".concat(l, ")") : void 0, y = _E(_E({
        clipPath: v
      }, Be(this.props, !0)), {}, {
        cx: h,
        cy: p
      });
      return /* @__PURE__ */ O.createElement(rt, {
        className: We("recharts-reference-dot", g)
      }, t.renderDot(m, y), Tn.renderCallByParent(this.props, {
        x: h - a,
        y: p - a,
        width: 2 * a,
        height: 2 * a
      }));
    }
  }]);
})(O.Component);
P0(T0, "displayName", "ReferenceDot");
P0(T0, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#fff",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1
});
P0(T0, "renderDot", function(e, t) {
  var n;
  return /* @__PURE__ */ O.isValidElement(e) ? n = /* @__PURE__ */ O.cloneElement(e, t) : je(e) ? n = e(t) : n = /* @__PURE__ */ O.createElement(M0, cd({}, t, {
    cx: t.cx,
    cy: t.cy,
    className: "recharts-reference-dot-dot"
  })), n;
});
function fd() {
  return fd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, fd.apply(this, arguments);
}
function os(e) {
  "@babel/helpers - typeof";
  return os = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, os(e);
}
function OE(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function AE(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? OE(Object(n), !0).forEach(function(r) {
      I0(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : OE(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Q8e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function J8e(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, Lk(r.key), r);
  }
}
function e6e(e, t, n) {
  return t && J8e(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function t6e(e, t, n) {
  return t = lu(t), n6e(e, kk() ? Reflect.construct(t, n || [], lu(e).constructor) : t.apply(e, n));
}
function n6e(e, t) {
  if (t && (os(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return r6e(e);
}
function r6e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function kk() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (kk = function() {
    return !!e;
  })();
}
function lu(e) {
  return lu = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, lu(e);
}
function o6e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && dd(e, t);
}
function dd(e, t) {
  return dd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, dd(e, t);
}
function I0(e, t, n) {
  return t = Lk(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Lk(e) {
  var t = i6e(e, "string");
  return os(t) == "symbol" ? t : t + "";
}
function i6e(e, t) {
  if (os(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (os(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var a6e = function(t, n, r, o, i) {
  var a = i.x1, s = i.x2, l = i.y1, c = i.y2, u = i.xAxis, f = i.yAxis;
  if (!u || !f) return null;
  var h = om({
    x: u.scale,
    y: f.scale
  }), p = {
    x: t ? h.x.apply(a, {
      position: "start"
    }) : h.x.rangeMin,
    y: r ? h.y.apply(l, {
      position: "start"
    }) : h.y.rangeMin
  }, C = {
    x: n ? h.x.apply(s, {
      position: "end"
    }) : h.x.rangeMax,
    y: o ? h.y.apply(c, {
      position: "end"
    }) : h.y.rangeMax
  };
  return Co(i, "discard") && (!h.isInRange(p) || !h.isInRange(C)) ? null : bk(p, C);
}, D0 = /* @__PURE__ */ (function(e) {
  function t() {
    return Q8e(this, t), t6e(this, t, arguments);
  }
  return o6e(t, e), e6e(t, [{
    key: "render",
    value: function() {
      var r = this.props, o = r.x1, i = r.x2, a = r.y1, s = r.y2, l = r.className, c = r.alwaysShow, u = r.clipPathId;
      Wo(c === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
      var f = ln(o), h = ln(i), p = ln(a), C = ln(s), m = this.props.shape;
      if (!f && !h && !p && !C && !m)
        return null;
      var g = a6e(f, h, p, C, this.props);
      if (!g && !m)
        return null;
      var v = Co(this.props, "hidden") ? "url(#".concat(u, ")") : void 0;
      return /* @__PURE__ */ O.createElement(rt, {
        className: We("recharts-reference-area", l)
      }, t.renderRect(m, AE(AE({
        clipPath: v
      }, Be(this.props, !0)), g)), Tn.renderCallByParent(this.props, g));
    }
  }]);
})(O.Component);
I0(D0, "displayName", "ReferenceArea");
I0(D0, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#ccc",
  fillOpacity: 0.5,
  stroke: "none",
  strokeWidth: 1
});
I0(D0, "renderRect", function(e, t) {
  var n;
  return /* @__PURE__ */ O.isValidElement(e) ? n = /* @__PURE__ */ O.cloneElement(e, t) : je(e) ? n = e(t) : n = /* @__PURE__ */ O.createElement(rm, fd({}, t, {
    className: "recharts-reference-area-rect"
  })), n;
});
function Nk(e, t, n) {
  if (t < 1)
    return [];
  if (t === 1 && n === void 0)
    return e;
  for (var r = [], o = 0; o < e.length; o += t)
    r.push(e[o]);
  return r;
}
function s6e(e, t, n) {
  var r = {
    width: e.width + t.width,
    height: e.height + t.height
  };
  return d8e(r, n);
}
function l6e(e, t, n) {
  var r = n === "width", o = e.x, i = e.y, a = e.width, s = e.height;
  return t === 1 ? {
    start: r ? o : i,
    end: r ? o + a : i + s
  } : {
    start: r ? o + a : i + s,
    end: r ? o : i
  };
}
function cu(e, t, n, r, o) {
  if (e * t < e * r || e * t > e * o)
    return !1;
  var i = n();
  return e * (t - e * i / 2 - r) >= 0 && e * (t + e * i / 2 - o) <= 0;
}
function c6e(e, t) {
  return Nk(e, t + 1);
}
function u6e(e, t, n, r, o) {
  for (var i = (r || []).slice(), a = t.start, s = t.end, l = 0, c = 1, u = a, f = function() {
    var C = r?.[l];
    if (C === void 0)
      return {
        v: Nk(r, c)
      };
    var m = l, g, v = function() {
      return g === void 0 && (g = n(C, m)), g;
    }, y = C.coordinate, w = l === 0 || cu(e, y, v, u, s);
    w || (l = 0, u = a, c += 1), w && (u = y + e * (v() / 2 + o), l += c);
  }, h; c <= i.length; )
    if (h = f(), h) return h.v;
  return [];
}
function y2(e) {
  "@babel/helpers - typeof";
  return y2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, y2(e);
}
function PE(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function An(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? PE(Object(n), !0).forEach(function(r) {
      f6e(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : PE(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function f6e(e, t, n) {
  return t = d6e(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function d6e(e) {
  var t = h6e(e, "string");
  return y2(t) == "symbol" ? t : t + "";
}
function h6e(e, t) {
  if (y2(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (y2(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function p6e(e, t, n, r, o) {
  for (var i = (r || []).slice(), a = i.length, s = t.start, l = t.end, c = function(h) {
    var p = i[h], C, m = function() {
      return C === void 0 && (C = n(p, h)), C;
    };
    if (h === a - 1) {
      var g = e * (p.coordinate + e * m() / 2 - l);
      i[h] = p = An(An({}, p), {}, {
        tickCoord: g > 0 ? p.coordinate - g * e : p.coordinate
      });
    } else
      i[h] = p = An(An({}, p), {}, {
        tickCoord: p.coordinate
      });
    var v = cu(e, p.tickCoord, m, s, l);
    v && (l = p.tickCoord - e * (m() / 2 + o), i[h] = An(An({}, p), {}, {
      isShow: !0
    }));
  }, u = a - 1; u >= 0; u--)
    c(u);
  return i;
}
function m6e(e, t, n, r, o, i) {
  var a = (r || []).slice(), s = a.length, l = t.start, c = t.end;
  if (i) {
    var u = r[s - 1], f = n(u, s - 1), h = e * (u.coordinate + e * f / 2 - c);
    a[s - 1] = u = An(An({}, u), {}, {
      tickCoord: h > 0 ? u.coordinate - h * e : u.coordinate
    });
    var p = cu(e, u.tickCoord, function() {
      return f;
    }, l, c);
    p && (c = u.tickCoord - e * (f / 2 + o), a[s - 1] = An(An({}, u), {}, {
      isShow: !0
    }));
  }
  for (var C = i ? s - 1 : s, m = function(y) {
    var w = a[y], x, b = function() {
      return x === void 0 && (x = n(w, y)), x;
    };
    if (y === 0) {
      var S = e * (w.coordinate - e * b() / 2 - l);
      a[y] = w = An(An({}, w), {}, {
        tickCoord: S < 0 ? w.coordinate - S * e : w.coordinate
      });
    } else
      a[y] = w = An(An({}, w), {}, {
        tickCoord: w.coordinate
      });
    var M = cu(e, w.tickCoord, b, l, c);
    M && (l = w.tickCoord + e * (b() / 2 + o), a[y] = An(An({}, w), {}, {
      isShow: !0
    }));
  }, g = 0; g < C; g++)
    m(g);
  return a;
}
function um(e, t, n) {
  var r = e.tick, o = e.ticks, i = e.viewBox, a = e.minTickGap, s = e.orientation, l = e.interval, c = e.tickFormatter, u = e.unit, f = e.angle;
  if (!o || !o.length || !r)
    return [];
  if (he(l) || $1.isSsr)
    return c6e(o, typeof l == "number" && he(l) ? l : 0);
  var h = [], p = s === "top" || s === "bottom" ? "width" : "height", C = u && p === "width" ? bl(u, {
    fontSize: t,
    letterSpacing: n
  }) : {
    width: 0,
    height: 0
  }, m = function(w, x) {
    var b = je(c) ? c(w.value, x) : w.value;
    return p === "width" ? s6e(bl(b, {
      fontSize: t,
      letterSpacing: n
    }), C, f) : bl(b, {
      fontSize: t,
      letterSpacing: n
    })[p];
  }, g = o.length >= 2 ? jr(o[1].coordinate - o[0].coordinate) : 1, v = l6e(i, g, p);
  return l === "equidistantPreserveStart" ? u6e(g, v, m, o, a) : (l === "preserveStart" || l === "preserveStartEnd" ? h = m6e(g, v, m, o, a, l === "preserveStartEnd") : h = p6e(g, v, m, o, a), h.filter(function(y) {
    return y.isShow;
  }));
}
var g6e = ["viewBox"], C6e = ["viewBox"], v6e = ["ticks"];
function is(e) {
  "@babel/helpers - typeof";
  return is = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, is(e);
}
function ga() {
  return ga = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ga.apply(this, arguments);
}
function TE(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function an(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? TE(Object(n), !0).forEach(function(r) {
      fm(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : TE(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function r9(e, t) {
  if (e == null) return {};
  var n = y6e(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function y6e(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function b6e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function IE(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, Vk(r.key), r);
  }
}
function w6e(e, t, n) {
  return t && IE(e.prototype, t), n && IE(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function x6e(e, t, n) {
  return t = uu(t), S6e(e, Fk() ? Reflect.construct(t, n || [], uu(e).constructor) : t.apply(e, n));
}
function S6e(e, t) {
  if (t && (is(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return M6e(e);
}
function M6e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Fk() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Fk = function() {
    return !!e;
  })();
}
function uu(e) {
  return uu = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, uu(e);
}
function E6e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && hd(e, t);
}
function hd(e, t) {
  return hd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, hd(e, t);
}
function fm(e, t, n) {
  return t = Vk(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Vk(e) {
  var t = _6e(e, "string");
  return is(t) == "symbol" ? t : t + "";
}
function _6e(e, t) {
  if (is(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (is(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Is = /* @__PURE__ */ (function(e) {
  function t(n) {
    var r;
    return b6e(this, t), r = x6e(this, t, [n]), r.state = {
      fontSize: "",
      letterSpacing: ""
    }, r;
  }
  return E6e(t, e), w6e(t, [{
    key: "shouldComponentUpdate",
    value: function(r, o) {
      var i = r.viewBox, a = r9(r, g6e), s = this.props, l = s.viewBox, c = r9(s, C6e);
      return !Ta(i, l) || !Ta(a, c) || !Ta(o, this.state);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var r = this.layerReference;
      if (r) {
        var o = r.getElementsByClassName("recharts-cartesian-axis-tick-value")[0];
        o && this.setState({
          fontSize: window.getComputedStyle(o).fontSize,
          letterSpacing: window.getComputedStyle(o).letterSpacing
        });
      }
    }
    /**
     * Calculate the coordinates of endpoints in ticks
     * @param  {Object} data The data of a simple tick
     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
     *  (x2, y2): The coordinate of endpoint close to axis
     */
  }, {
    key: "getTickLineCoord",
    value: function(r) {
      var o = this.props, i = o.x, a = o.y, s = o.width, l = o.height, c = o.orientation, u = o.tickSize, f = o.mirror, h = o.tickMargin, p, C, m, g, v, y, w = f ? -1 : 1, x = r.tickSize || u, b = he(r.tickCoord) ? r.tickCoord : r.coordinate;
      switch (c) {
        case "top":
          p = C = r.coordinate, g = a + +!f * l, m = g - w * x, y = m - w * h, v = b;
          break;
        case "left":
          m = g = r.coordinate, C = i + +!f * s, p = C - w * x, v = p - w * h, y = b;
          break;
        case "right":
          m = g = r.coordinate, C = i + +f * s, p = C + w * x, v = p + w * h, y = b;
          break;
        default:
          p = C = r.coordinate, g = a + +f * l, m = g + w * x, y = m + w * h, v = b;
          break;
      }
      return {
        line: {
          x1: p,
          y1: m,
          x2: C,
          y2: g
        },
        tick: {
          x: v,
          y
        }
      };
    }
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var r = this.props, o = r.orientation, i = r.mirror, a;
      switch (o) {
        case "left":
          a = i ? "start" : "end";
          break;
        case "right":
          a = i ? "end" : "start";
          break;
        default:
          a = "middle";
          break;
      }
      return a;
    }
  }, {
    key: "getTickVerticalAnchor",
    value: function() {
      var r = this.props, o = r.orientation, i = r.mirror, a = "end";
      switch (o) {
        case "left":
        case "right":
          a = "middle";
          break;
        case "top":
          a = i ? "start" : "end";
          break;
        default:
          a = i ? "end" : "start";
          break;
      }
      return a;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var r = this.props, o = r.x, i = r.y, a = r.width, s = r.height, l = r.orientation, c = r.mirror, u = r.axisLine, f = an(an(an({}, Be(this.props, !1)), Be(u, !1)), {}, {
        fill: "none"
      });
      if (l === "top" || l === "bottom") {
        var h = +(l === "top" && !c || l === "bottom" && c);
        f = an(an({}, f), {}, {
          x1: o,
          y1: i + h * s,
          x2: o + a,
          y2: i + h * s
        });
      } else {
        var p = +(l === "left" && !c || l === "right" && c);
        f = an(an({}, f), {}, {
          x1: o + p * a,
          y1: i,
          x2: o + p * a,
          y2: i + s
        });
      }
      return /* @__PURE__ */ O.createElement("line", ga({}, f, {
        className: We("recharts-cartesian-axis-line", Sr(u, "className"))
      }));
    }
  }, {
    key: "renderTicks",
    value: (
      /**
       * render the ticks
       * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
       * @param {string} fontSize Fontsize to consider for tick spacing
       * @param {string} letterSpacing Letterspacing to consider for tick spacing
       * @return {ReactComponent} renderedTicks
       */
      function(r, o, i) {
        var a = this, s = this.props, l = s.tickLine, c = s.stroke, u = s.tick, f = s.tickFormatter, h = s.unit, p = um(an(an({}, this.props), {}, {
          ticks: r
        }), o, i), C = this.getTickTextAnchor(), m = this.getTickVerticalAnchor(), g = Be(this.props, !1), v = Be(u, !1), y = an(an({}, g), {}, {
          fill: "none"
        }, Be(l, !1)), w = p.map(function(x, b) {
          var S = a.getTickLineCoord(x), M = S.line, E = S.tick, P = an(an(an(an({
            textAnchor: C,
            verticalAnchor: m
          }, g), {}, {
            stroke: "none",
            fill: c
          }, v), E), {}, {
            index: b,
            payload: x,
            visibleTicksCount: p.length,
            tickFormatter: f
          });
          return /* @__PURE__ */ O.createElement(rt, ga({
            className: "recharts-cartesian-axis-tick",
            key: "tick-".concat(x.value, "-").concat(x.coordinate, "-").concat(x.tickCoord)
          }, jl(a.props, x, b)), l && /* @__PURE__ */ O.createElement("line", ga({}, y, M, {
            className: We("recharts-cartesian-axis-tick-line", Sr(l, "className"))
          })), u && t.renderTickItem(u, P, "".concat(je(f) ? f(x.value, b) : x.value).concat(h || "")));
        });
        return /* @__PURE__ */ O.createElement("g", {
          className: "recharts-cartesian-axis-ticks"
        }, w);
      }
    )
  }, {
    key: "render",
    value: function() {
      var r = this, o = this.props, i = o.axisLine, a = o.width, s = o.height, l = o.ticksGenerator, c = o.className, u = o.hide;
      if (u)
        return null;
      var f = this.props, h = f.ticks, p = r9(f, v6e), C = h;
      return je(l) && (C = h && h.length > 0 ? l(this.props) : l(p)), a <= 0 || s <= 0 || !C || !C.length ? null : /* @__PURE__ */ O.createElement(rt, {
        className: We("recharts-cartesian-axis", c),
        ref: function(g) {
          r.layerReference = g;
        }
      }, i && this.renderAxisLine(), this.renderTicks(C, this.state.fontSize, this.state.letterSpacing), Tn.renderCallByParent(this.props));
    }
  }], [{
    key: "renderTickItem",
    value: function(r, o, i) {
      var a, s = We(o.className, "recharts-cartesian-axis-tick-value");
      return /* @__PURE__ */ O.isValidElement(r) ? a = /* @__PURE__ */ O.cloneElement(r, an(an({}, o), {}, {
        className: s
      })) : je(r) ? a = r(an(an({}, o), {}, {
        className: s
      })) : a = /* @__PURE__ */ O.createElement(T5, ga({}, o, {
        className: "recharts-cartesian-axis-tick-value"
      }), i), a;
    }
  }]);
})(Td);
fm(Is, "displayName", "CartesianAxis");
fm(Is, "defaultProps", {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  viewBox: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  // The orientation of axis
  orientation: "bottom",
  // The ticks
  ticks: [],
  stroke: "#666",
  tickLine: !0,
  axisLine: !0,
  tick: !0,
  mirror: !1,
  minTickGap: 5,
  // The width or height of tick
  tickSize: 6,
  tickMargin: 2,
  interval: "preserveEnd"
});
var O6e = ["x1", "y1", "x2", "y2", "key"], A6e = ["offset"];
function Pi(e) {
  "@babel/helpers - typeof";
  return Pi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Pi(e);
}
function DE(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function In(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? DE(Object(n), !0).forEach(function(r) {
      P6e(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : DE(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function P6e(e, t, n) {
  return t = T6e(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function T6e(e) {
  var t = I6e(e, "string");
  return Pi(t) == "symbol" ? t : t + "";
}
function I6e(e, t) {
  if (Pi(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Pi(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function li() {
  return li = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, li.apply(this, arguments);
}
function RE(e, t) {
  if (e == null) return {};
  var n = D6e(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function D6e(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
var R6e = function(t) {
  var n = t.fill;
  if (!n || n === "none")
    return null;
  var r = t.fillOpacity, o = t.x, i = t.y, a = t.width, s = t.height, l = t.ry;
  return /* @__PURE__ */ O.createElement("rect", {
    x: o,
    y: i,
    ry: l,
    width: a,
    height: s,
    stroke: "none",
    fill: n,
    fillOpacity: r,
    className: "recharts-cartesian-grid-bg"
  });
};
function Bk(e, t) {
  var n;
  if (/* @__PURE__ */ O.isValidElement(e))
    n = /* @__PURE__ */ O.cloneElement(e, t);
  else if (je(e))
    n = e(t);
  else {
    var r = t.x1, o = t.y1, i = t.x2, a = t.y2, s = t.key, l = RE(t, O6e), c = Be(l, !1);
    c.offset;
    var u = RE(c, A6e);
    n = /* @__PURE__ */ O.createElement("line", li({}, u, {
      x1: r,
      y1: o,
      x2: i,
      y2: a,
      fill: "none",
      key: s
    }));
  }
  return n;
}
function k6e(e) {
  var t = e.x, n = e.width, r = e.horizontal, o = r === void 0 ? !0 : r, i = e.horizontalPoints;
  if (!o || !i || !i.length)
    return null;
  var a = i.map(function(s, l) {
    var c = In(In({}, e), {}, {
      x1: t,
      y1: s,
      x2: t + n,
      y2: s,
      key: "line-".concat(l),
      index: l
    });
    return Bk(o, c);
  });
  return /* @__PURE__ */ O.createElement("g", {
    className: "recharts-cartesian-grid-horizontal"
  }, a);
}
function L6e(e) {
  var t = e.y, n = e.height, r = e.vertical, o = r === void 0 ? !0 : r, i = e.verticalPoints;
  if (!o || !i || !i.length)
    return null;
  var a = i.map(function(s, l) {
    var c = In(In({}, e), {}, {
      x1: s,
      y1: t,
      x2: s,
      y2: t + n,
      key: "line-".concat(l),
      index: l
    });
    return Bk(o, c);
  });
  return /* @__PURE__ */ O.createElement("g", {
    className: "recharts-cartesian-grid-vertical"
  }, a);
}
function N6e(e) {
  var t = e.horizontalFill, n = e.fillOpacity, r = e.x, o = e.y, i = e.width, a = e.height, s = e.horizontalPoints, l = e.horizontal, c = l === void 0 ? !0 : l;
  if (!c || !t || !t.length)
    return null;
  var u = s.map(function(h) {
    return Math.round(h + o - o);
  }).sort(function(h, p) {
    return h - p;
  });
  o !== u[0] && u.unshift(0);
  var f = u.map(function(h, p) {
    var C = !u[p + 1], m = C ? o + a - h : u[p + 1] - h;
    if (m <= 0)
      return null;
    var g = p % t.length;
    return /* @__PURE__ */ O.createElement("rect", {
      key: "react-".concat(p),
      y: h,
      x: r,
      height: m,
      width: i,
      stroke: "none",
      fill: t[g],
      fillOpacity: n,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ O.createElement("g", {
    className: "recharts-cartesian-gridstripes-horizontal"
  }, f);
}
function F6e(e) {
  var t = e.vertical, n = t === void 0 ? !0 : t, r = e.verticalFill, o = e.fillOpacity, i = e.x, a = e.y, s = e.width, l = e.height, c = e.verticalPoints;
  if (!n || !r || !r.length)
    return null;
  var u = c.map(function(h) {
    return Math.round(h + i - i);
  }).sort(function(h, p) {
    return h - p;
  });
  i !== u[0] && u.unshift(0);
  var f = u.map(function(h, p) {
    var C = !u[p + 1], m = C ? i + s - h : u[p + 1] - h;
    if (m <= 0)
      return null;
    var g = p % r.length;
    return /* @__PURE__ */ O.createElement("rect", {
      key: "react-".concat(p),
      x: h,
      y: a,
      width: m,
      height: l,
      stroke: "none",
      fill: r[g],
      fillOpacity: o,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ O.createElement("g", {
    className: "recharts-cartesian-gridstripes-vertical"
  }, f);
}
var V6e = function(t, n) {
  var r = t.xAxis, o = t.width, i = t.height, a = t.offset;
  return QR(um(In(In(In({}, Is.defaultProps), r), {}, {
    ticks: Ho(r, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: o,
      height: i
    }
  })), a.left, a.left + a.width, n);
}, B6e = function(t, n) {
  var r = t.yAxis, o = t.width, i = t.height, a = t.offset;
  return QR(um(In(In(In({}, Is.defaultProps), r), {}, {
    ticks: Ho(r, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: o,
      height: i
    }
  })), a.top, a.top + a.height, n);
}, ra = {
  horizontal: !0,
  vertical: !0,
  stroke: "#ccc",
  fill: "none",
  // The fill of colors of grid lines
  verticalFill: [],
  horizontalFill: []
};
function $k(e) {
  var t, n, r, o, i, a, s = sm(), l = lm(), c = _8e(), u = In(In({}, e), {}, {
    stroke: (t = e.stroke) !== null && t !== void 0 ? t : ra.stroke,
    fill: (n = e.fill) !== null && n !== void 0 ? n : ra.fill,
    horizontal: (r = e.horizontal) !== null && r !== void 0 ? r : ra.horizontal,
    horizontalFill: (o = e.horizontalFill) !== null && o !== void 0 ? o : ra.horizontalFill,
    vertical: (i = e.vertical) !== null && i !== void 0 ? i : ra.vertical,
    verticalFill: (a = e.verticalFill) !== null && a !== void 0 ? a : ra.verticalFill,
    x: he(e.x) ? e.x : c.left,
    y: he(e.y) ? e.y : c.top,
    width: he(e.width) ? e.width : c.width,
    height: he(e.height) ? e.height : c.height
  }), f = u.x, h = u.y, p = u.width, C = u.height, m = u.syncWithTicks, g = u.horizontalValues, v = u.verticalValues, y = S8e(), w = M8e();
  if (!he(p) || p <= 0 || !he(C) || C <= 0 || !he(f) || f !== +f || !he(h) || h !== +h)
    return null;
  var x = u.verticalCoordinatesGenerator || V6e, b = u.horizontalCoordinatesGenerator || B6e, S = u.horizontalPoints, M = u.verticalPoints;
  if ((!S || !S.length) && je(b)) {
    var E = g && g.length, P = b({
      yAxis: w ? In(In({}, w), {}, {
        ticks: E ? g : w.ticks
      }) : void 0,
      width: s,
      height: l,
      offset: c
    }, E ? !0 : m);
    Wo(Array.isArray(P), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat(Pi(P), "]")), Array.isArray(P) && (S = P);
  }
  if ((!M || !M.length) && je(x)) {
    var T = v && v.length, _ = x({
      xAxis: y ? In(In({}, y), {}, {
        ticks: T ? v : y.ticks
      }) : void 0,
      width: s,
      height: l,
      offset: c
    }, T ? !0 : m);
    Wo(Array.isArray(_), "verticalCoordinatesGenerator should return Array but instead it returned [".concat(Pi(_), "]")), Array.isArray(_) && (M = _);
  }
  return /* @__PURE__ */ O.createElement("g", {
    className: "recharts-cartesian-grid"
  }, /* @__PURE__ */ O.createElement(R6e, {
    fill: u.fill,
    fillOpacity: u.fillOpacity,
    x: u.x,
    y: u.y,
    width: u.width,
    height: u.height,
    ry: u.ry
  }), /* @__PURE__ */ O.createElement(k6e, li({}, u, {
    offset: c,
    horizontalPoints: S,
    xAxis: y,
    yAxis: w
  })), /* @__PURE__ */ O.createElement(L6e, li({}, u, {
    offset: c,
    verticalPoints: M,
    xAxis: y,
    yAxis: w
  })), /* @__PURE__ */ O.createElement(N6e, li({}, u, {
    horizontalPoints: S
  })), /* @__PURE__ */ O.createElement(F6e, li({}, u, {
    verticalPoints: M
  })));
}
$k.displayName = "CartesianGrid";
var $6e = ["type", "layout", "connectNulls", "ref"], j6e = ["key"];
function as(e) {
  "@babel/helpers - typeof";
  return as = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, as(e);
}
function kE(e, t) {
  if (e == null) return {};
  var n = H6e(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function H6e(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function Ml() {
  return Ml = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ml.apply(this, arguments);
}
function LE(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Jn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? LE(Object(n), !0).forEach(function(r) {
      Fr(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : LE(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function oa(e) {
  return q6e(e) || W6e(e) || Z6e(e) || z6e();
}
function z6e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Z6e(e, t) {
  if (e) {
    if (typeof e == "string") return pd(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return pd(e, t);
  }
}
function W6e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function q6e(e) {
  if (Array.isArray(e)) return pd(e);
}
function pd(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function U6e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function NE(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, Hk(r.key), r);
  }
}
function G6e(e, t, n) {
  return t && NE(e.prototype, t), n && NE(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function K6e(e, t, n) {
  return t = fu(t), Y6e(e, jk() ? Reflect.construct(t, n || [], fu(e).constructor) : t.apply(e, n));
}
function Y6e(e, t) {
  if (t && (as(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return X6e(e);
}
function X6e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function jk() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (jk = function() {
    return !!e;
  })();
}
function fu(e) {
  return fu = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, fu(e);
}
function Q6e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && md(e, t);
}
function md(e, t) {
  return md = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, md(e, t);
}
function Fr(e, t, n) {
  return t = Hk(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Hk(e) {
  var t = J6e(e, "string");
  return as(t) == "symbol" ? t : t + "";
}
function J6e(e, t) {
  if (as(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (as(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var K2 = /* @__PURE__ */ (function(e) {
  function t() {
    var n;
    U6e(this, t);
    for (var r = arguments.length, o = new Array(r), i = 0; i < r; i++)
      o[i] = arguments[i];
    return n = K6e(this, t, [].concat(o)), Fr(n, "state", {
      isAnimationFinished: !0,
      totalLength: 0
    }), Fr(n, "generateSimpleStrokeDasharray", function(a, s) {
      return "".concat(s, "px ").concat(a - s, "px");
    }), Fr(n, "getStrokeDasharray", function(a, s, l) {
      var c = l.reduce(function(v, y) {
        return v + y;
      });
      if (!c)
        return n.generateSimpleStrokeDasharray(s, a);
      for (var u = Math.floor(a / c), f = a % c, h = s - a, p = [], C = 0, m = 0; C < l.length; m += l[C], ++C)
        if (m + l[C] > f) {
          p = [].concat(oa(l.slice(0, C)), [f - m]);
          break;
        }
      var g = p.length % 2 === 0 ? [0, h] : [h];
      return [].concat(oa(t.repeat(l, u)), oa(p), g).map(function(v) {
        return "".concat(v, "px");
      }).join(", ");
    }), Fr(n, "id", Bi("recharts-line-")), Fr(n, "pathRef", function(a) {
      n.mainCurve = a;
    }), Fr(n, "handleAnimationEnd", function() {
      n.setState({
        isAnimationFinished: !0
      }), n.props.onAnimationEnd && n.props.onAnimationEnd();
    }), Fr(n, "handleAnimationStart", function() {
      n.setState({
        isAnimationFinished: !1
      }), n.props.onAnimationStart && n.props.onAnimationStart();
    }), n;
  }
  return Q6e(t, e), G6e(t, [{
    key: "componentDidMount",
    value: function() {
      if (this.props.isAnimationActive) {
        var r = this.getTotalLength();
        this.setState({
          totalLength: r
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      if (this.props.isAnimationActive) {
        var r = this.getTotalLength();
        r !== this.state.totalLength && this.setState({
          totalLength: r
        });
      }
    }
  }, {
    key: "getTotalLength",
    value: function() {
      var r = this.mainCurve;
      try {
        return r && r.getTotalLength && r.getTotalLength() || 0;
      } catch {
        return 0;
      }
    }
  }, {
    key: "renderErrorBar",
    value: function(r, o) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var i = this.props, a = i.points, s = i.xAxis, l = i.yAxis, c = i.layout, u = i.children, f = Yn(u, Ts);
      if (!f)
        return null;
      var h = function(m, g) {
        return {
          x: m.x,
          y: m.y,
          value: m.value,
          errorVal: cn(m.payload, g)
        };
      }, p = {
        clipPath: r ? "url(#clipPath-".concat(o, ")") : null
      };
      return /* @__PURE__ */ O.createElement(rt, p, f.map(function(C) {
        return /* @__PURE__ */ O.cloneElement(C, {
          key: "bar-".concat(C.props.dataKey),
          data: a,
          xAxis: s,
          yAxis: l,
          layout: c,
          dataPointFormatter: h
        });
      }));
    }
  }, {
    key: "renderDots",
    value: function(r, o, i) {
      var a = this.props.isAnimationActive;
      if (a && !this.state.isAnimationFinished)
        return null;
      var s = this.props, l = s.dot, c = s.points, u = s.dataKey, f = Be(this.props, !1), h = Be(l, !0), p = c.map(function(m, g) {
        var v = Jn(Jn(Jn({
          key: "dot-".concat(g),
          r: 3
        }, f), h), {}, {
          index: g,
          cx: m.x,
          cy: m.y,
          value: m.value,
          dataKey: u,
          payload: m.payload,
          points: c
        });
        return t.renderDotItem(l, v);
      }), C = {
        clipPath: r ? "url(#clipPath-".concat(o ? "" : "dots-").concat(i, ")") : null
      };
      return /* @__PURE__ */ O.createElement(rt, Ml({
        className: "recharts-line-dots",
        key: "dots"
      }, C), p);
    }
  }, {
    key: "renderCurveStatically",
    value: function(r, o, i, a) {
      var s = this.props, l = s.type, c = s.layout, u = s.connectNulls;
      s.ref;
      var f = kE(s, $6e), h = Jn(Jn(Jn({}, Be(f, !0)), {}, {
        fill: "none",
        className: "recharts-line-curve",
        clipPath: o ? "url(#clipPath-".concat(i, ")") : null,
        points: r
      }, a), {}, {
        type: l,
        layout: c,
        connectNulls: u
      });
      return /* @__PURE__ */ O.createElement(gi, Ml({}, h, {
        pathRef: this.pathRef
      }));
    }
  }, {
    key: "renderCurveWithAnimation",
    value: function(r, o) {
      var i = this, a = this.props, s = a.points, l = a.strokeDasharray, c = a.isAnimationActive, u = a.animationBegin, f = a.animationDuration, h = a.animationEasing, p = a.animationId, C = a.animateNewValues, m = a.width, g = a.height, v = this.state, y = v.prevPoints, w = v.totalLength;
      return /* @__PURE__ */ O.createElement(Ur, {
        begin: u,
        duration: f,
        isActive: c,
        easing: h,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "line-".concat(p),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(x) {
        var b = x.t;
        if (y) {
          var S = y.length / s.length, M = s.map(function(D, N) {
            var R = Math.floor(N * S);
            if (y[R]) {
              var L = y[R], B = jt(L.x, D.x), V = jt(L.y, D.y);
              return Jn(Jn({}, D), {}, {
                x: B(b),
                y: V(b)
              });
            }
            if (C) {
              var k = jt(m * 2, D.x), z = jt(g / 2, D.y);
              return Jn(Jn({}, D), {}, {
                x: k(b),
                y: z(b)
              });
            }
            return Jn(Jn({}, D), {}, {
              x: D.x,
              y: D.y
            });
          });
          return i.renderCurveStatically(M, r, o);
        }
        var E = jt(0, w), P = E(b), T;
        if (l) {
          var _ = "".concat(l).split(/[,\s]+/gim).map(function(D) {
            return parseFloat(D);
          });
          T = i.getStrokeDasharray(P, w, _);
        } else
          T = i.generateSimpleStrokeDasharray(w, P);
        return i.renderCurveStatically(s, r, o, {
          strokeDasharray: T
        });
      });
    }
  }, {
    key: "renderCurve",
    value: function(r, o) {
      var i = this.props, a = i.points, s = i.isAnimationActive, l = this.state, c = l.prevPoints, u = l.totalLength;
      return s && a && a.length && (!c && u > 0 || !Oi(c, a)) ? this.renderCurveWithAnimation(r, o) : this.renderCurveStatically(a, r, o);
    }
  }, {
    key: "render",
    value: function() {
      var r, o = this.props, i = o.hide, a = o.dot, s = o.points, l = o.className, c = o.xAxis, u = o.yAxis, f = o.top, h = o.left, p = o.width, C = o.height, m = o.isAnimationActive, g = o.id;
      if (i || !s || !s.length)
        return null;
      var v = this.state.isAnimationFinished, y = s.length === 1, w = We("recharts-line", l), x = c && c.allowDataOverflow, b = u && u.allowDataOverflow, S = x || b, M = Ne(g) ? this.id : g, E = (r = Be(a, !1)) !== null && r !== void 0 ? r : {
        r: 3,
        strokeWidth: 2
      }, P = E.r, T = P === void 0 ? 3 : P, _ = E.strokeWidth, D = _ === void 0 ? 2 : _, N = tD(a) ? a : {}, R = N.clipDot, L = R === void 0 ? !0 : R, B = T * 2 + D;
      return /* @__PURE__ */ O.createElement(rt, {
        className: w
      }, x || b ? /* @__PURE__ */ O.createElement("defs", null, /* @__PURE__ */ O.createElement("clipPath", {
        id: "clipPath-".concat(M)
      }, /* @__PURE__ */ O.createElement("rect", {
        x: x ? h : h - p / 2,
        y: b ? f : f - C / 2,
        width: x ? p : p * 2,
        height: b ? C : C * 2
      })), !L && /* @__PURE__ */ O.createElement("clipPath", {
        id: "clipPath-dots-".concat(M)
      }, /* @__PURE__ */ O.createElement("rect", {
        x: h - B / 2,
        y: f - B / 2,
        width: p + B,
        height: C + B
      }))) : null, !y && this.renderCurve(S, M), this.renderErrorBar(S, M), (y || a) && this.renderDots(S, L, M), (!m || v) && go.renderCallByParent(this.props, s));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(r, o) {
      return r.animationId !== o.prevAnimationId ? {
        prevAnimationId: r.animationId,
        curPoints: r.points,
        prevPoints: o.curPoints
      } : r.points !== o.curPoints ? {
        curPoints: r.points
      } : null;
    }
  }, {
    key: "repeat",
    value: function(r, o) {
      for (var i = r.length % 2 !== 0 ? [].concat(oa(r), [0]) : r, a = [], s = 0; s < o; ++s)
        a = [].concat(oa(a), oa(i));
      return a;
    }
  }, {
    key: "renderDotItem",
    value: function(r, o) {
      var i;
      if (/* @__PURE__ */ O.isValidElement(r))
        i = /* @__PURE__ */ O.cloneElement(r, o);
      else if (je(r))
        i = r(o);
      else {
        var a = o.key, s = kE(o, j6e), l = We("recharts-line-dot", typeof r != "boolean" ? r.className : "");
        i = /* @__PURE__ */ O.createElement(M0, Ml({
          key: a
        }, s, {
          className: l
        }));
      }
      return i;
    }
  }]);
})(xo);
Fr(K2, "displayName", "Line");
Fr(K2, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  connectNulls: !1,
  activeDot: !0,
  dot: !0,
  legendType: "line",
  stroke: "#3182bd",
  strokeWidth: 1,
  fill: "#fff",
  points: [],
  isAnimationActive: !$1.isSsr,
  animateNewValues: !0,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease",
  hide: !1,
  label: !1
});
Fr(K2, "getComposedData", function(e) {
  var t = e.props, n = e.xAxis, r = e.yAxis, o = e.xAxisTicks, i = e.yAxisTicks, a = e.dataKey, s = e.bandSize, l = e.displayedData, c = e.offset, u = t.layout, f = l.map(function(h, p) {
    var C = cn(h, a);
    return u === "horizontal" ? {
      x: Ya({
        axis: n,
        ticks: o,
        bandSize: s,
        entry: h,
        index: p
      }),
      y: Ne(C) ? null : r.scale(C),
      value: C,
      payload: h
    } : {
      x: Ne(C) ? null : n.scale(C),
      y: Ya({
        axis: r,
        ticks: i,
        bandSize: s,
        entry: h,
        index: p
      }),
      value: C,
      payload: h
    };
  });
  return Jn({
    points: f,
    layout: u
  }, c);
});
var e4e = ["layout", "type", "stroke", "connectNulls", "isRange", "ref"], t4e = ["key"], zk;
function ss(e) {
  "@babel/helpers - typeof";
  return ss = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ss(e);
}
function Zk(e, t) {
  if (e == null) return {};
  var n = n4e(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function n4e(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function ci() {
  return ci = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ci.apply(this, arguments);
}
function FE(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function f1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? FE(Object(n), !0).forEach(function(r) {
      fo(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : FE(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function r4e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function VE(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, qk(r.key), r);
  }
}
function o4e(e, t, n) {
  return t && VE(e.prototype, t), n && VE(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function i4e(e, t, n) {
  return t = du(t), a4e(e, Wk() ? Reflect.construct(t, n || [], du(e).constructor) : t.apply(e, n));
}
function a4e(e, t) {
  if (t && (ss(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return s4e(e);
}
function s4e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Wk() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Wk = function() {
    return !!e;
  })();
}
function du(e) {
  return du = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, du(e);
}
function l4e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && gd(e, t);
}
function gd(e, t) {
  return gd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, gd(e, t);
}
function fo(e, t, n) {
  return t = qk(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function qk(e) {
  var t = c4e(e, "string");
  return ss(t) == "symbol" ? t : t + "";
}
function c4e(e, t) {
  if (ss(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (ss(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Zi = /* @__PURE__ */ (function(e) {
  function t() {
    var n;
    r4e(this, t);
    for (var r = arguments.length, o = new Array(r), i = 0; i < r; i++)
      o[i] = arguments[i];
    return n = i4e(this, t, [].concat(o)), fo(n, "state", {
      isAnimationFinished: !0
    }), fo(n, "id", Bi("recharts-area-")), fo(n, "handleAnimationEnd", function() {
      var a = n.props.onAnimationEnd;
      n.setState({
        isAnimationFinished: !0
      }), je(a) && a();
    }), fo(n, "handleAnimationStart", function() {
      var a = n.props.onAnimationStart;
      n.setState({
        isAnimationFinished: !1
      }), je(a) && a();
    }), n;
  }
  return l4e(t, e), o4e(t, [{
    key: "renderDots",
    value: function(r, o, i) {
      var a = this.props.isAnimationActive, s = this.state.isAnimationFinished;
      if (a && !s)
        return null;
      var l = this.props, c = l.dot, u = l.points, f = l.dataKey, h = Be(this.props, !1), p = Be(c, !0), C = u.map(function(g, v) {
        var y = f1(f1(f1({
          key: "dot-".concat(v),
          r: 3
        }, h), p), {}, {
          index: v,
          cx: g.x,
          cy: g.y,
          dataKey: f,
          value: g.value,
          payload: g.payload,
          points: u
        });
        return t.renderDotItem(c, y);
      }), m = {
        clipPath: r ? "url(#clipPath-".concat(o ? "" : "dots-").concat(i, ")") : null
      };
      return /* @__PURE__ */ O.createElement(rt, ci({
        className: "recharts-area-dots"
      }, m), C);
    }
  }, {
    key: "renderHorizontalRect",
    value: function(r) {
      var o = this.props, i = o.baseLine, a = o.points, s = o.strokeWidth, l = a[0].x, c = a[a.length - 1].x, u = r * Math.abs(l - c), f = v1(a.map(function(h) {
        return h.y || 0;
      }));
      return he(i) && typeof i == "number" ? f = Math.max(i, f) : i && Array.isArray(i) && i.length && (f = Math.max(v1(i.map(function(h) {
        return h.y || 0;
      })), f)), he(f) ? /* @__PURE__ */ O.createElement("rect", {
        x: l < c ? l : l - u,
        y: 0,
        width: u,
        height: Math.floor(f + (s ? parseInt("".concat(s), 10) : 1))
      }) : null;
    }
  }, {
    key: "renderVerticalRect",
    value: function(r) {
      var o = this.props, i = o.baseLine, a = o.points, s = o.strokeWidth, l = a[0].y, c = a[a.length - 1].y, u = r * Math.abs(l - c), f = v1(a.map(function(h) {
        return h.x || 0;
      }));
      return he(i) && typeof i == "number" ? f = Math.max(i, f) : i && Array.isArray(i) && i.length && (f = Math.max(v1(i.map(function(h) {
        return h.x || 0;
      })), f)), he(f) ? /* @__PURE__ */ O.createElement("rect", {
        x: 0,
        y: l < c ? l : l - u,
        width: f + (s ? parseInt("".concat(s), 10) : 1),
        height: Math.floor(u)
      }) : null;
    }
  }, {
    key: "renderClipRect",
    value: function(r) {
      var o = this.props.layout;
      return o === "vertical" ? this.renderVerticalRect(r) : this.renderHorizontalRect(r);
    }
  }, {
    key: "renderAreaStatically",
    value: function(r, o, i, a) {
      var s = this.props, l = s.layout, c = s.type, u = s.stroke, f = s.connectNulls, h = s.isRange;
      s.ref;
      var p = Zk(s, e4e);
      return /* @__PURE__ */ O.createElement(rt, {
        clipPath: i ? "url(#clipPath-".concat(a, ")") : null
      }, /* @__PURE__ */ O.createElement(gi, ci({}, Be(p, !0), {
        points: r,
        connectNulls: f,
        type: c,
        baseLine: o,
        layout: l,
        stroke: "none",
        className: "recharts-area-area"
      })), u !== "none" && /* @__PURE__ */ O.createElement(gi, ci({}, Be(this.props, !1), {
        className: "recharts-area-curve",
        layout: l,
        type: c,
        connectNulls: f,
        fill: "none",
        points: r
      })), u !== "none" && h && /* @__PURE__ */ O.createElement(gi, ci({}, Be(this.props, !1), {
        className: "recharts-area-curve",
        layout: l,
        type: c,
        connectNulls: f,
        fill: "none",
        points: o
      })));
    }
  }, {
    key: "renderAreaWithAnimation",
    value: function(r, o) {
      var i = this, a = this.props, s = a.points, l = a.baseLine, c = a.isAnimationActive, u = a.animationBegin, f = a.animationDuration, h = a.animationEasing, p = a.animationId, C = this.state, m = C.prevPoints, g = C.prevBaseLine;
      return /* @__PURE__ */ O.createElement(Ur, {
        begin: u,
        duration: f,
        isActive: c,
        easing: h,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "area-".concat(p),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(v) {
        var y = v.t;
        if (m) {
          var w = m.length / s.length, x = s.map(function(E, P) {
            var T = Math.floor(P * w);
            if (m[T]) {
              var _ = m[T], D = jt(_.x, E.x), N = jt(_.y, E.y);
              return f1(f1({}, E), {}, {
                x: D(y),
                y: N(y)
              });
            }
            return E;
          }), b;
          if (he(l) && typeof l == "number") {
            var S = jt(g, l);
            b = S(y);
          } else if (Ne(l) || Es(l)) {
            var M = jt(g, 0);
            b = M(y);
          } else
            b = l.map(function(E, P) {
              var T = Math.floor(P * w);
              if (g[T]) {
                var _ = g[T], D = jt(_.x, E.x), N = jt(_.y, E.y);
                return f1(f1({}, E), {}, {
                  x: D(y),
                  y: N(y)
                });
              }
              return E;
            });
          return i.renderAreaStatically(x, b, r, o);
        }
        return /* @__PURE__ */ O.createElement(rt, null, /* @__PURE__ */ O.createElement("defs", null, /* @__PURE__ */ O.createElement("clipPath", {
          id: "animationClipPath-".concat(o)
        }, i.renderClipRect(y))), /* @__PURE__ */ O.createElement(rt, {
          clipPath: "url(#animationClipPath-".concat(o, ")")
        }, i.renderAreaStatically(s, l, r, o)));
      });
    }
  }, {
    key: "renderArea",
    value: function(r, o) {
      var i = this.props, a = i.points, s = i.baseLine, l = i.isAnimationActive, c = this.state, u = c.prevPoints, f = c.prevBaseLine, h = c.totalLength;
      return l && a && a.length && (!u && h > 0 || !Oi(u, a) || !Oi(f, s)) ? this.renderAreaWithAnimation(r, o) : this.renderAreaStatically(a, s, r, o);
    }
  }, {
    key: "render",
    value: function() {
      var r, o = this.props, i = o.hide, a = o.dot, s = o.points, l = o.className, c = o.top, u = o.left, f = o.xAxis, h = o.yAxis, p = o.width, C = o.height, m = o.isAnimationActive, g = o.id;
      if (i || !s || !s.length)
        return null;
      var v = this.state.isAnimationFinished, y = s.length === 1, w = We("recharts-area", l), x = f && f.allowDataOverflow, b = h && h.allowDataOverflow, S = x || b, M = Ne(g) ? this.id : g, E = (r = Be(a, !1)) !== null && r !== void 0 ? r : {
        r: 3,
        strokeWidth: 2
      }, P = E.r, T = P === void 0 ? 3 : P, _ = E.strokeWidth, D = _ === void 0 ? 2 : _, N = tD(a) ? a : {}, R = N.clipDot, L = R === void 0 ? !0 : R, B = T * 2 + D;
      return /* @__PURE__ */ O.createElement(rt, {
        className: w
      }, x || b ? /* @__PURE__ */ O.createElement("defs", null, /* @__PURE__ */ O.createElement("clipPath", {
        id: "clipPath-".concat(M)
      }, /* @__PURE__ */ O.createElement("rect", {
        x: x ? u : u - p / 2,
        y: b ? c : c - C / 2,
        width: x ? p : p * 2,
        height: b ? C : C * 2
      })), !L && /* @__PURE__ */ O.createElement("clipPath", {
        id: "clipPath-dots-".concat(M)
      }, /* @__PURE__ */ O.createElement("rect", {
        x: u - B / 2,
        y: c - B / 2,
        width: p + B,
        height: C + B
      }))) : null, y ? null : this.renderArea(S, M), (a || y) && this.renderDots(S, L, M), (!m || v) && go.renderCallByParent(this.props, s));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(r, o) {
      return r.animationId !== o.prevAnimationId ? {
        prevAnimationId: r.animationId,
        curPoints: r.points,
        curBaseLine: r.baseLine,
        prevPoints: o.curPoints,
        prevBaseLine: o.curBaseLine
      } : r.points !== o.curPoints || r.baseLine !== o.curBaseLine ? {
        curPoints: r.points,
        curBaseLine: r.baseLine
      } : null;
    }
  }]);
})(xo);
zk = Zi;
fo(Zi, "displayName", "Area");
fo(Zi, "defaultProps", {
  stroke: "#3182bd",
  fill: "#3182bd",
  fillOpacity: 0.6,
  xAxisId: 0,
  yAxisId: 0,
  legendType: "line",
  connectNulls: !1,
  // points of area
  points: [],
  dot: !1,
  activeDot: !0,
  hide: !1,
  isAnimationActive: !$1.isSsr,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
});
fo(Zi, "getBaseValue", function(e, t, n, r) {
  var o = e.layout, i = e.baseValue, a = t.props.baseValue, s = a ?? i;
  if (he(s) && typeof s == "number")
    return s;
  var l = o === "horizontal" ? r : n, c = l.scale.domain();
  if (l.type === "number") {
    var u = Math.max(c[0], c[1]), f = Math.min(c[0], c[1]);
    return s === "dataMin" ? f : s === "dataMax" || u < 0 ? u : Math.max(Math.min(c[0], c[1]), 0);
  }
  return s === "dataMin" ? c[0] : s === "dataMax" ? c[1] : c[0];
});
fo(Zi, "getComposedData", function(e) {
  var t = e.props, n = e.item, r = e.xAxis, o = e.yAxis, i = e.xAxisTicks, a = e.yAxisTicks, s = e.bandSize, l = e.dataKey, c = e.stackedData, u = e.dataStartIndex, f = e.displayedData, h = e.offset, p = t.layout, C = c && c.length, m = zk.getBaseValue(t, n, r, o), g = p === "horizontal", v = !1, y = f.map(function(x, b) {
    var S;
    C ? S = c[u + b] : (S = cn(x, l), Array.isArray(S) ? v = !0 : S = [m, S]);
    var M = S[1] == null || C && cn(x, l) == null;
    return g ? {
      x: Ya({
        axis: r,
        ticks: i,
        bandSize: s,
        entry: x,
        index: b
      }),
      y: M ? null : o.scale(S[1]),
      value: S,
      payload: x
    } : {
      x: M ? null : r.scale(S[1]),
      y: Ya({
        axis: o,
        ticks: a,
        bandSize: s,
        entry: x,
        index: b
      }),
      value: S,
      payload: x
    };
  }), w;
  return C || v ? w = y.map(function(x) {
    var b = Array.isArray(x.value) ? x.value[0] : null;
    return g ? {
      x: x.x,
      y: b != null && x.y != null ? o.scale(b) : null
    } : {
      x: b != null ? r.scale(b) : null,
      y: x.y
    };
  }) : w = g ? o.scale(m) : r.scale(m), f1({
    points: y,
    baseLine: w,
    layout: p,
    isRange: v
  }, h);
});
fo(Zi, "renderDotItem", function(e, t) {
  var n;
  if (/* @__PURE__ */ O.isValidElement(e))
    n = /* @__PURE__ */ O.cloneElement(e, t);
  else if (je(e))
    n = e(t);
  else {
    var r = We("recharts-area-dot", typeof e != "boolean" ? e.className : ""), o = t.key, i = Zk(t, t4e);
    n = /* @__PURE__ */ O.createElement(M0, ci({}, i, {
      key: o,
      className: r
    }));
  }
  return n;
});
function ls(e) {
  "@babel/helpers - typeof";
  return ls = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ls(e);
}
function u4e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function f4e(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, Kk(r.key), r);
  }
}
function d4e(e, t, n) {
  return t && f4e(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function h4e(e, t, n) {
  return t = hu(t), p4e(e, Uk() ? Reflect.construct(t, n || [], hu(e).constructor) : t.apply(e, n));
}
function p4e(e, t) {
  if (t && (ls(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return m4e(e);
}
function m4e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Uk() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Uk = function() {
    return !!e;
  })();
}
function hu(e) {
  return hu = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, hu(e);
}
function g4e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Cd(e, t);
}
function Cd(e, t) {
  return Cd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, Cd(e, t);
}
function Gk(e, t, n) {
  return t = Kk(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Kk(e) {
  var t = C4e(e, "string");
  return ls(t) == "symbol" ? t : t + "";
}
function C4e(e, t) {
  if (ls(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (ls(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var R0 = /* @__PURE__ */ (function(e) {
  function t() {
    return u4e(this, t), h4e(this, t, arguments);
  }
  return g4e(t, e), d4e(t, [{
    key: "render",
    value: function() {
      return null;
    }
  }]);
})(A.Component);
Gk(R0, "displayName", "ZAxis");
Gk(R0, "defaultProps", {
  zAxisId: 0,
  range: [64, 64],
  scale: "auto",
  type: "number"
});
var v4e = ["option", "isActive"];
function El() {
  return El = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, El.apply(this, arguments);
}
function y4e(e, t) {
  if (e == null) return {};
  var n = b4e(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function b4e(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function w4e(e) {
  var t = e.option, n = e.isActive, r = y4e(e, v4e);
  return typeof t == "string" ? /* @__PURE__ */ A.createElement(rd, El({
    option: /* @__PURE__ */ A.createElement(f0, El({
      type: t
    }, r)),
    isActive: n,
    shapeType: "symbols"
  }, r)) : /* @__PURE__ */ A.createElement(rd, El({
    option: t,
    isActive: n,
    shapeType: "symbols"
  }, r));
}
function cs(e) {
  "@babel/helpers - typeof";
  return cs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, cs(e);
}
function _l() {
  return _l = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, _l.apply(this, arguments);
}
function BE(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Cr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? BE(Object(n), !0).forEach(function(r) {
      b1(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : BE(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function x4e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function $E(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, Xk(r.key), r);
  }
}
function S4e(e, t, n) {
  return t && $E(e.prototype, t), n && $E(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function M4e(e, t, n) {
  return t = pu(t), E4e(e, Yk() ? Reflect.construct(t, n || [], pu(e).constructor) : t.apply(e, n));
}
function E4e(e, t) {
  if (t && (cs(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _4e(e);
}
function _4e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Yk() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Yk = function() {
    return !!e;
  })();
}
function pu(e) {
  return pu = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, pu(e);
}
function O4e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && vd(e, t);
}
function vd(e, t) {
  return vd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, vd(e, t);
}
function b1(e, t, n) {
  return t = Xk(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Xk(e) {
  var t = A4e(e, "string");
  return cs(t) == "symbol" ? t : t + "";
}
function A4e(e, t) {
  if (cs(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (cs(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var k0 = /* @__PURE__ */ (function(e) {
  function t() {
    var n;
    x4e(this, t);
    for (var r = arguments.length, o = new Array(r), i = 0; i < r; i++)
      o[i] = arguments[i];
    return n = M4e(this, t, [].concat(o)), b1(n, "state", {
      isAnimationFinished: !1
    }), b1(n, "handleAnimationEnd", function() {
      n.setState({
        isAnimationFinished: !0
      });
    }), b1(n, "handleAnimationStart", function() {
      n.setState({
        isAnimationFinished: !1
      });
    }), b1(n, "id", Bi("recharts-scatter-")), n;
  }
  return O4e(t, e), S4e(t, [{
    key: "renderSymbolsStatically",
    value: function(r) {
      var o = this, i = this.props, a = i.shape, s = i.activeShape, l = i.activeIndex, c = Be(this.props, !1);
      return r.map(function(u, f) {
        var h = l === f, p = h ? s : a, C = Cr(Cr({}, c), u);
        return /* @__PURE__ */ O.createElement(rt, _l({
          className: "recharts-scatter-symbol",
          key: "symbol-".concat(u?.cx, "-").concat(u?.cy, "-").concat(u?.size, "-").concat(f)
        }, jl(o.props, u, f), {
          role: "img"
        }), /* @__PURE__ */ O.createElement(w4e, _l({
          option: p,
          isActive: h,
          key: "symbol-".concat(f)
        }, C)));
      });
    }
  }, {
    key: "renderSymbolsWithAnimation",
    value: function() {
      var r = this, o = this.props, i = o.points, a = o.isAnimationActive, s = o.animationBegin, l = o.animationDuration, c = o.animationEasing, u = o.animationId, f = this.state.prevPoints;
      return /* @__PURE__ */ O.createElement(Ur, {
        begin: s,
        duration: l,
        isActive: a,
        easing: c,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "pie-".concat(u),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(h) {
        var p = h.t, C = i.map(function(m, g) {
          var v = f && f[g];
          if (v) {
            var y = jt(v.cx, m.cx), w = jt(v.cy, m.cy), x = jt(v.size, m.size);
            return Cr(Cr({}, m), {}, {
              cx: y(p),
              cy: w(p),
              size: x(p)
            });
          }
          var b = jt(0, m.size);
          return Cr(Cr({}, m), {}, {
            size: b(p)
          });
        });
        return /* @__PURE__ */ O.createElement(rt, null, r.renderSymbolsStatically(C));
      });
    }
  }, {
    key: "renderSymbols",
    value: function() {
      var r = this.props, o = r.points, i = r.isAnimationActive, a = this.state.prevPoints;
      return i && o && o.length && (!a || !Oi(a, o)) ? this.renderSymbolsWithAnimation() : this.renderSymbolsStatically(o);
    }
  }, {
    key: "renderErrorBar",
    value: function() {
      var r = this.props.isAnimationActive;
      if (r && !this.state.isAnimationFinished)
        return null;
      var o = this.props, i = o.points, a = o.xAxis, s = o.yAxis, l = o.children, c = Yn(l, Ts);
      return c ? c.map(function(u, f) {
        var h = u.props, p = h.direction, C = h.dataKey;
        return /* @__PURE__ */ O.cloneElement(u, {
          key: "".concat(p, "-").concat(C, "-").concat(i[f]),
          data: i,
          xAxis: a,
          yAxis: s,
          layout: p === "x" ? "vertical" : "horizontal",
          dataPointFormatter: function(g, v) {
            return {
              x: g.cx,
              y: g.cy,
              value: p === "x" ? +g.node.x : +g.node.y,
              errorVal: cn(g, v)
            };
          }
        });
      }) : null;
    }
  }, {
    key: "renderLine",
    value: function() {
      var r = this.props, o = r.points, i = r.line, a = r.lineType, s = r.lineJointType, l = Be(this.props, !1), c = Be(i, !1), u, f;
      if (a === "joint")
        u = o.map(function(w) {
          return {
            x: w.cx,
            y: w.cy
          };
        });
      else if (a === "fitting") {
        var h = coe(o), p = h.xmin, C = h.xmax, m = h.a, g = h.b, v = function(x) {
          return m * x + g;
        };
        u = [{
          x: p,
          y: v(p)
        }, {
          x: C,
          y: v(C)
        }];
      }
      var y = Cr(Cr(Cr({}, l), {}, {
        fill: "none",
        stroke: l && l.fill
      }, c), {}, {
        points: u
      });
      return /* @__PURE__ */ O.isValidElement(i) ? f = /* @__PURE__ */ O.cloneElement(i, y) : je(i) ? f = i(y) : f = /* @__PURE__ */ O.createElement(gi, _l({}, y, {
        type: s
      })), /* @__PURE__ */ O.createElement(rt, {
        className: "recharts-scatter-line",
        key: "recharts-scatter-line"
      }, f);
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, o = r.hide, i = r.points, a = r.line, s = r.className, l = r.xAxis, c = r.yAxis, u = r.left, f = r.top, h = r.width, p = r.height, C = r.id, m = r.isAnimationActive;
      if (o || !i || !i.length)
        return null;
      var g = this.state.isAnimationFinished, v = We("recharts-scatter", s), y = l && l.allowDataOverflow, w = c && c.allowDataOverflow, x = y || w, b = Ne(C) ? this.id : C;
      return /* @__PURE__ */ O.createElement(rt, {
        className: v,
        clipPath: x ? "url(#clipPath-".concat(b, ")") : null
      }, y || w ? /* @__PURE__ */ O.createElement("defs", null, /* @__PURE__ */ O.createElement("clipPath", {
        id: "clipPath-".concat(b)
      }, /* @__PURE__ */ O.createElement("rect", {
        x: y ? u : u - h / 2,
        y: w ? f : f - p / 2,
        width: y ? h : h * 2,
        height: w ? p : p * 2
      }))) : null, a && this.renderLine(), this.renderErrorBar(), /* @__PURE__ */ O.createElement(rt, {
        key: "recharts-scatter-symbols"
      }, this.renderSymbols()), (!m || g) && go.renderCallByParent(this.props, i));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(r, o) {
      return r.animationId !== o.prevAnimationId ? {
        prevAnimationId: r.animationId,
        curPoints: r.points,
        prevPoints: o.curPoints
      } : r.points !== o.curPoints ? {
        curPoints: r.points
      } : null;
    }
  }]);
})(xo);
b1(k0, "displayName", "Scatter");
b1(k0, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  zAxisId: 0,
  legendType: "circle",
  lineType: "joint",
  lineJointType: "linear",
  data: [],
  shape: "circle",
  hide: !1,
  isAnimationActive: !$1.isSsr,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: "linear"
});
b1(k0, "getComposedData", function(e) {
  var t = e.xAxis, n = e.yAxis, r = e.zAxis, o = e.item, i = e.displayedData, a = e.xAxisTicks, s = e.yAxisTicks, l = e.offset, c = o.props.tooltipType, u = Yn(o.props.children, Ip), f = Ne(t.dataKey) ? o.props.dataKey : t.dataKey, h = Ne(n.dataKey) ? o.props.dataKey : n.dataKey, p = r && r.dataKey, C = r ? r.range : R0.defaultProps.range, m = C && C[0], g = t.scale.bandwidth ? t.scale.bandwidth() : 0, v = n.scale.bandwidth ? n.scale.bandwidth() : 0, y = i.map(function(w, x) {
    var b = cn(w, f), S = cn(w, h), M = !Ne(p) && cn(w, p) || "-", E = [{
      name: Ne(t.dataKey) ? o.props.name : t.name || t.dataKey,
      unit: t.unit || "",
      value: b,
      payload: w,
      dataKey: f,
      type: c
    }, {
      name: Ne(n.dataKey) ? o.props.name : n.name || n.dataKey,
      unit: n.unit || "",
      value: S,
      payload: w,
      dataKey: h,
      type: c
    }];
    M !== "-" && E.push({
      name: r.name || r.dataKey,
      unit: r.unit || "",
      value: M,
      payload: w,
      dataKey: p,
      type: c
    });
    var P = Ya({
      axis: t,
      ticks: a,
      bandSize: g,
      entry: w,
      index: x,
      dataKey: f
    }), T = Ya({
      axis: n,
      ticks: s,
      bandSize: v,
      entry: w,
      index: x,
      dataKey: h
    }), _ = M !== "-" ? r.scale(M) : m, D = Math.sqrt(Math.max(_, 0) / Math.PI);
    return Cr(Cr({}, w), {}, {
      cx: P,
      cy: T,
      x: P - D,
      y: T - D,
      xAxis: t,
      yAxis: n,
      zAxis: r,
      width: 2 * D,
      height: 2 * D,
      size: _,
      node: {
        x: b,
        y: S,
        z: M
      },
      tooltipPayload: E,
      tooltipPosition: {
        x: P,
        y: T
      },
      payload: w
    }, u && u[x] && u[x].props);
  });
  return Cr({
    points: y
  }, l);
});
function us(e) {
  "@babel/helpers - typeof";
  return us = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, us(e);
}
function P4e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function T4e(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, eL(r.key), r);
  }
}
function I4e(e, t, n) {
  return t && T4e(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function D4e(e, t, n) {
  return t = mu(t), R4e(e, Qk() ? Reflect.construct(t, n || [], mu(e).constructor) : t.apply(e, n));
}
function R4e(e, t) {
  if (t && (us(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return k4e(e);
}
function k4e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Qk() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Qk = function() {
    return !!e;
  })();
}
function mu(e) {
  return mu = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, mu(e);
}
function L4e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && yd(e, t);
}
function yd(e, t) {
  return yd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, yd(e, t);
}
function Jk(e, t, n) {
  return t = eL(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function eL(e) {
  var t = N4e(e, "string");
  return us(t) == "symbol" ? t : t + "";
}
function N4e(e, t) {
  if (us(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (us(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function bd() {
  return bd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, bd.apply(this, arguments);
}
function F4e(e) {
  var t = e.xAxisId, n = sm(), r = lm(), o = Ak(t);
  return o == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ A.createElement(Is, bd({}, o, {
      className: We("recharts-".concat(o.axisType, " ").concat(o.axisType), o.className),
      viewBox: {
        x: 0,
        y: 0,
        width: n,
        height: r
      },
      ticksGenerator: function(a) {
        return Ho(a, !0);
      }
    }))
  );
}
var L0 = /* @__PURE__ */ (function(e) {
  function t() {
    return P4e(this, t), D4e(this, t, arguments);
  }
  return L4e(t, e), I4e(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ A.createElement(F4e, this.props);
    }
  }]);
})(A.Component);
Jk(L0, "displayName", "XAxis");
Jk(L0, "defaultProps", {
  allowDecimals: !0,
  hide: !1,
  orientation: "bottom",
  width: 0,
  height: 30,
  mirror: !1,
  xAxisId: 0,
  tickCount: 5,
  type: "category",
  padding: {
    left: 0,
    right: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1,
  allowDuplicatedCategory: !0
});
function fs(e) {
  "@babel/helpers - typeof";
  return fs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, fs(e);
}
function V4e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function B4e(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, rL(r.key), r);
  }
}
function $4e(e, t, n) {
  return t && B4e(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function j4e(e, t, n) {
  return t = gu(t), H4e(e, tL() ? Reflect.construct(t, n || [], gu(e).constructor) : t.apply(e, n));
}
function H4e(e, t) {
  if (t && (fs(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return z4e(e);
}
function z4e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function tL() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (tL = function() {
    return !!e;
  })();
}
function gu(e) {
  return gu = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, gu(e);
}
function Z4e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && wd(e, t);
}
function wd(e, t) {
  return wd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, wd(e, t);
}
function nL(e, t, n) {
  return t = rL(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function rL(e) {
  var t = W4e(e, "string");
  return fs(t) == "symbol" ? t : t + "";
}
function W4e(e, t) {
  if (fs(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (fs(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function xd() {
  return xd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, xd.apply(this, arguments);
}
var q4e = function(t) {
  var n = t.yAxisId, r = sm(), o = lm(), i = Pk(n);
  return i == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ A.createElement(Is, xd({}, i, {
      className: We("recharts-".concat(i.axisType, " ").concat(i.axisType), i.className),
      viewBox: {
        x: 0,
        y: 0,
        width: r,
        height: o
      },
      ticksGenerator: function(s) {
        return Ho(s, !0);
      }
    }))
  );
}, N0 = /* @__PURE__ */ (function(e) {
  function t() {
    return V4e(this, t), j4e(this, t, arguments);
  }
  return Z4e(t, e), $4e(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ A.createElement(q4e, this.props);
    }
  }]);
})(A.Component);
nL(N0, "displayName", "YAxis");
nL(N0, "defaultProps", {
  allowDuplicatedCategory: !0,
  allowDecimals: !0,
  hide: !1,
  orientation: "left",
  width: 60,
  height: 0,
  mirror: !1,
  yAxisId: 0,
  tickCount: 5,
  type: "number",
  padding: {
    top: 0,
    bottom: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1
});
function jE(e) {
  return Y4e(e) || K4e(e) || G4e(e) || U4e();
}
function U4e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function G4e(e, t) {
  if (e) {
    if (typeof e == "string") return Sd(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Sd(e, t);
  }
}
function K4e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Y4e(e) {
  if (Array.isArray(e)) return Sd(e);
}
function Sd(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
var Md = function(t, n, r, o, i) {
  var a = Yn(t, A0), s = Yn(t, T0), l = [].concat(jE(a), jE(s)), c = Yn(t, D0), u = "".concat(o, "Id"), f = o[0], h = n;
  if (l.length && (h = l.reduce(function(m, g) {
    if (g.props[u] === r && Co(g.props, "extendDomain") && he(g.props[f])) {
      var v = g.props[f];
      return [Math.min(m[0], v), Math.max(m[1], v)];
    }
    return m;
  }, h)), c.length) {
    var p = "".concat(f, "1"), C = "".concat(f, "2");
    h = c.reduce(function(m, g) {
      if (g.props[u] === r && Co(g.props, "extendDomain") && he(g.props[p]) && he(g.props[C])) {
        var v = g.props[p], y = g.props[C];
        return [Math.min(m[0], v, y), Math.max(m[1], v, y)];
      }
      return m;
    }, h);
  }
  return i && i.length && (h = i.reduce(function(m, g) {
    return he(g) ? [Math.min(m[0], g), Math.max(m[1], g)] : m;
  }, h)), h;
}, o9 = { exports: {} }, HE;
function X4e() {
  return HE || (HE = 1, (function(e) {
    var t = Object.prototype.hasOwnProperty, n = "~";
    function r() {
    }
    Object.create && (r.prototype = /* @__PURE__ */ Object.create(null), new r().__proto__ || (n = !1));
    function o(l, c, u) {
      this.fn = l, this.context = c, this.once = u || !1;
    }
    function i(l, c, u, f, h) {
      if (typeof u != "function")
        throw new TypeError("The listener must be a function");
      var p = new o(u, f || l, h), C = n ? n + c : c;
      return l._events[C] ? l._events[C].fn ? l._events[C] = [l._events[C], p] : l._events[C].push(p) : (l._events[C] = p, l._eventsCount++), l;
    }
    function a(l, c) {
      --l._eventsCount === 0 ? l._events = new r() : delete l._events[c];
    }
    function s() {
      this._events = new r(), this._eventsCount = 0;
    }
    s.prototype.eventNames = function() {
      var c = [], u, f;
      if (this._eventsCount === 0) return c;
      for (f in u = this._events)
        t.call(u, f) && c.push(n ? f.slice(1) : f);
      return Object.getOwnPropertySymbols ? c.concat(Object.getOwnPropertySymbols(u)) : c;
    }, s.prototype.listeners = function(c) {
      var u = n ? n + c : c, f = this._events[u];
      if (!f) return [];
      if (f.fn) return [f.fn];
      for (var h = 0, p = f.length, C = new Array(p); h < p; h++)
        C[h] = f[h].fn;
      return C;
    }, s.prototype.listenerCount = function(c) {
      var u = n ? n + c : c, f = this._events[u];
      return f ? f.fn ? 1 : f.length : 0;
    }, s.prototype.emit = function(c, u, f, h, p, C) {
      var m = n ? n + c : c;
      if (!this._events[m]) return !1;
      var g = this._events[m], v = arguments.length, y, w;
      if (g.fn) {
        switch (g.once && this.removeListener(c, g.fn, void 0, !0), v) {
          case 1:
            return g.fn.call(g.context), !0;
          case 2:
            return g.fn.call(g.context, u), !0;
          case 3:
            return g.fn.call(g.context, u, f), !0;
          case 4:
            return g.fn.call(g.context, u, f, h), !0;
          case 5:
            return g.fn.call(g.context, u, f, h, p), !0;
          case 6:
            return g.fn.call(g.context, u, f, h, p, C), !0;
        }
        for (w = 1, y = new Array(v - 1); w < v; w++)
          y[w - 1] = arguments[w];
        g.fn.apply(g.context, y);
      } else {
        var x = g.length, b;
        for (w = 0; w < x; w++)
          switch (g[w].once && this.removeListener(c, g[w].fn, void 0, !0), v) {
            case 1:
              g[w].fn.call(g[w].context);
              break;
            case 2:
              g[w].fn.call(g[w].context, u);
              break;
            case 3:
              g[w].fn.call(g[w].context, u, f);
              break;
            case 4:
              g[w].fn.call(g[w].context, u, f, h);
              break;
            default:
              if (!y) for (b = 1, y = new Array(v - 1); b < v; b++)
                y[b - 1] = arguments[b];
              g[w].fn.apply(g[w].context, y);
          }
      }
      return !0;
    }, s.prototype.on = function(c, u, f) {
      return i(this, c, u, f, !1);
    }, s.prototype.once = function(c, u, f) {
      return i(this, c, u, f, !0);
    }, s.prototype.removeListener = function(c, u, f, h) {
      var p = n ? n + c : c;
      if (!this._events[p]) return this;
      if (!u)
        return a(this, p), this;
      var C = this._events[p];
      if (C.fn)
        C.fn === u && (!h || C.once) && (!f || C.context === f) && a(this, p);
      else {
        for (var m = 0, g = [], v = C.length; m < v; m++)
          (C[m].fn !== u || h && !C[m].once || f && C[m].context !== f) && g.push(C[m]);
        g.length ? this._events[p] = g.length === 1 ? g[0] : g : a(this, p);
      }
      return this;
    }, s.prototype.removeAllListeners = function(c) {
      var u;
      return c ? (u = n ? n + c : c, this._events[u] && a(this, u)) : (this._events = new r(), this._eventsCount = 0), this;
    }, s.prototype.off = s.prototype.removeListener, s.prototype.addListener = s.prototype.on, s.prefixed = n, s.EventEmitter = s, e.exports = s;
  })(o9)), o9.exports;
}
var Q4e = X4e();
const J4e = /* @__PURE__ */ Mt(Q4e);
var i9 = new J4e(), a9 = "recharts.syncMouseEvents";
function b2(e) {
  "@babel/helpers - typeof";
  return b2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, b2(e);
}
function e9e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function t9e(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, oL(r.key), r);
  }
}
function n9e(e, t, n) {
  return t && t9e(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function s9(e, t, n) {
  return t = oL(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function oL(e) {
  var t = r9e(e, "string");
  return b2(t) == "symbol" ? t : t + "";
}
function r9e(e, t) {
  if (b2(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (b2(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var o9e = /* @__PURE__ */ (function() {
  function e() {
    e9e(this, e), s9(this, "activeIndex", 0), s9(this, "coordinateList", []), s9(this, "layout", "horizontal");
  }
  return n9e(e, [{
    key: "setDetails",
    value: function(n) {
      var r, o = n.coordinateList, i = o === void 0 ? null : o, a = n.container, s = a === void 0 ? null : a, l = n.layout, c = l === void 0 ? null : l, u = n.offset, f = u === void 0 ? null : u, h = n.mouseHandlerCallback, p = h === void 0 ? null : h;
      this.coordinateList = (r = i ?? this.coordinateList) !== null && r !== void 0 ? r : [], this.container = s ?? this.container, this.layout = c ?? this.layout, this.offset = f ?? this.offset, this.mouseHandlerCallback = p ?? this.mouseHandlerCallback, this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
    }
  }, {
    key: "focus",
    value: function() {
      this.spoofMouse();
    }
  }, {
    key: "keyboardEvent",
    value: function(n) {
      if (this.coordinateList.length !== 0)
        switch (n.key) {
          case "ArrowRight": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1), this.spoofMouse();
            break;
          }
          case "ArrowLeft": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.max(this.activeIndex - 1, 0), this.spoofMouse();
            break;
          }
        }
    }
  }, {
    key: "setIndex",
    value: function(n) {
      this.activeIndex = n;
    }
  }, {
    key: "spoofMouse",
    value: function() {
      var n, r;
      if (this.layout === "horizontal" && this.coordinateList.length !== 0) {
        var o = this.container.getBoundingClientRect(), i = o.x, a = o.y, s = o.height, l = this.coordinateList[this.activeIndex].coordinate, c = ((n = window) === null || n === void 0 ? void 0 : n.scrollX) || 0, u = ((r = window) === null || r === void 0 ? void 0 : r.scrollY) || 0, f = i + l + c, h = a + this.offset.top + s / 2 + u;
        this.mouseHandlerCallback({
          pageX: f,
          pageY: h
        });
      }
    }
  }]);
})();
function i9e(e, t, n) {
  if (n === "number" && t === !0 && Array.isArray(e)) {
    var r = e?.[0], o = e?.[1];
    if (r && o && he(r) && he(o))
      return !0;
  }
  return !1;
}
function a9e(e, t, n, r) {
  var o = r / 2;
  return {
    stroke: "none",
    fill: "#ccc",
    x: e === "horizontal" ? t.x - o : n.left + 0.5,
    y: e === "horizontal" ? n.top + 0.5 : t.y - o,
    width: e === "horizontal" ? r : n.width - 1,
    height: e === "horizontal" ? n.height - 1 : r
  };
}
function iL(e) {
  var t = e.cx, n = e.cy, r = e.radius, o = e.startAngle, i = e.endAngle, a = wn(t, n, r, o), s = wn(t, n, r, i);
  return {
    points: [a, s],
    cx: t,
    cy: n,
    radius: r,
    startAngle: o,
    endAngle: i
  };
}
function s9e(e, t, n) {
  var r, o, i, a;
  if (e === "horizontal")
    r = t.x, i = r, o = n.top, a = n.top + n.height;
  else if (e === "vertical")
    o = t.y, a = o, r = n.left, i = n.left + n.width;
  else if (t.cx != null && t.cy != null)
    if (e === "centric") {
      var s = t.cx, l = t.cy, c = t.innerRadius, u = t.outerRadius, f = t.angle, h = wn(s, l, c, f), p = wn(s, l, u, f);
      r = h.x, o = h.y, i = p.x, a = p.y;
    } else
      return iL(t);
  return [{
    x: r,
    y: o
  }, {
    x: i,
    y: a
  }];
}
function w2(e) {
  "@babel/helpers - typeof";
  return w2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, w2(e);
}
function zE(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Lc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? zE(Object(n), !0).forEach(function(r) {
      l9e(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : zE(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function l9e(e, t, n) {
  return t = c9e(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function c9e(e) {
  var t = u9e(e, "string");
  return w2(t) == "symbol" ? t : t + "";
}
function u9e(e, t) {
  if (w2(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (w2(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function f9e(e) {
  var t, n, r = e.element, o = e.tooltipEventType, i = e.isActive, a = e.activeCoordinate, s = e.activePayload, l = e.offset, c = e.activeTooltipIndex, u = e.tooltipAxisBandSize, f = e.layout, h = e.chartName, p = (t = r.props.cursor) !== null && t !== void 0 ? t : (n = r.type.defaultProps) === null || n === void 0 ? void 0 : n.cursor;
  if (!r || !p || !i || !a || h !== "ScatterChart" && o !== "axis")
    return null;
  var C, m = gi;
  if (h === "ScatterChart")
    C = a, m = k7e;
  else if (h === "BarChart")
    C = a9e(f, a, l, u), m = rm;
  else if (f === "radial") {
    var g = iL(a), v = g.cx, y = g.cy, w = g.radius, x = g.startAngle, b = g.endAngle;
    C = {
      cx: v,
      cy: y,
      startAngle: x,
      endAngle: b,
      innerRadius: w,
      outerRadius: w
    }, m = rk;
  } else
    C = {
      points: s9e(f, a, l)
    }, m = gi;
  var S = Lc(Lc(Lc(Lc({
    stroke: "#ccc",
    pointerEvents: "none"
  }, l), C), Be(p, !1)), {}, {
    payload: s,
    payloadIndex: c,
    className: We("recharts-tooltip-cursor", p.className)
  });
  return /* @__PURE__ */ sr(p) ? /* @__PURE__ */ Qt(p, S) : /* @__PURE__ */ Pd(m, S);
}
var d9e = ["item"], h9e = ["children", "className", "width", "height", "style", "compact", "title", "desc"];
function ds(e) {
  "@babel/helpers - typeof";
  return ds = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ds(e);
}
function Ca() {
  return Ca = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ca.apply(this, arguments);
}
function ZE(e, t) {
  return g9e(e) || m9e(e, t) || sL(e, t) || p9e();
}
function p9e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function m9e(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, o, i, a, s = [], l = !0, c = !1;
    try {
      if (i = (n = n.call(e)).next, t !== 0) for (; !(l = (r = i.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (u) {
      c = !0, o = u;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw o;
      }
    }
    return s;
  }
}
function g9e(e) {
  if (Array.isArray(e)) return e;
}
function WE(e, t) {
  if (e == null) return {};
  var n = C9e(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function C9e(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function v9e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function y9e(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, lL(r.key), r);
  }
}
function b9e(e, t, n) {
  return t && y9e(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function w9e(e, t, n) {
  return t = Cu(t), x9e(e, aL() ? Reflect.construct(t, n || [], Cu(e).constructor) : t.apply(e, n));
}
function x9e(e, t) {
  if (t && (ds(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return S9e(e);
}
function S9e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function aL() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (aL = function() {
    return !!e;
  })();
}
function Cu(e) {
  return Cu = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Cu(e);
}
function M9e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Ed(e, t);
}
function Ed(e, t) {
  return Ed = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, Ed(e, t);
}
function hs(e) {
  return O9e(e) || _9e(e) || sL(e) || E9e();
}
function E9e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function sL(e, t) {
  if (e) {
    if (typeof e == "string") return _d(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _d(e, t);
  }
}
function _9e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function O9e(e) {
  if (Array.isArray(e)) return _d(e);
}
function _d(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function qE(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function re(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? qE(Object(n), !0).forEach(function(r) {
      Ie(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : qE(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Ie(e, t, n) {
  return t = lL(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function lL(e) {
  var t = A9e(e, "string");
  return ds(t) == "symbol" ? t : t + "";
}
function A9e(e, t) {
  if (ds(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (ds(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var P9e = {
  xAxis: ["bottom", "top"],
  yAxis: ["left", "right"]
}, T9e = {
  width: "100%",
  height: "100%"
}, cL = {
  x: 0,
  y: 0
};
function Nc(e) {
  return e;
}
var I9e = function(t, n) {
  return n === "horizontal" ? t.x : n === "vertical" ? t.y : n === "centric" ? t.angle : t.radius;
}, D9e = function(t, n, r, o) {
  var i = n.find(function(u) {
    return u && u.index === r;
  });
  if (i) {
    if (t === "horizontal")
      return {
        x: i.coordinate,
        y: o.y
      };
    if (t === "vertical")
      return {
        x: o.x,
        y: i.coordinate
      };
    if (t === "centric") {
      var a = i.coordinate, s = o.radius;
      return re(re(re({}, o), wn(o.cx, o.cy, s, a)), {}, {
        angle: a,
        radius: s
      });
    }
    var l = i.coordinate, c = o.angle;
    return re(re(re({}, o), wn(o.cx, o.cy, l, c)), {}, {
      angle: c,
      radius: l
    });
  }
  return cL;
}, F0 = function(t, n) {
  var r = n.graphicalItems, o = n.dataStartIndex, i = n.dataEndIndex, a = (r ?? []).reduce(function(s, l) {
    var c = l.props.data;
    return c && c.length ? [].concat(hs(s), hs(c)) : s;
  }, []);
  return a.length > 0 ? a : t && t.length && he(o) && he(i) ? t.slice(o, i + 1) : [];
};
function uL(e) {
  return e === "number" ? [0, "auto"] : void 0;
}
var Od = function(t, n, r, o) {
  var i = t.graphicalItems, a = t.tooltipAxis, s = F0(n, t);
  return r < 0 || !i || !i.length || r >= s.length ? null : i.reduce(function(l, c) {
    var u, f = (u = c.props.data) !== null && u !== void 0 ? u : n;
    f && t.dataStartIndex + t.dataEndIndex !== 0 && // https://github.com/recharts/recharts/issues/4717
    // The data is sliced only when the active index is within the start/end index range.
    t.dataEndIndex - t.dataStartIndex >= r && (f = f.slice(t.dataStartIndex, t.dataEndIndex + 1));
    var h;
    if (a.dataKey && !a.allowDuplicatedCategory) {
      var p = f === void 0 ? s : f;
      h = v5(p, a.dataKey, o);
    } else
      h = f && f[r] || s[r];
    return h ? [].concat(hs(l), [ek(c, h)]) : l;
  }, []);
}, UE = function(t, n, r, o) {
  var i = o || {
    x: t.chartX,
    y: t.chartY
  }, a = I9e(i, r), s = t.orderedTooltipTicks, l = t.tooltipAxis, c = t.tooltipTicks, u = y5e(a, s, c, l);
  if (u >= 0 && c) {
    var f = c[u] && c[u].value, h = Od(t, n, u, f), p = D9e(r, s, u, i);
    return {
      activeTooltipIndex: u,
      activeLabel: f,
      activePayload: h,
      activeCoordinate: p
    };
  }
  return null;
}, R9e = function(t, n) {
  var r = n.axes, o = n.graphicalItems, i = n.axisType, a = n.axisIdKey, s = n.stackGroups, l = n.dataStartIndex, c = n.dataEndIndex, u = t.layout, f = t.children, h = t.stackOffset, p = XR(u, i);
  return r.reduce(function(C, m) {
    var g, v = m.type.defaultProps !== void 0 ? re(re({}, m.type.defaultProps), m.props) : m.props, y = v.type, w = v.dataKey, x = v.allowDataOverflow, b = v.allowDuplicatedCategory, S = v.scale, M = v.ticks, E = v.includeHidden, P = v[a];
    if (C[P])
      return C;
    var T = F0(t.data, {
      graphicalItems: o.filter(function(W) {
        var H, G = a in W.props ? W.props[a] : (H = W.type.defaultProps) === null || H === void 0 ? void 0 : H[a];
        return G === P;
      }),
      dataStartIndex: l,
      dataEndIndex: c
    }), _ = T.length, D, N, R;
    i9e(v.domain, x, y) && (D = jf(v.domain, null, x), p && (y === "number" || S !== "auto") && (R = xl(T, w, "category")));
    var L = uL(y);
    if (!D || D.length === 0) {
      var B, V = (B = v.domain) !== null && B !== void 0 ? B : L;
      if (w) {
        if (D = xl(T, w, y), y === "category" && p) {
          var k = loe(D);
          b && k ? (N = D, D = eu(0, _)) : b || (D = rM(V, D, m).reduce(function(W, H) {
            return W.indexOf(H) >= 0 ? W : [].concat(hs(W), [H]);
          }, []));
        } else if (y === "category")
          b ? D = D.filter(function(W) {
            return W !== "" && !Ne(W);
          }) : D = rM(V, D, m).reduce(function(W, H) {
            return W.indexOf(H) >= 0 || H === "" || Ne(H) ? W : [].concat(hs(W), [H]);
          }, []);
        else if (y === "number") {
          var z = M5e(T, o.filter(function(W) {
            var H, G, Y = a in W.props ? W.props[a] : (H = W.type.defaultProps) === null || H === void 0 ? void 0 : H[a], ne = "hide" in W.props ? W.props.hide : (G = W.type.defaultProps) === null || G === void 0 ? void 0 : G.hide;
            return Y === P && (E || !ne);
          }), w, i, u);
          z && (D = z);
        }
        p && (y === "number" || S !== "auto") && (R = xl(T, w, "category"));
      } else p ? D = eu(0, _) : s && s[P] && s[P].hasStack && y === "number" ? D = h === "expand" ? [0, 1] : JR(s[P].stackGroups, l, c) : D = YR(T, o.filter(function(W) {
        var H = a in W.props ? W.props[a] : W.type.defaultProps[a], G = "hide" in W.props ? W.props.hide : W.type.defaultProps.hide;
        return H === P && (E || !G);
      }), y, u, !0);
      if (y === "number")
        D = Md(f, D, P, i, M), V && (D = jf(V, D, x));
      else if (y === "category" && V) {
        var $ = V, Z = D.every(function(W) {
          return $.indexOf(W) >= 0;
        });
        Z && (D = $);
      }
    }
    return re(re({}, C), {}, Ie({}, P, re(re({}, v), {}, {
      axisType: i,
      domain: D,
      categoricalDomain: R,
      duplicateDomain: N,
      originalDomain: (g = v.domain) !== null && g !== void 0 ? g : L,
      isCategorical: p,
      layout: u
    })));
  }, {});
}, k9e = function(t, n) {
  var r = n.graphicalItems, o = n.Axis, i = n.axisType, a = n.axisIdKey, s = n.stackGroups, l = n.dataStartIndex, c = n.dataEndIndex, u = t.layout, f = t.children, h = F0(t.data, {
    graphicalItems: r,
    dataStartIndex: l,
    dataEndIndex: c
  }), p = h.length, C = XR(u, i), m = -1;
  return r.reduce(function(g, v) {
    var y = v.type.defaultProps !== void 0 ? re(re({}, v.type.defaultProps), v.props) : v.props, w = y[a], x = uL("number");
    if (!g[w]) {
      m++;
      var b;
      return C ? b = eu(0, p) : s && s[w] && s[w].hasStack ? (b = JR(s[w].stackGroups, l, c), b = Md(f, b, w, i)) : (b = jf(x, YR(h, r.filter(function(S) {
        var M, E, P = a in S.props ? S.props[a] : (M = S.type.defaultProps) === null || M === void 0 ? void 0 : M[a], T = "hide" in S.props ? S.props.hide : (E = S.type.defaultProps) === null || E === void 0 ? void 0 : E.hide;
        return P === w && !T;
      }), "number", u), o.defaultProps.allowDataOverflow), b = Md(f, b, w, i)), re(re({}, g), {}, Ie({}, w, re(re({
        axisType: i
      }, o.defaultProps), {}, {
        hide: !0,
        orientation: Sr(P9e, "".concat(i, ".").concat(m % 2), null),
        domain: b,
        originalDomain: x,
        isCategorical: C,
        layout: u
        // specify scale when no Axis
        // scale: isCategorical ? 'band' : 'linear',
      })));
    }
    return g;
  }, {});
}, L9e = function(t, n) {
  var r = n.axisType, o = r === void 0 ? "xAxis" : r, i = n.AxisComp, a = n.graphicalItems, s = n.stackGroups, l = n.dataStartIndex, c = n.dataEndIndex, u = t.children, f = "".concat(o, "Id"), h = Yn(u, i), p = {};
  return h && h.length ? p = R9e(t, {
    axes: h,
    graphicalItems: a,
    axisType: o,
    axisIdKey: f,
    stackGroups: s,
    dataStartIndex: l,
    dataEndIndex: c
  }) : a && a.length && (p = k9e(t, {
    Axis: i,
    graphicalItems: a,
    axisType: o,
    axisIdKey: f,
    stackGroups: s,
    dataStartIndex: l,
    dataEndIndex: c
  })), p;
}, N9e = function(t) {
  var n = p1(t), r = Ho(n, !1, !0);
  return {
    tooltipTicks: r,
    orderedTooltipTicks: Pp(r, function(o) {
      return o.coordinate;
    }),
    tooltipAxis: n,
    tooltipAxisBandSize: Z5(n, r)
  };
}, GE = function(t) {
  var n = t.children, r = t.defaultShowTooltip, o = nr(n, Ja), i = 0, a = 0;
  return t.data && t.data.length !== 0 && (a = t.data.length - 1), o && o.props && (o.props.startIndex >= 0 && (i = o.props.startIndex), o.props.endIndex >= 0 && (a = o.props.endIndex)), {
    chartX: 0,
    chartY: 0,
    dataStartIndex: i,
    dataEndIndex: a,
    activeTooltipIndex: -1,
    isTooltipActive: !!r
  };
}, F9e = function(t) {
  return !t || !t.length ? !1 : t.some(function(n) {
    var r = Zo(n && n.type);
    return r && r.indexOf("Bar") >= 0;
  });
}, KE = function(t) {
  return t === "horizontal" ? {
    numericAxisName: "yAxis",
    cateAxisName: "xAxis"
  } : t === "vertical" ? {
    numericAxisName: "xAxis",
    cateAxisName: "yAxis"
  } : t === "centric" ? {
    numericAxisName: "radiusAxis",
    cateAxisName: "angleAxis"
  } : {
    numericAxisName: "angleAxis",
    cateAxisName: "radiusAxis"
  };
}, V9e = function(t, n) {
  var r = t.props, o = t.graphicalItems, i = t.xAxisMap, a = i === void 0 ? {} : i, s = t.yAxisMap, l = s === void 0 ? {} : s, c = r.width, u = r.height, f = r.children, h = r.margin || {}, p = nr(f, Ja), C = nr(f, hi), m = Object.keys(l).reduce(function(b, S) {
    var M = l[S], E = M.orientation;
    return !M.mirror && !M.hide ? re(re({}, b), {}, Ie({}, E, b[E] + M.width)) : b;
  }, {
    left: h.left || 0,
    right: h.right || 0
  }), g = Object.keys(a).reduce(function(b, S) {
    var M = a[S], E = M.orientation;
    return !M.mirror && !M.hide ? re(re({}, b), {}, Ie({}, E, Sr(b, "".concat(E)) + M.height)) : b;
  }, {
    top: h.top || 0,
    bottom: h.bottom || 0
  }), v = re(re({}, g), m), y = v.bottom;
  p && (v.bottom += p.props.height || Ja.defaultProps.height), C && n && (v = x5e(v, o, r, n));
  var w = c - v.left - v.right, x = u - v.top - v.bottom;
  return re(re({
    brushBottom: y
  }, v), {}, {
    // never return negative values for height and width
    width: Math.max(w, 0),
    height: Math.max(x, 0)
  });
}, B9e = function(t, n) {
  if (n === "xAxis")
    return t[n].width;
  if (n === "yAxis")
    return t[n].height;
}, $9e = function(t) {
  var n = t.chartName, r = t.GraphicalChild, o = t.defaultTooltipEventType, i = o === void 0 ? "axis" : o, a = t.validateTooltipEventTypes, s = a === void 0 ? ["axis"] : a, l = t.axisComponents, c = t.legendContent, u = t.formatAxisMap, f = t.defaultProps, h = function(v, y) {
    var w = y.graphicalItems, x = y.stackGroups, b = y.offset, S = y.updateId, M = y.dataStartIndex, E = y.dataEndIndex, P = v.barSize, T = v.layout, _ = v.barGap, D = v.barCategoryGap, N = v.maxBarSize, R = KE(T), L = R.numericAxisName, B = R.cateAxisName, V = F9e(w), k = [];
    return w.forEach(function(z, $) {
      var Z = F0(v.data, {
        graphicalItems: [z],
        dataStartIndex: M,
        dataEndIndex: E
      }), W = z.type.defaultProps !== void 0 ? re(re({}, z.type.defaultProps), z.props) : z.props, H = W.dataKey, G = W.maxBarSize, Y = W["".concat(L, "Id")], ne = W["".concat(B, "Id")], J = {}, ee = l.reduce(function(ft, fe) {
        var ge, pe, De = y["".concat(fe.axisType, "Map")], xe = W["".concat(fe.axisType, "Id")];
        De && De[xe] || fe.axisType === "zAxis" || (process.env.NODE_ENV !== "production" ? Gn(!1, "Specifying a(n) ".concat(fe.axisType, "Id requires a corresponding ").concat(
          fe.axisType,
          "Id on the targeted graphical component "
        ).concat((ge = z == null || (pe = z.type) === null || pe === void 0 ? void 0 : pe.displayName) !== null && ge !== void 0 ? ge : "")) : Gn());
        var He = De[xe];
        return re(re({}, ft), {}, Ie(Ie({}, fe.axisType, He), "".concat(fe.axisType, "Ticks"), Ho(He)));
      }, J), U = ee[B], X = ee["".concat(B, "Ticks")], ie = x && x[Y] && x[Y].hasStack && N5e(z, x[Y].stackGroups), j = Zo(z.type).indexOf("Bar") >= 0, te = Z5(U, X), K = [], me = V && b5e({
        barSize: P,
        stackGroups: x,
        totalSize: B9e(ee, B)
      });
      if (j) {
        var we, ye, Ze = Ne(G) ? N : G, Ue = (we = (ye = Z5(U, X, !0)) !== null && ye !== void 0 ? ye : Ze) !== null && we !== void 0 ? we : 0;
        K = w5e({
          barGap: _,
          barCategoryGap: D,
          bandSize: Ue !== te ? Ue : te,
          sizeList: me[ne],
          maxBarSize: Ze
        }), Ue !== te && (K = K.map(function(ft) {
          return re(re({}, ft), {}, {
            position: re(re({}, ft.position), {}, {
              offset: ft.position.offset - Ue / 2
            })
          });
        }));
      }
      var Ke = z && z.type && z.type.getComposedData;
      Ke && k.push({
        props: re(re({}, Ke(re(re({}, ee), {}, {
          displayedData: Z,
          props: v,
          dataKey: H,
          item: z,
          bandSize: te,
          barPosition: K,
          offset: b,
          stackedData: ie,
          layout: T,
          dataStartIndex: M,
          dataEndIndex: E
        }))), {}, Ie(Ie(Ie({
          key: z.key || "item-".concat($)
        }, L, ee[L]), B, ee[B]), "animationId", S)),
        childIndex: woe(z, v.children),
        item: z
      });
    }), k;
  }, p = function(v, y) {
    var w = v.props, x = v.dataStartIndex, b = v.dataEndIndex, S = v.updateId;
    if (!vb({
      props: w
    }))
      return null;
    var M = w.children, E = w.layout, P = w.stackOffset, T = w.data, _ = w.reverseStackOrder, D = KE(E), N = D.numericAxisName, R = D.cateAxisName, L = Yn(M, r), B = R5e(T, L, "".concat(N, "Id"), "".concat(R, "Id"), P, _), V = l.reduce(function(W, H) {
      var G = "".concat(H.axisType, "Map");
      return re(re({}, W), {}, Ie({}, G, L9e(w, re(re({}, H), {}, {
        graphicalItems: L,
        stackGroups: H.axisType === N && B,
        dataStartIndex: x,
        dataEndIndex: b
      }))));
    }, {}), k = V9e(re(re({}, V), {}, {
      props: w,
      graphicalItems: L
    }), y?.legendBBox);
    Object.keys(V).forEach(function(W) {
      V[W] = u(w, V[W], k, W.replace("Map", ""), n);
    });
    var z = V["".concat(R, "Map")], $ = N9e(z), Z = h(w, re(re({}, V), {}, {
      dataStartIndex: x,
      dataEndIndex: b,
      updateId: S,
      graphicalItems: L,
      stackGroups: B,
      offset: k
    }));
    return re(re({
      formattedGraphicalItems: Z,
      graphicalItems: L,
      offset: k,
      stackGroups: B
    }, $), V);
  }, C = /* @__PURE__ */ (function(g) {
    function v(y) {
      var w, x, b;
      return v9e(this, v), b = w9e(this, v, [y]), Ie(b, "eventEmitterSymbol", Symbol("rechartsEventEmitter")), Ie(b, "accessibilityManager", new o9e()), Ie(b, "handleLegendBBoxUpdate", function(S) {
        if (S) {
          var M = b.state, E = M.dataStartIndex, P = M.dataEndIndex, T = M.updateId;
          b.setState(re({
            legendBBox: S
          }, p({
            props: b.props,
            dataStartIndex: E,
            dataEndIndex: P,
            updateId: T
          }, re(re({}, b.state), {}, {
            legendBBox: S
          }))));
        }
      }), Ie(b, "handleReceiveSyncEvent", function(S, M, E) {
        if (b.props.syncId === S) {
          if (E === b.eventEmitterSymbol && typeof b.props.syncMethod != "function")
            return;
          b.applySyncEvent(M);
        }
      }), Ie(b, "handleBrushChange", function(S) {
        var M = S.startIndex, E = S.endIndex;
        if (M !== b.state.dataStartIndex || E !== b.state.dataEndIndex) {
          var P = b.state.updateId;
          b.setState(function() {
            return re({
              dataStartIndex: M,
              dataEndIndex: E
            }, p({
              props: b.props,
              dataStartIndex: M,
              dataEndIndex: E,
              updateId: P
            }, b.state));
          }), b.triggerSyncEvent({
            dataStartIndex: M,
            dataEndIndex: E
          });
        }
      }), Ie(b, "handleMouseEnter", function(S) {
        var M = b.getMouseInfo(S);
        if (M) {
          var E = re(re({}, M), {}, {
            isTooltipActive: !0
          });
          b.setState(E), b.triggerSyncEvent(E);
          var P = b.props.onMouseEnter;
          je(P) && P(E, S);
        }
      }), Ie(b, "triggeredAfterMouseMove", function(S) {
        var M = b.getMouseInfo(S), E = M ? re(re({}, M), {}, {
          isTooltipActive: !0
        }) : {
          isTooltipActive: !1
        };
        b.setState(E), b.triggerSyncEvent(E);
        var P = b.props.onMouseMove;
        je(P) && P(E, S);
      }), Ie(b, "handleItemMouseEnter", function(S) {
        b.setState(function() {
          return {
            isTooltipActive: !0,
            activeItem: S,
            activePayload: S.tooltipPayload,
            activeCoordinate: S.tooltipPosition || {
              x: S.cx,
              y: S.cy
            }
          };
        });
      }), Ie(b, "handleItemMouseLeave", function() {
        b.setState(function() {
          return {
            isTooltipActive: !1
          };
        });
      }), Ie(b, "handleMouseMove", function(S) {
        S.persist(), b.throttleTriggeredAfterMouseMove(S);
      }), Ie(b, "handleMouseLeave", function(S) {
        b.throttleTriggeredAfterMouseMove.cancel();
        var M = {
          isTooltipActive: !1
        };
        b.setState(M), b.triggerSyncEvent(M);
        var E = b.props.onMouseLeave;
        je(E) && E(M, S);
      }), Ie(b, "handleOuterEvent", function(S) {
        var M = boe(S), E = Sr(b.props, "".concat(M));
        if (M && je(E)) {
          var P, T;
          /.*touch.*/i.test(M) ? T = b.getMouseInfo(S.changedTouches[0]) : T = b.getMouseInfo(S), E((P = T) !== null && P !== void 0 ? P : {}, S);
        }
      }), Ie(b, "handleClick", function(S) {
        var M = b.getMouseInfo(S);
        if (M) {
          var E = re(re({}, M), {}, {
            isTooltipActive: !0
          });
          b.setState(E), b.triggerSyncEvent(E);
          var P = b.props.onClick;
          je(P) && P(E, S);
        }
      }), Ie(b, "handleMouseDown", function(S) {
        var M = b.props.onMouseDown;
        if (je(M)) {
          var E = b.getMouseInfo(S);
          M(E, S);
        }
      }), Ie(b, "handleMouseUp", function(S) {
        var M = b.props.onMouseUp;
        if (je(M)) {
          var E = b.getMouseInfo(S);
          M(E, S);
        }
      }), Ie(b, "handleTouchMove", function(S) {
        S.changedTouches != null && S.changedTouches.length > 0 && b.throttleTriggeredAfterMouseMove(S.changedTouches[0]);
      }), Ie(b, "handleTouchStart", function(S) {
        S.changedTouches != null && S.changedTouches.length > 0 && b.handleMouseDown(S.changedTouches[0]);
      }), Ie(b, "handleTouchEnd", function(S) {
        S.changedTouches != null && S.changedTouches.length > 0 && b.handleMouseUp(S.changedTouches[0]);
      }), Ie(b, "handleDoubleClick", function(S) {
        var M = b.props.onDoubleClick;
        if (je(M)) {
          var E = b.getMouseInfo(S);
          M(E, S);
        }
      }), Ie(b, "handleContextMenu", function(S) {
        var M = b.props.onContextMenu;
        if (je(M)) {
          var E = b.getMouseInfo(S);
          M(E, S);
        }
      }), Ie(b, "triggerSyncEvent", function(S) {
        b.props.syncId !== void 0 && i9.emit(a9, b.props.syncId, S, b.eventEmitterSymbol);
      }), Ie(b, "applySyncEvent", function(S) {
        var M = b.props, E = M.layout, P = M.syncMethod, T = b.state.updateId, _ = S.dataStartIndex, D = S.dataEndIndex;
        if (S.dataStartIndex !== void 0 || S.dataEndIndex !== void 0)
          b.setState(re({
            dataStartIndex: _,
            dataEndIndex: D
          }, p({
            props: b.props,
            dataStartIndex: _,
            dataEndIndex: D,
            updateId: T
          }, b.state)));
        else if (S.activeTooltipIndex !== void 0) {
          var N = S.chartX, R = S.chartY, L = S.activeTooltipIndex, B = b.state, V = B.offset, k = B.tooltipTicks;
          if (!V)
            return;
          if (typeof P == "function")
            L = P(k, S);
          else if (P === "value") {
            L = -1;
            for (var z = 0; z < k.length; z++)
              if (k[z].value === S.activeLabel) {
                L = z;
                break;
              }
          }
          var $ = re(re({}, V), {}, {
            x: V.left,
            y: V.top
          }), Z = Math.min(N, $.x + $.width), W = Math.min(R, $.y + $.height), H = k[L] && k[L].value, G = Od(b.state, b.props.data, L), Y = k[L] ? {
            x: E === "horizontal" ? k[L].coordinate : Z,
            y: E === "horizontal" ? W : k[L].coordinate
          } : cL;
          b.setState(re(re({}, S), {}, {
            activeLabel: H,
            activeCoordinate: Y,
            activePayload: G,
            activeTooltipIndex: L
          }));
        } else
          b.setState(S);
      }), Ie(b, "renderCursor", function(S) {
        var M, E = b.state, P = E.isTooltipActive, T = E.activeCoordinate, _ = E.activePayload, D = E.offset, N = E.activeTooltipIndex, R = E.tooltipAxisBandSize, L = b.getTooltipEventType(), B = (M = S.props.active) !== null && M !== void 0 ? M : P, V = b.props.layout, k = S.key || "_recharts-cursor";
        return /* @__PURE__ */ O.createElement(f9e, {
          key: k,
          activeCoordinate: T,
          activePayload: _,
          activeTooltipIndex: N,
          chartName: n,
          element: S,
          isActive: B,
          layout: V,
          offset: D,
          tooltipAxisBandSize: R,
          tooltipEventType: L
        });
      }), Ie(b, "renderPolarAxis", function(S, M, E) {
        var P = Sr(S, "type.axisType"), T = Sr(b.state, "".concat(P, "Map")), _ = S.type.defaultProps, D = _ !== void 0 ? re(re({}, _), S.props) : S.props, N = T && T[D["".concat(P, "Id")]];
        return /* @__PURE__ */ Qt(S, re(re({}, N), {}, {
          className: We(P, N.className),
          key: S.key || "".concat(M, "-").concat(E),
          ticks: Ho(N, !0)
        }));
      }), Ie(b, "renderPolarGrid", function(S) {
        var M = S.props, E = M.radialLines, P = M.polarAngles, T = M.polarRadius, _ = b.state, D = _.radiusAxisMap, N = _.angleAxisMap, R = p1(D), L = p1(N), B = L.cx, V = L.cy, k = L.innerRadius, z = L.outerRadius;
        return /* @__PURE__ */ Qt(S, {
          polarAngles: Array.isArray(P) ? P : Ho(L, !0).map(function($) {
            return $.coordinate;
          }),
          polarRadius: Array.isArray(T) ? T : Ho(R, !0).map(function($) {
            return $.coordinate;
          }),
          cx: B,
          cy: V,
          innerRadius: k,
          outerRadius: z,
          key: S.key || "polar-grid",
          radialLines: E
        });
      }), Ie(b, "renderLegend", function() {
        var S = b.state.formattedGraphicalItems, M = b.props, E = M.children, P = M.width, T = M.height, _ = b.props.margin || {}, D = P - (_.left || 0) - (_.right || 0), N = GR({
          children: E,
          formattedGraphicalItems: S,
          legendWidth: D,
          legendContent: c
        });
        if (!N)
          return null;
        var R = N.item, L = WE(N, d9e);
        return /* @__PURE__ */ Qt(R, re(re({}, L), {}, {
          chartWidth: P,
          chartHeight: T,
          margin: _,
          onBBoxUpdate: b.handleLegendBBoxUpdate
        }));
      }), Ie(b, "renderTooltip", function() {
        var S, M = b.props, E = M.children, P = M.accessibilityLayer, T = nr(E, eo);
        if (!T)
          return null;
        var _ = b.state, D = _.isTooltipActive, N = _.activeCoordinate, R = _.activePayload, L = _.activeLabel, B = _.offset, V = (S = T.props.active) !== null && S !== void 0 ? S : D;
        return /* @__PURE__ */ Qt(T, {
          viewBox: re(re({}, B), {}, {
            x: B.left,
            y: B.top
          }),
          active: V,
          label: L,
          payload: V ? R : [],
          coordinate: N,
          accessibilityLayer: P
        });
      }), Ie(b, "renderBrush", function(S) {
        var M = b.props, E = M.margin, P = M.data, T = b.state, _ = T.offset, D = T.dataStartIndex, N = T.dataEndIndex, R = T.updateId;
        return /* @__PURE__ */ Qt(S, {
          key: S.key || "_recharts-brush",
          onChange: Ic(b.handleBrushChange, S.props.onChange),
          data: P,
          x: he(S.props.x) ? S.props.x : _.left,
          y: he(S.props.y) ? S.props.y : _.top + _.height + _.brushBottom - (E.bottom || 0),
          width: he(S.props.width) ? S.props.width : _.width,
          startIndex: D,
          endIndex: N,
          updateId: "brush-".concat(R)
        });
      }), Ie(b, "renderReferenceElement", function(S, M, E) {
        if (!S)
          return null;
        var P = b, T = P.clipPathId, _ = b.state, D = _.xAxisMap, N = _.yAxisMap, R = _.offset, L = S.type.defaultProps || {}, B = S.props, V = B.xAxisId, k = V === void 0 ? L.xAxisId : V, z = B.yAxisId, $ = z === void 0 ? L.yAxisId : z;
        return /* @__PURE__ */ Qt(S, {
          key: S.key || "".concat(M, "-").concat(E),
          xAxis: D[k],
          yAxis: N[$],
          viewBox: {
            x: R.left,
            y: R.top,
            width: R.width,
            height: R.height
          },
          clipPathId: T
        });
      }), Ie(b, "renderActivePoints", function(S) {
        var M = S.item, E = S.activePoint, P = S.basePoint, T = S.childIndex, _ = S.isRange, D = [], N = M.props.key, R = M.item.type.defaultProps !== void 0 ? re(re({}, M.item.type.defaultProps), M.item.props) : M.item.props, L = R.activeDot, B = R.dataKey, V = re(re({
          index: T,
          dataKey: B,
          cx: E.x,
          cy: E.y,
          r: 4,
          fill: nm(M.item),
          strokeWidth: 2,
          stroke: "#fff",
          payload: E.payload,
          value: E.value
        }, Be(L, !1)), y5(L));
        return D.push(v.renderActiveDot(L, V, "".concat(N, "-activePoint-").concat(T))), P ? D.push(v.renderActiveDot(L, re(re({}, V), {}, {
          cx: P.x,
          cy: P.y
        }), "".concat(N, "-basePoint-").concat(T))) : _ && D.push(null), D;
      }), Ie(b, "renderGraphicChild", function(S, M, E) {
        var P = b.filterFormatItem(S, M, E);
        if (!P)
          return null;
        var T = b.getTooltipEventType(), _ = b.state, D = _.isTooltipActive, N = _.tooltipAxis, R = _.activeTooltipIndex, L = _.activeLabel, B = b.props.children, V = nr(B, eo), k = P.props, z = k.points, $ = k.isRange, Z = k.baseLine, W = P.item.type.defaultProps !== void 0 ? re(re({}, P.item.type.defaultProps), P.item.props) : P.item.props, H = W.activeDot, G = W.hide, Y = W.activeBar, ne = W.activeShape, J = !!(!G && D && V && (H || Y || ne)), ee = {};
        T !== "axis" && V && V.props.trigger === "click" ? ee = {
          onClick: Ic(b.handleItemMouseEnter, S.props.onClick)
        } : T !== "axis" && (ee = {
          onMouseLeave: Ic(b.handleItemMouseLeave, S.props.onMouseLeave),
          onMouseEnter: Ic(b.handleItemMouseEnter, S.props.onMouseEnter)
        });
        var U = /* @__PURE__ */ Qt(S, re(re({}, P.props), ee));
        function X(fe) {
          return typeof N.dataKey == "function" ? N.dataKey(fe.payload) : null;
        }
        if (J)
          if (R >= 0) {
            var ie, j;
            if (N.dataKey && !N.allowDuplicatedCategory) {
              var te = typeof N.dataKey == "function" ? X : "payload.".concat(N.dataKey.toString());
              ie = v5(z, te, L), j = $ && Z && v5(Z, te, L);
            } else
              ie = z?.[R], j = $ && Z && Z[R];
            if (ne || Y) {
              var K = S.props.activeIndex !== void 0 ? S.props.activeIndex : R;
              return [/* @__PURE__ */ Qt(S, re(re(re({}, P.props), ee), {}, {
                activeIndex: K
              })), null, null];
            }
            if (!Ne(ie))
              return [U].concat(hs(b.renderActivePoints({
                item: P,
                activePoint: ie,
                basePoint: j,
                childIndex: R,
                isRange: $
              })));
          } else {
            var me, we = (me = b.getItemByXY(b.state.activeCoordinate)) !== null && me !== void 0 ? me : {
              graphicalItem: U
            }, ye = we.graphicalItem, Ze = ye.item, Ue = Ze === void 0 ? S : Ze, Ke = ye.childIndex, ft = re(re(re({}, P.props), ee), {}, {
              activeIndex: Ke
            });
            return [/* @__PURE__ */ Qt(Ue, ft), null, null];
          }
        return $ ? [U, null, null] : [U, null];
      }), Ie(b, "renderCustomized", function(S, M, E) {
        return /* @__PURE__ */ Qt(S, re(re({
          key: "recharts-customized-".concat(E)
        }, b.props), b.state));
      }), Ie(b, "renderMap", {
        CartesianGrid: {
          handler: Nc,
          once: !0
        },
        ReferenceArea: {
          handler: b.renderReferenceElement
        },
        ReferenceLine: {
          handler: Nc
        },
        ReferenceDot: {
          handler: b.renderReferenceElement
        },
        XAxis: {
          handler: Nc
        },
        YAxis: {
          handler: Nc
        },
        Brush: {
          handler: b.renderBrush,
          once: !0
        },
        Bar: {
          handler: b.renderGraphicChild
        },
        Line: {
          handler: b.renderGraphicChild
        },
        Area: {
          handler: b.renderGraphicChild
        },
        Radar: {
          handler: b.renderGraphicChild
        },
        RadialBar: {
          handler: b.renderGraphicChild
        },
        Scatter: {
          handler: b.renderGraphicChild
        },
        Pie: {
          handler: b.renderGraphicChild
        },
        Funnel: {
          handler: b.renderGraphicChild
        },
        Tooltip: {
          handler: b.renderCursor,
          once: !0
        },
        PolarGrid: {
          handler: b.renderPolarGrid,
          once: !0
        },
        PolarAngleAxis: {
          handler: b.renderPolarAxis
        },
        PolarRadiusAxis: {
          handler: b.renderPolarAxis
        },
        Customized: {
          handler: b.renderCustomized
        }
      }), b.clipPathId = "".concat((w = y.id) !== null && w !== void 0 ? w : Bi("recharts"), "-clip"), b.throttleTriggeredAfterMouseMove = GD(b.triggeredAfterMouseMove, (x = y.throttleDelay) !== null && x !== void 0 ? x : 1e3 / 60), b.state = {}, b;
    }
    return M9e(v, g), b9e(v, [{
      key: "componentDidMount",
      value: function() {
        var w, x;
        this.addListener(), this.accessibilityManager.setDetails({
          container: this.container,
          offset: {
            left: (w = this.props.margin.left) !== null && w !== void 0 ? w : 0,
            top: (x = this.props.margin.top) !== null && x !== void 0 ? x : 0
          },
          coordinateList: this.state.tooltipTicks,
          mouseHandlerCallback: this.triggeredAfterMouseMove,
          layout: this.props.layout
        }), this.displayDefaultTooltip();
      }
    }, {
      key: "displayDefaultTooltip",
      value: function() {
        var w = this.props, x = w.children, b = w.data, S = w.height, M = w.layout, E = nr(x, eo);
        if (E) {
          var P = E.props.defaultIndex;
          if (!(typeof P != "number" || P < 0 || P > this.state.tooltipTicks.length - 1)) {
            var T = this.state.tooltipTicks[P] && this.state.tooltipTicks[P].value, _ = Od(this.state, b, P, T), D = this.state.tooltipTicks[P].coordinate, N = (this.state.offset.top + S) / 2, R = M === "horizontal", L = R ? {
              x: D,
              y: N
            } : {
              y: D,
              x: N
            }, B = this.state.formattedGraphicalItems.find(function(k) {
              var z = k.item;
              return z.type.name === "Scatter";
            });
            B && (L = re(re({}, L), B.props.points[P].tooltipPosition), _ = B.props.points[P].tooltipPayload);
            var V = {
              activeTooltipIndex: P,
              isTooltipActive: !0,
              activeLabel: T,
              activePayload: _,
              activeCoordinate: L
            };
            this.setState(V), this.renderCursor(E), this.accessibilityManager.setIndex(P);
          }
        }
      }
    }, {
      key: "getSnapshotBeforeUpdate",
      value: function(w, x) {
        if (!this.props.accessibilityLayer)
          return null;
        if (this.state.tooltipTicks !== x.tooltipTicks && this.accessibilityManager.setDetails({
          coordinateList: this.state.tooltipTicks
        }), this.props.layout !== w.layout && this.accessibilityManager.setDetails({
          layout: this.props.layout
        }), this.props.margin !== w.margin) {
          var b, S;
          this.accessibilityManager.setDetails({
            offset: {
              left: (b = this.props.margin.left) !== null && b !== void 0 ? b : 0,
              top: (S = this.props.margin.top) !== null && S !== void 0 ? S : 0
            }
          });
        }
        return null;
      }
    }, {
      key: "componentDidUpdate",
      value: function(w) {
        cf([nr(w.children, eo)], [nr(this.props.children, eo)]) || this.displayDefaultTooltip();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.removeListener(), this.throttleTriggeredAfterMouseMove.cancel();
      }
    }, {
      key: "getTooltipEventType",
      value: function() {
        var w = nr(this.props.children, eo);
        if (w && typeof w.props.shared == "boolean") {
          var x = w.props.shared ? "axis" : "item";
          return s.indexOf(x) >= 0 ? x : i;
        }
        return i;
      }
      /**
       * Get the information of mouse in chart, return null when the mouse is not in the chart
       * @param  {MousePointer} event    The event object
       * @return {Object}          Mouse data
       */
    }, {
      key: "getMouseInfo",
      value: function(w) {
        if (!this.container)
          return null;
        var x = this.container, b = x.getBoundingClientRect(), S = cse(b), M = {
          chartX: Math.round(w.pageX - S.left),
          chartY: Math.round(w.pageY - S.top)
        }, E = b.width / x.offsetWidth || 1, P = this.inRange(M.chartX, M.chartY, E);
        if (!P)
          return null;
        var T = this.state, _ = T.xAxisMap, D = T.yAxisMap, N = this.getTooltipEventType(), R = UE(this.state, this.props.data, this.props.layout, P);
        if (N !== "axis" && _ && D) {
          var L = p1(_).scale, B = p1(D).scale, V = L && L.invert ? L.invert(M.chartX) : null, k = B && B.invert ? B.invert(M.chartY) : null;
          return re(re({}, M), {}, {
            xValue: V,
            yValue: k
          }, R);
        }
        return R ? re(re({}, M), R) : null;
      }
    }, {
      key: "inRange",
      value: function(w, x) {
        var b = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, S = this.props.layout, M = w / b, E = x / b;
        if (S === "horizontal" || S === "vertical") {
          var P = this.state.offset, T = M >= P.left && M <= P.left + P.width && E >= P.top && E <= P.top + P.height;
          return T ? {
            x: M,
            y: E
          } : null;
        }
        var _ = this.state, D = _.angleAxisMap, N = _.radiusAxisMap;
        if (D && N) {
          var R = p1(D);
          return aM({
            x: M,
            y: E
          }, R);
        }
        return null;
      }
    }, {
      key: "parseEventsOfWrapper",
      value: function() {
        var w = this.props.children, x = this.getTooltipEventType(), b = nr(w, eo), S = {};
        b && x === "axis" && (b.props.trigger === "click" ? S = {
          onClick: this.handleClick
        } : S = {
          onMouseEnter: this.handleMouseEnter,
          onDoubleClick: this.handleDoubleClick,
          onMouseMove: this.handleMouseMove,
          onMouseLeave: this.handleMouseLeave,
          onTouchMove: this.handleTouchMove,
          onTouchStart: this.handleTouchStart,
          onTouchEnd: this.handleTouchEnd,
          onContextMenu: this.handleContextMenu
        });
        var M = y5(this.props, this.handleOuterEvent);
        return re(re({}, M), S);
      }
    }, {
      key: "addListener",
      value: function() {
        i9.on(a9, this.handleReceiveSyncEvent);
      }
    }, {
      key: "removeListener",
      value: function() {
        i9.removeListener(a9, this.handleReceiveSyncEvent);
      }
    }, {
      key: "filterFormatItem",
      value: function(w, x, b) {
        for (var S = this.state.formattedGraphicalItems, M = 0, E = S.length; M < E; M++) {
          var P = S[M];
          if (P.item === w || P.props.key === w.key || x === Zo(P.item.type) && b === P.childIndex)
            return P;
        }
        return null;
      }
    }, {
      key: "renderClipPath",
      value: function() {
        var w = this.clipPathId, x = this.state.offset, b = x.left, S = x.top, M = x.height, E = x.width;
        return /* @__PURE__ */ O.createElement("defs", null, /* @__PURE__ */ O.createElement("clipPath", {
          id: w
        }, /* @__PURE__ */ O.createElement("rect", {
          x: b,
          y: S,
          height: M,
          width: E
        })));
      }
    }, {
      key: "getXScales",
      value: function() {
        var w = this.state.xAxisMap;
        return w ? Object.entries(w).reduce(function(x, b) {
          var S = ZE(b, 2), M = S[0], E = S[1];
          return re(re({}, x), {}, Ie({}, M, E.scale));
        }, {}) : null;
      }
    }, {
      key: "getYScales",
      value: function() {
        var w = this.state.yAxisMap;
        return w ? Object.entries(w).reduce(function(x, b) {
          var S = ZE(b, 2), M = S[0], E = S[1];
          return re(re({}, x), {}, Ie({}, M, E.scale));
        }, {}) : null;
      }
    }, {
      key: "getXScaleByAxisId",
      value: function(w) {
        var x;
        return (x = this.state.xAxisMap) === null || x === void 0 || (x = x[w]) === null || x === void 0 ? void 0 : x.scale;
      }
    }, {
      key: "getYScaleByAxisId",
      value: function(w) {
        var x;
        return (x = this.state.yAxisMap) === null || x === void 0 || (x = x[w]) === null || x === void 0 ? void 0 : x.scale;
      }
    }, {
      key: "getItemByXY",
      value: function(w) {
        var x = this.state, b = x.formattedGraphicalItems, S = x.activeItem;
        if (b && b.length)
          for (var M = 0, E = b.length; M < E; M++) {
            var P = b[M], T = P.props, _ = P.item, D = _.type.defaultProps !== void 0 ? re(re({}, _.type.defaultProps), _.props) : _.props, N = Zo(_.type);
            if (N === "Bar") {
              var R = (T.data || []).find(function(k) {
                return M7e(w, k);
              });
              if (R)
                return {
                  graphicalItem: P,
                  payload: R
                };
            } else if (N === "RadialBar") {
              var L = (T.data || []).find(function(k) {
                return aM(w, k);
              });
              if (L)
                return {
                  graphicalItem: P,
                  payload: L
                };
            } else if (E0(P, S) || _0(P, S) || g2(P, S)) {
              var B = h3e({
                graphicalItem: P,
                activeTooltipItem: S,
                itemData: D.data
              }), V = D.activeIndex === void 0 ? B : D.activeIndex;
              return {
                graphicalItem: re(re({}, P), {}, {
                  childIndex: V
                }),
                payload: g2(P, S) ? D.data[B] : P.props.data[B]
              };
            }
          }
        return null;
      }
    }, {
      key: "render",
      value: function() {
        var w = this;
        if (!vb(this))
          return null;
        var x = this.props, b = x.children, S = x.className, M = x.width, E = x.height, P = x.style, T = x.compact, _ = x.title, D = x.desc, N = WE(x, h9e), R = Be(N, !1);
        if (T)
          return /* @__PURE__ */ O.createElement(wE, {
            state: this.state,
            width: this.props.width,
            height: this.props.height,
            clipPathId: this.clipPathId
          }, /* @__PURE__ */ O.createElement(ff, Ca({}, R, {
            width: M,
            height: E,
            title: _,
            desc: D
          }), this.renderClipPath(), bb(b, this.renderMap)));
        if (this.props.accessibilityLayer) {
          var L, B;
          R.tabIndex = (L = this.props.tabIndex) !== null && L !== void 0 ? L : 0, R.role = (B = this.props.role) !== null && B !== void 0 ? B : "application", R.onKeyDown = function(k) {
            w.accessibilityManager.keyboardEvent(k);
          }, R.onFocus = function() {
            w.accessibilityManager.focus();
          };
        }
        var V = this.parseEventsOfWrapper();
        return /* @__PURE__ */ O.createElement(wE, {
          state: this.state,
          width: this.props.width,
          height: this.props.height,
          clipPathId: this.clipPathId
        }, /* @__PURE__ */ O.createElement("div", Ca({
          className: We("recharts-wrapper", S),
          style: re({
            position: "relative",
            cursor: "default",
            width: M,
            height: E
          }, P)
        }, V, {
          ref: function(z) {
            w.container = z;
          }
        }), /* @__PURE__ */ O.createElement(ff, Ca({}, R, {
          width: M,
          height: E,
          title: _,
          desc: D,
          style: T9e
        }), this.renderClipPath(), bb(b, this.renderMap)), this.renderLegend(), this.renderTooltip()));
      }
    }]);
  })(Td);
  Ie(C, "displayName", n), Ie(C, "defaultProps", re({
    layout: "horizontal",
    stackOffset: "none",
    barCategoryGap: "10%",
    barGap: 4,
    margin: {
      top: 5,
      right: 5,
      bottom: 5,
      left: 5
    },
    reverseStackOrder: !1,
    syncMethod: "index"
  }, f)), Ie(C, "getDerivedStateFromProps", function(g, v) {
    var y = g.dataKey, w = g.data, x = g.children, b = g.width, S = g.height, M = g.layout, E = g.stackOffset, P = g.margin, T = v.dataStartIndex, _ = v.dataEndIndex;
    if (v.updateId === void 0) {
      var D = GE(g);
      return re(re(re({}, D), {}, {
        updateId: 0
      }, p(re(re({
        props: g
      }, D), {}, {
        updateId: 0
      }), v)), {}, {
        prevDataKey: y,
        prevData: w,
        prevWidth: b,
        prevHeight: S,
        prevLayout: M,
        prevStackOffset: E,
        prevMargin: P,
        prevChildren: x
      });
    }
    if (y !== v.prevDataKey || w !== v.prevData || b !== v.prevWidth || S !== v.prevHeight || M !== v.prevLayout || E !== v.prevStackOffset || !Ta(P, v.prevMargin)) {
      var N = GE(g), R = {
        // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
        // any flickering
        chartX: v.chartX,
        chartY: v.chartY,
        // The tooltip should stay active when it was active in the previous render. If this is not
        // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
        isTooltipActive: v.isTooltipActive
      }, L = re(re({}, UE(v, w, M)), {}, {
        updateId: v.updateId + 1
      }), B = re(re(re({}, N), R), L);
      return re(re(re({}, B), p(re({
        props: g
      }, B), v)), {}, {
        prevDataKey: y,
        prevData: w,
        prevWidth: b,
        prevHeight: S,
        prevLayout: M,
        prevStackOffset: E,
        prevMargin: P,
        prevChildren: x
      });
    }
    if (!cf(x, v.prevChildren)) {
      var V, k, z, $, Z = nr(x, Ja), W = Z && (V = (k = Z.props) === null || k === void 0 ? void 0 : k.startIndex) !== null && V !== void 0 ? V : T, H = Z && (z = ($ = Z.props) === null || $ === void 0 ? void 0 : $.endIndex) !== null && z !== void 0 ? z : _, G = W !== T || H !== _, Y = !Ne(w), ne = Y && !G ? v.updateId : v.updateId + 1;
      return re(re({
        updateId: ne
      }, p(re(re({
        props: g
      }, v), {}, {
        updateId: ne,
        dataStartIndex: W,
        dataEndIndex: H
      }), v)), {}, {
        prevChildren: x,
        dataStartIndex: W,
        dataEndIndex: H
      });
    }
    return null;
  }), Ie(C, "renderActiveDot", function(g, v, y) {
    var w;
    return /* @__PURE__ */ sr(g) ? w = /* @__PURE__ */ Qt(g, v) : je(g) ? w = g(v) : w = /* @__PURE__ */ O.createElement(M0, v), /* @__PURE__ */ O.createElement(rt, {
      className: "recharts-active-dot",
      key: y
    }, w);
  });
  var m = /* @__PURE__ */ Xe(function(v, y) {
    return /* @__PURE__ */ O.createElement(C, Ca({}, v, {
      ref: y
    }));
  });
  return m.displayName = C.displayName, m;
}, j9e = $9e({
  chartName: "ComposedChart",
  GraphicalChild: [K2, Zi, zi, k0],
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: L0
  }, {
    axisType: "yAxis",
    AxisComp: N0
  }, {
    axisType: "zAxis",
    AxisComp: R0
  }],
  formatAxisMap: c8e
});
const H9e = ({
  lineConfig: e,
  barConfig: t,
  active: n,
  payload: r,
  label: o,
  allowDecimals: i,
  ...a
}) => {
  const { formatter: s } = a, l = (h) => h?.length && h.findIndex(
    (p) => Object.prototype.hasOwnProperty.call(p, "shortName")
  ) !== -1, c = (h, p) => h.findIndex((C) => C.name === p.name && C.shortName) !== -1, u = (h) => {
    if (h?.name)
      return !e && !t ? h.name : e && l(e) && c(e, h) ? e?.find((p) => p.name === h.name)?.shortName : t && l(t) && c(t, h) ? t?.find((p) => p.name === h.name)?.shortName : h.name;
  }, f = () => n && r?.length && r.map((h) => {
    const p = h, C = I(
      h.className,
      "flex items-center gap-1 first-of-type:mr-[5px]"
    );
    return /* @__PURE__ */ F(
      "div",
      {
        className: "flex w-full items-center justify-between gap-2 first-of-type:mr-[0.5rem]",
        children: [
          /* @__PURE__ */ F("div", { className: C, children: [
            p?.stroke && /* @__PURE__ */ d("svg", { width: "16", height: "16", children: /* @__PURE__ */ d(
              "line",
              {
                x1: "0",
                y1: "8",
                x2: "16",
                y2: "8",
                style: { stroke: p.color, strokeWidth: "3px" }
              }
            ) }),
            p?.fill && !p?.stroke && /* @__PURE__ */ d("svg", { width: "16", height: "16", children: /* @__PURE__ */ d(
              "rect",
              {
                width: "100%",
                height: "100%",
                rx: "3",
                fill: p.color
              }
            ) }),
            /* @__PURE__ */ F(Ye, { className: "!text-text-brand", children: [
              u(p),
              ":"
            ] })
          ] }),
          /* @__PURE__ */ d(Ye, { children: i ? s ? s(
            Ma(p.value, 2),
            u(p),
            r[r.indexOf(h)],
            r.indexOf(h),
            r
          ) : Ma(p.value, 2) : Ma(p.value, 0) })
        ]
      },
      p.name
    );
  });
  return n ? /* @__PURE__ */ F("div", { className: "flex flex-col rounded-sm bg-neutral-0 p-1 shadow-lg [&>span:first-of-type]:mb-[5px]", children: [
    o && /* @__PURE__ */ d(Ye, { weight: "bold", children: o }),
    f()
  ] }) : null;
}, z9e = (e) => {
  const { className: t, config: n, position: r = "left" } = e, o = {
    left: I("justify-start"),
    right: I("justify-end"),
    center: I("justify-center")
  }, i = I(
    "flex gap-[1rem]",
    o[r],
    t
  ), a = (l) => !l || !n ? [] : l.map((c) => ({
    ...n.find((f) => f.dataKey === c.dataKey),
    ...c
  })), s = _e(() => a(e.payload), []);
  return /* @__PURE__ */ d("div", { className: i, children: s?.length && s.map((l) => {
    const u = I(
      "flex items-center [&>svg]:mr-[5px]",
      l.className
    );
    return /* @__PURE__ */ F("div", { className: u, children: [
      /* @__PURE__ */ d("svg", { width: "16", height: "16", children: /* @__PURE__ */ d("rect", { width: "100%", height: "100%", rx: "10" }) }),
      /* @__PURE__ */ d(Ye, { className: "!text-neutral-950", children: l.value })
    ] }, l.value);
  }) });
}, dm = O.forwardRef(
  ({
    data: e = [],
    bars: t = [],
    lines: n = [],
    xAxisDataKey: r,
    yAxisDataKey: o,
    wrapperClasses: i = "h-[350px] w-full",
    xAxisLine: a = !1,
    yAxisLine: s = !1,
    tickLineY: l = !1,
    tickLineX: c = !1,
    margin: u,
    legendHorizontalAlign: f = "center",
    legendVerticalAlign: h = "bottom",
    legendPadding: p,
    layout: C = "horizontal",
    lineStrokeWidth: m = 2,
    hasYAxis: g = !0,
    cartesianGrid: v = !0,
    legend: y = !0,
    stack: w = !0,
    referenceLine: x = !0,
    maxBarSize: b,
    barGap: S,
    barRadius: M = [15, 15, 0, 0],
    onClick: E,
    onChartClick: P,
    ...T
  }, _) => {
    const D = I("rounded-full", E ? "cursor-pointer" : ""), N = I(
      "flex flex-col",
      !!P && "[&>svg]:cursor-pointer"
    ), R = (H, G) => {
      const Y = {
        name: H.name,
        dataKey: H.dataKey
      };
      E?.(Y, G);
    }, L = (H) => {
      if (!H) return I("text-surface-common-primary");
      switch (H) {
        case "primary":
          return I("text-surface-common-primary");
        case "primary-light":
          return I("text-surface-common-primary-light");
        case "primary-subtle":
          return I("text-surface-common-subtle");
        case "secondary":
          return I("text-surface-common-secondary");
      }
    }, B = (H) => {
      if (!H) return I("fill-surface-common-primary");
      switch (H) {
        case "primary":
          return I("fill-surface-common-primary");
        case "primary-light":
          return I("fill-surface-common-primary-light");
        case "primary-subtle":
          return I("fill-surface-common-subtle");
        case "secondary":
          return I("fill-surface-common-secondary");
      }
    }, V = ct((H) => H?.length ? H.map((G) => ({
      ...G,
      className: I(G?.className, L(G?.color)),
      stackId: G?.stackId || "stack",
      shortName: G?.shortName || G?.name || ""
    })) || [] : [], []), k = ct(
      (H) => H?.length ? H?.map((G) => ({
        ...G,
        className: I(G?.className, L(G?.color)),
        type: G?.type || "monotone",
        shortName: G?.shortName || G?.name || ""
      })) || [] : [],
      []
    ), z = ct(
      (H) => H?.length ? H?.map((G) => ({
        dataKey: G?.dataKey || "",
        className: I(G?.className, B(G?.color)),
        type: "rect"
      })) || [] : [],
      []
    ), $ = _e(
      () => V(t),
      [t, V]
    ), Z = _e(
      () => k(n),
      [n, k]
    ), W = _e(
      () => z([...$, ...Z]),
      [$, Z, z]
    );
    return /* @__PURE__ */ d("div", { className: i, ref: _, children: /* @__PURE__ */ d(nse, { children: /* @__PURE__ */ F(
      j9e,
      {
        data: e && e,
        margin: { top: 0.5, right: 50, bottom: 0, left: 0, ...u },
        layout: C && C,
        className: N,
        stackOffset: "sign",
        barGap: S,
        onClick: P,
        ...T,
        children: [
          x && /* @__PURE__ */ d(A0, { y: 0, stroke: "white" }),
          v && /* @__PURE__ */ d(
            $k,
            {
              className: "stroke-neutral-300",
              horizontal: !0,
              vertical: !1
            }
          ),
          /* @__PURE__ */ d(
            L0,
            {
              dataKey: r && r,
              axisLine: a && a,
              tickLine: c && c,
              type: C === "vertical" ? "number" : "category",
              tickMargin: 5,
              tickFormatter: pC
            }
          ),
          g && /* @__PURE__ */ d(
            N0,
            {
              dataKey: o && o,
              axisLine: s && s,
              tickLine: l && l,
              type: C === "vertical" ? "category" : "number",
              tickFormatter: pC
            }
          ),
          /* @__PURE__ */ d(
            eo,
            {
              content: /* @__PURE__ */ d(
                H9e,
                {
                  barConfig: t && t,
                  lineConfig: n && n
                }
              )
            }
          ),
          y && /* @__PURE__ */ d(
            hi,
            {
              verticalAlign: h && h,
              content: /* @__PURE__ */ d(
                z9e,
                {
                  position: f,
                  config: W
                }
              ),
              wrapperStyle: {
                paddingLeft: p?.left ? p.left : "0",
                paddingTop: p?.top ? p.top : "10px",
                paddingBottom: p?.bottom ? p.bottom : "20px",
                paddingRight: p?.right ? p.right : "0"
              }
            }
          ),
          $?.length && $.map((H) => {
            const G = I(D, H.className);
            return /* @__PURE__ */ d(
              zi,
              {
                className: G,
                dataKey: H.dataKey,
                fill: "currentColor",
                name: H.name,
                barSize: 8,
                maxBarSize: b || void 0,
                stackId: w ? "stack" : void 0,
                radius: M,
                onClick: (Y) => R(H, Y)
              },
              H.name
            );
          }),
          Z?.length && Z.map((H) => /* @__PURE__ */ d(
            K2,
            {
              className: H.className,
              stroke: "currentColor",
              type: H.type,
              dataKey: H.dataKey,
              name: H.name,
              strokeWidth: m,
              onClick: (G) => R(H, G)
            },
            H.name
          ))
        ]
      }
    ) }) });
  }
), rme = ({
  data: e,
  bars: t,
  xAxisDataKey: n,
  yAxisDataKey: r,
  maxBarSize: o = 10,
  barGap: i = -20,
  ...a
}) => /* @__PURE__ */ d(
  dm,
  {
    data: e,
    bars: t,
    legendHorizontalAlign: "right",
    legendVerticalAlign: "top",
    xAxisDataKey: n,
    yAxisDataKey: r,
    stack: !1,
    maxBarSize: o,
    barGap: i,
    ...a
  }
), ome = ({
  data: e,
  lines: t,
  xAxisDataKey: n,
  yAxisDataKey: r,
  ...o
}) => /* @__PURE__ */ d(
  dm,
  {
    data: e,
    lines: t,
    xAxisDataKey: n,
    yAxisDataKey: r,
    ...o
  }
), ime = ({
  data: e,
  bars: t,
  lines: n,
  ...r
}) => /* @__PURE__ */ d(dm, { data: e, bars: t, lines: n, ...r }), Z9e = [
  [
    { number: 0, name: "Jan" },
    { number: 1, name: "Feb" },
    { number: 2, name: "Mar" },
    { number: 3, name: "Apr" }
  ],
  [
    { number: 4, name: "May" },
    { number: 5, name: "Jun" },
    { number: 6, name: "Jul" },
    { number: 7, name: "Aug" }
  ],
  [
    { number: 8, name: "Sep" },
    { number: 9, name: "Oct" },
    { number: 10, name: "Nov" },
    { number: 11, name: "Dec" }
  ]
];
function W9e({
  onMonthSelect: e,
  selectedMonth: t,
  minDate: n,
  maxDate: r,
  disabledDates: o,
  callbacks: i,
  onYearBackward: a,
  onYearForward: s,
  variant: l,
  className: c,
  ...u
}) {
  return /* @__PURE__ */ d("div", { className: I("w-[280px] min-w-[200px] p-3", c), ...u, children: /* @__PURE__ */ d("div", { className: "flex flex-col space-y-4 sm:flex-row sm:space-x-4 sm:space-y-0", children: /* @__PURE__ */ d("div", { className: "w-full space-y-4", children: /* @__PURE__ */ d(
    q9e,
    {
      onMonthSelect: e,
      callbacks: i,
      selectedMonth: t,
      onYearBackward: a,
      onYearForward: s,
      variant: l,
      minDate: n,
      maxDate: r,
      disabledDates: o
    }
  ) }) }) });
}
function q9e({
  selectedMonth: e,
  onMonthSelect: t,
  callbacks: n,
  minDate: r,
  maxDate: o,
  disabledDates: i,
  onYearBackward: a,
  onYearForward: s
}) {
  const [l, c] = A.useState(
    e?.getFullYear() ?? (/* @__PURE__ */ new Date()).getFullYear()
  ), [u, f] = A.useState(
    e?.getMonth() ?? (/* @__PURE__ */ new Date()).getMonth()
  ), [h, p] = A.useState(l);
  r && o && r > o && (r = o);
  const C = i?.map((m) => ({ year: m.getFullYear(), month: m.getMonth() }));
  return /* @__PURE__ */ F(ut, { children: [
    /* @__PURE__ */ d("div", { className: "relative flex items-center justify-center pt-1", children: /* @__PURE__ */ F("div", { className: "relative flex items-center justify-center gap-2 pt-1", children: [
      /* @__PURE__ */ d(
        Dt,
        {
          variant: "ghost",
          onClick: () => {
            p(h - 1), a && a();
          },
          disabled: r && h === r.getFullYear(),
          small: !0,
          children: /* @__PURE__ */ d(qr, { className: "h-4 w-4" })
        }
      ),
      /* @__PURE__ */ d("div", { className: "text-lg font-semibold", children: n?.yearLabel ? n?.yearLabel(h) : h }),
      /* @__PURE__ */ d(
        Dt,
        {
          variant: "ghost",
          onClick: () => {
            p(h + 1), s && s();
          },
          disabled: o && h === o.getFullYear(),
          small: !0,
          children: /* @__PURE__ */ d(yo, { className: "h-4 w-4" })
        }
      )
    ] }) }),
    /* @__PURE__ */ d("table", { className: "w-full border-collapse space-y-1", children: /* @__PURE__ */ d("tbody", { children: Z9e.map((m, g) => /* @__PURE__ */ d("tr", { className: "mt-1 flex w-full", children: m.map((v) => /* @__PURE__ */ d(
      "td",
      {
        className: "relative h-fit w-1/4 p-0 text-center text-sm focus-within:relative focus-within:z-20 first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md [&:has([aria-selected].day-range-end)]:rounded-r-md",
        children: /* @__PURE__ */ d(
          Dt,
          {
            onClick: () => {
              f(v.number), c(h), t && t(new Date(h, v.number));
            },
            disabled: (o ? h > o?.getFullYear() || h == o?.getFullYear() && v.number > o.getMonth() : !1) || (r ? h < r?.getFullYear() || h == r?.getFullYear() && v.number < r.getMonth() : !1) || (C ? C?.some(
              (y) => y.year == h && y.month == v.number
            ) : !1),
            className: "w-full rounded",
            variant: h == l && v.number == u ? "default" : "ghost",
            children: n?.monthLabel ? n.monthLabel(v) : v.name
          }
        )
      },
      v.number
    )) }, "row-" + g)) }) })
  ] });
}
W9e.displayName = "MonthPicker";
const U9e = [
  [
    { number: 0, name: "Jan", yearOffset: 0 },
    { number: 1, name: "Feb", yearOffset: 0 },
    { number: 2, name: "Mar", yearOffset: 0 },
    { number: 3, name: "Apr", yearOffset: 0 }
  ],
  [
    { number: 4, name: "Mai", yearOffset: 0 },
    { number: 5, name: "Jun", yearOffset: 0 },
    { number: 6, name: "Jul", yearOffset: 0 },
    { number: 7, name: "Aug", yearOffset: 0 }
  ],
  [
    { number: 8, name: "Sep", yearOffset: 0 },
    { number: 9, name: "Okt", yearOffset: 0 },
    { number: 10, name: "Nov", yearOffset: 0 },
    { number: 11, name: "Des", yearOffset: 0 }
  ]
];
function fL({
  onMonthRangeSelect: e,
  onStartMonthSelect: t,
  callbacks: n,
  selectedMonthRange: r,
  onYearBackward: o,
  onYearForward: i,
  minDate: a,
  maxDate: s,
  quickSelectors: l,
  className: c,
  ...u
}) {
  return /* @__PURE__ */ d("div", { className: I("min-w-[350px] p-1", c), ...u, children: /* @__PURE__ */ d("div", { className: "flex flex-col space-y-4 sm:flex-row sm:space-x-4 sm:space-y-0", children: /* @__PURE__ */ d("div", { className: "w-full", children: /* @__PURE__ */ d(
    G9e,
    {
      onMonthRangeSelect: e,
      onStartMonthSelect: t,
      callbacks: n,
      selectedMonthRange: r,
      onYearBackward: o,
      onYearForward: i,
      minDate: a,
      maxDate: s,
      quickSelectors: l
    }
  ) }) }) });
}
function G9e({
  selectedMonthRange: e,
  onMonthRangeSelect: t,
  onStartMonthSelect: n,
  callbacks: r,
  minDate: o,
  maxDate: i,
  onYearBackward: a,
  onYearForward: s
}) {
  const [l, c] = A.useState(
    e?.start.getFullYear() ?? (/* @__PURE__ */ new Date()).getFullYear()
  ), [u, f] = A.useState(
    e?.start?.getMonth() ?? (/* @__PURE__ */ new Date()).getMonth()
  ), [h, p] = A.useState(
    e?.end?.getFullYear() ?? (/* @__PURE__ */ new Date()).getFullYear() + 1
  ), [C, m] = A.useState(
    e?.end?.getMonth() ?? (/* @__PURE__ */ new Date()).getMonth()
  ), [g, v] = A.useState(!1), [y, w] = A.useState(!0), [x, b] = A.useState(l);
  return o && i && o > i && (o = i), /* @__PURE__ */ d("div", { className: "flex gap-4", children: /* @__PURE__ */ F("div", { className: "min-w-[350px] space-y-1", children: [
    /* @__PURE__ */ F("div", { className: "relative flex items-center justify-center gap-2 pt-1", children: [
      /* @__PURE__ */ d(
        Dt,
        {
          variant: "ghost",
          onClick: () => {
            b(x - 1), a && a();
          },
          disabled: o && x === o.getFullYear(),
          small: !0,
          children: /* @__PURE__ */ d(qr, { className: "h-4 w-4" })
        }
      ),
      /* @__PURE__ */ d("div", { className: "text-lg font-semibold", children: r?.yearLabel ? r?.yearLabel(x) : x }),
      /* @__PURE__ */ d(
        Dt,
        {
          variant: "ghost",
          onClick: () => {
            b(x + 1), s && s();
          },
          disabled: i && x === i.getFullYear(),
          small: !0,
          children: /* @__PURE__ */ d(yo, { className: "h-4 w-4" })
        }
      )
    ] }),
    /* @__PURE__ */ d("table", { className: "w-full border-collapse", children: /* @__PURE__ */ d("tbody", { children: U9e.map((S, M) => /* @__PURE__ */ d("tr", { className: "mt-1 flex w-full", children: S.map((E) => /* @__PURE__ */ d(
      "td",
      {
        className: I(
          I(
            I(
              I(
                "[&:has([aria-selected])]: relative h-fit w-1/4 p-0 text-center text-sm focus-within:relative focus-within:z-[9999] first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md [&:has([aria-selected].day-range-end)]:rounded-r-md",
                (x + E.yearOffset > l || x + E.yearOffset == l && E.number > u) && (x + E.yearOffset < h || x + E.yearOffset == h && E.number < C) && (g || y) ? "bg-surface-common-card-highlight" : ""
              ),
              x + E.yearOffset == l && E.number == u && (g || y) ? "rounded-l-md bg-surface-common-card-highlight" : ""
            ),
            x + E.yearOffset == h && E.number == C && (g || y) && x + E.yearOffset >= l && E.number >= u ? "rounded-r-md bg-surface-common-card-highlight" : ""
          ),
          "flex items-center justify-center"
        ),
        onMouseEnter: () => {
          g && !y && (p(x + E.yearOffset), m(E.number));
        },
        children: /* @__PURE__ */ d(
          Dt,
          {
            onClick: () => {
              g ? x + E.yearOffset < l || x + E.yearOffset == l && E.number < u ? (v(!0), w(!1), f(E.number), c(x + E.yearOffset), p(x + E.yearOffset), m(E.number), n && n(
                new Date(x + E.yearOffset, E.number)
              )) : (v(!1), w(!0), t && t({
                start: new Date(l, u),
                end: new Date(
                  x + E.yearOffset,
                  E.number
                )
              })) : (v(!0), w(!1), f(E.number), c(x + E.yearOffset), p(x + E.yearOffset), m(E.number), n && n(
                new Date(x + E.yearOffset, E.number)
              ));
            },
            disabled: (i ? x + E.yearOffset > i?.getFullYear() || x + E.yearOffset == i?.getFullYear() && E.number > i.getMonth() : !1) || (o ? x + E.yearOffset < o?.getFullYear() || x + E.yearOffset == o?.getFullYear() && E.number < o.getMonth() : !1),
            variant: u == E.number && x + E.yearOffset == l || C == E.number && x + E.yearOffset == h && !g ? "default" : "ghost",
            className: "w-full rounded",
            children: r?.monthLabel ? r.monthLabel(E) : E.name
          }
        )
      },
      E.number + "-" + E.yearOffset
    )) }, "row-" + M)) }) })
  ] }) });
}
fL.displayName = "MonthRangePicker";
const K9e = (e) => new Date(e.getFullYear(), e.getMonth() + 1, 0), ame = ({
  onRangeChange: e,
  selectedRange: t,
  initialOpen: n,
  onOpenChange: r,
  placement: o,
  label: i,
  minDate: a,
  maxDate: s,
  setEndToLastDayOfMonth: l = !1
}) => {
  const [c, u] = O.useState(t.start), [f, h] = O.useState(t.end), p = I(
    "flex max-h-[42px] w-full min-w-13 items-center gap-sm rounded-md bg-white p-md ring-offset-0 transition-all",
    "hover:border-neutral-400",
    "outline-none focus-visible:border-surface-common-primary focus-visible:ring-[3px] focus-visible:ring-surface-common-primary-light",
    "border border-border-input",
    "flex justify-between"
  ), C = (m) => {
    if (u(m.start), l) {
      const g = K9e(m.end);
      h(g), e({ start: m.start, end: g });
    } else
      h(m.end), e(m);
  };
  return /* @__PURE__ */ F(
    Mn,
    {
      initialOpen: n,
      onOpenChange: r,
      placement: o,
      children: [
        /* @__PURE__ */ d(Ut, { weight: "semibold", className: "pb-[4px]", children: i || "" }),
        /* @__PURE__ */ F(oP, { className: p, children: [
          c?.toLocaleDateString("no-NO", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
          }),
          " ",
          "-",
          " ",
          f?.toLocaleDateString("no-NO", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
          }),
          /* @__PURE__ */ d(hL, { colorVariant: "primary" })
        ] }),
        /* @__PURE__ */ d(rP, { className: "z-[999] rounded-card border-2 bg-surface-common-white", children: /* @__PURE__ */ d(
          fL,
          {
            onMonthRangeSelect: C,
            selectedMonthRange: { start: c, end: f },
            minDate: a,
            maxDate: s
          }
        ) })
      ]
    }
  );
}, Y9e = ({
  word: e,
  speed: t,
  stop: n,
  className: r,
  onComplete: o
}) => {
  const [i, a] = ue(0), [s, l] = ue(""), c = I("text-paragraph text-text-primary", r);
  return ve(() => {
    if (!n)
      if (i < e.length) {
        const u = setTimeout(() => {
          l((f) => f + e[i]), a((f) => f + 1);
        }, t || 100);
        return () => clearTimeout(u);
      } else i === e.length && o && (a(0), l(`${s} `), o());
  }, [i, t, e, o, s, n]), /* @__PURE__ */ d(Rt, { className: c, children: s });
}, X9e = () => /* @__PURE__ */ d(
  oI.span,
  {
    className: "animate-blink inline-block h-[1em] w-[2px] bg-black",
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    transition: { duration: 0.5, repeat: 1 / 0, repeatType: "reverse" }
  }
), Q9e = ({
  words: e,
  speed: t = 100,
  showCaret: n = !0,
  loopInterval: r = 5e3
}) => {
  const [o, i] = ue(0), [a, s] = ue(!0), [l, c] = ue(0), u = _e(
    () => e[o] || "",
    [o, e]
  );
  return /* @__PURE__ */ F("div", { className: "flex items-center justify-center gap-[2px]", children: [
    /* @__PURE__ */ d(
      YE,
      {
        word: u,
        stop: !a,
        speed: t,
        onComplete: () => {
          o < e.length - 1 ? i(o + 1) : (s(!1), setTimeout(
            () => {
              i(0), c((h) => h + 1), s(!0);
            },
            Math.max(r, 1e3)
          ));
        }
      },
      l
    ),
    n && /* @__PURE__ */ d(YE.Caret, {})
  ] });
}, YE = Object.assign(Y9e, {
  Caret: X9e
}), J9e = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V9C3 8.45 3.19583 7.97917 3.5875 7.5875C3.97917 7.19583 4.45 7 5 7H7V5C7 4.45 7.19583 3.97917 7.5875 3.5875C7.97917 3.19583 8.45 3 9 3H15C15.55 3 16.0208 3.19583 16.4125 3.5875C16.8042 3.97917 17 4.45 17 5V11H19C19.55 11 20.0208 11.1958 20.4125 11.5875C20.8042 11.9792 21 12.45 21 13V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H13V17H11V21H5ZM5 19H7V17H5V19ZM5 15H7V13H5V15ZM5 11H7V9H5V11ZM9 15H11V13H9V15ZM9 11H11V9H9V11ZM9 7H11V5H9V7ZM13 15H15V13H13V15ZM13 11H15V9H13V11ZM13 7H15V5H13V7ZM17 19H19V17H17V19ZM17 15H19V13H17V15Z",
    fill: "currentColor"
  }
) }), sme = Q("IconApartment")(J9e), efe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M23 5V19C23 19.55 22.8042 20.0208 22.4125 20.4125C22.0208 20.8042 21.55 21 21 21H18C17.7167 21 17.4792 20.9042 17.2875 20.7125C17.0958 20.5208 17 20.2833 17 20C17 19.7167 17.0958 19.4792 17.2875 19.2875C17.4792 19.0958 17.7167 19 18 19H21V5H12V5.5C12 5.78333 11.9042 6.02083 11.7125 6.2125C11.5208 6.40417 11.2833 6.5 11 6.5C10.7167 6.5 10.4792 6.40417 10.2875 6.2125C10.0958 6.02083 10 5.78333 10 5.5V4.95C10 4.41667 10.1917 3.95833 10.575 3.575C10.9583 3.19167 11.4167 3 11.95 3H21C21.55 3 22.0208 3.19583 22.4125 3.5875C22.8042 3.97917 23 4.45 23 5ZM1 12.025C1 11.6917 1.075 11.3833 1.225 11.1C1.375 10.8167 1.58333 10.5833 1.85 10.4L6.85 6.825C7.03333 6.69167 7.22083 6.59583 7.4125 6.5375C7.60417 6.47917 7.8 6.45 8 6.45C8.2 6.45 8.39583 6.47917 8.5875 6.5375C8.77917 6.59583 8.96667 6.69167 9.15 6.825L14.15 10.4C14.4167 10.5833 14.625 10.8167 14.775 11.1C14.925 11.3833 15 11.6917 15 12.025V19C15 19.55 14.8042 20.0208 14.4125 20.4125C14.0208 20.8042 13.55 21 13 21H11C10.45 21 9.97917 20.8042 9.5875 20.4125C9.19583 20.0208 9 19.55 9 19V16H7V19C7 19.55 6.80417 20.0208 6.4125 20.4125C6.02083 20.8042 5.55 21 5 21H3C2.45 21 1.97917 20.8042 1.5875 20.4125C1.19583 20.0208 1 19.55 1 19V12.025ZM3 12V19H5V16C5 15.45 5.19583 14.9792 5.5875 14.5875C5.97917 14.1958 6.45 14 7 14H9C9.55 14 10.0208 14.1958 10.4125 14.5875C10.8042 14.9792 11 15.45 11 16V19H13V12L8 8.45L3 12ZM17.5 9H18.5C18.6333 9 18.75 8.95 18.85 8.85C18.95 8.75 19 8.63333 19 8.5V7.5C19 7.36667 18.95 7.25 18.85 7.15C18.75 7.05 18.6333 7 18.5 7H17.5C17.3667 7 17.25 7.05 17.15 7.15C17.05 7.25 17 7.36667 17 7.5V8.5C17 8.63333 17.05 8.75 17.15 8.85C17.25 8.95 17.3667 9 17.5 9ZM17.5 13H18.5C18.6333 13 18.75 12.95 18.85 12.85C18.95 12.75 19 12.6333 19 12.5V11.5C19 11.3667 18.95 11.25 18.85 11.15C18.75 11.05 18.6333 11 18.5 11H17.5C17.3667 11 17.25 11.05 17.15 11.15C17.05 11.25 17 11.3667 17 11.5V12.5C17 12.6333 17.05 12.75 17.15 12.85C17.25 12.95 17.3667 13 17.5 13ZM17.5 17H18.5C18.6333 17 18.75 16.95 18.85 16.85C18.95 16.75 19 16.6333 19 16.5V15.5C19 15.3667 18.95 15.25 18.85 15.15C18.75 15.05 18.6333 15 18.5 15H17.5C17.3667 15 17.25 15.05 17.15 15.15C17.05 15.25 17 15.3667 17 15.5V16.5C17 16.6333 17.05 16.75 17.15 16.85C17.25 16.95 17.3667 17 17.5 17Z",
    fill: "currentColor"
  }
) }), lme = Q("IconBuildingType")(efe), tfe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M6 21C5.71666 21 5.47916 20.9042 5.2875 20.7125C5.09583 20.5208 5 20.2833 5 20V10.85L3 12.375C2.76666 12.5417 2.51666 12.6125 2.25 12.5875C1.98333 12.5625 1.76666 12.4333 1.6 12.2C1.43333 11.9667 1.36666 11.7167 1.4 11.45C1.43333 11.1833 1.56666 10.9667 1.8 10.8L10.775 3.92499C10.9583 3.79166 11.1542 3.69166 11.3625 3.62499C11.5708 3.55833 11.7833 3.52499 12 3.52499C12.2167 3.52499 12.4292 3.55833 12.6375 3.62499C12.8458 3.69166 13.0417 3.79166 13.225 3.92499L22.2 10.8C22.4167 10.9667 22.5458 11.1833 22.5875 11.45C22.6292 11.7167 22.5667 11.9667 22.4 12.2C22.2333 12.4333 22.0167 12.5625 21.75 12.5875C21.4833 12.6125 21.2333 12.5417 21 12.375L19 10.85V20C19 20.2833 18.9042 20.5208 18.7125 20.7125C18.5208 20.9042 18.2833 21 18 21C17.7167 21 17.4792 20.9042 17.2875 20.7125C17.0958 20.5208 17 20.2833 17 20V11H7V20C7 20.2833 6.90416 20.5208 6.7125 20.7125C6.52083 20.9042 6.28333 21 6 21ZM9 20C8.71666 20 8.47916 19.9042 8.2875 19.7125C8.09583 19.5208 8 19.2833 8 19C8 18.7167 8.09583 18.4792 8.2875 18.2875C8.47916 18.0958 8.71666 18 9 18H15C15.2833 18 15.5208 18.0958 15.7125 18.2875C15.9042 18.4792 16 18.7167 16 19C16 19.2833 15.9042 19.5208 15.7125 19.7125C15.5208 19.9042 15.2833 20 15 20H9ZM9 17C8.71666 17 8.47916 16.9042 8.2875 16.7125C8.09583 16.5208 8 16.2833 8 16C8 15.7167 8.09583 15.4792 8.2875 15.2875C8.47916 15.0958 8.71666 15 9 15H15C15.2833 15 15.5208 15.0958 15.7125 15.2875C15.9042 15.4792 16 15.7167 16 16C16 16.2833 15.9042 16.5208 15.7125 16.7125C15.5208 16.9042 15.2833 17 15 17H9ZM9 14C8.71666 14 8.47916 13.9042 8.2875 13.7125C8.09583 13.5208 8 13.2833 8 13C8 12.7167 8.09583 12.4792 8.2875 12.2875C8.47916 12.0958 8.71666 12 9 12H15C15.2833 12 15.5208 12.0958 15.7125 12.2875C15.9042 12.4792 16 12.7167 16 13C16 13.2833 15.9042 13.5208 15.7125 13.7125C15.5208 13.9042 15.2833 14 15 14H9ZM7.425 8.99999H16.575L12 5.52499L7.425 8.99999Z",
    fill: "currentColor"
  }
) }), cme = Q("IconGarage")(tfe), nfe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M4.00006 19V11.625L3.00006 12.4C2.76672 12.5667 2.51672 12.6333 2.25006 12.6C1.98339 12.5667 1.76672 12.4333 1.60006 12.2C1.43339 11.9667 1.36672 11.7167 1.40006 11.45C1.43339 11.1833 1.55839 10.9667 1.77506 10.8L4.00006 9.1V7C4.00006 6.71667 4.09589 6.47917 4.28756 6.2875C4.47922 6.09583 4.71672 6 5.00006 6C5.28339 6 5.52089 6.09583 5.71256 6.2875C5.90422 6.47917 6.00006 6.71667 6.00006 7V7.575L10.7751 3.925C11.1417 3.64167 11.5501 3.5 12.0001 3.5C12.4501 3.5 12.8584 3.64167 13.2251 3.925L22.2251 10.8C22.4417 10.9667 22.5667 11.1833 22.6001 11.45C22.6334 11.7167 22.5667 11.9667 22.4001 12.2C22.2334 12.4167 22.0167 12.5417 21.7501 12.575C21.4834 12.6083 21.2417 12.5417 21.0251 12.375L20.0001 11.625V19C20.0001 19.55 19.8042 20.0208 19.4126 20.4125C19.0209 20.8042 18.5501 21 18.0001 21H6.00006C5.45006 21 4.97922 20.8042 4.58756 20.4125C4.19589 20.0208 4.00006 19.55 4.00006 19ZM6.00006 19H11.0001V16C11.0001 15.7167 11.0959 15.4792 11.2876 15.2875C11.4792 15.0958 11.7167 15 12.0001 15C12.2834 15 12.5209 15.0958 12.7126 15.2875C12.9042 15.4792 13.0001 15.7167 13.0001 16V19H18.0001V10.1L12.0001 5.525L6.00006 10.1V19ZM5.30006 5C4.91672 5 4.62089 4.84167 4.41256 4.525C4.20422 4.20833 4.19172 3.88333 4.37506 3.55C4.65839 3.06667 5.02922 2.6875 5.48756 2.4125C5.94589 2.1375 6.45006 2 7.00006 2C7.18339 2 7.35839 1.95417 7.52506 1.8625C7.69172 1.77083 7.81672 1.64167 7.90006 1.475C7.98339 1.325 8.09589 1.20833 8.23756 1.125C8.37922 1.04167 8.54172 1 8.72506 1C9.10839 1 9.40006 1.15833 9.60006 1.475C9.80006 1.79167 9.80839 2.11667 9.62506 2.45C9.34172 2.93333 8.97089 3.3125 8.51256 3.5875C8.05422 3.8625 7.55006 4 7.00006 4C6.81672 4 6.64172 4.04167 6.47506 4.125C6.30839 4.20833 6.18339 4.34167 6.10006 4.525C6.01672 4.675 5.90839 4.79167 5.77506 4.875C5.64172 4.95833 5.48339 5 5.30006 5Z",
    fill: "currentColor"
  }
) }), ume = Q("IconHome")(nfe), rfe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M5.02503 21C4.47503 21 4.00419 20.8042 3.61253 20.4125C3.22086 20.0208 3.02503 19.55 3.02503 19V11.05C2.64169 10.7 2.34586 10.25 2.13753 9.7C1.92919 9.15 1.92503 8.55 2.12503 7.9L3.17503 4.5C3.30836 4.06667 3.54586 3.70833 3.88753 3.425C4.22919 3.14167 4.62503 3 5.07503 3H18.975C19.425 3 19.8167 3.1375 20.15 3.4125C20.4834 3.6875 20.725 4.05 20.875 4.5L21.925 7.9C22.125 8.55 22.1209 9.14167 21.9125 9.675C21.7042 10.2083 21.4084 10.6667 21.025 11.05V19C21.025 19.55 20.8292 20.0208 20.4375 20.4125C20.0459 20.8042 19.575 21 19.025 21H5.02503ZM14.225 10C14.675 10 15.0167 9.84583 15.25 9.5375C15.4834 9.22917 15.575 8.88333 15.525 8.5L14.975 5H13.025V8.7C13.025 9.05 13.1417 9.35417 13.375 9.6125C13.6084 9.87083 13.8917 10 14.225 10ZM9.72503 10C10.1084 10 10.4209 9.87083 10.6625 9.6125C10.9042 9.35417 11.025 9.05 11.025 8.7V5H9.07503L8.52503 8.5C8.45836 8.9 8.54586 9.25 8.78753 9.55C9.02919 9.85 9.34169 10 9.72503 10ZM5.27503 10C5.57503 10 5.83753 9.89167 6.06253 9.675C6.28753 9.45833 6.42503 9.18333 6.47503 8.85L7.02503 5H5.07503L4.07503 8.35C3.97503 8.68333 4.02919 9.04167 4.23753 9.425C4.44586 9.80833 4.79169 10 5.27503 10ZM18.775 10C19.2584 10 19.6084 9.80833 19.825 9.425C20.0417 9.04167 20.0917 8.68333 19.975 8.35L18.925 5H17.025L17.575 8.85C17.625 9.18333 17.7625 9.45833 17.9875 9.675C18.2125 9.89167 18.475 10 18.775 10ZM5.02503 19H19.025V11.95C18.9417 11.9833 18.8875 12 18.8625 12H18.775C18.325 12 17.9292 11.925 17.5875 11.775C17.2459 11.625 16.9084 11.3833 16.575 11.05C16.275 11.35 15.9334 11.5833 15.55 11.75C15.1667 11.9167 14.7584 12 14.325 12C13.875 12 13.4542 11.9167 13.0625 11.75C12.6709 11.5833 12.325 11.35 12.025 11.05C11.7417 11.35 11.4125 11.5833 11.0375 11.75C10.6625 11.9167 10.2584 12 9.82503 12C9.34169 12 8.90419 11.9167 8.51253 11.75C8.12086 11.5833 7.77503 11.35 7.47503 11.05C7.12503 11.4 6.77919 11.6458 6.43753 11.7875C6.09586 11.9292 5.70836 12 5.27503 12H5.16253C5.12086 12 5.07503 11.9833 5.02503 11.95V19Z",
    fill: "currentColor"
  }
) }), fme = Q("IconStore")(rfe), ofe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M2 18V10.825C2 10.5583 2.05 10.3042 2.15 10.0625C2.25 9.82083 2.39167 9.60833 2.575 9.425L6.575 5.425C6.775 5.225 7 5.075 7.25 4.975C7.5 4.875 7.75 4.825 8 4.825C8.25 4.825 8.5 4.875 8.75 4.975C9 5.075 9.225 5.225 9.425 5.425L13.425 9.425C13.6083 9.60833 13.75 9.82083 13.85 10.0625C13.95 10.3042 14 10.5583 14 10.825V18C14 18.55 13.8042 19.0208 13.4125 19.4125C13.0208 19.8042 12.55 20 12 20H4C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18ZM4 18H7V16C7 15.7167 7.09583 15.4792 7.2875 15.2875C7.47917 15.0958 7.71667 15 8 15C8.28333 15 8.52083 15.0958 8.7125 15.2875C8.90417 15.4792 9 15.7167 9 16V18H12V10.825L8 6.825L4 10.825V18ZM16 19V9.175L12.525 5.7C12.2083 5.38333 12.1333 5.02083 12.3 4.6125C12.4667 4.20417 12.775 4 13.225 4C13.3583 4 13.4917 4.02917 13.625 4.0875C13.7583 4.14583 13.8667 4.21667 13.95 4.3L17.425 7.775C17.6083 7.95833 17.75 8.17083 17.85 8.4125C17.95 8.65417 18 8.90833 18 9.175V19C18 19.2833 17.9042 19.5208 17.7125 19.7125C17.5208 19.9042 17.2833 20 17 20C16.7167 20 16.4792 19.9042 16.2875 19.7125C16.0958 19.5208 16 19.2833 16 19ZM20 19V7.525L18.175 5.7C17.8583 5.38333 17.7833 5.02083 17.95 4.6125C18.1167 4.20417 18.425 4 18.875 4C19.0083 4 19.1417 4.02917 19.275 4.0875C19.4083 4.14583 19.5167 4.21667 19.6 4.3L21.425 6.125C21.6083 6.30833 21.75 6.52083 21.85 6.7625C21.95 7.00417 22 7.25833 22 7.525V19C22 19.2833 21.9042 19.5208 21.7125 19.7125C21.5208 19.9042 21.2833 20 21 20C20.7167 20 20.4792 19.9042 20.2875 19.7125C20.0958 19.5208 20 19.2833 20 19ZM8 13C7.71667 13 7.47917 12.9042 7.2875 12.7125C7.09583 12.5208 7 12.2833 7 12C7 11.7167 7.09583 11.4792 7.2875 11.2875C7.47917 11.0958 7.71667 11 8 11C8.28333 11 8.52083 11.0958 8.7125 11.2875C8.90417 11.4792 9 11.7167 9 12C9 12.2833 8.90417 12.5208 8.7125 12.7125C8.52083 12.9042 8.28333 13 8 13Z",
    fill: "currentColor"
  }
) }), dme = Q("IconTerracedHouse")(ofe), ife = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M14.075 11.725C15.2917 10.825 16.2417 9.8375 16.925 8.7625C17.6083 7.6875 17.95 6.61667 17.95 5.55C17.95 5.01667 17.8625 4.625 17.6875 4.375C17.5125 4.125 17.275 4 16.975 4C16.1917 4 15.5 4.6625 14.9 5.9875C14.3 7.3125 14 8.80833 14 10.475C14 10.7083 14.0042 10.9292 14.0125 11.1375C14.0208 11.3458 14.0417 11.5417 14.075 11.725ZM4.09999 16.3C3.91665 16.4833 3.68332 16.575 3.39999 16.575C3.11665 16.575 2.88332 16.4833 2.69999 16.3C2.51665 16.1167 2.42499 15.8833 2.42499 15.6C2.42499 15.3167 2.51665 15.0833 2.69999 14.9L3.59999 14L2.69999 13.1C2.51665 12.9167 2.42499 12.6833 2.42499 12.4C2.42499 12.1167 2.51665 11.8833 2.69999 11.7C2.88332 11.5167 3.11665 11.425 3.39999 11.425C3.68332 11.425 3.91665 11.5167 4.09999 11.7L4.99999 12.6L5.89999 11.7C6.08332 11.5167 6.31665 11.425 6.59999 11.425C6.88332 11.425 7.11665 11.5167 7.29999 11.7C7.48332 11.8833 7.57499 12.1167 7.57499 12.4C7.57499 12.6833 7.48332 12.9167 7.29999 13.1L6.39999 14L7.29999 14.9C7.48332 15.0833 7.57499 15.3167 7.57499 15.6C7.57499 15.8833 7.48332 16.1167 7.29999 16.3C7.11665 16.4833 6.88332 16.575 6.59999 16.575C6.31665 16.575 6.08332 16.4833 5.89999 16.3L4.99999 15.4L4.09999 16.3ZM15.45 16C14.95 16 14.4917 15.9042 14.075 15.7125C13.6583 15.5208 13.3 15.2083 13 14.775C12.7333 14.9083 12.4583 15.0417 12.175 15.175L11.325 15.575C11.0583 15.6917 10.7958 15.6958 10.5375 15.5875C10.2792 15.4792 10.1 15.2917 9.99999 15.025C9.89999 14.7583 9.91249 14.5 10.0375 14.25C10.1625 14 10.3583 13.8167 10.625 13.7C10.9083 13.5667 11.1833 13.4375 11.45 13.3125C11.7167 13.1875 11.975 13.0583 12.225 12.925C12.1417 12.5583 12.0792 12.1583 12.0375 11.725C11.9958 11.2917 11.975 10.825 11.975 10.325C11.975 7.925 12.45 5.9375 13.4 4.3625C14.35 2.7875 15.5417 2 16.975 2C17.8417 2 18.55 2.32083 19.1 2.9625C19.65 3.60417 19.925 4.5 19.925 5.65C19.925 7.08333 19.4708 8.5 18.5625 9.9C17.6542 11.3 16.3917 12.5583 14.775 13.675C14.8917 13.7917 15.0125 13.8792 15.1375 13.9375C15.2625 13.9958 15.3917 14.025 15.525 14.025C15.875 14.025 16.2833 13.8333 16.75 13.45C17.2167 13.0667 17.6667 12.55 18.1 11.9C18.2667 11.6667 18.4792 11.5042 18.7375 11.4125C18.9958 11.3208 19.25 11.3333 19.5 11.45C19.75 11.5833 19.9333 11.7792 20.05 12.0375C20.1667 12.2958 20.2 12.5667 20.15 12.85C20.1167 13.05 20.1 13.2417 20.1 13.425C20.1 13.6083 20.125 13.7833 20.175 13.95C20.2583 13.9167 20.3542 13.8625 20.4625 13.7875C20.5708 13.7125 20.6833 13.6167 20.8 13.5C21 13.3167 21.2375 13.2125 21.5125 13.1875C21.7875 13.1625 22.0333 13.2333 22.25 13.4C22.4833 13.5833 22.6083 13.8083 22.625 14.075C22.6417 14.3417 22.5583 14.5667 22.375 14.75C21.9917 15.1333 21.5875 15.4375 21.1625 15.6625C20.7375 15.8875 20.3333 16 19.95 16C19.6 16 19.2875 15.8958 19.0125 15.6875C18.7375 15.4792 18.5083 15.1583 18.325 14.725C17.8583 15.1417 17.3833 15.4583 16.9 15.675C16.4167 15.8917 15.9333 16 15.45 16ZM3.99999 21C3.71665 21 3.47915 20.9042 3.28749 20.7125C3.09582 20.5208 2.99999 20.2833 2.99999 20C2.99999 19.7167 3.09582 19.4792 3.28749 19.2875C3.47915 19.0958 3.71665 19 3.99999 19C4.28332 19 4.52082 19.0958 4.71249 19.2875C4.90415 19.4792 4.99999 19.7167 4.99999 20C4.99999 20.2833 4.90415 20.5208 4.71249 20.7125C4.52082 20.9042 4.28332 21 3.99999 21ZM7.99999 21C7.71665 21 7.47915 20.9042 7.28749 20.7125C7.09582 20.5208 6.99999 20.2833 6.99999 20C6.99999 19.7167 7.09582 19.4792 7.28749 19.2875C7.47915 19.0958 7.71665 19 7.99999 19C8.28332 19 8.52082 19.0958 8.71249 19.2875C8.90415 19.4792 8.99999 19.7167 8.99999 20C8.99999 20.2833 8.90415 20.5208 8.71249 20.7125C8.52082 20.9042 8.28332 21 7.99999 21ZM12 21C11.7167 21 11.4792 20.9042 11.2875 20.7125C11.0958 20.5208 11 20.2833 11 20C11 19.7167 11.0958 19.4792 11.2875 19.2875C11.4792 19.0958 11.7167 19 12 19C12.2833 19 12.5208 19.0958 12.7125 19.2875C12.9042 19.4792 13 19.7167 13 20C13 20.2833 12.9042 20.5208 12.7125 20.7125C12.5208 20.9042 12.2833 21 12 21ZM16 21C15.7167 21 15.4792 20.9042 15.2875 20.7125C15.0958 20.5208 15 20.2833 15 20C15 19.7167 15.0958 19.4792 15.2875 19.2875C15.4792 19.0958 15.7167 19 16 19C16.2833 19 16.5208 19.0958 16.7125 19.2875C16.9042 19.4792 17 19.7167 17 20C17 20.2833 16.9042 20.5208 16.7125 20.7125C16.5208 20.9042 16.2833 21 16 21ZM20 21C19.7167 21 19.4792 20.9042 19.2875 20.7125C19.0958 20.5208 19 20.2833 19 20C19 19.7167 19.0958 19.4792 19.2875 19.2875C19.4792 19.0958 19.7167 19 20 19C20.2833 19 20.5208 19.0958 20.7125 19.2875C20.9042 19.4792 21 19.7167 21 20C21 20.2833 20.9042 20.5208 20.7125 20.7125C20.5208 20.9042 20.2833 21 20 21Z",
    fill: "currentColor"
  }
) }), hme = Q("IconSign")(ife), afe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M12.475 16.825L20.85 8.45L19.55 7.15L11.175 15.525L12.475 16.825ZM3 15.275C3 15.7583 3.16667 16.1333 3.5 16.4C3.83333 16.6667 4.38333 16.8417 5.15 16.925C5.41667 16.9583 5.62917 17.0792 5.7875 17.2875C5.94583 17.4958 6.01667 17.7333 6 18C5.98333 18.2833 5.88333 18.5167 5.7 18.7C5.51667 18.8833 5.29167 18.9583 5.025 18.925C3.675 18.7583 2.66667 18.3708 2 17.7625C1.33333 17.1542 1 16.325 1 15.275C1 14.1917 1.44583 13.3125 2.3375 12.6375C3.22917 11.9625 4.46667 11.5583 6.05 11.425C6.7 11.375 7.1875 11.2708 7.5125 11.1125C7.8375 10.9542 8 10.7333 8 10.45C8 10.0833 7.825 9.79583 7.475 9.5875C7.125 9.37917 6.55 9.21667 5.75 9.1C5.48333 9.06667 5.27083 8.94167 5.1125 8.725C4.95417 8.50833 4.89167 8.26667 4.925 8C4.95833 7.71667 5.075 7.4875 5.275 7.3125C5.475 7.1375 5.70833 7.06667 5.975 7.1C7.35833 7.3 8.375 7.67083 9.025 8.2125C9.675 8.75417 10 9.5 10 10.45C10 11.3333 9.67917 12.025 9.0375 12.525C8.39583 13.025 7.45 13.325 6.2 13.425C5.13333 13.5083 4.33333 13.7042 3.8 14.0125C3.26667 14.3208 3 14.7417 3 15.275ZM12.95 19.175L8.825 15.05L18.375 5.5C18.7083 5.16667 19.1042 5 19.5625 5C20.0208 5 20.4167 5.16667 20.75 5.5L22.5 7.25C22.8333 7.58333 23 7.97917 23 8.4375C23 8.89583 22.8333 9.29167 22.5 9.625L12.95 19.175ZM8.975 20C8.69167 20.0667 8.44167 19.9917 8.225 19.775C8.00833 19.5583 7.93333 19.3083 8 19.025L8.825 15.05L12.95 19.175L8.975 20Z",
    fill: "currentColor"
  }
) }), pme = Q("IconSignAll")(afe), sfe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V4C4 3.45 4.19583 2.97917 4.5875 2.5875C4.97917 2.19583 5.45 2 6 2H13.175C13.4417 2 13.6958 2.05 13.9375 2.15C14.1792 2.25 14.3917 2.39167 14.575 2.575L19.425 7.425C19.6083 7.60833 19.75 7.82083 19.85 8.0625C19.95 8.30417 20 8.55833 20 8.825V20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22H6ZM13 8V4H6V20H18V9H14C13.7167 9 13.4792 8.90417 13.2875 8.7125C13.0958 8.52083 13 8.28333 13 8Z",
    fill: "currentColor"
  }
) }), lfe = Q("IconFile")(sfe), cfe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H9.175C9.44167 4 9.69583 4.05 9.9375 4.15C10.1792 4.25 10.3917 4.39167 10.575 4.575L12 6H20C20.55 6 21.0208 6.19583 21.4125 6.5875C21.8042 6.97917 22 7.45 22 8V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4ZM4 18H20V8H11.175L9.175 6H4V18Z",
    fill: "currentColor"
  }
) }), mme = Q("IconFolder")(cfe), ufe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H9.175C9.44167 4 9.69583 4.05 9.9375 4.15C10.1792 4.25 10.3917 4.39167 10.575 4.575L12 6H21C21.2833 6 21.5208 6.09583 21.7125 6.2875C21.9042 6.47917 22 6.71667 22 7C22 7.28333 21.9042 7.52083 21.7125 7.7125C21.5208 7.90417 21.2833 8 21 8H11.175L9.175 6H4V18L5.975 11.425C6.10833 10.9917 6.35417 10.6458 6.7125 10.3875C7.07083 10.1292 7.46667 10 7.9 10H20.8C21.4833 10 22.0208 10.2708 22.4125 10.8125C22.8042 11.3542 22.9083 11.9417 22.725 12.575L20.925 18.575C20.7917 19.0083 20.5458 19.3542 20.1875 19.6125C19.8292 19.8708 19.4333 20 19 20H4ZM6.1 18H19L20.8 12H7.9L6.1 18Z",
    fill: "currentColor"
  }
) }), gme = Q("IconFolderOpen")(ufe), ffe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M19 19H8C7.45 19 6.97917 18.8042 6.5875 18.4125C6.19583 18.0208 6 17.55 6 17V3C6 2.45 6.19583 1.97917 6.5875 1.5875C6.97917 1.19583 7.45 1 8 1H14.175C14.4417 1 14.6958 1.05 14.9375 1.15C15.1792 1.25 15.3917 1.39167 15.575 1.575L20.425 6.425C20.6083 6.60833 20.75 6.82083 20.85 7.0625C20.95 7.30417 21 7.55833 21 7.825V17C21 17.55 20.8042 18.0208 20.4125 18.4125C20.0208 18.8042 19.55 19 19 19ZM19 8H15.5C15.0833 8 14.7292 7.85417 14.4375 7.5625C14.1458 7.27083 14 6.91667 14 6.5V3H8V17H19V8ZM4 23C3.45 23 2.97917 22.8042 2.5875 22.4125C2.19583 22.0208 2 21.55 2 21V8C2 7.71667 2.09583 7.47917 2.2875 7.2875C2.47917 7.09583 2.71667 7 3 7C3.28333 7 3.52083 7.09583 3.7125 7.2875C3.90417 7.47917 4 7.71667 4 8V21H14C14.2833 21 14.5208 21.0958 14.7125 21.2875C14.9042 21.4792 15 21.7167 15 22C15 22.2833 14.9042 22.5208 14.7125 22.7125C14.5208 22.9042 14.2833 23 14 23H4Z",
    fill: "currentColor"
  }
) }), Cme = Q("IconCopy")(ffe), dfe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M6 22C5.16667 22 4.45833 21.7083 3.875 21.125C3.29167 20.5417 3 19.8333 3 19V17C3 16.7167 3.09583 16.4792 3.2875 16.2875C3.47917 16.0958 3.71667 16 4 16H6V2.60001C6 2.48335 6.05 2.40418 6.15 2.36251C6.25 2.32085 6.34167 2.34168 6.425 2.42501L7.15 3.15001C7.25 3.25001 7.36667 3.30001 7.5 3.30001C7.63333 3.30001 7.75 3.25001 7.85 3.15001L8.65 2.35001C8.75 2.25001 8.86667 2.20001 9 2.20001C9.13333 2.20001 9.25 2.25001 9.35 2.35001L10.15 3.15001C10.25 3.25001 10.3667 3.30001 10.5 3.30001C10.6333 3.30001 10.75 3.25001 10.85 3.15001L11.65 2.35001C11.75 2.25001 11.8667 2.20001 12 2.20001C12.1333 2.20001 12.25 2.25001 12.35 2.35001L13.15 3.15001C13.25 3.25001 13.3667 3.30001 13.5 3.30001C13.6333 3.30001 13.75 3.25001 13.85 3.15001L14.65 2.35001C14.75 2.25001 14.8667 2.20001 15 2.20001C15.1333 2.20001 15.25 2.25001 15.35 2.35001L16.15 3.15001C16.25 3.25001 16.3667 3.30001 16.5 3.30001C16.6333 3.30001 16.75 3.25001 16.85 3.15001L17.65 2.35001C17.75 2.25001 17.8667 2.20001 18 2.20001C18.1333 2.20001 18.25 2.25001 18.35 2.35001L19.15 3.15001C19.25 3.25001 19.3667 3.30001 19.5 3.30001C19.6333 3.30001 19.75 3.25001 19.85 3.15001L20.575 2.42501C20.6583 2.34168 20.75 2.32085 20.85 2.36251C20.95 2.40418 21 2.48335 21 2.60001V19C21 19.8333 20.7083 20.5417 20.125 21.125C19.5417 21.7083 18.8333 22 18 22H6ZM18 20C18.2833 20 18.5208 19.9042 18.7125 19.7125C18.9042 19.5208 19 19.2833 19 19V5.00001H8V16H16C16.2833 16 16.5208 16.0958 16.7125 16.2875C16.9042 16.4792 17 16.7167 17 17V19C17 19.2833 17.0958 19.5208 17.2875 19.7125C17.4792 19.9042 17.7167 20 18 20ZM10 7.00001H14C14.2833 7.00001 14.5208 7.09585 14.7125 7.28751C14.9042 7.47918 15 7.71668 15 8.00001C15 8.28335 14.9042 8.52085 14.7125 8.71251C14.5208 8.90418 14.2833 9.00001 14 9.00001H10C9.71667 9.00001 9.47917 8.90418 9.2875 8.71251C9.09583 8.52085 9 8.28335 9 8.00001C9 7.71668 9.09583 7.47918 9.2875 7.28751C9.47917 7.09585 9.71667 7.00001 10 7.00001ZM10 10H14C14.2833 10 14.5208 10.0958 14.7125 10.2875C14.9042 10.4792 15 10.7167 15 11C15 11.2833 14.9042 11.5208 14.7125 11.7125C14.5208 11.9042 14.2833 12 14 12H10C9.71667 12 9.47917 11.9042 9.2875 11.7125C9.09583 11.5208 9 11.2833 9 11C9 10.7167 9.09583 10.4792 9.2875 10.2875C9.47917 10.0958 9.71667 10 10 10ZM17 9.00001C16.7167 9.00001 16.4792 8.90418 16.2875 8.71251C16.0958 8.52085 16 8.28335 16 8.00001C16 7.71668 16.0958 7.47918 16.2875 7.28751C16.4792 7.09585 16.7167 7.00001 17 7.00001C17.2833 7.00001 17.5208 7.09585 17.7125 7.28751C17.9042 7.47918 18 7.71668 18 8.00001C18 8.28335 17.9042 8.52085 17.7125 8.71251C17.5208 8.90418 17.2833 9.00001 17 9.00001ZM17 12C16.7167 12 16.4792 11.9042 16.2875 11.7125C16.0958 11.5208 16 11.2833 16 11C16 10.7167 16.0958 10.4792 16.2875 10.2875C16.4792 10.0958 16.7167 10 17 10C17.2833 10 17.5208 10.0958 17.7125 10.2875C17.9042 10.4792 18 10.7167 18 11C18 11.2833 17.9042 11.5208 17.7125 11.7125C17.5208 11.9042 17.2833 12 17 12ZM6 20H15V18H5V19C5 19.2833 5.09583 19.5208 5.2875 19.7125C5.47917 19.9042 5.71667 20 6 20Z",
    fill: "currentColor"
  }
) }), vme = Q("IconInvoice")(dfe), hfe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M3 21.4V2.60001C3 2.48335 3.05 2.40418 3.15 2.36251C3.25 2.32085 3.34167 2.34168 3.425 2.42501L4.15 3.15001C4.25 3.25001 4.36667 3.30001 4.5 3.30001C4.63333 3.30001 4.75 3.25001 4.85 3.15001L5.65 2.35001C5.75 2.25001 5.86667 2.20001 6 2.20001C6.13333 2.20001 6.25 2.25001 6.35 2.35001L7.15 3.15001C7.25 3.25001 7.36667 3.30001 7.5 3.30001C7.63333 3.30001 7.75 3.25001 7.85 3.15001L8.65 2.35001C8.75 2.25001 8.86667 2.20001 9 2.20001C9.13333 2.20001 9.25 2.25001 9.35 2.35001L10.15 3.15001C10.25 3.25001 10.3667 3.30001 10.5 3.30001C10.6333 3.30001 10.75 3.25001 10.85 3.15001L11.65 2.35001C11.75 2.25001 11.8667 2.20001 12 2.20001C12.1333 2.20001 12.25 2.25001 12.35 2.35001L13.15 3.15001C13.25 3.25001 13.3667 3.30001 13.5 3.30001C13.6333 3.30001 13.75 3.25001 13.85 3.15001L14.65 2.35001C14.75 2.25001 14.8667 2.20001 15 2.20001C15.1333 2.20001 15.25 2.25001 15.35 2.35001L16.15 3.15001C16.25 3.25001 16.3667 3.30001 16.5 3.30001C16.6333 3.30001 16.75 3.25001 16.85 3.15001L17.65 2.35001C17.75 2.25001 17.8667 2.20001 18 2.20001C18.1333 2.20001 18.25 2.25001 18.35 2.35001L19.15 3.15001C19.25 3.25001 19.3667 3.30001 19.5 3.30001C19.6333 3.30001 19.75 3.25001 19.85 3.15001L20.575 2.42501C20.6583 2.34168 20.75 2.32085 20.85 2.36251C20.95 2.40418 21 2.48335 21 2.60001V21.4C21 21.5167 20.95 21.5958 20.85 21.6375C20.75 21.6792 20.6583 21.6583 20.575 21.575L19.85 20.85C19.75 20.75 19.6333 20.7 19.5 20.7C19.3667 20.7 19.25 20.75 19.15 20.85L18.35 21.65C18.25 21.75 18.1333 21.8 18 21.8C17.8667 21.8 17.75 21.75 17.65 21.65L16.85 20.85C16.75 20.75 16.6333 20.7 16.5 20.7C16.3667 20.7 16.25 20.75 16.15 20.85L15.35 21.65C15.25 21.75 15.1333 21.8 15 21.8C14.8667 21.8 14.75 21.75 14.65 21.65L13.85 20.85C13.75 20.75 13.6333 20.7 13.5 20.7C13.3667 20.7 13.25 20.75 13.15 20.85L12.35 21.65C12.25 21.75 12.1333 21.8 12 21.8C11.8667 21.8 11.75 21.75 11.65 21.65L10.85 20.85C10.75 20.75 10.6333 20.7 10.5 20.7C10.3667 20.7 10.25 20.75 10.15 20.85L9.35 21.65C9.25 21.75 9.13333 21.8 9 21.8C8.86667 21.8 8.75 21.75 8.65 21.65L7.85 20.85C7.75 20.75 7.63333 20.7 7.5 20.7C7.36667 20.7 7.25 20.75 7.15 20.85L6.35 21.65C6.25 21.75 6.13333 21.8 6 21.8C5.86667 21.8 5.75 21.75 5.65 21.65L4.85 20.85C4.75 20.75 4.63333 20.7 4.5 20.7C4.36667 20.7 4.25 20.75 4.15 20.85L3.425 21.575C3.34167 21.6583 3.25 21.6792 3.15 21.6375C3.05 21.5958 3 21.5167 3 21.4ZM7 17H17C17.2833 17 17.5208 16.9042 17.7125 16.7125C17.9042 16.5208 18 16.2833 18 16C18 15.7167 17.9042 15.4792 17.7125 15.2875C17.5208 15.0958 17.2833 15 17 15H7C6.71667 15 6.47917 15.0958 6.2875 15.2875C6.09583 15.4792 6 15.7167 6 16C6 16.2833 6.09583 16.5208 6.2875 16.7125C6.47917 16.9042 6.71667 17 7 17ZM7 13H17C17.2833 13 17.5208 12.9042 17.7125 12.7125C17.9042 12.5208 18 12.2833 18 12C18 11.7167 17.9042 11.4792 17.7125 11.2875C17.5208 11.0958 17.2833 11 17 11H7C6.71667 11 6.47917 11.0958 6.2875 11.2875C6.09583 11.4792 6 11.7167 6 12C6 12.2833 6.09583 12.5208 6.2875 12.7125C6.47917 12.9042 6.71667 13 7 13ZM7 9.00001H17C17.2833 9.00001 17.5208 8.90418 17.7125 8.71251C17.9042 8.52085 18 8.28335 18 8.00001C18 7.71668 17.9042 7.47918 17.7125 7.28751C17.5208 7.09585 17.2833 7.00001 17 7.00001H7C6.71667 7.00001 6.47917 7.09585 6.2875 7.28751C6.09583 7.47918 6 7.71668 6 8.00001C6 8.28335 6.09583 8.52085 6.2875 8.71251C6.47917 8.90418 6.71667 9.00001 7 9.00001ZM5 19.1H19V4.90001H5V19.1Z",
    fill: "currentColor"
  }
) }), yme = Q("IconRecipt")(hfe), pfe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M14 21V19.35C14 19.2167 14.025 19.0875 14.075 18.9625C14.125 18.8375 14.2 18.725 14.3 18.625L19.525 13.425C19.675 13.275 19.8417 13.1667 20.025 13.1C20.2083 13.0333 20.3917 13 20.575 13C20.775 13 20.9667 13.0375 21.15 13.1125C21.3333 13.1875 21.5 13.3 21.65 13.45L22.575 14.375C22.7083 14.525 22.8125 14.6917 22.8875 14.875C22.9625 15.0583 23 15.2417 23 15.425C23 15.6083 22.9667 15.7958 22.9 15.9875C22.8333 16.1792 22.725 16.35 22.575 16.5L17.375 21.7C17.275 21.8 17.1625 21.875 17.0375 21.925C16.9125 21.975 16.7833 22 16.65 22H15C14.7167 22 14.4792 21.9042 14.2875 21.7125C14.0958 21.5208 14 21.2833 14 21ZM15.5 20.5H16.45L19.475 17.45L18.55 16.525L15.5 19.55V20.5ZM6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V4C4 3.45 4.19583 2.97917 4.5875 2.5875C4.97917 2.19583 5.45 2 6 2H13.175C13.4417 2 13.6958 2.05 13.9375 2.15C14.1792 2.25 14.3917 2.39167 14.575 2.575L19.425 7.425C19.6083 7.60833 19.75 7.82083 19.85 8.0625C19.95 8.30417 20 8.55833 20 8.825V10.25C20 10.5333 19.9042 10.7708 19.7125 10.9625C19.5208 11.1542 19.2833 11.25 19 11.25C18.7167 11.25 18.4792 11.1542 18.2875 10.9625C18.0958 10.7708 18 10.5333 18 10.25V9H14C13.7167 9 13.4792 8.90417 13.2875 8.7125C13.0958 8.52083 13 8.28333 13 8V4H6V20H11C11.2833 20 11.5208 20.0958 11.7125 20.2875C11.9042 20.4792 12 20.7167 12 21C12 21.2833 11.9042 21.5208 11.7125 21.7125C11.5208 21.9042 11.2833 22 11 22H6ZM19.025 16.975L18.55 16.525L19.475 17.45L19.025 16.975Z",
    fill: "currentColor"
  }
) }), bme = Q("IconFileEdit")(pfe), mfe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M11.45 17C11.75 17 12.0458 16.9625 12.3375 16.8875C12.6292 16.8125 12.9 16.7 13.15 16.55L14.9 18.3C15.0833 18.4833 15.3167 18.575 15.6 18.575C15.8833 18.575 16.1167 18.4833 16.3 18.3C16.4833 18.1167 16.575 17.8833 16.575 17.6C16.575 17.3167 16.4833 17.0833 16.3 16.9L14.55 15.15C14.7 14.9 14.8125 14.6292 14.8875 14.3375C14.9625 14.0458 15 13.75 15 13.45C15 12.4833 14.6583 11.6667 13.975 11C13.2917 10.3333 12.4667 10 11.5 10C10.5333 10 9.70833 10.3417 9.025 11.025C8.34167 11.7083 8 12.5333 8 13.5C8 14.4667 8.33333 15.2917 9 15.975C9.66667 16.6583 10.4833 17 11.45 17ZM11.5 15C11.0833 15 10.7292 14.8542 10.4375 14.5625C10.1458 14.2708 10 13.9167 10 13.5C10 13.0833 10.1458 12.7292 10.4375 12.4375C10.7292 12.1458 11.0833 12 11.5 12C11.9167 12 12.2708 12.1458 12.5625 12.4375C12.8542 12.7292 13 13.0833 13 13.5C13 13.9167 12.8542 14.2708 12.5625 14.5625C12.2708 14.8542 11.9167 15 11.5 15ZM6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V4C4 3.45 4.19583 2.97917 4.5875 2.5875C4.97917 2.19583 5.45 2 6 2H13.175C13.4417 2 13.6958 2.05 13.9375 2.15C14.1792 2.25 14.3917 2.39167 14.575 2.575L19.425 7.425C19.6083 7.60833 19.75 7.82083 19.85 8.0625C19.95 8.30417 20 8.55833 20 8.825V20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22H6ZM13 8V4H6V20H18V9H14C13.7167 9 13.4792 8.90417 13.2875 8.7125C13.0958 8.52083 13 8.28333 13 8Z",
    fill: "currentColor"
  }
) }), wme = Q("IconFileSearch")(mfe), gfe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M16 12V10H18V12H16ZM16 14H14V12H16V14ZM16 16V14H18V16H16ZM11.175 8L9.175 6H4V18H14V16H16V18H20V8H16V10H14V8H11.175ZM4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H9.175C9.44167 4 9.69583 4.05 9.9375 4.15C10.1792 4.25 10.3917 4.39167 10.575 4.575L12 6H20C20.55 6 21.0208 6.19583 21.4125 6.5875C21.8042 6.97917 22 7.45 22 8V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4Z",
    fill: "currentColor"
  }
) }), xme = Q("IconZip")(gfe), Cfe = (e) => /* @__PURE__ */ F("svg", { viewBox: "0 0 24 24", ...e, children: [
  /* @__PURE__ */ d(
    "mask",
    {
      id: "mask0_4355_5655",
      style: { maskType: "alpha" },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "0",
      width: "24",
      height: "24",
      children: /* @__PURE__ */ d("rect", { width: "24", height: "24", fill: "currentColor" })
    }
  ),
  /* @__PURE__ */ d("g", { mask: "url(#mask0_4355_5655)", children: /* @__PURE__ */ d(
    "path",
    {
      d: "M10.925 15.125L9.525 13.725C9.425 13.625 9.31667 13.55 9.2 13.5C9.08333 13.45 8.9625 13.425 8.8375 13.425C8.7125 13.425 8.5875 13.45 8.4625 13.5C8.3375 13.55 8.225 13.625 8.125 13.725C7.925 13.925 7.825 14.1625 7.825 14.4375C7.825 14.7125 7.925 14.95 8.125 15.15L10.25 17.3C10.35 17.4 10.4583 17.4708 10.575 17.5125C10.6917 17.5542 10.8167 17.575 10.95 17.575C11.0833 17.575 11.2083 17.5542 11.325 17.5125C11.4417 17.4708 11.55 17.4 11.65 17.3L15.875 13.075C16.075 12.875 16.175 12.6333 16.175 12.35C16.175 12.0667 16.075 11.825 15.875 11.625C15.675 11.425 15.4333 11.325 15.15 11.325C14.8667 11.325 14.625 11.425 14.425 11.625L10.925 15.125ZM6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V4C4 3.45 4.19583 2.97917 4.5875 2.5875C4.97917 2.19583 5.45 2 6 2H13.175C13.4417 2 13.6958 2.05 13.9375 2.15C14.1792 2.25 14.3917 2.39167 14.575 2.575L19.425 7.425C19.6083 7.60833 19.75 7.82083 19.85 8.0625C19.95 8.30417 20 8.55833 20 8.825V20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22H6ZM13 8V4H6V20H18V9H14C13.7167 9 13.4792 8.90417 13.2875 8.7125C13.0958 8.52083 13 8.28333 13 8Z",
      fill: "currentColor"
    }
  ) })
] }), Sme = Q("IconFileSuccess")(Cfe), vfe = (e) => /* @__PURE__ */ F("svg", { viewBox: "0 0 24 24", ...e, children: [
  /* @__PURE__ */ d(
    "mask",
    {
      id: "mask0_4355_5658",
      style: { maskType: "alpha" },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "0",
      width: "24",
      height: "24",
      children: /* @__PURE__ */ d("rect", { width: "24", height: "24", fill: "currentColor" })
    }
  ),
  /* @__PURE__ */ d("g", { mask: "url(#mask0_4355_5658)", children: /* @__PURE__ */ d(
    "path",
    {
      d: "M6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V4C4 3.45 4.19583 2.97917 4.5875 2.5875C4.97917 2.19583 5.45 2 6 2H13.175C13.4417 2 13.6958 2.05 13.9375 2.15C14.1792 2.25 14.3917 2.39167 14.575 2.575L19.425 7.425C19.6083 7.60833 19.75 7.82083 19.85 8.0625C19.95 8.30417 20 8.55833 20 8.825V11.6C20 11.8833 19.9042 12.1208 19.7125 12.3125C19.5208 12.5042 19.2833 12.6 19 12.6C18.7167 12.6 18.4792 12.5042 18.2875 12.3125C18.0958 12.1208 18 11.8833 18 11.6V9H15C14.45 9 13.9792 8.80417 13.5875 8.4125C13.1958 8.02083 13 7.55 13 7V4H6V20H12.2C12.4833 20 12.7208 20.0958 12.9125 20.2875C13.1042 20.4792 13.2 20.7167 13.2 21C13.2 21.2833 13.1042 21.5208 12.9125 21.7125C12.7208 21.9042 12.4833 22 12.2 22H6ZM18 19.425L16.6 20.8C16.4167 20.9833 16.1875 21.0792 15.9125 21.0875C15.6375 21.0958 15.4 21 15.2 20.8C15.0167 20.6167 14.925 20.3833 14.925 20.1C14.925 19.8167 15.0167 19.5833 15.2 19.4L16.6 18L15.2 16.6C15.0167 16.4167 14.925 16.1833 14.925 15.9C14.925 15.6167 15.0167 15.3833 15.2 15.2C15.3833 15.0167 15.6167 14.925 15.9 14.925C16.1833 14.925 16.4167 15.0167 16.6 15.2L18 16.6L19.4 15.2C19.5833 15.0167 19.8125 14.9208 20.0875 14.9125C20.3625 14.9042 20.6 15 20.8 15.2C20.9833 15.3833 21.075 15.6167 21.075 15.9C21.075 16.1833 20.9833 16.4167 20.8 16.6L19.425 18L20.8 19.4C20.9833 19.5833 21.0792 19.8125 21.0875 20.0875C21.0958 20.3625 21 20.6 20.8 20.8C20.6167 20.9833 20.3833 21.075 20.1 21.075C19.8167 21.075 19.5833 20.9833 19.4 20.8L18 19.425Z",
      fill: "currentColor"
    }
  ) })
] }), Mme = Q("IconFileFail")(vfe), yfe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 18 18", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M8.76635 14.4C9.58535 14.4 10.279 14.1157 10.8474 13.5469C11.4158 12.9782 11.7 12.2875 11.7 11.475V9.67505C11.7 9.4838 11.6357 9.32349 11.507 9.19411C11.3784 9.06474 11.219 9.00005 11.0289 9.00005C10.8388 9.00005 10.6781 9.06474 10.5469 9.19411C10.4156 9.32349 10.35 9.4838 10.35 9.67505V11.475C10.35 11.9082 10.1969 12.279 9.8906 12.5875C9.58435 12.8959 9.20941 13.05 8.76579 13.05C8.33516 13.05 7.96654 12.8959 7.65991 12.5875C7.35329 12.279 7.19998 11.9082 7.19998 11.475V8.10005C7.19998 7.97505 7.24498 7.8688 7.33498 7.7813C7.42498 7.6938 7.52998 7.65005 7.64998 7.65005C7.77498 7.65005 7.88123 7.6938 7.96873 7.7813C8.05623 7.8688 8.09998 7.97505 8.09998 8.10005V11.0295C8.09998 11.214 8.16429 11.3719 8.29291 11.5032C8.42154 11.6344 8.58091 11.7 8.77104 11.7C8.96116 11.7 9.12185 11.6354 9.2531 11.506C9.38435 11.3766 9.44998 11.2163 9.44998 11.025V8.10005C9.44998 7.59605 9.27641 7.17005 8.92929 6.82205C8.58204 6.47405 8.15704 6.30005 7.65429 6.30005C7.15141 6.30005 6.72498 6.47405 6.37498 6.82205C6.02498 7.17005 5.84998 7.59605 5.84998 8.10005V11.475C5.84998 12.2875 6.13435 12.9782 6.7031 13.5469C7.27185 14.1157 7.9596 14.4 8.76635 14.4ZM4.94473 16.2C4.57323 16.2 4.25623 16.0679 3.99373 15.8035C3.73123 15.5391 3.59998 15.2213 3.59998 14.85V3.15005C3.59998 2.7788 3.73216 2.46099 3.99654 2.19661C4.26091 1.93224 4.57873 1.80005 4.94998 1.80005H10.8L14.4 5.40005V14.85C14.4 15.2213 14.2677 15.5391 14.0032 15.8035C13.7387 16.0679 13.4207 16.2 13.0492 16.2H4.94473ZM4.94998 14.85H13.05V6.30005H10.575C10.3837 6.30005 10.2234 6.23536 10.094 6.10599C9.96466 5.97661 9.89998 5.8163 9.89998 5.62505V3.15005H4.94998V14.85Z",
    fill: "currentColor"
  }
) }), Eme = Q("IconFilePresent")(yfe), dL = gt({
  feedback: void 0,
  setFeedback: () => {
  },
  open: !1,
  setOpen: () => {
  }
}), _me = ({
  children: e
}) => {
  const [t, n] = ue(
    void 0
  ), [r, o] = ue(!1);
  return /* @__PURE__ */ d(dL.Provider, { value: { feedback: t, setFeedback: n, open: r, setOpen: o }, children: e });
}, hm = () => {
  const e = Oe(dL);
  if (!e)
    throw new Error("useFeedback must be used within a FeedbackProvider");
  return e;
};
var ia = /* @__PURE__ */ ((e) => (e[e.HATE = 1] = "HATE", e[e.DISLIKE = 2] = "DISLIKE", e[e.NEUTRAL = 3] = "NEUTRAL", e[e.LIKE = 4] = "LIKE", e[e.LOVE = 5] = "LOVE", e))(ia || {});
const bfe = (e) => /* @__PURE__ */ F("svg", { viewBox: "0 0 24 24", ...e, children: [
  /* @__PURE__ */ d(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.777 1.90626L14.2061 2.20182L14.7817 1.91566L15.8211 4.0064L18.1252 4.35625C18.3131 4.3823 18.4898 4.46049 18.6355 4.58202C18.7834 4.70537 18.893 4.86827 18.9518 5.05166C19.0104 5.23506 19.0157 5.43139 18.967 5.61767C18.9185 5.80251 18.8189 5.96988 18.6795 6.10052L17.075 7.62539L17.4134 10.0071C17.4471 10.1912 17.4293 10.3812 17.3615 10.5559C17.2905 10.7389 17.1681 10.8974 17.009 11.0121C16.8498 11.1269 16.6607 11.193 16.4647 11.2024C16.2743 11.2116 16.0852 11.1669 15.9191 11.0736L13.8732 9.99049L11.8274 11.0736C11.6613 11.1669 11.4722 11.2116 11.2817 11.2024C11.0858 11.193 10.8967 11.1269 10.7375 11.0121C10.5784 10.8974 10.4559 10.7389 10.385 10.5559C10.316 10.3779 10.2987 10.1842 10.3349 9.99698L10.7258 7.67604L9.06326 6.08422L9.05016 6.07169C8.91938 5.93921 8.82777 5.77309 8.78503 5.59191C8.74228 5.41071 8.75024 5.22125 8.80803 5.04428C8.86581 4.86732 8.97119 4.70968 9.11263 4.58863C9.25406 4.46758 9.42609 4.38779 9.60986 4.35802L9.61941 4.35647L11.9258 4.01844L12.9624 1.93324C13.043 1.76545 13.1683 1.62304 13.3246 1.52168C13.4833 1.41872 13.6677 1.36222 13.8569 1.35859C14.046 1.35495 14.2325 1.40431 14.3951 1.50109C14.5577 1.59788 14.6899 1.73822 14.777 1.90626Z"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      className: "text-surface-common-primary-light",
      d: "M1 10.3584H3.36976C4.73373 10.3584 6.04184 10.9002 7.0063 11.8647L9.08988 13.9483C9.32942 14.3701 9.26937 14.9159 8.9097 15.2756C8.47795 15.7074 7.77791 15.7074 7.34616 15.2756L5.48186 13.4113C5.16804 13.0975 4.65925 13.0975 4.34543 13.4113C4.03162 13.7251 4.03162 14.2339 4.34543 14.5476L6.20974 16.4121C7.26913 17.4714 8.98674 17.4714 10.0461 16.4121C10.3146 16.1436 10.515 15.8328 10.6474 15.5013H14.5C15.5651 15.5013 16.4286 16.3647 16.4286 17.4298C16.4286 18.4949 15.5651 19.3584 14.5 19.3584H6.98738C5.62342 19.3584 4.3153 18.8166 3.35084 17.8521L1 15.5013V10.3584Z"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.08989 13.9482C9.32947 14.3701 9.26941 14.9159 8.90973 15.2756C8.47798 15.7073 7.77795 15.7073 7.34619 15.2756L5.48189 13.4113C5.16807 13.0975 4.65928 13.0975 4.34546 13.4113C4.03166 13.7251 4.03166 14.2339 4.34546 14.5476L6.20977 16.412C7.26916 17.4713 8.98677 17.4713 10.0462 16.412C10.3146 16.1436 10.515 15.8328 10.6474 15.5012H10.6429L9.08989 13.9482Z"
    }
  )
] }), wfe = Q("IconHandStar")(bfe), xfe = 3e3, Ome = ({
  title: e = "Gi oss din tilbakemelding",
  ingress: t = "Hva synes du om Portalen?",
  textareaLabel: n = "Hva likte du / hva likte du ikke?",
  bannerText: r = "Husk at du alltid kan gi tilbakemelding via avataren din i topplinjen til høyre — helt anonymt.",
  loading: o = !1,
  error: i,
  onSend: a
}) => {
  const { open: s, setOpen: l, setFeedback: c } = hm(), u = ke(null), [f, h] = ue(void 0), [p, C] = ue(null), m = !!p, g = (x) => {
    C(x), setTimeout(() => {
      u.current?.focus();
    }, 0);
  }, v = () => {
    if (!p) return;
    const x = { feedbackMessage: f || "", rating: p };
    c(x), a?.(x);
  }, y = (x) => {
    x.key === "Enter" && x.ctrlKey && m && v();
  };
  ve(() => {
    s && (h(void 0), C(null));
  }, [s]);
  const w = () => {
    const x = [
      {
        label: "😫",
        value: ia.HATE,
        description: "Hater det"
      },
      {
        label: "🙁",
        value: ia.DISLIKE,
        description: "Liker det ikke"
      },
      {
        label: "😐",
        value: ia.NEUTRAL,
        description: "Nøytral"
      },
      {
        label: "🙂",
        value: ia.LIKE,
        description: "Liker det"
      },
      {
        label: "😍",
        value: ia.LOVE,
        description: "Elsker det"
      }
    ];
    return /* @__PURE__ */ F("fieldset", { className: "m-0 border-0 p-0", children: [
      /* @__PURE__ */ d("legend", { className: "sr-only", children: "Velg din reaksjon" }),
      /* @__PURE__ */ d(
        "div",
        {
          className: "flex justify-center gap-sm sm:gap-md",
          role: "radiogroup",
          "aria-label": "Velg din reaksjon",
          children: x.map((b) => /* @__PURE__ */ d(
            "button",
            {
              disabled: o,
              type: "button",
              "aria-label": b.description,
              "aria-pressed": p === b.value,
              className: I(
                "focus:ring-primary rounded-full p-md text-xl outline-none transition-colors duration-200 ease-in-out hover:bg-surface-common-light focus:ring-2 sm:text-4xl",
                p === b.value && "bg-surface-common-light"
              ),
              onClick: () => g(b.value),
              children: b.label
            },
            b.value
          ))
        }
      )
    ] });
  };
  return s ? /* @__PURE__ */ F(
    vr,
    {
      open: s,
      onClose: () => l(!1),
      "aria-labelledby": "feedback-title",
      "aria-describedby": "feedback-description",
      children: [
        /* @__PURE__ */ d(vr.Header, { id: "feedback-title", children: e }),
        /* @__PURE__ */ d(vr.Block, { children: /* @__PURE__ */ F(
          "form",
          {
            onSubmit: (x) => {
              x.preventDefault(), m && v();
            },
            onKeyDown: y,
            children: [
              /* @__PURE__ */ F("div", { className: "flex flex-col gap-sm sm:gap-md", children: [
                /* @__PURE__ */ d(Rt, { id: "feedback-description", weight: "semibold", children: t }),
                /* @__PURE__ */ d(w, {}),
                /* @__PURE__ */ d(
                  Ine,
                  {
                    ref: u,
                    disabled: o,
                    label: n,
                    maxLength: xfe,
                    value: f || "",
                    onChange: (x) => h(x.target.value),
                    "aria-required": "true",
                    "aria-invalid": f === ""
                  }
                ),
                r && /* @__PURE__ */ d(Na, { variant: "default", closeButton: !1, children: /* @__PURE__ */ F("div", { className: "flex gap-sm", "aria-live": "polite", children: [
                  /* @__PURE__ */ d(wfe, { "aria-hidden": "true" }),
                  /* @__PURE__ */ d("div", { className: "flex flex-col", children: /* @__PURE__ */ d(Rt, { children: r }) })
                ] }) }),
                !!i && /* @__PURE__ */ d(Na, { variant: "error", closeButton: !1, children: i })
              ] }),
              /* @__PURE__ */ F(vr.Footer, { children: [
                /* @__PURE__ */ d(
                  Dt,
                  {
                    type: "button",
                    variant: "ghost",
                    onClick: () => l(!1),
                    disabled: o,
                    "aria-disabled": o,
                    trackingEvent: "Tilbakemelding - Avbryt",
                    trackingName: "Tilbakemelding",
                    children: "Avbryt"
                  }
                ),
                /* @__PURE__ */ d(
                  Dt,
                  {
                    type: "submit",
                    variant: "primary",
                    loading: o,
                    disabled: !m,
                    "aria-disabled": !m,
                    trackingEvent: "Tilbakemelding - Send",
                    trackingName: "Tilbakemelding",
                    children: "Send"
                  }
                )
              ] })
            ]
          }
        ) })
      ]
    }
  ) : null;
}, Ame = ({
  label: e = "Feedback",
  children: t,
  ...n
}) => {
  const { setOpen: r, open: o } = hm();
  return /* @__PURE__ */ d(Dt, { ...n, onClick: () => {
    o || r(!0);
  }, children: t || e });
}, Sfe = "frc-count", Mfe = "frc-threshold", Pme = ({
  initialRouteChangeThreshold: e = 50,
  incrementMultiplier: t = 5,
  maxThreshold: n = 6250,
  pathname: r,
  storageKey: o = Sfe,
  storageThresholdKey: i = Mfe,
  skip: a = !1
}) => {
  const [s, l] = ue(0), [c, u] = ue(
    e
  ), { setOpen: f } = hm(), h = ke(null), p = () => {
    const m = localStorage.getItem(i);
    u(m ? parseInt(m) : e);
  }, C = () => {
    const m = Math.min(
      c * t,
      n
    );
    localStorage.setItem(i, m.toString()), u(m);
  };
  ve(() => {
    if (a) return;
    const m = localStorage.getItem(o);
    p(), m && l(parseInt(m)), h.current = r;
  }, []), ve(() => {
    a || (h.current !== null && r !== h.current && l((m) => {
      const g = m + 1;
      return localStorage.setItem(o, g.toString()), g;
    }), h.current = r);
  }, [r, o]), ve(() => {
    a || c >= n || s >= c && (f(!0), C());
  }, [s, c, f]);
}, Efe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    fill: "currentColor",
    d: "M11 16.175V5C11 4.71667 11.0958 4.47917 11.2875 4.2875C11.4792 4.09583 11.7167 4 12 4C12.2833 4 12.5208 4.09583 12.7125 4.2875C12.9042 4.47917 13 4.71667 13 5V16.175L17.9 11.275C18.1 11.075 18.3333 10.9792 18.6 10.9875C18.8667 10.9958 19.1 11.1 19.3 11.3C19.4833 11.5 19.5792 11.7333 19.5875 12C19.5958 12.2667 19.5 12.5 19.3 12.7L12.7 19.3C12.6 19.4 12.4917 19.4708 12.375 19.5125C12.2583 19.5542 12.1333 19.575 12 19.575C11.8667 19.575 11.7417 19.5542 11.625 19.5125C11.5083 19.4708 11.4 19.4 11.3 19.3L4.69999 12.7C4.51665 12.5167 4.42499 12.2875 4.42499 12.0125C4.42499 11.7375 4.51665 11.5 4.69999 11.3C4.89999 11.1 5.13749 11 5.41249 11C5.68749 11 5.92499 11.1 6.12499 11.3L11 16.175Z"
  }
) }), Tme = Q("IconArrowDown")(Efe), _fe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M7.82499 13L12.725 17.9C12.925 18.1 13.0208 18.3333 13.0125 18.6C13.0042 18.8667 12.9 19.1 12.7 19.3C12.5 19.4833 12.2667 19.5792 12 19.5875C11.7333 19.5958 11.5 19.5 11.3 19.3L4.69999 12.7C4.59999 12.6 4.52915 12.4917 4.48749 12.375C4.44582 12.2583 4.42499 12.1333 4.42499 12C4.42499 11.8667 4.44582 11.7417 4.48749 11.625C4.52915 11.5083 4.59999 11.4 4.69999 11.3L11.3 4.69999C11.4833 4.51665 11.7125 4.42499 11.9875 4.42499C12.2625 4.42499 12.5 4.51665 12.7 4.69999C12.9 4.89999 13 5.13749 13 5.41249C13 5.68749 12.9 5.92499 12.7 6.12499L7.82499 11H19C19.2833 11 19.5208 11.0958 19.7125 11.2875C19.9042 11.4792 20 11.7167 20 12C20 12.2833 19.9042 12.5208 19.7125 12.7125C19.5208 12.9042 19.2833 13 19 13H7.82499Z",
    fill: "currentColor"
  }
) }), Ime = Q("IconArrowLeft")(_fe), Ofe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    fill: "currentColor",
    d: "M16.175 13H5C4.71667 13 4.47917 12.9042 4.2875 12.7125C4.09583 12.5208 4 12.2833 4 12C4 11.7167 4.09583 11.4792 4.2875 11.2875C4.47917 11.0958 4.71667 11 5 11H16.175L11.275 6.09999C11.075 5.89999 10.9792 5.66665 10.9875 5.39999C10.9958 5.13332 11.1 4.89999 11.3 4.69999C11.5 4.51665 11.7333 4.42082 12 4.41249C12.2667 4.40415 12.5 4.49999 12.7 4.69999L19.3 11.3C19.4 11.4 19.4708 11.5083 19.5125 11.625C19.5542 11.7417 19.575 11.8667 19.575 12C19.575 12.1333 19.5542 12.2583 19.5125 12.375C19.4708 12.4917 19.4 12.6 19.3 12.7L12.7 19.3C12.5167 19.4833 12.2875 19.575 12.0125 19.575C11.7375 19.575 11.5 19.4833 11.3 19.3C11.1 19.1 11 18.8625 11 18.5875C11 18.3125 11.1 18.075 11.3 17.875L16.175 13Z"
  }
) }), Dme = Q("IconArrowRight")(Ofe), Afe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    fill: "currentColor",
    d: "M11 7.82499L6.09999 12.725C5.89999 12.925 5.66665 13.0208 5.39999 13.0125C5.13332 13.0042 4.89999 12.9 4.69999 12.7C4.51665 12.5 4.42082 12.2667 4.41249 12C4.40415 11.7333 4.49999 11.5 4.69999 11.3L11.3 4.69999C11.4 4.59999 11.5083 4.52915 11.625 4.48749C11.7417 4.44582 11.8667 4.42499 12 4.42499C12.1333 4.42499 12.2583 4.44582 12.375 4.48749C12.4917 4.52915 12.6 4.59999 12.7 4.69999L19.3 11.3C19.4833 11.4833 19.575 11.7125 19.575 11.9875C19.575 12.2625 19.4833 12.5 19.3 12.7C19.1 12.9 18.8625 13 18.5875 13C18.3125 13 18.075 12.9 17.875 12.7L13 7.82499V19C13 19.2833 12.9042 19.5208 12.7125 19.7125C12.5208 19.9042 12.2833 20 12 20C11.7167 20 11.4792 19.9042 11.2875 19.7125C11.0958 19.5208 11 19.2833 11 19V7.82499Z"
  }
) }), Rme = Q("IconArrowUp")(Afe), Pfe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M12 10.8L8.10005 14.675C7.91672 14.8583 7.68755 14.9542 7.41255 14.9625C7.13755 14.9708 6.90005 14.875 6.70005 14.675C6.51672 14.4917 6.42505 14.2583 6.42505 13.975C6.42505 13.6917 6.51672 13.4583 6.70005 13.275L11.3 8.67499C11.4 8.57499 11.5084 8.50416 11.625 8.46249C11.7417 8.42083 11.8667 8.39999 12 8.39999C12.1334 8.39999 12.2584 8.42083 12.375 8.46249C12.4917 8.50416 12.6 8.57499 12.7 8.67499L17.3 13.275C17.4834 13.4583 17.5792 13.6875 17.5875 13.9625C17.5959 14.2375 17.5 14.475 17.3 14.675C17.1167 14.8583 16.8834 14.95 16.6 14.95C16.3167 14.95 16.0834 14.8583 15.9 14.675L12 10.8Z",
    fill: "currentColor"
  }
) }), V0 = Q("IconChevronUp")(Pfe), Tfe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M9 18L3 12L9 6L10.4 7.4L6.8 11H21V13H6.8L10.4 16.6L9 18Z",
    fill: "currentColor"
  }
) }), kme = Q("IconReturn")(Tfe), Ife = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M12 12C10.9 12 9.95833 11.6083 9.175 10.825C8.39167 10.0417 8 9.1 8 8C8 6.9 8.39167 5.95833 9.175 5.175C9.95833 4.39167 10.9 4 12 4C13.1 4 14.0417 4.39167 14.825 5.175C15.6083 5.95833 16 6.9 16 8C16 9.1 15.6083 10.0417 14.825 10.825C14.0417 11.6083 13.1 12 12 12ZM4 18V17.2C4 16.6333 4.14583 16.1125 4.4375 15.6375C4.72917 15.1625 5.11667 14.8 5.6 14.55C6.63333 14.0333 7.68333 13.6458 8.75 13.3875C9.81667 13.1292 10.9 13 12 13C13.1 13 14.1833 13.1292 15.25 13.3875C16.3167 13.6458 17.3667 14.0333 18.4 14.55C18.8833 14.8 19.2708 15.1625 19.5625 15.6375C19.8542 16.1125 20 16.6333 20 17.2V18C20 18.55 19.8042 19.0208 19.4125 19.4125C19.0208 19.8042 18.55 20 18 20H6C5.45 20 4.97917 19.8042 4.5875 19.4125C4.19583 19.0208 4 18.55 4 18ZM6 18H18V17.2C18 17.0167 17.9542 16.85 17.8625 16.7C17.7708 16.55 17.65 16.4333 17.5 16.35C16.6 15.9 15.6917 15.5625 14.775 15.3375C13.8583 15.1125 12.9333 15 12 15C11.0667 15 10.1417 15.1125 9.225 15.3375C8.30833 15.5625 7.4 15.9 6.5 16.35C6.35 16.4333 6.22917 16.55 6.1375 16.7C6.04583 16.85 6 17.0167 6 17.2V18ZM12 10C12.55 10 13.0208 9.80417 13.4125 9.4125C13.8042 9.02083 14 8.55 14 8C14 7.45 13.8042 6.97917 13.4125 6.5875C13.0208 6.19583 12.55 6 12 6C11.45 6 10.9792 6.19583 10.5875 6.5875C10.1958 6.97917 10 7.45 10 8C10 8.55 10.1958 9.02083 10.5875 9.4125C10.9792 9.80417 11.45 10 12 10Z",
    fill: "currentColor"
  }
) }), Dfe = Q("IconUser")(Ife), Rfe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M4 20V11C3.45 11 2.97917 10.8042 2.5875 10.4125C2.19583 10.0208 2 9.55 2 9V7C2 6.45 2.19583 5.97917 2.5875 5.5875C2.97917 5.19583 3.45 5 4 5H7.2C7.11667 4.85 7.0625 4.69167 7.0375 4.525C7.0125 4.35833 7 4.18333 7 4C7 3.16667 7.29167 2.45833 7.875 1.875C8.45833 1.29167 9.16667 1 10 1C10.3833 1 10.7417 1.07083 11.075 1.2125C11.4083 1.35417 11.7167 1.55 12 1.8C12.2833 1.53333 12.5917 1.33333 12.925 1.2C13.2583 1.06667 13.6167 1 14 1C14.8333 1 15.5417 1.29167 16.125 1.875C16.7083 2.45833 17 3.16667 17 4C17 4.18333 16.9833 4.35417 16.95 4.5125C16.9167 4.67083 16.8667 4.83333 16.8 5H20C20.55 5 21.0208 5.19583 21.4125 5.5875C21.8042 5.97917 22 6.45 22 7V9C22 9.55 21.8042 10.0208 21.4125 10.4125C21.0208 10.8042 20.55 11 20 11V20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22H6C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20ZM14 3C13.7167 3 13.4792 3.09583 13.2875 3.2875C13.0958 3.47917 13 3.71667 13 4C13 4.28333 13.0958 4.52083 13.2875 4.7125C13.4792 4.90417 13.7167 5 14 5C14.2833 5 14.5208 4.90417 14.7125 4.7125C14.9042 4.52083 15 4.28333 15 4C15 3.71667 14.9042 3.47917 14.7125 3.2875C14.5208 3.09583 14.2833 3 14 3ZM9 4C9 4.28333 9.09583 4.52083 9.2875 4.7125C9.47917 4.90417 9.71667 5 10 5C10.2833 5 10.5208 4.90417 10.7125 4.7125C10.9042 4.52083 11 4.28333 11 4C11 3.71667 10.9042 3.47917 10.7125 3.2875C10.5208 3.09583 10.2833 3 10 3C9.71667 3 9.47917 3.09583 9.2875 3.2875C9.09583 3.47917 9 3.71667 9 4ZM4 7V9H11V7H4ZM11 20V11H6V20H11ZM13 20H18V11H13V20ZM20 9V7H13V9H20Z",
    fill: "currentColor"
  }
) }), Lme = Q("IconGift")(Rfe), kfe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M5 19H6.425L16.2 9.225L14.775 7.8L5 17.575V19ZM4 21C3.71667 21 3.47917 20.9042 3.2875 20.7125C3.09583 20.5208 3 20.2833 3 20V17.575C3 17.3083 3.05 17.0542 3.15 16.8125C3.25 16.5708 3.39167 16.3583 3.575 16.175L16.2 3.575C16.4 3.39167 16.6208 3.25 16.8625 3.15C17.1042 3.05 17.3583 3 17.625 3C17.8917 3 18.15 3.05 18.4 3.15C18.65 3.25 18.8667 3.4 19.05 3.6L20.425 5C20.625 5.18333 20.7708 5.4 20.8625 5.65C20.9542 5.9 21 6.15 21 6.4C21 6.66667 20.9542 6.92083 20.8625 7.1625C20.7708 7.40417 20.625 7.625 20.425 7.825L7.825 20.425C7.64167 20.6083 7.42917 20.75 7.1875 20.85C6.94583 20.95 6.69167 21 6.425 21H4ZM15.475 8.525L14.775 7.8L16.2 9.225L15.475 8.525Z",
    fill: "currentColor"
  }
) }), Nme = Q("IconPen")(kfe), Lfe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M14 9C13.7167 9 13.4792 8.90417 13.2875 8.7125C13.0958 8.52083 13 8.28333 13 8C13 7.71667 13.0958 7.47917 13.2875 7.2875C13.4792 7.09583 13.7167 7 14 7H16V4C16 3.71667 16.0958 3.47917 16.2875 3.2875C16.4792 3.09583 16.7167 3 17 3C17.2833 3 17.5208 3.09583 17.7125 3.2875C17.9042 3.47917 18 3.71667 18 4V7H20C20.2833 7 20.5208 7.09583 20.7125 7.2875C20.9042 7.47917 21 7.71667 21 8C21 8.28333 20.9042 8.52083 20.7125 8.7125C20.5208 8.90417 20.2833 9 20 9H14ZM17 21C16.7167 21 16.4792 20.9042 16.2875 20.7125C16.0958 20.5208 16 20.2833 16 20V12C16 11.7167 16.0958 11.4792 16.2875 11.2875C16.4792 11.0958 16.7167 11 17 11C17.2833 11 17.5208 11.0958 17.7125 11.2875C17.9042 11.4792 18 11.7167 18 12V20C18 20.2833 17.9042 20.5208 17.7125 20.7125C17.5208 20.9042 17.2833 21 17 21ZM7 21C6.71667 21 6.47917 20.9042 6.2875 20.7125C6.09583 20.5208 6 20.2833 6 20V17H4C3.71667 17 3.47917 16.9042 3.2875 16.7125C3.09583 16.5208 3 16.2833 3 16C3 15.7167 3.09583 15.4792 3.2875 15.2875C3.47917 15.0958 3.71667 15 4 15H10C10.2833 15 10.5208 15.0958 10.7125 15.2875C10.9042 15.4792 11 15.7167 11 16C11 16.2833 10.9042 16.5208 10.7125 16.7125C10.5208 16.9042 10.2833 17 10 17H8V20C8 20.2833 7.90417 20.5208 7.7125 20.7125C7.52083 20.9042 7.28333 21 7 21ZM7 13C6.71667 13 6.47917 12.9042 6.2875 12.7125C6.09583 12.5208 6 12.2833 6 12V4C6 3.71667 6.09583 3.47917 6.2875 3.2875C6.47917 3.09583 6.71667 3 7 3C7.28333 3 7.52083 3.09583 7.7125 3.2875C7.90417 3.47917 8 3.71667 8 4V12C8 12.2833 7.90417 12.5208 7.7125 12.7125C7.52083 12.9042 7.28333 13 7 13Z",
    fill: "currentColor"
  }
) }), Fme = Q("IconDiscoverTune")(Lfe), Nfe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M4 21C3.45 21 2.97917 20.8042 2.5875 20.4125C2.19583 20.0208 2 19.55 2 19V10C2 9.68333 2.07083 9.38333 2.2125 9.1C2.35417 8.81667 2.55 8.58333 2.8 8.4L8.8 3.9C8.98333 3.76667 9.175 3.66667 9.375 3.6C9.575 3.53333 9.78333 3.5 10 3.5C10.2167 3.5 10.425 3.53333 10.625 3.6C10.825 3.66667 11.0167 3.76667 11.2 3.9L13.925 5.95C14.1917 6.15 14.3292 6.3875 14.3375 6.6625C14.3458 6.9375 14.275 7.175 14.125 7.375C13.975 7.575 13.7708 7.70417 13.5125 7.7625C13.2542 7.82083 12.9833 7.75 12.7 7.55L10 5.5L4 10V19H7C7.28333 19 7.52083 19.0958 7.7125 19.2875C7.90417 19.4792 8 19.7167 8 20C8 20.2833 7.90417 20.5208 7.7125 20.7125C7.52083 20.9042 7.28333 21 7 21H4ZM16 16C16.9 16 17.7708 16.1167 18.6125 16.35C19.4542 16.5833 20.2583 16.925 21.025 17.375C21.325 17.5583 21.5625 17.8042 21.7375 18.1125C21.9125 18.4208 22 18.75 22 19.1C22 19.6333 21.8167 20.0833 21.45 20.45C21.0833 20.8167 20.6333 21 20.1 21H11.9C11.3667 21 10.9167 20.8167 10.55 20.45C10.1833 20.0833 10 19.6333 10 19.1C10 18.75 10.0875 18.4208 10.2625 18.1125C10.4375 17.8042 10.675 17.5583 10.975 17.375C11.7417 16.925 12.5458 16.5833 13.3875 16.35C14.2292 16.1167 15.1 16 16 16ZM12.15 19H19.85C19.2667 18.6667 18.65 18.4167 18 18.25C17.35 18.0833 16.6833 18 16 18C15.3167 18 14.65 18.0833 14 18.25C13.35 18.4167 12.7333 18.6667 12.15 19ZM16 15C15.1667 15 14.4583 14.7083 13.875 14.125C13.2917 13.5417 13 12.8333 13 12C13 11.1667 13.2917 10.4583 13.875 9.875C14.4583 9.29167 15.1667 9 16 9C16.8333 9 17.5417 9.29167 18.125 9.875C18.7083 10.4583 19 11.1667 19 12C19 12.8333 18.7083 13.5417 18.125 14.125C17.5417 14.7083 16.8333 15 16 15ZM16 13C16.2833 13 16.5208 12.9042 16.7125 12.7125C16.9042 12.5208 17 12.2833 17 12C17 11.7167 16.9042 11.4792 16.7125 11.2875C16.5208 11.0958 16.2833 11 16 11C15.7167 11 15.4792 11.0958 15.2875 11.2875C15.0958 11.4792 15 11.7167 15 12C15 12.2833 15.0958 12.5208 15.2875 12.7125C15.4792 12.9042 15.7167 13 16 13Z",
    fill: "currentColor"
  }
) }), Vme = Q("IconLocationAway")(Nfe), Ffe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M13.2 3.9L19.2 8.4C19.45 8.58333 19.6458 8.81667 19.7875 9.1C19.9292 9.38333 20 9.68333 20 10V19C20 19.55 19.8042 20.0208 19.4125 20.4125C19.0208 20.8042 18.55 21 18 21H6C5.45 21 4.97917 20.8042 4.5875 20.4125C4.19583 20.0208 4 19.55 4 19V10C4 9.68333 4.07083 9.38333 4.2125 9.1C4.35417 8.81667 4.55 8.58333 4.8 8.4L10.8 3.9C11.15 3.63333 11.55 3.5 12 3.5C12.45 3.5 12.85 3.63333 13.2 3.9ZM12 15C12.8333 15 13.5417 14.7083 14.125 14.125C14.7083 13.5417 15 12.8333 15 12C15 11.1667 14.7083 10.4583 14.125 9.875C13.5417 9.29167 12.8333 9 12 9C11.1667 9 10.4583 9.29167 9.875 9.875C9.29167 10.4583 9 11.1667 9 12C9 12.8333 9.29167 13.5417 9.875 14.125C10.4583 14.7083 11.1667 15 12 15ZM12 13C11.7167 13 11.4792 12.9042 11.2875 12.7125C11.0958 12.5208 11 12.2833 11 12C11 11.7167 11.0958 11.4792 11.2875 11.2875C11.4792 11.0958 11.7167 11 12 11C12.2833 11 12.5208 11.0958 12.7125 11.2875C12.9042 11.4792 13 11.7167 13 12C13 12.2833 12.9042 12.5208 12.7125 12.7125C12.5208 12.9042 12.2833 13 12 13ZM12 18C11.3167 18 10.65 18.0833 10 18.25C9.35 18.4167 8.73333 18.6667 8.15 19H15.85C15.2667 18.6667 14.65 18.4167 14 18.25C13.35 18.0833 12.6833 18 12 18ZM6 10V18C6.86667 17.35 7.80833 16.8542 8.825 16.5125C9.84167 16.1708 10.9 16 12 16C13.1 16 14.1583 16.1708 15.175 16.5125C16.1917 16.8542 17.1333 17.35 18 18V10L12 5.5L6 10Z",
    fill: "currentColor"
  }
) }), Bme = Q("IconLocationHome")(Ffe), Vfe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M9 20C8.68333 20 8.38333 19.9292 8.1 19.7875C7.81667 19.6458 7.58333 19.45 7.4 19.2L2.9 13.2C2.63333 12.85 2.5 12.45 2.5 12C2.5 11.55 2.63333 11.15 2.9 10.8L7.4 4.8C7.58333 4.55 7.81667 4.35417 8.1 4.2125C8.38333 4.07083 8.68333 4 9 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H9ZM9 18H20V6H9L4.5 12L9 18ZM10 13C10.2833 13 10.5208 12.9042 10.7125 12.7125C10.9042 12.5208 11 12.2833 11 12C11 11.7167 10.9042 11.4792 10.7125 11.2875C10.5208 11.0958 10.2833 11 10 11C9.71667 11 9.47917 11.0958 9.2875 11.2875C9.09583 11.4792 9 11.7167 9 12C9 12.2833 9.09583 12.5208 9.2875 12.7125C9.47917 12.9042 9.71667 13 10 13ZM13.5 13C13.7833 13 14.0208 12.9042 14.2125 12.7125C14.4042 12.5208 14.5 12.2833 14.5 12C14.5 11.7167 14.4042 11.4792 14.2125 11.2875C14.0208 11.0958 13.7833 11 13.5 11C13.2167 11 12.9792 11.0958 12.7875 11.2875C12.5958 11.4792 12.5 11.7167 12.5 12C12.5 12.2833 12.5958 12.5208 12.7875 12.7125C12.9792 12.9042 13.2167 13 13.5 13ZM17 13C17.2833 13 17.5208 12.9042 17.7125 12.7125C17.9042 12.5208 18 12.2833 18 12C18 11.7167 17.9042 11.4792 17.7125 11.2875C17.5208 11.0958 17.2833 11 17 11C16.7167 11 16.4792 11.0958 16.2875 11.2875C16.0958 11.4792 16 11.7167 16 12C16 12.2833 16.0958 12.5208 16.2875 12.7125C16.4792 12.9042 16.7167 13 17 13Z",
    fill: "currentColor"
  }
) }), $me = Q("IconMore")(Vfe), Bfe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M6 14C5.45 14 4.97917 13.8042 4.5875 13.4125C4.19583 13.0208 4 12.55 4 12C4 11.45 4.19583 10.9792 4.5875 10.5875C4.97917 10.1958 5.45 10 6 10C6.55 10 7.02083 10.1958 7.4125 10.5875C7.80417 10.9792 8 11.45 8 12C8 12.55 7.80417 13.0208 7.4125 13.4125C7.02083 13.8042 6.55 14 6 14ZM12 14C11.45 14 10.9792 13.8042 10.5875 13.4125C10.1958 13.0208 10 12.55 10 12C10 11.45 10.1958 10.9792 10.5875 10.5875C10.9792 10.1958 11.45 10 12 10C12.55 10 13.0208 10.1958 13.4125 10.5875C13.8042 10.9792 14 11.45 14 12C14 12.55 13.8042 13.0208 13.4125 13.4125C13.0208 13.8042 12.55 14 12 14ZM18 14C17.45 14 16.9792 13.8042 16.5875 13.4125C16.1958 13.0208 16 12.55 16 12C16 11.45 16.1958 10.9792 16.5875 10.5875C16.9792 10.1958 17.45 10 18 10C18.55 10 19.0208 10.1958 19.4125 10.5875C19.8042 10.9792 20 11.45 20 12C20 12.55 19.8042 13.0208 19.4125 13.4125C19.0208 13.8042 18.55 14 18 14Z",
    fill: "currentColor"
  }
) }), jme = Q("IconMoreHoriz")(Bfe), $fe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M12 20C11.45 20 10.9792 19.8042 10.5875 19.4125C10.1958 19.0208 10 18.55 10 18C10 17.45 10.1958 16.9792 10.5875 16.5875C10.9792 16.1958 11.45 16 12 16C12.55 16 13.0208 16.1958 13.4125 16.5875C13.8042 16.9792 14 17.45 14 18C14 18.55 13.8042 19.0208 13.4125 19.4125C13.0208 19.8042 12.55 20 12 20ZM12 14C11.45 14 10.9792 13.8042 10.5875 13.4125C10.1958 13.0208 10 12.55 10 12C10 11.45 10.1958 10.9792 10.5875 10.5875C10.9792 10.1958 11.45 10 12 10C12.55 10 13.0208 10.1958 13.4125 10.5875C13.8042 10.9792 14 11.45 14 12C14 12.55 13.8042 13.0208 13.4125 13.4125C13.0208 13.8042 12.55 14 12 14ZM12 8C11.45 8 10.9792 7.80417 10.5875 7.4125C10.1958 7.02083 10 6.55 10 6C10 5.45 10.1958 4.97917 10.5875 4.5875C10.9792 4.19583 11.45 4 12 4C12.55 4 13.0208 4.19583 13.4125 4.5875C13.8042 4.97917 14 5.45 14 6C14 6.55 13.8042 7.02083 13.4125 7.4125C13.0208 7.80417 12.55 8 12 8Z",
    fill: "currentColor"
  }
) }), Hme = Q("IconMoreVert")($fe), jfe = (e) => /* @__PURE__ */ F("svg", { viewBox: "0 0 20 20", ...e, children: [
  /* @__PURE__ */ d(
    "mask",
    {
      id: "mask0_7031_18343",
      style: { maskType: "alpha" },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "0",
      width: "20",
      height: "20",
      children: /* @__PURE__ */ d("rect", { width: "20", height: "20", fill: "currentColor" })
    }
  ),
  /* @__PURE__ */ d("g", { mask: "url(#mask0_7031_18343)", children: /* @__PURE__ */ d(
    "path",
    {
      d: "M10.75 9.375V5.75C10.75 5.5375 10.6785 5.35937 10.5356 5.21562C10.3927 5.07187 10.2156 5 10.0044 5C9.79313 5 9.61458 5.07187 9.46875 5.21562C9.32292 5.35937 9.25 5.5375 9.25 5.75V9.6875C9.25 9.79861 9.27083 9.89931 9.3125 9.98958C9.35417 10.0799 9.40972 10.1597 9.47917 10.2292L12.2677 13.0177C12.4226 13.1726 12.6007 13.2465 12.8021 13.2396C13.0035 13.2326 13.1806 13.1528 13.3333 13C13.4861 12.8472 13.5625 12.6701 13.5625 12.4688C13.5625 12.2674 13.4838 12.0885 13.3263 11.9323L10.75 9.375ZM10 18C8.8975 18 7.86146 17.7917 6.89188 17.375C5.92229 16.9583 5.07292 16.3854 4.34375 15.6562C3.61458 14.9271 3.04167 14.0767 2.625 13.105C2.20833 12.1333 2 11.0951 2 9.99042C2 8.88569 2.20833 7.84722 2.625 6.875C3.04167 5.90278 3.61458 5.05556 4.34375 4.33333C5.07292 3.61111 5.92333 3.04167 6.895 2.625C7.86667 2.20833 8.90486 2 10.0096 2C11.1143 2 12.1528 2.21 13.1252 2.63C14.0974 3.05 14.9432 3.62 15.6625 4.34C16.3817 5.06 16.951 5.90667 17.3706 6.88C17.7902 7.85333 18 8.89333 18 10C18 11.1025 17.7917 12.1385 17.375 13.1081C16.9583 14.0777 16.3889 14.9271 15.6667 15.6562C14.9444 16.3854 14.0963 16.9583 13.1223 17.375C12.1483 17.7917 11.1075 18 10 18ZM10.01 16.5C11.8082 16.5 13.3394 15.8646 14.6038 14.5938C15.8679 13.3229 16.5 11.7883 16.5 9.99C16.5 8.19181 15.8679 6.66056 14.6038 5.39625C13.3394 4.13208 11.8082 3.5 10.01 3.5C8.21167 3.5 6.67708 4.13208 5.40625 5.39625C4.13542 6.66056 3.5 8.19181 3.5 9.99C3.5 11.7883 4.13542 13.3229 5.40625 14.5938C6.67708 15.8646 8.21167 16.5 10.01 16.5Z",
      fill: "currentColor"
    }
  ) })
] }), zme = Q("IconClock")(jfe), Hfe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    fill: "currentColor",
    d: "m12 18-4.2 1.8c-.667.283-1.3.23-1.9-.163-.6-.391-.9-.945-.9-1.662V5c0-.55.196-1.02.588-1.413A1.926 1.926 0 0 1 7 3h10c.55 0 1.02.196 1.413.587C18.803 3.98 19 4.45 19 5v12.975c0 .717-.3 1.27-.9 1.662-.6.392-1.233.446-1.9.163L12 18Zm0-2.2 5 2.15V5H7v12.95l5-2.15Z"
  }
) }), Zme = Q("IconBookmark")(Hfe), zfe = (e) => /* @__PURE__ */ F("svg", { viewBox: "0 0 24 24", ...e, children: [
  /* @__PURE__ */ d(
    "path",
    {
      d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M15.8 9.2a2.5 2.5 0 0 0-3.5 0l-.3.4-.35-.3a2.42 2.42 0 1 0-3.2 3.6l3.6 3.5 3.6-3.5c1.2-1.2 1.1-2.7.2-3.7",
      fill: "currentColor"
    }
  )
] }), Wme = Q("IconMessageCircleHeart")(zfe), Zfe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 16 16", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M15.75 15.4504C15.65 15.4504 15.5562 15.4316 15.4687 15.3941C15.3812 15.3566 15.3 15.3004 15.225 15.2254L13.5 13.5004H6C5.5875 13.5004 5.23437 13.3535 4.94062 13.0597C4.64687 12.766 4.5 12.4129 4.5 12.0004V11.2504H12.75C13.1625 11.2504 13.5156 11.1035 13.8094 10.8097C14.1031 10.516 14.25 10.1629 14.25 9.75037V4.50037H15C15.4125 4.50037 15.7656 4.64724 16.0594 4.94099C16.3531 5.23474 16.5 5.58787 16.5 6.00037V14.6816C16.5 14.9066 16.425 15.091 16.275 15.2347C16.125 15.3785 15.95 15.4504 15.75 15.4504ZM3 9.13162L3.88125 8.25037H11.25V3.00037H3V9.13162ZM2.25 11.7004C2.05 11.7004 1.875 11.6285 1.725 11.4847C1.575 11.341 1.5 11.1566 1.5 10.9316V3.00037C1.5 2.58787 1.64687 2.23474 1.94062 1.94099C2.23437 1.64724 2.5875 1.50037 3 1.50037H11.25C11.6625 1.50037 12.0156 1.64724 12.3094 1.94099C12.6031 2.23474 12.75 2.58787 12.75 3.00037V8.25037C12.75 8.66287 12.6031 9.01599 12.3094 9.30974C12.0156 9.60349 11.6625 9.75037 11.25 9.75037H4.5L2.775 11.4754C2.7 11.5504 2.61875 11.6066 2.53125 11.6441C2.44375 11.6816 2.35 11.7004 2.25 11.7004Z",
    fill: "currentColor"
  }
) }), qme = Q("IconForum")(Zfe), Wfe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 18 18", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M4.04995 16.2C3.6787 16.2 3.36089 16.0678 3.09651 15.8034C2.83214 15.539 2.69995 15.2212 2.69995 14.8499V12.2062C2.69995 12.0312 2.72808 11.8718 2.78433 11.7281C2.84058 11.5843 2.92495 11.45 3.03745 11.325L4.4437 9.71245C4.5662 9.5732 4.72495 9.50089 4.91995 9.49551C5.11495 9.49014 5.28095 9.55595 5.41795 9.69295C5.54345 9.81845 5.60933 9.96558 5.61558 10.1343C5.62183 10.3031 5.5687 10.4562 5.4562 10.5937L4.49995 11.7H13.5L12.375 10.4062C12.2625 10.2687 12.2093 10.1125 12.2156 9.93745C12.2218 9.76245 12.2877 9.6122 12.4132 9.4867C12.5502 9.3497 12.7125 9.28433 12.9 9.29058C13.0875 9.29683 13.25 9.37495 13.3875 9.52495L14.9625 11.325C15.0625 11.45 15.1437 11.5875 15.2062 11.7375C15.2687 11.8875 15.3 12.0436 15.3 12.206V14.8499C15.3 15.2212 15.1678 15.539 14.9034 15.8034C14.639 16.0678 14.3212 16.2 13.95 16.2H4.04995ZM4.04995 14.8499H13.95V13.05H4.04995V14.8499ZM8.1937 10.5375L5.66245 8.0062C5.48745 7.8312 5.39995 7.62183 5.39995 7.37808C5.39995 7.13433 5.48745 6.92495 5.66245 6.74995L9.44995 2.96245C9.62495 2.78745 9.83433 2.69995 10.0781 2.69995C10.3218 2.69995 10.5312 2.78745 10.7062 2.96245L13.2375 5.4937C13.4125 5.6687 13.5 5.87808 13.5 6.12183C13.5 6.36558 13.4125 6.57495 13.2375 6.74995L9.44995 10.5375C9.27495 10.7125 9.06558 10.8 8.82183 10.8C8.57808 10.8 8.3687 10.7125 8.1937 10.5375ZM11.9625 6.11245L10.0875 4.23745L6.93745 7.38745L8.81245 9.26245L11.9625 6.11245Z",
    fill: "currentColor"
  }
) }), Ume = Q("IconVote")(Wfe), qfe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M5 11C4.45 11 3.97917 10.8042 3.5875 10.4125C3.19583 10.0208 3 9.55 3 9V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H9C9.55 3 10.0208 3.19583 10.4125 3.5875C10.8042 3.97917 11 4.45 11 5V9C11 9.55 10.8042 10.0208 10.4125 10.4125C10.0208 10.8042 9.55 11 9 11H5ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V15C3 14.45 3.19583 13.9792 3.5875 13.5875C3.97917 13.1958 4.45 13 5 13H9C9.55 13 10.0208 13.1958 10.4125 13.5875C10.8042 13.9792 11 14.45 11 15V19C11 19.55 10.8042 20.0208 10.4125 20.4125C10.0208 20.8042 9.55 21 9 21H5ZM15 11C14.45 11 13.9792 10.8042 13.5875 10.4125C13.1958 10.0208 13 9.55 13 9V5C13 4.45 13.1958 3.97917 13.5875 3.5875C13.9792 3.19583 14.45 3 15 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V9C21 9.55 20.8042 10.0208 20.4125 10.4125C20.0208 10.8042 19.55 11 19 11H15ZM15 21C14.45 21 13.9792 20.8042 13.5875 20.4125C13.1958 20.0208 13 19.55 13 19V15C13 14.45 13.1958 13.9792 13.5875 13.5875C13.9792 13.1958 14.45 13 15 13H19C19.55 13 20.0208 13.1958 20.4125 13.5875C20.8042 13.9792 21 14.45 21 15V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H15ZM5 9H9V5H5V9ZM15 9H19V5H15V9ZM15 19H19V15H15V19ZM5 19H9V15H5V19Z",
    fill: "currentColor"
  }
) }), Gme = Q("IconDashboard")(qfe), Ufe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M8 11.75V7.5C8 7.08333 8.14583 6.72917 8.4375 6.4375C8.72917 6.14583 9.08333 6 9.5 6C9.91667 6 10.2708 6.14583 10.5625 6.4375C10.8542 6.72917 11 7.08333 11 7.5V11.75C11 12.1667 10.8542 12.5208 10.5625 12.8125C10.2708 13.1042 9.91667 13.25 9.5 13.25C9.08333 13.25 8.72917 13.1042 8.4375 12.8125C8.14583 12.5208 8 12.1667 8 11.75ZM13 11.525V3.5C13 3.08333 13.1458 2.72917 13.4375 2.4375C13.7292 2.14583 14.0833 2 14.5 2C14.9167 2 15.2708 2.14583 15.5625 2.4375C15.8542 2.72917 16 3.08333 16 3.5V11.525C16 12.025 15.8458 12.4 15.5375 12.65C15.2292 12.9 14.8833 13.025 14.5 13.025C14.1167 13.025 13.7708 12.9 13.4625 12.65C13.1542 12.4 13 12.025 13 11.525ZM3 14.975V11.5C3 11.0833 3.14583 10.7292 3.4375 10.4375C3.72917 10.1458 4.08333 10 4.5 10C4.91667 10 5.27083 10.1458 5.5625 10.4375C5.85417 10.7292 6 11.0833 6 11.5V14.975C6 15.475 5.84583 15.85 5.5375 16.1C5.22917 16.35 4.88333 16.475 4.5 16.475C4.11667 16.475 3.77083 16.35 3.4625 16.1C3.15417 15.85 3 15.475 3 14.975ZM5.4 21.05C4.96667 21.05 4.6625 20.8458 4.4875 20.4375C4.3125 20.0292 4.38333 19.6667 4.7 19.35L8.8 15.25C8.98333 15.0667 9.20417 14.9667 9.4625 14.95C9.72083 14.9333 9.95 15.0167 10.15 15.2L13 17.65L18.6 12.05H18C17.7167 12.05 17.4792 11.9542 17.2875 11.7625C17.0958 11.5708 17 11.3333 17 11.05C17 10.7667 17.0958 10.5292 17.2875 10.3375C17.4792 10.1458 17.7167 10.05 18 10.05H21C21.2833 10.05 21.5208 10.1458 21.7125 10.3375C21.9042 10.5292 22 10.7667 22 11.05V14.05C22 14.3333 21.9042 14.5708 21.7125 14.7625C21.5208 14.9542 21.2833 15.05 21 15.05C20.7167 15.05 20.4792 14.9542 20.2875 14.7625C20.0958 14.5708 20 14.3333 20 14.05V13.45L13.75 19.7C13.5667 19.8833 13.3458 19.9833 13.0875 20C12.8292 20.0167 12.6 19.9333 12.4 19.75L9.55 17.3L6.1 20.75C6.01667 20.8333 5.9125 20.9042 5.7875 20.9625C5.6625 21.0208 5.53333 21.05 5.4 21.05Z",
    fill: "currentColor"
  }
) }), Kme = Q("IconEconomy")(Ufe), Gfe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H9.2C9.41667 2.4 9.77917 1.91667 10.2875 1.55C10.7958 1.18333 11.3667 1 12 1C12.6333 1 13.2042 1.18333 13.7125 1.55C14.2208 1.91667 14.5833 2.4 14.8 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM5 19H19V5H5V19ZM8 17H13C13.2833 17 13.5208 16.9042 13.7125 16.7125C13.9042 16.5208 14 16.2833 14 16C14 15.7167 13.9042 15.4792 13.7125 15.2875C13.5208 15.0958 13.2833 15 13 15H8C7.71667 15 7.47917 15.0958 7.2875 15.2875C7.09583 15.4792 7 15.7167 7 16C7 16.2833 7.09583 16.5208 7.2875 16.7125C7.47917 16.9042 7.71667 17 8 17ZM8 13H16C16.2833 13 16.5208 12.9042 16.7125 12.7125C16.9042 12.5208 17 12.2833 17 12C17 11.7167 16.9042 11.4792 16.7125 11.2875C16.5208 11.0958 16.2833 11 16 11H8C7.71667 11 7.47917 11.0958 7.2875 11.2875C7.09583 11.4792 7 11.7167 7 12C7 12.2833 7.09583 12.5208 7.2875 12.7125C7.47917 12.9042 7.71667 13 8 13ZM8 9H16C16.2833 9 16.5208 8.90417 16.7125 8.7125C16.9042 8.52083 17 8.28333 17 8C17 7.71667 16.9042 7.47917 16.7125 7.2875C16.5208 7.09583 16.2833 7 16 7H8C7.71667 7 7.47917 7.09583 7.2875 7.2875C7.09583 7.47917 7 7.71667 7 8C7 8.28333 7.09583 8.52083 7.2875 8.7125C7.47917 8.90417 7.71667 9 8 9ZM12 4.25C12.2167 4.25 12.3958 4.17917 12.5375 4.0375C12.6792 3.89583 12.75 3.71667 12.75 3.5C12.75 3.28333 12.6792 3.10417 12.5375 2.9625C12.3958 2.82083 12.2167 2.75 12 2.75C11.7833 2.75 11.6042 2.82083 11.4625 2.9625C11.3208 3.10417 11.25 3.28333 11.25 3.5C11.25 3.71667 11.3208 3.89583 11.4625 4.0375C11.6042 4.17917 11.7833 4.25 12 4.25Z",
    fill: "currentColor"
  }
) }), Yme = Q("IconBoardwork")(Gfe), Kfe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M6 18L3.7 20.3C3.38333 20.6167 3.02083 20.6875 2.6125 20.5125C2.20417 20.3375 2 20.025 2 19.575V4C2 3.45 2.19583 2.97917 2.5875 2.5875C2.97917 2.19583 3.45 2 4 2H20C20.55 2 21.0208 2.19583 21.4125 2.5875C21.8042 2.97917 22 3.45 22 4V16C22 16.55 21.8042 17.0208 21.4125 17.4125C21.0208 17.8042 20.55 18 20 18H6ZM5.15 16H20V4H4V17.125L5.15 16Z",
    fill: "currentColor"
  }
) }), Xme = Q("IconCommunication")(Kfe), Yfe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M23 5V19C23 19.55 22.8042 20.0208 22.4125 20.4125C22.0208 20.8042 21.55 21 21 21H18C17.7167 21 17.4792 20.9042 17.2875 20.7125C17.0958 20.5208 17 20.2833 17 20C17 19.7167 17.0958 19.4792 17.2875 19.2875C17.4792 19.0958 17.7167 19 18 19H21V5H12V5.5C12 5.78333 11.9042 6.02083 11.7125 6.2125C11.5208 6.40417 11.2833 6.5 11 6.5C10.7167 6.5 10.4792 6.40417 10.2875 6.2125C10.0958 6.02083 10 5.78333 10 5.5V4.95C10 4.41667 10.1917 3.95833 10.575 3.575C10.9583 3.19167 11.4167 3 11.95 3H21C21.55 3 22.0208 3.19583 22.4125 3.5875C22.8042 3.97917 23 4.45 23 5ZM1 12.025C1 11.6917 1.075 11.3833 1.225 11.1C1.375 10.8167 1.58333 10.5833 1.85 10.4L6.85 6.825C7.03333 6.69167 7.22083 6.59583 7.4125 6.5375C7.60417 6.47917 7.8 6.45 8 6.45C8.2 6.45 8.39583 6.47917 8.5875 6.5375C8.77917 6.59583 8.96667 6.69167 9.15 6.825L14.15 10.4C14.4167 10.5833 14.625 10.8167 14.775 11.1C14.925 11.3833 15 11.6917 15 12.025V19C15 19.55 14.8042 20.0208 14.4125 20.4125C14.0208 20.8042 13.55 21 13 21H11C10.45 21 9.97917 20.8042 9.5875 20.4125C9.19583 20.0208 9 19.55 9 19V16H7V19C7 19.55 6.80417 20.0208 6.4125 20.4125C6.02083 20.8042 5.55 21 5 21H3C2.45 21 1.97917 20.8042 1.5875 20.4125C1.19583 20.0208 1 19.55 1 19V12.025ZM3 12V19H5V16C5 15.45 5.19583 14.9792 5.5875 14.5875C5.97917 14.1958 6.45 14 7 14H9C9.55 14 10.0208 14.1958 10.4125 14.5875C10.8042 14.9792 11 15.45 11 16V19H13V12L8 8.45L3 12ZM17.5 9H18.5C18.6333 9 18.75 8.95 18.85 8.85C18.95 8.75 19 8.63333 19 8.5V7.5C19 7.36667 18.95 7.25 18.85 7.15C18.75 7.05 18.6333 7 18.5 7H17.5C17.3667 7 17.25 7.05 17.15 7.15C17.05 7.25 17 7.36667 17 7.5V8.5C17 8.63333 17.05 8.75 17.15 8.85C17.25 8.95 17.3667 9 17.5 9ZM17.5 13H18.5C18.6333 13 18.75 12.95 18.85 12.85C18.95 12.75 19 12.6333 19 12.5V11.5C19 11.3667 18.95 11.25 18.85 11.15C18.75 11.05 18.6333 11 18.5 11H17.5C17.3667 11 17.25 11.05 17.15 11.15C17.05 11.25 17 11.3667 17 11.5V12.5C17 12.6333 17.05 12.75 17.15 12.85C17.25 12.95 17.3667 13 17.5 13ZM17.5 17H18.5C18.6333 17 18.75 16.95 18.85 16.85C18.95 16.75 19 16.6333 19 16.5V15.5C19 15.3667 18.95 15.25 18.85 15.15C18.75 15.05 18.6333 15 18.5 15H17.5C17.3667 15 17.25 15.05 17.15 15.15C17.05 15.25 17 15.3667 17 15.5V16.5C17 16.6333 17.05 16.75 17.15 16.85C17.25 16.95 17.3667 17 17.5 17Z",
    fill: "currentColor"
  }
) }), Xfe = Q("IconHousingAssociation")(Yfe), Qfe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M2 19V5C2 4.45 2.19583 3.97917 2.5875 3.5875C2.97917 3.19583 3.45 3 4 3H10C10.55 3 11.0208 3.19583 11.4125 3.5875C11.8042 3.97917 12 4.45 12 5V7H20C20.55 7 21.0208 7.19583 21.4125 7.5875C21.8042 7.97917 22 8.45 22 9V19C22 19.55 21.8042 20.0208 21.4125 20.4125C21.0208 20.8042 20.55 21 20 21H4C3.45 21 2.97917 20.8042 2.5875 20.4125C2.19583 20.0208 2 19.55 2 19ZM4 19H6V17H4V19ZM4 15H6V13H4V15ZM4 11H6V9H4V11ZM4 7H6V5H4V7ZM8 19H10V17H8V19ZM8 15H10V13H8V15ZM8 11H10V9H8V11ZM8 7H10V5H8V7ZM12 19H20V9H12V11H14V13H12V15H14V17H12V19ZM16 13V11H18V13H16ZM16 17V15H18V17H16Z",
    fill: "currentColor"
  }
) }), Qme = Q("IconHousingCooperative")(Qfe), Jfe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M12 20C11.0667 20 10.1875 19.8542 9.3625 19.5625C8.5375 19.2708 7.78333 18.8583 7.1 18.325L5.7 19.7C5.51667 19.8833 5.28333 19.975 5 19.975C4.71667 19.975 4.48333 19.8833 4.3 19.7C4.11667 19.5167 4.025 19.2833 4.025 19C4.025 18.7167 4.11667 18.4833 4.3 18.3L5.675 16.925C5.14167 16.2417 4.72917 15.4833 4.4375 14.65C4.14583 13.8167 4 12.9333 4 12C4 9.76667 4.775 7.875 6.325 6.325C7.875 4.775 9.76667 4 12 4H18C18.55 4 19.0208 4.19583 19.4125 4.5875C19.8042 4.97917 20 5.45 20 6V12C20 14.2333 19.225 16.125 17.675 17.675C16.125 19.225 14.2333 20 12 20ZM12 18C13.6667 18 15.0833 17.4167 16.25 16.25C17.4167 15.0833 18 13.6667 18 12V6H12C10.3333 6 8.91667 6.58333 7.75 7.75C6.58333 8.91667 6 10.3333 6 12C6 12.65 6.1 13.2708 6.3 13.8625C6.5 14.4542 6.775 14.9917 7.125 15.475L12.3 10.3C12.4833 10.1167 12.7167 10.025 13 10.025C13.2833 10.025 13.5167 10.1167 13.7 10.3C13.9 10.5 14 10.7375 14 11.0125C14 11.2875 13.9 11.525 13.7 11.725L8.525 16.9C9.00833 17.25 9.54583 17.5208 10.1375 17.7125C10.7292 17.9042 11.35 18 12 18Z",
    fill: "currentColor"
  }
) }), Jme = Q("IconSustainability")(Jfe), ede = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M11 20C10.45 20 9.97919 19.8042 9.58753 19.4125C9.19586 19.0209 9.00003 18.55 9.00003 18V16C9.00003 15.45 9.19586 14.9792 9.58753 14.5875C9.97919 14.1959 10.45 14 11 14H13C13.55 14 14.0209 14.1959 14.4125 14.5875C14.8042 14.9792 15 15.45 15 16V18C15 18.55 14.8042 19.0209 14.4125 19.4125C14.0209 19.8042 13.55 20 13 20H11ZM11 18H13V16H11V18ZM3.00002 12.4C2.76669 12.5667 2.51669 12.6334 2.25002 12.6C1.98336 12.5667 1.76669 12.4334 1.60002 12.2C1.43336 11.9667 1.37086 11.7167 1.41252 11.45C1.45419 11.1834 1.58336 10.9667 1.80002 10.8L10.775 3.92502C10.9584 3.79169 11.1542 3.69169 11.3625 3.62502C11.5709 3.55836 11.7834 3.52502 12 3.52502C12.2167 3.52502 12.4292 3.55836 12.6375 3.62502C12.8459 3.69169 13.0417 3.79169 13.225 3.92502L16 6.05002V5.50002C16 5.08336 16.1459 4.72919 16.4375 4.43752C16.7292 4.14586 17.0834 4.00002 17.5 4.00002C17.9167 4.00002 18.2709 4.14586 18.5625 4.43752C18.8542 4.72919 19 5.08336 19 5.50002V8.35002L22.225 10.8C22.4417 10.9667 22.5667 11.1834 22.6 11.45C22.6334 11.7167 22.5667 11.9667 22.4 12.2C22.2334 12.4334 22.0167 12.5667 21.75 12.6C21.4834 12.6334 21.2334 12.5667 21 12.4L12 5.52502L3.00002 12.4Z",
    fill: "currentColor"
  }
) }), ege = Q("IconHousing")(ede), tde = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M5.85 17.1C6.7 16.45 7.65 15.9375 8.7 15.5625C9.75 15.1875 10.85 15 12 15C13.15 15 14.25 15.1875 15.3 15.5625C16.35 15.9375 17.3 16.45 18.15 17.1C18.7333 16.4167 19.1875 15.6417 19.5125 14.775C19.8375 13.9083 20 12.9833 20 12C20 9.78333 19.2208 7.89583 17.6625 6.3375C16.1042 4.77917 14.2167 4 12 4C9.78333 4 7.89583 4.77917 6.3375 6.3375C4.77917 7.89583 4 9.78333 4 12C4 12.9833 4.1625 13.9083 4.4875 14.775C4.8125 15.6417 5.26667 16.4167 5.85 17.1ZM12 13C11.0167 13 10.1875 12.6625 9.5125 11.9875C8.8375 11.3125 8.5 10.4833 8.5 9.5C8.5 8.51667 8.8375 7.6875 9.5125 7.0125C10.1875 6.3375 11.0167 6 12 6C12.9833 6 13.8125 6.3375 14.4875 7.0125C15.1625 7.6875 15.5 8.51667 15.5 9.5C15.5 10.4833 15.1625 11.3125 14.4875 11.9875C13.8125 12.6625 12.9833 13 12 13ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C12.8833 20 13.7167 19.8708 14.5 19.6125C15.2833 19.3542 16 18.9833 16.65 18.5C16 18.0167 15.2833 17.6458 14.5 17.3875C13.7167 17.1292 12.8833 17 12 17C11.1167 17 10.2833 17.1292 9.5 17.3875C8.71667 17.6458 8 18.0167 7.35 18.5C8 18.9833 8.71667 19.3542 9.5 19.6125C10.2833 19.8708 11.1167 20 12 20ZM12 11C12.4333 11 12.7917 10.8583 13.075 10.575C13.3583 10.2917 13.5 9.93333 13.5 9.5C13.5 9.06667 13.3583 8.70833 13.075 8.425C12.7917 8.14167 12.4333 8 12 8C11.5667 8 11.2083 8.14167 10.925 8.425C10.6417 8.70833 10.5 9.06667 10.5 9.5C10.5 9.93333 10.6417 10.2917 10.925 10.575C11.2083 10.8583 11.5667 11 12 11Z",
    fill: "currentColor"
  }
) }), nde = Q("IconProfile")(tde), rde = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M4 13V15H20V13H4ZM4 2H20C20.55 2 21.0208 2.19583 21.4125 2.5875C21.8042 2.97917 22 3.45 22 4V15C22 15.55 21.8042 16.0208 21.4125 16.4125C21.0208 16.8042 20.55 17 20 17H16V20.375C16 20.7583 15.8417 21.0458 15.525 21.2375C15.2083 21.4292 14.8833 21.4417 14.55 21.275L12.45 20.225C12.3167 20.1417 12.1667 20.1 12 20.1C11.8333 20.1 11.6833 20.1417 11.55 20.225L9.45 21.275C9.11667 21.4417 8.79167 21.4292 8.475 21.2375C8.15833 21.0458 8 20.7583 8 20.375V17H4C3.45 17 2.97917 16.8042 2.5875 16.4125C2.19583 16.0208 2 15.55 2 15V4C2 3.45 2.19583 2.97917 2.5875 2.5875C2.97917 2.19583 3.45 2 4 2ZM4 10H20V4H4V10Z",
    fill: "currentColor"
  }
) }), tge = Q("IconMembership")(rde), ode = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M4 18C3.71667 18 3.47917 17.9042 3.2875 17.7125C3.09583 17.5208 3 17.2833 3 17C3 16.7167 3.09583 16.4792 3.2875 16.2875C3.47917 16.0958 3.71667 16 4 16H20C20.2833 16 20.5208 16.0958 20.7125 16.2875C20.9042 16.4792 21 16.7167 21 17C21 17.2833 20.9042 17.5208 20.7125 17.7125C20.5208 17.9042 20.2833 18 20 18H4ZM4 13C3.71667 13 3.47917 12.9042 3.2875 12.7125C3.09583 12.5208 3 12.2833 3 12C3 11.7167 3.09583 11.4792 3.2875 11.2875C3.47917 11.0958 3.71667 11 4 11H20C20.2833 11 20.5208 11.0958 20.7125 11.2875C20.9042 11.4792 21 11.7167 21 12C21 12.2833 20.9042 12.5208 20.7125 12.7125C20.5208 12.9042 20.2833 13 20 13H4ZM4 8C3.71667 8 3.47917 7.90417 3.2875 7.7125C3.09583 7.52083 3 7.28333 3 7C3 6.71667 3.09583 6.47917 3.2875 6.2875C3.47917 6.09583 3.71667 6 4 6H20C20.2833 6 20.5208 6.09583 20.7125 6.2875C20.9042 6.47917 21 6.71667 21 7C21 7.28333 20.9042 7.52083 20.7125 7.7125C20.5208 7.90417 20.2833 8 20 8H4Z",
    fill: "currentColor"
  }
) }), nge = Q("IconMenu")(ode), ide = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M7 9C6.45 9 5.97917 8.80417 5.5875 8.4125C5.19583 8.02083 5 7.55 5 7C5 6.45 5.19583 5.97917 5.5875 5.5875C5.97917 5.19583 6.45 5 7 5C7.55 5 8.02083 5.19583 8.4125 5.5875C8.80417 5.97917 9 6.45 9 7C9 7.55 8.80417 8.02083 8.4125 8.4125C8.02083 8.80417 7.55 9 7 9ZM5 22C4.71667 22 4.47917 21.9042 4.2875 21.7125C4.09583 21.5208 4 21.2833 4 21C3.45 21 2.97917 20.8042 2.5875 20.4125C2.19583 20.0208 2 19.55 2 19V14C2 13.7167 2.09583 13.4792 2.2875 13.2875C2.47917 13.0958 2.71667 13 3 13H5V12.25C5 11.6167 5.21667 11.0833 5.65 10.65C6.08333 10.2167 6.61667 10 7.25 10C7.58333 10 7.89167 10.0667 8.175 10.2C8.45833 10.3333 8.71667 10.5167 8.95 10.75L10.35 12.3C10.4833 12.4333 10.6125 12.5583 10.7375 12.675C10.8625 12.7917 11 12.9 11.15 13H18V4.85C18 4.61667 17.9167 4.41667 17.75 4.25C17.5833 4.08333 17.3833 4 17.15 4C17.05 4 16.9542 4.02083 16.8625 4.0625C16.7708 4.10417 16.6833 4.16667 16.6 4.25L15.35 5.5C15.4333 5.78333 15.45 6.0625 15.4 6.3375C15.35 6.6125 15.25 6.86667 15.1 7.1L12.35 4.3C12.5833 4.15 12.8333 4.05417 13.1 4.0125C13.3667 3.97083 13.6333 4 13.9 4.1L15.15 2.85C15.4167 2.58333 15.7208 2.375 16.0625 2.225C16.4042 2.075 16.7667 2 17.15 2C17.95 2 18.625 2.275 19.175 2.825C19.725 3.375 20 4.05 20 4.85V13H21C21.2833 13 21.5208 13.0958 21.7125 13.2875C21.9042 13.4792 22 13.7167 22 14V19C22 19.55 21.8042 20.0208 21.4125 20.4125C21.0208 20.8042 20.55 21 20 21C20 21.2833 19.9042 21.5208 19.7125 21.7125C19.5208 21.9042 19.2833 22 19 22H5ZM4 19H20V15H4V19Z",
    fill: "currentColor"
  }
) }), rge = Q("IconBathtub")(ide), ade = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M12 9C11.7167 9 11.4792 8.90417 11.2875 8.7125C11.0958 8.52083 11 8.28333 11 8C11 7.71667 11.0958 7.47917 11.2875 7.2875C11.4792 7.09583 11.7167 7 12 7C12.2833 7 12.5208 7.09583 12.7125 7.2875C12.9042 7.47917 13 7.71667 13 8C13 8.28333 12.9042 8.52083 12.7125 8.7125C12.5208 8.90417 12.2833 9 12 9ZM8 13C7.71667 13 7.47917 12.9042 7.2875 12.7125C7.09583 12.5208 7 12.2833 7 12C7 11.7167 7.09583 11.4792 7.2875 11.2875C7.47917 11.0958 7.71667 11 8 11C8.28333 11 8.52083 11.0958 8.7125 11.2875C8.90417 11.4792 9 11.7167 9 12C9 12.2833 8.90417 12.5208 8.7125 12.7125C8.52083 12.9042 8.28333 13 8 13ZM12 13C11.7167 13 11.4792 12.9042 11.2875 12.7125C11.0958 12.5208 11 12.2833 11 12C11 11.7167 11.0958 11.4792 11.2875 11.2875C11.4792 11.0958 11.7167 11 12 11C12.2833 11 12.5208 11.0958 12.7125 11.2875C12.9042 11.4792 13 11.7167 13 12C13 12.2833 12.9042 12.5208 12.7125 12.7125C12.5208 12.9042 12.2833 13 12 13ZM16 13C15.7167 13 15.4792 12.9042 15.2875 12.7125C15.0958 12.5208 15 12.2833 15 12C15 11.7167 15.0958 11.4792 15.2875 11.2875C15.4792 11.0958 15.7167 11 16 11C16.2833 11 16.5208 11.0958 16.7125 11.2875C16.9042 11.4792 17 11.7167 17 12C17 12.2833 16.9042 12.5208 16.7125 12.7125C16.5208 12.9042 16.2833 13 16 13ZM12 17C11.7167 17 11.4792 16.9042 11.2875 16.7125C11.0958 16.5208 11 16.2833 11 16C11 15.7167 11.0958 15.4792 11.2875 15.2875C11.4792 15.0958 11.7167 15 12 15C12.2833 15 12.5208 15.0958 12.7125 15.2875C12.9042 15.4792 13 15.7167 13 16C13 16.2833 12.9042 16.5208 12.7125 16.7125C12.5208 16.9042 12.2833 17 12 17ZM5 19H19V5H5V19ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5Z",
    fill: "currentColor"
  }
) }), oge = Q("IconBorderOuter")(ade), sde = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M20 9C19.7167 9 19.4792 8.90417 19.2875 8.7125C19.0958 8.52083 19 8.28333 19 8C19 7.71667 19.0958 7.47917 19.2875 7.2875C19.4792 7.09583 19.7167 7 20 7C20.2833 7 20.5208 7.09583 20.7125 7.2875C20.9042 7.47917 21 7.71667 21 8C21 8.28333 20.9042 8.52083 20.7125 8.7125C20.5208 8.90417 20.2833 9 20 9ZM20 13C19.7167 13 19.4792 12.9042 19.2875 12.7125C19.0958 12.5208 19 12.2833 19 12C19 11.7167 19.0958 11.4792 19.2875 11.2875C19.4792 11.0958 19.7167 11 20 11C20.2833 11 20.5208 11.0958 20.7125 11.2875C20.9042 11.4792 21 11.7167 21 12C21 12.2833 20.9042 12.5208 20.7125 12.7125C20.5208 12.9042 20.2833 13 20 13ZM20 17C19.7167 17 19.4792 16.9042 19.2875 16.7125C19.0958 16.5208 19 16.2833 19 16C19 15.7167 19.0958 15.4792 19.2875 15.2875C19.4792 15.0958 19.7167 15 20 15C20.2833 15 20.5208 15.0958 20.7125 15.2875C20.9042 15.4792 21 15.7167 21 16C21 16.2833 20.9042 16.5208 20.7125 16.7125C20.5208 16.9042 20.2833 17 20 17ZM8 21C7.71667 21 7.47917 20.9042 7.2875 20.7125C7.09583 20.5208 7 20.2833 7 20C7 19.7167 7.09583 19.4792 7.2875 19.2875C7.47917 19.0958 7.71667 19 8 19C8.28333 19 8.52083 19.0958 8.7125 19.2875C8.90417 19.4792 9 19.7167 9 20C9 20.2833 8.90417 20.5208 8.7125 20.7125C8.52083 20.9042 8.28333 21 8 21ZM12 21C11.7167 21 11.4792 20.9042 11.2875 20.7125C11.0958 20.5208 11 20.2833 11 20C11 19.7167 11.0958 19.4792 11.2875 19.2875C11.4792 19.0958 11.7167 19 12 19C12.2833 19 12.5208 19.0958 12.7125 19.2875C12.9042 19.4792 13 19.7167 13 20C13 20.2833 12.9042 20.5208 12.7125 20.7125C12.5208 20.9042 12.2833 21 12 21ZM16 21C15.7167 21 15.4792 20.9042 15.2875 20.7125C15.0958 20.5208 15 20.2833 15 20C15 19.7167 15.0958 19.4792 15.2875 19.2875C15.4792 19.0958 15.7167 19 16 19C16.2833 19 16.5208 19.0958 16.7125 19.2875C16.9042 19.4792 17 19.7167 17 20C17 20.2833 16.9042 20.5208 16.7125 20.7125C16.5208 20.9042 16.2833 21 16 21ZM20 21C19.7167 21 19.4792 20.9042 19.2875 20.7125C19.0958 20.5208 19 20.2833 19 20C19 19.7167 19.0958 19.4792 19.2875 19.2875C19.4792 19.0958 19.7167 19 20 19C20.2833 19 20.5208 19.0958 20.7125 19.2875C20.9042 19.4792 21 19.7167 21 20C21 20.2833 20.9042 20.5208 20.7125 20.7125C20.5208 20.9042 20.2833 21 20 21ZM3 20V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H20C20.2833 3 20.5208 3.09583 20.7125 3.2875C20.9042 3.47917 21 3.71667 21 4C21 4.28333 20.9042 4.52083 20.7125 4.7125C20.5208 4.90417 20.2833 5 20 5H5V20C5 20.2833 4.90417 20.5208 4.7125 20.7125C4.52083 20.9042 4.28333 21 4 21C3.71667 21 3.47917 20.9042 3.2875 20.7125C3.09583 20.5208 3 20.2833 3 20Z",
    fill: "currentColor"
  }
) }), ige = Q("IconBorderStyle")(sde), lde = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M12 17.65C12.1334 17.65 12.2542 17.6292 12.3625 17.5875C12.4709 17.5458 12.575 17.4833 12.675 17.4C13.2084 16.9167 13.7167 16.4417 14.2 15.975C14.6834 15.5083 15.1042 15.05 15.4625 14.6C15.8209 14.15 16.1084 13.7125 16.325 13.2875C16.5417 12.8625 16.65 12.45 16.65 12.05C16.65 11.3167 16.4 10.7083 15.9 10.225C15.4 9.74167 14.8 9.5 14.1 9.5C13.6667 9.5 13.2709 9.5875 12.9125 9.7625C12.5542 9.9375 12.25 10.1667 12 10.45C11.75 10.1667 11.4375 9.9375 11.0625 9.7625C10.6875 9.5875 10.3 9.5 9.90003 9.5C9.20003 9.5 8.60003 9.74167 8.10003 10.225C7.60003 10.7083 7.35003 11.3167 7.35003 12.05C7.35003 12.45 7.45836 12.8625 7.67502 13.2875C7.89169 13.7125 8.17919 14.15 8.53753 14.6C8.89586 15.05 9.31669 15.5083 9.80002 15.975C10.2834 16.4417 10.7917 16.9167 11.325 17.4C11.425 17.4833 11.5292 17.5458 11.6375 17.5875C11.7459 17.6292 11.8667 17.65 12 17.65ZM6.00002 21C5.45002 21 4.97919 20.8042 4.58752 20.4125C4.19586 20.0208 4.00002 19.55 4.00002 19V11.625L3.00002 12.4C2.76669 12.5667 2.51669 12.6333 2.25002 12.6C1.98336 12.5667 1.76669 12.4333 1.60002 12.2C1.43336 11.9667 1.37086 11.7167 1.41252 11.45C1.45419 11.1833 1.58336 10.9667 1.80002 10.8L10.775 3.925C10.9584 3.79167 11.1542 3.69167 11.3625 3.625C11.5709 3.55833 11.7834 3.525 12 3.525C12.2167 3.525 12.4292 3.55833 12.6375 3.625C12.8459 3.69167 13.0417 3.79167 13.225 3.925L22.225 10.8C22.4417 10.9667 22.5667 11.1833 22.6 11.45C22.6334 11.7167 22.5667 11.9667 22.4 12.2C22.2334 12.4167 22.0167 12.5417 21.75 12.575C21.4834 12.6083 21.2417 12.5417 21.025 12.375L20 11.625V19C20 19.55 19.8042 20.0208 19.4125 20.4125C19.0209 20.8042 18.55 21 18 21H6.00002ZM6.00002 19H18V10.1L12 5.525L6.00002 10.1V19Z",
    fill: "currentColor"
  }
) }), age = Q("IconFamilyHome")(lde), cde = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M18 6C17.45 6 16.9792 5.80417 16.5875 5.4125C16.1958 5.02083 16 4.55 16 4C16 3.45 16.1958 2.97917 16.5875 2.5875C16.9792 2.19583 17.45 2 18 2C18.55 2 19.0208 2.19583 19.4125 2.5875C19.8042 2.97917 20 3.45 20 4C20 4.55 19.8042 5.02083 19.4125 5.4125C19.0208 5.80417 18.55 6 18 6ZM17 21V14C17 13.3333 16.8292 12.7333 16.4875 12.2C16.1458 11.6667 15.7083 11.25 15.175 10.95L16.05 8.375C16.1833 7.95833 16.4292 7.625 16.7875 7.375C17.1458 7.125 17.55 7 18 7C18.45 7 18.8542 7.125 19.2125 7.375C19.5708 7.625 19.8167 7.95833 19.95 8.375L22.05 14.675C22.1667 15.0083 22.1208 15.3125 21.9125 15.5875C21.7042 15.8625 21.4333 16 21.1 16H20V21C20 21.2833 19.9042 21.5208 19.7125 21.7125C19.5208 21.9042 19.2833 22 19 22H18C17.7167 22 17.4792 21.9042 17.2875 21.7125C17.0958 21.5208 17 21.2833 17 21ZM12.5 11.5C12.0833 11.5 11.7292 11.3542 11.4375 11.0625C11.1458 10.7708 11 10.4167 11 10C11 9.58333 11.1458 9.22917 11.4375 8.9375C11.7292 8.64583 12.0833 8.5 12.5 8.5C12.9167 8.5 13.2708 8.64583 13.5625 8.9375C13.8542 9.22917 14 9.58333 14 10C14 10.4167 13.8542 10.7708 13.5625 11.0625C13.2708 11.3542 12.9167 11.5 12.5 11.5ZM5.5 6C4.95 6 4.47917 5.80417 4.0875 5.4125C3.69583 5.02083 3.5 4.55 3.5 4C3.5 3.45 3.69583 2.97917 4.0875 2.5875C4.47917 2.19583 4.95 2 5.5 2C6.05 2 6.52083 2.19583 6.9125 2.5875C7.30417 2.97917 7.5 3.45 7.5 4C7.5 4.55 7.30417 5.02083 6.9125 5.4125C6.52083 5.80417 6.05 6 5.5 6ZM3.5 21V15H3C2.71667 15 2.47917 14.9042 2.2875 14.7125C2.09583 14.5208 2 14.2833 2 14V9C2 8.45 2.19583 7.97917 2.5875 7.5875C2.97917 7.19583 3.45 7 4 7H7C7.55 7 8.02083 7.19583 8.4125 7.5875C8.80417 7.97917 9 8.45 9 9V14C9 14.2833 8.90417 14.5208 8.7125 14.7125C8.52083 14.9042 8.28333 15 8 15H7.5V21C7.5 21.2833 7.40417 21.5208 7.2125 21.7125C7.02083 21.9042 6.78333 22 6.5 22H4.5C4.21667 22 3.97917 21.9042 3.7875 21.7125C3.59583 21.5208 3.5 21.2833 3.5 21ZM11 21V18C10.7167 18 10.4792 17.9042 10.2875 17.7125C10.0958 17.5208 10 17.2833 10 17V14C10 13.5833 10.1458 13.2292 10.4375 12.9375C10.7292 12.6458 11.0833 12.5 11.5 12.5H13.5C13.9167 12.5 14.2708 12.6458 14.5625 12.9375C14.8542 13.2292 15 13.5833 15 14V17C15 17.2833 14.9042 17.5208 14.7125 17.7125C14.5208 17.9042 14.2833 18 14 18V21C14 21.2833 13.9042 21.5208 13.7125 21.7125C13.5208 21.9042 13.2833 22 13 22H12C11.7167 22 11.4792 21.9042 11.2875 21.7125C11.0958 21.5208 11 21.2833 11 21Z",
    fill: "currentColor"
  }
) }), sge = Q("IconFamilyRestroom")(cde), ude = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M4.02502 14.85C3.75836 14.65 3.62919 14.3875 3.63752 14.0625C3.64586 13.7375 3.78336 13.475 4.05002 13.275C4.23336 13.1417 4.43336 13.075 4.65002 13.075C4.86669 13.075 5.06669 13.1417 5.25002 13.275L12 18.5L18.75 13.275C18.9334 13.1417 19.1334 13.075 19.35 13.075C19.5667 13.075 19.7667 13.1417 19.95 13.275C20.2167 13.475 20.3542 13.7375 20.3625 14.0625C20.3709 14.3875 20.2417 14.65 19.975 14.85L13.225 20.1C12.8584 20.3833 12.45 20.525 12 20.525C11.55 20.525 11.1417 20.3833 10.775 20.1L4.02502 14.85ZM10.775 15.05L5.02502 10.575C4.50836 10.175 4.25002 9.65 4.25002 9C4.25002 8.35 4.50836 7.825 5.02502 7.425L10.775 2.95C11.1417 2.66667 11.55 2.525 12 2.525C12.45 2.525 12.8584 2.66667 13.225 2.95L18.975 7.425C19.4917 7.825 19.75 8.35 19.75 9C19.75 9.65 19.4917 10.175 18.975 10.575L13.225 15.05C12.8584 15.3333 12.45 15.475 12 15.475C11.55 15.475 11.1417 15.3333 10.775 15.05ZM12 13.45L17.75 9L12 4.55L6.25002 9L12 13.45Z",
    fill: "currentColor"
  }
) }), lge = Q("IconLayers")(ude), fde = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V8C3 7.45 3.19583 6.97917 3.5875 6.5875C3.97917 6.19583 4.45 6 5 6H7C7 4.61667 7.4875 3.4375 8.4625 2.4625C9.4375 1.4875 10.6167 1 12 1C13.3833 1 14.5625 1.4875 15.5375 2.4625C16.5125 3.4375 17 4.61667 17 6H19C19.55 6 20.0208 6.19583 20.4125 6.5875C20.8042 6.97917 21 7.45 21 8V20C21 20.55 20.8042 21.0208 20.4125 21.4125C20.0208 21.8042 19.55 22 19 22H5ZM5 20H19V8H5V20ZM9 6H15C15 5.16667 14.7083 4.45833 14.125 3.875C13.5417 3.29167 12.8333 3 12 3C11.1667 3 10.4583 3.29167 9.875 3.875C9.29167 4.45833 9 5.16667 9 6ZM11.975 14C13.2083 14 14.325 13.5917 15.325 12.775C16.325 11.9583 16.8167 11.0417 16.8 10.025C16.8 9.74167 16.7083 9.5 16.525 9.3C16.3417 9.1 16.1083 9 15.825 9C15.5917 9 15.3833 9.075 15.2 9.225C15.0167 9.375 14.8833 9.6 14.8 9.9C14.6167 10.5333 14.2583 11.0417 13.725 11.425C13.1917 11.8083 12.6083 12 11.975 12C11.3417 12 10.7542 11.8083 10.2125 11.425C9.67083 11.0417 9.31667 10.5333 9.15 9.9C9.06667 9.58333 8.94167 9.35417 8.775 9.2125C8.60833 9.07083 8.40833 9 8.175 9C7.89167 9 7.65417 9.1 7.4625 9.3C7.27083 9.5 7.175 9.74167 7.175 10.025C7.175 11.0417 7.66667 11.9583 8.65 12.775C9.63333 13.5917 10.7417 14 11.975 14Z",
    fill: "currentColor"
  }
) }), cge = Q("IconLocalMail")(fde), dde = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M3 19V9C3 8.45 3.19583 7.97917 3.5875 7.5875C3.97917 7.19583 4.45 7 5 7H9V5.825C9 5.55833 9.05 5.30417 9.15 5.0625C9.25 4.82083 9.39167 4.60833 9.575 4.425L10.575 3.425C10.9583 3.04167 11.4333 2.85 12 2.85C12.5667 2.85 13.0417 3.04167 13.425 3.425L14.425 4.425C14.6083 4.60833 14.75 4.82083 14.85 5.0625C14.95 5.30417 15 5.55833 15 5.825V11H19C19.55 11 20.0208 11.1958 20.4125 11.5875C20.8042 11.9792 21 12.45 21 13V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19ZM5 19H7V17H5V19ZM5 15H7V13H5V15ZM5 11H7V9H5V11ZM11 19H13V17H11V19ZM11 15H13V13H11V15ZM11 11H13V9H11V11ZM11 7H13V5H11V7ZM17 19H19V17H17V19ZM17 15H19V13H17V15Z",
    fill: "currentColor"
  }
) }), uge = Q("IconLocationCity")(dde), hde = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M10.35 19.8L10.65 18.4C10.7 18.1833 10.8042 18.0042 10.9625 17.8625C11.1208 17.7208 11.3167 17.6333 11.55 17.6L14.65 17.35C14.8667 17.3167 15.0667 17.3583 15.25 17.475C15.4333 17.5917 15.5667 17.75 15.65 17.95L16.05 18.9C16.7 18.5167 17.2833 18.0542 17.8 17.5125C18.3167 16.9708 18.75 16.3667 19.1 15.7L18.8 15.55C18.6167 15.4167 18.4833 15.2542 18.4 15.0625C18.3167 14.8708 18.3 14.6667 18.35 14.45L19.05 11.4C19.1 11.2 19.2042 11.0333 19.3625 10.9C19.5208 10.7667 19.7 10.6833 19.9 10.65C19.8167 10.2333 19.7125 9.82917 19.5875 9.4375C19.4625 9.04583 19.3 8.66667 19.1 8.3C18.95 8.38333 18.7875 8.42083 18.6125 8.4125C18.4375 8.40417 18.2833 8.35 18.15 8.25L15.5 6.65C15.3167 6.53333 15.1833 6.375 15.1 6.175C15.0167 5.975 15 5.76667 15.05 5.55L15.25 4.7C14.7333 4.46667 14.2042 4.29167 13.6625 4.175C13.1208 4.05833 12.5667 4 12 4C11.7667 4 11.525 4.0125 11.275 4.0375C11.025 4.0625 10.7833 4.1 10.55 4.15L11.3 5.85C11.3833 6.05 11.4042 6.25833 11.3625 6.475C11.3208 6.69167 11.2167 6.86667 11.05 7L8.7 9.05C8.53333 9.2 8.3375 9.28333 8.1125 9.3C7.8875 9.31667 7.68333 9.26667 7.5 9.15L5.2 7.75C4.81667 8.38333 4.52083 9.0625 4.3125 9.7875C4.10417 10.5125 4 11.25 4 12C4 12.2667 4.03333 12.7 4.1 13.3L6.3 13.1C6.53333 13.0667 6.74583 13.1042 6.9375 13.2125C7.12917 13.3208 7.26667 13.4833 7.35 13.7L8.55 16.55C8.63333 16.75 8.65417 16.9583 8.6125 17.175C8.57083 17.3917 8.46667 17.5667 8.3 17.7L7.35 18.5C7.8 18.8333 8.27917 19.1083 8.7875 19.325C9.29583 19.5417 9.81667 19.7 10.35 19.8ZM12.15 15.5C11.9333 15.5333 11.7333 15.4917 11.55 15.375C11.3667 15.2583 11.2333 15.1 11.15 14.9L9.8 11.8C9.71667 11.6 9.70417 11.3917 9.7625 11.175C9.82083 10.9583 9.93333 10.7833 10.1 10.65L12.65 8.5C12.8 8.35 12.9833 8.26667 13.2 8.25C13.4167 8.23333 13.6167 8.28333 13.8 8.4L16.6 10.05C16.7833 10.1667 16.925 10.325 17.025 10.525C17.125 10.725 17.15 10.9333 17.1 11.15L16.3 14.4C16.25 14.6167 16.15 14.7958 16 14.9375C15.85 15.0792 15.6667 15.1667 15.45 15.2L12.15 15.5ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z",
    fill: "currentColor"
  }
) }), fge = Q("IconSportsAndOutdoors")(hde), pde = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M7 18C5.33333 18 3.91667 17.4167 2.75 16.25C1.58333 15.0833 1 13.6667 1 12C1 10.3333 1.58333 8.91667 2.75 7.75C3.91667 6.58333 5.33333 6 7 6C8.1 6 9.10833 6.275 10.025 6.825C10.9417 7.375 11.6667 8.1 12.2 9H21C21.55 9 22.0208 9.19583 22.4125 9.5875C22.8042 9.97917 23 10.45 23 11V13C23 13.55 22.8042 14.0208 22.4125 14.4125C22.0208 14.8042 21.55 15 21 15V16C21 16.55 20.8042 17.0208 20.4125 17.4125C20.0208 17.8042 19.55 18 19 18H17C16.45 18 15.9792 17.8042 15.5875 17.4125C15.1958 17.0208 15 16.55 15 16V15H12.2C11.6667 15.9 10.9417 16.625 10.025 17.175C9.10833 17.725 8.1 18 7 18ZM7 16C8.1 16 8.98333 15.6625 9.65 14.9875C10.3167 14.3125 10.7167 13.65 10.85 13H17V16H19V13H21V11H10.85C10.7167 10.35 10.3167 9.6875 9.65 9.0125C8.98333 8.3375 8.1 8 7 8C5.9 8 4.95833 8.39167 4.175 9.175C3.39167 9.95833 3 10.9 3 12C3 13.1 3.39167 14.0417 4.175 14.825C4.95833 15.6083 5.9 16 7 16ZM7 14C7.55 14 8.02083 13.8042 8.4125 13.4125C8.80417 13.0208 9 12.55 9 12C9 11.45 8.80417 10.9792 8.4125 10.5875C8.02083 10.1958 7.55 10 7 10C6.45 10 5.97917 10.1958 5.5875 10.5875C5.19583 10.9792 5 11.45 5 12C5 12.55 5.19583 13.0208 5.5875 13.4125C5.97917 13.8042 6.45 14 7 14Z",
    fill: "currentColor"
  }
) }), dge = Q("IconVpnKey")(pde), mde = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M12 18.5V19C12 19.2833 11.9042 19.5208 11.7125 19.7125C11.5208 19.9042 11.2833 20 11 20C10.7167 20 10.4792 19.9042 10.2875 19.7125C10.0958 19.5208 10 19.2833 10 19V14C10 13.8833 10.0083 13.7667 10.025 13.65C10.0417 13.5333 10.0667 13.425 10.1 13.325L11.15 10.35C11.2833 9.95 11.525 9.625 11.875 9.375C12.225 9.125 12.6167 9 13.05 9H18.95C19.3833 9 19.775 9.125 20.125 9.375C20.475 9.625 20.7167 9.95 20.85 10.35L21.9 13.325C21.9333 13.425 21.9583 13.5333 21.975 13.65C21.9917 13.7667 22 13.8833 22 14V19C22 19.2833 21.9042 19.5208 21.7125 19.7125C21.5208 19.9042 21.2833 20 21 20C20.7167 20 20.4792 19.9042 20.2875 19.7125C20.0958 19.5208 20 19.2833 20 19V18.5H12ZM12 12.5H20L19.3 10.5H12.7L12 12.5ZM13 16.5C13.2833 16.5 13.5208 16.4042 13.7125 16.2125C13.9042 16.0208 14 15.7833 14 15.5C14 15.2167 13.9042 14.9792 13.7125 14.7875C13.5208 14.5958 13.2833 14.5 13 14.5C12.7167 14.5 12.4792 14.5958 12.2875 14.7875C12.0958 14.9792 12 15.2167 12 15.5C12 15.7833 12.0958 16.0208 12.2875 16.2125C12.4792 16.4042 12.7167 16.5 13 16.5ZM19 16.5C19.2833 16.5 19.5208 16.4042 19.7125 16.2125C19.9042 16.0208 20 15.7833 20 15.5C20 15.2167 19.9042 14.9792 19.7125 14.7875C19.5208 14.5958 19.2833 14.5 19 14.5C18.7167 14.5 18.4792 14.5958 18.2875 14.7875C18.0958 14.9792 18 15.2167 18 15.5C18 15.7833 18.0958 16.0208 18.2875 16.2125C18.4792 16.4042 18.7167 16.5 19 16.5ZM4.2 20C3.96667 20 3.80833 19.9 3.725 19.7C3.64167 19.5 3.68333 19.3167 3.85 19.15L5 18C4.16667 18 3.45833 17.7083 2.875 17.125C2.29167 16.5417 2 15.8333 2 15V7C2 5.9 2.49167 5.125 3.475 4.675C4.45833 4.225 6.13333 4 8.5 4C10.9667 4 12.6667 4.21667 13.6 4.65C14.5333 5.08333 15 5.86667 15 7C15 7.28333 14.9042 7.52083 14.7125 7.7125C14.5208 7.90417 14.2833 8 14 8C13.7167 8 13.4792 7.90417 13.2875 7.7125C13.0958 7.52083 13 7.28333 13 7H4V13H8C8.28333 13 8.52083 13.0958 8.7125 13.2875C8.90417 13.4792 9 13.7167 9 14V19C9 19.2833 8.90417 19.5208 8.7125 19.7125C8.52083 19.9042 8.28333 20 8 20H4.2ZM5 16C5.28333 16 5.52083 15.9042 5.7125 15.7125C5.90417 15.5208 6 15.2833 6 15C6 14.7167 5.90417 14.4792 5.7125 14.2875C5.52083 14.0958 5.28333 14 5 14C4.71667 14 4.47917 14.0958 4.2875 14.2875C4.09583 14.4792 4 14.7167 4 15C4 15.2833 4.09583 15.5208 4.2875 15.7125C4.47917 15.9042 4.71667 16 5 16ZM11.5 17H20.5V14H11.5V17Z",
    fill: "currentColor"
  }
) }), hge = Q("IconCommute")(mde), gde = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M3.95 19L2.05 12.3C2 12.1 2.02083 11.8667 2.1125 11.6C2.20417 11.3333 2.4 11.15 2.7 11.05L4 10.6V6C4 5.45 4.19583 4.97917 4.5875 4.5875C4.97917 4.19583 5.45 4 6 4H9V2C9 1.71667 9.09583 1.47917 9.2875 1.2875C9.47917 1.09583 9.71667 1 10 1H14C14.2833 1 14.5208 1.09583 14.7125 1.2875C14.9042 1.47917 15 1.71667 15 2V4H18C18.55 4 19.0208 4.19583 19.4125 4.5875C19.8042 4.97917 20 5.45 20 6V10.6L21.3 11.05C21.65 11.1833 21.8583 11.3792 21.925 11.6375C21.9917 11.8958 22 12.1167 21.95 12.3L20.05 19C19.3833 19 18.7667 18.8708 18.2 18.6125C17.6333 18.3542 17.1167 18.025 16.65 17.625C16.4667 17.4417 16.25 17.35 16 17.35C15.75 17.35 15.5333 17.4417 15.35 17.625C14.8833 18.025 14.3667 18.3542 13.8 18.6125C13.2333 18.8708 12.6333 19 12 19C11.8333 19 11.675 18.9917 11.525 18.975C11.375 18.9583 11.225 18.9333 11.075 18.9C10.5917 18.8 10.1333 18.625 9.7 18.375C9.26667 18.125 8.86667 17.8333 8.5 17.5C8.36667 17.3667 8.19583 17.3 7.9875 17.3C7.77917 17.3 7.60833 17.3667 7.475 17.5C7.00833 17.95 6.46667 18.3125 5.85 18.5875C5.23333 18.8625 4.6 19 3.95 19ZM12 23C11.3167 23 10.6375 22.9167 9.9625 22.75C9.2875 22.5833 8.63333 22.3333 8 22C7.36667 22.3333 6.71667 22.5833 6.05 22.75C5.38333 22.9167 4.7 23 4 23H3C2.71667 23 2.47917 22.9042 2.2875 22.7125C2.09583 22.5208 2 22.2833 2 22C2 21.7167 2.09583 21.4792 2.2875 21.2875C2.47917 21.0958 2.71667 21 3 21H4C4.6 21 5.2 20.9167 5.8 20.75C6.4 20.5833 6.95833 20.3417 7.475 20.025C7.64167 19.925 7.81667 19.875 8 19.875C8.18333 19.875 8.35833 19.925 8.525 20.025C8.89167 20.2583 9.3125 20.45 9.7875 20.6C10.2625 20.75 10.7167 20.85 11.15 20.9C11.2833 20.9167 11.425 20.9292 11.575 20.9375C11.725 20.9458 11.8667 20.95 12 20.95C12.6 20.95 13.2 20.875 13.8 20.725C14.4 20.575 14.9583 20.3417 15.475 20.025C15.6417 19.925 15.8167 19.875 16 19.875C16.1833 19.875 16.3583 19.925 16.525 20.025C17.0417 20.3583 17.6 20.6042 18.2 20.7625C18.8 20.9208 19.4 21 20 21H21C21.2833 21 21.5208 21.0958 21.7125 21.2875C21.9042 21.4792 22 21.7167 22 22C22 22.2833 21.9042 22.5208 21.7125 22.7125C21.5208 22.9042 21.2833 23 21 23H20C19.3 23 18.6167 22.9167 17.95 22.75C17.2833 22.5833 16.6333 22.3333 16 22C15.3667 22.3333 14.7125 22.5833 14.0375 22.75C13.3625 22.9167 12.6833 23 12 23ZM6 9.95L11.375 8.2C11.575 8.13333 11.7833 8.1 12 8.1C12.2167 8.1 12.425 8.13333 12.625 8.2L18 9.95V6H6V9.95ZM12 17C12.5 17 12.9667 16.8625 13.4 16.5875C13.8333 16.3125 14.2167 15.9917 14.55 15.625C14.95 15.1917 15.4417 14.9792 16.025 14.9875C16.6083 14.9958 17.0917 15.2167 17.475 15.65C17.6583 15.8333 17.8417 16.0125 18.025 16.1875C18.2083 16.3625 18.4167 16.5167 18.65 16.65L19.75 12.65L12 10.1L4.2 12.65L5.35 16.6C5.56667 16.4667 5.76667 16.325 5.95 16.175C6.13333 16.025 6.31667 15.8583 6.5 15.675C6.91667 15.2417 7.42083 15.0208 8.0125 15.0125C8.60417 15.0042 9.1 15.2167 9.5 15.65C9.73333 15.9 9.98333 16.1375 10.25 16.3625C10.5167 16.5875 10.8167 16.7583 11.15 16.875C11.2833 16.925 11.4208 16.9583 11.5625 16.975C11.7042 16.9917 11.85 17 12 17Z",
    fill: "currentColor"
  }
) }), pge = Q("IconDirectionsBoat")(gde), Cde = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M8 19V19.5C8 19.9167 7.85417 20.2708 7.5625 20.5625C7.27083 20.8542 6.91667 21 6.5 21C6.08333 21 5.72917 20.8542 5.4375 20.5625C5.14583 20.2708 5 19.9167 5 19.5V17.95C4.7 17.6167 4.45833 17.2458 4.275 16.8375C4.09167 16.4292 4 15.9833 4 15.5V6C4 4.61667 4.64167 3.60417 5.925 2.9625C7.20833 2.32083 9.23333 2 12 2C14.8667 2 16.9167 2.30833 18.15 2.925C19.3833 3.54167 20 4.56667 20 6V15.5C20 15.9833 19.9083 16.4292 19.725 16.8375C19.5417 17.2458 19.3 17.6167 19 17.95V19.5C19 19.9167 18.8542 20.2708 18.5625 20.5625C18.2708 20.8542 17.9167 21 17.5 21C17.0833 21 16.7292 20.8542 16.4375 20.5625C16.1458 20.2708 16 19.9167 16 19.5V19H8ZM6 10H18V7H6V10ZM8.5 16C8.91667 16 9.27083 15.8542 9.5625 15.5625C9.85417 15.2708 10 14.9167 10 14.5C10 14.0833 9.85417 13.7292 9.5625 13.4375C9.27083 13.1458 8.91667 13 8.5 13C8.08333 13 7.72917 13.1458 7.4375 13.4375C7.14583 13.7292 7 14.0833 7 14.5C7 14.9167 7.14583 15.2708 7.4375 15.5625C7.72917 15.8542 8.08333 16 8.5 16ZM15.5 16C15.9167 16 16.2708 15.8542 16.5625 15.5625C16.8542 15.2708 17 14.9167 17 14.5C17 14.0833 16.8542 13.7292 16.5625 13.4375C16.2708 13.1458 15.9167 13 15.5 13C15.0833 13 14.7292 13.1458 14.4375 13.4375C14.1458 13.7292 14 14.0833 14 14.5C14 14.9167 14.1458 15.2708 14.4375 15.5625C14.7292 15.8542 15.0833 16 15.5 16ZM6.45 5H17.65C17.4 4.71667 16.8625 4.47917 16.0375 4.2875C15.2125 4.09583 13.8833 4 12.05 4C10.2667 4 8.9625 4.10417 8.1375 4.3125C7.3125 4.52083 6.75 4.75 6.45 5ZM8 17H16C16.55 17 17.0208 16.8042 17.4125 16.4125C17.8042 16.0208 18 15.55 18 15V12H6V15C6 15.55 6.19583 16.0208 6.5875 16.4125C6.97917 16.8042 7.45 17 8 17Z",
    fill: "currentColor"
  }
) }), mge = Q("IconDirectionsBus")(Cde), vde = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M6 19V19.5C6 19.9167 5.85417 20.2708 5.5625 20.5625C5.27083 20.8542 4.91667 21 4.5 21C4.08333 21 3.72917 20.8542 3.4375 20.5625C3.14583 20.2708 3 19.9167 3 19.5V12.35C3 12.2333 3.00833 12.1167 3.025 12C3.04167 11.8833 3.06667 11.775 3.1 11.675L4.975 6.35C5.10833 5.95 5.35 5.625 5.7 5.375C6.05 5.125 6.44167 5 6.875 5H17.125C17.5583 5 17.95 5.125 18.3 5.375C18.65 5.625 18.8917 5.95 19.025 6.35L20.9 11.675C20.9333 11.775 20.9583 11.8833 20.975 12C20.9917 12.1167 21 12.2333 21 12.35V19.5C21 19.9167 20.8542 20.2708 20.5625 20.5625C20.2708 20.8542 19.9167 21 19.5 21C19.0833 21 18.7292 20.8542 18.4375 20.5625C18.1458 20.2708 18 19.9167 18 19.5V19H6ZM5.8 10H18.2L17.15 7H6.85L5.8 10ZM7.5 16C7.91667 16 8.27083 15.8542 8.5625 15.5625C8.85417 15.2708 9 14.9167 9 14.5C9 14.0833 8.85417 13.7292 8.5625 13.4375C8.27083 13.1458 7.91667 13 7.5 13C7.08333 13 6.72917 13.1458 6.4375 13.4375C6.14583 13.7292 6 14.0833 6 14.5C6 14.9167 6.14583 15.2708 6.4375 15.5625C6.72917 15.8542 7.08333 16 7.5 16ZM16.5 16C16.9167 16 17.2708 15.8542 17.5625 15.5625C17.8542 15.2708 18 14.9167 18 14.5C18 14.0833 17.8542 13.7292 17.5625 13.4375C17.2708 13.1458 16.9167 13 16.5 13C16.0833 13 15.7292 13.1458 15.4375 13.4375C15.1458 13.7292 15 14.0833 15 14.5C15 14.9167 15.1458 15.2708 15.4375 15.5625C15.7292 15.8542 16.0833 16 16.5 16ZM5 17H19V12H5V17Z",
    fill: "currentColor"
  }
) }), gge = Q("IconDirectionsCar")(vde), yde = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M4 15.5V6C4 4.61667 4.64167 3.60417 5.925 2.9625C7.20833 2.32083 9.23333 2 12 2C14.8667 2 16.9167 2.30833 18.15 2.925C19.3833 3.54167 20 4.56667 20 6V15.5C20 16.4833 19.6625 17.3125 18.9875 17.9875C18.3125 18.6625 17.4833 19 16.5 19L18.125 20.075C18.325 20.2083 18.3917 20.3958 18.325 20.6375C18.2583 20.8792 18.1 21 17.85 21H6.15C5.9 21 5.74167 20.8792 5.675 20.6375C5.60833 20.3958 5.675 20.2083 5.875 20.075L7.5 19C6.51667 19 5.6875 18.6625 5.0125 17.9875C4.3375 17.3125 4 16.4833 4 15.5ZM6 10H18V7H6V10ZM12 16C12.4167 16 12.7708 15.8542 13.0625 15.5625C13.3542 15.2708 13.5 14.9167 13.5 14.5C13.5 14.0833 13.3542 13.7292 13.0625 13.4375C12.7708 13.1458 12.4167 13 12 13C11.5833 13 11.2292 13.1458 10.9375 13.4375C10.6458 13.7292 10.5 14.0833 10.5 14.5C10.5 14.9167 10.6458 15.2708 10.9375 15.5625C11.2292 15.8542 11.5833 16 12 16ZM7.5 17H16.5C16.9333 17 17.2917 16.8583 17.575 16.575C17.8583 16.2917 18 15.9333 18 15.5V12H6V15.5C6 15.9333 6.14167 16.2917 6.425 16.575C6.70833 16.8583 7.06667 17 7.5 17ZM12 4C10.5667 4 9.37917 4.08333 8.4375 4.25C7.49583 4.41667 6.83333 4.66667 6.45 5H17.65C17.35 4.66667 16.7292 4.41667 15.7875 4.25C14.8458 4.08333 13.5833 4 12 4Z",
    fill: "currentColor"
  }
) }), Cge = Q("IconDirectionsRailway")(yde), bde = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M10.9 14.9L9.275 22.2C9.225 22.4333 9.10417 22.625 8.9125 22.775C8.72083 22.925 8.5 23 8.25 23C7.91667 23 7.65 22.875 7.45 22.625C7.25 22.375 7.18333 22.0917 7.25 21.775L9.8 8.9L8 9.6V12C8 12.2833 7.90417 12.5208 7.7125 12.7125C7.52083 12.9042 7.28333 13 7 13C6.71667 13 6.47917 12.9042 6.2875 12.7125C6.09583 12.5208 6 12.2833 6 12V8.95C6 8.75 6.05417 8.57083 6.1625 8.4125C6.27083 8.25417 6.41667 8.13333 6.6 8.05L11.05 6.15C11.2833 6.05 11.5292 5.99167 11.7875 5.975C12.0458 5.95833 12.2917 5.99167 12.525 6.075C12.7583 6.15833 12.9792 6.275 13.1875 6.425C13.3958 6.575 13.5667 6.76667 13.7 7L14.7 8.6C14.9167 8.93333 15.1708 9.25 15.4625 9.55C15.7542 9.85 16.0833 10.1083 16.45 10.325C16.6833 10.4583 16.9417 10.5792 17.225 10.6875C17.5083 10.7958 17.7917 10.875 18.075 10.925C18.3417 10.975 18.5625 11.0958 18.7375 11.2875C18.9125 11.4792 19 11.7167 19 12C19 12.2833 18.9 12.5167 18.7 12.7C18.5 12.8833 18.2583 12.9583 17.975 12.925C17.0417 12.7917 16.2042 12.5 15.4625 12.05C14.7208 11.6 14.075 11.0583 13.525 10.425L12.9 13.5L14.7 15.2C14.8 15.3 14.875 15.4125 14.925 15.5375C14.975 15.6625 15 15.7917 15 15.925V22C15 22.2833 14.9042 22.5208 14.7125 22.7125C14.5208 22.9042 14.2833 23 14 23C13.7167 23 13.4792 22.9042 13.2875 22.7125C13.0958 22.5208 13 22.2833 13 22V16.5L10.9 14.9ZM13.5 5.5C12.95 5.5 12.4792 5.30417 12.0875 4.9125C11.6958 4.52083 11.5 4.05 11.5 3.5C11.5 2.95 11.6958 2.47917 12.0875 2.0875C12.4792 1.69583 12.95 1.5 13.5 1.5C14.05 1.5 14.5208 1.69583 14.9125 2.0875C15.3042 2.47917 15.5 2.95 15.5 3.5C15.5 4.05 15.3042 4.52083 14.9125 4.9125C14.5208 5.30417 14.05 5.5 13.5 5.5Z",
    fill: "currentColor"
  }
) }), vge = Q("IconDirectionsWalk")(bde), wde = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M6 15V15.5C6 15.9167 5.85417 16.2708 5.5625 16.5625C5.27083 16.8542 4.91667 17 4.5 17C4.08333 17 3.72917 16.8542 3.4375 16.5625C3.14583 16.2708 3 15.9167 3 15.5V8.35C3 8.23333 3.00833 8.11667 3.025 8C3.04167 7.88333 3.06667 7.775 3.1 7.675L4.975 2.35C5.10833 1.95 5.35 1.625 5.7 1.375C6.05 1.125 6.44167 1 6.875 1H17.125C17.5583 1 17.95 1.125 18.3 1.375C18.65 1.625 18.8917 1.95 19.025 2.35L20.9 7.675C20.9333 7.775 20.9583 7.88333 20.975 8C20.9917 8.11667 21 8.23333 21 8.35V15.5C21 15.9167 20.8542 16.2708 20.5625 16.5625C20.2708 16.8542 19.9167 17 19.5 17C19.0833 17 18.7292 16.8542 18.4375 16.5625C18.1458 16.2708 18 15.9167 18 15.5V15H6ZM5.8 6H18.2L17.15 3H6.85L5.8 6ZM7.5 12C7.91667 12 8.27083 11.8542 8.5625 11.5625C8.85417 11.2708 9 10.9167 9 10.5C9 10.0833 8.85417 9.72917 8.5625 9.4375C8.27083 9.14583 7.91667 9 7.5 9C7.08333 9 6.72917 9.14583 6.4375 9.4375C6.14583 9.72917 6 10.0833 6 10.5C6 10.9167 6.14583 11.2708 6.4375 11.5625C6.72917 11.8542 7.08333 12 7.5 12ZM16.5 12C16.9167 12 17.2708 11.8542 17.5625 11.5625C17.8542 11.2708 18 10.9167 18 10.5C18 10.0833 17.8542 9.72917 17.5625 9.4375C17.2708 9.14583 16.9167 9 16.5 9C16.0833 9 15.7292 9.14583 15.4375 9.4375C15.1458 9.72917 15 10.0833 15 10.5C15 10.9167 15.1458 11.2708 15.4375 11.5625C15.7292 11.8542 16.0833 12 16.5 12ZM13 21V22.2C13 22.3833 12.9208 22.525 12.7625 22.625C12.6042 22.725 12.4417 22.7333 12.275 22.65L7.95 20.475C7.83333 20.4083 7.7875 20.3125 7.8125 20.1875C7.8375 20.0625 7.91667 20 8.05 20H11V18.8C11 18.6167 11.0792 18.475 11.2375 18.375C11.3958 18.275 11.5583 18.2667 11.725 18.35L16.05 20.525C16.1667 20.5917 16.2125 20.6875 16.1875 20.8125C16.1625 20.9375 16.0833 21 15.95 21H13ZM5 13H19V8H5V13Z",
    fill: "currentColor"
  }
) }), yge = Q("IconElectricCar")(wde), xde = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M6 10H12V5H6V10ZM6 19H12V12H6V19ZM13 21H5C4.71667 21 4.47917 20.9042 4.2875 20.7125C4.09583 20.5208 4 20.2833 4 20V5C4 4.45 4.19583 3.97917 4.5875 3.5875C4.97917 3.19583 5.45 3 6 3H12C12.55 3 13.0208 3.19583 13.4125 3.5875C13.8042 3.97917 14 4.45 14 5V12H15.25C15.7333 12 16.1458 12.1708 16.4875 12.5125C16.8292 12.8542 17 13.2667 17 13.75V18.375C17 18.6583 17.1167 18.9167 17.35 19.15C17.5833 19.3833 17.8417 19.5 18.125 19.5C18.425 19.5 18.6875 19.3833 18.9125 19.15C19.1375 18.9167 19.25 18.6583 19.25 18.375V9H19C18.7167 9 18.4792 8.90417 18.2875 8.7125C18.0958 8.52083 18 8.28333 18 8V6.5C18 6.36667 18.05 6.25 18.15 6.15C18.25 6.05 18.3667 6 18.5 6V5C18.5 4.86667 18.55 4.75 18.65 4.65C18.75 4.55 18.8667 4.5 19 4.5C19.1333 4.5 19.25 4.55 19.35 4.65C19.45 4.75 19.5 4.86667 19.5 5V6H20.5V5C20.5 4.86667 20.55 4.75 20.65 4.65C20.75 4.55 20.8667 4.5 21 4.5C21.1333 4.5 21.25 4.55 21.35 4.65C21.45 4.75 21.5 4.86667 21.5 5V6C21.6333 6 21.75 6.05 21.85 6.15C21.95 6.25 22 6.36667 22 6.5V8C22 8.28333 21.9042 8.52083 21.7125 8.7125C21.5208 8.90417 21.2833 9 21 9H20.75V18.375C20.75 19.075 20.4958 19.6875 19.9875 20.2125C19.4792 20.7375 18.8583 21 18.125 21C17.4083 21 16.7917 20.7375 16.275 20.2125C15.7583 19.6875 15.5 19.075 15.5 18.375V13.75C15.5 13.6667 15.4792 13.6042 15.4375 13.5625C15.3958 13.5208 15.3333 13.5 15.25 13.5H14V20C14 20.2833 13.9042 20.5208 13.7125 20.7125C13.5208 20.9042 13.2833 21 13 21ZM8.5 19L11 15H9.5V12L7 16H8.5V19Z",
    fill: "currentColor"
  }
) }), bge = Q("IconEvStation")(xde), Sde = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M5 19C3.61667 19 2.4375 18.5125 1.4625 17.5375C0.4875 16.5625 0 15.3833 0 14C0 12.6167 0.4875 11.4375 1.4625 10.4625C2.4375 9.4875 3.61667 9 5 9H16.6L14.6 7H12C11.7167 7 11.4792 6.90417 11.2875 6.7125C11.0958 6.52083 11 6.28333 11 6C11 5.71667 11.0958 5.47917 11.2875 5.2875C11.4792 5.09583 11.7167 5 12 5H14.575C14.8417 5 15.0958 5.05 15.3375 5.15C15.5792 5.25 15.7917 5.39167 15.975 5.575L19.45 9.05C20.75 9.15 21.8333 9.675 22.7 10.625C23.5667 11.575 24 12.7 24 14C24 15.3833 23.5125 16.5625 22.5375 17.5375C21.5625 18.5125 20.3833 19 19 19C17.6167 19 16.4375 18.5125 15.4625 17.5375C14.4875 16.5625 14 15.3833 14 14C14 13.7 14.0208 13.4042 14.0625 13.1125C14.1042 12.8208 14.1833 12.5333 14.3 12.25L11.85 14.7C11.75 14.8 11.6375 14.875 11.5125 14.925C11.3875 14.975 11.2583 15 11.125 15H9.9C9.66667 16.1667 9.09167 17.125 8.175 17.875C7.25833 18.625 6.2 19 5 19ZM19 17C19.8333 17 20.5417 16.7083 21.125 16.125C21.7083 15.5417 22 14.8333 22 14C22 13.1667 21.7083 12.4583 21.125 11.875C20.5417 11.2917 19.8333 11 19 11C18.1667 11 17.4583 11.2917 16.875 11.875C16.2917 12.4583 16 13.1667 16 14C16 14.8333 16.2917 15.5417 16.875 16.125C17.4583 16.7083 18.1667 17 19 17ZM5 17C5.63333 17 6.20417 16.8167 6.7125 16.45C7.22083 16.0833 7.58333 15.6 7.8 15H6C5.71667 15 5.47917 14.9042 5.2875 14.7125C5.09583 14.5208 5 14.2833 5 14C5 13.7167 5.09583 13.4792 5.2875 13.2875C5.47917 13.0958 5.71667 13 6 13H7.8C7.58333 12.4 7.22083 11.9167 6.7125 11.55C6.20417 11.1833 5.63333 11 5 11C4.16667 11 3.45833 11.2917 2.875 11.875C2.29167 12.4583 2 13.1667 2 14C2 14.8333 2.29167 15.5417 2.875 16.125C3.45833 16.7083 4.16667 17 5 17ZM9.95 13H10.7L12.7 11H8.95C9.2 11.2833 9.40833 11.5917 9.575 11.925C9.74167 12.2583 9.86667 12.6167 9.95 13Z",
    fill: "currentColor"
  }
) }), wge = Q("IconMotorcycle")(Sde), Mde = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M2 20V8.85C2 7.43333 2.36667 6.20417 3.1 5.1625C3.83333 4.12083 4.86667 3.33333 6.2 2.8C7.1 2.45 8.05833 2.22917 9.075 2.1375C10.0917 2.04583 11.0667 2 12 2C12.9333 2 13.9083 2.04583 14.925 2.1375C15.9417 2.22917 16.9 2.45 17.8 2.8C19.1333 3.33333 20.1667 4.12083 20.9 5.1625C21.6333 6.20417 22 7.43333 22 8.85V20C22 20.55 21.8042 21.0208 21.4125 21.4125C21.0208 21.8042 20.55 22 20 22H4C3.45 22 2.97917 21.8042 2.5875 21.4125C2.19583 21.0208 2 20.55 2 20ZM7.5 13V9H16.5V13H7.5ZM15.5 16.5C15.2167 16.5 14.9792 16.4042 14.7875 16.2125C14.5958 16.0208 14.5 15.7833 14.5 15.5C14.5 15.2167 14.5958 14.9792 14.7875 14.7875C14.9792 14.5958 15.2167 14.5 15.5 14.5C15.7833 14.5 16.0208 14.5958 16.2125 14.7875C16.4042 14.9792 16.5 15.2167 16.5 15.5C16.5 15.7833 16.4042 16.0208 16.2125 16.2125C16.0208 16.4042 15.7833 16.5 15.5 16.5ZM8.5 16.5C8.21667 16.5 7.97917 16.4042 7.7875 16.2125C7.59583 16.0208 7.5 15.7833 7.5 15.5C7.5 15.2167 7.59583 14.9792 7.7875 14.7875C7.97917 14.5958 8.21667 14.5 8.5 14.5C8.78333 14.5 9.02083 14.5958 9.2125 14.7875C9.40417 14.9792 9.5 15.2167 9.5 15.5C9.5 15.7833 9.40417 16.0208 9.2125 16.2125C9.02083 16.4042 8.78333 16.5 8.5 16.5ZM4 20H20V8.85C20 7.85 19.7542 6.99583 19.2625 6.2875C18.7708 5.57917 18.0333 5.03333 17.05 4.65C16.3167 4.36667 15.5042 4.1875 14.6125 4.1125C13.7208 4.0375 12.85 4 12 4C11.15 4 10.2792 4.0375 9.3875 4.1125C8.49583 4.1875 7.68333 4.36667 6.95 4.65C5.96667 5.03333 5.22917 5.57917 4.7375 6.2875C4.24583 6.99583 4 7.85 4 8.85V20ZM10.6 18.5H13.35L14.625 19.775C14.7083 19.8583 14.7958 19.9167 14.8875 19.95C14.9792 19.9833 15.075 20 15.175 20C15.5083 20 15.7375 19.8417 15.8625 19.525C15.9875 19.2083 15.9333 18.9333 15.7 18.7L15.45 18.45C16.1833 18.35 16.7917 18.0208 17.275 17.4625C17.7583 16.9042 18 16.25 18 15.5V9C18 7.7 17.4167 6.875 16.25 6.525C15.0833 6.175 13.6667 6 12 6C10.4833 6 9.10417 6.175 7.8625 6.525C6.62083 6.875 6 7.7 6 9V15.5C6 16.25 6.24167 16.9042 6.725 17.4625C7.20833 18.0208 7.81667 18.35 8.55 18.45L8.275 18.725C8.04167 18.9583 7.9875 19.2292 8.1125 19.5375C8.2375 19.8458 8.46667 20 8.8 20C8.9 20 8.99167 19.9833 9.075 19.95C9.15833 19.9167 9.24167 19.8583 9.325 19.775L10.6 18.5ZM4 20V8.85C4 7.85 4.24583 6.99583 4.7375 6.2875C5.22917 5.57917 5.96667 5.03333 6.95 4.65C7.68333 4.36667 8.49583 4.1875 9.3875 4.1125C10.2792 4.0375 11.15 4 12 4C12.85 4 13.7208 4.0375 14.6125 4.1125C15.5042 4.1875 16.3167 4.36667 17.05 4.65C18.0333 5.03333 18.7708 5.57917 19.2625 6.2875C19.7542 6.99583 20 7.85 20 8.85V20H4Z",
    fill: "currentColor"
  }
) }), xge = Q("IconSubway")(Mde), Ede = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M4 17.5V8C4 6.38333 4.70833 5.325 6.125 4.825C7.54167 4.325 9.16667 4.05 11 4L11.75 2.5H7.75C7.53333 2.5 7.35417 2.42917 7.2125 2.2875C7.07083 2.14583 7 1.96667 7 1.75C7 1.53333 7.07083 1.35417 7.2125 1.2125C7.35417 1.07083 7.53333 1 7.75 1H16.25C16.4667 1 16.6458 1.07083 16.7875 1.2125C16.9292 1.35417 17 1.53333 17 1.75C17 1.96667 16.9292 2.14583 16.7875 2.2875C16.6458 2.42917 16.4667 2.5 16.25 2.5H13.75L13 4C14.9833 4.05 16.6458 4.32083 17.9875 4.8125C19.3292 5.30417 20 6.36667 20 8V17.5C20 18.4833 19.6625 19.3125 18.9875 19.9875C18.3125 20.6625 17.4833 21 16.5 21L17 21.5C17.2833 21.7833 17.35 22.1042 17.2 22.4625C17.05 22.8208 16.775 23 16.375 23C16.2583 23 16.1458 22.9792 16.0375 22.9375C15.9292 22.8958 15.8333 22.8333 15.75 22.75L14 21H10L8.25 22.75C8.16667 22.8333 8.07083 22.8958 7.9625 22.9375C7.85417 22.9792 7.74167 23 7.625 23C7.24167 23 6.97083 22.8208 6.8125 22.4625C6.65417 22.1042 6.71667 21.7833 7 21.5L7.5 21C6.51667 21 5.6875 20.6625 5.0125 19.9875C4.3375 19.3125 4 18.4833 4 17.5ZM12 18C12.4167 18 12.7708 17.8542 13.0625 17.5625C13.3542 17.2708 13.5 16.9167 13.5 16.5C13.5 16.0833 13.3542 15.7292 13.0625 15.4375C12.7708 15.1458 12.4167 15 12 15C11.5833 15 11.2292 15.1458 10.9375 15.4375C10.6458 15.7292 10.5 16.0833 10.5 16.5C10.5 16.9167 10.6458 17.2708 10.9375 17.5625C11.2292 17.8542 11.5833 18 12 18ZM6 12H18V9H6V12ZM7.5 19H16.5C16.9333 19 17.2917 18.8583 17.575 18.575C17.8583 18.2917 18 17.9333 18 17.5V14H6V17.5C6 17.9333 6.14167 18.2917 6.425 18.575C6.70833 18.8583 7.06667 19 7.5 19ZM11.95 6C9.71667 6 8.28333 6.12083 7.65 6.3625C7.01667 6.60417 6.6 6.81667 6.4 7H17.65C17.45 6.76667 17.0167 6.54167 16.35 6.325C15.6833 6.10833 14.2167 6 11.95 6Z",
    fill: "currentColor"
  }
) }), Sge = Q("IconTram")(Ede), _de = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M12 20.325C11.7667 20.325 11.5292 20.2833 11.2875 20.2C11.0458 20.1167 10.8333 19.9833 10.65 19.8L8.925 18.225C7.15833 16.6083 5.5625 15.0042 4.1375 13.4125C2.7125 11.8208 2 10.0667 2 8.14999C2 6.58333 2.525 5.27499 3.575 4.22499C4.625 3.17499 5.93333 2.64999 7.5 2.64999C8.38333 2.64999 9.21667 2.83749 10 3.21249C10.7833 3.58749 11.45 4.09999 12 4.74999C12.55 4.09999 13.2167 3.58749 14 3.21249C14.7833 2.83749 15.6167 2.64999 16.5 2.64999C18.0667 2.64999 19.375 3.17499 20.425 4.22499C21.475 5.27499 22 6.58333 22 8.14999C22 10.0667 21.2917 11.825 19.875 13.425C18.4583 15.025 16.85 16.6333 15.05 18.25L13.35 19.8C13.1667 19.9833 12.9542 20.1167 12.7125 20.2C12.4708 20.2833 12.2333 20.325 12 20.325ZM11.05 6.74999C10.5667 6.06666 10.05 5.54583 9.5 5.18749C8.95 4.82916 8.28333 4.64999 7.5 4.64999C6.5 4.64999 5.66667 4.98333 5 5.64999C4.33333 6.31666 4 7.14999 4 8.14999C4 9.01666 4.30833 9.93749 4.925 10.9125C5.54167 11.8875 6.27917 12.8333 7.1375 13.75C7.99583 14.6667 8.87917 15.525 9.7875 16.325C10.6958 17.125 11.4333 17.7833 12 18.3C12.5667 17.7833 13.3042 17.125 14.2125 16.325C15.1208 15.525 16.0042 14.6667 16.8625 13.75C17.7208 12.8333 18.4583 11.8875 19.075 10.9125C19.6917 9.93749 20 9.01666 20 8.14999C20 7.14999 19.6667 6.31666 19 5.64999C18.3333 4.98333 17.5 4.64999 16.5 4.64999C15.7167 4.64999 15.05 4.82916 14.5 5.18749C13.95 5.54583 13.4333 6.06666 12.95 6.74999C12.8333 6.91666 12.6917 7.04166 12.525 7.12499C12.3583 7.20833 12.1833 7.24999 12 7.24999C11.8167 7.24999 11.6417 7.20833 11.475 7.12499C11.3083 7.04166 11.1667 6.91666 11.05 6.74999Z",
    fill: "currentColor"
  }
) }), Mge = Q("IconFavorite")(_de), Ode = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M12 20.325C11.7667 20.325 11.5292 20.2833 11.2875 20.2C11.0458 20.1167 10.8333 19.9833 10.65 19.8L8.925 18.225C7.15833 16.6083 5.5625 15.0042 4.1375 13.4125C2.7125 11.8208 2 10.0667 2 8.14999C2 6.58333 2.525 5.27499 3.575 4.22499C4.625 3.17499 5.93333 2.64999 7.5 2.64999C8.38333 2.64999 9.21667 2.83749 10 3.21249C10.7833 3.58749 11.45 4.09999 12 4.74999C12.55 4.09999 13.2167 3.58749 14 3.21249C14.7833 2.83749 15.6167 2.64999 16.5 2.64999C18.0667 2.64999 19.375 3.17499 20.425 4.22499C21.475 5.27499 22 6.58333 22 8.14999C22 10.0667 21.2917 11.825 19.875 13.425C18.4583 15.025 16.85 16.6333 15.05 18.25L13.35 19.8C13.1667 19.9833 12.9542 20.1167 12.7125 20.2C12.4708 20.2833 12.2333 20.325 12 20.325Z",
    fill: "currentColor"
  }
) }), Ege = Q("IconFavoriteFilled")(Ode), Ade = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M7.625 6.4L10.425 2.775C10.625 2.50833 10.8625 2.3125 11.1375 2.1875C11.4125 2.0625 11.7 2 12 2C12.3 2 12.5875 2.0625 12.8625 2.1875C13.1375 2.3125 13.375 2.50833 13.575 2.775L16.375 6.4L20.625 7.825C21.0583 7.95833 21.4 8.20417 21.65 8.5625C21.9 8.92083 22.025 9.31667 22.025 9.75C22.025 9.95 21.9958 10.15 21.9375 10.35C21.8792 10.55 21.7833 10.7417 21.65 10.925L18.9 14.825L19 18.925C19.0167 19.5083 18.825 20 18.425 20.4C18.025 20.8 17.5583 21 17.025 21C16.9917 21 16.8083 20.975 16.475 20.925L12 19.675L7.525 20.925C7.44167 20.9583 7.35 20.9792 7.25 20.9875C7.15 20.9958 7.05833 21 6.975 21C6.44167 21 5.975 20.8 5.575 20.4C5.175 20 4.98333 19.5083 5 18.925L5.1 14.8L2.375 10.925C2.24167 10.7417 2.14583 10.55 2.0875 10.35C2.02917 10.15 2 9.95 2 9.75C2 9.33333 2.12083 8.94583 2.3625 8.5875C2.60417 8.22917 2.94167 7.975 3.375 7.825L7.625 6.4ZM8.85 8.125L4 9.725L7.1 14.2L7 18.975L12 17.6L17 19L16.9 14.2L20 9.775L15.15 8.125L12 4L8.85 8.125Z",
    fill: "currentColor"
  }
) }), _ge = Q("IconKidStar")(Ade), Pde = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M7.625 6.4L10.425 2.775C10.625 2.50833 10.8625 2.3125 11.1375 2.1875C11.4125 2.0625 11.7 2 12 2C12.3 2 12.5875 2.0625 12.8625 2.1875C13.1375 2.3125 13.375 2.50833 13.575 2.775L16.375 6.4L20.625 7.825C21.0583 7.95833 21.4 8.20417 21.65 8.5625C21.9 8.92083 22.025 9.31667 22.025 9.75C22.025 9.95 21.9958 10.15 21.9375 10.35C21.8792 10.55 21.7833 10.7417 21.65 10.925L18.9 14.825L19 18.925C19.0167 19.5083 18.825 20 18.425 20.4C18.025 20.8 17.5583 21 17.025 21C16.9917 21 16.8083 20.975 16.475 20.925L12 19.675L7.525 20.925C7.44167 20.9583 7.35 20.9792 7.25 20.9875C7.15 20.9958 7.05833 21 6.975 21C6.44167 21 5.975 20.8 5.575 20.4C5.175 20 4.98333 19.5083 5 18.925L5.1 14.8L2.375 10.925C2.24167 10.7417 2.14583 10.55 2.0875 10.35C2.02917 10.15 2 9.95 2 9.75C2 9.33333 2.12083 8.94583 2.3625 8.5875C2.60417 8.22917 2.94167 7.975 3.375 7.825L7.625 6.4Z",
    fill: "currentColor"
  }
) }), Oge = Q("IconKidStarFilled")(Pde), Tde = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V10C4 9.45 4.19583 8.97917 4.5875 8.5875C4.97917 8.19583 5.45 8 6 8H7V6C7 4.61667 7.4875 3.4375 8.4625 2.4625C9.4375 1.4875 10.6167 1 12 1C13.3833 1 14.5625 1.4875 15.5375 2.4625C16.5125 3.4375 17 4.61667 17 6V8H18C18.55 8 19.0208 8.19583 19.4125 8.5875C19.8042 8.97917 20 9.45 20 10V20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22H6ZM6 20H18V10H6V20ZM12 17C12.55 17 13.0208 16.8042 13.4125 16.4125C13.8042 16.0208 14 15.55 14 15C14 14.45 13.8042 13.9792 13.4125 13.5875C13.0208 13.1958 12.55 13 12 13C11.45 13 10.9792 13.1958 10.5875 13.5875C10.1958 13.9792 10 14.45 10 15C10 15.55 10.1958 16.0208 10.5875 16.4125C10.9792 16.8042 11.45 17 12 17ZM9 8H15V6C15 5.16667 14.7083 4.45833 14.125 3.875C13.5417 3.29167 12.8333 3 12 3C11.1667 3 10.4583 3.29167 9.875 3.875C9.29167 4.45833 9 5.16667 9 6V8Z",
    fill: "currentColor"
  }
) }), Age = Q("IconLock")(Tde), Ide = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V10C4 9.45 4.19583 8.97917 4.5875 8.5875C4.97917 8.19583 5.45 8 6 8H15V6C15 5.16667 14.7083 4.45833 14.125 3.875C13.5417 3.29167 12.8333 3 12 3C11.3 3 10.6875 3.2125 10.1625 3.6375C9.6375 4.0625 9.28333 4.59167 9.1 5.225C9.03333 5.45833 8.89583 5.64583 8.6875 5.7875C8.47917 5.92917 8.25 6 8 6C7.71667 6 7.47917 5.90833 7.2875 5.725C7.09583 5.54167 7.025 5.325 7.075 5.075C7.30833 3.925 7.88333 2.95833 8.8 2.175C9.71667 1.39167 10.7833 1 12 1C13.3833 1 14.5625 1.4875 15.5375 2.4625C16.5125 3.4375 17 4.61667 17 6V8H18C18.55 8 19.0208 8.19583 19.4125 8.5875C19.8042 8.97917 20 9.45 20 10V20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22H6ZM6 20H18V10H6V20ZM12 17C12.55 17 13.0208 16.8042 13.4125 16.4125C13.8042 16.0208 14 15.55 14 15C14 14.45 13.8042 13.9792 13.4125 13.5875C13.0208 13.1958 12.55 13 12 13C11.45 13 10.9792 13.1958 10.5875 13.5875C10.1958 13.9792 10 14.45 10 15C10 15.55 10.1958 16.0208 10.5875 16.4125C10.9792 16.8042 11.45 17 12 17Z",
    fill: "currentColor"
  }
) }), Pge = Q("IconLockOpen")(Ide), Dde = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M12 16C13.25 16 14.3125 15.5625 15.1875 14.6875C16.0625 13.8125 16.5 12.75 16.5 11.5C16.5 10.25 16.0625 9.1875 15.1875 8.3125C14.3125 7.4375 13.25 7 12 7C10.75 7 9.68752 7.4375 8.81252 8.3125C7.93752 9.1875 7.50002 10.25 7.50002 11.5C7.50002 12.75 7.93752 13.8125 8.81252 14.6875C9.68752 15.5625 10.75 16 12 16ZM12 14.2C11.25 14.2 10.6125 13.9375 10.0875 13.4125C9.56252 12.8875 9.30002 12.25 9.30002 11.5C9.30002 10.75 9.56252 10.1125 10.0875 9.5875C10.6125 9.0625 11.25 8.8 12 8.8C12.75 8.8 13.3875 9.0625 13.9125 9.5875C14.4375 10.1125 14.7 10.75 14.7 11.5C14.7 12.25 14.4375 12.8875 13.9125 13.4125C13.3875 13.9375 12.75 14.2 12 14.2ZM12 19C9.76669 19 7.72919 18.4 5.88752 17.2C4.04586 16 2.59169 14.4167 1.52502 12.45C1.44169 12.3 1.37919 12.1458 1.33752 11.9875C1.29586 11.8292 1.27502 11.6667 1.27502 11.5C1.27502 11.3333 1.29586 11.1708 1.33752 11.0125C1.37919 10.8542 1.44169 10.7 1.52502 10.55C2.59169 8.58333 4.04586 7 5.88752 5.8C7.72919 4.6 9.76669 4 12 4C14.2334 4 16.2709 4.6 18.1125 5.8C19.9542 7 21.4084 8.58333 22.475 10.55C22.5584 10.7 22.6209 10.8542 22.6625 11.0125C22.7042 11.1708 22.725 11.3333 22.725 11.5C22.725 11.6667 22.7042 11.8292 22.6625 11.9875C22.6209 12.1458 22.5584 12.3 22.475 12.45C21.4084 14.4167 19.9542 16 18.1125 17.2C16.2709 18.4 14.2334 19 12 19ZM12 17C13.8834 17 15.6125 16.5042 17.1875 15.5125C18.7625 14.5208 19.9667 13.1833 20.8 11.5C19.9667 9.81667 18.7625 8.47917 17.1875 7.4875C15.6125 6.49583 13.8834 6 12 6C10.1167 6 8.38752 6.49583 6.81252 7.4875C5.23752 8.47917 4.03336 9.81667 3.20002 11.5C4.03336 13.1833 5.23752 14.5208 6.81252 15.5125C8.38752 16.5042 10.1167 17 12 17Z",
    fill: "currentColor"
  }
) }), Tge = Q("IconVisibility")(Dde), Rde = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M15.175 8.32501C15.6583 8.80834 16.0125 9.35834 16.2375 9.97501C16.4625 10.5917 16.5417 11.225 16.475 11.875C16.475 12.125 16.3833 12.3375 16.2 12.5125C16.0167 12.6875 15.8 12.775 15.55 12.775C15.3 12.775 15.0875 12.6875 14.9125 12.5125C14.7375 12.3375 14.65 12.125 14.65 11.875C14.7333 11.4417 14.7083 11.025 14.575 10.625C14.4417 10.225 14.2333 9.88334 13.95 9.60001C13.6667 9.31667 13.325 9.10001 12.925 8.95001C12.525 8.80001 12.1 8.76667 11.65 8.85001C11.4 8.85001 11.1875 8.75834 11.0125 8.57501C10.8375 8.39167 10.75 8.17501 10.75 7.92501C10.75 7.67501 10.8375 7.46251 11.0125 7.28751C11.1875 7.11251 11.4 7.02501 11.65 7.02501C12.2833 6.95834 12.9083 7.03751 13.525 7.26251C14.1417 7.48751 14.6917 7.84167 15.175 8.32501ZM12 6.00001C11.6833 6.00001 11.375 6.01251 11.075 6.03751C10.775 6.06251 10.475 6.10834 10.175 6.17501C9.89167 6.22501 9.6375 6.18334 9.4125 6.05001C9.1875 5.91667 9.03333 5.71667 8.95 5.45001C8.86667 5.18334 8.89583 4.92501 9.0375 4.67501C9.17917 4.42501 9.38333 4.27501 9.65 4.22501C10.0333 4.14167 10.4208 4.08334 10.8125 4.05001C11.2042 4.01667 11.6 4.00001 12 4.00001C14.2833 4.00001 16.3708 4.60001 18.2625 5.80001C20.1542 7.00001 21.6 8.61667 22.6 10.65C22.6667 10.7833 22.7167 10.9208 22.75 11.0625C22.7833 11.2042 22.8 11.35 22.8 11.5C22.8 11.65 22.7875 11.7958 22.7625 11.9375C22.7375 12.0792 22.6917 12.2167 22.625 12.35C22.325 13.0167 21.9542 13.6417 21.5125 14.225C21.0708 14.8083 20.5833 15.3417 20.05 15.825C19.85 16.0083 19.6167 16.0833 19.35 16.05C19.0833 16.0167 18.8667 15.8833 18.7 15.65C18.5333 15.4167 18.4625 15.1625 18.4875 14.8875C18.5125 14.6125 18.625 14.3833 18.825 14.2C19.225 13.8167 19.5917 13.4 19.925 12.95C20.2583 12.5 20.55 12.0167 20.8 11.5C19.9667 9.81667 18.7625 8.47917 17.1875 7.48751C15.6125 6.49584 13.8833 6.00001 12 6.00001ZM12 19C9.76667 19 7.725 18.3958 5.875 17.1875C4.025 15.9792 2.56667 14.3917 1.5 12.425C1.41667 12.2917 1.35417 12.1458 1.3125 11.9875C1.27083 11.8292 1.25 11.6667 1.25 11.5C1.25 11.3333 1.26667 11.175 1.3 11.025C1.33333 10.875 1.39167 10.725 1.475 10.575C1.80833 9.90834 2.19583 9.27084 2.6375 8.66251C3.07917 8.05417 3.58333 7.50001 4.15 7.00001L2.075 4.90001C1.89167 4.70001 1.80417 4.46251 1.8125 4.18751C1.82083 3.91251 1.91667 3.68334 2.1 3.50001C2.28333 3.31667 2.51667 3.22501 2.8 3.22501C3.08333 3.22501 3.31667 3.31667 3.5 3.50001L20.5 20.5C20.6833 20.6833 20.7792 20.9125 20.7875 21.1875C20.7958 21.4625 20.7 21.7 20.5 21.9C20.3167 22.0833 20.0833 22.175 19.8 22.175C19.5167 22.175 19.2833 22.0833 19.1 21.9L15.6 18.45C15.0167 18.6333 14.425 18.7708 13.825 18.8625C13.225 18.9542 12.6167 19 12 19ZM5.55 8.40001C5.06667 8.83334 4.625 9.30834 4.225 9.82501C3.825 10.3417 3.48333 10.9 3.2 11.5C4.03333 13.1833 5.2375 14.5208 6.8125 15.5125C8.3875 16.5042 10.1167 17 12 17C12.3333 17 12.6583 16.9792 12.975 16.9375C13.2917 16.8958 13.6167 16.85 13.95 16.8L13.05 15.85C12.8667 15.9 12.6917 15.9375 12.525 15.9625C12.3583 15.9875 12.1833 16 12 16C10.75 16 9.6875 15.5625 8.8125 14.6875C7.9375 13.8125 7.5 12.75 7.5 11.5C7.5 11.3167 7.5125 11.1417 7.5375 10.975C7.5625 10.8083 7.6 10.6333 7.65 10.45L5.55 8.40001Z",
    fill: "currentColor"
  }
) }), Ige = Q("IconVisibilityOff")(Rde), kde = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M3 18C2.45 18 1.97917 17.8042 1.5875 17.4125C1.19583 17.0208 1 16.55 1 16V4C1 3.45 1.19583 2.97917 1.5875 2.5875C1.97917 2.19583 2.45 2 3 2H19C19.55 2 20.0208 2.19583 20.4125 2.5875C20.8042 2.97917 21 3.45 21 4V8C21 8.28333 20.9042 8.52083 20.7125 8.7125C20.5208 8.90417 20.2833 9 20 9C19.7167 9 19.4792 8.90417 19.2875 8.7125C19.0958 8.52083 19 8.28333 19 8V6L11.525 10.675C11.4417 10.725 11.3542 10.7625 11.2625 10.7875C11.1708 10.8125 11.0833 10.825 11 10.825C10.9167 10.825 10.8292 10.8125 10.7375 10.7875C10.6458 10.7625 10.5583 10.725 10.475 10.675L3 6V16H12C12.2833 16 12.5208 16.0958 12.7125 16.2875C12.9042 16.4792 13 16.7167 13 17C13 17.2833 12.9042 17.5208 12.7125 17.7125C12.5208 17.9042 12.2833 18 12 18H3ZM11 9L19 4H3L11 9ZM19 22C17.9 22 16.9583 21.6083 16.175 20.825C15.3917 20.0417 15 19.1 15 18V13.5C15 12.8 15.2417 12.2083 15.725 11.725C16.2083 11.2417 16.8 11 17.5 11C18.2 11 18.7917 11.2417 19.275 11.725C19.7583 12.2083 20 12.8 20 13.5V17C20 17.2833 19.9042 17.5208 19.7125 17.7125C19.5208 17.9042 19.2833 18 19 18C18.7167 18 18.4792 17.9042 18.2875 17.7125C18.0958 17.5208 18 17.2833 18 17V13.5C18 13.3667 17.95 13.25 17.85 13.15C17.75 13.05 17.6333 13 17.5 13C17.3667 13 17.25 13.05 17.15 13.15C17.05 13.25 17 13.3667 17 13.5V18C17 18.55 17.1958 19.0208 17.5875 19.4125C17.9792 19.8042 18.45 20 19 20C19.55 20 20.0208 19.8042 20.4125 19.4125C20.8042 19.0208 21 18.55 21 18V15C21 14.7167 21.0958 14.4792 21.2875 14.2875C21.4792 14.0958 21.7167 14 22 14C22.2833 14 22.5208 14.0958 22.7125 14.2875C22.9042 14.4792 23 14.7167 23 15V18C23 19.1 22.6083 20.0417 21.825 20.825C21.0417 21.6083 20.1 22 19 22Z",
    fill: "currentColor"
  }
) }), Dge = Q("IconAttachEmail")(kde), Lde = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M7 14V20C7 20.2833 6.90417 20.5208 6.7125 20.7125C6.52083 20.9042 6.28333 21 6 21C5.71667 21 5.47917 20.9042 5.2875 20.7125C5.09583 20.5208 5 20.2833 5 20V5C5 4.71667 5.09583 4.47917 5.2875 4.2875C5.47917 4.09583 5.71667 4 6 4H13.175C13.4083 4 13.6167 4.075 13.8 4.225C13.9833 4.375 14.1 4.56667 14.15 4.8L14.4 6H19C19.2833 6 19.5208 6.09583 19.7125 6.2875C19.9042 6.47917 20 6.71667 20 7V15C20 15.2833 19.9042 15.5208 19.7125 15.7125C19.5208 15.9042 19.2833 16 19 16H13.825C13.5917 16 13.3833 15.925 13.2 15.775C13.0167 15.625 12.9 15.4333 12.85 15.2L12.6 14H7ZM14.65 14H18V8H13.575C13.3417 8 13.1333 7.925 12.95 7.775C12.7667 7.625 12.65 7.43333 12.6 7.2L12.35 6H7V12H13.425C13.6583 12 13.8667 12.075 14.05 12.225C14.2333 12.375 14.35 12.5667 14.4 12.8L14.65 14Z",
    fill: "currentColor"
  }
) }), Rge = Q("IconFlag")(Lde), Nde = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M19.175 11L15.3 7.12499C15.1 6.92499 15 6.68749 15 6.41249C15 6.13749 15.1 5.89999 15.3 5.69999C15.5 5.51665 15.7375 5.42499 16.0125 5.42499C16.2875 5.42499 16.5167 5.51665 16.7 5.69999L21.3 10.3C21.4 10.4 21.4708 10.5083 21.5125 10.625C21.5542 10.7417 21.575 10.8667 21.575 11C21.575 11.1333 21.5542 11.2583 21.5125 11.375C21.4708 11.4917 21.4 11.6 21.3 11.7L16.7 16.3C16.5 16.5 16.2667 16.5958 16 16.5875C15.7333 16.5792 15.5 16.4833 15.3 16.3C15.1 16.1 14.9958 15.8667 14.9875 15.6C14.9792 15.3333 15.075 15.1 15.275 14.9L19.175 11ZM13.175 12H7C6.16667 12 5.45833 12.2917 4.875 12.875C4.29167 13.4583 4 14.1667 4 15V18C4 18.2833 3.90417 18.5208 3.7125 18.7125C3.52083 18.9042 3.28333 19 3 19C2.71667 19 2.47917 18.9042 2.2875 18.7125C2.09583 18.5208 2 18.2833 2 18V15C2 13.6167 2.4875 12.4375 3.4625 11.4625C4.4375 10.4875 5.61667 9.99999 7 9.99999H13.175L10.3 7.12499C10.1 6.92499 10 6.68749 10 6.41249C10 6.13749 10.1 5.89999 10.3 5.69999C10.5 5.51665 10.7375 5.42499 11.0125 5.42499C11.2875 5.42499 11.5167 5.51665 11.7 5.69999L16.3 10.3C16.4 10.4 16.4708 10.5083 16.5125 10.625C16.5542 10.7417 16.575 10.8667 16.575 11C16.575 11.1333 16.5542 11.2583 16.5125 11.375C16.4708 11.4917 16.4 11.6 16.3 11.7L11.7 16.3C11.5 16.5 11.2667 16.5958 11 16.5875C10.7333 16.5792 10.5 16.4833 10.3 16.3C10.1 16.1 9.99583 15.8667 9.9875 15.6C9.97917 15.3333 10.075 15.1 10.275 14.9L13.175 12Z",
    fill: "currentColor"
  }
) }), kge = Q("IconForward")(Nde), Fde = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM5 19H19V16H16C15.5 16.6333 14.9042 17.125 14.2125 17.475C13.5208 17.825 12.7833 18 12 18C11.2167 18 10.4792 17.825 9.7875 17.475C9.09583 17.125 8.5 16.6333 8 16H5V19ZM12 16C12.5333 16 13.025 15.8625 13.475 15.5875C13.925 15.3125 14.2917 14.95 14.575 14.5C14.675 14.35 14.8 14.2292 14.95 14.1375C15.1 14.0458 15.2667 14 15.45 14H19V5H5V14H8.55C8.73333 14 8.9 14.0458 9.05 14.1375C9.2 14.2292 9.325 14.35 9.425 14.5C9.70833 14.95 10.075 15.3125 10.525 15.5875C10.975 15.8625 11.4667 16 12 16Z",
    fill: "currentColor"
  }
) }), Lge = Q("IconInbox")(Fde), Vde = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4ZM20 8L12.525 12.675C12.4417 12.725 12.3542 12.7625 12.2625 12.7875C12.1708 12.8125 12.0833 12.825 12 12.825C11.9167 12.825 11.8292 12.8125 11.7375 12.7875C11.6458 12.7625 11.5583 12.725 11.475 12.675L4 8V18H20V8ZM12 11L20 6H4L12 11ZM4 8.25V6.775V6.8V6.7875V8.25Z",
    fill: "currentColor"
  }
) }), Nge = Q("IconMail")(Vde), Bde = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M6.82502 12L9.72502 14.9C9.92502 15.1 10.0209 15.3333 10.0125 15.6C10.0042 15.8667 9.90002 16.1 9.70002 16.3C9.50002 16.4833 9.26669 16.5792 9.00002 16.5875C8.73336 16.5958 8.50002 16.5 8.30002 16.3L3.70002 11.7C3.50002 11.5 3.40002 11.2667 3.40002 11C3.40002 10.7333 3.50002 10.5 3.70002 10.3L8.30002 5.69999C8.48336 5.51665 8.71252 5.42499 8.98752 5.42499C9.26252 5.42499 9.50002 5.51665 9.70002 5.69999C9.90002 5.89999 10 6.13749 10 6.41249C10 6.68749 9.90002 6.92499 9.70002 7.12499L6.82502 9.99999H16C17.3834 9.99999 18.5625 10.4875 19.5375 11.4625C20.5125 12.4375 21 13.6167 21 15V18C21 18.2833 20.9042 18.5208 20.7125 18.7125C20.5209 18.9042 20.2834 19 20 19C19.7167 19 19.4792 18.9042 19.2875 18.7125C19.0959 18.5208 19 18.2833 19 18V15C19 14.1667 18.7084 13.4583 18.125 12.875C17.5417 12.2917 16.8334 12 16 12H6.82502Z",
    fill: "currentColor"
  }
) }), Fge = Q("IconReply")(Bde), $de = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M4.82499 11L8.72499 14.9C8.92499 15.1 9.02082 15.3333 9.01249 15.6C9.00415 15.8667 8.89999 16.1 8.69999 16.3C8.49999 16.4833 8.26665 16.5792 7.99999 16.5875C7.73332 16.5958 7.49999 16.5 7.29999 16.3L2.69999 11.7C2.59999 11.6 2.52915 11.4917 2.48749 11.375C2.44582 11.2583 2.42499 11.1333 2.42499 11C2.42499 10.8667 2.44582 10.7417 2.48749 10.625C2.52915 10.5083 2.59999 10.4 2.69999 10.3L7.29999 5.69999C7.48332 5.51665 7.71249 5.42499 7.98749 5.42499C8.26249 5.42499 8.49999 5.51665 8.69999 5.69999C8.89999 5.89999 8.99999 6.13749 8.99999 6.41249C8.99999 6.68749 8.89999 6.92499 8.69999 7.12499L4.82499 11ZM10.825 12L13.725 14.9C13.925 15.1 14.0208 15.3333 14.0125 15.6C14.0042 15.8667 13.9 16.1 13.7 16.3C13.5 16.4833 13.2667 16.5792 13 16.5875C12.7333 16.5958 12.5 16.5 12.3 16.3L7.69999 11.7C7.59999 11.6 7.52915 11.4917 7.48749 11.375C7.44582 11.2583 7.42499 11.1333 7.42499 11C7.42499 10.8667 7.44582 10.7417 7.48749 10.625C7.52915 10.5083 7.59999 10.4 7.69999 10.3L12.3 5.69999C12.4833 5.51665 12.7125 5.42499 12.9875 5.42499C13.2625 5.42499 13.5 5.51665 13.7 5.69999C13.9 5.89999 14 6.13749 14 6.41249C14 6.68749 13.9 6.92499 13.7 7.12499L10.825 9.99999H17C18.3833 9.99999 19.5625 10.4875 20.5375 11.4625C21.5125 12.4375 22 13.6167 22 15V18C22 18.2833 21.9042 18.5208 21.7125 18.7125C21.5208 18.9042 21.2833 19 21 19C20.7167 19 20.4792 18.9042 20.2875 18.7125C20.0958 18.5208 20 18.2833 20 18V15C20 14.1667 19.7083 13.4583 19.125 12.875C18.5417 12.2917 17.8333 12 17 12H10.825Z",
    fill: "currentColor"
  }
) }), Vge = Q("IconReplyAll")($de), jde = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M3 18.5V5.49997C3 5.1333 3.14583 4.85414 3.4375 4.66247C3.72917 4.4708 4.04167 4.44164 4.375 4.57497L14.35 8.74997C14.6667 8.8833 14.8583 9.07914 14.925 9.33747C14.9917 9.5958 14.975 9.84164 14.875 10.075C14.775 10.3083 14.6083 10.4916 14.375 10.625C14.1417 10.7583 13.8667 10.7583 13.55 10.625L5 6.99997V10.5L8.1 11.275C8.28333 11.325 8.42083 11.4166 8.5125 11.55C8.60417 11.6833 8.65 11.8333 8.65 12C8.65 12.1666 8.60417 12.3166 8.5125 12.45C8.42083 12.5833 8.28333 12.675 8.1 12.725L5 13.5V17L8.725 15.425C9.04167 15.2916 9.3125 15.2875 9.5375 15.4125C9.7625 15.5375 9.925 15.7166 10.025 15.95C10.125 16.1833 10.1417 16.4291 10.075 16.6875C10.0083 16.9458 9.81667 17.1416 9.5 17.275L4.4 19.425C4.06667 19.5583 3.75 19.5291 3.45 19.3375C3.15 19.1458 3 18.8666 3 18.5ZM17 22C15.6167 22 14.4375 21.5125 13.4625 20.5375C12.4875 19.5625 12 18.3833 12 17C12 15.6166 12.4875 14.4375 13.4625 13.4625C14.4375 12.4875 15.6167 12 17 12C18.3833 12 19.5625 12.4875 20.5375 13.4625C21.5125 14.4375 22 15.6166 22 17C22 18.3833 21.5125 19.5625 20.5375 20.5375C19.5625 21.5125 18.3833 22 17 22ZM17.5 16.8V14.5C17.5 14.3666 17.45 14.25 17.35 14.15C17.25 14.05 17.1333 14 17 14C16.8667 14 16.75 14.05 16.65 14.15C16.55 14.25 16.5 14.3666 16.5 14.5V16.775C16.5 16.9083 16.525 17.0375 16.575 17.1625C16.625 17.2875 16.7 17.4 16.8 17.5L18.3 19C18.4 19.1 18.5167 19.15 18.65 19.15C18.7833 19.15 18.9 19.1 19 19C19.1 18.9 19.15 18.7833 19.15 18.65C19.15 18.5166 19.1 18.4 19 18.3L17.5 16.8Z",
    fill: "currentColor"
  }
) }), Bge = Q("IconScheduleSend")(jde), Hde = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M19.8 12.925L4.4 19.425C4.06667 19.5583 3.75 19.5291 3.45 19.3375C3.15 19.1458 3 18.8666 3 18.5V5.49997C3 5.1333 3.15 4.85414 3.45 4.66247C3.75 4.4708 4.06667 4.44164 4.4 4.57497L19.8 11.075C20.2167 11.2583 20.425 11.5666 20.425 12C20.425 12.4333 20.2167 12.7416 19.8 12.925ZM5 17L16.85 12L5 6.99997V10.5L11 12L5 13.5V17Z",
    fill: "currentColor"
  }
) }), $ge = Q("IconSend")(Hde);
var zde = /* @__PURE__ */ ((e) => (e[e.VERY_LOW = 0] = "VERY_LOW", e[e.LOW = 1] = "LOW", e[e.MEDIUM = 2] = "MEDIUM", e[e.HIGH = 3] = "HIGH", e[e.VERY_HIGH = 4] = "VERY_HIGH", e))(zde || {});
const jge = ({ status: e }) => {
  const t = () => {
    switch (e) {
      case 0:
        return { rotate: "rotate(0 112 92)", color: "#E96359" };
      case 1:
        return { rotate: "rotate(50 112 92)", color: "#FFCB6D" };
      case 2:
        return { rotate: "rotate(105 112 92)", color: "#A4CD8F" };
      case 3:
        return { rotate: "rotate(160 112 92)", color: "#60A85F" };
      case 4:
        return { rotate: "rotate(210 112 92)", color: "#357443" };
    }
  };
  return /* @__PURE__ */ d("svg", { viewBox: "0 0 220 150", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ F("g", { clipPath: "url(#clip0_6377_89481)", children: [
    /* @__PURE__ */ d(
      "path",
      {
        d: "M111.997 52.4824C89.6193 52.4824 71.4756 70.6261 71.4756 93.0035C71.4756 115.381 89.6193 133.525 111.997 133.525C134.374 133.525 152.518 115.381 152.518 93.0035C152.518 70.6261 134.374 52.4824 111.997 52.4824ZM111.997 125.406C94.0975 125.406 79.5938 110.896 79.5938 93.0035C79.5938 75.1114 94.1045 60.6006 111.997 60.6006C129.889 60.6006 144.4 75.1114 144.4 93.0035C144.4 110.896 129.889 125.406 111.997 125.406Z",
        fill: t().color
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        d: "M89.0114 50.8899C77.8332 57.003 69.3517 67.4477 65.8306 79.9603L29.6899 71.7094C32.5124 60.7757 37.4518 50.7013 44.047 41.9404C45.0251 40.6339 46.0381 39.3694 47.1 38.1258C54.2401 29.6723 63.0151 22.637 72.9287 17.502L89.0114 50.8899Z",
        fill: "#FFCB6D"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        d: "M146.67 15.3776L130.594 48.7656C124.879 46.3623 118.592 45.0279 111.997 45.0279C105.401 45.0279 99.1276 46.3553 93.4128 48.7656L77.3301 15.3776C87.9215 10.6339 99.6516 8 111.997 8C124.342 8 136.079 10.6339 146.67 15.3776Z",
        fill: "#A4CD8F"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        d: "M194.311 71.7094L158.177 79.9603C154.649 67.4477 146.174 57.003 134.989 50.8899L151.072 17.502C160.986 22.637 169.761 29.6723 176.901 38.1258C177.963 39.3694 178.976 40.6339 179.954 41.9404C186.549 50.7013 191.488 60.7757 194.311 71.7094Z",
        fill: "#60A85F"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        d: "M197 93.0033C197 98.6553 196.448 104.182 195.393 109.526C195.079 111.133 194.715 112.726 194.31 114.298C191.495 125.225 186.555 135.306 179.953 144.067L150.98 120.963C156.646 113.096 159.972 103.434 159.972 93.0033C159.972 90.1808 159.727 87.4142 159.259 84.7244L195.393 76.4805C196.448 81.8251 197 87.3513 197 93.0033Z",
        fill: "#357443"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        d: "M73.0199 120.963L44.0473 144.067C37.4452 135.306 32.5058 125.225 29.6903 114.298C29.285 112.726 28.9217 111.133 28.6074 109.526C27.5524 104.182 27.0005 98.6553 27.0005 93.0033C27.0005 87.3513 27.5524 81.8251 28.6074 76.4805L64.741 84.7244C64.2729 87.4142 64.0284 90.1808 64.0284 93.0033C64.0284 103.434 67.3609 113.096 73.0199 120.963Z",
        fill: "#E96359"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        d: "M29.6898 114.298C29.2846 112.726 28.9213 111.133 28.6069 109.526L29.6898 114.298Z",
        fill: "#231F20"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        d: "M111.997 101.932C107.546 101.932 103.69 98.9137 102.607 94.5962C101.314 89.4122 104.472 84.1445 109.656 82.852C110.432 82.6564 111.221 82.5586 112.011 82.5586C116.461 82.5586 120.317 85.5767 121.4 89.8943C122.029 92.4024 121.638 95.0084 120.31 97.223C118.976 99.4377 116.866 101.01 114.358 101.638C113.582 101.834 112.793 101.932 112.004 101.932H111.997Z",
        fill: "#231F20",
        transform: t().rotate
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        d: "M112.004 83.6067C115.874 83.6067 119.395 86.2266 120.373 90.1529C121.533 94.7779 118.718 99.4728 114.086 100.626C113.38 100.8 112.681 100.884 111.983 100.884C108.112 100.884 104.591 98.2641 103.613 94.3378C102.453 89.7128 105.269 85.0179 109.901 83.8652C110.606 83.6905 111.305 83.6067 112.004 83.6067ZM112.004 81.5107C111.13 81.5107 110.25 81.6225 109.398 81.8321C106.617 82.5238 104.27 84.2634 102.796 86.7226C101.321 89.1818 100.888 92.0672 101.587 94.8478C102.782 99.6335 107.064 102.98 111.99 102.98C112.863 102.98 113.743 102.868 114.596 102.659C117.376 101.967 119.724 100.227 121.198 97.7681C122.672 95.3089 123.105 92.4235 122.406 89.6429C121.212 84.8572 116.929 81.5107 112.004 81.5107Z",
        fill: "white",
        transform: t().rotate
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        d: "M55.2185 108.611C54.1705 108.611 53.2972 107.877 53.1016 106.829C52.906 105.788 53.4579 104.796 54.45 104.405L95.5649 88.3432C95.8234 88.2453 96.0889 88.1895 96.3614 88.1895C96.9762 88.1895 97.57 88.4549 97.9822 88.923C98.3944 89.3841 98.5831 90.0059 98.5132 90.6207C98.3176 92.2625 98.4224 93.9113 98.8276 95.5322C99.2328 97.153 99.9175 98.6621 100.861 100.017C101.301 100.653 101.378 101.45 101.063 102.148C100.749 102.854 100.099 103.322 99.3376 103.413L55.4979 108.583C55.4001 108.597 55.3093 108.597 55.2185 108.597V108.611Z",
        fill: "#231F20",
        transform: t().rotate
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        d: "M96.3543 89.2444C96.997 89.2444 97.549 89.8033 97.4651 90.5019C97.2555 92.2206 97.3533 94.0091 97.8005 95.7976C98.2476 97.5791 99.0021 99.207 99.9942 100.625C100.483 101.324 100.05 102.281 99.2047 102.386L55.3651 107.556C55.3092 107.556 55.2603 107.563 55.2114 107.563C54.0167 107.563 53.6395 105.844 54.8202 105.383L95.9351 89.3212C96.0748 89.2653 96.2146 89.2444 96.3473 89.2444M96.3543 87.1484C95.9561 87.1484 95.5578 87.2253 95.1806 87.372L54.0656 103.434C52.5985 104.007 51.7811 105.481 52.0675 107.025C52.361 108.576 53.6534 109.659 55.2114 109.659C55.3441 109.659 55.4769 109.652 55.6096 109.638L99.4493 104.468C100.588 104.335 101.545 103.629 102.006 102.588C102.474 101.547 102.363 100.367 101.706 99.4235C100.833 98.173 100.204 96.7827 99.8265 95.2876C99.4562 93.7925 99.3584 92.2695 99.5401 90.7534C99.6519 89.8382 99.3654 88.923 98.7576 88.2313C98.1428 87.5397 97.2695 87.1484 96.3473 87.1484H96.3543Z",
        fill: "white",
        transform: t().rotate
      }
    )
  ] }) });
}, Zde = ({
  hoverable: e = !0,
  focusable: t = !0,
  dropdownItem: n = !1,
  negativeMargin: r = !1,
  children: o,
  className: i,
  LinkComponent: a,
  ...s
}) => {
  const l = e && !n, u = I(
    "flex w-full flex-1 justify-between py-1 outline-none",
    l && "px-1 hover:rounded-md hover:bg-surface-common-card-hover focus:rounded-md focus:bg-surface-common-card-hover focus:outline-1 focus:outline-surface-common-primary",
    t && !n && "focus:outline-1 focus:outline-surface-common-primary",
    n && "cursor-pointer py-0",
    r && "-mx-1 w-[calc(100%+1rem)]",
    i
  ), f = l ? "button" : "div", h = n ? "option" : void 0;
  return a ? O.cloneElement(a, {
    className: u,
    ...s,
    // @ts-expect-error: disable-next-line
    children: o
  }) : /* @__PURE__ */ d(f, { className: u, ...s, role: h, children: o });
}, Wde = ({
  flexDirection: e = "row",
  className: t,
  children: n,
  ...r
}) => {
  const o = I("flex", e === "row" ? "flex-row gap-1 items-center" : "flex-col", t);
  return /* @__PURE__ */ d("div", { className: o, ...r, children: n });
}, qde = ({
  children: e,
  className: t,
  ...n
}) => {
  const r = I("flex flex-col text-right", t);
  return /* @__PURE__ */ d("div", { className: r, ...n, children: e });
}, Ot = Object.assign(Zde, {
  Left: Wde,
  Right: qde
});
Ot.displayName = "ItemBlockBase";
Ot.Left.displayName = "ItemBlockBase.Left";
Ot.Right.displayName = "ItemBlockBase.Right";
const Hge = ({
  label: e,
  description: t,
  amount: n,
  image: r,
  ...o
}) => {
  const i = Ma(n);
  return /* @__PURE__ */ F(Ot, { ...o, children: [
    /* @__PURE__ */ F(Ot.Left, { flexDirection: "row", children: [
      r,
      /* @__PURE__ */ F("div", { className: "flex flex-col", children: [
        e && /* @__PURE__ */ d(Ye, { primary: !0, className: "text-left text-sm font-semibold", children: e }),
        t && /* @__PURE__ */ d(Ye, { primary: !0, className: "text-left text-sm font-normal", children: t })
      ] })
    ] }),
    n && /* @__PURE__ */ d(Ot.Right, { className: "justify-center", children: /* @__PURE__ */ d(Ye, { primary: !0, className: "text-right font-semibold", children: i }) })
  ] });
}, zge = ({
  LeftContent: e,
  RightContent: t,
  ...n
}) => /* @__PURE__ */ F(Ot, { ...n, children: [
  /* @__PURE__ */ d(Ot.Left, { flexDirection: "row", children: e }),
  /* @__PURE__ */ d(Ot.Right, { className: "justify-center", children: t })
] }), Zge = ({
  label: e,
  chipText: t,
  description: n,
  rightDescription: r,
  amount: o,
  ...i
}) => /* @__PURE__ */ F(Ot, { ...i, children: [
  /* @__PURE__ */ F(Ot.Left, { flexDirection: "column", children: [
    /* @__PURE__ */ d(Ye, { primary: !0, weight: "semibold", children: e }),
    /* @__PURE__ */ d(Ye, { primary: !0, className: "text-left text-sm font-normal", children: n }),
    t && /* @__PURE__ */ d(zd, { variant: "default", label: t })
  ] }),
  /* @__PURE__ */ F(Ot.Right, { children: [
    o && /* @__PURE__ */ F(Ye, { primary: !0, className: "text-right font-semibold", children: [
      o,
      ",-"
    ] }),
    r && /* @__PURE__ */ d(Ye, { primary: !0, className: "text-small font-normal", children: r })
  ] })
] }), Wge = ({
  children: e,
  ...t
}) => /* @__PURE__ */ d(Ot, { ...t, children: e }), qge = ({
  label: e,
  description: t,
  progress: n,
  amount: r,
  image: o,
  ...i
}) => /* @__PURE__ */ F(Ot, { ...i, children: [
  /* @__PURE__ */ F(Ot.Left, { flexDirection: "row", children: [
    o,
    /* @__PURE__ */ F("div", { className: "flex flex-col", children: [
      /* @__PURE__ */ d(Ye, { primary: !0, weight: "semibold", children: e }),
      /* @__PURE__ */ d(Ye, { primary: !0, className: "text-left text-sm font-normal", children: t })
    ] })
  ] }),
  /* @__PURE__ */ F(Ot.Right, { className: "justify-center", children: [
    /* @__PURE__ */ F(Ye, { primary: !0, className: "text-right font-semibold", children: [
      r,
      ",-"
    ] }),
    /* @__PURE__ */ d(
      "progress",
      {
        className: "h-1 w-13 [&::-moz-progress-bar]:bg-surface-common-primary [&::-webkit-progress-bar]:rounded-lg [&::-webkit-progress-bar]:bg-surface-common-light [&::-webkit-progress-value]:rounded-lg [&::-webkit-progress-value]:bg-surface-common-primary",
        value: n,
        max: "10"
      }
    )
  ] })
] }), Uge = ({
  label: e,
  amount: t,
  image: n,
  ...r
}) => /* @__PURE__ */ F(Ot, { ...r, children: [
  /* @__PURE__ */ F(Ot.Left, { flexDirection: "row", children: [
    n,
    /* @__PURE__ */ F(Ye, { primary: !0, weight: "semibold", children: [
      e,
      " "
    ] })
  ] }),
  /* @__PURE__ */ d(Ot.Right, { children: /* @__PURE__ */ F(Ye, { primary: !0, weight: "semibold", children: [
    t,
    ",-"
  ] }) })
] }), Gge = ({
  label: e,
  amount: t,
  hoverable: n = !1,
  ...r
}) => /* @__PURE__ */ F(Ot, { hoverable: n, ...r, children: [
  /* @__PURE__ */ d(Ot.Left, { flexDirection: "row", children: /* @__PURE__ */ d(Ye, { primary: !0, weight: "semibold", children: e }) }),
  /* @__PURE__ */ d(Ot.Right, { children: /* @__PURE__ */ F(Ye, { primary: !0, weight: "semibold", children: [
    t,
    ",-"
  ] }) })
] }), Kge = ({
  label: e,
  chipText: t,
  description: n,
  image: r,
  ...o
}) => /* @__PURE__ */ F(Ot, { ...o, children: [
  /* @__PURE__ */ F(Ot.Left, { flexDirection: "row", children: [
    r,
    /* @__PURE__ */ F("div", { className: "flex flex-col", children: [
      /* @__PURE__ */ d(Ye, { primary: !0, weight: "semibold", children: e }),
      n && /* @__PURE__ */ d(Ye, { primary: !0, className: "text-left text-sm font-normal", children: n })
    ] })
  ] }),
  /* @__PURE__ */ d(Ot.Right, { className: "justify-center text-center", children: t && /* @__PURE__ */ d(zd, { variant: "default", label: t }) })
] }), Ude = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M8.25 18C6.51667 18 5.04167 17.3917 3.825 16.175C2.60833 14.9583 2 13.4833 2 11.75C2 10.0167 2.60833 8.54167 3.825 7.325C5.04167 6.10833 6.51667 5.5 8.25 5.5H17.5C18.75 5.5 19.8125 5.9375 20.6875 6.8125C21.5625 7.6875 22 8.75 22 10C22 11.25 21.5625 12.3125 20.6875 13.1875C19.8125 14.0625 18.75 14.5 17.5 14.5H8.75C7.98333 14.5 7.33333 14.2333 6.8 13.7C6.26667 13.1667 6 12.5167 6 11.75C6 10.9833 6.26667 10.3333 6.8 9.8C7.33333 9.26667 7.98333 9 8.75 9H17C17.2833 9 17.5208 9.09583 17.7125 9.2875C17.9042 9.47917 18 9.71667 18 10C18 10.2833 17.9042 10.5208 17.7125 10.7125C17.5208 10.9042 17.2833 11 17 11H8.75C8.53333 11 8.35417 11.0708 8.2125 11.2125C8.07083 11.3542 8 11.5333 8 11.75C8 11.9667 8.07083 12.1458 8.2125 12.2875C8.35417 12.4292 8.53333 12.5 8.75 12.5H17.5C18.2 12.4833 18.7917 12.2375 19.275 11.7625C19.7583 11.2875 20 10.7 20 10C20 9.3 19.7583 8.70833 19.275 8.225C18.7917 7.74167 18.2 7.5 17.5 7.5H8.25C7.06667 7.48333 6.0625 7.89167 5.2375 8.725C4.4125 9.55833 4 10.5667 4 11.75C4 12.9167 4.4125 13.9083 5.2375 14.725C6.0625 15.5417 7.06667 15.9667 8.25 16H17C17.2833 16 17.5208 16.0958 17.7125 16.2875C17.9042 16.4792 18 16.7167 18 17C18 17.2833 17.9042 17.5208 17.7125 17.7125C17.5208 17.9042 17.2833 18 17 18H8.25Z",
    fill: "currentColor"
  }
) }), Yge = Q("IconAttachment")(Ude), Gde = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V6C3 5.45 3.19583 4.97917 3.5875 4.5875C3.97917 4.19583 4.45 4 5 4H6V3C6 2.71667 6.09583 2.47917 6.2875 2.2875C6.47917 2.09583 6.71667 2 7 2C7.28333 2 7.52083 2.09583 7.7125 2.2875C7.90417 2.47917 8 2.71667 8 3V4H16V3C16 2.71667 16.0958 2.47917 16.2875 2.2875C16.4792 2.09583 16.7167 2 17 2C17.2833 2 17.5208 2.09583 17.7125 2.2875C17.9042 2.47917 18 2.71667 18 3V4H19C19.55 4 20.0208 4.19583 20.4125 4.5875C20.8042 4.97917 21 5.45 21 6V20C21 20.55 20.8042 21.0208 20.4125 21.4125C20.0208 21.8042 19.55 22 19 22H5ZM5 20H19V10H5V20ZM5 8H19V6H5V8ZM12 14C11.7167 14 11.4792 13.9042 11.2875 13.7125C11.0958 13.5208 11 13.2833 11 13C11 12.7167 11.0958 12.4792 11.2875 12.2875C11.4792 12.0958 11.7167 12 12 12C12.2833 12 12.5208 12.0958 12.7125 12.2875C12.9042 12.4792 13 12.7167 13 13C13 13.2833 12.9042 13.5208 12.7125 13.7125C12.5208 13.9042 12.2833 14 12 14ZM8 14C7.71667 14 7.47917 13.9042 7.2875 13.7125C7.09583 13.5208 7 13.2833 7 13C7 12.7167 7.09583 12.4792 7.2875 12.2875C7.47917 12.0958 7.71667 12 8 12C8.28333 12 8.52083 12.0958 8.7125 12.2875C8.90417 12.4792 9 12.7167 9 13C9 13.2833 8.90417 13.5208 8.7125 13.7125C8.52083 13.9042 8.28333 14 8 14ZM16 14C15.7167 14 15.4792 13.9042 15.2875 13.7125C15.0958 13.5208 15 13.2833 15 13C15 12.7167 15.0958 12.4792 15.2875 12.2875C15.4792 12.0958 15.7167 12 16 12C16.2833 12 16.5208 12.0958 16.7125 12.2875C16.9042 12.4792 17 12.7167 17 13C17 13.2833 16.9042 13.5208 16.7125 13.7125C16.5208 13.9042 16.2833 14 16 14ZM12 18C11.7167 18 11.4792 17.9042 11.2875 17.7125C11.0958 17.5208 11 17.2833 11 17C11 16.7167 11.0958 16.4792 11.2875 16.2875C11.4792 16.0958 11.7167 16 12 16C12.2833 16 12.5208 16.0958 12.7125 16.2875C12.9042 16.4792 13 16.7167 13 17C13 17.2833 12.9042 17.5208 12.7125 17.7125C12.5208 17.9042 12.2833 18 12 18ZM8 18C7.71667 18 7.47917 17.9042 7.2875 17.7125C7.09583 17.5208 7 17.2833 7 17C7 16.7167 7.09583 16.4792 7.2875 16.2875C7.47917 16.0958 7.71667 16 8 16C8.28333 16 8.52083 16.0958 8.7125 16.2875C8.90417 16.4792 9 16.7167 9 17C9 17.2833 8.90417 17.5208 8.7125 17.7125C8.52083 17.9042 8.28333 18 8 18ZM16 18C15.7167 18 15.4792 17.9042 15.2875 17.7125C15.0958 17.5208 15 17.2833 15 17C15 16.7167 15.0958 16.4792 15.2875 16.2875C15.4792 16.0958 15.7167 16 16 16C16.2833 16 16.5208 16.0958 16.7125 16.2875C16.9042 16.4792 17 16.7167 17 17C17 17.2833 16.9042 17.5208 16.7125 17.7125C16.5208 17.9042 16.2833 18 16 18Z",
    fill: "currentColor"
  }
) }), hL = Q("IconCalender")(Gde), Kde = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M7 21C6.45 21 5.97917 20.8042 5.5875 20.4125C5.19583 20.0208 5 19.55 5 19V6C4.71667 6 4.47917 5.90417 4.2875 5.7125C4.09583 5.52083 4 5.28333 4 5C4 4.71667 4.09583 4.47917 4.2875 4.2875C4.47917 4.09583 4.71667 4 5 4H9C9 3.71667 9.09583 3.47917 9.2875 3.2875C9.47917 3.09583 9.71667 3 10 3H14C14.2833 3 14.5208 3.09583 14.7125 3.2875C14.9042 3.47917 15 3.71667 15 4H19C19.2833 4 19.5208 4.09583 19.7125 4.2875C19.9042 4.47917 20 4.71667 20 5C20 5.28333 19.9042 5.52083 19.7125 5.7125C19.5208 5.90417 19.2833 6 19 6V19C19 19.55 18.8042 20.0208 18.4125 20.4125C18.0208 20.8042 17.55 21 17 21H7ZM7 6V19H17V6H7ZM9 16C9 16.2833 9.09583 16.5208 9.2875 16.7125C9.47917 16.9042 9.71667 17 10 17C10.2833 17 10.5208 16.9042 10.7125 16.7125C10.9042 16.5208 11 16.2833 11 16V9C11 8.71667 10.9042 8.47917 10.7125 8.2875C10.5208 8.09583 10.2833 8 10 8C9.71667 8 9.47917 8.09583 9.2875 8.2875C9.09583 8.47917 9 8.71667 9 9V16ZM13 16C13 16.2833 13.0958 16.5208 13.2875 16.7125C13.4792 16.9042 13.7167 17 14 17C14.2833 17 14.5208 16.9042 14.7125 16.7125C14.9042 16.5208 15 16.2833 15 16V9C15 8.71667 14.9042 8.47917 14.7125 8.2875C14.5208 8.09583 14.2833 8 14 8C13.7167 8 13.4792 8.09583 13.2875 8.2875C13.0958 8.47917 13 8.71667 13 9V16Z",
    fill: "currentColor"
  }
) }), Yde = Q("IconDelete")(Kde), Xde = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M11 12.15V6.09998C9.73333 6.33331 8.75 6.94581 8.05 7.93748C7.35 8.92914 7 9.94998 7 11H6.5C5.53333 11 4.70833 11.3416 4.025 12.025C3.34167 12.7083 3 13.5333 3 14.5C3 15.4666 3.34167 16.2916 4.025 16.975C4.70833 17.6583 5.53333 18 6.5 18H18.5C19.2 18 19.7917 17.7583 20.275 17.275C20.7583 16.7916 21 16.2 21 15.5C21 14.8 20.7583 14.2083 20.275 13.725C19.7917 13.2416 19.2 13 18.5 13H17V11C17 10.2 16.8167 9.45414 16.45 8.76248C16.0833 8.07081 15.6 7.48331 15 6.99998V4.67498C16.2333 5.25831 17.2083 6.12081 17.925 7.26248C18.6417 8.40414 19 9.64998 19 11C20.15 11.1333 21.1042 11.6291 21.8625 12.4875C22.6208 13.3458 23 14.35 23 15.5C23 16.75 22.5625 17.8125 21.6875 18.6875C20.8125 19.5625 19.75 20 18.5 20H6.5C4.98333 20 3.6875 19.475 2.6125 18.425C1.5375 17.375 1 16.0916 1 14.575C1 13.275 1.39167 12.1166 2.175 11.1C2.95833 10.0833 3.98333 9.43331 5.25 9.14998C5.53333 7.94998 6.24167 6.80831 7.375 5.72498C8.50833 4.64164 9.71667 4.09998 11 4.09998C11.55 4.09998 12.0208 4.29581 12.4125 4.68748C12.8042 5.07914 13 5.54998 13 6.09998V12.15L13.9 11.275C14.0833 11.0916 14.3125 11 14.5875 11C14.8625 11 15.1 11.1 15.3 11.3C15.4833 11.4833 15.575 11.7166 15.575 12C15.575 12.2833 15.4833 12.5166 15.3 12.7L12.7 15.3C12.5 15.5 12.2667 15.6 12 15.6C11.7333 15.6 11.5 15.5 11.3 15.3L8.7 12.7C8.51667 12.5166 8.42083 12.2875 8.4125 12.0125C8.40417 11.7375 8.5 11.5 8.7 11.3C8.88333 11.1166 9.1125 11.0208 9.3875 11.0125C9.6625 11.0041 9.9 11.0916 10.1 11.275L11 12.15Z",
    fill: "currentColor"
  }
) }), Xge = Q("IconDownload")(Xde), Qde = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M2 18V15C2 14.1667 2.29167 13.4583 2.875 12.875C3.45833 12.2917 4.16667 12 5 12H6V6C6 5.45 6.19583 4.97917 6.5875 4.5875C6.97917 4.19583 7.45 4 8 4H16C16.55 4 17.0208 4.19583 17.4125 4.5875C17.8042 4.97917 18 5.45 18 6V12H19C19.8333 12 20.5417 12.2917 21.125 12.875C21.7083 13.4583 22 14.1667 22 15V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18ZM8 12H16V6H8V12ZM4 18H20V15C20 14.7167 19.9042 14.4792 19.7125 14.2875C19.5208 14.0958 19.2833 14 19 14H5C4.71667 14 4.47917 14.0958 4.2875 14.2875C4.09583 14.4792 4 14.7167 4 15V18Z",
    fill: "currentColor"
  }
) }), Qge = Q("IconPrinter")(Qde), Jde = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H16.175C16.4417 3 16.6958 3.05 16.9375 3.15C17.1792 3.25 17.3917 3.39167 17.575 3.575L20.425 6.425C20.6083 6.60833 20.75 6.82083 20.85 7.0625C20.95 7.30417 21 7.55833 21 7.825V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM19 7.85L16.15 5H5V19H19V7.85ZM12 18C12.8333 18 13.5417 17.7083 14.125 17.125C14.7083 16.5417 15 15.8333 15 15C15 14.1667 14.7083 13.4583 14.125 12.875C13.5417 12.2917 12.8333 12 12 12C11.1667 12 10.4583 12.2917 9.875 12.875C9.29167 13.4583 9 14.1667 9 15C9 15.8333 9.29167 16.5417 9.875 17.125C10.4583 17.7083 11.1667 18 12 18ZM7 10H14C14.2833 10 14.5208 9.90417 14.7125 9.7125C14.9042 9.52083 15 9.28333 15 9V7C15 6.71667 14.9042 6.47917 14.7125 6.2875C14.5208 6.09583 14.2833 6 14 6H7C6.71667 6 6.47917 6.09583 6.2875 6.2875C6.09583 6.47917 6 6.71667 6 7V9C6 9.28333 6.09583 9.52083 6.2875 9.7125C6.47917 9.90417 6.71667 10 7 10Z",
    fill: "currentColor"
  }
) }), Jge = Q("IconSave")(Jde), ehe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C12.9 20 13.7667 19.8542 14.6 19.5625C15.4333 19.2708 16.2 18.85 16.9 18.3L5.7 7.1C5.15 7.8 4.72917 8.56667 4.4375 9.4C4.14583 10.2333 4 11.1 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20ZM18.3 16.9C18.85 16.2 19.2708 15.4333 19.5625 14.6C19.8542 13.7667 20 12.9 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C11.1 4 10.2333 4.14583 9.4 4.4375C8.56667 4.72917 7.8 5.15 7.1 5.7L18.3 16.9Z",
    fill: "currentColor"
  }
) }), eCe = Q("IconStop")(ehe), the = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M13 11.6V8C13 7.71667 12.9042 7.47917 12.7125 7.2875C12.5208 7.09583 12.2833 7 12 7C11.7167 7 11.4792 7.09583 11.2875 7.2875C11.0958 7.47917 11 7.71667 11 8V11.975C11 12.1083 11.025 12.2375 11.075 12.3625C11.125 12.4875 11.2 12.6 11.3 12.7L14.6 16C14.7833 16.1833 15.0167 16.275 15.3 16.275C15.5833 16.275 15.8167 16.1833 16 16C16.1833 15.8167 16.275 15.5833 16.275 15.3C16.275 15.0167 16.1833 14.7833 16 14.6L13 11.6ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2167 20 16.1042 19.2208 17.6625 17.6625C19.2208 16.1042 20 14.2167 20 12C20 9.78333 19.2208 7.89583 17.6625 6.3375C16.1042 4.77917 14.2167 4 12 4C9.78333 4 7.89583 4.77917 6.3375 6.3375C4.77917 7.89583 4 9.78333 4 12C4 14.2167 4.77917 16.1042 6.3375 17.6625C7.89583 19.2208 9.78333 20 12 20Z",
    fill: "currentColor"
  }
) }), tCe = Q("IconTime")(the), nhe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M11 12.85L10.1 13.725C9.91667 13.9083 9.6875 14 9.4125 14C9.1375 14 8.9 13.9 8.7 13.7C8.51667 13.5167 8.425 13.2833 8.425 13C8.425 12.7167 8.51667 12.4833 8.7 12.3L11.3 9.7C11.5 9.5 11.7333 9.4 12 9.4C12.2667 9.4 12.5 9.5 12.7 9.7L15.3 12.3C15.4833 12.4833 15.5792 12.7125 15.5875 12.9875C15.5958 13.2625 15.5 13.5 15.3 13.7C15.1167 13.8833 14.8875 13.9792 14.6125 13.9875C14.3375 13.9958 14.1 13.9083 13.9 13.725L13 12.85V18H18.5C19.2 18 19.7917 17.7583 20.275 17.275C20.7583 16.7917 21 16.2 21 15.5C21 14.8 20.7583 14.2083 20.275 13.725C19.7917 13.2417 19.2 13 18.5 13H17V11C17 9.61667 16.5125 8.4375 15.5375 7.4625C14.5625 6.4875 13.3833 6 12 6C10.6167 6 9.4375 6.4875 8.4625 7.4625C7.4875 8.4375 7 9.61667 7 11H6.5C5.53333 11 4.70833 11.3417 4.025 12.025C3.34167 12.7083 3 13.5333 3 14.5C3 15.4667 3.34167 16.2917 4.025 16.975C4.70833 17.6583 5.53333 18 6.5 18H8C8.28333 18 8.52083 18.0958 8.7125 18.2875C8.90417 18.4792 9 18.7167 9 19C9 19.2833 8.90417 19.5208 8.7125 19.7125C8.52083 19.9042 8.28333 20 8 20H6.5C4.98333 20 3.6875 19.475 2.6125 18.425C1.5375 17.375 1 16.0917 1 14.575C1 13.275 1.39167 12.1167 2.175 11.1C2.95833 10.0833 3.98333 9.43333 5.25 9.15C5.66667 7.61667 6.5 6.375 7.75 5.425C9 4.475 10.4167 4 12 4C13.95 4 15.6042 4.67917 16.9625 6.0375C18.3208 7.39583 19 9.05 19 11C20.15 11.1333 21.1042 11.6292 21.8625 12.4875C22.6208 13.3458 23 14.35 23 15.5C23 16.75 22.5625 17.8125 21.6875 18.6875C20.8125 19.5625 19.75 20 18.5 20H13C12.45 20 11.9792 19.8042 11.5875 19.4125C11.1958 19.0208 11 18.55 11 18V12.85Z",
    fill: "currentColor"
  }
) }), rhe = Q("IconUpload")(nhe), ohe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M6 20C4.9 20 3.95833 19.6083 3.175 18.825C2.39167 18.0417 2 17.1 2 16V8C2 6.9 2.39167 5.95833 3.175 5.175C3.95833 4.39167 4.9 4 6 4H18C19.1 4 20.0417 4.39167 20.825 5.175C21.6083 5.95833 22 6.9 22 8V16C22 17.1 21.6083 18.0417 20.825 18.825C20.0417 19.6083 19.1 20 18 20H6ZM6 8H18C18.3667 8 18.7167 8.04167 19.05 8.125C19.3833 8.20833 19.7 8.34167 20 8.525V8C20 7.45 19.8042 6.97917 19.4125 6.5875C19.0208 6.19583 18.55 6 18 6H6C5.45 6 4.97917 6.19583 4.5875 6.5875C4.19583 6.97917 4 7.45 4 8V8.525C4.3 8.34167 4.61667 8.20833 4.95 8.125C5.28333 8.04167 5.63333 8 6 8ZM4.15 11.25L15.275 13.95C15.4917 14 15.7167 13.9542 15.95 13.8125C16.1833 13.6708 16.3 13.4667 16.3 13.2V12.8C16.3 12.5333 16.1833 12.3292 15.95 12.1875C15.7167 12.0458 15.4917 12 15.275 12.05L4.15 14.75V11.25Z",
    fill: "currentColor"
  }
) }), nCe = Q("IconWallet")(ohe), ihe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M15.5 17.125L20.45 12.175C20.6333 11.9917 20.8667 11.9 21.15 11.9C21.4333 11.9 21.6667 11.9917 21.85 12.175C22.0333 12.3583 22.125 12.5917 22.125 12.875C22.125 13.1583 22.0333 13.3917 21.85 13.575L16.2 19.225C16 19.425 15.7667 19.525 15.5 19.525C15.2333 19.525 15 19.425 14.8 19.225L11.95 16.375C11.7667 16.1917 11.675 15.9583 11.675 15.675C11.675 15.3917 11.7667 15.1583 11.95 14.975C12.1333 14.7917 12.3667 14.7 12.65 14.7C12.9333 14.7 13.1667 14.7917 13.35 14.975L15.5 17.125ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H9.175C9.35833 2.41667 9.71667 1.9375 10.25 1.5625C10.7833 1.1875 11.3667 1 12 1C12.6667 1 13.2625 1.1875 13.7875 1.5625C14.3125 1.9375 14.6667 2.41667 14.85 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V9C21 9.28333 20.9042 9.52083 20.7125 9.7125C20.5208 9.90417 20.2833 10 20 10C19.7167 10 19.4792 9.90417 19.2875 9.7125C19.0958 9.52083 19 9.28333 19 9V5H17V7C17 7.28333 16.9042 7.52083 16.7125 7.7125C16.5208 7.90417 16.2833 8 16 8H8C7.71667 8 7.47917 7.90417 7.2875 7.7125C7.09583 7.52083 7 7.28333 7 7V5H5V19H10C10.2833 19 10.5208 19.0958 10.7125 19.2875C10.9042 19.4792 11 19.7167 11 20C11 20.2833 10.9042 20.5208 10.7125 20.7125C10.5208 20.9042 10.2833 21 10 21H5ZM12 5C12.2833 5 12.5208 4.90417 12.7125 4.7125C12.9042 4.52083 13 4.28333 13 4C13 3.71667 12.9042 3.47917 12.7125 3.2875C12.5208 3.09583 12.2833 3 12 3C11.7167 3 11.4792 3.09583 11.2875 3.2875C11.0958 3.47917 11 3.71667 11 4C11 4.28333 11.0958 4.52083 11.2875 4.7125C11.4792 4.90417 11.7167 5 12 5Z",
    fill: "currentColor"
  }
) }), rCe = Q("IconClipboardCheck")(ihe), ahe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M4 18C3.45 18 2.97917 17.8042 2.5875 17.4125C2.19583 17.0208 2 16.55 2 16V4C2 3.45 2.19583 2.97917 2.5875 2.5875C2.97917 2.19583 3.45 2 4 2H20C20.55 2 21.0208 2.19583 21.4125 2.5875C21.8042 2.97917 22 3.45 22 4V19.575C22 20.025 21.7958 20.3375 21.3875 20.5125C20.9792 20.6875 20.6167 20.6167 20.3 20.3L18 18H4ZM18.85 16L20 17.125V4H4V16H18.85Z",
    fill: "currentColor"
  }
) }), oCe = Q("IconComment")(ahe), she = (e) => /* @__PURE__ */ F("svg", { viewBox: "0 0 24 24", ...e, children: [
  /* @__PURE__ */ F("g", { clipPath: "url(#clip0_1484_1061)", children: [
    /* @__PURE__ */ d(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.59016 9.1123C4.87853 8.82392 5.26105 8.66931 5.64993 8.65782C6.03463 8.64646 6.42448 8.77489 6.73371 9.04795L8.98347 11.0349L8.99008 11.0185C9.03359 10.9293 9.08747 10.8435 9.15174 10.763L9.25595 10.6465C9.68286 10.2196 10.2347 9.99999 10.7807 9.98697C10.8427 9.98549 10.9046 9.98667 10.9663 9.99049L11.0051 9.9947L11.0065 9.98049C11.0378 9.7423 11.1335 9.50792 11.2942 9.30676L11.3984 9.19028C11.8253 8.76337 12.3772 8.54374 12.9231 8.53072C12.9852 8.52924 13.0471 8.53041 13.1088 8.53424L13.1476 8.53806L13.1489 8.52424C13.1803 8.28604 13.276 8.05167 13.4367 7.8505L13.5409 7.73402C13.9662 7.30869 14.5157 7.08893 15.0618 7.07301C15.6217 7.05669 16.1778 7.25405 16.6005 7.66201L19.4568 10.5184C19.8983 10.9599 20.3775 11.8109 20.5315 12.4119C20.5344 12.4237 21.0813 14.9968 21.582 15.4975L22.6214 16.5369L21.3422 17.8161L19.8764 17.3275L20.365 18.7933L16.9645 22.1938L15.9251 21.1543C15.5207 20.75 13.4764 20.9524 12.7993 21.0317L12.6402 21.051C12.6028 21.0557 12.5812 21.0586 12.5812 21.0586C11.9689 21.1017 11.0069 20.9307 10.4515 20.6849L7.3384 19.3075C7.09772 19.201 6.9207 19.0446 6.80332 18.7739C6.65677 18.4358 6.74627 18.1802 6.86869 17.8327C7.05251 17.3109 7.46125 17.0301 7.83412 16.7959L7.9969 16.7013C8.49278 16.4352 9.06633 16.3171 9.63328 16.3911L9.77473 16.4195L4.59002 11.2335C4.33336 10.9768 4.18875 10.6509 4.15663 10.3163L4.14975 10.1726C4.14979 9.78999 4.2957 9.40676 4.59016 9.1123Z",
        fill: "white",
        stroke: "black",
        "stroke-opacity": "0.8"
      }
    ),
    /* @__PURE__ */ d("g", { filter: "url(#filter0_d_1484_1061)", children: /* @__PURE__ */ d(
      "path",
      {
        d: "M14.9595 11.4709L15.6666 10.7638L18.4951 13.5922L17.788 14.2993L14.9595 11.4709ZM13.5453 12.8851L14.2524 12.178L17.0809 15.0064L16.3737 15.7135L13.5453 12.8851ZM12.1311 14.2993L12.8382 13.5922L15.6666 16.4206L14.9595 17.1277L12.1311 14.2993Z",
        fill: "black"
      }
    ) })
  ] }),
  /* @__PURE__ */ F("defs", { children: [
    /* @__PURE__ */ F(
      "filter",
      {
        id: "filter0_d_1484_1061",
        x: "9.1311",
        y: "8.76379",
        width: "12.364",
        height: "12.3639",
        filterUnits: "userSpaceOnUse",
        "color-interpolation-filters": "sRGB",
        children: [
          /* @__PURE__ */ d("feFlood", { "flood-opacity": "0", result: "BackgroundImageFix" }),
          /* @__PURE__ */ d(
            "feColorMatrix",
            {
              in: "SourceAlpha",
              type: "matrix",
              values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
              result: "hardAlpha"
            }
          ),
          /* @__PURE__ */ d("feOffset", { dy: "1" }),
          /* @__PURE__ */ d("feGaussianBlur", { stdDeviation: "1.5" }),
          /* @__PURE__ */ d("feComposite", { in2: "hardAlpha", operator: "out" }),
          /* @__PURE__ */ d(
            "feColorMatrix",
            {
              type: "matrix",
              values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
            }
          ),
          /* @__PURE__ */ d(
            "feBlend",
            {
              mode: "normal",
              in2: "BackgroundImageFix",
              result: "effect1_dropShadow_1484_1061"
            }
          ),
          /* @__PURE__ */ d(
            "feBlend",
            {
              mode: "normal",
              in: "SourceGraphic",
              in2: "effect1_dropShadow_1484_1061",
              result: "shape"
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ d("clipPath", { id: "clip0_1484_1061", children: /* @__PURE__ */ d("rect", { width: "24", height: "24", fill: "white" }) })
  ] })
] }), iCe = Q("IconCursor")(she), lhe = (e) => /* @__PURE__ */ F("svg", { viewBox: "0 0 24 24", ...e, children: [
  /* @__PURE__ */ F("g", { clipPath: "url(#clip0_1484_1065)", children: [
    /* @__PURE__ */ d(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.35792 8.38C6.64629 8.09162 7.02881 7.93701 7.41769 7.92552C7.80239 7.91416 8.19224 8.04259 8.50147 8.31565L10.7512 10.3026L10.7578 10.2862C10.8014 10.197 10.8552 10.1112 10.9195 10.0307L11.0237 9.91423C11.4506 9.48733 12.0025 9.26769 12.5484 9.25467C12.6105 9.25319 12.6724 9.25437 12.7341 9.25819L12.7729 9.2624L12.7742 9.24819C12.8056 9.01 12.9013 8.77562 13.062 8.57446L13.1662 8.45798C13.5931 8.03107 14.145 7.81144 14.6909 7.79842C14.7529 7.79694 14.8149 7.79811 14.8765 7.80194L14.9154 7.80576L14.9167 7.79194C14.9481 7.55374 15.0438 7.31937 15.2044 7.1182L15.3087 7.00172C15.734 6.57639 16.2834 6.35663 16.8296 6.34071C17.3894 6.32439 17.9456 6.52175 18.3682 6.92971L21.2246 9.78608C21.6661 10.2276 22.1453 11.0786 22.2993 11.6796C22.3021 11.6914 22.849 14.2645 23.3497 14.7652L24.3891 15.8046L23.11 17.0838L21.6442 16.5952L22.1328 18.061L18.7323 21.4615L17.6929 20.422C17.2885 20.0177 15.2441 20.2201 14.567 20.2994L14.4079 20.3187C14.3706 20.3234 14.3489 20.3263 14.3489 20.3263C13.7367 20.3694 12.7747 20.1984 12.2192 19.9526L9.10616 18.5752C8.86548 18.4687 8.68846 18.3123 8.57108 18.0416C8.42453 17.7035 8.51403 17.4479 8.63645 17.1004C8.82027 16.5786 9.22901 16.2978 9.60188 16.0636L9.76466 15.969C10.2605 15.7029 10.8341 15.5848 11.401 15.6588L11.5425 15.6872L6.35778 10.5012C6.10112 10.2445 5.95651 9.91865 5.92439 9.58403L5.91752 9.44026C5.91755 9.05769 6.06346 8.67446 6.35792 8.38Z",
        fill: "white",
        stroke: "black",
        "stroke-opacity": "0.8"
      }
    ),
    /* @__PURE__ */ d("g", { filter: "url(#filter0_d_1484_1065)", children: /* @__PURE__ */ d(
      "path",
      {
        d: "M16.7273 10.7386L17.4344 10.0315L20.2628 12.8599L19.5557 13.567L16.7273 10.7386ZM15.3131 12.1528L16.0202 11.4457L18.8486 14.2741L18.1415 14.9812L15.3131 12.1528ZM13.8989 13.567L14.606 12.8599L17.4344 15.6883L16.7273 16.3954L13.8989 13.567Z",
        fill: "black"
      }
    ) }),
    /* @__PURE__ */ d("g", { filter: "url(#filter1_d_1484_1065)", children: /* @__PURE__ */ d(
      "path",
      {
        d: "M0.95874 9.12231L0.958489 8.12231L3.99716 8.12155L3.99741 9.12155L0.95874 9.12231Z",
        fill: "black"
      }
    ) }),
    /* @__PURE__ */ d("g", { filter: "url(#filter2_d_1484_1065)", children: /* @__PURE__ */ d(
      "path",
      {
        d: "M3.28717 12.865L2.58006 12.1579L3.99428 10.7437L4.70138 11.4508L3.28717 12.865Z",
        fill: "black"
      }
    ) }),
    /* @__PURE__ */ d("g", { filter: "url(#filter3_d_1484_1065)", children: /* @__PURE__ */ d(
      "path",
      {
        d: "M9.29761 6.85449L8.5905 6.14739L10.0047 4.73317L10.7118 5.44028L9.29761 6.85449Z",
        fill: "black"
      }
    ) }),
    /* @__PURE__ */ d("g", { filter: "url(#filter4_d_1484_1065)", children: /* @__PURE__ */ d(
      "path",
      {
        d: "M6.2204 2.85999L7.2204 2.85999L7.2204 5.89866L6.2204 5.89866L6.2204 2.85999Z",
        fill: "black"
      }
    ) }),
    /* @__PURE__ */ d("g", { filter: "url(#filter5_d_1484_1065)", children: /* @__PURE__ */ d(
      "path",
      {
        d: "M2.58008 5.08679L3.28718 4.37969L5.43585 6.52835L4.72875 7.23546L2.58008 5.08679Z",
        fill: "black"
      }
    ) })
  ] }),
  /* @__PURE__ */ F("defs", { children: [
    /* @__PURE__ */ F(
      "filter",
      {
        id: "filter0_d_1484_1065",
        x: "10.8989",
        y: "8.03149",
        width: "12.364",
        height: "12.3639",
        filterUnits: "userSpaceOnUse",
        "color-interpolation-filters": "sRGB",
        children: [
          /* @__PURE__ */ d("feFlood", { "flood-opacity": "0", result: "BackgroundImageFix" }),
          /* @__PURE__ */ d(
            "feColorMatrix",
            {
              in: "SourceAlpha",
              type: "matrix",
              values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
              result: "hardAlpha"
            }
          ),
          /* @__PURE__ */ d("feOffset", { dy: "1" }),
          /* @__PURE__ */ d("feGaussianBlur", { stdDeviation: "1.5" }),
          /* @__PURE__ */ d("feComposite", { in2: "hardAlpha", operator: "out" }),
          /* @__PURE__ */ d(
            "feColorMatrix",
            {
              type: "matrix",
              values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
            }
          ),
          /* @__PURE__ */ d(
            "feBlend",
            {
              mode: "normal",
              in2: "BackgroundImageFix",
              result: "effect1_dropShadow_1484_1065"
            }
          ),
          /* @__PURE__ */ d(
            "feBlend",
            {
              mode: "normal",
              in: "SourceGraphic",
              in2: "effect1_dropShadow_1484_1065",
              result: "shape"
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ F(
      "filter",
      {
        id: "filter1_d_1484_1065",
        x: "-2.0415",
        y: "6.12158",
        width: "9.03894",
        height: "7.00073",
        filterUnits: "userSpaceOnUse",
        "color-interpolation-filters": "sRGB",
        children: [
          /* @__PURE__ */ d("feFlood", { "flood-opacity": "0", result: "BackgroundImageFix" }),
          /* @__PURE__ */ d(
            "feColorMatrix",
            {
              in: "SourceAlpha",
              type: "matrix",
              values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
              result: "hardAlpha"
            }
          ),
          /* @__PURE__ */ d("feOffset", { dy: "1" }),
          /* @__PURE__ */ d("feGaussianBlur", { stdDeviation: "1.5" }),
          /* @__PURE__ */ d("feComposite", { in2: "hardAlpha", operator: "out" }),
          /* @__PURE__ */ d(
            "feColorMatrix",
            {
              type: "matrix",
              values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
            }
          ),
          /* @__PURE__ */ d(
            "feBlend",
            {
              mode: "normal",
              in2: "BackgroundImageFix",
              result: "effect1_dropShadow_1484_1065"
            }
          ),
          /* @__PURE__ */ d(
            "feBlend",
            {
              mode: "normal",
              in: "SourceGraphic",
              in2: "effect1_dropShadow_1484_1065",
              result: "shape"
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ F(
      "filter",
      {
        id: "filter2_d_1484_1065",
        x: "-0.419922",
        y: "8.74365",
        width: "8.12128",
        height: "8.12134",
        filterUnits: "userSpaceOnUse",
        "color-interpolation-filters": "sRGB",
        children: [
          /* @__PURE__ */ d("feFlood", { "flood-opacity": "0", result: "BackgroundImageFix" }),
          /* @__PURE__ */ d(
            "feColorMatrix",
            {
              in: "SourceAlpha",
              type: "matrix",
              values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
              result: "hardAlpha"
            }
          ),
          /* @__PURE__ */ d("feOffset", { dy: "1" }),
          /* @__PURE__ */ d("feGaussianBlur", { stdDeviation: "1.5" }),
          /* @__PURE__ */ d("feComposite", { in2: "hardAlpha", operator: "out" }),
          /* @__PURE__ */ d(
            "feColorMatrix",
            {
              type: "matrix",
              values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
            }
          ),
          /* @__PURE__ */ d(
            "feBlend",
            {
              mode: "normal",
              in2: "BackgroundImageFix",
              result: "effect1_dropShadow_1484_1065"
            }
          ),
          /* @__PURE__ */ d(
            "feBlend",
            {
              mode: "normal",
              in: "SourceGraphic",
              in2: "effect1_dropShadow_1484_1065",
              result: "shape"
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ F(
      "filter",
      {
        id: "filter3_d_1484_1065",
        x: "5.59052",
        y: "2.73315",
        width: "8.12128",
        height: "8.12134",
        filterUnits: "userSpaceOnUse",
        "color-interpolation-filters": "sRGB",
        children: [
          /* @__PURE__ */ d("feFlood", { "flood-opacity": "0", result: "BackgroundImageFix" }),
          /* @__PURE__ */ d(
            "feColorMatrix",
            {
              in: "SourceAlpha",
              type: "matrix",
              values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
              result: "hardAlpha"
            }
          ),
          /* @__PURE__ */ d("feOffset", { dy: "1" }),
          /* @__PURE__ */ d("feGaussianBlur", { stdDeviation: "1.5" }),
          /* @__PURE__ */ d("feComposite", { in2: "hardAlpha", operator: "out" }),
          /* @__PURE__ */ d(
            "feColorMatrix",
            {
              type: "matrix",
              values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
            }
          ),
          /* @__PURE__ */ d(
            "feBlend",
            {
              mode: "normal",
              in2: "BackgroundImageFix",
              result: "effect1_dropShadow_1484_1065"
            }
          ),
          /* @__PURE__ */ d(
            "feBlend",
            {
              mode: "normal",
              in: "SourceGraphic",
              in2: "effect1_dropShadow_1484_1065",
              result: "shape"
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ F(
      "filter",
      {
        id: "filter4_d_1484_1065",
        x: "3.2204",
        y: "0.859985",
        width: "7",
        height: "9.0387",
        filterUnits: "userSpaceOnUse",
        "color-interpolation-filters": "sRGB",
        children: [
          /* @__PURE__ */ d("feFlood", { "flood-opacity": "0", result: "BackgroundImageFix" }),
          /* @__PURE__ */ d(
            "feColorMatrix",
            {
              in: "SourceAlpha",
              type: "matrix",
              values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
              result: "hardAlpha"
            }
          ),
          /* @__PURE__ */ d("feOffset", { dy: "1" }),
          /* @__PURE__ */ d("feGaussianBlur", { stdDeviation: "1.5" }),
          /* @__PURE__ */ d("feComposite", { in2: "hardAlpha", operator: "out" }),
          /* @__PURE__ */ d(
            "feColorMatrix",
            {
              type: "matrix",
              values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
            }
          ),
          /* @__PURE__ */ d(
            "feBlend",
            {
              mode: "normal",
              in2: "BackgroundImageFix",
              result: "effect1_dropShadow_1484_1065"
            }
          ),
          /* @__PURE__ */ d(
            "feBlend",
            {
              mode: "normal",
              in: "SourceGraphic",
              in2: "effect1_dropShadow_1484_1065",
              result: "shape"
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ F(
      "filter",
      {
        id: "filter5_d_1484_1065",
        x: "-0.419922",
        y: "2.37964",
        width: "8.85577",
        height: "8.85583",
        filterUnits: "userSpaceOnUse",
        "color-interpolation-filters": "sRGB",
        children: [
          /* @__PURE__ */ d("feFlood", { "flood-opacity": "0", result: "BackgroundImageFix" }),
          /* @__PURE__ */ d(
            "feColorMatrix",
            {
              in: "SourceAlpha",
              type: "matrix",
              values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
              result: "hardAlpha"
            }
          ),
          /* @__PURE__ */ d("feOffset", { dy: "1" }),
          /* @__PURE__ */ d("feGaussianBlur", { stdDeviation: "1.5" }),
          /* @__PURE__ */ d("feComposite", { in2: "hardAlpha", operator: "out" }),
          /* @__PURE__ */ d(
            "feColorMatrix",
            {
              type: "matrix",
              values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
            }
          ),
          /* @__PURE__ */ d(
            "feBlend",
            {
              mode: "normal",
              in2: "BackgroundImageFix",
              result: "effect1_dropShadow_1484_1065"
            }
          ),
          /* @__PURE__ */ d(
            "feBlend",
            {
              mode: "normal",
              in: "SourceGraphic",
              in2: "effect1_dropShadow_1484_1065",
              result: "shape"
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ d("clipPath", { id: "clip0_1484_1065", children: /* @__PURE__ */ d("rect", { width: "24", height: "24", fill: "white" }) })
  ] })
] }), aCe = Q("IconCursorClick")(lhe), che = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M9 20C8.45 20 7.97917 19.8042 7.5875 19.4125C7.19583 19.0208 7 18.55 7 18C7 17.45 7.19583 16.9792 7.5875 16.5875C7.97917 16.1958 8.45 16 9 16C9.55 16 10.0208 16.1958 10.4125 16.5875C10.8042 16.9792 11 17.45 11 18C11 18.55 10.8042 19.0208 10.4125 19.4125C10.0208 19.8042 9.55 20 9 20ZM15 20C14.45 20 13.9792 19.8042 13.5875 19.4125C13.1958 19.0208 13 18.55 13 18C13 17.45 13.1958 16.9792 13.5875 16.5875C13.9792 16.1958 14.45 16 15 16C15.55 16 16.0208 16.1958 16.4125 16.5875C16.8042 16.9792 17 17.45 17 18C17 18.55 16.8042 19.0208 16.4125 19.4125C16.0208 19.8042 15.55 20 15 20ZM9 14C8.45 14 7.97917 13.8042 7.5875 13.4125C7.19583 13.0208 7 12.55 7 12C7 11.45 7.19583 10.9792 7.5875 10.5875C7.97917 10.1958 8.45 10 9 10C9.55 10 10.0208 10.1958 10.4125 10.5875C10.8042 10.9792 11 11.45 11 12C11 12.55 10.8042 13.0208 10.4125 13.4125C10.0208 13.8042 9.55 14 9 14ZM15 14C14.45 14 13.9792 13.8042 13.5875 13.4125C13.1958 13.0208 13 12.55 13 12C13 11.45 13.1958 10.9792 13.5875 10.5875C13.9792 10.1958 14.45 10 15 10C15.55 10 16.0208 10.1958 16.4125 10.5875C16.8042 10.9792 17 11.45 17 12C17 12.55 16.8042 13.0208 16.4125 13.4125C16.0208 13.8042 15.55 14 15 14ZM9 8C8.45 8 7.97917 7.80417 7.5875 7.4125C7.19583 7.02083 7 6.55 7 6C7 5.45 7.19583 4.97917 7.5875 4.5875C7.97917 4.19583 8.45 4 9 4C9.55 4 10.0208 4.19583 10.4125 4.5875C10.8042 4.97917 11 5.45 11 6C11 6.55 10.8042 7.02083 10.4125 7.4125C10.0208 7.80417 9.55 8 9 8ZM15 8C14.45 8 13.9792 7.80417 13.5875 7.4125C13.1958 7.02083 13 6.55 13 6C13 5.45 13.1958 4.97917 13.5875 4.5875C13.9792 4.19583 14.45 4 15 4C15.55 4 16.0208 4.19583 16.4125 4.5875C16.8042 4.97917 17 5.45 17 6C17 6.55 16.8042 7.02083 16.4125 7.4125C16.0208 7.80417 15.55 8 15 8Z",
    fill: "currentColor"
  }
) }), sCe = Q("IconDrag")(che), uhe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M11.95 18C12.3 18 12.5958 17.8792 12.8375 17.6375C13.0792 17.3958 13.2 17.1 13.2 16.75C13.2 16.4 13.0792 16.1042 12.8375 15.8625C12.5958 15.6208 12.3 15.5 11.95 15.5C11.6 15.5 11.3042 15.6208 11.0625 15.8625C10.8208 16.1042 10.7 16.4 10.7 16.75C10.7 17.1 10.8208 17.3958 11.0625 17.6375C11.3042 17.8792 11.6 18 11.95 18ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20ZM12.1 7.7C12.5167 7.7 12.8792 7.83333 13.1875 8.1C13.4958 8.36667 13.65 8.7 13.65 9.1C13.65 9.46667 13.5375 9.79167 13.3125 10.075C13.0875 10.3583 12.8333 10.625 12.55 10.875C12.1667 11.2083 11.8292 11.575 11.5375 11.975C11.2458 12.375 11.1 12.825 11.1 13.325C11.1 13.5583 11.1875 13.7542 11.3625 13.9125C11.5375 14.0708 11.7417 14.15 11.975 14.15C12.225 14.15 12.4375 14.0667 12.6125 13.9C12.7875 13.7333 12.9 13.525 12.95 13.275C13.0167 12.925 13.1667 12.6125 13.4 12.3375C13.6333 12.0625 13.8833 11.8 14.15 11.55C14.5333 11.1833 14.8625 10.7833 15.1375 10.35C15.4125 9.91667 15.55 9.43333 15.55 8.9C15.55 8.05 15.2042 7.35417 14.5125 6.8125C13.8208 6.27083 13.0167 6 12.1 6C11.4667 6 10.8625 6.13333 10.2875 6.4C9.7125 6.66667 9.275 7.075 8.975 7.625C8.85833 7.825 8.82083 8.0375 8.8625 8.2625C8.90417 8.4875 9.01667 8.65833 9.2 8.775C9.43333 8.90833 9.675 8.95 9.925 8.9C10.175 8.85 10.3833 8.70833 10.55 8.475C10.7333 8.225 10.9625 8.03333 11.2375 7.9C11.5125 7.76667 11.8 7.7 12.1 7.7Z",
    fill: "currentColor"
  }
) }), lCe = Q("IconHelp")(uhe), fhe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M12 19.35C14.0333 17.4833 15.5417 15.7875 16.525 14.2625C17.5083 12.7375 18 11.3833 18 10.2C18 8.38333 17.4208 6.89583 16.2625 5.7375C15.1042 4.57917 13.6833 4 12 4C10.3167 4 8.89583 4.57917 7.7375 5.7375C6.57917 6.89583 6 8.38333 6 10.2C6 11.3833 6.49167 12.7375 7.475 14.2625C8.45833 15.7875 9.96667 17.4833 12 19.35ZM12 21.325C11.7667 21.325 11.5333 21.2833 11.3 21.2C11.0667 21.1167 10.8583 20.9917 10.675 20.825C9.59167 19.825 8.63333 18.85 7.8 17.9C6.96667 16.95 6.27083 16.0292 5.7125 15.1375C5.15417 14.2458 4.72917 13.3875 4.4375 12.5625C4.14583 11.7375 4 10.95 4 10.2C4 7.7 4.80417 5.70833 6.4125 4.225C8.02083 2.74167 9.88333 2 12 2C14.1167 2 15.9792 2.74167 17.5875 4.225C19.1958 5.70833 20 7.7 20 10.2C20 10.95 19.8542 11.7375 19.5625 12.5625C19.2708 13.3875 18.8458 14.2458 18.2875 15.1375C17.7292 16.0292 17.0333 16.95 16.2 17.9C15.3667 18.85 14.4083 19.825 13.325 20.825C13.1417 20.9917 12.9333 21.1167 12.7 21.2C12.4667 21.2833 12.2333 21.325 12 21.325ZM12 12C12.55 12 13.0208 11.8042 13.4125 11.4125C13.8042 11.0208 14 10.55 14 10C14 9.45 13.8042 8.97917 13.4125 8.5875C13.0208 8.19583 12.55 8 12 8C11.45 8 10.9792 8.19583 10.5875 8.5875C10.1958 8.97917 10 9.45 10 10C10 10.55 10.1958 11.0208 10.5875 11.4125C10.9792 11.8042 11.45 12 12 12Z",
    fill: "currentColor"
  }
) }), cCe = Q("IconLocation")(fhe), dhe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M7 23C6.45 23 5.97917 22.8042 5.5875 22.4125C5.19583 22.0208 5 21.55 5 21V3C5 2.45 5.19583 1.97917 5.5875 1.5875C5.97917 1.19583 6.45 1 7 1H17C17.55 1 18.0208 1.19583 18.4125 1.5875C18.8042 1.97917 19 2.45 19 3V21C19 21.55 18.8042 22.0208 18.4125 22.4125C18.0208 22.8042 17.55 23 17 23H7ZM7 18V21H17V18H7ZM12 20.5C12.2833 20.5 12.5208 20.4042 12.7125 20.2125C12.9042 20.0208 13 19.7833 13 19.5C13 19.2167 12.9042 18.9792 12.7125 18.7875C12.5208 18.5958 12.2833 18.5 12 18.5C11.7167 18.5 11.4792 18.5958 11.2875 18.7875C11.0958 18.9792 11 19.2167 11 19.5C11 19.7833 11.0958 20.0208 11.2875 20.2125C11.4792 20.4042 11.7167 20.5 12 20.5ZM7 16H17V6H7V16ZM7 4H17V3H7V4Z",
    fill: "currentColor"
  }
) }), uCe = Q("IconMobile")(dhe), hhe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M4 21C3.45 21 2.97917 20.8042 2.5875 20.4125C2.19583 20.0208 2 19.55 2 19V5C2 4.45 2.19583 3.97917 2.5875 3.5875C2.97917 3.19583 3.45 3 4 3H20C20.55 3 21.0208 3.19583 21.4125 3.5875C21.8042 3.97917 22 4.45 22 5V19C22 19.55 21.8042 20.0208 21.4125 20.4125C21.0208 20.8042 20.55 21 20 21H4ZM4 19H20V5H4V19ZM7 17H17C17.2833 17 17.5208 16.9042 17.7125 16.7125C17.9042 16.5208 18 16.2833 18 16C18 15.7167 17.9042 15.4792 17.7125 15.2875C17.5208 15.0958 17.2833 15 17 15H7C6.71667 15 6.47917 15.0958 6.2875 15.2875C6.09583 15.4792 6 15.7167 6 16C6 16.2833 6.09583 16.5208 6.2875 16.7125C6.47917 16.9042 6.71667 17 7 17ZM7 13H9C9.28333 13 9.52083 12.9042 9.7125 12.7125C9.90417 12.5208 10 12.2833 10 12V8C10 7.71667 9.90417 7.47917 9.7125 7.2875C9.52083 7.09583 9.28333 7 9 7H7C6.71667 7 6.47917 7.09583 6.2875 7.2875C6.09583 7.47917 6 7.71667 6 8V12C6 12.2833 6.09583 12.5208 6.2875 12.7125C6.47917 12.9042 6.71667 13 7 13ZM13 13H17C17.2833 13 17.5208 12.9042 17.7125 12.7125C17.9042 12.5208 18 12.2833 18 12C18 11.7167 17.9042 11.4792 17.7125 11.2875C17.5208 11.0958 17.2833 11 17 11H13C12.7167 11 12.4792 11.0958 12.2875 11.2875C12.0958 11.4792 12 11.7167 12 12C12 12.2833 12.0958 12.5208 12.2875 12.7125C12.4792 12.9042 12.7167 13 13 13ZM13 9H17C17.2833 9 17.5208 8.90417 17.7125 8.7125C17.9042 8.52083 18 8.28333 18 8C18 7.71667 17.9042 7.47917 17.7125 7.2875C17.5208 7.09583 17.2833 7 17 7H13C12.7167 7 12.4792 7.09583 12.2875 7.2875C12.0958 7.47917 12 7.71667 12 8C12 8.28333 12.0958 8.52083 12.2875 8.7125C12.4792 8.90417 12.7167 9 13 9Z",
    fill: "currentColor"
  }
) }), fCe = Q("IconNewsMode")(hhe), phe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M7.5 11C6.53333 11 5.70833 10.6583 5.025 9.975C4.34167 9.29167 4 8.46667 4 7.5C4 6.53333 4.34167 5.70833 5.025 5.025C5.70833 4.34167 6.53333 4 7.5 4C8.46667 4 9.29167 4.34167 9.975 5.025C10.6583 5.70833 11 6.53333 11 7.5C11 8.46667 10.6583 9.29167 9.975 9.975C9.29167 10.6583 8.46667 11 7.5 11ZM7.5 9C7.91667 9 8.27083 8.85417 8.5625 8.5625C8.85417 8.27083 9 7.91667 9 7.5C9 7.08333 8.85417 6.72917 8.5625 6.4375C8.27083 6.14583 7.91667 6 7.5 6C7.08333 6 6.72917 6.14583 6.4375 6.4375C6.14583 6.72917 6 7.08333 6 7.5C6 7.91667 6.14583 8.27083 6.4375 8.5625C6.72917 8.85417 7.08333 9 7.5 9ZM16.5 20C15.5333 20 14.7083 19.6583 14.025 18.975C13.3417 18.2917 13 17.4667 13 16.5C13 15.5333 13.3417 14.7083 14.025 14.025C14.7083 13.3417 15.5333 13 16.5 13C17.4667 13 18.2917 13.3417 18.975 14.025C19.6583 14.7083 20 15.5333 20 16.5C20 17.4667 19.6583 18.2917 18.975 18.975C18.2917 19.6583 17.4667 20 16.5 20ZM16.5 18C16.9167 18 17.2708 17.8542 17.5625 17.5625C17.8542 17.2708 18 16.9167 18 16.5C18 16.0833 17.8542 15.7292 17.5625 15.4375C17.2708 15.1458 16.9167 15 16.5 15C16.0833 15 15.7292 15.1458 15.4375 15.4375C15.1458 15.7292 15 16.0833 15 16.5C15 16.9167 15.1458 17.2708 15.4375 17.5625C15.7292 17.8542 16.0833 18 16.5 18ZM4.7 19.3C4.51667 19.1167 4.425 18.8833 4.425 18.6C4.425 18.3167 4.51667 18.0833 4.7 17.9L17.9 4.7C18.0833 4.51667 18.3167 4.425 18.6 4.425C18.8833 4.425 19.1167 4.51667 19.3 4.7C19.4833 4.88333 19.575 5.11667 19.575 5.4C19.575 5.68333 19.4833 5.91667 19.3 6.1L6.1 19.3C5.91667 19.4833 5.68333 19.575 5.4 19.575C5.11667 19.575 4.88333 19.4833 4.7 19.3Z",
    fill: "currentColor"
  }
) }), dCe = Q("IconPercent")(phe), mhe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M6 19H12V18H6V19ZM6.75 10H11.25C11.45 10 11.625 9.925 11.775 9.775C11.925 9.625 12 9.45 12 9.25C12 9.05 11.925 8.875 11.775 8.725C11.625 8.575 11.45 8.5 11.25 8.5H6.75C6.55 8.5 6.375 8.575 6.225 8.725C6.075 8.875 6 9.05 6 9.25C6 9.45 6.075 9.625 6.225 9.775C6.375 9.925 6.55 10 6.75 10ZM6.75 7.5H11.25C11.45 7.5 11.625 7.425 11.775 7.275C11.925 7.125 12 6.95 12 6.75C12 6.55 11.925 6.375 11.775 6.225C11.625 6.075 11.45 6 11.25 6H6.75C6.55 6 6.375 6.075 6.225 6.225C6.075 6.375 6 6.55 6 6.75C6 6.95 6.075 7.125 6.225 7.275C6.375 7.425 6.55 7.5 6.75 7.5ZM16 11V9H18V7H16V5H18C18.55 5 19.0208 5.19583 19.4125 5.5875C19.8042 5.97917 20 6.45 20 7H22C22.2833 7 22.5208 7.09583 22.7125 7.2875C22.9042 7.47917 23 7.71667 23 8C23 8.28333 22.9042 8.52083 22.7125 8.7125C22.5208 8.90417 22.2833 9 22 9H20C20 9.55 19.8042 10.0208 19.4125 10.4125C19.0208 10.8042 18.55 11 18 11H16ZM12 16H10V11H14V5H6C5.45 5 4.97917 5.19583 4.5875 5.5875C4.19583 5.97917 4 6.45 4 7V9C4 9.55 4.19583 10.0208 4.5875 10.4125C4.97917 10.8042 5.45 11 6 11H8V16H6V13C4.9 13 3.95833 12.6083 3.175 11.825C2.39167 11.0417 2 10.1 2 9V7C2 5.9 2.39167 4.95833 3.175 4.175C3.95833 3.39167 4.9 3 6 3H14C14.55 3 15.0208 3.19583 15.4125 3.5875C15.8042 3.97917 16 4.45 16 5V11C16 11.55 15.8042 12.0208 15.4125 12.4125C15.0208 12.8042 14.55 13 14 13H12V16ZM5.5 21C5.08333 21 4.72917 20.8542 4.4375 20.5625C4.14583 20.2708 4 19.9167 4 19.5V17.5C4 17.0833 4.14583 16.7292 4.4375 16.4375C4.72917 16.1458 5.08333 16 5.5 16H12.5C12.9167 16 13.2708 16.1458 13.5625 16.4375C13.8542 16.7292 14 17.0833 14 17.5V19.5C14 19.9167 13.8542 20.2708 13.5625 20.5625C13.2708 20.8542 12.9167 21 12.5 21H5.5Z",
    fill: "currentColor"
  }
) }), hCe = Q("IconPowerDrill")(mhe), ghe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M12.05 20C9.81665 20 7.91665 19.225 6.34999 17.675C4.78332 16.125 3.99999 14.2333 3.99999 12V11.825L3.09999 12.725C2.91665 12.9083 2.68332 13 2.39999 13C2.11665 13 1.88332 12.9083 1.69999 12.725C1.51665 12.5417 1.42499 12.3083 1.42499 12.025C1.42499 11.7417 1.51665 11.5083 1.69999 11.325L4.29999 8.725C4.49999 8.525 4.73332 8.425 4.99999 8.425C5.26665 8.425 5.49999 8.525 5.69999 8.725L8.29999 11.325C8.48332 11.5083 8.57499 11.7417 8.57499 12.025C8.57499 12.3083 8.48332 12.5417 8.29999 12.725C8.11665 12.9083 7.88332 13 7.59999 13C7.31665 13 7.08332 12.9083 6.89999 12.725L5.99999 11.825V12C5.99999 13.6667 6.58749 15.0833 7.76249 16.25C8.93749 17.4167 10.3667 18 12.05 18C12.3167 18 12.5792 17.9833 12.8375 17.95C13.0958 17.9167 13.35 17.8583 13.6 17.775C13.8833 17.6917 14.15 17.7 14.4 17.8C14.65 17.9 14.8417 18.075 14.975 18.325C15.1083 18.5917 15.1208 18.8542 15.0125 19.1125C14.9042 19.3708 14.7083 19.5417 14.425 19.625C14.0417 19.7583 13.65 19.8542 13.25 19.9125C12.85 19.9708 12.45 20 12.05 20ZM11.95 6C11.6833 6 11.4208 6.01667 11.1625 6.05C10.9042 6.08333 10.65 6.14167 10.4 6.225C10.1167 6.30833 9.84582 6.3 9.58749 6.2C9.32915 6.1 9.13332 5.925 8.99999 5.675C8.86665 5.425 8.85415 5.17083 8.96249 4.9125C9.07082 4.65417 9.25832 4.48333 9.52499 4.4C9.92499 4.26667 10.325 4.16667 10.725 4.1C11.125 4.03333 11.5333 4 11.95 4C14.1833 4 16.0833 4.775 17.65 6.325C19.2167 7.875 20 9.76667 20 12V12.175L20.9 11.275C21.0833 11.0917 21.3167 11 21.6 11C21.8833 11 22.1167 11.0917 22.3 11.275C22.4833 11.4583 22.575 11.6917 22.575 11.975C22.575 12.2583 22.4833 12.4917 22.3 12.675L19.7 15.275C19.5 15.475 19.2667 15.575 19 15.575C18.7333 15.575 18.5 15.475 18.3 15.275L15.7 12.675C15.5167 12.4917 15.425 12.2583 15.425 11.975C15.425 11.6917 15.5167 11.4583 15.7 11.275C15.8833 11.0917 16.1167 11 16.4 11C16.6833 11 16.9167 11.0917 17.1 11.275L18 12.175V12C18 10.3333 17.4125 8.91667 16.2375 7.75C15.0625 6.58333 13.6333 6 11.95 6Z",
    fill: "currentColor"
  }
) }), pCe = Q("IconRefresh")(ghe), Che = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M12 22C10.6333 22 9.34167 21.7375 8.125 21.2125C6.90833 20.6875 5.84583 19.9708 4.9375 19.0625C4.02917 18.1542 3.3125 17.0917 2.7875 15.875C2.2625 14.6583 2 13.3667 2 12C2 10.6167 2.2625 9.32083 2.7875 8.1125C3.3125 6.90417 4.02917 5.84583 4.9375 4.9375C5.84583 4.02917 6.90833 3.3125 8.125 2.7875C9.34167 2.2625 10.6333 2 12 2C13.3833 2 14.6792 2.2625 15.8875 2.7875C17.0958 3.3125 18.1542 4.02917 19.0625 4.9375C19.9708 5.84583 20.6875 6.90417 21.2125 8.1125C21.7375 9.32083 22 10.6167 22 12C22 13.3667 21.7375 14.6583 21.2125 15.875C20.6875 17.0917 19.9708 18.1542 19.0625 19.0625C18.1542 19.9708 17.0958 20.6875 15.8875 21.2125C14.6792 21.7375 13.3833 22 12 22ZM12 19.95C12.4333 19.35 12.8083 18.725 13.125 18.075C13.4417 17.425 13.7 16.7333 13.9 16H10.1C10.3 16.7333 10.5583 17.425 10.875 18.075C11.1917 18.725 11.5667 19.35 12 19.95ZM9.4 19.55C9.1 19 8.8375 18.4292 8.6125 17.8375C8.3875 17.2458 8.2 16.6333 8.05 16H5.1C5.58333 16.8333 6.1875 17.5583 6.9125 18.175C7.6375 18.7917 8.46667 19.25 9.4 19.55ZM14.6 19.55C15.5333 19.25 16.3625 18.7917 17.0875 18.175C17.8125 17.5583 18.4167 16.8333 18.9 16H15.95C15.8 16.6333 15.6125 17.2458 15.3875 17.8375C15.1625 18.4292 14.9 19 14.6 19.55ZM4.25 14H7.65C7.6 13.6667 7.5625 13.3375 7.5375 13.0125C7.5125 12.6875 7.5 12.35 7.5 12C7.5 11.65 7.5125 11.3125 7.5375 10.9875C7.5625 10.6625 7.6 10.3333 7.65 10H4.25C4.16667 10.3333 4.10417 10.6625 4.0625 10.9875C4.02083 11.3125 4 11.65 4 12C4 12.35 4.02083 12.6875 4.0625 13.0125C4.10417 13.3375 4.16667 13.6667 4.25 14ZM9.65 14H14.35C14.4 13.6667 14.4375 13.3375 14.4625 13.0125C14.4875 12.6875 14.5 12.35 14.5 12C14.5 11.65 14.4875 11.3125 14.4625 10.9875C14.4375 10.6625 14.4 10.3333 14.35 10H9.65C9.6 10.3333 9.5625 10.6625 9.5375 10.9875C9.5125 11.3125 9.5 11.65 9.5 12C9.5 12.35 9.5125 12.6875 9.5375 13.0125C9.5625 13.3375 9.6 13.6667 9.65 14ZM16.35 14H19.75C19.8333 13.6667 19.8958 13.3375 19.9375 13.0125C19.9792 12.6875 20 12.35 20 12C20 11.65 19.9792 11.3125 19.9375 10.9875C19.8958 10.6625 19.8333 10.3333 19.75 10H16.35C16.4 10.3333 16.4375 10.6625 16.4625 10.9875C16.4875 11.3125 16.5 11.65 16.5 12C16.5 12.35 16.4875 12.6875 16.4625 13.0125C16.4375 13.3375 16.4 13.6667 16.35 14ZM15.95 8H18.9C18.4167 7.16667 17.8125 6.44167 17.0875 5.825C16.3625 5.20833 15.5333 4.75 14.6 4.45C14.9 5 15.1625 5.57083 15.3875 6.1625C15.6125 6.75417 15.8 7.36667 15.95 8ZM10.1 8H13.9C13.7 7.26667 13.4417 6.575 13.125 5.925C12.8083 5.275 12.4333 4.65 12 4.05C11.5667 4.65 11.1917 5.275 10.875 5.925C10.5583 6.575 10.3 7.26667 10.1 8ZM5.1 8H8.05C8.2 7.36667 8.3875 6.75417 8.6125 6.1625C8.8375 5.57083 9.1 5 9.4 4.45C8.46667 4.75 7.6375 5.20833 6.9125 5.825C6.1875 6.44167 5.58333 7.16667 5.1 8Z",
    fill: "currentColor"
  }
) }), mCe = Q("IconWeb")(Che), vhe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    id: "markunread_mailbox",
    d: "M6 10H4V20H20V10H11C10.7167 10 10.4792 9.90417 10.2875 9.7125C10.0958 9.52083 10 9.28333 10 9C10 8.71667 10.0958 8.47917 10.2875 8.2875C10.4792 8.09583 10.7167 8 11 8H20C20.55 8 21.0208 8.19583 21.4125 8.5875C21.8042 8.97917 22 9.45 22 10V20C22 20.55 21.8042 21.0208 21.4125 21.4125C21.0208 21.8042 20.55 22 20 22H4C3.45 22 2.97917 21.8042 2.5875 21.4125C2.19583 21.0208 2 20.55 2 20V10C2 9.45 2.19583 8.97917 2.5875 8.5875C2.97917 8.19583 3.45 8 4 8H6V3C6 2.71667 6.09583 2.47917 6.2875 2.2875C6.47917 2.09583 6.71667 2 7 2H13C13.2833 2 13.5208 2.09583 13.7125 2.2875C13.9042 2.47917 14 2.71667 14 3V5C14 5.28333 13.9042 5.52083 13.7125 5.7125C13.5208 5.90417 13.2833 6 13 6H8V13C8 13.2833 7.90417 13.5208 7.7125 13.7125C7.52083 13.9042 7.28333 14 7 14C6.71667 14 6.47917 13.9042 6.2875 13.7125C6.09583 13.5208 6 13.2833 6 13V10Z",
    fill: "currentColor"
  }
) }), gCe = Q("IconNotice")(vhe), yhe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H9.175C9.35833 2.41667 9.71667 1.9375 10.25 1.5625C10.7833 1.1875 11.3667 1 12 1C12.6667 1 13.2625 1.1875 13.7875 1.5625C14.3125 1.9375 14.6667 2.41667 14.85 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM5 19H19V5H17V7C17 7.28333 16.9042 7.52083 16.7125 7.7125C16.5208 7.90417 16.2833 8 16 8H8C7.71667 8 7.47917 7.90417 7.2875 7.7125C7.09583 7.52083 7 7.28333 7 7V5H5V19ZM12 5C12.2833 5 12.5208 4.90417 12.7125 4.7125C12.9042 4.52083 13 4.28333 13 4C13 3.71667 12.9042 3.47917 12.7125 3.2875C12.5208 3.09583 12.2833 3 12 3C11.7167 3 11.4792 3.09583 11.2875 3.2875C11.0958 3.47917 11 3.71667 11 4C11 4.28333 11.0958 4.52083 11.2875 4.7125C11.4792 4.90417 11.7167 5 12 5Z",
    fill: "currentColor"
  }
) }), CCe = Q("IconNote")(yhe), bhe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M9.00001 8.99998V20H16V17C16 16.7166 16.0958 16.4791 16.2875 16.2875C16.4792 16.0958 16.7167 16 17 16H20V8.99998H9.00001ZM7.00001 20V8.97498C7.00001 8.42498 7.20001 7.95831 7.60001 7.57498C8.00001 7.19165 8.47501 6.99998 9.02501 6.99998H20C20.55 6.99998 21.0208 7.19581 21.4125 7.58748C21.8042 7.97915 22 8.44998 22 8.99998V16.175C22 16.4416 21.95 16.6958 21.85 16.9375C21.75 17.1791 21.6083 17.3916 21.425 17.575L17.575 21.425C17.3917 21.6083 17.1792 21.75 16.9375 21.85C16.6958 21.95 16.4417 22 16.175 22H9.00001C8.45001 22 7.97918 21.8041 7.58751 21.4125C7.19585 21.0208 7.00001 20.55 7.00001 20ZM2.02501 6.24998C1.92501 5.69998 2.03335 5.20415 2.35001 4.76248C2.66668 4.32081 3.10001 4.04998 3.65001 3.94998L14.5 2.02498C15.0333 1.92498 15.5167 2.03748 15.95 2.36248C16.3833 2.68748 16.6667 3.11665 16.8 3.64998L16.975 4.42498C17.0583 4.75831 17.0083 5.02498 16.825 5.22498C16.6417 5.42498 16.425 5.54165 16.175 5.57498C15.925 5.60831 15.6875 5.56248 15.4625 5.43748C15.2375 5.31248 15.0833 5.08331 15 4.74998L14.825 3.99998L4.00001 5.92498L5.50001 14.525C5.55001 14.8083 5.50001 15.0625 5.35001 15.2875C5.20001 15.5125 4.98335 15.65 4.70001 15.7C4.41668 15.75 4.16668 15.6958 3.95001 15.5375C3.73335 15.3791 3.60001 15.1583 3.55001 14.875L2.02501 6.24998Z",
    fill: "currentColor"
  }
) }), vCe = Q("IconPostit")(bhe), whe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M5 19H14V15C14 14.7167 14.0958 14.4792 14.2875 14.2875C14.4792 14.0958 14.7167 14 15 14H19V5H5V19ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V14.175C21 14.4417 20.95 14.6958 20.85 14.9375C20.75 15.1792 20.6083 15.3917 20.425 15.575L15.575 20.425C15.3917 20.6083 15.1792 20.75 14.9375 20.85C14.6958 20.95 14.4417 21 14.175 21H5ZM11 14H8C7.71667 14 7.47917 13.9042 7.2875 13.7125C7.09583 13.5208 7 13.2833 7 13C7 12.7167 7.09583 12.4792 7.2875 12.2875C7.47917 12.0958 7.71667 12 8 12H11C11.2833 12 11.5208 12.0958 11.7125 12.2875C11.9042 12.4792 12 12.7167 12 13C12 13.2833 11.9042 13.5208 11.7125 13.7125C11.5208 13.9042 11.2833 14 11 14ZM16 10H8C7.71667 10 7.47917 9.90417 7.2875 9.7125C7.09583 9.52083 7 9.28333 7 9C7 8.71667 7.09583 8.47917 7.2875 8.2875C7.47917 8.09583 7.71667 8 8 8H16C16.2833 8 16.5208 8.09583 16.7125 8.2875C16.9042 8.47917 17 8.71667 17 9C17 9.28333 16.9042 9.52083 16.7125 9.7125C16.5208 9.90417 16.2833 10 16 10Z",
    fill: "currentColor"
  }
) }), yCe = Q("IconPostit2")(whe), xhe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM5 19H19V8H5V19Z",
    fill: "currentColor"
  }
) }), bCe = Q("IconSoftware")(xhe), She = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M6.05001 17.775C5.71668 17.5917 5.45835 17.3459 5.27501 17.0375C5.09168 16.7292 5.00001 16.3834 5.00001 16V11.2L2.60001 9.87502C2.41668 9.77502 2.28335 9.65002 2.20001 9.50002C2.11668 9.35002 2.07501 9.18336 2.07501 9.00002C2.07501 8.81669 2.11668 8.65002 2.20001 8.50002C2.28335 8.35002 2.41668 8.22502 2.60001 8.12502L11.05 3.52502C11.2 3.44169 11.3542 3.37919 11.5125 3.33752C11.6708 3.29586 11.8333 3.27502 12 3.27502C12.1667 3.27502 12.3292 3.29586 12.4875 3.33752C12.6458 3.37919 12.8 3.44169 12.95 3.52502L22.475 8.72502C22.6417 8.80836 22.7708 8.92919 22.8625 9.08752C22.9542 9.24586 23 9.41669 23 9.60002V16C23 16.2834 22.9042 16.5209 22.7125 16.7125C22.5208 16.9042 22.2833 17 22 17C21.7167 17 21.4792 16.9042 21.2875 16.7125C21.0958 16.5209 21 16.2834 21 16V10.1L19 11.2V16C19 16.3834 18.9083 16.7292 18.725 17.0375C18.5417 17.3459 18.2833 17.5917 17.95 17.775L12.95 20.475C12.8 20.5584 12.6458 20.6209 12.4875 20.6625C12.3292 20.7042 12.1667 20.725 12 20.725C11.8333 20.725 11.6708 20.7042 11.5125 20.6625C11.3542 20.6209 11.2 20.5584 11.05 20.475L6.05001 17.775ZM12 12.7L18.85 9.00002L12 5.30002L5.15001 9.00002L12 12.7ZM12 18.725L17 16.025V12.25L12.975 14.475C12.825 14.5584 12.6667 14.6209 12.5 14.6625C12.3333 14.7042 12.1667 14.725 12 14.725C11.8333 14.725 11.6667 14.7042 11.5 14.6625C11.3333 14.6209 11.175 14.5584 11.025 14.475L7.00001 12.25V16.025L12 18.725Z",
    fill: "currentColor"
  }
) }), wCe = Q("IconCourse")(She), Mhe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M3.5 20C3.08333 20 2.72917 19.8542 2.4375 19.5625C2.14583 19.2708 2 18.9167 2 18.5C2 18.0833 2.14583 17.7292 2.4375 17.4375C2.72917 17.1458 3.08333 17 3.5 17H4V6C4 5.45 4.19583 4.97917 4.5875 4.5875C4.97917 4.19583 5.45 4 6 4H20C20.2833 4 20.5208 4.09583 20.7125 4.2875C20.9042 4.47917 21 4.71667 21 5C21 5.28333 20.9042 5.52083 20.7125 5.7125C20.5208 5.90417 20.2833 6 20 6H6V17H10.5C10.9167 17 11.2708 17.1458 11.5625 17.4375C11.8542 17.7292 12 18.0833 12 18.5C12 18.9167 11.8542 19.2708 11.5625 19.5625C11.2708 19.8542 10.9167 20 10.5 20H3.5ZM15 20C14.7167 20 14.4792 19.9042 14.2875 19.7125C14.0958 19.5208 14 19.2833 14 19V9C14 8.71667 14.0958 8.47917 14.2875 8.2875C14.4792 8.09583 14.7167 8 15 8H21C21.2833 8 21.5208 8.09583 21.7125 8.2875C21.9042 8.47917 22 8.71667 22 9V19C22 19.2833 21.9042 19.5208 21.7125 19.7125C21.5208 19.9042 21.2833 20 21 20H15ZM16 17H20V10H16V17Z",
    fill: "currentColor"
  }
) }), xCe = Q("IconDigitalService")(Mhe), Ehe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    fill: "currentColor",
    d: "M8 11.75V7.5C8 7.08333 8.14583 6.72917 8.4375 6.4375C8.72917 6.14583 9.08333 6 9.5 6C9.91667 6 10.2708 6.14583 10.5625 6.4375C10.8542 6.72917 11 7.08333 11 7.5V11.75C11 12.1667 10.8542 12.5208 10.5625 12.8125C10.2708 13.1042 9.91667 13.25 9.5 13.25C9.08333 13.25 8.72917 13.1042 8.4375 12.8125C8.14583 12.5208 8 12.1667 8 11.75ZM13 11.525V3.5C13 3.08333 13.1458 2.72917 13.4375 2.4375C13.7292 2.14583 14.0833 2 14.5 2C14.9167 2 15.2708 2.14583 15.5625 2.4375C15.8542 2.72917 16 3.08333 16 3.5V11.525C16 12.025 15.8458 12.4 15.5375 12.65C15.2292 12.9 14.8833 13.025 14.5 13.025C14.1167 13.025 13.7708 12.9 13.4625 12.65C13.1542 12.4 13 12.025 13 11.525ZM3 14.975V11.5C3 11.0833 3.14583 10.7292 3.4375 10.4375C3.72917 10.1458 4.08333 10 4.5 10C4.91667 10 5.27083 10.1458 5.5625 10.4375C5.85417 10.7292 6 11.0833 6 11.5V14.975C6 15.475 5.84583 15.85 5.5375 16.1C5.22917 16.35 4.88333 16.475 4.5 16.475C4.11667 16.475 3.77083 16.35 3.4625 16.1C3.15417 15.85 3 15.475 3 14.975ZM5.4 21.05C4.96667 21.05 4.6625 20.8458 4.4875 20.4375C4.3125 20.0292 4.38333 19.6667 4.7 19.35L8.8 15.25C8.98333 15.0667 9.20417 14.9667 9.4625 14.95C9.72083 14.9333 9.95 15.0167 10.15 15.2L13 17.65L18.6 12.05H18C17.7167 12.05 17.4792 11.9542 17.2875 11.7625C17.0958 11.5708 17 11.3333 17 11.05C17 10.7667 17.0958 10.5292 17.2875 10.3375C17.4792 10.1458 17.7167 10.05 18 10.05H21C21.2833 10.05 21.5208 10.1458 21.7125 10.3375C21.9042 10.5292 22 10.7667 22 11.05V14.05C22 14.3333 21.9042 14.5708 21.7125 14.7625C21.5208 14.9542 21.2833 15.05 21 15.05C20.7167 15.05 20.4792 14.9542 20.2875 14.7625C20.0958 14.5708 20 14.3333 20 14.05V13.45L13.75 19.7C13.5667 19.8833 13.3458 19.9833 13.0875 20C12.8292 20.0167 12.6 19.9333 12.4 19.75L9.55 17.3L6.1 20.75C6.01667 20.8333 5.9125 20.9042 5.7875 20.9625C5.6625 21.0208 5.53333 21.05 5.4 21.05Z"
  }
) }), SCe = Q("IconFinans")(Ehe), _he = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M7 22C6.71667 22 6.47917 21.9042 6.2875 21.7125C6.09583 21.5208 6 21.2833 6 21V12.85C5.1 12.6167 4.375 12.1417 3.825 11.425C3.275 10.7083 3 9.9 3 9V3C3 2.71667 3.09583 2.47917 3.2875 2.2875C3.47917 2.09583 3.71667 2 4 2C4.28333 2 4.52083 2.09583 4.7125 2.2875C4.90417 2.47917 5 2.71667 5 3V8H6V3C6 2.71667 6.09583 2.47917 6.2875 2.2875C6.47917 2.09583 6.71667 2 7 2C7.28333 2 7.52083 2.09583 7.7125 2.2875C7.90417 2.47917 8 2.71667 8 3V8H9V3C9 2.71667 9.09583 2.47917 9.2875 2.2875C9.47917 2.09583 9.71667 2 10 2C10.2833 2 10.5208 2.09583 10.7125 2.2875C10.9042 2.47917 11 2.71667 11 3V9C11 9.9 10.725 10.7083 10.175 11.425C9.625 12.1417 8.9 12.6167 8 12.85V21C8 21.2833 7.90417 21.5208 7.7125 21.7125C7.52083 21.9042 7.28333 22 7 22ZM17 22C16.7167 22 16.4792 21.9042 16.2875 21.7125C16.0958 21.5208 16 21.2833 16 21V12.475C15.1 12.175 14.375 11.5458 13.825 10.5875C13.275 9.62917 13 8.54167 13 7.325C13 5.84167 13.3917 4.58333 14.175 3.55C14.9583 2.51667 15.9 2 17 2C18.1 2 19.0417 2.52083 19.825 3.5625C20.6083 4.60417 21 5.86667 21 7.35C21 8.56667 20.725 9.65 20.175 10.6C19.625 11.55 18.9 12.175 18 12.475V21C18 21.2833 17.9042 21.5208 17.7125 21.7125C17.5208 21.9042 17.2833 22 17 22Z",
    fill: "currentColor"
  }
) }), MCe = Q("IconFood")(_he), Ohe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M5 21C4.71667 21 4.47917 20.9042 4.2875 20.7125C4.09583 20.5208 4 20.2833 4 20V19C3.16667 19 2.45833 18.7083 1.875 18.125C1.29167 17.5417 1 16.8333 1 16V11C1 10.1667 1.29167 9.45833 1.875 8.875C2.45833 8.29167 3.16667 8 4 8V6C4 5.16667 4.29167 4.45833 4.875 3.875C5.45833 3.29167 6.16667 3 7 3H17C17.8333 3 18.5417 3.29167 19.125 3.875C19.7083 4.45833 20 5.16667 20 6V8C20.8333 8 21.5417 8.29167 22.125 8.875C22.7083 9.45833 23 10.1667 23 11V16C23 16.8333 22.7083 17.5417 22.125 18.125C21.5417 18.7083 20.8333 19 20 19V20C20 20.2833 19.9042 20.5208 19.7125 20.7125C19.5208 20.9042 19.2833 21 19 21C18.7167 21 18.4792 20.9042 18.2875 20.7125C18.0958 20.5208 18 20.2833 18 20V19H6V20C6 20.2833 5.90417 20.5208 5.7125 20.7125C5.52083 20.9042 5.28333 21 5 21ZM4 17H20C20.2833 17 20.5208 16.9042 20.7125 16.7125C20.9042 16.5208 21 16.2833 21 16V11C21 10.7167 20.9042 10.4792 20.7125 10.2875C20.5208 10.0958 20.2833 10 20 10C19.7167 10 19.4792 10.0958 19.2875 10.2875C19.0958 10.4792 19 10.7167 19 11V15H5V11C5 10.7167 4.90417 10.4792 4.7125 10.2875C4.52083 10.0958 4.28333 10 4 10C3.71667 10 3.47917 10.0958 3.2875 10.2875C3.09583 10.4792 3 10.7167 3 11V16C3 16.2833 3.09583 16.5208 3.2875 16.7125C3.47917 16.9042 3.71667 17 4 17ZM7 13H17V11C17 10.55 17.0917 10.1417 17.275 9.775C17.4583 9.40833 17.7 9.08333 18 8.8V6C18 5.71667 17.9042 5.47917 17.7125 5.2875C17.5208 5.09583 17.2833 5 17 5H7C6.71667 5 6.47917 5.09583 6.2875 5.2875C6.09583 5.47917 6 5.71667 6 6V8.8C6.3 9.08333 6.54167 9.40833 6.725 9.775C6.90833 10.1417 7 10.55 7 11V13Z",
    fill: "currentColor"
  }
) }), ECe = Q("IconFurniture")(Ohe), Ahe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    fill: "currentColor",
    d: "M5 11C4.45 11 3.97917 10.8042 3.5875 10.4125C3.19583 10.0208 3 9.55 3 9V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H9C9.55 3 10.0208 3.19583 10.4125 3.5875C10.8042 3.97917 11 4.45 11 5V9C11 9.55 10.8042 10.0208 10.4125 10.4125C10.0208 10.8042 9.55 11 9 11H5ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V15C3 14.45 3.19583 13.9792 3.5875 13.5875C3.97917 13.1958 4.45 13 5 13H9C9.55 13 10.0208 13.1958 10.4125 13.5875C10.8042 13.9792 11 14.45 11 15V19C11 19.55 10.8042 20.0208 10.4125 20.4125C10.0208 20.8042 9.55 21 9 21H5ZM15 11C14.45 11 13.9792 10.8042 13.5875 10.4125C13.1958 10.0208 13 9.55 13 9V5C13 4.45 13.1958 3.97917 13.5875 3.5875C13.9792 3.19583 14.45 3 15 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V9C21 9.55 20.8042 10.0208 20.4125 10.4125C20.0208 10.8042 19.55 11 19 11H15ZM15 21C14.45 21 13.9792 20.8042 13.5875 20.4125C13.1958 20.0208 13 19.55 13 19V15C13 14.45 13.1958 13.9792 13.5875 13.5875C13.9792 13.1958 14.45 13 15 13H19C19.55 13 20.0208 13.1958 20.4125 13.5875C20.8042 13.9792 21 14.45 21 15V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H15ZM5 9H9V5H5V9ZM15 9H19V5H15V9ZM15 19H19V15H15V19ZM5 19H9V15H5V19Z"
  }
) }), _Ce = Q("IconOther")(Ahe), Phe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    fill: "currentColor",
    d: "M23 5V19C23 19.55 22.8042 20.0208 22.4125 20.4125C22.0208 20.8042 21.55 21 21 21H18C17.7167 21 17.4792 20.9042 17.2875 20.7125C17.0958 20.5208 17 20.2833 17 20C17 19.7167 17.0958 19.4792 17.2875 19.2875C17.4792 19.0958 17.7167 19 18 19H21V5H12V5.5C12 5.78333 11.9042 6.02083 11.7125 6.2125C11.5208 6.40417 11.2833 6.5 11 6.5C10.7167 6.5 10.4792 6.40417 10.2875 6.2125C10.0958 6.02083 10 5.78333 10 5.5V4.95C10 4.41667 10.1917 3.95833 10.575 3.575C10.9583 3.19167 11.4167 3 11.95 3H21C21.55 3 22.0208 3.19583 22.4125 3.5875C22.8042 3.97917 23 4.45 23 5ZM1 12.025C1 11.6917 1.075 11.3833 1.225 11.1C1.375 10.8167 1.58333 10.5833 1.85 10.4L6.85 6.825C7.03333 6.69167 7.22083 6.59583 7.4125 6.5375C7.60417 6.47917 7.8 6.45 8 6.45C8.2 6.45 8.39583 6.47917 8.5875 6.5375C8.77917 6.59583 8.96667 6.69167 9.15 6.825L14.15 10.4C14.4167 10.5833 14.625 10.8167 14.775 11.1C14.925 11.3833 15 11.6917 15 12.025V19C15 19.55 14.8042 20.0208 14.4125 20.4125C14.0208 20.8042 13.55 21 13 21H11C10.45 21 9.97917 20.8042 9.5875 20.4125C9.19583 20.0208 9 19.55 9 19V16H7V19C7 19.55 6.80417 20.0208 6.4125 20.4125C6.02083 20.8042 5.55 21 5 21H3C2.45 21 1.97917 20.8042 1.5875 20.4125C1.19583 20.0208 1 19.55 1 19V12.025ZM3 12V19H5V16C5 15.45 5.19583 14.9792 5.5875 14.5875C5.97917 14.1958 6.45 14 7 14H9C9.55 14 10.0208 14.1958 10.4125 14.5875C10.8042 14.9792 11 15.45 11 16V19H13V12L8 8.45L3 12ZM17.5 9H18.5C18.6333 9 18.75 8.95 18.85 8.85C18.95 8.75 19 8.63333 19 8.5V7.5C19 7.36667 18.95 7.25 18.85 7.15C18.75 7.05 18.6333 7 18.5 7H17.5C17.3667 7 17.25 7.05 17.15 7.15C17.05 7.25 17 7.36667 17 7.5V8.5C17 8.63333 17.05 8.75 17.15 8.85C17.25 8.95 17.3667 9 17.5 9ZM17.5 13H18.5C18.6333 13 18.75 12.95 18.85 12.85C18.95 12.75 19 12.6333 19 12.5V11.5C19 11.3667 18.95 11.25 18.85 11.15C18.75 11.05 18.6333 11 18.5 11H17.5C17.3667 11 17.25 11.05 17.15 11.15C17.05 11.25 17 11.3667 17 11.5V12.5C17 12.6333 17.05 12.75 17.15 12.85C17.25 12.95 17.3667 13 17.5 13ZM17.5 17H18.5C18.6333 17 18.75 16.95 18.85 16.85C18.95 16.75 19 16.6333 19 16.5V15.5C19 15.3667 18.95 15.25 18.85 15.15C18.75 15.05 18.6333 15 18.5 15H17.5C17.3667 15 17.25 15.05 17.15 15.15C17.05 15.25 17 15.3667 17 15.5V16.5C17 16.6333 17.05 16.75 17.15 16.85C17.25 16.95 17.3667 17 17.5 17Z"
  }
) }), OCe = Q("IconRent")(Phe), The = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    fill: "currentColor",
    d: "M18.85 21.975C18.7167 21.975 18.5917 21.9542 18.475 21.9125C18.3583 21.8708 18.25 21.8 18.15 21.7L13.05 16.6C12.95 16.5 12.8792 16.3917 12.8375 16.275C12.7958 16.1583 12.775 16.0333 12.775 15.9C12.775 15.7667 12.7958 15.6417 12.8375 15.525C12.8792 15.4083 12.95 15.3 13.05 15.2L15.175 13.075C15.275 12.975 15.3833 12.9042 15.5 12.8625C15.6167 12.8208 15.7417 12.8 15.875 12.8C16.0083 12.8 16.1333 12.8208 16.25 12.8625C16.3667 12.9042 16.475 12.975 16.575 13.075L21.675 18.175C21.775 18.275 21.8458 18.3833 21.8875 18.5C21.9292 18.6167 21.95 18.7417 21.95 18.875C21.95 19.0083 21.9292 19.1333 21.8875 19.25C21.8458 19.3667 21.775 19.475 21.675 19.575L19.55 21.7C19.45 21.8 19.3417 21.8708 19.225 21.9125C19.1083 21.9542 18.9833 21.975 18.85 21.975ZM18.85 19.6L19.575 18.875L15.9 15.2L15.175 15.925L18.85 19.6ZM5.125 22C4.99167 22 4.8625 21.975 4.7375 21.925C4.6125 21.875 4.5 21.8 4.4 21.7L2.3 19.6C2.2 19.5 2.125 19.3875 2.075 19.2625C2.025 19.1375 2 19.0083 2 18.875C2 18.7417 2.025 18.6167 2.075 18.5C2.125 18.3833 2.2 18.275 2.3 18.175L7.6 12.875H9.725L10.575 12.025L6.45 7.9H5.025L2 4.875L4.825 2.05L7.85 5.075V6.5L11.975 10.625L14.875 7.725L13.8 6.65L15.2 5.25H12.375L11.675 4.55L15.225 1L15.925 1.7V4.525L17.325 3.125L20.875 6.675C21.1583 6.95833 21.375 7.27917 21.525 7.6375C21.675 7.99583 21.75 8.375 21.75 8.775C21.75 9.175 21.675 9.55833 21.525 9.925C21.375 10.2917 21.1583 10.6167 20.875 10.9L18.75 8.775L17.35 10.175L16.3 9.125L11.125 14.3V16.4L5.825 21.7C5.725 21.8 5.61667 21.875 5.5 21.925C5.38333 21.975 5.25833 22 5.125 22ZM5.125 19.6L9.375 15.35V14.625H8.65L4.4 18.875L5.125 19.6Z"
  }
) }), ACe = Q("IconRentWork")(The), Ihe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M3 10H4C4.28333 10 4.52083 10.0958 4.7125 10.2875C4.90417 10.4792 5 10.7167 5 11C5 11.2833 4.90417 11.5208 4.7125 11.7125C4.52083 11.9042 4.28333 12 4 12H3C2.71667 12 2.47917 11.9042 2.2875 11.7125C2.09583 11.5208 2 11.2833 2 11C2 10.7167 2.09583 10.4792 2.2875 10.2875C2.47917 10.0958 2.71667 10 3 10ZM4.7 15.4L5.4 14.7C5.6 14.5 5.83333 14.4042 6.1 14.4125C6.36667 14.4208 6.6 14.5167 6.8 14.7C7 14.9 7.10417 15.1375 7.1125 15.4125C7.12083 15.6875 7.025 15.925 6.825 16.125L6.125 16.825C5.925 17.025 5.6875 17.1208 5.4125 17.1125C5.1375 17.1042 4.9 17 4.7 16.8C4.51667 16.6 4.42083 16.3667 4.4125 16.1C4.40417 15.8333 4.5 15.6 4.7 15.4ZM5.4 7.3L4.7 6.6C4.5 6.4 4.40417 6.16667 4.4125 5.9C4.42083 5.63333 4.51667 5.4 4.7 5.2C4.9 5 5.1375 4.89583 5.4125 4.8875C5.6875 4.87917 5.925 4.975 6.125 5.175L6.825 5.875C7.025 6.075 7.12083 6.3125 7.1125 6.5875C7.10417 6.8625 7 7.1 6.8 7.3C6.6 7.48333 6.36667 7.57917 6.1 7.5875C5.83333 7.59583 5.6 7.5 5.4 7.3ZM17.3 19.3L13.25 15.25L12.5 17.5C12.4667 17.6167 12.4042 17.7042 12.3125 17.7625C12.2208 17.8208 12.125 17.85 12.025 17.85C11.925 17.85 11.8292 17.8167 11.7375 17.75C11.6458 17.6833 11.5833 17.5917 11.55 17.475L9.4 10.325C9.36667 10.1917 9.37083 10.0583 9.4125 9.925C9.45417 9.79167 9.51667 9.68333 9.6 9.6C9.68333 9.51667 9.79167 9.45417 9.925 9.4125C10.0583 9.37083 10.1917 9.36667 10.325 9.4L17.525 11.55C17.6417 11.5833 17.7292 11.6458 17.7875 11.7375C17.8458 11.8292 17.875 11.925 17.875 12.025C17.875 12.125 17.85 12.2208 17.8 12.3125C17.75 12.4042 17.6667 12.4667 17.55 12.5L15.3 13.3L19.3 17.3C19.5 17.5 19.6 17.7333 19.6 18C19.6 18.2667 19.5 18.5 19.3 18.7L18.7 19.3C18.5 19.5 18.2667 19.6 18 19.6C17.7333 19.6 17.5 19.5 17.3 19.3ZM10 5V4C10 3.71667 10.0958 3.47917 10.2875 3.2875C10.4792 3.09583 10.7167 3 11 3C11.2833 3 11.5208 3.09583 11.7125 3.2875C11.9042 3.47917 12 3.71667 12 4V5C12 5.28333 11.9042 5.52083 11.7125 5.7125C11.5208 5.90417 11.2833 6 11 6C10.7167 6 10.4792 5.90417 10.2875 5.7125C10.0958 5.52083 10 5.28333 10 5ZM15.175 5.875L15.9 5.15C16.0833 4.96667 16.3125 4.87083 16.5875 4.8625C16.8625 4.85417 17.1 4.95 17.3 5.15C17.4833 5.33333 17.5792 5.5625 17.5875 5.8375C17.5958 6.1125 17.5083 6.35 17.325 6.55L16.6 7.3C16.4167 7.5 16.1875 7.59583 15.9125 7.5875C15.6375 7.57917 15.4 7.48333 15.2 7.3C15 7.1 14.8958 6.8625 14.8875 6.5875C14.8792 6.3125 14.975 6.075 15.175 5.875Z",
    fill: "currentColor"
  }
) }), PCe = Q("IconService")(Ihe), Dhe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M4 18C3.45 18 2.97917 17.8042 2.5875 17.4125C2.19583 17.0208 2 16.55 2 16V5C2 4.45 2.19583 3.97917 2.5875 3.5875C2.97917 3.19583 3.45 3 4 3H11C11.2833 3 11.5208 3.09583 11.7125 3.2875C11.9042 3.47917 12 3.71667 12 4C12 4.28333 11.9042 4.52083 11.7125 4.7125C11.5208 4.90417 11.2833 5 11 5H4V16H20V14C20 13.7167 20.0958 13.4792 20.2875 13.2875C20.4792 13.0958 20.7167 13 21 13C21.2833 13 21.5208 13.0958 21.7125 13.2875C21.9042 13.4792 22 13.7167 22 14V16C22 16.55 21.8042 17.0208 21.4125 17.4125C21.0208 17.8042 20.55 18 20 18H17L17.7 18.7C17.8 18.8 17.875 18.9125 17.925 19.0375C17.975 19.1625 18 19.2917 18 19.425V20C18 20.2833 17.9042 20.5208 17.7125 20.7125C17.5208 20.9042 17.2833 21 17 21H7C6.71667 21 6.47917 20.9042 6.2875 20.7125C6.09583 20.5208 6 20.2833 6 20V19.425C6 19.2917 6.025 19.1625 6.075 19.0375C6.125 18.9125 6.2 18.8 6.3 18.7L7 18H4ZM14 11.175V4C14 3.71667 14.0958 3.47917 14.2875 3.2875C14.4792 3.09583 14.7167 3 15 3C15.2833 3 15.5208 3.09583 15.7125 3.2875C15.9042 3.47917 16 3.71667 16 4V11.175L17.9 9.3C18.0833 9.11667 18.3125 9.02083 18.5875 9.0125C18.8625 9.00417 19.1 9.1 19.3 9.3C19.4833 9.48333 19.575 9.71667 19.575 10C19.575 10.2833 19.4833 10.5167 19.3 10.7L15 15L10.7 10.7C10.5167 10.5167 10.4208 10.2875 10.4125 10.0125C10.4042 9.7375 10.5 9.3 10.7 9.3C10.8833 9.11667 11.1167 9.025 11.4 9.025C11.6833 9.025 11.9167 9.11667 12.1 9.3L14 11.175Z",
    fill: "currentColor"
  }
) }), TCe = Q("IconSoftwareOnetime")(Dhe), Rhe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M8.8 10.9499L10.95 8.77494L9.55 7.34994L9.15 7.74994C8.96667 7.93328 8.7375 8.02911 8.4625 8.03744C8.1875 8.04578 7.95 7.94994 7.75 7.74994C7.55 7.54994 7.45 7.31244 7.45 7.03744C7.45 6.76244 7.55 6.52494 7.75 6.32494L8.125 5.94994L7 4.82494L4.825 6.99994L8.8 10.9499ZM17 19.1749L19.175 16.9999L18.05 15.8749L17.65 16.2499C17.45 16.4499 17.2167 16.5499 16.95 16.5499C16.6833 16.5499 16.45 16.4499 16.25 16.2499C16.05 16.0499 15.95 15.8166 15.95 15.5499C15.95 15.2833 16.05 15.0499 16.25 14.8499L16.625 14.4499L15.2 13.0499L13.05 15.1999L17 19.1749ZM4 20.9999C3.71667 20.9999 3.47917 20.9041 3.2875 20.7124C3.09583 20.5208 3 20.2833 3 19.9999V17.1749C3 17.0416 3.025 16.9124 3.075 16.7874C3.125 16.6624 3.2 16.5499 3.3 16.4499L7.375 12.3749L3.05 8.04994C2.76667 7.76661 2.625 7.41661 2.625 6.99994C2.625 6.58328 2.76667 6.23328 3.05 5.94994L5.95 3.04994C6.23333 2.76661 6.58333 2.62911 7 2.63744C7.41667 2.64578 7.76667 2.79161 8.05 3.07494L12.4 7.39994L16.175 3.59994C16.375 3.39994 16.6 3.24994 16.85 3.14994C17.1 3.04994 17.3583 2.99994 17.625 2.99994C17.8917 2.99994 18.15 3.04994 18.4 3.14994C18.65 3.24994 18.875 3.39994 19.075 3.59994L20.4 4.94994C20.6 5.14994 20.75 5.37494 20.85 5.62494C20.95 5.87494 21 6.13328 21 6.39994C21 6.66661 20.95 6.92078 20.85 7.16244C20.75 7.40411 20.6 7.62494 20.4 7.82494L16.625 11.6249L20.95 15.9499C21.2333 16.2333 21.375 16.5833 21.375 16.9999C21.375 17.4166 21.2333 17.7666 20.95 18.0499L18.05 20.9499C17.7667 21.2333 17.4167 21.3749 17 21.3749C16.5833 21.3749 16.2333 21.2333 15.95 20.9499L11.625 16.6249L7.55 20.6999C7.45 20.7999 7.3375 20.8749 7.2125 20.9249C7.0875 20.9749 6.95833 20.9999 6.825 20.9999H4ZM5 18.9999H6.4L16.2 9.22494L14.775 7.79994L5 17.5999V18.9999Z",
    fill: "currentColor"
  }
) }), ICe = Q("IconStationary")(Rhe), khe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    fill: "currentColor",
    d: "M6.5 20C4.98333 20 3.6875 19.475 2.6125 18.425C1.5375 17.375 1 16.0917 1 14.575C1 13.275 1.39167 12.1167 2.175 11.1C2.95833 10.0833 3.98333 9.43333 5.25 9.15C5.66667 7.61667 6.5 6.375 7.75 5.425C9 4.475 10.4167 4 12 4C13.95 4 15.6042 4.67917 16.9625 6.0375C18.3208 7.39583 19 9.05 19 11C20.15 11.1333 21.1042 11.6292 21.8625 12.4875C22.6208 13.3458 23 14.35 23 15.5C23 16.75 22.5625 17.8125 21.6875 18.6875C20.8125 19.5625 19.75 20 18.5 20H6.5ZM6.5 18H18.5C19.2 18 19.7917 17.7583 20.275 17.275C20.7583 16.7917 21 16.2 21 15.5C21 14.8 20.7583 14.2083 20.275 13.725C19.7917 13.2417 19.2 13 18.5 13H17V11C17 9.61667 16.5125 8.4375 15.5375 7.4625C14.5625 6.4875 13.3833 6 12 6C10.6167 6 9.4375 6.4875 8.4625 7.4625C7.4875 8.4375 7 9.61667 7 11H6.5C5.53333 11 4.70833 11.3417 4.025 12.025C3.34167 12.7083 3 13.5333 3 14.5C3 15.4667 3.34167 16.2917 4.025 16.975C4.70833 17.6583 5.53333 18 6.5 18Z"
  }
) }), DCe = Q("IconSubscription")(khe), Lhe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    fill: "currentColor",
    d: "M7 16C7 15.45 7.19583 14.9792 7.5875 14.5875C7.97917 14.1958 8.45 14 9 14C9.55 14 10.0208 14.1958 10.4125 14.5875C10.8042 14.9792 11 15.45 11 16C11 16.55 10.8042 17.0208 10.4125 17.4125C10.0208 17.8042 9.55 18 9 18C8.45 18 7.97917 17.8042 7.5875 17.4125C7.19583 17.0208 7 16.55 7 16ZM5 23C4.71667 23 4.47917 22.9042 4.2875 22.7125C4.09583 22.5208 4 22.2833 4 22V14C4 13.7167 4.09583 13.4792 4.2875 13.2875C4.47917 13.0958 4.71667 13 5 13C5.28333 13 5.52083 13.0958 5.7125 13.2875C5.90417 13.4792 6 13.7167 6 14V19H12V15C12 14.7167 12.0958 14.4792 12.2875 14.2875C12.4792 14.0958 12.7167 14 13 14H18C18.55 14 19.0208 14.1958 19.4125 14.5875C19.8042 14.9792 20 15.45 20 16V22C20 22.2833 19.9042 22.5208 19.7125 22.7125C19.5208 22.9042 19.2833 23 19 23C18.7167 23 18.4792 22.9042 18.2875 22.7125C18.0958 22.5208 18 22.2833 18 22V21H6V22C6 22.2833 5.90417 22.5208 5.7125 22.7125C5.52083 22.9042 5.28333 23 5 23ZM12.8 7.65L10.15 10.3L10.375 11.75C10.3917 11.8333 10.3875 11.9083 10.3625 11.975C10.3375 12.0417 10.2917 12.1083 10.225 12.175L10.125 12.275C9.99167 12.4083 9.84583 12.4583 9.6875 12.425C9.52917 12.3917 9.40833 12.3 9.325 12.15L8.475 10.55L6.775 9.625C6.64167 9.55833 6.56667 9.45417 6.55 9.3125C6.53333 9.17083 6.575 9.05 6.675 8.95L6.875 8.75C6.90833 8.71667 7.025 8.675 7.225 8.625L8.725 8.825L11.375 6.175L6.675 3.625C6.49167 3.54167 6.39167 3.4 6.375 3.2C6.35833 3 6.41667 2.83333 6.55 2.7L6.725 2.525C6.80833 2.44167 6.89583 2.3875 6.9875 2.3625C7.07917 2.3375 7.175 2.34167 7.275 2.375L13.55 4L16.25 1.3C16.45 1.1 16.6917 1 16.975 1C17.2583 1 17.5 1.1 17.7 1.3C17.9 1.5 18 1.74167 18 2.025C18 2.30833 17.9 2.55 17.7 2.75L15 5.45L16.6 11.7C16.6333 11.8167 16.6375 11.925 16.6125 12.025C16.5875 12.125 16.5333 12.2167 16.45 12.3L16.35 12.4C16.2 12.55 16.0167 12.6083 15.8 12.575C15.5833 12.5417 15.425 12.4333 15.325 12.25L12.8 7.65ZM18 19V16H14V19H18Z"
  }
) }), RCe = Q("IconTravelAndTransport")(Lhe), kCe = () => /* @__PURE__ */ F(
  "svg",
  {
    width: "41",
    height: "20",
    viewBox: "0 0 41 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ d("rect", { x: "0.5", y: "0.5", width: "40", height: "19", rx: "2.5", fill: "white" }),
      /* @__PURE__ */ d("rect", { x: "0.5", y: "0.5", width: "40", height: "19", rx: "2.5", stroke: "#DEE0E4" }),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M10.128 14.144C9.512 14.144 8.956 14.024 8.46 13.784C7.972 13.536 7.584 13.184 7.296 12.728C7.016 12.264 6.876 11.708 6.876 11.06C6.876 10.404 7.028 9.848 7.332 9.392C7.644 8.928 8.056 8.576 8.568 8.336C9.08 8.088 9.632 7.964 10.224 7.964C10.704 7.964 11.128 8.044 11.496 8.204C11.864 8.356 12.168 8.552 12.408 8.792L11.748 9.656C11.516 9.472 11.28 9.332 11.04 9.236C10.808 9.14 10.56 9.092 10.296 9.092C9.904 9.092 9.556 9.176 9.252 9.344C8.956 9.504 8.724 9.732 8.556 10.028C8.388 10.324 8.304 10.668 8.304 11.06C8.304 11.452 8.384 11.796 8.544 12.092C8.712 12.388 8.94 12.616 9.228 12.776C9.524 12.936 9.868 13.016 10.26 13.016C10.596 13.016 10.904 12.952 11.184 12.824C11.464 12.696 11.716 12.544 11.94 12.368L12.516 13.256C12.18 13.544 11.804 13.764 11.388 13.916C10.972 14.068 10.552 14.144 10.128 14.144ZM17.8873 14.144C17.2873 14.144 16.8113 14.04 16.4593 13.832C16.1073 13.616 15.8553 13.32 15.7033 12.944C15.5513 12.568 15.4753 12.132 15.4753 11.636V9.2H13.9033V8.168L15.5353 8.108L15.7153 6.26H16.8553V8.108H19.5433V9.2H16.8553V11.624C16.8553 11.944 16.8993 12.212 16.9873 12.428C17.0753 12.636 17.2193 12.792 17.4193 12.896C17.6193 12.992 17.8833 13.04 18.2113 13.04C18.4673 13.04 18.6993 13.02 18.9073 12.98C19.1153 12.94 19.3153 12.884 19.5073 12.812L19.7713 13.808C19.5073 13.896 19.2233 13.972 18.9193 14.036C18.6153 14.108 18.2713 14.144 17.8873 14.144ZM21.9506 14V8.108H23.0906L23.2106 9.44H23.2466C23.5426 8.96 23.9066 8.596 24.3386 8.348C24.7786 8.092 25.2506 7.964 25.7546 7.964C25.9946 7.964 26.2026 7.984 26.3786 8.024C26.5546 8.064 26.7266 8.124 26.8946 8.204L26.6066 9.368C26.4146 9.304 26.2426 9.26 26.0906 9.236C25.9466 9.204 25.7626 9.188 25.5386 9.188C25.1386 9.188 24.7466 9.304 24.3626 9.536C23.9866 9.768 23.6466 10.172 23.3426 10.748V14H21.9506ZM32.3859 14.144C31.7059 14.144 31.1859 13.944 30.8259 13.544C30.4739 13.136 30.2979 12.572 30.2979 11.852V6.62H28.3779V5.528H31.6779V11.924C31.6779 12.324 31.7779 12.608 31.9779 12.776C32.1859 12.936 32.4379 13.016 32.7339 13.016C32.8859 13.016 33.0419 13 33.2019 12.968C33.3619 12.928 33.5419 12.868 33.7419 12.788L34.0659 13.808C33.7859 13.904 33.5219 13.984 33.2739 14.048C33.0339 14.112 32.7379 14.144 32.3859 14.144Z",
          fill: "#181B1F"
        }
      )
    ]
  }
), LCe = () => /* @__PURE__ */ F(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ d("rect", { x: "0.5", y: "0.5", width: "19", height: "19", rx: "2.5", fill: "white" }),
      /* @__PURE__ */ d("rect", { x: "0.5", y: "0.5", width: "19", height: "19", rx: "2.5", stroke: "#DEE0E4" }),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M9.624 14.144C9.072 14.144 8.544 14.044 8.04 13.844C7.536 13.644 7.088 13.36 6.696 12.992L7.512 12.044C7.808 12.308 8.144 12.524 8.52 12.692C8.896 12.852 9.292 12.932 9.708 12.932C10.164 12.932 10.512 12.844 10.752 12.668C10.992 12.484 11.112 12.256 11.112 11.984C11.112 11.752 11.056 11.568 10.944 11.432C10.832 11.288 10.676 11.168 10.476 11.072C10.284 10.976 10.056 10.876 9.792 10.772L8.724 10.304C8.452 10.192 8.184 10.048 7.92 9.872C7.664 9.696 7.452 9.472 7.284 9.2C7.124 8.928 7.044 8.6 7.044 8.216C7.044 7.8 7.16 7.428 7.392 7.1C7.624 6.764 7.944 6.5 8.352 6.308C8.768 6.108 9.24 6.008 9.768 6.008C10.248 6.008 10.704 6.1 11.136 6.284C11.576 6.46 11.96 6.7 12.288 7.004L11.568 7.892C11.304 7.676 11.024 7.512 10.728 7.4C10.44 7.28 10.096 7.22 9.696 7.22C9.328 7.22 9.028 7.3 8.796 7.46C8.564 7.62 8.448 7.848 8.448 8.144C8.448 8.344 8.512 8.508 8.64 8.636C8.768 8.764 8.932 8.876 9.132 8.972C9.34 9.068 9.56 9.16 9.792 9.248L10.824 9.692C11.16 9.82 11.456 9.976 11.712 10.16C11.968 10.344 12.168 10.572 12.312 10.844C12.456 11.108 12.528 11.432 12.528 11.816C12.528 12.24 12.412 12.628 12.18 12.98C11.948 13.332 11.616 13.616 11.184 13.832C10.752 14.04 10.232 14.144 9.624 14.144Z",
          fill: "#181B1F"
        }
      )
    ]
  }
), Nhe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    fill: "currentColor",
    d: "M9 13h6q.424 0 .713-.287A.97.97 0 0 0 16 12a.97.97 0 0 0-.287-.713A.97.97 0 0 0 15 11H9a.97.97 0 0 0-.713.287A.97.97 0 0 0 8 12q0 .424.287.713Q8.576 13 9 13m0 3h6q.424 0 .713-.287A.97.97 0 0 0 16 15a.97.97 0 0 0-.287-.713A.97.97 0 0 0 15 14H9a.97.97 0 0 0-.713.287A.97.97 0 0 0 8 15q0 .424.287.713Q8.576 16 9 16m0 3h3q.424 0 .713-.288A.97.97 0 0 0 13 18a.97.97 0 0 0-.287-.712A.97.97 0 0 0 12 17H9a.97.97 0 0 0-.713.288A.97.97 0 0 0 8 18q0 .424.287.712Q8.576 19 9 19m-3 3q-.824 0-1.412-.587A1.93 1.93 0 0 1 4 20V4q0-.824.588-1.412A1.93 1.93 0 0 1 6 2h7.175a1.98 1.98 0 0 1 1.4.575l4.85 4.85q.275.275.425.638.15.361.15.762V20q0 .824-.587 1.413A1.93 1.93 0 0 1 18 22zM18 9h-3.5q-.625 0-1.062-.437A1.45 1.45 0 0 1 13 7.5V4H6v16h12z"
  }
) }), NCe = Q("IconReport")(Nhe), Fhe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M10.55 18.2003L15.725 12.0003H11.725L12.45 6.32533L7.82497 13.0003H11.3L10.55 18.2003ZM8.99997 15.0003H5.89997C5.49997 15.0003 5.20414 14.8212 5.01247 14.4628C4.8208 14.1045 4.84164 13.7587 5.07497 13.4253L12.55 2.67533C12.7166 2.442 12.9333 2.2795 13.2 2.18783C13.4666 2.09616 13.7416 2.10033 14.025 2.20033C14.3083 2.30033 14.5166 2.47533 14.65 2.72533C14.7833 2.97533 14.8333 3.242 14.8 3.52533L14 10.0003H17.875C18.3083 10.0003 18.6125 10.192 18.7875 10.5753C18.9625 10.9587 18.9083 11.317 18.625 11.6503L10.4 21.5003C10.2166 21.717 9.99164 21.8587 9.72497 21.9253C9.4583 21.992 9.19997 21.967 8.94997 21.8503C8.69997 21.7337 8.50414 21.5545 8.36247 21.3128C8.2208 21.0712 8.16664 20.8087 8.19997 20.5253L8.99997 15.0003Z",
    fill: "currentColor"
  }
) }), FCe = Q("IconEnergy")(Fhe), Vhe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M12 21.9995C9.76667 21.9995 7.875 21.2245 6.325 19.6745C4.775 18.1245 4 16.2329 4 13.9995C4 12.1162 4.55833 10.3079 5.675 8.57452C6.79167 6.84118 8.325 5.32452 10.275 4.02452C10.6417 3.77452 11.0208 3.76202 11.4125 3.98702C11.8042 4.21202 12 4.54952 12 4.99952V6.29952C12 6.86618 12.1958 7.34118 12.5875 7.72452C12.9792 8.10785 13.4583 8.29952 14.025 8.29952C14.3083 8.29952 14.5792 8.23702 14.8375 8.11202C15.0958 7.98702 15.325 7.80785 15.525 7.57452C15.6583 7.40785 15.8292 7.30368 16.0375 7.26202C16.2458 7.22035 16.4417 7.26618 16.625 7.39952C17.675 8.14952 18.5 9.10785 19.1 10.2745C19.7 11.4412 20 12.6829 20 13.9995C20 16.2329 19.225 18.1245 17.675 19.6745C16.125 21.2245 14.2333 21.9995 12 21.9995ZM6 13.9995C6 14.8662 6.175 15.687 6.525 16.462C6.875 17.237 7.375 17.9162 8.025 18.4995C8.00833 18.4162 8 18.3412 8 18.2745V18.0495C8 17.5162 8.1 17.0162 8.3 16.5495C8.5 16.0829 8.79167 15.6579 9.175 15.2745L12 12.4995L14.825 15.2745C15.2083 15.6579 15.5 16.0829 15.7 16.5495C15.9 17.0162 16 17.5162 16 18.0495V18.2745C16 18.3412 15.9917 18.4162 15.975 18.4995C16.625 17.9162 17.125 17.237 17.475 16.462C17.825 15.687 18 14.8662 18 13.9995C18 13.1662 17.8458 12.3787 17.5375 11.637C17.2292 10.8954 16.7833 10.2329 16.2 9.64952C15.8667 9.86618 15.5167 10.0287 15.15 10.137C14.7833 10.2454 14.4083 10.2995 14.025 10.2995C12.9917 10.2995 12.0958 9.95785 11.3375 9.27452C10.5792 8.59118 10.1417 7.74952 10.025 6.74952C8.725 7.84952 7.72917 9.02035 7.0375 10.262C6.34583 11.5037 6 12.7495 6 13.9995ZM12 15.2995L10.575 16.6995C10.3917 16.8829 10.25 17.0912 10.15 17.3245C10.05 17.5579 10 17.7995 10 18.0495C10 18.5829 10.1958 19.0412 10.5875 19.4245C10.9792 19.8079 11.45 19.9995 12 19.9995C12.55 19.9995 13.0208 19.8079 13.4125 19.4245C13.8042 19.0412 14 18.5829 14 18.0495C14 17.7829 13.95 17.537 13.85 17.312C13.75 17.087 13.6083 16.8829 13.425 16.6995L12 15.2995Z",
    fill: "currentColor"
  }
) }), VCe = Q("IconFlame")(Vhe), Bhe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M12 22C9.71667 22 7.8125 21.2167 6.2875 19.65C4.7625 18.0833 4 16.1333 4 13.8C4 12.7667 4.23333 11.7333 4.7 10.7C5.16667 9.66667 5.75 8.675 6.45 7.725C7.15 6.775 7.90833 5.88333 8.725 5.05C9.54167 4.21667 10.3 3.49167 11 2.875C11.1333 2.74167 11.2875 2.64583 11.4625 2.5875C11.6375 2.52917 11.8167 2.5 12 2.5C12.1833 2.5 12.3625 2.52917 12.5375 2.5875C12.7125 2.64583 12.8667 2.74167 13 2.875C13.7 3.49167 14.4583 4.21667 15.275 5.05C16.0917 5.88333 16.85 6.775 17.55 7.725C18.25 8.675 18.8333 9.66667 19.3 10.7C19.7667 11.7333 20 12.7667 20 13.8C20 16.1333 19.2375 18.0833 17.7125 19.65C16.1875 21.2167 14.2833 22 12 22ZM12 20C13.7333 20 15.1667 19.4125 16.3 18.2375C17.4333 17.0625 18 15.5833 18 13.8C18 12.5833 17.4958 11.2083 16.4875 9.675C15.4792 8.14167 13.9833 6.46667 12 4.65C10.0167 6.46667 8.52083 8.14167 7.5125 9.675C6.50417 11.2083 6 12.5833 6 13.8C6 15.5833 6.56667 17.0625 7.7 18.2375C8.83333 19.4125 10.2667 20 12 20ZM12.275 19C12.475 18.9833 12.6458 18.9042 12.7875 18.7625C12.9292 18.6208 13 18.45 13 18.25C13 18.0167 12.925 17.8292 12.775 17.6875C12.625 17.5458 12.4333 17.4833 12.2 17.5C11.5167 17.55 10.7917 17.3625 10.025 16.9375C9.25833 16.5125 8.775 15.7417 8.575 14.625C8.54167 14.4417 8.45417 14.2917 8.3125 14.175C8.17083 14.0583 8.00833 14 7.825 14C7.59167 14 7.4 14.0875 7.25 14.2625C7.1 14.4375 7.05 14.6417 7.1 14.875C7.38333 16.3917 8.05 17.475 9.1 18.125C10.15 18.775 11.2083 19.0667 12.275 19Z",
    fill: "currentColor"
  }
) }), BCe = Q("IconDrop")(Bhe);
function Ar(e) {
  return (t) => function(n) {
    const r = {
      className: n.className ? n.className : void 0,
      accessibilityLabel: n.accessibilityLabel ? n.accessibilityLabel : void 0,
      decorative: n.decorative ? n.decorative : !0,
      primaryFill: n.primaryFill ? n.primaryFill : "fill-surface-common-icon-color",
      secondaryFill: n.secondaryFill ? n.secondaryFill : "fill-surface-common-secondary"
    }, {
      accessibilityLabel: o,
      decorative: i,
      className: a,
      primaryFill: s,
      secondaryFill: l
    } = r, c = I(a && a), u = {
      focusable: "false",
      role: i ? "presentation" : "img",
      primaryFill: s,
      secondaryFill: l
    };
    return o ? u["aria-label"] = o : u["aria-hidden"] = !0, /* @__PURE__ */ d(t, { className: c, ...u });
  };
}
const $he = (e) => /* @__PURE__ */ F("svg", { viewBox: "0 0 321 132", fill: "none", ...e, children: [
  /* @__PURE__ */ F("g", { clipPath: "url(#a)", children: [
    /* @__PURE__ */ d(
      "path",
      {
        className: "fill-surface-common-light",
        fillRule: "evenodd",
        d: "M311.013 128.62v-28.187c0-5.392-2.264-10.564-6.295-14.377l-11.727-11.093c-4.03-3.812-6.295-8.984-6.295-14.376v-15.36c0-5.393-2.264-10.565-6.295-14.377L254.084 5.954C250.053 2.142 244.586 0 238.886 0h-91.177c-5.7 0-11.168 2.142-15.198 5.955l-31.18 29.495c-4.032 3.813-9.498 5.955-15.199 5.955H48.93c-5.7 0-11.167 2.142-15.198 5.955L29.3 51.552c-4.03 3.813-6.295 8.984-6.295 14.377v8.46c0 5.392-2.265 10.563-6.296 14.376l-.784.742c-4.03 3.813-6.295 8.984-6.295 14.376v24.737z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        className: "fill-surface-common-primary-light",
        fillRule: "evenodd",
        d: "M58.493 43.763c8.766 0 15.872 7.128 15.872 15.922 0 1.401-.18 2.76-.52 4.055a20.9 20.9 0 0 1 5.692 14.357c0 11.594-9.422 20.992-21.044 20.992S37.45 89.691 37.45 78.097a20.9 20.9 0 0 1 5.691-14.357 16 16 0 0 1-.52-4.055c0-8.794 7.107-15.922 15.872-15.922",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        className: "fill-surface-common-secondary",
        fillRule: "evenodd",
        d: "M59.207 74.183c.59 0 1.07.478 1.07 1.068v8.806l4.937-6.76a1.067 1.067 0 0 1 1.484-.235c.474.341.58 1 .238 1.472l-.003.003-6.6 9.037-.056.07v21.229a1.069 1.069 0 0 1-2.14 0V90.031a1 1 0 0 1-.07-.064l-6.003-5.97a1.054 1.054 0 0 1-.002-1.494l.003-.003a1.07 1.07 0 0 1 1.505 0l4.566 4.543V75.251c0-.59.48-1.068 1.07-1.068Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        className: "fill-surface-common-primary",
        fillRule: "evenodd",
        d: "M37.45 70.803c6.463 0 11.702 5.272 11.702 11.775 0 1.037-.133 2.042-.383 3a15.48 15.48 0 0 1 4.196 10.617c0 8.574-6.946 15.525-15.515 15.525s-15.515-6.951-15.515-15.525c0-4.107 1.594-7.841 4.196-10.618a11.9 11.9 0 0 1-.383-2.999c0-6.503 5.24-11.775 11.702-11.775",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        className: "fill-surface-common-secondary",
        fillRule: "evenodd",
        d: "M37.987 93.218c.438 0 .794.355.794.792v6.489l3.662-4.983a.794.794 0 0 1 1.102-.175c.35.25.429.735.178 1.083l-.004.006-4.896 6.661-.042.053v15.648a.793.793 0 0 1-.794.792.793.793 0 0 1-.794-.792v-13.888l-.052-.047-4.453-4.403a.775.775 0 0 1-.006-1.098l.006-.005a.795.795 0 0 1 1.117 0l3.388 3.35v-8.69c0-.438.355-.793.794-.793",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        className: "fill-surface-common-primary-light",
        fillRule: "evenodd",
        d: "M264.112 45.008c-8.766 0-15.872 7.128-15.872 15.922 0 1.401.181 2.76.519 4.055a20.9 20.9 0 0 0-5.691 14.357c0 11.594 9.422 20.992 21.044 20.992s21.043-9.398 21.043-20.992a20.9 20.9 0 0 0-5.691-14.357 16 16 0 0 0 .519-4.055c0-8.794-7.106-15.922-15.871-15.922",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        className: "fill-surface-common-secondary",
        fillRule: "evenodd",
        d: "M263.398 75.428c-.591 0-1.07.478-1.07 1.068v8.806l-4.937-6.76a1.066 1.066 0 0 0-1.484-.235 1.05 1.05 0 0 0-.235 1.476l6.6 9.037q.027.037.056.07v21.229c0 .589.479 1.067 1.07 1.067s1.07-.478 1.07-1.067V91.276a1 1 0 0 0 .07-.063l6.003-5.972c.414-.411.415-1.08.002-1.493l-.003-.003a1.07 1.07 0 0 0-1.505.001l-4.567 4.543V76.496c0-.59-.479-1.067-1.07-1.067Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        className: "fill-surface-common-primary",
        fillRule: "evenodd",
        d: "M285.155 72.049c-6.463 0-11.702 5.271-11.702 11.774 0 1.037.133 2.042.383 3a15.48 15.48 0 0 0-4.196 10.617c0 8.574 6.946 15.525 15.515 15.525s15.515-6.951 15.515-15.525c0-4.106-1.594-7.841-4.196-10.617.25-.958.383-1.963.383-3 0-6.503-5.239-11.774-11.702-11.774",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        className: "fill-surface-common-secondary",
        fillRule: "evenodd",
        d: "M284.618 94.464a.793.793 0 0 0-.794.791v6.489l-3.662-4.983a.794.794 0 0 0-1.102-.175.775.775 0 0 0-.178 1.083l.004.006 4.896 6.661a1 1 0 0 0 .042.053v15.648a.793.793 0 0 0 1.588 0v-13.888l.052-.047 4.454-4.403a.775.775 0 0 0 .004-1.098l-.005-.005a.796.796 0 0 0-1.117 0l-3.388 3.35v-8.69a.793.793 0 0 0-.794-.792",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        className: "fill-surface-common-secondary",
        d: "M225.948 54.97c8.766 0 15.872-7.088 15.872-15.833 0-8.744-7.106-15.832-15.872-15.832s-15.871 7.088-15.871 15.832 7.106 15.833 15.871 15.833"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M181.965 11.03c6.465 0 11.705 5.217 11.705 11.652q0 .313-.016.623h-36.893a9 9 0 0 1-.006-.324c0-5.116 4.165-9.262 9.304-9.262a9.3 9.3 0 0 1 6.239 2.391 11.71 11.71 0 0 1 9.667-5.08m55.688 17.078c-6.464 0-11.705 5.217-11.705 11.652q0 .314.017.623h36.893q.005-.162.005-.324c0-5.115-4.165-9.262-9.303-9.262-2.401 0-4.59.905-6.24 2.391a11.7 11.7 0 0 0-9.667-5.08M131.545 40.383c-6.465 0-11.705 5.217-11.705 11.652q0 .314.016.623h36.893q.006-.162.006-.324c0-5.116-4.165-9.262-9.304-9.262a9.3 9.3 0 0 0-6.239 2.391 11.71 11.71 0 0 0-9.667-5.08",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        className: "fill-surface-common-primary-light",
        fillRule: "evenodd",
        d: "M55.823 128.798H5.431a13 13 0 0 1-.081-1.423c0-7.074 5.749-12.809 12.84-12.809.584 0 1.158.043 1.721.118a12.835 12.835 0 0 1 12.546-10.08 12.8 12.8 0 0 1 8.6 3.299c.498-6.62 6.036-11.838 12.8-11.838 6.858 0 12.46 5.364 12.82 12.116 6.769.36 12.146 5.948 12.146 12.789a12.73 12.73 0 0 1-2.68 7.828z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        className: "fill-surface-common-primary",
        fillRule: "evenodd",
        d: "M65.284 128.798h-38.65a10 10 0 0 1-.062-1.091c0-5.421 4.409-9.815 9.848-9.815.448 0 .888.033 1.32.09a9.84 9.84 0 0 1 9.622-7.724 9.83 9.83 0 0 1 6.597 2.528c.381-5.073 4.63-9.072 9.817-9.072 5.26 0 9.556 4.111 9.833 9.285 5.192.276 9.316 4.558 9.316 9.801a9.75 9.75 0 0 1-2.055 5.998z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        className: "fill-surface-common-primary-light",
        fillRule: "evenodd",
        d: "M263.394 128.798h50.392q.08-.702.081-1.423c0-7.074-5.749-12.809-12.84-12.809-.584 0-1.158.043-1.722.118a12.834 12.834 0 0 0-12.545-10.08 12.8 12.8 0 0 0-8.6 3.299c-.498-6.62-6.036-11.838-12.8-11.838-6.858 0-12.46 5.364-12.821 12.116-6.768.36-12.146 5.948-12.146 12.789 0 2.949 1.002 5.663 2.68 7.828z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        className: "fill-surface-common-primary",
        fillRule: "evenodd",
        d: "M253.933 128.798h38.65q.061-.537.062-1.091c0-5.421-4.409-9.815-9.848-9.815-.448 0-.888.033-1.32.09a9.84 9.84 0 0 0-9.623-7.724 9.83 9.83 0 0 0-6.596 2.528c-.382-5.073-4.629-9.072-9.817-9.072-5.26 0-9.557 4.111-9.834 9.285-5.191.276-9.315 4.558-9.315 9.801 0 2.259.768 4.339 2.055 5.998z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        className: "fill-surface-common-secondary",
        d: "M319.395 128.798H1.605c-.886 0-1.605.717-1.605 1.601S.719 132 1.605 132h317.79c.886 0 1.605-.717 1.605-1.601s-.719-1.601-1.605-1.601"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#A9A9A9",
        fillRule: "evenodd",
        d: "m262.947 88.949-21.484-22.771h-82.746l-19.974 24.194h27.107v38.426h98.44v-39.85z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#BA947F",
        fillRule: "evenodd",
        d: "M181.543 128.798h84.174v-2.847h-84.174z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#66493D",
        fillRule: "evenodd",
        d: "M134.463 128.798h47.08v-2.847h-47.08z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#BA947F",
        fillRule: "evenodd",
        d: "M262.863 125.951h2.854V91.795h-2.854z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#66493D",
        fillRule: "evenodd",
        d: "M260.01 125.951h2.853V91.795h-2.853z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#BA947F",
        fillRule: "evenodd",
        d: "M181.543 125.951h2.854V91.795h-2.854z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#66493D",
        fillRule: "evenodd",
        d: "M134.463 125.951h2.854V91.795h-2.854z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#BA947F",
        fillRule: "evenodd",
        d: "M137.317 125.951h2.853V91.795h-2.853z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#66493D",
        fillRule: "evenodd",
        d: "M178.69 125.951h2.853V91.795h-2.853z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#BA947F",
        fillRule: "evenodd",
        d: "M241.463 125.951h2.854V91.795h-2.854z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#66493D",
        fillRule: "evenodd",
        d: "M238.61 125.951h2.853V91.795h-2.853z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#BA947F",
        fillRule: "evenodd",
        d: "M251.45 125.951h2.853V91.795h-2.853z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#66493D",
        fillRule: "evenodd",
        d: "M248.597 125.951h2.853V91.795h-2.853z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#BA947F",
        fillRule: "evenodd",
        d: "M242.89 104.604h9.987v-2.847h-9.987zm0 14.232h9.987v-2.847h-9.987zm-49.933 7.115h2.853V91.795h-2.853z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#66493D",
        fillRule: "evenodd",
        d: "M190.103 125.951h2.854V91.795h-2.854z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#BA947F",
        fillRule: "evenodd",
        d: "M202.943 125.951h2.854V91.795h-2.854z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#66493D",
        fillRule: "evenodd",
        d: "M200.09 125.951h2.853V91.795h-2.853z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#BA947F",
        fillRule: "evenodd",
        d: "M194.383 104.604h9.987v-2.847h-9.987zm0 14.232h9.987v-2.847h-9.987zm-34.24 7.115h2.854V91.795h-2.854z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#66493D",
        fillRule: "evenodd",
        d: "M162.997 125.951h2.853V91.795h-2.853z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#BA947F",
        fillRule: "evenodd",
        d: "M150.157 125.951h2.853V91.795h-2.853z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#66493D",
        fillRule: "evenodd",
        d: "M153.01 125.951h2.853V91.795h-2.853z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#BA947F",
        fillRule: "evenodd",
        d: "M151.583 104.604h9.987v-2.847h-9.987zm0 14.232h9.987v-2.847h-9.987zm78.467 7.115h2.853V91.795h-2.853z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#66493D",
        fillRule: "evenodd",
        d: "M227.197 125.951h2.853V91.795h-2.853z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#BA947F",
        fillRule: "evenodd",
        d: "M214.357 125.951h2.853V91.795h-2.853z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#66493D",
        fillRule: "evenodd",
        d: "M211.503 125.951h2.854V91.795h-2.854z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#BA947F",
        fillRule: "evenodd",
        d: "M215.783 104.604h15.694v-5.693h-15.694zm26.415-39.159h-2.853l23.518 24.927h2.854zm-60.655 27.773h84.174v-2.846h-84.174z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#BA947F",
        fillRule: "evenodd",
        d: "M240.037 67.601h2.769L221.49 90.372h-2.853l21.4-22.77Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#66493D",
        fillRule: "evenodd",
        d: "m240.037 66.178-1.385 1.468 21.358 22.726h2.853z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#66493D",
        fillRule: "evenodd",
        d: "m239.345 65.445 1.385 1.467-22.093 23.46h-2.854z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#BA947F",
        fillRule: "evenodd",
        d: "M216.518 65.445h-2.853l23.518 24.927h2.854z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#BA947F",
        fillRule: "evenodd",
        d: "M214.357 67.601h2.769L195.81 90.372h-2.853l21.4-22.77Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#66493D",
        fillRule: "evenodd",
        d: "m214.357 66.178-1.385 1.468 21.358 22.726h2.853z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#66493D",
        fillRule: "evenodd",
        d: "m213.665 65.445 1.385 1.467-22.093 23.46h-2.854z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#BA947F",
        fillRule: "evenodd",
        d: "M186.558 65.445h-2.853l23.518 24.927h2.854z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#BA947F",
        fillRule: "evenodd",
        d: "M184.397 67.601h2.769L165.85 90.372h-2.853l21.4-22.77Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#66493D",
        fillRule: "evenodd",
        d: "m184.397 66.178-1.385 1.468 21.358 22.726h2.853z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#66493D",
        fillRule: "evenodd",
        d: "m183.705 65.445 1.385 1.467-22.093 23.46h-2.854z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#BA947F",
        fillRule: "evenodd",
        d: "M160.878 65.445h-2.853l23.518 24.927h2.854z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#BA947F",
        fillRule: "evenodd",
        d: "M158.717 67.601h2.769L140.17 90.372h-2.853l21.4-22.77Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#66493D",
        fillRule: "evenodd",
        d: "m158.717 66.178-1.385 1.468 21.358 22.726h2.853z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#66493D",
        fillRule: "evenodd",
        d: "m158.025 65.445 1.385 1.467-22.093 23.46h-2.854zm-23.562 27.773h47.08v-2.846h-47.08z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#BA947F",
        fillRule: "evenodd",
        d: "M244.168 68.291h-81.32l-2.705-2.846h81.32z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#A9A9A9",
        fillRule: "evenodd",
        d: "M98.797 128.798h52.786V94.641H98.797z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#BA947F",
        fillRule: "evenodd",
        d: "M100.223 128.798h84.174v-2.847h-84.174zm0-2.847h2.854V91.795h-2.854zm11.414 0h2.853V91.795h-2.853z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#66493D",
        fillRule: "evenodd",
        d: "M108.783 125.951h2.854V91.795h-2.854z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#BA947F",
        fillRule: "evenodd",
        d: "M121.623 125.951h2.854V91.795h-2.854z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#66493D",
        fillRule: "evenodd",
        d: "M118.77 125.951h2.853V91.795h-2.853z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#BA947F",
        fillRule: "evenodd",
        d: "M113.063 104.604h9.987v-2.847h-9.987zm0 14.232h9.987v-2.847h-9.987zm35.667 7.115h2.853V91.795h-2.853z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#66493D",
        fillRule: "evenodd",
        d: "M145.877 125.951h2.853V91.795h-2.853z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#BA947F",
        fillRule: "evenodd",
        d: "M133.037 125.951h2.853V91.795h-2.853z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#66493D",
        fillRule: "evenodd",
        d: "M130.183 125.951h2.854V91.795h-2.854z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#BA947F",
        fillRule: "evenodd",
        d: "M134.463 104.604h15.694v-5.693h-15.694z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        className: "fill-surface-common-secondary",
        fillRule: "evenodd",
        d: "M100.223 90.372h84.174L161.57 64.755H77.397z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#C3D0D8",
        fillRule: "evenodd",
        d: "M77.397 64.755 53.143 90.372v38.426h47.08V90.372z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#FFE168",
        fillRule: "evenodd",
        d: "M100.223 97.488h32.814v-7.116h-32.814z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M100.223 94.641v15.655h11.414v-9.962h31.386v-5.693zm51.36 34.157h32.814V90.372h-32.814z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        className: "fill-surface-common-secondary",
        fillRule: "evenodd",
        d: "M70.263 117.412h12.84v-14.231h-12.84z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#C3D0D8",
        fillRule: "evenodd",
        d: "M100.223 94.641h84.174v-4.27h-84.174z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#C3D0D8",
        fillRule: "evenodd",
        d: "M157.29 93.218h15.693l7.134 35.58h-15.694z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#BA947F",
        fillRule: "evenodd",
        d: "M46.01 128.798h1.427v-5.693H46.01zm17.12-11.386h-8.56v11.386h1.427v-5.693h7.133v5.693h1.427v-11.386z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#66493D",
        fillRule: "evenodd",
        d: "M61.703 128.798h1.427v-5.693h-1.427z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#BA947F",
        fillRule: "evenodd",
        d: "M51.717 115.989h17.12v-2.846h-17.12z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#66493D",
        fillRule: "evenodd",
        d: "M54.57 115.989h-2.853v-2.846H40.303v2.846h4.28v12.809h1.427v-5.693h7.133v5.693h1.427v-11.386h9.987v-1.423z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M51.717 108.873a4.275 4.275 0 0 0-4.28 4.27h8.56a4.275 4.275 0 0 0-4.28-4.27",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#BA947F",
        fillRule: "evenodd",
        d: "M171.557 128.798h-1.427l-9.987-44.119h1.427z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#66493D",
        fillRule: "evenodd",
        d: "M170.13 128.798h-1.427l-9.986-44.119h1.426zm9.987 0h-1.427l-9.987-44.119h1.427z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#BA947F",
        fillRule: "evenodd",
        d: "M181.543 128.798h-1.426l-9.987-44.119h1.427z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        fill: "#BA947F",
        fillRule: "evenodd",
        d: "M168.703 120.259h9.987v-2.847h-9.987zm-1.426-5.693h9.986v-2.846h-9.986zm-1.427-5.693h9.987v-2.846h-9.987zm-1.427-5.692h9.987v-2.847h-9.987zm9.987-5.693h-9.987l-1.426-2.847h9.986zm-1.427-5.693h-9.986l-1.427-2.846h9.987zm-2.853 34.156h9.987v-2.846h-9.987z",
        clipRule: "evenodd"
      }
    )
  ] }),
  /* @__PURE__ */ d("defs", { children: /* @__PURE__ */ d("clipPath", { id: "a", children: /* @__PURE__ */ d("path", { fill: "#fff", d: "M0 0h321v132H0z" }) }) })
] }), $Ce = Ar()($he), jhe = (e) => /* @__PURE__ */ d("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ d(
  "path",
  {
    d: "M11 12C9.9 12 8.95833 11.6083 8.175 10.825C7.39167 10.0417 7 9.1 7 8C7 6.9 7.39167 5.95833 8.175 5.175C8.95833 4.39167 9.9 4 11 4C12.1 4 13.0417 4.39167 13.825 5.175C14.6083 5.95833 15 6.9 15 8C15 9.1 14.6083 10.0417 13.825 10.825C13.0417 11.6083 12.1 12 11 12ZM11 10C11.55 10 12.0208 9.80417 12.4125 9.4125C12.8042 9.02083 13 8.55 13 8C13 7.45 12.8042 6.97917 12.4125 6.5875C12.0208 6.19583 11.55 6 11 6C10.45 6 9.97917 6.19583 9.5875 6.5875C9.19583 6.97917 9 7.45 9 8C9 8.55 9.19583 9.02083 9.5875 9.4125C9.97917 9.80417 10.45 10 11 10ZM21.4 22.8L18.9 20.3C18.55 20.5 18.175 20.6667 17.775 20.8C17.375 20.9333 16.95 21 16.5 21C15.25 21 14.1875 20.5625 13.3125 19.6875C12.4375 18.8125 12 17.75 12 16.5C12 15.25 12.4375 14.1875 13.3125 13.3125C14.1875 12.4375 15.25 12 16.5 12C17.75 12 18.8125 12.4375 19.6875 13.3125C20.5625 14.1875 21 15.25 21 16.5C21 16.95 20.9333 17.375 20.8 17.775C20.6667 18.175 20.5 18.55 20.3 18.9L22.8 21.4C22.9833 21.5833 23.075 21.8167 23.075 22.1C23.075 22.3833 22.9833 22.6167 22.8 22.8C22.6167 22.9833 22.3833 23.075 22.1 23.075C21.8167 23.075 21.5833 22.9833 21.4 22.8ZM16.5 19C17.2 19 17.7917 18.7583 18.275 18.275C18.7583 17.7917 19 17.2 19 16.5C19 15.8 18.7583 15.2083 18.275 14.725C17.7917 14.2417 17.2 14 16.5 14C15.8 14 15.2083 14.2417 14.725 14.725C14.2417 15.2083 14 15.8 14 16.5C14 17.2 14.2417 17.7917 14.725 18.275C15.2083 18.7583 15.8 19 16.5 19ZM3 18V17.225C3 16.6583 3.14167 16.1333 3.425 15.65C3.70833 15.1667 4.1 14.8 4.6 14.55C5.3 14.1833 6.07917 13.8625 6.9375 13.5875C7.79583 13.3125 8.675 13.1333 9.575 13.05C9.85833 13.0167 10.1 13.1 10.3 13.3C10.5 13.5 10.6 13.7417 10.6 14.025C10.6 14.3083 10.5 14.5542 10.3 14.7625C10.1 14.9708 9.85833 15.0917 9.575 15.125C8.625 15.2417 7.825 15.4167 7.175 15.65C6.525 15.8833 5.975 16.1167 5.525 16.35C5.35833 16.4333 5.22917 16.5542 5.1375 16.7125C5.04583 16.8708 5 17.0417 5 17.225V18H9.6C9.88333 18 10.1208 18.0958 10.3125 18.2875C10.5042 18.4792 10.6 18.7167 10.6 19C10.6 19.2833 10.5042 19.5208 10.3125 19.7125C10.1208 19.9042 9.88333 20 9.6 20H5C4.45 20 3.97917 19.8042 3.5875 19.4125C3.19583 19.0208 3 18.55 3 18Z",
    fill: "currentColor"
  }
) }), jCe = Q("IconPersonSearch")(jhe), HCe = ({ children: e }) => /* @__PURE__ */ d("div", { className: "fixed bottom-0 left-0 right-0 z-[2] flex h-[70px] flex-row items-stretch bg-white pb-2.5 shadow-[0_-2px_4px_0_rgba(0,0,0,0.1)]", children: e }), zCe = ({ text: e, icon: t, active: n, onClick: r }) => /* @__PURE__ */ F(
  "button",
  {
    className: I(
      "flex flex-1 flex-col items-center justify-center border-none bg-transparent",
      n ? "text-surface-common-primary" : "text-text-secondary"
    ),
    onClick: r,
    "aria-label": `Tab knapp for ${e}`,
    children: [
      t,
      /* @__PURE__ */ d(
        Ye,
        {
          className: I(
            n ? "text-surface-common-primary" : "text-text-secondary",
            "text-[10px]"
          ),
          children: e
        }
      )
    ]
  }
), Hhe = (e) => /* @__PURE__ */ F("svg", { viewBox: "0 0 120 120", fill: "none", ...e, children: [
  /* @__PURE__ */ d(
    "path",
    {
      d: "M30.45 76.65C26.97 69.22 23.72 61.12 20.62 53.54C20.5 53.25 20.17 53.11 19.88 53.23C19.86 53.23 19.84 53.25 19.82 53.26C13.02 57.15 10.18 57.31 1.65002 61.99C1.58002 62.03 13.66 85.92 13.73 85.88C21 81.78 23.62 79.88 30.14 77.41C30.43 77.3 30.58 76.98 30.47 76.69C30.47 76.68 30.46 76.66 30.45 76.65Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M25.57 54.08C24.4 54.53 23.25 54.86 22.12 55.33C21.95 55.41 21.75 55.33 21.67 55.16C21.59 54.99 21.67 54.79 21.84 54.71C23.06 54.12 22.3 54.45 25.63 52.92C25.89 52.8 26.2 52.92 26.32 53.19C29.75 60.75 31.63 64.52 34.77 72.25C34.88 72.51 34.77 72.81 34.51 72.93C33.85 73.23 31.18 74.31 30.52 74.59C30.33 74.67 30.12 74.59 30.03 74.4C29.94 74.21 30.03 74 30.22 73.91L33.61 72.19C32.87 70.42 26.09 55.26 25.57 54.07V54.08Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M30.24 51.42C31.44 44.81 36.31 38.82 40.97 36.51C41.91 36.06 42.9 35.69 43.91 35.43C44.11 35.37 44.31 35.48 44.37 35.68C44.43 35.88 44.32 36.08 44.12 36.14C43.19 36.47 42.29 36.89 41.45 37.41C36.19 40.59 32.48 45.82 31.22 51.84C31.14 52.26 30.83 52.3 27.74 53.73C27.58 53.82 27.37 53.76 27.28 53.59C27.19 53.42 27.25 53.22 27.42 53.13L30.22 51.42H30.24Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M38.73 43.15C39.18 42.66 40.01 41.9 40.11 41.8C42.73 39.25 45.93 37.36 49.43 36.29C49.63 36.24 49.75 36.04 49.7 35.84C49.65 35.64 49.45 35.52 49.25 35.57C45.45 36.3 41.98 38.23 39.34 41.07C38.9 41.59 38.51 42.16 38.18 42.76C38.08 42.92 38.13 43.13 38.29 43.23C38.43 43.32 38.62 43.29 38.73 43.16V43.15Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M42.73 44.4C45.32 42.01 48.29 40.07 51.53 38.67C51.72 38.6 51.82 38.39 51.74 38.19C51.67 38.01 51.47 37.91 51.29 37.97C47.91 38.76 43.98 41.27 42.22 43.95C42.11 44.1 42.13 44.31 42.28 44.42C42.42 44.53 42.61 44.51 42.73 44.39V44.4Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M38.43 64.81C36.49 65.76 36.45 65.78 34.32 66.66C34.15 66.74 33.95 66.68 33.87 66.51C33.79 66.34 33.85 66.14 34.02 66.06C35.41 65.16 36.86 64.34 38.35 63.61C38.59 63.49 38.89 63.56 39.05 63.79C41.14 66.7 45.4 67.03 48.94 66.26C49.84 66.08 50.72 65.81 51.57 65.44C51.75 65.35 51.97 65.44 52.06 65.61C52.14 65.78 52.08 65.99 51.91 66.09C47.77 68.59 41.38 68.38 38.43 64.81Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M48.89 55.7C49.93 59.48 51.27 63.17 52.9 66.73C53.82 68.81 54.78 70.91 56.8 71.97C58.98 73.12 61.26 72.37 63.58 71.61C67.15 70.44 77.22 65.6 79 64.96C80.51 64.41 85.24 62.27 86.07 60.9C87.1 59.21 86.58 57.19 85.93 55.33C84.19 51.07 82.24 46.91 80.08 42.85C78.99 41.01 77.71 39.43 75.58 39.25C72.71 39.01 70 40.9 67.62 42.11C63.68 44.11 60.2 45.4 56.31 47.75C56.14 47.85 56.08 48.08 56.18 48.26C56.28 48.44 56.51 48.49 56.69 48.39C59.97 46.47 64.5 44.79 68.08 43.05C70.3 41.97 72.98 40.14 75.49 40.36C77.2 40.51 78.24 41.94 79.12 43.43C80.07 45.04 84.02 53.3 84.86 55.71C85.37 57.19 85.92 58.98 85.1 60.32C84.42 60.98 83.64 61.53 82.79 61.96C81.45 62.71 80.05 63.36 78.62 63.91C75.07 65.19 63.56 71.25 59.57 71.47C58 71.58 56.48 70.84 55.6 69.53C54.17 67.67 50.78 59.78 49.55 55.53C49.49 55.35 49.29 55.27 49.12 55.33C48.96 55.39 48.87 55.55 48.9 55.71L48.89 55.7Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M68.14 56.66C69.57 56.05 70.58 55.48 72.13 54.76C73.44 54.15 75.27 53.35 76.16 52.86C77.26 52.25 77.67 52.04 77.5 51.68C77.3 51.25 76.76 51.56 75.68 51.96C74.63 52.34 66.28 55.93 66.86 56.89C67.06 57.23 67.45 56.96 68.15 56.67L68.14 56.66Z",
      className: "fill-surface-common-icon-color"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M69.13 59.79C70.44 59.25 71.38 58.69 72.86 57.94C74.14 57.3 75.81 56.5 76.58 56.05C77.65 55.43 77.99 55.24 77.82 54.89C77.63 54.5 77.23 54.72 76.08 55.16C73.52 56.25 71.05 57.53 68.68 58.99C68.09 59.42 67.7 59.65 67.88 59.97C68.05 60.26 68.29 60.13 69.12 59.78L69.13 59.79Z",
      className: "fill-surface-common-icon-color"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M69.04 63.9C69.62 63.62 79.34 58.52 79.55 58.4C80.51 57.85 80.94 57.7 80.75 57.31C80.56 56.9 80.07 57.13 78.17 57.95C74.66 59.55 71.26 61.37 67.98 63.4C67.16 63.97 66.75 64.18 66.95 64.52C67.15 64.86 67.48 64.65 69.04 63.9Z",
      className: "fill-surface-common-icon-color"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M118.35 73.08C118.35 73.08 118.35 73.02 118.35 72.99C118.35 72.9 118.33 72.81 118.29 72.73C118.03 72.27 117.3 72.44 116.88 72.46C116.33 72.48 115.79 72.51 115.24 72.54C114.1 72.59 112.96 72.64 111.82 72.62C109.09 72.59 106.28 72.22 103.86 70.88C102.88 70.33 101.93 69.69 100.99 69.14C98.5999 67.74 96.0699 66.34 93.7999 64.83C92.0099 63.64 89.8999 65.78 90.7999 67.71C92.0399 70.25 95.3599 71.63 95.2399 72.2C89.7299 71.61 86.2499 71.44 80.0499 68.39C79.0899 67.92 77.7299 67.25 76.8099 66.72C76.6499 66.62 76.4399 66.67 76.3499 66.83C76.2599 66.98 76.2899 67.18 76.4399 67.28C78.3299 68.78 80.4399 69.97 82.7099 70.8C86.6799 72.38 90.9199 73.14 95.1899 73.03C95.2999 75.17 97.5299 77.59 100.62 77.76C100.82 77.8 101.01 77.67 101.05 77.47C101.09 77.27 100.96 77.08 100.74 77.03C100.28 76.89 99.8399 76.7 99.4099 76.48C97.2999 75.46 95.6899 73.82 96.5799 71.66C96.7499 71.23 96.9799 70.81 97.2399 70.43C97.3699 70.3 97.3699 70.08 97.2399 69.95C97.1099 69.82 96.8899 69.82 96.7599 69.95C96.2699 70.3 95.8599 70.76 95.5699 71.3C95.7599 71.3 92.5899 69.2 91.7599 67.27C91.3299 66.31 92.3599 65.19 93.1799 65.75C95.5599 67.36 97.9399 68.67 100.42 70.12C103.22 71.76 104.84 73.41 110.42 73.71C111.76 73.78 113.1 73.76 114.44 73.7C115.12 73.67 115.8 73.63 116.49 73.6C116.84 73.58 117.2 73.56 117.55 73.55C117.79 73.54 118.23 73.61 118.34 73.32C118.37 73.25 118.37 73.18 118.37 73.1L118.35 73.08Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M73.79 70.13C75.02 71.07 76.45 72.07 80.19 73.28C82.43 74.09 84.78 74.57 87.16 74.72C87.36 74.75 87.55 74.62 87.58 74.42C87.61 74.22 87.48 74.03 87.28 74C86.59 73.83 85.93 73.63 85.25 73.47C82.07 72.82 78.99 71.79 76.06 70.4C75.74 70.26 74.47 69.71 74.15 69.56C73.99 69.46 73.78 69.51 73.69 69.67C73.59 69.83 73.64 70.04 73.8 70.13H73.79Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M71.93 73.17C73.99 74.54 76.21 75.63 78.55 76.42C80.83 77.38 83.23 78.04 85.68 78.37C85.88 78.41 86.07 78.28 86.11 78.08C86.15 77.89 86.03 77.7 85.84 77.65C85.13 77.43 84.45 77.18 83.77 76.96C76.58 74.68 79.11 75.29 72.24 72.57C72.08 72.48 71.87 72.54 71.78 72.7C71.69 72.86 71.75 73.07 71.91 73.16C71.91 73.16 71.92 73.16 71.93 73.16V73.17Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M69.42 75.82C71.2 77.64 73.27 78.73 75.67 79.95C83.95 84.15 93.9801 84.32 100.58 86.39C101.42 86.65 102.27 86.9 103.12 87.16C105.06 87.74 107 88.31 108.93 88.88C110 89.2 111.06 89.51 112.13 89.83C112.65 89.98 113.16 90.14 113.67 90.3C114.04 90.41 114.62 90.78 115 90.6C115.17 90.52 115.29 90.33 115.24 90.15C115.13 89.73 114.48 89.65 114.12 89.55C111.07 88.68 108.05 87.69 105.04 86.7C102.75 85.85 100.42 85.14 98.0501 84.55C91.6201 83.2 85.59 82.64 79.42 80.42C77 79.55 71.9501 77.38 69.8701 75.35C69.7301 75.22 69.52 75.23 69.39 75.37C69.27 75.5 69.27 75.7 69.39 75.83L69.42 75.82Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M54.67 52.01C55.89 50.61 55.12 49.33 54.93 48.8C53.73 45.44 50.82 43.65 47.5 45.13C44.91 46.32 43.04 48.66 42.44 51.44C42.39 51.62 42.49 51.81 42.67 51.86C42.85 51.91 43.04 51.81 43.09 51.63C43.09 51.63 43.09 51.61 43.09 51.6C44.02 49.27 45.74 47.34 47.96 46.16C50.19 45.17 52.37 45.77 54.07 49.16C54.27 49.54 54.43 49.94 54.57 50.35C54.29 51.4 53.04 52.46 51.98 51.82C51.1 51.31 50.66 49.73 48.93 49.77C47.28 49.8 46.1 51.78 45.27 53.21C43.51 56.25 42.85 61.25 46.29 62.07C47.39 62.27 48.52 62.16 49.55 61.75C49.73 61.7 49.83 61.51 49.78 61.33C49.73 61.15 49.54 61.05 49.36 61.1C48.44 61.33 47.48 61.32 46.56 61.09C43.97 60.29 45 55.93 46.26 53.77C46.8 52.84 47.88 50.91 48.96 50.89C50.04 50.87 50.3 52.13 51.44 52.77C52.18 53.18 53.07 53.16 53.8 52.74C53.31 53.35 53.05 54.12 53.06 54.91C53.06 56.92 54.69 58.55 56.7 58.55C58.71 58.55 60.33 56.92 60.34 54.91C60.32 51.81 56.81 50.78 54.68 52.01H54.67ZM58.47 56.66C57.48 57.61 55.92 57.61 54.93 56.66C52.87 54.66 55.31 52.04 56.83 52.22C58.89 52.47 60.09 55.09 58.47 56.66Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M56.82 52.22C55.3 52.04 52.8599 54.66 54.9199 56.66C55.9099 57.61 57.47 57.61 58.46 56.66C60.08 55.08 58.88 52.47 56.82 52.22Z",
      className: "fill-surface-common-icon-color"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M77.23 92.41C72.71 94.15 67.62 95.72 61.49 94.87C47.12 92.89 39.08 78.23 41.15 77.79C41.83 77.65 50.04 100.35 77.19 91.47C77.76 91.28 77.3 91.34 75.46 90.9C74.76 90.73 71.11 89.61 71.33 88.93C71.56 88.21 73.9 88.93 74.66 89.12C77.91 89.9 80.93 89.46 79.47 91.76C76.34 96.7 75.53 99.02 74.64 98.47C74.24 98.22 74.43 97.84 74.58 97.52C76.66 93.11 77.97 92.07 77.23 92.41Z",
      className: "fill-surface-common-icon-color"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M60.97 27.59C65.49 25.85 70.5799 24.28 76.7099 25.13C91.0799 27.11 99.12 41.77 97.05 42.21C96.37 42.35 88.1599 19.65 61.0099 28.53C60.4399 28.72 60.9 28.66 62.74 29.1C63.44 29.27 67.09 30.39 66.87 31.07C66.64 31.79 64.2999 31.07 63.5399 30.88C60.2899 30.1 57.2699 30.54 58.7299 28.24C61.8599 23.3 62.67 20.98 63.56 21.53C63.96 21.78 63.7699 22.16 63.6199 22.48C61.5399 26.89 60.23 27.93 60.97 27.59Z",
      className: "fill-surface-common-icon-color"
    }
  )
] }), ZCe = Ar()(Hhe), zhe = (e) => /* @__PURE__ */ F("svg", { viewBox: "0 0 120 120", fill: "none", ...e, children: [
  /* @__PURE__ */ d(
    "path",
    {
      d: "M33.9252 26.887C33.9606 27.463 33.1524 29.4153 30.1494 21.7671C29.8194 20.9265 29.982 20.1975 30.7218 20.6001C31.7544 21.1623 33.9558 26.4172 33.9252 26.887Z",
      className: "fill-surface-common-icon-color"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M46.5427 23.3422C46.1743 24.4492 44.9917 24.433 45.2449 22.804C46.4785 14.8618 49.5187 14.3938 46.5427 23.3422Z",
      className: "fill-surface-common-icon-color"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M17.3976 30.9341C18.267 31.0355 19.626 31.6277 21.5658 32.4653C23.0166 33.0917 22.5846 34.2869 21.648 33.9365C20.1666 33.3827 18.6504 32.9123 17.25 32.1581C16.2726 31.6319 16.1694 30.9077 17.3976 30.9341Z",
      className: "fill-surface-common-icon-color"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17.2023 44.2394C5.14569 51.2495 3.54713 52.2335 3.66244 52.9363C3.68064 53.0472 3.74148 53.1511 3.81064 53.2705L32.1324 101.552C32.545 102.251 32.7171 102.577 32.9557 102.637C33.194 102.696 33.4986 102.491 34.1748 102.131C38.2674 99.9534 42.3204 97.7016 46.359 95.4252C55.5517 90.2442 61.4502 87.0084 65.2104 84.945C66.2016 84.4014 67.0446 83.9388 67.7598 83.544C66.3204 84.0492 64.7058 84.618 62.8968 85.26C62.8956 85.2606 62.8566 85.2744 62.7816 85.3014C62.5422 85.3872 61.941 85.602 61.0614 85.9158C54.7763 89.4012 47.1109 93.6588 44.517 95.0994C43.9351 95.4222 43.6085 95.604 43.6098 95.6028C34.8056 100.43 33.5765 101.578 33.1126 101.325C33.0205 101.275 32.9586 101.17 32.8734 101.026C32.8626 101.008 4.79764 53.3479 4.80604 53.3623C4.57609 52.9733 4.65217 52.9295 7.02205 51.5647C7.70071 51.1739 8.56747 50.6747 9.66901 50.0281C9.67663 50.0237 13.061 48.0541 17.6389 45.3812L17.2023 44.2394Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M48.5778 37.9914C48.5718 38.4882 48.7212 38.322 42.4488 40.8558C38.7432 42.3528 29.7216 45.978 25.9482 47.298C25.1754 47.5686 25.3062 47.4258 23.4888 42.9378C23.2014 42.2286 23.2794 42.1104 24.0084 41.8152C28.8894 39.8382 39.5292 35.4384 45.6984 33.2292C46.5078 32.9394 46.5588 32.988 46.875 33.7842C47.6916 35.8386 48.1632 36.8076 48.5778 37.9914ZM45.8256 34.0884C44.3448 34.6086 42.2862 35.6538 24.48 42.5034C23.9808 42.6954 24.2238 42.5856 25.6296 46.146C25.8144 46.6146 25.9134 46.4022 26.9784 45.9762C48.5694 37.3398 47.6586 38.07 47.4738 37.6422C45.9222 34.044 46.0446 34.0116 45.8256 34.0884Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M28.1035 52.0873C27.5737 52.0447 27.5995 51.6031 27.9997 51.4123C29.7655 50.5705 28.7689 50.9611 38.9671 46.7929C47.3071 43.3843 47.1763 43.2817 47.4727 43.8463C47.8135 44.4961 47.1445 44.5267 37.0519 48.6115C31.5163 50.8519 29.1385 51.8917 28.1035 52.0873Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M30.9679 58.2382C30.3391 58.261 30.2881 57.655 30.6901 57.4384C31.2613 57.1312 30.6895 57.3598 45.8737 51.5848C47.5531 50.9464 47.9551 50.8048 48.1183 51.2914C48.2881 51.7978 48.0589 51.847 42.9007 53.806C42.5521 53.9386 31.3405 58.225 30.9679 58.2382Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M39.5221 83.3982C38.9323 83.352 38.9401 82.9542 39.3409 82.7436C41.0935 81.8244 47.1139 79.7616 49.1503 79.0854C50.7511 78.5532 51.0997 78.48 51.2407 78.9066C51.4273 79.473 51.0793 79.5732 44.8429 81.7452C43.5781 82.1856 40.8331 83.124 39.5221 83.3982Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M29.7031 54.9899C29.1223 55.0289 29.0407 54.5657 29.3227 54.3539C29.6935 54.0755 29.3113 54.2669 37.9567 50.7323C38.3275 50.5805 38.6977 50.4605 38.8645 50.8631C39.0979 51.4283 38.3629 51.5615 37.3357 51.9761C29.7283 55.0463 30.6535 54.6965 29.7031 54.9899Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M41.2027 86.0616C40.4899 86.043 40.4527 85.4208 40.9957 85.1994C42.9355 84.4086 43.8025 84.1416 46.5925 83.1972C47.3089 82.9548 47.6347 83.7492 46.8667 84.0594C45.6109 84.567 42.1651 85.8402 41.2027 86.0616Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M54.2747 67.4826C53.417 68.8626 52.9213 70.4898 52.9213 72.231C52.9213 77.2056 56.9689 81.2514 61.9417 81.2514C66.9163 81.2514 70.9621 77.2056 70.9621 72.231C70.9621 71.3256 70.8283 70.4508 70.5787 69.6258C70.3267 69.7566 70.0651 69.879 69.7939 69.993C69.9973 70.7046 70.1059 71.4558 70.1059 72.2322C70.1059 76.7346 66.4441 80.3964 61.9417 80.3964C57.4393 80.3964 53.7775 76.7346 53.7775 72.2322C53.7775 70.6914 54.2065 69.249 54.9514 68.0178C54.7193 67.8456 54.4936 67.6668 54.2747 67.4826Z",
      className: "fill-surface-common-icon-color"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M78.5544 78.3756L74.0214 66.639C73.8234 66.9276 73.6062 67.2066 73.3704 67.4742C74.613 70.6938 75.9522 74.1546 77.3946 77.8758C77.4996 78.147 77.451 78.213 77.1918 78.2988C76.2564 78.6078 57.0348 85.446 50.6412 87.7206L50.6375 87.7218L50.6342 87.723C49.3551 88.1778 48.5915 88.4496 48.5934 88.449C44.3479 89.9334 41.722 90.9402 40.0794 91.5702C38.0565 92.346 37.5252 92.55 37.2969 92.3694C37.2156 92.3052 37.1727 92.1924 37.1146 92.0394L37.1124 92.034C37.1052 92.0142 17.2518 40.3901 17.2578 40.4063C17.1024 40.0063 17.1765 39.9784 19.376 39.1508C20.1561 38.8573 21.2034 38.4632 22.6026 37.9163L22.7207 37.8715C24.6909 37.125 50.7314 27.2582 56.5422 24.8987C56.5545 24.8936 56.5665 24.8886 56.5781 24.8837C56.6286 24.8623 56.6735 24.8433 56.719 24.8414C56.9025 24.8339 57.0974 25.1041 57.7164 26.6144C57.9266 26.4061 58.1403 26.2277 58.356 26.0762L57.6006 24.1205L57.5909 24.1021C57.5255 23.9782 57.4717 23.8765 57.3902 23.8074C57.0156 23.4895 56.0555 23.8615 50.679 25.9449C48.3249 26.8571 45.1241 28.0973 40.755 29.7515C38.3119 30.6764 36.1086 31.5093 34.122 32.2602C18.2144 38.2733 16.2036 39.0334 16.2017 39.7985C16.2014 39.9092 16.2432 40.0201 16.291 40.1469L16.293 40.1525L36.2964 92.4324C36.3212 92.4966 36.3446 92.5578 36.3669 92.616C36.6087 93.2478 36.7235 93.5478 36.93 93.6378C37.1167 93.7194 37.3784 93.6288 37.8768 93.456C37.9795 93.4206 38.0922 93.3816 38.2164 93.3402C42.6114 91.8654 46.9788 90.309 51.3378 88.7268C61.2858 85.1154 67.6434 82.89 71.6904 81.474C77.6052 79.4034 78.5826 79.0614 78.615 78.6456C78.6216 78.5634 78.591 78.4776 78.5544 78.3756Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M56.3107 68.2188C46.8487 62.1912 50.4136 50.7337 59.4026 49.5621C59.7966 49.8567 60.2239 50.1605 60.6889 50.4785C59.716 50.5142 58.7447 50.6888 57.7957 51.0253C47.4799 54.6833 51.084 67.3848 61.7965 69.159C61.6711 69.5088 61.5529 69.8484 61.4419 70.1754C59.6209 69.8514 57.8518 69.201 56.3107 68.2188ZM66.8269 70.1844C71.2603 69.384 74.9131 66.5256 74.9335 61.6902C74.9347 61.4724 74.9275 61.2552 74.9131 61.0398C74.5465 60.8538 74.1955 60.6666 73.8583 60.477C74.5171 63.7722 73.0321 67.038 67.9987 68.7846C67.7029 68.8872 67.3879 68.9688 67.0627 69.0342C66.9835 69.4206 66.9049 69.8046 66.8269 70.1844ZM67.4461 67.1538C70.3033 66.2478 72.4783 64.1232 72.4927 60.8232C72.4945 60.405 72.4597 59.9923 72.3907 59.5866C72.0403 59.358 71.7031 59.1258 71.3743 58.8895C72.3679 61.6512 71.5813 64.557 67.6477 66.1572C67.5811 66.4878 67.5133 66.8202 67.4461 67.1538ZM65.9173 59.6962C62.2675 60.432 56.6557 57.6707 60.0145 52.2073C50.9464 54.133 53.2113 65.5986 62.7109 66.744C62.6041 67.0128 62.5003 67.2792 62.3989 67.542C60.8077 67.323 59.2482 66.789 57.9085 65.9358C50.3221 61.1034 53.4613 51.8959 60.6985 51.2833C60.8545 51.1137 61.0159 50.9588 61.1791 50.8135C61.4443 50.9961 61.7017 51.1764 61.9525 51.3544C61.4599 51.7955 60.8287 52.6628 60.0379 54.4729C58.7199 57.4885 64.0549 59.765 66.6025 58.4606C66.3763 58.85 66.1471 59.2636 65.9173 59.6962ZM68.1559 56.3123C68.1289 56.289 68.1013 56.2655 68.0737 56.2421C68.0623 56.2906 68.0497 56.3389 68.0371 56.387C68.0767 56.3584 68.1163 56.3336 68.1559 56.3123Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M70.2133 57.262C65.6425 53.5942 67.0945 54.082 61.1635 50.0602C57.4981 47.575 56.2603 46.024 54.7789 42.9808C54.0643 41.5132 53.4259 40.0012 53.0995 38.3818C52.9537 37.6576 53.1985 37.075 53.8651 36.7732C58.0435 34.8826 61.3897 43.1332 65.9983 43.636C67.5673 43.807 66.6121 42.094 65.6671 40.861C62.2057 36.3466 61.3117 34.0462 58.6711 33.3988C58.2271 33.2902 57.9631 33.2434 57.9835 33.028C58.0315 32.5264 59.5099 32.3134 61.1905 33.6484C62.0299 34.315 62.3401 34.7086 66.6991 40.756C68.8333 43.717 67.2409 44.7736 66.0043 44.5258C63.3271 43.9888 61.4683 42.2776 57.8119 38.5534C55.6279 36.3286 53.3521 37.2886 53.7613 38.4016C57.7387 49.2292 60.0427 46.948 67.8865 53.701C69.8239 55.369 73.0237 58.6624 79.6417 61.1292C82.6861 62.2638 85.8061 62.46 86.7163 62.997C88.6219 64.122 78.5911 63.9852 70.2133 57.262Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M96.5526 49.6377C98.5986 49.9803 113.83 61.5072 115.489 62.754C116.867 63.7902 116.905 64.9044 114 62.9874C109.168 59.7993 104.227 55.7103 97.2924 50.8779C96.1584 50.0877 97.4064 52.1769 93.1878 58.8747C91.455 61.6254 87.7314 65.2428 87.0882 65.7288C86.703 66.0198 85.8696 65.508 102.788 85.665C104.033 87.1488 103.718 87.9144 101.923 86.0466C98.9496 82.9524 90.4086 72.468 89.1006 70.671C85.5516 65.7966 85.7922 65.9808 86.604 65.085C90.4344 60.861 91.7934 59.5473 93.9534 55.0155C96.2232 50.2539 95.7648 49.7319 96.5526 49.6377Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M65.4565 27.6475C69.2017 30.1195 71.2687 31.2565 72.6973 33.4765C73.5241 34.7617 72.9691 35.2807 71.8021 33.7441C70.3861 31.8799 64.4479 27.3895 60.7615 26.7979C58.9927 26.5141 56.5897 30.1531 55.7857 31.7539C54.8869 33.5443 56.2003 35.6959 55.6561 35.7961C55.5181 35.8213 55.4647 35.7133 55.4173 35.6101C53.8681 32.2465 55.1029 30.4219 57.9391 27.2635C60.7753 24.1057 64.1023 27.4171 64.8127 27.1021C69.8137 24.8851 77.5789 31.5271 77.0473 32.1085C76.5157 32.6899 73.3681 28.2277 67.6909 27.2857C66.9253 27.1585 66.2209 27.3457 65.4565 27.6463V27.6475Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M80.7439 29.3902C85.3345 29.503 87.8239 34.4824 89.3533 38.8114C90.8035 42.916 91.8907 45.3874 94.4815 49.5808C95.4505 51.1486 94.6771 51.5998 93.4237 49.3546C87.3709 38.5132 87.7141 31.5394 80.9359 29.9794C80.2669 29.8252 80.1223 29.7604 80.1301 29.587C80.1409 29.3458 80.4337 29.3824 80.7439 29.3902Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M73.9092 27.4054C77.5968 27.3532 81.4848 31.114 81.1806 31.5208C80.8272 31.9942 79.6092 30.0466 76.2468 28.4986C74.4636 27.6778 72.2568 28.1632 72.2568 27.6928C72.2568 27.3688 72.5934 27.424 73.9092 27.4054Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M68.7576 57.3137C68.4774 59.4221 64.6908 77.3796 64.6872 77.3994C64.056 80.6214 61.5066 77.4852 54.483 70.6248C52.893 69.0714 54.0378 69.336 56.1072 70.1454C61.2816 72.1692 61.0806 73.503 61.4118 72.3222C62.8872 67.0692 68.5422 54.4235 68.7576 57.3137Z",
      className: "fill-surface-common-icon-color"
    }
  )
] }), WCe = Ar()(zhe), Zhe = (e) => /* @__PURE__ */ F("svg", { viewBox: "0 0 120 120", fill: "none", ...e, children: [
  /* @__PURE__ */ d(
    "path",
    {
      d: "M90.555 57.5838C81.2808 52.7472 66.5598 45.0732 58.8474 41.343C56.2158 40.0704 53.6958 40.9026 52.4448 43.1286C52.005 43.9086 51.4104 44.7834 50.058 47.2686C51.5266 47.0988 52.957 46.6877 54.2916 46.0518C56.856 44.8626 59.9622 46.0518 58.977 49.3518C58.149 52.1262 53.919 56.5128 45.7608 55.677C44.487 58.1514 42.816 61.2954 42.0318 63.0852C40.8648 65.7468 41.3796 68.019 44.0328 69.4908C50.517 73.0908 62.1468 78.6894 71.262 83.1984C73.7544 77.4144 79.1916 80.7882 87.0132 75.5538C89.6136 70.6188 91.971 66.3138 92.8692 64.4076C94.1478 61.6944 93.8292 59.2914 90.555 57.5838ZM53.7 67.542C51.5808 66.3258 49.5222 64.902 47.382 63.744C46.9512 63.5112 47.4498 62.784 47.922 62.9994C48.9528 63.4704 54.3678 66.0114 54.7422 66.8322C55.0386 67.4844 54.279 67.8732 53.7 67.542ZM59.0592 70.6728C58.4124 70.2912 56.6874 69.3918 56.2032 68.8392C55.5534 68.0982 55.9812 67.6872 56.8416 67.9452C57.927 68.4189 58.9675 68.9892 59.9508 69.6492C61.0026 70.2654 60.5076 71.5272 59.0604 70.6728H59.0592ZM65.2212 69.6528C63.5244 68.943 59.0226 66.0654 57.5586 65.2494C55.3152 63.9996 51.4956 62.163 49.6386 60.6468C49.5623 60.5891 49.5091 60.5061 49.4885 60.4127C49.4679 60.3193 49.4813 60.2216 49.5262 60.1372C49.5712 60.0528 49.6448 59.9871 49.7338 59.9521C49.8228 59.9171 49.9214 59.9149 50.0118 59.946C52.2696 60.6198 55.9092 62.8476 58.098 64.065C59.4636 64.8246 64.9722 67.7076 66.0354 68.679C66.594 69.1878 66.1626 70.0482 65.22 69.6546L65.2212 69.6528Z",
      className: "fill-surface-common-icon-color"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M57.5082 50.3022C58.1802 49.3422 58.5474 48.0378 57.4302 47.253C54.9198 45.4884 50.628 49.1388 47.9634 47.253C46.599 46.2858 43.9344 43.7916 47.0304 41.304C49.5228 39.3012 52.4904 39.03 55.4538 40.0554C55.8606 40.1964 56.1018 39.5688 55.7358 39.3654C52.7208 37.6854 48.6702 38.427 46.1136 40.6452C43.1622 43.206 44.8728 45.9696 46.284 47.3148C48.9312 49.8384 51.624 48.5082 54.5766 47.9094C55.3028 47.6927 56.0795 47.7163 56.7912 47.9766C57.6462 48.3996 57.117 49.3062 56.622 49.8966C54.3546 52.6158 50.5578 53.853 47.1054 53.7288C42.7128 53.571 38.9454 51.2532 35.1282 49.2684C34.7508 49.0722 34.4424 49.692 34.7862 49.9224C35.3018 50.2672 35.831 50.6026 36.3738 50.9286C31.1316 59.8296 28.1952 68.436 27.294 74.1714C27.2733 74.2669 27.2906 74.3668 27.3424 74.4497C27.3941 74.5327 27.4761 74.5922 27.571 74.6156C27.6659 74.6391 27.7662 74.6246 27.8506 74.5752C27.935 74.5259 27.9969 74.4456 28.023 74.3514C29.163 70.2264 30.1134 66.5256 31.7262 62.5176C33.2394 58.6686 35.0835 54.9581 37.2378 51.4278C40.4028 53.2068 43.7778 54.8328 47.3868 54.8508C51.168 54.8706 55.2672 53.4996 57.5082 50.3022Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M64.8378 43.2282C64.8798 43.3157 64.954 43.3836 65.0449 43.4177C65.1358 43.4518 65.2364 43.4494 65.3256 43.411C65.4147 43.3727 65.4856 43.3013 65.5234 43.2119C65.5612 43.1225 65.563 43.0219 65.5284 42.9312C63.12 36.2346 57.0558 31.0434 50.352 28.9308C54.4551 28.478 58.5091 27.6565 62.4648 26.4762C64.9674 25.7322 67.3638 24.6234 69.7554 23.919C71.3484 23.4498 72.2796 24.2892 70.8354 25.7532C67.9608 28.6602 64.6554 30.2364 60.882 31.7046C60.793 31.7385 60.7207 31.8057 60.6805 31.8919C60.6402 31.9782 60.6352 32.0768 60.6664 32.1667C60.6977 32.2566 60.7627 32.3309 60.8477 32.3736C60.9328 32.4164 61.0312 32.4244 61.122 32.3958C64.8552 31.5384 68.4306 29.1558 71.2554 26.6046C73.6914 24.4032 72.1896 22.3008 69.6522 22.9362C67.4622 23.4846 64.9212 24.7056 62.5914 25.4124C57.9771 26.793 53.2506 27.7659 48.4662 28.32C53.0862 26.2584 57.6846 22.6764 61.0278 19.2858C61.4574 18.8508 63.0174 16.8618 63.9276 17.0532C64.5732 17.1894 64.4478 18.0648 64.3224 18.5286C63.6367 20.6366 62.5251 22.5813 61.0566 24.2418C60.7902 24.5664 61.3272 25.0344 61.6176 24.726C63.1253 23.1478 64.3051 21.2863 65.0886 19.2492C65.4792 18.204 65.6286 16.3788 64.2156 16.0314C63.027 15.7398 61.5324 17.3028 60.8022 18.0714C56.8591 22.286 52.1206 25.6782 46.86 28.0524C50.4705 25.7083 53.5136 22.5894 55.7682 18.9222C56.3508 17.9724 56.8668 16.4568 58.1568 16.3422C58.65 16.2978 59.0814 16.5192 58.9878 17.22C58.9798 17.3101 59.004 17.4 59.0561 17.4739C59.1082 17.5477 59.1849 17.6007 59.2724 17.6233C59.3599 17.6459 59.4526 17.6368 59.534 17.5974C59.6154 17.558 59.6802 17.4911 59.7168 17.4084C60.1818 16.4388 59.2968 15.3948 58.2846 15.3486C56.745 15.2778 55.974 16.6686 55.3056 17.8152C54.4885 19.2297 53.5446 20.567 52.4856 21.8106C50.319 24.3432 46.866 27.6072 44.4168 28.26C37.9464 28.9944 30.051 34.9896 25.314 38.88C16.8 45.8682 8.15218 55.686 3.04798 65.5584C2.82658 65.988 3.42838 66.3924 3.69418 65.9682C9.88918 56.0682 16.488 47.7762 25.47 40.3122C29.481 36.9792 39.99 29.0922 45.7956 29.1432C54.1446 29.6838 61.3572 35.8758 64.8378 43.2282Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M116.318 77.5236C106.523 76.0836 99.8718 72.111 91.0416 75.1704C87.2238 76.4904 83.7312 78.6288 79.8534 79.7904C78.0228 80.34 75.9534 80.3718 74.2956 81.405C73.8414 81.6939 73.4551 82.0777 73.1632 82.53C72.8712 82.9822 72.6805 83.4923 72.6042 84.0252C72.1986 87.4644 76.1592 86.8554 78.3084 86.7168C81.048 86.5404 84.288 86.223 87.1092 86.4132C88.4226 86.502 88.3824 85.5612 87.3042 85.4682C84.4335 85.2946 81.5541 85.3243 78.6876 85.557C77.5668 85.6224 74.8662 86.0328 74.1114 85.2882C72.9156 84.108 74.5914 82.3296 75.9114 81.8682C77.5314 81.2982 79.4118 81.1254 81.1722 80.529C84.7044 79.3332 87.9396 77.4174 91.464 76.2018C95.6298 74.7654 98.8206 74.9472 103.078 75.7272C107.458 76.5294 111.854 77.9358 116.428 78.3564C116.951 78.4056 117.446 77.6892 116.318 77.5236Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M100.02 91.4544C95.775 88.8462 94.3476 88.3872 89.9028 90.7068C87.6836 91.9326 85.3174 92.8709 82.8612 93.4992C80.9932 93.9092 79.0702 94.0074 77.1702 93.7896C70.9788 92.862 58.9956 89.9268 54.0528 86.8464C53.3082 86.3826 51.003 84.909 51.7224 83.8848C52.2024 83.199 53.7966 83.9838 54.3816 84.1536C59.0694 85.512 66.3882 86.877 71.2176 86.5782C71.6436 86.5524 71.625 85.8798 71.2098 85.8378C64.2012 85.1358 61.8966 85.287 54.7206 83.205C53.5374 82.8618 51.6132 82.0338 50.8272 83.382C49.7238 85.2738 52.356 86.9904 53.6898 87.7692C59.0178 90.8808 69.8184 93.6168 75.9198 94.6692C72.0072 95.3376 58.6368 97.6518 55.863 98.1294C55.2522 98.2344 53.1822 98.9094 52.7376 98.1474C52.2048 97.2324 54.8316 96.177 55.3722 95.9106C58.0101 94.6685 60.7751 93.7168 63.6186 93.072C64.071 92.9604 63.9426 92.1864 63.4722 92.2584C60.661 92.7303 57.9315 93.6009 55.3662 94.8438C54.1662 95.4078 51.6894 96.3204 51.7176 97.9554C51.756 100.166 54.9438 99.2754 56.1606 99.0642C58.971 98.5782 72.969 96.207 77.1342 95.4396C74.2251 96.6156 71.4295 98.0547 68.7822 99.7392C65.7324 101.672 63.0192 104.653 62.0268 103.435C61.6284 102.945 62.316 102.182 62.6034 101.789C63.319 100.886 64.1074 100.043 64.9608 99.2688C65.298 98.9376 64.854 98.3286 64.4454 98.601C63.6637 99.1484 62.9643 99.8046 62.3682 100.55C61.6206 101.445 60.2682 102.917 61.3218 104.074C62.1018 104.932 63.3126 104.734 64.2018 104.162C65.8596 103.097 67.4196 101.722 69.1554 100.603C72.585 98.3946 77.1198 96.003 81.0648 95.0034C83.9316 94.3548 86.7291 93.4305 89.418 92.2434C93.9606 90.039 94.4676 89.3124 99.078 92.1396C103.663 94.9512 107.881 97.9662 112.323 100.955C112.406 101.011 112.509 101.033 112.608 101.016C112.707 100.998 112.796 100.942 112.855 100.861C112.914 100.779 112.938 100.678 112.924 100.578C112.909 100.478 112.856 100.388 112.777 100.327C108.732 97.0807 104.47 94.1163 100.02 91.4544Z",
      className: "fill-surface-common-secondary"
    }
  )
] }), qCe = Ar()(Zhe), Whe = (e) => /* @__PURE__ */ F("svg", { viewBox: "0 0 120 120", fill: "none", ...e, children: [
  /* @__PURE__ */ d(
    "path",
    {
      d: "M33.0096 39.2297C32.7138 37.9805 30.7896 36.7247 31.3446 31.6625C31.986 25.8995 35.7492 22.7135 41.3772 22.9025C40.3635 23.1088 39.3898 23.4774 38.4936 23.9939C38.2704 24.0575 36.606 23.8901 36.546 24.2723C36.486 24.6545 37.2468 24.6707 37.4658 24.6707C36.9351 25.0816 36.4521 25.5505 36.0258 26.0687C35.4382 26.0144 34.8463 26.0277 34.2618 26.1083C34.228 26.1178 34.1964 26.1339 34.1689 26.1556C34.1413 26.1773 34.1183 26.2042 34.1011 26.2348C34.0839 26.2653 34.073 26.299 34.0688 26.3338C34.0647 26.3687 34.0674 26.404 34.077 26.4377C34.1508 26.6999 34.41 26.6399 35.5002 26.7659C35.2417 27.1461 35.0122 27.5453 34.8138 27.9599C34.1682 27.9995 33.5232 28.0277 32.8818 28.0871C32.7144 28.0871 32.1618 28.6451 33.7938 28.6967L34.479 28.7165C34.2797 29.2441 34.1316 29.7896 34.0368 30.3455C33.4576 30.3567 32.8794 30.398 32.3046 30.4691C31.8342 30.5567 32.109 31.2653 33.9294 31.1381C33.876 31.6674 33.8519 32.1992 33.8574 32.7311C33.519 32.7311 31.8942 32.5199 31.8666 33.0179C31.839 33.5159 33.2406 33.4799 33.8574 33.5195L33.9654 34.9535C33.4554 35.0171 32.9418 35.0687 32.436 35.1485C32.1732 35.1887 32.196 35.5985 32.8344 35.6945C33.2503 35.7281 33.6679 35.736 34.0848 35.7179C34.1755 36.2271 34.3162 36.7261 34.5048 37.2077L33.561 37.2515C33.561 37.2515 32.5458 37.3547 33.2544 37.8329C33.7846 38.0291 34.3552 38.091 34.9152 38.0129C35.2161 38.5044 35.6245 38.9212 36.1098 39.2321C36.3846 39.4031 36.7698 39.0605 36.5082 38.7935C34.3776 36.4835 34.095 31.8437 35.1942 29.0045C37.1856 23.8271 43.9122 21.9113 47.5044 24.8147C47.5782 24.8651 47.6675 24.8873 47.7563 24.8775C47.8451 24.8677 47.9274 24.8265 47.9885 24.7613C48.0495 24.6961 48.0853 24.6113 48.0893 24.522C48.0932 24.4328 48.0652 24.3451 48.0102 24.2747C46.728 22.8485 44.6766 22.4705 42.9246 22.2347C38.4678 21.6413 34.35 22.7525 31.98 26.8943C30.2754 29.8613 29.7696 34.4615 31.26 37.6475C32.3286 39.8747 33.111 39.6599 33.0096 39.2297Z",
      className: "fill-surface-common-icon-color"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M49.5499 37.7124C49.3753 38.067 49.8361 38.7162 50.4295 37.7958C52.2061 35.0322 52.0825 29.5122 49.8163 26.7318C49.6693 26.5518 49.2031 26.8956 49.3225 27.0864C51.2743 30.1932 51.3601 34.0326 49.5499 37.7124Z",
      className: "fill-surface-common-icon-color"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M46.4232 33.423C46.3738 33.9331 46.1872 34.4203 45.8832 34.833C44.5796 33.171 43.2796 31.5074 41.9832 29.8422C42.7518 29.3364 43.2576 29.4444 44.118 29.2926C44.1622 29.2842 44.2042 29.2671 44.2418 29.2424C44.2794 29.2177 44.3117 29.1858 44.3369 29.1485C44.3621 29.1113 44.3797 29.0694 44.3886 29.0254C44.3976 28.9813 44.3978 28.9359 44.3892 28.8918C44.3034 28.4436 42.9246 28.0596 41.382 29.0856C41.1948 28.8708 40.9836 28.6656 40.7964 28.4682C40.6092 28.2708 40.2306 28.4682 40.362 28.7514C40.4955 29.0281 40.65 29.2943 40.824 29.5476C37.2714 33.132 41.8956 39.0462 45.7746 36.2076C46.5714 37.3476 47.0892 37.0038 47.0412 36.5142C46.9415 36.1511 46.743 35.8229 46.4676 35.5662C46.9838 34.9954 47.2925 34.2671 47.3436 33.4992C47.3537 33.3771 47.3149 33.2561 47.2357 33.1626C47.1566 33.0692 47.0435 33.011 46.9215 33.0009C46.7994 32.9908 46.6784 33.0296 46.5849 33.1087C46.4915 33.1879 46.4333 33.3009 46.4232 33.423ZM45.228 35.4978C42.36 37.6008 38.892 33.1482 41.4 30.3564C41.3364 30.3564 41.2638 30.18 45.228 35.4978Z",
      className: "fill-surface-common-icon-color"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M71.16 60.6888C61.5 42.6888 31.3332 41.9688 19.14 55.1406C15.1572 52.8264 8.92864 52.8384 7.86904 53.7942C6.89704 54.6744 7.76164 61.7598 9.54904 65.2542C10.2346 63.8342 11.2574 62.6036 12.528 61.6698C12.7314 61.5342 12.9264 61.8288 12.783 61.9884C8.84044 66.0942 7.01224 73.4484 9.79624 79.5834C18.4488 74.556 28.8 78.72 28.473 85.1178C28.1904 90.6342 22.9812 92.175 19.9224 92.4822C25.2594 95.4174 29.9664 96.5364 30.1302 96.915C31.038 99.0576 31.5798 102.06 33.5394 105.127C35.7414 105.481 39.9114 105.525 41.5326 105.127C42.699 102.14 43.4958 97.1616 43.6434 95.0472C43.6434 94.8642 44.0034 94.7766 44.0412 95.0118C44.1906 95.9992 44.1746 97.0045 43.9938 97.9866C47.96 97.5956 51.7794 96.2805 55.1454 94.1466C55.2846 94.0668 55.428 94.2744 55.356 94.4094C54.9024 95.274 52.3416 96.588 51.4134 97.0062C51.5448 97.3566 50.8734 104.044 50.5014 105.051C52.4088 105.418 56.7582 105.49 59.136 104.832C61.1868 104.263 66.0654 94.983 67.896 90.8928C66.3762 81.0438 66.9774 78.5544 71.16 60.6888ZM8.79064 55.0686C7.62724 54.4686 8.14144 54.1728 9.10924 54.543C11.001 55.2678 14.964 58.983 15.9318 60.5172C16.1718 60.888 15.5814 61.278 15.3066 60.951C13.8 59.139 10.8804 56.1462 8.79064 55.0686ZM15.7764 74.094C14.9442 74.1816 14.6058 71.514 15.6966 71.3616C16.605 71.2302 16.5294 74.0148 15.7764 74.094ZM16.047 67.6776C15.0762 67.941 14.709 68.5776 14.2872 69.3186C14.1156 69.6132 13.3986 69.5256 13.8888 68.343C14.241 67.5512 14.8883 66.9282 15.693 66.6066C15.7647 66.5776 15.8416 66.5636 15.9189 66.5655C15.9962 66.5674 16.0723 66.5851 16.1425 66.6176C16.2127 66.6501 16.2754 66.6966 16.3269 66.7543C16.3784 66.8121 16.4174 66.8797 16.4417 66.9532C16.466 67.0266 16.4749 67.1042 16.468 67.1812C16.4611 67.2582 16.4384 67.333 16.4014 67.4009C16.3644 67.4688 16.3139 67.5284 16.2529 67.576C16.192 67.6236 16.1219 67.6582 16.047 67.6776ZM24.2196 74.0778C23.4228 73.9092 23.6742 71.3658 24.6936 71.5608C25.713 71.7558 25.0398 74.2518 24.2196 74.0778ZM28.1706 67.7298C27.8706 67.092 27.3738 66.0288 25.4064 65.778C24.9486 65.7222 24.6618 64.698 26.2032 64.9818C26.8107 65.0557 27.3809 65.3138 27.8373 65.7214C28.2937 66.129 28.6144 66.6666 28.7562 67.2618C28.8438 67.8648 28.5216 68.4708 28.1706 67.7298ZM31.5636 88.599C31.3524 88.6422 31.2732 88.2924 31.4682 88.2006C33.6624 87.006 33.5946 84.9786 32.3082 83.1228C32.0136 82.6932 32.7282 82.179 33.0492 82.5828C34.6902 84.6522 34.518 87.9918 31.5636 88.599ZM39.5766 58.9398C38.3766 57.7488 35.5266 54.6384 31.9662 54.0012C33.5592 55.7814 35.4312 63.225 34.9662 65.6946C34.9499 65.7522 34.9151 65.8029 34.8673 65.8391C34.8195 65.8752 34.7612 65.8947 34.7013 65.8947C34.6414 65.8947 34.5832 65.8752 34.5354 65.8391C34.4875 65.8029 34.4528 65.7522 34.4364 65.6946C33.9906 62.7912 33.126 56.112 31.0764 54.2562C29.0298 54.6546 25.899 59.3262 24.7644 61.0908C24.6006 61.3494 24.1266 61.1706 24.2544 60.8718C25.3026 58.5965 26.8109 56.5632 28.6842 54.9C30.4608 53.271 31.6038 52.9404 33.9972 53.9124C36.0642 54.7339 37.902 56.0429 39.354 57.7278C40.1064 58.6254 39.9 59.2596 39.5766 58.9398ZM36.4662 51.2058C35.2716 50.7258 34.2996 50.0742 33.093 49.6722C36.9684 47.8362 44.9418 47.5854 48.8922 48.1626C50.2639 48.6129 51.5238 49.3503 52.5882 50.3256C48.8124 49.8474 42.0066 49.7478 36.4662 51.2058Z",
      className: "fill-surface-common-icon-color"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M50.6249 97.3051C49.4657 97.7551 45.1368 98.898 43.9296 98.565C43.707 100.21 43.1333 103.631 42.3365 104.993C44.848 105.326 47.3923 105.326 49.9037 104.993C50.3569 102.455 50.5981 99.8834 50.6249 97.3051Z",
      className: "fill-surface-common-icon-color"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M27.645 84.5844C27.645 81 23.2242 77.9244 17.493 78.156C10.2006 78.456 7.84679 81.315 7.87079 84.7362C7.89839 88.6704 11.3436 91.7292 17.1306 91.9284C22.9176 92.1276 27.645 90.1164 27.645 84.5844ZM13.1436 87.4278C11.0016 87.8046 10.515 83.5764 12.471 83.0112C14.259 82.494 15.2826 87.0516 13.1436 87.4278ZM21.7584 87.4956C19.608 87.3804 20.1894 82.74 22.1922 83.0826C23.8374 83.3658 23.9052 87.6108 21.7584 87.4956Z",
      className: "fill-surface-common-icon-color"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M19.986 93.2904C21.126 96.321 24.642 104.621 25.713 104.92C27.0036 105.28 30.321 105.358 32.5194 104.992C31.5198 103.518 29.9628 99.0174 29.6004 97.3608C27.96 97.269 21.6 94.35 19.986 93.2904Z",
      className: "fill-surface-common-icon-color"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M34.3434 43.3914C35.208 43.8606 37.2072 43.8456 36.8964 43.1802C36.6816 42.7224 35.5104 43.4634 34.1484 42.7146C33.9174 42.591 33.4836 42.9246 34.3434 43.3914Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M36.1121 42.579C36.1517 42.5444 36.1815 42.5 36.1985 42.4503C36.2155 42.4006 36.2192 42.3472 36.2091 42.2956C36.199 42.2441 36.1755 42.196 36.141 42.1564C36.1065 42.1167 36.0622 42.0868 36.0125 42.0696C35.6141 41.9622 35.1323 42.3918 33.5309 41.4696C33.2639 41.3142 32.9975 41.7246 33.8057 42.2664C34.4075 42.639 35.6177 42.9336 36.1121 42.579Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M46.5744 26.5884C46.4862 26.6994 46.5426 26.9154 46.7136 26.8956C47.4264 26.8116 47.9088 26.3694 49.5018 26.2542C49.598 26.2542 49.6901 26.216 49.7581 26.1481C49.8261 26.0801 49.8642 25.9879 49.8642 25.8918C49.8642 25.7957 49.8261 25.7035 49.7581 25.6356C49.6901 25.5676 49.598 25.5294 49.5018 25.5294C48.6534 25.5852 47.0964 25.9326 46.5744 26.5884Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M44.5872 22.0566C45.4986 21.9416 46.4242 22.0688 47.2709 22.4254C48.1176 22.7819 48.8553 23.3552 49.41 24.0876C49.9596 24.7644 50.43 24.2628 49.8084 23.478C48.8995 22.3793 47.5918 21.6861 46.1724 21.5508C44.3922 21.3834 44.2452 22.0968 44.5872 22.0566Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M35.3112 44.4432C36.6606 44.7997 38.0837 44.7636 39.4134 44.3394C40.935 43.8294 40.4454 43.1688 40.1184 43.2126C39.6882 43.2678 39.1584 44.1642 35.3832 44.0088C35.333 44.0133 35.2857 44.0343 35.2487 44.0686C35.2117 44.1029 35.1872 44.1484 35.179 44.1982C35.1707 44.2479 35.1792 44.2989 35.2032 44.3433C35.2271 44.3877 35.2651 44.4228 35.3112 44.4432Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M38.3777 39.6558C39.1739 40.4532 39.6245 39.9426 39.0509 39.2574C38.4052 38.6504 37.9558 37.8641 37.7603 36.9996C37.6967 36.7764 37.0355 36.5292 37.3625 37.8954C37.5412 38.5609 37.8912 39.1679 38.3777 39.6558Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M37.7964 40.158C37.92 39.798 37.4418 39.6282 37.227 39.8868C36.1992 41.1372 34.4394 40.6836 33.267 40.2852C33.024 40.1976 32.907 40.5162 33.087 40.6836C34.3278 41.7306 37.29 41.631 37.7964 40.158Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M51.2263 25.1706C53.0305 27.7038 56.9017 33.642 59.4427 35.1636C59.4881 35.1894 59.5413 35.1981 59.5926 35.1882C59.6439 35.1783 59.69 35.1505 59.7226 35.1096C59.7553 35.0688 59.7722 35.0176 59.7705 34.9654C59.7688 34.9131 59.7485 34.8632 59.7133 34.8246C56.4355 31.332 54.2851 28.2174 51.5173 24.3504C51.1189 23.7726 50.8279 23.6904 50.7487 24.3702C50.6512 25.0522 50.4747 25.7205 50.2225 26.3616C50.0077 27.0108 50.8597 26.9592 51.2263 25.1706Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M51.8274 34.8528C52.2258 35.7012 53.0424 37.059 53.8506 37.5372C53.8938 37.5689 53.9468 37.5843 54.0003 37.5807C54.0537 37.5771 54.1042 37.5548 54.1428 37.5177C54.1814 37.4805 54.2056 37.4309 54.2112 37.3776C54.2168 37.3244 54.2034 37.2708 54.1734 37.2264C53.58 36.2706 53.1456 36.1194 52.4526 34.6098C52.437 34.5684 52.4133 34.5304 52.3829 34.4981C52.3525 34.4658 52.316 34.4399 52.2755 34.4218C52.235 34.4038 52.1913 34.3939 52.147 34.3928C52.1027 34.3917 52.0586 34.3994 52.0172 34.4155C51.9759 34.4315 51.9382 34.4556 51.9062 34.4864C51.8743 34.5171 51.8487 34.5539 51.8311 34.5946C51.8134 34.6352 51.804 34.679 51.8034 34.7233C51.8027 34.7677 51.8109 34.8117 51.8274 34.8528Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M41.7672 44.1162C44.8272 45.6228 55.5834 45.411 61.2588 44.5626C65.2056 43.9728 71.2392 43.0212 74.5248 40.803C74.7 40.6794 74.5686 40.3686 74.3574 40.4484C69.2916 42.4398 67.4718 42.8382 62.091 43.6944C53.991 44.973 43.902 44.646 42.042 43.6386C40.8474 43.0014 40.5528 41.3646 40.5846 40.0938C51.8916 40.5558 59.088 37.509 65.6754 34.1202C69.0888 32.3802 72.3702 29.6394 77.5638 30.4362C87.2838 31.9254 90.9612 50.0106 90.774 55.6104C90.2244 57.5304 78.882 60.6126 72.534 59.0394C73.6014 53.8194 72.6972 48.0036 69.4872 43.746C69.4502 43.6933 69.3938 43.6574 69.3303 43.6462C69.2668 43.6351 69.2016 43.6496 69.1488 43.6866C69.0961 43.7236 69.0602 43.78 69.049 43.8435C69.0379 43.907 69.0524 43.9723 69.0894 44.025C71.7856 48.497 72.7263 53.8104 71.7294 58.9362C71.598 59.5962 72.4224 59.7762 73.4136 59.9238C78.0618 60.6006 85.9998 59.5932 89.9736 57.2076C90.9174 56.6418 91.4316 56.2596 91.4316 55.4988C91.4316 47.5734 87.4884 32.0208 78.3444 29.8308C73.4058 28.6356 69.6444 31.4238 65.4162 33.483C55.92 38.1462 50.796 39.855 40.2936 39.5244C40.2409 39.5166 40.1871 39.5204 40.136 39.5356C40.0849 39.5507 40.0377 39.5768 39.9977 39.6121C39.9577 39.6473 39.9259 39.6908 39.9045 39.7396C39.883 39.7884 39.8725 39.8413 39.8736 39.8946C39.7998 41.4996 40.2216 43.356 41.7672 44.1162Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M65.91 22.809C65.756 22.7806 65.5969 22.8106 65.4638 22.8931C65.3307 22.9757 65.2331 23.1048 65.19 23.2554C65.1462 23.4744 65.3016 23.5554 65.4408 23.4306C65.5835 23.2594 65.7856 23.1484 66.0066 23.1198C66.2688 23.0442 66.2208 22.8372 65.91 22.809Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M64.839 21.873C65.1374 21.8173 65.4441 21.8255 65.739 21.897C65.97 21.9528 66.165 21.8292 66.0696 21.597C65.9304 21.2502 65.1258 21.1704 64.7034 21.342C64.281 21.5136 64.2654 21.9804 64.839 21.873Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M64.2175 25.4814C64.4917 25.5954 65.3485 25.6014 65.4529 25.1988C65.4605 25.1667 65.4609 25.1332 65.4538 25.101C65.4468 25.0687 65.4325 25.0384 65.4122 25.0124C65.3918 24.9864 65.3659 24.9654 65.3362 24.9508C65.3066 24.9362 65.2741 24.9285 65.2411 24.9282C65.0101 24.9282 64.8667 25.1946 64.5121 25.143C64.8193 23.883 64.4413 23.4702 64.2895 24.2628C64.1779 24.84 63.9457 25.3686 64.2175 25.4814Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M65.982 26.4888C66.4734 26.8176 67.6944 26.6244 67.902 25.7724C67.9796 25.3825 67.946 24.9785 67.8051 24.6067C67.6642 24.2348 67.4217 23.9101 67.1052 23.6694C66.8652 23.4894 66.6594 23.7768 66.7278 24.0294C66.942 24.8622 66.225 25.551 65.8746 25.9176C65.6316 26.16 65.6886 26.2926 65.982 26.4888ZM67.1946 24.5232C67.7604 25.32 67.539 26.3616 66.2346 26.1348C66.7516 25.7426 67.0958 25.1647 67.1946 24.5232Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M62.6285 22.0722C62.4508 22.2417 62.3204 22.4548 62.2505 22.6903C62.1807 22.9257 62.1736 23.1754 62.2301 23.4144C62.2661 23.526 62.5373 23.7294 62.6285 23.2194C62.6825 22.9213 62.8208 22.6448 63.0269 22.4226C63.3413 22.0686 62.9351 21.8172 62.6285 22.0722Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M63.2622 24.3426C63.3706 24.2392 63.5108 24.1757 63.66 24.1626C63.9114 24.1302 63.8952 23.9154 63.6282 23.8674C63.5134 23.8466 63.395 23.87 63.2967 23.9328C63.1985 23.9957 63.1276 24.0935 63.0984 24.2064C63.0546 24.3306 63.153 24.4452 63.2622 24.3426Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M69.9211 102.04C68.3557 102.767 66.7294 103.355 65.0611 103.796C64.1689 104.04 64.1053 104.992 65.0089 105.195C65.8057 105.366 72.7489 105.195 73.5799 105.151C74.2171 105.123 74.8147 104.956 74.9299 104.243C75.0503 103.526 74.9089 102.789 74.5315 102.167C74.3845 101.977 73.9501 102.047 74.0017 102.307C74.1535 103.135 74.8225 104.39 73.1857 104.467C71.8951 104.527 66.2359 104.682 65.2999 104.518C66.8251 104.065 68.9479 103.375 70.1707 102.484C70.2121 102.443 70.239 102.39 70.2472 102.333C70.2554 102.275 70.2444 102.217 70.216 102.166C70.1875 102.116 70.1432 102.076 70.0899 102.053C70.0366 102.03 69.9772 102.026 69.9211 102.04Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M100.831 91.0482C102.131 91.7082 102.463 91.3746 101.436 93.9C100.617 95.932 99.5129 97.8374 98.1582 99.5592C98.106 97.9662 98.3382 95.8554 98.2974 94.2306C98.2974 93.9516 97.8354 93.9036 97.8 94.1946C97.5882 95.8674 97.533 97.7988 97.449 99.5232C97.3932 100.663 98.1144 100.742 98.8632 99.7464C100.417 97.7137 101.65 95.4546 102.519 93.048C102.73 92.448 102.917 91.821 102.519 91.2558C102.156 90.8045 101.647 90.4943 101.079 90.3792C100.994 90.36 100.905 90.3723 100.828 90.4138C100.751 90.4554 100.692 90.5233 100.662 90.6051C100.632 90.6868 100.632 90.7768 100.663 90.8583C100.694 90.9398 100.754 91.0073 100.831 91.0482Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M61.179 23.028C61.779 25.29 64.299 30.4398 67.3518 29.3406C67.4936 30.0128 67.8112 30.6354 68.2722 31.1448C68.388 31.2282 68.619 31.1088 68.5428 30.9576C68.2474 30.367 67.9945 29.756 67.7861 29.1294C68.2088 28.837 68.5693 28.4638 68.8469 28.0313C69.1244 27.5987 69.3135 27.1155 69.4032 26.6094C69.4229 26.3622 69.0846 26.3502 69.0048 26.5494C68.5746 27.585 67.83 28.911 66.5514 28.9074C63.8712 28.9074 61.6728 23.439 61.3314 21.3162C60.6744 21.1962 59.3676 20.8026 58.9734 20.2332C58.9486 20.1921 58.9381 20.144 58.9433 20.0963C58.9485 20.0486 58.9691 20.0039 59.0021 19.9691C59.0351 19.9342 59.0786 19.9111 59.126 19.9034C59.1733 19.8956 59.2219 19.9035 59.2644 19.926C61.4844 21.2004 64.2624 20.7228 66.5448 19.815C66.9432 21.3282 68.0982 22.089 68.2896 21.762C69.3168 19.9818 70.9458 21.7902 69.8382 22.989C69.4398 23.3874 69.3924 23.4984 69.4602 23.8812C69.7152 25.3548 71.6982 28.6044 72.6222 29.4288C81.5676 26.673 87.8622 34.6302 91.4406 47.3826C93.0972 46.6818 96.0365 45.1686 96.4145 38.3778C96.7925 31.587 91.6146 28.7178 89.2218 28.4214C86.829 28.125 86.3268 27.6648 86.3268 24.4944C86.3268 21.324 82.578 19.842 79.26 20.0172C75.3894 20.2242 74.0826 17.4972 73.1352 14.9988C72.2664 12.6972 68.3562 12.498 66.564 13.932C64.7718 15.366 63.0504 15.21 60.3066 14.613C57.7974 14.0592 55.6266 17.4522 56.4594 20.0928C56.773 21.0605 57.4188 21.8859 58.2826 22.4231C59.1464 22.9603 60.1724 23.1746 61.179 23.028Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M91.4274 57.42C85.3938 61.1436 76.0782 61.1916 72.1032 60.4386C70.4424 64.9668 68.5668 76.206 68.2164 80.2326C67.866 84.2592 69.1242 96.231 69.7764 101.261C71.4831 101.631 73.2504 101.623 74.9538 101.237C74.7906 99.9306 75.6186 84.7374 75.9216 83.1276C76.1964 81.666 78.4146 76.5204 80.139 72.948C80.0835 71.6153 79.8561 70.2954 79.4622 69.021C79.4399 68.9709 79.4383 68.914 79.4579 68.8627C79.4775 68.8114 79.5165 68.77 79.5666 68.7474C80.8404 68.1804 81.348 80.1882 83.6718 83.6454C84.4446 84.7926 94.485 91.7785 97.4238 93.642C98.4474 92.8854 100.12 91.3758 100.424 89.715C99.1968 88.8468 91.0404 80.4354 90.8892 79.9854C90.738 79.5354 92.7936 66.3876 91.4274 57.42Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M116.598 106.035C80.3579 105.986 39.858 105.852 3.39836 106.135C3.34478 106.133 3.29133 106.141 3.24121 106.16C3.1911 106.179 3.14535 106.208 3.10671 106.246C3.06806 106.283 3.03732 106.327 3.01632 106.377C2.99532 106.426 2.9845 106.479 2.9845 106.533C2.9845 106.586 2.99532 106.639 3.01632 106.689C3.03732 106.738 3.06806 106.783 3.10671 106.82C3.14535 106.857 3.1911 106.886 3.24121 106.905C3.29133 106.924 3.34478 106.933 3.39836 106.931C40.1664 107.003 80.1725 106.999 116.594 106.843C116.648 106.846 116.702 106.837 116.753 106.818C116.804 106.799 116.851 106.77 116.89 106.732C116.93 106.694 116.961 106.649 116.983 106.599C117.004 106.55 117.015 106.496 117.016 106.441C117.016 106.387 117.005 106.333 116.984 106.283C116.963 106.233 116.932 106.187 116.893 106.149C116.854 106.111 116.808 106.082 116.757 106.062C116.706 106.042 116.652 106.033 116.598 106.035Z",
      className: "fill-surface-common-secondary"
    }
  )
] }), UCe = Ar()(Whe), qhe = (e) => /* @__PURE__ */ F("svg", { viewBox: "0 0 120 120", fill: "none", ...e, children: [
  /* @__PURE__ */ d(
    "path",
    {
      d: "M50.2561 58.0858C50.7134 55.9305 49.5464 54.1203 48.8656 50.4952C48.6982 49.6074 48.5205 48.6459 48.3341 47.7626C48.2378 47.3058 47.5497 47.4083 47.6254 47.8383C48.0951 52.4687 49.7611 55.2543 49.928 58.0096C49.9033 58.2625 50.2561 58.2625 50.2561 58.0858Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M49.6491 47.2312C49.6614 47.8641 50.197 48.5501 50.4334 49.129C50.8485 50.1471 51.0354 51.2822 51.5211 52.2663C51.7477 52.7252 52.0778 52.5584 52.0778 52.3925C52.1338 51.8666 52.0555 51.335 51.8502 50.8475C51.4569 49.5725 50.8953 48.3556 50.18 47.2291C50.0791 47.0036 49.6403 46.8012 49.6491 47.2312Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M52.6599 47.483C53.2019 48.7903 53.6494 50.1348 53.9989 51.5062C54.0792 51.8342 54.2754 52.3116 54.7075 52.1133C55.892 51.5705 53.5493 47.8332 53.1893 47.3058C53.0173 47.0519 52.5589 47.1297 52.6599 47.483Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M75.3047 93.7866C75.3087 93.7504 75.2997 93.7139 75.2794 93.6836C74.1866 88.5105 71.3289 80.2797 68.9542 75.8966C68.4947 75.0359 67.9059 74.2508 67.2084 73.5688C66.5625 72.9508 64.9228 72.6356 64.6529 71.8734C64.0004 70.0333 63.3726 68.185 62.7299 66.3073C62.5486 65.7773 62.5018 64.8653 61.8441 64.789C61.4393 64.7401 61.0623 65.0465 60.7312 65.2191C58.0769 66.5967 54.2937 66.8872 51.3438 66.9145C51.3842 66.8631 51.4105 66.802 51.42 66.7373C51.4191 66.249 51.2961 65.7687 51.0622 65.34C50.8284 64.9113 50.4911 64.5479 50.081 64.2828C49.2477 63.5721 48.5306 62.7356 47.9556 61.8036C46.9941 59.8553 46.1088 57.8309 45.2987 55.8069C46.6892 56.1674 47.2583 56.1607 48.7399 58.1852C49.0679 58.7626 49.4964 59.2768 50.0053 59.7034C50.2546 59.861 50.8607 59.8826 50.6629 59.4248C50.2315 58.6325 49.686 57.9079 49.0438 57.2742C48.5229 56.5762 47.8902 55.9693 47.1712 55.4778C46.4035 55.0441 45.5143 54.8753 44.6411 54.9974C44.5357 55.0337 44.4482 55.1089 44.3965 55.2076C44.3448 55.3063 44.3328 55.421 44.363 55.5283C45.1484 57.6971 46.0609 59.8177 47.0955 61.8793C47.4781 62.688 48.0203 63.4109 48.6895 64.0047C49.5825 64.7803 50.4606 65.5986 50.8149 66.8372C50.8149 66.9366 51.0446 66.9134 50.1062 66.9134C49.9699 66.927 49.8425 66.9874 49.7456 67.0843C49.6487 67.1811 49.5883 67.3086 49.5748 67.4449C49.5748 68.7839 51.6348 75.9002 51.3458 76.5532C49.1313 81.5672 51.0152 87.4362 54.8628 99.603C54.9596 99.9084 55.2233 100.267 55.4705 100.109C55.625 100.011 55.6219 99.7802 55.6219 99.603C54.8159 92.393 50.5929 86.1615 51.523 78.9824C51.6378 78.0951 52.1204 77.1856 52.1559 76.3256C52.2739 73.4416 50.6624 70.6832 50.7654 67.7987C54.2319 68.153 59.3937 67.1915 61.5949 65.9519C61.1138 66.2048 63.5158 72.5331 64.226 72.9858C65.2277 73.6239 66.1974 72.7576 68.0468 76.1232C71.0456 81.5822 72.2723 87.8137 74.5239 93.6069C74.5763 93.78 74.6722 93.9367 74.8025 94.0622C75.0353 94.2609 75.401 94.0745 75.3047 93.7866Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M34.19 29.5703C34.7972 28.3811 34.2415 26.3258 33.3799 25.3705C32.3726 24.2529 30.9723 23.5546 29.7873 22.6379C24.7068 18.7079 22.0623 15.3764 19.3374 12.7195C18.8126 12.2045 17.5906 12.7916 17.0354 12.9723C9.67397 15.3702 2.73692 22.3258 2.76473 30.0245C2.76473 30.5812 4.25823 31.3388 4.63727 31.5932C7.51772 33.439 10.6437 34.87 13.9232 35.844C18.3007 37.2294 23.0063 37.4884 27.3076 35.6669L31.7103 39.2847C34.4552 37.9175 36.6381 35.6366 37.8836 32.8344L34.19 29.5703ZM29.864 34.2511C31.1768 34.7821 32.4247 35.4614 33.5834 36.2756C33.862 36.6299 33.7605 36.8071 33.3305 36.7308C32.9762 36.7308 30.1375 35.0715 29.5355 34.7826C28.9731 34.5138 29.2306 33.973 29.863 34.2511H29.864ZM34.722 35.2126C34.5449 35.3156 31.8895 33.4415 31.357 33.0115C31.1042 32.7586 31.4327 32.2019 31.787 32.48C32.8551 33.13 33.8857 33.8396 34.874 34.6054C35.151 34.6817 34.9744 35.2888 34.721 35.2126H34.722ZM36.1378 33.8973C35.9611 33.8973 33.4814 31.8728 33.0514 31.5185C32.5199 31.1647 32.9484 30.5575 33.5823 30.9113C34.1138 31.2657 36.4921 33.113 36.6693 33.4668C36.9226 33.8973 36.4921 34.2511 36.1378 33.8973Z",
      className: "fill-surface-common-icon-color"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M42.3367 36.7308C41.6286 36.2755 38.1873 33.2901 38.0859 33.2901C38.0625 33.2895 38.0393 33.2937 38.0176 33.3024C37.9959 33.3111 37.9762 33.3241 37.9597 33.3406C37.9432 33.3571 37.9302 33.3768 37.9215 33.3985C37.9128 33.4202 37.9087 33.4434 37.9092 33.4667V33.5697C38.0859 34.025 41.0847 37.0295 41.8814 37.5419C42.33 37.8308 43.0201 37.2891 43.3749 37.0867C44.8298 36.65 45.9757 37.0697 47.2714 37.871C47.6958 38.1337 48.1567 38.7568 48.6882 38.7568C48.7517 38.7649 48.8158 38.7483 48.8675 38.7106C48.9192 38.6729 48.9546 38.6168 48.9663 38.5539C48.9658 37.2345 44.4585 34.6863 42.3367 36.7308Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M44.1839 51.6339C43.6525 51.0262 39.2245 45.46 39.0473 45.1057C38.6935 44.2204 39.4779 43.4361 39.4779 42.9046C39.4779 42.8284 33.8355 38.8562 33.304 38.6538C33.1269 38.6538 33.0512 38.831 33.1269 39.0081C33.4812 39.4634 38.263 42.9046 38.3392 42.9046C37.9833 43.3839 37.8062 43.9725 37.8385 44.5686C37.8709 45.1647 38.1107 45.7307 38.5164 46.1687C39.9585 48.2046 41.5573 50.1248 43.2981 51.912C44.1999 52.858 45.7779 54.0374 45.3226 52.8735C44.984 52.4244 44.6027 52.0093 44.1839 51.6339Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M33.9387 60.2869C34.3945 60.0341 34.2951 59.5077 33.8357 59.6797C33.5454 59.7805 33.2497 59.8649 32.9499 59.9326C32.7962 59.6888 32.677 59.4248 32.5956 59.1483C32.4184 58.7182 31.9884 58.7939 32.0646 59.2513C32.0646 59.5294 32.5199 60.9209 32.6718 60.9209C32.8742 60.9956 33.8357 60.3879 33.9387 60.2869Z",
      className: "fill-surface-common-icon-color"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M44.6141 60.3879C44.1841 60.3879 42.5901 60.4909 42.1344 60.4909C41.3676 60.4892 40.6213 60.738 40.0089 61.1995C39.2081 61.56 35.9162 63.344 35.8344 63.4258C35.6567 62.8923 35.1473 62.2681 35.3281 61.9838C35.6218 61.5832 35.8001 61.1098 35.8437 60.615C35.8874 60.1202 35.7946 59.623 35.5756 59.1771C35.3566 58.7313 35.0196 58.354 34.6013 58.0862C34.183 57.8183 33.6993 57.6702 33.2027 57.6578C33.0003 57.405 32.7727 57.1269 32.5198 56.8483C33.8882 56.1892 34.981 55.0696 35.6067 53.6857C35.9597 52.78 36.4648 51.9414 37.1002 51.2059C37.8846 50.4978 38.928 50.3021 39.6562 49.5363C40.0012 49.1758 39.5532 48.5748 39.1247 48.9291C38.3403 49.4601 37.4545 49.8144 36.645 50.4226C34.62 52.1685 35.2704 53.2237 33.4824 55.2049C33.0071 55.6178 32.4797 55.9665 31.9137 56.2421C31.4648 55.7917 30.9535 55.4082 30.3954 55.1034C29.5859 54.5725 29.0796 55.1034 28.4472 55.5592C27.8148 56.015 27.206 56.5192 26.6761 56.976C26.2955 57.304 26.6004 57.7099 27.0304 58.0894C26.2816 58.3763 6.93359 65.9746 2.84191 66.6899C2.48759 66.8671 2.48759 67.398 2.84191 67.3223C7.51657 66.7852 23.5964 60.5382 27.9919 58.8207C28.6265 59.3828 29.2263 59.9829 29.7883 60.6175C29.5354 61.68 30.1426 62.7424 31.3822 63.173C31.7608 64.1638 31.8911 65.2323 31.7617 66.2851C30.7245 66.8413 29.6868 67.449 28.751 68.031C26.98 68.992 25.3072 69.9741 23.5387 70.9402C20.5579 72.5692 11.7339 77.163 6.66218 79.5175C6.48554 79.5175 6.66218 79.9481 6.91556 79.8719C14.3845 76.7509 21.644 73.1506 28.6486 69.0934C31.4841 67.4696 31.6077 66.9448 31.3812 67.398C31.341 67.4773 31.3154 67.5631 31.3054 67.6514C31.319 67.7876 31.3793 67.9149 31.4761 68.0117C31.5729 68.1085 31.7002 68.1688 31.8364 68.1824C33.1526 68.1152 34.4425 67.7884 35.632 67.2209C36.5173 66.968 36.6105 65.8999 36.3406 65.0198C36.2606 64.7787 36.1928 64.5338 36.1377 64.2859C36.6134 64.0327 37.07 63.7452 37.504 63.4258C38.3898 62.8944 41.1234 61.2943 42.0082 61.4019C42.793 61.4972 44.2093 61.2989 44.8407 60.7942C44.8669 60.667 44.7912 60.3879 44.6141 60.3879ZM33.9113 62.0575C32.2417 62.9428 30.192 61.4503 31.0016 59.5778C31.0778 59.1225 32.5033 58.0637 33.557 58.5153C35.9822 59.5551 34.4681 61.7037 33.9113 62.0575Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M63.2612 53.1516C61.9555 53.3223 60.6783 53.6659 59.4631 54.1734C59.0513 53.1275 58.5706 52.11 58.0242 51.1277C57.4767 50.0322 56.8152 48.9975 56.0507 48.0408C55.7979 47.7622 55.2937 47.8348 55.4688 48.1165C57.7546 51.7394 59.2628 55.7977 59.8978 60.0341C60.1553 62.0982 60.0147 62.639 60.2521 64.3601C60.3551 64.7139 60.8541 64.89 60.9607 64.4631C61.313 63.0417 61.0364 61.9149 61.0364 61.0224C60.8646 58.9071 60.4182 56.8233 59.7083 54.8233C60.593 54.8439 61.5623 54.1744 63.6933 53.9375C64.3005 53.8345 66.3404 54.4644 66.704 53.7604C67.2947 52.6124 63.6918 53.0507 63.2612 53.1516Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M83.553 16.3121C75.5571 26.231 77.3499 24.205 73.9385 28.8117C70.5151 27.3051 67.2084 25.5459 64.0459 23.5489L61.0851 21.752C63.895 17.4173 70.5035 3.70799 70.5735 3.13016C70.5671 3.07126 70.544 3.01543 70.5068 2.96933C70.4696 2.92322 70.4199 2.88878 70.3637 2.87011C70.3074 2.85144 70.247 2.84933 70.1896 2.86403C70.1322 2.87872 70.0803 2.90961 70.04 2.953C69.5322 3.47881 63.9902 14.7321 62.8815 16.7679C62.028 18.2757 61.2593 19.83 60.5789 21.4235C60.0937 21.0092 59.4706 20.7924 58.833 20.8163C58.3778 20.892 58.2259 21.3473 58.0487 21.7778C57.0872 23.3717 56.3425 25.1191 55.3161 26.7367C54.3185 28.3085 53.1907 29.8236 52.3049 31.4933V31.6725C52.3049 31.7992 52.8111 32.3559 54.0003 33.3174L53.0892 34.4556C52.0495 35.9578 50.9777 35.0967 49.8509 35.569C49.2185 35.8476 48.3574 36.3533 48.3574 37.1377C48.3641 37.1961 48.3874 37.2515 48.4244 37.2972C48.4615 37.3429 48.5109 37.377 48.5667 37.3956C48.6225 37.4142 48.6825 37.4165 48.7396 37.4022C48.7967 37.3879 48.8485 37.3576 48.8889 37.3148C49.4536 36.6771 50.2231 36.2565 51.0648 36.1257C52.8482 35.9094 52.8235 36.1097 54.4298 33.646C56.6124 35.3959 58.9307 36.9696 61.3627 38.352C61.2988 38.3894 61.2456 38.4426 61.2082 38.5065C60.886 38.9049 60.7317 39.4131 60.7782 39.9233C60.8894 40.3513 61.3097 40.8091 60.7782 41.5198C60.6462 41.666 60.5449 41.8373 60.4805 42.0235C59.5145 41.4461 58.4615 41.0287 57.3622 40.7875C55.7683 40.4332 54.1743 40.6103 52.5804 40.6103C51.315 40.5977 50.0568 40.8031 48.8611 41.2175C48.6587 41.2175 48.8611 41.5718 49.0383 41.5718C50.9772 41.5718 55.7281 40.7746 58.8552 42.2805C59.5663 42.5877 60.2239 43.0061 60.8034 43.5201C61.3574 44.0393 61.9785 44.4819 62.6502 44.8359L67.4325 46.7841C67.8878 46.9608 67.4325 45.6455 67.4325 45.6455C64.359 44.4162 62.7192 43.9779 61.51 42.813C61.407 42.7141 61.2978 42.6224 61.1876 42.5323C61.5276 42.253 61.78 41.8817 61.9144 41.4627C62.0489 41.0438 62.0597 40.595 61.9457 40.17C61.8187 39.8866 61.7252 39.5893 61.6671 39.2842C61.7788 39.0872 61.8802 38.8845 61.9709 38.677C63.4129 39.4361 66.9299 41.182 67.0818 39.9676C67.0818 39.7142 68.3976 39.0061 68.5753 38.7275C70.2552 37.2778 74.2722 33.9251 75.3815 32.1999C75.7353 31.6684 76.5197 31.0612 76.5197 30.3525C76.7895 29.3643 75.0679 29.2793 74.4453 29.0372C75.9671 27.363 76.1092 27.194 80.3405 21.6995C80.9729 20.9152 83.6045 16.8415 83.8826 16.5634C84.4388 15.7811 84.0845 15.5015 83.553 16.3121ZM75.1786 30.7089C74.9505 30.7089 67.5371 38.7805 66.8542 39.1091C66.3227 39.3877 65.7876 39.0205 65.2602 38.8562C59.0705 36.9286 54.9443 32.4115 53.0898 31.621C54.4924 30.1545 55.7001 28.5132 56.6829 26.7378C57.4765 25.389 58.6337 23.1183 58.7831 22.7656C58.8861 22.5142 59.0689 22.0075 59.1436 21.8386C63.6828 24.3919 70.5035 29.1768 75.1786 30.7089Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M49.1175 43.689C50.0497 43.7075 50.9808 43.3094 52.3816 43.3094C52.82 43.3389 53.26 43.3304 53.6969 43.2842C53.7811 43.2717 53.8601 43.2361 53.9251 43.1812C53.9751 43.1329 54.0074 43.0692 54.0167 43.0004C54.0261 42.9315 54.0119 42.8615 53.9766 42.8016C53.7489 42.4983 53.1922 42.5256 52.8631 42.4983C51.7433 42.334 50.5999 42.501 49.5738 42.9788C49.3956 43.0566 48.4851 43.6761 49.1175 43.689Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M49.4216 45.713C49.7708 46.1219 50.5345 46.0627 51.0155 46.0421C52.4807 45.9792 54.2827 46.3588 54.1529 45.6877C54.104 45.4343 53.6724 45.2551 53.4695 45.2072C52.4606 44.9672 51.2684 45.1042 50.2312 45.1042C49.9551 45.1058 49.0364 45.2623 49.4216 45.713Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M45.7778 50.7228C46.1177 51.2729 46.3732 51.8419 46.6631 52.4182C46.882 52.8529 47.3156 52.6211 47.2708 52.1901C47.1704 51.2275 45.9591 49.5265 45.3226 48.7998C45.1217 48.5707 44.9683 48.9543 44.9683 49.0779C44.9683 49.5589 45.5085 50.2872 45.7778 50.7228Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M52.7104 68.788C52.7163 69.2568 52.7757 69.7233 52.8876 70.1785C53.1132 71.8487 53.5484 73.543 53.7482 75.2389C53.9056 76.98 53.9732 78.728 53.9506 80.476C53.9477 80.6703 53.9561 80.8646 53.9758 81.0579C54.413 87.2961 56.2161 91.9172 58.378 97.403C58.5575 97.9397 58.8223 98.444 59.1624 98.8965C59.213 98.9443 59.2765 98.9763 59.345 98.9888C59.4135 99.0013 59.4841 98.9937 59.5484 98.9669C59.6127 98.9401 59.6678 98.8953 59.7072 98.8378C59.7465 98.7804 59.7683 98.7127 59.7701 98.6431C59.7186 97.7161 59.4956 97.609 57.8218 92.9781C53.8357 81.9458 55.4163 79.9759 54.7602 74.9634C54.5949 73.8862 54.3582 72.8213 54.0515 71.7755C53.8448 70.7892 53.5743 69.8172 53.2419 68.8658C53.1904 68.7113 52.9128 68.1067 52.7362 68.5367C52.7362 68.6114 52.7104 68.6871 52.7104 68.788Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M55.3924 69.5724C58.1637 86.8913 61.2604 90.0112 63.7169 97.7588C63.8977 98.1193 64.6022 98.1193 64.6022 97.6043V97.4524C62.4701 90.4865 60.6125 89.6048 57.3659 75.7194C56.8674 73.5863 56.4044 71.4686 55.8724 69.3684C55.754 69.0723 55.273 69.2731 55.3924 69.5724Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M57.8721 68.6114C58.4051 74.4757 61.4925 76.6649 66.2722 90.9526C67.5927 94.8995 67.6112 95.0777 68.2962 96.5192C68.4733 96.9745 69.0764 96.6222 69.0048 96.2658C68.8111 95.3369 68.549 94.4235 68.2205 93.5332C66.7898 89.5786 66.7625 89.2072 65.4122 85.6393C63.1143 79.567 62.0827 78.0338 60.377 74.7594C59.3665 72.8109 58.6258 70.7339 58.1754 68.5856C58.024 68.1556 57.8721 68.4342 57.8721 68.6114Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M60.152 67.0932C60.3186 68.9411 60.8249 70.7424 61.6455 72.4064C62.0641 73.2354 62.63 73.9812 63.3156 74.6076C64.0907 75.2359 64.8259 75.9121 65.5167 76.632C66.1381 77.4053 66.6414 78.2665 67.0102 79.1874C67.5041 80.3694 69.4977 84.6511 70.7043 88.372C72.4157 93.6512 72.1633 93.6147 72.7283 95.4311C72.9054 95.8863 73.6141 95.7854 73.5126 95.3281C72.6155 89.9443 69.0501 80.9333 66.8078 77.0353C66.2558 76.1973 65.5722 75.4539 64.7834 74.8336C62.1481 73.0486 61.424 69.7001 60.5331 66.9902C60.5331 66.7239 60.1025 66.7842 60.1025 67.0154C60.1746 67.068 60.1746 67.0932 60.152 67.0932Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M61.4645 25.9524C60.2233 25.0182 58.5702 26.6188 57.9728 27.6478C57.0721 29.2 57.8564 30.8325 59.3633 30.4056C60.5869 30.059 61.5005 28.8292 61.893 27.6478C62.002 27.3551 62.0194 27.0361 61.9429 26.7333C61.8663 26.4305 61.6995 26.1581 61.4645 25.9524ZM60.8573 27.089C60.8627 27.2143 60.8298 27.3383 60.763 27.4445C60.6962 27.5507 60.5986 27.6341 60.4833 27.6835C60.368 27.7329 60.2403 27.746 60.1174 27.7212C59.9944 27.6963 59.8819 27.6346 59.7949 27.5443C58.994 26.6034 60.5179 26.0729 60.8573 27.089ZM59.1115 29.3916C58.9952 29.4232 58.8722 29.4201 58.7576 29.3827C58.643 29.3453 58.5419 29.2752 58.4667 29.1811C58.3914 29.087 58.3453 28.9729 58.3341 28.8529C58.3228 28.7329 58.3469 28.6122 58.4033 28.5058C58.5063 28.2529 59.2886 28.0757 59.4658 28.4301C59.7187 28.9378 59.6177 29.115 59.1115 29.3936V29.3916Z",
      className: "fill-surface-common-icon-color"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M58.8842 31.038C59.4044 31.1536 59.9447 31.1426 60.4598 31.0062C60.9749 30.8697 61.4497 30.6116 61.8444 30.2537C63.3719 28.9662 63.3452 27.4109 62.7555 26.9392C62.0978 26.4839 62.1426 27.7977 62.0468 28.1031C61.8517 28.7272 61.4894 29.2859 60.9991 29.7187C60.5088 30.1514 59.9094 30.4415 59.2658 30.5576C58.4527 30.7605 58.5247 30.9783 58.8842 31.038Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M99.7464 49.5085C98.8996 49.3952 98.0448 49.3528 97.1909 49.3818C91.8715 48.9997 82.1354 46.7249 76.4436 45.8901C75.4064 45.7356 73.3536 45.8932 72.6229 44.9286C72.0888 44.2225 71.9147 42.626 70.7761 42.2722C70.0674 42.0951 69.6374 42.7275 69.6374 43.3347C69.6074 43.6588 69.6424 43.9857 69.7404 44.2962C69.2136 44.1988 68.6733 44.1988 68.1465 44.2962C67.5151 44.4069 66.8307 44.6505 66.8307 45.3586C66.8558 45.5673 66.9225 45.7689 67.0268 45.9515C67.1311 46.134 67.2708 46.2939 67.4378 46.4216C66.6535 46.6997 65.8439 47.1297 65.8439 48.0155C65.8584 48.2392 65.9314 48.4551 66.0557 48.6416C66.18 48.828 66.3512 48.9785 66.552 49.0779C65.7677 49.3313 64.9581 49.8623 65.0585 50.7481C65.0763 50.981 65.1593 51.2041 65.2981 51.392C65.4368 51.5799 65.6256 51.7249 65.8429 51.8105C65.2099 52.0639 64.3494 52.1649 64.4256 53.304C64.4576 53.6252 64.5822 53.9301 64.7844 54.1816C64.9866 54.4332 65.2575 54.6205 65.5643 54.7208C64.679 55.4294 63.7154 56.2143 64.0708 57.0996C64.4987 58.1631 65.538 58.314 66.55 58.0606C66.2466 58.6935 66.1694 59.7086 66.7271 60.237C67.2761 60.7581 68.4859 60.7885 69.6874 59.6802C69.9902 59.4006 70.2951 59.1235 70.6236 58.8707C76.8479 61.2237 83.2205 63.0303 89.5756 65.044C91.4219 65.629 93.2388 66.28 95.0918 66.7646C95.596 66.8969 95.6794 66.8933 95.8509 66.4103C96.7691 63.8157 97.3887 61.1207 98.1277 58.4659C98.8817 55.757 99.6727 53.0512 100.405 50.3438C100.505 49.8118 100.226 49.6166 99.7464 49.5085ZM72.5219 46.8768C72.5219 46.8768 72.8762 47.2312 72.7748 47.2312C72.5219 47.2312 71.9152 48.446 71.788 48.6732C70.9388 50.1702 70.4373 51.8392 70.3208 53.5564C70.2719 54.1641 70.3723 54.7455 70.3723 55.3275C70.3723 55.7328 70.2976 56.5635 69.7651 56.2385C69.0585 55.8054 69.1579 54.4422 69.2336 53.7588C69.2675 52.2967 69.6309 50.8611 70.2966 49.559C70.8811 48.4378 71.3652 47.5947 72.5219 46.8768Z",
      className: "fill-surface-common-icon-color"
    }
  )
] }), GCe = Ar()(qhe), Uhe = (e) => /* @__PURE__ */ F("svg", { viewBox: "0 0 150 150", fill: "none", ...e, children: [
  /* @__PURE__ */ d(
    "path",
    {
      d: "M66.5431 21.039C65.8798 20.9172 65.2605 20.6221 64.748 20.1838C64.2355 19.7454 63.848 19.1794 63.6248 18.543C63.3473 17.8553 63.0818 15.9428 61.9351 16.2008C61.4723 16.305 61.3598 16.7003 61.2443 17.0843C60.8094 18.2854 60.1304 19.3835 59.2501 20.3093C58.5756 21.1888 57.6725 21.8662 56.6393 22.2675C56.4395 22.3286 56.2679 22.4587 56.155 22.6345C56.0421 22.8104 55.9954 23.0205 56.023 23.2277C56.0507 23.4348 56.1509 23.6253 56.306 23.7654C56.461 23.9055 56.6607 23.986 56.8696 23.9925C59.5186 23.9048 60.1328 27.102 60.4786 29.0993C60.6436 30.5873 62.1593 30.5295 62.4751 29.5215C63.3106 26.8568 64.5488 24.1845 67.0058 22.6485C67.1618 22.5455 67.2807 22.3955 67.3455 22.2201C67.4102 22.0448 67.4172 21.8534 67.3656 21.6738C67.3139 21.4942 67.2063 21.3358 67.0584 21.2216C66.9104 21.1074 66.7299 21.0435 66.5431 21.039Z",
      className: "fill-surface-common-icon-color"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M58.134 36.3975C55.683 35.8725 54.4155 34.1295 53.409 31.9815C53.1038 31.3282 52.218 31.5202 51.834 32.0197C51.3338 32.6722 51.1365 33.5902 50.6438 34.3237C49.5899 35.9312 48.1158 37.2193 46.3815 38.0482C46.2124 38.156 46.081 38.3136 46.0053 38.4992C45.9297 38.6849 45.9136 38.8895 45.9593 39.0847C46.1513 39.7762 46.923 39.726 47.4593 39.891C49.0011 40.413 50.3964 41.2949 51.5295 42.4635C52.002 43.0687 51.9908 44.1525 52.566 44.6527C53.7578 45.6877 54.4928 43.4647 54.7928 42.6555C55.5019 40.8318 56.7468 39.2658 58.3635 38.1637C58.9785 37.6642 58.9808 36.5797 58.134 36.3975Z",
      className: "fill-surface-common-icon-color"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M111.159 63.5047C110.432 58.6665 106.776 54.1695 101.829 53.2147C101.695 53.1767 101.556 53.1654 101.418 53.1814C101.28 53.1974 101.146 53.2404 101.025 53.308C100.903 53.3756 100.797 53.4664 100.71 53.5753C100.624 53.6842 100.56 53.809 100.522 53.9426C100.484 54.0762 100.473 54.216 100.489 54.3539C100.505 54.4919 100.548 54.6254 100.615 54.7468C100.683 54.8681 100.774 54.975 100.883 55.0612C100.992 55.1475 101.116 55.2114 101.25 55.2495C103.115 55.659 104.824 56.5915 106.178 57.9376C107.532 59.2837 108.474 60.9877 108.894 62.85C111.037 71.544 103.622 80.0737 96.108 85.158C86.6032 91.5892 73.4955 93.9855 73.224 93.2212C72.5235 91.2525 68.358 83.367 68.463 75.6712C68.5408 73.0084 69.1715 70.391 70.3149 67.9849C71.4583 65.5789 73.0895 63.4369 75.105 61.695C77.3241 59.8349 79.9168 58.4732 82.7077 57.702C82.8144 57.67 82.9063 57.6012 82.9671 57.5079C83.0279 57.4146 83.0536 57.3027 83.0398 57.1922C83.026 57.0817 82.9734 56.9797 82.8915 56.9043C82.8095 56.8288 82.7035 56.7849 82.5922 56.7802C74.5432 56.9175 67.4205 65.7052 66.5812 74.1352C65.8935 81.0397 69.5737 90.7695 71.4562 93.9862C72.2925 95.415 85.701 94.2277 96.5669 87.3435C104.37 82.407 112.7 73.7557 111.159 63.5047Z",
      className: "fill-surface-common-icon-color"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M81.975 75.6383C80.7794 77.6683 79.7397 79.7861 78.8647 81.9735C77.8702 84.0967 77.0361 86.2913 76.3695 88.539C76.3427 88.6583 76.3624 88.7832 76.4244 88.8885C76.4865 88.9937 76.5863 89.0714 76.7036 89.1057C76.8209 89.14 76.9469 89.1283 77.0559 89.0731C77.1649 89.0178 77.2488 88.9232 77.2905 88.8083C78.1755 86.6333 78.8655 84.4313 79.7482 82.2833C80.631 80.1353 81.6292 78.021 82.3207 75.8333C82.362 75.561 82.0942 75.45 81.975 75.6383Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M80.25 87.0803C80.0632 87.0995 79.8887 87.1825 79.756 87.3153C79.6232 87.448 79.5402 87.6225 79.521 87.8093C79.5174 87.901 79.5328 87.9925 79.5663 88.0779C79.5997 88.1634 79.6505 88.241 79.7153 88.306C79.7802 88.3709 79.8578 88.4217 79.9432 88.4553C80.0286 88.4888 80.1201 88.5043 80.2118 88.5008C80.3987 88.4818 80.5733 88.3989 80.7063 88.2661C80.8392 88.1333 80.9223 87.9587 80.9415 87.7718C80.945 87.6801 80.9295 87.5886 80.896 87.5031C80.8624 87.4177 80.8116 87.34 80.7467 87.2751C80.6818 87.2102 80.6042 87.1594 80.5187 87.1259C80.4332 87.0923 80.3418 87.0768 80.25 87.0803Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M75.144 56.3633C70.035 53.9903 63.6142 54 58.71 56.7473C56.3437 58.1117 54.3005 59.9717 52.7205 62.1998C48.9005 67.7566 45.4871 73.5823 42.507 79.6313C38.9288 76.8185 35.0837 74.363 31.0268 72.3C30.3 71.9325 27.7748 70.7918 27.1868 70.6103C26.0138 69.9585 24.834 70.5533 23.7698 71.3783C23.229 71.7975 23.7338 72.687 24.3068 72.3C25.0395 71.805 26.544 70.914 26.9948 72.1845C27.348 73.1805 27.0278 74.4488 26.841 75.4485C26.4011 77.7896 25.6523 80.062 24.6143 82.206C23.5725 81.165 20.0318 78.7058 17.895 76.9073C17.436 76.521 16.9763 76.2203 16.395 76.6005C15.7455 77.0273 15.33 77.7255 14.706 78.1755C13.1228 79.308 12.2183 76.6598 10.3673 75.987C10.098 75.8715 9.94502 76.2173 10.0215 76.4475C10.4781 77.1738 11.0483 77.8221 11.7105 78.3675C12.1784 78.9456 12.8063 79.3729 13.5158 79.596C13.8582 79.64 14.206 79.6115 14.5367 79.5123C14.8674 79.413 15.1734 79.2453 15.435 79.02C15.9932 78.6262 16.4857 78.1468 16.8945 77.5995C17.2743 77.79 17.6236 78.036 17.931 78.3293C19.1438 79.1738 23.3618 82.5225 24.2663 82.9748C23.3288 84.7065 21.8985 86.964 20.3498 88.197C19.5383 88.8428 18.2453 89.5208 17.163 89.1563C16.4378 88.9125 16.599 87.699 16.6643 87.0833C16.881 85.0313 17.7143 82.779 18.3533 80.364C18.365 80.3063 18.3563 80.2463 18.3287 80.1942C18.3011 80.1422 18.2563 80.1013 18.202 80.0787C18.1476 80.056 18.087 80.0529 18.0306 80.0699C17.9742 80.087 17.9255 80.123 17.8928 80.172C17.0657 81.4863 16.4563 82.9256 16.0883 84.4343C15.6008 86.2785 14.913 89.496 16.7025 90.1553C18.2042 92.2086 20.0484 93.9879 22.1543 95.415C25.2645 97.7003 34.6928 103.365 38.3543 105.437C40.9283 106.893 43.3838 108.969 46.3793 109.468C47.9625 109.732 48.582 109.652 50.2185 108.739C50.7118 108.463 51.1863 108.155 51.639 107.817C51.327 110.056 49.758 122.401 49.758 124.017C49.762 124.157 49.8156 124.29 49.9091 124.394C50.0027 124.498 50.1301 124.565 50.2686 124.584C50.4072 124.602 50.5477 124.571 50.6652 124.495C50.7827 124.419 50.8695 124.305 50.91 124.171C51.1845 122.981 51.975 114.651 53.4435 103.821C56.0753 84.4155 57.1403 81.672 56.3235 78.246C55.9274 76.6468 55.1651 75.1615 54.0967 73.9073C53.8717 73.6358 53.4435 73.9823 53.5972 74.2913C55.5202 77.6318 55.6605 79.9913 55.2098 83.1608C54.7463 86.424 52.4835 101.476 51.9098 105.699C51.2636 106.395 50.5273 107.003 49.7205 107.504C48.8615 108.108 47.8018 108.356 46.764 108.195C43.9635 107.723 41.6138 105.785 39.2003 104.432C36.0923 102.689 26.4503 97.0223 23.6115 95.1405C21.4919 93.7636 19.5229 92.1678 17.7368 90.3795C21.099 90.3795 23.8305 86.4795 25.416 83.5065C26.8119 80.9303 27.7718 78.1409 28.257 75.2513C28.4991 74.2327 28.5499 73.1781 28.407 72.141C29.0948 72.534 31.3095 73.6335 34.32 75.4815C42.216 80.328 42.42 81.5663 46.2615 84.2745C46.5315 84.4643 46.8375 84.0825 46.6838 83.8523C45.8878 82.5961 44.8887 81.4809 43.7273 80.5523C43.6118 80.4773 43.5353 80.4023 43.4198 80.322C45.8948 76.86 48.0083 71.9835 52.9808 64.5795C54.4041 62.2557 56.2696 60.2337 58.4715 58.6283C63.621 55.1475 68.964 55.5915 75.0585 56.9783C75.225 57.0128 75.4867 56.5223 75.144 56.3633Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M12.7118 66.4613C12.2775 67.3005 11.5118 68.6033 12.75 69.111C13.5897 69.4014 14.4934 69.4533 15.3608 69.261C15.015 69.336 15.1688 70.95 15.2453 71.2185C15.3608 71.7563 15.8978 73.2728 16.6665 73.254C16.758 73.2534 16.8455 73.2168 16.9101 73.152C16.9747 73.0873 17.0112 72.9997 17.0115 72.9083C17.0115 72.411 16.2938 72.375 15.975 70.8353C15.9353 70.6433 15.783 69.1853 16.05 69.1455C16.95 69.1455 18.7875 67.7445 19.467 67.149C19.7738 66.8798 19.386 66.3735 19.0448 66.573C17.3333 67.5728 15.3968 68.646 13.3238 68.148C12.978 67.7258 15.0488 64.9613 15.243 64.6538C15.68 63.9021 16.2673 63.2485 16.968 62.7338C17.7735 62.271 18.5865 62.8403 19.272 63.2715C21.585 64.7265 23.3153 67.0215 22.572 69.6465C22.35 70.455 21.2085 71.6025 21.504 72.45C21.729 73.0973 23.787 74.649 24.384 75.0608C24.7841 75.4052 25.2796 75.6195 25.8045 75.675C25.8957 75.6811 25.9872 75.6681 26.073 75.6368C26.118 75.6109 26.1569 75.5759 26.1875 75.534C26.218 75.4921 26.2394 75.4442 26.2503 75.3936C26.2612 75.3429 26.2613 75.2905 26.2507 75.2397C26.24 75.189 26.2189 75.1411 26.1885 75.099C26.0385 74.7323 25.6995 74.664 22.1955 71.949C22.464 72.141 23.5808 69.8768 23.6543 69.645C24.6293 66.594 22.6643 63.9593 20.007 62.1968C17.601 60.6008 16.4745 61.107 14.7083 63.4253C13.9222 64.3526 13.2518 65.3721 12.7118 66.4613Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M9.98553 67.3065C10.254 67.7288 10.6763 68.343 11.2523 68.2275C11.3237 68.2036 11.3886 68.1634 11.442 68.1102C11.4953 68.057 11.5356 67.9921 11.5598 67.9208C11.6348 67.4595 11.2523 67.1145 11.022 66.7688C10.8068 66.4262 10.6511 66.0496 10.5615 65.655C10.3826 64.9114 10.4688 64.1287 10.8052 63.4418C11.1416 62.7549 11.7071 62.2069 12.4043 61.8923C13.1399 61.568 13.9459 61.4359 14.7465 61.5083C14.8137 61.5068 14.8786 61.4835 14.9314 61.4419C14.9842 61.4004 15.0221 61.3429 15.0394 61.2779C15.0567 61.213 15.0525 61.1443 15.0275 61.0819C15.0024 61.0196 14.9577 60.9671 14.9003 60.9323C12.4155 59.7698 8.68804 62.1323 9.40953 65.8073C9.50593 66.3387 9.70132 66.8473 9.98553 67.3065Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M10.5998 71.568C10.6874 71.538 10.7649 71.4841 10.8235 71.4124C10.882 71.3407 10.9194 71.2541 10.9313 71.1623C10.9433 71.0704 10.9293 70.9771 10.891 70.8928C10.8527 70.8085 10.7916 70.7366 10.7145 70.6853C10.0395 70.3028 8.9048 70.218 7.7198 67.6905C7.43087 67.1908 7.29719 66.6164 7.3358 66.0405C7.3793 65.811 7.0253 65.6167 6.91355 65.8485C5.98205 67.785 8.19455 72.0413 10.5998 71.568Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M9.06378 73.6035C8.10253 73.2128 7.2185 72.654 6.45303 71.9535C5.73554 71.2342 5.23049 70.3307 4.99353 69.3428C4.91853 68.9978 4.29903 69.036 4.34103 69.4178C4.44717 70.3318 4.75765 71.2102 5.24945 71.9878C5.74125 72.7655 6.40176 73.4226 7.18203 73.9103C7.63203 74.196 9.06603 74.6348 9.29403 74.1788C9.45003 73.95 9.29178 73.7603 9.06378 73.6035Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M7.37396 75.675C6.09836 75.1627 5.04917 74.2093 4.41746 72.9885C4.3722 72.9175 4.30341 72.8647 4.22315 72.8394C4.14289 72.814 4.05627 72.8178 3.97847 72.8499C3.90066 72.882 3.83664 72.9404 3.7976 73.015C3.75857 73.0896 3.74701 73.1755 3.76496 73.2577C4.13593 74.2761 4.7885 75.1682 5.64671 75.8302C6.27071 76.3162 7.91772 77.1802 8.64147 76.752C8.68685 76.7211 8.72519 76.681 8.75396 76.6343C8.78272 76.5875 8.80125 76.5352 8.80834 76.4808C8.81542 76.4264 8.8109 76.3711 8.79506 76.3185C8.77923 76.266 8.75244 76.2174 8.71647 76.176C8.30247 75.9301 7.84779 75.7605 7.37396 75.675Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M72.4559 115.455C72.3404 115.762 71.8417 117.18 71.7644 117.49C71.9144 117.49 73.5389 118.107 73.9147 117.106C74.3459 115.957 72.4942 115.455 72.4559 115.455Z",
      className: "fill-surface-common-icon-color"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M61.8967 95.22C62.0355 95.22 62.0122 95.3077 62.0122 95.22H61.8967Z",
      className: "fill-surface-common-icon-color"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M73.725 107.162C71.9715 107.941 69.975 107.219 69.8085 104.858C69.54 105.165 69.2715 105.472 68.964 105.779C67.5052 107.085 66.276 106.202 65.0475 105.05C65.528 106.703 65.8369 108.401 65.9692 110.118C66.8281 109.995 67.7029 110.046 68.5417 110.268C68.8102 110.343 71.0377 111.074 71.076 111.036C71.9565 109.734 72.84 108.467 73.725 107.162Z",
      className: "fill-surface-common-icon-color"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M80.0197 98.9062L62.0122 95.2582C61.0522 103.821 56.829 120.792 56.829 120.792C62.9722 123.134 76.2952 124.132 76.2952 124.132C78.4455 115.839 80.3655 107.43 80.0197 98.9062ZM70.725 100.288C70.9648 100.295 71.1925 100.395 71.3597 100.567C71.5269 100.739 71.6204 100.97 71.6204 101.21C71.6204 101.45 71.5269 101.68 71.3597 101.852C71.1925 102.024 70.9648 102.124 70.725 102.131C70.4852 102.124 70.2575 102.024 70.0903 101.852C69.9231 101.68 69.8295 101.45 69.8295 101.21C69.8295 100.97 69.9231 100.739 70.0903 100.567C70.2575 100.395 70.4852 100.295 70.725 100.288ZM63.6982 100.138C63.9363 100.148 64.1613 100.249 64.3264 100.421C64.4914 100.593 64.5835 100.822 64.5835 101.06C64.5835 101.298 64.4914 101.527 64.3264 101.699C64.1613 101.871 63.9363 101.972 63.6982 101.982C63.4533 101.982 63.2185 101.884 63.0456 101.71C62.8726 101.537 62.7757 101.302 62.7761 101.057C62.7765 100.812 62.8742 100.577 63.0477 100.404C63.2212 100.231 63.4563 100.134 63.7012 100.135L63.6982 100.138ZM65.5035 114.268C64.8549 115.713 64.0432 117.079 63.084 118.339C63.0199 118.439 62.9258 118.516 62.8152 118.559C62.7046 118.603 62.5831 118.61 62.4681 118.58C62.3531 118.55 62.2504 118.485 62.1749 118.393C62.0994 118.301 62.0548 118.188 62.0475 118.069C61.9297 117.225 61.8487 116.266 61.779 115.382C61.7362 114.844 61.5097 113.769 61.854 113.308C61.8725 113.275 61.8987 113.247 61.9304 113.227C61.9621 113.206 61.9983 113.193 62.036 113.189C62.0737 113.186 62.1117 113.191 62.1469 113.205C62.1821 113.219 62.2133 113.242 62.238 113.27C62.6985 113.654 62.8905 115.459 62.9677 116.57C63.6202 115.418 64.35 113.306 65.1945 113.652C65.3169 113.692 65.4184 113.779 65.4769 113.894C65.5354 114.009 65.546 114.142 65.5065 114.265L65.5035 114.268ZM68.1907 119.183C68.1369 119.32 68.0344 119.433 67.9029 119.5C67.7713 119.566 67.6199 119.582 67.4774 119.544C67.335 119.506 67.2116 119.417 67.1307 119.293C67.0498 119.17 67.017 119.022 67.0387 118.876C67.2307 118.147 67.6147 115.919 67.7302 115.576C68.1142 114.116 68.9587 114.538 68.8822 115.46C68.808 115.875 68.4037 118.455 68.1937 119.179L68.1907 119.183ZM74.142 118.223C73.7327 118.46 73.2761 118.603 72.805 118.643C72.3338 118.683 71.8597 118.618 71.4165 118.453C71.3833 118.6 71.3329 118.741 71.2665 118.876C71.1798 119.266 71.0093 119.633 70.767 119.951C70.617 120.101 70.0387 119.989 69.999 119.797C69.849 119.067 71.2665 115.305 71.499 114.847C71.949 113.952 73.1775 114.526 74.0332 115.039C75.1822 115.609 75.1027 117.375 74.145 118.219L74.142 118.223ZM75.9855 105.629C73.6687 108.917 71.8095 111.725 71.685 111.85C71.6679 111.912 71.6378 111.97 71.5967 112.021C71.5556 112.071 71.5044 112.112 71.4465 112.14C71.3885 112.169 71.325 112.186 71.2603 112.189C71.1955 112.191 71.131 112.18 71.0707 112.156C66.693 110.607 66.1957 111.256 65.4262 110.89C65.1517 110.758 65.2807 110.314 65.4645 110.314C65.0731 107.881 64.4562 105.49 63.6217 103.172C63.4987 102.829 64.0867 102.594 64.236 102.903C64.8825 103.992 65.7771 104.913 66.8467 105.591C67.5697 105.988 68.1142 105.475 68.613 104.977C69.0669 104.497 69.4661 103.969 69.8032 103.402C69.853 103.321 69.9279 103.258 70.0165 103.224C70.1051 103.189 70.2026 103.185 70.294 103.211C70.3855 103.237 70.4659 103.292 70.5229 103.368C70.58 103.444 70.6107 103.537 70.6102 103.632C70.5472 104.668 70.6102 106.166 71.877 106.473C73.1437 106.78 74.2957 105.897 75.2175 105.13C75.6045 104.7 76.338 105.129 75.9885 105.625L75.9855 105.629ZM77.2905 104.554C77.0524 104.545 76.8274 104.444 76.6623 104.272C76.4973 104.1 76.4052 103.871 76.4052 103.633C76.4052 103.395 76.4973 103.166 76.6623 102.994C76.8274 102.822 77.0524 102.721 77.2905 102.711C77.5215 102.729 77.7373 102.834 77.8947 103.004C78.0521 103.174 78.1398 103.397 78.1401 103.629C78.1405 103.861 78.0536 104.084 77.8967 104.255C77.7399 104.426 77.5245 104.531 77.2935 104.55L77.2905 104.554Z",
      className: "fill-surface-common-icon-color"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M146.1 96.7178C145.314 89.9408 142.005 82.9538 138.191 77.2508C133.553 70.3186 127.814 62.9521 119.722 61.0508C117.581 60.5468 114.458 60.4013 112.427 61.2428C112.157 61.3546 112.157 61.8188 112.502 61.8188C114.096 61.6185 115.71 61.6314 117.302 61.8571C125.56 63.2506 130.87 69.3878 135.655 76.2938C141.198 84.2941 146.449 95.0821 144.063 104.477C142.571 110.353 138.712 115.249 134.157 119.067C129.154 123.209 123.737 126.825 117.992 129.857C117.341 130.205 116.721 130.657 116.072 131.047C115.571 131.347 115.916 132.268 116.495 132.045C118.014 131.505 119.48 130.824 120.872 130.01C125.334 127.485 129.597 124.623 133.622 121.448C141.64 115.079 147.265 106.764 146.1 96.7178Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M96.0315 119.372C96.0916 119.429 96.1703 119.463 96.2533 119.467C96.3363 119.471 96.4179 119.445 96.4832 119.393C96.5486 119.342 96.5931 119.269 96.6088 119.187C96.6245 119.106 96.6102 119.021 96.5685 118.949C96.189 118.094 95.376 117.691 95.4938 117.224C95.5688 116.802 96.1425 116.413 96.4538 116.149C99.486 113.57 101.329 114.095 103.135 116.299C103.549 116.806 103.94 117.459 104.635 117.605C104.995 117.643 105.359 117.605 105.703 117.492C106.047 117.38 106.363 117.196 106.631 116.953C106.856 116.794 106.747 116.338 106.439 116.453C106.006 116.647 105.53 116.726 105.057 116.684C104.391 116.493 103.952 115.259 102.638 114.227C102.004 113.731 101.244 113.421 100.444 113.333C99.6436 113.245 98.8346 113.381 98.1075 113.727C96.9348 114.259 95.878 115.015 94.9973 115.955C94.7719 116.152 94.6007 116.404 94.4999 116.686C94.3991 116.968 94.372 117.271 94.4213 117.567C94.65 118.488 95.4165 118.834 96.0315 119.372Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M101.599 119.602C101.986 118.605 101.791 116.587 100.37 116.569C100.303 116.567 100.237 116.586 100.18 116.624C100.124 116.661 100.08 116.714 100.055 116.777C100.03 116.839 100.025 116.908 100.04 116.974C100.055 117.04 100.089 117.099 100.139 117.145C100.35 117.295 100.524 117.49 100.651 117.715C100.777 117.941 100.851 118.192 100.869 118.45C100.845 119.002 100.612 119.524 100.216 119.909C99.7694 120.321 99.2418 120.637 98.6668 120.835C98.0919 121.033 97.4821 121.11 96.876 121.06C95.7052 121.007 93.9315 120.406 93.3435 119.41C92.6437 118.225 93.3217 116.614 93.804 115.456C93.963 115.074 93.4582 114.765 93.2662 115.148C92.5372 116.339 91.7812 117.611 92.076 119.065C92.775 122.516 100.031 123.628 101.599 119.602Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M94.6875 124.209C94.6125 123.901 93.921 123.629 93.6502 123.518C93.116 123.299 92.6364 122.965 92.2451 122.541C91.8538 122.116 91.5603 121.611 91.3852 121.061C91.2795 120.638 90.7027 120.866 90.771 121.136C91.041 124.377 94.9635 125.4 94.6875 124.209Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M95.2244 127.473C95.5319 127.398 96.4912 126.67 95.7622 126.551C94.9192 126.415 94.1452 126.558 93.2669 126.129C92.4691 125.791 91.8068 125.197 91.3852 124.44C91.3599 124.395 91.326 124.355 91.2854 124.322C91.2447 124.29 91.1981 124.266 91.1481 124.252C91.0982 124.237 91.0459 124.233 90.9943 124.239C90.9427 124.245 90.8928 124.261 90.8474 124.286C90.802 124.311 90.762 124.345 90.7297 124.386C90.6974 124.427 90.6734 124.473 90.6592 124.523C90.6449 124.573 90.6406 124.625 90.6465 124.677C90.6524 124.729 90.6684 124.779 90.6937 124.824C91.3364 126.43 93.4499 127.917 95.2244 127.473Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M96.0316 130.583C96.3391 130.549 98.1046 130.045 97.2601 129.508C96.8536 129.203 93.8641 129.99 92.2298 128.356C92.1688 128.295 92.0859 128.261 91.9996 128.261C91.9132 128.261 91.8304 128.295 91.7693 128.356C91.7083 128.418 91.674 128.5 91.674 128.587C91.674 128.673 91.7083 128.756 91.7693 128.817C92.2787 129.44 92.9345 129.928 93.6783 130.236C94.422 130.544 95.2305 130.664 96.0316 130.583Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M110.084 116.953C109.501 115.895 108.638 115.018 107.588 114.419C108.335 113.552 109.172 112.767 110.084 112.076C119.505 103.542 120.195 102.878 121.409 102.055C122.737 101.063 124.297 100.429 125.94 100.212C126.042 100.212 126.14 100.172 126.212 100.1C126.284 100.028 126.324 99.9299 126.324 99.8281C126.324 99.7262 126.284 99.6285 126.212 99.5565C126.14 99.4845 126.042 99.444 125.94 99.444C124.378 99.456 122.846 99.8656 121.487 100.634C120.279 97.5308 114.78 91.2593 113.654 76.3291C113.654 76.2425 113.619 76.1595 113.558 76.0984C113.497 76.0372 113.414 76.0028 113.327 76.0028C113.241 76.0028 113.158 76.0372 113.097 76.0984C113.035 76.1595 113.001 76.2425 113.001 76.3291C112.922 81.6507 113.847 86.9396 115.727 91.9186C113.501 90.5203 111.473 88.8283 109.699 86.8883C109.057 86.1871 108.47 85.3883 107.779 84.7381C107.629 84.6226 107.357 84.7381 107.433 84.9301C107.826 85.7941 108.344 86.5961 108.969 87.3106C110.787 89.6307 113.028 91.585 115.574 93.0698C115.319 94.3216 113.116 106.592 113.116 107.43C112.003 108.428 106.704 113.189 106.282 113.535C106.051 113.765 104.551 115.79 105.552 115.493C106.356 115.255 106.856 115.112 107.587 115.801C108.168 116.434 108.659 117.144 109.046 117.912C110.399 120.142 111.445 122.545 112.156 125.054C111.483 125.124 110.816 125.24 110.159 125.399C109.562 125.557 109.027 125.892 108.623 126.359C107.198 127.928 106.166 129.547 104.362 130.737C102.563 131.955 100.465 132.659 98.295 132.772C96.6401 132.807 94.9988 132.465 93.495 131.774C93.4291 131.737 93.3514 131.727 93.2783 131.746C93.2053 131.765 93.1424 131.812 93.1027 131.876C93.0631 131.94 93.0498 132.017 93.0656 132.091C93.0814 132.165 93.1251 132.23 93.1875 132.272C96.1815 134.506 101.702 134.577 106.163 130.89C107.508 129.779 108.313 128.318 109.503 127.127C110.271 126.359 111.423 126.321 112.383 125.975C112.862 128.01 113.346 129.611 112.997 130.66C112.369 132.55 110.506 130.96 109.657 130.314C109.598 130.259 109.524 130.222 109.444 130.208C109.365 130.195 109.283 130.205 109.209 130.238C109.135 130.271 109.072 130.325 109.029 130.393C108.986 130.461 108.964 130.541 108.965 130.622C108.978 131.018 109.095 131.403 109.304 131.74C109.513 132.077 109.807 132.354 110.156 132.542C110.732 132.851 111.388 132.98 112.039 132.911C112.689 132.843 113.304 132.58 113.804 132.158C114.107 131.771 114.329 131.326 114.454 130.851C114.58 130.375 114.606 129.879 114.533 129.393C114.05 124.954 112.526 120.691 110.084 116.953ZM116.266 93.2618C117.07 95.2351 119.278 99.63 120.797 100.98C118.922 102.133 116.768 104.192 114.539 106.125C114.577 105.587 116.036 95.5275 116.266 93.2618Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M102.251 59.0123C102.053 58.4003 99.7574 57.8685 99.1409 58.014C99.0664 58.0362 99.0011 58.0819 98.9546 58.1442C98.9082 58.2065 98.8831 58.2821 98.8831 58.3598C98.8831 58.4375 98.9082 58.5131 98.9546 58.5754C99.0011 58.6377 99.0664 58.6834 99.1409 58.7056C99.739 58.7667 100.33 58.8825 100.907 59.0513C101.023 59.1263 102.973 64.3921 103.327 65.1173C103.552 65.5808 104.209 67.1146 104.325 67.3831C97.9124 72.9121 88.0447 79.6313 87.6989 79.8616C87.45 79.052 87.1552 78.2572 86.8161 77.4811C86.5199 76.6711 85.4286 73.4131 85.1662 72.5663C84.9272 71.6783 84.6324 70.8063 84.2834 69.9556C84.0914 69.5333 83.5874 69.6038 83.2851 69.8401C82.0371 70.8151 78.3704 76.3651 78.1401 76.7131C78.1784 76.1371 78.7236 69.5341 78.8691 68.4968C78.9501 67.9208 79.3686 65.6551 79.3686 65.1173C79.3616 64.9693 79.3025 64.8285 79.2016 64.7199C79.1008 64.6113 78.9648 64.5419 78.8177 64.524C78.6706 64.506 78.5219 64.5407 78.3979 64.6218C78.2739 64.7029 78.1826 64.8253 78.1401 64.9673C77.8784 65.6761 77.3077 70.8923 77.2567 71.6483C77.1817 72.7613 77.0646 76.0253 77.0646 76.5631C77.0505 77.1441 77.1151 77.7244 77.2567 78.2881C77.3849 78.7381 78.1026 78.4538 78.1784 78.4036C79.1076 77.5981 82.1534 72.7523 83.3617 71.4923C83.5117 72.0683 85.9724 79.9013 86.4367 80.6686C86.5657 80.8418 86.9924 81.2183 87.2429 81.1681C91.1121 80.1436 103.948 69.4373 105.712 68.1136C105.824 67.9976 105.893 67.8463 105.907 67.6852C105.921 67.5241 105.878 67.3633 105.787 67.2301C105.707 66.7306 102.55 59.9371 102.251 59.0123Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M83.0146 78.441C82.8352 78.4469 82.6652 78.5223 82.5404 78.6513C82.4156 78.7802 82.3458 78.9527 82.3458 79.1321C82.3458 79.3116 82.4156 79.484 82.5404 79.613C82.6652 79.7419 82.8352 79.8173 83.0146 79.8232C83.1939 79.8173 83.3639 79.7419 83.4887 79.613C83.6135 79.484 83.6833 79.3116 83.6833 79.1321C83.6833 78.9527 83.6135 78.7802 83.4887 78.6513C83.3639 78.5223 83.1939 78.4469 83.0146 78.441Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M110.276 35.3603C109.742 34.8795 109.133 34.4905 108.472 34.209C109.033 33.0597 109.34 31.8031 109.374 30.5245C109.407 29.2459 109.165 27.9751 108.664 26.7983C108.339 26.1015 107.875 25.4786 107.3 24.9679C106.725 24.4572 106.052 24.0695 105.322 23.8285C104.592 23.5875 103.82 23.4985 103.054 23.5668C102.289 23.6351 101.545 23.8594 100.869 24.2258C99.9159 24.8129 99.1139 25.6156 98.5277 26.5693C97.9415 27.523 97.5874 28.601 97.494 29.7165C97.4371 30.5934 97.5147 31.4739 97.7242 32.3273C97.7625 32.5575 97.4558 32.7113 97.3403 32.4773C96.1883 30.4808 96.5722 27.9848 97.5705 25.9883C98.207 24.7325 99.2118 23.701 100.451 23.0318C99.3015 22.2308 98.733 21.7178 97.3403 21.6113C96.0704 21.4969 94.7918 21.6947 93.6157 22.1873C92.4965 22.6581 91.5188 23.4116 90.7785 24.374C90.0381 25.3365 89.5605 26.4747 89.3925 27.6773C89.3697 28.4902 89.447 29.3028 89.6227 30.0968C89.6587 30.327 89.3542 30.327 89.2387 30.2115C88.356 28.983 88.4805 26.8748 88.9702 25.527C89.6211 23.8219 90.8602 22.4057 92.4638 21.534C91.0433 19.653 87.8572 19.4625 85.7445 19.9215C82.0207 20.7308 80.2777 25.0965 81.675 28.4843C82.5763 30.4604 84.2168 32.0042 86.244 32.784C87.5205 33.4019 88.939 33.667 90.3525 33.552C91.9016 34.8547 93.8575 35.5748 95.8815 35.5875C97.5019 37.3658 99.6592 38.5658 102.025 39.0045L100.988 40.617C100.412 40.692 99.8362 40.8855 99.2632 40.9245C99.3254 40.8129 99.358 40.6873 99.358 40.5596C99.358 40.4319 99.3254 40.3063 99.2632 40.1948C98.913 39.7943 98.256 39.7058 96.3833 39.081C95.9228 39.3113 93.9645 40.1948 93.888 40.233C94.617 40.5788 95.6925 41.3468 94.5022 42.0375C93.312 42.7283 88.6658 44.8793 88.5893 44.9175C89.6595 45.9878 91.7033 46.2893 93.2348 46.146C95.5748 45.927 97.3485 44.2305 98.649 42.4215C98.8417 42.1538 99.5318 42.2295 99.954 42.1913C98.9175 43.9575 97.8735 45.72 96.9593 47.5283C96.8852 47.6569 96.8556 47.8064 96.8751 47.9535C96.8946 48.1007 96.962 48.2373 97.067 48.3423C97.1719 48.4473 97.3085 48.5147 97.4557 48.5342C97.6029 48.5536 97.7523 48.5241 97.881 48.45C99.1942 47.775 101.445 46.5495 102.988 47.0678C105.111 47.7803 101.949 51.81 98.1495 50.9843C97.4827 50.8395 97.0995 51.8963 98.3415 52.251C97.9192 53.6715 96.9592 60.852 96.921 61.1205C95.9992 61.62 87.7057 66.4575 85.9395 67.341C85.7827 63.9705 85.9013 56.9018 85.9013 56.82C89.0993 57.6923 91.7385 58.3358 94.3867 56.3213C95.6081 55.3785 96.6157 54.1876 97.3433 52.827C97.4016 52.724 97.4214 52.6035 97.399 52.4873C97.3766 52.371 97.3135 52.2665 97.221 52.1926C97.1286 52.1186 97.0128 52.08 96.8944 52.0837C96.7761 52.0874 96.6629 52.1332 96.5752 52.2128C94.7385 53.8703 93.2753 56.2253 90.5475 56.2058C89.088 56.196 83.3287 54.5558 81.9082 54.0555C80.4877 53.5553 76.5367 51.8595 75.957 51.5603C75.3465 51.2445 74.9925 50.907 75.0735 50.178C75.1485 49.5248 77.535 42.117 77.646 41.9228C77.6697 41.8824 77.6852 41.8377 77.6915 41.7912C77.6977 41.7448 77.6947 41.6976 77.6825 41.6523C77.6703 41.6071 77.6492 41.5647 77.6205 41.5277C77.5917 41.4908 77.5559 41.4599 77.5151 41.4369C77.4742 41.4139 77.4292 41.3993 77.3827 41.3939C77.3361 41.3885 77.289 41.3925 77.244 41.4055C77.199 41.4186 77.157 41.4404 77.1206 41.4699C77.0842 41.4993 77.0539 41.5358 77.0317 41.577C75.8026 44.299 74.711 47.081 73.761 49.9125C73.687 50.2563 73.6864 50.6119 73.7593 50.9559C73.8322 51.3 73.9769 51.6247 74.184 51.909C74.6616 52.4219 75.2523 52.8163 75.909 53.061C77.361 53.7675 85.086 56.517 85.1242 56.517C84.9814 57.0719 84.8789 57.6363 84.8175 58.206C83.55 58.356 82.6327 59.4015 81.7072 60.2033C81.1717 60.666 79.173 62.5838 78.6735 63.0825C78.4432 63.351 78.7485 63.8123 79.0575 63.582C79.5952 63.2363 83.1255 60.4688 83.6272 60.0878C83.9242 59.8104 84.2779 59.6008 84.6637 59.4735C84.4748 62.427 84.4748 65.3895 84.6637 68.343C84.6649 68.4594 84.6963 68.5735 84.755 68.674C84.8137 68.7745 84.8976 68.8579 84.9984 68.9161C85.0992 68.9743 85.2134 69.0051 85.3298 69.0056C85.4462 69.0062 85.5607 68.9763 85.662 68.919C87.7703 67.8743 96.9397 62.6843 97.9102 61.9688C98.0193 61.885 98.1024 61.7721 98.15 61.6431C98.1975 61.5141 98.2075 61.3742 98.1787 61.2398C98.2537 60.9705 99.1388 53.7908 99.1005 52.293C99.6345 52.268 100.163 52.1778 100.675 52.0245C104.231 51.1088 105.426 48.0803 104.516 46.6493C104.822 46.1115 107.625 41.9648 107.815 41.7345C108.819 42.0683 108.684 42.9555 108.469 43.9613C108.347 44.4801 108.167 44.9833 107.931 45.4613C107.876 45.559 107.857 45.6734 107.878 45.7837C107.9 45.894 107.96 45.9929 108.049 46.0626C108.137 46.1322 108.247 46.1679 108.359 46.1633C108.472 46.1586 108.579 46.1139 108.661 46.0373C109.075 45.5804 109.366 45.025 109.505 44.424C109.76 43.7909 109.865 43.1078 109.813 42.4275C109.776 42.0474 109.64 41.6838 109.417 41.3736C109.194 41.0634 108.894 40.8176 108.545 40.6613C109.613 39.1208 111.539 36.768 110.276 35.3603Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M92.925 39.5843C93.4995 39.2745 95.0753 38.778 95.2283 38.7008C93.846 38.2403 86.2823 35.9753 83.9033 35.322C83.4038 35.5523 81.561 36.3975 81.1388 36.5895C81.2252 36.6347 81.3149 36.6731 81.4073 36.7043C81.4875 36.7561 81.5534 36.8272 81.599 36.911C81.6447 36.9949 81.6686 37.0888 81.6686 37.1843C81.6686 37.2797 81.6447 37.3737 81.599 37.4575C81.5534 37.5414 81.4875 37.6125 81.4073 37.6643C80.3813 38.1488 76.4573 39.891 76.3005 39.9683C77.745 41.4128 81.387 41.85 84.633 38.8928C84.594 38.9318 81.8648 42.7298 81.558 43.155C81.2858 43.5368 81.057 44.0018 81.5198 44.3835C82.4703 45.0267 83.5215 45.5068 84.63 45.804C84.975 45.804 85.3208 45.3435 85.0905 45.0368C84.783 44.5755 82.902 43.731 82.7483 43.6538C83.0168 43.2315 86.703 37.9718 86.9333 37.5105C87.663 37.7408 88.4333 37.9718 89.1608 38.202C87.8858 39.8633 87.084 41.9775 87.9315 43.8848C88.2315 43.7348 93.5363 41.274 93.6143 41.235C93.4643 41.16 93.3075 41.1203 93.2303 41.085C92.2455 40.7543 92.211 39.9668 92.925 39.5843Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M75.6044 39.0465C75.8347 38.9317 78.9044 37.5877 79.4437 37.3575C78.9832 37.3185 78.6404 36.5962 79.1752 36.3585C80.1022 35.9482 82.2502 35.0152 82.4392 34.938C80.9077 34.5555 79.0987 33.924 77.3707 33.6712C77.2255 33.6454 77.0759 33.672 76.9484 33.7462C76.3293 34.2643 75.8502 34.9296 75.555 35.6809C75.2598 36.4323 75.1579 37.2458 75.2587 38.0467C75.3465 38.3889 75.4621 38.7232 75.6044 39.0465Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M85.4722 50.5657C84.3217 50.3632 83.7645 49.7025 82.9762 48.9525C82.9218 48.9019 82.854 48.8681 82.7809 48.8549C82.7077 48.8417 82.6324 48.8498 82.5637 48.8781C82.495 48.9064 82.4359 48.9539 82.3934 49.0148C82.3509 49.0757 82.3267 49.1475 82.3237 49.2217C82.2855 50.1045 83.1652 50.9542 83.8597 51.372C86.805 53.142 91.605 50.382 91.2315 48.222C91.2014 48.1231 91.1466 48.0335 91.0723 47.9615C90.9981 47.8896 90.9067 47.8378 90.8069 47.8108C90.7071 47.7839 90.6021 47.7828 90.5017 47.8076C90.4014 47.8325 90.309 47.8824 90.2332 47.9527C89.6526 48.6 89.0375 49.2154 88.3905 49.7962C87.979 50.111 87.5093 50.3411 87.0084 50.4732C86.5075 50.6053 85.9854 50.6367 85.4722 50.5657Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M80.7877 98.9063C80.7777 98.7553 80.7252 98.6101 80.6363 98.4877C80.5474 98.3652 80.4256 98.2704 80.2851 98.2141C80.1445 98.1579 79.991 98.1426 79.8421 98.1699C79.6932 98.1972 79.5551 98.2661 79.4437 98.3685C79.4055 98.3685 76.0687 97.6005 72.3405 96.756C72.36 95.8565 72.5557 94.9695 72.9165 94.1453C73.0214 93.869 73.1859 93.6191 73.3982 93.4134C73.6105 93.2077 73.8654 93.0512 74.145 92.955C74.376 92.88 74.6062 92.9168 74.76 92.763C74.9625 92.5598 74.8545 92.0948 74.1067 91.995C72.1267 91.7295 71.1255 94.479 70.9567 96.4875C67.5015 95.7195 63.9307 94.9125 62.3947 94.6058C61.3582 94.26 61.0507 95.1818 61.2045 95.5658C60.3085 103.152 58.8454 110.66 56.8275 118.028C56.6677 118.84 56.4363 119.637 56.136 120.408C56.0798 120.509 56.0472 120.622 56.0406 120.738C56.0339 120.853 56.0535 120.969 56.0978 121.076C56.142 121.183 56.2098 121.279 56.2962 121.356C56.3825 121.433 56.4852 121.49 56.5965 121.522C62.6979 123.829 69.2043 124.874 75.7215 124.593C75.8112 124.694 75.9259 124.77 76.0541 124.812C76.1823 124.855 76.3195 124.863 76.4519 124.836C76.5842 124.809 76.7071 124.747 76.8081 124.657C76.9091 124.568 76.9846 124.453 77.0272 124.325C79.0305 116.625 81.15 106.922 80.7877 98.9063ZM75.8377 123.056C69.7286 123.307 63.6282 122.382 57.8685 120.33C57.996 119.906 59.364 114.944 60.1335 111.499C61.2752 106.431 62.134 101.304 62.706 96.1403C65.3557 96.678 79.2165 99.3653 79.332 99.3653C79.4722 107.381 77.775 115.311 75.8347 123.058L75.8377 123.056Z",
      className: "fill-surface-common-secondary"
    }
  )
] }), KCe = Ar()(
  Uhe
), Ghe = (e) => /* @__PURE__ */ F("svg", { viewBox: "0 0 120 120", fill: "none", ...e, children: [
  /* @__PURE__ */ d(
    "path",
    {
      d: "M49.6109 63.2146C49.8233 63.2146 49.9379 63.3794 49.9605 63.5359C49.9825 63.6891 49.9256 63.8767 49.7613 63.9724L49.7418 63.9832L49.7193 63.9871C46.7451 64.482 44.1892 65.031 41.2672 66.5701C40.0223 67.2249 38.8359 67.9862 37.7222 68.8455C37.3661 69.1655 36.9784 69.4486 36.565 69.6902L36.5494 69.7L36.5328 69.7039C36.3989 69.7372 36.2481 69.6876 36.1519 69.6062C36.1021 69.564 36.0561 69.5049 36.0396 69.4304C36.0222 69.3513 36.0415 69.2704 36.0943 69.2C36.4144 68.7449 36.8109 68.3488 37.2662 68.0291C37.7039 67.6796 38.1448 67.3264 38.5865 67.0173L38.5884 67.0164C41.6513 64.9496 46.0112 63.2146 49.6109 63.2146Z",
      className: "fill-surface-common-secondary stroke-surface-common-secondary stroke-[0.25]"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M48.4483 67.2723C49.4172 67.1272 50.4248 67.0497 51.129 67.1757C51.3261 67.2111 51.3986 67.4016 51.3917 67.5458C51.3843 67.696 51.2913 67.87 51.088 67.9042C49.5643 68.1928 45.9638 68.0097 41.2315 70.9677C41.0576 71.0766 40.8937 71.1857 40.7286 71.2958C40.5659 71.4043 40.4007 71.5124 40.2256 71.6219L40.2266 71.6229C40.0663 71.7374 39.8833 71.8401 39.7042 71.9432C39.5229 72.0476 39.3422 72.1543 39.1729 72.2811C39.0987 72.3366 39.0126 72.3515 38.9327 72.326C38.8587 72.3025 38.8034 72.249 38.7676 72.1932C38.7027 72.092 38.6668 71.9152 38.7842 71.7909C39.1224 71.4004 39.4956 71.0416 39.8995 70.7196L39.9034 70.7167C41.7214 69.3929 43.761 68.403 45.9258 67.7938L45.9278 67.7928C46.5249 67.6341 47.4752 67.4181 48.4483 67.2723Z",
      className: "fill-surface-common-secondary stroke-surface-common-secondary stroke-[0.25]"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M53.8745 70.9569C53.9661 70.9459 54.0506 70.9687 54.1127 71.0282C54.1754 71.0883 54.2005 71.1705 54.2006 71.246C54.2006 71.3963 54.0992 71.5666 53.8979 71.6005L53.893 71.6015C52.6914 71.7545 51.5063 72.0175 50.353 72.3876L50.3491 72.3895V72.3886C47.1465 73.2976 44.2384 75.0312 41.9145 77.4149L41.9106 77.4188L41.9096 77.4179C40.4668 78.7805 39.0264 80.3418 37.4252 81.7147C35.8188 83.0922 34.0335 84.2968 31.8774 84.9677C30.1082 85.542 27.778 85.776 26.103 84.7372C26.0297 84.695 25.974 84.6272 25.9477 84.5468C25.9215 84.4664 25.9261 84.379 25.9604 84.3017C25.9948 84.2242 26.0569 84.1624 26.1342 84.1278C26.209 84.0945 26.2932 84.0889 26.3715 84.1122C27.4208 84.3779 28.5026 84.4952 29.5844 84.4608C30.6796 84.3608 31.7513 84.0821 32.7563 83.6356L32.7592 83.6347C35.7272 82.3814 37.6769 80.3447 39.7895 78.2167C41.9 76.0908 44.1667 73.881 47.7563 72.33C49.6852 71.4737 51.7646 71.0067 53.8745 70.9559V70.9569Z",
      className: "fill-surface-common-secondary stroke-surface-common-secondary stroke-[0.25]"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M87.4778 45.2682L87.4768 45.2702C87.4834 45.2897 87.4968 45.3211 87.5178 45.3649C87.5595 45.4518 87.6252 45.5737 87.7083 45.7213C87.8742 46.0165 88.1059 46.4057 88.345 46.8014C88.5839 47.197 88.829 47.5984 89.0237 47.9176C89.2076 48.2192 89.3503 48.4549 89.3938 48.5378C89.4797 48.6773 89.5938 48.8421 89.72 49.0241C89.8454 49.205 89.9822 49.4025 90.1125 49.6022C90.3697 49.9963 90.6141 50.4208 90.6858 50.777L90.9456 51.9626C91.5829 54.7552 92.6251 58.3525 97.8586 74.8395C99.65 74.2895 106.533 72.1363 108.471 71.5338C109.327 71.2563 110.203 71.0152 111.034 70.7702C111.868 70.5245 112.66 70.2743 113.36 69.9801C114.763 69.39 115.759 68.6347 115.997 67.4069C116.075 66.6445 116.045 65.875 115.909 65.1208V65.1188C115.507 62.6468 114.905 60.2116 114.11 57.8366V57.8336C113.493 55.8525 112.879 53.8359 112.09 51.9508V51.9499C112.004 51.7694 112.05 51.5943 112.166 51.4782C112.278 51.3669 112.45 51.3116 112.618 51.3385C112.717 51.3528 112.798 51.3902 112.863 51.445C112.925 51.4983 112.968 51.5635 112.999 51.6266C113.03 51.6882 113.055 51.7565 113.076 51.8131L113.149 51.9704L113.155 51.9801H113.154C113.55 52.806 113.875 53.6645 114.126 54.5456L114.626 56.0407C115.397 58.4048 115.871 60.1561 116.27 61.7028L116.728 63.487L116.73 63.4967L116.876 64.3268C117.02 65.1547 117.143 65.974 117.124 66.7487C117.099 67.7878 116.818 68.7589 115.991 69.5866L115.992 69.5876C114.999 70.6262 113.558 71.0735 112.288 71.4674L112.281 71.4694C112.278 71.4706 112.226 71.4866 112.123 71.5182C112.02 71.5501 111.87 71.5963 111.68 71.6549C111.3 71.7724 110.759 71.9395 110.112 72.1403C108.816 72.5419 107.09 73.0782 105.352 73.6198C103.614 74.1615 101.863 74.7093 100.519 75.1335C99.8473 75.3454 99.2775 75.5265 98.8616 75.6608C98.5621 75.7575 98.3474 75.8302 98.2307 75.8708C98.2659 76.1471 98.1395 76.3968 97.9426 76.6042C97.7192 76.8394 97.3919 77.0373 97.0491 77.1891C96.7047 77.3415 96.3347 77.452 96.0178 77.5075C95.8594 77.5352 95.711 77.5501 95.5842 77.5485C95.463 77.5469 95.3464 77.5295 95.259 77.4831V77.484C95.064 77.386 94.9627 77.2792 94.9045 77.1481C94.8776 77.0874 94.8617 77.0248 94.8479 76.9684C94.8433 76.9497 94.8368 76.9319 94.8323 76.9137C88.2382 78.9852 65.4029 85.814 60.3342 87.2565L60.3333 87.2555C58.7217 87.7366 56.7873 88.446 54.8655 88.7721C52.9402 89.0988 50.9974 89.0484 49.3674 87.9889V87.9879C47.7967 87.022 46.7283 85.3345 45.9172 83.5026C45.1061 81.6706 44.5411 79.6673 43.9944 78.071L43.9905 78.0612L43.9915 78.0602C43.9515 77.8988 44.0548 77.7701 44.1643 77.7194C44.2214 77.693 44.2912 77.6816 44.3606 77.6999C44.4153 77.7143 44.4638 77.7453 44.5002 77.7917L44.5325 77.8424V77.8434C45.2573 79.3153 45.8595 80.8503 46.5354 82.3112C47.2153 83.7805 47.9796 85.1994 49.0471 86.485L49.1868 86.6422C49.9031 87.4023 50.9258 87.7704 52.0276 87.8922C53.2023 88.0221 54.452 87.8705 55.4768 87.6305L55.4778 87.6295C57.1839 87.2365 85.9036 78.6644 94.5667 75.9743C94.5565 75.9475 94.5443 75.9178 94.5325 75.8844C94.4823 75.7428 94.4142 75.5341 94.3313 75.2702C94.1653 74.7419 93.9376 73.9837 93.6682 73.068C93.1292 71.2358 92.4232 68.7698 91.7083 66.2487C90.2788 61.2077 88.8148 55.9383 88.594 55.0563C87.9379 52.43 87.051 49.7216 87.1399 46.9713C87.1404 46.8301 87.1621 46.4018 87.1838 46.0124C87.1949 45.8143 87.2058 45.6243 87.2141 45.484C87.2182 45.4141 87.2215 45.3563 87.2239 45.3161C87.2248 45.3004 87.2252 45.2871 87.2258 45.277C87.2255 45.2685 87.2251 45.2586 87.2268 45.2477C87.2295 45.2303 87.2368 45.1986 87.2639 45.1715L87.4973 44.9391L87.4778 45.2682Z",
      className: "fill-surface-common-icon-color stroke-surface-common-icon-color stroke-[0.25]"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M4.62219 54.3379C6.57874 45.9531 12.2487 42.6322 16.7667 43.1573H16.7677C17.8709 43.2952 18.8371 43.6681 19.7697 44.1172C20.2355 44.3416 20.6951 44.5868 21.1583 44.8301C21.6222 45.0738 22.0911 45.3164 22.5792 45.541C24.5246 46.4365 26.7869 47.0427 30.2247 46.1514V46.1504C30.3019 46.1307 30.3754 46.1441 30.4337 46.1836C30.4883 46.2206 30.5216 46.2744 30.5392 46.3233C30.5565 46.3713 30.5635 46.4281 30.5519 46.4805C30.5423 46.5237 30.5084 46.5892 30.4337 46.6114L30.4347 46.6133C28.6135 47.3419 27.0574 47.497 25.6622 47.3291C24.2691 47.1615 23.0424 46.6723 21.88 46.1221C19.5435 45.0162 17.4873 43.684 14.7921 44.0684L14.7931 44.0694C12.9622 44.3773 11.2588 45.2061 9.88684 46.4571L9.88489 46.459C6.75306 49.1981 5.57006 53.3822 4.99915 57.4229C3.28868 69.5014 3.43666 86.6718 5.74622 100.403L5.87219 101.095C6.18726 102.769 6.64802 104.843 7.27747 106.836C7.99784 109.117 8.9346 111.275 10.1144 112.613L10.3615 112.865C11.6353 114.063 13.4382 114.344 15.1818 113.939C17.1486 113.448 18.6017 112.28 19.7892 110.77C20.9788 109.257 21.8971 107.407 22.798 105.561C29.0473 92.4031 27.1831 95.767 29.1359 91.17C29.0984 91.1872 29.0593 91.2046 29.0197 91.2178H29.0187C28.1414 91.5008 27.3694 91.1023 26.7404 90.5186C26.1114 89.9349 25.597 89.1412 25.2247 88.5723C24.1925 86.9991 23.3254 84.8493 22.7247 82.9063C22.4241 81.9338 22.1888 81.0102 22.0333 80.2334C21.9138 79.6363 21.84 79.1202 21.8204 78.7334C21.3287 79.2367 20.8595 79.7551 20.3986 80.2832L18.8263 82.1192C16.7414 84.5656 14.3688 87.69 12.547 91.003C10.724 94.3182 9.4605 97.8091 9.57532 100.993H9.57434C9.58577 101.075 9.56509 101.152 9.50989 101.209C9.45444 101.266 9.37927 101.288 9.31262 101.288C9.24528 101.288 9.17278 101.266 9.11536 101.217C9.05785 101.168 9.02083 101.096 9.0177 101.01C8.90563 99.8838 8.95007 98.7475 9.15051 97.6338C10.1385 91.7087 14.6123 85.5697 18.505 81.0782C19.6417 79.7668 20.8273 78.3602 22.1007 77.128C22.2721 76.6955 22.5554 76.3162 22.922 76.0293C23.2961 75.7366 23.7426 75.5509 24.214 75.4922L24.2218 75.4912H24.2296C24.3218 75.4912 24.3985 75.53 24.4503 75.5918C24.4993 75.6504 24.5215 75.723 24.5255 75.7901C24.5326 75.9087 24.4794 76.0786 24.3185 76.128L24.3195 76.1289C23.9745 76.263 23.6658 76.4762 23.4191 76.752C23.1723 77.0278 22.9946 77.3582 22.8995 77.7159C22.7981 78.2568 22.7712 78.8082 22.8165 79.3555C23.8529 77.5458 24.7578 75.6639 25.5206 73.7227L25.5236 73.7159C28.6217 67.0044 35.6917 61.3283 47.131 59.7881V59.7891C47.3219 59.7552 47.4453 59.8959 47.4777 60.0254C47.4945 60.0927 47.4922 60.1713 47.4572 60.2412C47.4202 60.3147 47.352 60.3673 47.2609 60.3858L47.2618 60.3867C37.3045 62.5194 32.223 66.0362 29.2765 69.5869C27.802 71.3638 26.8587 73.1544 26.1056 74.795C25.3558 76.4283 24.7867 77.9348 24.0734 79.1094L24.0724 79.1084C24.0554 79.1399 24.0273 79.1843 23.9943 79.2315C23.9561 79.2859 23.9072 79.3536 23.8517 79.4287C23.7413 79.5782 23.6004 79.7646 23.4669 79.9444C23.3323 80.1257 23.2029 80.3022 23.1105 80.4385C23.0641 80.5069 23.029 80.5628 23.007 80.6026C23.0018 80.6118 22.9982 80.62 22.9952 80.626C23.3378 82.0344 24.1908 84.7929 25.2775 87.0371C25.825 88.1679 26.4269 89.1574 27.045 89.7793C27.3538 90.0899 27.6599 90.3019 27.9581 90.3985C28.252 90.4936 28.5432 90.4789 28.8351 90.3272C29.5093 89.9782 29.7607 89.3775 29.8243 88.6875C29.8888 87.9894 29.7598 87.2299 29.6925 86.5801L29.6906 86.5684L29.6915 86.5674C29.6906 86.4674 29.7255 86.3704 29.7902 86.294C29.8551 86.2173 29.9458 86.1667 30.045 86.1514C30.1443 86.1361 30.2462 86.1565 30.3312 86.21C30.4155 86.2631 30.4776 86.3452 30.507 86.4405C30.9076 87.6967 31.0651 89.0098 30.3722 90.1778C30.2439 90.5676 30.048 91.4563 29.295 93.4639C28.5349 95.4906 27.2019 98.6692 24.7823 103.686L24.7833 103.687C23.9339 105.52 23.0682 107.46 22.0265 109.218C21.0494 110.866 19.9127 112.361 18.4786 113.462L18.1886 113.677C16.5863 114.832 14.602 115.328 12.6447 115.063H12.6427C10.5672 114.747 9.08626 113.303 8.15149 111.522C7.09044 109.495 6.28903 107.342 5.76575 105.115V105.116C3.31175 95.4879 1.9283 77.037 3.65149 60.9532C3.82028 58.7286 4.14408 56.5182 4.62122 54.3389L4.62219 54.3379Z",
      className: "fill-surface-common-secondary stroke-surface-common-secondary stroke-[0.25]"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M47.6316 24.894C48.6432 24.1902 49.9632 24.9384 50.9316 25.422C51.6798 25.7736 53.3952 26.6976 54.0108 25.686C54.0552 25.5978 54.0108 25.422 53.8788 25.422C53.4842 25.3852 53.0877 25.3706 52.6914 25.3782C51.0714 25.122 48.999 23.0538 47.325 24.5424C47.1036 24.6744 47.4114 25.0698 47.6316 24.894Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M42.5292 30.7884C42.5664 29.9895 42.6694 29.195 42.837 28.413C43.4088 26.082 45.2124 24.102 46.797 22.3428C46.8201 22.3233 46.8388 22.2992 46.8521 22.2721C46.8654 22.2449 46.8729 22.2153 46.8741 22.1852C46.8754 22.155 46.8704 22.1249 46.8594 22.0967C46.8484 22.0686 46.8317 22.043 46.8104 22.0217C46.789 22.0003 46.7634 21.9836 46.7353 21.9726C46.7072 21.9617 46.677 21.9566 46.6469 21.9579C46.6167 21.9591 46.5871 21.9666 46.56 21.9799C46.5328 21.9932 46.5087 22.012 46.4892 22.035C45.3768 23.0568 44.3742 24.1919 43.4976 25.422C42.6022 26.6757 42.0697 28.152 41.9586 29.6886C41.972 30.1025 42.0771 30.5083 42.2664 30.8766C42.309 31.0086 42.5292 30.9204 42.5292 30.7884Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M41.4294 34.9674C42.4937 35.4851 43.6942 35.6543 44.8602 35.451C45.9162 35.2314 47.3238 34.4832 47.6316 33.384C47.6422 33.3499 47.6414 33.3133 47.6295 33.2797C47.6176 33.246 47.5951 33.2171 47.5654 33.1973C47.5357 33.1775 47.5004 33.1677 47.4648 33.1696C47.4291 33.1715 47.395 33.1848 47.3676 33.2076C46.4004 33.6474 45.339 35.7006 41.6076 34.5276C41.34 34.3956 41.163 34.8396 41.4294 34.9674Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M108.529 49.1847C110.182 48.842 112.071 48.7452 113.535 49.669L113.823 49.8673L113.832 49.8741L113.831 49.8751L114.042 50.0792C115.067 51.1204 115.693 52.4926 115.806 53.9552C115.821 54.0897 115.78 54.2049 115.699 54.2872C115.622 54.3664 115.517 54.4074 115.414 54.4181C115.216 54.4385 114.964 54.3439 114.901 54.088V54.087C114.638 53.0798 114.28 52.0546 113.696 51.2667C113.115 50.4837 112.311 49.9349 111.145 49.8712H111.143C109.105 49.7419 107.154 50.5211 105.252 51.1847L105.245 51.1866C105.018 51.2516 104.84 51.1168 104.772 50.9571C104.704 50.8001 104.727 50.575 104.935 50.4708H104.936C106.08 49.908 107.284 49.4768 108.526 49.1856L108.529 49.1847Z",
      className: "fill-surface-common-secondary stroke-surface-common-secondary stroke-[0.25]"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M108.989 45.9431C109.778 45.9517 110.451 46.0474 110.941 46.1414C111.186 46.1884 111.386 46.2348 111.531 46.2693C111.604 46.2867 111.661 46.3006 111.704 46.3103C111.748 46.3202 111.765 46.3227 111.766 46.323H111.78L111.766 46.448L111.78 46.324C112.223 46.3741 112.637 46.5728 112.953 46.8875L112.967 46.9012L112.976 46.9168C113.006 46.9726 113.023 47.0351 113.027 47.0984C113.03 47.1616 113.02 47.2251 112.996 47.284C112.973 47.3428 112.936 47.3959 112.89 47.4392C112.844 47.4825 112.789 47.5152 112.729 47.5349L112.706 47.5428L112.683 47.5408C112.306 47.5206 111.937 47.4287 111.594 47.2713C111.306 47.1911 111.015 47.1223 110.722 47.0652L110.426 47.0125C108.13 46.6436 105.779 47.138 103.827 48.4012L103.818 48.408L103.76 48.2967L103.817 48.408C103.719 48.4583 103.605 48.469 103.499 48.4383C103.393 48.4074 103.303 48.3364 103.247 48.241C103.192 48.1457 103.175 48.0329 103.2 47.9256C103.219 47.8451 103.261 47.7725 103.32 47.7156L103.383 47.6638C105.363 46.2593 107.41 45.9261 108.989 45.9431Z",
      className: "fill-surface-common-secondary stroke-surface-common-secondary stroke-[0.25]"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M105.269 43.5287C106.583 43.1622 107.957 43.0657 109.308 43.2445C109.478 43.2398 109.648 43.2546 109.814 43.2904C110.032 43.3126 110.258 43.3469 110.455 43.4164C110.656 43.4876 110.841 43.6006 110.95 43.7904H110.949C110.984 43.8444 111.006 43.9052 111.013 43.9691C111.02 44.0358 111.011 44.1031 110.986 44.1654C110.961 44.2276 110.922 44.2832 110.871 44.3266C110.827 44.364 110.774 44.3886 110.718 44.4047C110.566 44.4903 110.385 44.4695 110.238 44.4369C110.159 44.4195 110.079 44.3964 110.007 44.3764C109.934 44.3557 109.868 44.3382 109.809 44.3285L109.807 44.3275C108.477 44.0785 107.111 44.1009 105.79 44.392C104.468 44.6831 103.219 45.237 102.117 46.0219L102.116 46.0209C102.026 46.0899 101.923 46.0999 101.832 46.0688C101.744 46.0388 101.672 45.9745 101.623 45.9037C101.573 45.8325 101.538 45.7431 101.536 45.6508C101.534 45.555 101.569 45.4551 101.659 45.3832H101.658C102.723 44.5269 103.952 43.8962 105.269 43.5287Z",
      className: "fill-surface-common-secondary stroke-surface-common-secondary stroke-[0.25]"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M100.729 42.2202C103.037 40.152 106.153 39.627 109.148 40.2993H109.149C109.554 40.3752 109.924 40.5757 110.207 40.8706L110.323 41.0034L110.331 41.0132L110.337 41.0239C110.365 41.0775 110.38 41.1365 110.382 41.1968C110.384 41.2571 110.372 41.3174 110.348 41.3726C110.323 41.4277 110.286 41.477 110.24 41.5161C110.194 41.555 110.14 41.5829 110.082 41.5981L110.08 41.5991C109.793 41.6705 109.523 41.5657 109.206 41.4517C108.879 41.3343 108.461 41.1868 107.837 41.1177H107.832C106.683 40.9442 105.511 41.0039 104.386 41.2944C103.261 41.585 102.206 42.1001 101.285 42.8081C101.096 42.9627 100.861 42.9108 100.727 42.7837C100.658 42.7189 100.608 42.6283 100.602 42.5249C100.595 42.4186 100.636 42.3135 100.725 42.2251L100.729 42.2202Z",
      className: "fill-surface-common-secondary stroke-surface-common-secondary stroke-[0.25]"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M111.944 72.3539C112.026 72.3265 112.115 72.3295 112.196 72.3617C112.276 72.394 112.342 72.454 112.382 72.5306C112.423 72.6074 112.434 72.696 112.415 72.7806L112.413 72.7894L112.411 72.7982C111.513 75.1327 109.348 81.6887 105.892 87.7699C103.998 91.117 101.7 94.4797 98.4652 96.7396C96.9048 97.8516 95.1132 98.5961 93.224 98.9164L93.2201 98.9174C89.5643 99.4392 85.8033 97.3603 82.5082 94.3773C79.208 91.3897 76.3481 87.4708 74.4877 84.2543L74.4886 84.2533C74.4068 84.1263 74.391 83.9931 74.432 83.8734C74.4723 83.7563 74.5611 83.6656 74.6625 83.6097C74.7641 83.5538 74.8883 83.5276 75.0092 83.5502C75.1023 83.5676 75.1901 83.6132 75.2592 83.6908L75.3217 83.7797L75.3265 83.7885C75.4576 84.0741 75.615 84.3469 75.7972 84.6029L75.8021 84.6107C77.5003 87.3952 79.5012 89.9834 81.7679 92.3285H81.767C85.3156 95.9449 89.619 99.0681 94.3998 97.6625C98.9722 96.3245 102.402 92.0973 105.146 87.1566C107.889 82.2169 109.926 76.607 111.74 72.5258L111.743 72.5189L111.746 72.5121C111.791 72.4378 111.862 72.3815 111.944 72.3539Z",
      className: "fill-surface-common-secondary stroke-surface-common-secondary stroke-[0.25]"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M94.7988 77.5586C94.9054 77.5202 95.0068 77.5788 95.0566 77.6367C95.0869 77.6719 95.1128 77.7203 95.1162 77.7773C95.1192 77.8293 95.102 77.8792 95.0684 77.9219L94.958 78.083C94.6852 78.4489 94.3133 78.7539 93.9316 79.0342C93.4882 79.3598 93.0382 79.6475 92.6699 79.9727L92.666 79.9766C91.816 80.6641 91.0259 81.4228 90.3066 82.2461C90.2309 82.3364 90.1351 82.3845 90.0332 82.3848C89.9344 82.3849 89.8458 82.3407 89.7822 82.2773C89.6546 82.15 89.6082 81.9246 89.7627 81.7363H89.7617C90.4595 80.8619 91.2296 80.0474 92.0635 79.3018L92.0674 79.2988C92.4306 79 92.8628 78.5925 93.3154 78.2559C93.7673 77.9198 94.2666 77.6323 94.7988 77.5586Z",
      className: "fill-surface-common-secondary stroke-surface-common-secondary stroke-[0.25]"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M64.92 29.601C64.6998 29.6886 64.9638 26.2578 65.0076 26.0376C65.3598 23.8386 66.3714 21.771 66.4152 19.5276C66.4932 16.1136 64.4076 13.1322 60.8292 12.8856C59.9934 10.0266 58.2774 7.38721 55.5492 6.06721C49.4292 3.06181 38.883 6.55321 35.403 14.601C33.8634 18.12 33.6 22.2552 29.9922 24.4104C27.573 25.8618 25.1094 26.1258 22.4262 26.5656C22.3386 26.5656 22.3386 26.7414 22.4262 26.7414C23.3747 26.9911 24.3676 27.0213 25.3296 26.8296C27.1406 26.5532 28.8761 25.9096 30.4296 24.9384C28.4038 26.8992 25.7252 28.0427 22.908 28.1496C22.8565 28.1529 22.8065 28.1678 22.7616 28.193C22.7166 28.2183 22.678 28.2533 22.6484 28.2956C22.6189 28.3378 22.5992 28.3861 22.5908 28.437C22.5825 28.4879 22.5857 28.5399 22.6002 28.5894C23.0555 31.074 24.183 33.3863 25.86 35.2752C28.9392 38.8386 33.6456 40.0698 38.0004 38.1348C38.0463 38.1107 38.086 38.0763 38.1164 38.0343C38.1467 37.9923 38.167 37.9438 38.1755 37.8927C38.1841 37.8416 38.1807 37.7892 38.1656 37.7396C38.1505 37.69 38.1241 37.6445 38.0886 37.6068C36.5928 35.979 36.417 33.516 36.3732 31.4046C36.4565 27.875 37.3122 24.4064 38.88 21.243C39.9558 22.1394 41.5164 21.663 42.0036 23.0028C42.0912 23.2224 42.2232 23.5746 42.531 23.3988C42.8388 23.223 42.6192 22.6068 42.4872 22.3428C42.3014 21.959 41.9914 21.649 41.6076 21.4632C40.86 21.0672 39.804 21.243 39.1884 20.5836C39.408 20.1438 39.672 19.7034 39.8922 19.2636C44.8122 20.0508 48.3216 18.7464 52.3404 15.8328C53.2644 15.129 54.1878 14.4252 55.068 13.6776C54.9798 13.7214 54.7596 15.261 54.1878 16.1406C53.0022 18.0759 51.2737 19.62 49.2174 20.5806C48.9096 20.7126 49.0854 21.1962 49.3932 21.1962C52.3688 21.1795 55.2797 20.326 57.7932 18.7332C57.8814 18.6888 57.969 18.6012 58.0572 18.5568C56.8254 20.1846 55.4172 21.5922 53.3502 22.0758C53.2846 22.0896 53.2258 22.1256 53.1836 22.1777C53.1414 22.2297 53.1183 22.2947 53.1183 22.3617C53.1183 22.4287 53.1414 22.4937 53.1836 22.5458C53.2258 22.5978 53.2846 22.6338 53.3502 22.6476C56.0334 22.9998 57.9252 21.1524 58.4532 20.7564C57.5094 25.4196 52.56 28.5738 52.56 33.6918C53.9238 32.9562 63.8568 29.9232 64.92 29.601Z",
      className: "fill-surface-common-secondary"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M74.0861 88.3074C74.1412 88.3212 74.1993 88.3534 74.2394 88.409C74.2818 88.4678 74.2953 88.5414 74.2765 88.618L74.2755 88.6238C73.4065 91.5873 72.6874 94.5927 72.1222 97.6287C71.8617 99.1295 71.7335 100.207 71.6359 101.1C71.5388 101.989 71.4709 102.702 71.3322 103.467C71.3328 103.501 71.3282 103.536 71.3165 103.568C71.3024 103.608 71.2798 103.644 71.2501 103.674C71.2426 103.681 71.233 103.687 71.2247 103.693C71.2354 103.738 71.2386 103.784 71.2325 103.826C71.2246 103.881 71.2054 103.937 71.174 103.985C71.1437 104.032 71.097 104.076 71.0333 104.099C69.9484 104.533 68.4131 104.908 66.7081 105.245C65.0012 105.583 63.116 105.886 61.3302 106.176H61.3292C47.1769 108.32 32.75 107.307 26.1808 105.689L26.1681 105.686L26.1564 105.68C26.1048 105.656 26.0628 105.615 26.0363 105.564C26.0097 105.513 26.0005 105.455 26.0099 105.398C26.0193 105.342 26.0467 105.29 26.088 105.251C26.1296 105.211 26.1834 105.186 26.2404 105.18L26.2521 105.178L26.2648 105.179C30.2802 105.505 40.0703 107.178 53.6036 106.059C57.967 105.698 62.3074 105.097 66.6046 104.259L67.1447 104.132C68.3239 103.865 69.5176 103.666 70.7198 103.535C70.7052 103.503 70.6946 103.469 70.6886 103.433L70.6866 103.422V103.421C70.5734 101.945 70.8476 99.6465 71.2638 97.3563C71.6806 95.0623 72.2433 92.7619 72.7159 91.2781C73.0257 90.3061 73.4248 89.3735 73.7745 88.4559C73.8277 88.3058 73.9894 88.2833 74.0861 88.3074Z",
      className: "fill-surface-common-secondary stroke-surface-common-secondary stroke-[0.25]"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M26.7736 57.7604C26.8658 57.7374 26.9467 57.7803 26.9973 57.8473C27.0204 57.878 27.0391 57.9145 27.0529 57.9557L27.0822 58.0924V58.0963C27.2901 60.453 27.1849 62.8263 26.7697 65.154C27.3864 64.4446 28.0362 63.7641 28.7199 63.1188C28.7867 63.0522 28.8644 63.0015 28.9494 62.9967C29.05 62.9911 29.1229 63.0507 29.1584 63.1247C29.1909 63.1925 29.1955 63.2737 29.1828 63.3493C29.1698 63.427 29.1372 63.5097 29.0851 63.5876L29.0842 63.5895C28.729 64.0996 28.0876 64.906 27.5275 65.6032C27.2467 65.9527 26.9856 66.2747 26.7892 66.5211C26.6911 66.6443 26.6095 66.7479 26.55 66.8258C26.5202 66.8648 26.497 66.8972 26.4797 66.9215C26.471 66.9337 26.464 66.9434 26.4592 66.9508C26.4582 66.9524 26.457 66.9536 26.4562 66.9547C26.1179 67.9692 25.8835 69.0649 25.6066 70.0963C25.3312 71.1224 25.0143 72.0835 24.508 72.7848L24.4943 72.8004C24.4739 72.8207 24.4562 72.84 24.4299 72.8678C24.4061 72.8929 24.3775 72.9226 24.3449 72.9479C24.2813 72.9972 24.1906 73.0379 24.0793 73.0085C24.0263 73.0032 23.9839 72.9795 23.9572 72.9596C23.9265 72.9367 23.8978 72.9083 23.8771 72.8874L23.8693 72.8786L23.8625 72.8688C23.6997 72.6245 23.7257 72.3482 23.8117 72.0534C23.855 71.9049 23.9162 71.7434 23.9836 71.57C24.0515 71.3952 24.1262 71.2063 24.2004 70.9977C25.6326 66.8599 26.4171 62.5254 26.5256 58.1481V58.1413L26.5266 58.1335C26.5393 58.0439 26.566 57.9641 26.6037 57.901C26.6394 57.8412 26.695 57.7801 26.7736 57.7604Z",
      className: "fill-surface-common-secondary stroke-surface-common-secondary stroke-[0.25]"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M84.0096 40.7736C83.8012 39.8775 83.4601 39.0176 82.9974 38.2224C82.602 37.6068 81.1056 37.167 80.4462 36.9468C79.1541 36.4699 77.8108 36.1451 76.4436 35.979C75.696 35.8914 74.7276 35.8032 74.112 36.4188C73.3644 37.1226 73.5846 38.5302 73.6722 39.4542C73.8042 41.6538 74.4642 45.0846 76.2672 46.5342C79.215 48.8658 82.7772 43.983 83.9652 41.7396C84.0697 41.428 84.0851 41.0935 84.0096 40.7736Z",
      className: "fill-surface-common-icon-color"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M86.6489 37.2546C86.7755 39.4986 88.8479 40.686 90.7397 41.3454C92.1473 41.7852 95.9303 43.0614 96.8099 41.2578C97.3379 40.158 97.0301 38.5302 96.8537 37.3428C96.5897 35.4954 96.0617 32.7678 94.5221 31.4922C92.7221 30.0408 90.4319 31.6242 89.1119 32.988C88.1003 34.0434 86.5571 35.6274 86.6489 37.2546Z",
      className: "fill-surface-common-icon-color"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M87.396 40.422C86.6568 39.5477 86.1434 38.5055 85.9008 37.3866C85.9008 37.2984 85.8564 37.2108 85.8564 37.1226C85.725 37.1226 83.5698 37.7826 83.6574 37.9146C83.6574 37.9578 83.6376 37.5546 84.7128 41.2146C84.9768 41.1258 87.396 40.422 87.396 40.422Z",
      className: "fill-surface-common-icon-color"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M99.3118 19.7928C100.351 19.6533 101.397 19.7291 102.331 20.3456C103.716 21.257 104.403 22.8888 104.905 24.3964L105.111 25.0331L107.055 31.2557C107.292 31.1967 107.532 31.1454 107.773 31.1044L108.053 31.0614C108.1 31.0495 108.147 31.0479 108.194 31.0634C108.246 31.0811 108.284 31.1155 108.31 31.1512C108.347 31.204 108.36 31.2672 108.366 31.3202C108.366 31.3221 108.368 31.3235 108.368 31.3251C108.372 31.3348 108.376 31.3459 108.379 31.3563C108.386 31.3777 108.393 31.4058 108.401 31.4384C108.417 31.5041 108.437 31.5946 108.459 31.701C108.503 31.9141 108.554 32.1956 108.596 32.4813C108.638 32.7662 108.67 33.0597 108.675 33.2948C108.678 33.4115 108.673 33.5191 108.658 33.6063C108.65 33.65 108.639 33.6933 108.622 33.7313C108.606 33.7683 108.58 33.8105 108.536 33.8397L108.527 33.8466L108.517 33.8505C108.324 33.9354 108.123 34.0005 107.918 34.0487C108.127 34.7972 108.335 35.5363 108.543 36.2704L109.203 38.5848L109.204 38.5897C109.236 38.7182 109.217 38.8539 109.151 38.9686C109.085 39.0835 108.976 39.1686 108.849 39.2059C108.722 39.2431 108.586 39.2296 108.468 39.1688C108.35 39.1081 108.26 39.0049 108.217 38.8798L108.214 38.869C108.046 38.1962 107.719 37.0866 107.427 36.1161C107.188 35.3206 106.972 34.6136 106.887 34.328C106.088 34.5567 105.067 34.793 103.682 35.1415C102.224 35.5083 100.356 36.0037 97.9026 36.7587L97.7591 36.8036L97.7415 36.6542C97.6553 35.9295 97.4956 35.2154 97.264 34.5233V34.5223C97.2402 34.4705 97.2267 34.421 97.2171 34.3827C97.2057 34.3371 97.1968 34.306 97.1819 34.2762L97.1175 34.1473L97.2552 34.1014C100.153 33.1485 103.065 32.1502 106.017 31.4882C105.444 29.819 105.002 28.2718 104.597 26.9042C104.18 25.4976 103.801 24.2846 103.354 23.3153C102.906 22.346 102.397 21.6354 101.727 21.2177C101.061 20.8025 100.218 20.6642 99.0794 20.8807C96.717 21.3817 89.0222 23.7483 82.2298 25.7684C82.5509 26.8134 84.6287 33.4604 85.7542 36.4628L85.8167 36.6317H85.637C85.5451 36.6317 85.3843 36.6706 85.1761 36.7411C84.9731 36.8098 84.74 36.9034 84.5091 37.0009C84.2782 37.0983 84.0512 37.1986 83.8616 37.2821C83.6756 37.3641 83.519 37.4334 83.4339 37.4618L83.3284 37.4969L83.2806 37.3964C81.989 34.669 80.7881 32.1134 78.097 26.9803C76.9995 27.3394 67.8296 30.2625 58.4476 33.2557C49.8057 36.0129 40.9813 38.8319 38.1009 39.7733L37.2484 40.0555C34.8657 40.8943 33.8102 41.271 33.0374 42.1698L33.0384 42.1708C32.4136 42.9609 32.08 43.9429 32.095 44.9501V44.951C32.108 46.113 32.3438 47.2617 32.7894 48.3348L32.7913 48.3387C33.0557 49.0435 33.4957 50.2657 33.886 51.3485C34.2236 52.285 34.5239 53.1114 34.6409 53.4178C34.6567 53.4129 34.6737 53.4079 34.6917 53.4022C34.8891 53.3396 35.2232 53.2337 35.6751 53.0907C36.5794 52.8044 37.9562 52.3686 39.6556 51.8319C43.0543 50.7585 47.7452 49.2798 52.5355 47.7772C57.3258 46.2747 62.2163 44.748 66.013 43.58C67.9112 42.996 69.5366 42.5017 70.7396 42.1444C71.9368 41.7888 72.7273 41.5656 72.9456 41.5292L73.0911 41.5048V41.6483C73.0919 41.6532 73.0931 41.6606 73.095 41.6708C73.099 41.6912 73.1048 41.7198 73.1126 41.7557C73.1283 41.8275 73.1513 41.9262 73.179 42.0438C73.2345 42.2789 73.3104 42.5875 73.39 42.9032C73.4696 43.219 73.5525 43.5414 73.6243 43.8036C73.6974 44.0702 73.7557 44.2637 73.7845 44.3309L73.8411 44.4618L73.7034 44.5009C59.918 48.3778 49.2428 51.5242 35.6937 56.3319C35.9394 56.9954 37.1036 60.0109 37.6702 61.3065C37.7141 61.3873 37.7213 61.4726 37.6937 61.5497C37.6658 61.6274 37.6072 61.6855 37.5433 61.7196C37.4797 61.7535 37.3999 61.7696 37.3216 61.7499C37.2406 61.7294 37.1732 61.6724 37.136 61.5858L37.1351 61.5868C36.5233 60.3249 35.1964 57.3227 34.8968 56.6024C34.8882 56.607 34.8796 56.6123 34.8704 56.6171C34.8055 56.6509 34.7217 56.6921 34.6321 56.7177C34.543 56.7431 34.437 56.7567 34.3314 56.7255C34.2214 56.693 34.1285 56.6163 34.0599 56.493L34.0589 56.4911C33.878 56.1514 33.7535 55.7899 33.6282 55.4413C33.5018 55.0893 33.3729 54.7478 33.1819 54.4296V54.4286C33.1039 54.3091 33.0796 54.1897 33.1146 54.078C33.1481 53.9708 33.2281 53.8964 33.303 53.8475C33.3794 53.7977 33.4645 53.7645 33.5306 53.744V53.743C33.083 52.0337 32.5524 50.3468 31.9398 48.6893V48.6884C31.1916 46.6183 30.5982 44.1489 31.8626 42.0712C32.6346 40.7545 33.9949 40.1708 35.3128 39.6874C35.7979 39.4968 45.8142 36.2569 55.9984 32.9774C65.8162 29.8158 75.8045 26.6139 77.5941 26.0594C77.5637 25.9933 77.5334 25.9125 77.5091 25.83C77.4802 25.7318 77.4563 25.625 77.4456 25.5321C77.4403 25.4859 77.4378 25.4394 77.4407 25.3973C77.4435 25.359 77.4516 25.3073 77.4808 25.2635L77.5276 25.2118C77.5449 25.1968 77.5635 25.1838 77.5804 25.1727C77.6176 25.1484 77.6631 25.1233 77.7142 25.0985C77.8168 25.0487 77.9511 24.9933 78.1058 24.9354C78.4156 24.8194 78.8171 24.6887 79.2298 24.5594C80.0613 24.299 80.9325 24.0485 81.2376 23.9393L81.2405 23.9384C81.403 23.8844 81.5464 23.9007 81.6624 23.9784C81.7714 24.0515 81.8398 24.1685 81.8851 24.2802C81.9449 24.4279 81.9756 24.6059 81.9954 24.7323C84.6565 23.9278 93.9534 21.1988 96.2894 20.5497L97.012 20.3407C97.7512 20.1237 98.5358 19.897 99.3118 19.7928Z",
      className: "fill-surface-common-icon-color stroke-surface-common-icon-color stroke-[0.25]"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M86.6928 41.4336C86.1142 41.661 85.5075 41.809 84.8892 41.8734C83.2614 45.2166 82.1616 48.8676 80.754 52.2984C80.4462 53.0904 82.9536 52.0788 83.5692 51.111C83.7068 52.3888 84.0486 53.6362 84.5814 54.8058C84.7134 55.1136 85.0212 55.6854 85.197 55.0698C85.8366 52.1106 86.7438 40.6998 86.6928 41.4336Z",
      className: "fill-surface-common-icon-color"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M87.3522 41.1696C87.0981 41.8891 87.0375 42.6627 87.1764 43.413C89.112 46.6242 91.3554 49.7472 93.1164 53.0904C93.2484 53.3544 93.7764 53.2662 93.7326 52.9146C93.6882 52.6062 93.5562 49.1754 93.3804 49.1316C94.3493 49.4242 95.3708 49.4992 96.372 49.3512C96.4325 49.332 96.4872 49.2982 96.5314 49.2527C96.5756 49.2073 96.6078 49.1516 96.6252 49.0906C96.6426 49.0296 96.6447 48.9653 96.6312 48.9034C96.6177 48.8414 96.589 48.7838 96.5478 48.7356C93.9522 46.536 91.5768 44.0286 88.938 41.9172C88.674 41.6976 87.8382 40.8618 87.354 41.1696H87.3522Z",
      className: "fill-surface-common-icon-color"
    }
  )
] }), YCe = Ar()(Ghe), Khe = (e) => /* @__PURE__ */ F(
  "svg",
  {
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          d: "M57.3258 285.836C58.1117 285.45 58.7118 285.402 59.1057 285.808C59.8298 286.55 59.3778 287.116 57.4797 289.086C55.4998 290.846 36.1357 307.59 33.9417 306.1C33.5437 305.256 34.5297 304.034 35.8957 302.816C36.0977 302.636 57.1237 285.936 57.3237 285.838L57.3258 285.836Z",
          className: "fill-surface-common-icon-color"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M131.016 318.208C115.264 335.284 114.028 334.952 115.116 336.31C116.916 338.558 123.724 330.328 125.092 329.556C127.45 326.782 130.722 323.384 134.194 319.822C133.256 319.342 132.192 318.802 131.016 318.208Z",
          className: "fill-surface-common-icon-color"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M140.7 323.228C128.576 336.876 123.434 339.74 125.908 341.316C127.548 342.358 135.242 334.572 143.854 324.88C142.848 324.36 141.802 323.808 140.7 323.228Z",
          className: "fill-surface-common-icon-color"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M121.34 313.364C116.464 318.2 112.908 321.738 112.602 322.062C104.894 330.236 104.326 329.78 104.718 331.386C106.688 333.546 110.74 327.658 113.156 326.012C115.17 324.048 119.348 319.856 124.31 314.848L121.34 313.364Z",
          className: "fill-surface-common-icon-color"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M40.7479 309.444C40.1659 308.172 45.5819 304.628 47.4319 303.436C48.5419 302.72 50.9859 302.94 48.6699 305.004C46.4139 307.016 41.6339 311.38 40.7479 309.444Z",
          className: "fill-surface-common-icon-color"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M102.636 304.09C103.072 312.002 99.5038 320.482 90.3758 323.412C89.2918 323.76 89.0238 323.63 88.8738 322.44C86.4638 303.428 84.7298 308.446 90.6358 298.162L88.5418 297.128C87.5758 298.862 86.4817 300.97 85.2717 303.54C84.3857 305.422 85.0278 304.56 67.8038 301.536C65.3318 301.102 68.5597 294.552 75.0057 290.444L72.8578 289.382C64.2158 295.232 60.1738 306.894 69.4838 319.984C82.5838 332.49 101.808 325.492 104.71 309.008C104.82 309.018 104.98 307.472 104.836 305.176L102.636 304.09ZM85.1358 324.354C75.4678 324.758 65.2258 316.536 66.1218 304.73C66.2838 302.602 65.6597 303.438 82.9937 306.484C85.5357 306.932 83.9278 307.904 87.0278 322.056C87.5058 324.238 87.4318 324.258 85.1378 324.352L85.1358 324.354Z",
          className: "fill-surface-common-icon-color"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M176.752 329.88L158.078 347.816C144.29 361.086 146.018 359.126 142.04 357.27C137.928 355.352 102.612 342.55 101.966 341.644C81.99 333.396 57.674 326.492 48.758 320.906C36.066 314.936 22.164 311.048 16.6319 307.042C14.9879 305.852 16.3719 306.176 27.882 298.076C28.474 297.464 40.476 289.17 53.892 279.848C52.8 279.154 51.782 278.538 50.83 277.978C39.696 285.956 27.21 294.92 14.6099 303.646C6.4059 309.328 28.158 315.056 42.936 321.288C49.524 324.068 55.878 327.362 62.516 330.038C71.104 333.502 79.964 336.206 88.624 339.464C147.458 361.604 144.054 363.354 147.758 360.796C151.926 357.918 164.826 344.644 180.354 329.034C178.878 329.408 177.892 329.632 176.748 329.88H176.752Z",
          className: "fill-surface-common-icon-color"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M169.11 279.136C170.198 279.84 171.708 280.564 171.62 281.9C171.526 283.36 169.766 283.146 168.686 283.394C165.026 284.234 137.558 290.232 132.44 291.206C129.278 291.808 127.698 289.452 114.584 283.662C113.822 283.326 112.684 283.006 112.796 281.89C112.952 280.352 112.652 280.916 155.404 272.358C158.212 271.796 158.518 272.278 169.11 279.136Z",
          className: "fill-surface-common-secondary"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M182.64 299.186C181.11 299.332 180.524 299.156 170.486 292.594C164.938 288.968 175.11 289.114 206.258 280.808C212.854 279.05 213.952 281.6 221.77 286.53C222.604 287.056 223.236 287.744 223.134 288.65C223.006 289.78 223.268 289.172 182.642 299.188L182.64 299.186Z",
          className: "fill-surface-common-secondary"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M132.148 271.332C130.67 271.226 130.436 270.896 118.028 263.23C113.548 260.462 119.202 261.13 152.154 255.084C156.014 254.376 157.924 256.144 166.902 261.692C172.636 265.234 164.634 265.222 132.148 271.332Z",
          className: "fill-surface-common-secondary"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M180.572 280.638C178.136 280.594 177.14 279.706 166.436 272.01C162.592 269.246 173.894 269.83 198.81 263.656C203.788 262.422 204.558 264.294 214.8 270.504C219.358 273.268 211.9 274.042 180.572 280.638Z",
          className: "fill-surface-common-secondary"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M301.756 270.284C300.254 270.308 299.754 270.074 290.076 264.538C289.55 264.238 287.826 263.024 288.076 262.224C288.356 261.326 288.004 261.766 315.318 255.44C326.038 252.958 323.21 252.498 330.49 254.704C338.094 257.008 346.646 259.42 338.968 261.284C301.77 270.306 303.646 269.88 301.756 270.284Z",
          className: "fill-surface-common-secondary"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M315.634 278.298C372.204 263.542 370.288 263.218 370.68 265.318C370.996 267.006 204.24 309.688 180.22 314.956C178.472 315.34 177.672 314.52 179.864 313.876C190.374 310.79 229.946 300.65 315.634 278.298Z",
          className: "fill-surface-common-secondary"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M251.746 249.422C250.322 249.516 241.92 244.816 239.528 242.858C237.298 241.034 240.378 240.224 243.224 239.794C270.234 235.706 271.624 233.766 277.592 236.414C283.412 238.996 289.898 239.822 289.896 241.34C289.894 243.36 264.728 246.768 251.746 249.422Z",
          className: "fill-surface-common-secondary"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M265.304 252.66C261.188 250.236 264.958 250.81 298.466 244.044C301.34 243.464 307.648 246.786 313.376 248.758C318.338 250.464 305.08 252.718 280.476 258.504C277.064 259.306 277.448 259.814 265.304 252.66Z",
          className: "fill-surface-common-secondary"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M253.486 272.22C249.936 269.966 253.878 269.476 278.966 264.036C281.28 263.534 282.334 264.59 292.69 270.608C296.276 272.692 289.652 272.906 267.192 278.67C263.436 279.634 262.048 277.656 253.488 272.222L253.486 272.22Z",
          className: "fill-surface-common-secondary"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M178.942 262.818C175.894 261.932 168.282 256.792 165.72 255.02C162.58 252.85 165.09 252.876 190.354 248.742C195.24 247.942 196.16 249.338 204.648 255.614C206.118 256.702 205.818 257.856 204.09 258.172C178.98 262.782 181.64 262.328 178.942 262.818Z",
          className: "fill-surface-common-secondary"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M229.206 242.25C231.29 242.254 238.952 247.96 240.98 249.398C243.764 251.372 242.682 251.266 215.682 256.002C213.808 256.33 212.312 255.536 210.78 254.666C209.554 253.97 200.844 249.102 201.07 247.726C201.306 246.282 225.256 243.084 229.206 242.25Z",
          className: "fill-surface-common-secondary"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M232.344 287.02C230.05 286.794 222.68 280.978 220.898 279.516C218.594 277.626 221.12 277.356 228.834 275.554C247.038 271.302 246.176 271.086 248.176 272.49C259.32 280.314 258.646 280.56 255.97 281.328C245.904 284.212 236.462 285.922 232.346 287.022L232.344 287.02Z",
          className: "fill-surface-common-secondary"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M105.134 263.084C108.61 262.93 110.646 264.622 121.128 270.716C122.516 271.522 121.71 273.068 120.492 273.338C111.762 275.266 103.26 276.55 102.22 276.636C101.264 276.716 100.44 276.672 99.6302 276.24C86.7182 269.368 84.3602 269.296 84.6922 267.652C84.9582 266.336 84.8182 266.496 105.134 263.084Z",
          className: "fill-surface-common-secondary"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M247.938 265.574C246.728 265.702 246.414 265.442 236.796 258.626C236.266 258.25 235.446 257.858 235.522 257.226C235.616 256.458 236.518 256.256 237.222 256.122C260.854 251.638 254.956 250.38 268.11 258.648C268.714 259.028 269.66 259.32 269.498 260.096C269.274 261.16 268.012 261.354 261.156 262.844C247.998 265.704 248.894 265.47 247.938 265.572V265.574Z",
          className: "fill-surface-common-secondary"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M157.92 304.876C156.426 304.832 147.9 300.326 146.876 299.784C145.678 299.148 144.1 298.376 144.212 296.946C144.33 295.404 146.178 295.404 147.384 295.084C162.02 291.202 161.218 291.316 163.508 292.688C174.352 299.184 174.066 299.118 173.946 299.868C173.816 300.694 173.274 301.318 172.472 301.532C167.664 302.812 162.828 303.968 157.922 304.878L157.92 304.876Z",
          className: "fill-surface-common-secondary"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M227.426 258.18C229.47 258.072 237.512 264.274 239.158 265.804C241.268 267.766 239.68 267.708 224.88 270.81C222.804 271.246 212.988 264.612 211.228 263.298C209.876 262.288 210.358 261.494 211.37 261.294C227.4 258.102 226.746 258.218 227.426 258.182V258.18Z",
          className: "fill-surface-common-secondary"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M156.594 315.778C151.174 313.378 121.55 299.03 121.302 298.836C119.97 297.796 120.702 295.126 122.904 296.202C127.99 298.69 132.644 300.906 156.28 312.734C159.55 314.37 158.602 316.086 156.594 315.778Z",
          className: "fill-surface-common-secondary"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M83.8663 280.528C81.4463 279.3 77.9243 274.394 88.0263 279.246C101.026 285.49 101.46 285.45 101.224 287.028C100.824 289.7 97.4043 287.392 83.8663 280.528Z",
          className: "fill-surface-common-secondary"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M228.568 71.2356C228.602 71.3836 228.634 71.5316 228.668 71.6796C244.594 76.5136 245.786 90.4256 251.926 120.126L254.926 116.908C248.166 94.7436 249.716 76.6636 232.444 69.3896C231.314 69.9796 230.002 70.5736 228.57 71.2356H228.568Z",
          className: "fill-surface-common-secondary"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M279.686 224.634C280.566 219.66 267.418 170.729 259.936 140.349L257.29 143.599C277.426 222.824 278.394 223.444 272.432 224.764C263.636 226.71 73.6922 254 48.8982 262.256C44.3302 263.778 45.3762 266.82 44.7262 265.194C40.8402 255.462 22.3262 135.733 22.5082 134.333C12.5281 77.6152 11.9941 84.0592 42.3922 81.6672C42.4322 81.6552 75.9502 79.9352 75.9882 79.9432C90.4362 78.6992 128.384 76.5512 144.532 74.8672C144.806 73.8032 145.122 72.7472 145.476 71.7012C122.866 74.0492 95.6442 76.5312 62.9322 77.8552C9.53011 80.0172 10.6341 75.3632 15.7021 113.199C17.5961 127.339 28.5802 198.089 28.5882 198.129C43.5982 280.136 35.1622 264.512 55.6562 277.684C57.0682 278.592 130.934 314.958 130.97 314.996C168.082 334.158 154.386 334.432 235.314 311.312C235.354 311.3 380.218 273.256 384.038 270.666C407.278 254.9 278.706 230.17 279.686 224.634ZM360.766 273.184C207.852 313.134 181.088 322.526 164.714 324.296C159.914 324.562 147.764 318.476 143.482 316.338C49.9942 269.656 44.3562 268.858 50.8982 264.736C56.3862 261.276 177.128 245.044 267.234 229.498C279.808 227.33 271.586 227.124 329.92 245.224C332.482 246.018 369.72 258.694 375.798 261.118C391.392 267.338 375.162 269.426 360.77 273.186L360.766 273.184Z",
          className: "fill-surface-common-secondary"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M240.366 132.499C235.936 111.487 231.854 92.5814 230.072 85.6534C229.97 89.0474 229.532 92.2734 228.796 95.3194C231.102 107.533 233.938 121.847 236.856 136.249L240.366 132.499Z",
          className: "fill-surface-common-secondary"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M256.408 209.444C256.314 209.328 251.354 185.128 245.688 157.922L242.188 162.258C247.808 189.366 252.684 212.04 253.384 214.88C252.786 215.086 58.9882 245.544 58.5862 243.72C56.2642 233.2 37.4602 108.998 36.9502 101.484C36.9422 101.46 92.6802 96.9162 143.798 92.7542C143.612 91.7582 143.466 90.7542 143.36 89.7442C92.6662 93.8622 38.2242 98.2902 37.6922 98.2302C35.0082 98.7442 32.9882 97.3462 33.5902 102.09C37.8662 135.714 56.5742 246.854 56.2662 246.912C58.4222 248.47 253.6 217.732 253.64 217.728C258.86 217.2 257.946 216.34 256.408 209.444Z",
          className: "fill-surface-common-secondary"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M204.55 190.958C203.63 190.334 202.702 189.716 201.766 189.098C204.196 206.63 206.778 223.224 207.674 223.136C208.722 223.034 208.848 222.906 208.572 220.806C208.556 220.684 206.644 206.388 204.55 190.958Z",
          className: "fill-surface-common-icon-color"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M200.004 158.116C198.442 147.372 198.04 150.034 206.536 141.618L209.882 164.82C210.47 164.21 211.122 163.53 211.834 162.788L208.564 141.622C208.192 139.234 209.03 140.224 228.746 136.34C229.282 136.234 229.942 138.698 230.682 142.832L232.624 140.762C232.438 139.222 232.292 137.92 232.194 136.898C231.632 135.992 232.246 134.462 230.696 134.082C225.872 134.798 221.428 135.988 216.604 136.51C206.244 138.84 207.416 137.38 196.74 148.826C196.722 149.248 197 151.9 197.48 155.968C198.324 156.58 199.17 157.314 200.006 158.114L200.004 158.116Z",
          className: "fill-surface-common-icon-color"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M216.246 192.76C215.448 193.444 214.742 193.954 214.1 194.314C218.408 224.518 218.046 221.782 219.086 221.56C219.694 221.43 220.146 221.296 219.968 220.698C217.848 205.374 217.22 199.978 216.246 192.76Z",
          className: "fill-surface-common-icon-color"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M234.63 171.612C237.348 193.874 240.114 218.402 241.532 218.13C242.974 217.854 239.576 192.202 236.454 169.356L234.628 171.61L234.63 171.612Z",
          className: "fill-surface-common-icon-color"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M158.462 208.99C159.246 214.888 160.126 221.646 161.106 229.396L162.734 229.146C162.728 225.35 161.77 216.782 160.544 207.352L158.462 208.99Z",
          className: "fill-surface-common-icon-color"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M156.822 180.922C155.924 174.888 155.286 170.796 155.286 170.796C154.994 169.048 154.554 170.206 163.554 160.254L165.556 174.308L167.352 172.944C166.228 164.834 165.478 159.118 165.578 158.996C166.534 157.822 182.766 155.184 183.924 155.018C185.272 154.824 185.67 154.748 186.308 158.486L187.868 157.29C187.472 155.182 187.188 153.834 187.058 153.506C185.602 152.308 168.138 155.29 163.472 157.744C156.584 165.154 155.078 166.966 154.47 167.316C152.846 168.252 152.772 168.082 154.802 182.442L156.82 180.918L156.822 180.922Z",
          className: "fill-surface-common-icon-color"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M191.88 182.588L190.018 184.062C196.184 224.008 195.36 224.112 197.384 223.804C197.672 220.044 194.888 200.354 192.13 182.756L191.88 182.588Z",
          className: "fill-surface-common-icon-color"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M169.248 200.492C171.628 217.488 172.606 224.634 173.154 227.548L175.122 227.24L171.05 199.067L169.248 200.492Z",
          className: "fill-surface-common-icon-color"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M67.584 217.23C65.142 198.024 62.14 177.41 62.136 177.386C61.87 175.634 61.404 176.794 70.404 166.842L76.46 209.502L78.288 207.942C75.282 187.122 72.2559 165.806 72.434 165.588C73.392 164.416 89.622 161.776 90.78 161.61C93.506 161.22 92.342 161.302 97.16 192.544L99.1839 190.948C96.674 174.932 94.33 161.16 93.912 160.098C92.46 158.896 74.992 161.878 70.328 164.334C63.44 171.748 61.932 173.556 61.324 173.906C58.704 175.41 60.27 174.53 65.78 218.832C66.39 218.288 66.99 217.754 67.584 217.23Z",
          className: "fill-surface-common-icon-color"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M101.714 222.77C102.746 229.826 103.47 234.762 104.06 237.98C104.606 237.896 105.156 237.818 105.708 237.734C105.342 233.804 104.604 227.928 103.666 221.136L101.714 222.77Z",
          className: "fill-surface-common-icon-color"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M110.744 216.046C112.124 225.668 113.392 233.56 114.206 236.48C114.474 236.436 114.748 236.396 115.02 236.356C115.056 233.532 114.336 226.472 113.234 217.458C112.172 216.848 111.31 216.356 110.742 216.044L110.744 216.046Z",
          className: "fill-surface-common-icon-color"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M106.576 185.07C107.312 184.556 108.03 184.144 108.744 183.898C105.946 164.056 103.236 146.098 103.088 145.118C102.822 143.364 102.352 144.526 111.356 134.574L119.482 191.124C120.326 191.868 121.178 192.604 122.036 193.34C117.798 165.53 113.04 133.736 113.38 133.32C114.338 132.146 130.568 129.502 131.726 129.338C134.518 128.94 133.228 129.038 138.468 162.606C140.246 173.994 141.664 183.502 142.812 191.436L144.62 190.09C140.614 162.368 135.846 130.33 134.858 127.832C133.406 126.63 115.942 129.612 111.276 132.066C104.388 139.476 102.882 141.288 102.274 141.638C100.124 142.878 100.46 144.426 103.546 161.728C103.768 162.976 104.998 172.84 106.576 185.07Z",
          className: "fill-surface-common-icon-color"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M146.532 218.302C148.29 231.354 148.404 231.328 150.45 231.02L148.446 216.818L146.532 218.302Z",
          className: "fill-surface-common-icon-color"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M124.39 223.802C125.474 230.486 126.074 233.402 126.516 234.642C127.12 234.548 127.73 234.456 128.342 234.366L126.922 225.178C126.122 224.752 125.268 224.288 124.39 223.802Z",
          className: "fill-surface-common-icon-color"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M258.626 318.936C248.386 319.98 199.176 330.998 198.598 331.084C196.222 331.442 198.314 330.928 188.016 336.966C186.838 337.658 187.008 338.814 188.332 339.18C192.684 340.382 197.054 341.546 201.626 340.31C205.862 339.166 223.074 336.72 257.646 329.848C258.366 329.704 259.496 329.18 259.742 329.84C261.398 334.306 237.456 335.736 238.366 338.816C238.618 339.67 239.398 339.698 240.166 339.544C267.002 334.104 259.166 334.328 263.628 327.1C265.474 324.11 263.522 318.766 258.626 318.936ZM190.906 337.666C197.118 333.416 196.324 333.432 196.652 335.804C197.144 339.366 197.388 339.362 190.906 337.666ZM199.918 338.576C198.696 338.816 199.506 338.312 198.45 333.394C202.3 332.662 246.294 323.414 248.64 322.942C251.506 322.366 251.396 322.824 251.804 326.828C252.148 330.22 252.078 328.298 199.918 338.576ZM261.552 326.306C261.184 327.65 260.504 327.254 254.964 328.306C252.774 328.722 255.044 326.866 252.746 322.186C255.066 321.81 257.202 321.52 259.314 321.09C261.37 320.672 262.152 324.114 261.552 326.306Z",
          className: "fill-surface-common-secondary"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M190.966 44.4492C193.496 44.6432 194.236 43.9212 193.55 48.2712C193.09 51.1872 186 91.7852 186 91.7852C186 91.7852 225.03 73.6672 226.29 74.0112C236.69 119.027 182.22 143.061 155.784 110.969C132.442 82.6332 154.36 41.6432 190.966 44.4492ZM224.44 78.2752C224.262 77.0692 223.89 76.9112 222.728 77.4652C178.976 98.2732 182.332 98.5572 184.26 87.3072C189.514 56.6332 191.662 47.0412 189.87 47.0712C162.058 47.5412 147.114 68.2992 149.062 88.2312C151.16 109.709 169.626 124.881 191.096 122.769C210.854 120.825 228.012 102.575 224.44 78.2752Z",
          className: "fill-surface-common-icon-color"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M207.842 77.8676C179.496 91.3336 188.858 91.9956 200.266 40.0116C200.574 38.6076 201.258 38.0936 202.812 38.4216C217.328 41.4956 227.574 49.7416 233.486 63.3836C234.684 66.1476 234.5 65.2016 207.842 77.8676Z",
          className: "fill-surface-common-icon-color"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M96.578 107.022C97.764 107.318 105.558 105.152 107.008 107.418C106.676 110.684 100.508 109.558 69.486 112.348C61.882 112.376 42.932 114.744 45.992 110.506C52.86 110.234 96.54 107.03 96.578 107.022Z",
          className: "fill-surface-common-icon-color"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M104.858 118.002C102.162 119.476 76.4918 120.548 74.9018 121.074C70.0778 120.872 64.0278 121.864 66.3978 119.224C68.5338 118.782 99.6458 115.168 104.882 115.95C105.388 116.566 105.534 117.266 104.858 118.002Z",
          className: "fill-surface-common-icon-color"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M59.728 134.034C57.15 134.21 49.17 135.172 48.748 133.144C48.364 131.302 52.666 132.052 57.256 131.36C59.324 131.368 60.134 130.524 72.284 130.704C74.728 130.74 74.304 131.716 74.126 132.404C69.99 134.176 70.344 133.312 59.728 134.034Z",
          className: "fill-surface-common-icon-color"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M113.204 105.788C114.248 105.82 121.338 104.812 130.866 105.194C131.858 105.586 131.554 105.514 131.594 105.474C135.172 110.448 120.202 107.834 117.542 108.582C114.552 108.452 112.244 108.602 112.058 107.15C111.956 106.356 112.64 106.092 113.204 105.788Z",
          className: "fill-surface-common-icon-color"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M83.2098 131.954C80.9318 131.906 79.8318 131.828 79.9158 130.724C80.0598 128.834 84.6798 129.772 88.7578 128.96C89.5058 129.43 93.4518 127.984 94.9778 129.336C95.7058 132.298 86.2618 132.016 83.2098 131.954Z",
          className: "fill-surface-common-icon-color"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M48.586 119.812C53.608 120.062 57.85 118.578 60.954 119.238C64.006 121.318 55.834 122.502 52.14 122.586C45.83 122.732 45.48 120.162 48.586 119.812Z",
          className: "fill-surface-common-icon-color"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M291.78 101.696C282.542 123.86 283.034 124.566 278.978 121.87C275.19 119.352 274.852 117.798 273.68 119.212C215.76 189.162 214.798 194.792 209.86 191.268C204.336 187.326 198.556 183.768 192.942 179.968C192.044 179.36 191.482 179.374 190.636 180.048C188.072 182.09 137.664 221.95 133.704 224.434C131.628 225.738 130.9 224.054 125.918 221.398C111.446 213.68 110.496 211.824 108.86 213.19C92.032 227.232 81.99 235.668 77.498 239.602C75.062 239.874 60.584 242.092 59.35 242.464C59.256 241.76 58.152 230.19 58.092 229.496C71.634 217.128 85.216 205.318 99.73 194.056C109.204 186.706 109.56 185.254 111.434 187.26C116.618 192.804 122.632 197.428 128.234 202.506C129.36 203.526 130.172 203.758 131.602 202.814C143.126 195.212 192.358 157.332 192.398 157.3L194.13 157.036C200.396 160.674 206.79 171.74 209.166 169.498C212.606 166.254 261.842 113.744 265.514 109.564C266.112 108.884 266.15 108.438 265.514 107.762C263.872 106.018 262.584 103.964 260.58 102.538C259.484 101.76 259.754 100.692 261.174 100.114C267.282 97.624 262.072 100.958 287.554 89.442C301.946 82.938 297.248 88.58 291.78 101.696Z",
          className: "fill-surface-common-icon-color"
        }
      )
    ]
  }
), XCe = Ar()(Khe), Yhe = (e) => /* @__PURE__ */ F("svg", { viewBox: "0 0 104 87", fill: "none", ...e, children: [
  /* @__PURE__ */ d(
    "path",
    {
      className: "fill-surface-common-icon-color",
      d: "M67.408 22.897C54.8 16.322 34.784 5.887 24.298.813c-3.578-1.729-7.004-.6-8.705 2.427-.6 1.061-1.407 2.252-3.247 5.63-2.25 4.13-2.904 5.728-5.84 11.429-1.734 3.365-4.006 7.64-5.071 10.07-1.587 3.618-.885 6.71 2.72 8.71 8.815 4.894 24.63 12.505 37.021 18.636 3.39-7.864 10.78-3.276 21.415-10.393 3.536-6.71 6.742-12.564 7.962-15.154 1.737-3.687 1.305-6.954-3.145-9.28v.009Zm-50.11 13.542c-2.88-1.652-5.682-3.59-8.59-5.164-.588-.318.094-1.305.734-1.011 1.403.64 8.766 4.095 9.271 5.212.404.886-.628 1.416-1.415.967v-.004Zm7.285 4.254c-.881-.518-3.226-1.741-3.883-2.492-.885-1.007-.302-1.566.869-1.215a26.704 26.704 0 0 1 4.225 2.316c1.432.837.76 2.554-1.211 1.391Zm8.378-1.386c-2.309-.967-8.427-4.879-10.417-5.988-3.052-1.701-8.244-4.198-10.769-6.258a.547.547 0 0 1 .506-.954c3.071.918 8.02 3.944 10.993 5.6 1.855 1.032 9.344 4.952 10.792 6.274.76.693.172 1.86-1.109 1.325h.004Zm29.324-5.63a5.734 5.734 0 0 1-10.243.11c-6.2 1.082-9.267-5.522-4.788-9.491a6.074 6.074 0 0 1 9.181.938 5.883 5.883 0 0 1 5.85 8.452v-.008Z"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      className: "fill-surface-common-secondary",
      d: "M102.438 50.01c-13.318-1.958-22.361-7.359-34.37-3.198-5.192 1.794-9.94 4.703-15.21 6.281-2.488.747-5.302.792-7.558 2.195a5.09 5.09 0 0 0-2.3 3.56c-.551 4.675 4.833 3.847 7.754 3.66 3.724-.241 8.129-.674 11.967-.412 1.787.122 1.73-1.159.265-1.285a82.559 82.559 0 0 0-11.714.122c-1.526.09-5.197.649-6.22-.367-1.628-1.603.652-4.022 2.447-4.65 2.202-.775 4.76-1.012 7.154-1.82 4.8-1.627 9.202-4.23 13.995-5.881 5.666-1.954 10.001-1.705 15.79-.645 5.955 1.09 11.93 3.002 18.151 3.574.709.065 1.383-.906-.147-1.134h-.004Z"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      className: "fill-surface-common-secondary",
      d: "M80.277 68.948c-5.772-3.544-7.713-4.168-13.754-1.015a40.643 40.643 0 0 1-9.573 3.797c-2.542.559-5.156.69-7.738.396-8.42-1.26-24.71-5.254-31.433-9.439-1.011-.632-4.148-2.635-3.169-4.026.653-.934 2.819.135 3.614.367 6.375 1.848 16.324 3.704 22.891 3.296.58-.037.555-.95-.012-1.008-9.529-.954-12.661-.75-22.418-3.58-1.607-.466-4.226-1.592-5.294.24-1.502 2.574 2.08 4.907 3.89 5.963 7.245 4.23 21.93 7.95 30.226 9.382-5.32.91-23.499 4.054-27.272 4.703-.832.143-3.647 1.06-4.25.024-.726-1.244 2.847-2.68 3.581-3.043a54.729 54.729 0 0 1 11.213-3.858c.616-.151.44-1.204-.2-1.106a40.602 40.602 0 0 0-11.021 3.516c-1.632.767-5.001 2.007-4.96 4.23.053 3.006 4.385 1.795 6.04 1.51 3.823-.661 22.855-3.884 28.517-4.928a70.116 70.116 0 0 0-11.356 5.845c-4.148 2.627-7.836 6.682-9.186 5.026-.542-.665.392-1.706.783-2.24a28.618 28.618 0 0 1 3.206-3.426c.457-.449-.146-1.277-.701-.91a13.392 13.392 0 0 0-2.823 2.652c-1.016 1.215-2.855 3.218-1.424 4.792 1.061 1.167 2.709.898 3.916.119 2.256-1.448 4.377-3.317 6.735-4.838 4.662-3.002 10.83-6.253 16.193-7.615a61.76 61.76 0 0 0 11.356-3.753c6.175-2.998 6.865-3.985 13.134-.143C85.221 73.7 90.956 77.8 96.997 81.862c.24.163.567.102.73-.143a.53.53 0 0 0-.114-.713 153.946 153.946 0 0 0-17.344-12.062l.008.004Z"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      className: "fill-surface-common-icon-color",
      d: "M52.928 32.421a4.203 4.203 0 0 0 2.88-5.702 4.104 4.104 0 0 0-2.88 5.702Z"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      className: "fill-surface-common-icon-color",
      d: "M55.028 25.516c-2.027-2.285-5.303-2.08-7.338.142-2.92 3.186-.583 7.342 3.745 7.02a5.748 5.748 0 0 1 3.593-7.162Z"
    }
  )
] }), QCe = Ar()(Yhe), Xhe = (e) => {
  const { primaryFill: t, secondaryFill: n, ...r } = e;
  return /* @__PURE__ */ F("svg", { viewBox: "0 0 120 120", fill: "none", ...r, children: [
    /* @__PURE__ */ F("g", { "clip-path": "url(#clip0_4493_1081)", children: [
      /* @__PURE__ */ d(
        "path",
        {
          d: "M110.747 18.4172C110.747 18.4172 110.657 18.4072 110.627 18.4172C108.118 17.5441 97.6918 14.7845 94.34 14.1021C94.059 14.0419 93.758 13.9616 93.4469 13.8713C92.6039 13.6305 91.6506 13.3595 90.7675 13.6104C90.3159 13.7408 90.055 14.1523 89.6135 14.8246C88.7003 16.2095 87.0043 18.7885 81.5151 22.6019C79.7991 23.796 78.2337 24.8196 76.8488 25.7328C73.758 27.7599 71.3195 29.3555 68.9612 31.6335C63.9035 36.5206 62.0671 43.2842 62.4785 47.5993C62.4785 47.5993 62.4685 47.5993 62.4584 47.5993C61.7259 47.5993 60.7023 46.6661 60.06 46.0941L59.8092 45.8733C59.6687 45.7328 59.4479 45.7228 59.2773 45.8432C59.1067 45.9636 59.0465 46.1744 59.1569 46.3851C59.7389 47.1177 60.4012 47.8 61.1639 48.4222C61.5352 48.6129 61.9567 48.6731 62.3782 48.6731C62.7595 48.6731 63.1408 48.6229 63.5121 48.5828C63.6426 48.5627 63.773 48.5527 63.9035 48.5326C65.4489 48.372 82.5989 46.0439 86.8739 44.649C86.9742 44.6189 87.0646 44.5487 87.1147 44.4483C87.1649 44.348 87.1749 44.2476 87.1448 44.1372C87.0947 43.9767 86.9441 43.8562 86.7535 43.8562C85.479 43.9566 81.2743 44.7293 78.4946 45.2411C77.481 45.4217 76.6381 45.5823 76.1463 45.6626C72.6842 46.2546 64.9471 47.2983 63.3516 47.4789C63.5422 44.3379 63.753 42.351 65.0776 39.3003C67.8573 32.8979 73.3164 29.3856 78.5849 25.9937C83.2913 22.9631 88.1584 19.8322 90.9883 14.6741C93.6677 14.9852 101.033 16.9019 105.931 18.1764C107.897 18.6882 109.312 19.0595 109.945 19.1999C109.874 19.3304 109.804 19.4709 109.724 19.6114C108.69 21.6084 107.115 24.639 101.274 28.8136C99.9798 29.7368 98.625 30.5898 97.19 31.503C92.4434 34.5035 87.5362 37.6044 85.1679 43.1739C85.1077 43.2943 85.1177 43.4247 85.198 43.5351C85.2883 43.6656 85.4589 43.7459 85.6195 43.7258C85.76 43.7057 85.8704 43.6254 85.9206 43.495C88.2688 38.5376 92.7645 35.6877 97.5111 32.6771C101.816 29.9576 106.262 27.1377 109.463 22.5316C110.236 21.4578 110.798 20.2737 111.119 18.9792C111.169 18.7183 110.998 18.4573 110.737 18.4072L110.747 18.4172Z",
          className: n
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M119.488 62.5015C116.066 59.792 95.1731 41.0464 93.3065 39.2401L93.2764 39.21L93.2463 39.1899C92.9854 38.9692 92.6542 38.8487 92.303 38.8487C92.0622 38.8487 91.8213 38.9089 91.6106 39.0193L91.5403 39.0595L91.4801 39.1096C90.286 40.0228 89.2624 41.1267 88.4596 42.4012L88.4395 42.4313L88.4194 42.4614C88.1384 42.9832 88.2087 43.6255 88.58 44.077L88.6101 44.1172L88.6502 44.1573C89.1921 44.6992 89.3627 45.0404 89.4129 45.1909C86.1916 45.9536 63.1209 49.6164 61.7661 49.7469C61.5755 49.777 61.435 49.787 61.2945 49.787C60.9834 49.787 60.6723 49.7368 60.3713 49.6465C60.2107 49.496 59.6989 48.924 58.3141 46.9571C58.0331 46.5657 57.9829 46.0841 58.1736 45.6325C58.3642 45.1909 58.7456 44.8899 59.2273 44.8196L59.9297 44.7092C60.9834 44.5487 61.7962 43.6656 61.8665 42.6119C62.0973 38.9089 63.8635 36.5407 64.9272 35.1257L65.1078 34.8849L65.158 34.8247L65.1982 34.7544C65.5494 34.072 65.2885 33.2291 64.6061 32.8778C64.4455 32.7976 64.2649 32.7373 64.0843 32.7273H64.004H63.9237C61.9969 32.8578 54.29 33.5402 47.717 34.1322C44.2448 34.4433 40.8931 34.7544 38.4044 34.9852C35.4206 35.2595 33.8384 35.4903 33.6578 35.6776C31.5705 37.6646 1.21421 69.2853 0.290977 70.4192C-0.0201113 70.8006 -0.0903572 71.3124 0.12038 71.7439C0.321083 72.1653 0.752593 72.4363 1.21421 72.4363C1.5253 72.4363 1.81632 72.3159 2.04712 72.1051C4.28496 70.1985 29.5333 43.8362 34.4706 38.648C37.16 41.9094 44.1645 50.2787 51.3798 58.8487C55.4641 63.7057 58.9964 67.8703 61.5755 70.9109C64.7867 74.6908 66.5763 76.5808 66.9443 76.5808H67.1149C70.597 75.9687 115.574 65.8934 118.866 64.9802C119.418 64.8297 119.849 64.3781 119.96 63.8362C120.06 63.3344 119.88 62.8226 119.478 62.5116L119.488 62.5015Z",
          className: t
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M7.6065 70.0981C7.54629 69.8071 7.26531 69.6265 6.97429 69.6766C6.76355 69.7168 6.60299 69.8874 6.55281 70.1483C6.34208 73.8312 6.02095 94.2928 6.19155 103.575C6.19155 103.776 6.27183 103.967 6.41232 104.117C6.55281 104.258 6.74348 104.338 6.95422 104.338C7.37569 104.338 7.71689 103.997 7.71689 103.585C7.73696 102.431 7.93766 74.5437 7.61654 70.1483V70.0981H7.6065Z",
          className: n
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M58.3141 72.075C58.1937 71.9948 58.0532 71.9647 57.9127 71.9948C57.702 72.0349 57.5414 72.2055 57.4912 72.4664C57.2805 76.1393 56.9594 96.5908 57.13 105.893C57.13 106.094 57.2102 106.285 57.3507 106.435C57.4912 106.586 57.6819 106.656 57.8926 106.656C58.3141 106.656 58.6553 106.315 58.6553 105.903C58.7557 101.267 58.8058 84.5888 58.8058 81.0163C58.8058 77.4438 58.7255 74.9049 58.5449 72.4062C58.5148 72.2657 58.4345 72.1453 58.3141 72.065V72.075Z",
          className: n
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M111.53 70.1884C111.53 69.9275 111.34 69.7168 111.079 69.6867C110.798 69.6565 110.547 69.8372 110.467 70.1884C110.156 74.6641 109.985 92.8176 110.055 96.0288C110.055 96.2295 110.156 96.4202 110.306 96.5607C110.447 96.6912 110.627 96.7614 110.818 96.7614H110.858C111.259 96.7413 111.571 96.4302 111.591 96.0389C111.741 93.2993 112.012 75.9787 111.54 70.1984L111.53 70.1884Z",
          className: n
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M38.284 81.2772C38.0833 80.5547 37.3005 80.5246 36.8289 80.5045C36.7386 80.5045 36.6483 80.5045 36.568 80.4945C35.2935 80.364 24.9674 80.1332 23.4822 80.2838C23.2614 80.2838 23.0507 80.364 22.8901 80.5246C22.7295 80.6852 22.6392 80.8959 22.6392 81.1167C22.6392 81.488 22.8199 86.1242 23.0306 91.4829C23.2514 97.203 23.5022 103.686 23.5123 104.549C23.5123 104.81 23.733 105.081 24.2248 105.091C24.7366 105.101 24.8871 104.84 24.8871 104.609C24.9172 102.883 24.6864 95.507 24.4957 89.5763C24.3853 86.2045 24.285 82.9832 24.2749 81.9395C26.0913 81.9094 30.5369 82.0198 36.6382 82.2406L36.8891 89.9777C37.2203 100.274 37.2704 102.13 37.6116 105.04C37.6417 105.301 37.8023 105.522 38.0431 105.622C38.1335 105.663 38.2338 105.683 38.3342 105.683C38.4847 105.683 38.6252 105.643 38.7356 105.552C38.9162 105.412 39.0065 105.191 38.9764 105C38.9563 102.18 38.4746 82.1704 38.304 81.2873V81.2572L38.284 81.2772Z",
          className: n
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M104.014 75.3867C103.803 74.4233 102.599 74.6742 102.027 74.7946C101.937 74.8147 101.856 74.8347 101.796 74.8347C99.4279 75.1659 94.8118 76.1995 92.8449 76.641C92.3231 76.7615 91.9919 76.8317 91.8916 76.8518C91.5905 76.9321 91.3998 77.2532 91.4701 77.5844C91.5403 77.8854 91.8012 78.056 92.0822 78.0058C92.8047 77.9055 95.2232 77.494 97.5614 77.1027C99.5383 76.7715 101.716 76.4002 102.599 76.2697C102.579 77.9958 102.509 84.3982 102.459 85.9135C102.027 85.9938 101.124 86.1543 100.181 86.3249C97.9929 86.7163 94.7817 87.2883 92.7646 87.7098C92.7646 85.6426 92.7044 80.2136 92.5639 78.7183C92.5639 78.4072 92.3532 78.1664 92.0521 78.1363C91.721 78.0961 91.4199 78.3269 91.3497 78.6782C91.1891 79.9727 91.169 84.1473 91.149 86.907C91.149 87.6697 91.149 88.3019 91.1389 88.7033C91.1389 88.914 91.2393 89.1247 91.3898 89.2652C91.5403 89.4057 91.741 89.486 91.9518 89.486H91.9718L92.1023 89.4659C94.3401 88.9943 98.8459 88.1814 101.264 87.7499C102.117 87.5994 102.709 87.489 102.79 87.4689C103.141 87.4489 103.482 87.3084 103.743 87.0575L103.823 86.9572C104.054 86.5056 104.034 75.5071 104.014 75.4168V75.3967V75.3867Z",
          className: n
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M82.0272 79.1899C81.8164 78.2266 80.6122 78.4775 80.0402 78.5979C79.9499 78.6179 79.8696 78.638 79.8094 78.638C77.4411 78.9692 72.825 80.0028 70.8581 80.4443C70.3362 80.5648 70.0051 80.635 69.9047 80.6551C69.6037 80.7353 69.413 81.0565 69.4833 81.3876C69.5535 81.6887 69.8144 81.8593 70.0954 81.8091C70.838 81.6987 73.2364 81.2973 75.5545 80.9059C77.5314 80.5748 79.7291 80.2035 80.6022 80.063C80.5821 81.789 80.5119 88.2015 80.4617 89.7068C80.0402 89.787 79.1872 89.9376 78.2339 90.1082C76.0362 90.4995 72.7948 91.0816 70.7677 91.503C70.7677 89.4358 70.7075 84.0068 70.567 82.5116C70.567 82.2005 70.3563 81.9596 70.0553 81.9295C69.7341 81.8794 69.423 82.1202 69.3528 82.4714C69.1922 83.7559 69.1722 87.9105 69.1621 90.6601C69.1621 91.4529 69.1621 92.0951 69.1521 92.5066C69.1521 92.7173 69.2525 92.928 69.403 93.0685C69.5535 93.209 69.7442 93.2893 69.9449 93.2893H69.9649L70.1155 93.2692C72.3834 92.7976 76.9193 91.9747 79.3578 91.5331C80.1606 91.3927 80.7126 91.2923 80.7928 91.2722C81.1441 91.2522 81.4853 91.1016 81.7863 90.8207C82.1476 90.339 82.0272 79.3505 82.0071 79.2L82.0272 79.1899Z",
          className: n
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M107.938 20.3841C107.898 20.2537 107.797 20.0831 107.516 20.0128C106.834 19.8322 105.359 19.4007 103.633 18.8989C93.2764 15.8783 92.7846 15.8783 92.604 16.1694C89.6938 20.2637 84.7465 23.485 79.9597 26.6059C75.0024 29.8372 69.8644 33.1889 67.2051 37.4438C65.3185 40.4644 64.6462 43.2843 65.2081 45.8131C65.2483 45.9937 65.4189 46.1242 65.6095 46.1242C65.6296 46.1242 65.6497 46.1242 65.6597 46.1242C65.8805 46.1041 66.0511 45.9335 66.0511 45.7128C65.9306 43.1739 66.593 40.7052 67.9778 38.5678C69.8343 35.4669 74.0792 31.8141 80.592 27.7298L81.4148 27.218C85.7801 24.4885 90.2959 21.6586 93.2964 17.4238C97.5312 18.8688 101.886 20.1132 106.252 21.1167C104.395 23.3144 99.4981 26.9872 96.6281 28.8738L96.4776 28.9742C91.1389 32.4764 84.4956 36.8417 82.7495 43.194C82.6793 43.2943 82.6692 43.4147 82.7194 43.5151C82.7796 43.6455 82.9101 43.7459 83.0606 43.7459C83.2212 43.7459 83.3516 43.6455 83.4118 43.485C85.9708 37.213 91.169 33.8011 96.6883 30.1985C100.13 27.9506 103.683 25.6224 106.563 22.5216C106.593 22.4815 106.663 22.4112 106.754 22.3209C107.416 21.6285 108.058 20.9059 107.918 20.4042L107.938 20.3841Z",
          className: t
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M88.0682 28.362C86.9844 27.3384 85.3988 27.0575 84.024 27.6495C83.743 27.78 83.6327 28.1011 83.7631 28.4022C83.8936 28.7132 84.2047 28.8537 84.4856 28.7534C85.7099 28.362 86.8339 28.6029 87.3557 29.3455C87.7972 29.9877 87.6668 30.8708 87.0245 31.6736C86.3221 32.4463 85.5594 33.1789 84.7365 33.8613C84.0441 34.5135 83.4219 35.1157 82.87 35.6576C80.8429 37.6345 79.6086 38.8387 77.9929 39.2702C76.9392 39.5512 75.3035 39.4308 74.9723 38.2868C74.3903 36.2396 77.5012 33.8011 80.5117 31.4328C81.164 30.921 81.8063 30.4192 82.4184 29.9074L82.4385 29.8874C82.5589 29.7669 82.5689 29.5662 82.4585 29.4057C82.3482 29.2551 82.1675 29.1949 81.9869 29.2852C81.736 29.4558 81.4651 29.6465 81.174 29.8472C77.8524 32.1252 72.293 35.9385 73.9588 39.1197C74.5509 40.2436 75.7149 40.635 76.8088 40.635C77.0496 40.635 77.2804 40.6149 77.5012 40.5848C79.4781 40.2837 80.9131 39.1197 82.318 37.8452C83.151 37.0926 87.5363 33.0685 88.2889 32.0148C89.1219 30.9009 89.0315 29.3655 88.0682 28.352V28.362Z",
          className: t
        }
      )
    ] }),
    /* @__PURE__ */ d("defs", { children: /* @__PURE__ */ d("clipPath", { id: "clip0_4493_1081", children: /* @__PURE__ */ d(
      "rect",
      {
        width: "120",
        height: "93.156",
        fill: "white",
        transform: "translate(0 13.5)"
      }
    ) }) })
  ] });
}, JCe = Ar()(
  Xhe
), Qhe = (e) => /* @__PURE__ */ F("svg", { viewBox: "0 0 120 120", fill: "none", ...e, children: [
  /* @__PURE__ */ F("g", { "clip-path": "url(#clip0_4493_1081)", children: [
    /* @__PURE__ */ d(
      "path",
      {
        d: "M110.747 18.4172C110.747 18.4172 110.657 18.4072 110.627 18.4172C108.118 17.5441 97.6918 14.7845 94.34 14.1021C94.059 14.0419 93.758 13.9616 93.4469 13.8713C92.6039 13.6305 91.6506 13.3595 90.7675 13.6104C90.3159 13.7408 90.055 14.1523 89.6135 14.8246C88.7003 16.2095 87.0043 18.7885 81.5151 22.6019C79.7991 23.796 78.2337 24.8196 76.8488 25.7328C73.758 27.7599 71.3195 29.3555 68.9612 31.6335C63.9035 36.5206 62.0671 43.2842 62.4785 47.5993C62.4785 47.5993 62.4685 47.5993 62.4584 47.5993C61.7259 47.5993 60.7023 46.6661 60.06 46.0941L59.8092 45.8733C59.6687 45.7328 59.4479 45.7228 59.2773 45.8432C59.1067 45.9636 59.0465 46.1744 59.1569 46.3851C59.7389 47.1177 60.4012 47.8 61.1639 48.4222C61.5352 48.6129 61.9567 48.6731 62.3782 48.6731C62.7595 48.6731 63.1408 48.6229 63.5121 48.5828C63.6426 48.5627 63.773 48.5527 63.9035 48.5326C65.4489 48.372 82.5989 46.0439 86.8739 44.649C86.9742 44.6189 87.0646 44.5487 87.1147 44.4483C87.1649 44.348 87.1749 44.2476 87.1448 44.1372C87.0947 43.9767 86.9441 43.8562 86.7535 43.8562C85.479 43.9566 81.2743 44.7293 78.4946 45.2411C77.481 45.4217 76.6381 45.5823 76.1463 45.6626C72.6842 46.2546 64.9471 47.2983 63.3516 47.4789C63.5422 44.3379 63.753 42.351 65.0776 39.3003C67.8573 32.8979 73.3164 29.3856 78.5849 25.9937C83.2913 22.9631 88.1584 19.8322 90.9883 14.6741C93.6677 14.9852 101.033 16.9019 105.931 18.1764C107.897 18.6882 109.312 19.0595 109.945 19.1999C109.874 19.3304 109.804 19.4709 109.724 19.6114C108.69 21.6084 107.115 24.639 101.274 28.8136C99.9798 29.7368 98.625 30.5898 97.19 31.503C92.4434 34.5035 87.5362 37.6044 85.1679 43.1739C85.1077 43.2943 85.1177 43.4247 85.198 43.5351C85.2883 43.6656 85.4589 43.7459 85.6195 43.7258C85.76 43.7057 85.8704 43.6254 85.9206 43.495C88.2688 38.5376 92.7645 35.6877 97.5111 32.6771C101.816 29.9576 106.262 27.1377 109.463 22.5316C110.236 21.4578 110.798 20.2737 111.119 18.9792C111.169 18.7183 110.998 18.4573 110.737 18.4072L110.747 18.4172Z",
        className: "fill-[#489F91]"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        d: "M119.488 62.5015C116.066 59.792 95.1731 41.0464 93.3065 39.2401L93.2764 39.21L93.2463 39.1899C92.9854 38.9692 92.6542 38.8487 92.303 38.8487C92.0622 38.8487 91.8213 38.9089 91.6106 39.0193L91.5403 39.0595L91.4801 39.1096C90.286 40.0228 89.2624 41.1267 88.4596 42.4012L88.4395 42.4313L88.4194 42.4614C88.1384 42.9832 88.2087 43.6255 88.58 44.077L88.6101 44.1172L88.6502 44.1573C89.1921 44.6992 89.3627 45.0404 89.4129 45.1909C86.1916 45.9536 63.1209 49.6164 61.7661 49.7469C61.5755 49.777 61.435 49.787 61.2945 49.787C60.9834 49.787 60.6723 49.7368 60.3713 49.6465C60.2107 49.496 59.6989 48.924 58.3141 46.9571C58.0331 46.5657 57.9829 46.0841 58.1736 45.6325C58.3642 45.1909 58.7456 44.8899 59.2273 44.8196L59.9297 44.7092C60.9834 44.5487 61.7962 43.6656 61.8665 42.6119C62.0973 38.9089 63.8635 36.5407 64.9272 35.1257L65.1078 34.8849L65.158 34.8247L65.1982 34.7544C65.5494 34.072 65.2885 33.2291 64.6061 32.8778C64.4455 32.7976 64.2649 32.7373 64.0843 32.7273H64.004H63.9237C61.9969 32.8578 54.29 33.5402 47.717 34.1322C44.2448 34.4433 40.8931 34.7544 38.4044 34.9852C35.4206 35.2595 33.8384 35.4903 33.6578 35.6776C31.5705 37.6646 1.21421 69.2853 0.290977 70.4192C-0.0201113 70.8006 -0.0903572 71.3124 0.12038 71.7439C0.321083 72.1653 0.752593 72.4363 1.21421 72.4363C1.5253 72.4363 1.81632 72.3159 2.04712 72.1051C4.28496 70.1985 29.5333 43.8362 34.4706 38.648C37.16 41.9094 44.1645 50.2787 51.3798 58.8487C55.4641 63.7057 58.9964 67.8703 61.5755 70.9109C64.7867 74.6908 66.5763 76.5808 66.9443 76.5808H67.1149C70.597 75.9687 115.574 65.8934 118.866 64.9802C119.418 64.8297 119.849 64.3781 119.96 63.8362C120.06 63.3344 119.88 62.8226 119.478 62.5116L119.488 62.5015Z",
        className: "fill-[#489F91]"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        d: "M7.6065 70.0981C7.54629 69.8071 7.26531 69.6265 6.97429 69.6766C6.76355 69.7168 6.60299 69.8874 6.55281 70.1483C6.34208 73.8312 6.02095 94.2928 6.19155 103.575C6.19155 103.776 6.27183 103.967 6.41232 104.117C6.55281 104.258 6.74348 104.338 6.95422 104.338C7.37569 104.338 7.71689 103.997 7.71689 103.585C7.73696 102.431 7.93766 74.5437 7.61654 70.1483V70.0981H7.6065Z",
        className: "fill-[#D5E9E6]"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        d: "M58.3141 72.075C58.1937 71.9948 58.0532 71.9647 57.9127 71.9948C57.702 72.0349 57.5414 72.2055 57.4912 72.4664C57.2805 76.1393 56.9594 96.5908 57.13 105.893C57.13 106.094 57.2102 106.285 57.3507 106.435C57.4912 106.586 57.6819 106.656 57.8926 106.656C58.3141 106.656 58.6553 106.315 58.6553 105.903C58.7557 101.267 58.8058 84.5888 58.8058 81.0163C58.8058 77.4438 58.7255 74.9049 58.5449 72.4062C58.5148 72.2657 58.4345 72.1453 58.3141 72.065V72.075Z",
        className: "fill-[#D5E9E6]"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        d: "M111.53 70.1884C111.53 69.9275 111.34 69.7168 111.079 69.6867C110.798 69.6565 110.547 69.8372 110.467 70.1884C110.156 74.6641 109.985 92.8176 110.055 96.0288C110.055 96.2295 110.156 96.4202 110.306 96.5607C110.447 96.6912 110.627 96.7614 110.818 96.7614H110.858C111.259 96.7413 111.571 96.4302 111.591 96.0389C111.741 93.2993 112.012 75.9787 111.54 70.1984L111.53 70.1884Z",
        className: "fill-[#D5E9E6]"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        d: "M38.284 81.2772C38.0833 80.5547 37.3005 80.5246 36.8289 80.5045C36.7386 80.5045 36.6483 80.5045 36.568 80.4945C35.2935 80.364 24.9674 80.1332 23.4822 80.2838C23.2614 80.2838 23.0507 80.364 22.8901 80.5246C22.7295 80.6852 22.6392 80.8959 22.6392 81.1167C22.6392 81.488 22.8199 86.1242 23.0306 91.4829C23.2514 97.203 23.5022 103.686 23.5123 104.549C23.5123 104.81 23.733 105.081 24.2248 105.091C24.7366 105.101 24.8871 104.84 24.8871 104.609C24.9172 102.883 24.6864 95.507 24.4957 89.5763C24.3853 86.2045 24.285 82.9832 24.2749 81.9395C26.0913 81.9094 30.5369 82.0198 36.6382 82.2406L36.8891 89.9777C37.2203 100.274 37.2704 102.13 37.6116 105.04C37.6417 105.301 37.8023 105.522 38.0431 105.622C38.1335 105.663 38.2338 105.683 38.3342 105.683C38.4847 105.683 38.6252 105.643 38.7356 105.552C38.9162 105.412 39.0065 105.191 38.9764 105C38.9563 102.18 38.4746 82.1704 38.304 81.2873V81.2572L38.284 81.2772Z",
        className: "fill-[#D5E9E6]"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        d: "M104.014 75.3867C103.803 74.4233 102.599 74.6742 102.027 74.7946C101.937 74.8147 101.856 74.8347 101.796 74.8347C99.4279 75.1659 94.8118 76.1995 92.8449 76.641C92.3231 76.7615 91.9919 76.8317 91.8916 76.8518C91.5905 76.9321 91.3998 77.2532 91.4701 77.5844C91.5403 77.8854 91.8012 78.056 92.0822 78.0058C92.8047 77.9055 95.2232 77.494 97.5614 77.1027C99.5383 76.7715 101.716 76.4002 102.599 76.2697C102.579 77.9958 102.509 84.3982 102.459 85.9135C102.027 85.9938 101.124 86.1543 100.181 86.3249C97.9929 86.7163 94.7817 87.2883 92.7646 87.7098C92.7646 85.6426 92.7044 80.2136 92.5639 78.7183C92.5639 78.4072 92.3532 78.1664 92.0521 78.1363C91.721 78.0961 91.4199 78.3269 91.3497 78.6782C91.1891 79.9727 91.169 84.1473 91.149 86.907C91.149 87.6697 91.149 88.3019 91.1389 88.7033C91.1389 88.914 91.2393 89.1247 91.3898 89.2652C91.5403 89.4057 91.741 89.486 91.9518 89.486H91.9718L92.1023 89.4659C94.3401 88.9943 98.8459 88.1814 101.264 87.7499C102.117 87.5994 102.709 87.489 102.79 87.4689C103.141 87.4489 103.482 87.3084 103.743 87.0575L103.823 86.9572C104.054 86.5056 104.034 75.5071 104.014 75.4168V75.3967V75.3867Z",
        className: "fill-[#D5E9E6]"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        d: "M82.0272 79.1899C81.8164 78.2266 80.6122 78.4775 80.0402 78.5979C79.9499 78.6179 79.8696 78.638 79.8094 78.638C77.4411 78.9692 72.825 80.0028 70.8581 80.4443C70.3362 80.5648 70.0051 80.635 69.9047 80.6551C69.6037 80.7353 69.413 81.0565 69.4833 81.3876C69.5535 81.6887 69.8144 81.8593 70.0954 81.8091C70.838 81.6987 73.2364 81.2973 75.5545 80.9059C77.5314 80.5748 79.7291 80.2035 80.6022 80.063C80.5821 81.789 80.5119 88.2015 80.4617 89.7068C80.0402 89.787 79.1872 89.9376 78.2339 90.1082C76.0362 90.4995 72.7948 91.0816 70.7677 91.503C70.7677 89.4358 70.7075 84.0068 70.567 82.5116C70.567 82.2005 70.3563 81.9596 70.0553 81.9295C69.7341 81.8794 69.423 82.1202 69.3528 82.4714C69.1922 83.7559 69.1722 87.9105 69.1621 90.6601C69.1621 91.4529 69.1621 92.0951 69.1521 92.5066C69.1521 92.7173 69.2525 92.928 69.403 93.0685C69.5535 93.209 69.7442 93.2893 69.9449 93.2893H69.9649L70.1155 93.2692C72.3834 92.7976 76.9193 91.9747 79.3578 91.5331C80.1606 91.3927 80.7126 91.2923 80.7928 91.2722C81.1441 91.2522 81.4853 91.1016 81.7863 90.8207C82.1476 90.339 82.0272 79.3505 82.0071 79.2L82.0272 79.1899Z",
        className: "fill-[#D5E9E6]"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        d: "M107.938 20.3841C107.898 20.2537 107.797 20.0831 107.516 20.0128C106.834 19.8322 105.359 19.4007 103.633 18.8989C93.2764 15.8783 92.7846 15.8783 92.604 16.1694C89.6938 20.2637 84.7465 23.485 79.9597 26.6059C75.0024 29.8372 69.8644 33.1889 67.2051 37.4438C65.3185 40.4644 64.6462 43.2843 65.2081 45.8131C65.2483 45.9937 65.4189 46.1242 65.6095 46.1242C65.6296 46.1242 65.6497 46.1242 65.6597 46.1242C65.8805 46.1041 66.0511 45.9335 66.0511 45.7128C65.9306 43.1739 66.593 40.7052 67.9778 38.5678C69.8343 35.4669 74.0792 31.8141 80.592 27.7298L81.4148 27.218C85.7801 24.4885 90.2959 21.6586 93.2964 17.4238C97.5312 18.8688 101.886 20.1132 106.252 21.1167C104.395 23.3144 99.4981 26.9872 96.6281 28.8738L96.4776 28.9742C91.1389 32.4764 84.4956 36.8417 82.7495 43.194C82.6793 43.2943 82.6692 43.4147 82.7194 43.5151C82.7796 43.6455 82.9101 43.7459 83.0606 43.7459C83.2212 43.7459 83.3516 43.6455 83.4118 43.485C85.9708 37.213 91.169 33.8011 96.6883 30.1985C100.13 27.9506 103.683 25.6224 106.563 22.5216C106.593 22.4815 106.663 22.4112 106.754 22.3209C107.416 21.6285 108.058 20.9059 107.918 20.4042L107.938 20.3841Z",
        className: "fill-[#489F91]"
      }
    ),
    /* @__PURE__ */ d(
      "path",
      {
        d: "M88.0682 28.362C86.9844 27.3384 85.3988 27.0575 84.024 27.6495C83.743 27.78 83.6327 28.1011 83.7631 28.4022C83.8936 28.7132 84.2047 28.8537 84.4856 28.7534C85.7099 28.362 86.8339 28.6029 87.3557 29.3455C87.7972 29.9877 87.6668 30.8708 87.0245 31.6736C86.3221 32.4463 85.5594 33.1789 84.7365 33.8613C84.0441 34.5135 83.4219 35.1157 82.87 35.6576C80.8429 37.6345 79.6086 38.8387 77.9929 39.2702C76.9392 39.5512 75.3035 39.4308 74.9723 38.2868C74.3903 36.2396 77.5012 33.8011 80.5117 31.4328C81.164 30.921 81.8063 30.4192 82.4184 29.9074L82.4385 29.8874C82.5589 29.7669 82.5689 29.5662 82.4585 29.4057C82.3482 29.2551 82.1675 29.1949 81.9869 29.2852C81.736 29.4558 81.4651 29.6465 81.174 29.8472C77.8524 32.1252 72.293 35.9385 73.9588 39.1197C74.5509 40.2436 75.7149 40.635 76.8088 40.635C77.0496 40.635 77.2804 40.6149 77.5012 40.5848C79.4781 40.2837 80.9131 39.1197 82.318 37.8452C83.151 37.0926 87.5363 33.0685 88.2889 32.0148C89.1219 30.9009 89.0315 29.3655 88.0682 28.352V28.362Z",
        className: "fill-[#489F91]"
      }
    )
  ] }),
  /* @__PURE__ */ d("defs", { children: /* @__PURE__ */ d("clipPath", { id: "clip0_4493_1081", children: /* @__PURE__ */ d(
    "rect",
    {
      width: "120",
      height: "93.156",
      fill: "white",
      transform: "translate(0 13.5)"
    }
  ) }) })
] }), eve = Ar()(
  Qhe
);
export {
  lpe as Accordion,
  upe as Anchor,
  Upe as AppPicker,
  la as AppPickerAppEnum,
  K1 as BBLEnum,
  Na as Banner,
  $U as BannerBlock,
  BU as BannerFooter,
  VU as BannerHeader,
  ime as BarAndLineChart,
  rme as BarChart,
  jge as Barometer,
  zde as BarometerStatus,
  vs as Box,
  ZU as BoxBlock,
  WU as BoxEmpty,
  qU as BoxError,
  zU as BoxFooter,
  HU as BoxHeader,
  Dt as Button,
  ipe as ButtonsFilter,
  cpe as Card,
  cI as Carousel,
  D2 as Checkbox,
  zd as Chip,
  Ju as Combobox,
  VI as ComboboxEmpty,
  lp as ComboboxOption,
  dm as ComposableChart,
  bh as ContextMenu,
  Jpe as CountryFlag,
  Dne as CountrySelect,
  Spe as DDMMYYYY,
  UA as DataTable,
  Qpe as Datepicker,
  Xpe as DatepickerNative,
  are as Dropdown,
  Eo as ErrorMessage,
  Ome as Feedback,
  _me as FeedbackProvider,
  Ame as FeedbackTrigger,
  tme as FilePreview,
  fre as FileUpload,
  rpe as GlobalSearch,
  npe as GlobalSearchShortcut,
  _1 as Header,
  sme as IconApartment,
  Tme as IconArrowDown,
  Ime as IconArrowLeft,
  Dme as IconArrowRight,
  Rme as IconArrowUp,
  Dge as IconAttachEmail,
  Yge as IconAttachment,
  Tm as IconBack,
  rge as IconBathtub,
  Yme as IconBoardwork,
  Zme as IconBookmark,
  oge as IconBorderOuter,
  ige as IconBorderStyle,
  lme as IconBuildingType,
  hL as IconCalender,
  k2 as IconCheckmark,
  Gr as IconChevronDown,
  qr as IconChevronLeft,
  yo as IconChevronRight,
  V0 as IconChevronUp,
  rCe as IconClipboardCheck,
  zme as IconClock,
  Wr as IconClose,
  oCe as IconComment,
  Xme as IconCommunication,
  hge as IconCommute,
  Cme as IconCopy,
  wCe as IconCourse,
  iCe as IconCursor,
  aCe as IconCursorClick,
  Gme as IconDashboard,
  Yde as IconDelete,
  xCe as IconDigitalService,
  pge as IconDirectionsBoat,
  mge as IconDirectionsBus,
  gge as IconDirectionsCar,
  Cge as IconDirectionsRailway,
  vge as IconDirectionsWalk,
  Fme as IconDiscoverTune,
  Xge as IconDownload,
  sCe as IconDrag,
  BCe as IconDrop,
  Kme as IconEconomy,
  yge as IconElectricCar,
  FCe as IconEnergy,
  bge as IconEvStation,
  aO as IconExternal,
  age as IconFamilyHome,
  sge as IconFamilyRestroom,
  Mge as IconFavorite,
  Ege as IconFavoriteFilled,
  lfe as IconFile,
  bme as IconFileEdit,
  Mme as IconFileFail,
  Eme as IconFilePresent,
  wme as IconFileSearch,
  Sme as IconFileSuccess,
  SCe as IconFinans,
  Rge as IconFlag,
  VCe as IconFlame,
  mme as IconFolder,
  gme as IconFolderOpen,
  MCe as IconFood,
  qme as IconForum,
  kge as IconForward,
  ECe as IconFurniture,
  cme as IconGarage,
  Lme as IconGift,
  wfe as IconHandStar,
  lCe as IconHelp,
  ume as IconHome,
  ege as IconHousing,
  Xfe as IconHousingAssociation,
  Qme as IconHousingCooperative,
  Lge as IconInbox,
  ih as IconInfo,
  vme as IconInvoice,
  kCe as IconKeyCtrl,
  KV as IconKeyDownChevron,
  Y_ as IconKeyEsc,
  X_ as IconKeyReturn,
  LCe as IconKeyS,
  YV as IconKeyUpChevron,
  _ge as IconKidStar,
  Oge as IconKidStarFilled,
  lge as IconLayers,
  cge as IconLocalMail,
  cCe as IconLocation,
  Vme as IconLocationAway,
  uge as IconLocationCity,
  Bme as IconLocationHome,
  Age as IconLock,
  Pge as IconLockOpen,
  Nge as IconMail,
  tge as IconMembership,
  nge as IconMenu,
  Wme as IconMessageCircleHeart,
  iO as IconMinus,
  uCe as IconMobile,
  $me as IconMore,
  jme as IconMoreHoriz,
  Hme as IconMoreVert,
  wge as IconMotorcycle,
  fCe as IconNewsMode,
  CCe as IconNote,
  gCe as IconNotice,
  dP as IconNotifications,
  _Ce as IconOther,
  Nme as IconPen,
  dCe as IconPercent,
  jCe as IconPersonSearch,
  tj as IconPlus,
  vCe as IconPostit,
  yCe as IconPostit2,
  hCe as IconPowerDrill,
  Qge as IconPrinter,
  nde as IconProfile,
  yme as IconReceipt,
  pCe as IconRefresh,
  OCe as IconRent,
  ACe as IconRentWork,
  Fge as IconReply,
  Vge as IconReplyAll,
  NCe as IconReport,
  kme as IconReturn,
  Jge as IconSave,
  Bge as IconScheduleSend,
  wa as IconSearch,
  $ge as IconSend,
  PCe as IconService,
  hme as IconSign,
  pme as IconSignAll,
  bCe as IconSoftware,
  TCe as IconSoftwareOnetime,
  fge as IconSportsAndOutdoors,
  ICe as IconStationary,
  eCe as IconStop,
  fme as IconStore,
  DCe as IconSubscription,
  xge as IconSubway,
  Jme as IconSustainability,
  dme as IconTerracedHouse,
  tCe as IconTime,
  Sge as IconTram,
  RCe as IconTravelAndTransport,
  rhe as IconUpload,
  Dfe as IconUser,
  Tge as IconVisibility,
  Ige as IconVisibilityOff,
  Ume as IconVote,
  dge as IconVpnKey,
  nCe as IconWallet,
  mCe as IconWeb,
  xme as IconZip,
  Ipe as IconedButton,
  XCe as IllustrationBudget,
  QCe as IllustrationCard,
  $Ce as IllustrationError,
  ZCe as IllustrationMembershipBytt,
  WCe as IllustrationMembershipConsents,
  YCe as IllustrationMembershipGift,
  qCe as IllustrationMembershipOverfor,
  UCe as IllustrationMembershipSavings,
  GCe as IllustrationMembershipTeamBuilding,
  KCe as IllustrationMembershipVip,
  JCe as IllustrationPreemption,
  eve as IllustrationPreemptionBosor,
  Mj as Image,
  dpe as ImageViewer,
  A1 as Input,
  Hge as ItemAccountBlock,
  zge as ItemBaseBlock,
  Zge as ItemComplexBlock,
  Wge as ItemEmptyBlock,
  qge as ItemLoanBlock,
  Uge as ItemSimpleBlock,
  Gge as ItemSumBlock,
  Kge as ItemTaskBlock,
  Ut as Label,
  fpe as LabelledText,
  Kpe as Layout,
  Gpe as LayoutShell,
  ome as LineChart,
  bpe as MM,
  ppe as MONTHS,
  mpe as MONTHS_SHORT,
  Zpe as MainMenu,
  hpe as MediaCarousel,
  Wpe as Menu,
  qpe as MenuTop,
  vr as Modal,
  GU as ModalBlock,
  GA as ModalContext,
  KU as ModalFooter,
  YU as ModalHeader,
  XU as ModalTrigger,
  W9e as MonthPicker,
  fL as MonthRangePicker,
  ame as MonthRangePickerPopper,
  K_ as NavigationContext,
  UI as NestedDropdown,
  qI as NestedDropdownBlock,
  Zu as NotificationMenu,
  Tpe as Pagination,
  JA as PaginationContext,
  Ppe as PaginationProvider,
  Rt as Paragraph,
  Rne as PostalInput,
  Cee as Radio,
  nme as RadioGroup,
  ia as Rating,
  zpe as RelationPicker,
  ope as SearchContext,
  xn as Select,
  _U as SelectContent,
  AU as SelectGroup,
  PU as SelectItem,
  TU as SelectSeparator,
  S1 as Skeleton,
  Gc as SpinLoader,
  Go as Subtle,
  nG as Tab,
  HCe as TabBar,
  rG as TabContent,
  zCe as TabItem,
  Lt as Table,
  bO as TableBody,
  WZ as TableCell,
  UZ as TableFoot,
  GZ as TableHead,
  XZ as TableHeaderCell,
  QZ as TableLoading,
  JZ as TableRow,
  hh as Tabs,
  Ye as Text,
  Ine as Textarea,
  spe as ThemeShell,
  JU as Timeline,
  YA as TimelineItem,
  x1 as Tooltip,
  U_ as TooltipContent,
  G_ as TooltipTrigger,
  tP as TopBar,
  aG as TopBarSlot,
  YE as TypingEffect,
  Q9e as TypingSequence,
  _j as Video,
  gpe as WEEKDAYS_LONG,
  Cpe as WEEKDAYS_SHORT,
  Npe as chunkArray,
  I as cn,
  QL as cnNoMerge,
  Vpe as convertBlobToObjectUrl,
  Dl as countryCodes,
  ph as countryCodesMap,
  UV as createMarkup,
  rh as datesAreOnSameDay,
  ype as ddMM,
  oh as ddmmyyyy,
  zZ as ddmmyyyyhhmm,
  CG as dynamicSort,
  Lpe as filterStringMatcher,
  pC as formatAxisPrice,
  vpe as formatDate,
  Hpe as getByteSizeText,
  $Z as getDateFormat,
  HZ as getDateIsValid,
  $pe as getDomainFromUrl,
  Dpe as getFormattedAccountNumber,
  _pe as getFormattedCardNumber,
  Ea as getFormattedDate,
  y7 as getFormattedDateTimePretty,
  Ope as getFormattedOrganizationNumber,
  Bpe as getFormattedPhone,
  Ma as getFormattedPrice,
  Mpe as getFormattedPriceWithEnding,
  $O as getFormattedTime,
  Ape as getFormattedTimePeriod,
  kpe as getReducedArray,
  Epe as getTitleString,
  jpe as getUrlWithProtocol,
  jZ as getUtcDate,
  BO as hhmm,
  LG as isEqual,
  Rpe as isValidAccountNumber,
  wpe as mmYYYY,
  xpe as mmyyyy,
  fc as norwayCountryCode,
  bi as omit,
  Tl as parseDate,
  gG as phoneCodesMap,
  eme as upload,
  wG as useDebounce,
  mh as useDebounceCallback,
  Fpe as useDetectUserAgent,
  R2 as useDialogOverflowOverride,
  c5 as useEventListener,
  hm as useFeedback,
  yG as useFocus,
  bG as useHover,
  R1 as useIsMobile,
  uP as useIsWindows,
  vG as useIsomorphicLayoutEffect,
  eP as usePaginationContext,
  Pme as useShowFeedbackOnRouteChange
};
